(function (cjs, an) {

var p; // shortcut to reference prototypes
var lib={};var ss={};var img={};
lib.ssMetadata = [
		{name:"masteringafriendship_atlas_", frames: [[0,2004,1225,1000],[1227,2004,1223,1000],[6205,0,1979,1000],[3654,2969,1196,1000],[4159,0,2044,987],[6046,3729,983,800],[1085,3808,744,800],[2083,0,2074,1000],[3151,3971,545,800],[3420,1002,690,881],[1085,3006,1060,800],[7031,3729,1029,642],[5994,1969,1230,1000],[0,1002,1958,1000],[1960,1002,1458,1000],[4159,989,2008,976],[2452,2969,1200,1000],[2452,2004,787,900],[2576,3971,573,800],[3698,3971,991,181],[4852,2971,1192,1000],[3420,1967,1306,1000],[6046,2971,1490,756],[1831,3971,743,800],[6169,1002,1500,965],[0,3006,1083,1000],[7226,1969,921,1000],[4728,1967,1264,1000],[0,0,2081,1000]]}
];


// symbols:



(lib.allison_ivan = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.bwnecklacedraw = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.BandW_Drawing = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.boston = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.bridgedrawing = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.bridge_bracelet = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.finalpiece = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.flowers = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.fly_1 = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.fly_2 = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.green_broach = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.green_necklace = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.greenBraceletDraw = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.greenBro = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.hammers = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.handshammersblk = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.hands_0nwhitetable = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.katchin_face = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.katchin_side = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.mfa_logo = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.miye = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.nancy_studio = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.necklace = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.pearl = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.red_necklace = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.Stone_twins = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.wat_redNecklace_studio = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.Wat_studio_reddress = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.yel_broach_draw = function() {
	this.spriteSheet = ss["masteringafriendship_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.start = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AhxCVICSiaIiViNIApgrIC/C1Ii6DGg");
	this.shape.setTransform(1,1.1,0.783,0.783);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AklK4QiIg5hohpQhphpg6iHQg7iNAAiZQAAiZA7iMQA6iHBphpQBohpCIg5QCNg8CYAAQCaAACMA8QCIA5BoBpQBpBoA6CIQA7CMAACZQAACZg7CNQg6CHhpBpQhoBpiIA5QiMA8iaAAQiYAAiNg8gAkVqTQiBA3hjBjQhjBjg3CAQg4CFAACRQAACRA4CFQA3CBBjBjQBjBjCBA3QCFA4CQAAQCSAACFg4QCAg3BjhjQBjhjA3iBQA4iFAAiRQAAiRg4iFQg3iAhjhjQhjhjiAg3QiFg4iSAAQiQAAiFA4g");
	this.shape_1.setTransform(0,0,0.783,0.783);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AkhKtQiFg4hnhnQhnhng5iGQg6iKAAiXQAAiXA6iJQA5iGBnhnQBnhnCFg4QCLg7CWAAQCYAACKA7QCFA4BnBnQBnBnA5CGQA6CJAACXQAACYg6CJQg5CGhnBnQhnBniFA4QiKA7iYAAQiWAAiLg7g");
	this.shape_2.setTransform(-0.6,-0.5,0.783,0.783);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-59.2,-59.1,118.4,118.3);


(lib.restart = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AggA0IAAhVIgZAAIAAggIAbgBIAFgyIAhAAIAAAyIAtAAIAAAhIgtAAIAABVQAAAfAZAAQAIAAAKgEIAHAfQgUAGgPAAQg3ABAAhBg");
	this.shape.setTransform(49.9,95.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("Ag1BcIAAiyIAiAAIADAfIACAAQASgkAeAAQANAAAHAEIgHAkQgKgDgIAAQgbAAgNAmIAABsg");
	this.shape_1.setTransform(37.6,97.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("Ag5BQQgOgPAAgYQAAgdAZgOQAYgQA1gGQgBgjgeAAQgUAAgdARIgQgcQAlgXAjAAQBCAAAABNIAABqIgjAAIgCgUIgBAAQgcAYgaAAQgYAAgOgOgAggAmQABAXAZAAQAQAAAVgTIAAgpQg/AIAAAdg");
	this.shape_2.setTransform(19.7,97.7);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AggA0IAAhVIgZAAIAAggIAbgBIAFgyIAhAAIAAAyIAtAAIAAAhIgtAAIAABVQAAAfAZAAQAIAAAKgEIAHAfQgUAGgQAAQg2ABAAhBg");
	this.shape_3.setTransform(4.8,95.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AgkBXQgRgHgOgLIATgbQAaAUAWAAQAcAAABgVQgBgKgLgIQgHgDgSgIQgXgJgLgJQgQgOAAgUQAAgXARgPQASgPAcAAQAgAAAbAVIgTAaQgVgQgSAAQgLAAgIAGQgGAGAAAIQAAAKAMAGIAYALQAYAJAKAIQARAOgBAWQAAAZgRAPQgTAQgfAAQgSAAgSgHg");
	this.shape_4.setTransform(-9.2,97.7);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AgzBFQgZgaAAgrQAAgpAZgbQAXgZAgAAQAjAAATAYQATAWAAAnQAAALgCAIIhuAAQACAYAOANQAOANAVAAQAUAAAUgNIAOAbQgcATggAAQglAAgYgZgAgWgxQgMAMgCAVIBNAAQAAgtgkAAQgPAAgMAMg");
	this.shape_5.setTransform(-26.2,97.7);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("AAoB3IgxhdIgjAAIAABdIgqAAIAAjtIBPAAQBVgBAABIQAAAkgZATQgKAIgMAEIA4BjgAgsgHIAgAAQAxAAAAgoQAAgVgNgJQgMgHgYgBIggAAg");
	this.shape_6.setTransform(-44.9,94.8);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("AhxAWIDjhpIg9Cng");
	this.shape_7.setTransform(18.7,-27.5);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("AhCEYQg4gOgugiQgugigdgyQgegygIg5QgIg3AOg5QAPg4AigtQAiguAygeQAygdA4gJQA4gIA4AOQAxANAqAdQArAdAdApIg6AqQgvhBhMgTQgqgLgqAGQgqAGgmAXQglAWgaAiQgaAjgKAqQgLAqAGAqQAGArAWAlQAXAmAiAZQAjAaAqALQBWAWBOguQBNguAXhYIBFASQgZBhhPA9QhPA8hhAAQgjAAgkgJg");
	this.shape_8.setTransform(-1.4,-14.3);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("AlhNGQijhFh+h+Qh+h+hFijQhIipAAi5QAAi4BIipQBFijB+h+QB+h+CjhFQCphIC4AAQC4AACqBIQCjBFB+B+QB+B+BFCjQBICpAAC4QAAC5hICpQhFCjh+B+Qh+B+ijBFQiqBIi4AAQi4AAiphIgAlOsZQibBCh3B3Qh3B3hCCbQhECgAACuQAACvBECgQBCCbB3B3QB3B3CbBCQCgBECuAAQCvAACghEQCbhCB3h3QB3h3BCibQBEigAAivQAAiuhEigQhCibh3h3Qh3h3ibhCQighEivAAQiuAAigBEg");
	this.shape_9.setTransform(0,-16.1);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#FFFFFF").s().p("AlhNGQijhFh+h+Qh+h+hFijQhHipgBi5QABi4BHipQBFijB+h+QB+h+CjhFQCphIC4AAQC4AACqBIQCjBFB+B+QB+B+BFCjQBHCpAAC4QAAC5hHCpQhFCjh+B+Qh+B+ijBFQiqBIi4AAQi4AAiphIgAlOsZQibBCh3B3Qh3B3hCCbQhECgABCuQgBCvBECgQBCCbB3B3QB3B3CbBCQCgBECuAAQCvAAChhEQCahCB3h3QB3h3BCibQBEigAAivQAAiuhEigQhCibh3h3Qh3h3iahCQihhEivAAQiuAAigBEg");
	this.shape_10.setTransform(0,-16.1);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f().s("#000000").ss(1,0,0,4).p("AAAOJQC4AACohHQCihFB9h9QB9h9BFijQBHioAAi4QAAi3hHioQhFijh9h9Qh9h9iihFQiohHi4AAQi3AAioBHQijBFh9B9Qh9B+hECiQhICoAAC3QAAC4BICoQBECjB9B9QB9B9CjBFQCoBHC3AAg");
	this.shape_11.setTransform(0,-16.1);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#FFFFFF").s().p("AlfNCQiihFh+h9Qh9h9hEijQhHiogBi4QABi3BHioQBEiiB9h+QB+h9CihFQCohHC3AAQC4AACoBHQCiBFB9B9QB+B9BECjQBHCoAAC3QAAC4hHCoQhECjh+B9Qh9B9iiBFQioBHi4AAQi3AAiohHg");
	this.shape_12.setTransform(0,-16.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-91.4,-107.6,182.9,214.8);


(lib.green_stone_draw = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.greenBro();
	this.instance.parent = this;
	this.instance.setTransform(-673.7,-1039.5,1.127,1.127,30);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_stone_draw, new cjs.Rectangle(-1237.1,-1039.5,2474.2,2079.1), null);


(lib.green_stone = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.green_broach();
	this.instance.parent = this;
	this.instance.setTransform(-110.3,-297.2,0.743,0.743);

	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape.setTransform(-263.1,267.2,0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AhKBhIAAgVQAeAQAlAAQAgAAAPgKQAQgKAAgSQAAgQgNgLQgMgLgegLQgegJgOgKQgNgIgHgKQgGgLAAgPQAAgXAUgOQAUgOAjAAQAjAAAeANIgHASQgggOgaAAQgZAAgPAJQgQAJAAAPQAAARAMAKQANAKAgALQAbAKAPAJQANAIAHAKQAGALAAAOQAAAdgVAPQgWAPgnAAQgrAAgYgNg");
	this.shape_1.setTransform(-270.2,262.7,0.5,0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgdAAQgkAAgTATQgRATAAAsIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA1AAQBIAAAABNIAACKg");
	this.shape_2.setTransform(-280.6,262.6,0.5,0.5);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh9QgBgTAMAAQAGAAADAEQAEAGAAAJQAAAIgEAFQgDAGgGAAQgMgBABgSg");
	this.shape_3.setTransform(-288.8,260.7,0.5,0.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhTBaIBaB6g");
	this.shape_4.setTransform(-295,260.4,0.5,0.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AgOB3QgNgQAAgfIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAHAMQAJAMASAAQATAAANgDIAAAPQgNAFgTAAQgbAAgOgPg");
	this.shape_5.setTransform(-304.3,261.5,0.5,0.5);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQABgegNgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAkAAAQASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgWAAQghAAgRgQgAAYAAQgtACgSAMQgTALAAAZQgBAUANALQALALAYAAQAgAAAUgTQAUgUAAgiIAAgUg");
	this.shape_6.setTransform(-313.1,262.7,0.5,0.5);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("ABKCPIhKkIQgDARgGAWIg/DhIgRAAIhPkdIAVAAIBED9QAEgdAPg0IAxisIAVAAIA5DGQAMAnADAQIAHgeIA7jfIAVAAIhPEdg");
	this.shape_7.setTransform(-327,260.8,0.5,0.5);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgcAAghAQIgHgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_8.setTransform(-346.8,262.7,0.5,0.5);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIABAAQAOgYAOgJQAOgJAVAAQAMAAARACIgEATQgMgDgPAAQgbAAgRAXQgRAXAAAjIAAB0g");
	this.shape_9.setTransform(-354.9,262.6,0.5,0.5);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("AhCB/QgWgcAAg0QAAg2AWgdQAYgdArAAQAXAAAQAIQARAJAOAUIABAAIgBh9IATAAIAAEvIgNAAIgFggIgBAAQgZAkgtAAQgrAAgYgbgAgzgXQgSAXAAAvQAABaBGAAQAkAAARgVQARgVAAgwIAAgDQgBgwgQgWQgRgWgkAAQgiAAgSAZg");
	this.shape_10.setTransform(-365.7,260.5,0.5,0.5);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgOgPgcAAQglAAgRATQgTAUABArIAAB0IgUAAIAAjTIAQAAIAFAdIABAAQAVghAzAAQBJAAAABNIAACKg");
	this.shape_11.setTransform(-377.2,262.6,0.5,0.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAASASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgtACgSAMQgTALAAAZQAAAUAMALQAMALAWAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_12.setTransform(-388.8,262.7,0.5,0.5);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("ABCBqIhChfIhDBfIgVAAIBNhsIhKhnIAWAAIA/BZIA+hZIAWAAIhJBnIBOBsg");
	this.shape_13.setTransform(-398.8,262.7,0.5,0.5);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("Ag8BSQgagdABgzQgBgyAageQAYgfApAAQAnAAAVAaQAWAagBAtIAAAPIiYAAQACAsATAWQAUAXAlABQAUgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQguAAgagcgAgqhHQgTATgDAmICCAAQAAgkgQgVQgPgVgeAAQgdAAgSAVg");
	this.shape_14.setTransform(-409.2,262.7,0.5,0.5);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_15.setTransform(-417,260.4,0.5,0.5);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgnBlIBkAAIgyiHQgEARgHARg");
	this.shape_16.setTransform(-425.2,260.8,0.5,0.5);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#000000").s().p("AhaCWIAAgRQAMADANAAQAKAAAHgEQAIgFAGgKQAFgIAJgXIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgHAKQgIALgLAFQgLAFgOAAQgKAAgPgEg");
	this.shape_17.setTransform(-441,265.1,0.5,0.5);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAcAAA1QAAA1gYAcQgXAdgrAAQgXAAgSgJgAg1gaQgQAWAAAwIAAADQAAAwARAVQAQAVAkAAQAiAAASgZQARgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_18.setTransform(-451.3,260.5,0.5,0.5);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#000000").s().p("AgWAxQAGgXAFgYQAFgTAFgfIAWAAIACAEQgQA2gRAng");
	this.shape_19.setTransform(-464.2,256.1,0.5,0.5);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgUAAIAAkdIAUAAIAAB/IClAAIAAh/IAUAAIAAEdg");
	this.shape_20.setTransform(-472.8,260.8,0.5,0.5);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#000000").s().p("AhFBsQgkgmABhGQAAgrAQghQAQghAfgTQAggSAnAAQAqAAAhAQIgHASQghgQghAAQg0AAggAjQgfAiAAA7QAAA9AeAiQAdAiA1AAQAlAAAcgKIAAASQgaAKgsAAQg8AAghgng");
	this.shape_21.setTransform(-485.9,260.8,0.5,0.5);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgjAog7AAQg7AAgigogAhNhdQgcAhAAA8QAAA8AbAjQAcAhAyAAQAzAAAcghQAbghAAg+QAAg9gbghQgcghgzAAQgyAAgbAig");
	this.shape_22.setTransform(-500.1,260.8,0.5,0.5);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#000000").s().p("AhcBrQgjgmAAhFQAAhDAjgoQAignA6AAQA9AAAhAnQAiAogBBDQAABFghAmQgiAog8AAQg7AAghgogAhNhdQgcAgAAA9QAAA9AcAiQAbAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgcghgzAAQgyAAgbAig");
	this.shape_23.setTransform(-515.3,260.8,0.5,0.5);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#000000").s().p("ABHCPIhKh9IhGAAIAAB9IgUAAIAAkdIBEAAQA0AAAaAUQAZATAAAoQAAAcgPAUQgPATgfAIIBNCDgAhJABIA3AAQAjAAAUgPQATgQAAggQABgggUgPQgUgPgrAAIgvAAg");
	this.shape_24.setTransform(-528.1,260.8,0.5,0.5);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAZASAAAkQAAAZgPARQgQAQgdAFIAAABQAiAFARAQQAQARAAAdQAAAngaAVQgbAWgvAAgAhJB9IBDAAQBPAAgBhAQAAg7hSAAIg/AAgAhJgPIA/AAQAnAAASgNQATgOgBgcQABgdgVgNQgUgMgpAAIg5AAg");
	this.shape_25.setTransform(-540.7,260.8,0.5,0.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_26.setTransform(-557.7,260.8,0.5,0.5);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_27.setTransform(-570.9,260.8,0.5,0.5);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_28.setTransform(-580.6,260.8,0.5,0.5);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_29.setTransform(-587.4,260.8,0.5,0.5);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBmAAIgohlIgMgiQgEAWgGAMg");
	this.shape_30.setTransform(-599.4,260.8,0.5,0.5);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#000000").s().p("ABwCPIAAjYQAAgUACgbIgBAAIhrEHIgMAAIhqkHIgCAAIACAxIAADWIgTAAIAAkdIAeAAIBlD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_31.setTransform(-614,260.8,0.5,0.5);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_32.setTransform(-627.8,260.8,0.5,0.5);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#000000").s().p("AhOB1QgcgcAAgyIAAi3IAUAAIAAC4QAAApAXAXQAXAXApAAQApAAAWgWQAXgXAAgoIAAi6IAUAAIAAC4QAAAygdAbQgcAbgyAAQgyAAgcgbg");
	this.shape_33.setTransform(-641.7,260.9,0.5,0.5);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgjAog7AAQg7AAgigogAhNhdQgcAhAAA8QAAA8AbAjQAcAhAyAAQAzAAAcghQAbghAAg+QAAg9gbghQgcghgzAAQgyAAgbAig");
	this.shape_34.setTransform(-656.5,260.8,0.5,0.5);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_35.setTransform(-669.4,260.8,0.5,0.5);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_36.setTransform(-676.1,256.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.green_stone, new cjs.Rectangle(-677.2,-297.2,1354.6,594.5), null);


(lib.ButtonLeft_Right = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#241F21").s().p("AhiAHICeinIAlAjIh7CCIB9B3IgjAlg");
	this.shape.setTransform(16.1,38.8,0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#241F21").s().p("Al8L0QCZAACNg8QCGg5BphpQBohpA6iHQA7iNAAiZQAAiZg7iMQg6iIhohoQhphpiGg5QiNg8iZAAIAAgHQCbAACNA8QCIA6BqBqQBpBpA6CJQA8COAACaQAACbg8COQg6CJhpBpQhqBqiIA6QiNA8ibAAg");
	this.shape_1.setTransform(19.1,38.1,0.5,0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("Ai6l5QBNAABGAeQBDAdA1A1QA0A0AdBDQASArAHAuIAAB0QgHAtgSArQgdBDg0A1Qg1A0hDAdQhGAehNAAg");
	this.shape_2.setTransform(18.7,38.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,38.2,76.3);


(lib.bridhe_drawing = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.instance = new lib.bridgedrawing();
	this.instance.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.bridhe_drawing, new cjs.Rectangle(0,0,2044,987), null);


(lib.bridgebracelt = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape.setTransform(514,701.8,0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#000000").s().p("AhKBhIAAgVQAfAQAlAAQAeAAAQgKQARgLAAgRQAAgPgOgMQgNgLgegLQgdgKgOgIQgNgJgHgKQgGgKAAgPQAAgZAUgNQAUgOAjAAQAjAAAeANIgHASQgggNgagBQgYABgQAIQgPAJAAAPQgBARAMAKQAMAJAhAMQAcALAPAHQAMAJAHAKQAGALABAOQgBAdgVAPQgVAPgnAAQgsAAgYgNg");
	this.shape_1.setTransform(506.9,697.3,0.5,0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgOgPgcAAQglAAgRATQgSATAAAsIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAUghA0AAQBIAAABBNIAACKg");
	this.shape_2.setTransform(496.5,697.2,0.5,0.5);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgMh9QABgTALAAQAGAAADAEQADAFABAKQgBAIgDAFQgDAGgGAAQgLAAgBgTg");
	this.shape_3.setTransform(488.3,695.3,0.5,0.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#000000").s().p("AA3CYIhPhrIgiAfIAABMIgUAAIAAkvIAUAAIgCDRIABAAIBsh2IAWAAIhSBaIBaB6g");
	this.shape_4.setTransform(482,695,0.5,0.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#000000").s().p("AgOB3QgNgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAHAMQAJAMASAAQATAAANgDIAAAPQgOAFgSAAQgbAAgOgPg");
	this.shape_5.setTransform(472.8,696.1,0.5,0.5);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAbgQAvgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgdAAgfAQIgIgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_6.setTransform(463.9,697.3,0.5,0.5);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#000000").s().p("ABJCPIhJkIIgJAnIg/DhIgRAAIhPkdIAWAAIBCD9QAFgbAPg2IAxisIAVAAIA6DGQAKAnADAQIBEj9IAUAAIhQEdg");
	this.shape_7.setTransform(450.1,695.4,0.5,0.5);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAASASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgtACgSAMQgTALAAAZQAAAUAMALQAMALAWAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_8.setTransform(430.3,697.3,0.5,0.5);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAWAAQAMAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_9.setTransform(422.2,697.2,0.5,0.5);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#000000").s().p("AhBB/QgYgcAAg0QAAg2AYgdQAWgdArAAQAZAAAPAIQARAIAOAVIAAAAIAAgwIAAhNIASAAIAAEvIgMAAIgFggIgBAAQgZAkgtAAQgrAAgXgbgAgzgXQgSAXAAAvQAABaBGAAQAkAAAQgVQARgWABgvIAAgDQAAgwgRgWQgRgWglAAQghAAgSAZg");
	this.shape_10.setTransform(411.3,695.1,0.5,0.5);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#000000").s().p("ABABsIAAiJQAAghgNgNQgNgPgdAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAVghAzAAQBJAAAABNIAACKg");
	this.shape_11.setTransform(399.8,697.2,0.5,0.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_12.setTransform(388.2,697.3,0.5,0.5);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#000000").s().p("ABCBqIhChfIhDBfIgVAAIBNhsIhKhnIAWAAIA/BZIA+hZIAVAAIhIBnIBOBsg");
	this.shape_13.setTransform(378.3,697.3,0.5,0.5);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#000000").s().p("Ag8BRQgagcAAgzQAAgyAZgeQAagfApAAQAmAAAVAaQAWAbAAAsIAAAPIiYAAQABAsATAWQAUAYAlAAQAUAAALgDQAPgDAUgIIAAARQgRAJgQACQgNADgUAAQgtAAgbgdgAgqhIQgSAUgEAnICCAAQAAglgQgVQgPgVgdAAQgdAAgTAUg");
	this.shape_14.setTransform(367.8,697.3,0.5,0.5);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_15.setTransform(360.1,695,0.5,0.5);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#000000").s().p("ABiCPIgohlIhzAAIgoBlIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBmAAIgohmIgLghQgFAWgGAMg");
	this.shape_16.setTransform(351.8,695.4,0.5,0.5);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAIgFAGgKQAGgLAIgUIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_17.setTransform(336,699.7,0.5,0.5);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAbAAA2QAAA1gYAcQgYAdgqAAQgXAAgSgJgAg1gaQgQAVAAAxIAAADQAAAwAQAVQASAVAjAAQAiAAARgZQASgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_18.setTransform(325.8,695.1,0.5,0.5);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#000000").s().p("AgXAxQAHgTAGgcQAFgZAEgZIAWAAIACAEQgQA2gQAng");
	this.shape_19.setTransform(312.9,690.7,0.5,0.5);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_20.setTransform(306.3,695.4,0.5,0.5);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_21.setTransform(296.1,695.4,0.5,0.5);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#000000").s().p("AhQBtQgjgmgBhGQAAgrASgiQASghAhgTQAigSAqAAQAvAAAlARIgIASQgmgRgnAAQg3AAghAjQgiAjAAA6QAABBAfAgQAgAgA8AAQAoAAAbgLIAAhkIhVAAIAAgSIBpAAIAACBQgpASg0AAQhDAAgkgmg");
	this.shape_22.setTransform(282.8,695.4,0.5,0.5);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#000000").s().p("ABUCPIipj9IgBAAIACBEIAAC5IgTAAIAAkdIAUAAICoD8IABAAQgCgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_23.setTransform(268.5,695.4,0.5,0.5);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#000000").s().p("ABhCPIgnhlIhzAAIgoBlIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgziHQgEASgGAQg");
	this.shape_24.setTransform(255.3,695.4,0.5,0.5);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAZASAAAkQAAAZgQARQgPAQgcAFIAAABQAhAFAQAQQARAQAAAeQAAAngbAVQgbAWgtAAgAhJB9IBDAAQBPAAAAhAQgBg7hTAAIg+AAgAhJgPIA+AAQAoAAASgNQATgOAAgcQAAgcgVgOQgVgMgnAAIg6AAg");
	this.shape_25.setTransform(243.5,695.4,0.5,0.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#000000").s().p("AhsCPIAAkdIBOAAQBEAAAiAkQAlAkgBBEQABBHgnAlQglAlhIAAgAhYB9IAwAAQB/AAAAh+QAAg+gggeQgegfg8AAIg1AAg");
	this.shape_26.setTransform(224.9,695.4,0.5,0.5);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#000000").s().p("AhNCPIAAkdIATAAIAAEKICIAAIAAATg");
	this.shape_27.setTransform(213.1,695.4,0.5,0.5);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#000000").s().p("AhdBrQghgmAAhFQAAhDAhgoQAjgnA7AAQA7AAAiAnQAhAoABBDQAABFgjAmQghAog8AAQg7AAgigogAhOhdQgbAhAAA8QAAA9AbAiQAcAhAyAAQAzAAAcghQAbghAAg+QAAg9gbghQgbghgzAAQgzAAgcAig");
	this.shape_28.setTransform(199.5,695.4,0.5,0.5);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#000000").s().p("AhQBtQgkgmAAhGQABgrASgiQARghAigTQAigSApAAQAvAAAlARIgIASQgmgRgnAAQg3AAgiAjQggAjgBA6QAABBAgAgQAfAgA8AAQApAAAagLIAAhkIhVAAIAAgSIBqAAIAACBQgpASg0AAQhDAAglgmg");
	this.shape_29.setTransform(184.5,695.4,0.5,0.5);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#000000").s().p("AhQBtQgjgmgBhGQAAgrASgiQASghAhgTQAhgSArAAQAvAAAlARIgIASQgmgRgnAAQg3AAgiAjQghAjAAA6QAABBAfAgQAgAgA8AAQAoAAAbgLIAAhkIhVAAIAAgSIBpAAIAACBQgpASg0AAQhDAAgkgmg");
	this.shape_30.setTransform(164.8,695.4,0.5,0.5);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#000000").s().p("ABUCPIipj9IgBAAIACBEIAAC5IgTAAIAAkdIAUAAICoD8IABAAQgCgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_31.setTransform(150.5,695.4,0.5,0.5);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_32.setTransform(140.8,695.4,0.5,0.5);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#000000").s().p("AhXCHIAAgTQAfANAvAAQAjAAAUgRQAVgPAAgbQAAgQgHgLQgGgKgRgJQgPgJgdgKQgsgOgQgSQgQgRAAgdQAAggAZgUQAZgVAmAAQApAAAiAQIgHARQgjgPggAAQgfAAgTAPQgTAOAAAZQAAARAGAJQAGALANAIQANAIAfALQAgAKASAMQASALAGANQAIAOAAATQAAAkgaAVQgaAVgrAAQg1AAgbgMg");
	this.shape_33.setTransform(132.9,695.4,0.5,0.5);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#000000").s().p("AhXCHIAAgTQAgANAvAAQAiAAAUgRQAVgQAAgaQAAgQgHgLQgGgKgQgJQgSgKgbgJQgsgPgQgRQgQgRAAgdQAAggAYgUQAZgVAnAAQApAAAjAQIgIARQgjgPggAAQgfAAgTAPQgTAOAAAZQAAARAGAJQAGALANAIQAMAIAgALQAgAKASAMQARALAIANQAHAOAAATQAAAkgaAVQgbAVgqAAQg1AAgbgMg");
	this.shape_34.setTransform(122,695.4,0.5,0.5);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgiAog8AAQg6AAgjgogAhNhdQgcAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgbAig");
	this.shape_35.setTransform(108.8,695.4,0.5,0.5);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_36.setTransform(96,695.4,0.5,0.5);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AeAiQAcAiA2AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_37.setTransform(83.4,695.4,0.5,0.5);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_38.setTransform(66.6,695.4,0.5,0.5);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#000000").s().p("AhQBtQgjgmgBhGQAAgrASgiQASghAhgTQAjgSApAAQAvAAAlARIgIASQgmgRgnAAQg3AAghAjQgiAjABA6QAABBAfAgQAfAgA8AAQApAAAagLIAAhkIhVAAIAAgSIBpAAIAACBQgoASg0AAQhDAAglgmg");
	this.shape_39.setTransform(53.3,695.4,0.5,0.5);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#000000").s().p("AhrCPIAAkdIBNAAQBEAAAjAkQAjAjAABFQAABHglAlQgmAlhIAAgAhXB9IAvAAQB/AAAAh+QAAg9gfgfQgfgfg8AAIg0AAg");
	this.shape_40.setTransform(39.5,695.4,0.5,0.5);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_41.setTransform(29.6,695.4,0.5,0.5);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgQATQgPATgfAIIBOCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_42.setTransform(21.9,695.4,0.5,0.5);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#000000").s().p("AhdCPIAAkdIBPAAQA0AAAYASQAZARAAAlQAAAZgPARQgPAQgdAFIAAABQAhAFARAQQAQARAAAdQAAAngaAVQgbAWguAAgAhJB9IBEAAQBOAAAAhAQgBg7hSAAIg/AAgAhJgPIA/AAQAoAAARgNQATgOAAgcQAAgcgVgOQgUgMgoAAIg6AAg");
	this.shape_43.setTransform(9.3,695.4,0.5,0.5);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_44.setTransform(1.2,690.7,0.5,0.5);

	this.instance = new lib.bridge_bracelet();
	this.instance.parent = this;
	this.instance.setTransform(504.6,0,0.916,0.916);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.bridgebracelt, new cjs.Rectangle(0,0,1405.1,732.9), null);


(lib.blk_opacity = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("EiiZBPlMAAAifJMFEzAAAMAAACfJg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blk_opacity, new cjs.Rectangle(-1039.4,-509.3,2078.9,1018.6), null);


// stage content:
(lib.masteringafriendship = function(mode,startPosition,loop) {
if (loop == null) { loop = false; }	this.initialize(mode,startPosition,loop,{});

	// timeline functions:
	this.frame_0 = function() {
		/* Stop at This Frame
		The  timeline will stop/pause at the frame where you insert this code.
		Can also be used to stop/pause the timeline of movieclips.
		*/
		
		this.stop();
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.start1.addEventListener("click", fl_ClickToGoToAndStopAtFrame_46.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_46()
		{
			this.gotoAndStop(1);
		}
	}
	this.frame_1 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL1.addEventListener("click", fl_ClickToGoToAndStopAtFrame_44.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_44()
		{
			this.gotoAndStop(0);
		}
		
		
		/* Click to Go to Frame and Play
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and continues playback from that frame.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		this.buttonR1.addEventListener("click", fl_ClickToGoToAndPlayFromFrame_14.bind(this));
		
		function fl_ClickToGoToAndPlayFromFrame_14()
		{
			this.gotoAndPlay(2);
		}
	}
	this.frame_2 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL2.addEventListener("click", fl_ClickToGoToAndStopAtFrame_49.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_49()
		{
			this.gotoAndStop(1);
		}
	}
	this.frame_49 = function() {
		/* Stop at This Frame
		The  timeline will stop/pause at the frame where you insert this code.
		Can also be used to stop/pause the timeline of movieclips.
		*/
		
		this.stop();
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR2.addEventListener("click", fl_ClickToGoToAndStopAtFrame_47.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_47()
		{
			this.gotoAndStop(50);
		}
	}
	this.frame_50 = function() {
		/* Click to Go to Frame and Play
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and continues playback from that frame.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		this.buttonL3.addEventListener("click", fl_ClickToGoToAndPlayFromFrame_15.bind(this));
		
		function fl_ClickToGoToAndPlayFromFrame_15()
		{
			this.gotoAndPlay(2);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR3.addEventListener("click", fl_ClickToGoToAndStopAtFrame_50.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_50()
		{
			this.gotoAndStop(51);
		}
	}
	this.frame_51 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL4.addEventListener("click", fl_ClickToGoToAndStopAtFrame_51.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_51()
		{
			this.gotoAndStop(50);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR4.addEventListener("click", fl_ClickToGoToAndStopAtFrame_52.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_52()
		{
			this.gotoAndStop(52);
		}
	}
	this.frame_52 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL5.addEventListener("click", fl_ClickToGoToAndStopAtFrame_53.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_53()
		{
			this.gotoAndStop(51);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR5.addEventListener("click", fl_ClickToGoToAndStopAtFrame_54.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_54()
		{
			this.gotoAndStop(53);
		}
	}
	this.frame_53 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL6.addEventListener("click", fl_ClickToGoToAndStopAtFrame_55.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_55()
		{
			this.gotoAndStop(52);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR6.addEventListener("click", fl_ClickToGoToAndStopAtFrame_56.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_56()
		{
			this.gotoAndStop(54);
		}
	}
	this.frame_54 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL7.addEventListener("click", fl_ClickToGoToAndStopAtFrame_57.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_57()
		{
			this.gotoAndStop(53);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR7.addEventListener("click", fl_ClickToGoToAndStopAtFrame_58.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_58()
		{
			this.gotoAndStop(55);
		}
	}
	this.frame_55 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL8.addEventListener("click", fl_ClickToGoToAndStopAtFrame_59.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_59()
		{
			this.gotoAndStop(54);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR8.addEventListener("click", fl_ClickToGoToAndStopAtFrame_60.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_60()
		{
			this.gotoAndStop(56);
		}
	}
	this.frame_56 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL9.addEventListener("click", fl_ClickToGoToAndStopAtFrame_61.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_61()
		{
			this.gotoAndStop(55);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR9.addEventListener("click", fl_ClickToGoToAndStopAtFrame_62.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_62()
		{
			this.gotoAndStop(57);
		}
	}
	this.frame_57 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL10.addEventListener("click", fl_ClickToGoToAndStopAtFrame_63.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_63()
		{
			this.gotoAndStop(56);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR10.addEventListener("click", fl_ClickToGoToAndStopAtFrame_64.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_64()
		{
			this.gotoAndStop(58);
		}
	}
	this.frame_58 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL11.addEventListener("click", fl_ClickToGoToAndStopAtFrame_65.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_65()
		{
			this.gotoAndStop(57);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR11.addEventListener("click", fl_ClickToGoToAndStopAtFrame_66.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_66()
		{
			this.gotoAndStop(59);
		}
	}
	this.frame_59 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL12.addEventListener("click", fl_ClickToGoToAndStopAtFrame_67.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_67()
		{
			this.gotoAndStop(58);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR12.addEventListener("click", fl_ClickToGoToAndStopAtFrame_68.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_68()
		{
			this.gotoAndStop(60);
		}
	}
	this.frame_60 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL13.addEventListener("click", fl_ClickToGoToAndStopAtFrame_69.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_69()
		{
			this.gotoAndStop(59);
		}
		
		
		
		
		/* Click to Go to Frame and Play
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and continues playback from that frame.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		this.buttonR13.addEventListener("click", fl_ClickToGoToAndPlayFromFrame_16.bind(this));
		
		function fl_ClickToGoToAndPlayFromFrame_16()
		{
			this.gotoAndPlay(61);
		}
	}
	this.frame_61 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL14.addEventListener("click", fl_ClickToGoToAndStopAtFrame_71.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_71()
		{
			this.gotoAndStop(60);
		}
	}
	this.frame_105 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR14.addEventListener("click", fl_ClickToGoToAndStopAtFrame_72.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_72()
		{
			this.gotoAndStop(106);
		}
		
		
		/* Stop at This Frame
		The  timeline will stop/pause at the frame where you insert this code.
		Can also be used to stop/pause the timeline of movieclips.
		*/
		
		this.stop();
	}
	this.frame_106 = function() {
		/* Click to Go to Frame and Play
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and continues playback from that frame.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		this.buttonL15.addEventListener("click", fl_ClickToGoToAndPlayFromFrame_17.bind(this));
		
		function fl_ClickToGoToAndPlayFromFrame_17()
		{
			this.gotoAndPlay(61);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR15.addEventListener("click", fl_ClickToGoToAndStopAtFrame_73.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_73()
		{
			this.gotoAndStop(107);
		}
	}
	this.frame_107 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL16.addEventListener("click", fl_ClickToGoToAndStopAtFrame_74.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_74()
		{
			this.gotoAndStop(106);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR16.addEventListener("click", fl_ClickToGoToAndStopAtFrame_75.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_75()
		{
			this.gotoAndStop(108);
		}
	}
	this.frame_108 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL17.addEventListener("click", fl_ClickToGoToAndStopAtFrame_76.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_76()
		{
			this.gotoAndStop(107);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR17.addEventListener("click", fl_ClickToGoToAndStopAtFrame_77.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_77()
		{
			this.gotoAndStop(109);
		}
	}
	this.frame_109 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL18.addEventListener("click", fl_ClickToGoToAndStopAtFrame_78.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_78()
		{
			this.gotoAndStop(108);
		}
		
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR18.addEventListener("click", fl_ClickToGoToAndStopAtFrame_80.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_80()
		{
			this.gotoAndStop(110);
		}
	}
	this.frame_110 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL19.addEventListener("click", fl_ClickToGoToAndStopAtFrame_81.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_81()
		{
			this.gotoAndStop(109);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR19.addEventListener("click", fl_ClickToGoToAndStopAtFrame_82.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_82()
		{
			this.gotoAndStop(111);
		}
	}
	this.frame_111 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL20.addEventListener("click", fl_ClickToGoToAndStopAtFrame_83.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_83()
		{
			this.gotoAndStop(110);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR20.addEventListener("click", fl_ClickToGoToAndStopAtFrame_84.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_84()
		{
			this.gotoAndStop(112);
		}
	}
	this.frame_112 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL21.addEventListener("click", fl_ClickToGoToAndStopAtFrame_85.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_85()
		{
			this.gotoAndStop(111);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR21.addEventListener("click", fl_ClickToGoToAndStopAtFrame_86.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_86()
		{
			this.gotoAndStop(113);
		}
	}
	this.frame_113 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL22.addEventListener("click", fl_ClickToGoToAndStopAtFrame_87.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_87()
		{
			this.gotoAndStop(112);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR22.addEventListener("click", fl_ClickToGoToAndStopAtFrame_88.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_88()
		{
			this.gotoAndStop(114);
		}
	}
	this.frame_114 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL23.addEventListener("click", fl_ClickToGoToAndStopAtFrame_89.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_89()
		{
			this.gotoAndStop(113);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR23.addEventListener("click", fl_ClickToGoToAndStopAtFrame_90.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_90()
		{
			this.gotoAndStop(115);
		}
	}
	this.frame_115 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL24.addEventListener("click", fl_ClickToGoToAndStopAtFrame_91.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_91()
		{
			this.gotoAndStop(114);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR24.addEventListener("click", fl_ClickToGoToAndStopAtFrame_92.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_92()
		{
			this.gotoAndStop(116);
		}
	}
	this.frame_116 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL25.addEventListener("click", fl_ClickToGoToAndStopAtFrame_93.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_93()
		{
			this.gotoAndStop(115);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR25.addEventListener("click", fl_ClickToGoToAndStopAtFrame_94.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_94()
		{
			this.gotoAndStop(117);
		}
	}
	this.frame_117 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL26.addEventListener("click", fl_ClickToGoToAndStopAtFrame_95.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_95()
		{
			this.gotoAndStop(116);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR26.addEventListener("click", fl_ClickToGoToAndStopAtFrame_96.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_96()
		{
			this.gotoAndStop(118);
		}
	}
	this.frame_118 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL27.addEventListener("click", fl_ClickToGoToAndStopAtFrame_97.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_97()
		{
			this.gotoAndStop(117);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR27.addEventListener("click", fl_ClickToGoToAndStopAtFrame_98.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_98()
		{
			this.gotoAndStop(119);
		}
	}
	this.frame_119 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL28.addEventListener("click", fl_ClickToGoToAndStopAtFrame_99.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_99()
		{
			this.gotoAndStop(118);
		}
		
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonR28.addEventListener("click", fl_ClickToGoToAndStopAtFrame_100.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_100()
		{
			this.gotoAndStop(120);
		}
	}
	this.frame_120 = function() {
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.buttonL29.addEventListener("click", fl_ClickToGoToAndStopAtFrame_101.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_101()
		{
			this.gotoAndStop(119);
		}
		
		
		
		
		/* Click to Go to Frame and Play
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and continues playback from that frame.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		this.buttonR29.addEventListener("click", fl_ClickToGoToAndPlayFromFrame_18.bind(this));
		
		function fl_ClickToGoToAndPlayFromFrame_18()
		{
			this.gotoAndPlay(121);
		}
	}
	this.frame_164 = function() {
		/* Stop at This Frame
		The  timeline will stop/pause at the frame where you insert this code.
		Can also be used to stop/pause the timeline of movieclips.
		*/
		
		this.stop();
		
		/* Click to Go to Frame and Stop
		Clicking on the specified symbol instance moves the playhead to the specified frame in the timeline and stops the movie.
		Can be used on the main timeline or on movie clip timelines.
		
		Instructions:
		1. Replace the number 5 in the code below with the frame number you would like the playhead to move to when the symbol instance is clicked.
		2.Frame numbers in EaselJS start at 0 instead of 1
		*/
		
		
		this.restart.addEventListener("click", fl_ClickToGoToAndStopAtFrame_103.bind(this));
		
		function fl_ClickToGoToAndStopAtFrame_103()
		{
			this.gotoAndStop(0);
		}
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(1).call(this.frame_1).wait(1).call(this.frame_2).wait(47).call(this.frame_49).wait(1).call(this.frame_50).wait(1).call(this.frame_51).wait(1).call(this.frame_52).wait(1).call(this.frame_53).wait(1).call(this.frame_54).wait(1).call(this.frame_55).wait(1).call(this.frame_56).wait(1).call(this.frame_57).wait(1).call(this.frame_58).wait(1).call(this.frame_59).wait(1).call(this.frame_60).wait(1).call(this.frame_61).wait(44).call(this.frame_105).wait(1).call(this.frame_106).wait(1).call(this.frame_107).wait(1).call(this.frame_108).wait(1).call(this.frame_109).wait(1).call(this.frame_110).wait(1).call(this.frame_111).wait(1).call(this.frame_112).wait(1).call(this.frame_113).wait(1).call(this.frame_114).wait(1).call(this.frame_115).wait(1).call(this.frame_116).wait(1).call(this.frame_117).wait(1).call(this.frame_118).wait(1).call(this.frame_119).wait(1).call(this.frame_120).wait(44).call(this.frame_164).wait(1));

	// Layer 1
	this.instance = new lib.restart();
	this.instance.parent = this;
	this.instance.setTransform(1011.4,473.6);
	this.instance.alpha = 0.629;
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.restart = new lib.restart();
	this.restart.name = "restart";
	this.restart.parent = this;
	this.restart.setTransform(1011.4,473.6);
	this.restart.alpha = 0.82;
	new cjs.ButtonHelper(this.restart, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance}]},157).to({state:[{t:this.restart}]},7).wait(1));

	// Layer_6
	this.instance_1 = new lib.blk_opacity();
	this.instance_1.parent = this;
	this.instance_1.setTransform(1017,496.6);
	this.instance_1.alpha = 0;
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(153).to({_off:false},0).to({alpha:0.699},11).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#484A4E").s().p("AgVByIA1hLIgBAAQgQAGgPAAQgjAAgZgZQgagYAAgjQAAgjAagYQAagYAjAAQAkAAAZAYQAYAZAAAkQAAAagRAZIhNBtgAgxhYQgVAVAAAcQAAAdAVAUQAVAUAdABQAcgBAVgUQAVgUAAgdQAAgcgVgVQgVgUgcAAQgdAAgVAUg");
	this.shape.setTransform(176.3,670.5,0.5,0.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#484A4E").s().p("AAMB5IAAjiIgmAAIAHgPIAuAAIAADxg");
	this.shape_1.setTransform(165.6,670.5,0.5,0.5);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#484A4E").s().p("AgRCGIAAiGIgQAAIAAgNIAQAAIAAhCQAAgZAGgLQALgSAVAAQAHAAAGACIAAANIgMgCQgRAAgFAPQgCAJgBAUIAAA/IAlAAIAAANIglAAIAACGg");
	this.shape_2.setTransform(237.9,669.9,0.5,0.5);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#484A4E").s().p("Ag2A2QgYgWAAggQABgfAWgWQAXgXAgAAQAhAAAWAWQAYAXAAAfQAAAhgYAWQgWAWghAAQggAAgWgXgAgtgrQgRASAAAZQAAAaASATQARATAbAAQAbAAASgSQATgTAAgbQAAgagTgSQgSgTgbAAQgaAAgTAUg");
	this.shape_3.setTransform(231.3,672.9,0.5,0.5);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#484A4E").s().p("AgfBCQgOgKgEgSIAOgEQAJAeAbAAQAOAAALgKQAKgKAAgOQAAgMgJgHQgHgEgOgGQgUgGgJgGQgOgLAAgQQAAgRAMgKQANgLAPAAQAMAAALAHQAKAGAGALIgNAGQgIgQgTgBQgIAAgIAIQgIAGAAAKQAAAPAjAOQAlANAAAcQAAAUgOANQgOANgVAAQgSAAgOgLg");
	this.shape_4.setTransform(218.7,672.9,0.5,0.5);

	this.shape_5 = new cjs.Shape();
	this.shape_5.graphics.f("#484A4E").s().p("AgfBMIAAiTIAPAAIAAATIAAAAQAKgXAWABQAHAAAJADIgIANQgFgDgFAAQgVAAgGAXQgDALAAAbIAABMg");
	this.shape_5.setTransform(214.1,672.8,0.5,0.5);

	this.shape_6 = new cjs.Shape();
	this.shape_6.graphics.f("#484A4E").s().p("Ag0A2QgUgWAAggQAAghATgVQAVgWAgAAQASAAAPAHQAPAIAKAOIABAAIAAgZIAOAAIAACSIgOAAIAAgbIgBAAQgIAOgRAJQgPAHgRAAQghAAgUgXgAgqgrQgQASAAAZQAAAaAQATQARATAZAAQAcAAAQgUQAQgSAAgbQAAgbgRgQQgRgSgagBQgZAAgRAUg");
	this.shape_6.setTransform(206.3,672.9,0.5,0.5);

	this.shape_7 = new cjs.Shape();
	this.shape_7.graphics.f("#484A4E").s().p("Ag0A2QgUgWAAggQAAgfAUgWQAVgXAfAAQAhAAAVAXQATAXgBAfIiBAAQgBAcASASQARARAZAAQARAAAOgKQAOgJAIgPIAMAHQgVAoguAAQgfAAgVgXgAgmgvQgRAPgCAVIBzAAQgDgVgQgPQgQgQgXAAQgVAAgRAQg");
	this.shape_7.setTransform(198,672.9,0.5,0.5);

	this.shape_8 = new cjs.Shape();
	this.shape_8.graphics.f("#484A4E").s().p("AgHB5IAAhoIhSiIIASAAIBHB4IBIh4IARAAIhSCIIAABog");
	this.shape_8.setTransform(190.9,670.5,0.5,0.5);

	this.shape_9 = new cjs.Shape();
	this.shape_9.graphics.f("#484A4E").s().p("AgyBlQgVgRgDgeIAPAAQACAXARANQAQAOAXAAQAgAAAQgWQANgUAAgkIAAgSIgBAAQgJANgRAIQgPAHgSAAQgeAAgVgXQgUgVAAggQAAggAVgWQAVgXAgAAQAiAAAWAdIABAAIAAgZIAPAAIAACMQAAAUgDAMQgDARgKANQgVAdgmgBQgeAAgUgQgAgohTQgQASgBAZQABAbAQARQAQATAaABQAbAAAQgVQAQgRgBgcQAAgagQgRQgQgSgcAAQgXAAgRAUg");
	this.shape_9.setTransform(151.2,674.9,0.5,0.5);

	this.shape_10 = new cjs.Shape();
	this.shape_10.graphics.f("#484A4E").s().p("AAoBMIAAhYQAAgZgGgKQgIgOgWAAQgrAAAABAIAABJIgOAAIAAiTIAOAAIAAAXIABAAQAOgbAdABQAcAAAMARQAJAOABAfIAABYg");
	this.shape_10.setTransform(143,672.8,0.5,0.5);

	this.shape_11 = new cjs.Shape();
	this.shape_11.graphics.f("#484A4E").s().p("AgHBpIAAiSIAOAAIAACSgAgIhSQgEgEAAgFQAAgGAEgDQADgEAFAAQAGAAADAEQAEADABAGQgBAFgEAEQgDAFgGAAQgFAAgDgFg");
	this.shape_11.setTransform(137.1,671.3,0.5,0.5);

	this.shape_12 = new cjs.Shape();
	this.shape_12.graphics.f("#484A4E").s().p("AgLBkIAAiFIgRAAIAAgNIARAAIAAg1IAOAAIAAA1IAaAAIAAANIgaAAIAACFg");
	this.shape_12.setTransform(133.7,671.5,0.5,0.5);

	this.shape_13 = new cjs.Shape();
	this.shape_13.graphics.f("#484A4E").s().p("Ag0A2QgUgWAAggQAAghATgVQAVgWAgAAQASAAAPAHQAPAIAKAOIABAAIAAgZIAOAAIAACSIgOAAIAAgbIgBAAQgIAOgRAJQgPAHgRAAQghAAgUgXgAgpgrQgRASAAAZQAAAaAQATQARATAZAAQAcAAAQgUQAQgSAAgbQAAgbgRgQQgRgSgagBQgYAAgRAUg");
	this.shape_13.setTransform(126.9,672.9,0.5,0.5);

	this.shape_14 = new cjs.Shape();
	this.shape_14.graphics.f("#484A4E").s().p("AgfBMIAAiTIAPAAIAAATIABAAQAJgXAWABQAHAAAJADIgIANQgFgDgGAAQgTAAgHAXQgDALAAAbIAABMg");
	this.shape_14.setTransform(121,672.8,0.5,0.5);

	this.shape_15 = new cjs.Shape();
	this.shape_15.graphics.f("#484A4E").s().p("AghB+QgQgIgIgOIgBAAIAAAaIgOAAIAAkGIAOAAIAACMIABAAQAJgMAQgIQAPgIARAAQAhAAAUAVQAUAWAAAhQAAAhgUAWQgVAWggAAQgRAAgQgHgAgrALQgQASAAAbQAAAbAQASQAQATAbAAQAaAAARgTQAPgTAAgaQAAgagQgSQgRgSgZAAQgbAAgQARg");
	this.shape_15.setTransform(114,670,0.5,0.5);

	this.shape_16 = new cjs.Shape();
	this.shape_16.graphics.f("#484A4E").s().p("Ag0A2QgTgWAAggQgBgfAVgWQAUgXAfAAQAhAAAVAXQATAXAAAfIiCAAQAAAcAQASQARARAaAAQAjAAASgiIAMAHQgUAogvAAQgfAAgVgXgAgmgvQgRAPgCAVIBzAAQgDgVgQgPQgQgQgWAAQgWAAgRAQg");
	this.shape_16.setTransform(104.9,672.9,0.5,0.5);

	this.shape_17 = new cjs.Shape();
	this.shape_17.graphics.f("#484A4E").s().p("AgGCEIAAkHIANAAIAAEHg");
	this.shape_17.setTransform(99.2,670,0.5,0.5);

	this.shape_18 = new cjs.Shape();
	this.shape_18.graphics.f("#484A4E").s().p("Ag0A2QgUgWAAggQAAgfAUgWQAVgXAfAAQAhAAAVAXQATAXgBAfIiBAAQgBAcASASQARARAZAAQARAAAOgKQAOgJAIgPIAMAHQgVAoguAAQgfAAgVgXgAgmgvQgRAPgCAVIBzAAQgDgVgQgPQgQgQgXAAQgVAAgRAQg");
	this.shape_18.setTransform(93.4,672.9,0.5,0.5);

	this.shape_19 = new cjs.Shape();
	this.shape_19.graphics.f("#484A4E").s().p("AhBBXQgngkAAgzQAAgxAmglQAmglA0ABQAvgBAiAgIAAAVQgOgRgXgLQgXgKgWAAQgtAAghAhQghAhAAArQAAAsAhAfQAQAPAUAJQAVAKAVAAQAVAAAYgLQAYgKANgRIAAAWQglAdgtAAQgyABgmglg");
	this.shape_19.setTransform(83.1,670.5,0.5,0.5);

	this.shape_20 = new cjs.Shape();
	this.shape_20.graphics.f("#BAD0D0").s().p("AwWCZQhAg/ABhXQAAhYBBhAQBCg/BdAAQAzAAAuAVQAvAVAfAmIgmAiQgXgegkgTQglgSgnAAQhJAAgyAxQgxAxAABEQAABCAwAzQAzA0BEAAQA0AAArgkQAtglACgyIhwAAIAAgvICsAAIAAARQAABVg5A5Qg7A6hZAAQhaAAhBhAgAlFDVIgxhoIjGAAIgyBoIg5AAIDOmtIDPGtgAmMA+IhNimIhNCmICaAAgAOTDQIAAizIiNjoIA+AAIBqCwIBriwIA+AAIiODoIAACzgALHDQIh/iuIgWAAIAACuIg2AAIAAmbIBCAAQAlAAAVACQAgAEAYANQAaAPAPAbQAPAaAAAeQAAAtgcAhQgdAggvAFICJCzgAIygIIASAAQAzAAAagNQAlgSAAgtQAAgrgngSQgcgMgzAAIgOAAgADSDQIAAmbIDnAAIAAAvIixAAIAABzICtAAIAAAuIitAAIAACcICxAAIAAAvgAgKDQIAAmbIA1AAIAAFsICDAAIAAAvgAjmDQIAAmbIA2AAIAAFsICCAAIAAAvg");
	this.shape_20.setTransform(213.2,638.8,0.5,0.5);

	this.shape_21 = new cjs.Shape();
	this.shape_21.graphics.f("#547C7D").s().p("AzGFtIAArZMAmOAAAIAALZgAyqFSMAlWAAAIAAqkMglWAAAg");
	this.shape_21.setTransform(212.4,639.3,0.5,0.5);

	this.shape_22 = new cjs.Shape();
	this.shape_22.graphics.f("#FFFFFF").s().p("ACVDXIgyhnIjFAAIgxBnIg6AAIDNmtIDOGtgAhMBAICZAAIhNilg");
	this.shape_22.setTransform(131,638.7,0.5,0.5);

	this.shape_23 = new cjs.Shape();
	this.shape_23.graphics.f("#FFFFFF").s().p("AiGhjIAAEyIg2AAIAAmvIFEFEIAAkwIA1AAIAAGsg");
	this.shape_23.setTransform(109.7,638.9,0.5,0.5);

	this.shape_24 = new cjs.Shape();
	this.shape_24.graphics.f("#FFFFFF").s().p("AgaDOIAAmbIA1AAIAAGbg");
	this.shape_24.setTransform(95.1,638.9,0.5,0.5);

	this.shape_25 = new cjs.Shape();
	this.shape_25.graphics.f("#FFFFFF").s().p("AgaDOIAAlsIhmAAIAAgvIEBAAIAAAvIhmAAIAAFsg");
	this.shape_25.setTransform(85.3,638.9,0.5,0.5);

	this.shape_26 = new cjs.Shape();
	this.shape_26.graphics.f("#FFFFFF").s().p("ACVDXIgyhnIjFAAIgxBnIg6AAIDNmtIDOGtgAhMBAICZAAIhNilg");
	this.shape_26.setTransform(70.9,638.7,0.5,0.5);

	this.shape_27 = new cjs.Shape();
	this.shape_27.graphics.f("#FFFFFF").s().p("Ah1DOIAAmbIA+AAQBfAAApAfQAlAcAAA8QAAA9gsAfQgoAbhCAAIgfAAIAACtgAg/gMIARAAQAyAAAbgNQAlgSAAgsQAAgrgngRQgbgMgyAAIgPAAg");
	this.shape_27.setTransform(56.9,638.9,0.5,0.5);

	this.shape_28 = new cjs.Shape();
	this.shape_28.graphics.f("#A2C0BE").s().p("AwOFrIAArVMAgdAAAIAALVg");
	this.shape_28.setTransform(96,639.3,0.5,0.5);

	this.shape_29 = new cjs.Shape();
	this.shape_29.graphics.f("#484A4E").s().p("AgxAyQgUgVAAgdQAAgcAUgVQAVgUAcAAQAdAAAVAUQAUAVAAAcQAAAdgUAVQgVAUgdAAQgcAAgVgUgAgrgrQgSATAAAYQAAAaASASQASARAZABQAagBASgRQARgSAAgaQAAgYgRgTQgSgRgagBQgZABgSARgAAXAoIgWgjIgRAAIAAAjIgJAAIAAhMIAhAAQAbAAAAAUQAAATgYACIAXAjgAgQgEIAPAAQAOAAADgBQAKgCAAgJQAAgLgUAAIgWAAg");
	this.shape_29.setTransform(258.7,689.3,0.5,0.5);

	this.shape_30 = new cjs.Shape();
	this.shape_30.graphics.f("#484A4E").s().p("AgsBqQgSgNgIgXIANgGQARAqAnAAQAXAAARgQQARgQAAgXQAAgRgQgNQgIgGgXgMIgpgVQgZgQAAgaQAAgaARgRQARgQAZAAQASAAAQAJQAPAIAJAQIgLAIQgSgbgeAAQgRAAgNANQgNANAAASQAAAQAOAMQAIAHAUAJIAsAXQAbAQAAAeQAAAdgWAUQgWATgcAAQgYAAgTgOg");
	this.shape_30.setTransform(248.9,692,0.5,0.5);

	this.shape_31 = new cjs.Shape();
	this.shape_31.graphics.f("#484A4E").s().p("AA5B1IhwhwIgFAGIAABqIgPAAIAAjpIAPAAIAABtIBuhtIATAAIhxBxIB5B4g");
	this.shape_31.setTransform(238.9,692,0.5,0.5);

	this.shape_32 = new cjs.Shape();
	this.shape_32.graphics.f("#484A4E").s().p("AApB1IhLhvIgIAAIAABvIgPAAIAAjpIAdAAQATAAAJABQAPADAKAIQAYAQgBAiQAAAegSAQQgSAPgdgBIBLBvgAgqgHIATAAQAcAAAMgLQAQgNAAgYQAAgNgFgLQgHgMgMgGQgKgFgfAAIgKAAg");
	this.shape_32.setTransform(228.5,692,0.5,0.5);

	this.shape_33 = new cjs.Shape();
	this.shape_33.graphics.f("#484A4E").s().p("AhUBVQglgkAAgxQAAgwAkgkQAkgjAxAAQAyAAAkAjQAkAkAAAwQAAAxgkAkQgkAjgyAAQgwAAgkgjgAhKhKQggAgAAAqQAAArAgAgQAfAfArAAQAsAAAfgfQAgggAAgrQAAgqggggQgfgfgsAAQgrAAgfAfg");
	this.shape_33.setTransform(215.7,692,0.5,0.5);

	this.shape_34 = new cjs.Shape();
	this.shape_34.graphics.f("#484A4E").s().p("AAAhZIhZDYIhOjxIAPAAIBCDIIBXjUIBXDUIBBjIIAPAAIhPDxg");
	this.shape_34.setTransform(198.5,691.9,0.5,0.5);

	this.shape_35 = new cjs.Shape();
	this.shape_35.graphics.f("#484A4E").s().p("AhQBVQgkgkAAgwQAAgxAkgkQAkgjAxAAQA+AAAoA2IgMAKQgigyg5AAQgpAAggAgQggAgAAApQAAArAfAgQAfAfArAAQAlAAAggaQAbgWACgoIhUAAIAAgOIBjAAQAAAZgEARQgGAVgPAPQgQASgYAKQgYAKgZAAQgwAAgjgjg");
	this.shape_35.setTransform(174.8,692,0.5,0.5);

	this.shape_36 = new cjs.Shape();
	this.shape_36.graphics.f("#484A4E").s().p("AhahVIAADIIgPAAIAAjsIDEDOIAAjMIAPAAIAADyg");
	this.shape_36.setTransform(159.9,692.1,0.5,0.5);

	this.shape_37 = new cjs.Shape();
	this.shape_37.graphics.f("#484A4E").s().p("AgHB1IAAjpIAPAAIAADpg");
	this.shape_37.setTransform(149.8,692,0.5,0.5);

	this.shape_38 = new cjs.Shape();
	this.shape_38.graphics.f("#484A4E").s().p("AApB1IhMhvIgIAAIAABvIgOAAIAAjpIAdAAQASAAAKABQAOADAKAIQAYAQAAAiQAAAegTAQQgSAPgdgBIBMBvgAgrgHIAUAAQAbAAAMgLQARgNAAgYQAAgNgGgLQgHgMgMgGQgKgFgeAAIgLAAg");
	this.shape_38.setTransform(142.8,692,0.5,0.5);

	this.shape_39 = new cjs.Shape();
	this.shape_39.graphics.f("#484A4E").s().p("AApB1IhMhvIgHAAIAABvIgPAAIAAjpIAeAAQARAAAKABQAPADAKAIQAXAQAAAiQABAegUAQQgSAPgdgBIBMBvgAgqgHIATAAQAcAAAMgLQARgNAAgYQAAgOgHgKQgGgMgMgGQgLgFgfAAIgJAAg");
	this.shape_39.setTransform(133.3,692,0.5,0.5);

	this.shape_40 = new cjs.Shape();
	this.shape_40.graphics.f("#484A4E").s().p("AgGB1IAAjpIANAAIAADpg");
	this.shape_40.setTransform(125.5,692,0.5,0.5);

	this.shape_41 = new cjs.Shape();
	this.shape_41.graphics.f("#484A4E").s().p("AgHB1IAAjbIg8AAIAAgOICHAAIAAAOIg9AAIAADbg");
	this.shape_41.setTransform(118.5,692,0.5,0.5);

	this.shape_42 = new cjs.Shape();
	this.shape_42.graphics.f("#484A4E").s().p("AgsBqQgSgNgIgXIANgGQAQAqApAAQAWAAARgQQARgQAAgXQAAgRgQgNQgHgGgYgMIgpgVQgYgPAAgbQAAgaARgRQAQgQAaAAQASAAAPAJQAQAJAIAPIgLAIQgRgbgeAAQgSAAgNANQgMANAAASQAAAQAOAMQAHAHAUAJIAtAXQAaAQAAAeQAAAdgWAUQgWATgcAAQgYAAgTgOg");
	this.shape_42.setTransform(108.8,692,0.5,0.5);

	this.shape_43 = new cjs.Shape();
	this.shape_43.graphics.f("#484A4E").s().p("AgcAHIAAgNIA5AAIAAANg");
	this.shape_43.setTransform(101.1,692.9,0.5,0.5);

	this.shape_44 = new cjs.Shape();
	this.shape_44.graphics.f("#484A4E").s().p("AgkB1IAAjpIAPAAIAADbIA6AAIAAAOg");
	this.shape_44.setTransform(95.7,692,0.5,0.5);

	this.shape_45 = new cjs.Shape();
	this.shape_45.graphics.f("#484A4E").s().p("Ag/BbQgKgNgEgRQgCgLAAgXIAAiRIAPAAIAACNQAAAWACAKQACARAIAKQAIALAQAGQAOAGAOAAQAPAAAOgGQAQgGAIgLQAIgKACgRQACgKAAgWIAAiNIAPAAIAACRQAAAXgCALQgDARgLANQgZAcgnAAQgmAAgZgcg");
	this.shape_45.setTransform(85.5,692.1,0.5,0.5);

	this.shape_46 = new cjs.Shape();
	this.shape_46.graphics.f("#484A4E").s().p("AhUBVQgkgkAAgxQAAgwAkgkQAjgjAxAAQAxAAAlAjQAjAkABAwQgBAxgjAkQglAjgxAAQgxAAgjgjgAhKhKQgfAggBAqQABArAfAgQAfAfArAAQAsAAAfgfQAfggABgrQgBgqgfggQgfgfgsAAQgqAAggAfg");
	this.shape_46.setTransform(71.8,692,0.5,0.5);

	this.shape_47 = new cjs.Shape();
	this.shape_47.graphics.f("#484A4E").s().p("AgsBqQgSgNgIgXIANgGQARAqAnAAQAXAAARgQQARgQAAgXQAAgRgQgNQgIgGgXgMIgpgVQgZgQAAgaQAAgaARgRQARgQAZAAQASAAAQAJQAPAIAJAQIgLAIQgRgbgfAAQgRAAgNANQgNANAAASQAAAQAOAMQAIAHAUAJIAsAXQAbAQAAAeQAAAdgWAUQgWATgcAAQgYAAgTgOg");
	this.shape_47.setTransform(59,692,0.5,0.5);

	this.shape_48 = new cjs.Shape();
	this.shape_48.graphics.f("#A3A5A8").s().p("AhZEpQAegwAIghIAThKQAHAPAUAKQATALAWAAQBEAAAtg5QAtg4AAhQQAAhNg2gzQg2g0hPAAQhdAAg3A6QgzA0AABPQAAAjAQAiQASAlAbANQAIAEACgIIAJgjQABgGgDgDQgKgMgGgUQgHgUAAgSQAAg3AkgmQAngqA+AAQA3AAAjAjQAkAjAAA4QAAA+gcAoQgbAogpAAQgXAAgMgRQgOgQAFgXIAPg4QAJgfAAgQQAAgTgJgMQgJgNgTAAQgXAAgQAWQgQAVAAAgQAAAbAJATIgjCbQgHAeAGA7QhWgig1hPQg2hPAAhiQAAiABZhbQBZhbB8AAQB+AABZBbQBYBbAACAQAACBhYBbQhZBbh+AAQgsAAgtgOg");
	this.shape_48.setTransform(509.3,681.9,0.5,0.5);

	this.shape_49 = new cjs.Shape();
	this.shape_49.graphics.f("#FFFFFF").s().p("AgiClIAAiXIgzAAIAAg5IAzAAIAAgsQAAglAVgUQATgUAjAAQAXAAAWACIAAA0IgfAAQgRAAgHAIQgFAHAAAOIAAAmIA6AAIgHA5IgzAAIAACXg");
	this.shape_49.setTransform(402.1,681.2,0.5,0.5);

	this.shape_50 = new cjs.Shape();
	this.shape_50.graphics.f("#A3A5A8").s().p("AjbDcQhchbAAiBQAAiABchbQBbhbCAAAQCBAABcBbQBbBbAACAQAACBhbBbQhcBbiBAAQiAAAhbhbg");
	this.shape_50.setTransform(402.7,681.9,0.5,0.5);

	this.shape_51 = new cjs.Shape();
	this.shape_51.graphics.f("#FFFFFF").s().p("AiZBgIAPABQAsAAAjgbQgVAAgQgMQgRgMgGgTIAMABQAIAAAJgDQgWgEgOgRQgPgRAAgWIAAgBQAMAHARABQgcgTAAgiQAAgRAIgOQAYAdAiARQAiARAnACQgCgGAAgIQAAgaASgSQASgTAaAAQAcAAASAUQAUgEAVgLQgIAWgUANQASgCASgIQgMASgTAOIAAAIQAABEgvA0QgzA7hRAAQg1AAgsgdg");
	this.shape_51.setTransform(439.2,681.9,0.5,0.5);

	this.shape_52 = new cjs.Shape();
	this.shape_52.graphics.f("#A3A5A8").s().p("AjbDcQhchbAAiBQAAiABchbQBbhbCAAAQCBAABbBbQBcBbAACAQAACBhcBbQhbBbiBAAQiAAAhbhbg");
	this.shape_52.setTransform(438.5,681.9,0.5,0.5);

	this.shape_53 = new cjs.Shape();
	this.shape_53.graphics.f("#FFFFFF").s().p("AgNAOQgGgFgBgJQABgHAGgGQAFgGAIAAQAJAAAFAGQAHAGAAAHQAAAJgHAFQgFAGgJAAQgIAAgFgGg");
	this.shape_53.setTransform(478.9,677.4,0.5,0.5);

	this.shape_54 = new cjs.Shape();
	this.shape_54.graphics.f("#FFFFFF").s().p("Ag9A9QgZgZAAgkQAAgkAZgZQAagZAjAAQAkAAAaAZQAZAZAAAkQAAAkgZAZQgaAagkAAQgjAAgagagAgngnQgRARAAAWQAAAXARARQARAQAWABQAXgBARgQQARgRAAgXQAAgWgRgRQgRgQgXgBQgXABgQAQg");
	this.shape_54.setTransform(474.3,682,0.5,0.5);

	this.shape_55 = new cjs.Shape();
	this.shape_55.graphics.f("#FFFFFF").s().p("AhFCoQgYgBgRgHQgSgHgNgMQgMgMgHgSQgHgSgBgYIgBhFIABhFQABgXAHgSQAHgTAMgLQAOgOARgGQASgHAXAAQASgCAzAAIBGACQAXAAASAHQARAGAOAOQAMANAHARQAHASABAXIABBFIgBBFQgBAYgHASQgHAQgMAOQgNAMgSAHQgRAHgYABIhGABIhFgBgAhEiJQgQAAgPAGQgLADgJAJQgJAKgEAKQgFAPgBARIAACIQABAQAFAPQAFALAIAIQAKAJAKAEQALAFAUABIBEABIBFgBQAUgBALgFQAKgEAKgJQAHgHAGgMQAFgPAAgQIABhFIgBhDQAAgRgFgPQgFgMgIgIQgJgJgLgDQgPgGgQAAIhFgBIhEABg");
	this.shape_55.setTransform(474.3,682,0.5,0.5);

	this.shape_56 = new cjs.Shape();
	this.shape_56.graphics.f("#A3A5A8").s().p("AjbDcQhchbAAiBQAAiABchbQBbhbCAAAQCBAABbBbQBcBbAACAQAACBhcBbQhbBbiBAAQiAAAhbhbg");
	this.shape_56.setTransform(474.1,681.9,0.5,0.5);

	this.shape_57 = new cjs.Shape();
	this.shape_57.graphics.f("#A2C0BE").s().p("AhjAbIgUg1IDvAAIAAA1g");
	this.shape_57.setTransform(406.9,633.5,0.5,0.5);

	this.shape_58 = new cjs.Shape();
	this.shape_58.graphics.f("#A2C0BE").s().p("AGVhIIgCAAIg0EkIguAAIBSnJICUFrICUlrIBSHJIguAAIg1kkIgBAAIiCE2gAh2CjQg+hCAAhdQAAhcA+hBQA+hCBWAAQBXAAA+BCQA+BCAABbQAABdg+BCQg+BBhXAAQhWAAg+hBgAhXh6QgwA1AABJQAABJAwA1QAxA1BEAAQBEAAAxg1QAxg1AAhJQAAhJgwg1Qgxg1hFAAQhFAAgwA1gAoaCjQg/hCAAhcQAAhcA+hCQA+hCBXAAQBEAAA1AqIAAA8QgYgbgggPQghgQgiAAQhEAAgwA2QgwA1AABIQAABIAwA1QAxA2BEAAQAhAAAhgQQAggPAYgbIAAA8Qg3ArhCAAQhWAAg+hBgArzDaQgJgKAAgNQAAgNAJgJQAJgKAMAAQANAAAIAKQAJAJAAANQAAANgJAKQgIAKgNAAQgMAAgJgKg");
	this.shape_58.setTransform(563.6,633.6,0.5,0.5);

	this.shape_59 = new cjs.Shape();
	this.shape_59.graphics.f("#A2C0BE").s().p("AgZDlIAAjHIiKkCIA9AAIBmDEIBnjEIA9AAIiKECIAADHg");
	this.shape_59.setTransform(515.5,633.6,0.5,0.5);

	this.shape_60 = new cjs.Shape();
	this.shape_60.graphics.f("#A2C0BE").s().p("ABEDlIh8jCIgVAAIAADCIg1AAIAAnJIBAAAQAkAAAVADQAeAFAXANQAaARAPAeQAOAeAAAgQAAAygcAlQgcAjgsAGICEDHgAhNgLIARAAQAxAAAZgPQAkgTAAgyQAAgwglgUQgbgOgyAAIgNAAg");
	this.shape_60.setTransform(500.8,633.6,0.5,0.5);

	this.shape_61 = new cjs.Shape();
	this.shape_61.graphics.f("#A2C0BE").s().p("AhwDlIAAnJIDhAAIAAA1IisAAIAACAICnAAIAAAzIinAAIAACtICsAAIAAA0g");
	this.shape_61.setTransform(485.4,633.6,0.5,0.5);

	this.shape_62 = new cjs.Shape();
	this.shape_62.graphics.f("#A2C0BE").s().p("AhZDlIAAnJIA0AAIAAGVIB/AAIAAA0g");
	this.shape_62.setTransform(473.5,633.6,0.5,0.5);

	this.shape_63 = new cjs.Shape();
	this.shape_63.graphics.f("#A2C0BE").s().p("AhZDlIAAnJIA0AAIAAGVIB/AAIAAA0g");
	this.shape_63.setTransform(462.7,633.6,0.5,0.5);

	this.shape_64 = new cjs.Shape();
	this.shape_64.graphics.f("#A2C0BE").s().p("ACRDvIgwhzIjBAAIgwBzIg4AAIDIndIDJHdgAhKBIICVAAIhLi4g");
	this.shape_64.setTransform(446.4,633.1,0.5,0.5);

	this.shape_65 = new cjs.Shape();
	this.shape_65.graphics.f("#A2C0BE").s().p("AiPCoQg+hHAAhgQAAhiBAhGQBAhGBaAAQAxAAAtAWQAuAYAfAqIglAnQgWgjgkgUQgkgUgmAAQhGAAgxA2QgxA2AABNQAABJAwA4QAxA5BCAAQAzAAAqgnQAsgqABg2IhtAAIAAg0ICnAAIAAARQAABfg3BAQg5A/hXABQhXgBg/hGg");
	this.shape_65.setTransform(425.6,633.6,0.5,0.5);

	this.shape_66 = new cjs.Shape();
	this.shape_66.graphics.f("#A2C0BE").s().p("ACRDvIgwhzIjBAAIgwBzIg4AAIDIndIDJHdgAhKBIICVAAIhLi4g");
	this.shape_66.setTransform(394.1,633.1,0.5,0.5);

	this.shape_67 = new cjs.Shape();
	this.shape_67.graphics.f("#A2C0BE").s().p("AiDhuIAAFUIg0AAIAAneIE7FnIAAlSIA1AAIAAHcg");
	this.shape_67.setTransform(373.3,633.5,0.5,0.5);

	this.shape_68 = new cjs.Shape();
	this.shape_68.graphics.f("#A2C0BE").s().p("AgZDlIAAnJIAzAAIAAHJg");
	this.shape_68.setTransform(359.1,633.6,0.5,0.5);

	this.shape_69 = new cjs.Shape();
	this.shape_69.graphics.f("#A2C0BE").s().p("AgZDlIAAmUIhkAAIAAg1ID7AAIAAA1IhkAAIAAGUg");
	this.shape_69.setTransform(349.5,633.6,0.5,0.5);

	this.shape_70 = new cjs.Shape();
	this.shape_70.graphics.f("#A2C0BE").s().p("ACRDvIgwhzIjBAAIgwBzIg4AAIDIndIDJHdgAhKBIICVAAIhLi4g");
	this.shape_70.setTransform(335.5,633.1,0.5,0.5);

	this.shape_71 = new cjs.Shape();
	this.shape_71.graphics.f("#A2C0BE").s().p("AhyDlIAAnJIA8AAQBdAAAoAjQAkAfAABDQAABEgrAhQgnAfhAAAIgeAAIAADAgAg9gNIAQAAQAxAAAagPQAkgTAAgyQAAgwglgTQgbgNgxAAIgOAAg");
	this.shape_71.setTransform(321.8,633.6,0.5,0.5);

	this.shape_72 = new cjs.Shape();
	this.shape_72.graphics.f("#000000").s().p("AB2CSIgghIIirAAIghBIIgQAAIgBgCICDkhIAKAAICCEhIgBACgAhOA6ICdAAIhPiwg");
	this.shape_72.setTransform(702.7,585.2,0.5,0.5);

	this.shape_73 = new cjs.Shape();
	this.shape_73.graphics.f("#000000").s().p("Ag1CJQgdgPgRgYIAAgCIAMgKIACAAQAPAWAYAOQAZANAaAAQAhAAAWgSQAVgRAAgaQAAgegdgSQgIgFg2gVQgigOgPgNQgXgUAAgeQAAggAZgVQAYgVAmAAQA3AAAeAoIAAACIgLAKIgCAAQgbgjgtAAQgeAAgTAQQgUAQAAAYQAAAWASAPQANAMAgANQA3AWANAHQAgAWAAAlQAAAkgZAWQgaAWgpAAQgfAAgdgPg");
	this.shape_73.setTransform(689.4,585.2,0.5,0.5);

	this.shape_74 = new cjs.Shape();
	this.shape_74.graphics.f("#000000").s().p("AhVB0QggghAAg2IAAixIARAAIAACxQAAAuAcAdQAcAcAsAAQAtAAAcgcQAcgdAAguIAAixIARAAIAACxQAAA2ggAhQghAhg1AAQg0AAghghg");
	this.shape_74.setTransform(675.6,585.4,0.5,0.5);

	this.shape_75 = new cjs.Shape();
	this.shape_75.graphics.f("#000000").s().p("AAPCSIAAkTIguAAIAAgQIA/AAIAAEjg");
	this.shape_75.setTransform(657.7,585.2,0.5,0.5);

	this.shape_76 = new cjs.Shape();
	this.shape_76.graphics.f("#000000").s().p("AhMBuQgfgqAAhEQAAhDAfgqQAdgqAvAAQAwAAAeAqQAdAqAABDQAABEgdAqQgeAqgwAAQgvAAgdgqgAhAhhQgYAlgBA8QABA8AYAlQAZAmAnAAQApAAAYgmQAZglAAg8QAAg8gZglQgYglgpAAQgnAAgZAlg");
	this.shape_76.setTransform(649,585.2,0.5,0.5);

	this.shape_77 = new cjs.Shape();
	this.shape_77.graphics.f("#000000").s().p("Ag3CLQgagLgQgTIAAgDIAKgJIACAAQAOARAXAKQAUAIAWAAQAlAAAZgWQAZgYAAgkQAAgjgWgVQgXgXgkAAQgYAAgWALQgUAJgLAOIgBAAIgNgFIAXiUICOAAIAAAQIiAAAIgRBvQAggYAnAAQAtAAAbAcQAaAaAAApQAAArgeAcQgdAcgsAAQgZAAgZgKg");
	this.shape_77.setTransform(636.4,585.4,0.5,0.5);

	this.shape_78 = new cjs.Shape();
	this.shape_78.graphics.f("#000000").s().p("AgyCSIgBgBIB6kSIiiAAIAAgQIC3AAIAAAKIh9EZg");
	this.shape_78.setTransform(625.4,585.2,0.5,0.5);

	this.shape_79 = new cjs.Shape();
	this.shape_79.graphics.f("#000000").s().p("AhIB+QgdgZAAgnQAAgcARgWQARgVAdgJQgUgJgLgQQgLgRAAgUQAAgfAXgUQAXgUAiAAQAjAAAWAUQAXAUAAAfQABAUgLARQgMAQgSAJQAcAJARAVQARAWAAAcQAAAngdAZQgdAagsAAQgrAAgdgagAg8AKQgYAVAAAfQAAAgAYAVQAYAUAkAAQAkAAAZgUQAYgVAAggQAAgfgYgVQgZgUgkAAQgkAAgYAUgAgsh3QgSAQAAAXQAAAXASAQQASAQAaAAQAbAAARgQQASgQAAgXQAAgYgSgPQgRgQgbAAQgaAAgSAQg");
	this.shape_79.setTransform(614.4,585.2,0.5,0.5);

	this.shape_80 = new cjs.Shape();
	this.shape_80.graphics.f("#000000").s().p("ACFCSIgbj4IhlD4IgKAAIhlj5IgbD5IgRAAIAgkjIALAAIBrEHIBrkHIALAAIAhEjg");
	this.shape_80.setTransform(593,585.2,0.5,0.5);

	this.shape_81 = new cjs.Shape();
	this.shape_81.graphics.f("#000000").s().p("ABmCVIjEkIIAAEDIgSAAIAAkjIALAAIDFEGIAAkGIARAAIAAEog");
	this.shape_81.setTransform(576,585.3,0.5,0.5);

	this.shape_82 = new cjs.Shape();
	this.shape_82.graphics.f("#000000").s().p("AgPAtIgHgFIAAgCQAXghABgMQgGgBgFgGQgGgFAAgHQAAgHAHgGQAFgFAGAAQAJAAAFAFQAFAGAAAJQAAAXgjAug");
	this.shape_82.setTransform(560.4,593.2,0.5,0.5);

	this.shape_83 = new cjs.Shape();
	this.shape_83.graphics.f("#000000").s().p("AhKBWQgighAAg1QAAgxAfgiQAfgiAwAAQA4AAAdAsQAWAfAAApIAAAHIjIAAQACArAdAbQAbAaAnAAQAZAAAXgMQAYgLANgTIACAAIAKAJIAAACQgPAWgbANQgbAMgcAAQgvAAghgggAg/hLQgZAZgDApIC2AAQgBgegOgWQgZgogxAAQgnAAgaAag");
	this.shape_83.setTransform(552.1,586.9,0.5,0.5);

	this.shape_84 = new cjs.Shape();
	this.shape_84.graphics.f("#000000").s().p("AhXCSIAAkjICvAAIAAAPIidAAIAAB5IB8AAIAAAPIh8AAIAACMg");
	this.shape_84.setTransform(541.1,585.2,0.5,0.5);

	this.shape_85 = new cjs.Shape();
	this.shape_85.graphics.f("#000000").s().p("AhFBjQgYgUAAggQAAggAagTQAZgUApAAQAqAAAlAVIAAgfQgBgegTgSQgVgUggABQgVAAgUAJQgUAIgQAOIgCAAIgIgKIAAgBQARgRAWgJQAYgKAYAAQApAAAYAXQAYAXAAAnIAACRIgQAAIAAgnQgNAVgXAMQgXALgaAAQgmAAgYgTgAg3AGQgUAPAAAaQgBAZAUAPQASAPAfAAQAiAAAZgSQAagUAAgfIAAgVQglgVgqAAQghAAgVAPg");
	this.shape_85.setTransform(521.9,586.9,0.5,0.5);

	this.shape_86 = new cjs.Shape();
	this.shape_86.graphics.f("#000000").s().p("AgNCHQgQgRAAgfIAAiWIgoAAIAAgPIAoAAIAAhHIAPgCIACACIAABHIBJAAIAAAPIhJAAIAACVQAAAyArAAQAUAAALgLIACAAIAGALIAAACQgRAOgXAAQgcAAgPgRg");
	this.shape_86.setTransform(512.7,585.2,0.5,0.5);

	this.shape_87 = new cjs.Shape();
	this.shape_87.graphics.f("#000000").s().p("ABOBzIAAiKQAAgigVgVQgUgVgiAAQgjAAgXAXQgWAWAAAiIAACHIgRAAIAAjgIAQAAIAAAqQALgWAWgMQAWgNAcAAQAoAAAZAZQAZAYAAApIAACLg");
	this.shape_87.setTransform(502.4,586.8,0.5,0.5);

	this.shape_88 = new cjs.Shape();
	this.shape_88.graphics.f("#000000").s().p("AhFBjQgYgUAAggQAAggAZgTQAagUApAAQArAAAjAVIAAgfQABgegVgSQgTgUgiABQgqAAghAfIgCAAIgIgKIAAgBQAQgRAWgJQAYgKAXAAQAqAAAZAXQAXAXAAAnIAACRIgRAAIAAgnQgMAVgYAMQgWALgaAAQgmAAgYgTgAg3AGQgUAPgBAaQAAAZATAPQAUAPAeAAQAiAAAZgSQAZgUAAgfIAAgVQgjgVgrAAQghAAgVAPg");
	this.shape_88.setTransform(489.1,586.9,0.5,0.5);

	this.shape_89 = new cjs.Shape();
	this.shape_89.graphics.f("#000000").s().p("Ag1CJQgegPgQgYIAAgCIAMgKIACAAQAPAWAZAOQAYANAaAAQAiAAAVgSQAVgRAAgaQAAgegdgSQgIgFg2gVQgigOgPgNQgXgUAAgeQAAggAYgVQAZgVAmAAQA3AAAeAoIAAACIgLAKIgBAAQgcgjgtAAQgeAAgTAQQgUAQAAAYQAAAWASAPQANAMAgANQA3AVANAIQAhAWAAAlQAAAkgbAWQgaAWgoAAQgfAAgdgPg");
	this.shape_89.setTransform(477.4,585.2,0.5,0.5);

	this.shape_90 = new cjs.Shape();
	this.shape_90.graphics.f("#000000").s().p("AgOAtIgIgFIAAgCQAXghABgMQgHgBgEgGQgFgFAAgHQAAgHAGgGQAFgFAHAAQAIAAAFAFQAFAGAAAJQABAYgkAtg");
	this.shape_90.setTransform(464,593.2,0.5,0.5);

	this.shape_91 = new cjs.Shape();
	this.shape_91.graphics.f("#000000").s().p("AhKBWQgighAAg1QAAgxAegiQAggiAvAAQA5AAAdAsQAWAfAAApIAAAHIjIAAQACArAcAbQAcAaAmAAQAZAAAYgMQAXgLAOgTIACAAIAKAJIAAACQgQAWgaANQgbAMgdAAQguAAghgggAg/hLQgZAZgDApIC2AAQgCgegOgWQgYgogxAAQgnAAgaAag");
	this.shape_91.setTransform(455.8,586.9,0.5,0.5);

	this.shape_92 = new cjs.Shape();
	this.shape_92.graphics.f("#000000").s().p("AhDBbQgZgZAAgpIAAiLIASAAIAACLQAAAhATAVQAVAUAfAAQAiAAAXgWQAVgWABgiIAAiHIARAAIAADgIgRAAIAAgpQgMAVgVANQgVAMgbAAQgmAAgYgYg");
	this.shape_92.setTransform(442.6,587,0.5,0.5);

	this.shape_93 = new cjs.Shape();
	this.shape_93.graphics.f("#000000").s().p("ABOBzIAAiKQAAgigVgVQgVgVgiAAQgiAAgXAXQgWAWAAAiIAACHIgRAAIAAjgIAQAAIAAAqQALgWAWgMQAWgNAcAAQAoAAAZAZQAZAYAAApIAACLg");
	this.shape_93.setTransform(429.5,586.8,0.5,0.5);

	this.shape_94 = new cjs.Shape();
	this.shape_94.graphics.f("#000000").s().p("AhKBWQgighAAg1QAAgxAegiQAggiAvAAQA5AAAdAsQAWAfAAApIAAAHIjIAAQACArAcAbQAcAaAmAAQAZAAAYgMQAXgLAOgTIACAAIAKAJIAAACQgPAWgbANQgbAMgdAAQguAAghgggAg/hLQgZAZgDApIC2AAQgCgfgNgVQgZgogxAAQgnAAgaAag");
	this.shape_94.setTransform(416.3,586.9,0.5,0.5);

	this.shape_95 = new cjs.Shape();
	this.shape_95.graphics.f("#000000").s().p("AgEBxIhljfIABgBIARAAIBXDEIBajEIAQAAIAAABIhlDfg");
	this.shape_95.setTransform(404.3,586.9,0.5,0.5);

	this.shape_96 = new cjs.Shape();
	this.shape_96.graphics.f("#000000").s().p("AB2CSIgghIIirAAIghBIIgQAAIgBgCICDkhIAKAAICCEhIgBACgAhOA6ICdAAIhPiwg");
	this.shape_96.setTransform(391.7,585.2,0.5,0.5);

	this.shape_97 = new cjs.Shape();
	this.shape_97.graphics.f("#000000").s().p("AhKBWQgighAAg1QAAgxAegiQAggiAvAAQA5AAAdAsQAWAfAAApIAAAHIjIAAQACArAcAbQAcAaAmAAQAZAAAYgMQAXgLAOgTIACAAIAKAJIAAACQgPAWgbANQgbAMgdAAQguAAghgggAg/hLQgZAZgDApIC2AAQgBgegOgWQgZgogxAAQgnAAgaAag");
	this.shape_97.setTransform(372.7,586.9,0.5,0.5);

	this.shape_98 = new cjs.Shape();
	this.shape_98.graphics.f("#000000").s().p("AhHBUQghgiAAgyQAAgxAhgiQAhgiAxAAQAeAAAaANQAXAMAPAUIAAACIgKAIIgCAAQgfgngyAAQgqAAgdAdQgcAdAAArQAAAsAcAcQAcAeAsAAQAyAAAegoIACAAIAKAJIAAABQgPAVgXAMQgaANgeAAQgxAAghgig");
	this.shape_98.setTransform(360.1,586.9,0.5,0.5);

	this.shape_99 = new cjs.Shape();
	this.shape_99.graphics.f("#000000").s().p("AhFBjQgYgUAAggQAAggAagTQAZgUAoAAQAqAAAlAVIAAgfQAAgegTgSQgVgUggABQgrAAgiAfIgCAAIgIgKIAAgBQAQgRAYgJQAXgKAYAAQApAAAYAXQAYAXAAAnIAACRIgRAAIAAgnQgMAVgYAMQgWALgaAAQgnAAgXgTgAg3AGQgVAPAAAaQABAZASAPQATAPAgAAQAhAAAYgSQAagUAAgfIAAgVQgkgVgqAAQgiAAgUAPg");
	this.shape_99.setTransform(347.2,586.9,0.5,0.5);

	this.shape_100 = new cjs.Shape();
	this.shape_100.graphics.f("#000000").s().p("AgHCaIAAkwIAOgDIACACIAAExg");
	this.shape_100.setTransform(339.1,584.9,0.5,0.5);

	this.shape_101 = new cjs.Shape();
	this.shape_101.graphics.f("#000000").s().p("AhFBjQgYgUAAggQAAggAagTQAZgUAoAAQAqAAAlAVIAAgfQAAgegTgSQgVgUghABQgqAAgiAfIgCAAIgIgKIAAgBQARgRAXgJQAXgKAXAAQAqAAAYAXQAYAXAAAnIAACRIgRAAIAAgnQgMAVgYAMQgWALgaAAQgnAAgXgTgAg3AGQgVAPABAaQAAAZASAPQATAPAgAAQAhAAAYgSQAagUAAgfIAAgVQgkgVgqAAQgiAAgUAPg");
	this.shape_101.setTransform(330.1,586.9,0.5,0.5);

	this.shape_102 = new cjs.Shape();
	this.shape_102.graphics.f("#000000").s().p("AhgCSIAAkjIBjAAQAsAAAZAXQAZAWAAAoQAAAngZAWQgZAXgsAAIhRAAIAAB6gAhOAJIBVAAQAhAAAUgSQATgTAAggQAAgggTgTQgUgTghAAIhVAAg");
	this.shape_102.setTransform(318.8,585.2,0.5,0.5);

	this.shape_103 = new cjs.Shape();
	this.shape_103.graphics.f("#000000").s().p("AgNCHQgQgRAAgfIAAiWIgoAAIAAgPIAoAAIAAhHIAPgCIACACIAABHIBJAAIAAAPIhJAAIAACVQAAAyArAAQAUAAALgLIACAAIAGALIAAACQgRAOgWAAQgdAAgPgRg");
	this.shape_103.setTransform(302.1,585.2,0.5,0.5);

	this.shape_104 = new cjs.Shape();
	this.shape_104.graphics.f("#000000").s().p("AhNBMIAAgCIAKgIIACAAQAWAkAsAAQAbAAAQgMQARgNAAgUQAAgYgXgPQgLgGglgOQgYgLgMgLQgQgPAAgVQAAgZATgQQATgQAcAAQAWAAATAKQASAJALASIAAABIgLAIIgBAAQgWgegkAAQgVAAgOALQgOALAAASQAAAQANALQAKAKAVAHQApARAMAJQAaASAAAeQAAAcgVAQQgVARgiAAQg0AAgbgqg");
	this.shape_104.setTransform(293.3,586.9,0.5,0.5);

	this.shape_105 = new cjs.Shape();
	this.shape_105.graphics.f("#000000").s().p("AhKBWQgighAAg1QAAgxAfgiQAfgiAwAAQA4AAAdAsQAWAfAAApIAAAHIjIAAQACArAdAbQAbAaAnAAQAZAAAXgMQAYgLANgTIACAAIAKAJIAAACQgPAWgbANQgbAMgcAAQgvAAghgggAg/hLQgZAZgDApIC2AAQgBgegOgWQgZgogxAAQgnAAgaAag");
	this.shape_105.setTransform(282.2,586.9,0.5,0.5);

	this.shape_106 = new cjs.Shape();
	this.shape_106.graphics.f("#000000").s().p("ABSCSIhSj/IhRD/IgLAAIhrkiIACgBIARAAIBdEBIBTkBIAKAAIBTEDIBdkDIAQAAIABABIhqEig");
	this.shape_106.setTransform(265.6,585.2,0.5,0.5);

	this.shape_107 = new cjs.Shape();
	this.shape_107.graphics.f("#000000").s().p("AAPCSIAAkTIguAAIAAgQIA/AAIAAEjg");
	this.shape_107.setTransform(245.6,585.2,0.5,0.5);

	this.shape_108 = new cjs.Shape();
	this.shape_108.graphics.f("#000000").s().p("AhdBvIAAgCIALgJIABAAQAfAjAyAAQAgAAAWgTQAWgTAAgfQAAghgYgUQgXgSglAAIgRAAIAAgNIAUAAQAaAAAWgRQAVgSAAgaQAAgZgTgPQgSgQgbAAQgnAAgbAfIgCAAIgLgKIAAgCQAigjAtAAQAkAAAXAUQAXAUAAAfQAAAXgNASQgOASgWAIQAcAJAQATQARAWAAAdQAAAmgbAYQgbAYgoAAQg4AAglgpg");
	this.shape_108.setTransform(237.5,585.2,0.5,0.5);

	this.shape_109 = new cjs.Shape();
	this.shape_109.graphics.f("#000000").s().p("AAPCSIAAkTIguAAIAAgQIA/AAIAAEjg");
	this.shape_109.setTransform(228.1,585.2,0.5,0.5);

	this.shape_110 = new cjs.Shape();
	this.shape_110.graphics.f("#000000").s().p("AhbCVIAAgOIA7g7QAegeAPgRQAbgdAMgWQAOgZAAgVQAAgegUgRQgTgRgcAAQgpAAgfAkIgBAAIgLgJIAAgCQAPgSAWgMQAWgLAaAAQAkAAAYAVQAYAWAAAlQAAAYgPAaQgNAXgdAhQgTAUhJBLICdAAIAAAQg");
	this.shape_110.setTransform(190.5,585.1,0.5,0.5);

	this.shape_111 = new cjs.Shape();
	this.shape_111.graphics.f("#000000").s().p("AgxCOQgagLgSgUIAAgCIALgJIABAAQAfAjAyAAQAhAAAVgTQAWgTAAgfQAAghgYgUQgYgSgjAAIgRAAIAAgNIATAAQAbAAAVgRQAVgSAAgaQAAgZgSgPQgTgQgbAAQgmAAgcAfIgCAAIgKgKIAAgCQAhgjAuAAQAjAAAXAUQAXAUAAAfQAAAXgOASQgNASgWAIQAcAJAQATQARAWAAAdQAAAmgbAYQgbAYgoAAQgaAAgXgKg");
	this.shape_111.setTransform(179.1,585.2,0.5,0.5);

	this.shape_112 = new cjs.Shape();
	this.shape_112.graphics.f("#000000").s().p("AAzCSIAAhOIibAAIAAgOICkjHIAIAAIAADGIAlAAIAAAPIglAAIAABOgAhSA1ICFAAIAAijg");
	this.shape_112.setTransform(167.5,585.2,0.5,0.5);

	this.shape_113 = new cjs.Shape();
	this.shape_113.graphics.f("#000000").s().p("AgxCOQgagLgSgUIAAgCIALgJIABAAQAfAjAyAAQAhAAAVgTQAWgTAAgfQAAghgYgUQgYgSgjAAIgRAAIAAgNIASAAQAbAAAVgRQAWgSAAgaQAAgZgSgPQgTgQgbAAQgnAAgbAfIgCAAIgKgKIAAgCQAhgjAuAAQAjAAAXAUQAXAUAAAfQAAAXgOASQgNASgWAIQAcAJAQATQARAWAAAdQAAAmgbAYQgbAYgoAAQgaAAgXgKg");
	this.shape_113.setTransform(155.7,585.2,0.5,0.5);

	this.shape_114 = new cjs.Shape();
	this.shape_114.graphics.f("#000000").s().p("AgLANQgGgGAAgHQAAgHAGgFQAEgFAHAAQAHAAAGAFQAFAFAAAHQAAAHgFAGQgGAFgHAAQgHAAgEgFg");
	this.shape_114.setTransform(148,591.9,0.5,0.5);

	this.shape_115 = new cjs.Shape();
	this.shape_115.graphics.f("#000000").s().p("AhRBzQgUgZAAglQAAg6A2hNQAbglAeggIACAAIALAJIAAACQgaAageAqQgYAggNAeQAegfAsAAQAqAAAcAcQAcAaAAAqQAAAqgdAcQgdAbgsAAQgzAAgeglgAg7gCQgYAWgBAjQAAAjAZAXQAXAXAkAAQAlAAAXgXQAYgXAAgjQAAgjgYgWQgXgXgkAAQgkAAgYAXg");
	this.shape_115.setTransform(139.8,585.2,0.5,0.5);

	this.shape_116 = new cjs.Shape();
	this.shape_116.graphics.f("#000000").s().p("AhIB+QgegZABgnQAAgcARgWQARgVAdgJQgUgJgLgQQgKgRgBgUQAAgfAYgUQAWgUAiAAQAiAAAYAUQAXAUAAAfQAAAUgLARQgMAQgSAJQAcAJASAVQARAWAAAcQgBAngdAZQgdAagsAAQgrAAgdgagAg8AKQgXAVAAAfQAAAgAXAVQAYAUAkAAQAkAAAZgUQAYgVAAggQAAgfgYgVQgZgUgkAAQgkAAgYAUgAgsh3QgRAQgBAXQABAXARAQQATAQAZAAQAbAAASgQQARgQAAgXQAAgYgRgPQgSgQgbAAQgZAAgTAQg");
	this.shape_116.setTransform(127.2,585.2,0.5,0.5);

	this.shape_117 = new cjs.Shape();
	this.shape_117.graphics.f("#000000").s().p("AgLCYIgMgJIAAgCQAZgaAZghQAfgpAOgeQgeAfgqAAQgrAAgdgcQgdgaAAgqQABgrAdgbQAbgbAsAAQAtAAAcAbQAdAbAAAtQAAA9g6BPQgYAggdAggAg8hwQgYAXABAjQgBAjAYAVQAZAXAjAAQAkAAAZgXQAXgVAAgjQAAgjgXgXQgZgXgkAAQgjAAgZAXg");
	this.shape_117.setTransform(114.8,585.2,0.5,0.5);

	this.shape_118 = new cjs.Shape();
	this.shape_118.graphics.f("#000000").s().p("AgMANQgFgGAAgHQAAgHAFgFQAGgFAGAAQAIAAAFAFQAFAFAAAHQAAAHgFAGQgFAFgIAAQgGAAgGgFg");
	this.shape_118.setTransform(107.7,591.9,0.5,0.5);

	this.shape_119 = new cjs.Shape();
	this.shape_119.graphics.f("#000000").s().p("Ag3CLQgagLgQgTIAAgDIAKgJIACAAQAOARAWAKQAVAIAWAAQAlAAAZgWQAZgYAAgkQAAgjgWgVQgXgXgkAAQgYAAgWALQgUAJgLAOIgCAAIgNgFIAXiUICPAAIAAAQIiAAAIgRBvQAggYAnAAQAtAAAbAcQAaAaAAApQAAArgeAcQgdAcgsAAQgaAAgYgKg");
	this.shape_119.setTransform(99.6,585.4,0.5,0.5);

	this.shape_120 = new cjs.Shape();
	this.shape_120.graphics.f("#000000").s().p("AhNBuQgegqAAhEQAAhDAegqQAegqAvAAQAwAAAeAqQAeAqAABDQAABEgeAqQgeAqgwAAQgvAAgegqgAhAhhQgZAlAAA8QAAA8AZAlQAYAmAoAAQAoAAAZgmQAZglAAg8QAAg8gZglQgZglgoAAQgoAAgYAlg");
	this.shape_120.setTransform(86.8,585.2,0.5,0.5);

	this.shape_121 = new cjs.Shape();
	this.shape_121.graphics.f("#000000").s().p("Ag2CLQgbgLgQgTIAAgDIAKgJIACAAQAPARAVAKQAVAIAWAAQAlAAAYgWQAagYAAgkQAAgjgXgVQgWgXgkAAQgZAAgVALQgUAJgLAOIgCAAIgMgFIAWiUICPAAIAAAQIiAAAIgRBvQAggYAnAAQAtAAAcAcQAaAaAAApQAAArgfAcQgdAcgsAAQgaAAgXgKg");
	this.shape_121.setTransform(74.2,585.4,0.5,0.5);

	this.shape_122 = new cjs.Shape();
	this.shape_122.graphics.f("#000000").s().p("AAPCSIAAkTIguAAIAAgQIA/AAIAAEjg");
	this.shape_122.setTransform(58.2,585.2,0.5,0.5);

	this.shape_123 = new cjs.Shape();
	this.shape_123.graphics.f("#000000").s().p("AgHBjIAAhcIhgAAIAAgOIBgAAIAAhbIAPAAIAABbIBgAAIAAAOIhgAAIAABcg");
	this.shape_123.setTransform(50,585.8,0.5,0.5);

	this.shape_124 = new cjs.Shape();
	this.shape_124.graphics.f("#000000").s().p("AhJC+QgjgRgXggIAPgKQArA8BPAAQATgBASgGQATgFAQgNQAQgMAKgRQAKgSAAgXQAAgagNgTQgNgQgSgLQgSgKgXgGIgpgLIgogMQgTgIgOgLQgOgMgIgRQgIgQAAgaQAAgbAKgRQALgUAQgMQAQgMAXgHQAWgFAVAAQBQAAAoA5IgQAJQgUgagZgMQgYgNgjAAQgOAAgTAFQgRADgQALQgOAKgKAPQgKAQAAAYQAAAaAIAOQAIAPAOALQANAIAWAHQAeAJAOADQAYAGAVAIQAVAGARAOQAQALAKASQAKATAAAZQAAAagKAVQgKAWgSANQgPAOgZAJQgXAIgagBQgqAAgkgQg");
	this.shape_124.setTransform(178.2,275.7,0.5,0.5);

	this.shape_125 = new cjs.Shape();
	this.shape_125.graphics.f("#000000").s().p("AgEDoQgUgaAAgnIAAklIhVAAIAAgRIBUAAIAAhyIATAAIAAByIByAAIAAARIhyAAIAAElQAAAoASARQAUASAgAAQAXAAAVgIIACAPQgIADgQAEQgPACgLAAQguAAgSgag");
	this.shape_125.setTransform(162.9,273.1,0.5,0.5);

	this.shape_126 = new cjs.Shape();
	this.shape_126.graphics.f("#000000").s().p("AgIEjIAAmHIASAAIAAGHgAgNj8QgFgGgBgKQABgKAFgFQAHgHAGAAQAIAAAGAHQAFAGABAJQAAAKgHAGQgGAFgHABQgGgBgHgFg");
	this.shape_126.setTransform(151.7,271,0.5,0.5);

	this.shape_127 = new cjs.Shape();
	this.shape_127.graphics.f("#000000").s().p("AhOE4QgkgQgagcQgagcgPglQgOgmAAgsQAAgsAOgnQAPgmAagbQAagcAkgQQAjgPArAAQA3AAAwAdQAvAeAZA6IACAAIAAllIATAAIAAKBIgTAAIAAhpIgCAAQgZA6gvAeQgwAdg3AAQgrAAgjgPgAhKg3QggAQgXAbQgWAYgNAkQgMAiAAAnQAAAnAMAiQAMAjAXAaQAXAaAgAPQAhAPApAAQAmAAAhgPQAggPAZgaQAYgbANgiQANgjAAgnQAAgngNgjQgNgigYgaQgZgagggPQghgPgmAAQgpAAghAPg");
	this.shape_127.setTransform(132.8,269.7,0.5,0.5);

	this.shape_128 = new cjs.Shape();
	this.shape_128.graphics.f("#000000").s().p("AhDDAQgkgQgagcQgagcgOgnQgOgpAAgrQAAgsAPgmQAPgmAYgaQAagcAigPQAigOAmAAQAuAAAiAQQAiARAWAZQAWAaAMAiQALAhAAAkIAAAQIlcAAQAAAjAKAiQAKAiAXAdQAVAcAhAQQAhARAtAAQAuAAAkgSQAkgTAagiIANAMQgcAlgnAUQgnATgzAAQgrAAgjgPgAhJisQghATgSAaQgUAZgKAfQgKAfAAAVIFJAAQAAgmgMggQgOghgUgVQgWgXgdgMQgegMgkAAQgsAAgfASg");
	this.shape_128.setTransform(108.5,275.7,0.5,0.5);

	this.shape_129 = new cjs.Shape();
	this.shape_129.graphics.f("#000000").s().p("AhSDJIAAkjIgEhjIASAAIAEBnIACAAQAQg9AmgbQAlgaArAAIAPAAIAAARIgGgBIgFAAQglAAgaAQQgaARgRAbQgRAagIAhQgIAgAAAhIAADJg");
	this.shape_129.setTransform(92.6,275.4,0.5,0.5);

	this.shape_130 = new cjs.Shape();
	this.shape_130.graphics.f("#000000").s().p("AhNEmQg4gYgpgqQgpgqgWg6QgXg8AAhEQAAhEAXg7QAWg6ApgrQAqgqA3gXQA5gYBCAAQA3AAA2ATQA3AUAkAnIgMANQgSgTgXgOQgYgOgXgJQgYgJgbgFQgbgEgWAAQhBAAg0AYQg1AXgmApQgmAogUA3QgVA3AAA+QAAA+AUA3QAVA3AlApQAnAqA0AWQA1AYBBAAQA5gBA2gVQA4gWAigrIAOANQgmAtg7AXQg7AXg7AAQhDAAg4gYg");
	this.shape_130.setTransform(69.3,270.5,0.5,0.5);

	this.shape_131 = new cjs.Shape();
	this.shape_131.graphics.f("#000000").s().p("AgTAAQAAgYATABQAUgBAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_131.setTransform(338.9,511.6,0.5,0.5);

	this.shape_132 = new cjs.Shape();
	this.shape_132.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_132.setTransform(328.5,505.6,0.5,0.5);

	this.shape_133 = new cjs.Shape();
	this.shape_133.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAgAAA7IAAASIjCAAQABA4AZAdQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgWAEgUgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_133.setTransform(313.9,505.8,0.5,0.5);

	this.shape_134 = new cjs.Shape();
	this.shape_134.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_134.setTransform(299.7,508.7,0.5,0.5);

	this.shape_135 = new cjs.Shape();
	this.shape_135.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_135.setTransform(284.5,508.7,0.5,0.5);

	this.shape_136 = new cjs.Shape();
	this.shape_136.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgag");
	this.shape_136.setTransform(269.3,505.8,0.5,0.5);

	this.shape_137 = new cjs.Shape();
	this.shape_137.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_137.setTransform(255.6,502.8,0.5,0.5);

	this.shape_138 = new cjs.Shape();
	this.shape_138.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_138.setTransform(236.9,504.3,0.5,0.5);

	this.shape_139 = new cjs.Shape();
	this.shape_139.graphics.f("#000000").s().p("Ag/BoQgigkAAhCQAAhCAjgmQAigmA6AAQAkAAAgANIgHAWQglgMgZAAQgxAAgZAeQgaAfAAA5QAAA3AaAfQAaAfAtAAQAkAAAggNIAAAXQgbAMgoAAQg5AAghgkg");
	this.shape_139.setTransform(227,505.8,0.5,0.5);

	this.shape_140 = new cjs.Shape();
	this.shape_140.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAggmA0gBQAxABAbAhQAcAgAAA7IAAASIjCAAQAAA4AaAdQAZAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgSAEQgXAEgUgBQg6AAghgkgAg3hcQgYAbgDAwICnAAQgBgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_140.setTransform(213.7,505.8,0.5,0.5);

	this.shape_141 = new cjs.Shape();
	this.shape_141.graphics.f("#000000").s().p("AgwDwIAAgVQATAFANAAQAlAAgBgsIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgTAAgOgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_141.setTransform(202.2,506.3,0.5,0.5);

	this.shape_142 = new cjs.Shape();
	this.shape_142.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAlAABBQAABDggAkQggAlg4AAQgjABgcgSgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAeg");
	this.shape_142.setTransform(193.4,505.8,0.5,0.5);

	this.shape_143 = new cjs.Shape();
	this.shape_143.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_143.setTransform(181.9,505.6,0.5,0.5);

	this.shape_144 = new cjs.Shape();
	this.shape_144.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAdAkAABEQgBBBgeAmQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAaAAA7IAAAIQAAA/AWAbQAVAbAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_144.setTransform(168.9,508.7,0.5,0.5);

	this.shape_145 = new cjs.Shape();
	this.shape_145.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsABQAnAAAVgOQAVgNAAgXQAAgUgRgOQgQgOgmgNQgqgPgOgJQgQgLgJgNQgIgMAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIAMQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_145.setTransform(148.2,505.8,0.5,0.5);

	this.shape_146 = new cjs.Shape();
	this.shape_146.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAFAAAMQAAAMgFAGQgEAGgHAAQgPAAAAgYg");
	this.shape_146.setTransform(139.5,503.3,0.5,0.5);

	this.shape_147 = new cjs.Shape();
	this.shape_147.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_147.setTransform(129.2,502.8,0.5,0.5);

	this.shape_148 = new cjs.Shape();
	this.shape_148.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_148.setTransform(117.1,504.3,0.5,0.5);

	this.shape_149 = new cjs.Shape();
	this.shape_149.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAcAggBA7IAAASIjCAAQACA4AYAdQAaAeAuAAQAYAAASgDQATgEAZgKIAAAWQgXAKgUAEQgWAEgVgBQg5AAgigkgAg2hcQgZAbgDAwICmAAQABgwgVgaQgVgagjAAQgnAAgXAZg");
	this.shape_149.setTransform(99.4,505.8,0.5,0.5);

	this.shape_150 = new cjs.Shape();
	this.shape_150.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_150.setTransform(87.4,502.8,0.5,0.5);

	this.shape_151 = new cjs.Shape();
	this.shape_151.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_151.setTransform(72.9,505.8,0.5,0.5);

	this.shape_152 = new cjs.Shape();
	this.shape_152.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgpAAgUAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgWAXgOQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_152.setTransform(55.4,505.6,0.5,0.5);

	this.shape_153 = new cjs.Shape();
	this.shape_153.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_153.setTransform(979.8,470.4,0.5,0.5);

	this.shape_154 = new cjs.Shape();
	this.shape_154.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_154.setTransform(969,464.6,0.5,0.5);

	this.shape_155 = new cjs.Shape();
	this.shape_155.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAbAhQAcAiABA5IAAASIjCAAQAAA3AaAeQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgUAEQgXAEgUgBQg6AAghgkgAg3hcQgYAagDAxICmAAQAAgxgVgZQgUgagkAAQgmAAgYAZg");
	this.shape_155.setTransform(959.1,467.5,0.5,0.5);

	this.shape_156 = new cjs.Shape();
	this.shape_156.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAWgLAjAAQBcAAgBBiIAACxg");
	this.shape_156.setTransform(944.7,464.6,0.5,0.5);

	this.shape_157 = new cjs.Shape();
	this.shape_157.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABCghAlQgfAlg4AAQgjABgcgSgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAeg");
	this.shape_157.setTransform(923,467.5,0.5,0.5);

	this.shape_158 = new cjs.Shape();
	this.shape_158.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAfAJAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_158.setTransform(911,466,0.5,0.5);

	this.shape_159 = new cjs.Shape();
	this.shape_159.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgXAKgUAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgaglAAQglAAgZAZg");
	this.shape_159.setTransform(893.3,467.5,0.5,0.5);

	this.shape_160 = new cjs.Shape();
	this.shape_160.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgWAXgOQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_160.setTransform(875.1,467.4,0.5,0.5);

	this.shape_161 = new cjs.Shape();
	this.shape_161.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_161.setTransform(860.9,465,0.5,0.5);

	this.shape_162 = new cjs.Shape();
	this.shape_162.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXABQAWAAASgFIAAAVQgRAFgXAAQgjABgRgUg");
	this.shape_162.setTransform(853.6,466,0.5,0.5);

	this.shape_163 = new cjs.Shape();
	this.shape_163.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_163.setTransform(838.8,467.4,0.5,0.5);

	this.shape_164 = new cjs.Shape();
	this.shape_164.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_164.setTransform(830.1,465,0.5,0.5);

	this.shape_165 = new cjs.Shape();
	this.shape_165.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgXAKgUAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgaglAAQglAAgZAZg");
	this.shape_165.setTransform(820.2,467.5,0.5,0.5);

	this.shape_166 = new cjs.Shape();
	this.shape_166.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_166.setTransform(805.8,464.6,0.5,0.5);

	this.shape_167 = new cjs.Shape();
	this.shape_167.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_167.setTransform(793.7,466,0.5,0.5);

	this.shape_168 = new cjs.Shape();
	this.shape_168.graphics.f("#000000").s().p("AhdC0QgdgUAAgjQAAgcARgTQASgSAegHQgMgFgIgKQgIgJABgNQAAgaAjgUQgZgKgNgVQgNgVAAgbQAAgnAagaQAZgYAtAAQAYAAAQAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgjAXg/AAQgyAAgcgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgQgLQgSgLglAAIgrAAQhKAAgBA7gAg4igQgTATAAAgQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigTgRQgRgSgiAAQggAAgSATg");
	this.shape_168.setTransform(776.4,470.4,0.5,0.5);

	this.shape_169 = new cjs.Shape();
	this.shape_169.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAaAAA2IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_169.setTransform(762.2,467.4,0.5,0.5);

	this.shape_170 = new cjs.Shape();
	this.shape_170.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_170.setTransform(751.8,465,0.5,0.5);

	this.shape_171 = new cjs.Shape();
	this.shape_171.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QAOAlAGAYIAAAAQAMgkAJgaIBGi2IAaAAIhpENg");
	this.shape_171.setTransform(743,467.5,0.5,0.5);

	this.shape_172 = new cjs.Shape();
	this.shape_172.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAHQAFAFAAAMQAAAMgFAGQgDAGgIAAQgPAAAAgYg");
	this.shape_172.setTransform(734.3,465,0.5,0.5);

	this.shape_173 = new cjs.Shape();
	this.shape_173.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAghQAAgigSgRQgSgSghAAQghAAgSATg");
	this.shape_173.setTransform(724.7,470.4,0.5,0.5);

	this.shape_174 = new cjs.Shape();
	this.shape_174.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA5CYQAbBGAGAXIABAAIAiheIA5iXIAaAAIh4E6QgOAkgLAQQgKANgNAHQgPAGgSABQgNgBgSgFg");
	this.shape_174.setTransform(705.6,470.6,0.5,0.5);

	this.shape_175 = new cjs.Shape();
	this.shape_175.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_175.setTransform(696.8,464.6,0.5,0.5);

	this.shape_176 = new cjs.Shape();
	this.shape_176.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtABQAnAAAVgOQAVgMgBgYQAAgUgQgOQgQgOgngNQgqgPgNgJQgRgMgIgMQgJgOAAgTQABgeAZgSQAagSAtAAQArAAAnARIgJAWQgngQgiAAQghAAgTALQgUALAAATQABAWAPAMQAPANAqAPQAkANASALQAQAKAJANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_176.setTransform(687.9,467.5,0.5,0.5);

	this.shape_177 = new cjs.Shape();
	this.shape_177.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAAAhjg");
	this.shape_177.setTransform(674.5,467.6,0.5,0.5);

	this.shape_178 = new cjs.Shape();
	this.shape_178.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABDggAkQggAlg4AAQgjABgcgSgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAeg");
	this.shape_178.setTransform(659.6,467.5,0.5,0.5);

	this.shape_179 = new cjs.Shape();
	this.shape_179.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_179.setTransform(648,467.4,0.5,0.5);

	this.shape_180 = new cjs.Shape();
	this.shape_180.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAbAiAAA5IAAASIjBAAQAAA4AZAdQAaAeAuAAQAYAAARgDQAUgEAYgKIAAAWQgWAKgUAEQgWAEgVgBQg5AAgigkgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgVgagjAAQgmAAgYAZg");
	this.shape_180.setTransform(635.2,467.5,0.5,0.5);

	this.shape_181 = new cjs.Shape();
	this.shape_181.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_181.setTransform(620.7,467.4,0.5,0.5);

	this.shape_182 = new cjs.Shape();
	this.shape_182.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAgAAA7IAAASIjCAAQABA5AaAcQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgYAKgTAEQgWAEgUgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgVgagkAAQgmAAgXAZg");
	this.shape_182.setTransform(606.1,467.5,0.5,0.5);

	this.shape_183 = new cjs.Shape();
	this.shape_183.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigUQgXgKgNgVQgOgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgiAXQgkAXg+AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAghQAAgigSgRQgSgSghAAQghAAgSATg");
	this.shape_183.setTransform(592.5,470.4,0.5,0.5);

	this.shape_184 = new cjs.Shape();
	this.shape_184.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAcgqBCAAQBbAAABBjIAACwg");
	this.shape_184.setTransform(571.7,467.4,0.5,0.5);

	this.shape_185 = new cjs.Shape();
	this.shape_185.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_185.setTransform(561.3,465,0.5,0.5);

	this.shape_186 = new cjs.Shape();
	this.shape_186.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgNALgcIANgjIhnkOIAZAAIA5CYQAbBGAHAXIAAAAQAKgfAZg/IA4iXIAaAAIh4E6QgOAkgLAQQgKANgOAHQgOAGgRABQgOgBgSgFg");
	this.shape_186.setTransform(545.9,470.6,0.5,0.5);

	this.shape_187 = new cjs.Shape();
	this.shape_187.graphics.f("#000000").s().p("Ag/BoQgigkABhCQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAeQgaAfABA5QgBA3AaAfQAbAfAsAAQAlAAAfgNIAAAXQgaAMgpAAQg5AAghgkg");
	this.shape_187.setTransform(534.3,467.5,0.5,0.5);

	this.shape_188 = new cjs.Shape();
	this.shape_188.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_188.setTransform(520.5,467.4,0.5,0.5);

	this.shape_189 = new cjs.Shape();
	this.shape_189.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_189.setTransform(505.7,467.5,0.5,0.5);

	this.shape_190 = new cjs.Shape();
	this.shape_190.graphics.f("#000000").s().p("ABrC2IjXlDIgCAAQADA7AAAdIAADrIgYAAIAAlrIAZAAIDWFCIACAAQgCgoAAguIAAjsIAYAAIAAFrg");
	this.shape_190.setTransform(490.2,465.2,0.5,0.5);

	this.shape_191 = new cjs.Shape();
	this.shape_191.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgXAeAAA7QABBzBYAAQAuAAAVgaQAWgcAAg8IAAgFQAAg9gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_191.setTransform(466.4,464.7,0.5,0.5);

	this.shape_192 = new cjs.Shape();
	this.shape_192.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_192.setTransform(451.7,467.4,0.5,0.5);

	this.shape_193 = new cjs.Shape();
	this.shape_193.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_193.setTransform(436.9,467.5,0.5,0.5);

	this.shape_194 = new cjs.Shape();
	this.shape_194.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_194.setTransform(416.8,467.5,0.5,0.5);

	this.shape_195 = new cjs.Shape();
	this.shape_195.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_195.setTransform(406.4,467.4,0.5,0.5);

	this.shape_196 = new cjs.Shape();
	this.shape_196.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_196.setTransform(392.6,464.7,0.5,0.5);

	this.shape_197 = new cjs.Shape();
	this.shape_197.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_197.setTransform(378,467.4,0.5,0.5);

	this.shape_198 = new cjs.Shape();
	this.shape_198.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_198.setTransform(363.2,467.5,0.5,0.5);

	this.shape_199 = new cjs.Shape();
	this.shape_199.graphics.f("#000000").s().p("ABUCHIhUh5IhVB5IgcAAIBjiKIheiDIAcAAIBQByIBQhyIAbAAIheCDIBkCKg");
	this.shape_199.setTransform(350.5,467.5,0.5,0.5);

	this.shape_200 = new cjs.Shape();
	this.shape_200.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgoQAhgmA1gBQAwABAbAhQAbAgAAA7IAAASIjBAAQABA4AZAdQAZAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgYAKgSAEQgXAEgUgBQg7AAgggkgAg3hcQgXAbgEAwICnAAQgBgwgUgaQgVgagjAAQgmAAgZAZg");
	this.shape_200.setTransform(337.2,467.5,0.5,0.5);

	this.shape_201 = new cjs.Shape();
	this.shape_201.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_201.setTransform(327.3,464.6,0.5,0.5);

	this.shape_202 = new cjs.Shape();
	this.shape_202.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgFAWgJAWg");
	this.shape_202.setTransform(316.7,465.1,0.5,0.5);

	this.shape_203 = new cjs.Shape();
	this.shape_203.graphics.f("#000000").s().p("ABHDCIhliJIgtAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICIiXIAfAAIhqBzIBzCbg");
	this.shape_203.setTransform(297.4,464.6,0.5,0.5);

	this.shape_204 = new cjs.Shape();
	this.shape_204.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_204.setTransform(282.7,467.4,0.5,0.5);

	this.shape_205 = new cjs.Shape();
	this.shape_205.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_205.setTransform(267.9,467.5,0.5,0.5);

	this.shape_206 = new cjs.Shape();
	this.shape_206.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_206.setTransform(254.1,464.6,0.5,0.5);

	this.shape_207 = new cjs.Shape();
	this.shape_207.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAfAJAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_207.setTransform(242.1,466,0.5,0.5);

	this.shape_208 = new cjs.Shape();
	this.shape_208.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAlAABBQAABDggAkQggAlg4AAQgjABgcgSgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAeg");
	this.shape_208.setTransform(223.9,467.5,0.5,0.5);

	this.shape_209 = new cjs.Shape();
	this.shape_209.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_209.setTransform(212,466,0.5,0.5);

	this.shape_210 = new cjs.Shape();
	this.shape_210.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggmA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA3AaAeQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgVAEQgWAEgUgBQg7AAgggkgAg3hcQgXAagEAxICmAAQAAgxgVgZQgUgagkAAQgmAAgYAZg");
	this.shape_210.setTransform(194.3,467.5,0.5,0.5);

	this.shape_211 = new cjs.Shape();
	this.shape_211.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_211.setTransform(182.2,464.6,0.5,0.5);

	this.shape_212 = new cjs.Shape();
	this.shape_212.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAGAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_212.setTransform(172.1,465,0.5,0.5);

	this.shape_213 = new cjs.Shape();
	this.shape_213.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_213.setTransform(166.3,464.6,0.5,0.5);

	this.shape_214 = new cjs.Shape();
	this.shape_214.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_214.setTransform(148.8,464.7,0.5,0.5);

	this.shape_215 = new cjs.Shape();
	this.shape_215.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_215.setTransform(138.7,464.6,0.5,0.5);

	this.shape_216 = new cjs.Shape();
	this.shape_216.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAYgZAAg3IAAiUIAXAAIAAEOIgUAAIgFgmIgBAAQgbArhCAAQhdAAABhjg");
	this.shape_216.setTransform(128.2,467.6,0.5,0.5);

	this.shape_217 = new cjs.Shape();
	this.shape_217.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAlAABBQAABDggAkQggAlg4AAQgjABgcgSgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAeg");
	this.shape_217.setTransform(113.3,467.5,0.5,0.5);

	this.shape_218 = new cjs.Shape();
	this.shape_218.graphics.f("#000000").s().p("ABOCHIg8i0IgOg2IgCAAIhMDqIgYAAIhNkNIAZAAIAsCbQARBAADAWIACAAQAPg+AGgPIA3ikIAWAAIA1CjQATA+ADAQIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_218.setTransform(96.6,467.5,0.5,0.5);

	this.shape_219 = new cjs.Shape();
	this.shape_219.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAgAAA7IAAASIjCAAQABA4AaAdQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgYAKgTAEQgWAEgUgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgVgagkAAQgmAAgXAZg");
	this.shape_219.setTransform(73.8,467.5,0.5,0.5);

	this.shape_220 = new cjs.Shape();
	this.shape_220.graphics.f("#000000").s().p("ABdC2IhelQIgLAxIhQEfIgWAAIhklrIAbAAIBVFDQAFggAUhHIA/jcIAbAAIBJD9QANArAFAbIAIgmIBNkdIAaAAIhlFrg");
	this.shape_220.setTransform(55.4,465.2,0.5,0.5);

	this.shape_221 = new cjs.Shape();
	this.shape_221.graphics.f("#000000").s().p("AgTAAQAAgYATABQAUgBAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_221.setTransform(471.1,435.1,0.5,0.5);

	this.shape_222 = new cjs.Shape();
	this.shape_222.graphics.f("#000000").s().p("AhVCjQgdgaAAgwQAAggAUgZQAVgYAsgRQgpgTgQgVQgQgVgBgdQAAgbAOgTQAMgUAZgLQAWgLAeAAQAuAAAcAYQAcAYAAAoQAAAdgRAUQgRAWgoASQAxATATAXQATAYAAAhQAAAtggAbQgfAbg0AAQg3AAgegZgAhGAnQgSAWgBAgQAAAjAYASQAXATAqAAQAoAAAYgUQAagUAAgiQAAgfgUgTQgUgUg3gVQgtARgUAWgAg4iTQgWARAAAfQABARAHANQAIAOAPAKQAPAMAiAOQApgQARgTQASgSAAgbQAAgegWgSQgVgRgjAAQgjAAgVARg");
	this.shape_222.setTransform(460.8,426.9,0.5,0.5);

	this.shape_223 = new cjs.Shape();
	this.shape_223.graphics.f("#000000").s().p("AAjC2IAAkIQAAglADgmIgHAHIhMA8IgOgRIBhhKIAWAAIAAFrg");
	this.shape_223.setTransform(444.5,426.9,0.5,0.5);

	this.shape_224 = new cjs.Shape();
	this.shape_224.graphics.f("#000000").s().p("AhXCMQgdgvAAhdQAAhfAdgtQAcgvA7ABQA4AAAfAvQAeAwAABbQAABfgdAuQgeAvg6gBQg5AAgegvgAhEh6QgWArABBPQgBBUAXAoQAWApAtAAQAvAAAUgqQAWgpAAhSQAAhRgWgpQgUgqgvAAQgvAAgVAqg");
	this.shape_224.setTransform(431.7,426.9,0.5,0.5);

	this.shape_225 = new cjs.Shape();
	this.shape_225.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAogrARgVQAQgWAHgVQAIgUAAgXQAAgggVgVQgWgUggAAQguAAgqAhIgOgRQAvgnA3AAQAvAAAbAaQAbAZAAAtQAAAkgSAiQgSAfgyAzIhcBgIAAABIDCAAIAAAYg");
	this.shape_225.setTransform(417,426.8,0.5,0.5);

	this.shape_226 = new cjs.Shape();
	this.shape_226.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgMQAHgMALgdIAOgjIhokOIAaAAIA4CYQAZBBAJAcIAAAAQAOgqAVg0IA4iXIAaAAIh4E6QgPAngKANQgJANgOAHQgOAGgSABQgOgBgSgFg");
	this.shape_226.setTransform(397.4,432.3,0.5,0.5);

	this.shape_227 = new cjs.Shape();
	this.shape_227.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_227.setTransform(387.5,429.1,0.5,0.5);

	this.shape_228 = new cjs.Shape();
	this.shape_228.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAgAAA7IAAASIjCAAQABA4AZAdQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgWAEgUgBQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_228.setTransform(374.6,429.3,0.5,0.5);

	this.shape_229 = new cjs.Shape();
	this.shape_229.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_229.setTransform(364.8,426.3,0.5,0.5);

	this.shape_230 = new cjs.Shape();
	this.shape_230.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_230.setTransform(359,426.3,0.5,0.5);

	this.shape_231 = new cjs.Shape();
	this.shape_231.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgag");
	this.shape_231.setTransform(348.9,429.3,0.5,0.5);

	this.shape_232 = new cjs.Shape();
	this.shape_232.graphics.f("#000000").s().p("AhmCLQgugxAAhZQAAg3AYgqQAWgsAqgXQArgXA2AAQA7gBAwAWIgKAYQgwgXgyAAQhIAAgqAtQgqAsAABLQAABTApAoQAoAqBMAAQAzAAAigOIAAiAIhsAAIAAgXICGAAIAAClQg0AWhDAAQhUAAgvgwg");
	this.shape_232.setTransform(333.2,426.9,0.5,0.5);

	this.shape_233 = new cjs.Shape();
	this.shape_233.graphics.f("#000000").s().p("AhPB4QgVgUAAglQAAgnAggWQAigVA9gBIA0gCIAAgSQgBgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAWgBAyIAACzIgSAAIgFgrIgDAAQgVAbgUAKQgWALgdAAQgnAAgXgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_233.setTransform(310.3,429.3,0.5,0.5);

	this.shape_234 = new cjs.Shape();
	this.shape_234.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_234.setTransform(296.6,429.1,0.5,0.5);

	this.shape_235 = new cjs.Shape();
	this.shape_235.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_235.setTransform(286.1,426.8,0.5,0.5);

	this.shape_236 = new cjs.Shape();
	this.shape_236.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAWAAATgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_236.setTransform(278.8,427.8,0.5,0.5);

	this.shape_237 = new cjs.Shape();
	this.shape_237.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_237.setTransform(267.5,429.3,0.5,0.5);

	this.shape_238 = new cjs.Shape();
	this.shape_238.graphics.f("#000000").s().p("AhsC2IAAlrIBZAAQCAAAAABoQAAA1gkAbQgjAchBABIg4AAIAACWgAhTAJIAyAAQA8AAAcgSQAbgVAAguQAAgpgagVQgagUg1AAIg8AAg");
	this.shape_238.setTransform(254.3,426.9,0.5,0.5);

	this.shape_239 = new cjs.Shape();
	this.shape_239.graphics.f("#000000").s().p("AheChQgsgZgYgrQgYgrAAgyQAAgwAZgsQAZgsArgZQAsgZAxAAQAxAAAsAZQAsAYAZAsQAZAsAAAxQAAAygYAqQgZAsgrAZQgrAag0AAQgzAAgrgagAhRiNQgmAWgWAmQgWAnAAAqQAAAsAWAmQAWAmAmAWQAmAWArAAQAsAAAmgWQAmgWAWgmQAWglAAgtQAAgrgVglQgVglgngXQgmgXgtAAQgqAAgnAWgAhABUQgZgdAAg1QAAgzAbgfQAcgfAtAAQAdAAAcANIgJAUQgagLgWAAQgiAAgUAYQgUAXAAAqQAAAuASAWQATAWAjAAQAVAAAdgKIAAAWQgZALgbAAQguAAgZgdg");
	this.shape_239.setTransform(229,426.9,0.5,0.5);

	this.shape_240 = new cjs.Shape();
	this.shape_240.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtABQAnAAAVgOQAVgMAAgYQAAgUgRgOQgQgOgmgNQgrgQgNgIQgRgLgIgNQgJgOAAgTQABgeAZgSQAagSAsAAQAsAAAnARIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArAQQAkANASALQARALAIAMQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_240.setTransform(205.8,429.3,0.5,0.5);

	this.shape_241 = new cjs.Shape();
	this.shape_241.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAgAAA7IAAASIjCAAQABA4AZAdQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgWAEgUgBQg7AAgggkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_241.setTransform(192.9,429.3,0.5,0.5);

	this.shape_242 = new cjs.Shape();
	this.shape_242.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgNAHgJALQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgyAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAghQAAgigSgRQgSgSghAAQghAAgSATg");
	this.shape_242.setTransform(179.3,432.2,0.5,0.5);

	this.shape_243 = new cjs.Shape();
	this.shape_243.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_243.setTransform(165.4,429.3,0.5,0.5);

	this.shape_244 = new cjs.Shape();
	this.shape_244.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgRgggBQgqAAgUAYQgTAWAAAyIAACdIgZAAIAAi4QAAhFg+AAQgrABgTAYQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_244.setTransform(147.9,429.1,0.5,0.5);

	this.shape_245 = new cjs.Shape();
	this.shape_245.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAGAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_245.setTransform(133.7,426.8,0.5,0.5);

	this.shape_246 = new cjs.Shape();
	this.shape_246.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAJgGAIgMQAIgMALgdIAMgjIhnkOIAaAAIA5CYQAdBPAEAOIABAAIAiheIA5iXIAZAAIh4E6QgPAmgJAOQgMAOgMAGQgPAGgRABQgOgBgSgFg");
	this.shape_246.setTransform(118.3,432.3,0.5,0.5);

	this.shape_247 = new cjs.Shape();
	this.shape_247.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_247.setTransform(108.4,429.1,0.5,0.5);

	this.shape_248 = new cjs.Shape();
	this.shape_248.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_248.setTransform(99.7,426.3,0.5,0.5);

	this.shape_249 = new cjs.Shape();
	this.shape_249.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAcAggBA7IAAASIjBAAQABA4AYAdQAaAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgXAKgUAEQgWAEgUgBQg7AAghgkgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgVgagjAAQgmAAgYAZg");
	this.shape_249.setTransform(89.8,429.3,0.5,0.5);

	this.shape_250 = new cjs.Shape();
	this.shape_250.graphics.f("#000000").s().p("ABOCHIhKjqIgCAAIhMDqIgYAAIhNkNIAaAAIArCbQAQBAAEAWIACAAQAPg+AGgPIA3ikIAWAAIA1CjQATA+ADAQIABAAQADgTAShEIApiaIAYAAIhIENg");
	this.shape_250.setTransform(73.6,429.3,0.5,0.5);

	this.shape_251 = new cjs.Shape();
	this.shape_251.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA3AbAeQAZAeAvAAQAXAAARgDQATgEAZgKIAAAWQgVAKgVAEQgWAEgUgBQg6AAghgkgAg3hcQgYAagDAxICmAAQAAgxgVgZQgUgagkAAQgmAAgYAZg");
	this.shape_251.setTransform(57.4,429.3,0.5,0.5);

	this.shape_252 = new cjs.Shape();
	this.shape_252.graphics.f("#000000").s().p("Ag8DdIAAgWQASAFATAAQA7AAAAhBIAAluIAZAAIAAFrQAABchUAAQgWAAgPgHg");
	this.shape_252.setTransform(44.8,429.2,0.5,0.5);

	this.shape_253 = new cjs.Shape();
	this.shape_253.graphics.f("#000000").s().p("AgTAAQAAgYATABQAUgBAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_253.setTransform(730.7,396.8,0.5,0.5);

	this.shape_254 = new cjs.Shape();
	this.shape_254.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_254.setTransform(724.8,388.1,0.5,0.5);

	this.shape_255 = new cjs.Shape();
	this.shape_255.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgXAKgUAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgaglAAQgmAAgYAZg");
	this.shape_255.setTransform(714.9,391,0.5,0.5);

	this.shape_256 = new cjs.Shape();
	this.shape_256.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_256.setTransform(700.5,388.1,0.5,0.5);

	this.shape_257 = new cjs.Shape();
	this.shape_257.graphics.f("#000000").s().p("Ag/BoQghgkAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg5AAgggkg");
	this.shape_257.setTransform(687.1,391,0.5,0.5);

	this.shape_258 = new cjs.Shape();
	this.shape_258.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAFAAAMQAAAMgFAGQgEAGgHAAQgPAAAAgYg");
	this.shape_258.setTransform(677.9,388.5,0.5,0.5);

	this.shape_259 = new cjs.Shape();
	this.shape_259.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgeIgCAAIiIFOIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_259.setTransform(664,388.7,0.5,0.5);

	this.shape_260 = new cjs.Shape();
	this.shape_260.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgMQAIgNAKgcIAOgjIhokOIAZAAIA5CYQAbBGAGAXIABAAQAKgfAYg/IA5iXIAaAAIh4E6QgOAkgLAQQgJANgOAHQgPAGgRABQgOgBgSgFg");
	this.shape_260.setTransform(640.5,394.1,0.5,0.5);

	this.shape_261 = new cjs.Shape();
	this.shape_261.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAeQgaAfAAA5QAAA3AaAfQAaAfAtAAQAkAAAggNIAAAXQgbAMgpAAQg4AAgigkg");
	this.shape_261.setTransform(628.9,391,0.5,0.5);

	this.shape_262 = new cjs.Shape();
	this.shape_262.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_262.setTransform(615.1,390.9,0.5,0.5);

	this.shape_263 = new cjs.Shape();
	this.shape_263.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_263.setTransform(600.3,391,0.5,0.5);

	this.shape_264 = new cjs.Shape();
	this.shape_264.graphics.f("#000000").s().p("ABrC2IjXlDIgCAAQADA7AAAdIAADrIgYAAIAAlrIAZAAIDWFCIACAAQgCgoAAguIAAjsIAYAAIAAFrg");
	this.shape_264.setTransform(584.8,388.7,0.5,0.5);

	this.shape_265 = new cjs.Shape();
	this.shape_265.graphics.f("#000000").s().p("AgdA+QAThBAJg6IAcAAIADAFQgSBBgYA1g");
	this.shape_265.setTransform(565.8,397.9,0.5,0.5);

	this.shape_266 = new cjs.Shape();
	this.shape_266.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsABQAoAAAUgOQAVgMAAgYQAAgUgRgOQgPgNgngOQgqgPgOgJQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgngQgjAAQggAAgTALQgUALAAATQAAAVAQANQAPANAqAPQAmAOAQAKQARALAIAMQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_266.setTransform(557.5,391,0.5,0.5);

	this.shape_267 = new cjs.Shape();
	this.shape_267.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_267.setTransform(544.2,390.9,0.5,0.5);

	this.shape_268 = new cjs.Shape();
	this.shape_268.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAHQAFAFAAAMQAAAMgFAGQgDAGgIAAQgPAAAAgYg");
	this.shape_268.setTransform(533.7,388.5,0.5,0.5);

	this.shape_269 = new cjs.Shape();
	this.shape_269.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_269.setTransform(525.8,388.1,0.5,0.5);

	this.shape_270 = new cjs.Shape();
	this.shape_270.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAWAAATgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_270.setTransform(514,389.5,0.5,0.5);

	this.shape_271 = new cjs.Shape();
	this.shape_271.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_271.setTransform(502.7,391,0.5,0.5);

	this.shape_272 = new cjs.Shape();
	this.shape_272.graphics.f("#000000").s().p("ABdC2IhelQIgLAxIhQEfIgWAAIhklrIAbAAIBVFDQAGgfAThIIA/jcIAbAAIBJD9QALAoAHAeIAIgmIBNkdIAaAAIhlFrg");
	this.shape_272.setTransform(485,388.7,0.5,0.5);

	this.shape_273 = new cjs.Shape();
	this.shape_273.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_273.setTransform(459.8,391,0.5,0.5);

	this.shape_274 = new cjs.Shape();
	this.shape_274.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_274.setTransform(449.5,390.9,0.5,0.5);

	this.shape_275 = new cjs.Shape();
	this.shape_275.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_275.setTransform(435.6,388.2,0.5,0.5);

	this.shape_276 = new cjs.Shape();
	this.shape_276.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_276.setTransform(421,390.9,0.5,0.5);

	this.shape_277 = new cjs.Shape();
	this.shape_277.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_277.setTransform(406.2,391,0.5,0.5);

	this.shape_278 = new cjs.Shape();
	this.shape_278.graphics.f("#000000").s().p("ABVCHIhVh5IhVB5IgbAAIBiiKIhfiDIAdAAIBQByIBPhyIAbAAIhcCDIBjCKg");
	this.shape_278.setTransform(393.5,391,0.5,0.5);

	this.shape_279 = new cjs.Shape();
	this.shape_279.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgoQAhgmA0gBQAwABAcAhQAbAhAAA6IAAASIjCAAQABA4AZAdQAbAeAuAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgWAEgUgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_279.setTransform(380.2,391,0.5,0.5);

	this.shape_280 = new cjs.Shape();
	this.shape_280.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_280.setTransform(370.3,388.1,0.5,0.5);

	this.shape_281 = new cjs.Shape();
	this.shape_281.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAPAAICQFtgAgNhiIgzCBICBAAIhBitQgEAXgJAVg");
	this.shape_281.setTransform(359.8,388.6,0.5,0.5);

	this.shape_282 = new cjs.Shape();
	this.shape_282.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgKIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgTgGgVAAQgcAAgNARQgLARAAAmIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_282.setTransform(342.5,388,0.5,0.5);

	this.shape_283 = new cjs.Shape();
	this.shape_283.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhglA2AAQA4AAAgAmQAgAmAABAQAABCghAlQgfAlg4AAQgjABgcgSgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAeg");
	this.shape_283.setTransform(330.4,391,0.5,0.5);

	this.shape_284 = new cjs.Shape();
	this.shape_284.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgMQAHgMALgdIAOgjIhokOIAZAAIA5CYQAZBBAJAcIAAAAQAOgqAUg0IA5iXIAaAAIh4E6QgQAngJANQgKANgNAHQgPAGgRABQgOgBgSgFg");
	this.shape_284.setTransform(310.4,394.1,0.5,0.5);

	this.shape_285 = new cjs.Shape();
	this.shape_285.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtABQAnAAAVgOQAVgMAAgYQAAgTgRgPQgQgOgmgNQgqgPgOgJQgRgLgIgNQgJgOAAgTQAAgeAagSQAagSAsAAQAtAAAmARIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArAQQAkANASALQARALAIAMQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_285.setTransform(298.6,391,0.5,0.5);

	this.shape_286 = new cjs.Shape();
	this.shape_286.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAcAhgBA6IAAASIjCAAQACA4AYAdQAaAeAuAAQAYAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWAEgVgBQg5AAgigkgAg2hcQgYAZgEAyICmAAQABgwgVgaQgVgagjAAQgmAAgYAZg");
	this.shape_286.setTransform(285.7,391,0.5,0.5);

	this.shape_287 = new cjs.Shape();
	this.shape_287.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAWAAATgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_287.setTransform(274.3,389.5,0.5,0.5);

	this.shape_288 = new cjs.Shape();
	this.shape_288.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhbAAgBhjg");
	this.shape_288.setTransform(262.6,391.1,0.5,0.5);

	this.shape_289 = new cjs.Shape();
	this.shape_289.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhglA2AAQA4AAAgAmQAgAmAABAQAABCghAlQgfAlg4AAQgjABgcgSgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAeg");
	this.shape_289.setTransform(247.7,391,0.5,0.5);

	this.shape_290 = new cjs.Shape();
	this.shape_290.graphics.f("#000000").s().p("Ag/BoQghgkAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg5AAgggkg");
	this.shape_290.setTransform(234.4,391,0.5,0.5);

	this.shape_291 = new cjs.Shape();
	this.shape_291.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsABQAoAAAUgOQAVgMAAgYQAAgUgRgOQgQgOgmgNQgqgPgOgJQgQgLgJgNQgIgMAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIAMQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_291.setTransform(215.4,391,0.5,0.5);

	this.shape_292 = new cjs.Shape();
	this.shape_292.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgmA1gBQAxABAbAhQAcAiAAA5IAAASIjDAAQAAA3AaAeQAaAeAuAAQAYAAARgDQATgEAagKIAAAWQgXAKgUAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgVgagkAAQglAAgZAZg");
	this.shape_292.setTransform(202.6,391,0.5,0.5);

	this.shape_293 = new cjs.Shape();
	this.shape_293.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQgBgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQgBgaAkgUQgXgKgOgVQgNgUgBgcQABgoAZgZQAZgYAtAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgQAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgkAXg+AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgQgLQgRgLglAAIgsAAQhKAAAAA7gAg4igQgTATAAAgQAAAgATARQATARAgAAQAiAAARgRQASgRAAghQAAgigTgRQgSgSggAAQghAAgSATg");
	this.shape_293.setTransform(188.9,393.9,0.5,0.5);

	this.shape_294 = new cjs.Shape();
	this.shape_294.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_294.setTransform(175,391,0.5,0.5);

	this.shape_295 = new cjs.Shape();
	this.shape_295.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgpAAgUAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgWAXgOQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_295.setTransform(157.5,390.9,0.5,0.5);

	this.shape_296 = new cjs.Shape();
	this.shape_296.graphics.f("#000000").s().p("AgMC2IAAlrIAYAAIAAFrg");
	this.shape_296.setTransform(143,388.7,0.5,0.5);

	this.shape_297 = new cjs.Shape();
	this.shape_297.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_297.setTransform(130.3,388.1,0.5,0.5);

	this.shape_298 = new cjs.Shape();
	this.shape_298.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_298.setTransform(120.2,391,0.5,0.5);

	this.shape_299 = new cjs.Shape();
	this.shape_299.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAaIABAAQALgkAKgaIBGi2IAZAAIhpENg");
	this.shape_299.setTransform(108,391,0.5,0.5);

	this.shape_300 = new cjs.Shape();
	this.shape_300.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_300.setTransform(99.3,388.5,0.5,0.5);

	this.shape_301 = new cjs.Shape();
	this.shape_301.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAAABiIAACxg");
	this.shape_301.setTransform(89,388.1,0.5,0.5);

	this.shape_302 = new cjs.Shape();
	this.shape_302.graphics.f("#000000").s().p("Ag/BoQghgkAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg5AAgggkg");
	this.shape_302.setTransform(75.6,391,0.5,0.5);

	this.shape_303 = new cjs.Shape();
	this.shape_303.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_303.setTransform(65.2,390.9,0.5,0.5);

	this.shape_304 = new cjs.Shape();
	this.shape_304.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_304.setTransform(51.7,388.6,0.5,0.5);

	this.shape_305 = new cjs.Shape();
	this.shape_305.graphics.f("#000000").s().p("AhVCjQgdgaAAgwQAAghAVgYQAUgYAsgRQgogTgRgVQgQgVAAgdQAAgaANgUQANgUAYgLQAXgLAdAAQAuAAAcAYQAdAYAAAoQAAAcgSAVQgRAWgoASQAxATATAXQATAYAAAhQAAAtggAbQgfAbg0AAQg3AAgegZgAhFAnQgUAWAAAgQAAAiAYATQAXATAqAAQAoAAAYgUQAagUAAgiQAAgfgUgTQgTgUg3gVQguARgTAWgAg4iTQgVASAAAeQAAARAHANQAJAOAPAKQAOAMAiAOQAogQATgTQARgTAAgaQAAgegVgSQgVgRgkAAQgiAAgWARg");
	this.shape_305.setTransform(286.4,350.4,0.5,0.5);

	this.shape_306 = new cjs.Shape();
	this.shape_306.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIhUBDIgOgRIBihKIAVAAIAAFrg");
	this.shape_306.setTransform(270.1,350.4,0.5,0.5);

	this.shape_307 = new cjs.Shape();
	this.shape_307.graphics.f("#000000").s().p("AhXCMQgdgwAAhcQAAhfAdgtQAdgvA6ABQA5AAAeAvQAeAwAABbQAABggdAtQgeAvg6gBQg4AAgfgvgAhEh6QgVAqAABQQAABUAWAoQAWApAtAAQAuAAAWgqQAVgqABhRQgBhPgVgrQgWgqguAAQgvAAgVAqg");
	this.shape_307.setTransform(257.4,350.4,0.5,0.5);

	this.shape_308 = new cjs.Shape();
	this.shape_308.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAogrAQgVQAQgWAIgVQAIgTAAgYQAAghgVgUQgWgUghAAQgtAAgqAhIgNgRQAtgnA4AAQAuAAAcAaQAbAZAAAtQAAAkgTAiQgRAfgxAzIhdBgIAAABIDCAAIAAAYg");
	this.shape_308.setTransform(242.6,350.3,0.5,0.5);

	this.shape_309 = new cjs.Shape();
	this.shape_309.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBGAHAYIAAAAIAihfIA6iXIAZAAIh4E6QgPAmgKAOQgLAOgMAGQgPAGgRABQgNgBgTgFg");
	this.shape_309.setTransform(223,355.8,0.5,0.5);

	this.shape_310 = new cjs.Shape();
	this.shape_310.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_310.setTransform(213.1,352.6,0.5,0.5);

	this.shape_311 = new cjs.Shape();
	this.shape_311.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA3AbAfQAZAdAuAAQAYAAARgDQASgEAbgKIAAAWQgXAKgTAEQgXAEgVgBQg6AAgggkgAg3hcQgXAagEAxICmAAQAAgxgUgZQgVgagkAAQgmAAgYAZg");
	this.shape_311.setTransform(200.3,352.8,0.5,0.5);

	this.shape_312 = new cjs.Shape();
	this.shape_312.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_312.setTransform(190.4,349.8,0.5,0.5);

	this.shape_313 = new cjs.Shape();
	this.shape_313.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_313.setTransform(184.6,349.8,0.5,0.5);

	this.shape_314 = new cjs.Shape();
	this.shape_314.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_314.setTransform(174.5,352.8,0.5,0.5);

	this.shape_315 = new cjs.Shape();
	this.shape_315.graphics.f("#000000").s().p("AhlCLQgugwAAhaQAAg2AWgrQAYgtAqgWQAqgXA2AAQA7gBAwAWIgKAYQgwgXgyAAQhHAAgrAtQgqAsAABLQAABSAoApQApAqBMAAQAzAAAjgOIAAiAIhtAAIAAgXICGAAIAAClQg0AWhCAAQhVAAgugwg");
	this.shape_315.setTransform(158.8,350.4,0.5,0.5);

	this.shape_316 = new cjs.Shape();
	this.shape_316.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_316.setTransform(136,352.8,0.5,0.5);

	this.shape_317 = new cjs.Shape();
	this.shape_317.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_317.setTransform(122.2,352.6,0.5,0.5);

	this.shape_318 = new cjs.Shape();
	this.shape_318.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_318.setTransform(111.8,350.3,0.5,0.5);

	this.shape_319 = new cjs.Shape();
	this.shape_319.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgPIAngLIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQgBAgALAOQALAPAXABQAWAAASgFIAAAVQgQAFgYAAQgjABgRgUg");
	this.shape_319.setTransform(104.4,351.3,0.5,0.5);

	this.shape_320 = new cjs.Shape();
	this.shape_320.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgWAcgUAJQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_320.setTransform(93.1,352.8,0.5,0.5);

	this.shape_321 = new cjs.Shape();
	this.shape_321.graphics.f("#000000").s().p("AhtC2IAAlrIBaAAQCBAAAABoQAAA1gkAbQglAchAABIg4AAIAACWgAhTAJIAyAAQA8AAAcgSQAbgVAAgtQAAgrgagUQgagUg1AAIg8AAg");
	this.shape_321.setTransform(79.9,350.4,0.5,0.5);

	this.shape_322 = new cjs.Shape();
	this.shape_322.graphics.f("#000000").s().p("AheChQgrgZgZgrQgYgrAAgyQAAgwAZgsQAZgsArgZQAsgZAxAAQAxAAAtAZQArAZAZArQAZArAAAyQAAAygYAqQgYAsgrAZQgsAag0AAQgzAAgrgagAhRiNQglAWgXAmQgWAmAAArQAAAuAWAkQAWAmAmAWQAmAWArAAQAsAAAmgWQAmgVAWgnQAWgmAAgsQAAgrgVglQgVglgngXQgmgXgtAAQgqAAgnAWgAhABUQgZgcAAg2QAAgzAbgfQAcgfAtAAQAdAAAcANIgJAUQgagLgWAAQgiAAgUAYQgUAYAAApQAAAtASAXQATAWAjAAQAVAAAdgKIAAAWQgZALgbAAQguAAgZgdg");
	this.shape_322.setTransform(54.6,350.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_322},{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},121).to({state:[{t:this.shape_322},{t:this.shape_321},{t:this.shape_320},{t:this.shape_319},{t:this.shape_318},{t:this.shape_317},{t:this.shape_316},{t:this.shape_315},{t:this.shape_314},{t:this.shape_313},{t:this.shape_312},{t:this.shape_311},{t:this.shape_310},{t:this.shape_309},{t:this.shape_308},{t:this.shape_307},{t:this.shape_306},{t:this.shape_305},{t:this.shape_304},{t:this.shape_303},{t:this.shape_302},{t:this.shape_301},{t:this.shape_300},{t:this.shape_299},{t:this.shape_298},{t:this.shape_297},{t:this.shape_296},{t:this.shape_295},{t:this.shape_294},{t:this.shape_293},{t:this.shape_292},{t:this.shape_291},{t:this.shape_290},{t:this.shape_289},{t:this.shape_288},{t:this.shape_287},{t:this.shape_286},{t:this.shape_285},{t:this.shape_284},{t:this.shape_283},{t:this.shape_282},{t:this.shape_281},{t:this.shape_280},{t:this.shape_279},{t:this.shape_278},{t:this.shape_277},{t:this.shape_276},{t:this.shape_275},{t:this.shape_274},{t:this.shape_273},{t:this.shape_272},{t:this.shape_271},{t:this.shape_270},{t:this.shape_269},{t:this.shape_268},{t:this.shape_267},{t:this.shape_266},{t:this.shape_265},{t:this.shape_264},{t:this.shape_263},{t:this.shape_262},{t:this.shape_261},{t:this.shape_260},{t:this.shape_259},{t:this.shape_258},{t:this.shape_257},{t:this.shape_256},{t:this.shape_255},{t:this.shape_254},{t:this.shape_253},{t:this.shape_252},{t:this.shape_251},{t:this.shape_250},{t:this.shape_249},{t:this.shape_248},{t:this.shape_247},{t:this.shape_246},{t:this.shape_245},{t:this.shape_244},{t:this.shape_243},{t:this.shape_242},{t:this.shape_241},{t:this.shape_240},{t:this.shape_239},{t:this.shape_238},{t:this.shape_237},{t:this.shape_236},{t:this.shape_235},{t:this.shape_234},{t:this.shape_233},{t:this.shape_232},{t:this.shape_231},{t:this.shape_230},{t:this.shape_229},{t:this.shape_228},{t:this.shape_227},{t:this.shape_226},{t:this.shape_225},{t:this.shape_224},{t:this.shape_223},{t:this.shape_222},{t:this.shape_221},{t:this.shape_220},{t:this.shape_219},{t:this.shape_218},{t:this.shape_217},{t:this.shape_216},{t:this.shape_215},{t:this.shape_214},{t:this.shape_213},{t:this.shape_212},{t:this.shape_211},{t:this.shape_210},{t:this.shape_209},{t:this.shape_208},{t:this.shape_207},{t:this.shape_206},{t:this.shape_205},{t:this.shape_204},{t:this.shape_203},{t:this.shape_202},{t:this.shape_201},{t:this.shape_200},{t:this.shape_199},{t:this.shape_198},{t:this.shape_197},{t:this.shape_196},{t:this.shape_195},{t:this.shape_194},{t:this.shape_193},{t:this.shape_192},{t:this.shape_191},{t:this.shape_190},{t:this.shape_189},{t:this.shape_188},{t:this.shape_187},{t:this.shape_186},{t:this.shape_185},{t:this.shape_184},{t:this.shape_183},{t:this.shape_182},{t:this.shape_181},{t:this.shape_180},{t:this.shape_179},{t:this.shape_178},{t:this.shape_177},{t:this.shape_176},{t:this.shape_175},{t:this.shape_174},{t:this.shape_173},{t:this.shape_172},{t:this.shape_171},{t:this.shape_170},{t:this.shape_169},{t:this.shape_168},{t:this.shape_167},{t:this.shape_166},{t:this.shape_165},{t:this.shape_164},{t:this.shape_163},{t:this.shape_162},{t:this.shape_161},{t:this.shape_160},{t:this.shape_159},{t:this.shape_158},{t:this.shape_157},{t:this.shape_156},{t:this.shape_155},{t:this.shape_154},{t:this.shape_153},{t:this.shape_152},{t:this.shape_151},{t:this.shape_150},{t:this.shape_149},{t:this.shape_148},{t:this.shape_147},{t:this.shape_146},{t:this.shape_145},{t:this.shape_144},{t:this.shape_143},{t:this.shape_142},{t:this.shape_141},{t:this.shape_140},{t:this.shape_139},{t:this.shape_138},{t:this.shape_137},{t:this.shape_136},{t:this.shape_135},{t:this.shape_134},{t:this.shape_133},{t:this.shape_132},{t:this.shape_131},{t:this.shape_130},{t:this.shape_129},{t:this.shape_128},{t:this.shape_127},{t:this.shape_126},{t:this.shape_125},{t:this.shape_124},{t:this.shape_123},{t:this.shape_122},{t:this.shape_121},{t:this.shape_120},{t:this.shape_119},{t:this.shape_118},{t:this.shape_117},{t:this.shape_116},{t:this.shape_115},{t:this.shape_114},{t:this.shape_113},{t:this.shape_112},{t:this.shape_111},{t:this.shape_110},{t:this.shape_109},{t:this.shape_108},{t:this.shape_107},{t:this.shape_106},{t:this.shape_105},{t:this.shape_104},{t:this.shape_103},{t:this.shape_102},{t:this.shape_101},{t:this.shape_100},{t:this.shape_99},{t:this.shape_98},{t:this.shape_97},{t:this.shape_96},{t:this.shape_95},{t:this.shape_94},{t:this.shape_93},{t:this.shape_92},{t:this.shape_91},{t:this.shape_90},{t:this.shape_89},{t:this.shape_88},{t:this.shape_87},{t:this.shape_86},{t:this.shape_85},{t:this.shape_84},{t:this.shape_83},{t:this.shape_82},{t:this.shape_81},{t:this.shape_80},{t:this.shape_79},{t:this.shape_78},{t:this.shape_77},{t:this.shape_76},{t:this.shape_75},{t:this.shape_74},{t:this.shape_73},{t:this.shape_72},{t:this.shape_71},{t:this.shape_70},{t:this.shape_69},{t:this.shape_68},{t:this.shape_67},{t:this.shape_66},{t:this.shape_65},{t:this.shape_64},{t:this.shape_63},{t:this.shape_62},{t:this.shape_61},{t:this.shape_60},{t:this.shape_59},{t:this.shape_58},{t:this.shape_57},{t:this.shape_56},{t:this.shape_55},{t:this.shape_54},{t:this.shape_53},{t:this.shape_52},{t:this.shape_51},{t:this.shape_50},{t:this.shape_49},{t:this.shape_48},{t:this.shape_47},{t:this.shape_46},{t:this.shape_45},{t:this.shape_44},{t:this.shape_43},{t:this.shape_42},{t:this.shape_41},{t:this.shape_40},{t:this.shape_39},{t:this.shape_38},{t:this.shape_37},{t:this.shape_36},{t:this.shape_35},{t:this.shape_34},{t:this.shape_33},{t:this.shape_32},{t:this.shape_31},{t:this.shape_30},{t:this.shape_29},{t:this.shape_28},{t:this.shape_27},{t:this.shape_26},{t:this.shape_25},{t:this.shape_24},{t:this.shape_23},{t:this.shape_22},{t:this.shape_21},{t:this.shape_20},{t:this.shape_19},{t:this.shape_18},{t:this.shape_17},{t:this.shape_16},{t:this.shape_15},{t:this.shape_14},{t:this.shape_13},{t:this.shape_12},{t:this.shape_11},{t:this.shape_10},{t:this.shape_9},{t:this.shape_8},{t:this.shape_7},{t:this.shape_6},{t:this.shape_5},{t:this.shape_4},{t:this.shape_3},{t:this.shape_2},{t:this.shape_1},{t:this.shape}]},43).wait(1));

	// ButtonLeftRight copy 60
	this.buttonR29 = new lib.ButtonLeft_Right();
	this.buttonR29.name = "buttonR29";
	this.buttonR29.parent = this;
	this.buttonR29.setTransform(2025.4,513.5,1,1,180);
	this.buttonR29._off = true;
	new cjs.ButtonHelper(this.buttonR29, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR29).wait(120).to({_off:false},0).to({_off:true},1).wait(44));

	// ButtonLeftRight copy 61
	this.buttonL29 = new lib.ButtonLeft_Right();
	this.buttonL29.name = "buttonL29";
	this.buttonL29.parent = this;
	this.buttonL29.setTransform(-0.1,437.2);
	this.buttonL29._off = true;
	new cjs.ButtonHelper(this.buttonL29, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL29).wait(120).to({_off:false},0).to({_off:true},1).wait(44));

	// Layer 1
	this.instance_2 = new lib.finalpiece();
	this.instance_2.parent = this;
	this.instance_2.setTransform(893,178,0.325,0.325);

	this.shape_323 = new cjs.Shape();
	this.shape_323.graphics.f("#A2C0BE").s().p("AhUAXIgSgtIDNAAIAAAtg");
	this.shape_323.setTransform(990.4,776.8,0.5,0.5);

	this.shape_324 = new cjs.Shape();
	this.shape_324.graphics.f("#A2C0BE").s().p("AFbg9IgBAAIgtD4IgnAAIBGmFIB+E1IB/k1IBHGFIgoAAIgtj4IgBAAIhwEIgAhlCKQg2g3AAhQQAAhOA2g4QA1g4BJAAQBLAAA1A4QA2A4AABOQAABQg2A3Qg1A4hLAAQhJAAg1g4gAhLhoQgpAtAAA+QAAA/AqAtQAqAtA5AAQA7AAAqgtQAqgtAAg/QAAg/gpgsQgqgtg8AAQg6AAgqAtgAnNCKQg2g3AAhPQAAhOA1g5QA1g4BLAAQA6AAAuAkIAAAzQgWgXgbgNQgcgNgdAAQg6AAgqAuQgpAtAAA9QAAA9AqAuQAqAuA6AAQAcAAAcgOQAbgNAWgWIAAAzQgvAkg5AAQhKAAg1g4gAqHC6QgIgJAAgLQAAgLAIgIQAHgIALAAQALAAAHAIQAIAIAAALQAAALgIAJQgHAIgLAAQgLAAgHgIg");
	this.shape_324.setTransform(1124.7,776.9,0.5,0.5);

	this.shape_325 = new cjs.Shape();
	this.shape_325.graphics.f("#A2C0BE").s().p("AgWDDIAAiqIh1jbIAzAAIBYCnIBZinIAzAAIh1DbIAACqg");
	this.shape_325.setTransform(1083.5,776.9,0.5,0.5);

	this.shape_326 = new cjs.Shape();
	this.shape_326.graphics.f("#A2C0BE").s().p("AA6DDIhqilIgSAAIAAClIgtAAIAAmFIA2AAQAgAAARACQAaAEAUAMQAWAOANAaQAMAZAAAcQAAArgYAeQgYAegmAFIBxCqgAhCgJIAOAAQArAAAVgNQAfgRAAgqQAAgpghgRQgWgMgqAAIgMAAg");
	this.shape_326.setTransform(1070.9,776.9,0.5,0.5);

	this.shape_327 = new cjs.Shape();
	this.shape_327.graphics.f("#A2C0BE").s().p("AhgDDIAAmFIDBAAIAAAsIiUAAIAABuICQAAIAAArIiQAAIAACUICUAAIAAAsg");
	this.shape_327.setTransform(1057.7,776.9,0.5,0.5);

	this.shape_328 = new cjs.Shape();
	this.shape_328.graphics.f("#A2C0BE").s().p("AhNDDIAAmFIAtAAIAAFZIBtAAIAAAsg");
	this.shape_328.setTransform(1047.5,776.9,0.5,0.5);

	this.shape_329 = new cjs.Shape();
	this.shape_329.graphics.f("#A2C0BE").s().p("AhNDDIAAmFIAtAAIAAFZIBtAAIAAAsg");
	this.shape_329.setTransform(1038.2,776.9,0.5,0.5);

	this.shape_330 = new cjs.Shape();
	this.shape_330.graphics.f("#A2C0BE").s().p("AB8DMIgphiIilAAIgpBiIgxAAICsmXICtGXgAg/A9IB/AAIhAidg");
	this.shape_330.setTransform(1024.2,776.5,0.5,0.5);

	this.shape_331 = new cjs.Shape();
	this.shape_331.graphics.f("#A2C0BE").s().p("Ah7CPQg1g8AAhSQAAhTA3g8QA3g9BMAAQArAAAmAUQAoAUAbAkIggAhQgUgdgegRQgegSghAAQg8AAgqAvQgqAuAABBQAAA+ApAwQAqAxA4AAQAsAAAkgiQAmgjABgvIhdAAIAAgsICPAAIAAAPQAABRgvA2QgxA3hLAAQhLAAg2g9g");
	this.shape_331.setTransform(1006.4,776.9,0.5,0.5);

	this.shape_332 = new cjs.Shape();
	this.shape_332.graphics.f("#A2C0BE").s().p("AB8DMIgphiIilAAIgpBiIgxAAICsmXICtGXgAg/A9ICAAAIhBidg");
	this.shape_332.setTransform(979.4,776.5,0.5,0.5);

	this.shape_333 = new cjs.Shape();
	this.shape_333.graphics.f("#A2C0BE").s().p("AhwheIAAEjIgtAAIAAmZIEOEyIAAkfIAtAAIAAGVg");
	this.shape_333.setTransform(961.6,776.8,0.5,0.5);

	this.shape_334 = new cjs.Shape();
	this.shape_334.graphics.f("#A2C0BE").s().p("AgVDDIAAmFIAsAAIAAGFg");
	this.shape_334.setTransform(949.4,776.9,0.5,0.5);

	this.shape_335 = new cjs.Shape();
	this.shape_335.graphics.f("#A2C0BE").s().p("AgWDDIAAlZIhWAAIAAgsIDYAAIAAAsIhWAAIAAFZg");
	this.shape_335.setTransform(941.1,776.9,0.5,0.5);

	this.shape_336 = new cjs.Shape();
	this.shape_336.graphics.f("#A2C0BE").s().p("AB8DMIgphiIilAAIgpBiIgxAAICsmXICtGXgAg/A9IB/AAIhAidg");
	this.shape_336.setTransform(929.1,776.5,0.5,0.5);

	this.shape_337 = new cjs.Shape();
	this.shape_337.graphics.f("#A2C0BE").s().p("AhiDDIAAmFIA0AAQBPAAAjAdQAfAbAAA5QAAA6gmAdQghAag3AAIgaAAIAACjgAg1gLIAPAAQApAAAXgMQAfgRAAgqQAAgpghgQQgXgMgqAAIgMAAg");
	this.shape_337.setTransform(917.4,776.9,0.5,0.5);

	this.shape_338 = new cjs.Shape();
	this.shape_338.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAZgUgBQgTABAAgZg");
	this.shape_338.setTransform(1613.9,530.9,0.5,0.5);

	this.shape_339 = new cjs.Shape();
	this.shape_339.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2AAgggQg");
	this.shape_339.setTransform(1604.8,525.1,0.5,0.5);

	this.shape_340 = new cjs.Shape();
	this.shape_340.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_340.setTransform(1593.9,522.2,0.5,0.5);

	this.shape_341 = new cjs.Shape();
	this.shape_341.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_341.setTransform(1582.6,525,0.5,0.5);

	this.shape_342 = new cjs.Shape();
	this.shape_342.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_342.setTransform(1569.2,525.1,0.5,0.5);

	this.shape_343 = new cjs.Shape();
	this.shape_343.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA7AFAbIACAAQAOg7AHgSIA4ikIAVAAIA1CjQARA2AFAYIACAAQABgMAShLIAqiaIAZAAIhKENg");
	this.shape_343.setTransform(1552.5,525.1,0.5,0.5);

	this.shape_344 = new cjs.Shape();
	this.shape_344.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNgBgXQAAgUgQgOQgQgNgngOQgqgPgNgKQgRgJgIgOQgJgOAAgTQABgeAZgSQAagRAtAAQArAAAnAQIgJAWQgogQghAAQghAAgTALQgUAKAAAVQABAUAPANQAPANAqAQQAmANAPAJQARAKAJAOQAIAPAAARQAAAlgbATQgcAUgygBQg3AAgfgQg");
	this.shape_344.setTransform(1530.7,525.1,0.5,0.5);

	this.shape_345 = new cjs.Shape();
	this.shape_345.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2AAgggQg");
	this.shape_345.setTransform(1518.8,525.1,0.5,0.5);

	this.shape_346 = new cjs.Shape();
	this.shape_346.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAggnQAggnA2ABQAvgBAcAiQAbAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAYAAARgDQATgEAagKIAAAWQgXALgUADQgWADgVAAQg5AAgigkgAg2hcQgZAbgDAvICmAAQAAgvgUgaQgVgbgjAAQgnABgXAZg");
	this.shape_346.setTransform(1506,525.1,0.5,0.5);

	this.shape_347 = new cjs.Shape();
	this.shape_347.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_347.setTransform(1496.1,522.2,0.5,0.5);

	this.shape_348 = new cjs.Shape();
	this.shape_348.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA3AZAdQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYALgTADQgWADgUAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgugUgbQgVgbgkAAQgmABgXAZg");
	this.shape_348.setTransform(1486.2,525.1,0.5,0.5);

	this.shape_349 = new cjs.Shape();
	this.shape_349.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgPgTggABQgqAAgUAWQgTAXAAAxIAACeIgZAAIAAi4QAAhEg+AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAkIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgXAWgMQAWgNAcAAQAtAAAWAYQAWAYAAAzIAACwg");
	this.shape_349.setTransform(1468,525,0.5,0.5);

	this.shape_350 = new cjs.Shape();
	this.shape_350.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_350.setTransform(1453.8,522.6,0.5,0.5);

	this.shape_351 = new cjs.Shape();
	this.shape_351.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_351.setTransform(1446.5,523.6,0.5,0.5);

	this.shape_352 = new cjs.Shape();
	this.shape_352.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgSBAgYA2g");
	this.shape_352.setTransform(1432.6,532,0.5,0.5);

	this.shape_353 = new cjs.Shape();
	this.shape_353.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_353.setTransform(1427.4,522.2,0.5,0.5);

	this.shape_354 = new cjs.Shape();
	this.shape_354.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_354.setTransform(1417.3,525.1,0.5,0.5);

	this.shape_355 = new cjs.Shape();
	this.shape_355.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAkIABAAQAagqBEAAQBbAAAABjIAACwg");
	this.shape_355.setTransform(1403.6,525,0.5,0.5);

	this.shape_356 = new cjs.Shape();
	this.shape_356.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOghAAgpQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_356.setTransform(1388.5,525.1,0.5,0.5);

	this.shape_357 = new cjs.Shape();
	this.shape_357.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_357.setTransform(1378.1,522.6,0.5,0.5);

	this.shape_358 = new cjs.Shape();
	this.shape_358.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAOAYAAQAWAAATgEIAAAUQgSAHgXgBQgkAAgQgSg");
	this.shape_358.setTransform(1370.8,523.6,0.5,0.5);

	this.shape_359 = new cjs.Shape();
	this.shape_359.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_359.setTransform(1359.5,528,0.5,0.5);

	this.shape_360 = new cjs.Shape();
	this.shape_360.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgoQAggnA0ABQAwgBAcAiQAbAgABA6IAAAUIjDAAQABA3AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgYALgSADQgXADgVAAQg6AAghgkgAg3hcQgXAbgEAvICmAAQAAgugUgbQgVgbgkAAQgmABgYAZg");
	this.shape_360.setTransform(1344.5,525.1,0.5,0.5);

	this.shape_361 = new cjs.Shape();
	this.shape_361.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAkAAAfAMIgGAWQgkgMgZAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAkAAAggNIAAAXQgaANgqgBQg4AAgigkg");
	this.shape_361.setTransform(1331.8,525.1,0.5,0.5);

	this.shape_362 = new cjs.Shape();
	this.shape_362.graphics.f("#000000").s().p("ABVCHIhVh5IhVB5IgbAAIBiiKIhfiDIAdAAIBQByIBPhyIAcAAIhdCDIBjCKg");
	this.shape_362.setTransform(1319.1,525.1,0.5,0.5);

	this.shape_363 = new cjs.Shape();
	this.shape_363.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgnA1ABQAwgBAbAiQAcAhAAA5IAAAUIjCAAQAAA3AbAdQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgVAEQgWADgUAAQg6AAgigkgAg3hcQgYAagDAwICmAAQAAgvgUgaQgVgbgkAAQglABgZAZg");
	this.shape_363.setTransform(1305.7,525.1,0.5,0.5);

	this.shape_364 = new cjs.Shape();
	this.shape_364.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgTQARgSAdgHQgMgFgHgKQgIgJAAgNQAAgaAjgUQgXgKgOgVQgMgUAAgcQAAgoAZgZQAagYArAAQAZAAAQAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAXASQAYASAAAjQAAArgjAXQgjAXg+AAQg0AAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg5igQgSATAAAgQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigSgRQgTgSghAAQggAAgTATg");
	this.shape_364.setTransform(1285.5,528,0.5,0.5);

	this.shape_365 = new cjs.Shape();
	this.shape_365.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAkIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_365.setTransform(1271.3,525,0.5,0.5);

	this.shape_366 = new cjs.Shape();
	this.shape_366.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_366.setTransform(1260.9,522.6,0.5,0.5);

	this.shape_367 = new cjs.Shape();
	this.shape_367.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_367.setTransform(1252.9,522.2,0.5,0.5);

	this.shape_368 = new cjs.Shape();
	this.shape_368.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_368.setTransform(1238.4,525.1,0.5,0.5);

	this.shape_369 = new cjs.Shape();
	this.shape_369.graphics.f("#000000").s().p("ACdCKIAAixQAAgmgPgTQgQgTggABQgpAAgUAWQgUAYAAAwIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgTAaAAA1IAACVIgZAAIAAkNIAUAAIAGAkIABAAQAMgTAUgMQAUgLAZAAQBBAAARAwIABAAQAMgXAXgMQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_369.setTransform(1220.9,525,0.5,0.5);

	this.shape_370 = new cjs.Shape();
	this.shape_370.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhgkQAfgmA4ABQA4AAAfAlQAgAmAABAQAABDggAkQggAlg4AAQgiAAgdgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_370.setTransform(1195.5,525.1,0.5,0.5);

	this.shape_371 = new cjs.Shape();
	this.shape_371.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_371.setTransform(1183.6,523.6,0.5,0.5);

	this.shape_372 = new cjs.Shape();
	this.shape_372.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgNQAHgLAMgcIAMgkIhnkNIAZAAIA6CXQAdBPAEAOIAAAAQAOgqAUg0IA6iWIAZAAIh4E5QgPAngKAMQgLAPgMAGQgPAHgSAAQgNAAgSgGg");
	this.shape_372.setTransform(1167,528.2,0.5,0.5);

	this.shape_373 = new cjs.Shape();
	this.shape_373.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_373.setTransform(1156.7,523.6,0.5,0.5);

	this.shape_374 = new cjs.Shape();
	this.shape_374.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAbAhABA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAYAAARgDQAUgEAYgKIAAAWQgWALgUADQgWADgVAAQg6AAghgkgAg3hcQgXAbgEAvICnAAQgBgugUgbQgVgbgkAAQgmABgYAZg");
	this.shape_374.setTransform(1145.6,525.1,0.5,0.5);

	this.shape_375 = new cjs.Shape();
	this.shape_375.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_375.setTransform(1134.5,525,0.5,0.5);

	this.shape_376 = new cjs.Shape();
	this.shape_376.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_376.setTransform(1125.8,522.6,0.5,0.5);

	this.shape_377 = new cjs.Shape();
	this.shape_377.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_377.setTransform(1118.5,523.6,0.5,0.5);

	this.shape_378 = new cjs.Shape();
	this.shape_378.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgXAZQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAkIABAAQAagqBEAAQBbAAABBjIAACwg");
	this.shape_378.setTransform(1107,525,0.5,0.5);

	this.shape_379 = new cjs.Shape();
	this.shape_379.graphics.f("#000000").s().p("AhNBoQghgkAAhCQABg/AggoQAggnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA3AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgYALgTADQgWADgVAAQg6AAghgkgAg3hcQgXAbgEAvICmAAQABgugVgbQgUgbglAAQglABgZAZg");
	this.shape_379.setTransform(1092.4,525.1,0.5,0.5);

	this.shape_380 = new cjs.Shape();
	this.shape_380.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_380.setTransform(1074.7,525,0.5,0.5);

	this.shape_381 = new cjs.Shape();
	this.shape_381.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_381.setTransform(1065.9,522.6,0.5,0.5);

	this.shape_382 = new cjs.Shape();
	this.shape_382.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AYAdQAaAeAuAAQAXAAASgDQAUgFAYgJIAAAWQgWALgUADQgWADgVAAQg5AAgigkgAg2hcQgZAbgDAvICmAAQAAgugUgbQgVgbgjAAQgmABgYAZg");
	this.shape_382.setTransform(1056.1,525.1,0.5,0.5);

	this.shape_383 = new cjs.Shape();
	this.shape_383.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAWgLAiAAQBcAAABBiIAACxg");
	this.shape_383.setTransform(1041.6,522.2,0.5,0.5);

	this.shape_384 = new cjs.Shape();
	this.shape_384.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_384.setTransform(1029.6,523.6,0.5,0.5);

	this.shape_385 = new cjs.Shape();
	this.shape_385.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAkIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_385.setTransform(1011.4,525,0.5,0.5);

	this.shape_386 = new cjs.Shape();
	this.shape_386.graphics.f("#000000").s().p("AgLC5IAAkNIAXAAIAAENgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_386.setTransform(1000.9,522.6,0.5,0.5);

	this.shape_387 = new cjs.Shape();
	this.shape_387.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgPgNgngOQgqgPgOgKQgRgKgIgNQgJgOAAgTQAAgeAagSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUAKAAAVQAAAUAPANQAPANArAQQAmANAQAJQARALAIANQAIAPAAARQAAAlgcATQgbAUgygBQg2AAgggQg");
	this.shape_387.setTransform(985.4,525.1,0.5,0.5);

	this.shape_388 = new cjs.Shape();
	this.shape_388.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_388.setTransform(975.1,523.6,0.5,0.5);

	this.shape_389 = new cjs.Shape();
	this.shape_389.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_389.setTransform(966.9,525,0.5,0.5);

	this.shape_390 = new cjs.Shape();
	this.shape_390.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_390.setTransform(953.9,525.1,0.5,0.5);

	this.shape_391 = new cjs.Shape();
	this.shape_391.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AaAcQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgYALgTADQgWADgUAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgvgUgaQgVgbgkAAQgmABgXAZg");
	this.shape_391.setTransform(940.6,525.1,0.5,0.5);

	this.shape_392 = new cjs.Shape();
	this.shape_392.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_392.setTransform(926.1,522.2,0.5,0.5);

	this.shape_393 = new cjs.Shape();
	this.shape_393.graphics.f("#000000").s().p("AiCCiQgegbAAgtQAAgjATgXQASgYAygbIgTgUQgQgRgIgRQgIgRAAgTQAAgjAYgVQAXgWAoAAQAmABAXAUQAWAUAAAkQAAAZgRAWQgRAWgtAbIBvBxQARgUAJgTQAMgYAHgbIAYAAQgQA+gkAsIBCBDIgiAAIgwgwQgYAXgRAJQgSALgUAFQgWAFgaAAQg0AAgegZgAhpAbQgOAMgIAPQgHAPAAAUQAAAkAXAUQAXAUAqAAQAgAAAZgLQAagKAagbIh3h3QgjASgOALgAhRiWQgRAPAAAaQAAATAKARQALARAbAbQApgXANgSQAQgRAAgYQAAgXgQgQQgOgOgbAAQgbAAgRAOg");
	this.shape_393.setTransform(903.3,522.8,0.5,0.5);

	this.shape_394 = new cjs.Shape();
	this.shape_394.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2AAgggQg");
	this.shape_394.setTransform(881.1,525.1,0.5,0.5);

	this.shape_395 = new cjs.Shape();
	this.shape_395.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQAUgEAYgKIAAAWQgWALgUADQgWADgUAAQg7AAghgkgAg2hcQgYAbgEAvICmAAQAAgvgUgaQgVgbgjAAQgmABgYAZg");
	this.shape_395.setTransform(868.2,525.1,0.5,0.5);

	this.shape_396 = new cjs.Shape();
	this.shape_396.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAOAjAHAaIABAAQALgkAKgaIBGi2IAZAAIhoENg");
	this.shape_396.setTransform(855.4,525.1,0.5,0.5);

	this.shape_397 = new cjs.Shape();
	this.shape_397.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_397.setTransform(846.7,522.6,0.5,0.5);

	this.shape_398 = new cjs.Shape();
	this.shape_398.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_398.setTransform(840.9,522.2,0.5,0.5);

	this.shape_399 = new cjs.Shape();
	this.shape_399.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_399.setTransform(827.3,525,0.5,0.5);

	this.shape_400 = new cjs.Shape();
	this.shape_400.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_400.setTransform(818.6,522.6,0.5,0.5);

	this.shape_401 = new cjs.Shape();
	this.shape_401.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AfgoQAhgnA1ABQAvgBAcAiQAbAgAAA6IAAAUIjCAAQABA3AZAdQAaAeAuAAQAYAAASgDQATgEAZgKIAAAWQgYALgTADQgWADgVAAQg5AAgigkgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgbgjAAQgnABgXAZg");
	this.shape_401.setTransform(808.7,525.1,0.5,0.5);

	this.shape_402 = new cjs.Shape();
	this.shape_402.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgvAAgYAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_402.setTransform(794.2,522.2,0.5,0.5);

	this.shape_403 = new cjs.Shape();
	this.shape_403.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAOAYAAQAWAAATgEIAAAUQgSAHgYgBQgjAAgQgSg");
	this.shape_403.setTransform(782.2,523.6,0.5,0.5);

	this.shape_404 = new cjs.Shape();
	this.shape_404.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_404.setTransform(763.5,522.3,0.5,0.5);

	this.shape_405 = new cjs.Shape();
	this.shape_405.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA1ABQAxgBAbAiQAbAgAAA6IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgYALgSADQgXADgUAAQg7AAgggkgAg3hcQgYAbgDAvICnAAQgBgugUgbQgVgbgkAAQgmABgYAZg");
	this.shape_405.setTransform(749.3,525.1,0.5,0.5);

	this.shape_406 = new cjs.Shape();
	this.shape_406.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfAKAPQAMAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_406.setTransform(737.9,523.6,0.5,0.5);

	this.shape_407 = new cjs.Shape();
	this.shape_407.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_407.setTransform(726.6,525.1,0.5,0.5);

	this.shape_408 = new cjs.Shape();
	this.shape_408.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAkAAAfAMIgGAWQgkgMgZAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAkAAAggNIAAAXQgbANgpgBQg4AAgigkg");
	this.shape_408.setTransform(714.5,525.1,0.5,0.5);

	this.shape_409 = new cjs.Shape();
	this.shape_409.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_409.setTransform(705.3,522.6,0.5,0.5);

	this.shape_410 = new cjs.Shape();
	this.shape_410.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgcAAg8IAAgFQAAg9gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_410.setTransform(694.4,522.3,0.5,0.5);

	this.shape_411 = new cjs.Shape();
	this.shape_411.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAbAhABA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAYAAARgDQAUgEAZgKIAAAWQgXALgUADQgWADgVAAQg5AAgigkgAg2hcQgZAbgDAvICmAAQAAgvgUgaQgVgbgkAAQgmABgXAZg");
	this.shape_411.setTransform(680.2,525.1,0.5,0.5);

	this.shape_412 = new cjs.Shape();
	this.shape_412.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_412.setTransform(665.2,522.3,0.5,0.5);

	this.shape_413 = new cjs.Shape();
	this.shape_413.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AZAdQAZAeAvAAQAWAAASgDQAUgFAYgJIAAAWQgWALgTADQgXADgUAAQg7AAgggkgAg3hcQgXAbgEAvICmAAQAAgugUgbQgVgbgjAAQgmABgZAZg");
	this.shape_413.setTransform(644.4,525.1,0.5,0.5);

	this.shape_414 = new cjs.Shape();
	this.shape_414.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAaIABAAQALgkAJgaIBHi2IAZAAIhpENg");
	this.shape_414.setTransform(631.6,525.1,0.5,0.5);

	this.shape_415 = new cjs.Shape();
	this.shape_415.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_415.setTransform(618.5,525.1,0.5,0.5);

	this.shape_416 = new cjs.Shape();
	this.shape_416.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_416.setTransform(604.7,522.2,0.5,0.5);

	this.shape_417 = new cjs.Shape();
	this.shape_417.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhgkQAfgmA4ABQA4AAAfAlQAgAmAABAQAABDggAkQggAlg4AAQgiAAgdgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_417.setTransform(583,525.1,0.5,0.5);

	this.shape_418 = new cjs.Shape();
	this.shape_418.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_418.setTransform(568.1,522.2,0.5,0.5);

	this.shape_419 = new cjs.Shape();
	this.shape_419.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIACAAQAOg7AHgSIA4ikIAVAAIA1CjQARA2AFAYIACAAQABgMAShLIAqiaIAZAAIhKENg");
	this.shape_419.setTransform(551.3,525.1,0.5,0.5);

	this.shape_420 = new cjs.Shape();
	this.shape_420.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAUgNABgXQgBgUgQgOQgQgNgmgOQgrgPgOgKQgPgJgJgOQgIgOAAgTQgBgeAagSQAagRAsAAQAtAAAnAQIgJAWQgogQgjAAQggAAgTALQgTAKAAAVQAAAUAOANQAQANArAQQAjANASAJQAQAKAIAOQAJAPAAARQAAAlgcATQgbAUgygBQg3AAgfgQg");
	this.shape_420.setTransform(529.5,525.1,0.5,0.5);

	this.shape_421 = new cjs.Shape();
	this.shape_421.graphics.f("#000000").s().p("AgdA+QAHgVAJgnQAHgjAFgcIAcAAIADAFQgTBAgXA2g");
	this.shape_421.setTransform(521.7,516.8,0.5,0.5);

	this.shape_422 = new cjs.Shape();
	this.shape_422.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAOAXAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgRgSg");
	this.shape_422.setTransform(515.5,523.6,0.5,0.5);

	this.shape_423 = new cjs.Shape();
	this.shape_423.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgKgJgNQgJgOABgTQAAgeAZgSQAagRAsAAQAtAAAnAQIgJAWQgogQgjAAQggAAgTALQgTAKgBAVQAAAUAPANQAPANAsAQQAjANASAJQARALAIANQAIAOAAASQAAAlgcATQgbAUgygBQg2AAgggQg");
	this.shape_423.setTransform(505.3,525.1,0.5,0.5);

	this.shape_424 = new cjs.Shape();
	this.shape_424.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_424.setTransform(496.6,522.6,0.5,0.5);

	this.shape_425 = new cjs.Shape();
	this.shape_425.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAOAYAAQAWAAATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_425.setTransform(489.3,523.6,0.5,0.5);

	this.shape_426 = new cjs.Shape();
	this.shape_426.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_426.setTransform(481.1,525,0.5,0.5);

	this.shape_427 = new cjs.Shape();
	this.shape_427.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgag");
	this.shape_427.setTransform(468,525.1,0.5,0.5);

	this.shape_428 = new cjs.Shape();
	this.shape_428.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAggkQAhgmA3ABQA3AAAgAlQAgAmAABAQAABDggAkQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_428.setTransform(447.6,525.1,0.5,0.5);

	this.shape_429 = new cjs.Shape();
	this.shape_429.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkNIAaAAIAsCbQARBAADAWIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATA+ADAQIACAAQACgTARhEIAqiaIAYAAIhJENg");
	this.shape_429.setTransform(431,525.1,0.5,0.5);

	this.shape_430 = new cjs.Shape();
	this.shape_430.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_430.setTransform(415.1,522.8,0.5,0.5);

	this.shape_431 = new cjs.Shape();
	this.shape_431.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAZgUgBQgTABAAgZg");
	this.shape_431.setTransform(1480.6,492.7,0.5,0.5);

	this.shape_432 = new cjs.Shape();
	this.shape_432.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_432.setTransform(1474.7,483.9,0.5,0.5);

	this.shape_433 = new cjs.Shape();
	this.shape_433.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAggnQAggnA1ABQAxgBAbAiQAcAgAAA7IAAATIjCAAQABA3AZAdQAZAeAuAAQAYAAARgDQAUgEAZgKIAAAWQgYALgSADQgXADgVAAQg6AAgggkgAg3hcQgYAbgDAvICnAAQgBgugUgbQgVgbgkAAQgmABgYAZg");
	this.shape_433.setTransform(1464.8,486.9,0.5,0.5);

	this.shape_434 = new cjs.Shape();
	this.shape_434.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAWgLAjAAQBcAAAABiIAACxg");
	this.shape_434.setTransform(1450.4,483.9,0.5,0.5);

	this.shape_435 = new cjs.Shape();
	this.shape_435.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkgBAfAMIgGAXQgkgMgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg4AAghgkg");
	this.shape_435.setTransform(1437,486.9,0.5,0.5);

	this.shape_436 = new cjs.Shape();
	this.shape_436.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAIAAAEAHQAEAFAAAMQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_436.setTransform(1427.8,484.4,0.5,0.5);

	this.shape_437 = new cjs.Shape();
	this.shape_437.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADgfIgCAAIiIFOIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_437.setTransform(1413.9,484.5,0.5,0.5);

	this.shape_438 = new cjs.Shape();
	this.shape_438.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgNQAIgMAKgbIANgkIhnkNIAaAAIA4CXQAZBBAJAcIABAAQAIgcAahCIA4iWIAaAAIh4E5QgPAngKANQgJANgOAHQgPAHgRAAQgOAAgSgGg");
	this.shape_438.setTransform(1390.4,489.9,0.5,0.5);

	this.shape_439 = new cjs.Shape();
	this.shape_439.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAjgBAgAMIgGAXQgkgMgZAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg4AAgigkg");
	this.shape_439.setTransform(1378.8,486.9,0.5,0.5);

	this.shape_440 = new cjs.Shape();
	this.shape_440.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_440.setTransform(1365,486.7,0.5,0.5);

	this.shape_441 = new cjs.Shape();
	this.shape_441.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_441.setTransform(1350.2,486.9,0.5,0.5);

	this.shape_442 = new cjs.Shape();
	this.shape_442.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA5AAAeIAADrIgYAAIAAlrIAZAAIDWFBIACAAQgCgoAAgsIAAjtIAYAAIAAFrg");
	this.shape_442.setTransform(1334.7,484.5,0.5,0.5);

	this.shape_443 = new cjs.Shape();
	this.shape_443.graphics.f("#000000").s().p("AiCCiQgegaAAguQAAgjASgXQATgZAygaIgTgUQgQgRgIgRQgIgRAAgTQAAgkAYgUQAXgWAoAAQAmABAXAUQAWAVAAAjQAAAZgRAWQgRAWgtAbIBvBxQAPgSALgVQAMgYAHgbIAYAAQgQA+gkAsIBCBDIgiAAIgwgxQgYAYgRAJQgSALgUAFQgXAFgZAAQg0ABgegagAhpAbQgQANgGAOQgHAPAAAUQAAAkAXAUQAXAUApAAQAhAAAZgLQAagKAagbIh3h3QgjASgOALgAhRiWQgRAPAAAaQAAATAKARQALARAbAbQAogWAOgTQAQgRAAgYQAAgXgQgQQgPgOgaAAQgbAAgRAOg");
	this.shape_443.setTransform(1310.3,484.5,0.5,0.5);

	this.shape_444 = new cjs.Shape();
	this.shape_444.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2ABgggRg");
	this.shape_444.setTransform(1288,486.9,0.5,0.5);

	this.shape_445 = new cjs.Shape();
	this.shape_445.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_445.setTransform(1274.7,486.7,0.5,0.5);

	this.shape_446 = new cjs.Shape();
	this.shape_446.graphics.f("#000000").s().p("AgLC5IAAkNIAXAAIAAENgAgPigQAAgYAPAAQAIAAADAHQAFAFAAAMQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_446.setTransform(1264.3,484.4,0.5,0.5);

	this.shape_447 = new cjs.Shape();
	this.shape_447.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_447.setTransform(1256.3,483.9,0.5,0.5);

	this.shape_448 = new cjs.Shape();
	this.shape_448.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAiuIgpAAIAAgPIApgKIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWgBATgEIAAAUQgSAHgXgBQgjAAgRgSg");
	this.shape_448.setTransform(1244.6,485.4,0.5,0.5);

	this.shape_449 = new cjs.Shape();
	this.shape_449.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagZAAgsIAAgZg");
	this.shape_449.setTransform(1233.3,486.9,0.5,0.5);

	this.shape_450 = new cjs.Shape();
	this.shape_450.graphics.f("#000000").s().p("ABdC2IhelRQgEAbgHAXIhQEfIgWAAIhklrIAbAAIBVFCQAGggAUhGIA+jcIAbAAIBJD9QALAoAHAeIAIgmIBNkdIAaAAIhlFrg");
	this.shape_450.setTransform(1215.6,484.5,0.5,0.5);

	this.shape_451 = new cjs.Shape();
	this.shape_451.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_451.setTransform(1190.4,486.9,0.5,0.5);

	this.shape_452 = new cjs.Shape();
	this.shape_452.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_452.setTransform(1180,486.7,0.5,0.5);

	this.shape_453 = new cjs.Shape();
	this.shape_453.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg4AAgdgjgAhBgeQgXAeABA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gWgcQgVgbguAAQgsAAgWAfg");
	this.shape_453.setTransform(1166.2,484.1,0.5,0.5);

	this.shape_454 = new cjs.Shape();
	this.shape_454.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_454.setTransform(1151.6,486.7,0.5,0.5);

	this.shape_455 = new cjs.Shape();
	this.shape_455.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_455.setTransform(1136.8,486.9,0.5,0.5);

	this.shape_456 = new cjs.Shape();
	this.shape_456.graphics.f("#000000").s().p("ABVCHIhVh5IhVB5IgbAAIBiiKIhfiDIAdAAIBQByIBPhyIAbAAIhcCDIBjCKg");
	this.shape_456.setTransform(1124.1,486.9,0.5,0.5);

	this.shape_457 = new cjs.Shape();
	this.shape_457.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgWAKgVAEQgWADgUAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgvgUgaQgVgbgkAAQgmABgXAZg");
	this.shape_457.setTransform(1110.8,486.9,0.5,0.5);

	this.shape_458 = new cjs.Shape();
	this.shape_458.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_458.setTransform(1100.9,483.9,0.5,0.5);

	this.shape_459 = new cjs.Shape();
	this.shape_459.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAPAAICQFtgAgNhiIgzCBICBAAIgyiCQgIgUgGgXQgGAYgIAUg");
	this.shape_459.setTransform(1090.4,484.5,0.5,0.5);

	this.shape_460 = new cjs.Shape();
	this.shape_460.graphics.f("#000000").s().p("AgSCYQgQgUgBgpIAAiuIgnAAIAAgPIAngKIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWgBASgEIAAAUQgQAHgYgBQgjAAgSgSg");
	this.shape_460.setTransform(1071.6,485.4,0.5,0.5);

	this.shape_461 = new cjs.Shape();
	this.shape_461.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkAAQgvgBgXAZQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBbAAAABjIAACwg");
	this.shape_461.setTransform(1060.1,486.7,0.5,0.5);

	this.shape_462 = new cjs.Shape();
	this.shape_462.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA6IAAATIjDAAQAAA3AaAdQAaAeAuAAQAYAAARgDQATgEAZgKIAAAWQgWALgUADQgWADgVAAQg6AAghgkgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgbgkAAQgmABgYAZg");
	this.shape_462.setTransform(1045.5,486.9,0.5,0.5);

	this.shape_463 = new cjs.Shape();
	this.shape_463.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2ABgggRg");
	this.shape_463.setTransform(1032.5,486.9,0.5,0.5);

	this.shape_464 = new cjs.Shape();
	this.shape_464.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAbAhABA6IAAATIjDAAQAAA3AaAdQAaAeAuAAQAYAAARgDQAUgEAYgKIAAAWQgWALgTADQgXADgVAAQg6AAgggkgAg3hcQgXAbgEAvICnAAQAAgugVgbQgVgbgkAAQgmABgYAZg");
	this.shape_464.setTransform(1019.6,486.9,0.5,0.5);

	this.shape_465 = new cjs.Shape();
	this.shape_465.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_465.setTransform(1008.5,486.7,0.5,0.5);

	this.shape_466 = new cjs.Shape();
	this.shape_466.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABBgeAmQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAaAAA7IAAAIQAAA/AWAbQAVAbAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_466.setTransform(995.5,489.8,0.5,0.5);

	this.shape_467 = new cjs.Shape();
	this.shape_467.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgnA1ABQAwgBAcAiQAbAhABA6IAAATIjDAAQABA3AZAdQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgYALgSADQgXADgVAAQg6AAghgkgAg3hcQgXAbgEAvICmAAQABgugVgbQgUgbglAAQglABgZAZg");
	this.shape_467.setTransform(980.5,486.9,0.5,0.5);

	this.shape_468 = new cjs.Shape();
	this.shape_468.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIACAwIACAAQARgdATgNQASgMAbAAQASAAASAEIgEAXQgSgEgRAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_468.setTransform(969.5,486.7,0.5,0.5);

	this.shape_469 = new cjs.Shape();
	this.shape_469.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgGAIgNQAJgPAJgYIAOgkIhokNIAZAAIA5CXQAbBFAGAYIABAAQALggAXg+IA5iWIAaAAIh4E5QgOAkgLAQQgKANgNAHQgPAHgRAAQgOAAgSgGg");
	this.shape_469.setTransform(951.1,489.9,0.5,0.5);

	this.shape_470 = new cjs.Shape();
	this.shape_470.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_470.setTransform(942.4,483.9,0.5,0.5);

	this.shape_471 = new cjs.Shape();
	this.shape_471.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjCAAQABA4AaAcQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgYALgTADQgWADgUAAQg6AAghgkgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgbgkAAQgmABgXAZg");
	this.shape_471.setTransform(932.5,486.9,0.5,0.5);

	this.shape_472 = new cjs.Shape();
	this.shape_472.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAjAGAaIABAAQAKgjALgbIBGi2IAZAAIhpENg");
	this.shape_472.setTransform(919.7,486.9,0.5,0.5);

	this.shape_473 = new cjs.Shape();
	this.shape_473.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_473.setTransform(910.9,484.4,0.5,0.5);

	this.shape_474 = new cjs.Shape();
	this.shape_474.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgqgPgOgKQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAlANAQAJQARALAIANQAIAPAAARQAAAkgbAUQgcAUgygBQg2ABgggRg");
	this.shape_474.setTransform(902,486.9,0.5,0.5);

	this.shape_475 = new cjs.Shape();
	this.shape_475.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACuQAAApASATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgZArhDAAQhdAAAAhjg");
	this.shape_475.setTransform(888.6,487,0.5,0.5);

	this.shape_476 = new cjs.Shape();
	this.shape_476.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_476.setTransform(878.2,483.9,0.5,0.5);

	this.shape_477 = new cjs.Shape();
	this.shape_477.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkgBAfAMIgGAXQgkgMgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAXQgaAMgqAAQg4AAghgkg");
	this.shape_477.setTransform(869.6,486.9,0.5,0.5);

	this.shape_478 = new cjs.Shape();
	this.shape_478.graphics.f("#000000").s().p("ABVCHIhVh5IhVB5IgbAAIBiiKIheiDIAcAAIBQByIBQhyIAbAAIhdCDIBjCKg");
	this.shape_478.setTransform(856.9,486.9,0.5,0.5);

	this.shape_479 = new cjs.Shape();
	this.shape_479.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA6IAAATIjCAAQABA3AZAdQAaAeAuAAQAYAAASgDQATgFAZgJIAAAWQgXALgUADQgWADgVAAQg5AAgigkgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgbgjAAQgnABgXAZg");
	this.shape_479.setTransform(843.6,486.9,0.5,0.5);

	this.shape_480 = new cjs.Shape();
	this.shape_480.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_480.setTransform(822.5,486.9,0.5,0.5);

	this.shape_481 = new cjs.Shape();
	this.shape_481.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgPIAogKIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWgBATgEIAAAUQgSAHgYgBQgiAAgSgSg");
	this.shape_481.setTransform(810.5,485.4,0.5,0.5);

	this.shape_482 = new cjs.Shape();
	this.shape_482.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgFQAAg9gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_482.setTransform(791.8,484.1,0.5,0.5);

	this.shape_483 = new cjs.Shape();
	this.shape_483.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAAAhjg");
	this.shape_483.setTransform(777.1,487,0.5,0.5);

	this.shape_484 = new cjs.Shape();
	this.shape_484.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPghAAgpQAAhBAgglQAhgmA2ABQA4AAAgAlQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAsAAAagfQAYggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_484.setTransform(762.1,486.9,0.5,0.5);

	this.shape_485 = new cjs.Shape();
	this.shape_485.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_485.setTransform(750.6,486.7,0.5,0.5);

	this.shape_486 = new cjs.Shape();
	this.shape_486.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_486.setTransform(737.5,489.8,0.5,0.5);

	this.shape_487 = new cjs.Shape();
	this.shape_487.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgrgQgNgJQgRgKgIgNQgJgOAAgTQAAgeAagSQAagRAsAAQAsAAAnAQIgJAWQgngQgjAAQggAAgTALQgUAKAAAVQABAUAPANQAOANArAQQAkANASAJQARALAIANQAIAOAAASQAAAlgbATQgcAUgygBQg3ABgfgRg");
	this.shape_487.setTransform(716.9,486.9,0.5,0.5);

	this.shape_488 = new cjs.Shape();
	this.shape_488.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_488.setTransform(708.2,484.4,0.5,0.5);

	this.shape_489 = new cjs.Shape();
	this.shape_489.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAIgGAKgNQAGgMAMgbIANgkIhokNIAaAAIA5CXQAbBFAGAYIABAAIAiheIA5iWIAZAAIh4E5QgPAngKANQgKAOgNAGQgPAHgRAAQgNAAgTgGg");
	this.shape_489.setTransform(692.8,489.9,0.5,0.5);

	this.shape_490 = new cjs.Shape();
	this.shape_490.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_490.setTransform(682.9,486.7,0.5,0.5);

	this.shape_491 = new cjs.Shape();
	this.shape_491.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA1ABQAwgBAbAiQAcAhAAA6IAAATIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgUAEQgXADgUAAQg7AAgggkgAg2hcQgYAagEAwICmAAQAAgvgVgaQgUgbgkAAQgmABgXAZg");
	this.shape_491.setTransform(670.1,486.9,0.5,0.5);

	this.shape_492 = new cjs.Shape();
	this.shape_492.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_492.setTransform(660.2,483.9,0.5,0.5);

	this.shape_493 = new cjs.Shape();
	this.shape_493.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_493.setTransform(654.4,483.9,0.5,0.5);

	this.shape_494 = new cjs.Shape();
	this.shape_494.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_494.setTransform(644.3,486.9,0.5,0.5);

	this.shape_495 = new cjs.Shape();
	this.shape_495.graphics.f("#000000").s().p("AhlCLQgugwAAhaQAAg2AWgsQAYgrAqgXQAqgXA2gBQA7AAAwAXIgKAWQgwgVgyAAQhHAAgrAsQgqAtAABKQAABSAoAqQApApBMAAQAzAAAjgOIAAiAIhtAAIAAgXICGAAIAAClQg0AXhCgBQhVABgugxg");
	this.shape_495.setTransform(628.6,484.5,0.5,0.5);

	this.shape_496 = new cjs.Shape();
	this.shape_496.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_496.setTransform(605.7,486.9,0.5,0.5);

	this.shape_497 = new cjs.Shape();
	this.shape_497.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBbAAAABjIAACwg");
	this.shape_497.setTransform(592,486.7,0.5,0.5);

	this.shape_498 = new cjs.Shape();
	this.shape_498.graphics.f("#000000").s().p("AgMC5IAAkNIAYAAIAAENgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_498.setTransform(581.5,484.4,0.5,0.5);

	this.shape_499 = new cjs.Shape();
	this.shape_499.graphics.f("#000000").s().p("AgSCYQgQgUAAgpIAAiuIgpAAIAAgPIApgKIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWgBASgEIAAAUQgQAHgZgBQgiAAgSgSg");
	this.shape_499.setTransform(574.2,485.4,0.5,0.5);

	this.shape_500 = new cjs.Shape();
	this.shape_500.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgXAcgUAJQgVALgdAAQgnAAgWgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_500.setTransform(562.9,486.9,0.5,0.5);

	this.shape_501 = new cjs.Shape();
	this.shape_501.graphics.f("#000000").s().p("AhtC2IAAlrIBaAAQCBAAAABoQAAA1gkAbQglAchAAAIg4AAIAACXgAhTAKIAyAAQA8gBAcgSQAbgVAAguQAAgqgagUQgagUg1AAIg8AAg");
	this.shape_501.setTransform(549.7,484.5,0.5,0.5);

	this.shape_502 = new cjs.Shape();
	this.shape_502.graphics.f("#BAD0D0").s().p("AzpC4QhNhMAAhoQAAhqBOhMQBQhNBvAAQA+AAA3AZQA5AaAmAtIgtAqQgdglgrgWQgsgWgwAAQhXAAg8A7Qg8A6AABTQAABPA7A9QA8A/BTAAQA+AAA0gsQA2gsACg8IiHAAIAAg4IDPAAIAAATQAABohFBEQhGBFhsAAQhsAAhNhNgAmGEAIg8h8IjuAAIg7B8IhFAAID3oEID5IEgAncBLIhdjIIhcDIIC5AAgARND7IAAjYIiqkXIBLAAICADTIB/jTIBKAAIiqEXIAADYgANYD7IiZjSIgbAAIAADSIhBAAIAAnvIBOAAQAvAAAYADQAnAFAcAPQAfARATAhQASAgAAAkQAAA2giAnQgjAmg4AHICkDYgAKkgKIAUAAQA+AAAggPQAtgWgBg1QAAg0gugWQgigPg9AAIgRAAgAD9D7IAAnvIEWAAIAAA4IjWAAIAACLIDQAAIAAA4IjQAAIAAC7IDWAAIAAA5gAgMD7IAAnvIBAAAIAAG2ICdAAIAAA5gAkVD7IAAnvIBBAAIAAG2ICdAAIAAA5g");
	this.shape_502.setTransform(1104.3,670.5,0.5,0.5);

	this.shape_503 = new cjs.Shape();
	this.shape_503.graphics.f("#547C7D").s().p("A2+G3IAAttMAt9AAAIAANtgA2cGXMAs5AAAIAAstMgs5AAAg");
	this.shape_503.setTransform(1103.3,671.1,0.5,0.5);

	this.shape_504 = new cjs.Shape();
	this.shape_504.graphics.f("#FFFFFF").s().p("ACyEDIg7h9IjtAAIg8B9IhFAAID3oFID4IFgAhbBOIC3AAIhcjIg");
	this.shape_504.setTransform(1005.5,670.3,0.5,0.5);

	this.shape_505 = new cjs.Shape();
	this.shape_505.graphics.f("#FFFFFF").s().p("Aihh3IAAFwIhBAAIAAoGIGFGFIAAluIBAAAIAAIEg");
	this.shape_505.setTransform(979.8,670.6,0.5,0.5);

	this.shape_506 = new cjs.Shape();
	this.shape_506.graphics.f("#FFFFFF").s().p("AgfD4IAAnvIA/AAIAAHvg");
	this.shape_506.setTransform(962.3,670.6,0.5,0.5);

	this.shape_507 = new cjs.Shape();
	this.shape_507.graphics.f("#FFFFFF").s().p("AgfD4IAAm3Ih8AAIAAg4IE3AAIAAA4Ih8AAIAAG3g");
	this.shape_507.setTransform(950.5,670.6,0.5,0.5);

	this.shape_508 = new cjs.Shape();
	this.shape_508.graphics.f("#FFFFFF").s().p("ACyEDIg7h9IjtAAIg8B9IhFAAID3oFID4IFgAhbBOIC3AAIhcjIg");
	this.shape_508.setTransform(933.3,670.3,0.5,0.5);

	this.shape_509 = new cjs.Shape();
	this.shape_509.graphics.f("#FFFFFF").s().p("AiND4IAAnvIBLAAQBxAAAyAlQAtAiAABIQAABKg2AlQgvAhhQAAIglAAIAADQgAhMgPIAVAAQA8AAAggPQAsgWAAg1QAAg0gugUQghgPg9AAIgRAAg");
	this.shape_509.setTransform(916.4,670.6,0.5,0.5);

	this.shape_510 = new cjs.Shape();
	this.shape_510.graphics.f("#A2C0BE").s().p("AzgG1IAAtoMAnBAAAIAANog");
	this.shape_510.setTransform(963.4,671,0.5,0.5);

	this.shape_511 = new cjs.Shape();
	this.shape_511.graphics.f("#484A4E").s().p("Ag6A7QgagYAAgjQAAgiAagZQAYgYAiAAQAjAAAYAYQAaAZgBAiQABAjgaAYQgYAZgjAAQgiAAgYgZgAgzgzQgWAVAAAeQAAAfAWAVQAVAWAeAAQAfAAAVgWQAWgVAAgfQAAgegWgVQgVgWgfAAQgeAAgVAWgAAcAwIgbgrIgUAAIAAArIgLAAIAAhbIAoAAQAhAAgBAYQAAAXgdABIAcArgAgTgEIASAAQAQAAAFgBQAMgDAAgLQAAgOgZAAIgaAAg");
	this.shape_511.setTransform(1158.9,711.5,0.5,0.5);

	this.shape_512 = new cjs.Shape();
	this.shape_512.graphics.f("#484A4E").s().p("Ag1CAQgVgQgLgcIAQgHQAVAzAvAAQAbAAAVgUQAVgTAAgcQAAgUgUgQQgJgHgcgOIgygaQgdgSAAghQAAgfAUgTQAUgVAfAAQAWAAASALQATALAKASIgNALQgWgigjAAQgWAAgPAQQgPAQAAAWQAAATARAPQAJAHAYALIA2AbQAgAVAAAkQAAAigbAYQgaAXgjAAQgdAAgWgQg");
	this.shape_512.setTransform(1147.1,714.8,0.5,0.5);

	this.shape_513 = new cjs.Shape();
	this.shape_513.graphics.f("#484A4E").s().p("ABECNIiGiHIgHAIIAAB/IgSAAIAAkZIASAAIAACDICFiDIAXAAIiJCIICSCRg");
	this.shape_513.setTransform(1135.2,714.8,0.5,0.5);

	this.shape_514 = new cjs.Shape();
	this.shape_514.graphics.f("#484A4E").s().p("AAxCNIhbiGIgJAAIAACGIgSAAIAAkZIAjAAQAXAAALACQARADAMAJQAdAUAAApQAAAjgXAUQgWASgjgBIBcCGgAgzgJIAXAAQAiAAAOgMQAUgQAAgdQAAgRgHgNQgIgOgPgHQgJgEgOgBIgagBIgMAAg");
	this.shape_514.setTransform(1122.6,714.8,0.5,0.5);

	this.shape_515 = new cjs.Shape();
	this.shape_515.graphics.f("#484A4E").s().p("AhmBmQgrgrAAg7QAAg7ArgqQArgrA7AAQA8AAArArQArAqAAA7QAAA7grArQgsAqg7AAQg7AAgrgqgAhZhZQgmAmAAAzQAAA0AmAmQAlAlA0AAQA0AAAmgmQAmglAAg0QAAgzgmgmQgmgmg0AAQg0AAglAmg");
	this.shape_515.setTransform(1107.3,714.8,0.5,0.5);

	this.shape_516 = new cjs.Shape();
	this.shape_516.graphics.f("#484A4E").s().p("AAAhqIhrECIhekiIASAAIBQDxIBnj+IBqD+IBPjxIARAAIhfEig");
	this.shape_516.setTransform(1086.6,714.7,0.5,0.5);

	this.shape_517 = new cjs.Shape();
	this.shape_517.graphics.f("#484A4E").s().p("AhhBmQgrgrAAg6QAAg8ArgqQArgrA8AAQBKAAAwBCIgOAMQgTgdgcgQQgcgQgiAAQgyAAgnAmQgmAnAAAyQAAA1AmAlQAmAmAzAAQAsAAAngfQAhgcABgvIhkAAIAAgRIB2AAQABAdgGAVQgHAYgRAUQgUAVgdAMQgcAMgeAAQg6AAgrgqg");
	this.shape_517.setTransform(1058.1,714.8,0.5,0.5);

	this.shape_518 = new cjs.Shape();
	this.shape_518.graphics.f("#484A4E").s().p("AhshnIAADxIgSAAIAAkcIDrD4IAAj1IASAAIAAEig");
	this.shape_518.setTransform(1040.2,714.9,0.5,0.5);

	this.shape_519 = new cjs.Shape();
	this.shape_519.graphics.f("#484A4E").s().p("AgICNIAAkZIARAAIAAEZg");
	this.shape_519.setTransform(1028,714.8,0.5,0.5);

	this.shape_520 = new cjs.Shape();
	this.shape_520.graphics.f("#484A4E").s().p("AAxCNIhbiGIgJAAIAACGIgSAAIAAkZIAjAAQAWAAAMACQARADANAJQAcAVAAAoQAAAjgXAUQgVASgkgBIBcCGgAgzgJIAXAAQARAAAJgCQANgCAJgIQAUgRAAgcQAAgRgHgNQgIgOgPgHQgJgEgOgBIgagBIgMAAg");
	this.shape_520.setTransform(1019.6,714.8,0.5,0.5);

	this.shape_521 = new cjs.Shape();
	this.shape_521.graphics.f("#484A4E").s().p("AAxCNIhbiGIgJAAIAACGIgSAAIAAkZIAjAAQAWAAAMACQARADANAJQAcAUAAApQAAAjgXAUQgWASgjgBIBcCGgAgzgJIAXAAQARAAAJgCQANgCAJgIQAUgQAAgdQAAgRgHgNQgIgOgPgHQgJgEgOgBIgagBIgMAAg");
	this.shape_521.setTransform(1008.2,714.8,0.5,0.5);

	this.shape_522 = new cjs.Shape();
	this.shape_522.graphics.f("#484A4E").s().p("AgICNIAAkZIARAAIAAEZg");
	this.shape_522.setTransform(998.9,714.8,0.5,0.5);

	this.shape_523 = new cjs.Shape();
	this.shape_523.graphics.f("#484A4E").s().p("AgICNIAAkIIhJAAIAAgRICjAAIAAARIhJAAIAAEIg");
	this.shape_523.setTransform(990.4,714.8,0.5,0.5);

	this.shape_524 = new cjs.Shape();
	this.shape_524.graphics.f("#484A4E").s().p("Ag1CAQgVgQgLgcIAQgHQAVAzAvAAQAbAAAVgUQAVgTAAgcQAAgUgUgQQgJgHgcgOIgygaQgdgSAAghQAAgfAUgTQAUgVAfAAQAVAAATALQATALAKASIgNALQgWgigjAAQgWAAgPAQQgPAQAAAWQAAATARAPQAJAHAYALIA2AbQAgAVAAAkQAAAigbAYQgaAXgjAAQgdAAgWgQg");
	this.shape_524.setTransform(978.7,714.8,0.5,0.5);

	this.shape_525 = new cjs.Shape();
	this.shape_525.graphics.f("#484A4E").s().p("AgjAIIAAgQIBGAAIAAAQg");
	this.shape_525.setTransform(969.5,715.9,0.5,0.5);

	this.shape_526 = new cjs.Shape();
	this.shape_526.graphics.f("#484A4E").s().p("AgsCNIAAkZIASAAIAAEIIBHAAIAAARg");
	this.shape_526.setTransform(963.1,714.8,0.5,0.5);

	this.shape_527 = new cjs.Shape();
	this.shape_527.graphics.f("#484A4E").s().p("AgpCHQgVgJgOgQQgMgQgEgVQgDgMAAgcIAAivIASAAIAACqQAAAaACAMQADAUAKANQAKANASAHQASAHAQAAQARAAASgHQASgHAKgNQAKgNADgUQACgMAAgaIAAiqIASAAIAACvQAAAcgDAMQgDAVgNAQQgOAQgVAJQgUAIgWAAQgVAAgUgIg");
	this.shape_527.setTransform(950.8,714.9,0.5,0.5);

	this.shape_528 = new cjs.Shape();
	this.shape_528.graphics.f("#484A4E").s().p("AhmBmQgrgrAAg7QAAg7ArgqQArgrA7AAQA7AAAsArQArAqAAA7QAAA7grArQgsAqg7AAQg7AAgrgqgAhahZQgmAmAAAzQAAA0AmAmQAmAlA0AAQA1AAAlgmQAmglAAg0QAAgzgmgmQglgmg1AAQg0AAgmAmg");
	this.shape_528.setTransform(934.3,714.8,0.5,0.5);

	this.shape_529 = new cjs.Shape();
	this.shape_529.graphics.f("#484A4E").s().p("Ag1CAQgWgQgJgcIAPgHQAUAzAwAAQAbAAAUgUQAWgTAAgcQgBgUgTgQQgJgHgdgOIgxgaQgegSAAghQABgfAUgTQAUgVAfAAQAWAAASALQASALAKASIgMALQgWgigkAAQgVAAgPAQQgPAQgBAWQAAATARAPQAKAHAYALIA1AbQAgAVABAkQAAAigbAYQgaAXgjAAQgdAAgWgQg");
	this.shape_529.setTransform(918.9,714.8,0.5,0.5);

	this.shape_530 = new cjs.Shape();
	this.shape_530.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_530.setTransform(400.2,807.8,0.5,0.5);

	this.shape_531 = new cjs.Shape();
	this.shape_531.graphics.f("#000000").s().p("Ag8BSQgagdAAgzQAAgxAZgfQAagfApAAQAmAAAVAaQAWAbAAAsIAAAPIiYAAQABAsATAWQAUAXAlABQAUgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQgtAAgbgcgAgqhHQgSATgEAmICCAAQAAgkgQgVQgPgVgdAAQgdAAgTAVg");
	this.shape_531.setTransform(392.5,810.1,0.5,0.5);

	this.shape_532 = new cjs.Shape();
	this.shape_532.graphics.f("#000000").s().p("ABACYIAAiKQAAgfgNgPQgOgOgcAAQgkAAgTATQgRAUAAAqIAAB1IgUAAIAAkvIAUAAIgBB7IABAAQANgTARgIQATgIAZgBQBJAAAABNIAACLg");
	this.shape_532.setTransform(381.2,807.8,0.5,0.5);

	this.shape_533 = new cjs.Shape();
	this.shape_533.graphics.f("#000000").s().p("AgxBSQgbgdAAgzQAAg0AbgdQAbgeAtAAQAcAAAaAJIgGARQgbgIgVgBQgmAAgUAYQgUAZAAAsQAAAqAUAZQAUAYAkABQAbAAAagKIAAARQgTAKgiAAQgtAAgZgcg");
	this.shape_533.setTransform(370.7,810.1,0.5,0.5);

	this.shape_534 = new cjs.Shape();
	this.shape_534.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh9QAAgTALAAQAGAAADAEQAEAGgBAJQABAIgEAFQgDAGgGAAQgLgBAAgSg");
	this.shape_534.setTransform(363.5,808.2,0.5,0.5);

	this.shape_535 = new cjs.Shape();
	this.shape_535.graphics.f("#000000").s().p("ABwCPIAAjYQAAgUACgbIgBAAIhrEHIgMAAIhqkHIgCAAIACAxIAADWIgTAAIAAkdIAeAAIBlD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_535.setTransform(352.6,808.3,0.5,0.5);

	this.shape_536 = new cjs.Shape();
	this.shape_536.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAHgEAHgLQAGgLAIgUIAKgcIhRjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgNAhgHAIQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_536.setTransform(334.1,812.5,0.5,0.5);

	this.shape_537 = new cjs.Shape();
	this.shape_537.graphics.f("#000000").s().p("AgyBSQgZgdAAgzQAAg0AbgdQAageAuAAQAcAAAZAJIgGARQgbgIgUgBQgnAAgUAYQgUAYAAAtQAAArAUAYQAVAYAiABQAcAAAagKIAAARQgUAKgiAAQgsAAgagcg");
	this.shape_537.setTransform(325,810.1,0.5,0.5);

	this.shape_538 = new cjs.Shape();
	this.shape_538.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgcAAQglAAgTATQgRATAAAsIAAB0IgUAAIAAjTIARAAIADAdIACAAQAVghA0AAQBHAAABBNIAACKg");
	this.shape_538.setTransform(314.2,810,0.5,0.5);

	this.shape_539 = new cjs.Shape();
	this.shape_539.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgbAAQgdAAgfAQIgIgRQAkgQAgAAQAjAAASASQARATAAAmIAACMIgOAAIgGgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgUALAAAZQAAAUANALQAMALAWAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_539.setTransform(302.6,810.1,0.5,0.5);

	this.shape_540 = new cjs.Shape();
	this.shape_540.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_540.setTransform(290.4,808.3,0.5,0.5);

	this.shape_541 = new cjs.Shape();
	this.shape_541.graphics.f("#000000").s().p("AhaCWIAAgRQAMADANAAQAKAAAHgEQAIgFAGgKQAGgLAIgUIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_541.setTransform(273.4,812.5,0.5,0.5);

	this.shape_542 = new cjs.Shape();
	this.shape_542.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAsAAAXAcQAXAcAAA1QAAA1gYAcQgXAdgrAAQgXAAgSgJgAg1gaQgQAWAAAwIAAADQAAAwARAVQAQAVAkAAQAiAAASgZQARgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_542.setTransform(263.2,807.9,0.5,0.5);

	this.shape_543 = new cjs.Shape();
	this.shape_543.graphics.f("#000000").s().p("AgWAxQAGgXAFgYQAGgZAEgZIAWAAIACAEQgQA2gRAng");
	this.shape_543.setTransform(250.3,803.6,0.5,0.5);

	this.shape_544 = new cjs.Shape();
	this.shape_544.graphics.f("#000000").s().p("ABTCPIAAiNIimAAIAACNIgTAAIAAkdIATAAIAAB/ICmAAIAAh/IAUAAIAAEdg");
	this.shape_544.setTransform(241.7,808.3,0.5,0.5);

	this.shape_545 = new cjs.Shape();
	this.shape_545.graphics.f("#000000").s().p("AhGBsQgigngBhFQAAgrARghQAQghAfgTQAfgSAoAAQAqAAAhAQIgHASQghgQghAAQg0AAggAjQgfAiAAA7QABA9AdAiQAdAiA1AAQAlAAAcgKIAAASQgaAKgsAAQg7AAgjgng");
	this.shape_545.setTransform(228.6,808.3,0.5,0.5);

	this.shape_546 = new cjs.Shape();
	this.shape_546.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgjAog7AAQg7AAgigogAhNhdQgcAhAAA8QAAA8AbAjQAbAhAzAAQAzAAAcghQAbghAAg+QAAg9gbghQgcghgzAAQgyAAgbAig");
	this.shape_546.setTransform(214.4,808.3,0.5,0.5);

	this.shape_547 = new cjs.Shape();
	this.shape_547.graphics.f("#000000").s().p("AhcBrQgjgmAAhFQAAhEAjgnQAignA6AAQA9AAAhAnQAiAogBBDQAABFghAmQgiAog8AAQg7AAghgogAhNhdQgcAgAAA9QAAA9AcAiQAbAhAyAAQA0AAAaghQAcghAAg+QAAg9gcghQgaghg0AAQgyAAgbAig");
	this.shape_547.setTransform(199.1,808.3,0.5,0.5);

	this.shape_548 = new cjs.Shape();
	this.shape_548.graphics.f("#000000").s().p("ABHCPIhKh9IhGAAIAAB9IgUAAIAAkdIBEAAQA0AAAaAUQAZATgBAoQAAAdgOATQgPATgfAIIBNCDgAhJABIA3AAQAjAAAUgPQATgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_548.setTransform(186.3,808.3,0.5,0.5);

	this.shape_549 = new cjs.Shape();
	this.shape_549.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAZASAAAkQAAAZgPARQgQAQgcAFIAAABQAhAFARAQQAQARAAAdQAAAngaAVQgbAWgvAAgAhJB9IBDAAQBPAAAAhAQgBg7hSAAIg/AAgAhJgPIA/AAQAnAAASgNQATgOgBgcQABgdgVgNQgUgMgpAAIg5AAg");
	this.shape_549.setTransform(173.8,808.3,0.5,0.5);

	this.shape_550 = new cjs.Shape();
	this.shape_550.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_550.setTransform(156.8,808.3,0.5,0.5);

	this.shape_551 = new cjs.Shape();
	this.shape_551.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_551.setTransform(145.6,808.3,0.5,0.5);

	this.shape_552 = new cjs.Shape();
	this.shape_552.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_552.setTransform(137.8,808.3,0.5,0.5);

	this.shape_553 = new cjs.Shape();
	this.shape_553.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_553.setTransform(131,808.3,0.5,0.5);

	this.shape_554 = new cjs.Shape();
	this.shape_554.graphics.f("#000000").s().p("AhcBrQgjgnAAhEQAAhDAjgoQAignA6AAQA9AAAhAnQAiAogBBDQAABFghAmQgiAog8AAQg7AAghgogAhNhdQgcAhAAA8QAAA9AbAiQAbAhAzAAQAzAAAcghQAbghAAg+QAAg9gbghQgcghgzAAQgyAAgbAig");
	this.shape_554.setTransform(117.4,808.3,0.5,0.5);

	this.shape_555 = new cjs.Shape();
	this.shape_555.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_555.setTransform(104.5,808.3,0.5,0.5);

	this.shape_556 = new cjs.Shape();
	this.shape_556.graphics.f("#000000").s().p("AhXCHIAAgTQAfANAvAAQAiAAAVgRQAVgQAAgaQAAgQgHgLQgHgKgPgJQgSgKgbgJQgtgPgPgRQgRgRAAgdQAAggAZgUQAZgVAnAAQApAAAiAQIgHARQgkgPggAAQgeAAgTAPQgTAOAAAZQAAARAGAJQAGALANAIQANAIAfALQAiALAQALQARALAHANQAIAPAAASQAAAkgaAVQgbAVgqAAQg2AAgagMg");
	this.shape_556.setTransform(93.9,808.3,0.5,0.5);

	this.shape_557 = new cjs.Shape();
	this.shape_557.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgJhNIgpBlIBmAAIgziHQgEARgGARg");
	this.shape_557.setTransform(82.4,808.3,0.5,0.5);

	this.shape_558 = new cjs.Shape();
	this.shape_558.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_558.setTransform(73.9,808.3,0.5,0.5);

	this.shape_559 = new cjs.Shape();
	this.shape_559.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgVAAIAAkdIAVAAIAAB/IClAAIAAh/IAUAAIAAEdg");
	this.shape_559.setTransform(64.2,808.3,0.5,0.5);

	this.shape_560 = new cjs.Shape();
	this.shape_560.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA8AdAjQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_560.setTransform(51.1,808.3,0.5,0.5);

	this.shape_561 = new cjs.Shape();
	this.shape_561.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_561.setTransform(43.1,803.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_561},{t:this.shape_560},{t:this.shape_559},{t:this.shape_558},{t:this.shape_557},{t:this.shape_556},{t:this.shape_555},{t:this.shape_554},{t:this.shape_553},{t:this.shape_552},{t:this.shape_551},{t:this.shape_550},{t:this.shape_549},{t:this.shape_548},{t:this.shape_547},{t:this.shape_546},{t:this.shape_545},{t:this.shape_544},{t:this.shape_543},{t:this.shape_542},{t:this.shape_541},{t:this.shape_540},{t:this.shape_539},{t:this.shape_538},{t:this.shape_537},{t:this.shape_536},{t:this.shape_535},{t:this.shape_534},{t:this.shape_533},{t:this.shape_532},{t:this.shape_531},{t:this.shape_530},{t:this.shape_529},{t:this.shape_528},{t:this.shape_527},{t:this.shape_526},{t:this.shape_525},{t:this.shape_524},{t:this.shape_523},{t:this.shape_522},{t:this.shape_521},{t:this.shape_520},{t:this.shape_519},{t:this.shape_518},{t:this.shape_517},{t:this.shape_516},{t:this.shape_515},{t:this.shape_514},{t:this.shape_513},{t:this.shape_512},{t:this.shape_511},{t:this.shape_510},{t:this.shape_509},{t:this.shape_508},{t:this.shape_507},{t:this.shape_506},{t:this.shape_505},{t:this.shape_504},{t:this.shape_503},{t:this.shape_502},{t:this.shape_501},{t:this.shape_500},{t:this.shape_499},{t:this.shape_498},{t:this.shape_497},{t:this.shape_496},{t:this.shape_495},{t:this.shape_494},{t:this.shape_493},{t:this.shape_492},{t:this.shape_491},{t:this.shape_490},{t:this.shape_489},{t:this.shape_488},{t:this.shape_487},{t:this.shape_486},{t:this.shape_485},{t:this.shape_484},{t:this.shape_483},{t:this.shape_482},{t:this.shape_481},{t:this.shape_480},{t:this.shape_479},{t:this.shape_478},{t:this.shape_477},{t:this.shape_476},{t:this.shape_475},{t:this.shape_474},{t:this.shape_473},{t:this.shape_472},{t:this.shape_471},{t:this.shape_470},{t:this.shape_469},{t:this.shape_468},{t:this.shape_467},{t:this.shape_466},{t:this.shape_465},{t:this.shape_464},{t:this.shape_463},{t:this.shape_462},{t:this.shape_461},{t:this.shape_460},{t:this.shape_459},{t:this.shape_458},{t:this.shape_457},{t:this.shape_456},{t:this.shape_455},{t:this.shape_454},{t:this.shape_453},{t:this.shape_452},{t:this.shape_451},{t:this.shape_450},{t:this.shape_449},{t:this.shape_448},{t:this.shape_447},{t:this.shape_446},{t:this.shape_445},{t:this.shape_444},{t:this.shape_443},{t:this.shape_442},{t:this.shape_441},{t:this.shape_440},{t:this.shape_439},{t:this.shape_438},{t:this.shape_437},{t:this.shape_436},{t:this.shape_435},{t:this.shape_434},{t:this.shape_433},{t:this.shape_432},{t:this.shape_431},{t:this.shape_430},{t:this.shape_429},{t:this.shape_428},{t:this.shape_427},{t:this.shape_426},{t:this.shape_425},{t:this.shape_424},{t:this.shape_423},{t:this.shape_422},{t:this.shape_421},{t:this.shape_420},{t:this.shape_419},{t:this.shape_418},{t:this.shape_417},{t:this.shape_416},{t:this.shape_415},{t:this.shape_414},{t:this.shape_413},{t:this.shape_412},{t:this.shape_411},{t:this.shape_410},{t:this.shape_409},{t:this.shape_408},{t:this.shape_407},{t:this.shape_406},{t:this.shape_405},{t:this.shape_404},{t:this.shape_403},{t:this.shape_402},{t:this.shape_401},{t:this.shape_400},{t:this.shape_399},{t:this.shape_398},{t:this.shape_397},{t:this.shape_396},{t:this.shape_395},{t:this.shape_394},{t:this.shape_393},{t:this.shape_392},{t:this.shape_391},{t:this.shape_390},{t:this.shape_389},{t:this.shape_388},{t:this.shape_387},{t:this.shape_386},{t:this.shape_385},{t:this.shape_384},{t:this.shape_383},{t:this.shape_382},{t:this.shape_381},{t:this.shape_380},{t:this.shape_379},{t:this.shape_378},{t:this.shape_377},{t:this.shape_376},{t:this.shape_375},{t:this.shape_374},{t:this.shape_373},{t:this.shape_372},{t:this.shape_371},{t:this.shape_370},{t:this.shape_369},{t:this.shape_368},{t:this.shape_367},{t:this.shape_366},{t:this.shape_365},{t:this.shape_364},{t:this.shape_363},{t:this.shape_362},{t:this.shape_361},{t:this.shape_360},{t:this.shape_359},{t:this.shape_358},{t:this.shape_357},{t:this.shape_356},{t:this.shape_355},{t:this.shape_354},{t:this.shape_353},{t:this.shape_352},{t:this.shape_351},{t:this.shape_350},{t:this.shape_349},{t:this.shape_348},{t:this.shape_347},{t:this.shape_346},{t:this.shape_345},{t:this.shape_344},{t:this.shape_343},{t:this.shape_342},{t:this.shape_341},{t:this.shape_340},{t:this.shape_339},{t:this.shape_338},{t:this.shape_337},{t:this.shape_336},{t:this.shape_335},{t:this.shape_334},{t:this.shape_333},{t:this.shape_332},{t:this.shape_331},{t:this.shape_330},{t:this.shape_329},{t:this.shape_328},{t:this.shape_327},{t:this.shape_326},{t:this.shape_325},{t:this.shape_324},{t:this.shape_323},{t:this.instance_2}]},120).to({state:[]},1).wait(44));

	// ButtonLeftRight copy 58
	this.buttonR28 = new lib.ButtonLeft_Right();
	this.buttonR28.name = "buttonR28";
	this.buttonR28.parent = this;
	this.buttonR28.setTransform(2025.4,513.5,1,1,180);
	this.buttonR28._off = true;
	new cjs.ButtonHelper(this.buttonR28, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR28).wait(119).to({_off:false},0).to({_off:true},1).wait(45));

	// ButtonLeftRight copy 59
	this.buttonL28 = new lib.ButtonLeft_Right();
	this.buttonL28.name = "buttonL28";
	this.buttonL28.parent = this;
	this.buttonL28.setTransform(-0.1,437.2);
	this.buttonL28._off = true;
	new cjs.ButtonHelper(this.buttonL28, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL28).wait(119).to({_off:false},0).to({_off:true},1).wait(45));

	// Layer 1
	this.shape_562 = new cjs.Shape();
	this.shape_562.graphics.f("#000000").s().p("Ag4DuQgagJgTgSQgRgPgMgbQgLgbAAgdQAAgWAGgUQAHgUAMgRQANgSATgMQASgMAbgIIAAgBQgrgQgUggQgVgfAAgiQAAgbAKgUQAKgWAQgQQAQgOAXgJQAXgJAZAAQAaAAAYAJQAWAIAQAPQARAQAJAWQAKAUgBAbQAAAhgTAgQgUAggrAQIAAABQAaAJATAMQAUAOAMAQQANASAFATQAGATAAAWQAAAfgLAZQgLAZgTARQgSASgaAJQgaAKgfAAQgeAAgagKgAgwgBQgYAIgRAQQgSARgJAXQgKAXAAAbQAAAZAJAXQAKAWAQARQAQAQAYAKQAaAKAZAAQAcAAAYgKQAZgKAPgQQARgSAJgVQAJgXAAgZQAAgcgKgWQgKgXgRgRQgRgQgXgIQgXgKgbAAQgaAAgWAKgAgrjjQgTAIgPAOQgOANgJAUQgIAUgBAWQABAWAIATQAHASAPAQQAPAPAUAJQAVAJAWAAQAWAAAVgJQAVgJAOgPQAQgQAGgSQAJgTAAgWQAAgWgJgUQgJgVgOgMQgPgOgTgIQgUgHgXAAQgWAAgVAHg");
	this.shape_562.setTransform(1647.8,594.2,0.5,0.5);

	this.shape_563 = new cjs.Shape();
	this.shape_563.graphics.f("#000000").s().p("AAqDwIAAnNIhZBNIgJgMIBihTIAPAAIAAHfg");
	this.shape_563.setTransform(1625,594.2,0.5,0.5);

	this.shape_564 = new cjs.Shape();
	this.shape_564.graphics.f("#000000").s().p("AhKDhQgdgYgQgjQgRglgGgsQgGgrAAgqQAAgoAGgsQAGgsARgkQAQglAdgXQAdgXAtAAQAuAAAdAXQAeAYAPAkQARAkAGAsQAGAsAAAoQAAAqgGArQgGAsgRAlQgPAigeAZQgcAXgvAAQguAAgcgXgAg0jcQgVALgQAVQgOATgJAaQgJAZgFAaQgEAZgCAaIAABTQACAbAEAYQAFAaAJAZQAIAZAPAUQAOAUAXANQAWAMAeAAQAfAAAWgMQAXgNANgUQAQgUAIgZQAJgZAEgaQAFgYACgbIAAhTQgCgagFgZQgEgagJgZQgJgagPgTQgPgVgVgLQgWgNgfAAQgeAAgWANg");
	this.shape_564.setTransform(1605.9,594.2,0.5,0.5);

	this.shape_565 = new cjs.Shape();
	this.shape_565.graphics.f("#000000").s().p("AiGD0IAAgSICnjEQAmgsAWgjQAWgkAAglQAAgXgIgWQgIgUgOgOQgOgNgVgJQgUgHgYAAQglAAgfAVQgdAUgNApIgOgEQAMgsAjgYQAigXArAAQAcAAAXAJQAXAJAPAQQARARAJAUQAJAVAAAZQABAWgHATQgGAWgLASQgNAXgRATQgZAfgOAQIidC5ID9AAIAAAPg");
	this.shape_565.setTransform(1584.2,594,0.5,0.5);

	this.shape_566 = new cjs.Shape();
	this.shape_566.graphics.f("#000000").s().p("AgbBNIAmiZIARAAIgrCZg");
	this.shape_566.setTransform(1559.5,607,0.5,0.5);

	this.shape_567 = new cjs.Shape();
	this.shape_567.graphics.f("#000000").s().p("AiFD0IAAgSICljEQAmgrAXgkQAWgkABglQAAgXgJgWQgIgUgPgOQgOgOgVgIQgTgHgYAAQgmAAgeAVQgdAUgNApIgOgEQANgsAigYQAigXArAAQAcAAAWAJQAYAJAPAQQASARAIAUQAJAVAAAZQAAAYgFARQgHAUgLAUQgLATgTAXQgZAfgOAQIidC5ID+AAIAAAPg");
	this.shape_567.setTransform(1543.7,594,0.5,0.5);

	this.shape_568 = new cjs.Shape();
	this.shape_568.graphics.f("#000000").s().p("ACADwIiQjxIhxAAIAADxIgPAAIAAnfICFAAQAaAAAbAFQAcAFAUANQAWAOANAWQAOAXAAAlQAAAhgNAXQgNAWgUAOQgWAPgXAFQgZAGgXAAICRDygAiBgOIB2AAQBBAAAjgcQAjgbAAgzQAAgfgMgVQgOgVgTgMQgTgMgbgEQgdgFgXAAIhuAAg");
	this.shape_568.setTransform(1513,594.2,0.5,0.5);

	this.shape_569 = new cjs.Shape();
	this.shape_569.graphics.f("#000000").s().p("AiQDwIAAnfIEWAAIAAAOIkIAAIAADSID5AAIAAAOIj5AAIAADjIETAAIAAAOg");
	this.shape_569.setTransform(1491,594.2,0.5,0.5);

	this.shape_570 = new cjs.Shape();
	this.shape_570.graphics.f("#000000").s().p("AiWDwIAAnfICDAAQAdAAAYAGQAbAFAVANQAVANANAVQANAWAAAhQAAAZgJAUQgHASgPAOQgMAOgTAIQgPAIgVAFIAAABQARACAWAIQAVAHASAPQASAPAMAXQAMAYAAAfQAAAngPAYQgOAZgXAOQgXAOgbAGQgdAGgXAAgAiHDiIB+AAQAfAAAagGQAcgHASgNQAUgOALgVQALgWAAgdQAAgggNgYQgNgWgVgPQgTgOgZgHQgYgFgXAAIiFAAgAiHgTIB0AAQAXAAAYgGQAWgFAVgNQASgNANgUQAMgUAAgcQAAgcgMgVQgLgTgTgMQgTgLgZgFQgXgFgcAAIhwAAg");
	this.shape_570.setTransform(1468.6,594.2,0.5,0.5);

	this.shape_571 = new cjs.Shape();
	this.shape_571.graphics.f("#000000").s().p("ADcDwIAAnOIgDAAIjTHOIgMAAIjTnOIgCAAIAAHOIgPAAIAAnfIAaAAIDQHJIDQnJIAbAAIAAHfg");
	this.shape_571.setTransform(1440.1,594.2,0.5,0.5);

	this.shape_572 = new cjs.Shape();
	this.shape_572.graphics.f("#000000").s().p("AiQDwIAAnfIEXAAIAAAOIkIAAIAADSID4AAIAAAOIj4AAIAADjIESAAIAAAOg");
	this.shape_572.setTransform(1413.6,594.2,0.5,0.5);

	this.shape_573 = new cjs.Shape();
	this.shape_573.graphics.f("#000000").s().p("AgMDwIi0nfIAQAAICvHRIABAAICxnRIAQAAIi3Hfg");
	this.shape_573.setTransform(1390.4,594.2,0.5,0.5);

	this.shape_574 = new cjs.Shape();
	this.shape_574.graphics.f("#000000").s().p("AhhDqQgugSghgiQgggigTguQgTguAAg4QAAg3ATguQATgwAgggQAhghAtgTQAsgTA2AAQA2AAAtATQAtATAgAhQAgAgAUAwQATAugBA3QABA4gTAuQgSAugiAiQggAigtASQgvATg0AAQgzAAgugTgAhdjcQgqATgfAgQggAigPAqQgRArAAAyQAAAyAQAsQAQArAfAhQAfAgAqATQAqATA0AAQA1AAAqgTQArgTAeggQAeggARgsQARgrAAgzQAAgwgRgtQgQgrggghQgfgggrgTQgpgTg0AAQgzAAgqATg");
	this.shape_574.setTransform(1363.8,594.2,0.5,0.5);

	this.shape_575 = new cjs.Shape();
	this.shape_575.graphics.f("#000000").s().p("ACqDwIlYnMIgCAAIAAHMIgPAAIAAnfIAWAAIFXHLIACAAIAAnLIAQAAIAAHfg");
	this.shape_575.setTransform(1333.9,594.2,0.5,0.5);

	this.shape_576 = new cjs.Shape();
	this.shape_576.graphics.f("#000000").s().p("Ag8AHIAAgNIB5AAIAAANg");
	this.shape_576.setTransform(1303.1,597.6,0.5,0.5);

	this.shape_577 = new cjs.Shape();
	this.shape_577.graphics.f("#000000").s().p("AiFD0IAAgSICmjEQAogvAUggQAWgkAAglQAAgZgHgUQgJgUgPgOQgOgOgUgIQgUgHgXAAQgnAAgdAVQgeAUgNApIgOgEQAOgsAhgYQAigXAsAAQAbAAAXAJQAXAJAQAQQAQARAJAUQAJAVAAAZQAAAWgFATQgGAUgMAUQgNAVgQAVIjFDoID+AAIAAAPg");
	this.shape_577.setTransform(1275.5,594,0.5,0.5);

	this.shape_578 = new cjs.Shape();
	this.shape_578.graphics.f("#000000").s().p("AAqDwIAAnNIhaBNIgIgMIBihTIAPAAIAAHfg");
	this.shape_578.setTransform(1253.3,594.2,0.5,0.5);

	this.shape_579 = new cjs.Shape();
	this.shape_579.graphics.f("#000000").s().p("ACADwIiQjxIhxAAIAADxIgPAAIAAnfICFAAQAZAAAbAFQAdAFAUANQAWANANAXQAOAXgBAlQAAAigNAWQgMAWgUAOQgWAPgXAFQgZAGgXAAICRDygAiBgOIB1AAQBBAAAkgcQAjgbgBgzQAAgfgMgVQgLgUgVgNQgUgMgagEQgcgFgYAAIhuAAg");
	this.shape_579.setTransform(1223.8,594.2,0.5,0.5);

	this.shape_580 = new cjs.Shape();
	this.shape_580.graphics.f("#000000").s().p("AiQDwIAAnfIEXAAIAAAOIkIAAIAADSID4AAIAAAOIj4AAIAADjIESAAIAAAOg");
	this.shape_580.setTransform(1201.8,594.2,0.5,0.5);

	this.shape_581 = new cjs.Shape();
	this.shape_581.graphics.f("#000000").s().p("AiWDwIAAnfICDAAQAcAAAZAGQAbAFAVANQAUAMANAWQANAVAAAiQAAAbgIASQgHASgPAOQgNAOgSAIQgQAIgUAFIAAABQARACAWAIQAVAHASAPQASAPAMAXQAMAXAAAgQAAAmgPAZQgPAZgWAOQgWAOgcAGQgdAGgXAAgAiHDiIB9AAQAgAAAagGQAbgHATgNQAUgOALgVQALgVAAgeQAAgggNgYQgOgXgUgOQgUgOgZgHQgXgFgXAAIiFAAgAiHgTIBzAAQAYAAAYgGQAXgGAUgMQATgNAMgUQALgUAAgcQAAgdgLgUQgLgTgUgMQgSgLgZgFQgYgFgbAAIhwAAg");
	this.shape_581.setTransform(1179.4,594.2,0.5,0.5);

	this.shape_582 = new cjs.Shape();
	this.shape_582.graphics.f("#000000").s().p("AhhDqQgugSgggiQghgigTguQgSgugBg4QABg3ASguQATgwAhggQAgghAtgTQAtgTA1AAQA3AAArATQAtATAiAhQAgAgATAwQASAuABA3QgBA4gSAuQgTAuggAiQgiAigtASQguATg0AAQg0AAgtgTgAhcjcQgrATgfAgQggAigQAqQgRArAAAyQAAAyARAsQARAsAeAgQAeAgArATQAqATA0AAQA1AAAqgTQArgTAeggQAeggARgsQARgrAAgzQAAgwgRgtQgRgrgfghQgegggrgTQgrgTgzAAQgyAAgqATg");
	this.shape_582.setTransform(1151.5,594.2,0.5,0.5);

	this.shape_583 = new cjs.Shape();
	this.shape_583.graphics.f("#000000").s().p("AgHDwIAAnRIijAAIAAgOIFVAAIAAAOIikAAIAAHRg");
	this.shape_583.setTransform(1126.8,594.2,0.5,0.5);

	this.shape_584 = new cjs.Shape();
	this.shape_584.graphics.f("#000000").s().p("Ag+DqQgsgTghghQggghgSgvQgSgvAAg3QAAg2ASgvQATgwAfggQAgghAugTQAsgTA1AAQAtAAArAPQAqAPAeAfIgKALQgOgPgSgLQgVgMgRgHQgSgHgWgEQgUgDgUAAQgyAAgrATQgpASgfAhQgeAhgRArQgQAsAAAxQAAAyAQAsQAQAsAfAgQAdAgArATQApATA0AAQAuAAArgSQAsgRAcgiIALAKQgfAkguASQgvASgwAAQg0AAgugTg");
	this.shape_584.setTransform(1104.1,594.2,0.5,0.5);

	this.shape_585 = new cjs.Shape();
	this.shape_585.graphics.f("#000000").s().p("AhhDqQgugTggghQgigjgSgtQgTgvAAg3QAAg2ATgvQASguAigiQAgghAtgTQAtgTA1AAQA3AAAsATQAtATAhAhQAgAiATAuQATAwAAA1QAAA2gTAwQgSAtghAjQghAiguASQgtATg1AAQgzAAgugTgAhcjcQgrATgfAgQgeAggSAsQgRArAAAyQAAAyARAsQASAtAdAfQAeAgArATQAqATA0AAQA1AAAqgTQArgTAeggQAfghAQgrQARgsAAgyQAAgygRgrQgQgqgggiQggghgpgSQgqgTg0AAQgyAAgqATg");
	this.shape_585.setTransform(1074.5,594.2,0.5,0.5);

	this.shape_586 = new cjs.Shape();
	this.shape_586.graphics.f("#5F493F").s().p("AnjGJQiiigAAjfQAAh2A1hxQA0hxBehYQBnhfCBgqQCAgqC6AAIB3AEQBoAGAUAAQBPgBAggJIAVAAIAADyIghAAQgEgrgHgaQgHgbgPgVQgdgthTgYQhSgYh6gBQk6ABiECgQhtCFAAETQABEPCYCVQCaCWEWAAQBxAAAugWQAugVAAgzIAAilQgBhNgUgYQgWgYhFAAIhWAAIAAggICGAEQBPACA1AAQAzAABKgCIB8gEIAAAgIgvAAQhHAAgVAYQgWAYAABNIAAEOQhNALheAGQhbAGhPAAQmgAAjSjSg");
	this.shape_586.setTransform(1627.9,367,0.5,0.5);

	this.shape_587 = new cjs.Shape();
	this.shape_587.graphics.f("#5F493F").s().p("AHyJRIuLvqIAMNCQACA/AhAcQAgAcBHAAIBCAAIAAAhIiJgEIhLgDQhuAEhnADIAAghIAwAAQA0AAAlgjQAkgigBgzIgRtyQhEhFgfgRQgfgQg/AAIAAgfIACAAIBDADQApACAcABQAlgBBogFINJOdIgLryQgBhLgkghQgjgghPAAIgqAAIAAgfIBnADQA9ACAoABQBAgBCBgFIAAAfIgnAAQg5AAgdAZQgeAaAAAwIAPQeg");
	this.shape_587.setTransform(1549.2,367.5,0.5,0.5);

	this.shape_588 = new cjs.Shape();
	this.shape_588.graphics.f("#5F493F").s().p("AgHJCQgxABhIACIh5AEIAAghIA6AAQBGABAVgYQAXgZAAhNIAAtTQAAhOgWgYQgVgYhFAAIgtAAIAAghIB5ADQBIACAwABQBSgBChgFIAAAhIg6AAQhFAAgWAYQgXAYAABOIAANTQAABOAWAYQAVAYBFgBIAtAAIAAAhQihgHhRAAg");
	this.shape_588.setTransform(1492.9,367.1,0.5,0.5);

	this.shape_589 = new cjs.Shape();
	this.shape_589.graphics.f("#5F493F").s().p("AD5I4QgkgdhWiEIg6haQinkGgNgQQgGgJgQgHQgbgKgtAAQhLAGgNAAIAAGbQAABOAVAYQAVAYBFgBIA/AAIAAAhQibgHhNAAQgyABhMACIh9AEIAAghIAmAAQBHABAWgYQAVgYAAhOIAAtTQAAhOgVgYQgVgYhGAAIgrAAIAAggQBhgKCCgHQB2gHBRgCQDFAAB1BPQB0BPAACFQAABVg0BCQg1BDh/BKIBqCaQCtD9A4BJQArA3ArAXQApAWA4AAIBFAAIAAAcQiHAThMABQhjAAgvgmgAklo5IAAIhQA0AIA3AAQCHAAA+g+QA+g9AAiGQAAiPhJhQQhJhRiEAAQgXABhBAHg");
	this.shape_589.setTransform(1441.9,367,0.5,0.5);

	this.shape_590 = new cjs.Shape();
	this.shape_590.graphics.f("#5F493F").s().p("AgVJCQlTAHhpAAIAAghIApAAQBFABAVgYQAVgYAAhOIAAtTQAAhOgVgYQgVgYhFAAIgrAAIAAghQDrAFDsABQC5gBC6gFIAJDoIggAAQgIhugmgnQglgmhkAAIlFAAIAAHpIE0AAQA+AAAagdQAbgdAGhJIAgAAIAAFFIggAAQgEhQgigmQgjgmhFAAIkfAAIAAHGQAAA2AXAWQAYAWA7AAIDxAAQBVAAAugiQAughBEhwIAgAAIhaDfQkxgHheAAg");
	this.shape_590.setTransform(1372.5,367.1,0.5,0.5);

	this.shape_591 = new cjs.Shape();
	this.shape_591.graphics.f("#5F493F").s().p("AgHJQQgxABhHACIh6AEIAAghIA6AAQBGAAAWgWQAWgYAAhKIAAvAIlHAAQhJAAgXAhQgaAigJB6IgeAAIAGkQIAFAAQAeARAVAEQAaAHAtAAINgAAQAuAAAZgHQAWgEAegRIAEAAIAHEQIgeAAQgKh5gZgjQgYghhJAAIlGAAIAAPAQABBKAUAYQAWAWBFAAIAtAAIAAAhQihgHhRAAg");
	this.shape_591.setTransform(1308.7,366.4,0.5,0.5);

	this.shape_592 = new cjs.Shape();
	this.shape_592.graphics.f("#5F493F").s().p("AjUJGQg1gJgNgBQgOAAgRAGQgQAFgHAFIgXAAIgwj2IAhgKQAtB5BWA6QBVA8CBgBQCKAABVhCQBVhDAAhtQAAhUg+g7Qg+g7irhQQi5hXhGg+QhfhVAAh3QAAiDBrhSQBrhRCpAAQAoAAAoAEQAmAEA4AMQBEALASAAQARABAagJIARAAIAJDvIgegCQgIhwhHg6QhIg7iCAAQh9ABhNA2QhNA3AABZQAABMBCA8QBBA7ClBJQClBJBEA4QBzBfAACJQAACVh5BiQh5Bhi2ABQhRAAhvgVg");
	this.shape_592.setTransform(1246.6,367,0.5,0.5);

	this.shape_593 = new cjs.Shape();
	this.shape_593.graphics.f("#5F493F").s().p("AGCJNQhsAAhrAHIAAghIA5AAQAeABARgPQARgQAAgZQAAgXgIgXIigmFIloAAIh+FYQgTAyAAAnQAAAbAWAQQAYAPApgBIA5AAIAAAhIhbgEQg2gCgmgBQh/AAg4AHIAAghIAlAAQA8AAAcgTQAdgTAUg4IGFwoIAwAAIGNPMQAxB5AcAiQAbAfA4AAIAmAAIAAAhQh7gHheAAgAjYARIE9AAIipmXg");
	this.shape_593.setTransform(1183,366.6,0.5,0.5);

	this.shape_594 = new cjs.Shape();
	this.shape_594.graphics.f("#5F493F").s().p("AgyJSInhu3IgSMTQgDBEAgAXQAfAVBhAAIAlAAIAAAhIhugEQhBgCgsgBQhAAAioAHIAAghQBhABAogPQBCgaADhNIATscQAChqgqgrQgrgqhsAAIgnAAIAAgfIADAAIBPADQAvACAeABQAjgBAzgCIBUgDIACAAIHxPdIGpvdIBeADQA3ACAkABQAmgBA2gCIBbgDIAAAfIghAAQhRAAgmAbQglAcAAA6IARNgQACBNAcAZQAcAaBUgBIAgAAIAAAhIh3gEQhIgCgwgBQg0ABhRACIiHAEIAAghIAgAAQBPAAAkgZQAjgZgCg5IgRu7IngRag");
	this.shape_594.setTransform(1100.3,367.6,0.5,0.5);

	this.shape_595 = new cjs.Shape();
	this.shape_595.graphics.f("#4D362E").s().p("AjCFQIAAqfIC2AAQAlAAAjAIQAlAIAeATQAeASATAhQATAhAAAwQAAArgPAgQgQAhgbAWQgbAWgjALQglALgmAAIitAAIAAFKgAitgMICtAAQAiAAAdgIQAggJAYgTQAZgTAPgeQAPgdAAgqQAAgqgQgdQgQgdgagRQgbgSgegHQgggHgeAAIiqAAg");
	this.shape_595.setTransform(1517.4,499.4,0.5,0.5);

	this.shape_596 = new cjs.Shape();
	this.shape_596.graphics.f("#4D362E").s().p("AgJFQIAAqfIATAAIAAKfg");
	this.shape_596.setTransform(1489,499.4,0.5,0.5);

	this.shape_597 = new cjs.Shape();
	this.shape_597.graphics.f("#4D362E").s().p("ADiFQIAAlRInDAAIAAFRIgVAAIAAqfIAVAAIAAE7IHDAAIAAk7IAVAAIAAKfg");
	this.shape_597.setTransform(1458,499.4,0.5,0.5);

	this.shape_598 = new cjs.Shape();
	this.shape_598.graphics.f("#4D362E").s().p("AhzFNQg1gXghgmIAQgOQAkAnAwAUQAwATAzAAQAjAAAigLQAigLAZgUQAagUAPgfQAOgdAAgnQAAgngQgbQgRgbgZgSQgZgTghgNQgjgOgegKQgogLgkgQQgjgOgZgWQgZgUgOgfQgOgfAAgqQAAgoARgiQAQggAdgXQAcgXAmgMQAmgLAoAAQA0AAAtATQAuAUAeAkIgQAOQgbgigpgSQgpgSgxAAQgiAAggAJQggAJgbAUQgbATgQAeQgQAeAAAnQAAAnAOAbQAPAcAXASQAXAUAfAMQAbALAiAMQAtAOAiAOQAkAOAdAVQAcAVAQAeQAPAdAAAsQAAArgQAhQgRAigcAXQgaAXgnAMQglAMgoAAQg+AAg0gWg");
	this.shape_598.setTransform(1419,499.4,0.5,0.5);

	this.shape_599 = new cjs.Shape();
	this.shape_599.graphics.f("#4D362E").s().p("AkXFQIAAqfIC+AAQBNAABDATQBFAUAxApQAyApAdBAQAdBAgBBWQABBXgdA/QgdBAgyApQgyAphEAUQhEAUhMAAgAkDE9IClAAQBIAABCgSQBBgTAwgmQAvgoAcg7QAbg7ABhUQgBhTgbg8Qgcg9gvgmQgvgmhCgSQhAgShKAAIilAAg");
	this.shape_599.setTransform(1379.9,499.4,0.5,0.5);

	this.shape_600 = new cjs.Shape();
	this.shape_600.graphics.f("#4D362E").s().p("ADuGsIniqFIgDAAIAAKFIgUAAIAAqfIAdAAIHiKEIADAAIAAs8IAVAAIAANXg");
	this.shape_600.setTransform(1334.3,494.8,0.5,0.5);

	this.shape_601 = new cjs.Shape();
	this.shape_601.graphics.f("#4D362E").s().p("AjLFQIAAqfIGHAAIAAATIlyAAIAAEnIFdAAIAAATIldAAIAAE/IGCAAIAAATg");
	this.shape_601.setTransform(1295,499.4,0.5,0.5);

	this.shape_602 = new cjs.Shape();
	this.shape_602.graphics.f("#4D362E").s().p("AgKFQIAAqfIAVAAIAAKfg");
	this.shape_602.setTransform(1266.1,499.4,0.5,0.5);

	this.shape_603 = new cjs.Shape();
	this.shape_603.graphics.f("#4D362E").s().p("ACzFQIjKlSIieAAIAAFSIgVAAIAAqfIC6AAQAmAAAkAGQAmAHAeASQAfATASAgQATAhAAAzQAAAvgSAgQgSAggcASQgdAUgjAJQgjAIgfAAIDLFTgAi1gUICkAAQBcAAAxgnQAxgnAAhHQAAgtgRgcQgRgdgcgQQgbgRgmgHQgigGgnAAIiaAAg");
	this.shape_603.setTransform(1239.5,499.4,0.5,0.5);

	this.shape_604 = new cjs.Shape();
	this.shape_604.graphics.f("#4D362E").s().p("Ai/FQIAAqfIF/AAIAAATIlqAAIAAEnIFQAAIAAATIlQAAIAAFSg");
	this.shape_604.setTransform(1204.2,499.4,0.5,0.5);

	this.shape_605 = new cjs.Shape();
	this.shape_605.graphics.f("#4D362E").s().p("AmxJBIH1yBIAaAAIFTMlIgWAAIiLlFImGAAIkkKhgAhuhyIF4AAIi6nBg");
	this.shape_605.setTransform(1356.4,472,0.5,0.5);

	this.shape_606 = new cjs.Shape();
	this.shape_606.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUABQgTgBAAgYg");
	this.shape_606.setTransform(380.2,602.6,0.5,0.5);

	this.shape_607 = new cjs.Shape();
	this.shape_607.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgMALgcIAOgkIhokOIAZAAIA5CYQAcBIAGAWIAAAAQAKggAYg/IA5iXIAaAAIh4E6QgOAkgLAQQgJANgPAHQgNAHgSAAQgOAAgSgGg");
	this.shape_607.setTransform(371.3,599.9,0.5,0.5);

	this.shape_608 = new cjs.Shape();
	this.shape_608.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_608.setTransform(361.4,596.7,0.5,0.5);

	this.shape_609 = new cjs.Shape();
	this.shape_609.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2AAQAvgBAcAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgWAKgVAEQgWADgUABQg7AAghglgAg2hcQgYAbgEAvICmAAQAAgvgUgaQgUgagkgBQgmAAgYAag");
	this.shape_609.setTransform(348.6,596.8,0.5,0.5);

	this.shape_610 = new cjs.Shape();
	this.shape_610.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_610.setTransform(338.7,593.9,0.5,0.5);

	this.shape_611 = new cjs.Shape();
	this.shape_611.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_611.setTransform(332.9,593.9,0.5,0.5);

	this.shape_612 = new cjs.Shape();
	this.shape_612.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_612.setTransform(322.8,596.8,0.5,0.5);

	this.shape_613 = new cjs.Shape();
	this.shape_613.graphics.f("#000000").s().p("AhlCKQgvgwAAhZQAAg3AXgrQAYgrApgXQAsgXA1gBQA7AAAwAXIgKAWQgwgVgyAAQhHAAgrAsQgqAsAABLQAABSAoAqQApApBMAAQAzAAAjgOIAAiAIhtAAIAAgXICGAAIAAClQg0AXhDAAQhUAAgugyg");
	this.shape_613.setTransform(307.1,594.5,0.5,0.5);

	this.shape_614 = new cjs.Shape();
	this.shape_614.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_614.setTransform(284.2,596.8,0.5,0.5);

	this.shape_615 = new cjs.Shape();
	this.shape_615.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_615.setTransform(270.5,596.7,0.5,0.5);

	this.shape_616 = new cjs.Shape();
	this.shape_616.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_616.setTransform(260,594.4,0.5,0.5);

	this.shape_617 = new cjs.Shape();
	this.shape_617.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_617.setTransform(252.7,595.3,0.5,0.5);

	this.shape_618 = new cjs.Shape();
	this.shape_618.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_618.setTransform(241.4,596.8,0.5,0.5);

	this.shape_619 = new cjs.Shape();
	this.shape_619.graphics.f("#000000").s().p("AhtC2IAAlrIBaAAQCBAAgBBoQAAA1gkAbQgkAchAAAIg4AAIAACXgAhTAKIAxAAQA+AAAagUQAcgTAAgvQAAgqgagUQgZgUg2AAIg8AAg");
	this.shape_619.setTransform(228.2,594.5,0.5,0.5);

	this.shape_620 = new cjs.Shape();
	this.shape_620.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAJgFAJgNQAHgMALgcIAOgkIhokOIAZAAIA6CYQAbBIAGAWIAAAAIAihfIA6iXIAZAAIh4E6QgPAmgKAOQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_620.setTransform(207.7,599.9,0.5,0.5);

	this.shape_621 = new cjs.Shape();
	this.shape_621.graphics.f("#000000").s().p("Ag0C4QgXgMgOgWIgCAAIgHApIgPAAIAAmCIAYAAIAABhIgBAoIAAAWIABAAQAQgZAWgLQAWgMAdAAQA4AAAeAkQAcAkAABDQAABEgeAlQgfAkg1AAQgdAAgXgMgAhEgiQgVAbAAA+IAAAFQAAA8AWAcQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_621.setTransform(194.6,594,0.5,0.5);

	this.shape_622 = new cjs.Shape();
	this.shape_622.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_622.setTransform(172,594,0.5,0.5);

	this.shape_623 = new cjs.Shape();
	this.shape_623.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_623.setTransform(157.9,596.8,0.5,0.5);

	this.shape_624 = new cjs.Shape();
	this.shape_624.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_624.setTransform(146.4,595.3,0.5,0.5);

	this.shape_625 = new cjs.Shape();
	this.shape_625.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAZAAA2IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAZgrBDAAQBdAAAABjIAACwg");
	this.shape_625.setTransform(134.9,596.7,0.5,0.5);

	this.shape_626 = new cjs.Shape();
	this.shape_626.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_626.setTransform(120.3,596.8,0.5,0.5);

	this.shape_627 = new cjs.Shape();
	this.shape_627.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgVgRgOQgQgOgmgNQgogOgQgLQgRgKgIgOQgIgNAAgTQgBgeAagSQAagRAtAAQArAAAoAQIgJAWQgogQgiAAQghAAgTALQgTAKAAAVQAAAUAOANQAPAMAsARQAmANAPAJQARALAIANQAIAOAAASQAAAlgcATQgbAUgyAAQg3gBgfgRg");
	this.shape_627.setTransform(107.3,596.8,0.5,0.5);

	this.shape_628 = new cjs.Shape();
	this.shape_628.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_628.setTransform(94.4,596.8,0.5,0.5);

	this.shape_629 = new cjs.Shape();
	this.shape_629.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_629.setTransform(83.3,596.7,0.5,0.5);

	this.shape_630 = new cjs.Shape();
	this.shape_630.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlg0AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_630.setTransform(70.3,599.8,0.5,0.5);

	this.shape_631 = new cjs.Shape();
	this.shape_631.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgVAKgWAEQgWADgUABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgVgagkgBQgmAAgXAag");
	this.shape_631.setTransform(55.3,596.8,0.5,0.5);

	this.shape_632 = new cjs.Shape();
	this.shape_632.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_632.setTransform(44.2,596.7,0.5,0.5);

	this.shape_633 = new cjs.Shape();
	this.shape_633.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgMALgcIAOgkIhokOIAZAAIA6CYQAbBIAFAWIABAAIAihfIA5iXIAaAAIh4E6QgOAkgLAQQgJANgPAHQgMAHgUAAQgNAAgSgGg");
	this.shape_633.setTransform(751,561.6,0.5,0.5);

	this.shape_634 = new cjs.Shape();
	this.shape_634.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_634.setTransform(742.3,555.7,0.5,0.5);

	this.shape_635 = new cjs.Shape();
	this.shape_635.graphics.f("#000000").s().p("AhNBoQgggjAAhDQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg7AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_635.setTransform(732.4,558.6,0.5,0.5);

	this.shape_636 = new cjs.Shape();
	this.shape_636.graphics.f("#000000").s().p("AgLCHIhpkOIAaAAIBFC4QAOAkAHAaIABAAQAJgiALgcIBGi4IAaAAIhpEOg");
	this.shape_636.setTransform(719.5,558.6,0.5,0.5);

	this.shape_637 = new cjs.Shape();
	this.shape_637.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_637.setTransform(710.8,556.1,0.5,0.5);

	this.shape_638 = new cjs.Shape();
	this.shape_638.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgWQAAgVgRgOQgPgNgngOQgogOgQgLQgRgKgIgOQgIgMAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUAKAAAVQAAAUAQANQAPANAqAQQAoANAOAJQARALAIANQAIAPAAARQAAAlgcATQgbAUgyAAQg2gBgggRg");
	this.shape_638.setTransform(701.9,558.6,0.5,0.5);

	this.shape_639 = new cjs.Shape();
	this.shape_639.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAwgBAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_639.setTransform(688.4,558.7,0.5,0.5);

	this.shape_640 = new cjs.Shape();
	this.shape_640.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_640.setTransform(678.1,555.7,0.5,0.5);

	this.shape_641 = new cjs.Shape();
	this.shape_641.graphics.f("#000000").s().p("Ag/BoQghgkAAhDQAAhBAigmQAiglA6AAQAjAAAgAMIgGAVQgkgLgZAAQgxAAgaAeQgZAgAAA4QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAWQgaANgqABQg5AAggglg");
	this.shape_641.setTransform(669.5,558.6,0.5,0.5);

	this.shape_642 = new cjs.Shape();
	this.shape_642.graphics.f("#000000").s().p("ABVCHIhVh4IhVB4IgbAAIBiiKIhfiEIAdAAIBQBzIBPhzIAcAAIhdCEIBjCKg");
	this.shape_642.setTransform(656.8,558.6,0.5,0.5);

	this.shape_643 = new cjs.Shape();
	this.shape_643.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2AAQAvgBAbAiQAcAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAYAAARgDQATgEAagKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgagjgBQgnAAgXAag");
	this.shape_643.setTransform(643.4,558.6,0.5,0.5);

	this.shape_644 = new cjs.Shape();
	this.shape_644.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgSBAgYA2g");
	this.shape_644.setTransform(626.6,565.5,0.5,0.5);

	this.shape_645 = new cjs.Shape();
	this.shape_645.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2AAQAvgBAcAiQAcAhgBA5IAAAUIjCAAQABA4AZAcQAaAeAuAAQAYAAASgDQATgEAZgKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgvgVgaQgVgagjgBQgnAAgXAag");
	this.shape_645.setTransform(617.3,558.6,0.5,0.5);

	this.shape_646 = new cjs.Shape();
	this.shape_646.graphics.f("#000000").s().p("Ag/BoQgigkAAhDQABhCAiglQAiglA6AAQAjAAAhAMIgIAVQgjgLgaAAQgwAAgZAeQgaAfAAA5QAAA3AaAfQAZAfAtAAQAlAAAfgNIAAAWQgbANgoABQg5AAghglg");
	this.shape_646.setTransform(604.6,558.6,0.5,0.5);

	this.shape_647 = new cjs.Shape();
	this.shape_647.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_647.setTransform(590.8,558.5,0.5,0.5);

	this.shape_648 = new cjs.Shape();
	this.shape_648.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1AAQAxgBAbAiQAcAhAAA5IAAAUIjDAAQAAA3AbAdQAZAeAvAAQAXAAARgDQAUgEAYgKIAAAWQgVAKgUAEQgXADgUABQg6AAghglgAg3hcQgYAbgDAvICmAAQAAgvgUgaQgVgagkgBQgmAAgYAag");
	this.shape_648.setTransform(576.2,558.6,0.5,0.5);

	this.shape_649 = new cjs.Shape();
	this.shape_649.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_649.setTransform(566.3,556.1,0.5,0.5);

	this.shape_650 = new cjs.Shape();
	this.shape_650.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_650.setTransform(555.4,555.8,0.5,0.5);

	this.shape_651 = new cjs.Shape();
	this.shape_651.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkAAQAwgBAXgYQAWgZAAg3IAAiUIAYAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAABhjg");
	this.shape_651.setTransform(540.6,558.7,0.5,0.5);

	this.shape_652 = new cjs.Shape();
	this.shape_652.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_652.setTransform(526,558.6,0.5,0.5);

	this.shape_653 = new cjs.Shape();
	this.shape_653.graphics.f("#000000").s().p("AhNBoQgggjAAhDQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg7AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_653.setTransform(506.1,558.6,0.5,0.5);

	this.shape_654 = new cjs.Shape();
	this.shape_654.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_654.setTransform(491.1,555.8,0.5,0.5);

	this.shape_655 = new cjs.Shape();
	this.shape_655.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_655.setTransform(481,556.1,0.5,0.5);

	this.shape_656 = new cjs.Shape();
	this.shape_656.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAOA3AGAeIACAAQAMgxAJgcIA4ilIAVAAIA1ClQARA1AFAYIACAAQABgOAThJIApibIAZAAIhKEOg");
	this.shape_656.setTransform(468.9,558.6,0.5,0.5);

	this.shape_657 = new cjs.Shape();
	this.shape_657.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_657.setTransform(451.7,555.8,0.5,0.5);

	this.shape_658 = new cjs.Shape();
	this.shape_658.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_658.setTransform(441.6,555.7,0.5,0.5);

	this.shape_659 = new cjs.Shape();
	this.shape_659.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_659.setTransform(434.7,558.5,0.5,0.5);

	this.shape_660 = new cjs.Shape();
	this.shape_660.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAeg");
	this.shape_660.setTransform(421.3,558.6,0.5,0.5);

	this.shape_661 = new cjs.Shape();
	this.shape_661.graphics.f("#000000").s().p("ABNCHIg7i0QgHgVgHghIgCAAIhMDqIgYAAIhOkOIAbAAIArCdQAOA3AGAeIACAAQANg2AIgXIA4ilIAVAAIA1ClQATA9ADAQIACAAQABgOAThJIApibIAZAAIhKEOg");
	this.shape_661.setTransform(404.6,558.6,0.5,0.5);

	this.shape_662 = new cjs.Shape();
	this.shape_662.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_662.setTransform(381.6,558.6,0.5,0.5);

	this.shape_663 = new cjs.Shape();
	this.shape_663.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhgkQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAeg");
	this.shape_663.setTransform(361.2,558.6,0.5,0.5);

	this.shape_664 = new cjs.Shape();
	this.shape_664.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_664.setTransform(349.3,557.1,0.5,0.5);

	this.shape_665 = new cjs.Shape();
	this.shape_665.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA1AAQAxgBAaAiQAcAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAYAAARgDQATgEAagKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgagkgBQgmAAgXAag");
	this.shape_665.setTransform(331.6,558.6,0.5,0.5);

	this.shape_666 = new cjs.Shape();
	this.shape_666.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_666.setTransform(321.7,555.7,0.5,0.5);

	this.shape_667 = new cjs.Shape();
	this.shape_667.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCfIACAAQAPgZAWgLQAWgMAeAAQA5AAAcAkQAdAjAABEQAABEgeAlQgfAkg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_667.setTransform(311.6,555.8,0.5,0.5);

	this.shape_668 = new cjs.Shape();
	this.shape_668.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_668.setTransform(296.4,558.6,0.5,0.5);

	this.shape_669 = new cjs.Shape();
	this.shape_669.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_669.setTransform(287.2,555.7,0.5,0.5);

	this.shape_670 = new cjs.Shape();
	this.shape_670.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_670.setTransform(281.5,556.1,0.5,0.5);

	this.shape_671 = new cjs.Shape();
	this.shape_671.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_671.setTransform(271.4,558.6,0.5,0.5);

	this.shape_672 = new cjs.Shape();
	this.shape_672.graphics.f("#000000").s().p("AgLCHIhpkOIAaAAIBGC4QAOAmAGAYIAAAAQAMglAJgZIBGi4IAaAAIhpEOg");
	this.shape_672.setTransform(259.2,558.6,0.5,0.5);

	this.shape_673 = new cjs.Shape();
	this.shape_673.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_673.setTransform(246.2,558.6,0.5,0.5);

	this.shape_674 = new cjs.Shape();
	this.shape_674.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAOA3AGAeIACAAQAOg7AHgSIA4ilIAVAAIA1ClQARA1AFAYIACAAQABgOAThJIApibIAZAAIhKEOg");
	this.shape_674.setTransform(224,558.6,0.5,0.5);

	this.shape_675 = new cjs.Shape();
	this.shape_675.graphics.f("#000000").s().p("Ag+B7QgbgQgQghQgOghAAgpQAAhCAhgkQAgglA3AAQA4AAAfAlQAgAmAABAQAABCghAlQggAmg3AAQgjAAgbgSgAhFhXQgYAfAAA4QAAA3AYAgQAaAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAeg");
	this.shape_675.setTransform(207.3,558.6,0.5,0.5);

	this.shape_676 = new cjs.Shape();
	this.shape_676.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_676.setTransform(192.4,558.5,0.5,0.5);

	this.shape_677 = new cjs.Shape();
	this.shape_677.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgWQAAgVgRgOQgPgNgngOQgogOgQgLQgQgJgJgPQgIgMAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgTAKAAAVQAAAUAPANQAPANAqAQQAoANAOAJQARALAIANQAIAPAAARQAAAlgcATQgbAUgyAAQg2gBgggRg");
	this.shape_677.setTransform(172.2,558.6,0.5,0.5);

	this.shape_678 = new cjs.Shape();
	this.shape_678.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_678.setTransform(163.5,556.1,0.5,0.5);

	this.shape_679 = new cjs.Shape();
	this.shape_679.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_679.setTransform(148.9,555.7,0.5,0.5);

	this.shape_680 = new cjs.Shape();
	this.shape_680.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_680.setTransform(137.5,558.5,0.5,0.5);

	this.shape_681 = new cjs.Shape();
	this.shape_681.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAeg");
	this.shape_681.setTransform(124.2,558.6,0.5,0.5);

	this.shape_682 = new cjs.Shape();
	this.shape_682.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgZAAIhMkOIAaAAIArCdQAQA/AEAWIACAAQANg2AIgXIA3ilIAWAAIA1ClQATA9ADAQIABAAQADgTAShEIAoibIAaAAIhKEOg");
	this.shape_682.setTransform(107.5,558.6,0.5,0.5);

	this.shape_683 = new cjs.Shape();
	this.shape_683.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_683.setTransform(87.6,558.5,0.5,0.5);

	this.shape_684 = new cjs.Shape();
	this.shape_684.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_684.setTransform(78.9,556.1,0.5,0.5);

	this.shape_685 = new cjs.Shape();
	this.shape_685.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1AAQAxgBAbAiQAcAhAAA5IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAXAAARgDQAUgEAYgKIAAAWQgVAKgUAEQgXADgUABQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgvgUgaQgVgagkgBQgmAAgYAag");
	this.shape_685.setTransform(69,558.6,0.5,0.5);

	this.shape_686 = new cjs.Shape();
	this.shape_686.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_686.setTransform(54.5,555.7,0.5,0.5);

	this.shape_687 = new cjs.Shape();
	this.shape_687.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_687.setTransform(42.5,557.1,0.5,0.5);

	this.shape_688 = new cjs.Shape();
	this.shape_688.graphics.f("#000000").s().p("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");
	this.shape_688.setTransform(400.6,520.4,0.5,0.5);

	this.shape_689 = new cjs.Shape();
	this.shape_689.graphics.f("#000000").s().p("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");
	this.shape_689.setTransform(403.8,482.2,0.5,0.5);

	this.shape_690 = new cjs.Shape();
	this.shape_690.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAdglA3AAQAeAAAVALQAXAMAPAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgGgpIgDAAQgeAug6AAQg4AAgdgjgAhBgeQgWAeAAA7QgBBzBZAAQAtAAAWgaQAWgbgBg9IAAgFQABg9gWgcQgUgbgwAAQgrAAgWAfg");
	this.shape_690.setTransform(776.9,441,0.5,0.5);

	this.shape_691 = new cjs.Shape();
	this.shape_691.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_691.setTransform(762.3,443.7,0.5,0.5);

	this.shape_692 = new cjs.Shape();
	this.shape_692.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_692.setTransform(747.5,443.8,0.5,0.5);

	this.shape_693 = new cjs.Shape();
	this.shape_693.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_693.setTransform(730.1,442.3,0.5,0.5);

	this.shape_694 = new cjs.Shape();
	this.shape_694.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgMAAgXQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAXQgngRgiAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAnAOAOAIQARALAIAOQAIAOAAARQAAAkgbAUQgcAUgyAAQg2gBgggQg");
	this.shape_694.setTransform(720,443.8,0.5,0.5);

	this.shape_695 = new cjs.Shape();
	this.shape_695.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_695.setTransform(706.9,443.8,0.5,0.5);

	this.shape_696 = new cjs.Shape();
	this.shape_696.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQABgxASgYQARgXAqAAQAWAAAWAHIgFAVQgUgGgUAAQgcAAgNARQgKARgBAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_696.setTransform(697.7,440.8,0.5,0.5);

	this.shape_697 = new cjs.Shape();
	this.shape_697.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_697.setTransform(685,441,0.5,0.5);

	this.shape_698 = new cjs.Shape();
	this.shape_698.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_698.setTransform(670.6,443.8,0.5,0.5);

	this.shape_699 = new cjs.Shape();
	this.shape_699.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA0AAQAxgBAbAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgXAKgTAEQgXADgUABQg7AAggglgAg2hcQgYAbgEAvICnAAQgBgugUgbQgUgaglgBQglABgYAZg");
	this.shape_699.setTransform(657.3,443.8,0.5,0.5);

	this.shape_700 = new cjs.Shape();
	this.shape_700.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_700.setTransform(645.9,442.3,0.5,0.5);

	this.shape_701 = new cjs.Shape();
	this.shape_701.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAnAAAVgNQAVgMAAgXQAAgVgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQggAAgTALQgUAKAAAVQAAAUAPANQAQANAqAQQAoANAOAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2gBgggQg");
	this.shape_701.setTransform(635.7,443.8,0.5,0.5);

	this.shape_702 = new cjs.Shape();
	this.shape_702.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_702.setTransform(615.3,441,0.5,0.5);

	this.shape_703 = new cjs.Shape();
	this.shape_703.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_703.setTransform(605.2,440.9,0.5,0.5);

	this.shape_704 = new cjs.Shape();
	this.shape_704.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AZAdQAaAeAvAAQAXAAARgDQATgEAZgKIAAAWQgVAKgVAEQgWADgUABQg7AAghglgAg2hcQgZAbgDAvICmAAQAAgvgUgaQgVgagjgBQgmABgYAZg");
	this.shape_704.setTransform(595.3,443.8,0.5,0.5);

	this.shape_705 = new cjs.Shape();
	this.shape_705.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_705.setTransform(580.9,440.9,0.5,0.5);

	this.shape_706 = new cjs.Shape();
	this.shape_706.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABBggAmQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_706.setTransform(559.2,443.8,0.5,0.5);

	this.shape_707 = new cjs.Shape();
	this.shape_707.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAWgLAjAAQBcAAAABiIAACxg");
	this.shape_707.setTransform(544.3,440.9,0.5,0.5);

	this.shape_708 = new cjs.Shape();
	this.shape_708.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAQA/AEAWIABAAQAQg9AGgQIA4ilIAVAAIA1ClQATA9ADAQIACAAQACgTAShEIApibIAYAAIhJEOg");
	this.shape_708.setTransform(527.5,443.8,0.5,0.5);

	this.shape_709 = new cjs.Shape();
	this.shape_709.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgMAAgXQAAgVgQgOQgSgNglgOQgogOgQgLQgQgKgJgNQgJgOABgTQAAgeAZgSQAagRAsAAQAtAAAnAQIgJAXQgogRgjAAQggAAgTALQgTAKgBAVQAAAUAQANQAOAMAsARQAmANAPAJQARALAIAOQAIANAAASQAAAlgcATQgbAUgyAAQg3gBgfgQg");
	this.shape_709.setTransform(505.6,443.8,0.5,0.5);

	this.shape_710 = new cjs.Shape();
	this.shape_710.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_710.setTransform(495.3,442.3,0.5,0.5);

	this.shape_711 = new cjs.Shape();
	this.shape_711.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgMAAgXQAAgVgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQggAAgTALQgUAKAAAVQAAAUAQANQAPANAqAQQAoANAOAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2gBgggQg");
	this.shape_711.setTransform(485.2,443.8,0.5,0.5);

	this.shape_712 = new cjs.Shape();
	this.shape_712.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_712.setTransform(476.4,441.4,0.5,0.5);

	this.shape_713 = new cjs.Shape();
	this.shape_713.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfALAPQALAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_713.setTransform(469.1,442.3,0.5,0.5);

	this.shape_714 = new cjs.Shape();
	this.shape_714.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_714.setTransform(460.9,443.7,0.5,0.5);

	this.shape_715 = new cjs.Shape();
	this.shape_715.graphics.f("#000000").s().p("AhPB4QgVgUgBglQAAgnAigWQAhgVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgVAKQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_715.setTransform(447.9,443.8,0.5,0.5);

	this.shape_716 = new cjs.Shape();
	this.shape_716.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOghAAgpQAAhBAgglQAgglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQghAmg3AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_716.setTransform(427.5,443.8,0.5,0.5);

	this.shape_717 = new cjs.Shape();
	this.shape_717.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA4AFAdIABAAQAQg9AGgQIA4ilIAVAAIA1ClQATBAADANIABAAQADgTARhEIAqibIAZAAIhKEOg");
	this.shape_717.setTransform(410.8,443.8,0.5,0.5);

	this.shape_718 = new cjs.Shape();
	this.shape_718.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_718.setTransform(397.1,442.3,0.5,0.5);

	this.shape_719 = new cjs.Shape();
	this.shape_719.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgXAKgTAEQgXADgVABQg6AAghglgAg3hcQgXAbgEAvICnAAQAAgugVgbQgUgaglgBQglABgZAZg");
	this.shape_719.setTransform(379.4,443.8,0.5,0.5);

	this.shape_720 = new cjs.Shape();
	this.shape_720.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_720.setTransform(368.3,443.7,0.5,0.5);

	this.shape_721 = new cjs.Shape();
	this.shape_721.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgVALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_721.setTransform(355.3,443.8,0.5,0.5);

	this.shape_722 = new cjs.Shape();
	this.shape_722.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgMALgcIAOgkIhokOIAZAAIA5CYQAbBGAGAYIABAAIAihfIA5iXIAaAAIh4E6QgOAlgLAPQgKANgOAHQgNAHgSAAQgOAAgSgGg");
	this.shape_722.setTransform(336.5,446.9,0.5,0.5);

	this.shape_723 = new cjs.Shape();
	this.shape_723.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAAUIjCAAQABA4AZAcQAaAeAuAAQAYAAASgDQATgFAZgJIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgagjgBQgnABgXAZg");
	this.shape_723.setTransform(323.7,443.8,0.5,0.5);

	this.shape_724 = new cjs.Shape();
	this.shape_724.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_724.setTransform(309.2,440.9,0.5,0.5);

	this.shape_725 = new cjs.Shape();
	this.shape_725.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_725.setTransform(294.9,441.5,0.5,0.5);

	this.shape_726 = new cjs.Shape();
	this.shape_726.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUABQgTgBAAgYg");
	this.shape_726.setTransform(278.6,449.6,0.5,0.5);

	this.shape_727 = new cjs.Shape();
	this.shape_727.graphics.f("#000000").s().p("AhNChQgggjAAhDQAAhAAfgmQAggnA1AAQAwAAAbAiQAcAhAAA4IAAAUIjCAAQAAA3AaAeQAaAdAuABQAYAAARgDQATgFAagJIAAAVQgWALgVADQgWAEgVAAQg5AAgiglgAg2gjQgZAbgDAvICmAAQAAgvgUgZQgVgbgkAAQgmAAgXAZgAgahzIAAgEQAQgSATgZQAQgVAHgOIAjAAIAAAFQgJANgVAVQgVAVgZAWg");
	this.shape_727.setTransform(268.6,441,0.5,0.5);

	this.shape_728 = new cjs.Shape();
	this.shape_728.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAIgFAKgNQAGgMAMgcIANgkIhokOIAaAAIA5CYQAbBGAGAYIABAAIAihfIA5iXIAZAAIh4E6QgPAngJANQgLANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_728.setTransform(255.7,446.9,0.5,0.5);

	this.shape_729 = new cjs.Shape();
	this.shape_729.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_729.setTransform(247,441.4,0.5,0.5);

	this.shape_730 = new cjs.Shape();
	this.shape_730.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBEAAQBcAAgBBjIAACwg");
	this.shape_730.setTransform(236.7,443.7,0.5,0.5);

	this.shape_731 = new cjs.Shape();
	this.shape_731.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgVALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_731.setTransform(221.9,443.8,0.5,0.5);

	this.shape_732 = new cjs.Shape();
	this.shape_732.graphics.f("#000000").s().p("Ag8DdIAAgWQASAFASAAQA8AAAAhCIAAltIAaAAIAAFrQAABchVAAQgWAAgPgHg");
	this.shape_732.setTransform(210,443.8,0.5,0.5);

	this.shape_733 = new cjs.Shape();
	this.shape_733.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_733.setTransform(198.5,443.7,0.5,0.5);

	this.shape_734 = new cjs.Shape();
	this.shape_734.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAhgnA1AAQAwgBAbAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgXAKgTAEQgXADgUABQg7AAggglgAg3hcQgXAbgEAvICnAAQgBgugUgbQgVgagjgBQgmABgZAZg");
	this.shape_734.setTransform(185.7,443.8,0.5,0.5);

	this.shape_735 = new cjs.Shape();
	this.shape_735.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_735.setTransform(175.8,441.4,0.5,0.5);

	this.shape_736 = new cjs.Shape();
	this.shape_736.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_736.setTransform(170.1,440.9,0.5,0.5);

	this.shape_737 = new cjs.Shape();
	this.shape_737.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAcAggBA6IAAAUIjBAAQABA4AYAcQAaAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgWAKgVAEQgWADgUABQg7AAghglgAg2hcQgZAbgDAvICmAAQAAgugUgbQgVgagjgBQgmABgYAZg");
	this.shape_737.setTransform(160.2,443.8,0.5,0.5);

	this.shape_738 = new cjs.Shape();
	this.shape_738.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_738.setTransform(148.7,442.3,0.5,0.5);

	this.shape_739 = new cjs.Shape();
	this.shape_739.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgyCBIgdAAICTltIAOAAICQFtgAgMhiIg0CBICCAAIhBitQgFAWgIAWg");
	this.shape_739.setTransform(137,441.5,0.5,0.5);

	this.shape_740 = new cjs.Shape();
	this.shape_740.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_740.setTransform(118.3,442.3,0.5,0.5);

	this.shape_741 = new cjs.Shape();
	this.shape_741.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_741.setTransform(107,443.8,0.5,0.5);

	this.shape_742 = new cjs.Shape();
	this.shape_742.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_742.setTransform(89,440.9,0.5,0.5);

	this.shape_743 = new cjs.Shape();
	this.shape_743.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_743.setTransform(77.6,443.7,0.5,0.5);

	this.shape_744 = new cjs.Shape();
	this.shape_744.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_744.setTransform(64.3,443.8,0.5,0.5);

	this.shape_745 = new cjs.Shape();
	this.shape_745.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA4AFAdIABAAQAQg9AGgQIA4ilIAVAAIA1ClQATBAADANIABAAQADgTARhEIAqibIAZAAIhKEOg");
	this.shape_745.setTransform(47.6,443.8,0.5,0.5);

	this.shape_746 = new cjs.Shape();
	this.shape_746.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAbAeAuAAQAXAAARgDQATgEAagKIAAAWQgXAKgUAEQgWADgUABQg6AAghglgAg2hcQgYAagEAwICmAAQAAgwgUgZQgVgagkgBQgmABgXAZg");
	this.shape_746.setTransform(772.9,405.6,0.5,0.5);

	this.shape_747 = new cjs.Shape();
	this.shape_747.graphics.f("#000000").s().p("AgMCHIhokOIAZAAIBGC4QAPAkAGAaIABAAQAKgkALgaIBGi4IAZAAIhoEOg");
	this.shape_747.setTransform(760,405.6,0.5,0.5);

	this.shape_748 = new cjs.Shape();
	this.shape_748.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_748.setTransform(751.3,403.1,0.5,0.5);

	this.shape_749 = new cjs.Shape();
	this.shape_749.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_749.setTransform(743.9,404.1,0.5,0.5);

	this.shape_750 = new cjs.Shape();
	this.shape_750.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_750.setTransform(732.6,405.6,0.5,0.5);

	this.shape_751 = new cjs.Shape();
	this.shape_751.graphics.f("#000000").s().p("AgLCHIhpkOIAZAAIBGC4QAPAkAGAaIABAAQALglAKgZIBGi4IAZAAIhpEOg");
	this.shape_751.setTransform(720.5,405.6,0.5,0.5);

	this.shape_752 = new cjs.Shape();
	this.shape_752.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_752.setTransform(707.2,405.6,0.5,0.5);

	this.shape_753 = new cjs.Shape();
	this.shape_753.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvAAgXAYQgWAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAZgrBDAAQBdAAAABjIAACwg");
	this.shape_753.setTransform(692.3,405.5,0.5,0.5);

	this.shape_754 = new cjs.Shape();
	this.shape_754.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkOIAWAAIAEAmIACAAQAagrBCAAQBdAAgBBjIAACwg");
	this.shape_754.setTransform(677.2,405.5,0.5,0.5);

	this.shape_755 = new cjs.Shape();
	this.shape_755.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_755.setTransform(666.8,403.1,0.5,0.5);

	this.shape_756 = new cjs.Shape();
	this.shape_756.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_756.setTransform(649.2,402.8,0.5,0.5);

	this.shape_757 = new cjs.Shape();
	this.shape_757.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvAAgXAYQgWAZAAA2IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAZgrBDAAQBdAAAABjIAACwg");
	this.shape_757.setTransform(634.6,405.5,0.5,0.5);

	this.shape_758 = new cjs.Shape();
	this.shape_758.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgWAcgUAJQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_758.setTransform(619.8,405.6,0.5,0.5);

	this.shape_759 = new cjs.Shape();
	this.shape_759.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_759.setTransform(604,402.7,0.5,0.5);

	this.shape_760 = new cjs.Shape();
	this.shape_760.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAwgBAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_760.setTransform(593.5,405.7,0.5,0.5);

	this.shape_761 = new cjs.Shape();
	this.shape_761.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_761.setTransform(583.1,402.6,0.5,0.5);

	this.shape_762 = new cjs.Shape();
	this.shape_762.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_762.setTransform(575.5,402.7,0.5,0.5);

	this.shape_763 = new cjs.Shape();
	this.shape_763.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAwgBAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_763.setTransform(565.1,405.7,0.5,0.5);

	this.shape_764 = new cjs.Shape();
	this.shape_764.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAgglQAhglA3AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgYAfg");
	this.shape_764.setTransform(550.1,405.6,0.5,0.5);

	this.shape_765 = new cjs.Shape();
	this.shape_765.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgVgRgOQgQgNgngOQgngOgQgLQgRgKgIgNQgJgOAAgTQABgeAZgSQAagRAtAAQArAAAnAQIgJAXQgngRgiAAQghAAgTALQgUAKABAVQgBAUAQANQAPANAqAQQAnANAPAJQAQALAJAOQAIANAAASQAAAlgbATQgcAUgyAAQg3gBgfgQg");
	this.shape_765.setTransform(536.7,405.6,0.5,0.5);

	this.shape_766 = new cjs.Shape();
	this.shape_766.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAARAEIgEAXQgTgEgQAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_766.setTransform(520.1,405.5,0.5,0.5);

	this.shape_767 = new cjs.Shape();
	this.shape_767.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_767.setTransform(511.4,403.1,0.5,0.5);

	this.shape_768 = new cjs.Shape();
	this.shape_768.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQATgEAagKIAAAWQgVAKgWAEQgWADgUABQg6AAghglgAg2hcQgYAagEAwICmAAQAAgwgUgZQgVgagkgBQgmABgXAZg");
	this.shape_768.setTransform(501.5,405.6,0.5,0.5);

	this.shape_769 = new cjs.Shape();
	this.shape_769.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAWgLAjAAQBcAAAABiIAACxg");
	this.shape_769.setTransform(487,402.7,0.5,0.5);

	this.shape_770 = new cjs.Shape();
	this.shape_770.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgQAGgYAAQgjAAgSgUg");
	this.shape_770.setTransform(475,404.1,0.5,0.5);

	this.shape_771 = new cjs.Shape();
	this.shape_771.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_771.setTransform(456.3,402.8,0.5,0.5);

	this.shape_772 = new cjs.Shape();
	this.shape_772.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_772.setTransform(441.7,405.5,0.5,0.5);

	this.shape_773 = new cjs.Shape();
	this.shape_773.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_773.setTransform(426.9,405.6,0.5,0.5);

	this.shape_774 = new cjs.Shape();
	this.shape_774.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_774.setTransform(411,402.7,0.5,0.5);

	this.shape_775 = new cjs.Shape();
	this.shape_775.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxgBAbAiQAcAhAAA5IAAAUIjDAAQAAA3AbAdQAZAeAuAAQAYAAARgDQASgEAbgKIAAAWQgWAKgUAEQgXADgVABQg6AAggglgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgagkgBQgmABgYAZg");
	this.shape_775.setTransform(401.2,405.6,0.5,0.5);

	this.shape_776 = new cjs.Shape();
	this.shape_776.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_776.setTransform(386.7,402.7,0.5,0.5);

	this.shape_777 = new cjs.Shape();
	this.shape_777.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAiglA6AAQAjAAAgAMIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAkAAAggNIAAAWQgaANgqABQg4AAgiglg");
	this.shape_777.setTransform(373.4,405.6,0.5,0.5);

	this.shape_778 = new cjs.Shape();
	this.shape_778.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_778.setTransform(364.2,403.1,0.5,0.5);

	this.shape_779 = new cjs.Shape();
	this.shape_779.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgPAAIiIlQIgCAAIACBAIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_779.setTransform(350.3,403.3,0.5,0.5);

	this.shape_780 = new cjs.Shape();
	this.shape_780.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgMALgcIAOgkIhokOIAZAAIA5CYQAbBGAGAYIABAAIAihfIA5iXIAaAAIh4E6QgOAlgLAPQgJANgPAHQgNAHgSAAQgOAAgSgGg");
	this.shape_780.setTransform(326.8,408.6,0.5,0.5);

	this.shape_781 = new cjs.Shape();
	this.shape_781.graphics.f("#000000").s().p("Ag/BoQgigkAAhDQABhCAiglQAiglA6AAQAjAAAhAMIgHAVQgkgLgaAAQgwAAgaAfQgaAfABA4QgBA3AaAfQAbAfAsAAQAlAAAfgNIAAAWQgbANgoABQg5AAghglg");
	this.shape_781.setTransform(315.2,405.6,0.5,0.5);

	this.shape_782 = new cjs.Shape();
	this.shape_782.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_782.setTransform(301.4,405.5,0.5,0.5);

	this.shape_783 = new cjs.Shape();
	this.shape_783.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_783.setTransform(286.6,405.6,0.5,0.5);

	this.shape_784 = new cjs.Shape();
	this.shape_784.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA5AAAeIAADrIgYAAIAAlrIAZAAIDWFBIACAAQgCgoAAgsIAAjtIAYAAIAAFrg");
	this.shape_784.setTransform(271.1,403.3,0.5,0.5);

	this.shape_785 = new cjs.Shape();
	this.shape_785.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgTBAgXA2g");
	this.shape_785.setTransform(252.1,412.5,0.5,0.5);

	this.shape_786 = new cjs.Shape();
	this.shape_786.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgMAAgXQAAgVgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgJgOAAgTQAAgeAagSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQggAAgTALQgUAKAAAVQAAAUAPANQAQANAqAQQAoANAOAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2gBgggQg");
	this.shape_786.setTransform(243.7,405.6,0.5,0.5);

	this.shape_787 = new cjs.Shape();
	this.shape_787.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_787.setTransform(230.4,405.5,0.5,0.5);

	this.shape_788 = new cjs.Shape();
	this.shape_788.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_788.setTransform(220,403.1,0.5,0.5);

	this.shape_789 = new cjs.Shape();
	this.shape_789.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_789.setTransform(212,402.7,0.5,0.5);

	this.shape_790 = new cjs.Shape();
	this.shape_790.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_790.setTransform(200.3,404.1,0.5,0.5);

	this.shape_791 = new cjs.Shape();
	this.shape_791.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_791.setTransform(189,405.6,0.5,0.5);

	this.shape_792 = new cjs.Shape();
	this.shape_792.graphics.f("#000000").s().p("ABdC2IhelRQgDAVgIAdIhQEfIgWAAIhklrIAbAAIBVFCQAGgiAThEIA/jcIAbAAIBJD9QANArAFAbIBVlDIAaAAIhlFrg");
	this.shape_792.setTransform(171.3,403.3,0.5,0.5);

	this.shape_793 = new cjs.Shape();
	this.shape_793.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_793.setTransform(146.1,405.6,0.5,0.5);

	this.shape_794 = new cjs.Shape();
	this.shape_794.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_794.setTransform(135.7,405.5,0.5,0.5);

	this.shape_795 = new cjs.Shape();
	this.shape_795.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg9gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_795.setTransform(121.9,402.8,0.5,0.5);

	this.shape_796 = new cjs.Shape();
	this.shape_796.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_796.setTransform(107.3,405.5,0.5,0.5);

	this.shape_797 = new cjs.Shape();
	this.shape_797.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_797.setTransform(92.5,405.6,0.5,0.5);

	this.shape_798 = new cjs.Shape();
	this.shape_798.graphics.f("#000000").s().p("ABUCHIhUh4IhVB4IgcAAIBjiKIheiEIAcAAIBQBzIBQhzIAbAAIheCEIBkCKg");
	this.shape_798.setTransform(79.8,405.6,0.5,0.5);

	this.shape_799 = new cjs.Shape();
	this.shape_799.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA0AAQAxgBAbAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAYAAAQgDQAUgEAZgKIAAAWQgXAKgTAEQgXADgUABQg7AAggglgAg2hcQgXAagFAwICnAAQgBgugUgbQgVgagkgBQgmABgXAZg");
	this.shape_799.setTransform(66.5,405.6,0.5,0.5);

	this.shape_800 = new cjs.Shape();
	this.shape_800.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_800.setTransform(56.6,402.7,0.5,0.5);

	this.shape_801 = new cjs.Shape();
	this.shape_801.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_801.setTransform(46.1,403.2,0.5,0.5);

	this.shape_802 = new cjs.Shape();
	this.shape_802.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgTgGgVAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_802.setTransform(770.2,364.3,0.5,0.5);

	this.shape_803 = new cjs.Shape();
	this.shape_803.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABCghAlQgfAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_803.setTransform(758,367.3,0.5,0.5);

	this.shape_804 = new cjs.Shape();
	this.shape_804.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAJgGAIgMQAIgMALgcIAMgkIhnkOIAZAAIA6CYQAZBGAIAYIABAAQANgqAUg1IA6iXIAZAAIh4E6QgPAngKANQgKANgNAHQgOAHgTAAQgNAAgSgGg");
	this.shape_804.setTransform(738.1,370.4,0.5,0.5);

	this.shape_805 = new cjs.Shape();
	this.shape_805.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_805.setTransform(728.1,367.2,0.5,0.5);

	this.shape_806 = new cjs.Shape();
	this.shape_806.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_806.setTransform(714.8,367.3,0.5,0.5);

	this.shape_807 = new cjs.Shape();
	this.shape_807.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_807.setTransform(702.9,365.8,0.5,0.5);

	this.shape_808 = new cjs.Shape();
	this.shape_808.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAUgNAAgWQAAgVgQgOQgQgNgmgOQgogOgRgLQgPgKgJgNQgJgOABgTQAAgeAZgSQAagRAsAAQAtAAAnAQIgJAXQgogRgjAAQggAAgTALQgUAKAAAVQAAAUAPANQAPANArAQQAnANAOAJQARALAIAOQAJANAAASQAAAlgcATQgbAUgyAAQg3gBgfgQg");
	this.shape_808.setTransform(692.8,367.3,0.5,0.5);

	this.shape_809 = new cjs.Shape();
	this.shape_809.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AfgnQAhgnA1AAQAvgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAuAAQAYAAASgDQATgEAZgKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgagjgBQgnABgXAZg");
	this.shape_809.setTransform(673.3,367.3,0.5,0.5);

	this.shape_810 = new cjs.Shape();
	this.shape_810.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_810.setTransform(658.9,364.4,0.5,0.5);

	this.shape_811 = new cjs.Shape();
	this.shape_811.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_811.setTransform(646.8,365.8,0.5,0.5);

	this.shape_812 = new cjs.Shape();
	this.shape_812.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAnAAAVgNQAVgNAAgWQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgKgJgNQgIgNAAgUQAAgeAZgSQAagRAtAAQAsAAAnAQIgJAXQgpgRghAAQghAAgTALQgTAKAAAVQAAAUAPANQAPANArAQQAnAOAOAIQARALAIAOQAIAOAAARQAAAlgbATQgcAUgyAAQg2gBgggQg");
	this.shape_812.setTransform(630.1,367.3,0.5,0.5);

	this.shape_813 = new cjs.Shape();
	this.shape_813.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA4AZAcQAaAeAuAAQAXAAATgDQATgFAZgJIAAAWQgWAKgUAEQgXADgVABQg6AAggglgAg3hcQgXAbgEAvICmAAQABgugVgbQgVgagkgBQglABgZAZg");
	this.shape_813.setTransform(617.2,367.3,0.5,0.5);

	this.shape_814 = new cjs.Shape();
	this.shape_814.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgTAGgXAAQgiAAgSgUg");
	this.shape_814.setTransform(605.8,365.8,0.5,0.5);

	this.shape_815 = new cjs.Shape();
	this.shape_815.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAjgVA8gBIA0gCIAAgSQgBgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgFgrIgDAAQgVAbgUAKQgWALgdAAQgoAAgWgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_815.setTransform(594.5,367.3,0.5,0.5);

	this.shape_816 = new cjs.Shape();
	this.shape_816.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_816.setTransform(584.1,367.2,0.5,0.5);

	this.shape_817 = new cjs.Shape();
	this.shape_817.graphics.f("#000000").s().p("Ag0C4QgWgLgPgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCfIACAAQAQgZAWgLQAVgMAeAAQA5AAAcAkQAdAkAABDQAABDgeAmQgeAkg2AAQgcAAgYgMgAhEgiQgVAbAAA+IAAAFQAAA9AWAbQAVAaAuAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_817.setTransform(571.1,364.5,0.5,0.5);

	this.shape_818 = new cjs.Shape();
	this.shape_818.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAgAAA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAXAAATgDQATgEAZgKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgugVgbQgUgaglgBQgmABgXAZg");
	this.shape_818.setTransform(556.1,367.3,0.5,0.5);

	this.shape_819 = new cjs.Shape();
	this.shape_819.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_819.setTransform(546.2,364.4,0.5,0.5);

	this.shape_820 = new cjs.Shape();
	this.shape_820.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAYAAARgDQATgEAagKIAAAWQgWAKgVAEQgWADgVABQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgwgUgZQgVgagkgBQgmABgXAZg");
	this.shape_820.setTransform(536.3,367.3,0.5,0.5);

	this.shape_821 = new cjs.Shape();
	this.shape_821.graphics.f("#000000").s().p("Ag/BoQgigkAAhDQAAhBAjgmQAiglA6AAQAjAAAhAMIgIAVQgkgLgZAAQgxAAgZAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAkAAAggNIAAAWQgbANgoABQg5AAghglg");
	this.shape_821.setTransform(523.6,367.3,0.5,0.5);

	this.shape_822 = new cjs.Shape();
	this.shape_822.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAGAnIABAAQAbgsA9AAQA3AAAcAkQAdAkAABEQABBBgfAmQgeAlg0AAQg+AAgcgvIgDAAIADCkgAhDiWQgWAbABA6IAAAIQgBA/AVAbQAXAbAuAAQApAAAYgfQAWgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_822.setTransform(503.4,370.3,0.5,0.5);

	this.shape_823 = new cjs.Shape();
	this.shape_823.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_823.setTransform(492.5,364.9,0.5,0.5);

	this.shape_824 = new cjs.Shape();
	this.shape_824.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_824.setTransform(482.2,364.4,0.5,0.5);

	this.shape_825 = new cjs.Shape();
	this.shape_825.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgMAAgXQAAgVgRgOQgPgNgngOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQggAAgTALQgTAKAAAVQAAAUAPANQAPANAqAQQAoANAOAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2gBgggQg");
	this.shape_825.setTransform(468.6,367.3,0.5,0.5);

	this.shape_826 = new cjs.Shape();
	this.shape_826.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAVALQAXAMAPAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgGgpIgDAAQgeAug6AAQg4AAgdgjgAhBgeQgWAeAAA7QgBBzBZAAQAtAAAWgaQAWgbgBg9IAAgFQABg9gWgcQgUgbgvAAQgsAAgWAfg");
	this.shape_826.setTransform(454.7,364.5,0.5,0.5);

	this.shape_827 = new cjs.Shape();
	this.shape_827.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_827.setTransform(440.1,367.2,0.5,0.5);

	this.shape_828 = new cjs.Shape();
	this.shape_828.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAAUIjBAAQABA4AZAcQAZAeAvAAQAWAAASgDQAUgFAYgJIAAAWQgVAKgVAEQgWADgUABQg7AAghglgAg2hcQgYAbgEAvICmAAQAAgugUgbQgUgagkgBQgmABgYAZg");
	this.shape_828.setTransform(425.5,367.3,0.5,0.5);

	this.shape_829 = new cjs.Shape();
	this.shape_829.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_829.setTransform(415.6,364.9,0.5,0.5);

	this.shape_830 = new cjs.Shape();
	this.shape_830.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_830.setTransform(408.7,367.2,0.5,0.5);

	this.shape_831 = new cjs.Shape();
	this.shape_831.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACaICjAAIAAAYIijAAIAACig");
	this.shape_831.setTransform(397.6,365,0.5,0.5);

	this.shape_832 = new cjs.Shape();
	this.shape_832.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_832.setTransform(376.2,367.3,0.5,0.5);

	this.shape_833 = new cjs.Shape();
	this.shape_833.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAYAAAQAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgjAXg/AAQgzAAgcgTgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAghgTgTQgRgRghAAQghAAgSATg");
	this.shape_833.setTransform(356.6,370.3,0.5,0.5);

	this.shape_834 = new cjs.Shape();
	this.shape_834.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvAAgXAYQgWAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_834.setTransform(342.5,367.2,0.5,0.5);

	this.shape_835 = new cjs.Shape();
	this.shape_835.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_835.setTransform(332,364.9,0.5,0.5);

	this.shape_836 = new cjs.Shape();
	this.shape_836.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_836.setTransform(325,367.2,0.5,0.5);

	this.shape_837 = new cjs.Shape();
	this.shape_837.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAbAiQAdAhAAA5IAAAUIjCAAQAAA3AaAdQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgUAEQgXADgUABQg7AAggglgAg3hcQgYAagDAwICmAAQAAgvgUgaQgVgagkgBQglABgZAZg");
	this.shape_837.setTransform(312.2,367.3,0.5,0.5);

	this.shape_838 = new cjs.Shape();
	this.shape_838.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_838.setTransform(300.7,365.8,0.5,0.5);

	this.shape_839 = new cjs.Shape();
	this.shape_839.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgMAAgXQAAgVgRgOQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgOAAgTQgBgeAagSQAagRAtAAQArAAAoAQIgJAXQgogRgiAAQghAAgTALQgTAKAAAVQAAAUAOANQAPANAsAQQAmANAPAJQAPAKAKAPQAIANAAASQAAAlgcATQgbAUgyAAQg3gBgfgQg");
	this.shape_839.setTransform(290.6,367.3,0.5,0.5);

	this.shape_840 = new cjs.Shape();
	this.shape_840.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_840.setTransform(277.6,367.3,0.5,0.5);

	this.shape_841 = new cjs.Shape();
	this.shape_841.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlQIgCAAQACAcAAAkIAAEQIgXAAIAAlrIAmAAICBE/IABAAICBk/IAmAAIAAFrg");
	this.shape_841.setTransform(260.3,365,0.5,0.5);

	this.shape_842 = new cjs.Shape();
	this.shape_842.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgTBAgXA2g");
	this.shape_842.setTransform(239.5,374.3,0.5,0.5);

	this.shape_843 = new cjs.Shape();
	this.shape_843.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQAAA3AbAdQAZAeAuAAQAYAAARgDQASgEAbgKIAAAWQgVAKgWAEQgWADgVABQg6AAggglgAg3hcQgXAagEAwICmAAQAAgwgUgZQgVgagkgBQgmABgYAZg");
	this.shape_843.setTransform(230.2,367.3,0.5,0.5);

	this.shape_844 = new cjs.Shape();
	this.shape_844.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_844.setTransform(219.1,367.2,0.5,0.5);

	this.shape_845 = new cjs.Shape();
	this.shape_845.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAgglQAhglA3AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_845.setTransform(205.8,367.3,0.5,0.5);

	this.shape_846 = new cjs.Shape();
	this.shape_846.graphics.f("#000000").s().p("AgjDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgyASgXQARgXAqAAQAVAAAXAHIgFAVQgTgGgVAAQgcAAgMARQgMASAAAlIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_846.setTransform(195.4,364.3,0.5,0.5);

	this.shape_847 = new cjs.Shape();
	this.shape_847.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAXAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgWADgUABQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgVgagkgBQgmABgXAZg");
	this.shape_847.setTransform(183.7,367.3,0.5,0.5);

	this.shape_848 = new cjs.Shape();
	this.shape_848.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAWgLQAWgMAdAAQA4AAAeAkQAcAkAABDQAABEgeAlQgfAkg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_848.setTransform(169.5,364.5,0.5,0.5);

	this.shape_849 = new cjs.Shape();
	this.shape_849.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_849.setTransform(150.8,367.2,0.5,0.5);

	this.shape_850 = new cjs.Shape();
	this.shape_850.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgVAEQgWADgUABQg7AAghglgAg2hcQgYAagEAwICmAAQAAgwgVgZQgUgagkgBQgmABgXAZg");
	this.shape_850.setTransform(138,367.3,0.5,0.5);

	this.shape_851 = new cjs.Shape();
	this.shape_851.graphics.f("#000000").s().p("AgLCHIhpkOIAaAAIBGC4QAOAkAGAaIABAAQANgtAIgRIBGi4IAZAAIhpEOg");
	this.shape_851.setTransform(125.1,367.3,0.5,0.5);

	this.shape_852 = new cjs.Shape();
	this.shape_852.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AZAdQAaAeAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgVAEQgWADgUABQg7AAghglgAg2hcQgZAagDAwICmAAQAAgwgVgZQgUgagkgBQgmABgXAZg");
	this.shape_852.setTransform(112.3,367.3,0.5,0.5);

	this.shape_853 = new cjs.Shape();
	this.shape_853.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvAAgXAYQgWAZAAA2IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAagrBDAAQBdAAAABjIAACwg");
	this.shape_853.setTransform(97.8,367.2,0.5,0.5);

	this.shape_854 = new cjs.Shape();
	this.shape_854.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA0AAQAxgBAbAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAWAAASgDQAUgEAZgKIAAAWQgXAKgTAEQgXADgUABQg7AAggglgAg2hcQgYAbgEAvICnAAQgBgugUgbQgVgagkgBQglABgYAZg");
	this.shape_854.setTransform(76.6,367.3,0.5,0.5);

	this.shape_855 = new cjs.Shape();
	this.shape_855.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_855.setTransform(64.5,364.4,0.5,0.5);

	this.shape_856 = new cjs.Shape();
	this.shape_856.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_856.setTransform(54.4,364.9,0.5,0.5);

	this.shape_857 = new cjs.Shape();
	this.shape_857.graphics.f("#000000").s().p("AhiC2IAAlrIAYAAIAAFTICuAAIAAAYg");
	this.shape_857.setTransform(46,365,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_857},{t:this.shape_856},{t:this.shape_855},{t:this.shape_854},{t:this.shape_853},{t:this.shape_852},{t:this.shape_851},{t:this.shape_850},{t:this.shape_849},{t:this.shape_848},{t:this.shape_847},{t:this.shape_846},{t:this.shape_845},{t:this.shape_844},{t:this.shape_843},{t:this.shape_842},{t:this.shape_841},{t:this.shape_840},{t:this.shape_839},{t:this.shape_838},{t:this.shape_837},{t:this.shape_836},{t:this.shape_835},{t:this.shape_834},{t:this.shape_833},{t:this.shape_832},{t:this.shape_831},{t:this.shape_830},{t:this.shape_829},{t:this.shape_828},{t:this.shape_827},{t:this.shape_826},{t:this.shape_825},{t:this.shape_824},{t:this.shape_823},{t:this.shape_822},{t:this.shape_821},{t:this.shape_820},{t:this.shape_819},{t:this.shape_818},{t:this.shape_817},{t:this.shape_816},{t:this.shape_815},{t:this.shape_814},{t:this.shape_813},{t:this.shape_812},{t:this.shape_811},{t:this.shape_810},{t:this.shape_809},{t:this.shape_808},{t:this.shape_807},{t:this.shape_806},{t:this.shape_805},{t:this.shape_804},{t:this.shape_803},{t:this.shape_802},{t:this.shape_801},{t:this.shape_800},{t:this.shape_799},{t:this.shape_798},{t:this.shape_797},{t:this.shape_796},{t:this.shape_795},{t:this.shape_794},{t:this.shape_793},{t:this.shape_792},{t:this.shape_791},{t:this.shape_790},{t:this.shape_789},{t:this.shape_788},{t:this.shape_787},{t:this.shape_786},{t:this.shape_785},{t:this.shape_784},{t:this.shape_783},{t:this.shape_782},{t:this.shape_781},{t:this.shape_780},{t:this.shape_779},{t:this.shape_778},{t:this.shape_777},{t:this.shape_776},{t:this.shape_775},{t:this.shape_774},{t:this.shape_773},{t:this.shape_772},{t:this.shape_771},{t:this.shape_770},{t:this.shape_769},{t:this.shape_768},{t:this.shape_767},{t:this.shape_766},{t:this.shape_765},{t:this.shape_764},{t:this.shape_763},{t:this.shape_762},{t:this.shape_761},{t:this.shape_760},{t:this.shape_759},{t:this.shape_758},{t:this.shape_757},{t:this.shape_756},{t:this.shape_755},{t:this.shape_754},{t:this.shape_753},{t:this.shape_752},{t:this.shape_751},{t:this.shape_750},{t:this.shape_749},{t:this.shape_748},{t:this.shape_747},{t:this.shape_746},{t:this.shape_745},{t:this.shape_744},{t:this.shape_743},{t:this.shape_742},{t:this.shape_741},{t:this.shape_740},{t:this.shape_739},{t:this.shape_738},{t:this.shape_737},{t:this.shape_736},{t:this.shape_735},{t:this.shape_734},{t:this.shape_733},{t:this.shape_732},{t:this.shape_731},{t:this.shape_730},{t:this.shape_729},{t:this.shape_728},{t:this.shape_727},{t:this.shape_726},{t:this.shape_725},{t:this.shape_724},{t:this.shape_723},{t:this.shape_722},{t:this.shape_721},{t:this.shape_720},{t:this.shape_719},{t:this.shape_718},{t:this.shape_717},{t:this.shape_716},{t:this.shape_715},{t:this.shape_714},{t:this.shape_713},{t:this.shape_712},{t:this.shape_711},{t:this.shape_710},{t:this.shape_709},{t:this.shape_708},{t:this.shape_707},{t:this.shape_706},{t:this.shape_705},{t:this.shape_704},{t:this.shape_703},{t:this.shape_702},{t:this.shape_701},{t:this.shape_700},{t:this.shape_699},{t:this.shape_698},{t:this.shape_697},{t:this.shape_696},{t:this.shape_695},{t:this.shape_694},{t:this.shape_693},{t:this.shape_692},{t:this.shape_691},{t:this.shape_690},{t:this.shape_689},{t:this.shape_688},{t:this.shape_687},{t:this.shape_686},{t:this.shape_685},{t:this.shape_684},{t:this.shape_683},{t:this.shape_682},{t:this.shape_681},{t:this.shape_680},{t:this.shape_679},{t:this.shape_678},{t:this.shape_677},{t:this.shape_676},{t:this.shape_675},{t:this.shape_674},{t:this.shape_673},{t:this.shape_672},{t:this.shape_671},{t:this.shape_670},{t:this.shape_669},{t:this.shape_668},{t:this.shape_667},{t:this.shape_666},{t:this.shape_665},{t:this.shape_664},{t:this.shape_663},{t:this.shape_662},{t:this.shape_661},{t:this.shape_660},{t:this.shape_659},{t:this.shape_658},{t:this.shape_657},{t:this.shape_656},{t:this.shape_655},{t:this.shape_654},{t:this.shape_653},{t:this.shape_652},{t:this.shape_651},{t:this.shape_650},{t:this.shape_649},{t:this.shape_648},{t:this.shape_647},{t:this.shape_646},{t:this.shape_645},{t:this.shape_644},{t:this.shape_643},{t:this.shape_642},{t:this.shape_641},{t:this.shape_640},{t:this.shape_639},{t:this.shape_638},{t:this.shape_637},{t:this.shape_636},{t:this.shape_635},{t:this.shape_634},{t:this.shape_633},{t:this.shape_632},{t:this.shape_631},{t:this.shape_630},{t:this.shape_629},{t:this.shape_628},{t:this.shape_627},{t:this.shape_626},{t:this.shape_625},{t:this.shape_624},{t:this.shape_623},{t:this.shape_622},{t:this.shape_621},{t:this.shape_620},{t:this.shape_619},{t:this.shape_618},{t:this.shape_617},{t:this.shape_616},{t:this.shape_615},{t:this.shape_614},{t:this.shape_613},{t:this.shape_612},{t:this.shape_611},{t:this.shape_610},{t:this.shape_609},{t:this.shape_608},{t:this.shape_607},{t:this.shape_606},{t:this.shape_605},{t:this.shape_604},{t:this.shape_603},{t:this.shape_602},{t:this.shape_601},{t:this.shape_600},{t:this.shape_599},{t:this.shape_598},{t:this.shape_597},{t:this.shape_596},{t:this.shape_595},{t:this.shape_594},{t:this.shape_593},{t:this.shape_592},{t:this.shape_591},{t:this.shape_590},{t:this.shape_589},{t:this.shape_588},{t:this.shape_587},{t:this.shape_586},{t:this.shape_585},{t:this.shape_584},{t:this.shape_583},{t:this.shape_582},{t:this.shape_581},{t:this.shape_580},{t:this.shape_579},{t:this.shape_578},{t:this.shape_577},{t:this.shape_576},{t:this.shape_575},{t:this.shape_574},{t:this.shape_573},{t:this.shape_572},{t:this.shape_571},{t:this.shape_570},{t:this.shape_569},{t:this.shape_568},{t:this.shape_567},{t:this.shape_566},{t:this.shape_565},{t:this.shape_564},{t:this.shape_563},{t:this.shape_562}]},119).to({state:[]},1).wait(45));

	// ButtonLeftRight copy 56
	this.buttonR27 = new lib.ButtonLeft_Right();
	this.buttonR27.name = "buttonR27";
	this.buttonR27.parent = this;
	this.buttonR27.setTransform(2025,513.5,1,1,180);
	this.buttonR27._off = true;
	new cjs.ButtonHelper(this.buttonR27, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR27).wait(118).to({_off:false},0).to({_off:true},1).wait(46));

	// ButtonLeftRight copy 57
	this.buttonL27 = new lib.ButtonLeft_Right();
	this.buttonL27.name = "buttonL27";
	this.buttonL27.parent = this;
	this.buttonL27.setTransform(0,437.2);
	this.buttonL27._off = true;
	new cjs.ButtonHelper(this.buttonL27, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL27).wait(118).to({_off:false},0).to({_off:true},1).wait(46));

	// Layer 1
	this.instance_3 = new lib.mfa_logo();
	this.instance_3.parent = this;
	this.instance_3.setTransform(51,329,0.514,0.514);

	this.instance_4 = new lib.boston();
	this.instance_4.parent = this;
	this.instance_4.setTransform(832,-9);

	this.shape_858 = new cjs.Shape();
	this.shape_858.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_858.setTransform(638.3,615.3,0.5,0.5);

	this.shape_859 = new cjs.Shape();
	this.shape_859.graphics.f("#000000").s().p("AB8C3IgyiBIiUAAIgyCBIgcAAICSltIAQAAICPFtgAgNhjIgzCDICBAAIhAiuQgHAagHARg");
	this.shape_859.setTransform(627.6,607.1,0.5,0.5);

	this.shape_860 = new cjs.Shape();
	this.shape_860.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgXAAIAAlrIAnAAICAE/IABAAICBk/IAmAAIAAFrg");
	this.shape_860.setTransform(609,607.1,0.5,0.5);

	this.shape_861 = new cjs.Shape();
	this.shape_861.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAFQgTBCgXA1g");
	this.shape_861.setTransform(588.2,616.4,0.5,0.5);

	this.shape_862 = new cjs.Shape();
	this.shape_862.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_862.setTransform(578.4,609.3,0.5,0.5);

	this.shape_863 = new cjs.Shape();
	this.shape_863.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhglQAegkA4gBQA5AAAfAmQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg2gZghQgYgegtAAQgtAAgXAeg");
	this.shape_863.setTransform(563.3,609.5,0.5,0.5);

	this.shape_864 = new cjs.Shape();
	this.shape_864.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_864.setTransform(551.4,607.9,0.5,0.5);

	this.shape_865 = new cjs.Shape();
	this.shape_865.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgUAKAAAUQAAAVAQANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAUgzAAQg1AAghgQg");
	this.shape_865.setTransform(541.3,609.5,0.5,0.5);

	this.shape_866 = new cjs.Shape();
	this.shape_866.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAggkA4gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_866.setTransform(528,609.5,0.5,0.5);

	this.shape_867 = new cjs.Shape();
	this.shape_867.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBCAAAgAXQAgAXAAAuQAAAggTAVQgUAVglAGIAAABQAsAHAUAUQAVAUAAAmQAAAzghAbQgiAbg8AAgAhdCgIBVAAQBlAAAAhTQAAhKhqAAIhQAAgAhdgTIBQAAQAyAAAYgRQAXgRAAgkQAAglgagQQgagRg0AAIhJAAg");
	this.shape_867.setTransform(513.1,607.1,0.5,0.5);

	this.shape_868 = new cjs.Shape();
	this.shape_868.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_868.setTransform(490.4,609.3,0.5,0.5);

	this.shape_869 = new cjs.Shape();
	this.shape_869.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_869.setTransform(480,607,0.5,0.5);

	this.shape_870 = new cjs.Shape();
	this.shape_870.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgNABgWQgBgVgQgOQgRgOglgNQgogOgRgKQgQgMgIgNQgJgNABgTQAAgeAZgSQAagSAsAAQAtAAAnARIgJAWQgpgQgiAAQggAAgTALQgTAKgBAUQAAAVAPANQAPANAsAPQAiANATAKQAPAKAKAOQAIANAAATQAAAkgcATQgbAUgyAAQg1AAghgQg");
	this.shape_870.setTransform(464.4,609.5,0.5,0.5);

	this.shape_871 = new cjs.Shape();
	this.shape_871.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_871.setTransform(454.1,607.9,0.5,0.5);

	this.shape_872 = new cjs.Shape();
	this.shape_872.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_872.setTransform(446,609.3,0.5,0.5);

	this.shape_873 = new cjs.Shape();
	this.shape_873.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgMhjIgzCDICAAAIhAiuQgFAUgIAXg");
	this.shape_873.setTransform(432.5,607.1,0.5,0.5);

	this.shape_874 = new cjs.Shape();
	this.shape_874.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgWALgVACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgUgbglABQgmgBgXAag");
	this.shape_874.setTransform(411.2,609.5,0.5,0.5);

	this.shape_875 = new cjs.Shape();
	this.shape_875.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_875.setTransform(396.7,609.3,0.5,0.5);

	this.shape_876 = new cjs.Shape();
	this.shape_876.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAGQgDAHgIAAQgPAAAAgYg");
	this.shape_876.setTransform(386.3,607,0.5,0.5);

	this.shape_877 = new cjs.Shape();
	this.shape_877.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACbICjAAIAAAWIijAAIAACjg");
	this.shape_877.setTransform(378.1,607.1,0.5,0.5);

	this.shape_878 = new cjs.Shape();
	this.shape_878.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_878.setTransform(361,606.5,0.5,0.5);

	this.shape_879 = new cjs.Shape();
	this.shape_879.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAggkA4gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_879.setTransform(348.8,609.5,0.5,0.5);

	this.shape_880 = new cjs.Shape();
	this.shape_880.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAASAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_880.setTransform(323.6,609.3,0.5,0.5);

	this.shape_881 = new cjs.Shape();
	this.shape_881.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARASAkAAQAvAAAXgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_881.setTransform(304.6,609.6,0.5,0.5);

	this.shape_882 = new cjs.Shape();
	this.shape_882.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA5AYAdQAaAdAvAAQAXAAARgDQATgEAagLIAAAXQgXALgUACQgVAEgVAAQg6AAgigkgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_882.setTransform(290.2,609.5,0.5,0.5);

	this.shape_883 = new cjs.Shape();
	this.shape_883.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgOAAgVQAAgVgQgOQgRgOglgNQgogOgRgKQgPgLgJgOQgJgNABgTQAAgeAZgSQAagSAsAAQAtAAAnARIgJAWQgpgQgiAAQggAAgTALQgTAKgBAUQAAAVAPANQAPANAsAPQAjANARAKQARAKAIAOQAJANAAATQAAAkgcATQgbAUgyAAQg1AAghgQg");
	this.shape_883.setTransform(277.2,609.5,0.5,0.5);

	this.shape_884 = new cjs.Shape();
	this.shape_884.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASASAjAAQAvAAAXgYQAXgYAAg4IAAiUIAYAAIAAEOIgVAAIgEgmIgCAAQgaArhCAAQhcAAAAhjg");
	this.shape_884.setTransform(263.7,609.6,0.5,0.5);

	this.shape_885 = new cjs.Shape();
	this.shape_885.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_885.setTransform(245.3,607.1,0.5,0.5);

	this.shape_886 = new cjs.Shape();
	this.shape_886.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_886.setTransform(220.7,609.5,0.5,0.5);

	this.shape_887 = new cjs.Shape();
	this.shape_887.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_887.setTransform(206.2,606.5,0.5,0.5);

	this.shape_888 = new cjs.Shape();
	this.shape_888.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_888.setTransform(191.9,607.1,0.5,0.5);

	this.shape_889 = new cjs.Shape();
	this.shape_889.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_889.setTransform(175.7,606.5,0.5,0.5);

	this.shape_890 = new cjs.Shape();
	this.shape_890.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAggkA4gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_890.setTransform(163.5,609.5,0.5,0.5);

	this.shape_891 = new cjs.Shape();
	this.shape_891.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_891.setTransform(142,609.3,0.5,0.5);

	this.shape_892 = new cjs.Shape();
	this.shape_892.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAggkA3gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_892.setTransform(126.9,609.5,0.5,0.5);

	this.shape_893 = new cjs.Shape();
	this.shape_893.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_893.setTransform(116.6,607,0.5,0.5);

	this.shape_894 = new cjs.Shape();
	this.shape_894.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_894.setTransform(109.2,607.9,0.5,0.5);

	this.shape_895 = new cjs.Shape();
	this.shape_895.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAkAAAfANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAlAAAggOIAAAXQgbANgpAAQg5AAghglg");
	this.shape_895.setTransform(99.4,609.5,0.5,0.5);

	this.shape_896 = new cjs.Shape();
	this.shape_896.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAggmQAfgoA2AAQAvAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAuAAQAZAAARgDQASgEAagLIAAAXQgXALgUACQgUAEgXAAQg5AAgigkgAg2hcQgZAbgDAwICmAAQABgwgVgaQgUgbgkABQgngBgXAag");
	this.shape_896.setTransform(86,609.5,0.5,0.5);

	this.shape_897 = new cjs.Shape();
	this.shape_897.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_897.setTransform(76.1,606.5,0.5,0.5);

	this.shape_898 = new cjs.Shape();
	this.shape_898.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_898.setTransform(70.4,606.5,0.5,0.5);

	this.shape_899 = new cjs.Shape();
	this.shape_899.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_899.setTransform(60,609.5,0.5,0.5);

	this.shape_900 = new cjs.Shape();
	this.shape_900.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAjAAAgANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAlAAAfgOIAAAXQgaANgqAAQg5AAggglg");
	this.shape_900.setTransform(46.8,609.5,0.5,0.5);

	this.shape_901 = new cjs.Shape();
	this.shape_901.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_901.setTransform(731.4,569.7,0.5,0.5);

	this.shape_902 = new cjs.Shape();
	this.shape_902.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_902.setTransform(719.9,571.1,0.5,0.5);

	this.shape_903 = new cjs.Shape();
	this.shape_903.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_903.setTransform(705.3,571.2,0.5,0.5);

	this.shape_904 = new cjs.Shape();
	this.shape_904.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_904.setTransform(690.8,571.1,0.5,0.5);

	this.shape_905 = new cjs.Shape();
	this.shape_905.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_905.setTransform(676,571.2,0.5,0.5);

	this.shape_906 = new cjs.Shape();
	this.shape_906.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgPgSQgQgSggAAQgpABgUAWQgVAYAAAwIAACeIgXAAIAAi4QAAhFg/AAQgqAAgUAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQALgUAVgLQAUgLAZAAQBAAAARAwIACAAQANgYAWgMQAWgMAcAAQAtAAAWAXQAXAYgBA0IAACwg");
	this.shape_906.setTransform(658.5,571.1,0.5,0.5);

	this.shape_907 = new cjs.Shape();
	this.shape_907.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_907.setTransform(643.1,571.1,0.5,0.5);

	this.shape_908 = new cjs.Shape();
	this.shape_908.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAg/AfgnQAhgoA1AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQAAA5AaAdQAZAdAvAAQAXAAARgDQATgEAagLIAAAXQgYALgSACQgWAEgVAAQg6AAghgkgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgUgbgkABQgmgBgZAag");
	this.shape_908.setTransform(630.3,571.2,0.5,0.5);

	this.shape_909 = new cjs.Shape();
	this.shape_909.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAmIACAAQAcgrA8AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAaAAA7IAAAIQAAA+AVAbQAWAcAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_909.setTransform(616.1,574.1,0.5,0.5);

	this.shape_910 = new cjs.Shape();
	this.shape_910.graphics.f("#000000").s().p("AhNBoQghglAAhBQAAg/AhgnQAggoA0AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAYAAASgDQASgEAagLIAAAXQgXALgUACQgVAEgWAAQg5AAgigkgAg2hcQgYAZgEAyICnAAQAAgwgVgaQgUgbglABQglgBgYAag");
	this.shape_910.setTransform(594.5,571.2,0.5,0.5);

	this.shape_911 = new cjs.Shape();
	this.shape_911.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQARgZAWgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_911.setTransform(580,568.3,0.5,0.5);

	this.shape_912 = new cjs.Shape();
	this.shape_912.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_912.setTransform(568,569.7,0.5,0.5);

	this.shape_913 = new cjs.Shape();
	this.shape_913.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgeAAgMARQgLASAAAlIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_913.setTransform(554.3,568.2,0.5,0.5);

	this.shape_914 = new cjs.Shape();
	this.shape_914.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAggkA3gBQA4AAAgAmQAgAlAABBQAABBggAmQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgZgegsAAQgtAAgYAeg");
	this.shape_914.setTransform(542.2,571.2,0.5,0.5);

	this.shape_915 = new cjs.Shape();
	this.shape_915.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_915.setTransform(523.6,569.7,0.5,0.5);

	this.shape_916 = new cjs.Shape();
	this.shape_916.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAASADIgEAYQgPgEgUAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_916.setTransform(515.5,571.1,0.5,0.5);

	this.shape_917 = new cjs.Shape();
	this.shape_917.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_917.setTransform(502.4,571.2,0.5,0.5);

	this.shape_918 = new cjs.Shape();
	this.shape_918.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_918.setTransform(488.9,574.1,0.5,0.5);

	this.shape_919 = new cjs.Shape();
	this.shape_919.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgUAKAAAUQAAAVAQANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgbAUgyAAQg1AAghgQg");
	this.shape_919.setTransform(468.3,571.2,0.5,0.5);

	this.shape_920 = new cjs.Shape();
	this.shape_920.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_920.setTransform(459.5,568.7,0.5,0.5);

	this.shape_921 = new cjs.Shape();
	this.shape_921.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_921.setTransform(445,568.3,0.5,0.5);

	this.shape_922 = new cjs.Shape();
	this.shape_922.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_922.setTransform(433.6,571.1,0.5,0.5);

	this.shape_923 = new cjs.Shape();
	this.shape_923.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAggkA3gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_923.setTransform(420.3,571.2,0.5,0.5);

	this.shape_924 = new cjs.Shape();
	this.shape_924.graphics.f("#000000").s().p("ABNCHIg7izQgHgWgHghIgCAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA3AGAfIACAAQANg2AIgYIA4ijIAVAAIA1CjQATA8ADASIACAAQABgOAThJIApiaIAZAAIhKENg");
	this.shape_924.setTransform(403.6,571.2,0.5,0.5);

	this.shape_925 = new cjs.Shape();
	this.shape_925.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_925.setTransform(383.7,571.1,0.5,0.5);

	this.shape_926 = new cjs.Shape();
	this.shape_926.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_926.setTransform(375,568.7,0.5,0.5);

	this.shape_927 = new cjs.Shape();
	this.shape_927.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvAAAcAiQAbAiAAA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgUACQgUAEgXAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgwgUgaQgVgbgjABQgngBgXAag");
	this.shape_927.setTransform(365.1,571.2,0.5,0.5);

	this.shape_928 = new cjs.Shape();
	this.shape_928.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIADAAQAPgZAXgKQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_928.setTransform(350.6,568.3,0.5,0.5);

	this.shape_929 = new cjs.Shape();
	this.shape_929.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_929.setTransform(338.6,569.7,0.5,0.5);

	this.shape_930 = new cjs.Shape();
	this.shape_930.graphics.f("#000000").s().p("AgeCmQAJggAHgdQAIglAEgbIAcAAIADAFQgTBBgYA3gAgDh6QgFgFAAgOQAAgYASAAQAVAAAAAYQAAANgGAGQgFAGgKAAQgIAAgFgGg");
	this.shape_930.setTransform(324.3,573,0.5,0.5);

	this.shape_931 = new cjs.Shape();
	this.shape_931.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAHgLALgcIAOgkIhokOIAZAAIA5CYQAbBFAGAZIABAAQAKggAZg/IA4iXIAaAAIh4E6QgOAlgLAPQgJANgPAHQgNAHgSAAQgOAAgSgGg");
	this.shape_931.setTransform(316,574.3,0.5,0.5);

	this.shape_932 = new cjs.Shape();
	this.shape_932.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_932.setTransform(307.2,568.3,0.5,0.5);

	this.shape_933 = new cjs.Shape();
	this.shape_933.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_933.setTransform(301.4,568.3,0.5,0.5);

	this.shape_934 = new cjs.Shape();
	this.shape_934.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_934.setTransform(291.4,571.2,0.5,0.5);

	this.shape_935 = new cjs.Shape();
	this.shape_935.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgvAAgXAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAcgqBCAAQBbAAABBjIAACwg");
	this.shape_935.setTransform(277.6,571.1,0.5,0.5);

	this.shape_936 = new cjs.Shape();
	this.shape_936.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAggkA4gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_936.setTransform(262.5,571.2,0.5,0.5);

	this.shape_937 = new cjs.Shape();
	this.shape_937.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_937.setTransform(252.2,568.7,0.5,0.5);

	this.shape_938 = new cjs.Shape();
	this.shape_938.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_938.setTransform(244.9,569.7,0.5,0.5);

	this.shape_939 = new cjs.Shape();
	this.shape_939.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_939.setTransform(233.6,571.2,0.5,0.5);

	this.shape_940 = new cjs.Shape();
	this.shape_940.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_940.setTransform(219.8,571.1,0.5,0.5);

	this.shape_941 = new cjs.Shape();
	this.shape_941.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhHAegkQAdglA2AAQAeAAAWALQAUAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgbQAVgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_941.setTransform(197.6,568.4,0.5,0.5);

	this.shape_942 = new cjs.Shape();
	this.shape_942.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgmQAggoA1AAQAxAAAaAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgTACQgWAEgVAAQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgkABQglgBgZAag");
	this.shape_942.setTransform(183.4,571.2,0.5,0.5);

	this.shape_943 = new cjs.Shape();
	this.shape_943.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_943.setTransform(172,569.7,0.5,0.5);

	this.shape_944 = new cjs.Shape();
	this.shape_944.graphics.f("#000000").s().p("AhABnQgggkAAhCQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgigLgbAAQgxAAgaAeQgaAgAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgOIAAAXQgaANgqAAQg5AAghglg");
	this.shape_944.setTransform(162.1,571.2,0.5,0.5);

	this.shape_945 = new cjs.Shape();
	this.shape_945.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgVALgUACQgWAEgVAAQg6AAghgkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgVgbgkABQgmgBgXAag");
	this.shape_945.setTransform(148.8,571.2,0.5,0.5);

	this.shape_946 = new cjs.Shape();
	this.shape_946.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_946.setTransform(134.6,574.1,0.5,0.5);

	this.shape_947 = new cjs.Shape();
	this.shape_947.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgUAKAAAUQAAAVAQANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAUgzAAQg1AAghgQg");
	this.shape_947.setTransform(120.6,571.2,0.5,0.5);

	this.shape_948 = new cjs.Shape();
	this.shape_948.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AZAeQAaAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgUACQgUAEgWAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgxgVgZQgUgbgkABQgmgBgXAag");
	this.shape_948.setTransform(107.7,571.2,0.5,0.5);

	this.shape_949 = new cjs.Shape();
	this.shape_949.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_949.setTransform(96.6,571.1,0.5,0.5);

	this.shape_950 = new cjs.Shape();
	this.shape_950.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA3AAQAdAAAWALQAUAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgeAug7AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_950.setTransform(76.2,568.4,0.5,0.5);

	this.shape_951 = new cjs.Shape();
	this.shape_951.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_951.setTransform(61.6,571.1,0.5,0.5);

	this.shape_952 = new cjs.Shape();
	this.shape_952.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_952.setTransform(46.7,571.2,0.5,0.5);

	this.shape_953 = new cjs.Shape();
	this.shape_953.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQALgHAHgMQAHgKALgdIAOgkIhokOIAZAAIA6CYQAcBNAFARIAAAAQAOgqAUg1IA6iXIAZAAIh4E6QgPAngKANQgKANgNAHQgOAHgSAAQgOAAgSgGg");
	this.shape_953.setTransform(688.8,536,0.5,0.5);

	this.shape_954 = new cjs.Shape();
	this.shape_954.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_954.setTransform(678.5,531.4,0.5,0.5);

	this.shape_955 = new cjs.Shape();
	this.shape_955.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_955.setTransform(671.5,530.5,0.5,0.5);

	this.shape_956 = new cjs.Shape();
	this.shape_956.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_956.setTransform(661.2,532.8,0.5,0.5);

	this.shape_957 = new cjs.Shape();
	this.shape_957.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARASAkAAQAvAAAXgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_957.setTransform(646,533.1,0.5,0.5);

	this.shape_958 = new cjs.Shape();
	this.shape_958.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_958.setTransform(627.4,532.8,0.5,0.5);

	this.shape_959 = new cjs.Shape();
	this.shape_959.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgpABgUAWQgVAYABAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQALgUAVgLQAUgLAaAAQA/AAASAwIABAAQAOgYAVgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_959.setTransform(604.9,532.8,0.5,0.5);

	this.shape_960 = new cjs.Shape();
	this.shape_960.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_960.setTransform(586,533,0.5,0.5);

	this.shape_961 = new cjs.Shape();
	this.shape_961.graphics.f("#000000").s().p("AhABnQgggkAAhCQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAlAAAfgOIAAAXQgaANgqAAQg5AAghglg");
	this.shape_961.setTransform(572.8,533,0.5,0.5);

	this.shape_962 = new cjs.Shape();
	this.shape_962.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAHgLALgcIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgQAngJANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_962.setTransform(554,536,0.5,0.5);

	this.shape_963 = new cjs.Shape();
	this.shape_963.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_963.setTransform(544.1,532.8,0.5,0.5);

	this.shape_964 = new cjs.Shape();
	this.shape_964.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_964.setTransform(535.3,530,0.5,0.5);

	this.shape_965 = new cjs.Shape();
	this.shape_965.graphics.f("#000000").s().p("AhNBoQggglgBhBQABg/AggnQAggoA1AAQAvAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAuAAQAZAAARgDQASgEAagLIAAAXQgXALgUACQgVAEgWAAQg5AAgigkgAg3hcQgXAbgEAwICmAAQABgwgVgaQgUgbgkABQgmgBgZAag");
	this.shape_965.setTransform(525.5,533,0.5,0.5);

	this.shape_966 = new cjs.Shape();
	this.shape_966.graphics.f("#000000").s().p("ABNCHIg7izIgPg3IgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA4AFAeIABAAQAQg+AGgQIA4ijIAVAAIA1CjQASA8AEASIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_966.setTransform(509.2,533,0.5,0.5);

	this.shape_967 = new cjs.Shape();
	this.shape_967.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgVALgUACQgWAEgVAAQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgkABQgmgBgYAag");
	this.shape_967.setTransform(493,533,0.5,0.5);

	this.shape_968 = new cjs.Shape();
	this.shape_968.graphics.f("#000000").s().p("AgwDwIAAgWQAQAFAQAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAhgQATQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgQAAAAgYg");
	this.shape_968.setTransform(481.5,533.5,0.5,0.5);

	this.shape_969 = new cjs.Shape();
	this.shape_969.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_969.setTransform(469.2,531.4,0.5,0.5);

	this.shape_970 = new cjs.Shape();
	this.shape_970.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_970.setTransform(461,532.8,0.5,0.5);

	this.shape_971 = new cjs.Shape();
	this.shape_971.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_971.setTransform(448,533,0.5,0.5);

	this.shape_972 = new cjs.Shape();
	this.shape_972.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_972.setTransform(428,533,0.5,0.5);

	this.shape_973 = new cjs.Shape();
	this.shape_973.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_973.setTransform(413.6,530,0.5,0.5);

	this.shape_974 = new cjs.Shape();
	this.shape_974.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_974.setTransform(401.5,531.4,0.5,0.5);

	this.shape_975 = new cjs.Shape();
	this.shape_975.graphics.f("#000000").s().p("ABTCKIAAivQgBgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_975.setTransform(383.4,532.8,0.5,0.5);

	this.shape_976 = new cjs.Shape();
	this.shape_976.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_976.setTransform(372.9,530.5,0.5,0.5);

	this.shape_977 = new cjs.Shape();
	this.shape_977.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgOABgVQAAgVgRgOQgQgOgmgNQgogOgRgKQgPgLgJgOQgIgNAAgTQgBgeAagSQAagSAtAAQAsAAAnARIgJAWQgpgQghAAQghAAgTALQgTAKAAAUQAAAVAOANQAPANAsAPQAjANASAKQAQAKAIAOQAJAOAAASQAAAkgcATQgbAUgyAAQg2AAgggQg");
	this.shape_977.setTransform(357.4,533,0.5,0.5);

	this.shape_978 = new cjs.Shape();
	this.shape_978.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_978.setTransform(347.4,532.8,0.5,0.5);

	this.shape_979 = new cjs.Shape();
	this.shape_979.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_979.setTransform(334.1,533,0.5,0.5);

	this.shape_980 = new cjs.Shape();
	this.shape_980.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_980.setTransform(322.2,531.4,0.5,0.5);

	this.shape_981 = new cjs.Shape();
	this.shape_981.graphics.f("#000000").s().p("AhABnQghgjAAhDQABhBAhgmQAjgmA6AAQAkAAAfANIgHAVQgigLgbAAQgxAAgZAeQgZAfgBA5QABA3AZAfQAZAfAuAAQAkAAAhgOIAAAXQgbANgqAAQg5AAghglg");
	this.shape_981.setTransform(312.4,533,0.5,0.5);

	this.shape_982 = new cjs.Shape();
	this.shape_982.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggoA0AAQAxAAAbAiQAbAhABA5IAAATIjDAAQABA5AaAdQAZAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgWAEgWAAQg5AAghgkgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgbglABQgmgBgYAag");
	this.shape_982.setTransform(299,533,0.5,0.5);

	this.shape_983 = new cjs.Shape();
	this.shape_983.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_983.setTransform(289.1,530,0.5,0.5);

	this.shape_984 = new cjs.Shape();
	this.shape_984.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_984.setTransform(283.4,530,0.5,0.5);

	this.shape_985 = new cjs.Shape();
	this.shape_985.graphics.f("#000000").s().p("Ag+B7QgbgRgQggQgOghAAgpQAAhCAgglQAggkA4gBQA4AAAfAmQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgbgRgAhFhXQgYAfAAA4QAAA3AYAgQAaAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_985.setTransform(273,533,0.5,0.5);

	this.shape_986 = new cjs.Shape();
	this.shape_986.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAkAAAfANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAlAAAfgOIAAAXQgaANgqAAQg5AAggglg");
	this.shape_986.setTransform(259.8,533,0.5,0.5);

	this.shape_987 = new cjs.Shape();
	this.shape_987.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA3AAQAdAAAVALQAVAKASAaIACAAQgCgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgeAug7AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_987.setTransform(238.8,530.2,0.5,0.5);

	this.shape_988 = new cjs.Shape();
	this.shape_988.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_988.setTransform(224.2,532.8,0.5,0.5);

	this.shape_989 = new cjs.Shape();
	this.shape_989.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_989.setTransform(209.4,533,0.5,0.5);

	this.shape_990 = new cjs.Shape();
	this.shape_990.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgUAKAAAUQAAAVAQANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAUgzAAQg1AAghgQg");
	this.shape_990.setTransform(190.4,533,0.5,0.5);

	this.shape_991 = new cjs.Shape();
	this.shape_991.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_991.setTransform(180.1,531.4,0.5,0.5);

	this.shape_992 = new cjs.Shape();
	this.shape_992.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgJAWQgpgQghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARALAIANQAIAOAAASQAAAjgbAUQgcAUgyAAQg1AAghgQg");
	this.shape_992.setTransform(170,533,0.5,0.5);

	this.shape_993 = new cjs.Shape();
	this.shape_993.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_993.setTransform(161.3,530.5,0.5,0.5);

	this.shape_994 = new cjs.Shape();
	this.shape_994.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_994.setTransform(153.9,531.4,0.5,0.5);

	this.shape_995 = new cjs.Shape();
	this.shape_995.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_995.setTransform(145.8,532.8,0.5,0.5);

	this.shape_996 = new cjs.Shape();
	this.shape_996.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_996.setTransform(132.7,533,0.5,0.5);

	this.shape_997 = new cjs.Shape();
	this.shape_997.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgKAAgMQAAgaAigVQgXgIgOgWQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgIgBQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQASARAhAAQAhAAASgRQASgRAAghQAAgigTgSQgRgRghAAQghAAgSATg");
	this.shape_997.setTransform(113.1,535.9,0.5,0.5);

	this.shape_998 = new cjs.Shape();
	this.shape_998.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_998.setTransform(99,532.8,0.5,0.5);

	this.shape_999 = new cjs.Shape();
	this.shape_999.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAggkA3gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_999.setTransform(83.9,533,0.5,0.5);

	this.shape_1000 = new cjs.Shape();
	this.shape_1000.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgpABgVAWQgTAYAAAwIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_1000.setTransform(65.3,532.8,0.5,0.5);

	this.shape_1001 = new cjs.Shape();
	this.shape_1001.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1001.setTransform(46.7,533,0.5,0.5);

	this.shape_1002 = new cjs.Shape();
	this.shape_1002.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_1002.setTransform(710.4,491.9,0.5,0.5);

	this.shape_1003 = new cjs.Shape();
	this.shape_1003.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAgigkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_1003.setTransform(696.2,494.7,0.5,0.5);

	this.shape_1004 = new cjs.Shape();
	this.shape_1004.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1004.setTransform(685.1,494.6,0.5,0.5);

	this.shape_1005 = new cjs.Shape();
	this.shape_1005.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AZAeQAaAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgUACQgUAEgWAAQg6AAgigkgAg2hcQgYAagEAxICmAAQAAgxgVgZQgTgbglABQgmgBgXAag");
	this.shape_1005.setTransform(672.3,494.7,0.5,0.5);

	this.shape_1006 = new cjs.Shape();
	this.shape_1006.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC2QANAjAHAbIABAAQANgsAIgSIBGi2IAZAAIhpENg");
	this.shape_1006.setTransform(659.4,494.7,0.5,0.5);

	this.shape_1007 = new cjs.Shape();
	this.shape_1007.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAaAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgXALgUACQgUAEgWAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgxgUgZQgVgbgkABQgmgBgXAag");
	this.shape_1007.setTransform(646.6,494.7,0.5,0.5);

	this.shape_1008 = new cjs.Shape();
	this.shape_1008.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1008.setTransform(635.5,494.6,0.5,0.5);

	this.shape_1009 = new cjs.Shape();
	this.shape_1009.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgTAKAAAUQAAAVAPANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAUgyAAQg1AAghgQg");
	this.shape_1009.setTransform(617,494.7,0.5,0.5);

	this.shape_1010 = new cjs.Shape();
	this.shape_1010.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_1010.setTransform(608.3,492.2,0.5,0.5);

	this.shape_1011 = new cjs.Shape();
	this.shape_1011.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAJgGAJgNQAJgOAJgZIAOgkIhokOIAZAAIA5CYQAbBFAGAZIABAAQAKggAZg/IA4iXIAaAAIh4E6QgOAlgLAPQgJAMgOAIQgOAHgSAAQgOAAgSgGg");
	this.shape_1011.setTransform(592.9,497.8,0.5,0.5);

	this.shape_1012 = new cjs.Shape();
	this.shape_1012.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_1012.setTransform(583,494.6,0.5,0.5);

	this.shape_1013 = new cjs.Shape();
	this.shape_1013.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1013.setTransform(574.3,491.8,0.5,0.5);

	this.shape_1014 = new cjs.Shape();
	this.shape_1014.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgUgbglABQgmgBgXAag");
	this.shape_1014.setTransform(564.4,494.7,0.5,0.5);

	this.shape_1015 = new cjs.Shape();
	this.shape_1015.graphics.f("#000000").s().p("ABNCHIg7izQgGgUgJgjIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA3AGAfIACAAQAOg6AHgUIA4ijIAVAAIA1CjQAQAyAGAcIACAAQABgMAShLIAqiaIAZAAIhKENg");
	this.shape_1015.setTransform(548.2,494.7,0.5,0.5);

	this.shape_1016 = new cjs.Shape();
	this.shape_1016.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAg/AfgnQAhgoA1AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQABA4AZAeQAZAdAvAAQAXAAARgDQATgEAagLIAAAXQgYALgSACQgWAEgVAAQg6AAghgkgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgUgbgkABQgmgBgZAag");
	this.shape_1016.setTransform(532,494.7,0.5,0.5);

	this.shape_1017 = new cjs.Shape();
	this.shape_1017.graphics.f("#000000").s().p("AgwDwIAAgWQAQAFAQAAQAkAAAAgrIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgQAAAAgYg");
	this.shape_1017.setTransform(520.4,495.3,0.5,0.5);

	this.shape_1018 = new cjs.Shape();
	this.shape_1018.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgUACQgVAEgVAAQg6AAgigkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgVgbgkABQgmgBgXAag");
	this.shape_1018.setTransform(505.6,494.7,0.5,0.5);

	this.shape_1019 = new cjs.Shape();
	this.shape_1019.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA3AAQAdAAAVALQAVAKASAaIACAAQgCgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgeAug7AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_1019.setTransform(490.6,491.9,0.5,0.5);

	this.shape_1020 = new cjs.Shape();
	this.shape_1020.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1020.setTransform(476.2,494.7,0.5,0.5);

	this.shape_1021 = new cjs.Shape();
	this.shape_1021.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgpABgUAWQgUAYAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAMgUAUgLQAUgLAZAAQBBAAARAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_1021.setTransform(458.7,494.6,0.5,0.5);

	this.shape_1022 = new cjs.Shape();
	this.shape_1022.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA2AAQAeAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_1022.setTransform(439.4,491.9,0.5,0.5);

	this.shape_1023 = new cjs.Shape();
	this.shape_1023.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_1023.setTransform(424.8,494.6,0.5,0.5);

	this.shape_1024 = new cjs.Shape();
	this.shape_1024.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1024.setTransform(409.9,494.7,0.5,0.5);

	this.shape_1025 = new cjs.Shape();
	this.shape_1025.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAQgZAXgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_1025.setTransform(396.2,491.8,0.5,0.5);

	this.shape_1026 = new cjs.Shape();
	this.shape_1026.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1026.setTransform(374.5,494.6,0.5,0.5);

	this.shape_1027 = new cjs.Shape();
	this.shape_1027.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_1027.setTransform(364.1,492.2,0.5,0.5);

	this.shape_1028 = new cjs.Shape();
	this.shape_1028.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAJgGQAKgGAIgNQAHgLALgcIANgkIhnkOIAZAAIA5CYQAbBFAHAZIAAAAIAihfIA5iXIAaAAIh5E6QgOAlgKAPQgJANgPAHQgNAHgSAAQgOAAgSgGg");
	this.shape_1028.setTransform(348.7,497.8,0.5,0.5);

	this.shape_1029 = new cjs.Shape();
	this.shape_1029.graphics.f("#000000").s().p("AhABnQgggjAAhDQgBhBAjgmQAigmA6AAQAkAAAfANIgGAVQgjgLgaAAQgxAAgaAeQgZAgAAA4QAAA3AZAfQAbAfAsAAQAlAAAfgNIAAAWQgaANgpAAQg6AAghglg");
	this.shape_1029.setTransform(337.1,494.7,0.5,0.5);

	this.shape_1030 = new cjs.Shape();
	this.shape_1030.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1030.setTransform(323.5,494.7,0.5,0.5);

	this.shape_1031 = new cjs.Shape();
	this.shape_1031.graphics.f("#000000").s().p("AheCzQgcgTAAgjQABgcARgTQARgSAdgHQgMgFgHgKQgIgJAAgNQAAgaAjgVQgYgJgNgVQgNgUAAgcQAAgnAagaQAagYArAAQAaAAAPAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgTAAgHgBQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAWASQAYARAAAkQAAArgjAXQgjAXg+AAQg0AAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgSgLgkAAIgrAAQhLAAAAA6gAg5igQgSASAAAhQAAAfATASQATARAgAAQAhAAASgRQASgRAAghQAAgjgSgRQgTgRghAAQggAAgTATg");
	this.shape_1031.setTransform(310.6,497.6,0.5,0.5);

	this.shape_1032 = new cjs.Shape();
	this.shape_1032.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAbAdAuAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_1032.setTransform(296.9,494.7,0.5,0.5);

	this.shape_1033 = new cjs.Shape();
	this.shape_1033.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_1033.setTransform(287,491.8,0.5,0.5);

	this.shape_1034 = new cjs.Shape();
	this.shape_1034.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgOABgVQAAgVgRgOQgQgOgmgNQgogOgQgKQgRgLgIgOQgIgMAAgUQgBgeAagSQAagSAtAAQArAAAoARIgJAWQgqgQggAAQghAAgTALQgTAKAAAUQAAAVAOANQAPANAsAPQAkAOARAJQAQAKAJAOQAIAOAAASQAAAkgcATQgbAUgyAAQg2AAgggQg");
	this.shape_1034.setTransform(271.5,494.7,0.5,0.5);

	this.shape_1035 = new cjs.Shape();
	this.shape_1035.graphics.f("#000000").s().p("AgdA/QAHgWAJgnIAMhAIAcAAIADAGQgTA/gXA4g");
	this.shape_1035.setTransform(263.8,486.4,0.5,0.5);

	this.shape_1036 = new cjs.Shape();
	this.shape_1036.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1036.setTransform(259,491.8,0.5,0.5);

	this.shape_1037 = new cjs.Shape();
	this.shape_1037.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_1037.setTransform(249.2,494.7,0.5,0.5);

	this.shape_1038 = new cjs.Shape();
	this.shape_1038.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_1038.setTransform(234.7,491.8,0.5,0.5);

	this.shape_1039 = new cjs.Shape();
	this.shape_1039.graphics.f("#000000").s().p("Ag/BnQgigjAAhDQABhBAigmQAigmA6AAQAjAAAhANIgHAVQghgLgdAAQgwAAgaAeQgaAgAAA4QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgbANgoAAQg5AAghglg");
	this.shape_1039.setTransform(221.4,494.7,0.5,0.5);

	this.shape_1040 = new cjs.Shape();
	this.shape_1040.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_1040.setTransform(212.1,492.2,0.5,0.5);

	this.shape_1041 = new cjs.Shape();
	this.shape_1041.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgOAAIiIlPIgDAAQACAbABAkIAAEQIgYAAIAAlrIAmAAICBE/IABAAICBk/IAmAAIAAFrg");
	this.shape_1041.setTransform(198.3,492.4,0.5,0.5);

	this.shape_1042 = new cjs.Shape();
	this.shape_1042.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAUAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgbQAVgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_1042.setTransform(172.6,491.9,0.5,0.5);

	this.shape_1043 = new cjs.Shape();
	this.shape_1043.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1043.setTransform(158,494.6,0.5,0.5);

	this.shape_1044 = new cjs.Shape();
	this.shape_1044.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1044.setTransform(143.2,494.7,0.5,0.5);

	this.shape_1045 = new cjs.Shape();
	this.shape_1045.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAWQgogQgiAAQggAAgTALQgUAKAAAUQAAAVAPANQAQANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgbAUgyAAQg1AAghgQg");
	this.shape_1045.setTransform(124.2,494.7,0.5,0.5);

	this.shape_1046 = new cjs.Shape();
	this.shape_1046.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1046.setTransform(110.9,494.6,0.5,0.5);

	this.shape_1047 = new cjs.Shape();
	this.shape_1047.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_1047.setTransform(100.5,492.2,0.5,0.5);

	this.shape_1048 = new cjs.Shape();
	this.shape_1048.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqByIBzCcg");
	this.shape_1048.setTransform(92.5,491.8,0.5,0.5);

	this.shape_1049 = new cjs.Shape();
	this.shape_1049.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_1049.setTransform(80.8,493.2,0.5,0.5);

	this.shape_1050 = new cjs.Shape();
	this.shape_1050.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_1050.setTransform(69.5,494.7,0.5,0.5);

	this.shape_1051 = new cjs.Shape();
	this.shape_1051.graphics.f("#000000").s().p("ABdC2IhelRQgCANgJAlIhQEfIgWAAIhklrIAbAAIBVFDQAFghAUhGIA/jcIAbAAIBJD8QANAtAFAaIBVlDIAaAAIhlFrg");
	this.shape_1051.setTransform(51.8,492.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1051},{t:this.shape_1050},{t:this.shape_1049},{t:this.shape_1048},{t:this.shape_1047},{t:this.shape_1046},{t:this.shape_1045},{t:this.shape_1044},{t:this.shape_1043},{t:this.shape_1042},{t:this.shape_1041},{t:this.shape_1040},{t:this.shape_1039},{t:this.shape_1038},{t:this.shape_1037},{t:this.shape_1036},{t:this.shape_1035},{t:this.shape_1034},{t:this.shape_1033},{t:this.shape_1032},{t:this.shape_1031},{t:this.shape_1030},{t:this.shape_1029},{t:this.shape_1028},{t:this.shape_1027},{t:this.shape_1026},{t:this.shape_1025},{t:this.shape_1024},{t:this.shape_1023},{t:this.shape_1022},{t:this.shape_1021},{t:this.shape_1020},{t:this.shape_1019},{t:this.shape_1018},{t:this.shape_1017},{t:this.shape_1016},{t:this.shape_1015},{t:this.shape_1014},{t:this.shape_1013},{t:this.shape_1012},{t:this.shape_1011},{t:this.shape_1010},{t:this.shape_1009},{t:this.shape_1008},{t:this.shape_1007},{t:this.shape_1006},{t:this.shape_1005},{t:this.shape_1004},{t:this.shape_1003},{t:this.shape_1002},{t:this.shape_1001},{t:this.shape_1000},{t:this.shape_999},{t:this.shape_998},{t:this.shape_997},{t:this.shape_996},{t:this.shape_995},{t:this.shape_994},{t:this.shape_993},{t:this.shape_992},{t:this.shape_991},{t:this.shape_990},{t:this.shape_989},{t:this.shape_988},{t:this.shape_987},{t:this.shape_986},{t:this.shape_985},{t:this.shape_984},{t:this.shape_983},{t:this.shape_982},{t:this.shape_981},{t:this.shape_980},{t:this.shape_979},{t:this.shape_978},{t:this.shape_977},{t:this.shape_976},{t:this.shape_975},{t:this.shape_974},{t:this.shape_973},{t:this.shape_972},{t:this.shape_971},{t:this.shape_970},{t:this.shape_969},{t:this.shape_968},{t:this.shape_967},{t:this.shape_966},{t:this.shape_965},{t:this.shape_964},{t:this.shape_963},{t:this.shape_962},{t:this.shape_961},{t:this.shape_960},{t:this.shape_959},{t:this.shape_958},{t:this.shape_957},{t:this.shape_956},{t:this.shape_955},{t:this.shape_954},{t:this.shape_953},{t:this.shape_952},{t:this.shape_951},{t:this.shape_950},{t:this.shape_949},{t:this.shape_948},{t:this.shape_947},{t:this.shape_946},{t:this.shape_945},{t:this.shape_944},{t:this.shape_943},{t:this.shape_942},{t:this.shape_941},{t:this.shape_940},{t:this.shape_939},{t:this.shape_938},{t:this.shape_937},{t:this.shape_936},{t:this.shape_935},{t:this.shape_934},{t:this.shape_933},{t:this.shape_932},{t:this.shape_931},{t:this.shape_930},{t:this.shape_929},{t:this.shape_928},{t:this.shape_927},{t:this.shape_926},{t:this.shape_925},{t:this.shape_924},{t:this.shape_923},{t:this.shape_922},{t:this.shape_921},{t:this.shape_920},{t:this.shape_919},{t:this.shape_918},{t:this.shape_917},{t:this.shape_916},{t:this.shape_915},{t:this.shape_914},{t:this.shape_913},{t:this.shape_912},{t:this.shape_911},{t:this.shape_910},{t:this.shape_909},{t:this.shape_908},{t:this.shape_907},{t:this.shape_906},{t:this.shape_905},{t:this.shape_904},{t:this.shape_903},{t:this.shape_902},{t:this.shape_901},{t:this.shape_900},{t:this.shape_899},{t:this.shape_898},{t:this.shape_897},{t:this.shape_896},{t:this.shape_895},{t:this.shape_894},{t:this.shape_893},{t:this.shape_892},{t:this.shape_891},{t:this.shape_890},{t:this.shape_889},{t:this.shape_888},{t:this.shape_887},{t:this.shape_886},{t:this.shape_885},{t:this.shape_884},{t:this.shape_883},{t:this.shape_882},{t:this.shape_881},{t:this.shape_880},{t:this.shape_879},{t:this.shape_878},{t:this.shape_877},{t:this.shape_876},{t:this.shape_875},{t:this.shape_874},{t:this.shape_873},{t:this.shape_872},{t:this.shape_871},{t:this.shape_870},{t:this.shape_869},{t:this.shape_868},{t:this.shape_867},{t:this.shape_866},{t:this.shape_865},{t:this.shape_864},{t:this.shape_863},{t:this.shape_862},{t:this.shape_861},{t:this.shape_860},{t:this.shape_859},{t:this.shape_858},{t:this.instance_4},{t:this.instance_3}]},118).to({state:[]},1).wait(46));

	// ButtonLeftRight copy 54
	this.buttonR26 = new lib.ButtonLeft_Right();
	this.buttonR26.name = "buttonR26";
	this.buttonR26.parent = this;
	this.buttonR26.setTransform(2025,513.5,1,1,180);
	this.buttonR26._off = true;
	new cjs.ButtonHelper(this.buttonR26, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR26).wait(117).to({_off:false},0).to({_off:true},1).wait(47));

	// ButtonLeftRight copy 55
	this.buttonL26 = new lib.ButtonLeft_Right();
	this.buttonL26.name = "buttonL26";
	this.buttonL26.parent = this;
	this.buttonL26.setTransform(0,437.2);
	this.buttonL26._off = true;
	new cjs.ButtonHelper(this.buttonL26, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL26).wait(117).to({_off:false},0).to({_off:true},1).wait(47));

	// Layer 1
	this.instance_5 = new lib.allison_ivan();
	this.instance_5.parent = this;
	this.instance_5.setTransform(805,-4);

	this.shape_1052 = new cjs.Shape();
	this.shape_1052.graphics.f("#000000").s().p("AhqCLIAAgrQAWAMAZAFQAYAHAYAAQAjAAAUgLQAUgLAAgZQAAgRgQgNQgQgNgrgRQgqgOgTgNQgSgMgIgPQgJgOAAgWQAAglAegVQAegWA0AAQAyAAAvAUIgRAmQgugUglAAQggAAgQALQgRALAAASQAAAMAGAIQAGAJAOAHQAPAJAmAOQA3AUASATQATAVAAAdQAAArggAXQgfAXg5AAQg9AAghgTg");
	this.shape_1052.setTransform(280.2,783.8,0.5,0.5);

	this.shape_1053 = new cjs.Shape();
	this.shape_1053.graphics.f("#000000").s().p("ABSCbIAAjEQAAglgRgTQgSgSgjAAQgvAAgXAaQgWAaAAA7IAACfIgvAAIAAkwIAnAAIAHAqIACAAQAOgXAagMQAZgMAfAAQA3AAAcAaQAbAbABA6IAADGg");
	this.shape_1053.setTransform(264.6,783.6,0.5,0.5);

	this.shape_1054 = new cjs.Shape();
	this.shape_1054.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgJAAgPQAAgPAIgIQAIgHAKAAQAMAAAHAIQAIAHAAAPQAAAQgIAIQgHAHgMABQgLgBgHgHg");
	this.shape_1054.setTransform(252.2,780.9,0.5,0.5);

	this.shape_1055 = new cjs.Shape();
	this.shape_1055.graphics.f("#000000").s().p("ABCDZIhqiQIgjAdIAABzIguAAIAAmwIAuAAIAADkQAAATgCAcIACAAQALgQAZgcIBihnIA3AAIh8CAICECwg");
	this.shape_1055.setTransform(242.2,780.6,0.5,0.5);

	this.shape_1056 = new cjs.Shape();
	this.shape_1056.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgWIArgTIAUhCIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAWAAQAOAAAKgDQANgBAFgCIAAAkQgHACgPAEQgNACgNAAQhYgBAAhcg");
	this.shape_1056.setTransform(228.5,782.1,0.5,0.5);

	this.shape_1057 = new cjs.Shape();
	this.shape_1057.graphics.f("#000000").s().p("AhgCHQgZgYAAgrQAAhbCSgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgXAcgXALQgWAKgiAAQguAAgZgXgAAeAEQg2ADgZAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_1057.setTransform(215.2,783.8,0.5,0.5);

	this.shape_1058 = new cjs.Shape();
	this.shape_1058.graphics.f("#000000").s().p("ABlDMIhgk+IgGggQgGAjgOAtIhPEOIgvAAIhsmXIAyAAIBAD7QAOA2AGAqQAHgyAPgyIBJj3IAxAAIBMD5QAOArAJA3QAEgjAQg+IBAj6IAyAAIhtGXg");
	this.shape_1058.setTransform(194.5,781.2,0.5,0.5);

	this.shape_1059 = new cjs.Shape();
	this.shape_1059.graphics.f("#000000").s().p("AhfCHQgagYAAgrQAAhbCTgFIAzgBIAAgTQAAglgPgQQgPgSgjAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgWAbgYAMQgVAKgiAAQguAAgZgXgAAeAEQg3ADgXAOQgZAQAAAgQAAAYAPAOQAQANAbAAQAqAAAZgYQAYgXAAgrIAAgcg");
	this.shape_1059.setTransform(165.5,783.8,0.5,0.5);

	this.shape_1060 = new cjs.Shape();
	this.shape_1060.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQAQgdAZgRQAXgQAcAAQAWAAAPADIgGArQgVgEgNAAQglAAgaAeQgaAdAAAuIAACig");
	this.shape_1060.setTransform(153.3,783.6,0.5,0.5);

	this.shape_1061 = new cjs.Shape();
	this.shape_1061.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhLAhgpQAhgqA8AAQA9AAAiAtIADAAIgCgWIgBiRIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg7AAgigogAhAgZQgVAeAAA6QAAA7AVAdQAWAeApAAQAvAAAVgaQAVgZAAg6IAAgKQAAhAgVgbQgXgcgtAAQgpAAgWAgg");
	this.shape_1061.setTransform(137.3,780.7,0.5,0.5);

	this.shape_1062 = new cjs.Shape();
	this.shape_1062.graphics.f("#000000").s().p("ABRCbIAAjEQAAgkgRgUQgRgSgkAAQguAAgXAaQgXAaABA7IAACfIguAAIAAkwIAlAAIAIAqIACAAQAPgXAYgMQAZgMAgAAQA3AAAcAaQAbAcAAA5IAADGg");
	this.shape_1062.setTransform(120.3,783.6,0.5,0.5);

	this.shape_1063 = new cjs.Shape();
	this.shape_1063.graphics.f("#000000").s().p("AhfCHQgbgZAAgqQAAhbCTgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQglAAgwAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAbAYgBA1IAADPIgiAAIgJgrIgDAAQgVAcgYALQgWAKghAAQgvAAgYgXgAAeAEQg3ADgYAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_1063.setTransform(103.1,783.8,0.5,0.5);

	this.shape_1064 = new cjs.Shape();
	this.shape_1064.graphics.f("#000000").s().p("ABWCZIhVh8IhWB8Ig0AAIBwicIhqiUIA0AAIBQB1IBPh1IA0AAIhqCUIBwCcg");
	this.shape_1064.setTransform(88.2,783.8,0.5,0.5);

	this.shape_1065 = new cjs.Shape();
	this.shape_1065.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhIAlgsQAkgrA8AAQA6AAAhAlQAhAmAAA+IAAAdIjRAAQACA2AZAbQAbAcAsAAQAyAAAwgVIAAApQgZALgWAFQgVAEgfAAQhCAAgogpgAg1hfQgXAZgDAqICeAAQABgsgUgXQgUgYgjAAQgkAAgWAYg");
	this.shape_1065.setTransform(72.8,783.8,0.5,0.5);

	this.shape_1066 = new cjs.Shape();
	this.shape_1066.graphics.f("#000000").s().p("AgWDZIAAmwIAtAAIAAGwg");
	this.shape_1066.setTransform(61.1,780.6,0.5,0.5);

	this.shape_1067 = new cjs.Shape();
	this.shape_1067.graphics.f("#000000").s().p("ACDDMIgyiBIijAAIgyCBIgvAAICgmXIAnAAICgGXgAgRhdIgwB9ICDAAIgwh9QgIgVgKglQgHAfgKAbg");
	this.shape_1067.setTransform(48.5,781.2,0.5,0.5);

	this.shape_1068 = new cjs.Shape();
	this.shape_1068.graphics.f("#000000").s().p("AAKA+QAHgWAIgoQAJgkADgaIAdAAIADAGQgIAegNAhQgLAggLAXgAhEA+QAHgYAIgkQAHgfAFghIAdAAIADAGQgSBAgZA2g");
	this.shape_1068.setTransform(343.2,738.1,0.5,0.5);

	this.shape_1069 = new cjs.Shape();
	this.shape_1069.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1069.setTransform(331.9,746.2,0.5,0.5);

	this.shape_1070 = new cjs.Shape();
	this.shape_1070.graphics.f("#000000").s().p("Ag/B7QgbgQgOghQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAmAABAQAABBghAmQggAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1070.setTransform(316.9,746.4,0.5,0.5);

	this.shape_1071 = new cjs.Shape();
	this.shape_1071.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_1071.setTransform(295.6,749.3,0.5,0.5);

	this.shape_1072 = new cjs.Shape();
	this.shape_1072.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1072.setTransform(284.7,743.9,0.5,0.5);

	this.shape_1073 = new cjs.Shape();
	this.shape_1073.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1073.setTransform(274.4,743.4,0.5,0.5);

	this.shape_1074 = new cjs.Shape();
	this.shape_1074.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQgBgUgQgOQgQgOgngOQgmgNgRgLQgRgKgIgOQgJgOAAgTQABgeAZgSQAZgRAugBQArAAAnARIgJAWQgngQgiAAQgfAAgVALQgUAMABASQgBAWAQAMQAOANArAPQAlAOAQAKQARAJAJAOQAIAOAAASQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1074.setTransform(260.8,746.4,0.5,0.5);

	this.shape_1075 = new cjs.Shape();
	this.shape_1075.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1075.setTransform(250.8,746.2,0.5,0.5);

	this.shape_1076 = new cjs.Shape();
	this.shape_1076.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA2AAQAvABAcAhQAcAigBA5IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgCAdgMIAAAWQgXAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmAAgYAZg");
	this.shape_1076.setTransform(238,746.4,0.5,0.5);

	this.shape_1077 = new cjs.Shape();
	this.shape_1077.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_1077.setTransform(223.6,746.2,0.5,0.5);

	this.shape_1078 = new cjs.Shape();
	this.shape_1078.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1078.setTransform(211.5,744.9,0.5,0.5);

	this.shape_1079 = new cjs.Shape();
	this.shape_1079.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1079.setTransform(203.3,746.2,0.5,0.5);

	this.shape_1080 = new cjs.Shape();
	this.shape_1080.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1080.setTransform(190.3,746.4,0.5,0.5);

	this.shape_1081 = new cjs.Shape();
	this.shape_1081.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_1081.setTransform(176.8,749.3,0.5,0.5);

	this.shape_1082 = new cjs.Shape();
	this.shape_1082.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgCAegMIAAAWQgWAKgVAEQgRAEgZgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_1082.setTransform(155.2,746.4,0.5,0.5);

	this.shape_1083 = new cjs.Shape();
	this.shape_1083.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1083.setTransform(140.7,743.4,0.5,0.5);

	this.shape_1084 = new cjs.Shape();
	this.shape_1084.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXABQAZAAAPgFIAAAVQgQAFgYAAQgjABgSgUg");
	this.shape_1084.setTransform(128.7,744.9,0.5,0.5);

	this.shape_1085 = new cjs.Shape();
	this.shape_1085.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_1085.setTransform(111,746.4,0.5,0.5);

	this.shape_1086 = new cjs.Shape();
	this.shape_1086.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_1086.setTransform(98.9,743.4,0.5,0.5);

	this.shape_1087 = new cjs.Shape();
	this.shape_1087.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1087.setTransform(84.4,746.4,0.5,0.5);

	this.shape_1088 = new cjs.Shape();
	this.shape_1088.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1088.setTransform(73.7,744.9,0.5,0.5);

	this.shape_1089 = new cjs.Shape();
	this.shape_1089.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPghAAgpQAAhBAhgmQAgglA2AAQA5AAAfAmQAgAmAABAQAABBghAmQggAlg3AAQgkABgbgSgAhEhWQgZAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_1089.setTransform(55.5,746.4,0.5,0.5);

	this.shape_1090 = new cjs.Shape();
	this.shape_1090.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1090.setTransform(43.6,744.9,0.5,0.5);

	this.shape_1091 = new cjs.Shape();
	this.shape_1091.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1091.setTransform(644.9,705.2,0.5,0.5);

	this.shape_1092 = new cjs.Shape();
	this.shape_1092.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_1092.setTransform(634.8,708.1,0.5,0.5);

	this.shape_1093 = new cjs.Shape();
	this.shape_1093.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_1093.setTransform(624.4,708,0.5,0.5);

	this.shape_1094 = new cjs.Shape();
	this.shape_1094.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAvAAAYgYQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgZAqhDAAQhdAAAAhjg");
	this.shape_1094.setTransform(611,708.2,0.5,0.5);

	this.shape_1095 = new cjs.Shape();
	this.shape_1095.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1095.setTransform(599.1,706.6,0.5,0.5);

	this.shape_1096 = new cjs.Shape();
	this.shape_1096.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1096.setTransform(587.8,708.1,0.5,0.5);

	this.shape_1097 = new cjs.Shape();
	this.shape_1097.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1097.setTransform(574,708,0.5,0.5);

	this.shape_1098 = new cjs.Shape();
	this.shape_1098.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1098.setTransform(555.4,706.6,0.5,0.5);

	this.shape_1099 = new cjs.Shape();
	this.shape_1099.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1099.setTransform(548.4,705.2,0.5,0.5);

	this.shape_1100 = new cjs.Shape();
	this.shape_1100.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1100.setTransform(538.5,708.1,0.5,0.5);

	this.shape_1101 = new cjs.Shape();
	this.shape_1101.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgUQAAgyASgYQARgXAqAAQAXAAAWAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1101.setTransform(528.6,705.1,0.5,0.5);

	this.shape_1102 = new cjs.Shape();
	this.shape_1102.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1102.setTransform(512.8,706.6,0.5,0.5);

	this.shape_1103 = new cjs.Shape();
	this.shape_1103.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1103.setTransform(505.8,705.6,0.5,0.5);

	this.shape_1104 = new cjs.Shape();
	this.shape_1104.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTBBgYA1g");
	this.shape_1104.setTransform(493.2,715.1,0.5,0.5);

	this.shape_1105 = new cjs.Shape();
	this.shape_1105.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1105.setTransform(483.4,705.2,0.5,0.5);

	this.shape_1106 = new cjs.Shape();
	this.shape_1106.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1106.setTransform(471.3,706.6,0.5,0.5);

	this.shape_1107 = new cjs.Shape();
	this.shape_1107.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1107.setTransform(464.4,705.6,0.5,0.5);

	this.shape_1108 = new cjs.Shape();
	this.shape_1108.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgQAShHIAqiaIAZAAIhKENg");
	this.shape_1108.setTransform(452.3,708.1,0.5,0.5);

	this.shape_1109 = new cjs.Shape();
	this.shape_1109.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_1109.setTransform(431.4,705.2,0.5,0.5);

	this.shape_1110 = new cjs.Shape();
	this.shape_1110.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1110.setTransform(420,708,0.5,0.5);

	this.shape_1111 = new cjs.Shape();
	this.shape_1111.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1111.setTransform(406.7,708.1,0.5,0.5);

	this.shape_1112 = new cjs.Shape();
	this.shape_1112.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAMg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_1112.setTransform(390,708.1,0.5,0.5);

	this.shape_1113 = new cjs.Shape();
	this.shape_1113.graphics.f("#000000").s().p("Ag/B7QgbgQgOghQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBghAmQgfAlg4AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1113.setTransform(366.7,708.1,0.5,0.5);

	this.shape_1114 = new cjs.Shape();
	this.shape_1114.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1114.setTransform(354.8,706.6,0.5,0.5);

	this.shape_1115 = new cjs.Shape();
	this.shape_1115.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA2AAQAdAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_1115.setTransform(336.1,705.3,0.5,0.5);

	this.shape_1116 = new cjs.Shape();
	this.shape_1116.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1116.setTransform(321.4,708.1,0.5,0.5);

	this.shape_1117 = new cjs.Shape();
	this.shape_1117.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBghAmQgfAlg4AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1117.setTransform(306.5,708.1,0.5,0.5);

	this.shape_1118 = new cjs.Shape();
	this.shape_1118.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgOgGgGgIQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgNAHgJALQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1118.setTransform(292.3,711,0.5,0.5);

	this.shape_1119 = new cjs.Shape();
	this.shape_1119.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAUgNABgWQAAgUgRgOQgQgOgmgOQgngNgSgLQgPgKgJgOQgIgOAAgTQgBgeAagSQAZgRAugBQAsAAAnARIgJAWQgogQgiAAQggAAgUALQgTAMAAASQAAAWAOAMQAOANAtAPQAjAOASAKQAQAJAIAOQAJANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_1119.setTransform(273,708.1,0.5,0.5);

	this.shape_1120 = new cjs.Shape();
	this.shape_1120.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1120.setTransform(259.9,708.1,0.5,0.5);

	this.shape_1121 = new cjs.Shape();
	this.shape_1121.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_1121.setTransform(244.4,708.1,0.5,0.5);

	this.shape_1122 = new cjs.Shape();
	this.shape_1122.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1122.setTransform(221.4,708.1,0.5,0.5);

	this.shape_1123 = new cjs.Shape();
	this.shape_1123.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1123.setTransform(207.6,708,0.5,0.5);

	this.shape_1124 = new cjs.Shape();
	this.shape_1124.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_1124.setTransform(197.2,705.6,0.5,0.5);

	this.shape_1125 = new cjs.Shape();
	this.shape_1125.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1125.setTransform(189.8,706.6,0.5,0.5);

	this.shape_1126 = new cjs.Shape();
	this.shape_1126.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1126.setTransform(178.5,708.1,0.5,0.5);

	this.shape_1127 = new cjs.Shape();
	this.shape_1127.graphics.f("#000000").s().p("AhtC2IAAlrIBZAAQCCAAAABoQgBA2gjAaQgkAchBAAIg5AAIAACXgAhUAKIAzAAQA8AAAcgTQAbgVAAgtQAAgqgagVQgZgUg2AAIg9AAg");
	this.shape_1127.setTransform(165.4,705.8,0.5,0.5);

	this.shape_1128 = new cjs.Shape();
	this.shape_1128.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1128.setTransform(146.2,706.6,0.5,0.5);

	this.shape_1129 = new cjs.Shape();
	this.shape_1129.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1129.setTransform(134.7,705.2,0.5,0.5);

	this.shape_1130 = new cjs.Shape();
	this.shape_1130.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgNgVQgNgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgNAHgJALQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1130.setTransform(120.4,711,0.5,0.5);

	this.shape_1131 = new cjs.Shape();
	this.shape_1131.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAlAAQAuAAAYgYQAWgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1131.setTransform(106.2,708.2,0.5,0.5);

	this.shape_1132 = new cjs.Shape();
	this.shape_1132.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1132.setTransform(91.2,708.1,0.5,0.5);

	this.shape_1133 = new cjs.Shape();
	this.shape_1133.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAAABiIAACxg");
	this.shape_1133.setTransform(76.3,705.2,0.5,0.5);

	this.shape_1134 = new cjs.Shape();
	this.shape_1134.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1134.setTransform(64.3,706.6,0.5,0.5);

	this.shape_1135 = new cjs.Shape();
	this.shape_1135.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_1135.setTransform(50.3,705.8,0.5,0.5);

	this.shape_1136 = new cjs.Shape();
	this.shape_1136.graphics.f("#000000").s().p("AANA+IgDgEQAIgeAMghQAJgZAOggIAQAAQgHAXgIAnQgIAlgEAZgAhBA+IgDgEQAJghALgdQANgkAKgWIAQAAQgJAfgHAgQgIAjgDAag");
	this.shape_1136.setTransform(43.3,699.8,0.5,0.5);

	this.shape_1137 = new cjs.Shape();
	this.shape_1137.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_1137.setTransform(247.5,637.4,0.5,0.5);

	this.shape_1138 = new cjs.Shape();
	this.shape_1138.graphics.f("#000000").s().p("AhzCmIAAgYQAXAMAYAFQAbAGAWAAQA2AAAcgWQAbgXAAgoQAAgkgcgTQgcgUg2AAIgnAAIAAgXIAoAAQAsAAAagVQAbgVAAgmQAAgfgWgRQgVgTgjAAQgZAAgYAIQgXAIgbASIgMgRQAWgSAdgKQAegKAeAAQAyAAAbAYQAcAYAAAqQAAAkgWAWQgVAXgkAGIAAACQAsAGAXAUQAXAXAAAmQAAAzgjAcQgiAchBAAQg3AAgqgVg");
	this.shape_1138.setTransform(236.8,629.3,0.5,0.5);

	this.shape_1139 = new cjs.Shape();
	this.shape_1139.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA9IgOgSIBihKIAVAAIAAFrg");
	this.shape_1139.setTransform(220.8,629.3,0.5,0.5);

	this.shape_1140 = new cjs.Shape();
	this.shape_1140.graphics.f("#000000").s().p("AhWCMQgegwAAhcQAAhfAdguQAcgtA7AAQA5AAAeAvQAeAwAABbQAABggdAtQgeAug6AAQg5AAgdgvgAhEh6QgVAqAABQQAABTAWApQAXApAsAAQAuAAAWgqQAVgrAAhQQAAhPgVgrQgVgqgvAAQgvAAgVAqg");
	this.shape_1140.setTransform(208.1,629.3,0.5,0.5);

	this.shape_1141 = new cjs.Shape();
	this.shape_1141.graphics.f("#000000").s().p("AhxC5IAAgXIBhhlQAogpAQgWQARgWAHgVQAIgUAAgXQAAgggVgVQgWgVghAAQgtABgqAhIgNgSQAsgmA5ABQAuAAAcAZQAbAZAAAsQAAAlgTAhQgSAigwAxIhdBgIAAAAIDCAAIAAAZg");
	this.shape_1141.setTransform(193.3,629.2,0.5,0.5);

	this.shape_1142 = new cjs.Shape();
	this.shape_1142.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgnA1AAQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgCAegMIAAAWQgXAKgUAEQgRAEgagBQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgagkAAQglAAgZAZg");
	this.shape_1142.setTransform(172.6,631.6,0.5,0.5);

	this.shape_1143 = new cjs.Shape();
	this.shape_1143.graphics.f("#000000").s().p("Ag/BoQgiglABhBQAAhCAigmQAigmA6AAQAiAAAiANIgHAWQgjgMgaAAQgxAAgaAfQgaAfABA5QgBA3AaAeQAaAfAtAAQAmAAAegNIAAAXQgZAMgqAAQg6AAgggkg");
	this.shape_1143.setTransform(159.8,631.6,0.5,0.5);

	this.shape_1144 = new cjs.Shape();
	this.shape_1144.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgvABgYAYQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAcgqBCAAQBbAAABBjIAACwg");
	this.shape_1144.setTransform(146,631.5,0.5,0.5);

	this.shape_1145 = new cjs.Shape();
	this.shape_1145.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_1145.setTransform(135.6,629.1,0.5,0.5);

	this.shape_1146 = new cjs.Shape();
	this.shape_1146.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAUgNAAgWQAAgUgQgOQgQgOgmgOQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgfAAgUALQgTAMgBASQAAAWAQAMQANANAtAPQAjAOARAKQARAJAIAOQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1146.setTransform(126.7,631.6,0.5,0.5);

	this.shape_1147 = new cjs.Shape();
	this.shape_1147.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1147.setTransform(111.3,628.7,0.5,0.5);

	this.shape_1148 = new cjs.Shape();
	this.shape_1148.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_1148.setTransform(101.4,631.6,0.5,0.5);

	this.shape_1149 = new cjs.Shape();
	this.shape_1149.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1149.setTransform(87,628.7,0.5,0.5);

	this.shape_1150 = new cjs.Shape();
	this.shape_1150.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAigmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgZAfQgaAfAAA5QAAA3AaAeQAYAfAuAAQAmAAAegNIAAAXQgZAMgqAAQg6AAghgkg");
	this.shape_1150.setTransform(73.6,631.6,0.5,0.5);

	this.shape_1151 = new cjs.Shape();
	this.shape_1151.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1151.setTransform(64.4,629.1,0.5,0.5);

	this.shape_1152 = new cjs.Shape();
	this.shape_1152.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgXAAIAAlrIAnAAICAE/IABAAICBk/IAmAAIAAFrg");
	this.shape_1152.setTransform(50.5,629.3,0.5,0.5);

	this.shape_1153 = new cjs.Shape();
	this.shape_1153.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1153.setTransform(734.7,596.3,0.5,0.5);

	this.shape_1154 = new cjs.Shape();
	this.shape_1154.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBDAAQBbAAAABjIAACwg");
	this.shape_1154.setTransform(720.6,593.2,0.5,0.5);

	this.shape_1155 = new cjs.Shape();
	this.shape_1155.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1155.setTransform(710.1,590.9,0.5,0.5);

	this.shape_1156 = new cjs.Shape();
	this.shape_1156.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXABQAZAAAPgFIAAAVQgSAFgWAAQgjABgRgUg");
	this.shape_1156.setTransform(702.8,591.9,0.5,0.5);

	this.shape_1157 = new cjs.Shape();
	this.shape_1157.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAcgqBCAAQBcAAAABjIAACwg");
	this.shape_1157.setTransform(691.3,593.2,0.5,0.5);

	this.shape_1158 = new cjs.Shape();
	this.shape_1158.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAbAhQAcAiABA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgVAKgUAEQgTAEgYgBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQglAAgZAZg");
	this.shape_1158.setTransform(676.7,593.4,0.5,0.5);

	this.shape_1159 = new cjs.Shape();
	this.shape_1159.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAVgNAAgWQAAgUgRgOQgQgOgmgOQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAagRAtgBQArAAAoARIgKAWQgngQgiAAQggAAgUALQgTAMAAASQAAAWAPAMQAOANAsAPQAlAOAQAKQARAKAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_1159.setTransform(663.6,593.4,0.5,0.5);

	this.shape_1160 = new cjs.Shape();
	this.shape_1160.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAbAhQAcAiABA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgWAKgTAEQgTAEgYgBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_1160.setTransform(650.8,593.4,0.5,0.5);

	this.shape_1161 = new cjs.Shape();
	this.shape_1161.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1161.setTransform(639.7,593.2,0.5,0.5);

	this.shape_1162 = new cjs.Shape();
	this.shape_1162.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAnIABAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhCiWQgWAaAAA7IAAAIQAAA/AVAbQAWAbAuAAQAqAAAXgfQAWgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_1162.setTransform(626.7,596.3,0.5,0.5);

	this.shape_1163 = new cjs.Shape();
	this.shape_1163.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAcAhQAcAjAAA4IAAASIjDAAQABA4AaAeQAZAdAuAAQAYAAARgDQARgDAbgLIAAAWQgWAKgTAEQgTAEgZgBQg5AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmAAgYAZg");
	this.shape_1163.setTransform(611.7,593.4,0.5,0.5);

	this.shape_1164 = new cjs.Shape();
	this.shape_1164.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAWAEIgEAYQgRgFgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_1164.setTransform(600.6,593.2,0.5,0.5);

	this.shape_1165 = new cjs.Shape();
	this.shape_1165.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1165.setTransform(580.7,593.2,0.5,0.5);

	this.shape_1166 = new cjs.Shape();
	this.shape_1166.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgnA1AAQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgXAKgUAEQgRAEgagBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgnAAgXAZg");
	this.shape_1166.setTransform(566.1,593.4,0.5,0.5);

	this.shape_1167 = new cjs.Shape();
	this.shape_1167.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAuAAQAYAAARgDQAPgDAdgLIAAAWQgWAKgTAEQgSAEgagBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_1167.setTransform(552.1,593.4,0.5,0.5);

	this.shape_1168 = new cjs.Shape();
	this.shape_1168.graphics.f("#000000").s().p("Ag0C4QgYgMgMgVIgDAAIgHAoIgPAAIAAmCIAZAAIgCCfIACAAQAOgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgcAAgYgMgAhEgiQgUAbAAA/IAAAEQAAA+AVAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_1168.setTransform(537.9,590.6,0.5,0.5);

	this.shape_1169 = new cjs.Shape();
	this.shape_1169.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA3AAQAcAAAWALQAWALARAaIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1169.setTransform(515.3,590.6,0.5,0.5);

	this.shape_1170 = new cjs.Shape();
	this.shape_1170.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1170.setTransform(500.9,593.4,0.5,0.5);

	this.shape_1171 = new cjs.Shape();
	this.shape_1171.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1171.setTransform(487.2,590.4,0.5,0.5);

	this.shape_1172 = new cjs.Shape();
	this.shape_1172.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAegmA3AAQAbAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgXAeAAA7QABBzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_1172.setTransform(465,590.6,0.5,0.5);

	this.shape_1173 = new cjs.Shape();
	this.shape_1173.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1173.setTransform(450.3,593.2,0.5,0.5);

	this.shape_1174 = new cjs.Shape();
	this.shape_1174.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1174.setTransform(435.5,593.4,0.5,0.5);

	this.shape_1175 = new cjs.Shape();
	this.shape_1175.graphics.f("#000000").s().p("AhcC1IAAgWQAMAEAOACQANACAKAAQA8AAAjgtQAjgsAEhUIgDAAQgSAWgZANQgaANgaAAQgyAAgdgcQgcgaAAg0QAAg2AfgjQAfghAyAAQAjAAAaASQAcATAOAlQAOAkAAAyQAABHgSAwQgUAxgjAWQgkAXgyAAQgbAAgVgGgAhBiKQgYAbAAAuQAAArAWAWQAVAWApAAQAYAAAWgLQAWgLANgSQAMgTAAgTQAAgfgLgXQgMgagVgOQgUgPgaAAQgoAAgXAbg");
	this.shape_1175.setTransform(415.2,591,0.5,0.5);

	this.shape_1176 = new cjs.Shape();
	this.shape_1176.graphics.f("#000000").s().p("AhcC1IAAgWQALAEAPACQANACAKAAQA8AAAjgtQAjgsAEhUIgDAAQgSAWgZANQgaANgaAAQgzAAgcgcQgcgaAAg0QAAg2AfgjQAfghAxAAQAkAAAaASQAbATAPAlQAOAkAAAyQAABGgTAxQgTAwgjAXQgkAXgyAAQgbAAgVgGgAhBiKQgYAbAAAuQAAArAWAWQAWAWAoAAQAYAAAWgLQAVgLAOgSQAMgTAAgTQAAgdgLgZQgMgagVgOQgUgPgbAAQgnAAgXAbg");
	this.shape_1176.setTransform(400.6,591,0.5,0.5);

	this.shape_1177 = new cjs.Shape();
	this.shape_1177.graphics.f("#000000").s().p("AhcC1IAAgWQALAEAOACQAOACAJAAQA9AAAjgtQAjgsAEhUIgDAAQgSAWgaANQgZANgaAAQgzAAgcgcQgcgaAAg0QAAg2AfgjQAeghAyAAQAkAAAaASQAbATAPAlQAOAkAAAyQAABGgTAxQgTAwgjAXQgkAXgzAAQgaAAgVgGgAhBiKQgYAaAAAvQAAArAWAWQAWAWAoAAQAYAAAWgLQAWgLAMgSQANgTAAgTQAAgdgLgZQgNgbgUgNQgVgPgaAAQgnAAgXAbg");
	this.shape_1177.setTransform(386.1,591,0.5,0.5);

	this.shape_1178 = new cjs.Shape();
	this.shape_1178.graphics.f("#000000").s().p("AAjC2IAAkIQABgkADgnIgIAHIhMA9IgOgSIBihKIAVAAIAAFrg");
	this.shape_1178.setTransform(369.9,591,0.5,0.5);

	this.shape_1179 = new cjs.Shape();
	this.shape_1179.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgkAAQguABgYAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_1179.setTransform(350.3,593.2,0.5,0.5);

	this.shape_1180 = new cjs.Shape();
	this.shape_1180.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1180.setTransform(339.9,590.9,0.5,0.5);

	this.shape_1181 = new cjs.Shape();
	this.shape_1181.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_1181.setTransform(319.3,591,0.5,0.5);

	this.shape_1182 = new cjs.Shape();
	this.shape_1182.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA6AAAdIAADrIgYAAIAAlrIAZAAIDWFCIACAAQgCgoAAguIAAjsIAYAAIAAFrg");
	this.shape_1182.setTransform(299.1,591,0.5,0.5);

	this.shape_1183 = new cjs.Shape();
	this.shape_1183.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgSBBgYA1g");
	this.shape_1183.setTransform(280.2,600.3,0.5,0.5);

	this.shape_1184 = new cjs.Shape();
	this.shape_1184.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA2AAQAvABAcAhQAbAjAAA4IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgDAcgLIAAAWQgWAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmAAgYAZg");
	this.shape_1184.setTransform(270.9,593.4,0.5,0.5);

	this.shape_1185 = new cjs.Shape();
	this.shape_1185.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACbICjAAIAAAWIijAAIAACjg");
	this.shape_1185.setTransform(258.6,591,0.5,0.5);

	this.shape_1186 = new cjs.Shape();
	this.shape_1186.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1186.setTransform(237.2,593.4,0.5,0.5);

	this.shape_1187 = new cjs.Shape();
	this.shape_1187.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1187.setTransform(226.5,591.9,0.5,0.5);

	this.shape_1188 = new cjs.Shape();
	this.shape_1188.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1188.setTransform(214.9,593.2,0.5,0.5);

	this.shape_1189 = new cjs.Shape();
	this.shape_1189.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAYAAAwIAACzIgTAAIgGgqIgCAAQgWAagUALQgVAKgdAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1189.setTransform(200.1,593.4,0.5,0.5);

	this.shape_1190 = new cjs.Shape();
	this.shape_1190.graphics.f("#000000").s().p("AhwCsIAAgZQApAQA8AAQAsABAagVQAagUAAgiQAAgUgJgOQgIgOgUgLQgUgMgkgMQg4gSgWgXQgVgWAAglQAAgoAggbQAggZAyAAQAxAAAvATIgKAWQgtgTgpAAQgnAAgYATQgYATAAAfQAAAWAHAMQAIAMAQALQAQAKApAPQApANAXAPQAVANAJASQAKASAAAYQABAugiAbQgiAag2AAQhCAAglgPg");
	this.shape_1190.setTransform(186.9,591,0.5,0.5);

	this.shape_1191 = new cjs.Shape();
	this.shape_1191.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgvABgYAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1191.setTransform(165.9,593.2,0.5,0.5);

	this.shape_1192 = new cjs.Shape();
	this.shape_1192.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1192.setTransform(155.4,590.9,0.5,0.5);

	this.shape_1193 = new cjs.Shape();
	this.shape_1193.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1193.setTransform(138.4,593.2,0.5,0.5);

	this.shape_1194 = new cjs.Shape();
	this.shape_1194.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1194.setTransform(123.4,593.4,0.5,0.5);

	this.shape_1195 = new cjs.Shape();
	this.shape_1195.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1195.setTransform(113,590.9,0.5,0.5);

	this.shape_1196 = new cjs.Shape();
	this.shape_1196.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1196.setTransform(105.7,591.9,0.5,0.5);

	this.shape_1197 = new cjs.Shape();
	this.shape_1197.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_1197.setTransform(94.4,596.3,0.5,0.5);

	this.shape_1198 = new cjs.Shape();
	this.shape_1198.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1198.setTransform(79.4,593.4,0.5,0.5);

	this.shape_1199 = new cjs.Shape();
	this.shape_1199.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAmAAAfgNIAAAXQgaAMgqAAQg5AAghgkg");
	this.shape_1199.setTransform(66.6,593.4,0.5,0.5);

	this.shape_1200 = new cjs.Shape();
	this.shape_1200.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgvABgXAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1200.setTransform(52.9,593.2,0.5,0.5);

	this.shape_1201 = new cjs.Shape();
	this.shape_1201.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1201.setTransform(42.4,590.9,0.5,0.5);

	this.shape_1202 = new cjs.Shape();
	this.shape_1202.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgUgRgOQgQgOgmgOQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgeAagSQAagRAsgBQAsAAAnARIgJAWQgngQgjAAQgfAAgUALQgUAMAAASQABAWAPAMQANAMAsAQQAkANASALQARAKAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1202.setTransform(698.7,555.1,0.5,0.5);

	this.shape_1203 = new cjs.Shape();
	this.shape_1203.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1203.setTransform(688.4,553.6,0.5,0.5);

	this.shape_1204 = new cjs.Shape();
	this.shape_1204.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1204.setTransform(681.5,552.6,0.5,0.5);

	this.shape_1205 = new cjs.Shape();
	this.shape_1205.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgnQAhgnA1AAQAvABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAPgDAdgLIAAAWQgYAKgTAEQgRAEgagBQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgVgagjAAQgmAAgZAZg");
	this.shape_1205.setTransform(665,555.1,0.5,0.5);

	this.shape_1206 = new cjs.Shape();
	this.shape_1206.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgaAgAAA4QAAA1AaAgQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_1206.setTransform(652.2,555.1,0.5,0.5);

	this.shape_1207 = new cjs.Shape();
	this.shape_1207.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1207.setTransform(638.4,555,0.5,0.5);

	this.shape_1208 = new cjs.Shape();
	this.shape_1208.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1208.setTransform(627.9,552.6,0.5,0.5);

	this.shape_1209 = new cjs.Shape();
	this.shape_1209.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgUgRgOQgQgOgmgOQgogNgQgLQgRgLgIgNQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgeAAgVALQgTAMgBASQAAAWAPAMQAOAMAtAQQAjANASALQARAKAIANQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1209.setTransform(619,555.1,0.5,0.5);

	this.shape_1210 = new cjs.Shape();
	this.shape_1210.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAUgMAAgXQAAgUgQgOQgQgOgmgOQgngNgSgLQgQgLgIgNQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgeAAgVALQgUAMAAASQAAAWAPAMQAOANAsAPQAkANASALQAPAJAKAOQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1210.setTransform(600.5,555.1,0.5,0.5);

	this.shape_1211 = new cjs.Shape();
	this.shape_1211.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgkAAQguABgYAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_1211.setTransform(587.2,555,0.5,0.5);

	this.shape_1212 = new cjs.Shape();
	this.shape_1212.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1212.setTransform(576.7,552.6,0.5,0.5);

	this.shape_1213 = new cjs.Shape();
	this.shape_1213.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_1213.setTransform(568.8,552.2,0.5,0.5);

	this.shape_1214 = new cjs.Shape();
	this.shape_1214.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1214.setTransform(557.1,553.6,0.5,0.5);

	this.shape_1215 = new cjs.Shape();
	this.shape_1215.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1215.setTransform(545.8,555.1,0.5,0.5);

	this.shape_1216 = new cjs.Shape();
	this.shape_1216.graphics.f("#000000").s().p("ABdC2IhQkYQgGgWgIgiQgDASgIAfIhQEfIgWAAIhklrIAbAAIBVFDQAGghAThGIA+jcIAcAAIBJD8QANAtAFAbQACgQAGgXIBNkdIAaAAIhlFrg");
	this.shape_1216.setTransform(528.1,552.8,0.5,0.5);

	this.shape_1217 = new cjs.Shape();
	this.shape_1217.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgNgVQgNgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1217.setTransform(503.4,558,0.5,0.5);

	this.shape_1218 = new cjs.Shape();
	this.shape_1218.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_1218.setTransform(489.3,555,0.5,0.5);

	this.shape_1219 = new cjs.Shape();
	this.shape_1219.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1219.setTransform(478.8,552.6,0.5,0.5);

	this.shape_1220 = new cjs.Shape();
	this.shape_1220.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1220.setTransform(471.5,553.6,0.5,0.5);

	this.shape_1221 = new cjs.Shape();
	this.shape_1221.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1221.setTransform(460,555,0.5,0.5);

	this.shape_1222 = new cjs.Shape();
	this.shape_1222.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_1222.setTransform(445.4,555.1,0.5,0.5);

	this.shape_1223 = new cjs.Shape();
	this.shape_1223.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAmgBAWgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1223.setTransform(432.3,555.1,0.5,0.5);

	this.shape_1224 = new cjs.Shape();
	this.shape_1224.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgnQAfgnA1AAQAvABAcAhQAcAiABA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgVAKgVAEQgRAEgZgBQg7AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgagkAAQgmAAgYAZg");
	this.shape_1224.setTransform(419.5,555.1,0.5,0.5);

	this.shape_1225 = new cjs.Shape();
	this.shape_1225.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1225.setTransform(408.4,555,0.5,0.5);

	this.shape_1226 = new cjs.Shape();
	this.shape_1226.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAdgsA7AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_1226.setTransform(395.4,558,0.5,0.5);

	this.shape_1227 = new cjs.Shape();
	this.shape_1227.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgVAKgUAEQgTAEgYgBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQglAAgZAZg");
	this.shape_1227.setTransform(380.4,555.1,0.5,0.5);

	this.shape_1228 = new cjs.Shape();
	this.shape_1228.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1228.setTransform(369.3,555,0.5,0.5);

	this.shape_1229 = new cjs.Shape();
	this.shape_1229.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgvABgXAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1229.setTransform(349.4,555,0.5,0.5);

	this.shape_1230 = new cjs.Shape();
	this.shape_1230.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0AAQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1230.setTransform(334.8,555.1,0.5,0.5);

	this.shape_1231 = new cjs.Shape();
	this.shape_1231.graphics.f("#000000").s().p("AhMBoQgigkAAhCQABhAAfgnQAhgnA0AAQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgagBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_1231.setTransform(320.8,555.1,0.5,0.5);

	this.shape_1232 = new cjs.Shape();
	this.shape_1232.graphics.f("#000000").s().p("Ag0C4QgYgMgNgVIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAPgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_1232.setTransform(306.6,552.3,0.5,0.5);

	this.shape_1233 = new cjs.Shape();
	this.shape_1233.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg4AAgdgjgAhBgeQgXAeABA7QAABzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_1233.setTransform(284,552.3,0.5,0.5);

	this.shape_1234 = new cjs.Shape();
	this.shape_1234.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1234.setTransform(269.6,555.1,0.5,0.5);

	this.shape_1235 = new cjs.Shape();
	this.shape_1235.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1235.setTransform(255.9,552.2,0.5,0.5);

	this.shape_1236 = new cjs.Shape();
	this.shape_1236.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1236.setTransform(234.5,555.1,0.5,0.5);

	this.shape_1237 = new cjs.Shape();
	this.shape_1237.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgvABgXAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1237.setTransform(220.7,555,0.5,0.5);

	this.shape_1238 = new cjs.Shape();
	this.shape_1238.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1238.setTransform(210.2,552.6,0.5,0.5);

	this.shape_1239 = new cjs.Shape();
	this.shape_1239.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgjABgRgUg");
	this.shape_1239.setTransform(202.9,553.6,0.5,0.5);

	this.shape_1240 = new cjs.Shape();
	this.shape_1240.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_1240.setTransform(191.6,555.1,0.5,0.5);

	this.shape_1241 = new cjs.Shape();
	this.shape_1241.graphics.f("#000000").s().p("AhsC2IAAlrIBZAAQCAAAAABoQAAA1gjAbQgkAchBAAIg4AAIAACXgAhTAKIAyAAQA8AAAcgTQAcgVgBgtQAAgqgagVQgagUg1AAIg8AAg");
	this.shape_1241.setTransform(178.4,552.8,0.5,0.5);

	this.shape_1242 = new cjs.Shape();
	this.shape_1242.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_1242.setTransform(160.7,560.9,0.5,0.5);

	this.shape_1243 = new cjs.Shape();
	this.shape_1243.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAQAAQAMAAAJgGQALgGAHgMQAIgNALgcIAMgjIhnkOIAaAAIA5CYQAaBFAHAYIAAAAIBcj1IAZAAIh4E6QgQAogIAMQgLAOgNAGQgNAGgTABQgPAAgRgGg");
	this.shape_1243.setTransform(151.8,558.2,0.5,0.5);

	this.shape_1244 = new cjs.Shape();
	this.shape_1244.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1244.setTransform(141.9,555,0.5,0.5);

	this.shape_1245 = new cjs.Shape();
	this.shape_1245.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgVAKgVAEQgRAEgZgBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgagkAAQgmAAgYAZg");
	this.shape_1245.setTransform(129.1,555.1,0.5,0.5);

	this.shape_1246 = new cjs.Shape();
	this.shape_1246.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1246.setTransform(119.2,552.2,0.5,0.5);

	this.shape_1247 = new cjs.Shape();
	this.shape_1247.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1247.setTransform(113.4,552.2,0.5,0.5);

	this.shape_1248 = new cjs.Shape();
	this.shape_1248.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1248.setTransform(103.3,555.1,0.5,0.5);

	this.shape_1249 = new cjs.Shape();
	this.shape_1249.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAdgHQgMgFgHgJQgHgKAAgMQAAgaAigVQgXgKgOgVQgNgVAAgaQAAgpAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSggAAQghAAgSATg");
	this.shape_1249.setTransform(90.4,558,0.5,0.5);

	this.shape_1250 = new cjs.Shape();
	this.shape_1250.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAcAhQAcAjAAA4IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQARgDAbgLIAAAWQgWAKgTAEQgTAEgYgBQg6AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmAAgYAZg");
	this.shape_1250.setTransform(70.1,555.1,0.5,0.5);

	this.shape_1251 = new cjs.Shape();
	this.shape_1251.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1251.setTransform(55.6,552.2,0.5,0.5);

	this.shape_1252 = new cjs.Shape();
	this.shape_1252.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1252.setTransform(43.6,553.6,0.5,0.5);

	this.shape_1253 = new cjs.Shape();
	this.shape_1253.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAZgLAfAAQBdAAgBBiIAACxg");
	this.shape_1253.setTransform(724.2,513.9,0.5,0.5);

	this.shape_1254 = new cjs.Shape();
	this.shape_1254.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1254.setTransform(712.2,515.4,0.5,0.5);

	this.shape_1255 = new cjs.Shape();
	this.shape_1255.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1255.setTransform(705.2,514.4,0.5,0.5);

	this.shape_1256 = new cjs.Shape();
	this.shape_1256.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA3AFAeIABAAQAPg7AHgSIA4ikIAVAAIA1CjQASA9AEARIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_1256.setTransform(693.1,516.9,0.5,0.5);

	this.shape_1257 = new cjs.Shape();
	this.shape_1257.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAKgGAHgMQAIgNAKgcIAOgjIhokOIAZAAIA6CYQAaBFAHAYIABAAIBbj1IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_1257.setTransform(671.4,519.9,0.5,0.5);

	this.shape_1258 = new cjs.Shape();
	this.shape_1258.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1258.setTransform(661.1,515.4,0.5,0.5);

	this.shape_1259 = new cjs.Shape();
	this.shape_1259.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1259.setTransform(654.1,514.4,0.5,0.5);

	this.shape_1260 = new cjs.Shape();
	this.shape_1260.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAlAGAYIABAAQAJggALgeIBHi2IAZAAIhpENg");
	this.shape_1260.setTransform(645.4,516.9,0.5,0.5);

	this.shape_1261 = new cjs.Shape();
	this.shape_1261.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1261.setTransform(636.7,514.4,0.5,0.5);

	this.shape_1262 = new cjs.Shape();
	this.shape_1262.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgUgQgOQgSgOglgOQgngNgRgLQgRgLgIgNQgJgOABgTQAAgeAZgSQAbgRArgBQAtAAAnARIgKAWQgngQgjAAQgfAAgUALQgTAMgBASQAAAWAQAMQANAMAtAQQAjANASALQARAKAIANQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1262.setTransform(627.7,516.9,0.5,0.5);

	this.shape_1263 = new cjs.Shape();
	this.shape_1263.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgZAAg2IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1263.setTransform(614.3,517,0.5,0.5);

	this.shape_1264 = new cjs.Shape();
	this.shape_1264.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1264.setTransform(604,513.9,0.5,0.5);

	this.shape_1265 = new cjs.Shape();
	this.shape_1265.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA5QAAA3AaAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_1265.setTransform(595.3,516.9,0.5,0.5);

	this.shape_1266 = new cjs.Shape();
	this.shape_1266.graphics.f("#000000").s().p("ABVCHIhVh4IhVB4IgbAAIBiiKIhfiDIAdAAIBQByIBPhyIAbAAIhcCDIBjCKg");
	this.shape_1266.setTransform(582.6,516.9,0.5,0.5);

	this.shape_1267 = new cjs.Shape();
	this.shape_1267.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgnA1AAQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgagBQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_1267.setTransform(569.3,516.9,0.5,0.5);

	this.shape_1268 = new cjs.Shape();
	this.shape_1268.graphics.f("#000000").s().p("AhdC0QgdgTAAgkQAAgcARgSQARgTAfgHQgNgFgHgJQgIgKAAgMQAAgaAjgVQgYgKgNgVQgNgVAAgaQAAgoAagaQAagYArAAQAZAAAQAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAtAAAWARQAYASAAAjQAAArgjAXQgiAXhAAAQgzAAgbgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAgBA7gAg4igQgTATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSghAAQgfAAgTATg");
	this.shape_1268.setTransform(549,519.8,0.5,0.5);

	this.shape_1269 = new cjs.Shape();
	this.shape_1269.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_1269.setTransform(534.9,516.7,0.5,0.5);

	this.shape_1270 = new cjs.Shape();
	this.shape_1270.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1270.setTransform(524.4,514.4,0.5,0.5);

	this.shape_1271 = new cjs.Shape();
	this.shape_1271.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNgBgWQAAgUgQgOQgQgOgngOQgmgNgRgLQgQgKgJgOQgIgOgBgTQAAgeAagSQAZgRAugBQArAAAnARIgJAWQgngQgiAAQggAAgUALQgTAMAAASQgBAWAQAMQAOANArAPQAlAOAQAKQARAJAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1271.setTransform(515.5,516.9,0.5,0.5);

	this.shape_1272 = new cjs.Shape();
	this.shape_1272.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPghAAgpQAAhBAhgmQAfglA4AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgjABgcgSgAhEhWQgZAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1272.setTransform(502.1,516.9,0.5,0.5);

	this.shape_1273 = new cjs.Shape();
	this.shape_1273.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_1273.setTransform(487.5,519.8,0.5,0.5);

	this.shape_1274 = new cjs.Shape();
	this.shape_1274.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBghAmQgfAlg4AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1274.setTransform(472,516.9,0.5,0.5);

	this.shape_1275 = new cjs.Shape();
	this.shape_1275.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1275.setTransform(460.5,516.7,0.5,0.5);

	this.shape_1276 = new cjs.Shape();
	this.shape_1276.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_1276.setTransform(447.4,519.8,0.5,0.5);

	this.shape_1277 = new cjs.Shape();
	this.shape_1277.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTBBgYA1g");
	this.shape_1277.setTransform(429.7,523.8,0.5,0.5);

	this.shape_1278 = new cjs.Shape();
	this.shape_1278.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAcgqBCAAQBcAAAABjIAACwg");
	this.shape_1278.setTransform(419.9,516.7,0.5,0.5);

	this.shape_1279 = new cjs.Shape();
	this.shape_1279.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1279.setTransform(404.8,516.9,0.5,0.5);

	this.shape_1280 = new cjs.Shape();
	this.shape_1280.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXABQAZAAAPgFIAAAVQgRAFgXAAQgjABgRgUg");
	this.shape_1280.setTransform(392.9,515.4,0.5,0.5);

	this.shape_1281 = new cjs.Shape();
	this.shape_1281.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgngNgRgLQgRgLgIgNQgIgOAAgTQgBgeAagSQAZgRAugBQAsAAAnARIgJAWQgogQgiAAQgfAAgVALQgTAMAAASQAAAWAOAMQAOAMAtAQQAjANASALQARAKAIANQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_1281.setTransform(382.8,516.9,0.5,0.5);

	this.shape_1282 = new cjs.Shape();
	this.shape_1282.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1282.setTransform(369.5,516.9,0.5,0.5);

	this.shape_1283 = new cjs.Shape();
	this.shape_1283.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBDAAAfAXQAgAXAAAuQAAAggTAVQgUAVglAGIAAABQArAHAVAUQAVAVAAAmQAAAygiAbQghAbg8AAgAhdCgIBVAAQBkAAAAhSQAAhMhpAAIhQAAgAhdgTIBQAAQAyAAAXgRQAYgRAAgkQAAglgbgQQgagRgzAAIhJAAg");
	this.shape_1283.setTransform(354.6,514.5,0.5,0.5);

	this.shape_1284 = new cjs.Shape();
	this.shape_1284.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgvABgYAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1284.setTransform(332,516.7,0.5,0.5);

	this.shape_1285 = new cjs.Shape();
	this.shape_1285.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1285.setTransform(321.5,514.4,0.5,0.5);

	this.shape_1286 = new cjs.Shape();
	this.shape_1286.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXABQAZAAAPgFIAAAVQgSAFgWAAQgjABgRgUg");
	this.shape_1286.setTransform(307.5,515.4,0.5,0.5);

	this.shape_1287 = new cjs.Shape();
	this.shape_1287.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1287.setTransform(300.6,514.4,0.5,0.5);

	this.shape_1288 = new cjs.Shape();
	this.shape_1288.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1288.setTransform(291.6,516.9,0.5,0.5);

	this.shape_1289 = new cjs.Shape();
	this.shape_1289.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1289.setTransform(282.9,514.4,0.5,0.5);

	this.shape_1290 = new cjs.Shape();
	this.shape_1290.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAaIABAAQAJggALgeIBHi2IAZAAIhpENg");
	this.shape_1290.setTransform(274.2,516.9,0.5,0.5);

	this.shape_1291 = new cjs.Shape();
	this.shape_1291.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1291.setTransform(254.5,516.9,0.5,0.5);

	this.shape_1292 = new cjs.Shape();
	this.shape_1292.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgSQgPgTggAAQgpAAgVAYQgTAXAAAxIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAaQgUAZAAA2IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAMgUAUgKQAVgMAZAAQBAAAAQAxIABAAQAOgYAWgNQAXgMAcAAQAsAAAWAYQAWAXABA0IAACwg");
	this.shape_1292.setTransform(230.4,516.7,0.5,0.5);

	this.shape_1293 = new cjs.Shape();
	this.shape_1293.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggnA0AAQAwABAcAhQAcAiAAA5IAAASIjCAAQABA4AZAeQAZAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgSAEQgTAEgYgBQg6AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmAAgYAZg");
	this.shape_1293.setTransform(212.1,516.9,0.5,0.5);

	this.shape_1294 = new cjs.Shape();
	this.shape_1294.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1294.setTransform(197.6,513.9,0.5,0.5);

	this.shape_1295 = new cjs.Shape();
	this.shape_1295.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1295.setTransform(185.6,515.4,0.5,0.5);

	this.shape_1296 = new cjs.Shape();
	this.shape_1296.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1296.setTransform(166.9,514.1,0.5,0.5);

	this.shape_1297 = new cjs.Shape();
	this.shape_1297.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1297.setTransform(156.8,514.4,0.5,0.5);

	this.shape_1298 = new cjs.Shape();
	this.shape_1298.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1298.setTransform(146.7,516.9,0.5,0.5);

	this.shape_1299 = new cjs.Shape();
	this.shape_1299.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAdgsA7AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhCiWQgWAaAAA7IAAAIQAAA/AVAbQAVAbAvAAQAqAAAXgfQAWgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_1299.setTransform(133.2,519.8,0.5,0.5);

	this.shape_1300 = new cjs.Shape();
	this.shape_1300.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAJgGAIgMQAIgOAKgbIAOgjIhokOIAZAAIA6CYQAaBFAHAYIAAAAIBcj1IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_1300.setTransform(112.7,519.9,0.5,0.5);

	this.shape_1301 = new cjs.Shape();
	this.shape_1301.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1301.setTransform(102.8,516.7,0.5,0.5);

	this.shape_1302 = new cjs.Shape();
	this.shape_1302.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1AAQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgXAKgTAEQgSAEgagBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_1302.setTransform(90,516.9,0.5,0.5);

	this.shape_1303 = new cjs.Shape();
	this.shape_1303.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1303.setTransform(80.1,513.9,0.5,0.5);

	this.shape_1304 = new cjs.Shape();
	this.shape_1304.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1304.setTransform(74.3,513.9,0.5,0.5);

	this.shape_1305 = new cjs.Shape();
	this.shape_1305.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1305.setTransform(64.2,516.9,0.5,0.5);

	this.shape_1306 = new cjs.Shape();
	this.shape_1306.graphics.f("#000000").s().p("AhlCLQgugwAAhaQAAg3AWgrQAYgrAqgXQApgXA3AAQA8AAAvAVIgKAXQgwgWgyAAQhHAAgrAtQgqAtAABKQAABSAoApQAoAqBNAAQAzAAAjgOIAAiAIhtAAIAAgXICGAAIAAClQg0AWhCAAQhWAAgtgwg");
	this.shape_1306.setTransform(48.5,514.5,0.5,0.5);

	this.shape_1307 = new cjs.Shape();
	this.shape_1307.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgdAAQgpAAgUgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1307.setTransform(750.4,478.6,0.5,0.5);

	this.shape_1308 = new cjs.Shape();
	this.shape_1308.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgkAAQguAAgYAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_1308.setTransform(736.6,478.5,0.5,0.5);

	this.shape_1309 = new cjs.Shape();
	this.shape_1309.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1309.setTransform(726.1,476.1,0.5,0.5);

	this.shape_1310 = new cjs.Shape();
	this.shape_1310.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1310.setTransform(718.8,477.1,0.5,0.5);

	this.shape_1311 = new cjs.Shape();
	this.shape_1311.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1311.setTransform(707.5,478.6,0.5,0.5);

	this.shape_1312 = new cjs.Shape();
	this.shape_1312.graphics.f("#000000").s().p("AhtC2IAAlrIBZAAQCCAAAABoQgBA2gjAaQgjAdhCAAIg4AAIAACWgAhTAKIAyAAQA8AAAcgTQAbgVAAgtQAAgqgZgVQgbgUg1AAIg8AAg");
	this.shape_1312.setTransform(694.3,476.3,0.5,0.5);

	this.shape_1313 = new cjs.Shape();
	this.shape_1313.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgUQAAgzATgXQARgXAqAAQAXAAAVAHIgFAVQgUgGgUAAQgdAAgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1313.setTransform(676.7,475.6,0.5,0.5);

	this.shape_1314 = new cjs.Shape();
	this.shape_1314.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1314.setTransform(664.6,478.6,0.5,0.5);

	this.shape_1315 = new cjs.Shape();
	this.shape_1315.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1315.setTransform(646,477.1,0.5,0.5);

	this.shape_1316 = new cjs.Shape();
	this.shape_1316.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgMIAMg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZAAAPgFIAAAVQgRAFgYAAQgiABgRgUg");
	this.shape_1316.setTransform(637.5,477.1,0.5,0.5);

	this.shape_1317 = new cjs.Shape();
	this.shape_1317.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmgBgXAag");
	this.shape_1317.setTransform(626.4,478.6,0.5,0.5);

	this.shape_1318 = new cjs.Shape();
	this.shape_1318.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1318.setTransform(612,478.5,0.5,0.5);

	this.shape_1319 = new cjs.Shape();
	this.shape_1319.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1319.setTransform(600.3,478.5,0.5,0.5);

	this.shape_1320 = new cjs.Shape();
	this.shape_1320.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1320.setTransform(587.2,478.6,0.5,0.5);

	this.shape_1321 = new cjs.Shape();
	this.shape_1321.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBDAAAfAXQAgAXAAAuQAAAggTAVQgUAVglAGIAAABQArAHAVAUQAVAVAAAmQAAAygiAbQghAbg8AAgAhdCgIBVAAQBkAAAAhSQAAhMhpAAIhQAAgAhdgTIBQAAQAyAAAXgRQAYgRAAglQAAgkgbgQQgagRgzAAIhJAAg");
	this.shape_1321.setTransform(573.5,476.3,0.5,0.5);

	this.shape_1322 = new cjs.Shape();
	this.shape_1322.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1322.setTransform(550.9,478.5,0.5,0.5);

	this.shape_1323 = new cjs.Shape();
	this.shape_1323.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1323.setTransform(536.1,478.6,0.5,0.5);

	this.shape_1324 = new cjs.Shape();
	this.shape_1324.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAlAGAYIAAAAQAKggAMgeIBGi2IAZAAIhoENg");
	this.shape_1324.setTransform(524,478.6,0.5,0.5);

	this.shape_1325 = new cjs.Shape();
	this.shape_1325.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_1325.setTransform(514.9,476.3,0.5,0.5);

	this.shape_1326 = new cjs.Shape();
	this.shape_1326.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1326.setTransform(497.1,475.8,0.5,0.5);

	this.shape_1327 = new cjs.Shape();
	this.shape_1327.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1327.setTransform(482.5,478.5,0.5,0.5);

	this.shape_1328 = new cjs.Shape();
	this.shape_1328.graphics.f("#000000").s().p("AhPB4QgVgUgBglQAAgnAigWQAfgVA/gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAWAXQAXAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagVALQgVAKgdAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_1328.setTransform(467.7,478.6,0.5,0.5);

	this.shape_1329 = new cjs.Shape();
	this.shape_1329.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgkAAQguAAgYAZQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_1329.setTransform(447.3,478.5,0.5,0.5);

	this.shape_1330 = new cjs.Shape();
	this.shape_1330.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_1330.setTransform(432.2,478.6,0.5,0.5);

	this.shape_1331 = new cjs.Shape();
	this.shape_1331.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1331.setTransform(418.7,478.6,0.5,0.5);

	this.shape_1332 = new cjs.Shape();
	this.shape_1332.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1332.setTransform(410,476.1,0.5,0.5);

	this.shape_1333 = new cjs.Shape();
	this.shape_1333.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1333.setTransform(404.2,475.7,0.5,0.5);

	this.shape_1334 = new cjs.Shape();
	this.shape_1334.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1334.setTransform(398.5,475.7,0.5,0.5);

	this.shape_1335 = new cjs.Shape();
	this.shape_1335.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgFAWgJAWg");
	this.shape_1335.setTransform(387.9,476.2,0.5,0.5);

	this.shape_1336 = new cjs.Shape();
	this.shape_1336.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTA/gXA3g");
	this.shape_1336.setTransform(370.5,485.6,0.5,0.5);

	this.shape_1337 = new cjs.Shape();
	this.shape_1337.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1337.setTransform(363.8,477.1,0.5,0.5);

	this.shape_1338 = new cjs.Shape();
	this.shape_1338.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1338.setTransform(352.2,478.5,0.5,0.5);

	this.shape_1339 = new cjs.Shape();
	this.shape_1339.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmgBgXAag");
	this.shape_1339.setTransform(337.6,478.6,0.5,0.5);

	this.shape_1340 = new cjs.Shape();
	this.shape_1340.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgTQgQgTggAAQgqAAgTAYQgVAXAAAxIAACdIgXAAIAAi4QAAhFg/AAQgrAAgTAaQgTAZAAA2IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAMgUATgKQAWgMAYAAQBAAAASAwIABAAQAOgXAVgNQAYgMAaAAQAuAAAVAYQAXAXgBA0IAACwg");
	this.shape_1340.setTransform(319.5,478.5,0.5,0.5);

	this.shape_1341 = new cjs.Shape();
	this.shape_1341.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgnQAhgmA1gBQAvABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAPgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQABgvgVgbQgVgagjAAQgngBgXAag");
	this.shape_1341.setTransform(301.1,478.6,0.5,0.5);

	this.shape_1342 = new cjs.Shape();
	this.shape_1342.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQARgMAcAAQANAAAYADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1342.setTransform(290.1,478.5,0.5,0.5);

	this.shape_1343 = new cjs.Shape();
	this.shape_1343.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1343.setTransform(281.3,476.1,0.5,0.5);

	this.shape_1344 = new cjs.Shape();
	this.shape_1344.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1344.setTransform(274,477.1,0.5,0.5);

	this.shape_1345 = new cjs.Shape();
	this.shape_1345.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgnQAggmA0gBQAwABAcAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgSAEQgTAEgYgBQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmgBgYAag");
	this.shape_1345.setTransform(262.9,478.6,0.5,0.5);

	this.shape_1346 = new cjs.Shape();
	this.shape_1346.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQARgMAcAAQANAAAYADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1346.setTransform(251.8,478.5,0.5,0.5);

	this.shape_1347 = new cjs.Shape();
	this.shape_1347.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1347.setTransform(235.3,478.5,0.5,0.5);

	this.shape_1348 = new cjs.Shape();
	this.shape_1348.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1348.setTransform(226.6,476.1,0.5,0.5);

	this.shape_1349 = new cjs.Shape();
	this.shape_1349.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAbAjABA4IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgagkAAQglgBgZAag");
	this.shape_1349.setTransform(216.7,478.6,0.5,0.5);

	this.shape_1350 = new cjs.Shape();
	this.shape_1350.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_1350.setTransform(202.3,475.7,0.5,0.5);

	this.shape_1351 = new cjs.Shape();
	this.shape_1351.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1351.setTransform(190.2,477.1,0.5,0.5);

	this.shape_1352 = new cjs.Shape();
	this.shape_1352.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_1352.setTransform(175.4,478.5,0.5,0.5);

	this.shape_1353 = new cjs.Shape();
	this.shape_1353.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAjAAA4IAAASIjCAAQAAA4AaAeQAZAdAuAAQAYAAARgDQAQgDAcgLIAAAWQgWAKgTAEQgTAEgZgBQg5AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgVgagkAAQgmgBgYAag");
	this.shape_1353.setTransform(162.6,478.6,0.5,0.5);

	this.shape_1354 = new cjs.Shape();
	this.shape_1354.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQgBAgALAOQALAPAXABQAZAAAPgFIAAAVQgSAFgWAAQgjABgRgUg");
	this.shape_1354.setTransform(151.2,477.1,0.5,0.5);

	this.shape_1355 = new cjs.Shape();
	this.shape_1355.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgUQAAgyATgYQARgXAqAAQAXAAAWAHIgGAVQgUgGgTAAQgdAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1355.setTransform(144.1,475.6,0.5,0.5);

	this.shape_1356 = new cjs.Shape();
	this.shape_1356.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1356.setTransform(132.2,478.6,0.5,0.5);

	this.shape_1357 = new cjs.Shape();
	this.shape_1357.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAKgRAIgYIAOgjIhokOIAaAAIA4CYQAaBEAIAaIAAAAQALgiAYg9IA4iXIAaAAIh4E6QgOAmgLAOQgJANgOAHQgNAGgTABQgPAAgRgGg");
	this.shape_1357.setTransform(113.5,481.7,0.5,0.5);

	this.shape_1358 = new cjs.Shape();
	this.shape_1358.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1358.setTransform(104.7,475.7,0.5,0.5);

	this.shape_1359 = new cjs.Shape();
	this.shape_1359.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1359.setTransform(97.4,477.1,0.5,0.5);

	this.shape_1360 = new cjs.Shape();
	this.shape_1360.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_1360.setTransform(89.2,478.5,0.5,0.5);

	this.shape_1361 = new cjs.Shape();
	this.shape_1361.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1361.setTransform(75.9,478.6,0.5,0.5);

	this.shape_1362 = new cjs.Shape();
	this.shape_1362.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_1362.setTransform(61,475.7,0.5,0.5);

	this.shape_1363 = new cjs.Shape();
	this.shape_1363.graphics.f("#000000").s().p("AhvCsIAAgZQAmAQA9AAQAuABAZgVQAagUAAgiQAAgUgIgOQgKgOgTgLQgTgLgmgNQg3gRgWgYQgVgWAAglQAAgpAggaQAggZAxAAQAzAAAuATIgJAWQgvgTgpAAQgmAAgZATQgYATAAAfQAAAVAIANQAHAMARALQAPAKApAPQArAOAVAOQAWANAKASQAKARAAAZQgBAtghAcQgiAag3AAQhBAAgkgPg");
	this.shape_1363.setTransform(46.5,476.3,0.5,0.5);

	this.shape_1364 = new cjs.Shape();
	this.shape_1364.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_1364.setTransform(750.1,407.9,0.5,0.5);

	this.shape_1365 = new cjs.Shape();
	this.shape_1365.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1365.setTransform(741.1,402.1,0.5,0.5);

	this.shape_1366 = new cjs.Shape();
	this.shape_1366.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAmgBAWgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAPAMQAPANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1366.setTransform(729.2,402.1,0.5,0.5);

	this.shape_1367 = new cjs.Shape();
	this.shape_1367.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_1367.setTransform(716.4,402.1,0.5,0.5);

	this.shape_1368 = new cjs.Shape();
	this.shape_1368.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_1368.setTransform(706.5,399.2,0.5,0.5);

	this.shape_1369 = new cjs.Shape();
	this.shape_1369.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAbAiAAA5IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgXAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmgBgYAag");
	this.shape_1369.setTransform(696.6,402.1,0.5,0.5);

	this.shape_1370 = new cjs.Shape();
	this.shape_1370.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgTQgQgTggAAQgpAAgUAYQgUAWAAAyIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAaQgTAYAAA3IAACUIgZAAIAAkOIAUAAIAFAlIACAAQALgTAVgLQAVgMAYAAQBAAAASAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_1370.setTransform(678.4,402,0.5,0.5);

	this.shape_1371 = new cjs.Shape();
	this.shape_1371.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1371.setTransform(664.2,399.6,0.5,0.5);

	this.shape_1372 = new cjs.Shape();
	this.shape_1372.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1372.setTransform(656.9,400.6,0.5,0.5);

	this.shape_1373 = new cjs.Shape();
	this.shape_1373.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_1373.setTransform(638.2,399.3,0.5,0.5);

	this.shape_1374 = new cjs.Shape();
	this.shape_1374.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1374.setTransform(623.5,402,0.5,0.5);

	this.shape_1375 = new cjs.Shape();
	this.shape_1375.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1375.setTransform(608.7,402.1,0.5,0.5);

	this.shape_1376 = new cjs.Shape();
	this.shape_1376.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1376.setTransform(592.9,399.2,0.5,0.5);

	this.shape_1377 = new cjs.Shape();
	this.shape_1377.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1377.setTransform(582.8,402.1,0.5,0.5);

	this.shape_1378 = new cjs.Shape();
	this.shape_1378.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1378.setTransform(569.1,402,0.5,0.5);

	this.shape_1379 = new cjs.Shape();
	this.shape_1379.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1379.setTransform(554,402.1,0.5,0.5);

	this.shape_1380 = new cjs.Shape();
	this.shape_1380.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1380.setTransform(543.7,399.6,0.5,0.5);

	this.shape_1381 = new cjs.Shape();
	this.shape_1381.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1381.setTransform(536.3,400.6,0.5,0.5);

	this.shape_1382 = new cjs.Shape();
	this.shape_1382.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_1382.setTransform(524.8,402,0.5,0.5);

	this.shape_1383 = new cjs.Shape();
	this.shape_1383.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmgBgXAag");
	this.shape_1383.setTransform(510.2,402.1,0.5,0.5);

	this.shape_1384 = new cjs.Shape();
	this.shape_1384.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBHC3QANAjAHAaIABAAQAKghALgdIBFi2IAaAAIhoENg");
	this.shape_1384.setTransform(497.4,402.1,0.5,0.5);

	this.shape_1385 = new cjs.Shape();
	this.shape_1385.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgSgTgjAAQgvAAgYAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBdAAAABjIAACwg");
	this.shape_1385.setTransform(484.1,402,0.5,0.5);

	this.shape_1386 = new cjs.Shape();
	this.shape_1386.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1386.setTransform(469,402.1,0.5,0.5);

	this.shape_1387 = new cjs.Shape();
	this.shape_1387.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQABhCAigmQAigmA6AAQAiAAAiANIgHAWQgjgMgbAAQgwAAgZAfQgaAfAAA5QAAA3AaAeQAZAfAtAAQAmAAAegNIAAAXQgZAMgqAAQg6AAgggkg");
	this.shape_1387.setTransform(455.8,402.1,0.5,0.5);

	this.shape_1388 = new cjs.Shape();
	this.shape_1388.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAcgqBBAAQBdAAAABjIAACwg");
	this.shape_1388.setTransform(442,402,0.5,0.5);

	this.shape_1389 = new cjs.Shape();
	this.shape_1389.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAXgYQAWgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhbAAgBhjg");
	this.shape_1389.setTransform(426.8,402.2,0.5,0.5);

	this.shape_1390 = new cjs.Shape();
	this.shape_1390.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgYAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_1390.setTransform(405.3,399.2,0.5,0.5);

	this.shape_1391 = new cjs.Shape();
	this.shape_1391.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1391.setTransform(393.2,400.6,0.5,0.5);

	this.shape_1392 = new cjs.Shape();
	this.shape_1392.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAhgmQAfglA4AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgjABgcgSgAhEhWQgZAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1392.setTransform(381.6,402.1,0.5,0.5);

	this.shape_1393 = new cjs.Shape();
	this.shape_1393.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAOgYAXgMQAWgMAeAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_1393.setTransform(367,399.3,0.5,0.5);

	this.shape_1394 = new cjs.Shape();
	this.shape_1394.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgNABgWQAAgUgRgOQgQgPgmgNQgngNgSgLQgPgKgJgOQgIgOAAgTQgBgeAagSQAZgRAugBQAsAAAnARIgJAWQgogQgiAAQggAAgUALQgTAMAAASQAAAWAOAMQAOANAtAPQAjAOASAKQAQAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_1394.setTransform(346.4,402.1,0.5,0.5);

	this.shape_1395 = new cjs.Shape();
	this.shape_1395.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1395.setTransform(333.3,402.1,0.5,0.5);

	this.shape_1396 = new cjs.Shape();
	this.shape_1396.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_1396.setTransform(317.8,402.1,0.5,0.5);

	this.shape_1397 = new cjs.Shape();
	this.shape_1397.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgMIAMg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZAAAPgFIAAAVQgQAFgZAAQgiABgRgUg");
	this.shape_1397.setTransform(297.5,400.6,0.5,0.5);

	this.shape_1398 = new cjs.Shape();
	this.shape_1398.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAYAAAwIAACzIgTAAIgGgqIgCAAQgWAagUALQgVAKgdAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1398.setTransform(286.2,402.1,0.5,0.5);

	this.shape_1399 = new cjs.Shape();
	this.shape_1399.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_1399.setTransform(272.4,399.2,0.5,0.5);

	this.shape_1400 = new cjs.Shape();
	this.shape_1400.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1400.setTransform(260.4,400.6,0.5,0.5);

	this.shape_1401 = new cjs.Shape();
	this.shape_1401.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAKgGAIgMQAIgOAKgbIAOgjIhokOIAZAAIA6CYQAaBEAHAaIAAAAIBcj2IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_1401.setTransform(243.8,405.2,0.5,0.5);

	this.shape_1402 = new cjs.Shape();
	this.shape_1402.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1402.setTransform(233.9,402,0.5,0.5);

	this.shape_1403 = new cjs.Shape();
	this.shape_1403.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_1403.setTransform(225.2,399.2,0.5,0.5);

	this.shape_1404 = new cjs.Shape();
	this.shape_1404.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAcAigBA5IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgXAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmgBgYAag");
	this.shape_1404.setTransform(215.3,402.1,0.5,0.5);

	this.shape_1405 = new cjs.Shape();
	this.shape_1405.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA3AFAeIABAAQAPg7AHgSIA4ikIAVAAIA1CjQASA9AEARIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_1405.setTransform(199.1,402.1,0.5,0.5);

	this.shape_1406 = new cjs.Shape();
	this.shape_1406.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAuAAQAYAAARgDQAPgDAdgLIAAAWQgWAKgTAEQgTAEgZgBQg5AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgYAag");
	this.shape_1406.setTransform(182.9,402.1,0.5,0.5);

	this.shape_1407 = new cjs.Shape();
	this.shape_1407.graphics.f("#000000").s().p("AgwDwIAAgWQAQAGAQAAQAlgBAAgrIAAlGIAYAAIAAFCQAAAhgQATQgPASgdAAQgUAAgNgGgAARjeQAAgXAQAAQAHAAAFAGQAEAGAAALQAAAMgEAGQgFAHgHAAQgQAAAAgZg");
	this.shape_1407.setTransform(171.3,402.7,0.5,0.5);

	this.shape_1408 = new cjs.Shape();
	this.shape_1408.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg7AAgggkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmgBgXAag");
	this.shape_1408.setTransform(156.5,402.1,0.5,0.5);

	this.shape_1409 = new cjs.Shape();
	this.shape_1409.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1409.setTransform(141.5,399.3,0.5,0.5);

	this.shape_1410 = new cjs.Shape();
	this.shape_1410.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAVAXAAAxIAACzIgSAAIgFgqIgDAAQgVAagUALQgWAKgdAAQgoAAgWgUgAAeAAQg3ACgaAPQgYAPABAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1410.setTransform(127.1,402.1,0.5,0.5);

	this.shape_1411 = new cjs.Shape();
	this.shape_1411.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgSQgPgTggAAQgqAAgTAYQgUAWAAAyIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAaQgUAZAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgKQAVgMAYAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_1411.setTransform(109.6,402,0.5,0.5);

	this.shape_1412 = new cjs.Shape();
	this.shape_1412.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_1412.setTransform(90.3,399.3,0.5,0.5);

	this.shape_1413 = new cjs.Shape();
	this.shape_1413.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_1413.setTransform(75.6,402,0.5,0.5);

	this.shape_1414 = new cjs.Shape();
	this.shape_1414.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1414.setTransform(60.8,402.1,0.5,0.5);

	this.shape_1415 = new cjs.Shape();
	this.shape_1415.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1415.setTransform(47.1,399.2,0.5,0.5);

	this.shape_1416 = new cjs.Shape();
	this.shape_1416.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTBBgYA1g");
	this.shape_1416.setTransform(675.2,370.8,0.5,0.5);

	this.shape_1417 = new cjs.Shape();
	this.shape_1417.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1417.setTransform(664.9,361.1,0.5,0.5);

	this.shape_1418 = new cjs.Shape();
	this.shape_1418.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_1418.setTransform(650.2,363.7,0.5,0.5);

	this.shape_1419 = new cjs.Shape();
	this.shape_1419.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1419.setTransform(639.8,361.4,0.5,0.5);

	this.shape_1420 = new cjs.Shape();
	this.shape_1420.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_1420.setTransform(631.8,360.9,0.5,0.5);

	this.shape_1421 = new cjs.Shape();
	this.shape_1421.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_1421.setTransform(620.4,363.7,0.5,0.5);

	this.shape_1422 = new cjs.Shape();
	this.shape_1422.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_1422.setTransform(609.1,363.9,0.5,0.5);

	this.shape_1423 = new cjs.Shape();
	this.shape_1423.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_1423.setTransform(598.7,363.7,0.5,0.5);

	this.shape_1424 = new cjs.Shape();
	this.shape_1424.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgUQAAgyASgYQARgXAqAAQAXAAAWAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1424.setTransform(591.7,360.9,0.5,0.5);

	this.shape_1425 = new cjs.Shape();
	this.shape_1425.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhglA3AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1425.setTransform(579.5,363.9,0.5,0.5);

	this.shape_1426 = new cjs.Shape();
	this.shape_1426.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_1426.setTransform(567.9,363.7,0.5,0.5);

	this.shape_1427 = new cjs.Shape();
	this.shape_1427.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAbAiAAA5IAAASIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAWQgXAKgUAEQgSAEgZgBQg5AAgigkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgngBgXAag");
	this.shape_1427.setTransform(556.8,363.9,0.5,0.5);

	this.shape_1428 = new cjs.Shape();
	this.shape_1428.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_1428.setTransform(542.4,363.7,0.5,0.5);

	this.shape_1429 = new cjs.Shape();
	this.shape_1429.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA2AAQA4AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1429.setTransform(527.3,363.9,0.5,0.5);

	this.shape_1430 = new cjs.Shape();
	this.shape_1430.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQgBgcARgSQASgTAegHQgNgFgHgJQgIgKABgMQAAgaAjgVQgYgKgNgVQgNgUgBgbQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXhAAAQgyAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgQgLQgSgLgkAAIgsAAQhKAAAAA7gAg4igQgTATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgTgSgfAAQggAAgTATg");
	this.shape_1430.setTransform(506.6,366.8,0.5,0.5);

	this.shape_1431 = new cjs.Shape();
	this.shape_1431.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1431.setTransform(492.4,363.7,0.5,0.5);

	this.shape_1432 = new cjs.Shape();
	this.shape_1432.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1432.setTransform(482,361.4,0.5,0.5);

	this.shape_1433 = new cjs.Shape();
	this.shape_1433.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1433.setTransform(474.6,362.4,0.5,0.5);

	this.shape_1434 = new cjs.Shape();
	this.shape_1434.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1434.setTransform(463.3,363.9,0.5,0.5);

	this.shape_1435 = new cjs.Shape();
	this.shape_1435.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgoQAggmA0gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAeQAaAdAuAAQAZAAARgDQAPgDAdgLIAAAWQgYAKgTAEQgRAEgagBQg6AAghgkgAg2hcQgYAZgEAyICnAAQAAgvgVgbQgUgaglAAQgmgBgXAag");
	this.shape_1435.setTransform(450,363.9,0.5,0.5);

	this.shape_1436 = new cjs.Shape();
	this.shape_1436.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1436.setTransform(439,363.7,0.5,0.5);

	this.shape_1437 = new cjs.Shape();
	this.shape_1437.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_1437.setTransform(427.3,363.9,0.5,0.5);

	this.shape_1438 = new cjs.Shape();
	this.shape_1438.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgUQAAgzASgXQARgXAqAAQAXAAAWAHIgGAVQgUgGgUAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1438.setTransform(411.4,360.9,0.5,0.5);

	this.shape_1439 = new cjs.Shape();
	this.shape_1439.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhglA2AAQA4AAAgAmQAgAmAABAQAABBghAmQgfAlg4AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1439.setTransform(399.3,363.9,0.5,0.5);

	this.shape_1440 = new cjs.Shape();
	this.shape_1440.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAIgNALgcIAMgjIhnkOIAaAAIA4CYQAZBAAJAeIAAAAQAPguAUgxIA4iXIAaAAIh4E6QgQApgJALQgKANgNAHQgNAGgTABQgQAAgQgGg");
	this.shape_1440.setTransform(379.3,366.9,0.5,0.5);

	this.shape_1441 = new cjs.Shape();
	this.shape_1441.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_1441.setTransform(367.7,363.9,0.5,0.5);

	this.shape_1442 = new cjs.Shape();
	this.shape_1442.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1442.setTransform(354.1,363.9,0.5,0.5);

	this.shape_1443 = new cjs.Shape();
	this.shape_1443.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgNgVQgNgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAbAAAiQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAgAAATgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1443.setTransform(341.2,366.8,0.5,0.5);

	this.shape_1444 = new cjs.Shape();
	this.shape_1444.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAcAigBA5IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgngBgXAag");
	this.shape_1444.setTransform(327.5,363.9,0.5,0.5);

	this.shape_1445 = new cjs.Shape();
	this.shape_1445.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1445.setTransform(317.6,360.9,0.5,0.5);

	this.shape_1446 = new cjs.Shape();
	this.shape_1446.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1446.setTransform(300.9,363.9,0.5,0.5);

	this.shape_1447 = new cjs.Shape();
	this.shape_1447.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1447.setTransform(280,361.1,0.5,0.5);

	this.shape_1448 = new cjs.Shape();
	this.shape_1448.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggoQAggmA1gBQAvABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAPgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQABgvgVgbQgVgagjAAQgngBgXAag");
	this.shape_1448.setTransform(265.8,363.9,0.5,0.5);

	this.shape_1449 = new cjs.Shape();
	this.shape_1449.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgvAAgYAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_1449.setTransform(251.4,360.9,0.5,0.5);

	this.shape_1450 = new cjs.Shape();
	this.shape_1450.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1450.setTransform(237.7,363.9,0.5,0.5);

	this.shape_1451 = new cjs.Shape();
	this.shape_1451.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1451.setTransform(229,361.4,0.5,0.5);

	this.shape_1452 = new cjs.Shape();
	this.shape_1452.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1452.setTransform(223.2,360.9,0.5,0.5);

	this.shape_1453 = new cjs.Shape();
	this.shape_1453.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAQgYAVgMQAWgMAeAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_1453.setTransform(213.2,361.1,0.5,0.5);

	this.shape_1454 = new cjs.Shape();
	this.shape_1454.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_1454.setTransform(198,363.9,0.5,0.5);

	this.shape_1455 = new cjs.Shape();
	this.shape_1455.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1455.setTransform(187.2,362.4,0.5,0.5);

	this.shape_1456 = new cjs.Shape();
	this.shape_1456.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgNABgWQgBgUgQgOQgQgPgmgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgeAAgVALQgTAMgBASQAAAWAPAMQAOANAtAPQAjAOASAKQAQAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1456.setTransform(177.1,363.9,0.5,0.5);

	this.shape_1457 = new cjs.Shape();
	this.shape_1457.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAbAiAAA5IAAASIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgXAKgUAEQgRAEgZgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgagkAAQgmgBgYAag");
	this.shape_1457.setTransform(164.3,363.9,0.5,0.5);

	this.shape_1458 = new cjs.Shape();
	this.shape_1458.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAIgOAKgbIAOgjIhokOIAZAAIA5CYQAbBEAGAaIABAAQALgiAXg9IA5iXIAaAAIh4E6QgPAmgKAOQgKANgNAHQgNAGgTABQgPAAgRgGg");
	this.shape_1458.setTransform(144.8,366.9,0.5,0.5);

	this.shape_1459 = new cjs.Shape();
	this.shape_1459.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1459.setTransform(136,360.9,0.5,0.5);

	this.shape_1460 = new cjs.Shape();
	this.shape_1460.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA4AZAeQAaAdAvAAQAXAAARgDQAPgDAdgLIAAAWQgWAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgVgaQgUgagkAAQgngBgWAag");
	this.shape_1460.setTransform(126.2,363.9,0.5,0.5);

	this.shape_1461 = new cjs.Shape();
	this.shape_1461.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgjABgQgUg");
	this.shape_1461.setTransform(114.7,362.4,0.5,0.5);

	this.shape_1462 = new cjs.Shape();
	this.shape_1462.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1462.setTransform(103.4,363.9,0.5,0.5);

	this.shape_1463 = new cjs.Shape();
	this.shape_1463.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgSQgPgTggAAQgqAAgUAYQgTAXAAAxIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAaQgUAZAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgKQAUgMAZAAQBAAAARAwIABAAQAOgXAWgNQAXgMAbAAQAtAAAWAYQAWAXAAA0IAACwg");
	this.shape_1463.setTransform(85.9,363.7,0.5,0.5);

	this.shape_1464 = new cjs.Shape();
	this.shape_1464.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1464.setTransform(71.7,361.4,0.5,0.5);

	this.shape_1465 = new cjs.Shape();
	this.shape_1465.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1465.setTransform(64.4,362.4,0.5,0.5);

	this.shape_1466 = new cjs.Shape();
	this.shape_1466.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1466.setTransform(57.4,360.9,0.5,0.5);

	this.shape_1467 = new cjs.Shape();
	this.shape_1467.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAlAAQAvAAAWgYQAXgZAAg2IAAiVIAZAAIAAEOIgVAAIgEglIgCAAQgaAqhDAAQhcAAgBhjg");
	this.shape_1467.setTransform(46.9,364,0.5,0.5);

	this.shape_1468 = new cjs.Shape();
	this.shape_1468.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1468.setTransform(672.2,322.8,0.5,0.5);

	this.shape_1469 = new cjs.Shape();
	this.shape_1469.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTglAAQgvAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1469.setTransform(657.5,325.5,0.5,0.5);

	this.shape_1470 = new cjs.Shape();
	this.shape_1470.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1470.setTransform(642.7,325.6,0.5,0.5);

	this.shape_1471 = new cjs.Shape();
	this.shape_1471.graphics.f("#000000").s().p("AhNChQgggkAAhBQAAhAAfgnQAhgnA1AAQAvAAAcAhQAbAiAAA4IAAAUIjBAAQABA4AZAdQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgXAKgUADQgSAEgYAAQg7AAghglgAg2giQgYAagEAvICmAAQAAgtgUgcQgUgagkAAQgmAAgYAagAgbhzIAAgEQAPgQAUgbQASgWAHgNIAjAAIAAAEQgIAMgXAXQgUAVgaAWg");
	this.shape_1471.setTransform(622.8,322.7,0.5,0.5);

	this.shape_1472 = new cjs.Shape();
	this.shape_1472.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAKgGAHgMQAIgOAKgbIANgjIhnkOIAZAAIA6CYQAYBAAJAeIAAAAQAJgeAZhBIA6iXIAZAAIh4E6QgQApgJALQgKANgNAHQgNAGgUABQgPAAgQgGg");
	this.shape_1472.setTransform(610,328.7,0.5,0.5);

	this.shape_1473 = new cjs.Shape();
	this.shape_1473.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1473.setTransform(601.2,323.1,0.5,0.5);

	this.shape_1474 = new cjs.Shape();
	this.shape_1474.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1474.setTransform(590.9,325.5,0.5,0.5);

	this.shape_1475 = new cjs.Shape();
	this.shape_1475.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1475.setTransform(576.1,325.6,0.5,0.5);

	this.shape_1476 = new cjs.Shape();
	this.shape_1476.graphics.f("#000000").s().p("Ag8DeIAAgXQAVAGAQAAQA7gBAAhBIAAluIAZAAIAAFrQAABchUAAQgYAAgNgGg");
	this.shape_1476.setTransform(564.3,325.6,0.5,0.5);

	this.shape_1477 = new cjs.Shape();
	this.shape_1477.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1477.setTransform(552.8,325.5,0.5,0.5);

	this.shape_1478 = new cjs.Shape();
	this.shape_1478.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA1gBQAwABAbAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAdgLIAAAWQgWAKgUAEQgSAEgZgBQg5AAgigkgAg2hcQgYAZgEAyICmAAQAAgwgVgaQgUgagkAAQgngBgWAag");
	this.shape_1478.setTransform(540,325.6,0.5,0.5);

	this.shape_1479 = new cjs.Shape();
	this.shape_1479.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1479.setTransform(530.1,323.1,0.5,0.5);

	this.shape_1480 = new cjs.Shape();
	this.shape_1480.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1480.setTransform(524.3,322.7,0.5,0.5);

	this.shape_1481 = new cjs.Shape();
	this.shape_1481.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgnQAfgmA1gBQAvABAdAhQAbAiABA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgagBQg5AAgigkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgngBgWAag");
	this.shape_1481.setTransform(514.4,325.6,0.5,0.5);

	this.shape_1482 = new cjs.Shape();
	this.shape_1482.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1482.setTransform(503,324.1,0.5,0.5);

	this.shape_1483 = new cjs.Shape();
	this.shape_1483.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgNhiIgzCBICBAAIgxiCQgHgRgIgaQgGAYgIAUg");
	this.shape_1483.setTransform(491.2,323.2,0.5,0.5);

	this.shape_1484 = new cjs.Shape();
	this.shape_1484.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQAAgdARgRQARgTAegHQgNgFgHgJQgHgJAAgNQAAgaAjgVQgYgKgOgVQgNgVAAgaQAAgpAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgQAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYARQAXASAAAjQAAArgjAXQghAXhBAAQgyAAgcgTgAhgB7QABA3BTAAQBpAAAAhEQAAgYgQgLQgRgLglAAIgsAAQhKAAgBA7gAg4igQgSASAAAiQgBAfAUARQASASAgAAQAhAAASgSQASgRAAggQAAgjgTgRQgRgSgiAAQgfAAgTATg");
	this.shape_1484.setTransform(470.3,328.5,0.5,0.5);

	this.shape_1485 = new cjs.Shape();
	this.shape_1485.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1485.setTransform(456.2,325.5,0.5,0.5);

	this.shape_1486 = new cjs.Shape();
	this.shape_1486.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1486.setTransform(445.7,323.1,0.5,0.5);

	this.shape_1487 = new cjs.Shape();
	this.shape_1487.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_1487.setTransform(435.6,328.5,0.5,0.5);

	this.shape_1488 = new cjs.Shape();
	this.shape_1488.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_1488.setTransform(420.2,325.6,0.5,0.5);

	this.shape_1489 = new cjs.Shape();
	this.shape_1489.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1489.setTransform(409.8,322.7,0.5,0.5);

	this.shape_1490 = new cjs.Shape();
	this.shape_1490.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0gBQAwABAcAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgSAEQgTAEgYgBQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmgBgYAag");
	this.shape_1490.setTransform(399.9,325.6,0.5,0.5);

	this.shape_1491 = new cjs.Shape();
	this.shape_1491.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAlAGAYIABAAQAKggAKgeIBHi2IAZAAIhpENg");
	this.shape_1491.setTransform(387.1,325.6,0.5,0.5);

	this.shape_1492 = new cjs.Shape();
	this.shape_1492.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAbAiAAA5IAAASIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgYAKgSAEQgTAEgYgBQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagjAAQgmgBgZAag");
	this.shape_1492.setTransform(374.2,325.6,0.5,0.5);

	this.shape_1493 = new cjs.Shape();
	this.shape_1493.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1493.setTransform(359.2,322.8,0.5,0.5);

	this.shape_1494 = new cjs.Shape();
	this.shape_1494.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAngBAVgNQAUgMAAgXQAAgUgQgOQgQgPgngNQgmgNgSgLQgQgKgIgOQgJgOAAgTQAAgeAagSQAagRAsgBQAsAAAnARIgJAWQgngQgjAAQgfAAgUALQgUAMAAASQABAWAPAMQAOANArAPQAlAOAQAKQAQAJAKAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1494.setTransform(339.4,325.6,0.5,0.5);

	this.shape_1495 = new cjs.Shape();
	this.shape_1495.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggoQAggmA1gBQAvABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAPgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQABgvgVgbQgVgagjAAQgngBgXAag");
	this.shape_1495.setTransform(326.6,325.6,0.5,0.5);

	this.shape_1496 = new cjs.Shape();
	this.shape_1496.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBHC3QAOAlAGAYIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_1496.setTransform(313.7,325.6,0.5,0.5);

	this.shape_1497 = new cjs.Shape();
	this.shape_1497.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1497.setTransform(305,323.1,0.5,0.5);

	this.shape_1498 = new cjs.Shape();
	this.shape_1498.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1498.setTransform(299.2,322.7,0.5,0.5);

	this.shape_1499 = new cjs.Shape();
	this.shape_1499.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_1499.setTransform(285.6,325.5,0.5,0.5);

	this.shape_1500 = new cjs.Shape();
	this.shape_1500.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1500.setTransform(276.9,323.1,0.5,0.5);

	this.shape_1501 = new cjs.Shape();
	this.shape_1501.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_1501.setTransform(267,325.6,0.5,0.5);

	this.shape_1502 = new cjs.Shape();
	this.shape_1502.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1502.setTransform(252.6,322.7,0.5,0.5);

	this.shape_1503 = new cjs.Shape();
	this.shape_1503.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXABQAZAAAPgFIAAAVQgRAFgXAAQgjABgRgUg");
	this.shape_1503.setTransform(240.5,324.1,0.5,0.5);

	this.shape_1504 = new cjs.Shape();
	this.shape_1504.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1504.setTransform(225.4,324.1,0.5,0.5);

	this.shape_1505 = new cjs.Shape();
	this.shape_1505.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1505.setTransform(213.8,325.5,0.5,0.5);

	this.shape_1506 = new cjs.Shape();
	this.shape_1506.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0gBQAwABAcAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgSAEQgTAEgYgBQg6AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmgBgYAag");
	this.shape_1506.setTransform(199.2,325.6,0.5,0.5);

	this.shape_1507 = new cjs.Shape();
	this.shape_1507.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AVAbQAWAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_1507.setTransform(185,328.5,0.5,0.5);

	this.shape_1508 = new cjs.Shape();
	this.shape_1508.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgNABgWQgBgUgQgOQgQgPgmgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgeAAgVALQgTAMgBASQAAAWAPAMQAOANAtAPQAjAOASAKQAQAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1508.setTransform(171,325.6,0.5,0.5);

	this.shape_1509 = new cjs.Shape();
	this.shape_1509.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgNAAgWQAAgUgQgOQgQgPgmgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgfAAgUALQgTAMgBASQAAAWAQAMQANANAtAPQAjAOARAKQARAKAIANQAJAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1509.setTransform(152.5,325.6,0.5,0.5);

	this.shape_1510 = new cjs.Shape();
	this.shape_1510.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgjABgRgUg");
	this.shape_1510.setTransform(142.2,324.1,0.5,0.5);

	this.shape_1511 = new cjs.Shape();
	this.shape_1511.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgMABgXQgBgUgQgOQgQgPgmgNQgngNgSgLQgQgLgIgNQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgeAAgVALQgTAMgBASQAAAWAPAMQAOANAtAPQAjAOASAKQAPAJAKAOQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1511.setTransform(132.1,325.6,0.5,0.5);

	this.shape_1512 = new cjs.Shape();
	this.shape_1512.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1512.setTransform(123.4,323.1,0.5,0.5);

	this.shape_1513 = new cjs.Shape();
	this.shape_1513.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1513.setTransform(116,324.1,0.5,0.5);

	this.shape_1514 = new cjs.Shape();
	this.shape_1514.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1514.setTransform(107.9,325.5,0.5,0.5);

	this.shape_1515 = new cjs.Shape();
	this.shape_1515.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1515.setTransform(94.8,325.6,0.5,0.5);

	this.shape_1516 = new cjs.Shape();
	this.shape_1516.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgagBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgYAag");
	this.shape_1516.setTransform(74.9,325.6,0.5,0.5);

	this.shape_1517 = new cjs.Shape();
	this.shape_1517.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAXgLAhAAQBdAAgBBiIAACxg");
	this.shape_1517.setTransform(60.5,322.7,0.5,0.5);

	this.shape_1518 = new cjs.Shape();
	this.shape_1518.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_1518.setTransform(46.2,323.3,0.5,0.5);

	this.shape_1519 = new cjs.Shape();
	this.shape_1519.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_1519.setTransform(409.8,254.9,0.5,0.5);

	this.shape_1520 = new cjs.Shape();
	this.shape_1520.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQAKgFAIgNQAIgOAKgbIAOgjIhokOIAaAAIA4CYQAaBEAIAaIAAAAQALgiAYg9IA4iXIAaAAIh4E6QgPAmgKAOQgKANgOAHQgMAGgTABQgPAAgRgGg");
	this.shape_1520.setTransform(401,252.2,0.5,0.5);

	this.shape_1521 = new cjs.Shape();
	this.shape_1521.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1521.setTransform(391,249,0.5,0.5);

	this.shape_1522 = new cjs.Shape();
	this.shape_1522.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvABAcAhQAcAigBA5IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgXAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmgBgYAag");
	this.shape_1522.setTransform(378.2,249.1,0.5,0.5);

	this.shape_1523 = new cjs.Shape();
	this.shape_1523.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1523.setTransform(368.3,246.2,0.5,0.5);

	this.shape_1524 = new cjs.Shape();
	this.shape_1524.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_1524.setTransform(362.5,246.2,0.5,0.5);

	this.shape_1525 = new cjs.Shape();
	this.shape_1525.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1525.setTransform(352.4,249.1,0.5,0.5);

	this.shape_1526 = new cjs.Shape();
	this.shape_1526.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1526.setTransform(339.5,252,0.5,0.5);

	this.shape_1527 = new cjs.Shape();
	this.shape_1527.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAcAigBA5IAAASIjCAAQACA4AYAeQAaAdAvAAQAYAAAQgDQAQgDAdgLIAAAWQgXAKgUAEQgRAEgZgBQg6AAgigkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgVgagjAAQgngBgXAag");
	this.shape_1527.setTransform(319.2,249.1,0.5,0.5);

	this.shape_1528 = new cjs.Shape();
	this.shape_1528.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1528.setTransform(304.7,246.2,0.5,0.5);

	this.shape_1529 = new cjs.Shape();
	this.shape_1529.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1529.setTransform(292.7,247.6,0.5,0.5);

	this.shape_1530 = new cjs.Shape();
	this.shape_1530.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1530.setTransform(277.5,247.6,0.5,0.5);

	this.shape_1531 = new cjs.Shape();
	this.shape_1531.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1531.setTransform(266.2,249.1,0.5,0.5);

	this.shape_1532 = new cjs.Shape();
	this.shape_1532.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAKgRAIgYIANgjIhnkOIAaAAIA4CYQAaBEAIAaIAAAAQALgiAYg9IA4iXIAaAAIh5E6QgOAmgKAOQgKANgNAHQgNAGgTABQgQAAgQgGg");
	this.shape_1532.setTransform(247.5,252.2,0.5,0.5);

	this.shape_1533 = new cjs.Shape();
	this.shape_1533.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_1533.setTransform(237.5,249,0.5,0.5);

	this.shape_1534 = new cjs.Shape();
	this.shape_1534.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1534.setTransform(228.8,246.2,0.5,0.5);

	this.shape_1535 = new cjs.Shape();
	this.shape_1535.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgZgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_1535.setTransform(218.9,249.1,0.5,0.5);

	this.shape_1536 = new cjs.Shape();
	this.shape_1536.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_1536.setTransform(202.7,249.1,0.5,0.5);

	this.shape_1537 = new cjs.Shape();
	this.shape_1537.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAcAigBA5IAAASIjBAAQABA4AYAeQAaAdAvAAQAWAAASgDQAQgDAdgLIAAAWQgXAKgUAEQgSAEgYgBQg6AAgigkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgVgagjAAQgmgBgYAag");
	this.shape_1537.setTransform(186.5,249.1,0.5,0.5);

	this.shape_1538 = new cjs.Shape();
	this.shape_1538.graphics.f("#000000").s().p("AgwDwIAAgWQAQAGAQAAQAkgBAAgrIAAlGIAZAAIAAFCQAAAjgQARQgPASgdAAQgTAAgOgGgAARjeQAAgXAPAAQAJAAAEAGQAEAGAAALQAAAMgEAGQgFAHgIAAQgPAAAAgZg");
	this.shape_1538.setTransform(175,249.7,0.5,0.5);

	this.shape_1539 = new cjs.Shape();
	this.shape_1539.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1539.setTransform(161.1,249.1,0.5,0.5);

	this.shape_1540 = new cjs.Shape();
	this.shape_1540.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAmgBAWgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgeAagSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAPAMQAPANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1540.setTransform(149.2,249.1,0.5,0.5);

	this.shape_1541 = new cjs.Shape();
	this.shape_1541.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1541.setTransform(136.1,249.1,0.5,0.5);

	this.shape_1542 = new cjs.Shape();
	this.shape_1542.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1542.setTransform(126.9,246.2,0.5,0.5);

	this.shape_1543 = new cjs.Shape();
	this.shape_1543.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_1543.setTransform(118.3,249.1,0.5,0.5);

	this.shape_1544 = new cjs.Shape();
	this.shape_1544.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_1544.setTransform(107.8,249,0.5,0.5);

	this.shape_1545 = new cjs.Shape();
	this.shape_1545.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAegmA3AAQAbAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQggAug5AAQg3AAgegjgAhBgeQgXAeAAA7QABBzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_1545.setTransform(95.8,246.3,0.5,0.5);

	this.shape_1546 = new cjs.Shape();
	this.shape_1546.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1546.setTransform(85.7,246.2,0.5,0.5);

	this.shape_1547 = new cjs.Shape();
	this.shape_1547.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1547.setTransform(78.7,249,0.5,0.5);

	this.shape_1548 = new cjs.Shape();
	this.shape_1548.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPghAAgpQAAhBAhgmQAfglA4AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgjABgcgSgAhEhWQgZAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1548.setTransform(65.4,249.1,0.5,0.5);

	this.shape_1549 = new cjs.Shape();
	this.shape_1549.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA3AFAeIABAAQAPg7AHgSIA4ikIAVAAIA1CjQATBAADAOIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_1549.setTransform(48.7,249.1,0.5,0.5);

	this.shape_1550 = new cjs.Shape();
	this.shape_1550.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_1550.setTransform(659.4,210.7,0.5,0.5);

	this.shape_1551 = new cjs.Shape();
	this.shape_1551.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1551.setTransform(650.7,208.4,0.5,0.5);

	this.shape_1552 = new cjs.Shape();
	this.shape_1552.graphics.f("#000000").s().p("AhMBoQghgkAAhBQAAhBAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1552.setTransform(640.8,210.9,0.5,0.5);

	this.shape_1553 = new cjs.Shape();
	this.shape_1553.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1553.setTransform(626.3,207.9,0.5,0.5);

	this.shape_1554 = new cjs.Shape();
	this.shape_1554.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1554.setTransform(614.3,209.4,0.5,0.5);

	this.shape_1555 = new cjs.Shape();
	this.shape_1555.graphics.f("#000000").s().p("AhMBoQgigkAAhBQAAhAAhgoQAggmA0gBQAwABAcAhQAbAiAAA5IAAASIjBAAQABA4AZAeQAZAdAvAAQAYAAAQgDQAQgCAdgMIAAAWQgYAKgSAEQgTAEgYgBQg7AAgggkgAg2hcQgXAZgFAyICnAAQgBgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1555.setTransform(596.6,210.9,0.5,0.5);

	this.shape_1556 = new cjs.Shape();
	this.shape_1556.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1556.setTransform(585.5,210.7,0.5,0.5);

	this.shape_1557 = new cjs.Shape();
	this.shape_1557.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1557.setTransform(572.1,211,0.5,0.5);

	this.shape_1558 = new cjs.Shape();
	this.shape_1558.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1558.setTransform(560.2,209.4,0.5,0.5);

	this.shape_1559 = new cjs.Shape();
	this.shape_1559.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1559.setTransform(548.9,210.9,0.5,0.5);

	this.shape_1560 = new cjs.Shape();
	this.shape_1560.graphics.f("#000000").s().p("AhNBoQgggkgBhBQABhBAfgnQAggmA2gBQAvABAcAhQAbAjAAA4IAAASIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAQgDAcgLIAAAWQgXAKgUAEQgRAEgagBQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgVgagjAAQgmAAgZAZg");
	this.shape_1560.setTransform(535.6,210.9,0.5,0.5);

	this.shape_1561 = new cjs.Shape();
	this.shape_1561.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgUQAAgzASgXQARgXAqAAQAXAAAWAHIgGAVQgUgGgUAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1561.setTransform(525.6,207.9,0.5,0.5);

	this.shape_1562 = new cjs.Shape();
	this.shape_1562.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1562.setTransform(506.8,210.9,0.5,0.5);

	this.shape_1563 = new cjs.Shape();
	this.shape_1563.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1563.setTransform(494.9,209.4,0.5,0.5);

	this.shape_1564 = new cjs.Shape();
	this.shape_1564.graphics.f("#000000").s().p("AhMBoQgigkAAhBQAAhBAhgnQAfgmA1gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAWQgYAKgSAEQgSAEgagBQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgaglAAQgmAAgYAZg");
	this.shape_1564.setTransform(477.2,210.9,0.5,0.5);

	this.shape_1565 = new cjs.Shape();
	this.shape_1565.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAngBAVgNQAVgNgBgWQAAgUgQgOQgQgOgngOQgmgNgRgLQgRgKgIgOQgJgOAAgTQABgeAZgSQAZgRAugBQArAAAnARIgJAWQgngQgiAAQgfAAgVALQgUAMABASQgBAWAQANQAOAMArAPQAlAOAQAKQARAKAJANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1565.setTransform(464.2,210.9,0.5,0.5);

	this.shape_1566 = new cjs.Shape();
	this.shape_1566.graphics.f("#000000").s().p("Ag/B7QgbgQgPghQgOghAAgpQAAhBAggmQAgglA3AAQA5AAAfAmQAgAmAABAQAABBggAmQghAlg3AAQgjABgcgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1566.setTransform(450.9,210.9,0.5,0.5);

	this.shape_1567 = new cjs.Shape();
	this.shape_1567.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1567.setTransform(435.9,207.9,0.5,0.5);

	this.shape_1568 = new cjs.Shape();
	this.shape_1568.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6AAQAiAAAhANIgGAWQgkgMgZAAQgyAAgZAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgqAAQg6AAghgkg");
	this.shape_1568.setTransform(422.6,210.9,0.5,0.5);

	this.shape_1569 = new cjs.Shape();
	this.shape_1569.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAKgRAIgYIAOgjIhokOIAZAAIA5CYQAbBEAGAaIABAAQALgiAXg9IA5iXIAaAAIh4E6QgPAmgKAOQgJANgOAHQgNAGgTABQgQAAgQgGg");
	this.shape_1569.setTransform(403.8,213.9,0.5,0.5);

	this.shape_1570 = new cjs.Shape();
	this.shape_1570.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1570.setTransform(395,207.9,0.5,0.5);

	this.shape_1571 = new cjs.Shape();
	this.shape_1571.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1571.setTransform(384.1,208.1,0.5,0.5);

	this.shape_1572 = new cjs.Shape();
	this.shape_1572.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAlAAQAvAAAWgYQAXgZABg2IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgbAqhCAAQhdAAAAhjg");
	this.shape_1572.setTransform(369.4,211,0.5,0.5);

	this.shape_1573 = new cjs.Shape();
	this.shape_1573.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1573.setTransform(354.4,210.9,0.5,0.5);

	this.shape_1574 = new cjs.Shape();
	this.shape_1574.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_1574.setTransform(342.9,210.7,0.5,0.5);

	this.shape_1575 = new cjs.Shape();
	this.shape_1575.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAdAkAABFQgBBBgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhCiWQgXAaAAA7IAAAIQABA/AUAbQAWAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_1575.setTransform(329.9,213.8,0.5,0.5);

	this.shape_1576 = new cjs.Shape();
	this.shape_1576.graphics.f("#000000").s().p("AgdA+QAThCAIg6IAdAAIADAGQgSBBgZA1g");
	this.shape_1576.setTransform(312.1,217.8,0.5,0.5);

	this.shape_1577 = new cjs.Shape();
	this.shape_1577.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1577.setTransform(305.3,209.4,0.5,0.5);

	this.shape_1578 = new cjs.Shape();
	this.shape_1578.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1578.setTransform(296.8,209.4,0.5,0.5);

	this.shape_1579 = new cjs.Shape();
	this.shape_1579.graphics.f("#000000").s().p("AhNBoQgggkAAhBQgBhBAggnQAggmA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQgBA4AaAeQAaAdAvAAQAXAAARgDQAPgCAdgMIAAAWQgWAKgUAEQgSAEgYgBQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgVgaQgUgagkAAQgnAAgWAZg");
	this.shape_1579.setTransform(285.7,210.9,0.5,0.5);

	this.shape_1580 = new cjs.Shape();
	this.shape_1580.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1580.setTransform(271.2,210.7,0.5,0.5);

	this.shape_1581 = new cjs.Shape();
	this.shape_1581.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQARgMAcAAQAOAAAWADIgEAZQgRgFgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_1581.setTransform(259.6,210.7,0.5,0.5);

	this.shape_1582 = new cjs.Shape();
	this.shape_1582.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1582.setTransform(246.5,210.9,0.5,0.5);

	this.shape_1583 = new cjs.Shape();
	this.shape_1583.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBDAAAfAXQAgAXAAAuQAAAggTAVQgUAVglAGIAAABQArAHAVAUQAVAUAAAnQAAAyghAbQgiAbg8AAgAhdCgIBVAAQBkAAAAhSQAAhMhpAAIhQAAgAhdgTIBQAAQAyAAAXgRQAYgRAAglQAAgkgbgQQgagRgzAAIhJAAg");
	this.shape_1583.setTransform(232.8,208.5,0.5,0.5);

	this.shape_1584 = new cjs.Shape();
	this.shape_1584.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAcgqBCAAQBbAAABBjIAACwg");
	this.shape_1584.setTransform(210.2,210.7,0.5,0.5);

	this.shape_1585 = new cjs.Shape();
	this.shape_1585.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1585.setTransform(195.4,210.9,0.5,0.5);

	this.shape_1586 = new cjs.Shape();
	this.shape_1586.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QAOAlAGAYIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_1586.setTransform(183.2,210.9,0.5,0.5);

	this.shape_1587 = new cjs.Shape();
	this.shape_1587.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_1587.setTransform(174.1,208.5,0.5,0.5);

	this.shape_1588 = new cjs.Shape();
	this.shape_1588.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1588.setTransform(156.3,208.1,0.5,0.5);

	this.shape_1589 = new cjs.Shape();
	this.shape_1589.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_1589.setTransform(141.7,210.7,0.5,0.5);

	this.shape_1590 = new cjs.Shape();
	this.shape_1590.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgcAAQgqAAgUgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1590.setTransform(126.9,210.9,0.5,0.5);

	this.shape_1591 = new cjs.Shape();
	this.shape_1591.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1591.setTransform(106.5,210.7,0.5,0.5);

	this.shape_1592 = new cjs.Shape();
	this.shape_1592.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1592.setTransform(91.4,210.9,0.5,0.5);

	this.shape_1593 = new cjs.Shape();
	this.shape_1593.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAQANQAOAMArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1593.setTransform(77.9,210.9,0.5,0.5);

	this.shape_1594 = new cjs.Shape();
	this.shape_1594.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1594.setTransform(69.2,208.4,0.5,0.5);

	this.shape_1595 = new cjs.Shape();
	this.shape_1595.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1595.setTransform(63.4,207.9,0.5,0.5);

	this.shape_1596 = new cjs.Shape();
	this.shape_1596.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_1596.setTransform(57.7,207.9,0.5,0.5);

	this.shape_1597 = new cjs.Shape();
	this.shape_1597.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_1597.setTransform(47.2,208.5,0.5,0.5);

	this.shape_1598 = new cjs.Shape();
	this.shape_1598.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgSA/gYA3g");
	this.shape_1598.setTransform(678.7,179.6,0.5,0.5);

	this.shape_1599 = new cjs.Shape();
	this.shape_1599.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1599.setTransform(673.5,169.7,0.5,0.5);

	this.shape_1600 = new cjs.Shape();
	this.shape_1600.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1600.setTransform(667.8,169.7,0.5,0.5);

	this.shape_1601 = new cjs.Shape();
	this.shape_1601.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1601.setTransform(662,170.1,0.5,0.5);

	this.shape_1602 = new cjs.Shape();
	this.shape_1602.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_1602.setTransform(654.1,169.7,0.5,0.5);

	this.shape_1603 = new cjs.Shape();
	this.shape_1603.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgngNgRgLQgRgLgIgNQgIgOgBgTQAAgeAagSQAZgRAugBQArAAAnARIgIAWQgogQgiAAQggAAgUALQgTAMAAASQgBAWAPANQAOALAsAQQAkANASALQARAKAIANQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_1603.setTransform(640.8,172.6,0.5,0.5);

	this.shape_1604 = new cjs.Shape();
	this.shape_1604.graphics.f("#000000").s().p("AhMBoQghgkAAhBQAAhBAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmAAgXAZg");
	this.shape_1604.setTransform(621.3,172.6,0.5,0.5);

	this.shape_1605 = new cjs.Shape();
	this.shape_1605.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAMAdAJAgIABAAQAKghALgdIBGi2IAZAAIhpENg");
	this.shape_1605.setTransform(608.4,172.6,0.5,0.5);

	this.shape_1606 = new cjs.Shape();
	this.shape_1606.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1606.setTransform(599.7,170.1,0.5,0.5);

	this.shape_1607 = new cjs.Shape();
	this.shape_1607.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgXAAQgkABgQgUg");
	this.shape_1607.setTransform(592.4,171.1,0.5,0.5);

	this.shape_1608 = new cjs.Shape();
	this.shape_1608.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA5QAAA3AaAeQAZAfAuAAQAmAAAegNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_1608.setTransform(582.5,172.6,0.5,0.5);

	this.shape_1609 = new cjs.Shape();
	this.shape_1609.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1609.setTransform(568.7,172.5,0.5,0.5);

	this.shape_1610 = new cjs.Shape();
	this.shape_1610.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1610.setTransform(558.3,170.1,0.5,0.5);

	this.shape_1611 = new cjs.Shape();
	this.shape_1611.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1611.setTransform(550.9,171.1,0.5,0.5);

	this.shape_1612 = new cjs.Shape();
	this.shape_1612.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAmgBAWgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAPANQAPAMArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1612.setTransform(540.8,172.6,0.5,0.5);

	this.shape_1613 = new cjs.Shape();
	this.shape_1613.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1613.setTransform(532.1,170.1,0.5,0.5);

	this.shape_1614 = new cjs.Shape();
	this.shape_1614.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA2AAQAcAAAXALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_1614.setTransform(521.2,169.8,0.5,0.5);

	this.shape_1615 = new cjs.Shape();
	this.shape_1615.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAegkQAdgmA2AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_1615.setTransform(499.4,169.8,0.5,0.5);

	this.shape_1616 = new cjs.Shape();
	this.shape_1616.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgvABgXAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_1616.setTransform(484.7,172.5,0.5,0.5);

	this.shape_1617 = new cjs.Shape();
	this.shape_1617.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1617.setTransform(469.9,172.6,0.5,0.5);

	this.shape_1618 = new cjs.Shape();
	this.shape_1618.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAKgGAIgMQAIgOAKgbIAOgjIhokOIAZAAIA6CYQAaBEAHAaIAAAAIBcj2IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_1618.setTransform(451.2,175.7,0.5,0.5);

	this.shape_1619 = new cjs.Shape();
	this.shape_1619.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1619.setTransform(441.2,172.5,0.5,0.5);

	this.shape_1620 = new cjs.Shape();
	this.shape_1620.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1620.setTransform(427.9,172.6,0.5,0.5);

	this.shape_1621 = new cjs.Shape();
	this.shape_1621.graphics.f("#000000").s().p("AgSCXQgQgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1621.setTransform(416,171.1,0.5,0.5);

	this.shape_1622 = new cjs.Shape();
	this.shape_1622.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAUgMAAgXQAAgUgQgOQgQgOgmgOQgngNgSgLQgQgLgIgNQgJgOABgTQAAgeAZgSQAagRAsgBQAtAAAnARIgJAWQgogQgjAAQgfAAgUALQgTAMgBASQAAAWAPANQAOALAtAQQAjANASALQAPAKAKANQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1622.setTransform(405.9,172.6,0.5,0.5);

	this.shape_1623 = new cjs.Shape();
	this.shape_1623.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAngBAVgNQAUgMAAgXQAAgUgQgOQgQgOgngOQgmgNgSgLQgPgKgJgOQgJgOAAgTQAAgeAagSQAagRAsgBQAtAAAmARIgJAWQgngQgjAAQgfAAgUALQgUAMAAASQABAWAPANQAOAMArAPQAlAOAQAKQARAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1623.setTransform(387.4,172.6,0.5,0.5);

	this.shape_1624 = new cjs.Shape();
	this.shape_1624.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAvAAAXgYQAXgYAAg3IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_1624.setTransform(373.9,172.7,0.5,0.5);

	this.shape_1625 = new cjs.Shape();
	this.shape_1625.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1625.setTransform(359,172.6,0.5,0.5);

	this.shape_1626 = new cjs.Shape();
	this.shape_1626.graphics.f("#000000").s().p("AhNBoQgggkgBhBQABhBAggnQAfgmA2gBQAvABAcAhQAbAiAAA5IAAASIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQARgCAcgMIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgVgagjAAQgnAAgXAZg");
	this.shape_1626.setTransform(344.6,172.6,0.5,0.5);

	this.shape_1627 = new cjs.Shape();
	this.shape_1627.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQgBgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQgBgaAkgVQgYgKgNgVQgNgUgBgbQABgpAZgZQAagYAsAAQAZAAAPAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgQAIgHAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQg0AAgbgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgQgLQgRgLglAAIgsAAQhKAAAAA7gAg5igQgSATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgTgSgfAAQggAAgUATg");
	this.shape_1627.setTransform(330.9,175.5,0.5,0.5);

	this.shape_1628 = new cjs.Shape();
	this.shape_1628.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1628.setTransform(317,172.6,0.5,0.5);

	this.shape_1629 = new cjs.Shape();
	this.shape_1629.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQARgMAcAAQANAAAYADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1629.setTransform(306.6,172.5,0.5,0.5);

	this.shape_1630 = new cjs.Shape();
	this.shape_1630.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAlAAQAvAAAXgYQAWgZAAg2IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_1630.setTransform(293.2,172.7,0.5,0.5);

	this.shape_1631 = new cjs.Shape();
	this.shape_1631.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1631.setTransform(278.3,172.6,0.5,0.5);

	this.shape_1632 = new cjs.Shape();
	this.shape_1632.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6AAQAiAAAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAaAfAtAAQAmAAAfgNIAAAXQgaAMgrAAQg4AAgigkg");
	this.shape_1632.setTransform(265,172.6,0.5,0.5);

	this.shape_1633 = new cjs.Shape();
	this.shape_1633.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1633.setTransform(248,172.5,0.5,0.5);

	this.shape_1634 = new cjs.Shape();
	this.shape_1634.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1634.setTransform(239.3,170.1,0.5,0.5);

	this.shape_1635 = new cjs.Shape();
	this.shape_1635.graphics.f("#000000").s().p("AhMBoQgigkAAhBQAAhBAhgnQAfgmA1gBQAwABAcAhQAcAjAAA4IAAASIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQARgDAbgLIAAAWQgWAKgTAEQgTAEgYgBQg6AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgagkAAQgmAAgYAZg");
	this.shape_1635.setTransform(229.4,172.6,0.5,0.5);

	this.shape_1636 = new cjs.Shape();
	this.shape_1636.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1636.setTransform(214.9,169.7,0.5,0.5);

	this.shape_1637 = new cjs.Shape();
	this.shape_1637.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_1637.setTransform(202.9,171.1,0.5,0.5);

	this.shape_1638 = new cjs.Shape();
	this.shape_1638.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAKgGAIgMQAIgOAKgbIAOgjIhokOIAZAAIA6CYQAaBEAHAaIAAAAIBcj2IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_1638.setTransform(186.3,175.7,0.5,0.5);

	this.shape_1639 = new cjs.Shape();
	this.shape_1639.graphics.f("#000000").s().p("Ag0C4QgYgMgNgVIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAPgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_1639.setTransform(173.3,169.8,0.5,0.5);

	this.shape_1640 = new cjs.Shape();
	this.shape_1640.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_1640.setTransform(150.7,169.8,0.5,0.5);

	this.shape_1641 = new cjs.Shape();
	this.shape_1641.graphics.f("#000000").s().p("AhMBoQghgkAAhBQAAhBAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_1641.setTransform(136.5,172.6,0.5,0.5);

	this.shape_1642 = new cjs.Shape();
	this.shape_1642.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_1642.setTransform(125.4,172.5,0.5,0.5);

	this.shape_1643 = new cjs.Shape();
	this.shape_1643.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhglA3AAQA3AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_1643.setTransform(112.1,172.6,0.5,0.5);

	this.shape_1644 = new cjs.Shape();
	this.shape_1644.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgSQgPgTggAAQgqAAgTAYQgUAWAAAyIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAaQgUAZAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgKQAVgMAYAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_1644.setTransform(93.4,172.5,0.5,0.5);

	this.shape_1645 = new cjs.Shape();
	this.shape_1645.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1645.setTransform(74.9,172.6,0.5,0.5);

	this.shape_1646 = new cjs.Shape();
	this.shape_1646.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_1646.setTransform(61.2,172.5,0.5,0.5);

	this.shape_1647 = new cjs.Shape();
	this.shape_1647.graphics.f("#000000").s().p("AhiC2IAAlrIDGAAIAAAXIiuAAIAACKICkAAIAAAWIikAAIAACdICuAAIAAAXg");
	this.shape_1647.setTransform(47.1,170.3,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1647},{t:this.shape_1646},{t:this.shape_1645},{t:this.shape_1644},{t:this.shape_1643},{t:this.shape_1642},{t:this.shape_1641},{t:this.shape_1640},{t:this.shape_1639},{t:this.shape_1638},{t:this.shape_1637},{t:this.shape_1636},{t:this.shape_1635},{t:this.shape_1634},{t:this.shape_1633},{t:this.shape_1632},{t:this.shape_1631},{t:this.shape_1630},{t:this.shape_1629},{t:this.shape_1628},{t:this.shape_1627},{t:this.shape_1626},{t:this.shape_1625},{t:this.shape_1624},{t:this.shape_1623},{t:this.shape_1622},{t:this.shape_1621},{t:this.shape_1620},{t:this.shape_1619},{t:this.shape_1618},{t:this.shape_1617},{t:this.shape_1616},{t:this.shape_1615},{t:this.shape_1614},{t:this.shape_1613},{t:this.shape_1612},{t:this.shape_1611},{t:this.shape_1610},{t:this.shape_1609},{t:this.shape_1608},{t:this.shape_1607},{t:this.shape_1606},{t:this.shape_1605},{t:this.shape_1604},{t:this.shape_1603},{t:this.shape_1602},{t:this.shape_1601},{t:this.shape_1600},{t:this.shape_1599},{t:this.shape_1598},{t:this.shape_1597},{t:this.shape_1596},{t:this.shape_1595},{t:this.shape_1594},{t:this.shape_1593},{t:this.shape_1592},{t:this.shape_1591},{t:this.shape_1590},{t:this.shape_1589},{t:this.shape_1588},{t:this.shape_1587},{t:this.shape_1586},{t:this.shape_1585},{t:this.shape_1584},{t:this.shape_1583},{t:this.shape_1582},{t:this.shape_1581},{t:this.shape_1580},{t:this.shape_1579},{t:this.shape_1578},{t:this.shape_1577},{t:this.shape_1576},{t:this.shape_1575},{t:this.shape_1574},{t:this.shape_1573},{t:this.shape_1572},{t:this.shape_1571},{t:this.shape_1570},{t:this.shape_1569},{t:this.shape_1568},{t:this.shape_1567},{t:this.shape_1566},{t:this.shape_1565},{t:this.shape_1564},{t:this.shape_1563},{t:this.shape_1562},{t:this.shape_1561},{t:this.shape_1560},{t:this.shape_1559},{t:this.shape_1558},{t:this.shape_1557},{t:this.shape_1556},{t:this.shape_1555},{t:this.shape_1554},{t:this.shape_1553},{t:this.shape_1552},{t:this.shape_1551},{t:this.shape_1550},{t:this.shape_1549},{t:this.shape_1548},{t:this.shape_1547},{t:this.shape_1546},{t:this.shape_1545},{t:this.shape_1544},{t:this.shape_1543},{t:this.shape_1542},{t:this.shape_1541},{t:this.shape_1540},{t:this.shape_1539},{t:this.shape_1538},{t:this.shape_1537},{t:this.shape_1536},{t:this.shape_1535},{t:this.shape_1534},{t:this.shape_1533},{t:this.shape_1532},{t:this.shape_1531},{t:this.shape_1530},{t:this.shape_1529},{t:this.shape_1528},{t:this.shape_1527},{t:this.shape_1526},{t:this.shape_1525},{t:this.shape_1524},{t:this.shape_1523},{t:this.shape_1522},{t:this.shape_1521},{t:this.shape_1520},{t:this.shape_1519},{t:this.shape_1518},{t:this.shape_1517},{t:this.shape_1516},{t:this.shape_1515},{t:this.shape_1514},{t:this.shape_1513},{t:this.shape_1512},{t:this.shape_1511},{t:this.shape_1510},{t:this.shape_1509},{t:this.shape_1508},{t:this.shape_1507},{t:this.shape_1506},{t:this.shape_1505},{t:this.shape_1504},{t:this.shape_1503},{t:this.shape_1502},{t:this.shape_1501},{t:this.shape_1500},{t:this.shape_1499},{t:this.shape_1498},{t:this.shape_1497},{t:this.shape_1496},{t:this.shape_1495},{t:this.shape_1494},{t:this.shape_1493},{t:this.shape_1492},{t:this.shape_1491},{t:this.shape_1490},{t:this.shape_1489},{t:this.shape_1488},{t:this.shape_1487},{t:this.shape_1486},{t:this.shape_1485},{t:this.shape_1484},{t:this.shape_1483},{t:this.shape_1482},{t:this.shape_1481},{t:this.shape_1480},{t:this.shape_1479},{t:this.shape_1478},{t:this.shape_1477},{t:this.shape_1476},{t:this.shape_1475},{t:this.shape_1474},{t:this.shape_1473},{t:this.shape_1472},{t:this.shape_1471},{t:this.shape_1470},{t:this.shape_1469},{t:this.shape_1468},{t:this.shape_1467},{t:this.shape_1466},{t:this.shape_1465},{t:this.shape_1464},{t:this.shape_1463},{t:this.shape_1462},{t:this.shape_1461},{t:this.shape_1460},{t:this.shape_1459},{t:this.shape_1458},{t:this.shape_1457},{t:this.shape_1456},{t:this.shape_1455},{t:this.shape_1454},{t:this.shape_1453},{t:this.shape_1452},{t:this.shape_1451},{t:this.shape_1450},{t:this.shape_1449},{t:this.shape_1448},{t:this.shape_1447},{t:this.shape_1446},{t:this.shape_1445},{t:this.shape_1444},{t:this.shape_1443},{t:this.shape_1442},{t:this.shape_1441},{t:this.shape_1440},{t:this.shape_1439},{t:this.shape_1438},{t:this.shape_1437},{t:this.shape_1436},{t:this.shape_1435},{t:this.shape_1434},{t:this.shape_1433},{t:this.shape_1432},{t:this.shape_1431},{t:this.shape_1430},{t:this.shape_1429},{t:this.shape_1428},{t:this.shape_1427},{t:this.shape_1426},{t:this.shape_1425},{t:this.shape_1424},{t:this.shape_1423},{t:this.shape_1422},{t:this.shape_1421},{t:this.shape_1420},{t:this.shape_1419},{t:this.shape_1418},{t:this.shape_1417},{t:this.shape_1416},{t:this.shape_1415},{t:this.shape_1414},{t:this.shape_1413},{t:this.shape_1412},{t:this.shape_1411},{t:this.shape_1410},{t:this.shape_1409},{t:this.shape_1408},{t:this.shape_1407},{t:this.shape_1406},{t:this.shape_1405},{t:this.shape_1404},{t:this.shape_1403},{t:this.shape_1402},{t:this.shape_1401},{t:this.shape_1400},{t:this.shape_1399},{t:this.shape_1398},{t:this.shape_1397},{t:this.shape_1396},{t:this.shape_1395},{t:this.shape_1394},{t:this.shape_1393},{t:this.shape_1392},{t:this.shape_1391},{t:this.shape_1390},{t:this.shape_1389},{t:this.shape_1388},{t:this.shape_1387},{t:this.shape_1386},{t:this.shape_1385},{t:this.shape_1384},{t:this.shape_1383},{t:this.shape_1382},{t:this.shape_1381},{t:this.shape_1380},{t:this.shape_1379},{t:this.shape_1378},{t:this.shape_1377},{t:this.shape_1376},{t:this.shape_1375},{t:this.shape_1374},{t:this.shape_1373},{t:this.shape_1372},{t:this.shape_1371},{t:this.shape_1370},{t:this.shape_1369},{t:this.shape_1368},{t:this.shape_1367},{t:this.shape_1366},{t:this.shape_1365},{t:this.shape_1364},{t:this.shape_1363},{t:this.shape_1362},{t:this.shape_1361},{t:this.shape_1360},{t:this.shape_1359},{t:this.shape_1358},{t:this.shape_1357},{t:this.shape_1356},{t:this.shape_1355},{t:this.shape_1354},{t:this.shape_1353},{t:this.shape_1352},{t:this.shape_1351},{t:this.shape_1350},{t:this.shape_1349},{t:this.shape_1348},{t:this.shape_1347},{t:this.shape_1346},{t:this.shape_1345},{t:this.shape_1344},{t:this.shape_1343},{t:this.shape_1342},{t:this.shape_1341},{t:this.shape_1340},{t:this.shape_1339},{t:this.shape_1338},{t:this.shape_1337},{t:this.shape_1336},{t:this.shape_1335},{t:this.shape_1334},{t:this.shape_1333},{t:this.shape_1332},{t:this.shape_1331},{t:this.shape_1330},{t:this.shape_1329},{t:this.shape_1328},{t:this.shape_1327},{t:this.shape_1326},{t:this.shape_1325},{t:this.shape_1324},{t:this.shape_1323},{t:this.shape_1322},{t:this.shape_1321},{t:this.shape_1320},{t:this.shape_1319},{t:this.shape_1318},{t:this.shape_1317},{t:this.shape_1316},{t:this.shape_1315},{t:this.shape_1314},{t:this.shape_1313},{t:this.shape_1312},{t:this.shape_1311},{t:this.shape_1310},{t:this.shape_1309},{t:this.shape_1308},{t:this.shape_1307},{t:this.shape_1306},{t:this.shape_1305},{t:this.shape_1304},{t:this.shape_1303},{t:this.shape_1302},{t:this.shape_1301},{t:this.shape_1300},{t:this.shape_1299},{t:this.shape_1298},{t:this.shape_1297},{t:this.shape_1296},{t:this.shape_1295},{t:this.shape_1294},{t:this.shape_1293},{t:this.shape_1292},{t:this.shape_1291},{t:this.shape_1290},{t:this.shape_1289},{t:this.shape_1288},{t:this.shape_1287},{t:this.shape_1286},{t:this.shape_1285},{t:this.shape_1284},{t:this.shape_1283},{t:this.shape_1282},{t:this.shape_1281},{t:this.shape_1280},{t:this.shape_1279},{t:this.shape_1278},{t:this.shape_1277},{t:this.shape_1276},{t:this.shape_1275},{t:this.shape_1274},{t:this.shape_1273},{t:this.shape_1272},{t:this.shape_1271},{t:this.shape_1270},{t:this.shape_1269},{t:this.shape_1268},{t:this.shape_1267},{t:this.shape_1266},{t:this.shape_1265},{t:this.shape_1264},{t:this.shape_1263},{t:this.shape_1262},{t:this.shape_1261},{t:this.shape_1260},{t:this.shape_1259},{t:this.shape_1258},{t:this.shape_1257},{t:this.shape_1256},{t:this.shape_1255},{t:this.shape_1254},{t:this.shape_1253},{t:this.shape_1252},{t:this.shape_1251},{t:this.shape_1250},{t:this.shape_1249},{t:this.shape_1248},{t:this.shape_1247},{t:this.shape_1246},{t:this.shape_1245},{t:this.shape_1244},{t:this.shape_1243},{t:this.shape_1242},{t:this.shape_1241},{t:this.shape_1240},{t:this.shape_1239},{t:this.shape_1238},{t:this.shape_1237},{t:this.shape_1236},{t:this.shape_1235},{t:this.shape_1234},{t:this.shape_1233},{t:this.shape_1232},{t:this.shape_1231},{t:this.shape_1230},{t:this.shape_1229},{t:this.shape_1228},{t:this.shape_1227},{t:this.shape_1226},{t:this.shape_1225},{t:this.shape_1224},{t:this.shape_1223},{t:this.shape_1222},{t:this.shape_1221},{t:this.shape_1220},{t:this.shape_1219},{t:this.shape_1218},{t:this.shape_1217},{t:this.shape_1216},{t:this.shape_1215},{t:this.shape_1214},{t:this.shape_1213},{t:this.shape_1212},{t:this.shape_1211},{t:this.shape_1210},{t:this.shape_1209},{t:this.shape_1208},{t:this.shape_1207},{t:this.shape_1206},{t:this.shape_1205},{t:this.shape_1204},{t:this.shape_1203},{t:this.shape_1202},{t:this.shape_1201},{t:this.shape_1200},{t:this.shape_1199},{t:this.shape_1198},{t:this.shape_1197},{t:this.shape_1196},{t:this.shape_1195},{t:this.shape_1194},{t:this.shape_1193},{t:this.shape_1192},{t:this.shape_1191},{t:this.shape_1190},{t:this.shape_1189},{t:this.shape_1188},{t:this.shape_1187},{t:this.shape_1186},{t:this.shape_1185},{t:this.shape_1184},{t:this.shape_1183},{t:this.shape_1182},{t:this.shape_1181},{t:this.shape_1180},{t:this.shape_1179},{t:this.shape_1178},{t:this.shape_1177},{t:this.shape_1176},{t:this.shape_1175},{t:this.shape_1174},{t:this.shape_1173},{t:this.shape_1172},{t:this.shape_1171},{t:this.shape_1170},{t:this.shape_1169},{t:this.shape_1168},{t:this.shape_1167},{t:this.shape_1166},{t:this.shape_1165},{t:this.shape_1164},{t:this.shape_1163},{t:this.shape_1162},{t:this.shape_1161},{t:this.shape_1160},{t:this.shape_1159},{t:this.shape_1158},{t:this.shape_1157},{t:this.shape_1156},{t:this.shape_1155},{t:this.shape_1154},{t:this.shape_1153},{t:this.shape_1152},{t:this.shape_1151},{t:this.shape_1150},{t:this.shape_1149},{t:this.shape_1148},{t:this.shape_1147},{t:this.shape_1146},{t:this.shape_1145},{t:this.shape_1144},{t:this.shape_1143},{t:this.shape_1142},{t:this.shape_1141},{t:this.shape_1140},{t:this.shape_1139},{t:this.shape_1138},{t:this.shape_1137},{t:this.shape_1136},{t:this.shape_1135},{t:this.shape_1134},{t:this.shape_1133},{t:this.shape_1132},{t:this.shape_1131},{t:this.shape_1130},{t:this.shape_1129},{t:this.shape_1128},{t:this.shape_1127},{t:this.shape_1126},{t:this.shape_1125},{t:this.shape_1124},{t:this.shape_1123},{t:this.shape_1122},{t:this.shape_1121},{t:this.shape_1120},{t:this.shape_1119},{t:this.shape_1118},{t:this.shape_1117},{t:this.shape_1116},{t:this.shape_1115},{t:this.shape_1114},{t:this.shape_1113},{t:this.shape_1112},{t:this.shape_1111},{t:this.shape_1110},{t:this.shape_1109},{t:this.shape_1108},{t:this.shape_1107},{t:this.shape_1106},{t:this.shape_1105},{t:this.shape_1104},{t:this.shape_1103},{t:this.shape_1102},{t:this.shape_1101},{t:this.shape_1100},{t:this.shape_1099},{t:this.shape_1098},{t:this.shape_1097},{t:this.shape_1096},{t:this.shape_1095},{t:this.shape_1094},{t:this.shape_1093},{t:this.shape_1092},{t:this.shape_1091},{t:this.shape_1090},{t:this.shape_1089},{t:this.shape_1088},{t:this.shape_1087},{t:this.shape_1086},{t:this.shape_1085},{t:this.shape_1084},{t:this.shape_1083},{t:this.shape_1082},{t:this.shape_1081},{t:this.shape_1080},{t:this.shape_1079},{t:this.shape_1078},{t:this.shape_1077},{t:this.shape_1076},{t:this.shape_1075},{t:this.shape_1074},{t:this.shape_1073},{t:this.shape_1072},{t:this.shape_1071},{t:this.shape_1070},{t:this.shape_1069},{t:this.shape_1068},{t:this.shape_1067},{t:this.shape_1066},{t:this.shape_1065},{t:this.shape_1064},{t:this.shape_1063},{t:this.shape_1062},{t:this.shape_1061},{t:this.shape_1060},{t:this.shape_1059},{t:this.shape_1058},{t:this.shape_1057},{t:this.shape_1056},{t:this.shape_1055},{t:this.shape_1054},{t:this.shape_1053},{t:this.shape_1052},{t:this.instance_5}]},117).to({state:[]},1).wait(47));

	// ButtonLeftRight copy 52
	this.buttonR25 = new lib.ButtonLeft_Right();
	this.buttonR25.name = "buttonR25";
	this.buttonR25.parent = this;
	this.buttonR25.setTransform(2025,513.5,1,1,180);
	this.buttonR25._off = true;
	new cjs.ButtonHelper(this.buttonR25, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR25).wait(116).to({_off:false},0).to({_off:true},1).wait(48));

	// ButtonLeftRight copy 53
	this.buttonL25 = new lib.ButtonLeft_Right();
	this.buttonL25.name = "buttonL25";
	this.buttonL25.parent = this;
	this.buttonL25.setTransform(0,437.2);
	this.buttonL25._off = true;
	new cjs.ButtonHelper(this.buttonL25, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL25).wait(116).to({_off:false},0).to({_off:true},1).wait(48));

	// Layer 1
	this.instance_6 = new lib.hammers();
	this.instance_6.parent = this;
	this.instance_6.setTransform(572,-9);

	this.shape_1648 = new cjs.Shape();
	this.shape_1648.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_1648.setTransform(483.6,499.9,0.5,0.5);

	this.shape_1649 = new cjs.Shape();
	this.shape_1649.graphics.f("#000000").s().p("AAzC3IAAhdIi7AAIAAgRIC0j/IAeAAIAAD7IA/AAIAAAVIg/AAIAABdgAAVhyIh/C3ICdAAIAAhoQAAhOADgwIgCAAQgHAOgYAhg");
	this.shape_1649.setTransform(473.4,491.8,0.5,0.5);

	this.shape_1650 = new cjs.Shape();
	this.shape_1650.graphics.f("#000000").s().p("AAjC2IAAkIQAAgkAEgnIgIAHIhMA8IgOgRIBihKIAVAAIAAFrg");
	this.shape_1650.setTransform(456.9,491.8,0.5,0.5);

	this.shape_1651 = new cjs.Shape();
	this.shape_1651.graphics.f("#000000").s().p("AhXCMQgdgvAAhdQAAhfAcgtQAdgvA7ABQA4gBAfAwQAeAwAABbQAABfgdAuQgeAug6AAQg5AAgegvgAhEh6QgWArABBPQgBBUAXAoQAWApAtAAQAvAAAUgqQAXgqAAhRQAAhPgXgrQgUgqgvAAQgvAAgVAqg");
	this.shape_1651.setTransform(444.2,491.8,0.5,0.5);

	this.shape_1652 = new cjs.Shape();
	this.shape_1652.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAlgnAUgZQAQgWAHgVQAIgUAAgXQAAgggVgVQgWgUggAAQguAAgqAhIgOgRQAvgnA3AAQAvAAAaAaQAcAZAAAtQAAAkgTAiQgRAfgxAzIhdBgIAAABIDCAAIAAAYg");
	this.shape_1652.setTransform(429.4,491.7,0.5,0.5);

	this.shape_1653 = new cjs.Shape();
	this.shape_1653.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAaAAA2IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_1653.setTransform(408.3,494,0.5,0.5);

	this.shape_1654 = new cjs.Shape();
	this.shape_1654.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAAMgEAGQgGAHgGAAQgPAAAAgZg");
	this.shape_1654.setTransform(397.8,491.7,0.5,0.5);

	this.shape_1655 = new cjs.Shape();
	this.shape_1655.graphics.f("#000000").s().p("AhMChQgigkABhBQAAhAAfgnQAhgnA0AAQAxAAAbAhQAbAhAAA5IAAAUIjBAAQABA4AZAdQAZAdAvAAQAWAAASgDQAUgEAZgKIAAAXQgYAKgSADQgTAEgYAAQg7AAggglgAg2giQgXAZgFAwICnAAQgBgugUgbQgUgaglAAQgmAAgXAagAgbhzIAAgEQARgSASgZQASgWAHgNIAjAAIAAAEQgKAOgVAVQgaAZgUASg");
	this.shape_1655.setTransform(381.3,491.3,0.5,0.5);

	this.shape_1656 = new cjs.Shape();
	this.shape_1656.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAJgGAIgMQAIgMALgdIAMgjIhnkOIAZAAIA6CYQAYBCAJAcIABAAQANgqAUg2IA6iWIAZAAIh4E6QgQAngJAMQgKAOgNAHQgNAGgUABQgPAAgQgGg");
	this.shape_1656.setTransform(368.4,497.2,0.5,0.5);

	this.shape_1657 = new cjs.Shape();
	this.shape_1657.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPAAAAgZg");
	this.shape_1657.setTransform(359.7,491.7,0.5,0.5);

	this.shape_1658 = new cjs.Shape();
	this.shape_1658.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_1658.setTransform(349.4,494,0.5,0.5);

	this.shape_1659 = new cjs.Shape();
	this.shape_1659.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1659.setTransform(334.6,494.1,0.5,0.5);

	this.shape_1660 = new cjs.Shape();
	this.shape_1660.graphics.f("#000000").s().p("Ag8DdIAAgWQAVAGAQAAQA7AAAAhCIAAluIAZAAIAAFrQAABchUAAQgWAAgPgHg");
	this.shape_1660.setTransform(322.7,494.1,0.5,0.5);

	this.shape_1661 = new cjs.Shape();
	this.shape_1661.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1661.setTransform(311.3,494,0.5,0.5);

	this.shape_1662 = new cjs.Shape();
	this.shape_1662.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2gBQAvABAbAhQAcAiAAA5IAAASIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAWQgWAKgUAEQgSADgYAAQg7ABghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgagjAAQgmAAgYAag");
	this.shape_1662.setTransform(298.4,494.1,0.5,0.5);

	this.shape_1663 = new cjs.Shape();
	this.shape_1663.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAAMgEAGQgGAHgGAAQgPAAAAgZg");
	this.shape_1663.setTransform(288.6,491.7,0.5,0.5);

	this.shape_1664 = new cjs.Shape();
	this.shape_1664.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1664.setTransform(282.8,491.2,0.5,0.5);

	this.shape_1665 = new cjs.Shape();
	this.shape_1665.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2gBQAvABAbAhQAcAiAAA5IAAASIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAWQgXAKgUAEQgSADgZAAQg5ABgiglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgagjAAQgnAAgXAag");
	this.shape_1665.setTransform(272.9,494.1,0.5,0.5);

	this.shape_1666 = new cjs.Shape();
	this.shape_1666.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgXAAQgjAAgRgTg");
	this.shape_1666.setTransform(261.4,492.6,0.5,0.5);

	this.shape_1667 = new cjs.Shape();
	this.shape_1667.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICTltIAOAAICQFtgAgNhiIgzCBICCAAIgyiCQgHgRgIgaQgGAYgIAUg");
	this.shape_1667.setTransform(249.7,491.8,0.5,0.5);

	this.shape_1668 = new cjs.Shape();
	this.shape_1668.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_1668.setTransform(227.4,491.3,0.5,0.5);

	this.shape_1669 = new cjs.Shape();
	this.shape_1669.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA6IAAASIjCAAQABA5AZAdQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgSAEQgTADgYAAQg6ABghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_1669.setTransform(213.3,494.1,0.5,0.5);

	this.shape_1670 = new cjs.Shape();
	this.shape_1670.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgRgLgIgNQgIgOAAgSQgBgfAagSQAZgRAugBQArAAAoARIgJAXQgogRgiAAQghAAgTALQgTAMAAASQAAAWAOAMQAPANAsAPQAjAOASAKQAPAJAKAOQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_1670.setTransform(200.2,494.1,0.5,0.5);

	this.shape_1671 = new cjs.Shape();
	this.shape_1671.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABBghAmQgfAlg4AAQgkABgbgSgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1671.setTransform(186.9,494.1,0.5,0.5);

	this.shape_1672 = new cjs.Shape();
	this.shape_1672.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_1672.setTransform(176.6,491.2,0.5,0.5);

	this.shape_1673 = new cjs.Shape();
	this.shape_1673.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA4QAAA4AZAeQAaAfAtAAQAlAAAggNIAAAXQgaAMgrAAQg4ABgiglg");
	this.shape_1673.setTransform(167.9,494.1,0.5,0.5);

	this.shape_1674 = new cjs.Shape();
	this.shape_1674.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAngBAVgNQAVgNgBgWQAAgVgQgNQgQgOgmgOQgqgOgOgKQgRgLgIgNQgJgOAAgSQAAgfAagSQAagRAsgBQAsAAAnARIgJAXQgngRgjAAQggAAgTALQgUAMAAASQABAWAPAMQAOAMArAQQAkANASALQAQAJAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_1674.setTransform(148.9,494.1,0.5,0.5);

	this.shape_1675 = new cjs.Shape();
	this.shape_1675.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_1675.setTransform(138.6,492.6,0.5,0.5);

	this.shape_1676 = new cjs.Shape();
	this.shape_1676.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAngBAVgNQAVgNAAgWQAAgVgQgNQgSgOglgOQgqgPgOgJQgRgLgIgNQgJgOAAgSQAAgfAagSQAbgRArgBQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAMAAASQABAWAPAMQAOAMArAQQAkANASALQARALAIAMQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1676.setTransform(128.5,494.1,0.5,0.5);

	this.shape_1677 = new cjs.Shape();
	this.shape_1677.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_1677.setTransform(119.8,491.7,0.5,0.5);

	this.shape_1678 = new cjs.Shape();
	this.shape_1678.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgYAAQgjAAgQgTg");
	this.shape_1678.setTransform(112.4,492.6,0.5,0.5);

	this.shape_1679 = new cjs.Shape();
	this.shape_1679.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAWADIgEAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1679.setTransform(104.3,494,0.5,0.5);

	this.shape_1680 = new cjs.Shape();
	this.shape_1680.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1680.setTransform(91.2,494.1,0.5,0.5);

	this.shape_1681 = new cjs.Shape();
	this.shape_1681.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA5IAAASIjCAAQAAA5AaAdQAYAdAwAAQAXAAARgDQAUgEAYgKIAAAWQgWAKgTAEQgTADgYAAQg6ABghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_1681.setTransform(71.3,494.1,0.5,0.5);

	this.shape_1682 = new cjs.Shape();
	this.shape_1682.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1682.setTransform(56.8,491.2,0.5,0.5);

	this.shape_1683 = new cjs.Shape();
	this.shape_1683.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_1683.setTransform(44.8,492.6,0.5,0.5);

	this.shape_1684 = new cjs.Shape();
	this.shape_1684.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTA/gXA3g");
	this.shape_1684.setTransform(518.8,462.8,0.5,0.5);

	this.shape_1685 = new cjs.Shape();
	this.shape_1685.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagRAsgBQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAMAAASQAAAWAPAMQAQANAqAPQAmAOAQAKQARALAIANQAIANAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_1685.setTransform(510.5,455.9,0.5,0.5);

	this.shape_1686 = new cjs.Shape();
	this.shape_1686.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1686.setTransform(500.6,455.8,0.5,0.5);

	this.shape_1687 = new cjs.Shape();
	this.shape_1687.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1687.setTransform(487.5,455.9,0.5,0.5);

	this.shape_1688 = new cjs.Shape();
	this.shape_1688.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA1gBQAwABAbAhQAbAhAAA6IAAASIjBAAQABA4AZAeQAYAdAwAAQAWAAASgDQAUgEAZgKIAAAXQgYAJgSAEQgTADgYAAQg7ABggglgAg2hbQgYAZgEAxICnAAQgBgwgUgaQgVgagjAAQgmAAgYAag");
	this.shape_1688.setTransform(474.2,455.9,0.5,0.5);

	this.shape_1689 = new cjs.Shape();
	this.shape_1689.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAJgGAIgMQAIgNAKgcIANgjIhnkOIAZAAIA6CYQAYBCAJAcIABAAQAIgeAZhCIA6iWIAZAAIh4E6QgPAngKANQgKANgNAHQgNAGgUAAQgPABgQgGg");
	this.shape_1689.setTransform(461.4,459,0.5,0.5);

	this.shape_1690 = new cjs.Shape();
	this.shape_1690.graphics.f("#000000").s().p("AhXCMQgdgwAAhcQAAhfAdgtQAdgvA6ABQA5gBAeAwQAeAwAABbQAABggdAtQgdAvg7gBQg5AAgegvgAhEh6QgVAqAABQQAABTAWApQAWApAtAAQAuAAAWgqQAVgpABhSQgBhRgVgpQgWgqguAAQgvAAgVAqg");
	this.shape_1690.setTransform(441.6,453.5,0.5,0.5);

	this.shape_1691 = new cjs.Shape();
	this.shape_1691.graphics.f("#000000").s().p("AAyC3IAAhdIi6AAIAAgRIC0j/IAeAAIAAD7IA/AAIAAAVIg/AAIAABdgAAVhyIh/C3ICcAAIAAhoQAAhCAEg8IgCAAQgDAHgcAog");
	this.shape_1691.setTransform(427.1,453.5,0.5,0.5);

	this.shape_1692 = new cjs.Shape();
	this.shape_1692.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKANQgLAOgMAGQgNAGgTAAQgPABgRgGg");
	this.shape_1692.setTransform(407.3,459,0.5,0.5);

	this.shape_1693 = new cjs.Shape();
	this.shape_1693.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1693.setTransform(398.6,453,0.5,0.5);

	this.shape_1694 = new cjs.Shape();
	this.shape_1694.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIACAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1694.setTransform(391.6,455.8,0.5,0.5);

	this.shape_1695 = new cjs.Shape();
	this.shape_1695.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1695.setTransform(378.5,455.9,0.5,0.5);

	this.shape_1696 = new cjs.Shape();
	this.shape_1696.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2gBQAvABAbAhQAcAiAAA5IAAASIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgRADgZAAQg7ABghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgagjAAQgmAAgYAag");
	this.shape_1696.setTransform(365.3,455.9,0.5,0.5);

	this.shape_1697 = new cjs.Shape();
	this.shape_1697.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBbAAABBjIAACwg");
	this.shape_1697.setTransform(350.8,455.8,0.5,0.5);

	this.shape_1698 = new cjs.Shape();
	this.shape_1698.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1698.setTransform(332.5,455.8,0.5,0.5);

	this.shape_1699 = new cjs.Shape();
	this.shape_1699.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_1699.setTransform(319.2,455.9,0.5,0.5);

	this.shape_1700 = new cjs.Shape();
	this.shape_1700.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAXAAAWAHIgGAVQgVgHgTAAQgdABgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1700.setTransform(308.8,452.9,0.5,0.5);

	this.shape_1701 = new cjs.Shape();
	this.shape_1701.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_1701.setTransform(293.4,455.8,0.5,0.5);

	this.shape_1702 = new cjs.Shape();
	this.shape_1702.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAhAAA6IAAASIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTADgYAAQg6ABghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_1702.setTransform(280.5,455.9,0.5,0.5);

	this.shape_1703 = new cjs.Shape();
	this.shape_1703.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1703.setTransform(266.1,453,0.5,0.5);

	this.shape_1704 = new cjs.Shape();
	this.shape_1704.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_1704.setTransform(254,454.4,0.5,0.5);

	this.shape_1705 = new cjs.Shape();
	this.shape_1705.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgFAYgJIAAAXQgWAJgTAEQgTADgYAAQg7ABggglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_1705.setTransform(243,455.9,0.5,0.5);

	this.shape_1706 = new cjs.Shape();
	this.shape_1706.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcARgSQATgTAcgHQgLgFgIgJQgHgJAAgNQAAgbAigUQgXgKgOgVQgNgUABgcQgBgoAagZQAbgYAqAAQAaAAAPAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAvAAQArAAAYASQAXASAAAjQAAAqgjAYQghAXhBAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgSASAAAhQgBAgAUARQASARAgAAQAhAAASgRQASgRAAggQAAgjgTgRQgRgSgiAAQggAAgSATg");
	this.shape_1706.setTransform(229.3,458.8,0.5,0.5);

	this.shape_1707 = new cjs.Shape();
	this.shape_1707.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1707.setTransform(215.1,455.9,0.5,0.5);

	this.shape_1708 = new cjs.Shape();
	this.shape_1708.graphics.f("#000000").s().p("AgSCXQgQgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZgBAQgDIAAAUQgRAFgZAAQgiABgSgUg");
	this.shape_1708.setTransform(203.2,454.4,0.5,0.5);

	this.shape_1709 = new cjs.Shape();
	this.shape_1709.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgbAigUQgYgKgNgVQgNgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgSgRQgTgSggAAQghAAgSATg");
	this.shape_1709.setTransform(185.9,458.8,0.5,0.5);

	this.shape_1710 = new cjs.Shape();
	this.shape_1710.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_1710.setTransform(171.7,455.8,0.5,0.5);

	this.shape_1711 = new cjs.Shape();
	this.shape_1711.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_1711.setTransform(161.3,453.4,0.5,0.5);

	this.shape_1712 = new cjs.Shape();
	this.shape_1712.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_1712.setTransform(153.3,453,0.5,0.5);

	this.shape_1713 = new cjs.Shape();
	this.shape_1713.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_1713.setTransform(142,455.8,0.5,0.5);

	this.shape_1714 = new cjs.Shape();
	this.shape_1714.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1714.setTransform(128.6,455.9,0.5,0.5);

	this.shape_1715 = new cjs.Shape();
	this.shape_1715.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIABAAQAQg+AGgPIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgMAShLIAqiaIAZAAIhKENg");
	this.shape_1715.setTransform(111.9,455.9,0.5,0.5);

	this.shape_1716 = new cjs.Shape();
	this.shape_1716.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQAOAAAWADIgEAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_1716.setTransform(92,455.8,0.5,0.5);

	this.shape_1717 = new cjs.Shape();
	this.shape_1717.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1gBQAvABAcAhQAcAhgBA6IAAASIjCAAQACA4AYAeQAaAdAuAAQAYAAASgDQATgEAZgKIAAAXQgXAJgUAEQgRADgaAAQg5ABgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgagjAAQgnAAgXAag");
	this.shape_1717.setTransform(79.2,455.9,0.5,0.5);

	this.shape_1718 = new cjs.Shape();
	this.shape_1718.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_1718.setTransform(67.7,454.4,0.5,0.5);

	this.shape_1719 = new cjs.Shape();
	this.shape_1719.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAXAAAWAHIgGAVQgVgHgTAAQgdABgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_1719.setTransform(60.7,452.9,0.5,0.5);

	this.shape_1720 = new cjs.Shape();
	this.shape_1720.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_1720.setTransform(48.4,453.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1720},{t:this.shape_1719},{t:this.shape_1718},{t:this.shape_1717},{t:this.shape_1716},{t:this.shape_1715},{t:this.shape_1714},{t:this.shape_1713},{t:this.shape_1712},{t:this.shape_1711},{t:this.shape_1710},{t:this.shape_1709},{t:this.shape_1708},{t:this.shape_1707},{t:this.shape_1706},{t:this.shape_1705},{t:this.shape_1704},{t:this.shape_1703},{t:this.shape_1702},{t:this.shape_1701},{t:this.shape_1700},{t:this.shape_1699},{t:this.shape_1698},{t:this.shape_1697},{t:this.shape_1696},{t:this.shape_1695},{t:this.shape_1694},{t:this.shape_1693},{t:this.shape_1692},{t:this.shape_1691},{t:this.shape_1690},{t:this.shape_1689},{t:this.shape_1688},{t:this.shape_1687},{t:this.shape_1686},{t:this.shape_1685},{t:this.shape_1684},{t:this.shape_1683},{t:this.shape_1682},{t:this.shape_1681},{t:this.shape_1680},{t:this.shape_1679},{t:this.shape_1678},{t:this.shape_1677},{t:this.shape_1676},{t:this.shape_1675},{t:this.shape_1674},{t:this.shape_1673},{t:this.shape_1672},{t:this.shape_1671},{t:this.shape_1670},{t:this.shape_1669},{t:this.shape_1668},{t:this.shape_1667},{t:this.shape_1666},{t:this.shape_1665},{t:this.shape_1664},{t:this.shape_1663},{t:this.shape_1662},{t:this.shape_1661},{t:this.shape_1660},{t:this.shape_1659},{t:this.shape_1658},{t:this.shape_1657},{t:this.shape_1656},{t:this.shape_1655},{t:this.shape_1654},{t:this.shape_1653},{t:this.shape_1652},{t:this.shape_1651},{t:this.shape_1650},{t:this.shape_1649},{t:this.shape_1648},{t:this.instance_6}]},116).to({state:[]},1).wait(48));

	// ButtonLeftRight copy 50
	this.buttonR24 = new lib.ButtonLeft_Right();
	this.buttonR24.name = "buttonR24";
	this.buttonR24.parent = this;
	this.buttonR24.setTransform(2025,513.5,1,1,180);
	this.buttonR24._off = true;
	new cjs.ButtonHelper(this.buttonR24, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR24).wait(115).to({_off:false},0).to({_off:true},1).wait(49));

	// ButtonLeftRight copy 51
	this.buttonL24 = new lib.ButtonLeft_Right();
	this.buttonL24.name = "buttonL24";
	this.buttonL24.parent = this;
	this.buttonL24.setTransform(0,437.2);
	this.buttonL24._off = true;
	new cjs.ButtonHelper(this.buttonL24, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL24).wait(115).to({_off:false},0).to({_off:true},1).wait(49));

	// Layer 1
	this.shape_1721 = new cjs.Shape();
	this.shape_1721.graphics.f("#000000").s().p("AjmHbQgOgCgOgFIAJgaQAFACASAEQAMACAPAAQAcAAAWgKQAUgMAQgQQAOgQALgYQAJgTAJgYIA8ijIj4qCIAiAAIDkJgIDepgIAhAAIk2M/QgVA6gkAhQglAfg5AAQgLAAgRgCg");
	this.shape_1721.setTransform(386.4,488.5,0.5,0.5);

	this.shape_1722 = new cjs.Shape();
	this.shape_1722.graphics.f("#000000").s().p("AhHEzQg6gYgrgrQgrgtgXg9QgYg8AAhJQAAhGAYg+QAXg8ArgtQArgsA6gaQA6gZBEAAQA7AAA3AWQA2AWAlAnIgXAVQgjgmgwgTQgugVg1AAQhBAAg2AZQg1AaglAqQgmAqgUA3QgUA5AAA7QAAA9AUA4QAUA3AmAqQAlApA1AaQA1AYBCAAQAzAAAygSQAzgSAkgjIAUAUQgpAog3ASQg4ATg4AAQhDAAg7gZg");
	this.shape_1722.setTransform(356.6,480.2,0.5,0.5);

	this.shape_1723 = new cjs.Shape();
	this.shape_1723.graphics.f("#000000").s().p("AhuFBQgmgLgdgWQgdgUgUgkQgSgiAAguQAAhCAjgpQAigoA1gXQAxgVA9gIQA9gHAuAAIBtAAIAAgyQAAhog3gxQg5gwhZAAQg4AAgwAVQgxAVgkAhIgRgYQAsglA3gUQA3gUA0AAQBrAAA+A3QA+A3AAB3IAAERQAAAmAEAmQADAoAEAaIgdAAQgCgOgCgUIgDgoIgDgqIgBgiIgDAAQgcBVhDArQhDAphLAAQgkAAgngLgAgBgVQg4AFgwATQgwATgeAjQgfAkAAA7QAAArARAeQARAdAaASQAdASAeAIQAjAIAZAAQBGAAAtgaQAvgaAcgoQAcgoAKgxQALguAAgwIAAg7IhhAAQg0AAg4AHg");
	this.shape_1723.setTransform(321.1,480.2,0.5,0.5);

	this.shape_1724 = new cjs.Shape();
	this.shape_1724.graphics.f("#000000").s().p("AiXHOQhFgegyg4IAVgVQAzA6BDAbQBCAbBGAAQBSAAA2geQA3geAfgxQAggxANg/QAMhBABhDIAAiBIgFAAQgRAtgfAjQgeAjgkAXQgkAYgsAMQgsANgrAAQhDAAg6gaQg4gYgsgtQgpgsgXg8QgXg8AAhHQAAhIAXg8QAXg+ApgsQArgtA5gZQA6gZBDAAQBZAABMAvQBMAwAoBeIAFAAIAAiqIAdAAIAAJNQAABMgPBDQgRBFgjAzQgkA0g8AeQg5AehZAAQhYAAhEgegAh2m4Qg0AZglAqQgmArgTA3QgTA4AAA9QAAA9ATA4QAUA2AlArQAkAqA1AZQA1AYBAAAQA9AAA1gYQA2gZAlgqQAmgqAWg3QAWg3gBg/QABg/gWg4QgWg4gmgpQglgpg2gZQgzgYg/AAQhAAAg1AZg");
	this.shape_1724.setTransform(281.7,488.2,0.5,0.5);

	this.shape_1725 = new cjs.Shape();
	this.shape_1725.graphics.f("#000000").s().p("AhtEyQg4gXgqguQgqgugWg+QgWg/AAhIQAAhHAXg8QAXg6AogtQAngrA4gYQA3gYA9AAQBKAAA2AaQA2AZAlArQAkAqASA2QARA2AAA4IAAAZIouAAQAAA3ARA5QASA5AiArQAjAtA1AaQA1AbBHAAQBKAAA5gcQA4gdArg5IAWAUQguA7g/AgQg9AfhSAAQhEAAg6gagAh2kUQgzAdgfAsQggAqgPAvQgPAwAAAjIIOAAQAAg9gVgzQgTgygigkQghgkgxgVQgwgTg6AAQhGAAgyAdg");
	this.shape_1725.setTransform(242.9,480.2,0.5,0.5);

	this.shape_1726 = new cjs.Shape();
	this.shape_1726.graphics.f("#000000").s().p("Aj9HhIAAvBIAeAAIAAOmIHdAAIAAAbg");
	this.shape_1726.setTransform(211.2,471.8,0.5,0.5);

	this.shape_1727 = new cjs.Shape();
	this.shape_1727.graphics.f("#000000").s().p("AhsEyQg6gZgpgsQgpgtgXg/QgXg+AAhJQAAhHAYg8QAWg6ApgtQAogrA3gYQA2gYA+AAQBKAAA2AaQA1AZAmArQAlAqAQA2QATA1gBA5IAAAZIouAAQAAA6ARA2QARA3AjAtQAiAsA2AbQA1AbBHAAQBKAAA4gcQA5gdAqg5IAXAUQgvA6g9AhQg/AfhRAAQhEAAg5gagAh2kUQgyAdghAsQggAsgPAtQgPAwAAAjIIPAAQgBg9gTgzQgWg0gggiQgigkgwgVQgvgTg7AAQhGAAgyAdg");
	this.shape_1727.setTransform(155.4,480.2,0.5,0.5);

	this.shape_1728 = new cjs.Shape();
	this.shape_1728.graphics.f("#000000").s().p("ADeICIAAl3QAAgogIgpQgIgtgWghQgXglgmgXQgmgYg6ABQgzAAguAUQgsAVgjAoQggAmgVA5QgTA4AABJIAAE4IgeAAIAAwDIAeAAIAAI2IACAAQANgrAaghQAYghAigZQAhgYAmgMQAlgMApAAQBAAAAsAWQAtAYAZAmQAaAnAKAuQALAuAAAyIAAF6g");
	this.shape_1728.setTransform(117.3,470.2,0.5,0.5);

	this.shape_1729 = new cjs.Shape();
	this.shape_1729.graphics.f("#000000").s().p("AgOHhIAAumIlIAAIAAgbIKtAAIAAAbIlIAAIAAOmg");
	this.shape_1729.setTransform(80.6,471.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_1729},{t:this.shape_1728},{t:this.shape_1727},{t:this.shape_1726},{t:this.shape_1725},{t:this.shape_1724},{t:this.shape_1723},{t:this.shape_1722},{t:this.shape_1721}]},115).to({state:[]},1).wait(49));

	// ButtonLeftRight copy 48
	this.buttonR23 = new lib.ButtonLeft_Right();
	this.buttonR23.name = "buttonR23";
	this.buttonR23.parent = this;
	this.buttonR23.setTransform(2025,513.5,1,1,180);
	this.buttonR23._off = true;
	new cjs.ButtonHelper(this.buttonR23, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR23).wait(114).to({_off:false},0).to({_off:true},1).wait(50));

	// ButtonLeftRight copy 49
	this.buttonL23 = new lib.ButtonLeft_Right();
	this.buttonL23.name = "buttonL23";
	this.buttonL23.parent = this;
	this.buttonL23.setTransform(0,437.2);
	this.buttonL23._off = true;
	new cjs.ButtonHelper(this.buttonL23, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL23).wait(114).to({_off:false},0).to({_off:true},1).wait(50));

	// Layer 1
	this.shape_1730 = new cjs.Shape();
	this.shape_1730.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_1730.setTransform(558.2,815.9,0.5,0.5);

	this.shape_1731 = new cjs.Shape();
	this.shape_1731.graphics.f("#000000").s().p("AhLBhIAAgVQAgAQAkAAQAfAAAQgKQARgKAAgSQgBgQgNgLQgNgLgdgLQgegKgOgJQgNgIgHgKQgGgKAAgQQAAgYAUgNQAUgOAjAAQAjAAAeANIgHASQgggOgaAAQgYAAgQAJQgPAJAAAPQgBARAMAKQAMAKAhALQAcAKAOAJQANAIAHAKQAGAMAAANQAAAcgVAQQgWAPgnAAQgrAAgZgNg");
	this.shape_1731.setTransform(551.1,811.3,0.5,0.5);

	this.shape_1732 = new cjs.Shape();
	this.shape_1732.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgNgPgdAAQglAAgRATQgTAUABArIAAB0IgTAAIAAjTIAQAAIAEAdIAAAAQAVghA0AAQBJAAgBBNIAACKg");
	this.shape_1732.setTransform(540.7,811.2,0.5,0.5);

	this.shape_1733 = new cjs.Shape();
	this.shape_1733.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQAEAGAAAJQAAAHgEAGQgDAGgGAAQgMgBAAgSg");
	this.shape_1733.setTransform(532.5,809.4,0.5,0.5);

	this.shape_1734 = new cjs.Shape();
	this.shape_1734.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAXAAIhSBaIBaB6g");
	this.shape_1734.setTransform(526.3,809,0.5,0.5);

	this.shape_1735 = new cjs.Shape();
	this.shape_1735.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAHALQAJAMASAAQATAAANgDIAAAPQgOAFgSAAQgbAAgNgPg");
	this.shape_1735.setTransform(517,810.1,0.5,0.5);

	this.shape_1736 = new cjs.Shape();
	this.shape_1736.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgcAAghAQIgHgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAWAAQAiAAATgTQAUgUAAgiIAAgUg");
	this.shape_1736.setTransform(508.2,811.3,0.5,0.5);

	this.shape_1737 = new cjs.Shape();
	this.shape_1737.graphics.f("#000000").s().p("ABJCPIg+jcIgMgsIgIAnIg/DhIgRAAIhOkdIAVAAIBCD9QAGgfAOgyIAxisIAVAAIA6DGIANA3IAHgeIA9jfIATAAIhPEdg");
	this.shape_1737.setTransform(494.3,809.5,0.5,0.5);

	this.shape_1738 = new cjs.Shape();
	this.shape_1738.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_1738.setTransform(474.5,811.3,0.5,0.5);

	this.shape_1739 = new cjs.Shape();
	this.shape_1739.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAVAAQANAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_1739.setTransform(466.4,811.2,0.5,0.5);

	this.shape_1740 = new cjs.Shape();
	this.shape_1740.graphics.f("#000000").s().p("AhBB/QgYgcAAg0QAAg2AYgdQAWgdArAAQAYAAAQAIQASAJAMAUIABAAIgBgwIAAhNIATAAIAAEvIgMAAIgFggIgCAAQgYAkguAAQgqAAgXgbgAgzgXQgRAXAAAvQAABaBEAAQAlAAAQgVQARgVAAgwIAAgDQAAgwgRgWQgQgWglAAQgiAAgRAZg");
	this.shape_1740.setTransform(455.6,809.1,0.5,0.5);

	this.shape_1741 = new cjs.Shape();
	this.shape_1741.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_1741.setTransform(444.1,811.2,0.5,0.5);

	this.shape_1742 = new cjs.Shape();
	this.shape_1742.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgFgiIgBAAQgQAVgRAIQgQAJgXAAQgfAAgSgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_1742.setTransform(432.5,811.3,0.5,0.5);

	this.shape_1743 = new cjs.Shape();
	this.shape_1743.graphics.f("#000000").s().p("ABDBqIhDhfIhCBfIgWAAIBNhsIhKhnIAWAAIA/BZIA+hZIAWAAIhJBnIBOBsg");
	this.shape_1743.setTransform(422.5,811.3,0.5,0.5);

	this.shape_1744 = new cjs.Shape();
	this.shape_1744.graphics.f("#000000").s().p("Ag8BSQgagdAAgzQAAgxAZgfQAagfApAAQAmAAAVAaQAWAaAAAtIAAAPIiYAAQAAArAUAXQAUAXAkABQAVgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgVAAQgsAAgbgcgAgqhHQgTAUgDAlICCAAQAAgkgQgVQgQgVgcAAQgeAAgSAVg");
	this.shape_1744.setTransform(412.1,811.3,0.5,0.5);

	this.shape_1745 = new cjs.Shape();
	this.shape_1745.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_1745.setTransform(404.3,809,0.5,0.5);

	this.shape_1746 = new cjs.Shape();
	this.shape_1746.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBlAAIgnhlQgFgNgHgVQgEAWgGAMg");
	this.shape_1746.setTransform(396.1,809.5,0.5,0.5);

	this.shape_1747 = new cjs.Shape();
	this.shape_1747.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAHgEAHgLQAHgLAHgUIAKgcIhRjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgNAhgHAIQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_1747.setTransform(380.3,813.7,0.5,0.5);

	this.shape_1748 = new cjs.Shape();
	this.shape_1748.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgLAAIAAkvIATAAIgBB9IABAAQAMgTARgJQARgJAXAAQAtAAAWAcQAWAcABA1QgBA1gXAcQgYAdgqAAQgXAAgSgJgAg1gaQgQAWAAAwIAAADQAAAvARAWQARAVAjAAQAiAAARgZQASgXAAguQAAhbhFAAQglAAgQAWg");
	this.shape_1748.setTransform(370,809.1,0.5,0.5);

	this.shape_1749 = new cjs.Shape();
	this.shape_1749.graphics.f("#000000").s().p("AgUAxIgDgEIAQgwQAKgcAHgRIAOAAQgHAXgHAaQgGAhgCAPg");
	this.shape_1749.setTransform(357.1,804.8,0.5,0.5);

	this.shape_1750 = new cjs.Shape();
	this.shape_1750.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_1750.setTransform(350.6,809.5,0.5,0.5);

	this.shape_1751 = new cjs.Shape();
	this.shape_1751.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AeAiQAcAiA2AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_1751.setTransform(338.7,809.5,0.5,0.5);

	this.shape_1752 = new cjs.Shape();
	this.shape_1752.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgziHQgEARgGARg");
	this.shape_1752.setTransform(326.2,809.5,0.5,0.5);

	this.shape_1753 = new cjs.Shape();
	this.shape_1753.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_1753.setTransform(315.9,809.5,0.5,0.5);

	this.shape_1754 = new cjs.Shape();
	this.shape_1754.graphics.f("#000000").s().p("ABHCPIhsiWIgmAgIAAB2IgUAAIAAkdIAUAAIAACTICPiTIAZAAIh0B5IB3Ckg");
	this.shape_1754.setTransform(305.2,809.5,0.5,0.5);

	this.shape_1755 = new cjs.Shape();
	this.shape_1755.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQARghAfgTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AdAiQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_1755.setTransform(292.4,809.5,0.5,0.5);

	this.shape_1756 = new cjs.Shape();
	this.shape_1756.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_1756.setTransform(280.8,809.5,0.5,0.5);

	this.shape_1757 = new cjs.Shape();
	this.shape_1757.graphics.f("#000000").s().p("ABUCPIipj9IgBAAIACBEIAAC5IgTAAIAAkdIAUAAICoD8IABAAQgCgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_1757.setTransform(267.7,809.5,0.5,0.5);

	this.shape_1758 = new cjs.Shape();
	this.shape_1758.graphics.f("#000000").s().p("AhrCPIAAkdIBMAAQBFAAAjAkQAkAkAABEQgBBHglAlQgmAlhIAAgAhYB9IAvAAQCAAAgBh+QAAg+gfgeQgegfg8AAIg1AAg");
	this.shape_1758.setTransform(248.6,809.5,0.5,0.5);

	this.shape_1759 = new cjs.Shape();
	this.shape_1759.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_1759.setTransform(233.9,809.5,0.5,0.5);

	this.shape_1760 = new cjs.Shape();
	this.shape_1760.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgiAog8AAQg6AAgjgogAhNhdQgcAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbgiAAg9QAAg8gbgiQgbghg0AAQgyAAgbAig");
	this.shape_1760.setTransform(219.1,809.5,0.5,0.5);

	this.shape_1761 = new cjs.Shape();
	this.shape_1761.graphics.f("#000000").s().p("ABwCPIAAjYQAAgUACgbIgBAAIhrEHIgLAAIhrkHIgBAAIABAxIAADWIgTAAIAAkdIAeAAIBlD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_1761.setTransform(202.8,809.5,0.5,0.5);

	this.shape_1762 = new cjs.Shape();
	this.shape_1762.graphics.f("#000000").s().p("ABhCQIgnhmIh0AAIgnBmIgWAAIBykeIAMAAIBxEegAgKhNIgoBlIBlAAIgyiHQgFARgGARg");
	this.shape_1762.setTransform(188.2,809.5,0.5,0.5);

	this.shape_1763 = new cjs.Shape();
	this.shape_1763.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_1763.setTransform(179.7,809.5,0.5,0.5);

	this.shape_1764 = new cjs.Shape();
	this.shape_1764.graphics.f("#000000").s().p("AhrCPIAAkdIBMAAQBFAAAjAkQAjAkABBEQgBBHglAlQgmAlhIAAgAhXB9IAuAAQCAAAgBh+QAAg+gegeQgfgfg8AAIg0AAg");
	this.shape_1764.setTransform(170.5,809.5,0.5,0.5);

	this.shape_1765 = new cjs.Shape();
	this.shape_1765.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_1765.setTransform(153.5,809.5,0.5,0.5);

	this.shape_1766 = new cjs.Shape();
	this.shape_1766.graphics.f("#000000").s().p("AhOB1QgcgbAAgzIAAi3IAUAAIAAC4QAAAqAYAWQAWAXApAAQApAAAXgWQAWgXgBgoIAAi6IAVAAIAAC4QAAAygdAbQgcAbgyAAQgyAAgcgbg");
	this.shape_1766.setTransform(140.4,809.6,0.5,0.5);

	this.shape_1767 = new cjs.Shape();
	this.shape_1767.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAAB5IB/AAIAAASIh/AAIAACAg");
	this.shape_1767.setTransform(129.1,809.5,0.5,0.5);

	this.shape_1768 = new cjs.Shape();
	this.shape_1768.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_1768.setTransform(117.9,809.5,0.5,0.5);

	this.shape_1769 = new cjs.Shape();
	this.shape_1769.graphics.f("#000000").s().p("ABUCPIAAiNIinAAIAACNIgTAAIAAkdIATAAIAAB/ICnAAIAAh/IAUAAIAAEdg");
	this.shape_1769.setTransform(105.5,809.5,0.5,0.5);

	this.shape_1770 = new cjs.Shape();
	this.shape_1770.graphics.f("#000000").s().p("AhQBtQgjgmgBhGQAAgrASgiQASghAhgTQAjgSApAAQAvAAAlARIgIASQgmgRgnAAQg3AAghAjQgiAjABA6QAABBAfAgQAfAgA8AAQApAAAagLIAAhkIhVAAIAAgSIBpAAIAACBQgoASg1AAQhCAAglgmg");
	this.shape_1770.setTransform(90.9,809.5,0.5,0.5);

	this.shape_1771 = new cjs.Shape();
	this.shape_1771.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_1771.setTransform(81.3,809.5,0.5,0.5);

	this.shape_1772 = new cjs.Shape();
	this.shape_1772.graphics.f("#000000").s().p("AhNCPIAAkdIATAAIAAEKICIAAIAAATg");
	this.shape_1772.setTransform(74.4,809.5,0.5,0.5);

	this.shape_1773 = new cjs.Shape();
	this.shape_1773.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_1773.setTransform(63.4,809.5,0.5,0.5);

	this.shape_1774 = new cjs.Shape();
	this.shape_1774.graphics.f("#000000").s().p("AhsCPIAAkdIBOAAQBDAAAkAkQAkAkgBBEQAABHglAlQgmAlhIAAgAhYB9IAwAAQB/AAAAh+QAAg9gggfQgegfg8AAIg1AAg");
	this.shape_1774.setTransform(50.8,809.5,0.5,0.5);

	this.shape_1775 = new cjs.Shape();
	this.shape_1775.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_1775.setTransform(41.9,804.8,0.5,0.5);

	this.instance_7 = new lib.necklace();
	this.instance_7.parent = this;
	this.instance_7.setTransform(376,190,0.862,0.862);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.shape_1775},{t:this.shape_1774},{t:this.shape_1773},{t:this.shape_1772},{t:this.shape_1771},{t:this.shape_1770},{t:this.shape_1769},{t:this.shape_1768},{t:this.shape_1767},{t:this.shape_1766},{t:this.shape_1765},{t:this.shape_1764},{t:this.shape_1763},{t:this.shape_1762},{t:this.shape_1761},{t:this.shape_1760},{t:this.shape_1759},{t:this.shape_1758},{t:this.shape_1757},{t:this.shape_1756},{t:this.shape_1755},{t:this.shape_1754},{t:this.shape_1753},{t:this.shape_1752},{t:this.shape_1751},{t:this.shape_1750},{t:this.shape_1749},{t:this.shape_1748},{t:this.shape_1747},{t:this.shape_1746},{t:this.shape_1745},{t:this.shape_1744},{t:this.shape_1743},{t:this.shape_1742},{t:this.shape_1741},{t:this.shape_1740},{t:this.shape_1739},{t:this.shape_1738},{t:this.shape_1737},{t:this.shape_1736},{t:this.shape_1735},{t:this.shape_1734},{t:this.shape_1733},{t:this.shape_1732},{t:this.shape_1731},{t:this.shape_1730}]},114).to({state:[]},1).wait(50));

	// ButtonLeftRight copy 46
	this.buttonR22 = new lib.ButtonLeft_Right();
	this.buttonR22.name = "buttonR22";
	this.buttonR22.parent = this;
	this.buttonR22.setTransform(2025,513.5,1,1,180);
	this.buttonR22._off = true;
	new cjs.ButtonHelper(this.buttonR22, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR22).wait(113).to({_off:false},0).to({_off:true},1).wait(51));

	// ButtonLeftRight copy 47
	this.buttonL22 = new lib.ButtonLeft_Right();
	this.buttonL22.name = "buttonL22";
	this.buttonL22.parent = this;
	this.buttonL22.setTransform(0,437.2);
	this.buttonL22._off = true;
	new cjs.ButtonHelper(this.buttonL22, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL22).wait(113).to({_off:false},0).to({_off:true},1).wait(51));

	// Layer 1
	this.instance_8 = new lib.wat_redNecklace_studio();
	this.instance_8.parent = this;
	this.instance_8.setTransform(1105,-4);

	this.shape_1776 = new cjs.Shape();
	this.shape_1776.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_1776.setTransform(388.4,815.8,0.5,0.5);

	this.shape_1777 = new cjs.Shape();
	this.shape_1777.graphics.f("#000000").s().p("AhEBuQgXgmAAhIQAAhJAXglQAWgkAuAAQAtAAAXAlQAYAmAABHQAABKgXAlQgXAkguAAQgsAAgYglgAg1hgQgRAhAAA/QABBCAQAgQASAfAjAAQAkAAARggQARghAAhAQAAg/gRghQgRgggkAAQglAAgQAgg");
	this.shape_1777.setTransform(380.4,809.4,0.5,0.5);

	this.shape_1778 = new cjs.Shape();
	this.shape_1778.graphics.f("#000000").s().p("AhICOIAAgRQAKADAKABIASACQAvAAAbgjQAcgiADhDIgCAAQgNARgVALQgVAKgUAAQgnAAgWgWQgXgUABgpQgBgrAZgaQAXgbAoAAQAcAAAUAPQAWAPALAcQALAdAAAnQAAA3gPAmQgOAmgcASQgcASgnAAQgVAAgRgFgAgzhsQgTAUAAAlQABAiAQARQASARAfAAQATAAARgJQASgIAJgOQAKgOAAgQQAAgXgJgTQgJgUgQgMQgQgLgVAAQgfAAgSAVg");
	this.shape_1778.setTransform(368.8,809.4,0.5,0.5);

	this.shape_1779 = new cjs.Shape();
	this.shape_1779.graphics.f("#000000").s().p("AhICOIAAgRIAmAGQAvAAAcgjQAbgjADhCIgCAAQgOARgUALQgUAKgUAAQgnAAgXgWQgWgUAAgpQAAgrAYgaQAYgbAnAAQAcAAAUAPQAWAPALAcQALAdAAAnQAAA3gPAmQgOAlgcATQgdASgnAAQgVAAgQgFgAgzhsQgTAVAAAkQAAAhARASQASARAfAAQATAAARgJQARgIAKgOQAKgPAAgPQAAgXgJgTQgKgVgPgLQgQgLgVAAQgeAAgTAVg");
	this.shape_1779.setTransform(357.4,809.4,0.5,0.5);

	this.shape_1780 = new cjs.Shape();
	this.shape_1780.graphics.f("#000000").s().p("AAcCPIAAjPQAAggACgbIgGAFIg7AwIgLgOIBMg6IARAAIAAEdg");
	this.shape_1780.setTransform(344.7,809.4,0.5,0.5);

	this.shape_1781 = new cjs.Shape();
	this.shape_1781.graphics.f("#000000").s().p("AgWAxQAPg1AGgsIAWAAIACAEQgPA1gSAog");
	this.shape_1781.setTransform(332.7,816.7,0.5,0.5);

	this.shape_1782 = new cjs.Shape();
	this.shape_1782.graphics.f("#000000").s().p("Ag8B/QgagdAAgzQAAgxAZgfQAagfApAAQAmAAAVAaQAWAaAAAsIAAAQIiYAAQABAsATAWQAUAXAkABQAVgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgVAAQgsAAgbgcgAgqgaQgTAUgDAkICCAAQAAgjgQgVQgQgVgcAAQgeAAgSAVgAgVhaIAAgDQAQgSAMgPQANgSAGgKIAbAAIAAADQgGALgSAQQgNAOgXAUg");
	this.shape_1782.setTransform(325.4,809,0.5,0.5);

	this.shape_1783 = new cjs.Shape();
	this.shape_1783.graphics.f("#000000").s().p("AhaCWIAAgRQALADANAAQAKAAAIgEQAIgFAGgKQAFgIAJgXIAKgcIhRjTIAUAAIAtB3QATAyAHAXIAAAAIAbhKIAth2IAUAAIheD1QgNAfgHAKQgHAKgLAGQgKAFgPAAQgLAAgOgEg");
	this.shape_1783.setTransform(315.3,813.7,0.5,0.5);

	this.shape_1784 = new cjs.Shape();
	this.shape_1784.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQAEAGAAAJQAAAIgEAFQgDAGgGAAQgMgBAAgSg");
	this.shape_1784.setTransform(308.5,809.3,0.5,0.5);

	this.shape_1785 = new cjs.Shape();
	this.shape_1785.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgbAAQglAAgSATQgSATAAAsIAAB0IgTAAIAAjTIAQAAIAEAdIABAAQAUghA0AAQBIAAAABNIAACKg");
	this.shape_1785.setTransform(300.4,811.2,0.5,0.5);

	this.shape_1786 = new cjs.Shape();
	this.shape_1786.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgPAVgSAIQgQAJgXAAQggAAgRgQgAAYAAQgtACgSAMQgTALgBAZQAAAUANALQALALAYAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_1786.setTransform(288.8,811.3,0.5,0.5);

	this.shape_1787 = new cjs.Shape();
	this.shape_1787.graphics.f("#000000").s().p("AgvCtIAAgRQAQAEANAAQAuAAAAgzIAAkfIAUAAIAAEdQAABIhBAAQgSAAgMgGg");
	this.shape_1787.setTransform(279.5,811.2,0.5,0.5);

	this.shape_1788 = new cjs.Shape();
	this.shape_1788.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAWAAQAMAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_1788.setTransform(270.5,811.2,0.5,0.5);

	this.shape_1789 = new cjs.Shape();
	this.shape_1789.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgyAZgeQAZgfAqAAQAlAAAWAaQAVAaABAtIAAAPIiYAAQABAsATAWQAUAXAkABQAVgBAMgCQAOgCAUgJIAAARQgRAIgQAEQgMACgWAAQgtAAgagcgAgrhHQgSATgDAmICCAAQAAglgQgUQgQgVgcAAQgdAAgUAVg");
	this.shape_1789.setTransform(260.4,811.3,0.5,0.5);

	this.shape_1790 = new cjs.Shape();
	this.shape_1790.graphics.f("#000000").s().p("AgICRIAAjUIASAAIAADUgAgMh9QAAgTAMAAQAGAAAEAEQACAGAAAJQAAAIgCAFQgEAGgGAAQgMgBAAgSg");
	this.shape_1790.setTransform(252.7,809.3,0.5,0.5);

	this.shape_1791 = new cjs.Shape();
	this.shape_1791.graphics.f("#000000").s().p("AgJCYIAAkvIASAAIAAEvg");
	this.shape_1791.setTransform(248.2,809,0.5,0.5);

	this.shape_1792 = new cjs.Shape();
	this.shape_1792.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgxAZgfQAZgfAqAAQAlAAAWAaQAVAaABAtIAAAPIiYAAQAAArAUAXQAUAXAkABQAWgBALgCQAPgCAUgJIAAARQgSAIgQAEQgMACgWAAQgtAAgagcgAgrhHQgSAUgDAlICCAAQAAglgQgUQgQgVgcAAQgdAAgUAVg");
	this.shape_1792.setTransform(240.4,811.3,0.5,0.5);

	this.shape_1793 = new cjs.Shape();
	this.shape_1793.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAIALQAIAMATAAQASAAANgDIAAAPQgOAFgSAAQgbAAgNgPg");
	this.shape_1793.setTransform(231.4,810.1,0.5,0.5);

	this.shape_1794 = new cjs.Shape();
	this.shape_1794.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBlAAIgyiHQgEARgHARg");
	this.shape_1794.setTransform(222.2,809.4,0.5,0.5);

	this.shape_1795 = new cjs.Shape();
	this.shape_1795.graphics.f("#000000").s().p("AgWAxQAPg5AGgoIAWAAIADAEQgOAvgUAug");
	this.shape_1795.setTransform(208.6,816.7,0.5,0.5);

	this.shape_1796 = new cjs.Shape();
	this.shape_1796.graphics.f("#000000").s().p("AhKBhIAAgVQAfAQAkAAQAgAAAPgKQAQgKAAgSQAAgQgNgLQgMgLgegLQgcgIgQgLQgOgIgFgKQgHgLAAgPQAAgXAUgOQAUgOAjAAQAkAAAdANIgHASQgggOgaAAQgZAAgPAJQgPAJAAAPQAAARALAKQANAKAhALQAcALANAIQAOAIAGAKQAGALAAAOQAAAdgVAPQgWAPgnAAQgrAAgYgNg");
	this.shape_1796.setTransform(202,811.3,0.5,0.5);

	this.shape_1797 = new cjs.Shape();
	this.shape_1797.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_1797.setTransform(191.6,811.2,0.5,0.5);

	this.shape_1798 = new cjs.Shape();
	this.shape_1798.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh9QAAgTALAAQAGAAADAEQAEAGAAAJQAAAIgEAFQgDAGgGAAQgLgBAAgSg");
	this.shape_1798.setTransform(183.4,809.3,0.5,0.5);

	this.shape_1799 = new cjs.Shape();
	this.shape_1799.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhSBaIBZB6g");
	this.shape_1799.setTransform(177.1,809,0.5,0.5);

	this.shape_1800 = new cjs.Shape();
	this.shape_1800.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAJgwIALAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAIAMQAIAMASAAQASAAAOgDIAAAPQgOAFgSAAQgbAAgNgPg");
	this.shape_1800.setTransform(167.9,810.1,0.5,0.5);

	this.shape_1801 = new cjs.Shape();
	this.shape_1801.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_1801.setTransform(159.1,811.3,0.5,0.5);

	this.shape_1802 = new cjs.Shape();
	this.shape_1802.graphics.f("#000000").s().p("ABJCPIg+jcQgIgagEgSQgCARgHAWQgFAXg6DKIgQAAIhOkdIAUAAIBDD9QAEgWAQg7IAxisIAVAAIA5DGQALAmAEARQACgQAEgOIA8jfIAUAAIhPEdg");
	this.shape_1802.setTransform(145.2,809.4,0.5,0.5);

	this.shape_1803 = new cjs.Shape();
	this.shape_1803.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAkAAAQASQASATAAAmIAACMIgPAAIgEgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgRgQgAAYAAQgtACgSAMQgTALgBAZQAAAUANALQALALAYAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_1803.setTransform(125.4,811.3,0.5,0.5);

	this.shape_1804 = new cjs.Shape();
	this.shape_1804.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIABAAQAOgYAOgJQAOgJAVAAQAMAAARACIgEATQgMgDgPAAQgaAAgSAXQgRAXAAAjIAAB0g");
	this.shape_1804.setTransform(117.3,811.2,0.5,0.5);

	this.shape_1805 = new cjs.Shape();
	this.shape_1805.graphics.f("#000000").s().p("AhBB/QgYgcABg0QAAg2AWgdQAYgdArAAQAXAAAQAIQARAJAOAUIABAAIgBh9IATAAIAAEvIgNAAIgFggIgBAAQgYAkguAAQgqAAgYgbgAgzgXQgRAXAAAvQAABaBFAAQAkAAARgVQARgVAAgwIAAgDQAAgwgRgWQgQgWglAAQgjAAgRAZg");
	this.shape_1805.setTransform(106.4,809.1,0.5,0.5);

	this.shape_1806 = new cjs.Shape();
	this.shape_1806.graphics.f("#000000").s().p("ABABsIAAiJQABgggOgOQgOgPgcAAQglAAgRATQgSATAAAsIAAB0IgTAAIAAjTIAQAAIAEAdIABAAQAUghA0AAQBIAAAABNIAACKg");
	this.shape_1806.setTransform(95,811.2,0.5,0.5);

	this.shape_1807 = new cjs.Shape();
	this.shape_1807.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgcAAghAQIgHgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_1807.setTransform(83.3,811.3,0.5,0.5);

	this.shape_1808 = new cjs.Shape();
	this.shape_1808.graphics.f("#000000").s().p("ABDBqIhDhfIhCBfIgWAAIBNhsIhKhnIAWAAIA/BZIA+hZIAWAAIhJBnIBOBsg");
	this.shape_1808.setTransform(73.4,811.3,0.5,0.5);

	this.shape_1809 = new cjs.Shape();
	this.shape_1809.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgxAagfQAYgfAqAAQAmAAAVAaQAVAaAAAtIAAAPIiXAAQAAArAUAXQAUAXAkABQAWgBALgCQAOgCAUgJIAAARQgRAIgQAEQgMACgWAAQgtAAgagcgAgqhHQgTAUgDAlICCAAQAAglgQgUQgPgVgdAAQgeAAgSAVg");
	this.shape_1809.setTransform(63,811.3,0.5,0.5);

	this.shape_1810 = new cjs.Shape();
	this.shape_1810.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_1810.setTransform(55.2,809,0.5,0.5);

	this.shape_1811 = new cjs.Shape();
	this.shape_1811.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBlAAIgziHQgDARgHARg");
	this.shape_1811.setTransform(47,809.4,0.5,0.5);

	this.shape_1812 = new cjs.Shape();
	this.shape_1812.graphics.f("#000000").s().p("AhqCLIAAgrQAWALAZAHQAYAGAYAAQAjAAAUgMQAUgKAAgZQAAgRgQgNQgQgNgrgRQgqgOgTgNQgSgMgIgOQgJgQAAgUQAAgmAegWQAegVA0AAQAyAAAvAUIgRAlQgugSglgBQggAAgQALQgRAKAAASQAAANAGAIQAGAJAOAHQAPAJAmAOQA3AUASATQATAUAAAeQAAArggAXQgfAXg5AAQg9AAghgTg");
	this.shape_1812.setTransform(281.6,705.1,0.5,0.5);

	this.shape_1813 = new cjs.Shape();
	this.shape_1813.graphics.f("#000000").s().p("ABSCbIAAjEQAAglgRgTQgSgSgjAAQgvAAgXAaQgWAaAAA7IAACfIgvAAIAAkwIAnAAIAHAqIACAAQAOgXAagMQAZgMAfAAQA3AAAcAaQAbAbABA6IAADGg");
	this.shape_1813.setTransform(266.1,704.9,0.5,0.5);

	this.shape_1814 = new cjs.Shape();
	this.shape_1814.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSibQgIgHAAgPQAAgQAIgIQAIgHAKAAQAMAAAHAHQAIAIAAAQQAAAPgIAHQgHAJgMgBQgLABgHgJg");
	this.shape_1814.setTransform(253.7,702.3,0.5,0.5);

	this.shape_1815 = new cjs.Shape();
	this.shape_1815.graphics.f("#000000").s().p("ABCDYIhqiQIgjAfIAABxIguAAIAAmwIAuAAIAADlQAAATgCAdIACAAQALgQAZgdIBihoIA3AAIh8CCICECug");
	this.shape_1815.setTransform(243.7,701.9,0.5,0.5);

	this.shape_1816 = new cjs.Shape();
	this.shape_1816.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgXIArgTIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACzQAAAbANAPQANAOAWAAQAOAAAKgBQANgCAFgCIAAAjQgHAEgPACQgNACgNAAQhYAAAAhcg");
	this.shape_1816.setTransform(230,703.5,0.5,0.5);

	this.shape_1817 = new cjs.Shape();
	this.shape_1817.graphics.f("#000000").s().p("AhgCHQgZgYAAgrQAAhbCSgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgXAcgXALQgWAKgiAAQguAAgZgXgAAeAEQg2ADgZAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_1817.setTransform(216.6,705.1,0.5,0.5);

	this.shape_1818 = new cjs.Shape();
	this.shape_1818.graphics.f("#000000").s().p("ABlDLIhgk8IgGgiQgGAkgOAtIhPENIgvAAIhsmWIAyAAIBAD7QAOA2AGAqQAHgyAPgyIBJj3IAxAAIBMD6QAOAqAJA3QAEgjAQg9IBAj7IAyAAIhtGWg");
	this.shape_1818.setTransform(196,702.5,0.5,0.5);

	this.shape_1819 = new cjs.Shape();
	this.shape_1819.graphics.f("#000000").s().p("AhfCHQgagYAAgrQAAhbCTgFIAzgBIAAgTQAAglgPgQQgPgSgjAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgWAbgYAMQgVAKgiAAQguAAgZgXgAAeAEQg3ADgXAOQgZAQAAAgQAAAYAPAOQAQANAbAAQAqAAAZgYQAYgXAAgrIAAgcg");
	this.shape_1819.setTransform(167,705.1,0.5,0.5);

	this.shape_1820 = new cjs.Shape();
	this.shape_1820.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQAQgdAZgRQAXgQAcAAQAWAAAPADIgGArQgVgEgNAAQglAAgaAeQgaAdAAAuIAACig");
	this.shape_1820.setTransform(154.8,704.9,0.5,0.5);

	this.shape_1821 = new cjs.Shape();
	this.shape_1821.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhLAhgpQAhgqA8AAQA9AAAiAtIADAAIgCgWIgBiRIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg7AAgigogAhAgZQgVAeAAA6QAAA7AVAdQAWAeApAAQAvAAAVgaQAVgZAAg6IAAgKQAAhAgVgbQgXgcgtAAQgpAAgWAgg");
	this.shape_1821.setTransform(138.8,702,0.5,0.5);

	this.shape_1822 = new cjs.Shape();
	this.shape_1822.graphics.f("#000000").s().p("ABRCbIAAjEQAAgkgRgUQgRgSgkAAQguAAgXAaQgXAaABA7IAACfIguAAIAAkwIAlAAIAIAqIACAAQAPgXAYgMQAZgMAgAAQA3AAAcAaQAbAcAAA5IAADGg");
	this.shape_1822.setTransform(121.8,704.9,0.5,0.5);

	this.shape_1823 = new cjs.Shape();
	this.shape_1823.graphics.f("#000000").s().p("AhfCHQgbgZAAgqQAAhbCTgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQglAAgwAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAbAYgBA1IAADPIgiAAIgJgrIgDAAQgVAcgYALQgWAKghAAQgvAAgYgXgAAeAEQg3ADgYAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_1823.setTransform(104.5,705.1,0.5,0.5);

	this.shape_1824 = new cjs.Shape();
	this.shape_1824.graphics.f("#000000").s().p("ABWCYIhVh7IhWB7Ig0AAIBwiaIhqiWIA0AAIBQB1IBPh1IA0AAIhqCWIBwCag");
	this.shape_1824.setTransform(89.6,705.1,0.5,0.5);

	this.shape_1825 = new cjs.Shape();
	this.shape_1825.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAlgsQAkgrA8AAQA6AAAhAmQAhAmAAA9IAAAcIjRAAQACA2AZAcQAbAcAsAAQAyAAAwgVIAAAqQgZAKgWAEQgVAFgfAAQhCAAgogpgAg1heQgXAYgDAqICeAAQABgsgUgXQgUgYgjAAQgkABgWAYg");
	this.shape_1825.setTransform(74.2,705.1,0.5,0.5);

	this.shape_1826 = new cjs.Shape();
	this.shape_1826.graphics.f("#000000").s().p("AgWDYIAAmwIAtAAIAAGwg");
	this.shape_1826.setTransform(62.6,701.9,0.5,0.5);

	this.shape_1827 = new cjs.Shape();
	this.shape_1827.graphics.f("#000000").s().p("ACDDMIgyiBIijAAIgyCBIgvAAICgmXIAnAAICgGXgAgRhdIgwB9ICDAAIgwh9QgIgVgKglQgHAfgKAbg");
	this.shape_1827.setTransform(50,702.5,0.5,0.5);

	this.shape_1828 = new cjs.Shape();
	this.shape_1828.graphics.f("#000000").s().p("AAKA/QAHgXAIgnQAJglADgZIAdAAIADAEQgIAggNAhQgMAhgKAWgAhEA/QAHgZAIgkQAIgjAEgcIAdAAIADAEQgSBCgZA2g");
	this.shape_1828.setTransform(157.9,659.4,0.5,0.5);

	this.shape_1829 = new cjs.Shape();
	this.shape_1829.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_1829.setTransform(151,673.5,0.5,0.5);

	this.shape_1830 = new cjs.Shape();
	this.shape_1830.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAYAAASgDQAPgCAdgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgVgbgjABQgnAAgXAag");
	this.shape_1830.setTransform(141,667.7,0.5,0.5);

	this.shape_1831 = new cjs.Shape();
	this.shape_1831.graphics.f("#000000").s().p("AhGCKIAAkNIAUAAIACAwIACAAQARgeATgMQARgMAcAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1831.setTransform(130,667.6,0.5,0.5);

	this.shape_1832 = new cjs.Shape();
	this.shape_1832.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAbAhAAA5IAAATIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgXAKgUADQgSADgYABQg7AAghglgAg2hbQgXAYgFAxICmAAQAAgtgUgcQgUgbgkABQgmAAgYAag");
	this.shape_1832.setTransform(117.1,667.7,0.5,0.5);

	this.shape_1833 = new cjs.Shape();
	this.shape_1833.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_1833.setTransform(102.7,664.8,0.5,0.5);

	this.shape_1834 = new cjs.Shape();
	this.shape_1834.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_1834.setTransform(90.6,666.2,0.5,0.5);

	this.shape_1835 = new cjs.Shape();
	this.shape_1835.graphics.f("#000000").s().p("AhGCKIAAkNIAUAAIACAwIADAAQAQgeATgMQARgMAcAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1835.setTransform(75.8,667.6,0.5,0.5);

	this.shape_1836 = new cjs.Shape();
	this.shape_1836.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAcAhAAA5IAAATIjCAAQABA4AZAeQAZAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg6AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_1836.setTransform(63,667.7,0.5,0.5);

	this.shape_1837 = new cjs.Shape();
	this.shape_1837.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_1837.setTransform(48.5,664.8,0.5,0.5);

	this.shape_1838 = new cjs.Shape();
	this.shape_1838.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBg/AggnQAhgnA0AAQAwgBAcAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_1838.setTransform(981.4,629.4,0.5,0.5);

	this.shape_1839 = new cjs.Shape();
	this.shape_1839.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAlAGAYIABAAQAJggALgeIBHi2IAZAAIhpENg");
	this.shape_1839.setTransform(968.6,629.4,0.5,0.5);

	this.shape_1840 = new cjs.Shape();
	this.shape_1840.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1840.setTransform(955.5,629.4,0.5,0.5);

	this.shape_1841 = new cjs.Shape();
	this.shape_1841.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAAABiIAACxg");
	this.shape_1841.setTransform(941.8,626.5,0.5,0.5);

	this.shape_1842 = new cjs.Shape();
	this.shape_1842.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAmAABAQAABBghAnQgfAkg4ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1842.setTransform(920.1,629.4,0.5,0.5);

	this.shape_1843 = new cjs.Shape();
	this.shape_1843.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAJAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1843.setTransform(908.2,627.9,0.5,0.5);

	this.shape_1844 = new cjs.Shape();
	this.shape_1844.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA1AAQAwgBAcAiQAbAiABA4IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAQgDAcgLIAAAXQgXAKgTADQgSADgaABQg6AAghglgAg3hbQgXAagEAvICmAAQABgtgVgcQgUgbglABQglAAgZAag");
	this.shape_1844.setTransform(890.5,629.4,0.5,0.5);

	this.shape_1845 = new cjs.Shape();
	this.shape_1845.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1845.setTransform(880.6,626.5,0.5,0.5);

	this.shape_1846 = new cjs.Shape();
	this.shape_1846.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAQgYAWgMQAWgMAdAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_1846.setTransform(870.5,626.6,0.5,0.5);

	this.shape_1847 = new cjs.Shape();
	this.shape_1847.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgdAAQgpAAgUgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1847.setTransform(855.3,629.4,0.5,0.5);

	this.shape_1848 = new cjs.Shape();
	this.shape_1848.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAvAAAXgYQAXgYAAg3IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgZAqhDAAQhcAAAAhjg");
	this.shape_1848.setTransform(841.4,629.6,0.5,0.5);

	this.shape_1849 = new cjs.Shape();
	this.shape_1849.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1849.setTransform(831.1,626.5,0.5,0.5);

	this.shape_1850 = new cjs.Shape();
	this.shape_1850.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1850.setTransform(821,629.4,0.5,0.5);

	this.shape_1851 = new cjs.Shape();
	this.shape_1851.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAOAjAHAaIABAAQAIgdAMghIBHi2IAZAAIhpENg");
	this.shape_1851.setTransform(808.8,629.4,0.5,0.5);

	this.shape_1852 = new cjs.Shape();
	this.shape_1852.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAKgQAIgXIAOgkIhokNIAZAAIA6CYQAaBEAGAYIABAAQALghAXg9IA6iWIAZAAIh4E5QgOAmgLANQgKAOgNAHQgNAHgUgBQgPAAgQgEg");
	this.shape_1852.setTransform(790.5,632.5,0.5,0.5);

	this.shape_1853 = new cjs.Shape();
	this.shape_1853.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1853.setTransform(780.6,629.3,0.5,0.5);

	this.shape_1854 = new cjs.Shape();
	this.shape_1854.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAcAhAAA5IAAATIjDAAQABA4AaAeQAZAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg6AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_1854.setTransform(767.7,629.4,0.5,0.5);

	this.shape_1855 = new cjs.Shape();
	this.shape_1855.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAOAjAHAaIABAAQAIgdAMghIBHi2IAZAAIhpENg");
	this.shape_1855.setTransform(754.9,629.4,0.5,0.5);

	this.shape_1856 = new cjs.Shape();
	this.shape_1856.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmAAAWgMQAUgOABgWQgBgUgQgPQgQgOgmgNQgngNgSgLQgPgKgJgOQgIgOAAgSQgBgfAagSQAagRAsAAQAtAAAnAQIgJAXQgogRgjAAQgeAAgVALQgTALAAAUQAAAVAOAMQAOAMAtARQAjANASAJQAQALAIAOQAJANAAASQAAAlgcATQgbAUgyAAQg3AAgfgRg");
	this.shape_1856.setTransform(736.4,629.4,0.5,0.5);

	this.shape_1857 = new cjs.Shape();
	this.shape_1857.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1857.setTransform(723.3,629.4,0.5,0.5);

	this.shape_1858 = new cjs.Shape();
	this.shape_1858.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_1858.setTransform(707.8,629.4,0.5,0.5);

	this.shape_1859 = new cjs.Shape();
	this.shape_1859.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAitIgpAAIAAgPIApgLIAMg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAhALAOQALAOAXAAQAZAAAQgDIAAATQgRAHgZAAQgigBgRgSg");
	this.shape_1859.setTransform(687.5,627.9,0.5,0.5);

	this.shape_1860 = new cjs.Shape();
	this.shape_1860.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_1860.setTransform(680.2,627.1,0.5,0.5);

	this.shape_1861 = new cjs.Shape();
	this.shape_1861.graphics.f("#000000").s().p("AgdA/QAKgjAFgaQAIggAFgfIAcAAIADAEQgTBCgYA2g");
	this.shape_1861.setTransform(668.5,621.1,0.5,0.5);

	this.shape_1862 = new cjs.Shape();
	this.shape_1862.graphics.f("#000000").s().p("AgnCiQAAgXATAAQAUAAAAAXQAAAZgUAAQgTAAAAgZgAgfBYIAAgJQAAgfAJgTQAJgUAZgVIAWgTQATgPAHgQQAIgOAAgUQAAgfgVgTQgVgTggAAQgUAAgRAFQgUAEgRAJIgKgTQAegNAQgDQAQgEAXAAQAsAAAaAYQAaAZAAArQAAASgEALQgEALgJANQgIAKgLALIgaAVQgPANgKALQgGALgEANQgFAKAAAaIAAADg");
	this.shape_1862.setTransform(661.2,627.1,0.5,0.5);

	this.shape_1863 = new cjs.Shape();
	this.shape_1863.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1863.setTransform(651.5,627.9,0.5,0.5);

	this.shape_1864 = new cjs.Shape();
	this.shape_1864.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_1864.setTransform(639.9,629.3,0.5,0.5);

	this.shape_1865 = new cjs.Shape();
	this.shape_1865.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAhAAA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgSADQgTADgZABQg6AAggglgAg3hbQgXAagEAvICnAAQAAgtgVgcQgUgbglABQgmAAgYAag");
	this.shape_1865.setTransform(625.4,629.4,0.5,0.5);

	this.shape_1866 = new cjs.Shape();
	this.shape_1866.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgSQgQgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_1866.setTransform(607.2,629.3,0.5,0.5);

	this.shape_1867 = new cjs.Shape();
	this.shape_1867.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAATIjDAAQAAA4AbAeQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgWAKgTADQgTADgYABQg6AAghglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQglAAgZAag");
	this.shape_1867.setTransform(588.9,629.4,0.5,0.5);

	this.shape_1868 = new cjs.Shape();
	this.shape_1868.graphics.f("#000000").s().p("AhdC0QgdgTAAgkQAAgcARgSQARgTAfgHQgNgFgHgJQgIgKAAgMQAAgaAjgVQgYgKgNgVQgNgVAAgaQAAgoAagaQAagYArAAQAZAAAQAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAtAAAWARQAYASAAAjQAAArgjAXQgiAXhAAAQgzAAgbgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgQgLQgSgLgkAAIgsAAQhKAAgBA7gAg4igQgTATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSghAAQgfAAgTATg");
	this.shape_1868.setTransform(575.2,632.4,0.5,0.5);

	this.shape_1869 = new cjs.Shape();
	this.shape_1869.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgSgjAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_1869.setTransform(561.1,629.3,0.5,0.5);

	this.shape_1870 = new cjs.Shape();
	this.shape_1870.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1870.setTransform(546.3,629.4,0.5,0.5);

	this.shape_1871 = new cjs.Shape();
	this.shape_1871.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1871.setTransform(535.9,629.3,0.5,0.5);

	this.shape_1872 = new cjs.Shape();
	this.shape_1872.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1872.setTransform(526,629.3,0.5,0.5);

	this.shape_1873 = new cjs.Shape();
	this.shape_1873.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1873.setTransform(512.9,629.4,0.5,0.5);

	this.shape_1874 = new cjs.Shape();
	this.shape_1874.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAcAhgBA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgXAYgFAxICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_1874.setTransform(493,629.4,0.5,0.5);

	this.shape_1875 = new cjs.Shape();
	this.shape_1875.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1875.setTransform(478.5,626.5,0.5,0.5);

	this.shape_1876 = new cjs.Shape();
	this.shape_1876.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_1876.setTransform(466.5,627.9,0.5,0.5);

	this.shape_1877 = new cjs.Shape();
	this.shape_1877.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA0AAQAwgBAcAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgTADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICmAAQABgtgVgcQgUgbglABQglAAgZAag");
	this.shape_1877.setTransform(448.8,629.4,0.5,0.5);

	this.shape_1878 = new cjs.Shape();
	this.shape_1878.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_1878.setTransform(436.7,626.5,0.5,0.5);

	this.shape_1879 = new cjs.Shape();
	this.shape_1879.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1879.setTransform(426.6,627,0.5,0.5);

	this.shape_1880 = new cjs.Shape();
	this.shape_1880.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1880.setTransform(420.8,626.5,0.5,0.5);

	this.shape_1881 = new cjs.Shape();
	this.shape_1881.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1881.setTransform(403.7,629.6,0.5,0.5);

	this.shape_1882 = new cjs.Shape();
	this.shape_1882.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1882.setTransform(388.8,629.4,0.5,0.5);

	this.shape_1883 = new cjs.Shape();
	this.shape_1883.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgNAKgaIAOgkIhokNIAZAAIA5CYQAZA/AJAdIAAAAQAKgcAZhCIA4iWIAaAAIh4E5QgQAogJALQgJAOgOAHQgNAHgTgBQgPAAgRgEg");
	this.shape_1883.setTransform(375.5,632.5,0.5,0.5);

	this.shape_1884 = new cjs.Shape();
	this.shape_1884.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABBghAnQgfAkg4ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1884.setTransform(355.5,629.4,0.5,0.5);

	this.shape_1885 = new cjs.Shape();
	this.shape_1885.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_1885.setTransform(340,626.6,0.5,0.5);

	this.shape_1886 = new cjs.Shape();
	this.shape_1886.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAPg7AHgSIA4ikIAVAAIA1CjQARA4AFAWIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_1886.setTransform(317,629.4,0.5,0.5);

	this.shape_1887 = new cjs.Shape();
	this.shape_1887.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1887.setTransform(300.3,629.4,0.5,0.5);

	this.shape_1888 = new cjs.Shape();
	this.shape_1888.graphics.f("#000000").s().p("ABrC2IAAizIjUAAIAACzIgaAAIAAlrIAaAAIAAChIDUAAIAAihIAZAAIAAFrg");
	this.shape_1888.setTransform(283.7,627.1,0.5,0.5);

	this.shape_1889 = new cjs.Shape();
	this.shape_1889.graphics.f("#000000").s().p("AgnCiQAAgXATAAQAUAAAAAXQAAAZgUAAQgTAAAAgZgAgfBYIAAgJQAAgfAJgTQAJgUAZgVIAWgTQASgPAIgQQAIgOAAgUQAAgfgVgTQgWgTggAAQgTAAgSAFQgTAEgSAJIgJgTQAegNAQgDQAQgEAWAAQAtAAAaAYQAaAZAAArQAAARgEAMQgEALgJANQgIAKgMALIgZAVQgPANgKALQgHALgEANQgEAKAAAaIAAADg");
	this.shape_1889.setTransform(262.4,627.1,0.5,0.5);

	this.shape_1890 = new cjs.Shape();
	this.shape_1890.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1890.setTransform(253.1,629.3,0.5,0.5);

	this.shape_1891 = new cjs.Shape();
	this.shape_1891.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_1891.setTransform(240.2,629.4,0.5,0.5);

	this.shape_1892 = new cjs.Shape();
	this.shape_1892.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXg/AAQgzAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1892.setTransform(226.6,632.4,0.5,0.5);

	this.shape_1893 = new cjs.Shape();
	this.shape_1893.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgjAAQgwAAgXAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_1893.setTransform(212.5,629.3,0.5,0.5);

	this.shape_1894 = new cjs.Shape();
	this.shape_1894.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA2AAQA4gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1894.setTransform(197.4,629.4,0.5,0.5);

	this.shape_1895 = new cjs.Shape();
	this.shape_1895.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1895.setTransform(187,626.5,0.5,0.5);

	this.shape_1896 = new cjs.Shape();
	this.shape_1896.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_1896.setTransform(170.5,629.4,0.5,0.5);

	this.shape_1897 = new cjs.Shape();
	this.shape_1897.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAPgYAXgMQAWgMAdAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_1897.setTransform(156.3,626.6,0.5,0.5);

	this.shape_1898 = new cjs.Shape();
	this.shape_1898.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1898.setTransform(137.3,627.9,0.5,0.5);

	this.shape_1899 = new cjs.Shape();
	this.shape_1899.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_1899.setTransform(130.3,627,0.5,0.5);

	this.shape_1900 = new cjs.Shape();
	this.shape_1900.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1900.setTransform(112.8,626.6,0.5,0.5);

	this.shape_1901 = new cjs.Shape();
	this.shape_1901.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1901.setTransform(102.7,626.5,0.5,0.5);

	this.shape_1902 = new cjs.Shape();
	this.shape_1902.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1902.setTransform(92.3,629.6,0.5,0.5);

	this.shape_1903 = new cjs.Shape();
	this.shape_1903.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAgglQAhglA3AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1903.setTransform(77.3,629.4,0.5,0.5);

	this.shape_1904 = new cjs.Shape();
	this.shape_1904.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_1904.setTransform(62.4,626.5,0.5,0.5);

	this.shape_1905 = new cjs.Shape();
	this.shape_1905.graphics.f("#000000").s().p("AhvCtIAAgaQAmARA9AAQAugBAZgUQAagUAAgiQAAgUgIgOQgKgOgTgLQgTgLgmgNQg3gSgWgWQgVgXAAglQAAgpAggZQAggaAxAAQAzAAAuATIgJAWQgvgTgpAAQgmAAgZATQgYATAAAgQAAATAIAOQAHAMARALQAPAJApAQQArAOAVANQAWAOAKASQAKARAAAZQgBAtghAbQgiAbg3AAQhBAAgkgOg");
	this.shape_1905.setTransform(48,627.1,0.5,0.5);

	this.shape_1906 = new cjs.Shape();
	this.shape_1906.graphics.f("#000000").s().p("AgnCiQAAgXATAAQAUAAAAAXQAAAZgUAAQgTAAAAgZgAgfBYIAAgJQAAgfAJgTQAKgUAYgVIAWgTQATgPAHgQQAHgOAAgUQABgfgVgTQgVgTghAAQgTAAgRAFQgTAEgTAJIgJgTQAegNAQgDQARgEAVAAQAtAAAaAYQAaAZAAArQAAARgFAMQgEANgIALQgIAKgLALIgaAVQgPANgJALQgJANgDALQgEAMAAAYIAAADg");
	this.shape_1906.setTransform(988.5,588.9,0.5,0.5);

	this.shape_1907 = new cjs.Shape();
	this.shape_1907.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_1907.setTransform(975.8,588.3,0.5,0.5);

	this.shape_1908 = new cjs.Shape();
	this.shape_1908.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgXgKgOgVQgNgVAAgaQAAgpAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSggAAQggAAgTATg");
	this.shape_1908.setTransform(961.6,594.1,0.5,0.5);

	this.shape_1909 = new cjs.Shape();
	this.shape_1909.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_1909.setTransform(952,588.7,0.5,0.5);

	this.shape_1910 = new cjs.Shape();
	this.shape_1910.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAZgLAfAAQBdAAgBBiIAACxg");
	this.shape_1910.setTransform(941.7,588.3,0.5,0.5);

	this.shape_1911 = new cjs.Shape();
	this.shape_1911.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1911.setTransform(920,591.2,0.5,0.5);

	this.shape_1912 = new cjs.Shape();
	this.shape_1912.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAfglA3AAQA4gBAgAmQAgAmAABAQAABBghAnQggAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1912.setTransform(905,591.2,0.5,0.5);

	this.shape_1913 = new cjs.Shape();
	this.shape_1913.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1913.setTransform(893.1,589.7,0.5,0.5);

	this.shape_1914 = new cjs.Shape();
	this.shape_1914.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_1914.setTransform(877.9,589.7,0.5,0.5);

	this.shape_1915 = new cjs.Shape();
	this.shape_1915.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1915.setTransform(871,588.7,0.5,0.5);

	this.shape_1916 = new cjs.Shape();
	this.shape_1916.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgQgOgmgNQgmgNgSgLQgRgLgIgNQgJgOAAgSQAAgfAagSQAbgRArAAQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgUALAAAUQABAVAPAMQANAMAsARQAkAMASAKQARAMAIANQAIANAAASQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_1916.setTransform(855.4,591.2,0.5,0.5);

	this.shape_1917 = new cjs.Shape();
	this.shape_1917.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_1917.setTransform(846.7,588.7,0.5,0.5);

	this.shape_1918 = new cjs.Shape();
	this.shape_1918.graphics.f("#000000").s().p("AgaA/IgDgGQAKggALgdQALgkALgVIAQAAQgJAdgHAiQgJAqgDATg");
	this.shape_1918.setTransform(842,582.9,0.5,0.5);

	this.shape_1919 = new cjs.Shape();
	this.shape_1919.graphics.f("#000000").s().p("AhqAKIAAgTIDVAAIAAATg");
	this.shape_1919.setTransform(827.1,591.1,0.5,0.5);

	this.shape_1920 = new cjs.Shape();
	this.shape_1920.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_1920.setTransform(806.7,591.1,0.5,0.5);

	this.shape_1921 = new cjs.Shape();
	this.shape_1921.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABBggAnQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1921.setTransform(791.6,591.2,0.5,0.5);

	this.shape_1922 = new cjs.Shape();
	this.shape_1922.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_1922.setTransform(770.9,594.1,0.5,0.5);

	this.shape_1923 = new cjs.Shape();
	this.shape_1923.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgSgjAAQgwAAgXAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_1923.setTransform(756.7,591.1,0.5,0.5);

	this.shape_1924 = new cjs.Shape();
	this.shape_1924.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1924.setTransform(746.3,588.7,0.5,0.5);

	this.shape_1925 = new cjs.Shape();
	this.shape_1925.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_1925.setTransform(738.3,588.3,0.5,0.5);

	this.shape_1926 = new cjs.Shape();
	this.shape_1926.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1926.setTransform(727,591.1,0.5,0.5);

	this.shape_1927 = new cjs.Shape();
	this.shape_1927.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA2AAQA4gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1927.setTransform(713.6,591.2,0.5,0.5);

	this.shape_1928 = new cjs.Shape();
	this.shape_1928.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAMg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQACgSAShFIApiaIAZAAIhKENg");
	this.shape_1928.setTransform(696.9,591.2,0.5,0.5);

	this.shape_1929 = new cjs.Shape();
	this.shape_1929.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmAAAWgMQAUgNAAgXQAAgUgQgPQgQgOgmgNQgngNgSgLQgQgLgIgNQgJgOABgSQAAgfAZgSQAagRAsAAQAtAAAnAQIgJAXQgogRgjAAQgeAAgVALQgUALAAAUQAAAVAPAMQAOAMAsARQAkAMASAKQAPALAKAOQAIANAAASQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_1929.setTransform(675.1,591.2,0.5,0.5);

	this.shape_1930 = new cjs.Shape();
	this.shape_1930.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1930.setTransform(662,591.2,0.5,0.5);

	this.shape_1931 = new cjs.Shape();
	this.shape_1931.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAMg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_1931.setTransform(646.5,591.2,0.5,0.5);

	this.shape_1932 = new cjs.Shape();
	this.shape_1932.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_1932.setTransform(627.4,588.9,0.5,0.5);

	this.shape_1933 = new cjs.Shape();
	this.shape_1933.graphics.f("#000000").s().p("AhNBoQgggjAAhDQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg7AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_1933.setTransform(610.6,591.2,0.5,0.5);

	this.shape_1934 = new cjs.Shape();
	this.shape_1934.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6ABQAigBAhANIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAmAAAegNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_1934.setTransform(597.8,591.2,0.5,0.5);

	this.shape_1935 = new cjs.Shape();
	this.shape_1935.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAQgDAcgLIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgUgbglABQgmAAgXAag");
	this.shape_1935.setTransform(584.5,591.2,0.5,0.5);

	this.shape_1936 = new cjs.Shape();
	this.shape_1936.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1936.setTransform(574.6,588.7,0.5,0.5);

	this.shape_1937 = new cjs.Shape();
	this.shape_1937.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_1937.setTransform(564.5,594.1,0.5,0.5);

	this.shape_1938 = new cjs.Shape();
	this.shape_1938.graphics.f("#000000").s().p("AhPB4QgVgUgBglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgdAAQgpAAgVgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_1938.setTransform(542.7,591.2,0.5,0.5);

	this.shape_1939 = new cjs.Shape();
	this.shape_1939.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgnAAIAAgPIAngLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQABAhAJAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1939.setTransform(525.4,589.7,0.5,0.5);

	this.shape_1940 = new cjs.Shape();
	this.shape_1940.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1940.setTransform(513.7,591.3,0.5,0.5);

	this.shape_1941 = new cjs.Shape();
	this.shape_1941.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAgglQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1941.setTransform(498.7,591.2,0.5,0.5);

	this.shape_1942 = new cjs.Shape();
	this.shape_1942.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgQAAIAAmCIAZAAIgBCfIABAAQAPgYAWgMQAWgMAeAAQA5AAAdAkQAdAkAABEQgBBCgeAmQgeAkg2AAQgdAAgXgMgAhEgiQgVAbAAA/IAAAEQAAA+AWAaQAUAaAvAAQAsAAAVgfQAXgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_1942.setTransform(484.1,588.4,0.5,0.5);

	this.shape_1943 = new cjs.Shape();
	this.shape_1943.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_1943.setTransform(468.9,591.2,0.5,0.5);

	this.shape_1944 = new cjs.Shape();
	this.shape_1944.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgWAJgUAEQgRADgZABQg7AAghglgAg2hbQgYAYgEAxICmAAQAAgugVgbQgUgbgkABQgmAAgXAag");
	this.shape_1944.setTransform(449,591.2,0.5,0.5);

	this.shape_1945 = new cjs.Shape();
	this.shape_1945.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgQgOgmgNQgngNgRgLQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgTALAAAUQAAAVAPAMQAOAMArARQAmANAQAJQARAMAIANQAIAOAAARQAAAkgbAUQgcAUgyAAQg2AAgggRg");
	this.shape_1945.setTransform(435.9,591.2,0.5,0.5);

	this.shape_1946 = new cjs.Shape();
	this.shape_1946.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1946.setTransform(427.2,588.7,0.5,0.5);

	this.shape_1947 = new cjs.Shape();
	this.shape_1947.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAOAjAHAaIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_1947.setTransform(418.5,591.2,0.5,0.5);

	this.shape_1948 = new cjs.Shape();
	this.shape_1948.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA2AAQAcAAAXALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_1948.setTransform(404.6,588.4,0.5,0.5);

	this.shape_1949 = new cjs.Shape();
	this.shape_1949.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1949.setTransform(390.2,591.2,0.5,0.5);

	this.shape_1950 = new cjs.Shape();
	this.shape_1950.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1950.setTransform(373.2,591.1,0.5,0.5);

	this.shape_1951 = new cjs.Shape();
	this.shape_1951.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA2AAQA4gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1951.setTransform(359.9,591.2,0.5,0.5);

	this.shape_1952 = new cjs.Shape();
	this.shape_1952.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_1952.setTransform(349.5,588.2,0.5,0.5);

	this.shape_1953 = new cjs.Shape();
	this.shape_1953.graphics.f("#000000").s().p("Ag0DeIAAgYIBRAAIAAmMIhRAAIAAgXIBpAAIAAG7g");
	this.shape_1953.setTransform(333.3,590.9,0.5,0.5);

	this.shape_1954 = new cjs.Shape();
	this.shape_1954.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1954.setTransform(327.2,588.3,0.5,0.5);

	this.shape_1955 = new cjs.Shape();
	this.shape_1955.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg7AAggglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_1955.setTransform(317.3,591.2,0.5,0.5);

	this.shape_1956 = new cjs.Shape();
	this.shape_1956.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1956.setTransform(302.8,588.3,0.5,0.5);

	this.shape_1957 = new cjs.Shape();
	this.shape_1957.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAigmQAigmA6ABQAigBAhANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAmAAAegNIAAAXQgZANgqAAQg6AAghglg");
	this.shape_1957.setTransform(289.5,591.2,0.5,0.5);

	this.shape_1958 = new cjs.Shape();
	this.shape_1958.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1958.setTransform(280.3,588.7,0.5,0.5);

	this.shape_1959 = new cjs.Shape();
	this.shape_1959.graphics.f("#000000").s().p("ACPC2IAAkTQAAgZADgjIgCAAIiIFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAFAIABAAICBlAIAnAAIAAFrg");
	this.shape_1959.setTransform(266.4,588.9,0.5,0.5);

	this.shape_1960 = new cjs.Shape();
	this.shape_1960.graphics.f("#000000").s().p("Ag0DeIAAm7IBpAAIAAAXIhRAAIAAGMIBRAAIAAAYg");
	this.shape_1960.setTransform(252.1,590.9,0.5,0.5);

	this.shape_1961 = new cjs.Shape();
	this.shape_1961.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_1961.setTransform(236.5,591.1,0.5,0.5);

	this.shape_1962 = new cjs.Shape();
	this.shape_1962.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA3AaAfQAZAdAvAAQAXAAARgDQAPgCAegMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgXAag");
	this.shape_1962.setTransform(223.7,591.2,0.5,0.5);

	this.shape_1963 = new cjs.Shape();
	this.shape_1963.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1963.setTransform(209.2,588.3,0.5,0.5);

	this.shape_1964 = new cjs.Shape();
	this.shape_1964.graphics.f("#000000").s().p("Ag+B8QgbgRgPghQgPghAAgpQAAhBAhglQAgglA3AAQA4gBAfAmQAgAmAABAQAABBghAnQggAkg3ABQgkgBgagQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_1964.setTransform(187.6,591.2,0.5,0.5);

	this.shape_1965 = new cjs.Shape();
	this.shape_1965.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1965.setTransform(175.6,589.7,0.5,0.5);

	this.shape_1966 = new cjs.Shape();
	this.shape_1966.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_1966.setTransform(159.9,588.3,0.5,0.5);

	this.shape_1967 = new cjs.Shape();
	this.shape_1967.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABBghAnQgfAkg4ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_1967.setTransform(145.1,591.2,0.5,0.5);

	this.shape_1968 = new cjs.Shape();
	this.shape_1968.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1968.setTransform(130.2,591.2,0.5,0.5);

	this.shape_1969 = new cjs.Shape();
	this.shape_1969.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1969.setTransform(119.8,588.3,0.5,0.5);

	this.shape_1970 = new cjs.Shape();
	this.shape_1970.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_1970.setTransform(102.3,588.4,0.5,0.5);

	this.shape_1971 = new cjs.Shape();
	this.shape_1971.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_1971.setTransform(92.2,588.3,0.5,0.5);

	this.shape_1972 = new cjs.Shape();
	this.shape_1972.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_1972.setTransform(81.8,591.3,0.5,0.5);

	this.shape_1973 = new cjs.Shape();
	this.shape_1973.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_1973.setTransform(66.8,591.2,0.5,0.5);

	this.shape_1974 = new cjs.Shape();
	this.shape_1974.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA3AFAeIABAAQAPg7AHgSIA4ikIAVAAIA1CjQATBAADAOIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_1974.setTransform(50.2,591.2,0.5,0.5);

	this.shape_1975 = new cjs.Shape();
	this.shape_1975.graphics.f("#000000").s().p("AgLC2IAAlrIAYAAIAAFrg");
	this.shape_1975.setTransform(965.9,550.6,0.5,0.5);

	this.shape_1976 = new cjs.Shape();
	this.shape_1976.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgPgNgngOQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgUALAAAUQAAAVAQAMQAOAMArARQAmANAQAJQARAMAIANQAIAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_1976.setTransform(950,552.9,0.5,0.5);

	this.shape_1977 = new cjs.Shape();
	this.shape_1977.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAvgBAdAiQAcAiAAA4IAAATIjDAAQAAA3AbAfQAZAdAuAAQAYAAARgDQAPgCAdgMIAAAXQgVAJgVAEQgRADgaABQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgmAAgYAag");
	this.shape_1977.setTransform(937.2,552.9,0.5,0.5);

	this.shape_1978 = new cjs.Shape();
	this.shape_1978.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgRQgPgSggAAQgqgBgTAXQgUAXAAAxIAACeIgZAAIAAi4QAAhEg+AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgWAVgKQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_1978.setTransform(919,552.8,0.5,0.5);

	this.shape_1979 = new cjs.Shape();
	this.shape_1979.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_1979.setTransform(904.8,550.5,0.5,0.5);

	this.shape_1980 = new cjs.Shape();
	this.shape_1980.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_1980.setTransform(897.5,551.4,0.5,0.5);

	this.shape_1981 = new cjs.Shape();
	this.shape_1981.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAATIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgXAKgUADQgSADgYABQg7AAghglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgUgbgkABQgmAAgYAag");
	this.shape_1981.setTransform(886.4,552.9,0.5,0.5);

	this.shape_1982 = new cjs.Shape();
	this.shape_1982.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgSQgQgSggAAQgpgBgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_1982.setTransform(868.2,552.8,0.5,0.5);

	this.shape_1983 = new cjs.Shape();
	this.shape_1983.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAgglQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_1983.setTransform(849.4,552.9,0.5,0.5);

	this.shape_1984 = new cjs.Shape();
	this.shape_1984.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAnAAAVgMQAUgOAAgWQAAgUgQgPQgQgOgngNQgmgNgSgLQgPgKgJgOQgJgOAAgSQAAgfAagSQAagRAsAAQAsAAAnAQIgJAXQgngRgjAAQgfAAgUALQgUALAAAUQABAVAPAMQAOAMArARQAlANAQAJQARALAIAOQAJAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_1984.setTransform(835.9,552.9,0.5,0.5);

	this.shape_1985 = new cjs.Shape();
	this.shape_1985.graphics.f("#000000").s().p("AgdA/QAThDAJg5IAcAAIADAEQgTBCgXA2g");
	this.shape_1985.setTransform(820.3,559.9,0.5,0.5);

	this.shape_1986 = new cjs.Shape();
	this.shape_1986.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAtIAACVg");
	this.shape_1986.setTransform(813.9,552.8,0.5,0.5);

	this.shape_1987 = new cjs.Shape();
	this.shape_1987.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAATIjDAAQABA4AaAeQAZAdAuAAQAYAAARgDQARgDAbgLIAAAXQgWAKgTADQgTADgZABQg5AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_1987.setTransform(801,552.9,0.5,0.5);

	this.shape_1988 = new cjs.Shape();
	this.shape_1988.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_1988.setTransform(791.2,550.5,0.5,0.5);

	this.shape_1989 = new cjs.Shape();
	this.shape_1989.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_1989.setTransform(785.4,550,0.5,0.5);

	this.shape_1990 = new cjs.Shape();
	this.shape_1990.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAcAiQAbAiAAA4IAAATIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgDAcgLIAAAXQgWAKgUADQgRADgZABQg7AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQglAAgZAag");
	this.shape_1990.setTransform(775.5,552.9,0.5,0.5);

	this.shape_1991 = new cjs.Shape();
	this.shape_1991.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQALAOAXAAQAZAAAPgDIAAATQgRAHgXAAQgjgBgRgSg");
	this.shape_1991.setTransform(764.1,551.4,0.5,0.5);

	this.shape_1992 = new cjs.Shape();
	this.shape_1992.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICTltIAPAAICPFtgAgNhiIgzCBICCAAIgyiCQgEgKgLghQgFAWgJAWg");
	this.shape_1992.setTransform(752.3,550.6,0.5,0.5);

	this.shape_1993 = new cjs.Shape();
	this.shape_1993.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_1993.setTransform(731,552.9,0.5,0.5);

	this.shape_1994 = new cjs.Shape();
	this.shape_1994.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_1994.setTransform(716.6,550,0.5,0.5);

	this.shape_1995 = new cjs.Shape();
	this.shape_1995.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQALAOAXAAQAZAAAQgDIAAATQgSAHgXAAQgjgBgRgSg");
	this.shape_1995.setTransform(704.5,551.4,0.5,0.5);

	this.shape_1996 = new cjs.Shape();
	this.shape_1996.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_1996.setTransform(689.4,551.4,0.5,0.5);

	this.shape_1997 = new cjs.Shape();
	this.shape_1997.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_1997.setTransform(678.1,552.9,0.5,0.5);

	this.shape_1998 = new cjs.Shape();
	this.shape_1998.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIACAAQAbgrBBAAQBdAAgBBjIAACwg");
	this.shape_1998.setTransform(657.7,552.8,0.5,0.5);

	this.shape_1999 = new cjs.Shape();
	this.shape_1999.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAATIjDAAQAAA3AbAfQAZAdAuAAQAYAAARgDQAPgCAegMIAAAXQgXAJgTAEQgSADgaABQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQglAAgZAag");
	this.shape_1999.setTransform(643.1,552.9,0.5,0.5);

	this.shape_2000 = new cjs.Shape();
	this.shape_2000.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAYgLAhAAQBbAAAABiIAACxg");
	this.shape_2000.setTransform(628.7,550,0.5,0.5);

	this.shape_2001 = new cjs.Shape();
	this.shape_2001.graphics.f("#000000").s().p("ABdC2IhQkYQgKgigEgXQgGAegFAUIhQEfIgWAAIhklrIAbAAIBVFDQAGghAThGIA+jcIAcAAIBJD8QANAuAFAZQADgQAFgWIBNkdIAaAAIhlFrg");
	this.shape_2001.setTransform(609.7,550.6,0.5,0.5);

	this.shape_2002 = new cjs.Shape();
	this.shape_2002.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_2002.setTransform(588.7,558.7,0.5,0.5);

	this.shape_2003 = new cjs.Shape();
	this.shape_2003.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgPgNgngOQgngNgRgLQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAsAAQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgTALAAAUQAAAVAPAMQAOAMArARQAmANAQAJQARAMAIANQAIAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_2003.setTransform(579.6,552.9,0.5,0.5);

	this.shape_2004 = new cjs.Shape();
	this.shape_2004.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_2004.setTransform(567.1,555.9,0.5,0.5);

	this.shape_2005 = new cjs.Shape();
	this.shape_2005.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_2005.setTransform(553,552.8,0.5,0.5);

	this.shape_2006 = new cjs.Shape();
	this.shape_2006.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2006.setTransform(542.5,550.5,0.5,0.5);

	this.shape_2007 = new cjs.Shape();
	this.shape_2007.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_2007.setTransform(532.2,552.8,0.5,0.5);

	this.shape_2008 = new cjs.Shape();
	this.shape_2008.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2008.setTransform(517.6,552.9,0.5,0.5);

	this.shape_2009 = new cjs.Shape();
	this.shape_2009.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QALAdAJAgIABAAQAJghAMgdIBGi2IAZAAIhpENg");
	this.shape_2009.setTransform(504.7,552.9,0.5,0.5);

	this.shape_2010 = new cjs.Shape();
	this.shape_2010.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2010.setTransform(491.9,552.9,0.5,0.5);

	this.shape_2011 = new cjs.Shape();
	this.shape_2011.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA1AAQAvgBAdAiQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgXAJgUAEQgRADgaABQg6AAghglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgnAAgXAag");
	this.shape_2011.setTransform(471.3,552.9,0.5,0.5);

	this.shape_2012 = new cjs.Shape();
	this.shape_2012.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_2012.setTransform(456.8,550,0.5,0.5);

	this.shape_2013 = new cjs.Shape();
	this.shape_2013.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2013.setTransform(444.8,551.4,0.5,0.5);

	this.shape_2014 = new cjs.Shape();
	this.shape_2014.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2014.setTransform(426.6,552.8,0.5,0.5);

	this.shape_2015 = new cjs.Shape();
	this.shape_2015.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2015.setTransform(416.2,550.5,0.5,0.5);

	this.shape_2016 = new cjs.Shape();
	this.shape_2016.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2016.setTransform(402.6,552.8,0.5,0.5);

	this.shape_2017 = new cjs.Shape();
	this.shape_2017.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgXAag");
	this.shape_2017.setTransform(389.7,552.9,0.5,0.5);

	this.shape_2018 = new cjs.Shape();
	this.shape_2018.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2018.setTransform(375.3,552.8,0.5,0.5);

	this.shape_2019 = new cjs.Shape();
	this.shape_2019.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_2019.setTransform(360.2,552.8,0.5,0.5);

	this.shape_2020 = new cjs.Shape();
	this.shape_2020.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_2020.setTransform(349.8,550.5,0.5,0.5);

	this.shape_2021 = new cjs.Shape();
	this.shape_2021.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAegmA2AAQAcAAAXALQAWALARAaIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QgBBzBZAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_2021.setTransform(338.9,550.1,0.5,0.5);

	this.shape_2022 = new cjs.Shape();
	this.shape_2022.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgVAJgUAEQgTADgYABQg7AAggglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQglAAgYAag");
	this.shape_2022.setTransform(318.1,552.9,0.5,0.5);

	this.shape_2023 = new cjs.Shape();
	this.shape_2023.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAaIABAAQAKggALgeIBGi2IAZAAIhpENg");
	this.shape_2023.setTransform(305.2,552.9,0.5,0.5);

	this.shape_2024 = new cjs.Shape();
	this.shape_2024.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2024.setTransform(292.2,552.9,0.5,0.5);

	this.shape_2025 = new cjs.Shape();
	this.shape_2025.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_2025.setTransform(278.4,550,0.5,0.5);

	this.shape_2026 = new cjs.Shape();
	this.shape_2026.graphics.f("#000000").s().p("AgdA/QAThDAJg5IAcAAIADAEQgTBAgXA4g");
	this.shape_2026.setTransform(261,559.9,0.5,0.5);

	this.shape_2027 = new cjs.Shape();
	this.shape_2027.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2027.setTransform(254.6,552.8,0.5,0.5);

	this.shape_2028 = new cjs.Shape();
	this.shape_2028.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgVAJgUAEQgTADgYABQg7AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgnAAgXAag");
	this.shape_2028.setTransform(241.8,552.9,0.5,0.5);

	this.shape_2029 = new cjs.Shape();
	this.shape_2029.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_2029.setTransform(227.4,550,0.5,0.5);

	this.shape_2030 = new cjs.Shape();
	this.shape_2030.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAfAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2030.setTransform(215.3,551.4,0.5,0.5);

	this.shape_2031 = new cjs.Shape();
	this.shape_2031.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgVAJgVAEQgRADgZABQg7AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgmAAgYAag");
	this.shape_2031.setTransform(204.2,552.9,0.5,0.5);

	this.shape_2032 = new cjs.Shape();
	this.shape_2032.graphics.f("#000000").s().p("AhdC0QgdgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_2032.setTransform(190.6,555.9,0.5,0.5);

	this.shape_2033 = new cjs.Shape();
	this.shape_2033.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABBggAnQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2033.setTransform(176.4,552.9,0.5,0.5);

	this.shape_2034 = new cjs.Shape();
	this.shape_2034.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACpQAAAhAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_2034.setTransform(164.5,551.4,0.5,0.5);

	this.shape_2035 = new cjs.Shape();
	this.shape_2035.graphics.f("#000000").s().p("AgSCYQgQgUgBgpIAAitIgnAAIAAgPIAngLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACpQAAAhAKAOQAMAOAXAAQAZAAAQgDIAAATQgTAHgXAAQgigBgSgSg");
	this.shape_2035.setTransform(149.3,551.4,0.5,0.5);

	this.shape_2036 = new cjs.Shape();
	this.shape_2036.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_2036.setTransform(142.4,550.5,0.5,0.5);

	this.shape_2037 = new cjs.Shape();
	this.shape_2037.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAbAiABA4IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAPgDAdgLIAAAXQgXAKgTADQgSADgaABQg6AAggglgAg3hbQgXAagEAvICnAAQAAgtgVgcQgVgbgkABQgmAAgYAag");
	this.shape_2037.setTransform(125.9,552.9,0.5,0.5);

	this.shape_2038 = new cjs.Shape();
	this.shape_2038.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQAAgcAQgSQARgTAfgHQgNgFgHgJQgIgKABgMQAAgaAjgVQgYgKgOgVQgNgUAAgbQAAgpAagZQAbgYArAAQAYAAAQAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgQAIgHAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAsAAAYARQAXASAAAjQAAArgjAXQghAXhBAAQgyAAgcgTgAhgB7QABA3BTAAQBpAAAAhEQAAgYgQgLQgSgLgkAAIgsAAQhKAAgBA7gAg4igQgTATAAAhQAAAfAUARQASASAgAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSghAAQgfAAgTATg");
	this.shape_2038.setTransform(112.2,555.9,0.5,0.5);

	this.shape_2039 = new cjs.Shape();
	this.shape_2039.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2039.setTransform(98.3,552.9,0.5,0.5);

	this.shape_2040 = new cjs.Shape();
	this.shape_2040.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgSgSgjAAQgvAAgYAYQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2040.setTransform(84.6,552.8,0.5,0.5);

	this.shape_2041 = new cjs.Shape();
	this.shape_2041.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2041.setTransform(69.8,552.9,0.5,0.5);

	this.shape_2042 = new cjs.Shape();
	this.shape_2042.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgSQgQgSggAAQgpgBgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_2042.setTransform(52.3,552.8,0.5,0.5);

	this.shape_2043 = new cjs.Shape();
	this.shape_2043.graphics.f("#000000").s().p("AgdA/QAUhJAIgzIAcAAIADAEQgTBCgYA2g");
	this.shape_2043.setTransform(967.4,521.6,0.5,0.5);

	this.shape_2044 = new cjs.Shape();
	this.shape_2044.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQARgMAcAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2044.setTransform(961,514.6,0.5,0.5);

	this.shape_2045 = new cjs.Shape();
	this.shape_2045.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2045.setTransform(948.1,514.7,0.5,0.5);

	this.shape_2046 = new cjs.Shape();
	this.shape_2046.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2046.setTransform(933.7,511.8,0.5,0.5);

	this.shape_2047 = new cjs.Shape();
	this.shape_2047.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_2047.setTransform(921.6,513.2,0.5,0.5);

	this.shape_2048 = new cjs.Shape();
	this.shape_2048.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBg/AggnQAhgnA0AAQAwgBAcAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg2hbQgYAYgEAxICnAAQgBgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2048.setTransform(910.6,514.7,0.5,0.5);

	this.shape_2049 = new cjs.Shape();
	this.shape_2049.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgNgVQgNgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQATASAgAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_2049.setTransform(896.9,517.6,0.5,0.5);

	this.shape_2050 = new cjs.Shape();
	this.shape_2050.graphics.f("#000000").s().p("Ag/B8QgbgRgOghQgPghAAgpQAAhBAhglQAfglA4AAQA3gBAgAmQAgAmAABAQAABBghAnQggAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2050.setTransform(882.8,514.7,0.5,0.5);

	this.shape_2051 = new cjs.Shape();
	this.shape_2051.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2051.setTransform(870.8,513.2,0.5,0.5);

	this.shape_2052 = new cjs.Shape();
	this.shape_2052.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgPgNgngOQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgRQAagTAsABQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgUALAAAUQAAAVAQAMQAOAMArARQAmANAQAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_2052.setTransform(854.1,514.7,0.5,0.5);

	this.shape_2053 = new cjs.Shape();
	this.shape_2053.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_2053.setTransform(839,514.7,0.5,0.5);

	this.shape_2054 = new cjs.Shape();
	this.shape_2054.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2054.setTransform(822.3,514.7,0.5,0.5);

	this.shape_2055 = new cjs.Shape();
	this.shape_2055.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_2055.setTransform(807.4,511.8,0.5,0.5);

	this.shape_2056 = new cjs.Shape();
	this.shape_2056.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgMQAVgOAAgWQAAgUgRgPQgPgNgngOQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgRQAagTAsABQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgUALAAAUQAAAVAQAMQAOAMArARQAmANAQAJQARALAIAOQAIAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_2056.setTransform(793.8,514.7,0.5,0.5);

	this.shape_2057 = new cjs.Shape();
	this.shape_2057.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2057.setTransform(776.9,513.2,0.5,0.5);

	this.shape_2058 = new cjs.Shape();
	this.shape_2058.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgcAAgNARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2058.setTransform(769.8,511.7,0.5,0.5);

	this.shape_2059 = new cjs.Shape();
	this.shape_2059.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2059.setTransform(757.9,514.7,0.5,0.5);

	this.shape_2060 = new cjs.Shape();
	this.shape_2060.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAcAAAtIAACVg");
	this.shape_2060.setTransform(747.5,514.6,0.5,0.5);

	this.shape_2061 = new cjs.Shape();
	this.shape_2061.graphics.f("#000000").s().p("Ag/BoQgiglABhBQgBhCAjgmQAigmA6ABQAiAAAhAMIgGAWQgkgMgZAAQgxAAgaAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAmAAAegNIAAAXQgZANgqAAQg6AAggglg");
	this.shape_2061.setTransform(735.9,514.7,0.5,0.5);

	this.shape_2062 = new cjs.Shape();
	this.shape_2062.graphics.f("#000000").s().p("Ag/B8QgbgRgOghQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABBggAnQghAkg3ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2062.setTransform(715.5,514.7,0.5,0.5);

	this.shape_2063 = new cjs.Shape();
	this.shape_2063.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAdgmA3AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQgfAug6AAQg4AAgdgjgAhBgeQgXAeAAA7QAABzBZAAQAuAAAWgaQAUgaABg+IAAgEQgBg+gUgcQgWgbgvAAQgqAAgXAfg");
	this.shape_2063.setTransform(700,511.9,0.5,0.5);

	this.shape_2064 = new cjs.Shape();
	this.shape_2064.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_2064.setTransform(678.2,511.9,0.5,0.5);

	this.shape_2065 = new cjs.Shape();
	this.shape_2065.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_2065.setTransform(668.2,511.8,0.5,0.5);

	this.shape_2066 = new cjs.Shape();
	this.shape_2066.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAvAAAXgYQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAAAhjg");
	this.shape_2066.setTransform(657.7,514.8,0.5,0.5);

	this.shape_2067 = new cjs.Shape();
	this.shape_2067.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAmAABAQAABBghAnQgfAkg4ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2067.setTransform(642.8,514.7,0.5,0.5);

	this.shape_2068 = new cjs.Shape();
	this.shape_2068.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgQAShHIAqiaIAZAAIhKENg");
	this.shape_2068.setTransform(626.1,514.7,0.5,0.5);

	this.shape_2069 = new cjs.Shape();
	this.shape_2069.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAcAhgBA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_2069.setTransform(603.2,514.7,0.5,0.5);

	this.shape_2070 = new cjs.Shape();
	this.shape_2070.graphics.f("#000000").s().p("ABdC2IhPkYQgLgigDgXQgGAegGAUQgOA2hCDpIgVAAIhllrIAbAAIBVFDQAGghAUhGIA+jcIAbAAIBJD8QAPA3ADAQQADgQAGgWIBMkdIAaAAIhlFrg");
	this.shape_2070.setTransform(584.8,512.4,0.5,0.5);

	this.shape_2071 = new cjs.Shape();
	this.shape_2071.graphics.f("#000000").s().p("AAMA/IgDgGQAKggALgeQANgjAKgVIAQAAQgHAWgIAnQgIAlgEAagAhBA/IgDgGQAFgUAPgpQANglAKgUIAQAAQgJAdgHAiQgIAigDAbg");
	this.shape_2071.setTransform(569.7,506.4,0.5,0.5);

	this.shape_2072 = new cjs.Shape();
	this.shape_2072.graphics.f("#000000").s().p("AgdA/QAUhJAIgzIAcAAIADAEQgTBCgYA2g");
	this.shape_2072.setTransform(556.1,521.6,0.5,0.5);

	this.shape_2073 = new cjs.Shape();
	this.shape_2073.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmAAAWgMQAVgNAAgXQAAgUgRgPQgQgOgmgNQgngNgRgLQgRgLgIgNQgIgOgBgSQAAgfAagRQAZgTAuABQArAAAnAQIgIAXQgogRgiAAQggAAgUALQgTALAAAUQgBAVAPAMQAPAMArARQAkAMASAKQAPALAKAOQAIANAAASQAAAlgcATQgbAUgyAAQg3AAgfgRg");
	this.shape_2073.setTransform(547.7,514.7,0.5,0.5);

	this.shape_2074 = new cjs.Shape();
	this.shape_2074.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgYAAIAAkNIAVAAIAEAlIABAAQAbgrBCAAQBdAAgBBjIAACwg");
	this.shape_2074.setTransform(534.4,514.6,0.5,0.5);

	this.shape_2075 = new cjs.Shape();
	this.shape_2075.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2075.setTransform(523.9,512.2,0.5,0.5);

	this.shape_2076 = new cjs.Shape();
	this.shape_2076.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_2076.setTransform(516,511.8,0.5,0.5);

	this.shape_2077 = new cjs.Shape();
	this.shape_2077.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2077.setTransform(504.3,513.2,0.5,0.5);

	this.shape_2078 = new cjs.Shape();
	this.shape_2078.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2078.setTransform(493,514.7,0.5,0.5);

	this.shape_2079 = new cjs.Shape();
	this.shape_2079.graphics.f("#000000").s().p("ABdC2IhQkYQgGgWgIgjQgDAUgIAeIhQEfIgWAAIhklrIAbAAIBVFDQAGghAThGIA+jcIAcAAIBJD8QANAuAFAZQACgQAGgWIBNkdIAaAAIhlFrg");
	this.shape_2079.setTransform(475.3,512.4,0.5,0.5);

	this.shape_2080 = new cjs.Shape();
	this.shape_2080.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmAAAWgMQAVgOAAgWQAAgUgRgPQgQgOgmgNQgpgOgPgKQgRgLgIgNQgJgOABgSQAAgfAZgRQAagTAsABQAtAAAnAQIgJAXQgogRgjAAQgeAAgVALQgTALgBAUQAAAVAPAMQAOAMAtARQAjAMASAKQARALAIAOQAIANAAASQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_2080.setTransform(451.3,514.7,0.5,0.5);

	this.shape_2081 = new cjs.Shape();
	this.shape_2081.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAIgNAKgaIANgkIhnkNIAZAAIA6CYQAaBEAGAYIABAAQALghAXg9IA6iWIAZAAIh4E5QgPAmgKANQgKAOgNAHQgNAHgUgBQgPAAgQgEg");
	this.shape_2081.setTransform(439.6,517.8,0.5,0.5);

	this.shape_2082 = new cjs.Shape();
	this.shape_2082.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2082.setTransform(426.5,514.7,0.5,0.5);

	this.shape_2083 = new cjs.Shape();
	this.shape_2083.graphics.f("#000000").s().p("AhvCtIAAgaQAnARA9AAQAtgBAZgUQAagUAAgiQAAgVgIgNQgKgOgTgLQgTgLgmgNQg3gSgVgWQgWgXAAglQAAgpAggZQAhgaAwAAQAzAAAuATIgJAWQgvgTgoAAQgnAAgYATQgZATAAAgQAAATAIAOQAHANARAKQAPAJApAQQArANAVAOQAWAOAKASQAJARABAZQgBAtghAbQgiAbg2AAQhDAAgjgOg");
	this.shape_2083.setTransform(413.3,512.4,0.5,0.5);

	this.shape_2084 = new cjs.Shape();
	this.shape_2084.graphics.f("#000000").s().p("AAKA/QAIgdAHghQAJglAEgZIAcAAIADAEQgJAigMAfQgMAfgKAYgAhEA/QAGgXAJgmQAKgtACgSIAdAAIADAEQgRBAgaA4g");
	this.shape_2084.setTransform(395.9,506.4,0.5,0.5);

	this.shape_2085 = new cjs.Shape();
	this.shape_2085.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_2085.setTransform(389,520.5,0.5,0.5);

	this.shape_2086 = new cjs.Shape();
	this.shape_2086.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2086.setTransform(383,511.7,0.5,0.5);

	this.shape_2087 = new cjs.Shape();
	this.shape_2087.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2087.setTransform(375.4,511.8,0.5,0.5);

	this.shape_2088 = new cjs.Shape();
	this.shape_2088.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAbAhAAA5IAAATIjBAAQABA4AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg2hbQgXAYgFAxICnAAQgBgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_2088.setTransform(365.6,514.7,0.5,0.5);

	this.shape_2089 = new cjs.Shape();
	this.shape_2089.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmAAAWgMQAVgOAAgWQAAgUgRgPQgQgOgmgNQgogNgQgLQgRgLgIgNQgIgOAAgSQgBgfAagRQAZgTAuABQAsAAAnAQIgJAXQgogRgiAAQggAAgUALQgTALAAAUQAAAVAOAMQAOAMAtARQAjAMASAKQARALAIAOQAIANAAASQAAAlgcATQgbAUgyAAQg3AAgfgRg");
	this.shape_2089.setTransform(352.5,514.7,0.5,0.5);

	this.shape_2090 = new cjs.Shape();
	this.shape_2090.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAJgNAJgaIANgkIhnkNIAaAAIA5CYQAZBEAIAYIAAAAQALghAYg9IA5iWIAZAAIh5E5QgNAmgLANQgKAOgNAHQgNAHgUgBQgOAAgRgEg");
	this.shape_2090.setTransform(340.8,517.8,0.5,0.5);

	this.shape_2091 = new cjs.Shape();
	this.shape_2091.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgSQgQgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2091.setTransform(323.8,514.6,0.5,0.5);

	this.shape_2092 = new cjs.Shape();
	this.shape_2092.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg4AAgdgjgAhBgeQgXAeABA7QAABzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_2092.setTransform(297.9,511.9,0.5,0.5);

	this.shape_2093 = new cjs.Shape();
	this.shape_2093.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA1AAQAvgBAdAiQAcAigBA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgXAJgUAEQgSADgZABQg5AAgiglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgnAAgWAag");
	this.shape_2093.setTransform(283.7,514.7,0.5,0.5);

	this.shape_2094 = new cjs.Shape();
	this.shape_2094.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQgBgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgoAagaQAagYAsAAQAZAAAPAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgJAKQgHAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgkAXg+AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg5igQgSATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgTgSgfAAQggAAgUATg");
	this.shape_2094.setTransform(270,517.6,0.5,0.5);

	this.shape_2095 = new cjs.Shape();
	this.shape_2095.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgcAAQgqAAgUgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2095.setTransform(256.1,514.7,0.5,0.5);

	this.shape_2096 = new cjs.Shape();
	this.shape_2096.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_2096.setTransform(242.4,514.6,0.5,0.5);

	this.shape_2097 = new cjs.Shape();
	this.shape_2097.graphics.f("#000000").s().p("AhPB4QgVgUAAglQAAgnAggWQAhgVA+gBIA0gCIAAgSQgBgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAVAXAAAxIAACzIgSAAIgFgqIgDAAQgVAagUALQgWAKgdAAQgoAAgWgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_2097.setTransform(227.6,514.7,0.5,0.5);

	this.shape_2098 = new cjs.Shape();
	this.shape_2098.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgRQgPgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgWAVgKQAUgLAZAAQBAAAARAwIABAAQAOgWAWgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2098.setTransform(210.1,514.6,0.5,0.5);

	this.shape_2099 = new cjs.Shape();
	this.shape_2099.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAggnA1AAQAvgBAcAiQAdAiAAA4IAAATIjCAAQAAA3AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgVAJgVAEQgRADgZABQg7AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgmAAgYAag");
	this.shape_2099.setTransform(185.2,514.7,0.5,0.5);

	this.shape_2100 = new cjs.Shape();
	this.shape_2100.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QAOAjAGAaIABAAQANgpAIgVIBGi2IAZAAIhoENg");
	this.shape_2100.setTransform(172.3,514.7,0.5,0.5);

	this.shape_2101 = new cjs.Shape();
	this.shape_2101.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2101.setTransform(159.2,514.7,0.5,0.5);

	this.shape_2102 = new cjs.Shape();
	this.shape_2102.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_2102.setTransform(145.5,511.8,0.5,0.5);

	this.shape_2103 = new cjs.Shape();
	this.shape_2103.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2103.setTransform(126.8,513.2,0.5,0.5);

	this.shape_2104 = new cjs.Shape();
	this.shape_2104.graphics.f("#000000").s().p("AgdA/QAHgXAJgmQAHgjAFgcIAcAAIADAEQgTBAgXA4g");
	this.shape_2104.setTransform(120.9,506.4,0.5,0.5);

	this.shape_2105 = new cjs.Shape();
	this.shape_2105.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgjAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_2105.setTransform(111.6,514.6,0.5,0.5);

	this.shape_2106 = new cjs.Shape();
	this.shape_2106.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2106.setTransform(96,511.9,0.5,0.5);

	this.shape_2107 = new cjs.Shape();
	this.shape_2107.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2107.setTransform(85.9,511.8,0.5,0.5);

	this.shape_2108 = new cjs.Shape();
	this.shape_2108.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_2108.setTransform(75.4,514.8,0.5,0.5);

	this.shape_2109 = new cjs.Shape();
	this.shape_2109.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2109.setTransform(60.5,514.7,0.5,0.5);

	this.shape_2110 = new cjs.Shape();
	this.shape_2110.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6ABQAiAAAhAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAmAAAegNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_2110.setTransform(47.3,514.7,0.5,0.5);

	this.shape_2111 = new cjs.Shape();
	this.shape_2111.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAvgBAdAiQAcAiAAA4IAAAUIjDAAQAAA2AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgWAJgVAEQgRADgaABQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_2111.setTransform(930.7,476.4,0.5,0.5);

	this.shape_2112 = new cjs.Shape();
	this.shape_2112.graphics.f("#000000").s().p("Ag0C4QgYgMgNgVIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAPgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_2112.setTransform(916.5,473.6,0.5,0.5);

	this.shape_2113 = new cjs.Shape();
	this.shape_2113.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokNIAZAAIA6CYQAcBMAFARIAAAAIBcj1IAZAAIh4E5QgPAogJALQgMAPgMAGQgNAHgTgBQgPAAgRgEg");
	this.shape_2113.setTransform(902.6,479.5,0.5,0.5);

	this.shape_2114 = new cjs.Shape();
	this.shape_2114.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2114.setTransform(889.6,476.4,0.5,0.5);

	this.shape_2115 = new cjs.Shape();
	this.shape_2115.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2115.setTransform(872.1,476.3,0.5,0.5);

	this.shape_2116 = new cjs.Shape();
	this.shape_2116.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2116.setTransform(850.1,476.3,0.5,0.5);

	this.shape_2117 = new cjs.Shape();
	this.shape_2117.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAgglQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2117.setTransform(836.7,476.4,0.5,0.5);

	this.shape_2118 = new cjs.Shape();
	this.shape_2118.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgTAAQgdAAgNARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2118.setTransform(819.7,473.5,0.5,0.5);

	this.shape_2119 = new cjs.Shape();
	this.shape_2119.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2119.setTransform(812.1,473.5,0.5,0.5);

	this.shape_2120 = new cjs.Shape();
	this.shape_2120.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAAUIjDAAQAAA2AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgXAKgUADQgRADgaABQg6AAghglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQglAAgZAag");
	this.shape_2120.setTransform(802.3,476.4,0.5,0.5);

	this.shape_2121 = new cjs.Shape();
	this.shape_2121.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnABAVgNQAVgOAAgWQAAgUgRgPQgQgOgmgNQgngNgRgLQgQgKgJgOQgIgNAAgTQAAgfAZgRQAagTAtABQArAAAoAQIgKAXQgngRgiAAQggAAgUALQgTALAAAUQAAAVAPAMQAOAMAsARQAlANAQAJQARAMAIANQAIAOAAARQAAAkgbAUQgcAUgyAAQg2AAgggRg");
	this.shape_2121.setTransform(789.2,476.4,0.5,0.5);

	this.shape_2122 = new cjs.Shape();
	this.shape_2122.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBDAHAaIAAAAIBcj1IAZAAIh4E5QgQAogJALQgLAPgMAGQgNAHgTgBQgPAAgRgEg");
	this.shape_2122.setTransform(777.5,479.5,0.5,0.5);

	this.shape_2123 = new cjs.Shape();
	this.shape_2123.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgSggAAQgqgBgUAXQgTAYAAAwIAACeIgZAAIAAi4QAAhEg+AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgWAVgKQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAXgMAbAAQAtAAAWAYQAWAYAAAzIAACwg");
	this.shape_2123.setTransform(760.5,476.3,0.5,0.5);

	this.shape_2124 = new cjs.Shape();
	this.shape_2124.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCghAmQgfAkg4ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2124.setTransform(735.1,476.4,0.5,0.5);

	this.shape_2125 = new cjs.Shape();
	this.shape_2125.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_2125.setTransform(719.6,473.6,0.5,0.5);

	this.shape_2126 = new cjs.Shape();
	this.shape_2126.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2126.setTransform(698.3,476.4,0.5,0.5);

	this.shape_2127 = new cjs.Shape();
	this.shape_2127.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_2127.setTransform(686.4,474.9,0.5,0.5);

	this.shape_2128 = new cjs.Shape();
	this.shape_2128.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmABAWgNQAVgOAAgWQAAgUgRgPQgQgOgngNQgmgNgRgLQgRgKgIgOQgIgOgBgSQAAgfAagRQAZgTAuABQArAAAnAQIgJAXQgngRgiAAQggAAgUALQgTALAAAUQgBAVAPAMQAOAMAsARQAlANARAJQAQALAJAOQAIAMAAATQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_2128.setTransform(669.7,476.4,0.5,0.5);

	this.shape_2129 = new cjs.Shape();
	this.shape_2129.graphics.f("#000000").s().p("AgSCYQgQgTgBgqIAAitIgnAAIAAgPIAngLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQgBAgAKAOQAMAOAXAAQAZAAAPgDIAAATQgRAHgXAAQgjgBgSgSg");
	this.shape_2129.setTransform(659.4,474.9,0.5,0.5);

	this.shape_2130 = new cjs.Shape();
	this.shape_2130.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAlAAQAvAAAXgYQAWgZAAg2IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_2130.setTransform(647.7,476.6,0.5,0.5);

	this.shape_2131 = new cjs.Shape();
	this.shape_2131.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQAAgcAQgSQASgTAegHQgNgFgHgJQgIgKABgMQgBgaAjgVQgYgKgMgVQgOgVAAgaQAAgoAagaQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgJAKQgHAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgcgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSghAAQgfAAgTATg");
	this.shape_2131.setTransform(633.6,479.4,0.5,0.5);

	this.shape_2132 = new cjs.Shape();
	this.shape_2132.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2132.setTransform(613.3,476.4,0.5,0.5);

	this.shape_2133 = new cjs.Shape();
	this.shape_2133.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2133.setTransform(598.8,473.5,0.5,0.5);

	this.shape_2134 = new cjs.Shape();
	this.shape_2134.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgXAAQgjgBgRgSg");
	this.shape_2134.setTransform(586.8,474.9,0.5,0.5);

	this.shape_2135 = new cjs.Shape();
	this.shape_2135.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2135.setTransform(568.1,473.6,0.5,0.5);

	this.shape_2136 = new cjs.Shape();
	this.shape_2136.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2136.setTransform(553.7,476.4,0.5,0.5);

	this.shape_2137 = new cjs.Shape();
	this.shape_2137.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_2137.setTransform(539.9,473.5,0.5,0.5);

	this.shape_2138 = new cjs.Shape();
	this.shape_2138.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AaAeQAZAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgSADQgSADgaABQg6AAggglgAg3hbQgWAYgFAxICnAAQAAgtgVgcQgUgbglABQgmAAgYAag");
	this.shape_2138.setTransform(518.7,476.4,0.5,0.5);

	this.shape_2139 = new cjs.Shape();
	this.shape_2139.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QANAjAHAaIABAAQAIgdAMghIBGi2IAaAAIhpENg");
	this.shape_2139.setTransform(505.9,476.4,0.5,0.5);

	this.shape_2140 = new cjs.Shape();
	this.shape_2140.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgqIgCAAQgWAagUALQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_2140.setTransform(492.8,476.4,0.5,0.5);

	this.shape_2141 = new cjs.Shape();
	this.shape_2141.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_2141.setTransform(479.1,473.5,0.5,0.5);

	this.shape_2142 = new cjs.Shape();
	this.shape_2142.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2142.setTransform(460.4,474.9,0.5,0.5);

	this.shape_2143 = new cjs.Shape();
	this.shape_2143.graphics.f("#000000").s().p("AgdA/QAIgZAHgkQAIggAFgfIAcAAIADAEQgTBCgYA2g");
	this.shape_2143.setTransform(454.4,468.1,0.5,0.5);

	this.shape_2144 = new cjs.Shape();
	this.shape_2144.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2144.setTransform(445.1,476.3,0.5,0.5);

	this.shape_2145 = new cjs.Shape();
	this.shape_2145.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2145.setTransform(429.6,473.6,0.5,0.5);

	this.shape_2146 = new cjs.Shape();
	this.shape_2146.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2146.setTransform(419.5,473.5,0.5,0.5);

	this.shape_2147 = new cjs.Shape();
	this.shape_2147.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAYgZAAg2IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_2147.setTransform(409,476.6,0.5,0.5);

	this.shape_2148 = new cjs.Shape();
	this.shape_2148.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2148.setTransform(394.1,476.4,0.5,0.5);

	this.shape_2149 = new cjs.Shape();
	this.shape_2149.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgYAAIhNkNIAaAAIArCcQAQA/AEAWIABAAQANg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQACgSAShFIApiaIAYAAIhJENg");
	this.shape_2149.setTransform(377.4,476.4,0.5,0.5);

	this.shape_2150 = new cjs.Shape();
	this.shape_2150.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2150.setTransform(358.3,474.1,0.5,0.5);

	this.shape_2151 = new cjs.Shape();
	this.shape_2151.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_2151.setTransform(345.6,473.5,0.5,0.5);

	this.shape_2152 = new cjs.Shape();
	this.shape_2152.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAcAigBA4IAAAUIjBAAQABA3AYAeQAaAdAvAAQAWAAASgDQAQgDAcgLIAAAXQgWAKgUADQgSADgYABQg7AAghglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgmAAgYAag");
	this.shape_2152.setTransform(335.8,476.4,0.5,0.5);

	this.shape_2153 = new cjs.Shape();
	this.shape_2153.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAcAhgBA5IAAAUIjCAAQACA3AYAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgVgbgjABQgnAAgXAag");
	this.shape_2153.setTransform(321.8,476.4,0.5,0.5);

	this.shape_2154 = new cjs.Shape();
	this.shape_2154.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAVAGIgFAWQgUgGgUAAQgcAAgMARQgMAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2154.setTransform(311.8,473.5,0.5,0.5);

	this.shape_2155 = new cjs.Shape();
	this.shape_2155.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2155.setTransform(297.3,474.1,0.5,0.5);

	this.shape_2156 = new cjs.Shape();
	this.shape_2156.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2156.setTransform(283,474.9,0.5,0.5);

	this.shape_2157 = new cjs.Shape();
	this.shape_2157.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2157.setTransform(271.7,476.4,0.5,0.5);

	this.shape_2158 = new cjs.Shape();
	this.shape_2158.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2158.setTransform(257.9,473.5,0.5,0.5);

	this.shape_2159 = new cjs.Shape();
	this.shape_2159.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_2159.setTransform(245.9,474.9,0.5,0.5);

	this.shape_2160 = new cjs.Shape();
	this.shape_2160.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAnABAVgNQAVgNgBgXQAAgUgQgPQgQgOgngNQgmgNgRgLQgRgLgIgNQgJgOAAgSQABgfAZgRQAZgTAuABQArAAAnAQIgJAXQgngRgiAAQgfAAgVALQgUALABAUQgBAVAQAMQAOAMArARQAlANAQAJQARAKAJAPQAIAMAAATQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_2160.setTransform(229.2,476.4,0.5,0.5);

	this.shape_2161 = new cjs.Shape();
	this.shape_2161.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQAAgdARgRQARgTAegHQgNgFgHgJQgHgJAAgNQAAgaAjgVQgYgKgNgVQgNgVgBgaQABgpAZgZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgPAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgQgLQgQgLgmAAIgsAAQhKAAAAA7gAg4igQgSASAAAiQAAAfATARQASASAgAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSggAAQghAAgSATg");
	this.shape_2161.setTransform(216.7,479.4,0.5,0.5);

	this.shape_2162 = new cjs.Shape();
	this.shape_2162.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_2162.setTransform(202.5,476.3,0.5,0.5);

	this.shape_2163 = new cjs.Shape();
	this.shape_2163.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_2163.setTransform(192.1,474,0.5,0.5);

	this.shape_2164 = new cjs.Shape();
	this.shape_2164.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2164.setTransform(181.7,473.5,0.5,0.5);

	this.shape_2165 = new cjs.Shape();
	this.shape_2165.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_2165.setTransform(169.7,474.9,0.5,0.5);

	this.shape_2166 = new cjs.Shape();
	this.shape_2166.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgSADQgSADgaABQg6AAggglgAg2hbQgYAYgEAxICnAAQAAgtgVgcQgUgbglABQgmAAgXAag");
	this.shape_2166.setTransform(152,476.4,0.5,0.5);

	this.shape_2167 = new cjs.Shape();
	this.shape_2167.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2167.setTransform(140.9,476.3,0.5,0.5);

	this.shape_2168 = new cjs.Shape();
	this.shape_2168.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2168.setTransform(127.8,476.4,0.5,0.5);

	this.shape_2169 = new cjs.Shape();
	this.shape_2169.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgTADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICnAAQAAgtgVgcQgUgbglABQglAAgZAag");
	this.shape_2169.setTransform(107.9,476.4,0.5,0.5);

	this.shape_2170 = new cjs.Shape();
	this.shape_2170.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2170.setTransform(96.8,476.3,0.5,0.5);

	this.shape_2171 = new cjs.Shape();
	this.shape_2171.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2171.setTransform(84,476.4,0.5,0.5);

	this.shape_2172 = new cjs.Shape();
	this.shape_2172.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2172.setTransform(69.5,473.5,0.5,0.5);

	this.shape_2173 = new cjs.Shape();
	this.shape_2173.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_2173.setTransform(55.3,474.1,0.5,0.5);

	this.shape_2174 = new cjs.Shape();
	this.shape_2174.graphics.f("#000000").s().p("AANA/IgDgGQAIgdAMghQAJgZAOgfIAQAAQgHAWgIAnQgIAlgEAagAhBA/IgDgGQAJggALgdQANgkAKgVIAQAAQgJAdgHAiQgIAigDAbg");
	this.shape_2174.setTransform(44.8,468.1,0.5,0.5);

	this.shape_2175 = new cjs.Shape();
	this.shape_2175.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_2175.setTransform(653.5,405.7,0.5,0.5);

	this.shape_2176 = new cjs.Shape();
	this.shape_2176.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAIgGAJgNQAIgNAKgaIANgkIhnkNIAaAAIA5CYQAZBDAIAaIAAAAQALgiAYg9IA5iWIAZAAIh5E5QgOAmgKANQgKAOgOAHQgMAHgUgBQgOAAgRgEg");
	this.shape_2176.setTransform(644.6,403,0.5,0.5);

	this.shape_2177 = new cjs.Shape();
	this.shape_2177.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAtIAACVg");
	this.shape_2177.setTransform(634.7,399.8,0.5,0.5);

	this.shape_2178 = new cjs.Shape();
	this.shape_2178.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2178.setTransform(626,397,0.5,0.5);

	this.shape_2179 = new cjs.Shape();
	this.shape_2179.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2179.setTransform(616.1,399.9,0.5,0.5);

	this.shape_2180 = new cjs.Shape();
	this.shape_2180.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_2180.setTransform(599.9,399.9,0.5,0.5);

	this.shape_2181 = new cjs.Shape();
	this.shape_2181.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAggmQAggnA2AAQAvgBAcAiQAcAhgBA5IAAAUIjCAAQABA3AZAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgSADgZABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_2181.setTransform(583.7,399.9,0.5,0.5);

	this.shape_2182 = new cjs.Shape();
	this.shape_2182.graphics.f("#000000").s().p("AgwDwIAAgVQAQAEAQAAQAlABAAgtIAAlFIAYAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAPAAQAJAAAEAGQAEAHAAALQAAALgEAHQgFAGgIAAQgPAAAAgYg");
	this.shape_2182.setTransform(572.1,400.5,0.5,0.5);

	this.shape_2183 = new cjs.Shape();
	this.shape_2183.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2183.setTransform(561.3,397,0.5,0.5);

	this.shape_2184 = new cjs.Shape();
	this.shape_2184.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAgglQAhglA3AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2184.setTransform(549.1,399.9,0.5,0.5);

	this.shape_2185 = new cjs.Shape();
	this.shape_2185.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAmABAWgNQAVgNAAgXQAAgUgRgPQgQgOgngNQgmgNgRgLQgRgKgIgOQgIgOgBgSQAAgfAagRQAZgTAuABQArAAAnAQIgJAXQgngRgiAAQggAAgUALQgTALAAAUQgBAVAPAMQAOAMAsARQAlANARAJQAPAKAKAPQAIAMAAATQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_2185.setTransform(529,399.9,0.5,0.5);

	this.shape_2186 = new cjs.Shape();
	this.shape_2186.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AaAeQAZAdAvAAQAWAAATgDQAPgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_2186.setTransform(516.2,399.9,0.5,0.5);

	this.shape_2187 = new cjs.Shape();
	this.shape_2187.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6ABQAiAAAhAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAmAAAegNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_2187.setTransform(503.4,399.9,0.5,0.5);

	this.shape_2188 = new cjs.Shape();
	this.shape_2188.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAAUIjDAAQAAA2AbAfQAZAdAuAAQAYAAARgDQAPgCAdgMIAAAXQgWAJgTAEQgTADgZABQg5AAghglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQglAAgZAag");
	this.shape_2188.setTransform(490.1,399.9,0.5,0.5);

	this.shape_2189 = new cjs.Shape();
	this.shape_2189.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_2189.setTransform(480.2,397.5,0.5,0.5);

	this.shape_2190 = new cjs.Shape();
	this.shape_2190.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AVAbQAWAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_2190.setTransform(470.1,402.9,0.5,0.5);

	this.shape_2191 = new cjs.Shape();
	this.shape_2191.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2191.setTransform(447.5,397.1,0.5,0.5);

	this.shape_2192 = new cjs.Shape();
	this.shape_2192.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgjAAQgwAAgWAYQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_2192.setTransform(432.9,399.8,0.5,0.5);

	this.shape_2193 = new cjs.Shape();
	this.shape_2193.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2193.setTransform(422.4,397.5,0.5,0.5);

	this.shape_2194 = new cjs.Shape();
	this.shape_2194.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_2194.setTransform(414.5,397,0.5,0.5);

	this.shape_2195 = new cjs.Shape();
	this.shape_2195.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_2195.setTransform(403.1,399.8,0.5,0.5);

	this.shape_2196 = new cjs.Shape();
	this.shape_2196.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2196.setTransform(391.8,399.9,0.5,0.5);

	this.shape_2197 = new cjs.Shape();
	this.shape_2197.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_2197.setTransform(381.4,399.8,0.5,0.5);

	this.shape_2198 = new cjs.Shape();
	this.shape_2198.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgxATgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2198.setTransform(374.3,397,0.5,0.5);

	this.shape_2199 = new cjs.Shape();
	this.shape_2199.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2199.setTransform(362.1,399.9,0.5,0.5);

	this.shape_2200 = new cjs.Shape();
	this.shape_2200.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_2200.setTransform(350.6,399.8,0.5,0.5);

	this.shape_2201 = new cjs.Shape();
	this.shape_2201.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjCAAQAAA2AaAfQAaAdAuAAQAYAAARgDQARgCAcgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgVgbgjABQgnAAgXAag");
	this.shape_2201.setTransform(339.5,399.9,0.5,0.5);

	this.shape_2202 = new cjs.Shape();
	this.shape_2202.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_2202.setTransform(325,399.8,0.5,0.5);

	this.shape_2203 = new cjs.Shape();
	this.shape_2203.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_2203.setTransform(310,399.9,0.5,0.5);

	this.shape_2204 = new cjs.Shape();
	this.shape_2204.graphics.f("#000000").s().p("AhdC0QgdgTAAgkQAAgcARgSQASgTAegHQgNgFgHgJQgIgKABgMQgBgaAjgVQgYgKgNgVQgNgVAAgaQAAgoAagaQAagYArAAQAZAAAQAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAKAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXARQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgcgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAgBA7gAg4igQgTATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgTgRQgSgSghAAQgfAAgTATg");
	this.shape_2204.setTransform(289.2,402.9,0.5,0.5);

	this.shape_2205 = new cjs.Shape();
	this.shape_2205.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkAAQgvAAgYAYQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_2205.setTransform(275.1,399.8,0.5,0.5);

	this.shape_2206 = new cjs.Shape();
	this.shape_2206.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_2206.setTransform(264.6,397.5,0.5,0.5);

	this.shape_2207 = new cjs.Shape();
	this.shape_2207.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_2207.setTransform(256.7,397,0.5,0.5);

	this.shape_2208 = new cjs.Shape();
	this.shape_2208.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2208.setTransform(242.2,399.9,0.5,0.5);

	this.shape_2209 = new cjs.Shape();
	this.shape_2209.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2209.setTransform(224.7,399.8,0.5,0.5);

	this.shape_2210 = new cjs.Shape();
	this.shape_2210.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgSggAAQgqgBgUAXQgTAYAAAwIAACeIgZAAIAAi4QAAhEg+AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgWAVgKQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2210.setTransform(195.6,399.8,0.5,0.5);

	this.shape_2211 = new cjs.Shape();
	this.shape_2211.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2211.setTransform(176.8,399.9,0.5,0.5);

	this.shape_2212 = new cjs.Shape();
	this.shape_2212.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2212.setTransform(165.2,399.8,0.5,0.5);

	this.shape_2213 = new cjs.Shape();
	this.shape_2213.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2213.setTransform(156.4,397,0.5,0.5);

	this.shape_2214 = new cjs.Shape();
	this.shape_2214.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnABAVgNQAVgOAAgWQAAgUgRgPQgQgOgmgNQgngNgRgLQgQgKgJgOQgIgNAAgTQAAgfAZgRQAagTAtABQArAAAoAQIgKAXQgngRgiAAQggAAgUALQgTALAAAUQAAAVAPAMQAOAMAsARQAlANAQAJQARAMAIANQAIAOAAARQAAAkgbAUQgcAUgyAAQg2AAgggRg");
	this.shape_2214.setTransform(139.1,399.9,0.5,0.5);

	this.shape_2215 = new cjs.Shape();
	this.shape_2215.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAbAiQAcAiAAA4IAAAUIjCAAQAAA2AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgugUgbQgVgbgjABQgnAAgXAag");
	this.shape_2215.setTransform(126.2,399.9,0.5,0.5);

	this.shape_2216 = new cjs.Shape();
	this.shape_2216.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAOAjAHAaIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_2216.setTransform(113.4,399.9,0.5,0.5);

	this.shape_2217 = new cjs.Shape();
	this.shape_2217.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_2217.setTransform(104.7,397.5,0.5,0.5);

	this.shape_2218 = new cjs.Shape();
	this.shape_2218.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2218.setTransform(98.9,397,0.5,0.5);

	this.shape_2219 = new cjs.Shape();
	this.shape_2219.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2219.setTransform(81.9,399.8,0.5,0.5);

	this.shape_2220 = new cjs.Shape();
	this.shape_2220.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgZAAIhMkNIAaAAIArCcQAQA/AEAWIABAAQANg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQACgSAShFIApiaIAYAAIhJENg");
	this.shape_2220.setTransform(65.1,399.9,0.5,0.5);

	this.shape_2221 = new cjs.Shape();
	this.shape_2221.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_2221.setTransform(48.4,399.9,0.5,0.5);

	this.shape_2222 = new cjs.Shape();
	this.shape_2222.graphics.f("#000000").s().p("AhGCKIAAkNIAUAAIACAwIACAAQARgeATgMQARgMAcAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2222.setTransform(975.3,361.6,0.5,0.5);

	this.shape_2223 = new cjs.Shape();
	this.shape_2223.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2223.setTransform(966.6,359.2,0.5,0.5);

	this.shape_2224 = new cjs.Shape();
	this.shape_2224.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjBAAQAAA2AaAfQAZAdAvAAQAXAAARgDQAPgCAegMIAAAXQgWAJgVAEQgRADgZABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgXAag");
	this.shape_2224.setTransform(956.7,361.7,0.5,0.5);

	this.shape_2225 = new cjs.Shape();
	this.shape_2225.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_2225.setTransform(942.2,358.8,0.5,0.5);

	this.shape_2226 = new cjs.Shape();
	this.shape_2226.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgnAAIAAgPIAngLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQABAgAJAOQAMAOAXAAQAZAAAQgDIAAATQgRAHgZAAQgigBgSgSg");
	this.shape_2226.setTransform(930.2,360.2,0.5,0.5);

	this.shape_2227 = new cjs.Shape();
	this.shape_2227.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAcAAAXALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2227.setTransform(911.5,358.9,0.5,0.5);

	this.shape_2228 = new cjs.Shape();
	this.shape_2228.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAcgrBCAAQBcAAgBBjIAACwg");
	this.shape_2228.setTransform(896.8,361.6,0.5,0.5);

	this.shape_2229 = new cjs.Shape();
	this.shape_2229.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2229.setTransform(882,361.7,0.5,0.5);

	this.shape_2230 = new cjs.Shape();
	this.shape_2230.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2230.setTransform(865,361.6,0.5,0.5);

	this.shape_2231 = new cjs.Shape();
	this.shape_2231.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2231.setTransform(852.2,361.7,0.5,0.5);

	this.shape_2232 = new cjs.Shape();
	this.shape_2232.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2232.setTransform(837.7,358.8,0.5,0.5);

	this.shape_2233 = new cjs.Shape();
	this.shape_2233.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQALAOAXAAQAZAAAQgDIAAATQgSAHgXAAQgjgBgRgSg");
	this.shape_2233.setTransform(825.7,360.2,0.5,0.5);

	this.shape_2234 = new cjs.Shape();
	this.shape_2234.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2234.setTransform(814.1,361.7,0.5,0.5);

	this.shape_2235 = new cjs.Shape();
	this.shape_2235.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2235.setTransform(799.2,361.6,0.5,0.5);

	this.shape_2236 = new cjs.Shape();
	this.shape_2236.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2236.setTransform(784.4,361.7,0.5,0.5);

	this.shape_2237 = new cjs.Shape();
	this.shape_2237.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAvgBAdAiQAbAiABA4IAAAUIjDAAQAAA2AaAfQAaAdAuAAQAYAAARgDQAPgCAegMIAAAXQgWAJgVAEQgRADgaABQg5AAgiglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgnAAgWAag");
	this.shape_2237.setTransform(764.5,361.7,0.5,0.5);

	this.shape_2238 = new cjs.Shape();
	this.shape_2238.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_2238.setTransform(750.1,361.6,0.5,0.5);

	this.shape_2239 = new cjs.Shape();
	this.shape_2239.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCghAmQgfAkg4ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2239.setTransform(735,361.7,0.5,0.5);

	this.shape_2240 = new cjs.Shape();
	this.shape_2240.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2240.setTransform(716.4,360.2,0.5,0.5);

	this.shape_2241 = new cjs.Shape();
	this.shape_2241.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAtIAACVg");
	this.shape_2241.setTransform(708.3,361.6,0.5,0.5);

	this.shape_2242 = new cjs.Shape();
	this.shape_2242.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2242.setTransform(694.9,361.7,0.5,0.5);

	this.shape_2243 = new cjs.Shape();
	this.shape_2243.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_2243.setTransform(680.3,364.6,0.5,0.5);

	this.shape_2244 = new cjs.Shape();
	this.shape_2244.graphics.f("#000000").s().p("AhyDHIAAmIIAVAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjABBGQAABCgfAkQgeAlg1AAQg9AAgcgvIgCAAIACCkgAhDiWQgVAbAAA6IAAAIQAAA/AUAbQAXAbAuAAQApAAAXgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_2244.setTransform(665.1,364.6,0.5,0.5);

	this.shape_2245 = new cjs.Shape();
	this.shape_2245.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgCAAQgZAqhDAAQhcAAAAhjg");
	this.shape_2245.setTransform(649.5,361.8,0.5,0.5);

	this.shape_2246 = new cjs.Shape();
	this.shape_2246.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAnABAVgNQAVgOAAgWQAAgUgRgPQgQgOgmgNQgmgNgSgLQgRgKgIgOQgJgOAAgSQAAgfAagRQAagTAsABQAsAAAnAQIgJAXQgngRgjAAQgfAAgUALQgUALAAAUQABAVAPAMQANAMAsARQAkAMASAKQARAMAIANQAIAMAAATQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_2246.setTransform(636.1,361.7,0.5,0.5);

	this.shape_2247 = new cjs.Shape();
	this.shape_2247.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_2247.setTransform(616.1,361.7,0.5,0.5);

	this.shape_2248 = new cjs.Shape();
	this.shape_2248.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_2248.setTransform(604.2,360.2,0.5,0.5);

	this.shape_2249 = new cjs.Shape();
	this.shape_2249.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgXAKgUADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICnAAQAAgtgVgcQgUgbglABQglAAgZAag");
	this.shape_2249.setTransform(586.5,361.7,0.5,0.5);

	this.shape_2250 = new cjs.Shape();
	this.shape_2250.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2250.setTransform(576.6,358.8,0.5,0.5);

	this.shape_2251 = new cjs.Shape();
	this.shape_2251.graphics.f("#000000").s().p("Ag0C4QgYgMgNgVIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAPgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_2251.setTransform(566.5,358.9,0.5,0.5);

	this.shape_2252 = new cjs.Shape();
	this.shape_2252.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2252.setTransform(551.3,361.7,0.5,0.5);

	this.shape_2253 = new cjs.Shape();
	this.shape_2253.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AfgnQAhgnA1AAQAvgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAuAAQAYAAASgDQAPgCAdgMIAAAXQgYAKgTADQgRADgaABQg6AAghglgAg3hbQgXAYgEAxICmAAQABgtgVgcQgVgbgjABQgmAAgZAag");
	this.shape_2253.setTransform(531.4,361.7,0.5,0.5);

	this.shape_2254 = new cjs.Shape();
	this.shape_2254.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2254.setTransform(520.3,361.6,0.5,0.5);

	this.shape_2255 = new cjs.Shape();
	this.shape_2255.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AaAeQAZAdAvAAQAXAAARgDQAPgCAegMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgXAag");
	this.shape_2255.setTransform(507.5,361.7,0.5,0.5);

	this.shape_2256 = new cjs.Shape();
	this.shape_2256.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_2256.setTransform(491.3,361.7,0.5,0.5);

	this.shape_2257 = new cjs.Shape();
	this.shape_2257.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2257.setTransform(467.4,358.9,0.5,0.5);

	this.shape_2258 = new cjs.Shape();
	this.shape_2258.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_2258.setTransform(452.8,361.6,0.5,0.5);

	this.shape_2259 = new cjs.Shape();
	this.shape_2259.graphics.f("#000000").s().p("AhPB4QgVgUAAglQgBgnAigWQAfgVA/gBIA0gCIAAgSQgBgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAWAXQAXAXgBAxIAACzIgSAAIgFgqIgCAAQgWAagUALQgWAKgdAAQgoAAgWgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_2259.setTransform(438,361.7,0.5,0.5);

	this.shape_2260 = new cjs.Shape();
	this.shape_2260.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQABA3AaAeQAZAdAvAAQAWAAATgDQAPgCAdgMIAAAXQgYAKgSADQgTADgYABQg6AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_2260.setTransform(418.1,361.7,0.5,0.5);

	this.shape_2261 = new cjs.Shape();
	this.shape_2261.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAlAGAYIABAAQAJggALgeIBHi2IAZAAIhpENg");
	this.shape_2261.setTransform(405.2,361.7,0.5,0.5);

	this.shape_2262 = new cjs.Shape();
	this.shape_2262.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2262.setTransform(396.5,359.2,0.5,0.5);

	this.shape_2263 = new cjs.Shape();
	this.shape_2263.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2263.setTransform(389.2,360.2,0.5,0.5);

	this.shape_2264 = new cjs.Shape();
	this.shape_2264.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2264.setTransform(377.9,361.7,0.5,0.5);

	this.shape_2265 = new cjs.Shape();
	this.shape_2265.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2265.setTransform(364.6,361.7,0.5,0.5);

	this.shape_2266 = new cjs.Shape();
	this.shape_2266.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2266.setTransform(353.5,361.6,0.5,0.5);

	this.shape_2267 = new cjs.Shape();
	this.shape_2267.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQAAhCAigmQAjgmA6ABQAiAAAiAMIgIAWQgjgMgaAAQgwAAgaAfQgZAfgBA4QABA3AZAfQAZAfAuAAQAlAAAggNIAAAXQgaANgrAAQg5AAggglg");
	this.shape_2267.setTransform(341.9,361.7,0.5,0.5);

	this.shape_2268 = new cjs.Shape();
	this.shape_2268.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgUgbglABQglAAgZAag");
	this.shape_2268.setTransform(321.9,361.7,0.5,0.5);

	this.shape_2269 = new cjs.Shape();
	this.shape_2269.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAOgYAXgMQAWgMAeAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_2269.setTransform(307.7,358.9,0.5,0.5);

	this.shape_2270 = new cjs.Shape();
	this.shape_2270.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCghAmQgfAkg4ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2270.setTransform(285.6,361.7,0.5,0.5);

	this.shape_2271 = new cjs.Shape();
	this.shape_2271.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAJAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2271.setTransform(273.7,360.2,0.5,0.5);

	this.shape_2272 = new cjs.Shape();
	this.shape_2272.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjCAAQABA3AZAeQAaAdAuAAQAYAAASgDQAQgDAcgLIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgVgbgjABQgnAAgXAag");
	this.shape_2272.setTransform(256,361.7,0.5,0.5);

	this.shape_2273 = new cjs.Shape();
	this.shape_2273.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgTADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICmAAQABgtgVgcQgUgbglABQglAAgZAag");
	this.shape_2273.setTransform(242,361.7,0.5,0.5);

	this.shape_2274 = new cjs.Shape();
	this.shape_2274.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2274.setTransform(230.9,361.6,0.5,0.5);

	this.shape_2275 = new cjs.Shape();
	this.shape_2275.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAYAAAVAGIgGAWQgUgGgTAAQgeAAgMARQgKAQAAAoIAAAZIA+AAIAAAVIg+AAIAAD4g");
	this.shape_2275.setTransform(222.1,358.7,0.5,0.5);

	this.shape_2276 = new cjs.Shape();
	this.shape_2276.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2276.setTransform(206.4,360.2,0.5,0.5);

	this.shape_2277 = new cjs.Shape();
	this.shape_2277.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2277.setTransform(199.4,358.8,0.5,0.5);

	this.shape_2278 = new cjs.Shape();
	this.shape_2278.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2278.setTransform(189.5,361.7,0.5,0.5);

	this.shape_2279 = new cjs.Shape();
	this.shape_2279.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2279.setTransform(179.6,358.7,0.5,0.5);

	this.shape_2280 = new cjs.Shape();
	this.shape_2280.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBDAHAaIAAAAIBcj1IAZAAIh4E5QgQAogJALQgLAPgMAGQgNAHgTgBQgPAAgRgEg");
	this.shape_2280.setTransform(162.4,364.8,0.5,0.5);

	this.shape_2281 = new cjs.Shape();
	this.shape_2281.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAAUIjBAAQAAA2AaAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgVAJgUAEQgTADgYABQg7AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgmAAgYAag");
	this.shape_2281.setTransform(149.6,361.7,0.5,0.5);

	this.shape_2282 = new cjs.Shape();
	this.shape_2282.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_2282.setTransform(135.1,358.8,0.5,0.5);

	this.shape_2283 = new cjs.Shape();
	this.shape_2283.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAgAKAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2283.setTransform(123.1,360.2,0.5,0.5);

	this.shape_2284 = new cjs.Shape();
	this.shape_2284.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAiAAA4IAAAUIjBAAQAAA2AZAfQAaAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgWAJgUAEQgSADgYABQg7AAghglgAg2hbQgYAYgEAxICmAAQAAgugVgbQgUgbgkABQgnAAgWAag");
	this.shape_2284.setTransform(105.4,361.7,0.5,0.5);

	this.shape_2285 = new cjs.Shape();
	this.shape_2285.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQARgeASgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAcAAAtIAACVg");
	this.shape_2285.setTransform(94.3,361.6,0.5,0.5);

	this.shape_2286 = new cjs.Shape();
	this.shape_2286.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAAUIjCAAQAAA2AaAfQAZAdAvAAQAXAAARgDQAQgCAcgMIAAAXQgWAKgTADQgTADgYABQg6AAghglgAg3hbQgXAagEAvICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_2286.setTransform(81.4,361.7,0.5,0.5);

	this.shape_2287 = new cjs.Shape();
	this.shape_2287.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_2287.setTransform(67,358.8,0.5,0.5);

	this.shape_2288 = new cjs.Shape();
	this.shape_2288.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA3AFAeIABAAQAPg7AHgSIA4ikIAVAAIA1CjQATBAADAOIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_2288.setTransform(50.2,361.7,0.5,0.5);

	this.shape_2289 = new cjs.Shape();
	this.shape_2289.graphics.f("#000000").s().p("AgSCYQgQgTgBgqIAAitIgnAAIAAgPIAngLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQgBAgAKAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgXAAQgjgBgSgSg");
	this.shape_2289.setTransform(996.7,321.9,0.5,0.5);

	this.shape_2290 = new cjs.Shape();
	this.shape_2290.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgSgjAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2290.setTransform(985.1,323.3,0.5,0.5);

	this.shape_2291 = new cjs.Shape();
	this.shape_2291.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAbAiABA4IAAAUIjDAAQABA3AZAeQAaAdAuAAQAXAAATgDQAQgDAcgLIAAAXQgXAKgUADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICnAAQAAgtgVgcQgVgbgkABQgmAAgYAag");
	this.shape_2291.setTransform(970.6,323.4,0.5,0.5);

	this.shape_2292 = new cjs.Shape();
	this.shape_2292.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgSggAAQgqgBgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgWAVgKQAVgLAYAAQBAAAARAwIABAAQAOgWAWgOQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_2292.setTransform(952.4,323.3,0.5,0.5);

	this.shape_2293 = new cjs.Shape();
	this.shape_2293.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2293.setTransform(933.6,323.3,0.5,0.5);

	this.shape_2294 = new cjs.Shape();
	this.shape_2294.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAhglQAfglA4AAQA4gBAfAmQAgAmAABAQAABDggAlQghAkg3ABQgjgBgcgQgAhEhWQgZAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2294.setTransform(918.5,323.4,0.5,0.5);

	this.shape_2295 = new cjs.Shape();
	this.shape_2295.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgeATgMQARgMAcAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2295.setTransform(907,323.3,0.5,0.5);

	this.shape_2296 = new cjs.Shape();
	this.shape_2296.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2296.setTransform(898.3,321,0.5,0.5);

	this.shape_2297 = new cjs.Shape();
	this.shape_2297.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAaIABAAQAKghALgdIBGi2IAZAAIhoENg");
	this.shape_2297.setTransform(889.5,323.4,0.5,0.5);

	this.shape_2298 = new cjs.Shape();
	this.shape_2298.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2298.setTransform(876.2,323.3,0.5,0.5);

	this.shape_2299 = new cjs.Shape();
	this.shape_2299.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjBAAQABA3AZAeQAZAdAvAAQAWAAASgDQAQgDAcgLIAAAXQgWAKgUADQgSADgYABQg7AAghglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgUgbgkABQgmAAgYAag");
	this.shape_2299.setTransform(861.6,323.4,0.5,0.5);

	this.shape_2300 = new cjs.Shape();
	this.shape_2300.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_2300.setTransform(840.6,323.3,0.5,0.5);

	this.shape_2301 = new cjs.Shape();
	this.shape_2301.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2301.setTransform(825.8,323.4,0.5,0.5);

	this.shape_2302 = new cjs.Shape();
	this.shape_2302.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAgAKAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2302.setTransform(808.4,321.9,0.5,0.5);

	this.shape_2303 = new cjs.Shape();
	this.shape_2303.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2303.setTransform(801.4,320.5,0.5,0.5);

	this.shape_2304 = new cjs.Shape();
	this.shape_2304.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_2304.setTransform(795.7,321,0.5,0.5);

	this.shape_2305 = new cjs.Shape();
	this.shape_2305.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAwAAAWgYQAYgZAAg2IAAiVIAXAAIAAEOIgUAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_2305.setTransform(785.2,323.6,0.5,0.5);

	this.shape_2306 = new cjs.Shape();
	this.shape_2306.graphics.f("#000000").s().p("Ag0C4QgYgMgNgVIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAPgYAXgMQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_2306.setTransform(770.5,320.6,0.5,0.5);

	this.shape_2307 = new cjs.Shape();
	this.shape_2307.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAIgMALgbIAMgkIhnkNIAZAAIA6CYQAZBDAIAaIABAAQAPguASgxIA6iWIAZAAIh4E5QgQApgJAKQgKAPgNAGQgNAHgUgBQgPAAgQgEg");
	this.shape_2307.setTransform(750.1,326.5,0.5,0.5);

	this.shape_2308 = new cjs.Shape();
	this.shape_2308.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAPgCAegMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2308.setTransform(737.2,323.4,0.5,0.5);

	this.shape_2309 = new cjs.Shape();
	this.shape_2309.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2309.setTransform(722.8,320.5,0.5,0.5);

	this.shape_2310 = new cjs.Shape();
	this.shape_2310.graphics.f("#000000").s().p("AgRCYQgSgTABgqIAAitIgpAAIAAgPIApgLIAMg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQALAOAXAAQAZAAAPgDIAAATQgSAHgWAAQgjgBgRgSg");
	this.shape_2310.setTransform(710.7,321.9,0.5,0.5);

	this.shape_2311 = new cjs.Shape();
	this.shape_2311.graphics.f("#000000").s().p("AgdA/QAUhJAIgzIAcAAIADAEQgTBCgYA2g");
	this.shape_2311.setTransform(696.9,330.4,0.5,0.5);

	this.shape_2312 = new cjs.Shape();
	this.shape_2312.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAKgQAIgXIANgkIhnkNIAaAAIA5CYQAZBDAIAaIAAAAQALgiAYg9IA5iWIAZAAIh5E5QgNAmgLANQgKAOgNAHQgNAHgUgBQgPAAgQgEg");
	this.shape_2312.setTransform(688.7,326.5,0.5,0.5);

	this.shape_2313 = new cjs.Shape();
	this.shape_2313.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2313.setTransform(679.9,320.5,0.5,0.5);

	this.shape_2314 = new cjs.Shape();
	this.shape_2314.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_2314.setTransform(674.2,320.5,0.5,0.5);

	this.shape_2315 = new cjs.Shape();
	this.shape_2315.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2315.setTransform(664.1,323.4,0.5,0.5);

	this.shape_2316 = new cjs.Shape();
	this.shape_2316.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6ABQAiAAAhAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAmAAAegNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_2316.setTransform(652,323.4,0.5,0.5);

	this.shape_2317 = new cjs.Shape();
	this.shape_2317.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2317.setTransform(642.8,321,0.5,0.5);

	this.shape_2318 = new cjs.Shape();
	this.shape_2318.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2318.setTransform(635.5,321.9,0.5,0.5);

	this.shape_2319 = new cjs.Shape();
	this.shape_2319.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhglA3AAQA3gBAgAmQAgAmAABAQAABDggAlQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAuAAAXgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2319.setTransform(623.9,323.4,0.5,0.5);

	this.shape_2320 = new cjs.Shape();
	this.shape_2320.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_2320.setTransform(613.6,321,0.5,0.5);

	this.shape_2321 = new cjs.Shape();
	this.shape_2321.graphics.f("#000000").s().p("Ag0C4QgXgMgOgVIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAQgYAVgMQAWgMAeAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAVAaAuAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_2321.setTransform(603.5,320.6,0.5,0.5);

	this.shape_2322 = new cjs.Shape();
	this.shape_2322.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgSggAAQgpgBgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAASAwIABAAQAMgWAXgOQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_2322.setTransform(584.3,323.3,0.5,0.5);

	this.shape_2323 = new cjs.Shape();
	this.shape_2323.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBDAHAaIAAAAIBcj1IAZAAIh4E5QgQAogJALQgLAPgMAGQgNAHgTgBQgPAAgRgEg");
	this.shape_2323.setTransform(567.1,326.5,0.5,0.5);

	this.shape_2324 = new cjs.Shape();
	this.shape_2324.graphics.f("#000000").s().p("AhvCtIAAgaQAnARA9AAQAsgBAagUQAagUAAgiQAAgUgIgOQgKgOgTgLQgTgLgmgNQg2gSgXgWQgVgXAAglQAAgpAggZQAggaAxAAQAzAAAuATIgJAWQgvgTgoAAQgnAAgYATQgZATAAAgQAAATAIAOQAIANAQAKQARALAnAOQArANAVAOQAWAOAKASQAJARABAZQgBAtghAbQgiAbg2AAQhDAAgjgOg");
	this.shape_2324.setTransform(554.4,321.1,0.5,0.5);

	this.shape_2325 = new cjs.Shape();
	this.shape_2325.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_2325.setTransform(537.7,329.2,0.5,0.5);

	this.shape_2326 = new cjs.Shape();
	this.shape_2326.graphics.f("#000000").s().p("AhMChQghgkAAhBQAAhAAfgnQAhgnA0AAQAwAAAcAhQAbAiAAA4IAAAUIjCAAQABA4AZAdQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSAEgYAAQg7AAggglgAg2giQgYAZgEAwICmAAQAAgtgUgcQgVgagkAAQgmAAgXAagAgbhzIAAgEQARgSASgZQASgWAHgNIAjAAIAAAEQgIAMgXAXQgVAVgZAWg");
	this.shape_2326.setTransform(527.7,320.6,0.5,0.5);

	this.shape_2327 = new cjs.Shape();
	this.shape_2327.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokNIAZAAIA6CYQAYA/AJAeIAAAAQAQguASgxIA6iWIAZAAIh4E5QgQApgJAKQgKAPgNAGQgNAHgUgBQgPAAgQgEg");
	this.shape_2327.setTransform(514.8,326.5,0.5,0.5);

	this.shape_2328 = new cjs.Shape();
	this.shape_2328.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2328.setTransform(506.1,321,0.5,0.5);

	this.shape_2329 = new cjs.Shape();
	this.shape_2329.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_2329.setTransform(495.8,323.3,0.5,0.5);

	this.shape_2330 = new cjs.Shape();
	this.shape_2330.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2330.setTransform(481,323.4,0.5,0.5);

	this.shape_2331 = new cjs.Shape();
	this.shape_2331.graphics.f("#000000").s().p("Ag8DdIAAgVQAVAEAQAAQA7AAAAhCIAAltIAZAAIAAFrQAABchUAAQgYAAgNgHg");
	this.shape_2331.setTransform(469.1,323.4,0.5,0.5);

	this.shape_2332 = new cjs.Shape();
	this.shape_2332.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAcAAAtIAACVg");
	this.shape_2332.setTransform(457.7,323.3,0.5,0.5);

	this.shape_2333 = new cjs.Shape();
	this.shape_2333.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjCAAQAAA2AaAfQAaAdAuAAQAYAAARgDQARgCAcgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgugUgbQgVgbgjABQgnAAgXAag");
	this.shape_2333.setTransform(444.8,323.4,0.5,0.5);

	this.shape_2334 = new cjs.Shape();
	this.shape_2334.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2334.setTransform(435,321,0.5,0.5);

	this.shape_2335 = new cjs.Shape();
	this.shape_2335.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2335.setTransform(429.2,320.5,0.5,0.5);

	this.shape_2336 = new cjs.Shape();
	this.shape_2336.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwgBAcAiQAbAiABA4IAAAUIjDAAQAAA2AaAfQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgTADQgSADgaABQg6AAggglgAg3hbQgXAagEAvICmAAQAAgugUgbQgVgbgkABQglAAgZAag");
	this.shape_2336.setTransform(419.3,323.4,0.5,0.5);

	this.shape_2337 = new cjs.Shape();
	this.shape_2337.graphics.f("#000000").s().p("AgSCYQgQgTgBgqIAAitIgnAAIAAgPIAngLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQgBAgAKAOQAMAOAXAAQAZAAAQgDIAAATQgTAHgWAAQgjgBgSgSg");
	this.shape_2337.setTransform(407.9,321.9,0.5,0.5);

	this.shape_2338 = new cjs.Shape();
	this.shape_2338.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgNhiIgzCBICBAAIgxiCQgHgRgIgaQgFAYgJAUg");
	this.shape_2338.setTransform(396.1,321.1,0.5,0.5);

	this.shape_2339 = new cjs.Shape();
	this.shape_2339.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2339.setTransform(377.4,321.9,0.5,0.5);

	this.shape_2340 = new cjs.Shape();
	this.shape_2340.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2340.setTransform(366.1,323.4,0.5,0.5);

	this.shape_2341 = new cjs.Shape();
	this.shape_2341.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AVAbQAWAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_2341.setTransform(346,326.4,0.5,0.5);

	this.shape_2342 = new cjs.Shape();
	this.shape_2342.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2342.setTransform(335.1,321,0.5,0.5);

	this.shape_2343 = new cjs.Shape();
	this.shape_2343.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2343.setTransform(324.8,320.5,0.5,0.5);

	this.shape_2344 = new cjs.Shape();
	this.shape_2344.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnABAVgNQAVgOAAgWQAAgUgRgPQgQgOgmgNQgngNgRgLQgQgKgJgOQgIgNAAgTQAAgfAZgRQAagTAtABQArAAAoAQIgKAXQgngRgiAAQggAAgUALQgTALAAAUQAAAVAPAMQAOAMAsARQAlANAQAJQARAMAIANQAIAOAAARQAAAkgbAUQgcAUgyAAQg2AAgggRg");
	this.shape_2344.setTransform(311.1,323.4,0.5,0.5);

	this.shape_2345 = new cjs.Shape();
	this.shape_2345.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAcAAAtIAACVg");
	this.shape_2345.setTransform(301.2,323.3,0.5,0.5);

	this.shape_2346 = new cjs.Shape();
	this.shape_2346.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwgBAcAiQAbAiAAA4IAAAUIjBAAQABA3AZAeQAZAdAvAAQAWAAASgDQARgDAbgLIAAAXQgWAKgTADQgTADgYABQg7AAggglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQglAAgZAag");
	this.shape_2346.setTransform(288.4,323.4,0.5,0.5);

	this.shape_2347 = new cjs.Shape();
	this.shape_2347.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgkAAQguAAgYAYQgWAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_2347.setTransform(273.9,323.3,0.5,0.5);

	this.shape_2348 = new cjs.Shape();
	this.shape_2348.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2348.setTransform(261.9,321.9,0.5,0.5);

	this.shape_2349 = new cjs.Shape();
	this.shape_2349.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2349.setTransform(253.7,323.3,0.5,0.5);

	this.shape_2350 = new cjs.Shape();
	this.shape_2350.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2350.setTransform(240.7,323.4,0.5,0.5);

	this.shape_2351 = new cjs.Shape();
	this.shape_2351.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgfAAg2QAAh4hWAAQguAAgXAag");
	this.shape_2351.setTransform(227.2,326.4,0.5,0.5);

	this.shape_2352 = new cjs.Shape();
	this.shape_2352.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_2352.setTransform(205.1,323.3,0.5,0.5);

	this.shape_2353 = new cjs.Shape();
	this.shape_2353.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_2353.setTransform(194.7,321,0.5,0.5);

	this.shape_2354 = new cjs.Shape();
	this.shape_2354.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgYAKgSADQgTADgYABQg7AAggglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgjABQgmAAgZAag");
	this.shape_2354.setTransform(178.1,323.4,0.5,0.5);

	this.shape_2355 = new cjs.Shape();
	this.shape_2355.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2355.setTransform(168.2,320.5,0.5,0.5);

	this.shape_2356 = new cjs.Shape();
	this.shape_2356.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_2356.setTransform(162.5,321,0.5,0.5);

	this.shape_2357 = new cjs.Shape();
	this.shape_2357.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_2357.setTransform(152.2,320.5,0.5,0.5);

	this.shape_2358 = new cjs.Shape();
	this.shape_2358.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAPg7AHgSIA4ikIAVAAIA1CjQARA4AFAWIABAAQADgSARhFIAqiaIAZAAIhKENg");
	this.shape_2358.setTransform(135.3,323.4,0.5,0.5);

	this.shape_2359 = new cjs.Shape();
	this.shape_2359.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA2AAQAcAAAXALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_2359.setTransform(111.5,320.6,0.5,0.5);

	this.shape_2360 = new cjs.Shape();
	this.shape_2360.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2360.setTransform(97.1,323.4,0.5,0.5);

	this.shape_2361 = new cjs.Shape();
	this.shape_2361.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2361.setTransform(83.8,323.4,0.5,0.5);

	this.shape_2362 = new cjs.Shape();
	this.shape_2362.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2362.setTransform(73.9,320.5,0.5,0.5);

	this.shape_2363 = new cjs.Shape();
	this.shape_2363.graphics.f("#000000").s().p("Ag/B8QgagSgPggQgPghAAgpQAAhBAhglQAgglA2AAQA5gBAfAmQAgAmAABAQAABCghAmQggAkg3ABQgkgBgbgQgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_2363.setTransform(57,323.4,0.5,0.5);

	this.shape_2364 = new cjs.Shape();
	this.shape_2364.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2364.setTransform(45,321.9,0.5,0.5);

	this.shape_2365 = new cjs.Shape();
	this.shape_2365.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_2365.setTransform(1004.6,282.4,0.5,0.5);

	this.shape_2366 = new cjs.Shape();
	this.shape_2366.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AZAeQAZAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgXAKgUADQgRADgZABQg7AAghglgAg2hbQgXAYgFAxICnAAQgBgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2366.setTransform(990.4,285.2,0.5,0.5);

	this.shape_2367 = new cjs.Shape();
	this.shape_2367.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2367.setTransform(978.9,283.7,0.5,0.5);

	this.shape_2368 = new cjs.Shape();
	this.shape_2368.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgjAAQgvAAgYAYQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_2368.setTransform(967.4,285.1,0.5,0.5);

	this.shape_2369 = new cjs.Shape();
	this.shape_2369.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2369.setTransform(952.6,285.2,0.5,0.5);

	this.shape_2370 = new cjs.Shape();
	this.shape_2370.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_2370.setTransform(937.1,285.2,0.5,0.5);

	this.shape_2371 = new cjs.Shape();
	this.shape_2371.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgNQAKgQAIgXIAOgkIhokNIAZAAIA6CYQAaBEAGAZIABAAQALgiAXg9IA6iWIAZAAIh4E5QgOAmgLANQgKAOgNAHQgNAHgUgBQgPAAgQgEg");
	this.shape_2371.setTransform(915.4,288.3,0.5,0.5);

	this.shape_2372 = new cjs.Shape();
	this.shape_2372.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAcAhgBA5IAAAUIjCAAQACA3AYAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgSADgZABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_2372.setTransform(902.5,285.2,0.5,0.5);

	this.shape_2373 = new cjs.Shape();
	this.shape_2373.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2373.setTransform(888.1,282.3,0.5,0.5);

	this.shape_2374 = new cjs.Shape();
	this.shape_2374.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2374.setTransform(876,283.7,0.5,0.5);

	this.shape_2375 = new cjs.Shape();
	this.shape_2375.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjCAAQABA3AZAeQAaAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgXAKgUADQgRADgaABQg6AAghglgAg3hbQgXAagEAvICmAAQABgtgVgcQgVgbgjABQgmAAgZAag");
	this.shape_2375.setTransform(858.3,285.2,0.5,0.5);

	this.shape_2376 = new cjs.Shape();
	this.shape_2376.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgyATgXQARgXAqAAQAXAAAVAGIgFAWQgUgGgUAAQgdAAgLARQgMAQAAAoIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2376.setTransform(848.4,282.2,0.5,0.5);

	this.shape_2377 = new cjs.Shape();
	this.shape_2377.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2377.setTransform(840.8,282.7,0.5,0.5);

	this.shape_2378 = new cjs.Shape();
	this.shape_2378.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2378.setTransform(835,282.3,0.5,0.5);

	this.shape_2379 = new cjs.Shape();
	this.shape_2379.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgTAAQgdAAgNARQgLARAAAnIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_2379.setTransform(822.6,282.2,0.5,0.5);

	this.shape_2380 = new cjs.Shape();
	this.shape_2380.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_2380.setTransform(810.4,285.2,0.5,0.5);

	this.shape_2381 = new cjs.Shape();
	this.shape_2381.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdgkQAegmA2AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgqAAgXAfg");
	this.shape_2381.setTransform(788.3,282.4,0.5,0.5);

	this.shape_2382 = new cjs.Shape();
	this.shape_2382.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2382.setTransform(773.7,285.1,0.5,0.5);

	this.shape_2383 = new cjs.Shape();
	this.shape_2383.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2383.setTransform(763.2,282.7,0.5,0.5);

	this.shape_2384 = new cjs.Shape();
	this.shape_2384.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_2384.setTransform(755.3,282.3,0.5,0.5);

	this.shape_2385 = new cjs.Shape();
	this.shape_2385.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAAUIjCAAQABA3AZAeQAZAdAvAAQAXAAARgDQARgDAbgLIAAAXQgWAKgTADQgTADgYABQg6AAghglgAg3hbQgXAagEAvICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_2385.setTransform(734.4,285.2,0.5,0.5);

	this.shape_2386 = new cjs.Shape();
	this.shape_2386.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_2386.setTransform(719.9,282.3,0.5,0.5);

	this.shape_2387 = new cjs.Shape();
	this.shape_2387.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAfAKAPQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2387.setTransform(707.9,283.7,0.5,0.5);

	this.shape_2388 = new cjs.Shape();
	this.shape_2388.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAiAAA4IAAAUIjBAAQAAA2AZAfQAaAdAvAAQAXAAARgDQAQgCAcgMIAAAXQgWAKgUADQgSADgYABQg7AAghglgAg2hbQgYAagEAvICmAAQAAgugUgbQgVgbgjABQgmAAgYAag");
	this.shape_2388.setTransform(690.2,285.2,0.5,0.5);

	this.shape_2389 = new cjs.Shape();
	this.shape_2389.graphics.f("#000000").s().p("AgSCYQgQgTAAgqIAAitIgpAAIAAgPIApgLIAMg9IAMAAIAABBIBPAAIAAAWIhPAAIAACqQAAAgALAOQALAOAXAAQAZAAAPgDIAAATQgRAHgYAAQgigBgSgSg");
	this.shape_2389.setTransform(678.7,283.7,0.5,0.5);

	this.shape_2390 = new cjs.Shape();
	this.shape_2390.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgqIgBAAQgWAagVALQgVAKgdAAQgpAAgUgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2390.setTransform(667.4,285.2,0.5,0.5);

	this.shape_2391 = new cjs.Shape();
	this.shape_2391.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAAUIjBAAQABA3AYAeQAaAdAvAAQAWAAASgDQAQgCAdgMIAAAXQgXAKgUADQgSADgYABQg7AAghglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgmAAgYAag");
	this.shape_2391.setTransform(654.1,285.2,0.5,0.5);

	this.shape_2392 = new cjs.Shape();
	this.shape_2392.graphics.f("#000000").s().p("AhGCKIAAkNIAUAAIACAwIADAAQAQgeATgMQARgMAcAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_2392.setTransform(643.1,285.1,0.5,0.5);

	this.shape_2393 = new cjs.Shape();
	this.shape_2393.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6ABQAiAAAhAMIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAZAfAuAAQAmAAAegNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_2393.setTransform(631.4,285.2,0.5,0.5);

	this.shape_2394 = new cjs.Shape();
	this.shape_2394.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdgkQAdgmA3AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQgfAug6AAQg4AAgdgjgAhBgeQgXAeAAA7QAABzBZAAQAuAAAWgaQAUgaABg+IAAgEQgBg+gUgcQgWgbgvAAQgqAAgXAfg");
	this.shape_2394.setTransform(610.5,282.4,0.5,0.5);

	this.shape_2395 = new cjs.Shape();
	this.shape_2395.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2395.setTransform(600.4,282.3,0.5,0.5);

	this.shape_2396 = new cjs.Shape();
	this.shape_2396.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkAAQAvAAAYgYQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgZAqhDAAQhdAAAAhjg");
	this.shape_2396.setTransform(589.9,285.3,0.5,0.5);

	this.shape_2397 = new cjs.Shape();
	this.shape_2397.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCggAmQghAkg3ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AZAgQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2397.setTransform(575,285.2,0.5,0.5);

	this.shape_2398 = new cjs.Shape();
	this.shape_2398.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6ABQAiAAAiAMIgHAWQgkgMgaAAQgxAAgZAfQgaAfABA4QgBA3AaAfQAZAfAuAAQAmAAAegNIAAAXQgZANgqAAQg6AAghglg");
	this.shape_2398.setTransform(561.8,285.2,0.5,0.5);

	this.shape_2399 = new cjs.Shape();
	this.shape_2399.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAZBEAHAZIABAAIBcj1IAZAAIh4E5QgPAmgKANQgKAOgNAHQgNAHgUgBQgPAAgQgEg");
	this.shape_2399.setTransform(543,288.3,0.5,0.5);

	this.shape_2400 = new cjs.Shape();
	this.shape_2400.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAcAigBA4IAAAUIjCAAQABA3AZAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_2400.setTransform(530.1,285.2,0.5,0.5);

	this.shape_2401 = new cjs.Shape();
	this.shape_2401.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2401.setTransform(515.7,282.3,0.5,0.5);

	this.shape_2402 = new cjs.Shape();
	this.shape_2402.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAJAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2402.setTransform(503.6,283.7,0.5,0.5);

	this.shape_2403 = new cjs.Shape();
	this.shape_2403.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAegkQAdgmA2AAQAcAAAXALQAWALARAaIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_2403.setTransform(484.9,282.4,0.5,0.5);

	this.shape_2404 = new cjs.Shape();
	this.shape_2404.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAiAAA4IAAAUIjDAAQAAA2AbAfQAZAdAvAAQAXAAARgDQAPgCAdgMIAAAXQgWAKgTADQgTADgYABQg6AAghglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_2404.setTransform(470.7,285.2,0.5,0.5);

	this.shape_2405 = new cjs.Shape();
	this.shape_2405.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAtIAACVg");
	this.shape_2405.setTransform(459.6,285.1,0.5,0.5);

	this.shape_2406 = new cjs.Shape();
	this.shape_2406.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkAAQAwAAAXgYQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgaAqhCAAQhdAAABhjg");
	this.shape_2406.setTransform(446.2,285.3,0.5,0.5);

	this.shape_2407 = new cjs.Shape();
	this.shape_2407.graphics.f("#000000").s().p("AhfB8IAAgbQAoAUAuAAQAnABAVgNQAVgNAAgXQAAgUgRgPQgQgOgmgNQgngNgRgLQgRgLgIgNQgIgOgBgSQAAgfAagRQAZgTAuABQArAAAnAQIgIAXQgogRgiAAQggAAgUALQgTALAAAUQgBAVAPAMQAOAMAtARQAjAMASAKQAQALAJAOQAIAMAAATQAAAlgbATQgcAUgyAAQg3AAgfgRg");
	this.shape_2407.setTransform(432.7,285.2,0.5,0.5);

	this.shape_2408 = new cjs.Shape();
	this.shape_2408.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAZAAA2IAACVIgYAAIAAkNIAVAAIAEAlIACAAQAagrBCAAQBdAAgBBjIAACwg");
	this.shape_2408.setTransform(419.4,285.1,0.5,0.5);

	this.shape_2409 = new cjs.Shape();
	this.shape_2409.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAvgBAdAiQAcAiAAA4IAAAUIjDAAQAAA2AbAfQAZAdAuAAQAYAAARgDQAPgCAegMIAAAXQgWAJgVAEQgRADgaABQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_2409.setTransform(404.9,285.2,0.5,0.5);

	this.shape_2410 = new cjs.Shape();
	this.shape_2410.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBEAHAZIAAAAIBcj1IAZAAIh4E5QgQAogJALQgLAPgMAGQgNAHgTgBQgPAAgRgEg");
	this.shape_2410.setTransform(385.4,288.3,0.5,0.5);

	this.shape_2411 = new cjs.Shape();
	this.shape_2411.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_2411.setTransform(376.6,282.3,0.5,0.5);

	this.shape_2412 = new cjs.Shape();
	this.shape_2412.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAhgnA1AAQAvgBAcAiQAcAhgBA5IAAAUIjCAAQACA3AYAeQAaAdAuAAQAYAAARgDQAQgCAdgMIAAAXQgXAKgUADQgRADgaABQg5AAgiglgAg2hbQgYAagEAvICmAAQABgtgVgcQgVgbgjABQgnAAgXAag");
	this.shape_2412.setTransform(366.8,285.2,0.5,0.5);

	this.shape_2413 = new cjs.Shape();
	this.shape_2413.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBHC3QAOAlAGAYIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_2413.setTransform(353.9,285.2,0.5,0.5);

	this.shape_2414 = new cjs.Shape();
	this.shape_2414.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2414.setTransform(345.2,282.7,0.5,0.5);

	this.shape_2415 = new cjs.Shape();
	this.shape_2415.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAJAOQAMAOAXAAQAZAAAQgDIAAATQgSAHgYAAQgigBgSgSg");
	this.shape_2415.setTransform(337.8,283.7,0.5,0.5);

	this.shape_2416 = new cjs.Shape();
	this.shape_2416.graphics.f("#000000").s().p("AhABoQghglAAhBQABhCAhgmQAjgmA6ABQAiAAAhAMIgHAWQgigMgbAAQgvAAgbAfQgZAfgBA4QABA3AZAfQAaAfAtAAQAmAAAfgNIAAAXQgaANgrAAQg5AAghglg");
	this.shape_2416.setTransform(328,285.2,0.5,0.5);

	this.shape_2417 = new cjs.Shape();
	this.shape_2417.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA3AaAeQAZAdAuAAQAXAAATgDQAPgCAdgMIAAAXQgYAKgSADQgTADgZABQg6AAggglgAg2hbQgYAYgEAxICnAAQAAgtgVgcQgUgbglABQgmAAgXAag");
	this.shape_2417.setTransform(314.6,285.2,0.5,0.5);

	this.shape_2418 = new cjs.Shape();
	this.shape_2418.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2418.setTransform(304.8,282.3,0.5,0.5);

	this.shape_2419 = new cjs.Shape();
	this.shape_2419.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2419.setTransform(299,282.3,0.5,0.5);

	this.shape_2420 = new cjs.Shape();
	this.shape_2420.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAggkQAhglA2AAQA4gBAgAmQAgAlAABBQAABCghAmQgfAkg4ABQgkgBgbgQgAhFhWQgYAgAAA2QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2420.setTransform(288.6,285.2,0.5,0.5);

	this.shape_2421 = new cjs.Shape();
	this.shape_2421.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6ABQAiAAAhAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAmAAAegNIAAAXQgZANgqAAQg5AAghglg");
	this.shape_2421.setTransform(275.4,285.2,0.5,0.5);

	this.shape_2422 = new cjs.Shape();
	this.shape_2422.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2422.setTransform(259.5,282.3,0.5,0.5);

	this.shape_2423 = new cjs.Shape();
	this.shape_2423.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQABA3AZAeQAaAdAvAAQAXAAARgDQAQgCAdgMIAAAXQgYAKgTADQgSADgYABQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_2423.setTransform(249.7,285.2,0.5,0.5);

	this.shape_2424 = new cjs.Shape();
	this.shape_2424.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2424.setTransform(235.2,282.3,0.5,0.5);

	this.shape_2425 = new cjs.Shape();
	this.shape_2425.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQABhCAigmQAigmA6ABQAiAAAiAMIgHAWQgjgMgbAAQgwAAgaAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAmAAAegNIAAAXQgZANgqAAQg6AAggglg");
	this.shape_2425.setTransform(221.9,285.2,0.5,0.5);

	this.shape_2426 = new cjs.Shape();
	this.shape_2426.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_2426.setTransform(212.6,282.7,0.5,0.5);

	this.shape_2427 = new cjs.Shape();
	this.shape_2427.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgOAAIiJlPIgCAAQACAbAAAkIAAEQIgXAAIAAlrIAmAAICBFAIABAAICBlAIAmAAIAAFrg");
	this.shape_2427.setTransform(198.8,282.9,0.5,0.5);

	this.shape_2428 = new cjs.Shape();
	this.shape_2428.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdgkQAegmA2AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg4AAgcgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgqAAgXAfg");
	this.shape_2428.setTransform(173.1,282.4,0.5,0.5);

	this.shape_2429 = new cjs.Shape();
	this.shape_2429.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2429.setTransform(158.5,285.1,0.5,0.5);

	this.shape_2430 = new cjs.Shape();
	this.shape_2430.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2430.setTransform(143.7,285.2,0.5,0.5);

	this.shape_2431 = new cjs.Shape();
	this.shape_2431.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAmABAWgNQAVgOAAgWQAAgUgRgPQgPgNgngOQgngNgRgLQgRgKgIgOQgIgNAAgTQAAgfAZgRQAagTAsABQAsAAAoAQIgKAXQgngRgjAAQgfAAgUALQgUALAAAUQAAAVAPAMQAPAMArARQAmANAQAJQARAMAIANQAIAOAAARQAAAlgcATQgbAUgyAAQg2AAgggRg");
	this.shape_2431.setTransform(124.7,285.2,0.5,0.5);

	this.shape_2432 = new cjs.Shape();
	this.shape_2432.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgXAYQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_2432.setTransform(111.4,285.1,0.5,0.5);

	this.shape_2433 = new cjs.Shape();
	this.shape_2433.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2433.setTransform(101,282.7,0.5,0.5);

	this.shape_2434 = new cjs.Shape();
	this.shape_2434.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_2434.setTransform(93,282.3,0.5,0.5);

	this.shape_2435 = new cjs.Shape();
	this.shape_2435.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg9IANAAIAABBIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAOAYAAQAZAAAQgDIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_2435.setTransform(81.3,283.7,0.5,0.5);

	this.shape_2436 = new cjs.Shape();
	this.shape_2436.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2436.setTransform(70,285.2,0.5,0.5);

	this.shape_2437 = new cjs.Shape();
	this.shape_2437.graphics.f("#000000").s().p("ABdC2IhelRIgLAyIhQEfIgWAAIhklrIAbAAIBVFDQAFggAUhHIA/jcIAbAAIBJD8QANAuAFAZIAIgmIBNkdIAaAAIhlFrg");
	this.shape_2437.setTransform(52.3,282.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_2437},{t:this.shape_2436},{t:this.shape_2435},{t:this.shape_2434},{t:this.shape_2433},{t:this.shape_2432},{t:this.shape_2431},{t:this.shape_2430},{t:this.shape_2429},{t:this.shape_2428},{t:this.shape_2427},{t:this.shape_2426},{t:this.shape_2425},{t:this.shape_2424},{t:this.shape_2423},{t:this.shape_2422},{t:this.shape_2421},{t:this.shape_2420},{t:this.shape_2419},{t:this.shape_2418},{t:this.shape_2417},{t:this.shape_2416},{t:this.shape_2415},{t:this.shape_2414},{t:this.shape_2413},{t:this.shape_2412},{t:this.shape_2411},{t:this.shape_2410},{t:this.shape_2409},{t:this.shape_2408},{t:this.shape_2407},{t:this.shape_2406},{t:this.shape_2405},{t:this.shape_2404},{t:this.shape_2403},{t:this.shape_2402},{t:this.shape_2401},{t:this.shape_2400},{t:this.shape_2399},{t:this.shape_2398},{t:this.shape_2397},{t:this.shape_2396},{t:this.shape_2395},{t:this.shape_2394},{t:this.shape_2393},{t:this.shape_2392},{t:this.shape_2391},{t:this.shape_2390},{t:this.shape_2389},{t:this.shape_2388},{t:this.shape_2387},{t:this.shape_2386},{t:this.shape_2385},{t:this.shape_2384},{t:this.shape_2383},{t:this.shape_2382},{t:this.shape_2381},{t:this.shape_2380},{t:this.shape_2379},{t:this.shape_2378},{t:this.shape_2377},{t:this.shape_2376},{t:this.shape_2375},{t:this.shape_2374},{t:this.shape_2373},{t:this.shape_2372},{t:this.shape_2371},{t:this.shape_2370},{t:this.shape_2369},{t:this.shape_2368},{t:this.shape_2367},{t:this.shape_2366},{t:this.shape_2365},{t:this.shape_2364},{t:this.shape_2363},{t:this.shape_2362},{t:this.shape_2361},{t:this.shape_2360},{t:this.shape_2359},{t:this.shape_2358},{t:this.shape_2357},{t:this.shape_2356},{t:this.shape_2355},{t:this.shape_2354},{t:this.shape_2353},{t:this.shape_2352},{t:this.shape_2351},{t:this.shape_2350},{t:this.shape_2349},{t:this.shape_2348},{t:this.shape_2347},{t:this.shape_2346},{t:this.shape_2345},{t:this.shape_2344},{t:this.shape_2343},{t:this.shape_2342},{t:this.shape_2341},{t:this.shape_2340},{t:this.shape_2339},{t:this.shape_2338},{t:this.shape_2337},{t:this.shape_2336},{t:this.shape_2335},{t:this.shape_2334},{t:this.shape_2333},{t:this.shape_2332},{t:this.shape_2331},{t:this.shape_2330},{t:this.shape_2329},{t:this.shape_2328},{t:this.shape_2327},{t:this.shape_2326},{t:this.shape_2325},{t:this.shape_2324},{t:this.shape_2323},{t:this.shape_2322},{t:this.shape_2321},{t:this.shape_2320},{t:this.shape_2319},{t:this.shape_2318},{t:this.shape_2317},{t:this.shape_2316},{t:this.shape_2315},{t:this.shape_2314},{t:this.shape_2313},{t:this.shape_2312},{t:this.shape_2311},{t:this.shape_2310},{t:this.shape_2309},{t:this.shape_2308},{t:this.shape_2307},{t:this.shape_2306},{t:this.shape_2305},{t:this.shape_2304},{t:this.shape_2303},{t:this.shape_2302},{t:this.shape_2301},{t:this.shape_2300},{t:this.shape_2299},{t:this.shape_2298},{t:this.shape_2297},{t:this.shape_2296},{t:this.shape_2295},{t:this.shape_2294},{t:this.shape_2293},{t:this.shape_2292},{t:this.shape_2291},{t:this.shape_2290},{t:this.shape_2289},{t:this.shape_2288},{t:this.shape_2287},{t:this.shape_2286},{t:this.shape_2285},{t:this.shape_2284},{t:this.shape_2283},{t:this.shape_2282},{t:this.shape_2281},{t:this.shape_2280},{t:this.shape_2279},{t:this.shape_2278},{t:this.shape_2277},{t:this.shape_2276},{t:this.shape_2275},{t:this.shape_2274},{t:this.shape_2273},{t:this.shape_2272},{t:this.shape_2271},{t:this.shape_2270},{t:this.shape_2269},{t:this.shape_2268},{t:this.shape_2267},{t:this.shape_2266},{t:this.shape_2265},{t:this.shape_2264},{t:this.shape_2263},{t:this.shape_2262},{t:this.shape_2261},{t:this.shape_2260},{t:this.shape_2259},{t:this.shape_2258},{t:this.shape_2257},{t:this.shape_2256},{t:this.shape_2255},{t:this.shape_2254},{t:this.shape_2253},{t:this.shape_2252},{t:this.shape_2251},{t:this.shape_2250},{t:this.shape_2249},{t:this.shape_2248},{t:this.shape_2247},{t:this.shape_2246},{t:this.shape_2245},{t:this.shape_2244},{t:this.shape_2243},{t:this.shape_2242},{t:this.shape_2241},{t:this.shape_2240},{t:this.shape_2239},{t:this.shape_2238},{t:this.shape_2237},{t:this.shape_2236},{t:this.shape_2235},{t:this.shape_2234},{t:this.shape_2233},{t:this.shape_2232},{t:this.shape_2231},{t:this.shape_2230},{t:this.shape_2229},{t:this.shape_2228},{t:this.shape_2227},{t:this.shape_2226},{t:this.shape_2225},{t:this.shape_2224},{t:this.shape_2223},{t:this.shape_2222},{t:this.shape_2221},{t:this.shape_2220},{t:this.shape_2219},{t:this.shape_2218},{t:this.shape_2217},{t:this.shape_2216},{t:this.shape_2215},{t:this.shape_2214},{t:this.shape_2213},{t:this.shape_2212},{t:this.shape_2211},{t:this.shape_2210},{t:this.shape_2209},{t:this.shape_2208},{t:this.shape_2207},{t:this.shape_2206},{t:this.shape_2205},{t:this.shape_2204},{t:this.shape_2203},{t:this.shape_2202},{t:this.shape_2201},{t:this.shape_2200},{t:this.shape_2199},{t:this.shape_2198},{t:this.shape_2197},{t:this.shape_2196},{t:this.shape_2195},{t:this.shape_2194},{t:this.shape_2193},{t:this.shape_2192},{t:this.shape_2191},{t:this.shape_2190},{t:this.shape_2189},{t:this.shape_2188},{t:this.shape_2187},{t:this.shape_2186},{t:this.shape_2185},{t:this.shape_2184},{t:this.shape_2183},{t:this.shape_2182},{t:this.shape_2181},{t:this.shape_2180},{t:this.shape_2179},{t:this.shape_2178},{t:this.shape_2177},{t:this.shape_2176},{t:this.shape_2175},{t:this.shape_2174},{t:this.shape_2173},{t:this.shape_2172},{t:this.shape_2171},{t:this.shape_2170},{t:this.shape_2169},{t:this.shape_2168},{t:this.shape_2167},{t:this.shape_2166},{t:this.shape_2165},{t:this.shape_2164},{t:this.shape_2163},{t:this.shape_2162},{t:this.shape_2161},{t:this.shape_2160},{t:this.shape_2159},{t:this.shape_2158},{t:this.shape_2157},{t:this.shape_2156},{t:this.shape_2155},{t:this.shape_2154},{t:this.shape_2153},{t:this.shape_2152},{t:this.shape_2151},{t:this.shape_2150},{t:this.shape_2149},{t:this.shape_2148},{t:this.shape_2147},{t:this.shape_2146},{t:this.shape_2145},{t:this.shape_2144},{t:this.shape_2143},{t:this.shape_2142},{t:this.shape_2141},{t:this.shape_2140},{t:this.shape_2139},{t:this.shape_2138},{t:this.shape_2137},{t:this.shape_2136},{t:this.shape_2135},{t:this.shape_2134},{t:this.shape_2133},{t:this.shape_2132},{t:this.shape_2131},{t:this.shape_2130},{t:this.shape_2129},{t:this.shape_2128},{t:this.shape_2127},{t:this.shape_2126},{t:this.shape_2125},{t:this.shape_2124},{t:this.shape_2123},{t:this.shape_2122},{t:this.shape_2121},{t:this.shape_2120},{t:this.shape_2119},{t:this.shape_2118},{t:this.shape_2117},{t:this.shape_2116},{t:this.shape_2115},{t:this.shape_2114},{t:this.shape_2113},{t:this.shape_2112},{t:this.shape_2111},{t:this.shape_2110},{t:this.shape_2109},{t:this.shape_2108},{t:this.shape_2107},{t:this.shape_2106},{t:this.shape_2105},{t:this.shape_2104},{t:this.shape_2103},{t:this.shape_2102},{t:this.shape_2101},{t:this.shape_2100},{t:this.shape_2099},{t:this.shape_2098},{t:this.shape_2097},{t:this.shape_2096},{t:this.shape_2095},{t:this.shape_2094},{t:this.shape_2093},{t:this.shape_2092},{t:this.shape_2091},{t:this.shape_2090},{t:this.shape_2089},{t:this.shape_2088},{t:this.shape_2087},{t:this.shape_2086},{t:this.shape_2085},{t:this.shape_2084},{t:this.shape_2083},{t:this.shape_2082},{t:this.shape_2081},{t:this.shape_2080},{t:this.shape_2079},{t:this.shape_2078},{t:this.shape_2077},{t:this.shape_2076},{t:this.shape_2075},{t:this.shape_2074},{t:this.shape_2073},{t:this.shape_2072},{t:this.shape_2071},{t:this.shape_2070},{t:this.shape_2069},{t:this.shape_2068},{t:this.shape_2067},{t:this.shape_2066},{t:this.shape_2065},{t:this.shape_2064},{t:this.shape_2063},{t:this.shape_2062},{t:this.shape_2061},{t:this.shape_2060},{t:this.shape_2059},{t:this.shape_2058},{t:this.shape_2057},{t:this.shape_2056},{t:this.shape_2055},{t:this.shape_2054},{t:this.shape_2053},{t:this.shape_2052},{t:this.shape_2051},{t:this.shape_2050},{t:this.shape_2049},{t:this.shape_2048},{t:this.shape_2047},{t:this.shape_2046},{t:this.shape_2045},{t:this.shape_2044},{t:this.shape_2043},{t:this.shape_2042},{t:this.shape_2041},{t:this.shape_2040},{t:this.shape_2039},{t:this.shape_2038},{t:this.shape_2037},{t:this.shape_2036},{t:this.shape_2035},{t:this.shape_2034},{t:this.shape_2033},{t:this.shape_2032},{t:this.shape_2031},{t:this.shape_2030},{t:this.shape_2029},{t:this.shape_2028},{t:this.shape_2027},{t:this.shape_2026},{t:this.shape_2025},{t:this.shape_2024},{t:this.shape_2023},{t:this.shape_2022},{t:this.shape_2021},{t:this.shape_2020},{t:this.shape_2019},{t:this.shape_2018},{t:this.shape_2017},{t:this.shape_2016},{t:this.shape_2015},{t:this.shape_2014},{t:this.shape_2013},{t:this.shape_2012},{t:this.shape_2011},{t:this.shape_2010},{t:this.shape_2009},{t:this.shape_2008},{t:this.shape_2007},{t:this.shape_2006},{t:this.shape_2005},{t:this.shape_2004},{t:this.shape_2003},{t:this.shape_2002},{t:this.shape_2001},{t:this.shape_2000},{t:this.shape_1999},{t:this.shape_1998},{t:this.shape_1997},{t:this.shape_1996},{t:this.shape_1995},{t:this.shape_1994},{t:this.shape_1993},{t:this.shape_1992},{t:this.shape_1991},{t:this.shape_1990},{t:this.shape_1989},{t:this.shape_1988},{t:this.shape_1987},{t:this.shape_1986},{t:this.shape_1985},{t:this.shape_1984},{t:this.shape_1983},{t:this.shape_1982},{t:this.shape_1981},{t:this.shape_1980},{t:this.shape_1979},{t:this.shape_1978},{t:this.shape_1977},{t:this.shape_1976},{t:this.shape_1975},{t:this.shape_1974},{t:this.shape_1973},{t:this.shape_1972},{t:this.shape_1971},{t:this.shape_1970},{t:this.shape_1969},{t:this.shape_1968},{t:this.shape_1967},{t:this.shape_1966},{t:this.shape_1965},{t:this.shape_1964},{t:this.shape_1963},{t:this.shape_1962},{t:this.shape_1961},{t:this.shape_1960},{t:this.shape_1959},{t:this.shape_1958},{t:this.shape_1957},{t:this.shape_1956},{t:this.shape_1955},{t:this.shape_1954},{t:this.shape_1953},{t:this.shape_1952},{t:this.shape_1951},{t:this.shape_1950},{t:this.shape_1949},{t:this.shape_1948},{t:this.shape_1947},{t:this.shape_1946},{t:this.shape_1945},{t:this.shape_1944},{t:this.shape_1943},{t:this.shape_1942},{t:this.shape_1941},{t:this.shape_1940},{t:this.shape_1939},{t:this.shape_1938},{t:this.shape_1937},{t:this.shape_1936},{t:this.shape_1935},{t:this.shape_1934},{t:this.shape_1933},{t:this.shape_1932},{t:this.shape_1931},{t:this.shape_1930},{t:this.shape_1929},{t:this.shape_1928},{t:this.shape_1927},{t:this.shape_1926},{t:this.shape_1925},{t:this.shape_1924},{t:this.shape_1923},{t:this.shape_1922},{t:this.shape_1921},{t:this.shape_1920},{t:this.shape_1919},{t:this.shape_1918},{t:this.shape_1917},{t:this.shape_1916},{t:this.shape_1915},{t:this.shape_1914},{t:this.shape_1913},{t:this.shape_1912},{t:this.shape_1911},{t:this.shape_1910},{t:this.shape_1909},{t:this.shape_1908},{t:this.shape_1907},{t:this.shape_1906},{t:this.shape_1905},{t:this.shape_1904},{t:this.shape_1903},{t:this.shape_1902},{t:this.shape_1901},{t:this.shape_1900},{t:this.shape_1899},{t:this.shape_1898},{t:this.shape_1897},{t:this.shape_1896},{t:this.shape_1895},{t:this.shape_1894},{t:this.shape_1893},{t:this.shape_1892},{t:this.shape_1891},{t:this.shape_1890},{t:this.shape_1889},{t:this.shape_1888},{t:this.shape_1887},{t:this.shape_1886},{t:this.shape_1885},{t:this.shape_1884},{t:this.shape_1883},{t:this.shape_1882},{t:this.shape_1881},{t:this.shape_1880},{t:this.shape_1879},{t:this.shape_1878},{t:this.shape_1877},{t:this.shape_1876},{t:this.shape_1875},{t:this.shape_1874},{t:this.shape_1873},{t:this.shape_1872},{t:this.shape_1871},{t:this.shape_1870},{t:this.shape_1869},{t:this.shape_1868},{t:this.shape_1867},{t:this.shape_1866},{t:this.shape_1865},{t:this.shape_1864},{t:this.shape_1863},{t:this.shape_1862},{t:this.shape_1861},{t:this.shape_1860},{t:this.shape_1859},{t:this.shape_1858},{t:this.shape_1857},{t:this.shape_1856},{t:this.shape_1855},{t:this.shape_1854},{t:this.shape_1853},{t:this.shape_1852},{t:this.shape_1851},{t:this.shape_1850},{t:this.shape_1849},{t:this.shape_1848},{t:this.shape_1847},{t:this.shape_1846},{t:this.shape_1845},{t:this.shape_1844},{t:this.shape_1843},{t:this.shape_1842},{t:this.shape_1841},{t:this.shape_1840},{t:this.shape_1839},{t:this.shape_1838},{t:this.shape_1837},{t:this.shape_1836},{t:this.shape_1835},{t:this.shape_1834},{t:this.shape_1833},{t:this.shape_1832},{t:this.shape_1831},{t:this.shape_1830},{t:this.shape_1829},{t:this.shape_1828},{t:this.shape_1827},{t:this.shape_1826},{t:this.shape_1825},{t:this.shape_1824},{t:this.shape_1823},{t:this.shape_1822},{t:this.shape_1821},{t:this.shape_1820},{t:this.shape_1819},{t:this.shape_1818},{t:this.shape_1817},{t:this.shape_1816},{t:this.shape_1815},{t:this.shape_1814},{t:this.shape_1813},{t:this.shape_1812},{t:this.shape_1811},{t:this.shape_1810},{t:this.shape_1809},{t:this.shape_1808},{t:this.shape_1807},{t:this.shape_1806},{t:this.shape_1805},{t:this.shape_1804},{t:this.shape_1803},{t:this.shape_1802},{t:this.shape_1801},{t:this.shape_1800},{t:this.shape_1799},{t:this.shape_1798},{t:this.shape_1797},{t:this.shape_1796},{t:this.shape_1795},{t:this.shape_1794},{t:this.shape_1793},{t:this.shape_1792},{t:this.shape_1791},{t:this.shape_1790},{t:this.shape_1789},{t:this.shape_1788},{t:this.shape_1787},{t:this.shape_1786},{t:this.shape_1785},{t:this.shape_1784},{t:this.shape_1783},{t:this.shape_1782},{t:this.shape_1781},{t:this.shape_1780},{t:this.shape_1779},{t:this.shape_1778},{t:this.shape_1777},{t:this.shape_1776},{t:this.instance_8}]},113).to({state:[]},1).wait(51));

	// ButtonLeftRight copy 44
	this.buttonR21 = new lib.ButtonLeft_Right();
	this.buttonR21.name = "buttonR21";
	this.buttonR21.parent = this;
	this.buttonR21.setTransform(2025,513.5,1,1,180);
	this.buttonR21._off = true;
	new cjs.ButtonHelper(this.buttonR21, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR21).wait(112).to({_off:false},0).to({_off:true},1).wait(52));

	// ButtonLeftRight copy 45
	this.buttonL21 = new lib.ButtonLeft_Right();
	this.buttonL21.name = "buttonL21";
	this.buttonL21.parent = this;
	this.buttonL21.setTransform(0,437.2);
	this.buttonL21._off = true;
	new cjs.ButtonHelper(this.buttonL21, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL21).wait(112).to({_off:false},0).to({_off:true},1).wait(52));

	// Layer 1
	this.instance_9 = new lib.yel_broach_draw();
	this.instance_9.parent = this;
	this.instance_9.setTransform(2039,992,1,1,180);
	this.instance_9._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_9).wait(112).to({_off:false},0).to({_off:true},1).wait(52));

	// ButtonLeftRight copy 42
	this.buttonR20 = new lib.ButtonLeft_Right();
	this.buttonR20.name = "buttonR20";
	this.buttonR20.parent = this;
	this.buttonR20.setTransform(2025,513.5,1,1,180);
	this.buttonR20._off = true;
	new cjs.ButtonHelper(this.buttonR20, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR20).wait(111).to({_off:false},0).to({_off:true},1).wait(53));

	// ButtonLeftRight copy 43
	this.buttonL20 = new lib.ButtonLeft_Right();
	this.buttonL20.name = "buttonL20";
	this.buttonL20.parent = this;
	this.buttonL20.setTransform(0,437.2);
	this.buttonL20._off = true;
	new cjs.ButtonHelper(this.buttonL20, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL20).wait(111).to({_off:false},0).to({_off:true},1).wait(53));

	// Layer 1
	this.shape_2438 = new cjs.Shape();
	this.shape_2438.graphics.f("#000000").s().p("AgWDZIAAmwIAtAAIAAGwg");
	this.shape_2438.setTransform(215.6,586.2,0.5,0.5);

	this.shape_2439 = new cjs.Shape();
	this.shape_2439.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhJAkgrQAkgrA9AAQA6AAAhAmQAhAkAAA/IAAAcIjRAAQACA2AZAcQAZAbAuAAQAxABAxgVIAAApQgbAMgTAEQgWAEgfAAQhDAAgngpgAg2hfQgVAZgEAqICeAAQABgsgUgYQgUgWgjAAQgkAAgXAXg");
	this.shape_2439.setTransform(204.1,589.4,0.5,0.5);

	this.shape_2440 = new cjs.Shape();
	this.shape_2440.graphics.f("#000000").s().p("ABSDZIAAjGQAAgkgRgSQgRgTglAAQgvAAgWAaQgWAZAAA8IAACgIgvAAIAAmwIAvAAIAACCQAAAWgDASIAEAAQANgWAZgNQAZgNAfAAQA6AAAbAbQAcAaAAA6IAADHg");
	this.shape_2440.setTransform(187.3,586.2,0.5,0.5);

	this.shape_2441 = new cjs.Shape();
	this.shape_2441.graphics.f("#000000").s().p("AhJB1QgkgpAAhKQAAhMAkgpQAlgqBEAAQAWAAAWAFQAUAEAOAGIgOAoQgOgFgUgGQgSgDgNAAQhcAAgBB1QAAA5AYAeQAWAdArAAQAmAAApgQIAAApQgfAQgvAAQhBAAgkgpg");
	this.shape_2441.setTransform(172.1,589.4,0.5,0.5);

	this.shape_2442 = new cjs.Shape();
	this.shape_2442.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQAMAAAHAHQAIAIAAAPQAAAQgIAIQgHAHgMAAQgLAAgHgHg");
	this.shape_2442.setTransform(161.3,586.6,0.5,0.5);

	this.shape_2443 = new cjs.Shape();
	this.shape_2443.graphics.f("#000000").s().p("ACaDMIAAkGQAAgpAEg5IgCAAIiMFoIgkAAIiKloIgDAAQAEAlAABAIAAEDIgrAAIAAmWIBHAAICAFOIACAAICClOIBHAAIAAGWg");
	this.shape_2443.setTransform(144.9,586.9,0.5,0.5);

	this.shape_2444 = new cjs.Shape();
	this.shape_2444.graphics.f("#000000").s().p("AiKDYIAAglQAOAEAUgBQAvAAAVg1IARgsIh7kxIAyAAIBCCuQAXA9ADAYIADAAIAPgwQAPgtA9imIAxAAIiDFaQgTAzgZAWQgbAWgmAAQgSAAgXgFg");
	this.shape_2444.setTransform(117.4,592.8,0.5,0.5);

	this.shape_2445 = new cjs.Shape();
	this.shape_2445.graphics.f("#000000").s().p("AhJB1QgkgpAAhKQAAhMAkgpQAlgqBEAAQAVAAAXAFQAUAEAOAGIgOAoQgOgFgUgGQgTgDgNAAQhcAAAAB1QAAA4AXAfQAXAdArAAQAmAAApgQIAAApQgfAQgvAAQhBAAgkgpg");
	this.shape_2445.setTransform(103.8,589.4,0.5,0.5);

	this.shape_2446 = new cjs.Shape();
	this.shape_2446.graphics.f("#000000").s().p("ABRCbIAAjEQAAgmgRgSQgQgSglAAQguAAgXAaQgWAZgBA8IAACfIguAAIAAkwIAmAAIAHAqIADAAQANgWAbgNQAZgMAeAAQA4AAAbAaQAdAbAAA6IAADGg");
	this.shape_2446.setTransform(88,589.3,0.5,0.5);

	this.shape_2447 = new cjs.Shape();
	this.shape_2447.graphics.f("#000000").s().p("AhgCGQgagXAAgrQAAhcCUgEIAzgCIAAgTQAAgjgPgSQgPgRgjAAQgmAAgvAYIgOgkQAYgMAagHQAYgHAcAAQA3AAAaAYQAbAYAAA2IAADPIgjAAIgJgrIgCAAQgXAcgXALQgXAKghAAQgsAAgbgYgAAeAEQg2ACgYAPQgZAPAAAgQAAAaAPAMQAQAOAaAAQArAAAZgYQAYgXAAgrIAAgcg");
	this.shape_2447.setTransform(70.8,589.4,0.5,0.5);

	this.shape_2448 = new cjs.Shape();
	this.shape_2448.graphics.f("#000000").s().p("ABpDMIjelVIgBAAQAEA8AAAyIAADnIgsAAIAAmWIA1AAIDdFSIACAAIgCgwIgBg6IAAjoIAsAAIAAGWg");
	this.shape_2448.setTransform(52.6,586.9,0.5,0.5);

	this.shape_2449 = new cjs.Shape();
	this.shape_2449.graphics.f("#000000").s().p("A3KEAIAAhmIABg+IgBAAQgeAvg+AAQg1AAgdgkQgegiAAhDQAAhEAeglQAdgmA2AAQA8AAAcAsIACAAIAFgnIAUAAIAAGIgA5lhYQgXAfAAA7QAAA5AWAdQAXAdApAAQAyAAAVgbQAVgbAAhAIAAgDQAAg9gVgbQgWgbguAAQgrAAgXAfgAWZB4QgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBQAAIAAAWIhQAAIAACqQABAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgSgTgANUBnQghglAAhCQAAg/AggnQAfgnA3AAQAwAAAcAhQAbAiAAA5IAAATIjDAAQABA4AZAdQAaAdAvAAQAYABAQgEQAUgDAZgLIAAAWQgWALgUADQgVAEgWAAQg6AAgigkgANqheQgYAbgEAwICoAAQAAgvgVgbQgUgagkAAQgnAAgYAZgAF2BnQgiglABhCQAAg+AfgoQAhgnA2AAQAwAAAbAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAZAdAwAAQAYABAQgEQATgDAagLIAAAWQgYALgSADQgWAEgVAAQg7AAghgkgAGLheQgXAbgEAwICoAAQgBgvgUgbQgUgagkAAQgnAAgZAZgAlhBoQgegjAAhCQAAhGAeglQAdglA3AAQAeAAAWALQAVALARAZIABAAIgBg+IAAhhIAZAAIAAGDIgRAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAlPhXQgWAfAAA6QAABzBZAAQAtAAAXgbQAVgbAAg8IAAgEQAAg/gVgbQgVgcgwAAQgsAAgWAggAr7BnQggglAAhCQgBg/AggnQAggnA2AAQAwAAAcAhQAbAhAAA6IAAATIjDAAQABA4AZAdQAaAdAvAAQAZABAQgEQASgDAbgLIAAAWQgYALgTADQgVAEgWAAQg6AAgigkgArkheQgYAagEAxICnAAQAAgwgUgaQgVgagkAAQgnAAgXAZgAulB4QgRgUAAgpIAAitIgoAAIAAgPIAogLIANg9IAMAAIAABBIBQAAIAAAWIhQAAIAACqQABAfAKAPQALAPAXAAQAXAAATgEIAAAUQgTAGgXAAQgkAAgRgTgA1aAoIAAiwIAYAAIAACvQAAAoARATQASASAkAAQAwAAAXgYQAXgZAAg2IAAiVIAYAAIAAEOIgVAAIgEgmIgCAAQgbArhCAAQhdAAAAhjgAUYCGIAAiuQgBgpgRgTQgRgTgkAAQgxABgWAYQgWAYAAA4IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAagqBDAAQBdAAAABjIAACwgAJ9CGIAAkOIAUAAIACAxIADAAQAQgeATgMQATgMAbAAQASAAATADIgFAYQgTgEgQAAQgjAAgWAdQgWAeAAAtIAACUgADXCGIAAj4IgyAAIAAgPIAygJIAAgVQABgyASgXQASgYAqAAQAVAAAYAIIgHAVQgSgHgVAAQgdAAgMARQgMASAAAmIAAAZIBAAAIAAAWIhAAAIAAD4gAA+CGIAAj4IgyAAIAAgPIAygJIAAgVQAAgyATgXQASgYAqAAQAVAAAYAIIgGAVQgTgHgVAAQgcAAgNARQgMASAAAmIAAAZIBAAAIAAAWIhAAAIAAD4gAhACGIAAkOIAZAAIAAEOgAwqCGIAAkOIAYAAIAAEOgAZchoQAGgVAJgpQAIgmAEgZIAdAAIADAFQgJAegMAjQgMAggKAXgAYMhoQAIgYAIglQAHgjAEgdIAeAAIADAFQgSBBgZA3gAhEjTQAAgYAQAAQAIAAAFAGQADAGABAMQgBAMgDAGQgFAGgIAAQgQAAAAgYgAwujTQAAgYAQAAQAIAAAEAGQAFAHAAALQAAALgFAHQgEAGgIAAQgQAAAAgYg");
	this.shape_2449.setTransform(127.7,552.1,0.5,0.5);

	this.shape_2450 = new cjs.Shape();
	this.shape_2450.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAbAAAiQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_2450.setTransform(751.7,516.7,0.5,0.5);

	this.shape_2451 = new cjs.Shape();
	this.shape_2451.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAYAAA4IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAZgqBEAAQBbAAAABjIAACwg");
	this.shape_2451.setTransform(737.6,513.6,0.5,0.5);

	this.shape_2452 = new cjs.Shape();
	this.shape_2452.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_2452.setTransform(727.1,511.3,0.5,0.5);

	this.shape_2453 = new cjs.Shape();
	this.shape_2453.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAjAAQBcAAAABiIAACxg");
	this.shape_2453.setTransform(716.8,510.8,0.5,0.5);

	this.shape_2454 = new cjs.Shape();
	this.shape_2454.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQABAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2454.setTransform(704.7,512.2,0.5,0.5);

	this.shape_2455 = new cjs.Shape();
	this.shape_2455.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgoQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgEQATgDAagLIAAAXQgYALgTADQgVADgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgaglAAQgmAAgXAZg");
	this.shape_2455.setTransform(693.6,513.8,0.5,0.5);

	this.shape_2456 = new cjs.Shape();
	this.shape_2456.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgUAYQgTAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_2456.setTransform(675.5,513.6,0.5,0.5);

	this.shape_2457 = new cjs.Shape();
	this.shape_2457.graphics.f("#000000").s().p("Ag+B7QgcgRgPggQgOghAAgpQAAhBAggmQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCggAlQggAmg4gBQgjAAgbgRgAhFhXQgYAfAAA4QAAA3AYAfQAZAgAsAAQAtAAAZggQAYgfAAg3QAAg3gZggQgZgegsAAQgsAAgZAeg");
	this.shape_2457.setTransform(656.7,513.8,0.5,0.5);

	this.shape_2458 = new cjs.Shape();
	this.shape_2458.graphics.f("#000000").s().p("AhfB7IAAgaQApAVAtAAQAnAAAVgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgRgLgIgOQgJgNAAgTQABgeAZgSQAagSAtAAQArAAAnARIgJAWQgngQgiAAQghAAgTALQgTAKAAAUQgBAVAQANQAOAMArAQQAjAMATALQARAMAIAMQAIANAAATQAAAkgbAUQgcATgyAAQg3ABgfgSg");
	this.shape_2458.setTransform(643.2,513.8,0.5,0.5);

	this.shape_2459 = new cjs.Shape();
	this.shape_2459.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgoQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgEQATgDAagLIAAAXQgYALgTADQgVADgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgaglAAQgmAAgXAZg");
	this.shape_2459.setTransform(623.7,513.8,0.5,0.5);

	this.shape_2460 = new cjs.Shape();
	this.shape_2460.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqByIBzCcg");
	this.shape_2460.setTransform(611.6,510.8,0.5,0.5);

	this.shape_2461 = new cjs.Shape();
	this.shape_2461.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2461.setTransform(597.1,513.8,0.5,0.5);

	this.shape_2462 = new cjs.Shape();
	this.shape_2462.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgUAYQgTAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_2462.setTransform(579.7,513.6,0.5,0.5);

	this.shape_2463 = new cjs.Shape();
	this.shape_2463.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQARgZAWgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_2463.setTransform(554.3,510.8,0.5,0.5);

	this.shape_2464 = new cjs.Shape();
	this.shape_2464.graphics.f("#000000").s().p("Ag/BnQghgjAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAeQgZAfAAA5QAAA4AZAeQAaAfAtAAQAlAAAfgOIAAAYQgaAMgpAAQg5AAghglg");
	this.shape_2464.setTransform(540.9,513.8,0.5,0.5);

	this.shape_2465 = new cjs.Shape();
	this.shape_2465.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2465.setTransform(527.3,513.8,0.5,0.5);

	this.shape_2466 = new cjs.Shape();
	this.shape_2466.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgnQAggmA1gBQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAYAAAQgEQASgDAagLIAAAXQgWALgUADQgUADgWAAQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgxgVgZQgTgaglAAQgmAAgYAZg");
	this.shape_2466.setTransform(514.1,513.8,0.5,0.5);

	this.shape_2467 = new cjs.Shape();
	this.shape_2467.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2467.setTransform(497.5,510.8,0.5,0.5);

	this.shape_2468 = new cjs.Shape();
	this.shape_2468.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2468.setTransform(491.8,510.8,0.5,0.5);

	this.shape_2469 = new cjs.Shape();
	this.shape_2469.graphics.f("#000000").s().p("AgdA+QAIgYAHgkQAHgdAGgiIAcAAIADAFQgTA/gYA3g");
	this.shape_2469.setTransform(487,505.4,0.5,0.5);

	this.shape_2470 = new cjs.Shape();
	this.shape_2470.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgnQAfgmA1gBQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgEQASgDAbgLIAAAXQgXALgTADQgWADgWAAQg5AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_2470.setTransform(478.2,513.8,0.5,0.5);

	this.shape_2471 = new cjs.Shape();
	this.shape_2471.graphics.f("#000000").s().p("ABNCIIg7i0IgOg2IgCAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQANg3AIgWIA4ikIAVAAIA1CjQATA+ADAQIACAAQACgTAShEIApiaIAZAAIhKEOg");
	this.shape_2471.setTransform(462,513.8,0.5,0.5);

	this.shape_2472 = new cjs.Shape();
	this.shape_2472.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2472.setTransform(443.2,510.8,0.5,0.5);

	this.shape_2473 = new cjs.Shape();
	this.shape_2473.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2473.setTransform(433.2,513.8,0.5,0.5);

	this.shape_2474 = new cjs.Shape();
	this.shape_2474.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgEAGgIAAQgPAAAAgYg");
	this.shape_2474.setTransform(424,511.3,0.5,0.5);

	this.shape_2475 = new cjs.Shape();
	this.shape_2475.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_2475.setTransform(417,513.6,0.5,0.5);

	this.shape_2476 = new cjs.Shape();
	this.shape_2476.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgnQAfgmA1gBQAxAAAbAiQAbAiABA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgEQAUgDAZgLIAAAXQgXALgTADQgWADgWAAQg5AAghgkgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgaglAAQgmAAgYAZg");
	this.shape_2476.setTransform(404.2,513.8,0.5,0.5);

	this.shape_2477 = new cjs.Shape();
	this.shape_2477.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgSgUg");
	this.shape_2477.setTransform(392.7,512.2,0.5,0.5);

	this.shape_2478 = new cjs.Shape();
	this.shape_2478.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgFgrIgDAAQgVAbgUAKQgYALgbAAQgnAAgXgUgAAeAAQg3ACgaAPQgYAPABAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_2478.setTransform(381.4,513.8,0.5,0.5);

	this.shape_2479 = new cjs.Shape();
	this.shape_2479.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgTAYQgUAVAAAyIAACeIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_2479.setTransform(363.9,513.6,0.5,0.5);

	this.shape_2480 = new cjs.Shape();
	this.shape_2480.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2480.setTransform(341.9,513.6,0.5,0.5);

	this.shape_2481 = new cjs.Shape();
	this.shape_2481.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2481.setTransform(328.9,513.8,0.5,0.5);

	this.shape_2482 = new cjs.Shape();
	this.shape_2482.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2482.setTransform(319.7,510.8,0.5,0.5);

	this.shape_2483 = new cjs.Shape();
	this.shape_2483.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2483.setTransform(313.9,511.3,0.5,0.5);

	this.shape_2484 = new cjs.Shape();
	this.shape_2484.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgTAYQgUAVAAAyIAACeIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_2484.setTransform(299.8,513.6,0.5,0.5);

	this.shape_2485 = new cjs.Shape();
	this.shape_2485.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2485.setTransform(285.6,511.3,0.5,0.5);

	this.shape_2486 = new cjs.Shape();
	this.shape_2486.graphics.f("#000000").s().p("AhfB7IAAgaQAqAVAsAAQAnAAAVgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgJAWQgpgQghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkANARAKQARAMAIAMQAIANAAATQAAAkgbAUQgcATgyAAQg2ABgggSg");
	this.shape_2486.setTransform(276.7,513.8,0.5,0.5);

	this.shape_2487 = new cjs.Shape();
	this.shape_2487.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_2487.setTransform(261.3,510.8,0.5,0.5);

	this.shape_2488 = new cjs.Shape();
	this.shape_2488.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOghAAgpQAAhBAggmQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCggAlQggAmg4gBQgjAAgcgRgAhFhXQgYAfAAA4QAAA3AYAfQAaAgArAAQAtAAAZggQAYgfAAg3QAAg3gZggQgZgegsAAQgsAAgZAeg");
	this.shape_2488.setTransform(249.1,513.8,0.5,0.5);

	this.shape_2489 = new cjs.Shape();
	this.shape_2489.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2489.setTransform(230.6,512.2,0.5,0.5);

	this.shape_2490 = new cjs.Shape();
	this.shape_2490.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACvQAAAoASATQASASAjAAQAvAAAYgYQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAAAhjg");
	this.shape_2490.setTransform(218.9,513.9,0.5,0.5);

	this.shape_2491 = new cjs.Shape();
	this.shape_2491.graphics.f("#000000").s().p("Ah3CJQgrgyAAhXQAAhWAsgzQArgxBLAAQBMAAArAxQAsAzAABWQAABXgsAyQgrAyhMAAQhLAAgsgygAhjh4QgjArAABNQAABOAjAqQAiArBBABQBCAAAigrQAjgqAAhPQAAhOgjgqQgigqhCAAQhAAAgjAqg");
	this.shape_2491.setTransform(201.7,511.4,0.5,0.5);

	this.shape_2492 = new cjs.Shape();
	this.shape_2492.graphics.f("#000000").s().p("Ag0DeIAAgXIBRAAIAAmNIhRAAIAAgXIBpAAIAAG7g");
	this.shape_2492.setTransform(180.5,513.4,0.5,0.5);

	this.shape_2493 = new cjs.Shape();
	this.shape_2493.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2493.setTransform(173.1,513.6,0.5,0.5);

	this.shape_2494 = new cjs.Shape();
	this.shape_2494.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgnQAggmA1gBQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAYAAAQgEQASgDAagLIAAAXQgWALgUADQgUADgWAAQg6AAgigkgAg2hcQgYAagEAxICmAAQAAgxgVgZQgTgaglAAQgmAAgXAZg");
	this.shape_2494.setTransform(160.3,513.8,0.5,0.5);

	this.shape_2495 = new cjs.Shape();
	this.shape_2495.graphics.f("#000000").s().p("AgLCIIhpkOIAZAAIBGC2QAPAlAGAZIABAAQANgrAIgTIBGi2IAZAAIhpEOg");
	this.shape_2495.setTransform(147.4,513.8,0.5,0.5);

	this.shape_2496 = new cjs.Shape();
	this.shape_2496.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgnQAggmA1gBQAwAAAbAiQAcAiAAA4IAAATIjBAAQgBA3AaAfQAaAdAvAAQAYAAAQgEQASgDAagLIAAAXQgWALgUADQgUADgWAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgxgUgZQgUgaglAAQgmAAgXAZg");
	this.shape_2496.setTransform(134.6,513.8,0.5,0.5);

	this.shape_2497 = new cjs.Shape();
	this.shape_2497.graphics.f("#000000").s().p("ABNCIIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQAMgxAJgcIA4ikIAVAAIA1CjQAQA1AGAZIACAAQABgNAThKIApiaIAZAAIhKEOg");
	this.shape_2497.setTransform(118.4,513.8,0.5,0.5);

	this.shape_2498 = new cjs.Shape();
	this.shape_2498.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAmg4gBQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2498.setTransform(101.7,513.8,0.5,0.5);

	this.shape_2499 = new cjs.Shape();
	this.shape_2499.graphics.f("#000000").s().p("ABqC2IAAizIjTAAIAACzIgaAAIAAlrIAaAAIAACiIDTAAIAAiiIAaAAIAAFrg");
	this.shape_2499.setTransform(85,511.4,0.5,0.5);

	this.shape_2500 = new cjs.Shape();
	this.shape_2500.graphics.f("#000000").s().p("Ag0DeIAAm7IBpAAIAAAXIhRAAIAAGNIBRAAIAAAXg");
	this.shape_2500.setTransform(72.6,513.4,0.5,0.5);

	this.shape_2501 = new cjs.Shape();
	this.shape_2501.graphics.f("#000000").s().p("ABmAAQAAgYAUABQAUgBAAAYQAAAYgUAAQgUAAAAgYgAgTAAQAAgYATABQAUgBAAAYQAAAYgUAAQgTAAAAgYgAiNAAQAAgYAUABQAVgBAAAYQAAAYgVAAQgUAAAAgYg");
	this.shape_2501.setTransform(58.6,519.6,0.5,0.5);

	this.shape_2502 = new cjs.Shape();
	this.shape_2502.graphics.f("#000000").s().p("AANA+IgDgFQAHgaANgkQAIgXAPghIAQAAQgGAVgJAoQgIAlgEAZgAhBA+IgDgFQAKgkAKgZQANgkAKgVIAQAAQgIAbgIAkQgHAggEAcg");
	this.shape_2502.setTransform(45.7,505.4,0.5,0.5);

	this.shape_2503 = new cjs.Shape();
	this.shape_2503.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_2503.setTransform(552.8,443.1,0.5,0.5);

	this.shape_2504 = new cjs.Shape();
	this.shape_2504.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2504.setTransform(546.9,434.3,0.5,0.5);

	this.shape_2505 = new cjs.Shape();
	this.shape_2505.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2505.setTransform(536.8,437.3,0.5,0.5);

	this.shape_2506 = new cjs.Shape();
	this.shape_2506.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2506.setTransform(527.7,434.8,0.5,0.5);

	this.shape_2507 = new cjs.Shape();
	this.shape_2507.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_2507.setTransform(520.7,437.1,0.5,0.5);

	this.shape_2508 = new cjs.Shape();
	this.shape_2508.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA5IAAATIjDAAQABA5AaAdQAZAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgVAEgXAAQg5ABghglgAg3hcQgYAbgDAwICnAAQAAgwgVgaQgUgaglAAQgmAAgYAZg");
	this.shape_2508.setTransform(507.9,437.3,0.5,0.5);

	this.shape_2509 = new cjs.Shape();
	this.shape_2509.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2509.setTransform(496.4,435.7,0.5,0.5);

	this.shape_2510 = new cjs.Shape();
	this.shape_2510.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2510.setTransform(485.1,437.3,0.5,0.5);

	this.shape_2511 = new cjs.Shape();
	this.shape_2511.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgRgggBQgpAAgUAYQgUAWAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQANgXAWgNQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_2511.setTransform(467.6,437.1,0.5,0.5);

	this.shape_2512 = new cjs.Shape();
	this.shape_2512.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_2512.setTransform(445.6,437.1,0.5,0.5);

	this.shape_2513 = new cjs.Shape();
	this.shape_2513.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAmAABAQAABCggAlQggAmg4gBQgjAAgcgRgAhEhXQgZAfAAA4QAAA4AZAeQAZAgArAAQAtAAAYggQAZgeAAg4QAAg3gZggQgYgegtAAQgsAAgYAeg");
	this.shape_2513.setTransform(432.3,437.3,0.5,0.5);

	this.shape_2514 = new cjs.Shape();
	this.shape_2514.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgdAAgNARQgLASAAAlIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_2514.setTransform(421.9,434.3,0.5,0.5);

	this.shape_2515 = new cjs.Shape();
	this.shape_2515.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgRgLgIgOQgIgNAAgTQgBgeAagSQAagSAtAAQAsAAAnARIgJAXQgogRgiAAQghAAgTALQgTAKAAAUQAAAVAOANQAPAMAsAQQAiAMATALQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_2515.setTransform(404.5,437.3,0.5,0.5);

	this.shape_2516 = new cjs.Shape();
	this.shape_2516.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAg/AfgnQAhgnA0gBQAxABAbAhQAbAhAAA5IAAATIjBAAQABA5AZAdQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgSACQgVAEgWAAQg6ABghglgAg2hcQgXAZgFAyICnAAQgBgwgUgaQgUgaglAAQgmAAgXAZg");
	this.shape_2516.setTransform(391.7,437.3,0.5,0.5);

	this.shape_2517 = new cjs.Shape();
	this.shape_2517.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAeQgZAfAAA5QAAA4AZAeQAaAfAtAAQAlAAAfgOIAAAYQgaAMgqAAQg5AAggglg");
	this.shape_2517.setTransform(378.9,437.3,0.5,0.5);

	this.shape_2518 = new cjs.Shape();
	this.shape_2518.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_2518.setTransform(368.5,437.1,0.5,0.5);

	this.shape_2519 = new cjs.Shape();
	this.shape_2519.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQASASAjAAQAvAAAYgYQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAAAhjg");
	this.shape_2519.setTransform(355,437.4,0.5,0.5);

	this.shape_2520 = new cjs.Shape();
	this.shape_2520.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4gBQgjAAgcgRgAhFhXQgYAgAAA3QAAA4AZAeQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2520.setTransform(340.1,437.3,0.5,0.5);

	this.shape_2521 = new cjs.Shape();
	this.shape_2521.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgXQAAgUgRgNQgPgOgngOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAKAAAUQAAAVAPANQAQANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2521.setTransform(326.6,437.3,0.5,0.5);

	this.shape_2522 = new cjs.Shape();
	this.shape_2522.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgnA1gBQAwABAcAhQAcAiAAA4IAAATIjDAAQAAA3AbAfQAZAdAuAAQAZAAAQgDQASgEAagLIAAAXQgVALgVACQgUAEgXAAQg5ABghglgAg3hcQgYAagDAxICmAAQAAgxgVgZQgUgagkAAQgmAAgYAZg");
	this.shape_2522.setTransform(307.2,437.3,0.5,0.5);

	this.shape_2523 = new cjs.Shape();
	this.shape_2523.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgRgggBQgqAAgUAYQgTAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_2523.setTransform(289,437.1,0.5,0.5);

	this.shape_2524 = new cjs.Shape();
	this.shape_2524.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_2524.setTransform(270.4,437.3,0.5,0.5);

	this.shape_2525 = new cjs.Shape();
	this.shape_2525.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2525.setTransform(258.1,437.3,0.5,0.5);

	this.shape_2526 = new cjs.Shape();
	this.shape_2526.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgUACQgVAEgWAAQg5ABgiglgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgUgaglAAQglAAgZAZg");
	this.shape_2526.setTransform(238.6,437.3,0.5,0.5);

	this.shape_2527 = new cjs.Shape();
	this.shape_2527.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgZAXgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_2527.setTransform(224.2,434.3,0.5,0.5);

	this.shape_2528 = new cjs.Shape();
	this.shape_2528.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2528.setTransform(212.1,435.7,0.5,0.5);

	this.shape_2529 = new cjs.Shape();
	this.shape_2529.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA4IAAATIjDAAQAAA3AbAfQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgTACQgVAEgWAAQg6ABghglgAg3hcQgYAagDAxICmAAQAAgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_2529.setTransform(194.4,437.3,0.5,0.5);

	this.shape_2530 = new cjs.Shape();
	this.shape_2530.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2530.setTransform(181.4,437.3,0.5,0.5);

	this.shape_2531 = new cjs.Shape();
	this.shape_2531.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQASASAjAAQAwAAAXgYQAWgYAAg3IAAiVIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhDAAQhbAAgBhjg");
	this.shape_2531.setTransform(168,437.4,0.5,0.5);

	this.shape_2532 = new cjs.Shape();
	this.shape_2532.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4gBQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2532.setTransform(146.4,437.3,0.5,0.5);

	this.shape_2533 = new cjs.Shape();
	this.shape_2533.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2533.setTransform(134.5,435.7,0.5,0.5);

	this.shape_2534 = new cjs.Shape();
	this.shape_2534.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_2534.setTransform(115.8,434.5,0.5,0.5);

	this.shape_2535 = new cjs.Shape();
	this.shape_2535.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAggmQAfgnA1gBQAxABAbAhQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgTACQgWAEgWAAQg5ABgiglgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgUgaglAAQglAAgZAZg");
	this.shape_2535.setTransform(101.6,437.3,0.5,0.5);

	this.shape_2536 = new cjs.Shape();
	this.shape_2536.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_2536.setTransform(86.6,434.5,0.5,0.5);

	this.shape_2537 = new cjs.Shape();
	this.shape_2537.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBcAAgBBjIAACwg");
	this.shape_2537.setTransform(72,437.1,0.5,0.5);

	this.shape_2538 = new cjs.Shape();
	this.shape_2538.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgnA1gBQAvABAcAhQAcAhgBA5IAAATIjCAAQACA5AYAdQAaAdAuAAQAZAAAQgDQATgEAagLIAAAXQgXALgUACQgUAEgXAAQg5ABgiglgAg2hcQgYAagEAxICmAAQABgwgVgaQgUgagkAAQgnAAgXAZg");
	this.shape_2538.setTransform(57.4,437.3,0.5,0.5);

	this.shape_2539 = new cjs.Shape();
	this.shape_2539.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2539.setTransform(45.9,435.7,0.5,0.5);

	this.shape_2540 = new cjs.Shape();
	this.shape_2540.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgXQAAgUgRgNQgPgOgngOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAKAAAUQAAAVAPANQAQANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2540.setTransform(731.5,399,0.5,0.5);

	this.shape_2541 = new cjs.Shape();
	this.shape_2541.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2541.setTransform(721.2,397.5,0.5,0.5);

	this.shape_2542 = new cjs.Shape();
	this.shape_2542.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgPgOgngOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTAKAAAUQAAAVAPANQAPANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2542.setTransform(711.1,399,0.5,0.5);

	this.shape_2543 = new cjs.Shape();
	this.shape_2543.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAGAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2543.setTransform(702.4,396.5,0.5,0.5);

	this.shape_2544 = new cjs.Shape();
	this.shape_2544.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgRgUg");
	this.shape_2544.setTransform(695,397.5,0.5,0.5);

	this.shape_2545 = new cjs.Shape();
	this.shape_2545.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2545.setTransform(686.9,398.9,0.5,0.5);

	this.shape_2546 = new cjs.Shape();
	this.shape_2546.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2546.setTransform(673.8,399,0.5,0.5);

	this.shape_2547 = new cjs.Shape();
	this.shape_2547.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA5IAAATIjDAAQABA5AaAdQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgSACQgWAEgVAAQg6ABghglgAg3hcQgYAbgDAwICnAAQgBgwgUgaQgUgaglAAQgmAAgYAZg");
	this.shape_2547.setTransform(653.9,399,0.5,0.5);

	this.shape_2548 = new cjs.Shape();
	this.shape_2548.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAWgLAjAAQBcAAgBBiIAACxg");
	this.shape_2548.setTransform(639.4,396.1,0.5,0.5);

	this.shape_2549 = new cjs.Shape();
	this.shape_2549.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_2549.setTransform(627.4,397.5,0.5,0.5);

	this.shape_2550 = new cjs.Shape();
	this.shape_2550.graphics.f("#000000").s().p("AgdA/QAThEAIg4IAdAAIADAFQgTBAgYA3g");
	this.shape_2550.setTransform(613.5,405.9,0.5,0.5);

	this.shape_2551 = new cjs.Shape();
	this.shape_2551.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2551.setTransform(605.2,399,0.5,0.5);

	this.shape_2552 = new cjs.Shape();
	this.shape_2552.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgPgOgngOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTAKAAAUQAAAVAPANQAPANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2552.setTransform(593.3,399,0.5,0.5);

	this.shape_2553 = new cjs.Shape();
	this.shape_2553.graphics.f("#000000").s().p("AhNBoQghglAAhBQAAhAAggmQAggnA1gBQAxABAbAhQAbAiAAA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgWALgVACQgVAEgWAAQg5ABgiglgAg2hcQgZAagDAxICmAAQAAgwgUgaQgUgaglAAQgmAAgXAZg");
	this.shape_2553.setTransform(580.5,399,0.5,0.5);

	this.shape_2554 = new cjs.Shape();
	this.shape_2554.graphics.f("#000000").s().p("Ag/BnQgigjABhDQAAhBAigmQAigmA6AAQAjAAAhANIgHAVQglgLgZAAQgwAAgaAeQgaAfABA5QgBA4AaAeQAbAfAsAAQAlAAAfgOIAAAYQgbAMgoAAQg6AAggglg");
	this.shape_2554.setTransform(567.7,399,0.5,0.5);

	this.shape_2555 = new cjs.Shape();
	this.shape_2555.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAmg4gBQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2555.setTransform(553.9,399,0.5,0.5);

	this.shape_2556 = new cjs.Shape();
	this.shape_2556.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2556.setTransform(542.3,398.9,0.5,0.5);

	this.shape_2557 = new cjs.Shape();
	this.shape_2557.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_2557.setTransform(529.3,401.9,0.5,0.5);

	this.shape_2558 = new cjs.Shape();
	this.shape_2558.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigUQgXgKgNgVQgOgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgOAIgIAKQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_2558.setTransform(508,401.9,0.5,0.5);

	this.shape_2559 = new cjs.Shape();
	this.shape_2559.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgXAYQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_2559.setTransform(493.9,398.9,0.5,0.5);

	this.shape_2560 = new cjs.Shape();
	this.shape_2560.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2560.setTransform(483.4,396.5,0.5,0.5);

	this.shape_2561 = new cjs.Shape();
	this.shape_2561.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpByIBzCcg");
	this.shape_2561.setTransform(475.5,396.1,0.5,0.5);

	this.shape_2562 = new cjs.Shape();
	this.shape_2562.graphics.f("#000000").s().p("AhOB4QgXgUAAglQABgnAggWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgWALgbAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAagZQAYgZAAgsIAAgag");
	this.shape_2562.setTransform(461,399,0.5,0.5);

	this.shape_2563 = new cjs.Shape();
	this.shape_2563.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgRgggBQgqAAgTAYQgUAWAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrABgTAYQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_2563.setTransform(443.5,398.9,0.5,0.5);

	this.shape_2564 = new cjs.Shape();
	this.shape_2564.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggnA1gBQAwABAbAhQAcAiAAA4IAAATIjBAAQgBA3AaAfQAaAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgUACQgUAEgWAAQg6ABgiglgAg2hcQgZAagDAxICmAAQAAgxgVgZQgTgaglAAQgmAAgXAZg");
	this.shape_2564.setTransform(418.6,399,0.5,0.5);

	this.shape_2565 = new cjs.Shape();
	this.shape_2565.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_2565.setTransform(404.1,396.1,0.5,0.5);

	this.shape_2566 = new cjs.Shape();
	this.shape_2566.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgQAGgYAAQgjAAgSgUg");
	this.shape_2566.setTransform(392.1,397.5,0.5,0.5);

	this.shape_2567 = new cjs.Shape();
	this.shape_2567.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgNAHgJALQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_2567.setTransform(374.7,401.9,0.5,0.5);

	this.shape_2568 = new cjs.Shape();
	this.shape_2568.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_2568.setTransform(360.6,398.9,0.5,0.5);

	this.shape_2569 = new cjs.Shape();
	this.shape_2569.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2569.setTransform(350.1,396.5,0.5,0.5);

	this.shape_2570 = new cjs.Shape();
	this.shape_2570.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_2570.setTransform(343.1,398.9,0.5,0.5);

	this.shape_2571 = new cjs.Shape();
	this.shape_2571.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARASAkAAQAwAAAXgYQAWgYAAg3IAAiVIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAAAhjg");
	this.shape_2571.setTransform(329.7,399.1,0.5,0.5);

	this.shape_2572 = new cjs.Shape();
	this.shape_2572.graphics.f("#000000").s().p("AiJC2IAAlrIBiAAQBWAAAuAuQAtAtAABYQAABagwAvQgwAvhcAAgAhwCgIA8AAQCiAAAAihQAAhPgngnQgogohMAAIhDAAg");
	this.shape_2572.setTransform(313.7,396.7,0.5,0.5);

	this.shape_2573 = new cjs.Shape();
	this.shape_2573.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_2573.setTransform(294.6,404.8,0.5,0.5);

	this.shape_2574 = new cjs.Shape();
	this.shape_2574.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2574.setTransform(287.5,398.9,0.5,0.5);

	this.shape_2575 = new cjs.Shape();
	this.shape_2575.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAhAAhgmQAfgnA1gBQAwABAcAhQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgUACQgVAEgWAAQg5ABgiglgAg3hcQgXAagEAxICmAAQAAgxgUgZQgUgaglAAQgmAAgYAZg");
	this.shape_2575.setTransform(274.6,399,0.5,0.5);

	this.shape_2576 = new cjs.Shape();
	this.shape_2576.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAQgZAXgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_2576.setTransform(260.2,396.1,0.5,0.5);

	this.shape_2577 = new cjs.Shape();
	this.shape_2577.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2577.setTransform(248.1,397.5,0.5,0.5);

	this.shape_2578 = new cjs.Shape();
	this.shape_2578.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAhAAggmQAhgnA0gBQAwABAcAhQAcAiAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgWALgVACQgUAEgXAAQg5ABgiglgAg3hcQgXAagEAxICmAAQAAgxgUgZQgUgaglAAQgmAAgYAZg");
	this.shape_2578.setTransform(237.1,399,0.5,0.5);

	this.shape_2579 = new cjs.Shape();
	this.shape_2579.graphics.f("#000000").s().p("AhdCzQgdgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigUQgXgKgNgVQgOgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgOAIgIAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgiAXQgkAXg+AAQg0AAgbgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgSATg");
	this.shape_2579.setTransform(223.4,401.9,0.5,0.5);

	this.shape_2580 = new cjs.Shape();
	this.shape_2580.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4gBQgjAAgcgRgAhFhXQgYAgAAA3QAAA4AZAeQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2580.setTransform(209.2,399,0.5,0.5);

	this.shape_2581 = new cjs.Shape();
	this.shape_2581.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_2581.setTransform(197.3,397.5,0.5,0.5);

	this.shape_2582 = new cjs.Shape();
	this.shape_2582.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhBAhgmQAfgkA3gBQA5AAAfAmQAgAmAABAQAABCghAlQgfAmg4gBQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAfQAZAgArAAQAtAAAYggQAZgfAAg3QAAg3gZggQgYgegtAAQgtAAgXAeg");
	this.shape_2582.setTransform(179.1,399,0.5,0.5);

	this.shape_2583 = new cjs.Shape();
	this.shape_2583.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_2583.setTransform(168.8,396.5,0.5,0.5);

	this.shape_2584 = new cjs.Shape();
	this.shape_2584.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAVALQAXALAQAaIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgXAeABA7QAABzBYAAQAuAAAVgaQAWgcAAg8IAAgFQAAg+gVgbQgWgbguAAQgsAAgWAfg");
	this.shape_2584.setTransform(157.9,396.2,0.5,0.5);

	this.shape_2585 = new cjs.Shape();
	this.shape_2585.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQASASAjAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_2585.setTransform(143.1,399.1,0.5,0.5);

	this.shape_2586 = new cjs.Shape();
	this.shape_2586.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_2586.setTransform(131.2,397.5,0.5,0.5);

	this.shape_2587 = new cjs.Shape();
	this.shape_2587.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgXQAAgTgRgOQgQgOgmgOQgogOgQgKQgRgLgIgOQgIgNgBgTQAAgeAagSQAagSAtAAQArAAAnARIgJAXQgngRgiAAQghAAgTALQgTAKAAAUQgBAVAPANQAPAMArAQQAjAMATALQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_2587.setTransform(121.1,399,0.5,0.5);

	this.shape_2588 = new cjs.Shape();
	this.shape_2588.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAg/AfgnQAhgnA1gBQAwABAbAhQAbAhAAA5IAAATIjBAAQABA5AZAdQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgSACQgVAEgWAAQg6ABghglgAg2hcQgXAZgFAyICnAAQgBgwgUgaQgUgagkAAQgnAAgXAZg");
	this.shape_2588.setTransform(101.6,399,0.5,0.5);

	this.shape_2589 = new cjs.Shape();
	this.shape_2589.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_2589.setTransform(87.2,396.1,0.5,0.5);

	this.shape_2590 = new cjs.Shape();
	this.shape_2590.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_2590.setTransform(75.1,397.5,0.5,0.5);

	this.shape_2591 = new cjs.Shape();
	this.shape_2591.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgeAAgLARQgLARAAAmIAAAZIA+AAIAAAWIg+AAIAAD4g");
	this.shape_2591.setTransform(61.5,396,0.5,0.5);

	this.shape_2592 = new cjs.Shape();
	this.shape_2592.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4gBQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAeQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg4gZgfQgZgegsAAQgtAAgYAeg");
	this.shape_2592.setTransform(49.3,399,0.5,0.5);

	this.shape_2593 = new cjs.Shape();
	this.shape_2593.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgXQAAgUgQgNQgRgOgmgOQgogOgQgKQgRgLgIgOQgIgNAAgTQgBgeAagSQAagSAsAAQAsAAAoARIgJAXQgogRgjAAQggAAgTALQgTAKAAAUQAAAVAOANQAPAMAsAQQAkANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2593.setTransform(725.6,360.8,0.5,0.5);

	this.shape_2594 = new cjs.Shape();
	this.shape_2594.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgnA0gBQAwABAcAhQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6ABghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgaglAAQgmAAgXAZg");
	this.shape_2594.setTransform(712.7,360.8,0.5,0.5);

	this.shape_2595 = new cjs.Shape();
	this.shape_2595.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2595.setTransform(702.9,358.3,0.5,0.5);

	this.shape_2596 = new cjs.Shape();
	this.shape_2596.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfALAPQALAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_2596.setTransform(695.5,359.2,0.5,0.5);

	this.shape_2597 = new cjs.Shape();
	this.shape_2597.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_2597.setTransform(688.6,358.3,0.5,0.5);

	this.shape_2598 = new cjs.Shape();
	this.shape_2598.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2598.setTransform(682.8,357.8,0.5,0.5);

	this.shape_2599 = new cjs.Shape();
	this.shape_2599.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2599.setTransform(677,358.3,0.5,0.5);

	this.shape_2600 = new cjs.Shape();
	this.shape_2600.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAWgLQAWgMAdAAQA4AAAeAkQAcAkAABDQAABEgeAkQgfAlg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA8AWAcQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_2600.setTransform(666.9,358,0.5,0.5);

	this.shape_2601 = new cjs.Shape();
	this.shape_2601.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_2601.setTransform(656.1,358.3,0.5,0.5);

	this.shape_2602 = new cjs.Shape();
	this.shape_2602.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgXQAAgUgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTAKAAAUQAAAVAPANQAPANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2602.setTransform(647.2,360.8,0.5,0.5);

	this.shape_2603 = new cjs.Shape();
	this.shape_2603.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_2603.setTransform(633.9,360.6,0.5,0.5);

	this.shape_2604 = new cjs.Shape();
	this.shape_2604.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOghAAgpQAAhBAggmQAhgkA2gBQA5AAAfAmQAgAmAABAQAABCggAlQghAmg3gBQgjAAgcgRgAhFhXQgYAfAAA4QAAA3AYAfQAaAgArAAQAtAAAZggQAYgfAAg3QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_2604.setTransform(618.8,360.8,0.5,0.5);

	this.shape_2605 = new cjs.Shape();
	this.shape_2605.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_2605.setTransform(604.1,363.7,0.5,0.5);

	this.shape_2606 = new cjs.Shape();
	this.shape_2606.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNABgXQAAgUgRgNQgQgOgmgOQgogOgRgKQgQgMgIgNQgIgNAAgTQAAgeAZgSQAagSAtAAQAsAAAnARIgJAXQgogRgiAAQghAAgTALQgUAKAAAUQAAAVAPANQAPANAsAPQAiAMATALQAQALAJAOQAIAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_2606.setTransform(590.1,360.8,0.5,0.5);

	this.shape_2607 = new cjs.Shape();
	this.shape_2607.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgnA0gBQAxABAbAhQAbAhAAA5IAAATIjBAAQABA5AZAdQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgXALgUACQgVAEgVAAQg6ABgiglgAg3hcQgXAbgEAwICnAAQgBgwgUgaQgUgaglAAQglAAgZAZg");
	this.shape_2607.setTransform(577.3,360.8,0.5,0.5);

	this.shape_2608 = new cjs.Shape();
	this.shape_2608.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_2608.setTransform(566.2,360.6,0.5,0.5);

	this.shape_2609 = new cjs.Shape();
	this.shape_2609.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgnA0gBQAwABAcAhQAbAhAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgYALgTACQgVAEgVAAQg6ABghglgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgUgaglAAQgmAAgXAZg");
	this.shape_2609.setTransform(546.7,360.8,0.5,0.5);

	this.shape_2610 = new cjs.Shape();
	this.shape_2610.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_2610.setTransform(532.3,357.8,0.5,0.5);

	this.shape_2611 = new cjs.Shape();
	this.shape_2611.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_2611.setTransform(520.3,359.2,0.5,0.5);

	this.shape_2612 = new cjs.Shape();
	this.shape_2612.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_2612.setTransform(501.5,358,0.5,0.5);

	this.shape_2613 = new cjs.Shape();
	this.shape_2613.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgnA1gBQAvABAcAhQAcAhgBA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAZAAAPgDQATgEAagLIAAAXQgXALgUACQgUAEgWAAQg6ABgiglgAg2hcQgYAZgEAyICmAAQABgwgVgaQgUgagkAAQgmAAgYAZg");
	this.shape_2613.setTransform(487.4,360.8,0.5,0.5);

	this.shape_2614 = new cjs.Shape();
	this.shape_2614.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_2614.setTransform(476.3,360.6,0.5,0.5);

	this.shape_2615 = new cjs.Shape();
	this.shape_2615.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2615.setTransform(463.2,360.8,0.5,0.5);

	this.shape_2616 = new cjs.Shape();
	this.shape_2616.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_2616.setTransform(449.5,357.8,0.5,0.5);

	this.shape_2617 = new cjs.Shape();
	this.shape_2617.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgXQAAgUgQgNQgSgOglgOQgngOgRgKQgRgLgIgOQgJgNAAgTQAAgeAagSQAagSAsAAQAtAAAmARIgJAXQgngRgjAAQggAAgTALQgUAKAAAUQABAVAPANQAOAMArAQQAjAMATALQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_2617.setTransform(435.9,360.8,0.5,0.5);

	this.shape_2618 = new cjs.Shape();
	this.shape_2618.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_2618.setTransform(420.5,357.8,0.5,0.5);

	this.shape_2619 = new cjs.Shape();
	this.shape_2619.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggnA2gBQAvABAcAhQAcAigBA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQAUgEAZgLIAAAXQgXALgUACQgUAEgXAAQg5ABgiglgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgVgagjAAQgnAAgXAZg");
	this.shape_2619.setTransform(410.6,360.8,0.5,0.5);

	this.shape_2620 = new cjs.Shape();
	this.shape_2620.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgZAXgKQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_2620.setTransform(396.2,357.8,0.5,0.5);

	this.shape_2621 = new cjs.Shape();
	this.shape_2621.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAjAAAgANIgGAVQgkgLgZAAQgxAAgaAeQgZAfAAA5QAAA4AZAeQAaAfAtAAQAlAAAfgOIAAAYQgaAMgqAAQg5AAggglg");
	this.shape_2621.setTransform(382.8,360.8,0.5,0.5);

	this.shape_2622 = new cjs.Shape();
	this.shape_2622.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAGAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_2622.setTransform(373.6,358.3,0.5,0.5);

	this.shape_2623 = new cjs.Shape();
	this.shape_2623.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlQIgCAAIACBAIAAEQIgZAAIAAlrIAoAAICAE/IABAAICCk/IAmAAIAAFrg");
	this.shape_2623.setTransform(359.7,358.4,0.5,0.5);

	this.shape_2624 = new cjs.Shape();
	this.shape_2624.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_2624.setTransform(334.1,358,0.5,0.5);

	this.shape_2625 = new cjs.Shape();
	this.shape_2625.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_2625.setTransform(319.5,360.6,0.5,0.5);

	this.shape_2626 = new cjs.Shape();
	this.shape_2626.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgUAKQgYALgaAAQgoAAgXgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQARAOAbAAQAqAAAagZQAYgZAAgsIAAgag");
	this.shape_2626.setTransform(304.7,360.8,0.5,0.5);

	this.shape_2627 = new cjs.Shape();
	this.shape_2627.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNABgXQAAgUgRgNQgQgOgmgOQgogOgRgKQgPgLgJgOQgIgNAAgTQgBgeAagSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAOANQAQANArAPQAkAOARAJQARAMAHANQAJAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_2627.setTransform(285.7,360.8,0.5,0.5);

	this.shape_2628 = new cjs.Shape();
	this.shape_2628.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgWAYQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_2628.setTransform(272.4,360.6,0.5,0.5);

	this.shape_2629 = new cjs.Shape();
	this.shape_2629.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAGAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_2629.setTransform(261.9,358.3,0.5,0.5);

	this.shape_2630 = new cjs.Shape();
	this.shape_2630.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICIiXIAeAAIhpByIByCcg");
	this.shape_2630.setTransform(254,357.8,0.5,0.5);

	this.shape_2631 = new cjs.Shape();
	this.shape_2631.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgSgUg");
	this.shape_2631.setTransform(242.3,359.2,0.5,0.5);

	this.shape_2632 = new cjs.Shape();
	this.shape_2632.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_2632.setTransform(231,360.8,0.5,0.5);

	this.shape_2633 = new cjs.Shape();
	this.shape_2633.graphics.f("#000000").s().p("ABdC2IhPkYQgLgjgDgWQgGAegGAUIhQEfIgVAAIhllrIAbAAIBVFDQAGgjAUhFIA+jbIAbAAIBJD8QALAoAHAfIAIgmIBNkdIAaAAIhlFrg");
	this.shape_2633.setTransform(213.3,358.4,0.5,0.5);

	this.shape_2634 = new cjs.Shape();
	this.shape_2634.graphics.f("#000000").s().p("AgdA/QAThEAIg4IAdAAIADAFQgTBAgYA3g");
	this.shape_2634.setTransform(192.1,367.7,0.5,0.5);

	this.shape_2635 = new cjs.Shape();
	this.shape_2635.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_2635.setTransform(185.7,360.6,0.5,0.5);

	this.shape_2636 = new cjs.Shape();
	this.shape_2636.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggnA0gBQAxABAbAhQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgWAEgWAAQg5ABghglgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgaglAAQgmAAgYAZg");
	this.shape_2636.setTransform(172.9,360.8,0.5,0.5);

	this.shape_2637 = new cjs.Shape();
	this.shape_2637.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAGAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_2637.setTransform(163,358.3,0.5,0.5);

	this.shape_2638 = new cjs.Shape();
	this.shape_2638.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2638.setTransform(157.2,357.8,0.5,0.5);

	this.shape_2639 = new cjs.Shape();
	this.shape_2639.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA5IAAATIjCAAQABA5AZAdQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgSACQgWAEgVAAQg6ABghglgAg3hcQgYAbgDAwICnAAQgBgwgUgaQgUgaglAAQgmAAgYAZg");
	this.shape_2639.setTransform(147.4,360.8,0.5,0.5);

	this.shape_2640 = new cjs.Shape();
	this.shape_2640.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2640.setTransform(135.9,359.2,0.5,0.5);

	this.shape_2641 = new cjs.Shape();
	this.shape_2641.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgyCBIgdAAICSltIAQAAICPFtgAgNhjIgyCCICAAAIhAitQgFAXgJAUg");
	this.shape_2641.setTransform(124.2,358.4,0.5,0.5);

	this.shape_2642 = new cjs.Shape();
	this.shape_2642.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgnA1gBQAwABAcAhQAcAiAAA4IAAATIjDAAQAAA3AbAfQAZAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgWALgVACQgUAEgXAAQg5ABghglgAg3hcQgXAagEAxICmAAQAAgxgUgZQgVgagkAAQgmAAgYAZg");
	this.shape_2642.setTransform(102.9,360.8,0.5,0.5);

	this.shape_2643 = new cjs.Shape();
	this.shape_2643.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgZAYgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_2643.setTransform(88.5,357.8,0.5,0.5);

	this.shape_2644 = new cjs.Shape();
	this.shape_2644.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAASgEIAAAUQgQAGgZAAQgiAAgRgUg");
	this.shape_2644.setTransform(76.4,359.2,0.5,0.5);

	this.shape_2645 = new cjs.Shape();
	this.shape_2645.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_2645.setTransform(61.2,359.2,0.5,0.5);

	this.shape_2646 = new cjs.Shape();
	this.shape_2646.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhjIgzCCICBAAIhAitQgIAcgGAPg");
	this.shape_2646.setTransform(49.5,358.4,0.5,0.5);

	this.instance_10 = new lib.red_necklace();
	this.instance_10.parent = this;
	this.instance_10.setTransform(939,253,0.644,0.644);

	this.shape_2647 = new cjs.Shape();
	this.shape_2647.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_2647.setTransform(593.9,815.5,0.5,0.5);

	this.shape_2648 = new cjs.Shape();
	this.shape_2648.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_2648.setTransform(589.2,808.7,0.5,0.5);

	this.shape_2649 = new cjs.Shape();
	this.shape_2649.graphics.f("#000000").s().p("Ag8BSQgagdABgzQAAgyAZgeQAYgfApAAQAnAAAVAaQAWAagBAtIAAAPIiYAAQABAsAUAWQAUAXAlABQATgBAMgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQguAAgagcgAgqhHQgTATgDAmICCAAQAAgkgQgVQgQgVgdAAQgdAAgSAVg");
	this.shape_2649.setTransform(581.5,811,0.5,0.5);

	this.shape_2650 = new cjs.Shape();
	this.shape_2650.graphics.f("#000000").s().p("ABACYIAAiKQAAgfgNgPQgNgOgdAAQgkAAgTATQgRAUAAAqIAAB1IgUAAIAAkvIAUAAIgBB7IABAAQANgTARgIQATgIAZgBQBJAAAABNIAACLg");
	this.shape_2650.setTransform(570.1,808.7,0.5,0.5);

	this.shape_2651 = new cjs.Shape();
	this.shape_2651.graphics.f("#000000").s().p("AgyBSQgZgdAAgzQAAg1AagcQAbgeAuAAQAcAAAYAJIgFARQgbgIgVgBQgmAAgUAYQgUAZAAAsQAAAqAUAZQAUAYAjABQAcAAAagKIAAARQgUAKghAAQgsAAgbgcg");
	this.shape_2651.setTransform(559.7,811,0.5,0.5);

	this.shape_2652 = new cjs.Shape();
	this.shape_2652.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh9QgBgTAMAAQAGAAADAEQAEAGgBAJQABAIgEAFQgDAGgGAAQgMgBABgSg");
	this.shape_2652.setTransform(552.4,809,0.5,0.5);

	this.shape_2653 = new cjs.Shape();
	this.shape_2653.graphics.f("#000000").s().p("ABwCPIAAjYQAAgZACgWIgBAAIhrEHIgMAAIhqkHIgCAAIACAxIAADWIgTAAIAAkdIAfAAIBkD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_2653.setTransform(541.5,809.1,0.5,0.5);

	this.shape_2654 = new cjs.Shape();
	this.shape_2654.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAIgFAGgKQAGgLAIgUIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_2654.setTransform(523.1,813.4,0.5,0.5);

	this.shape_2655 = new cjs.Shape();
	this.shape_2655.graphics.f("#000000").s().p("AgyBSQgZgdAAgzQAAg0AagdQAbgeAuAAQAcAAAYAJIgFARQgbgIgUgBQgmAAgVAYQgUAZAAAsQAAAqAUAZQAVAYAiABQAcAAAagKIAAARQgUAKghAAQgtAAgagcg");
	this.shape_2655.setTransform(514,811,0.5,0.5);

	this.shape_2656 = new cjs.Shape();
	this.shape_2656.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_2656.setTransform(503.2,810.9,0.5,0.5);

	this.shape_2657 = new cjs.Shape();
	this.shape_2657.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgFgiIgBAAQgQAVgRAIQgQAJgXAAQgfAAgSgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_2657.setTransform(491.6,811,0.5,0.5);

	this.shape_2658 = new cjs.Shape();
	this.shape_2658.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_2658.setTransform(479.4,809.1,0.5,0.5);

	this.shape_2659 = new cjs.Shape();
	this.shape_2659.graphics.f("#000000").s().p("AhaCWIAAgRQAMADANAAQAJAAAIgEQAIgFAFgKQAGgIAJgXIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHALgLAFQgLAFgOAAQgLAAgOgEg");
	this.shape_2659.setTransform(462.4,813.4,0.5,0.5);

	this.shape_2660 = new cjs.Shape();
	this.shape_2660.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAcAAA1QAAA1gYAcQgXAdgrAAQgWAAgTgJgAg1gaQgQAWAAAwIAAADQAAAwARAVQAQAVAkAAQAiAAASgZQARgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_2660.setTransform(452.2,808.8,0.5,0.5);

	this.shape_2661 = new cjs.Shape();
	this.shape_2661.graphics.f("#000000").s().p("AgWAxIAVhhIAWAAIACAEQgOAygTArg");
	this.shape_2661.setTransform(439.3,804.4,0.5,0.5);

	this.shape_2662 = new cjs.Shape();
	this.shape_2662.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_2662.setTransform(432.7,809.1,0.5,0.5);

	this.shape_2663 = new cjs.Shape();
	this.shape_2663.graphics.f("#000000").s().p("AhGBsQgigngBhFQABgrAQghQAQghAggTQAfgSAoAAQApAAAiAQIgJASQgggQghAAQg0AAggAjQgeAiAAA7QAAA9AcAiQAeAiA0AAQAlAAAegKIAAASQgbAKgsAAQg7AAgjgng");
	this.shape_2663.setTransform(420.9,809.1,0.5,0.5);

	this.shape_2664 = new cjs.Shape();
	this.shape_2664.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBmAAIgohlIgLgiQgGAWgFAMg");
	this.shape_2664.setTransform(408.4,809.1,0.5,0.5);

	this.shape_2665 = new cjs.Shape();
	this.shape_2665.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_2665.setTransform(398,809.1,0.5,0.5);

	this.shape_2666 = new cjs.Shape();
	this.shape_2666.graphics.f("#000000").s().p("ABICPIhtiWIgmAgIAAB2IgUAAIAAkdIAUAAIAACTICOiTIAaAAIh0B5IB3Ckg");
	this.shape_2666.setTransform(387.3,809.1,0.5,0.5);

	this.shape_2667 = new cjs.Shape();
	this.shape_2667.graphics.f("#000000").s().p("AhGBsQgjgnABhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AdAiQAdAiA1AAQAmAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_2667.setTransform(374.6,809.1,0.5,0.5);

	this.shape_2668 = new cjs.Shape();
	this.shape_2668.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_2668.setTransform(363,809.1,0.5,0.5);

	this.shape_2669 = new cjs.Shape();
	this.shape_2669.graphics.f("#000000").s().p("ABUCPIioj9IgCAAIADBEIAAC5IgUAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_2669.setTransform(349.8,809.1,0.5,0.5);

	this.shape_2670 = new cjs.Shape();
	this.shape_2670.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_2670.setTransform(332.3,809.1,0.5,0.5);

	this.shape_2671 = new cjs.Shape();
	this.shape_2671.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_2671.setTransform(321.1,809.1,0.5,0.5);

	this.shape_2672 = new cjs.Shape();
	this.shape_2672.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2672.setTransform(313.4,809.1,0.5,0.5);

	this.shape_2673 = new cjs.Shape();
	this.shape_2673.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAYASAAAkQAAAZgOARQgPAQgdAFIAAABQAhAFAQAQQARAQAAAeQAAAngbAVQgbAWgtAAgAhJB9IBDAAQBOAAABhAQAAg7hUAAIg+AAgAhJgPIA+AAQAoAAASgNQATgOAAgcQAAgcgVgOQgUgMgoAAIg6AAg");
	this.shape_2673.setTransform(305.1,809.1,0.5,0.5);

	this.shape_2674 = new cjs.Shape();
	this.shape_2674.graphics.f("#000000").s().p("AhcBrQgjgnAAhEQAAhDAjgoQAignA6AAQA9AAAhAnQAiAogBBDQABBFgiAmQgiAog8AAQg7AAghgogAhNhdQgcAhAAA8QAAA8AcAjQAbAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgbAig");
	this.shape_2674.setTransform(290.7,809.1,0.5,0.5);

	this.shape_2675 = new cjs.Shape();
	this.shape_2675.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_2675.setTransform(278.7,809.1,0.5,0.5);

	this.shape_2676 = new cjs.Shape();
	this.shape_2676.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2676.setTransform(270.3,809.1,0.5,0.5);

	this.shape_2677 = new cjs.Shape();
	this.shape_2677.graphics.f("#000000").s().p("ABHCPIhJh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAaAUQAZATAAAoQAAAdgPATQgQATgeAIIBNCDgAhJABIA3AAQAjAAAUgPQATgQAAggQABgggUgPQgTgPgsAAIgvAAg");
	this.shape_2677.setTransform(262.6,809.1,0.5,0.5);

	this.shape_2678 = new cjs.Shape();
	this.shape_2678.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_2678.setTransform(250.6,809.1,0.5,0.5);

	this.shape_2679 = new cjs.Shape();
	this.shape_2679.graphics.f("#000000").s().p("AhrCPIAAkdIBMAAQBFAAAjAkQAjAkABBEQgBBHglAlQgmAlhIAAgAhXB9IAuAAQCAAAgBh+QAAg+gegeQgfgfg8AAIg0AAg");
	this.shape_2679.setTransform(233.5,809.1,0.5,0.5);

	this.shape_2680 = new cjs.Shape();
	this.shape_2680.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_2680.setTransform(218.8,809.1,0.5,0.5);

	this.shape_2681 = new cjs.Shape();
	this.shape_2681.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgnBlIBkAAIgyiHQgEARgHARg");
	this.shape_2681.setTransform(205.6,809.1,0.5,0.5);

	this.shape_2682 = new cjs.Shape();
	this.shape_2682.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_2682.setTransform(190.1,809.1,0.5,0.5);

	this.shape_2683 = new cjs.Shape();
	this.shape_2683.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgmhlQgGgNgHgVQgEARgGARg");
	this.shape_2683.setTransform(178.2,809.1,0.5,0.5);

	this.shape_2684 = new cjs.Shape();
	this.shape_2684.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_2684.setTransform(167,809.1,0.5,0.5);

	this.shape_2685 = new cjs.Shape();
	this.shape_2685.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgiAog8AAQg6AAgjgogAhNhdQgcAgAAA9QAAA9AcAiQAbAhAyAAQA0AAAbghQAbgiAAg9QAAg8gbgiQgbghg0AAQgyAAgbAig");
	this.shape_2685.setTransform(152.6,809.1,0.5,0.5);

	this.shape_2686 = new cjs.Shape();
	this.shape_2686.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQARghAfgTQAfgSAnAAQAqAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AdAiQAeAiA1AAQAkAAAegKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_2686.setTransform(139.1,809.1,0.5,0.5);

	this.shape_2687 = new cjs.Shape();
	this.shape_2687.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_2687.setTransform(122.3,809.1,0.5,0.5);

	this.shape_2688 = new cjs.Shape();
	this.shape_2688.graphics.f("#000000").s().p("AhOB1QgbgbAAgzIAAi3IAUAAIAAC4QAAAqAWAWQAXAXApAAQApAAAXgWQAWgXAAgoIAAi6IATAAIAAC4QABAygdAbQgcAbgzAAQgwAAgdgbg");
	this.shape_2688.setTransform(109.2,809.2,0.5,0.5);

	this.shape_2689 = new cjs.Shape();
	this.shape_2689.graphics.f("#000000").s().p("ABDCzIg3hBIgMAAQg7AAghgnQgjgmABhFQgBhFAjgmQAignA7AAQA7AAAiAnQAhAoAABDQABA5gZAmQgZAlgrALIBBBEgAhOh9QgbAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbghAAg+QAAg+gbggQgbghgzAAQgzAAgcAig");
	this.shape_2689.setTransform(94.3,810.7,0.5,0.5);

	this.shape_2690 = new cjs.Shape();
	this.shape_2690.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2690.setTransform(84.2,809.1,0.5,0.5);

	this.shape_2691 = new cjs.Shape();
	this.shape_2691.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_2691.setTransform(76.4,809.1,0.5,0.5);

	this.shape_2692 = new cjs.Shape();
	this.shape_2692.graphics.f("#000000").s().p("ABTCPIioj9IgBAAIADBEIAAC5IgUAAIAAkdIAUAAICoD8IACAAQgDgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_2692.setTransform(64,809.1,0.5,0.5);

	this.shape_2693 = new cjs.Shape();
	this.shape_2693.graphics.f("#000000").s().p("ABhCQIgnhmIh0AAIgnBmIgWAAIBykeIAMAAIBxEegAgKhNIgoBlIBlAAIgyiHQgFARgGARg");
	this.shape_2693.setTransform(50.8,809.1,0.5,0.5);

	this.shape_2694 = new cjs.Shape();
	this.shape_2694.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_2694.setTransform(43.3,804.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_2694},{t:this.shape_2693},{t:this.shape_2692},{t:this.shape_2691},{t:this.shape_2690},{t:this.shape_2689},{t:this.shape_2688},{t:this.shape_2687},{t:this.shape_2686},{t:this.shape_2685},{t:this.shape_2684},{t:this.shape_2683},{t:this.shape_2682},{t:this.shape_2681},{t:this.shape_2680},{t:this.shape_2679},{t:this.shape_2678},{t:this.shape_2677},{t:this.shape_2676},{t:this.shape_2675},{t:this.shape_2674},{t:this.shape_2673},{t:this.shape_2672},{t:this.shape_2671},{t:this.shape_2670},{t:this.shape_2669},{t:this.shape_2668},{t:this.shape_2667},{t:this.shape_2666},{t:this.shape_2665},{t:this.shape_2664},{t:this.shape_2663},{t:this.shape_2662},{t:this.shape_2661},{t:this.shape_2660},{t:this.shape_2659},{t:this.shape_2658},{t:this.shape_2657},{t:this.shape_2656},{t:this.shape_2655},{t:this.shape_2654},{t:this.shape_2653},{t:this.shape_2652},{t:this.shape_2651},{t:this.shape_2650},{t:this.shape_2649},{t:this.shape_2648},{t:this.shape_2647},{t:this.instance_10},{t:this.shape_2646},{t:this.shape_2645},{t:this.shape_2644},{t:this.shape_2643},{t:this.shape_2642},{t:this.shape_2641},{t:this.shape_2640},{t:this.shape_2639},{t:this.shape_2638},{t:this.shape_2637},{t:this.shape_2636},{t:this.shape_2635},{t:this.shape_2634},{t:this.shape_2633},{t:this.shape_2632},{t:this.shape_2631},{t:this.shape_2630},{t:this.shape_2629},{t:this.shape_2628},{t:this.shape_2627},{t:this.shape_2626},{t:this.shape_2625},{t:this.shape_2624},{t:this.shape_2623},{t:this.shape_2622},{t:this.shape_2621},{t:this.shape_2620},{t:this.shape_2619},{t:this.shape_2618},{t:this.shape_2617},{t:this.shape_2616},{t:this.shape_2615},{t:this.shape_2614},{t:this.shape_2613},{t:this.shape_2612},{t:this.shape_2611},{t:this.shape_2610},{t:this.shape_2609},{t:this.shape_2608},{t:this.shape_2607},{t:this.shape_2606},{t:this.shape_2605},{t:this.shape_2604},{t:this.shape_2603},{t:this.shape_2602},{t:this.shape_2601},{t:this.shape_2600},{t:this.shape_2599},{t:this.shape_2598},{t:this.shape_2597},{t:this.shape_2596},{t:this.shape_2595},{t:this.shape_2594},{t:this.shape_2593},{t:this.shape_2592},{t:this.shape_2591},{t:this.shape_2590},{t:this.shape_2589},{t:this.shape_2588},{t:this.shape_2587},{t:this.shape_2586},{t:this.shape_2585},{t:this.shape_2584},{t:this.shape_2583},{t:this.shape_2582},{t:this.shape_2581},{t:this.shape_2580},{t:this.shape_2579},{t:this.shape_2578},{t:this.shape_2577},{t:this.shape_2576},{t:this.shape_2575},{t:this.shape_2574},{t:this.shape_2573},{t:this.shape_2572},{t:this.shape_2571},{t:this.shape_2570},{t:this.shape_2569},{t:this.shape_2568},{t:this.shape_2567},{t:this.shape_2566},{t:this.shape_2565},{t:this.shape_2564},{t:this.shape_2563},{t:this.shape_2562},{t:this.shape_2561},{t:this.shape_2560},{t:this.shape_2559},{t:this.shape_2558},{t:this.shape_2557},{t:this.shape_2556},{t:this.shape_2555},{t:this.shape_2554},{t:this.shape_2553},{t:this.shape_2552},{t:this.shape_2551},{t:this.shape_2550},{t:this.shape_2549},{t:this.shape_2548},{t:this.shape_2547},{t:this.shape_2546},{t:this.shape_2545},{t:this.shape_2544},{t:this.shape_2543},{t:this.shape_2542},{t:this.shape_2541},{t:this.shape_2540},{t:this.shape_2539},{t:this.shape_2538},{t:this.shape_2537},{t:this.shape_2536},{t:this.shape_2535},{t:this.shape_2534},{t:this.shape_2533},{t:this.shape_2532},{t:this.shape_2531},{t:this.shape_2530},{t:this.shape_2529},{t:this.shape_2528},{t:this.shape_2527},{t:this.shape_2526},{t:this.shape_2525},{t:this.shape_2524},{t:this.shape_2523},{t:this.shape_2522},{t:this.shape_2521},{t:this.shape_2520},{t:this.shape_2519},{t:this.shape_2518},{t:this.shape_2517},{t:this.shape_2516},{t:this.shape_2515},{t:this.shape_2514},{t:this.shape_2513},{t:this.shape_2512},{t:this.shape_2511},{t:this.shape_2510},{t:this.shape_2509},{t:this.shape_2508},{t:this.shape_2507},{t:this.shape_2506},{t:this.shape_2505},{t:this.shape_2504},{t:this.shape_2503},{t:this.shape_2502},{t:this.shape_2501},{t:this.shape_2500},{t:this.shape_2499},{t:this.shape_2498},{t:this.shape_2497},{t:this.shape_2496},{t:this.shape_2495},{t:this.shape_2494},{t:this.shape_2493},{t:this.shape_2492},{t:this.shape_2491},{t:this.shape_2490},{t:this.shape_2489},{t:this.shape_2488},{t:this.shape_2487},{t:this.shape_2486},{t:this.shape_2485},{t:this.shape_2484},{t:this.shape_2483},{t:this.shape_2482},{t:this.shape_2481},{t:this.shape_2480},{t:this.shape_2479},{t:this.shape_2478},{t:this.shape_2477},{t:this.shape_2476},{t:this.shape_2475},{t:this.shape_2474},{t:this.shape_2473},{t:this.shape_2472},{t:this.shape_2471},{t:this.shape_2470},{t:this.shape_2469},{t:this.shape_2468},{t:this.shape_2467},{t:this.shape_2466},{t:this.shape_2465},{t:this.shape_2464},{t:this.shape_2463},{t:this.shape_2462},{t:this.shape_2461},{t:this.shape_2460},{t:this.shape_2459},{t:this.shape_2458},{t:this.shape_2457},{t:this.shape_2456},{t:this.shape_2455},{t:this.shape_2454},{t:this.shape_2453},{t:this.shape_2452},{t:this.shape_2451},{t:this.shape_2450},{t:this.shape_2449},{t:this.shape_2448},{t:this.shape_2447},{t:this.shape_2446},{t:this.shape_2445},{t:this.shape_2444},{t:this.shape_2443},{t:this.shape_2442},{t:this.shape_2441},{t:this.shape_2440},{t:this.shape_2439},{t:this.shape_2438}]},111).to({state:[]},1).wait(53));

	// ButtonLeftRight copy 40
	this.buttonR19 = new lib.ButtonLeft_Right();
	this.buttonR19.name = "buttonR19";
	this.buttonR19.parent = this;
	this.buttonR19.setTransform(2025,513.5,1,1,180);
	this.buttonR19._off = true;
	new cjs.ButtonHelper(this.buttonR19, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR19).wait(110).to({_off:false},0).to({_off:true},1).wait(54));

	// ButtonLeftRight copy 41
	this.buttonL19 = new lib.ButtonLeft_Right();
	this.buttonL19.name = "buttonL19";
	this.buttonL19.parent = this;
	this.buttonL19.setTransform(0,437.2);
	this.buttonL19._off = true;
	new cjs.ButtonHelper(this.buttonL19, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL19).wait(110).to({_off:false},0).to({_off:true},1).wait(54));

	// Layer 1
	this.instance_11 = new lib.green_necklace();
	this.instance_11.parent = this;
	this.instance_11.setTransform(888,166);

	this.shape_2695 = new cjs.Shape();
	this.shape_2695.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_2695.setTransform(503.5,801.9,0.5,0.5);

	this.shape_2696 = new cjs.Shape();
	this.shape_2696.graphics.f("#000000").s().p("AhLBhIAAgVQAgAQAkAAQAfAAAQgKQAQgKAAgSQABgQgNgLQgOgLgdgLQgegKgOgJQgNgIgGgKQgHgKAAgQQAAgYAUgNQAUgOAjAAQAkAAAdANIgHASQgggOgaAAQgYAAgQAJQgQAJAAAPQABARAMAKQALAKAiALQAbAKAOAJQANAIAHAKQAGALAAAOQAAAdgVAPQgVAPgoAAQgrAAgZgNg");
	this.shape_2696.setTransform(496.4,797.4,0.5,0.5);

	this.shape_2697 = new cjs.Shape();
	this.shape_2697.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQglAAgRATQgSATAAAsIAAB0IgTAAIAAjTIAQAAIADAdIABAAQAVghA0AAQBJAAgBBNIAACKg");
	this.shape_2697.setTransform(485.9,797.3,0.5,0.5);

	this.shape_2698 = new cjs.Shape();
	this.shape_2698.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgLh9QAAgTALAAQAGAAADAEQAEAGgBAJQABAIgEAFQgDAGgGAAQgLgBAAgSg");
	this.shape_2698.setTransform(477.7,795.4,0.5,0.5);

	this.shape_2699 = new cjs.Shape();
	this.shape_2699.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhTBaIBaB6g");
	this.shape_2699.setTransform(471.5,795.1,0.5,0.5);

	this.shape_2700 = new cjs.Shape();
	this.shape_2700.graphics.f("#000000").s().p("AgOB3QgNgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAHAMQAJAMASAAQATAAANgDIAAAPQgOAFgSAAQgbAAgOgPg");
	this.shape_2700.setTransform(462.3,796.2,0.5,0.5);

	this.shape_2701 = new cjs.Shape();
	this.shape_2701.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAbgQAvgBIApgBIAAgOQAAgegNgQQgMgPgbAAQgdAAgfAQIgIgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_2701.setTransform(453.4,797.4,0.5,0.5);

	this.shape_2702 = new cjs.Shape();
	this.shape_2702.graphics.f("#000000").s().p("ABJCPIhJkIIgJAnIg/DhIgRAAIhOkdIAUAAIBED9QAFgdAPg0IAwisIAVAAIA5DGQALAnAEAQIBCj9IAUAAIhOEdg");
	this.shape_2702.setTransform(439.6,795.5,0.5,0.5);

	this.shape_2703 = new cjs.Shape();
	this.shape_2703.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgbAAQgdAAggAQIgHgRQAjgQAhAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgtACgSAMQgTALAAAZQAAAUAMALQAMALAWAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_2703.setTransform(419.8,797.4,0.5,0.5);

	this.shape_2704 = new cjs.Shape();
	this.shape_2704.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAWAAQAMAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_2704.setTransform(411.6,797.3,0.5,0.5);

	this.shape_2705 = new cjs.Shape();
	this.shape_2705.graphics.f("#000000").s().p("AhCB/QgXgcABg0QgBg2AXgdQAXgdAsAAQAXAAAQAIQARAIANAVIABAAIgBgwIAAhNIATAAIAAEvIgMAAIgFggIgCAAQgYAkgtAAQgrAAgYgbgAgzgXQgRAXAAAvQAABaBFAAQAkAAAQgVQASgWgBgvIAAgDQAAgwgQgWQgRgWgkAAQgiAAgSAZg");
	this.shape_2705.setTransform(400.8,795.2,0.5,0.5);

	this.shape_2706 = new cjs.Shape();
	this.shape_2706.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgdAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAVghAzAAQBJAAAABNIAACKg");
	this.shape_2706.setTransform(389.3,797.3,0.5,0.5);

	this.shape_2707 = new cjs.Shape();
	this.shape_2707.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_2707.setTransform(377.7,797.4,0.5,0.5);

	this.shape_2708 = new cjs.Shape();
	this.shape_2708.graphics.f("#000000").s().p("ABCBqIhChfIhDBfIgVAAIBNhsIhKhnIAWAAIA/BZIA+hZIAVAAIhIBnIBOBsg");
	this.shape_2708.setTransform(367.8,797.4,0.5,0.5);

	this.shape_2709 = new cjs.Shape();
	this.shape_2709.graphics.f("#000000").s().p("Ag8BSQgagdABgzQAAgyAZgeQAYgfAqAAQAmAAAVAaQAWAagBAtIAAAPIiXAAQAAAsAUAWQAUAXAlABQAUgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQguAAgagcgAgqhHQgTATgEAmICDAAQAAgkgQgVQgQgVgcAAQgdAAgTAVg");
	this.shape_2709.setTransform(357.3,797.4,0.5,0.5);

	this.shape_2710 = new cjs.Shape();
	this.shape_2710.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_2710.setTransform(349.6,795.1,0.5,0.5);

	this.shape_2711 = new cjs.Shape();
	this.shape_2711.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgmhlIgNgiQgEAWgGAMg");
	this.shape_2711.setTransform(341.3,795.5,0.5,0.5);

	this.shape_2712 = new cjs.Shape();
	this.shape_2712.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAIgFAGgKQAGgLAIgUIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_2712.setTransform(325.5,799.8,0.5,0.5);

	this.shape_2713 = new cjs.Shape();
	this.shape_2713.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAbAAA2QAAA1gYAcQgYAdgqAAQgXAAgSgJgAg1gaQgQAVAAAxIAAADQAAAwAQAVQASAVAjAAQAiAAARgZQASgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_2713.setTransform(315.3,795.2,0.5,0.5);

	this.shape_2714 = new cjs.Shape();
	this.shape_2714.graphics.f("#000000").s().p("AgWAxQAGgTAFgcQAGgZAEgZIAWAAIADAEQgRA2gRAng");
	this.shape_2714.setTransform(302.4,790.8,0.5,0.5);

	this.shape_2715 = new cjs.Shape();
	this.shape_2715.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiIAAIAABsICAAAIAAASIiAAAIAAB6ICIAAIAAATg");
	this.shape_2715.setTransform(295.8,795.5,0.5,0.5);

	this.shape_2716 = new cjs.Shape();
	this.shape_2716.graphics.f("#000000").s().p("AhGBsQgjgnAAhFQAAgrARghQAQghAfgTQAggSAnAAQAqAAAiAQIgIASQghgQgiAAQg0AAgfAjQgfAiABA7QAAA9AdAiQAdAiA0AAQAlAAAdgKIAAASQgbAKgrAAQg8AAgigng");
	this.shape_2716.setTransform(284,795.5,0.5,0.5);

	this.shape_2717 = new cjs.Shape();
	this.shape_2717.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBykeIAMAAIBxEegAgKhNIgoBlIBlAAIgmhlQgGgNgGgVQgFARgGARg");
	this.shape_2717.setTransform(271.5,795.5,0.5,0.5);

	this.shape_2718 = new cjs.Shape();
	this.shape_2718.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_2718.setTransform(261.1,795.5,0.5,0.5);

	this.shape_2719 = new cjs.Shape();
	this.shape_2719.graphics.f("#000000").s().p("ABHCPIhsiWIgmAgIAAB2IgUAAIAAkdIAUAAIAACTICPiTIAZAAIh0B5IB3Ckg");
	this.shape_2719.setTransform(250.4,795.5,0.5,0.5);

	this.shape_2720 = new cjs.Shape();
	this.shape_2720.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQARghAfgTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA8AdAjQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_2720.setTransform(237.7,795.5,0.5,0.5);

	this.shape_2721 = new cjs.Shape();
	this.shape_2721.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_2721.setTransform(226.1,795.5,0.5,0.5);

	this.shape_2722 = new cjs.Shape();
	this.shape_2722.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_2722.setTransform(212.9,795.5,0.5,0.5);

	this.shape_2723 = new cjs.Shape();
	this.shape_2723.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQARghAfgTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA8AdAjQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_2723.setTransform(194.6,795.5,0.5,0.5);

	this.shape_2724 = new cjs.Shape();
	this.shape_2724.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2724.setTransform(185.6,795.5,0.5,0.5);

	this.shape_2725 = new cjs.Shape();
	this.shape_2725.graphics.f("#000000").s().p("ABUCPIipj9IgBAAIACBEIAAC5IgTAAIAAkdIAUAAICoD8IABAAQgCgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_2725.setTransform(175.8,795.5,0.5,0.5);

	this.shape_2726 = new cjs.Shape();
	this.shape_2726.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgUAAIAAkdIAUAAIAAB/IClAAIAAh/IAVAAIAAEdg");
	this.shape_2726.setTransform(161.4,795.5,0.5,0.5);

	this.shape_2727 = new cjs.Shape();
	this.shape_2727.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_2727.setTransform(149,795.5,0.5,0.5);

	this.shape_2728 = new cjs.Shape();
	this.shape_2728.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_2728.setTransform(138.7,795.5,0.5,0.5);

	this.shape_2729 = new cjs.Shape();
	this.shape_2729.graphics.f("#000000").s().p("AhsCPIAAkdIBOAAQBEAAAiAkQAkAkAABEQAABHgmAlQglAlhIAAgAhXB9IAvAAQB/AAAAh+QAAg+gfgeQgfgfg8AAIg0AAg");
	this.shape_2729.setTransform(120.9,795.5,0.5,0.5);

	this.shape_2730 = new cjs.Shape();
	this.shape_2730.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_2730.setTransform(108.3,795.5,0.5,0.5);

	this.shape_2731 = new cjs.Shape();
	this.shape_2731.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_2731.setTransform(97.2,795.5,0.5,0.5);

	this.shape_2732 = new cjs.Shape();
	this.shape_2732.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2732.setTransform(88,795.5,0.5,0.5);

	this.shape_2733 = new cjs.Shape();
	this.shape_2733.graphics.f("#000000").s().p("AhVCPIAAkdIBGAAQBlAAAABSQAAApgcAWQgcAWgzAAIgsAAIAAB2gAhBAHIAnAAQAwAAAVgPQAVgQAAgjQAAghgUgQQgVgQgpAAIgvAAg");
	this.shape_2733.setTransform(80.1,795.5,0.5,0.5);

	this.shape_2734 = new cjs.Shape();
	this.shape_2734.graphics.f("#000000").s().p("AhXCHIAAgTQAgANAvAAQAiAAAUgRQAVgPAAgbQAAgQgHgLQgGgKgQgJQgQgJgcgKQgtgOgQgSQgRgSAAgcQAAggAagUQAZgVAmAAQApAAAjAQIgIARQgjgPggAAQgfAAgTAPQgTAOAAAZQAAARAGAJQAFAKAOAJQANAIAfALQAgAKASAMQARAKAIAOQAHAOAAATQAAAkgaAVQgaAVgrAAQg1AAgbgMg");
	this.shape_2734.setTransform(68.3,795.5,0.5,0.5);

	this.shape_2735 = new cjs.Shape();
	this.shape_2735.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_2735.setTransform(55.6,795.5,0.5,0.5);

	this.shape_2736 = new cjs.Shape();
	this.shape_2736.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_2736.setTransform(45.9,795.5,0.5,0.5);

	this.shape_2737 = new cjs.Shape();
	this.shape_2737.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_2737.setTransform(41.9,790.8,0.5,0.5);

	this.shape_2738 = new cjs.Shape();
	this.shape_2738.graphics.f("#000000").s().p("AhqCLIAAgrQAWALAZAHQAYAGAYAAQAjAAAUgMQAUgMAAgXQAAgRgQgNQgQgNgrgRQgsgQgRgLQgTgNgHgOQgJgPAAgVQAAglAegVQAegWA0AAQAyAAAvAUIgRAmQgugUglABQggAAgQAKQgRALAAARQAAANAGAIQAGAJAOAHQAPAJAmAOQA3AUASATQATAUAAAfQAAAqggAXQgfAXg5AAQg8AAgigTg");
	this.shape_2738.setTransform(281.2,630.1,0.5,0.5);

	this.shape_2739 = new cjs.Shape();
	this.shape_2739.graphics.f("#000000").s().p("ABSCbIAAjEQAAglgRgTQgSgSgjAAQgvAAgXAaQgWAaAAA7IAACfIgvAAIAAkwIAnAAIAHAqIACAAQAOgXAagMQAZgMAfAAQA3AAAcAaQAbAaABA7IAADGg");
	this.shape_2739.setTransform(265.6,629.9,0.5,0.5);

	this.shape_2740 = new cjs.Shape();
	this.shape_2740.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgPQAAgQAIgIQAHgHALAAQAMAAAHAHQAIAIAAAQQAAAPgIAIQgHAHgMAAQgLAAgHgHg");
	this.shape_2740.setTransform(253.2,627.2,0.5,0.5);

	this.shape_2741 = new cjs.Shape();
	this.shape_2741.graphics.f("#000000").s().p("ABCDZIhqiQIgjAdIAABzIguAAIAAmwIAuAAIAADkQAAATgCAdIACAAQANgUAXgZIBihnIA3AAIh8CAICECwg");
	this.shape_2741.setTransform(243.2,626.9,0.5,0.5);

	this.shape_2742 = new cjs.Shape();
	this.shape_2742.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgXIArgSIAUhBIAaAAIAABGIBYAAIAAAkIhYAAIAACyQAAAcANAOQANAPAWABQAOAAAKgDIASgDIAAAjQgHAEgPACQgMACgOAAQhYAAAAhcg");
	this.shape_2742.setTransform(229.5,628.4,0.5,0.5);

	this.shape_2743 = new cjs.Shape();
	this.shape_2743.graphics.f("#000000").s().p("AhgCGQgZgXAAgrQAAhbCSgFIA0gCIAAgTQAAgjgPgSQgQgRgiAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAYQAaAZAAA1IAADPIgiAAIgJgrIgCAAQgYAcgWALQgYAKggAAQguAAgZgYgAAeAEQg2ADgZAOQgYAQAAAfQAAAZAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_2743.setTransform(216.2,630.1,0.5,0.5);

	this.shape_2744 = new cjs.Shape();
	this.shape_2744.graphics.f("#000000").s().p("ABlDMIhgk+IgGggQgGAkgOAsIhPEOIgvAAIhsmWIAyAAIBAD6QAOA0AGArQAHgxAPgyIBJj2IAxAAIBMD4QAOArAJA2QAFgkAPg7IBAj6IAyAAIhtGWg");
	this.shape_2744.setTransform(195.5,627.5,0.5,0.5);

	this.shape_2745 = new cjs.Shape();
	this.shape_2745.graphics.f("#000000").s().p("AhfCGQgagXAAgrQAAhbCTgFIAzgCIAAgTQAAgkgPgRQgQgRgiAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAYQAaAZAAA1IAADPIgiAAIgJgrIgCAAQgWAcgYALQgXAKggAAQguAAgZgYgAAeAEQg3ADgXAOQgZAPAAAgQAAAZAPAOQAQANAbAAQAqAAAZgYQAYgXAAgrIAAgcg");
	this.shape_2745.setTransform(166.5,630.1,0.5,0.5);

	this.shape_2746 = new cjs.Shape();
	this.shape_2746.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQAQgdAZgRQAXgQAcAAQAWAAAPADIgGArQgVgEgNAAQglAAgaAeQgaAdAAAuIAACig");
	this.shape_2746.setTransform(154.3,629.9,0.5,0.5);

	this.shape_2747 = new cjs.Shape();
	this.shape_2747.graphics.f("#000000").s().p("AhkCyQghgoAAhMQAAhLAhgpQAhgqA8AAQA9AAAiAtIADAAIgCgWIgBiRIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg7AAgigpgAhAgaQgVAfAAA6QAAA7AVAdQAWAeApAAQAvAAAVgaQAVgZAAg6IAAgKQAAhAgVgbQgXgcgtAAQgpAAgWAfg");
	this.shape_2747.setTransform(138.3,627,0.5,0.5);

	this.shape_2748 = new cjs.Shape();
	this.shape_2748.graphics.f("#000000").s().p("ABRCbIAAjEQAAgkgRgUQgRgSgkAAQguAAgXAaQgXAaABA7IAACfIguAAIAAkwIAlAAIAIAqIACAAQAPgXAYgMQAZgMAgAAQA3AAAcAaQAbAbAAA6IAADGg");
	this.shape_2748.setTransform(121.3,629.9,0.5,0.5);

	this.shape_2749 = new cjs.Shape();
	this.shape_2749.graphics.f("#000000").s().p("AhfCGQgbgXAAgrQAAhbCTgFIA0gCIAAgTQAAgjgPgSQgQgRgiAAQglAAgwAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAYQAbAZgBA1IAADPIgiAAIgJgrIgDAAQgWAcgXALQgXAKggAAQgvAAgYgYgAAeAEQg3ADgYAOQgYAQAAAfQAAAZAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_2749.setTransform(104.1,630.1,0.5,0.5);

	this.shape_2750 = new cjs.Shape();
	this.shape_2750.graphics.f("#000000").s().p("ABWCZIhVh8IhWB8Ig0AAIBwibIhqiVIA0AAIBQB0IBPh0IA0AAIhqCVIBwCbg");
	this.shape_2750.setTransform(89.2,630.1,0.5,0.5);

	this.shape_2751 = new cjs.Shape();
	this.shape_2751.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhJAlgrQAkgrA8AAQA6AAAhAlQAhAmAAA+IAAAdIjRAAQACA1AZAcQAaAcAtAAQAzAAAvgVIAAApQgZAMgWADQgVAFgfAAQhCAAgogpgAg1hfQgXAZgDAqICeAAQABgrgUgYQgUgXgjAAQgkAAgWAXg");
	this.shape_2751.setTransform(73.8,630.1,0.5,0.5);

	this.shape_2752 = new cjs.Shape();
	this.shape_2752.graphics.f("#000000").s().p("AgWDZIAAmwIAtAAIAAGwg");
	this.shape_2752.setTransform(62.1,626.9,0.5,0.5);

	this.shape_2753 = new cjs.Shape();
	this.shape_2753.graphics.f("#000000").s().p("ACDDMIgyiBIijAAIgyCBIgvAAICgmXIAnAAICgGXgAgRhdIgwB9ICDAAIgwh9QgIgWgKglQgHAfgKAcg");
	this.shape_2753.setTransform(49.5,627.5,0.5,0.5);

	this.shape_2754 = new cjs.Shape();
	this.shape_2754.graphics.f("#000000").s().p("AAKA+QAIgaAHgjQAKgnACgXIAdAAIADAFQgJAkgMAcQgMAhgKAVgAhEA+QAFgSAKgqQAIgjAEgcIAdAAIADAFQgUBEgXAyg");
	this.shape_2754.setTransform(733.6,584.3,0.5,0.5);

	this.shape_2755 = new cjs.Shape();
	this.shape_2755.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2755.setTransform(726.9,589.7,0.5,0.5);

	this.shape_2756 = new cjs.Shape();
	this.shape_2756.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2756.setTransform(716.8,592.7,0.5,0.5);

	this.shape_2757 = new cjs.Shape();
	this.shape_2757.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAdAkgBBFQAABBgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAaAAA7IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgWAag");
	this.shape_2757.setTransform(703.3,595.6,0.5,0.5);

	this.shape_2758 = new cjs.Shape();
	this.shape_2758.graphics.f("#000000").s().p("Ah3CJQgrgxAAhYQAAhWAsgzQAsgxBKAAQBMgBArAzQAsAzAABVQAABXgsAyQgrAyhMAAQhLAAgsgygAhjh4QgjArAABNQAABOAjArQAiArBBAAQBBgBAjgqQAjgqAAhPQAAhOgjgqQgjgphBAAQhAAAgjApg");
	this.shape_2758.setTransform(685.6,590.3,0.5,0.5);

	this.shape_2759 = new cjs.Shape();
	this.shape_2759.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAHIgGAVQgVgHgTAAQgdABgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_2759.setTransform(666.3,589.7,0.5,0.5);

	this.shape_2760 = new cjs.Shape();
	this.shape_2760.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2760.setTransform(654.1,592.7,0.5,0.5);

	this.shape_2761 = new cjs.Shape();
	this.shape_2761.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2761.setTransform(635.6,591.2,0.5,0.5);

	this.shape_2762 = new cjs.Shape();
	this.shape_2762.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2762.setTransform(624,592.7,0.5,0.5);

	this.shape_2763 = new cjs.Shape();
	this.shape_2763.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2763.setTransform(613.7,589.7,0.5,0.5);

	this.shape_2764 = new cjs.Shape();
	this.shape_2764.graphics.f("#000000").s().p("AhPB4QgVgUgBglQAAgnAigWQAggVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgVAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZABgsIAAgZg");
	this.shape_2764.setTransform(597,592.7,0.5,0.5);

	this.shape_2765 = new cjs.Shape();
	this.shape_2765.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAfAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_2765.setTransform(576,589.9,0.5,0.5);

	this.shape_2766 = new cjs.Shape();
	this.shape_2766.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAxAAAbAiQAbAiABA4IAAATIjDAAQABA5AaAdQAYAdAwAAQAWAAATgDQATgEAYgKIAAAWQgWAKgTAEQgTADgYAAQg7ABggglgAg3hcQgYAagDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_2766.setTransform(561.9,592.7,0.5,0.5);

	this.shape_2767 = new cjs.Shape();
	this.shape_2767.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgngOQgpgPgOgJQgRgKgIgOQgIgOgBgSQAAgfAagSQAZgSAuAAQArAAAnARIgJAWQgogQghAAQghAAgTALQgTALAAATQgBAWAPAMQAPANArAPQAmAOAQAKQAQAKAJANQAIAPAAARQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_2767.setTransform(548.8,592.7,0.5,0.5);

	this.shape_2768 = new cjs.Shape();
	this.shape_2768.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhDAAQhbAAgBhjg");
	this.shape_2768.setTransform(535.4,592.8,0.5,0.5);

	this.shape_2769 = new cjs.Shape();
	this.shape_2769.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_2769.setTransform(513.3,589.9,0.5,0.5);

	this.shape_2770 = new cjs.Shape();
	this.shape_2770.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_2770.setTransform(498.7,592.5,0.5,0.5);

	this.shape_2771 = new cjs.Shape();
	this.shape_2771.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2771.setTransform(483.9,592.7,0.5,0.5);

	this.shape_2772 = new cjs.Shape();
	this.shape_2772.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAmgBAWgNQAUgNAAgWQAAgVgQgNQgQgOgmgOQgrgPgOgJQgPgKgJgOQgJgOABgSQAAgfAZgSQAagSAsAAQAtAAAnARIgJAWQgogQgjAAQggAAgTALQgTALgBATQAAAWAPAMQAPANAsAPQAjAOARAKQARAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2772.setTransform(464.9,592.7,0.5,0.5);

	this.shape_2773 = new cjs.Shape();
	this.shape_2773.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_2773.setTransform(451.6,592.5,0.5,0.5);

	this.shape_2774 = new cjs.Shape();
	this.shape_2774.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAXAAARgDQATgEAagKIAAAWQgYAKgTAEQgSADgYAAQg6ABghglgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgVgagkAAQgmAAgXAZg");
	this.shape_2774.setTransform(437,592.7,0.5,0.5);

	this.shape_2775 = new cjs.Shape();
	this.shape_2775.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA1gBQAwAAAbAiQAcAiAAA4IAAATIjBAAQgBA3AaAfQAZAdAwAAQAXAAARgDQASgEAagKIAAAWQgWAKgUAEQgSADgYAAQg7ABghglgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgVgagkAAQgnAAgWAZg");
	this.shape_2775.setTransform(423.1,592.7,0.5,0.5);

	this.shape_2776 = new cjs.Shape();
	this.shape_2776.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_2776.setTransform(412,592.5,0.5,0.5);

	this.shape_2777 = new cjs.Shape();
	this.shape_2777.graphics.f("#000000").s().p("AhdC0QgdgUAAgjQAAgcARgSQARgTAfgHQgMgFgIgJQgIgKABgMQAAgbAigUQgYgKgNgVQgNgVAAgbQAAgnAagaQAagYArAAQAZAAAQAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAJAAANQAAAMAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgcgTgAhgB7QAAA3BUAAQBpAAAAhEQAAgYgQgLQgSgLgkAAIgsAAQhKAAgBA7gAg4igQgTATAAAgQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgTgRQgSgSghAAQggAAgSATg");
	this.shape_2777.setTransform(399.5,595.6,0.5,0.5);

	this.shape_2778 = new cjs.Shape();
	this.shape_2778.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_2778.setTransform(378.2,589.9,0.5,0.5);

	this.shape_2779 = new cjs.Shape();
	this.shape_2779.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAAABjIAACwg");
	this.shape_2779.setTransform(363.5,592.5,0.5,0.5);

	this.shape_2780 = new cjs.Shape();
	this.shape_2780.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2780.setTransform(348.7,592.7,0.5,0.5);

	this.shape_2781 = new cjs.Shape();
	this.shape_2781.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgRgLgIgNQgJgOAAgSQAAgfAagSQAZgSAtAAQAsAAAnARIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArAQQAkANASALQARALAIAMQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_2781.setTransform(329.8,592.7,0.5,0.5);

	this.shape_2782 = new cjs.Shape();
	this.shape_2782.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgSADgYAAQg7ABghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_2782.setTransform(316.9,592.7,0.5,0.5);

	this.shape_2783 = new cjs.Shape();
	this.shape_2783.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAoARAUQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_2783.setTransform(302.3,592.8,0.5,0.5);

	this.shape_2784 = new cjs.Shape();
	this.shape_2784.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2784.setTransform(292,589.7,0.5,0.5);

	this.shape_2785 = new cjs.Shape();
	this.shape_2785.graphics.f("#000000").s().p("Ag0C4QgYgMgNgWIgCAAIgHApIgPAAIAAmCIAYAAIgCCfIACAAQAPgZAWgLQAWgMAeAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAaAtAAQAsAAAWgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_2785.setTransform(281.9,589.9,0.5,0.5);

	this.shape_2786 = new cjs.Shape();
	this.shape_2786.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_2786.setTransform(259.3,589.9,0.5,0.5);

	this.shape_2787 = new cjs.Shape();
	this.shape_2787.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgoQAggmA0gBQAwAAAcAiQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAXAAATgDQATgEAZgKIAAAWQgYAKgTAEQgRADgaAAQg6ABghglgAg3hcQgXAagEAxICnAAQAAgwgVgaQgUgaglAAQglAAgZAZg");
	this.shape_2787.setTransform(245.2,592.7,0.5,0.5);

	this.shape_2788 = new cjs.Shape();
	this.shape_2788.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QAOAlAGAYIAAAAQALggAKgeIBGi2IAaAAIhpENg");
	this.shape_2788.setTransform(232.3,592.7,0.5,0.5);

	this.shape_2789 = new cjs.Shape();
	this.shape_2789.graphics.f("#000000").s().p("Ag+B7QgbgQgQghQgOghAAgpQAAhCAgglQAhgkA3gBQA4AAAfAmQAgAmAABAQAABBggAmQghAlg3AAQgkABgagSgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_2789.setTransform(219,592.7,0.5,0.5);

	this.shape_2790 = new cjs.Shape();
	this.shape_2790.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2790.setTransform(208.6,589.7,0.5,0.5);

	this.shape_2791 = new cjs.Shape();
	this.shape_2791.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAJgGAIgMQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKAMQgLAPgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_2791.setTransform(193.3,595.7,0.5,0.5);

	this.shape_2792 = new cjs.Shape();
	this.shape_2792.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAhgmQAjgmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg4ABgiglg");
	this.shape_2792.setTransform(181.7,592.7,0.5,0.5);

	this.shape_2793 = new cjs.Shape();
	this.shape_2793.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_2793.setTransform(167.9,592.5,0.5,0.5);

	this.shape_2794 = new cjs.Shape();
	this.shape_2794.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2794.setTransform(153.1,592.7,0.5,0.5);

	this.shape_2795 = new cjs.Shape();
	this.shape_2795.graphics.f("#000000").s().p("ABqC2IjWlCIgCAAQADA6AAAdIAADrIgYAAIAAlrIAZAAIDXFCIABAAQgDgyAAgkIAAjsIAZAAIAAFrg");
	this.shape_2795.setTransform(137.6,590.3,0.5,0.5);

	this.shape_2796 = new cjs.Shape();
	this.shape_2796.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_2796.setTransform(118.7,598.5,0.5,0.5);

	this.shape_2797 = new cjs.Shape();
	this.shape_2797.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXAAQAZAAAQgDIAAAUQgSAFgXAAQgjAAgRgTg");
	this.shape_2797.setTransform(111.2,591.2,0.5,0.5);

	this.shape_2798 = new cjs.Shape();
	this.shape_2798.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPAAAAgZg");
	this.shape_2798.setTransform(104.3,590.2,0.5,0.5);

	this.shape_2799 = new cjs.Shape();
	this.shape_2799.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvAAAcAiQAbAiAAA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAWQgXAKgUAEQgRADgaAAQg5ABgiglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagjAAQgnAAgXAZg");
	this.shape_2799.setTransform(87.8,592.7,0.5,0.5);

	this.shape_2800 = new cjs.Shape();
	this.shape_2800.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAOAjAHAaIAAAAQALggALgeIBFi2IAaAAIhoENg");
	this.shape_2800.setTransform(74.9,592.7,0.5,0.5);

	this.shape_2801 = new cjs.Shape();
	this.shape_2801.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2801.setTransform(61.8,592.7,0.5,0.5);

	this.shape_2802 = new cjs.Shape();
	this.shape_2802.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_2802.setTransform(48.1,589.7,0.5,0.5);

	this.shape_2803 = new cjs.Shape();
	this.shape_2803.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOghAAgpQAAhCAgglQAggkA4gBQA4AAAfAmQAgAmAABAQAABBghAmQggAlg3AAQgkABgbgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_2803.setTransform(710.1,554.4,0.5,0.5);

	this.shape_2804 = new cjs.Shape();
	this.shape_2804.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2804.setTransform(698.1,552.9,0.5,0.5);

	this.shape_2805 = new cjs.Shape();
	this.shape_2805.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_2805.setTransform(679.4,551.6,0.5,0.5);

	this.shape_2806 = new cjs.Shape();
	this.shape_2806.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2806.setTransform(665,554.4,0.5,0.5);

	this.shape_2807 = new cjs.Shape();
	this.shape_2807.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_2807.setTransform(651.3,551.5,0.5,0.5);

	this.shape_2808 = new cjs.Shape();
	this.shape_2808.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2808.setTransform(633.9,552.1,0.5,0.5);

	this.shape_2809 = new cjs.Shape();
	this.shape_2809.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAVgcAAg8IAAgEQAAg9gVgdQgWgbgvAAQgqAAgXAfg");
	this.shape_2809.setTransform(616,551.6,0.5,0.5);

	this.shape_2810 = new cjs.Shape();
	this.shape_2810.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_2810.setTransform(601.4,554.3,0.5,0.5);

	this.shape_2811 = new cjs.Shape();
	this.shape_2811.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2811.setTransform(586.6,554.4,0.5,0.5);

	this.shape_2812 = new cjs.Shape();
	this.shape_2812.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2812.setTransform(570.8,551.5,0.5,0.5);

	this.shape_2813 = new cjs.Shape();
	this.shape_2813.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2813.setTransform(560.7,554.4,0.5,0.5);

	this.shape_2814 = new cjs.Shape();
	this.shape_2814.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_2814.setTransform(547.2,557.3,0.5,0.5);

	this.shape_2815 = new cjs.Shape();
	this.shape_2815.graphics.f("#000000").s().p("Ah2CJQgsgyAAhXQAAhWAsgzQAsgxBKAAQBMgBAsAzQArAzAABVQAABXgsAyQgrAyhMAAQhLAAgrgygAhjh4QgjArAABNQAABNAjAsQAjArBAAAQBCgBAigqQAjgqAAhPQAAhOgjgqQgigphCAAQg/AAgkApg");
	this.shape_2815.setTransform(529.5,552.1,0.5,0.5);

	this.shape_2816 = new cjs.Shape();
	this.shape_2816.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_2816.setTransform(505.7,554.3,0.5,0.5);

	this.shape_2817 = new cjs.Shape();
	this.shape_2817.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2817.setTransform(490.9,554.4,0.5,0.5);

	this.shape_2818 = new cjs.Shape();
	this.shape_2818.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAmgBAWgNQAUgNAAgWQAAgVgQgNQgQgOgmgOQgrgPgOgJQgPgKgJgOQgJgOABgSQAAgfAZgSQAagSAsAAQAtAAAnARIgJAWQgogQgjAAQggAAgTALQgTALgBATQAAAWAPAMQAPANAsAPQAjAOARAKQARAKAIANQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2818.setTransform(471.9,554.4,0.5,0.5);

	this.shape_2819 = new cjs.Shape();
	this.shape_2819.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAtAAQAsAAAnARIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIAMQAIAPAAARQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2819.setTransform(460,554.4,0.5,0.5);

	this.shape_2820 = new cjs.Shape();
	this.shape_2820.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA4AAAfAmQAgAlAABBQAABCggAlQghAlg3AAQgkABgbgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2820.setTransform(446.7,554.4,0.5,0.5);

	this.shape_2821 = new cjs.Shape();
	this.shape_2821.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2821.setTransform(435.2,554.3,0.5,0.5);

	this.shape_2822 = new cjs.Shape();
	this.shape_2822.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgaAgAAA4QAAA2AaAfQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABghglg");
	this.shape_2822.setTransform(423.5,554.4,0.5,0.5);

	this.shape_2823 = new cjs.Shape();
	this.shape_2823.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2823.setTransform(410,554.4,0.5,0.5);

	this.shape_2824 = new cjs.Shape();
	this.shape_2824.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgSADgYAAQg6ABghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_2824.setTransform(390.1,554.4,0.5,0.5);

	this.shape_2825 = new cjs.Shape();
	this.shape_2825.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngQgUQgPgSggAAQgpAAgVAYQgTAWgBAyIAACdIgYAAIAAi4QABhFg/AAQgrAAgTAZQgTAagBA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAMgTATgMQAWgLAYAAQBBAAAQAwIABAAQAOgXAWgNQAYgMAbAAQAsAAAWAYQAXAXAAA0IAACwg");
	this.shape_2825.setTransform(371.9,554.3,0.5,0.5);

	this.shape_2826 = new cjs.Shape();
	this.shape_2826.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2826.setTransform(353.3,554.4,0.5,0.5);

	this.shape_2827 = new cjs.Shape();
	this.shape_2827.graphics.f("#000000").s().p("Ag/BoQgiglABhBQgBhCAjgmQAigmA6AAQAkAAAgANIgHAVQglgLgYAAQgyAAgZAfQgaAfABA5QgBA3AaAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgqAAQg6ABggglg");
	this.shape_2827.setTransform(341.3,554.4,0.5,0.5);

	this.shape_2828 = new cjs.Shape();
	this.shape_2828.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2828.setTransform(325.1,552.1,0.5,0.5);

	this.shape_2829 = new cjs.Shape();
	this.shape_2829.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvAAAcAiQAcAhgBA5IAAATIjCAAQABA5AZAdQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAWQgXAKgUAEQgRADgaAAQg5ABgiglgAg2hcQgZAagDAxICmAAQAAgwgUgaQgVgagjAAQgnAAgXAZg");
	this.shape_2829.setTransform(308.3,554.4,0.5,0.5);

	this.shape_2830 = new cjs.Shape();
	this.shape_2830.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABggglg");
	this.shape_2830.setTransform(295.5,554.4,0.5,0.5);

	this.shape_2831 = new cjs.Shape();
	this.shape_2831.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_2831.setTransform(281.7,554.3,0.5,0.5);

	this.shape_2832 = new cjs.Shape();
	this.shape_2832.graphics.f("#000000").s().p("Ag+B7QgbgQgQghQgOghAAgpQAAhCAgglQAhgkA3gBQA4AAAfAmQAgAmAABAQAABBggAmQggAlg4AAQgkABgagSgAhFhWQgYAeAAA4QAAA3AYAgQAaAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2832.setTransform(266.6,554.4,0.5,0.5);

	this.shape_2833 = new cjs.Shape();
	this.shape_2833.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAfAJAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2833.setTransform(248.1,552.9,0.5,0.5);

	this.shape_2834 = new cjs.Shape();
	this.shape_2834.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACuQAAApASATQARASAkAAQAvAAAYgYQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_2834.setTransform(236.4,554.5,0.5,0.5);

	this.shape_2835 = new cjs.Shape();
	this.shape_2835.graphics.f("#000000").s().p("Ag0C4QgYgMgMgWIgDAAIgHApIgPAAIAAmCIAZAAIgDCfIADAAQAOgZAXgLQAVgMAeAAQA5AAAcAkQAdAkAABEQABBCgfAmQgeAkg2AAQgcAAgYgMgAhEgiQgUAcAAA+IAAAEQAAA9AVAbQAWAaAtAAQAsAAAWgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_2835.setTransform(221.8,551.6,0.5,0.5);

	this.shape_2836 = new cjs.Shape();
	this.shape_2836.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggoQAggmA0gBQAwAAAcAiQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAXAAATgDQATgEAZgKIAAAWQgYAKgTAEQgRADgaAAQg6ABghglgAg3hcQgXAagEAxICmAAQABgwgVgaQgUgaglAAQglAAgZAZg");
	this.shape_2836.setTransform(200.2,554.4,0.5,0.5);

	this.shape_2837 = new cjs.Shape();
	this.shape_2837.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAlAAQAvAAAXgYQAWgZAAg3IAAiUIAYAAIAAEOIgUAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_2837.setTransform(185.6,554.5,0.5,0.5);

	this.shape_2838 = new cjs.Shape();
	this.shape_2838.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2838.setTransform(175.2,551.5,0.5,0.5);

	this.shape_2839 = new cjs.Shape();
	this.shape_2839.graphics.f("#000000").s().p("Ag0C4QgXgMgNgWIgDAAIgHApIgQAAIAAmCIAaAAIgCCfIACAAQAOgZAWgLQAXgMAdAAQA5AAAcAkQAdAkABBEQAABCgfAmQgeAkg2AAQgdAAgXgMgAhEgiQgVAbABA/IAAAEQgBA9AWAbQAVAaAuAAQAsAAAVgfQAXgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_2839.setTransform(165.2,551.6,0.5,0.5);

	this.shape_2840 = new cjs.Shape();
	this.shape_2840.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2840.setTransform(143.1,551.5,0.5,0.5);

	this.shape_2841 = new cjs.Shape();
	this.shape_2841.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2841.setTransform(131.1,552.9,0.5,0.5);

	this.shape_2842 = new cjs.Shape();
	this.shape_2842.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPAAAAgZg");
	this.shape_2842.setTransform(124.1,551.9,0.5,0.5);

	this.shape_2843 = new cjs.Shape();
	this.shape_2843.graphics.f("#000000").s().p("ABOCHIg8i0IgOg2IgCAAIhMDqIgYAAIhNkNIAZAAIAsCbQARBAADAWIACAAQAPg+AGgPIA3ikIAWAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2843.setTransform(112,554.4,0.5,0.5);

	this.shape_2844 = new cjs.Shape();
	this.shape_2844.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_2844.setTransform(91.1,551.5,0.5,0.5);

	this.shape_2845 = new cjs.Shape();
	this.shape_2845.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_2845.setTransform(79.7,554.3,0.5,0.5);

	this.shape_2846 = new cjs.Shape();
	this.shape_2846.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABCggAlQghAlg3AAQgjABgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2846.setTransform(66.4,554.4,0.5,0.5);

	this.shape_2847 = new cjs.Shape();
	this.shape_2847.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2847.setTransform(49.7,554.4,0.5,0.5);

	this.shape_2848 = new cjs.Shape();
	this.shape_2848.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAJgGAIgMQAIgMALgdIAMgjIhnkOIAZAAIA6CYQAYBCAJAcIAAAAQAOgqAUg2IA6iWIAZAAIh4E6QgQAngJAMQgKAOgNAHQgNAGgUABQgPAAgQgGg");
	this.shape_2848.setTransform(763.3,519.2,0.5,0.5);

	this.shape_2849 = new cjs.Shape();
	this.shape_2849.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2849.setTransform(754.5,513.2,0.5,0.5);

	this.shape_2850 = new cjs.Shape();
	this.shape_2850.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_2850.setTransform(748.8,513.2,0.5,0.5);

	this.shape_2851 = new cjs.Shape();
	this.shape_2851.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2851.setTransform(738.7,516.2,0.5,0.5);

	this.shape_2852 = new cjs.Shape();
	this.shape_2852.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_2852.setTransform(724.8,516.3,0.5,0.5);

	this.shape_2853 = new cjs.Shape();
	this.shape_2853.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNgBgWQAAgVgQgNQgQgOgngOQgpgPgOgJQgRgKgIgOQgJgOAAgSQABgfAZgSQAZgSAuAAQArAAAnARIgJAWQgngQgiAAQghAAgTALQgUALABATQgBAWAPAMQAQANAqAPQAlAOARAKQAQAKAJANQAIAPAAARQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_2853.setTransform(711.3,516.2,0.5,0.5);

	this.shape_2854 = new cjs.Shape();
	this.shape_2854.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAvAAAYgYQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgCAAQgZArhDAAQhdAAAAhjg");
	this.shape_2854.setTransform(697.9,516.3,0.5,0.5);

	this.shape_2855 = new cjs.Shape();
	this.shape_2855.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2855.setTransform(679.4,514.7,0.5,0.5);

	this.shape_2856 = new cjs.Shape();
	this.shape_2856.graphics.f("#000000").s().p("AgdA+QAHgWAIgmQAIgfAFggIAcAAIADAFQgTBBgYA1g");
	this.shape_2856.setTransform(673.4,507.8,0.5,0.5);

	this.shape_2857 = new cjs.Shape();
	this.shape_2857.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBcAAAABjIAACwg");
	this.shape_2857.setTransform(664.1,516,0.5,0.5);

	this.shape_2858 = new cjs.Shape();
	this.shape_2858.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABBggAmQggAlg4AAQgkABgbgSgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAagfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_2858.setTransform(649.1,516.2,0.5,0.5);

	this.shape_2859 = new cjs.Shape();
	this.shape_2859.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_2859.setTransform(633.6,513.4,0.5,0.5);

	this.shape_2860 = new cjs.Shape();
	this.shape_2860.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2860.setTransform(616.6,513.8,0.5,0.5);

	this.shape_2861 = new cjs.Shape();
	this.shape_2861.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_2861.setTransform(603.7,522,0.5,0.5);

	this.shape_2862 = new cjs.Shape();
	this.shape_2862.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAtAAQArAAAoARIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIAMQAIAPAAARQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2862.setTransform(594.6,516.2,0.5,0.5);

	this.shape_2863 = new cjs.Shape();
	this.shape_2863.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_2863.setTransform(581.3,516,0.5,0.5);

	this.shape_2864 = new cjs.Shape();
	this.shape_2864.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0gBQAxAAAbAiQAcAhAAA5IAAATIjCAAQABA5AZAdQAYAdAwAAQAWAAASgDQAUgEAZgKIAAAWQgYAKgSAEQgTADgYAAQg7ABggglgAg3hcQgYAagDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_2864.setTransform(566.8,516.2,0.5,0.5);

	this.shape_2865 = new cjs.Shape();
	this.shape_2865.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgnQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgSADgYAAQg7ABghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_2865.setTransform(552.8,516.2,0.5,0.5);

	this.shape_2866 = new cjs.Shape();
	this.shape_2866.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2866.setTransform(541.7,516,0.5,0.5);

	this.shape_2867 = new cjs.Shape();
	this.shape_2867.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgbAigUQgYgKgMgVQgOgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgNAHgJALQgIAKAAAMQAAANAKAFQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgSgRQgTgSggAAQghAAgSATg");
	this.shape_2867.setTransform(529.2,519.1,0.5,0.5);

	this.shape_2868 = new cjs.Shape();
	this.shape_2868.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_2868.setTransform(507.9,513.4,0.5,0.5);

	this.shape_2869 = new cjs.Shape();
	this.shape_2869.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBDAAQBcAAABBjIAACwg");
	this.shape_2869.setTransform(493.3,516,0.5,0.5);

	this.shape_2870 = new cjs.Shape();
	this.shape_2870.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgWAcgUAJQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2870.setTransform(478.5,516.2,0.5,0.5);

	this.shape_2871 = new cjs.Shape();
	this.shape_2871.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBg/AhgoQAggmA0gBQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA5AaAdQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgSAEQgTADgYAAQg7ABggglgAg3hcQgYAagDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAZg");
	this.shape_2871.setTransform(458.5,516.2,0.5,0.5);

	this.shape_2872 = new cjs.Shape();
	this.shape_2872.graphics.f("#000000").s().p("AheC0QgcgVAAgiQAAgcASgSQARgTAegHQgMgFgIgJQgHgKAAgMQAAgbAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgTgRQgSgSggAAQghAAgSATg");
	this.shape_2872.setTransform(444.9,519.1,0.5,0.5);

	this.shape_2873 = new cjs.Shape();
	this.shape_2873.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_2873.setTransform(430.8,516,0.5,0.5);

	this.shape_2874 = new cjs.Shape();
	this.shape_2874.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2874.setTransform(415.9,516.2,0.5,0.5);

	this.shape_2875 = new cjs.Shape();
	this.shape_2875.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_2875.setTransform(405.6,516,0.5,0.5);

	this.shape_2876 = new cjs.Shape();
	this.shape_2876.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAlg3AAQgjABgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2876.setTransform(392.2,516.2,0.5,0.5);

	this.shape_2877 = new cjs.Shape();
	this.shape_2877.graphics.f("#000000").s().p("AgdA+QAUhIAIg0IAcAAIADAGQgTBAgYA2g");
	this.shape_2877.setTransform(375,523.1,0.5,0.5);

	this.shape_2878 = new cjs.Shape();
	this.shape_2878.graphics.f("#000000").s().p("ABNCHIhJjqIgCAAIhMDqIgYAAIhNkNIAaAAIArCbQAQBAAEAWIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATA9ADARIACAAQACgTAShEIApiaIAYAAIhIENg");
	this.shape_2878.setTransform(363.5,516.2,0.5,0.5);

	this.shape_2879 = new cjs.Shape();
	this.shape_2879.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABDggAkQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2879.setTransform(346.8,516.2,0.5,0.5);

	this.shape_2880 = new cjs.Shape();
	this.shape_2880.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2880.setTransform(336.4,513.2,0.5,0.5);

	this.shape_2881 = new cjs.Shape();
	this.shape_2881.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2881.setTransform(330.6,513.2,0.5,0.5);

	this.shape_2882 = new cjs.Shape();
	this.shape_2882.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggmA1gBQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQASgEAagKIAAAWQgVAKgUAEQgTADgYAAQg7ABggglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQglAAgYAZg");
	this.shape_2882.setTransform(320.8,516.2,0.5,0.5);

	this.shape_2883 = new cjs.Shape();
	this.shape_2883.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAJgGAIgMQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKAMQgLAPgMAGQgNAGgTABQgPAAgRgGg");
	this.shape_2883.setTransform(307.9,519.2,0.5,0.5);

	this.shape_2884 = new cjs.Shape();
	this.shape_2884.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA2gBQAvAAAbAiQAcAiAAA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAWQgXAKgUAEQgSADgZAAQg5ABgiglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagjAAQgnAAgXAZg");
	this.shape_2884.setTransform(288.5,516.2,0.5,0.5);

	this.shape_2885 = new cjs.Shape();
	this.shape_2885.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_2885.setTransform(276.4,513.2,0.5,0.5);

	this.shape_2886 = new cjs.Shape();
	this.shape_2886.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_2886.setTransform(266.2,513.7,0.5,0.5);

	this.shape_2887 = new cjs.Shape();
	this.shape_2887.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2887.setTransform(260.5,513.2,0.5,0.5);

	this.shape_2888 = new cjs.Shape();
	this.shape_2888.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2888.setTransform(247.7,513.8,0.5,0.5);

	this.shape_2889 = new cjs.Shape();
	this.shape_2889.graphics.f("#000000").s().p("AhqAKIAAgTIDVAAIAAATg");
	this.shape_2889.setTransform(231.5,516,0.5,0.5);

	this.shape_2890 = new cjs.Shape();
	this.shape_2890.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAWQgYAKgTAEQgSADgYAAQg6ABghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAZg");
	this.shape_2890.setTransform(211.5,516.2,0.5,0.5);

	this.shape_2891 = new cjs.Shape();
	this.shape_2891.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAHIgGAVQgVgHgTAAQgdABgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_2891.setTransform(201.6,513.2,0.5,0.5);

	this.shape_2892 = new cjs.Shape();
	this.shape_2892.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAHgGAAQgPAAAAgZg");
	this.shape_2892.setTransform(194,513.7,0.5,0.5);

	this.shape_2893 = new cjs.Shape();
	this.shape_2893.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2893.setTransform(188.2,513.2,0.5,0.5);

	this.shape_2894 = new cjs.Shape();
	this.shape_2894.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_2894.setTransform(171.3,516,0.5,0.5);

	this.shape_2895 = new cjs.Shape();
	this.shape_2895.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAHgHAAQgPAAAAgZg");
	this.shape_2895.setTransform(160.8,513.7,0.5,0.5);

	this.shape_2896 = new cjs.Shape();
	this.shape_2896.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYAAQgiAAgSgTg");
	this.shape_2896.setTransform(146.9,514.7,0.5,0.5);

	this.shape_2897 = new cjs.Shape();
	this.shape_2897.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2897.setTransform(135.6,516.2,0.5,0.5);

	this.shape_2898 = new cjs.Shape();
	this.shape_2898.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_2898.setTransform(121.8,513.2,0.5,0.5);

	this.shape_2899 = new cjs.Shape();
	this.shape_2899.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgYAAQgjAAgQgTg");
	this.shape_2899.setTransform(109.8,514.7,0.5,0.5);

	this.shape_2900 = new cjs.Shape();
	this.shape_2900.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0gBQAxAAAbAiQAcAhAAA5IAAATIjDAAQABA5AaAdQAYAdAwAAQAWAAATgDQATgEAZgKIAAAWQgYAKgSAEQgTADgYAAQg6ABghglgAg3hcQgYAagDAxICnAAQAAgwgVgaQgVgagkAAQgmAAgYAZg");
	this.shape_2900.setTransform(92.1,516.2,0.5,0.5);

	this.shape_2901 = new cjs.Shape();
	this.shape_2901.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_2901.setTransform(80,513.2,0.5,0.5);

	this.shape_2902 = new cjs.Shape();
	this.shape_2902.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAHgHAAQgPAAAAgZg");
	this.shape_2902.setTransform(69.9,513.7,0.5,0.5);

	this.shape_2903 = new cjs.Shape();
	this.shape_2903.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2903.setTransform(64.1,513.2,0.5,0.5);

	this.shape_2904 = new cjs.Shape();
	this.shape_2904.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_2904.setTransform(51.3,513.8,0.5,0.5);

	this.shape_2905 = new cjs.Shape();
	this.shape_2905.graphics.f("#000000").s().p("AANA+IgDgFQAIgcAMgiQAJgaAOgeIAQAAQgGAUgJApQgIAlgEAZgAhBA+IgDgFQAJggALgdQANgkAKgVIAQAAQgIAbgIAkQgIAigDAag");
	this.shape_2905.setTransform(44.3,507.8,0.5,0.5);

	this.shape_2906 = new cjs.Shape();
	this.shape_2906.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_2906.setTransform(186.2,445.5,0.5,0.5);

	this.shape_2907 = new cjs.Shape();
	this.shape_2907.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAtgBQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAMAAASQAAAWAPAMQAPANAqAPQAmAOAQAKQARALAIANQAIANAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2907.setTransform(177.2,439.7,0.5,0.5);

	this.shape_2908 = new cjs.Shape();
	this.shape_2908.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA5IAAASIjDAAQAAA3AaAfQAaAdAuAAQAYAAARgDQASgEAbgKIAAAXQgXAJgTAEQgSADgaAAQg6ABggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2908.setTransform(164.3,439.7,0.5,0.5);

	this.shape_2909 = new cjs.Shape();
	this.shape_2909.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAZgqBDAAQBdAAgBBjIAACwg");
	this.shape_2909.setTransform(149.9,439.5,0.5,0.5);

	this.shape_2910 = new cjs.Shape();
	this.shape_2910.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2910.setTransform(134.8,439.7,0.5,0.5);

	this.shape_2911 = new cjs.Shape();
	this.shape_2911.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2911.setTransform(122.9,438.2,0.5,0.5);

	this.shape_2912 = new cjs.Shape();
	this.shape_2912.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_2912.setTransform(108.1,439.5,0.5,0.5);

	this.shape_2913 = new cjs.Shape();
	this.shape_2913.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0gBQAxABAbAhQAbAhABA6IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgSADgaAAQg6ABggglgAg3hbQgXAZgEAxICnAAQAAgwgVgaQgUgaglAAQgmAAgYAag");
	this.shape_2913.setTransform(95.3,439.7,0.5,0.5);

	this.shape_2914 = new cjs.Shape();
	this.shape_2914.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2914.setTransform(85.4,436.7,0.5,0.5);

	this.shape_2915 = new cjs.Shape();
	this.shape_2915.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_2915.setTransform(75,439.7,0.5,0.5);

	this.shape_2916 = new cjs.Shape();
	this.shape_2916.graphics.f("#000000").s().p("Ag/B8QgagSgPggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAlg3AAQgjAAgcgQgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2916.setTransform(60.1,439.7,0.5,0.5);

	this.shape_2917 = new cjs.Shape();
	this.shape_2917.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABggglg");
	this.shape_2917.setTransform(46.8,439.7,0.5,0.5);

	this.shape_2918 = new cjs.Shape();
	this.shape_2918.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2918.setTransform(756.3,401.4,0.5,0.5);

	this.shape_2919 = new cjs.Shape();
	this.shape_2919.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2919.setTransform(744.4,399.9,0.5,0.5);

	this.shape_2920 = new cjs.Shape();
	this.shape_2920.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_2920.setTransform(725.7,398.6,0.5,0.5);

	this.shape_2921 = new cjs.Shape();
	this.shape_2921.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAxABAbAhQAcAiAAA5IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgFAZgJIAAAXQgXAJgTAEQgTADgZAAQg6ABggglgAg3hbQgXAZgEAxICnAAQAAgwgVgaQgUgaglAAQgmAAgYAag");
	this.shape_2921.setTransform(711.5,401.4,0.5,0.5);

	this.shape_2922 = new cjs.Shape();
	this.shape_2922.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXABQAZgBAPgDIAAAUQgQAFgYAAQgjABgSgUg");
	this.shape_2922.setTransform(700.1,399.9,0.5,0.5);

	this.shape_2923 = new cjs.Shape();
	this.shape_2923.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABggglg");
	this.shape_2923.setTransform(690.2,401.4,0.5,0.5);

	this.shape_2924 = new cjs.Shape();
	this.shape_2924.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2924.setTransform(676.7,401.4,0.5,0.5);

	this.shape_2925 = new cjs.Shape();
	this.shape_2925.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2925.setTransform(666.3,401.3,0.5,0.5);

	this.shape_2926 = new cjs.Shape();
	this.shape_2926.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2926.setTransform(656,399.9,0.5,0.5);

	this.shape_2927 = new cjs.Shape();
	this.shape_2927.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgXAAQgkABgQgUg");
	this.shape_2927.setTransform(647.4,399.9,0.5,0.5);

	this.shape_2928 = new cjs.Shape();
	this.shape_2928.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2928.setTransform(636.1,401.4,0.5,0.5);

	this.shape_2929 = new cjs.Shape();
	this.shape_2929.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_2929.setTransform(615.8,401.3,0.5,0.5);

	this.shape_2930 = new cjs.Shape();
	this.shape_2930.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA6IAAASIjCAAQABA4AZAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTADgYAAQg6ABghglgAg3hbQgXAYgEAyICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2930.setTransform(601.2,401.4,0.5,0.5);

	this.shape_2931 = new cjs.Shape();
	this.shape_2931.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2931.setTransform(589.7,399.9,0.5,0.5);

	this.shape_2932 = new cjs.Shape();
	this.shape_2932.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAXAAAWAHIgGAVQgVgHgTAAQgdABgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_2932.setTransform(582.7,398.4,0.5,0.5);

	this.shape_2933 = new cjs.Shape();
	this.shape_2933.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAlg3AAQgjAAgcgQgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2933.setTransform(570.5,401.4,0.5,0.5);

	this.shape_2934 = new cjs.Shape();
	this.shape_2934.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgOgOgKQgRgLgIgNQgIgOgBgSQAAgfAagSQAZgRAugBQArAAAnARIgJAXQgngRgiAAQghAAgTALQgTAMAAASQgBAWAPAMQAPANArAPQAkANASALQAQAJAJAPQAIAMAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_2934.setTransform(550.4,401.4,0.5,0.5);

	this.shape_2935 = new cjs.Shape();
	this.shape_2935.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2935.setTransform(537.3,401.4,0.5,0.5);

	this.shape_2936 = new cjs.Shape();
	this.shape_2936.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIACAAQANg3AIgWIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgOAThJIApiaIAZAAIhKENg");
	this.shape_2936.setTransform(521.8,401.4,0.5,0.5);

	this.shape_2937 = new cjs.Shape();
	this.shape_2937.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2937.setTransform(503.1,398.5,0.5,0.5);

	this.shape_2938 = new cjs.Shape();
	this.shape_2938.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAwABAbAhQAdAiAAA5IAAASIjDAAQAAA3AbAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTADgYAAQg7ABggglgAg3hbQgXAYgEAyICmAAQAAgxgVgZQgUgagkAAQgmAAgYAag");
	this.shape_2938.setTransform(493.2,401.4,0.5,0.5);

	this.shape_2939 = new cjs.Shape();
	this.shape_2939.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_2939.setTransform(478.8,398.5,0.5,0.5);

	this.shape_2940 = new cjs.Shape();
	this.shape_2940.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgaAgAAA4QAAA2AaAfQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABghglg");
	this.shape_2940.setTransform(465.4,401.4,0.5,0.5);

	this.shape_2941 = new cjs.Shape();
	this.shape_2941.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_2941.setTransform(456.2,398.9,0.5,0.5);

	this.shape_2942 = new cjs.Shape();
	this.shape_2942.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgPAAIiIlPIgCAAIACA/IAAEQIgZAAIAAlrIAnAAICBE/IABAAICBk/IAmAAIAAFrg");
	this.shape_2942.setTransform(442.3,399.1,0.5,0.5);

	this.shape_2943 = new cjs.Shape();
	this.shape_2943.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAxABAbAhQAbAhABA6IAAASIjDAAQABA4AaAeQAZAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgTADgZAAQg6ABggglgAg3hbQgXAZgEAxICnAAQAAgwgVgaQgUgaglAAQgmAAgYAag");
	this.shape_2943.setTransform(417.7,401.4,0.5,0.5);

	this.shape_2944 = new cjs.Shape();
	this.shape_2944.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_2944.setTransform(407.8,398.5,0.5,0.5);

	this.shape_2945 = new cjs.Shape();
	this.shape_2945.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_2945.setTransform(402,398.9,0.5,0.5);

	this.shape_2946 = new cjs.Shape();
	this.shape_2946.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_2946.setTransform(391.7,398.5,0.5,0.5);

	this.shape_2947 = new cjs.Shape();
	this.shape_2947.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2947.setTransform(374.9,401.4,0.5,0.5);

	this.shape_2948 = new cjs.Shape();
	this.shape_2948.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKANQgLAOgMAGQgNAGgTAAQgPABgRgGg");
	this.shape_2948.setTransform(353.2,404.5,0.5,0.5);

	this.shape_2949 = new cjs.Shape();
	this.shape_2949.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2949.setTransform(343.3,401.3,0.5,0.5);

	this.shape_2950 = new cjs.Shape();
	this.shape_2950.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_2950.setTransform(334.5,398.5,0.5,0.5);

	this.shape_2951 = new cjs.Shape();
	this.shape_2951.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBg/AhgnQAggnA0gBQAxABAbAhQAcAhAAA6IAAASIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTADgYAAQg7ABggglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2951.setTransform(324.7,401.4,0.5,0.5);

	this.shape_2952 = new cjs.Shape();
	this.shape_2952.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2952.setTransform(308.4,401.4,0.5,0.5);

	this.shape_2953 = new cjs.Shape();
	this.shape_2953.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA1gBQAxABAbAhQAcAigBA5IAAASIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgWAJgVAEQgRADgaAAQg5ABgiglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgagkAAQgnAAgWAag");
	this.shape_2953.setTransform(292.2,401.4,0.5,0.5);

	this.shape_2954 = new cjs.Shape();
	this.shape_2954.graphics.f("#000000").s().p("AgwDwIAAgVQATAFANAAQAlAAAAgsIAAlGIAYAAIAAFCQAAAhgQATQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_2954.setTransform(280.7,402,0.5,0.5);

	this.shape_2955 = new cjs.Shape();
	this.shape_2955.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2955.setTransform(268.8,401.3,0.5,0.5);

	this.shape_2956 = new cjs.Shape();
	this.shape_2956.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0gBQAwABAcAhQAbAhAAA6IAAASIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSADgYAAQg6ABghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgXAag");
	this.shape_2956.setTransform(255.9,401.4,0.5,0.5);

	this.shape_2957 = new cjs.Shape();
	this.shape_2957.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_2957.setTransform(241.5,398.5,0.5,0.5);

	this.shape_2958 = new cjs.Shape();
	this.shape_2958.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAagqBEAAQBcAAgBBjIAACwg");
	this.shape_2958.setTransform(219.8,401.3,0.5,0.5);

	this.shape_2959 = new cjs.Shape();
	this.shape_2959.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPAAAAgZg");
	this.shape_2959.setTransform(209.3,398.9,0.5,0.5);

	this.shape_2960 = new cjs.Shape();
	this.shape_2960.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagRAsgBQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAMAAASQAAAWAQAMQAPANAqAPQAmAOAQAKQARALAIANQAIANAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_2960.setTransform(193.8,401.4,0.5,0.5);

	this.shape_2961 = new cjs.Shape();
	this.shape_2961.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA3AZAfQAZAdAwAAQAXAAARgDQASgEAbgKIAAAXQgXAJgUAEQgSADgYAAQg7ABghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgagkAAQgnAAgWAag");
	this.shape_2961.setTransform(181,401.4,0.5,0.5);

	this.shape_2962 = new cjs.Shape();
	this.shape_2962.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_2962.setTransform(166.5,401.3,0.5,0.5);

	this.shape_2963 = new cjs.Shape();
	this.shape_2963.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAlg4AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2963.setTransform(151.4,401.4,0.5,0.5);

	this.shape_2964 = new cjs.Shape();
	this.shape_2964.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2964.setTransform(139.5,399.9,0.5,0.5);

	this.shape_2965 = new cjs.Shape();
	this.shape_2965.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_2965.setTransform(124.7,401.3,0.5,0.5);

	this.shape_2966 = new cjs.Shape();
	this.shape_2966.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2gBQAvABAcAhQAcAhgBA6IAAASIjBAAQABA4AYAeQAZAdAwAAQAWAAASgDQAUgEAZgKIAAAXQgXAJgUAEQgSADgYAAQg7ABghglgAg2hbQgZAZgDAxICmAAQAAgwgUgaQgVgagjAAQgmAAgYAag");
	this.shape_2966.setTransform(111.9,401.4,0.5,0.5);

	this.shape_2967 = new cjs.Shape();
	this.shape_2967.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAWgLAXAAQBAAAASAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_2967.setTransform(93.7,401.3,0.5,0.5);

	this.shape_2968 = new cjs.Shape();
	this.shape_2968.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2968.setTransform(78.3,401.3,0.5,0.5);

	this.shape_2969 = new cjs.Shape();
	this.shape_2969.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2969.setTransform(65.2,401.4,0.5,0.5);

	this.shape_2970 = new cjs.Shape();
	this.shape_2970.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2970.setTransform(49.7,401.4,0.5,0.5);

	this.shape_2971 = new cjs.Shape();
	this.shape_2971.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAlg4AAQgkAAgbgQgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_2971.setTransform(693.5,363.2,0.5,0.5);

	this.shape_2972 = new cjs.Shape();
	this.shape_2972.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2972.setTransform(681.5,361.7,0.5,0.5);

	this.shape_2973 = new cjs.Shape();
	this.shape_2973.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgeAug7AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_2973.setTransform(662.8,360.4,0.5,0.5);

	this.shape_2974 = new cjs.Shape();
	this.shape_2974.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTADgYAAQg7ABggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2974.setTransform(648.7,363.2,0.5,0.5);

	this.shape_2975 = new cjs.Shape();
	this.shape_2975.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXABQAZgBAQgDIAAAUQgSAFgXAAQgjABgRgUg");
	this.shape_2975.setTransform(637.2,361.7,0.5,0.5);

	this.shape_2976 = new cjs.Shape();
	this.shape_2976.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABghglg");
	this.shape_2976.setTransform(627.3,363.2,0.5,0.5);

	this.shape_2977 = new cjs.Shape();
	this.shape_2977.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2977.setTransform(613.8,363.2,0.5,0.5);

	this.shape_2978 = new cjs.Shape();
	this.shape_2978.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_2978.setTransform(603.4,363,0.5,0.5);

	this.shape_2979 = new cjs.Shape();
	this.shape_2979.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2979.setTransform(593.1,361.7,0.5,0.5);

	this.shape_2980 = new cjs.Shape();
	this.shape_2980.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgjABgQgUg");
	this.shape_2980.setTransform(584.6,361.7,0.5,0.5);

	this.shape_2981 = new cjs.Shape();
	this.shape_2981.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_2981.setTransform(573.3,363.2,0.5,0.5);

	this.shape_2982 = new cjs.Shape();
	this.shape_2982.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA3AaAfQAZAdAvAAQAYAAARgDQASgEAbgKIAAAXQgXAJgTAEQgSADgaAAQg6ABggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2982.setTransform(553.4,363.2,0.5,0.5);

	this.shape_2983 = new cjs.Shape();
	this.shape_2983.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_2983.setTransform(542.3,363,0.5,0.5);

	this.shape_2984 = new cjs.Shape();
	this.shape_2984.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAlg3AAQgjAAgcgQgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_2984.setTransform(528.9,363.2,0.5,0.5);

	this.shape_2985 = new cjs.Shape();
	this.shape_2985.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgpAAgUAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAKgTAWgMQAWgLAXAAQBBAAARAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_2985.setTransform(510.3,363,0.5,0.5);

	this.shape_2986 = new cjs.Shape();
	this.shape_2986.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAtgBQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAMAAASQAAAWAPAMQAPANAqAPQAmAOAQAKQARALAIANQAIANAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2986.setTransform(486.3,363.2,0.5,0.5);

	this.shape_2987 = new cjs.Shape();
	this.shape_2987.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_2987.setTransform(473.3,363.2,0.5,0.5);

	this.shape_2988 = new cjs.Shape();
	this.shape_2988.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_2988.setTransform(457.7,363.2,0.5,0.5);

	this.shape_2989 = new cjs.Shape();
	this.shape_2989.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgnA1gBQAxABAaAhQAdAiAAA5IAAASIjCAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTADgYAAQg7ABggglgAg3hbQgYAZgDAxICmAAQAAgwgUgaQgVgagkAAQgmAAgYAag");
	this.shape_2989.setTransform(434.9,363.2,0.5,0.5);

	this.shape_2990 = new cjs.Shape();
	this.shape_2990.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_2990.setTransform(420.5,360.2,0.5,0.5);

	this.shape_2991 = new cjs.Shape();
	this.shape_2991.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAngBAVgNQAUgNAAgWQAAgVgQgNQgQgOgmgOQgqgOgPgKQgQgLgIgNQgJgOAAgSQAAgfAagSQAagRAsgBQAtAAAmARIgJAXQgngRgjAAQggAAgTALQgUAMAAASQABAWAPAMQAOAMArAQQAkANASALQAPAJAKAPQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2991.setTransform(406.8,363.2,0.5,0.5);

	this.shape_2992 = new cjs.Shape();
	this.shape_2992.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2992.setTransform(389.9,361.7,0.5,0.5);

	this.shape_2993 = new cjs.Shape();
	this.shape_2993.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_2993.setTransform(378.6,363.2,0.5,0.5);

	this.shape_2994 = new cjs.Shape();
	this.shape_2994.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_2994.setTransform(364.9,360.2,0.5,0.5);

	this.shape_2995 = new cjs.Shape();
	this.shape_2995.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_2995.setTransform(352.8,361.7,0.5,0.5);

	this.shape_2996 = new cjs.Shape();
	this.shape_2996.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAtgBQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAMAAASQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIANQAIANAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_2996.setTransform(336.1,363.2,0.5,0.5);

	this.shape_2997 = new cjs.Shape();
	this.shape_2997.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZgBAQgDIAAAUQgSAFgYAAQgjABgQgUg");
	this.shape_2997.setTransform(325.8,361.7,0.5,0.5);

	this.shape_2998 = new cjs.Shape();
	this.shape_2998.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_2998.setTransform(314.2,363,0.5,0.5);

	this.shape_2999 = new cjs.Shape();
	this.shape_2999.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAoARAUQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_2999.setTransform(299,363.3,0.5,0.5);

	this.shape_3000 = new cjs.Shape();
	this.shape_3000.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA4AAAfAmQAgAlAABBQAABDggAkQghAlg3AAQgkAAgbgQgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3000.setTransform(284.1,363.2,0.5,0.5);

	this.shape_3001 = new cjs.Shape();
	this.shape_3001.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgaAgAAA4QAAA2AaAfQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABghglg");
	this.shape_3001.setTransform(270.9,363.2,0.5,0.5);

	this.shape_3002 = new cjs.Shape();
	this.shape_3002.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQASgEAagKIAAAXQgVAJgUAEQgTADgYAAQg7ABggglgAg3hbQgXAYgEAyICmAAQAAgxgVgZQgUgagkAAQgmAAgYAag");
	this.shape_3002.setTransform(257.6,363.2,0.5,0.5);

	this.shape_3003 = new cjs.Shape();
	this.shape_3003.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_3003.setTransform(246.5,363,0.5,0.5);

	this.shape_3004 = new cjs.Shape();
	this.shape_3004.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAtgBQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAMAAASQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIANQAIANAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3004.setTransform(228,363.2,0.5,0.5);

	this.shape_3005 = new cjs.Shape();
	this.shape_3005.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAgBBjIAACwg");
	this.shape_3005.setTransform(214.7,363,0.5,0.5);

	this.shape_3006 = new cjs.Shape();
	this.shape_3006.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAGQgEAHgIAAQgPAAAAgZg");
	this.shape_3006.setTransform(204.2,360.7,0.5,0.5);

	this.shape_3007 = new cjs.Shape();
	this.shape_3007.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_3007.setTransform(196.3,360.2,0.5,0.5);

	this.shape_3008 = new cjs.Shape();
	this.shape_3008.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQABAgAJAOQAMAPAXABQAZgBAQgDIAAAUQgTAFgXAAQgiABgSgUg");
	this.shape_3008.setTransform(184.5,361.7,0.5,0.5);

	this.shape_3009 = new cjs.Shape();
	this.shape_3009.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3009.setTransform(173.2,363.2,0.5,0.5);

	this.shape_3010 = new cjs.Shape();
	this.shape_3010.graphics.f("#000000").s().p("ABdC2IhelQQgEAYgHAZIhQEfIgWAAIhklrIAbAAIBVFDQAGgiAUhFIA+jcIAbAAIBJD8QALAoAHAfIAIgmIBNkdIAaAAIhlFrg");
	this.shape_3010.setTransform(155.5,360.8,0.5,0.5);

	this.shape_3011 = new cjs.Shape();
	this.shape_3011.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYg");
	this.shape_3011.setTransform(134.5,369,0.5,0.5);

	this.shape_3012 = new cjs.Shape();
	this.shape_3012.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_3012.setTransform(127.4,363,0.5,0.5);

	this.shape_3013 = new cjs.Shape();
	this.shape_3013.graphics.f("#000000").s().p("AhNBoQgggkAAhCQgBhAAggmQAggnA1gBQAwABAbAhQAcAiAAA5IAAASIjBAAQAAA3AZAfQAZAdAwAAQAXAAARgDQASgEAbgKIAAAXQgXAJgUAEQgSADgYAAQg7ABghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgagkAAQgnAAgWAag");
	this.shape_3013.setTransform(114.6,363.2,0.5,0.5);

	this.shape_3014 = new cjs.Shape();
	this.shape_3014.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_3014.setTransform(100.1,360.2,0.5,0.5);

	this.shape_3015 = new cjs.Shape();
	this.shape_3015.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXABQAZgBAPgDIAAAUQgQAFgYAAQgjABgRgUg");
	this.shape_3015.setTransform(88.1,361.7,0.5,0.5);

	this.shape_3016 = new cjs.Shape();
	this.shape_3016.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3016.setTransform(76.5,363.2,0.5,0.5);

	this.shape_3017 = new cjs.Shape();
	this.shape_3017.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_3017.setTransform(61.6,363,0.5,0.5);

	this.shape_3018 = new cjs.Shape();
	this.shape_3018.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_3018.setTransform(46.8,363.2,0.5,0.5);

	this.shape_3019 = new cjs.Shape();
	this.shape_3019.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0gBQAwABAcAhQAcAhAAA6IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgXAJgUAEQgRADgaAAQg5ABgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgUgaglAAQgmAAgXAag");
	this.shape_3019.setTransform(735.9,324.9,0.5,0.5);

	this.shape_3020 = new cjs.Shape();
	this.shape_3020.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3020.setTransform(721.5,324.8,0.5,0.5);

	this.shape_3021 = new cjs.Shape();
	this.shape_3021.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3021.setTransform(706.4,324.9,0.5,0.5);

	this.shape_3022 = new cjs.Shape();
	this.shape_3022.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_3022.setTransform(684.3,322.1,0.5,0.5);

	this.shape_3023 = new cjs.Shape();
	this.shape_3023.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2gBQAvABAcAhQAbAiAAA5IAAASIjBAAQABA4AYAeQAZAdAwAAQAWAAASgDQAUgFAYgJIAAAXQgWAJgUAEQgSADgYAAQg7ABghglgAg2hbQgZAZgDAxICmAAQAAgwgUgaQgVgagjAAQgmAAgYAag");
	this.shape_3023.setTransform(670.2,324.9,0.5,0.5);

	this.shape_3024 = new cjs.Shape();
	this.shape_3024.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgMIAMg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZgBAPgDIAAAUQgQAFgZAAQgiABgRgUg");
	this.shape_3024.setTransform(658.7,323.4,0.5,0.5);

	this.shape_3025 = new cjs.Shape();
	this.shape_3025.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgLgJgNQgIgOAAgSQAAgfAZgSQAagRAsgBQAtAAAnARIgJAXQgogRgjAAQggAAgTALQgUAMAAASQAAAWAPAMQAPAMAsAQQAjANASALQARALAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3025.setTransform(648.6,324.9,0.5,0.5);

	this.shape_3026 = new cjs.Shape();
	this.shape_3026.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3026.setTransform(635.5,324.9,0.5,0.5);

	this.shape_3027 = new cjs.Shape();
	this.shape_3027.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_3027.setTransform(625.1,324.8,0.5,0.5);

	this.shape_3028 = new cjs.Shape();
	this.shape_3028.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAPAXABQAZgBAQgDIAAAUQgSAFgXAAQgjABgRgUg");
	this.shape_3028.setTransform(614.8,323.4,0.5,0.5);

	this.shape_3029 = new cjs.Shape();
	this.shape_3029.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_3029.setTransform(603.3,324.8,0.5,0.5);

	this.shape_3030 = new cjs.Shape();
	this.shape_3030.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3030.setTransform(588.2,324.9,0.5,0.5);

	this.shape_3031 = new cjs.Shape();
	this.shape_3031.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAaAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg6ABghglg");
	this.shape_3031.setTransform(575,324.9,0.5,0.5);

	this.shape_3032 = new cjs.Shape();
	this.shape_3032.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_3032.setTransform(554,322.1,0.5,0.5);

	this.shape_3033 = new cjs.Shape();
	this.shape_3033.graphics.f("#000000").s().p("ABTCKIAAiuQgBgpgRgTQgRgTgkAAQgwABgWAYQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_3033.setTransform(539.4,324.8,0.5,0.5);

	this.shape_3034 = new cjs.Shape();
	this.shape_3034.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_3034.setTransform(524.6,324.9,0.5,0.5);

	this.shape_3035 = new cjs.Shape();
	this.shape_3035.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_3035.setTransform(503.7,322.1,0.5,0.5);

	this.shape_3036 = new cjs.Shape();
	this.shape_3036.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0gBQAwABAcAhQAbAhABA6IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgSADgaAAQg6ABghglgAg2hbQgYAYgEAyICmAAQABgwgVgaQgUgaglAAQgmAAgXAag");
	this.shape_3036.setTransform(489.5,324.9,0.5,0.5);

	this.shape_3037 = new cjs.Shape();
	this.shape_3037.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_3037.setTransform(478.1,323.4,0.5,0.5);

	this.shape_3038 = new cjs.Shape();
	this.shape_3038.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_3038.setTransform(466.5,324.8,0.5,0.5);

	this.shape_3039 = new cjs.Shape();
	this.shape_3039.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgnQAggnA0gBQAwABAcAhQAbAhABA6IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgTAEQgRADgaAAQg6ABghglgAg3hbQgXAZgEAxICmAAQABgwgVgaQgUgaglAAQglAAgZAag");
	this.shape_3039.setTransform(451.9,324.9,0.5,0.5);

	this.shape_3040 = new cjs.Shape();
	this.shape_3040.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgRgggBQgpAAgUAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAKgTAWgMQAWgLAXAAQBBAAARAwIABAAQAMgXAXgNQAXgMAcAAQAtAAAVAYQAWAXAAA0IAACwg");
	this.shape_3040.setTransform(433.7,324.8,0.5,0.5);

	this.shape_3041 = new cjs.Shape();
	this.shape_3041.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAGQgEAHgHAAQgPAAAAgZg");
	this.shape_3041.setTransform(419.6,322.4,0.5,0.5);

	this.shape_3042 = new cjs.Shape();
	this.shape_3042.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3042.setTransform(413.8,322,0.5,0.5);

	this.shape_3043 = new cjs.Shape();
	this.shape_3043.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAbQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_3043.setTransform(403.7,327.8,0.5,0.5);

	this.shape_3044 = new cjs.Shape();
	this.shape_3044.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgRgggBQgpAAgVAYQgTAWgBAyIAACdIgYAAIAAi4QABhFg/AAQgqAAgUAZQgTAagBA2IAACUIgYAAIAAkOIAUAAIAGAlIABAAQAMgTATgMQAXgLAXAAQBBAAAQAwIACAAQANgXAWgNQAYgMAaAAQAtAAAWAYQAXAXAAA0IAACwg");
	this.shape_3044.setTransform(384.5,324.8,0.5,0.5);

	this.shape_3045 = new cjs.Shape();
	this.shape_3045.graphics.f("#000000").s().p("Ag/B8QgbgSgPggQgOghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_3045.setTransform(365.7,324.9,0.5,0.5);

	this.shape_3046 = new cjs.Shape();
	this.shape_3046.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgxAAgaAfQgZAfAAA5QAAA3AZAeQAZAfAuAAQAkAAAggNIAAAXQgZAMgrAAQg5ABggglg");
	this.shape_3046.setTransform(352.5,324.9,0.5,0.5);

	this.shape_3047 = new cjs.Shape();
	this.shape_3047.graphics.f("#000000").s().p("AhzC/IAAgVQAQAEAPAAQANAAAKgGQAJgGAIgMQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKANQgLAOgMAGQgNAGgTAAQgPABgRgGg");
	this.shape_3047.setTransform(333.7,328,0.5,0.5);

	this.shape_3048 = new cjs.Shape();
	this.shape_3048.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1gBQAwABAbAhQAcAiABA5IAAASIjCAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgVAJgUAEQgTADgYAAQg6ABghglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgagkAAQglAAgZAag");
	this.shape_3048.setTransform(320.8,324.9,0.5,0.5);

	this.shape_3049 = new cjs.Shape();
	this.shape_3049.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_3049.setTransform(306.4,322,0.5,0.5);

	this.shape_3050 = new cjs.Shape();
	this.shape_3050.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZgBAQgDIAAAUQgSAFgYAAQgiABgSgUg");
	this.shape_3050.setTransform(294.3,323.4,0.5,0.5);

	this.shape_3051 = new cjs.Shape();
	this.shape_3051.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAGQgTBBgYA1g");
	this.shape_3051.setTransform(280.5,331.9,0.5,0.5);

	this.shape_3052 = new cjs.Shape();
	this.shape_3052.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0gBQAwABAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAXAAARgDQATgEAagKIAAAXQgYAJgTAEQgSADgYAAQg6ABghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgagkAAQgmAAgXAag");
	this.shape_3052.setTransform(271.1,324.9,0.5,0.5);

	this.shape_3053 = new cjs.Shape();
	this.shape_3053.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQgfAug6AAQg4AAgcgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAUgbABg9IAAgEQgBg+gUgcQgVgbgwAAQgqAAgXAfg");
	this.shape_3053.setTransform(256.2,322.1,0.5,0.5);

	this.shape_3054 = new cjs.Shape();
	this.shape_3054.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_3054.setTransform(246.1,322.4,0.5,0.5);

	this.shape_3055 = new cjs.Shape();
	this.shape_3055.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAuAAQAngBAVgNQAVgNAAgWQAAgVgRgNQgQgOgmgOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagRAtgBQArAAAoARIgJAXQgpgRghAAQghAAgTALQgTAMAAASQAAAWAPAMQAPANArAPQAlAOAQAKQARALAIANQAIANAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3055.setTransform(237.2,324.9,0.5,0.5);

	this.shape_3056 = new cjs.Shape();
	this.shape_3056.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_3056.setTransform(227.2,324.8,0.5,0.5);

	this.shape_3057 = new cjs.Shape();
	this.shape_3057.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAKgGQAJgGAIgMQAIgMALgdIAMgjIhnkOIAZAAIA6CYQAZBFAIAZIABAAQANgqAUg2IA6iWIAZAAIh4E6QgPAngKANQgKANgNAHQgNAGgUAAQgPABgQgGg");
	this.shape_3057.setTransform(217.3,328,0.5,0.5);

	this.shape_3058 = new cjs.Shape();
	this.shape_3058.graphics.f("#000000").s().p("Ag0C4QgYgMgNgWIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAVgLQAXgMAdAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAaAtAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_3058.setTransform(204.2,322.1,0.5,0.5);

	this.shape_3059 = new cjs.Shape();
	this.shape_3059.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_3059.setTransform(192.1,324.8,0.5,0.5);

	this.shape_3060 = new cjs.Shape();
	this.shape_3060.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA0gBQAwABAcAhQAbAhABA6IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgTAEQgRADgaAAQg6ABghglgAg3hbQgXAZgEAxICmAAQABgwgVgaQgUgaglAAQglAAgZAag");
	this.shape_3060.setTransform(181,324.9,0.5,0.5);

	this.shape_3061 = new cjs.Shape();
	this.shape_3061.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_3061.setTransform(166,322.1,0.5,0.5);

	this.shape_3062 = new cjs.Shape();
	this.shape_3062.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPAAAAgZg");
	this.shape_3062.setTransform(156,322.4,0.5,0.5);

	this.shape_3063 = new cjs.Shape();
	this.shape_3063.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvAAQAmgBAWgNQAVgNAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgJgOAAgSQAAggAagRQAagRAsgBQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAMAAASQAAAWAPAMQAQANAqAPQAmAOAQAKQARALAIANQAIANAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3063.setTransform(147.1,324.9,0.5,0.5);

	this.shape_3064 = new cjs.Shape();
	this.shape_3064.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgbAigUQgYgKgNgVQgNgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgdgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgSgRQgTgSggAAQghAAgSATg");
	this.shape_3064.setTransform(127.9,327.8,0.5,0.5);

	this.shape_3065 = new cjs.Shape();
	this.shape_3065.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvABgXAYQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_3065.setTransform(113.8,324.8,0.5,0.5);

	this.shape_3066 = new cjs.Shape();
	this.shape_3066.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAGQgFAHgHAAQgPAAAAgZg");
	this.shape_3066.setTransform(103.3,322.4,0.5,0.5);

	this.shape_3067 = new cjs.Shape();
	this.shape_3067.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpBzIBzCbg");
	this.shape_3067.setTransform(95.4,322,0.5,0.5);

	this.shape_3068 = new cjs.Shape();
	this.shape_3068.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_3068.setTransform(84,324.8,0.5,0.5);

	this.shape_3069 = new cjs.Shape();
	this.shape_3069.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAlg3AAQgkAAgbgQgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3069.setTransform(70.7,324.9,0.5,0.5);

	this.shape_3070 = new cjs.Shape();
	this.shape_3070.graphics.f("#000000").s().p("ABdC2IhelQIgLAxIhQEfIgWAAIhklrIAbAAIBVFDQAFgfAUhIIA/jcIAbAAIBJD8QANAsAFAbIAIgmIBNkdIAaAAIhlFrg");
	this.shape_3070.setTransform(51.9,322.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_3070},{t:this.shape_3069},{t:this.shape_3068},{t:this.shape_3067},{t:this.shape_3066},{t:this.shape_3065},{t:this.shape_3064},{t:this.shape_3063},{t:this.shape_3062},{t:this.shape_3061},{t:this.shape_3060},{t:this.shape_3059},{t:this.shape_3058},{t:this.shape_3057},{t:this.shape_3056},{t:this.shape_3055},{t:this.shape_3054},{t:this.shape_3053},{t:this.shape_3052},{t:this.shape_3051},{t:this.shape_3050},{t:this.shape_3049},{t:this.shape_3048},{t:this.shape_3047},{t:this.shape_3046},{t:this.shape_3045},{t:this.shape_3044},{t:this.shape_3043},{t:this.shape_3042},{t:this.shape_3041},{t:this.shape_3040},{t:this.shape_3039},{t:this.shape_3038},{t:this.shape_3037},{t:this.shape_3036},{t:this.shape_3035},{t:this.shape_3034},{t:this.shape_3033},{t:this.shape_3032},{t:this.shape_3031},{t:this.shape_3030},{t:this.shape_3029},{t:this.shape_3028},{t:this.shape_3027},{t:this.shape_3026},{t:this.shape_3025},{t:this.shape_3024},{t:this.shape_3023},{t:this.shape_3022},{t:this.shape_3021},{t:this.shape_3020},{t:this.shape_3019},{t:this.shape_3018},{t:this.shape_3017},{t:this.shape_3016},{t:this.shape_3015},{t:this.shape_3014},{t:this.shape_3013},{t:this.shape_3012},{t:this.shape_3011},{t:this.shape_3010},{t:this.shape_3009},{t:this.shape_3008},{t:this.shape_3007},{t:this.shape_3006},{t:this.shape_3005},{t:this.shape_3004},{t:this.shape_3003},{t:this.shape_3002},{t:this.shape_3001},{t:this.shape_3000},{t:this.shape_2999},{t:this.shape_2998},{t:this.shape_2997},{t:this.shape_2996},{t:this.shape_2995},{t:this.shape_2994},{t:this.shape_2993},{t:this.shape_2992},{t:this.shape_2991},{t:this.shape_2990},{t:this.shape_2989},{t:this.shape_2988},{t:this.shape_2987},{t:this.shape_2986},{t:this.shape_2985},{t:this.shape_2984},{t:this.shape_2983},{t:this.shape_2982},{t:this.shape_2981},{t:this.shape_2980},{t:this.shape_2979},{t:this.shape_2978},{t:this.shape_2977},{t:this.shape_2976},{t:this.shape_2975},{t:this.shape_2974},{t:this.shape_2973},{t:this.shape_2972},{t:this.shape_2971},{t:this.shape_2970},{t:this.shape_2969},{t:this.shape_2968},{t:this.shape_2967},{t:this.shape_2966},{t:this.shape_2965},{t:this.shape_2964},{t:this.shape_2963},{t:this.shape_2962},{t:this.shape_2961},{t:this.shape_2960},{t:this.shape_2959},{t:this.shape_2958},{t:this.shape_2957},{t:this.shape_2956},{t:this.shape_2955},{t:this.shape_2954},{t:this.shape_2953},{t:this.shape_2952},{t:this.shape_2951},{t:this.shape_2950},{t:this.shape_2949},{t:this.shape_2948},{t:this.shape_2947},{t:this.shape_2946},{t:this.shape_2945},{t:this.shape_2944},{t:this.shape_2943},{t:this.shape_2942},{t:this.shape_2941},{t:this.shape_2940},{t:this.shape_2939},{t:this.shape_2938},{t:this.shape_2937},{t:this.shape_2936},{t:this.shape_2935},{t:this.shape_2934},{t:this.shape_2933},{t:this.shape_2932},{t:this.shape_2931},{t:this.shape_2930},{t:this.shape_2929},{t:this.shape_2928},{t:this.shape_2927},{t:this.shape_2926},{t:this.shape_2925},{t:this.shape_2924},{t:this.shape_2923},{t:this.shape_2922},{t:this.shape_2921},{t:this.shape_2920},{t:this.shape_2919},{t:this.shape_2918},{t:this.shape_2917},{t:this.shape_2916},{t:this.shape_2915},{t:this.shape_2914},{t:this.shape_2913},{t:this.shape_2912},{t:this.shape_2911},{t:this.shape_2910},{t:this.shape_2909},{t:this.shape_2908},{t:this.shape_2907},{t:this.shape_2906},{t:this.shape_2905},{t:this.shape_2904},{t:this.shape_2903},{t:this.shape_2902},{t:this.shape_2901},{t:this.shape_2900},{t:this.shape_2899},{t:this.shape_2898},{t:this.shape_2897},{t:this.shape_2896},{t:this.shape_2895},{t:this.shape_2894},{t:this.shape_2893},{t:this.shape_2892},{t:this.shape_2891},{t:this.shape_2890},{t:this.shape_2889},{t:this.shape_2888},{t:this.shape_2887},{t:this.shape_2886},{t:this.shape_2885},{t:this.shape_2884},{t:this.shape_2883},{t:this.shape_2882},{t:this.shape_2881},{t:this.shape_2880},{t:this.shape_2879},{t:this.shape_2878},{t:this.shape_2877},{t:this.shape_2876},{t:this.shape_2875},{t:this.shape_2874},{t:this.shape_2873},{t:this.shape_2872},{t:this.shape_2871},{t:this.shape_2870},{t:this.shape_2869},{t:this.shape_2868},{t:this.shape_2867},{t:this.shape_2866},{t:this.shape_2865},{t:this.shape_2864},{t:this.shape_2863},{t:this.shape_2862},{t:this.shape_2861},{t:this.shape_2860},{t:this.shape_2859},{t:this.shape_2858},{t:this.shape_2857},{t:this.shape_2856},{t:this.shape_2855},{t:this.shape_2854},{t:this.shape_2853},{t:this.shape_2852},{t:this.shape_2851},{t:this.shape_2850},{t:this.shape_2849},{t:this.shape_2848},{t:this.shape_2847},{t:this.shape_2846},{t:this.shape_2845},{t:this.shape_2844},{t:this.shape_2843},{t:this.shape_2842},{t:this.shape_2841},{t:this.shape_2840},{t:this.shape_2839},{t:this.shape_2838},{t:this.shape_2837},{t:this.shape_2836},{t:this.shape_2835},{t:this.shape_2834},{t:this.shape_2833},{t:this.shape_2832},{t:this.shape_2831},{t:this.shape_2830},{t:this.shape_2829},{t:this.shape_2828},{t:this.shape_2827},{t:this.shape_2826},{t:this.shape_2825},{t:this.shape_2824},{t:this.shape_2823},{t:this.shape_2822},{t:this.shape_2821},{t:this.shape_2820},{t:this.shape_2819},{t:this.shape_2818},{t:this.shape_2817},{t:this.shape_2816},{t:this.shape_2815},{t:this.shape_2814},{t:this.shape_2813},{t:this.shape_2812},{t:this.shape_2811},{t:this.shape_2810},{t:this.shape_2809},{t:this.shape_2808},{t:this.shape_2807},{t:this.shape_2806},{t:this.shape_2805},{t:this.shape_2804},{t:this.shape_2803},{t:this.shape_2802},{t:this.shape_2801},{t:this.shape_2800},{t:this.shape_2799},{t:this.shape_2798},{t:this.shape_2797},{t:this.shape_2796},{t:this.shape_2795},{t:this.shape_2794},{t:this.shape_2793},{t:this.shape_2792},{t:this.shape_2791},{t:this.shape_2790},{t:this.shape_2789},{t:this.shape_2788},{t:this.shape_2787},{t:this.shape_2786},{t:this.shape_2785},{t:this.shape_2784},{t:this.shape_2783},{t:this.shape_2782},{t:this.shape_2781},{t:this.shape_2780},{t:this.shape_2779},{t:this.shape_2778},{t:this.shape_2777},{t:this.shape_2776},{t:this.shape_2775},{t:this.shape_2774},{t:this.shape_2773},{t:this.shape_2772},{t:this.shape_2771},{t:this.shape_2770},{t:this.shape_2769},{t:this.shape_2768},{t:this.shape_2767},{t:this.shape_2766},{t:this.shape_2765},{t:this.shape_2764},{t:this.shape_2763},{t:this.shape_2762},{t:this.shape_2761},{t:this.shape_2760},{t:this.shape_2759},{t:this.shape_2758},{t:this.shape_2757},{t:this.shape_2756},{t:this.shape_2755},{t:this.shape_2754},{t:this.shape_2753},{t:this.shape_2752},{t:this.shape_2751},{t:this.shape_2750},{t:this.shape_2749},{t:this.shape_2748},{t:this.shape_2747},{t:this.shape_2746},{t:this.shape_2745},{t:this.shape_2744},{t:this.shape_2743},{t:this.shape_2742},{t:this.shape_2741},{t:this.shape_2740},{t:this.shape_2739},{t:this.shape_2738},{t:this.shape_2737},{t:this.shape_2736},{t:this.shape_2735},{t:this.shape_2734},{t:this.shape_2733},{t:this.shape_2732},{t:this.shape_2731},{t:this.shape_2730},{t:this.shape_2729},{t:this.shape_2728},{t:this.shape_2727},{t:this.shape_2726},{t:this.shape_2725},{t:this.shape_2724},{t:this.shape_2723},{t:this.shape_2722},{t:this.shape_2721},{t:this.shape_2720},{t:this.shape_2719},{t:this.shape_2718},{t:this.shape_2717},{t:this.shape_2716},{t:this.shape_2715},{t:this.shape_2714},{t:this.shape_2713},{t:this.shape_2712},{t:this.shape_2711},{t:this.shape_2710},{t:this.shape_2709},{t:this.shape_2708},{t:this.shape_2707},{t:this.shape_2706},{t:this.shape_2705},{t:this.shape_2704},{t:this.shape_2703},{t:this.shape_2702},{t:this.shape_2701},{t:this.shape_2700},{t:this.shape_2699},{t:this.shape_2698},{t:this.shape_2697},{t:this.shape_2696},{t:this.shape_2695},{t:this.instance_11}]},110).to({state:[]},1).wait(54));

	// ButtonLeftRight copy 38
	this.buttonR18 = new lib.ButtonLeft_Right();
	this.buttonR18.name = "buttonR18";
	this.buttonR18.parent = this;
	this.buttonR18.setTransform(2025,513.5,1,1,180);
	this.buttonR18._off = true;
	new cjs.ButtonHelper(this.buttonR18, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR18).wait(109).to({_off:false},0).to({_off:true},1).wait(55));

	// ButtonLeftRight copy 39
	this.buttonL18 = new lib.ButtonLeft_Right();
	this.buttonL18.name = "buttonL18";
	this.buttonL18.parent = this;
	this.buttonL18.setTransform(0,437.2);
	this.buttonL18._off = true;
	new cjs.ButtonHelper(this.buttonL18, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL18).wait(109).to({_off:false},0).to({_off:true},1).wait(55));

	// Layer 1
	this.instance_12 = new lib.BandW_Drawing();
	this.instance_12.parent = this;
	this.instance_12.setTransform(-8.4,-19.5,1.033,1.033,0,0,-0.1);
	this.instance_12._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_12).wait(109).to({_off:false},0).to({_off:true},1).wait(55));

	// ButtonLeftRight copy 36
	this.buttonR17 = new lib.ButtonLeft_Right();
	this.buttonR17.name = "buttonR17";
	this.buttonR17.parent = this;
	this.buttonR17.setTransform(2025,513.5,1,1,180);
	this.buttonR17._off = true;
	new cjs.ButtonHelper(this.buttonR17, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR17).wait(108).to({_off:false},0).to({_off:true},1).wait(56));

	// ButtonLeftRight copy 37
	this.buttonL17 = new lib.ButtonLeft_Right();
	this.buttonL17.name = "buttonL17";
	this.buttonL17.parent = this;
	this.buttonL17.setTransform(0,437.2);
	this.buttonL17._off = true;
	new cjs.ButtonHelper(this.buttonL17, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL17).wait(108).to({_off:false},0).to({_off:true},1).wait(56));

	// Layer 1
	this.shape_3071 = new cjs.Shape();
	this.shape_3071.graphics.f("#000000").s().p("AgTDCIAAmDIAoAAIAAGDg");
	this.shape_3071.setTransform(197.2,738.7,0.5,0.5);

	this.shape_3072 = new cjs.Shape();
	this.shape_3072.graphics.f("#000000").s().p("AhPBpQgkglAAhCQABhAAggoQAggmA2AAQAzAAAeAhQAfAiAAA3IAAAZIi7AAQAAAwAXAZQAYAZApAAQAsAAAqgSIAAAlQgVAKgTADQgTAEgdAAQg8AAgigkgAgwhUQgTAVgDAmICNAAQAAgogRgUQgSgVggAAQggAAgUAWg");
	this.shape_3072.setTransform(186.9,741.5,0.5,0.5);

	this.shape_3073 = new cjs.Shape();
	this.shape_3073.graphics.f("#000000").s().p("ABJDCIAAixQAAgggPgQQgQgRggAAQgrAAgTAYQgUAXAAA0IAACPIgpAAIAAmDIApAAIAAB2QAAAXgCAMIADAAQAMgUAXgLQAWgLAcAAQAyAAAZAXQAZAZAAAyIAACyg");
	this.shape_3073.setTransform(171.9,738.7,0.5,0.5);

	this.shape_3074 = new cjs.Shape();
	this.shape_3074.graphics.f("#000000").s().p("AhBBpQghglAAhCQAAhEAhglQAhglA9AAQAVAAASAEQAVAFAKAFIgNAjQgOgFgQgEQgPgEgNAAQhTAAAABpQAAAyAVAbQAUAbAnAAQAhAAAlgOIAAAkQgbAOgqAAQg6AAghgkg");
	this.shape_3074.setTransform(158.2,741.5,0.5,0.5);

	this.shape_3075 = new cjs.Shape();
	this.shape_3075.graphics.f("#000000").s().p("AgUC7IAAkPIAoAAIAAEPgAgQiKQgIgHAAgOQAAgNAIgHQAGgHAKAAQAKAAAHAHQAIAHAAANQAAAPgIAGQgIAHgJAAQgJAAgHgHg");
	this.shape_3075.setTransform(148.7,739,0.5,0.5);

	this.shape_3076 = new cjs.Shape();
	this.shape_3076.graphics.f("#000000").s().p("ACKC2IAAjpQAAgsAEgsIgCAAIh9FBIghAAIh8lBIgCAAQAEAsAAAuIAADnIgoAAIAAlrIBAAAIB0EsIABAAIB0ksIA/AAIAAFrg");
	this.shape_3076.setTransform(133.9,739.3,0.5,0.5);

	this.shape_3077 = new cjs.Shape();
	this.shape_3077.graphics.f("#000000").s().p("Ah8DBIAAghQAPAEARAAQAqAAASgxIAPgnIhukQIAtAAIA7CbQAUA0ADAYIACAAIAPgqQAKgfA5ieIAsAAIh1E1QgPAtgZAUQgWATgjAAQgVAAgRgEg");
	this.shape_3077.setTransform(109.4,744.6,0.5,0.5);

	this.shape_3078 = new cjs.Shape();
	this.shape_3078.graphics.f("#000000").s().p("AhBBpQghglAAhCQAAhEAhglQAhglA8AAQAWAAASAEQAVAFAKAFIgNAjQgOgFgQgEQgPgEgOAAQhSAAAABpQAAAzAUAaQAVAbAnAAQAhAAAlgOIAAAkQgbAOgqAAQg7AAgggkg");
	this.shape_3078.setTransform(97.2,741.5,0.5,0.5);

	this.shape_3079 = new cjs.Shape();
	this.shape_3079.graphics.f("#000000").s().p("ABJCLIAAiwQAAghgPgQQgQgRggAAQgqAAgUAXQgUAXAAA2IAACOIgpAAIAAkQIAiAAIAGAlIACAAQAMgTAYgMQAWgLAcAAQAyAAAYAYQAZAYAAA0IAACxg");
	this.shape_3079.setTransform(83,741.4,0.5,0.5);

	this.shape_3080 = new cjs.Shape();
	this.shape_3080.graphics.f("#000000").s().p("AhVB4QgYgVAAgmQABhRCDgFIAugBIAAgRQAAgggOgQQgOgPgeAAQghAAgrAVIgMggQAVgLAWgGQAYgGAYAAQAxAAAXAVQAXAWAAAwIAAC5IgeAAIgJgmIgBAAQgVAZgUAJQgUAJgdAAQgpAAgXgVgAAbADQgxADgVANQgWANAAAdQAAAWANAMQAOAMAZAAQAmAAAVgVQAWgUAAgnIAAgZg");
	this.shape_3080.setTransform(67.6,741.6,0.5,0.5);

	this.shape_3081 = new cjs.Shape();
	this.shape_3081.graphics.f("#000000").s().p("ABeC2IjGkwIgCAAQAEA5AAAqIAADNIgnAAIAAlrIAwAAIDFEvIACAAIgCgrQgBgYAAgcIAAjQIAnAAIAAFrg");
	this.shape_3081.setTransform(51.4,739.3,0.5,0.5);

	this.shape_3082 = new cjs.Shape();
	this.shape_3082.graphics.f("#000000").s().p("AAJA/QAJgdAHghQAJglADgZIAdAAIAEAEQgKAigMAfQgMAfgKAYgAhFA/QAHgWAJgnIAMg/IAdAAIADAEQgSBAgZA4g");
	this.shape_3082.setTransform(380.5,695,0.5,0.5);

	this.shape_3083 = new cjs.Shape();
	this.shape_3083.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3083.setTransform(372.3,701.8,0.5,0.5);

	this.shape_3084 = new cjs.Shape();
	this.shape_3084.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3084.setTransform(360.7,703.2,0.5,0.5);

	this.shape_3085 = new cjs.Shape();
	this.shape_3085.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3085.setTransform(345.9,703.4,0.5,0.5);

	this.shape_3086 = new cjs.Shape();
	this.shape_3086.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3086.setTransform(335.2,701.8,0.5,0.5);

	this.shape_3087 = new cjs.Shape();
	this.shape_3087.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_3087.setTransform(327,703.2,0.5,0.5);

	this.shape_3088 = new cjs.Shape();
	this.shape_3088.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3088.setTransform(313.7,703.3,0.5,0.5);

	this.shape_3089 = new cjs.Shape();
	this.shape_3089.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAmIACAAQAcgrA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAaAAA7IAAAIQAAA/AVAaQAWAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_3089.setTransform(299,706.3,0.5,0.5);

	this.shape_3090 = new cjs.Shape();
	this.shape_3090.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3090.setTransform(279.8,703.2,0.5,0.5);

	this.shape_3091 = new cjs.Shape();
	this.shape_3091.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3091.setTransform(265.7,700.9,0.5,0.5);

	this.shape_3092 = new cjs.Shape();
	this.shape_3092.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgKgIgOQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgogQgiAAQggAAgUALQgTALAAATQAAAWAOAMQAPANAsAQQAjAMASAKQAQAKAJAOQAIAOAAASQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_3092.setTransform(250.1,703.3,0.5,0.5);

	this.shape_3093 = new cjs.Shape();
	this.shape_3093.graphics.f("#000000").s().p("AgdA/QAHgWAJgnIAMg/IAcAAIADAEQgUBEgWA0g");
	this.shape_3093.setTransform(242.4,695,0.5,0.5);

	this.shape_3094 = new cjs.Shape();
	this.shape_3094.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQALAPAXAAQAWAAASgEIAAATQgRAHgXAAQgkgBgQgSg");
	this.shape_3094.setTransform(236.1,701.8,0.5,0.5);

	this.shape_3095 = new cjs.Shape();
	this.shape_3095.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQABgnAggXQAhgUA+gCIAzgBIAAgSQAAgmgPgUQgRgUgiAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAVAXQAXAXAAAxIAACzIgSAAIgHgrIgCAAQgUAagWALQgVALgcAAQgpAAgVgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3095.setTransform(224.8,703.4,0.5,0.5);

	this.shape_3096 = new cjs.Shape();
	this.shape_3096.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_3096.setTransform(211.1,700.4,0.5,0.5);

	this.shape_3097 = new cjs.Shape();
	this.shape_3097.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3097.setTransform(199,701.8,0.5,0.5);

	this.shape_3098 = new cjs.Shape();
	this.shape_3098.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAVAQANQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3098.setTransform(182.3,703.3,0.5,0.5);

	this.shape_3099 = new cjs.Shape();
	this.shape_3099.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3099.setTransform(170.4,703.3,0.5,0.5);

	this.shape_3100 = new cjs.Shape();
	this.shape_3100.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3100.setTransform(157.5,703.3,0.5,0.5);

	this.shape_3101 = new cjs.Shape();
	this.shape_3101.graphics.f("#000000").s().p("AhABoQggglgBhBQABhCAhgmQAjglA6AAQAkAAAfAMIgHAWQgjgMgZAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAkAAAhgNIAAAXQgaAMgrAAQg4AAgigkg");
	this.shape_3101.setTransform(144.8,703.3,0.5,0.5);

	this.shape_3102 = new cjs.Shape();
	this.shape_3102.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOggAAgqQAAhBAgglQAhglA2AAQA4AAAgAlQAgAmAABAQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_3102.setTransform(131,703.3,0.5,0.5);

	this.shape_3103 = new cjs.Shape();
	this.shape_3103.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3103.setTransform(119.4,703.2,0.5,0.5);

	this.shape_3104 = new cjs.Shape();
	this.shape_3104.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_3104.setTransform(106.4,706.3,0.5,0.5);

	this.shape_3105 = new cjs.Shape();
	this.shape_3105.graphics.f("#000000").s().p("AhPB4QgWgVABgkQAAgnAggXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgRgUgiAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAVAXAAAxIAACzIgSAAIgFgrIgDAAQgUAagVALQgWALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAOABAgQAAAaAPANQAQAPAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_3105.setTransform(84.6,703.4,0.5,0.5);

	this.shape_3106 = new cjs.Shape();
	this.shape_3106.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgKgIgOQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgpgQghAAQggAAgUALQgTALAAATQAAAWAOAMQAQANArAQQAkANARAJQAQAKAJAOQAIAOAAASQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_3106.setTransform(65.6,703.3,0.5,0.5);

	this.shape_3107 = new cjs.Shape();
	this.shape_3107.graphics.f("#000000").s().p("AgdA/QAHgWAJgnIAMg/IAcAAIADAEQgTBAgXA4g");
	this.shape_3107.setTransform(57.9,695,0.5,0.5);

	this.shape_3108 = new cjs.Shape();
	this.shape_3108.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQALAPAXAAQAWAAASgEIAAATQgSAHgWAAQgkgBgQgSg");
	this.shape_3108.setTransform(51.6,701.8,0.5,0.5);

	this.shape_3109 = new cjs.Shape();
	this.shape_3109.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_3109.setTransform(44.6,700.9,0.5,0.5);

	this.shape_3110 = new cjs.Shape();
	this.shape_3110.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgUBEgWA0g");
	this.shape_3110.setTransform(755.5,672,0.5,0.5);

	this.shape_3111 = new cjs.Shape();
	this.shape_3111.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokNIAaAAIA5CYQAcBMAFARIAAAAIAjhfIA5iWIAZAAIh4E5QgPAngKANQgKAOgNAGQgNAHgTgBQgPAAgRgEg");
	this.shape_3111.setTransform(747.3,668.2,0.5,0.5);

	this.shape_3112 = new cjs.Shape();
	this.shape_3112.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_3112.setTransform(738.6,662.2,0.5,0.5);

	this.shape_3113 = new cjs.Shape();
	this.shape_3113.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3113.setTransform(728.7,665.1,0.5,0.5);

	this.shape_3114 = new cjs.Shape();
	this.shape_3114.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgnAAIAAgPIAngLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQABAgAJAOQAMAPAXAAQAWAAATgEIAAATQgRAHgZAAQgjgBgRgSg");
	this.shape_3114.setTransform(717.2,663.6,0.5,0.5);

	this.shape_3115 = new cjs.Shape();
	this.shape_3115.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAVAXQAXAYAAAwIAACzIgTAAIgGgrIgCAAQgVAagVALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3115.setTransform(705.9,665.1,0.5,0.5);

	this.shape_3116 = new cjs.Shape();
	this.shape_3116.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3116.setTransform(688.4,665,0.5,0.5);

	this.shape_3117 = new cjs.Shape();
	this.shape_3117.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3117.setTransform(674.2,662.6,0.5,0.5);

	this.shape_3118 = new cjs.Shape();
	this.shape_3118.graphics.f("#000000").s().p("AgSCYQgQgUgBgpIAAitIgnAAIAAgPIAngLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQgBAgAKAOQAMAPAXAAQAWAAASgEIAAATQgRAHgXAAQgkgBgRgSg");
	this.shape_3118.setTransform(666.9,663.6,0.5,0.5);

	this.shape_3119 = new cjs.Shape();
	this.shape_3119.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3119.setTransform(659.9,662.2,0.5,0.5);

	this.shape_3120 = new cjs.Shape();
	this.shape_3120.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACvQAAApASASQASATAjAAQAvAAAXgZQAXgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgaAqhCAAQhdAAAAhjg");
	this.shape_3120.setTransform(649.5,665.2,0.5,0.5);

	this.shape_3121 = new cjs.Shape();
	this.shape_3121.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3121.setTransform(627.4,662.3,0.5,0.5);

	this.shape_3122 = new cjs.Shape();
	this.shape_3122.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3122.setTransform(612.8,665,0.5,0.5);

	this.shape_3123 = new cjs.Shape();
	this.shape_3123.graphics.f("#000000").s().p("AhPB4QgWgVABgkQAAgnAggXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgRgUgiAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAVAXAAAxIAACzIgSAAIgGgrIgCAAQgUAagVALQgWALgcAAQgpAAgWgUgAAeAAQg5ADgYAPQgYAOAAAgQABAaAPANQAQAPAcAAQAqAAAagZQAYgZAAgsIAAgZg");
	this.shape_3123.setTransform(598,665.1,0.5,0.5);

	this.shape_3124 = new cjs.Shape();
	this.shape_3124.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgJAWQgpgQghAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3124.setTransform(579,665.1,0.5,0.5);

	this.shape_3125 = new cjs.Shape();
	this.shape_3125.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3125.setTransform(567.1,665.1,0.5,0.5);

	this.shape_3126 = new cjs.Shape();
	this.shape_3126.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAggmQAggnA1AAQAwAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgTAEQgTADgYAAQg7AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_3126.setTransform(554.3,665.1,0.5,0.5);

	this.shape_3127 = new cjs.Shape();
	this.shape_3127.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAiglA6AAQAkAAAfAMIgHAWQgigMgaAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAaAfAtAAQAlAAAggNIAAAXQgaAMgrAAQg4AAgigkg");
	this.shape_3127.setTransform(541.5,665.1,0.5,0.5);

	this.shape_3128 = new cjs.Shape();
	this.shape_3128.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3128.setTransform(527.7,665.1,0.5,0.5);

	this.shape_3129 = new cjs.Shape();
	this.shape_3129.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3129.setTransform(516.1,665,0.5,0.5);

	this.shape_3130 = new cjs.Shape();
	this.shape_3130.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3130.setTransform(503.1,668,0.5,0.5);

	this.shape_3131 = new cjs.Shape();
	this.shape_3131.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAxAAAaAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3131.setTransform(481.5,665.1,0.5,0.5);

	this.shape_3132 = new cjs.Shape();
	this.shape_3132.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAbIABAAQAJggAMgfIBGi2IAZAAIhpENg");
	this.shape_3132.setTransform(468.6,665.1,0.5,0.5);

	this.shape_3133 = new cjs.Shape();
	this.shape_3133.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3133.setTransform(459.9,662.6,0.5,0.5);

	this.shape_3134 = new cjs.Shape();
	this.shape_3134.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgnAAIAAgPIAngLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQABAgAJAOQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3134.setTransform(452.6,663.6,0.5,0.5);

	this.shape_3135 = new cjs.Shape();
	this.shape_3135.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAVAXQAXAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3135.setTransform(441.3,665.1,0.5,0.5);

	this.shape_3136 = new cjs.Shape();
	this.shape_3136.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABg/AggnQAggnA0AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3136.setTransform(428,665.1,0.5,0.5);

	this.shape_3137 = new cjs.Shape();
	this.shape_3137.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3137.setTransform(416.9,665,0.5,0.5);

	this.shape_3138 = new cjs.Shape();
	this.shape_3138.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_3138.setTransform(405.3,665.1,0.5,0.5);

	this.shape_3139 = new cjs.Shape();
	this.shape_3139.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3139.setTransform(385.1,665.1,0.5,0.5);

	this.shape_3140 = new cjs.Shape();
	this.shape_3140.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgVgRgOQgRgOglgNQgogNgQgLQgRgLgIgNQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgogQgiAAQggAAgUALQgTALAAATQAAAWAOAMQAPANAsAQQAiAMATAKQARALAIANQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_3140.setTransform(366.2,665.1,0.5,0.5);

	this.shape_3141 = new cjs.Shape();
	this.shape_3141.graphics.f("#000000").s().p("AgdA/QAHgYAIglQAJgkADgbIAdAAIADAEQgTBBgYA3g");
	this.shape_3141.setTransform(358.5,656.8,0.5,0.5);

	this.shape_3142 = new cjs.Shape();
	this.shape_3142.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3142.setTransform(352.2,663.6,0.5,0.5);

	this.shape_3143 = new cjs.Shape();
	this.shape_3143.graphics.f("#000000").s().p("AgLC2IAAlrIAYAAIAAFrg");
	this.shape_3143.setTransform(344.9,662.8,0.5,0.5);

	this.shape_3144 = new cjs.Shape();
	this.shape_3144.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3144.setTransform(332,670.9,0.5,0.5);

	this.shape_3145 = new cjs.Shape();
	this.shape_3145.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAKgQAIgXIAOgkIhokNIAaAAIA4CYQAbBFAHAYIAAAAQAKggAZg/IA4iWIAaAAIh4E5QgPAlgKAPQgJANgOAHQgNAHgTgBQgPAAgRgEg");
	this.shape_3145.setTransform(323.1,668.2,0.5,0.5);

	this.shape_3146 = new cjs.Shape();
	this.shape_3146.graphics.f("#000000").s().p("AgSCYQgQgUgBgpIAAitIgnAAIAAgPIAngLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgAKAOQAMAPAXAAQAWAAATgEIAAATQgTAHgXAAQgjgBgRgSg");
	this.shape_3146.setTransform(312.8,663.6,0.5,0.5);

	this.shape_3147 = new cjs.Shape();
	this.shape_3147.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_3147.setTransform(305.8,662.6,0.5,0.5);

	this.shape_3148 = new cjs.Shape();
	this.shape_3148.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3148.setTransform(300.1,662.2,0.5,0.5);

	this.shape_3149 = new cjs.Shape();
	this.shape_3149.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgWALgcAAQgpAAgVgUgAAeAAQg5ADgXAPQgYAOAAAgQAAAaAPANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3149.setTransform(290,665.1,0.5,0.5);

	this.shape_3150 = new cjs.Shape();
	this.shape_3150.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQASATAjAAQAvAAAYgZQAWgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhDAAQhbAAgBhjg");
	this.shape_3150.setTransform(276.1,665.2,0.5,0.5);

	this.shape_3151 = new cjs.Shape();
	this.shape_3151.graphics.f("#000000").s().p("ABaDHIAAhnIABg9IgBAAQgdAug+ABQg2gBgdgiQgdglAAhBQAAhDAdgmQAegmA2AAQA6AAAdArIACAAIAEgmIAVAAIAAGIgAhBiRQgWAfAAA8QAAA4AWAdQAXAdApAAQAwAAAWgcQAVgbAAg/IAAgDQAAg9gVgbQgWgbguAAQgqAAgYAfg");
	this.shape_3151.setTransform(260.6,668,0.5,0.5);

	this.shape_3152 = new cjs.Shape();
	this.shape_3152.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3152.setTransform(243.9,662.2,0.5,0.5);

	this.shape_3153 = new cjs.Shape();
	this.shape_3153.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAVAXQAXAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3153.setTransform(233.9,665.1,0.5,0.5);

	this.shape_3154 = new cjs.Shape();
	this.shape_3154.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAARAEIgEAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3154.setTransform(223.5,665,0.5,0.5);

	this.shape_3155 = new cjs.Shape();
	this.shape_3155.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARATAkAAQAwAAAXgZQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgaAqhCAAQhdAAAAhjg");
	this.shape_3155.setTransform(210,665.2,0.5,0.5);

	this.shape_3156 = new cjs.Shape();
	this.shape_3156.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3156.setTransform(198.1,663.6,0.5,0.5);

	this.shape_3157 = new cjs.Shape();
	this.shape_3157.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3157.setTransform(186.8,668,0.5,0.5);

	this.shape_3158 = new cjs.Shape();
	this.shape_3158.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3158.setTransform(176,662.2,0.5,0.5);

	this.shape_3159 = new cjs.Shape();
	this.shape_3159.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQARATAlAAQAuAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgaAqhDAAQhdAAABhjg");
	this.shape_3159.setTransform(165.5,665.2,0.5,0.5);

	this.shape_3160 = new cjs.Shape();
	this.shape_3160.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3160.setTransform(152.3,665.1,0.5,0.5);

	this.shape_3161 = new cjs.Shape();
	this.shape_3161.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3161.setTransform(139.9,665.1,0.5,0.5);

	this.shape_3162 = new cjs.Shape();
	this.shape_3162.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3162.setTransform(120.2,665.1,0.5,0.5);

	this.shape_3163 = new cjs.Shape();
	this.shape_3163.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBCgYA2g");
	this.shape_3163.setTransform(104.2,672,0.5,0.5);

	this.shape_3164 = new cjs.Shape();
	this.shape_3164.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAYAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAKgTAWgMQAUgLAZAAQBBAAARAwIABAAQAMgXAXgNQAWgMAdAAQAtAAAVAYQAWAWAAA1IAACwg");
	this.shape_3164.setTransform(90.6,665,0.5,0.5);

	this.shape_3165 = new cjs.Shape();
	this.shape_3165.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjCAAQAAA5AaAdQAZAdAvAAQATAAAVgDQARgDAbgLIAAAWQgWAKgTAEQgTADgYAAQg6AAghgkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_3165.setTransform(72.3,665.1,0.5,0.5);

	this.shape_3166 = new cjs.Shape();
	this.shape_3166.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_3166.setTransform(57.9,662.2,0.5,0.5);

	this.shape_3167 = new cjs.Shape();
	this.shape_3167.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3167.setTransform(45.8,663.6,0.5,0.5);

	this.shape_3168 = new cjs.Shape();
	this.shape_3168.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3168.setTransform(744.5,626.7,0.5,0.5);

	this.shape_3169 = new cjs.Shape();
	this.shape_3169.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3169.setTransform(734.1,624.4,0.5,0.5);

	this.shape_3170 = new cjs.Shape();
	this.shape_3170.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNABgWQgBgUgQgPQgRgOglgNQgngNgSgLQgPgKgJgOQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgogQgiAAQggAAgUALQgTALAAATQAAAWAOAMQAQANArAQQAjAMASAKQAQAKAIAOQAJANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_3170.setTransform(718.5,626.8,0.5,0.5);

	this.shape_3171 = new cjs.Shape();
	this.shape_3171.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgJAWQgpgQghAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3171.setTransform(706.6,626.8,0.5,0.5);

	this.shape_3172 = new cjs.Shape();
	this.shape_3172.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAxAAAbAhQAbAiAAA5IAAASIjBAAQAAA5AaAdQAZAdAvAAQATAAAVgDQARgDAbgLIAAAWQgWAKgTAEQgTADgYAAQg7AAgggkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_3172.setTransform(693.8,626.8,0.5,0.5);

	this.shape_3173 = new cjs.Shape();
	this.shape_3173.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQguAAgYAZQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAAABjIAACwg");
	this.shape_3173.setTransform(679.3,626.7,0.5,0.5);

	this.shape_3174 = new cjs.Shape();
	this.shape_3174.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_3174.setTransform(664.5,629.8,0.5,0.5);

	this.shape_3175 = new cjs.Shape();
	this.shape_3175.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNgBgWQAAgUgQgPQgSgOglgNQgmgNgRgLQgRgLgIgNQgJgOAAgTQABgeAZgSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgeAAgVALQgUALAAATQAAAWAQAMQAPANAqAQQAjAMATAKQAQAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3175.setTransform(650.5,626.8,0.5,0.5);

	this.shape_3176 = new cjs.Shape();
	this.shape_3176.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3176.setTransform(641.8,624.4,0.5,0.5);

	this.shape_3177 = new cjs.Shape();
	this.shape_3177.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3177.setTransform(634.8,626.7,0.5,0.5);

	this.shape_3178 = new cjs.Shape();
	this.shape_3178.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAhgmQAjglA6AAQAkAAAfAMIgGAWQgkgMgZAAQgyAAgZAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAlAAAggNIAAAXQgaAMgrAAQg4AAgigkg");
	this.shape_3178.setTransform(623.2,626.8,0.5,0.5);

	this.shape_3179 = new cjs.Shape();
	this.shape_3179.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3179.setTransform(602.3,624,0.5,0.5);

	this.shape_3180 = new cjs.Shape();
	this.shape_3180.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_3180.setTransform(587.6,626.7,0.5,0.5);

	this.shape_3181 = new cjs.Shape();
	this.shape_3181.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgrIgCAAQgVAagVALQgWALgcAAQgpAAgVgUgAAeAAQg5ADgXAPQgYAOAAAgQAAAaAPANQAQAPAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_3181.setTransform(572.8,626.9,0.5,0.5);

	this.shape_3182 = new cjs.Shape();
	this.shape_3182.graphics.f("#000000").s().p("AhNBoQghgkAAhCQABhAAfgmQAggnA2AAQAvAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgYAKgTAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3182.setTransform(552.9,626.8,0.5,0.5);

	this.shape_3183 = new cjs.Shape();
	this.shape_3183.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_3183.setTransform(540.1,626.8,0.5,0.5);

	this.shape_3184 = new cjs.Shape();
	this.shape_3184.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3184.setTransform(526.3,626.7,0.5,0.5);

	this.shape_3185 = new cjs.Shape();
	this.shape_3185.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3185.setTransform(511.5,626.9,0.5,0.5);

	this.shape_3186 = new cjs.Shape();
	this.shape_3186.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_3186.setTransform(502.4,623.9,0.5,0.5);

	this.shape_3187 = new cjs.Shape();
	this.shape_3187.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3187.setTransform(492.3,626.9,0.5,0.5);

	this.shape_3188 = new cjs.Shape();
	this.shape_3188.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAQgYAWgMQAVgLAeAAQA5AAAdAjQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_3188.setTransform(478.8,624,0.5,0.5);

	this.shape_3189 = new cjs.Shape();
	this.shape_3189.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBCgYA2g");
	this.shape_3189.setTransform(461,633.8,0.5,0.5);

	this.shape_3190 = new cjs.Shape();
	this.shape_3190.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOgkgNQgngNgRgLQgRgLgIgNQgIgOgBgTQAAgeAagSQAZgRAuAAQArAAAnAQIgIAWQgogQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAPANAsAQQAiAMATAKQAQAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3190.setTransform(452.7,626.8,0.5,0.5);

	this.shape_3191 = new cjs.Shape();
	this.shape_3191.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQgBgUgQgPQgSgOglgNQgmgNgRgLQgRgKgIgOQgJgOAAgTQABgeAZgSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQgfAAgVALQgUALABATQgBAWAQAMQAPANAqAQQAkAMARAKQARAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3191.setTransform(440.8,626.8,0.5,0.5);

	this.shape_3192 = new cjs.Shape();
	this.shape_3192.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AaAdQAZAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3192.setTransform(427.9,626.8,0.5,0.5);

	this.shape_3193 = new cjs.Shape();
	this.shape_3193.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_3193.setTransform(413.5,626.7,0.5,0.5);

	this.shape_3194 = new cjs.Shape();
	this.shape_3194.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3194.setTransform(401.4,625.3,0.5,0.5);

	this.shape_3195 = new cjs.Shape();
	this.shape_3195.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgcAAgNARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3195.setTransform(394.4,623.9,0.5,0.5);

	this.shape_3196 = new cjs.Shape();
	this.shape_3196.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3196.setTransform(382.2,626.8,0.5,0.5);

	this.shape_3197 = new cjs.Shape();
	this.shape_3197.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOgkgNQgngNgRgLQgRgLgIgNQgIgOgBgTQAAgeAagSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAPANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3197.setTransform(368.7,626.8,0.5,0.5);

	this.shape_3198 = new cjs.Shape();
	this.shape_3198.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3198.setTransform(351.8,625.3,0.5,0.5);

	this.shape_3199 = new cjs.Shape();
	this.shape_3199.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA2IAACVIgYAAIAAmDIAYAAIgCCeIADAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_3199.setTransform(340.3,623.9,0.5,0.5);

	this.shape_3200 = new cjs.Shape();
	this.shape_3200.graphics.f("#000000").s().p("AhdC0QgdgUAAgjQAAgcARgTQASgSAegGQgNgGgHgKQgHgJAAgMQAAgaAigWQgXgJgOgVQgNgTABgcQgBgpAagZQAagYArAAQAbAAAOAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIALAAAKQAAANAKAGQAKAHAXgBIAuAAQArAAAZASQAXASAAAjQAAArgjAXQghAXhBAAQgyAAgcgTgAhgB6QAAA4BUABQBpgBAAhEQAAgXgQgMQgRgLglAAIgsAAQhKAAgBA6gAg4igQgSASAAAiQgBAfAUARQATARAfABQAhgBASgRQASgRAAghQAAgigTgRQgRgSgiAAQgfAAgTATg");
	this.shape_3200.setTransform(326,629.8,0.5,0.5);

	this.shape_3201 = new cjs.Shape();
	this.shape_3201.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3201.setTransform(316.5,624.4,0.5,0.5);

	this.shape_3202 = new cjs.Shape();
	this.shape_3202.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIADAAQAQgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3202.setTransform(309.5,626.7,0.5,0.5);

	this.shape_3203 = new cjs.Shape();
	this.shape_3203.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgZAAQg7AAghgkgAg2hcQgXAZgFAyICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_3203.setTransform(290,626.8,0.5,0.5);

	this.shape_3204 = new cjs.Shape();
	this.shape_3204.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAYAAA3IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAiAAQBbAAABBiIAACxg");
	this.shape_3204.setTransform(275.6,623.9,0.5,0.5);

	this.shape_3205 = new cjs.Shape();
	this.shape_3205.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_3205.setTransform(263.5,625.3,0.5,0.5);

	this.shape_3206 = new cjs.Shape();
	this.shape_3206.graphics.f("#000000").s().p("AgSCYQgQgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgALAOQALAPAXAAQAWAAATgEIAAATQgRAHgZAAQgigBgSgSg");
	this.shape_3206.setTransform(248.4,625.3,0.5,0.5);

	this.shape_3207 = new cjs.Shape();
	this.shape_3207.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3207.setTransform(237.3,626.8,0.5,0.5);

	this.shape_3208 = new cjs.Shape();
	this.shape_3208.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgTQARgSAegGQgMgGgIgKQgHgJAAgMQAAgaAigWQgYgJgMgVQgOgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAmgaAZQgaAYgrAAQgSABgIgCQgOAIgIAKQgIAKAAALQAAANAKAGQAKAHAXgBIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB6QAAA4BTABQBpgBAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQAUARAfABQAhgBASgRQASgRAAghQAAgigSgRQgTgSggAAQggAAgTATg");
	this.shape_3208.setTransform(223.6,629.8,0.5,0.5);

	this.shape_3209 = new cjs.Shape();
	this.shape_3209.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3209.setTransform(202.9,626.8,0.5,0.5);

	this.shape_3210 = new cjs.Shape();
	this.shape_3210.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3210.setTransform(190.9,625.3,0.5,0.5);

	this.shape_3211 = new cjs.Shape();
	this.shape_3211.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA5CYQAbBFAHAYIAAAAIAihfIA5iWIAaAAIh4E5QgOAlgLAPQgJANgPAHQgMAHgTgBQgPAAgRgEg");
	this.shape_3211.setTransform(174.4,629.9,0.5,0.5);

	this.shape_3212 = new cjs.Shape();
	this.shape_3212.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_3212.setTransform(164.4,626.7,0.5,0.5);

	this.shape_3213 = new cjs.Shape();
	this.shape_3213.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgjgBgRgSg");
	this.shape_3213.setTransform(154.1,625.3,0.5,0.5);

	this.shape_3214 = new cjs.Shape();
	this.shape_3214.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQARATAkAAQAwAAAXgZQAXgZAAg2IAAiVIAXAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAABhjg");
	this.shape_3214.setTransform(135.8,627,0.5,0.5);

	this.shape_3215 = new cjs.Shape();
	this.shape_3215.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3215.setTransform(120.9,626.8,0.5,0.5);

	this.shape_3216 = new cjs.Shape();
	this.shape_3216.graphics.f("#000000").s().p("AgMC2IAAiLIh6jgIAeAAIBpDGIBqjGIAcAAIh6DeIAACNg");
	this.shape_3216.setTransform(106.7,624.5,0.5,0.5);

	this.shape_3217 = new cjs.Shape();
	this.shape_3217.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3217.setTransform(90.3,632.6,0.5,0.5);

	this.shape_3218 = new cjs.Shape();
	this.shape_3218.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3218.setTransform(80.3,626.8,0.5,0.5);

	this.shape_3219 = new cjs.Shape();
	this.shape_3219.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3219.setTransform(66.3,626.8,0.5,0.5);

	this.shape_3220 = new cjs.Shape();
	this.shape_3220.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3220.setTransform(55.2,626.7,0.5,0.5);

	this.shape_3221 = new cjs.Shape();
	this.shape_3221.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3221.setTransform(46.4,623.9,0.5,0.5);

	this.shape_3222 = new cjs.Shape();
	this.shape_3222.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AggnQAhgnA1AAQAwAAAbAhQAcAhgBA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgZAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3222.setTransform(765.6,588.6,0.5,0.5);

	this.shape_3223 = new cjs.Shape();
	this.shape_3223.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3223.setTransform(754.1,587.1,0.5,0.5);

	this.shape_3224 = new cjs.Shape();
	this.shape_3224.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3224.setTransform(747.2,586.1,0.5,0.5);

	this.shape_3225 = new cjs.Shape();
	this.shape_3225.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAvAAAXgZQAXgYAAg3IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_3225.setTransform(736.7,588.7,0.5,0.5);

	this.shape_3226 = new cjs.Shape();
	this.shape_3226.graphics.f("#000000").s().p("ABaDHIAAhnIABg9IgBAAQgdAug+ABQg2gBgdgiQgdglAAhBQAAhDAdgmQAegmA2AAQA6AAAdArIACAAIAEgmIAVAAIAAGIgAhAiRQgXAeAAA9QAAA4AWAdQAWAdAqAAQAwAAAWgcQAVgbAAg/IAAgDQAAg9gVgbQgWgbguAAQgrAAgWAfg");
	this.shape_3226.setTransform(721.2,591.5,0.5,0.5);

	this.shape_3227 = new cjs.Shape();
	this.shape_3227.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3227.setTransform(700.4,588.6,0.5,0.5);

	this.shape_3228 = new cjs.Shape();
	this.shape_3228.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3228.setTransform(689.4,588.5,0.5,0.5);

	this.shape_3229 = new cjs.Shape();
	this.shape_3229.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3229.setTransform(676.3,588.6,0.5,0.5);

	this.shape_3230 = new cjs.Shape();
	this.shape_3230.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAKgQAIgXIANgkIhnkNIAaAAIA5CYQAaBFAHAYIAAAAQALggAYg/IA5iWIAZAAIh5E5QgNAlgLAPQgJANgOAHQgNAHgUgBQgOAAgRgEg");
	this.shape_3230.setTransform(657.5,591.7,0.5,0.5);

	this.shape_3231 = new cjs.Shape();
	this.shape_3231.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA0AAQAxAAAbAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQATAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgZAAQg7AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_3231.setTransform(644.7,588.6,0.5,0.5);

	this.shape_3232 = new cjs.Shape();
	this.shape_3232.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgwAAgXAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAXgLAiAAQBbAAABBiIAACxg");
	this.shape_3232.setTransform(630.2,585.7,0.5,0.5);

	this.shape_3233 = new cjs.Shape();
	this.shape_3233.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3233.setTransform(618.2,587.1,0.5,0.5);

	this.shape_3234 = new cjs.Shape();
	this.shape_3234.graphics.f("#000000").s().p("AgSCYQgQgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgALAOQALAPAXAAQAWAAASgEIAAATQgRAHgYAAQgigBgSgSg");
	this.shape_3234.setTransform(603,587.1,0.5,0.5);

	this.shape_3235 = new cjs.Shape();
	this.shape_3235.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAvAAAXgZQAYgZAAg2IAAiVIAXAAIAAEOIgUAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_3235.setTransform(591.3,588.7,0.5,0.5);

	this.shape_3236 = new cjs.Shape();
	this.shape_3236.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAQgYAWgMQAVgLAeAAQA5AAAdAjQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_3236.setTransform(576.7,585.8,0.5,0.5);

	this.shape_3237 = new cjs.Shape();
	this.shape_3237.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBCgYA2g");
	this.shape_3237.setTransform(558.9,595.5,0.5,0.5);

	this.shape_3238 = new cjs.Shape();
	this.shape_3238.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3238.setTransform(549.6,588.6,0.5,0.5);

	this.shape_3239 = new cjs.Shape();
	this.shape_3239.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQAAhCAigmQAjglA6AAQAjAAAhAMIgIAWQgjgMgaAAQgwAAgaAfQgZAfgBA4QABA3AZAfQAZAfAuAAQAkAAAhgNIAAAXQgaAMgrAAQg5AAgggkg");
	this.shape_3239.setTransform(536.9,588.6,0.5,0.5);

	this.shape_3240 = new cjs.Shape();
	this.shape_3240.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAcAhAAA6IAAASIjDAAQABA5AaAdQAZAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg6AAgggkgAg3hcQgYAagDAxICnAAQAAgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_3240.setTransform(523.5,588.6,0.5,0.5);

	this.shape_3241 = new cjs.Shape();
	this.shape_3241.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3241.setTransform(513.6,586.1,0.5,0.5);

	this.shape_3242 = new cjs.Shape();
	this.shape_3242.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3242.setTransform(503.5,591.5,0.5,0.5);

	this.shape_3243 = new cjs.Shape();
	this.shape_3243.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3243.setTransform(481.7,588.6,0.5,0.5);

	this.shape_3244 = new cjs.Shape();
	this.shape_3244.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3244.setTransform(464.4,587.1,0.5,0.5);

	this.shape_3245 = new cjs.Shape();
	this.shape_3245.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3245.setTransform(456.2,588.5,0.5,0.5);

	this.shape_3246 = new cjs.Shape();
	this.shape_3246.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3246.setTransform(443.1,588.6,0.5,0.5);

	this.shape_3247 = new cjs.Shape();
	this.shape_3247.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3247.setTransform(432.4,587.1,0.5,0.5);

	this.shape_3248 = new cjs.Shape();
	this.shape_3248.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3248.setTransform(422.3,588.6,0.5,0.5);

	this.shape_3249 = new cjs.Shape();
	this.shape_3249.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgWAKgVAEQgRADgZAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3249.setTransform(402.8,588.6,0.5,0.5);

	this.shape_3250 = new cjs.Shape();
	this.shape_3250.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOAzAGAiIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_3250.setTransform(386.6,588.6,0.5,0.5);

	this.shape_3251 = new cjs.Shape();
	this.shape_3251.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3251.setTransform(363.7,588.6,0.5,0.5);

	this.shape_3252 = new cjs.Shape();
	this.shape_3252.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3252.setTransform(352.7,588.5,0.5,0.5);

	this.shape_3253 = new cjs.Shape();
	this.shape_3253.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3253.setTransform(339.3,588.6,0.5,0.5);

	this.shape_3254 = new cjs.Shape();
	this.shape_3254.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3254.setTransform(328.9,585.6,0.5,0.5);

	this.shape_3255 = new cjs.Shape();
	this.shape_3255.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3255.setTransform(317.2,588.6,0.5,0.5);

	this.shape_3256 = new cjs.Shape();
	this.shape_3256.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgQAAIAAmCIAZAAIgBCfIABAAQAPgYAWgMQAWgLAeAAQA6AAAbAjQAeAlAABDQAABCgfAmQgeAkg2AAQgdAAgXgMgAhEgiQgVAbAAA/IAAAEQAAA+AWAaQAWAbAtAAQAsAAAVgfQAXggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_3256.setTransform(303,585.8,0.5,0.5);

	this.shape_3257 = new cjs.Shape();
	this.shape_3257.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNABgWQgBgUgQgPQgSgOgkgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAZgRAtAAQAsAAAoAQIgJAWQgpgQgiAAQgeAAgVALQgTALgBATQAAAWAPAMQAPANAsAQQAkANARAJQARALAHANQAJAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3257.setTransform(282.4,588.6,0.5,0.5);

	this.shape_3258 = new cjs.Shape();
	this.shape_3258.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAbAiAAA5IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAcgLIAAAWQgWAKgUAEQgRADgZAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_3258.setTransform(269.6,588.6,0.5,0.5);

	this.shape_3259 = new cjs.Shape();
	this.shape_3259.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAXgLAiAAQBbAAABBiIAACxg");
	this.shape_3259.setTransform(255.1,585.7,0.5,0.5);

	this.shape_3260 = new cjs.Shape();
	this.shape_3260.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3260.setTransform(241.7,588.6,0.5,0.5);

	this.shape_3261 = new cjs.Shape();
	this.shape_3261.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3261.setTransform(230.9,587.1,0.5,0.5);

	this.shape_3262 = new cjs.Shape();
	this.shape_3262.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA0AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgTAEQgRADgaAAQg6AAghgkgAg3hcQgWAZgFAyICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3262.setTransform(219.9,588.6,0.5,0.5);

	this.shape_3263 = new cjs.Shape();
	this.shape_3263.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_3263.setTransform(207.8,585.7,0.5,0.5);

	this.shape_3264 = new cjs.Shape();
	this.shape_3264.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgTALAAATQAAAWAPAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3264.setTransform(194.5,588.6,0.5,0.5);

	this.shape_3265 = new cjs.Shape();
	this.shape_3265.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3265.setTransform(174.5,588.6,0.5,0.5);

	this.shape_3266 = new cjs.Shape();
	this.shape_3266.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3266.setTransform(159.1,585.8,0.5,0.5);

	this.shape_3267 = new cjs.Shape();
	this.shape_3267.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgkAAQguAAgYAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_3267.setTransform(137.8,588.5,0.5,0.5);

	this.shape_3268 = new cjs.Shape();
	this.shape_3268.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3268.setTransform(123.2,588.6,0.5,0.5);

	this.shape_3269 = new cjs.Shape();
	this.shape_3269.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3269.setTransform(111.8,587.1,0.5,0.5);

	this.shape_3270 = new cjs.Shape();
	this.shape_3270.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3270.setTransform(104.7,585.6,0.5,0.5);

	this.shape_3271 = new cjs.Shape();
	this.shape_3271.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPggAAgqQAAhBAhglQAfglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgeAlg5AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_3271.setTransform(92.6,588.6,0.5,0.5);

	this.shape_3272 = new cjs.Shape();
	this.shape_3272.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3272.setTransform(71.5,588.6,0.5,0.5);

	this.shape_3273 = new cjs.Shape();
	this.shape_3273.graphics.f("#000000").s().p("ABdC2IhelRQgCANgJAmIhQEeIgWAAIhklrIAbAAIBVFDQAFggAUhHIA/jcIAbAAIBJD8QANAtAFAaIAIgmIBNkdIAaAAIhlFrg");
	this.shape_3273.setTransform(53.1,586.3,0.5,0.5);

	this.shape_3274 = new cjs.Shape();
	this.shape_3274.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3274.setTransform(762.5,556.1,0.5,0.5);

	this.shape_3275 = new cjs.Shape();
	this.shape_3275.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3275.setTransform(755.4,550.2,0.5,0.5);

	this.shape_3276 = new cjs.Shape();
	this.shape_3276.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjCAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgjAAQgmAAgZAag");
	this.shape_3276.setTransform(742.6,550.3,0.5,0.5);

	this.shape_3277 = new cjs.Shape();
	this.shape_3277.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3277.setTransform(731.1,548.8,0.5,0.5);

	this.shape_3278 = new cjs.Shape();
	this.shape_3278.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARATAkAAQAwAAAXgZQAXgZgBg2IAAiVIAYAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_3278.setTransform(719.4,550.5,0.5,0.5);

	this.shape_3279 = new cjs.Shape();
	this.shape_3279.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3279.setTransform(704.8,553.3,0.5,0.5);

	this.shape_3280 = new cjs.Shape();
	this.shape_3280.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgRgTgfAAQgpAAgUAXQgVAYABAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgaAAIAAkOIAVAAIAGAlIABAAQALgTAVgMQAUgLAaAAQA/AAASAwIABAAQAOgXAVgNQAWgMAcAAQAuAAAVAYQAWAXAAA0IAACwg");
	this.shape_3280.setTransform(685.6,550.2,0.5,0.5);

	this.shape_3281 = new cjs.Shape();
	this.shape_3281.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAeglA4AAQA5AAAfAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_3281.setTransform(666.8,550.3,0.5,0.5);

	this.shape_3282 = new cjs.Shape();
	this.shape_3282.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3282.setTransform(653.6,550.3,0.5,0.5);

	this.shape_3283 = new cjs.Shape();
	this.shape_3283.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3283.setTransform(633.4,550.4,0.5,0.5);

	this.shape_3284 = new cjs.Shape();
	this.shape_3284.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3284.setTransform(613,550.2,0.5,0.5);

	this.shape_3285 = new cjs.Shape();
	this.shape_3285.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3285.setTransform(598,550.3,0.5,0.5);

	this.shape_3286 = new cjs.Shape();
	this.shape_3286.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAKgQAIgXIANgkIhnkNIAaAAIA4CYQAbBFAHAYIAAAAQAKggAZg/IA4iWIAaAAIh5E5QgOAlgKAPQgJANgOAHQgNAHgTgBQgQAAgQgEg");
	this.shape_3286.setTransform(578,553.4,0.5,0.5);

	this.shape_3287 = new cjs.Shape();
	this.shape_3287.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3287.setTransform(568.1,550.2,0.5,0.5);

	this.shape_3288 = new cjs.Shape();
	this.shape_3288.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3288.setTransform(559.4,547.4,0.5,0.5);

	this.shape_3289 = new cjs.Shape();
	this.shape_3289.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgWAKgVAEQgRADgZAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3289.setTransform(549.5,550.3,0.5,0.5);

	this.shape_3290 = new cjs.Shape();
	this.shape_3290.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOAzAGAiIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_3290.setTransform(533.3,550.3,0.5,0.5);

	this.shape_3291 = new cjs.Shape();
	this.shape_3291.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_3291.setTransform(517.1,550.3,0.5,0.5);

	this.shape_3292 = new cjs.Shape();
	this.shape_3292.graphics.f("#000000").s().p("AgwDwIAAgVQAQAEAQAAQAkAAAAgrIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgTAAgOgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAAKgEAIQgFAGgHAAQgQAAAAgYg");
	this.shape_3292.setTransform(505.5,550.9,0.5,0.5);

	this.shape_3293 = new cjs.Shape();
	this.shape_3293.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3293.setTransform(493.6,550.2,0.5,0.5);

	this.shape_3294 = new cjs.Shape();
	this.shape_3294.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQASATAjAAQAvAAAYgZQAWgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhDAAQhbAAgBhjg");
	this.shape_3294.setTransform(480.2,550.5,0.5,0.5);

	this.shape_3295 = new cjs.Shape();
	this.shape_3295.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3295.setTransform(465.2,550.3,0.5,0.5);

	this.shape_3296 = new cjs.Shape();
	this.shape_3296.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3296.setTransform(443.7,550.2,0.5,0.5);

	this.shape_3297 = new cjs.Shape();
	this.shape_3297.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQgBgcASgTQAQgSAfgGQgMgGgIgKQgHgJAAgMQgBgaAkgWQgZgJgMgVQgOgUAAgbQAAgpAagZQAZgYAtAAQAaAAAOAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgiAXQgkAXg+AAQgzAAgcgTgAhfB6QAAA4BTABQBpgBAAhEQAAgXgQgMQgRgLglAAIgsAAQhKAAAAA6gAg5igQgSASAAAiQAAAeATASQAUARAfABQAhgBASgRQASgRAAghQAAgigTgRQgTgSgfAAQghAAgTATg");
	this.shape_3297.setTransform(429.5,553.3,0.5,0.5);

	this.shape_3298 = new cjs.Shape();
	this.shape_3298.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3298.setTransform(419.9,547.9,0.5,0.5);

	this.shape_3299 = new cjs.Shape();
	this.shape_3299.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3299.setTransform(411,550.3,0.5,0.5);

	this.shape_3300 = new cjs.Shape();
	this.shape_3300.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgnA1AAQAxAAAaAhQAcAiABA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgTAEQgTADgYAAQg7AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_3300.setTransform(398.1,550.3,0.5,0.5);

	this.shape_3301 = new cjs.Shape();
	this.shape_3301.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdglA3AAQAeAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_3301.setTransform(383.1,547.5,0.5,0.5);

	this.shape_3302 = new cjs.Shape();
	this.shape_3302.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3302.setTransform(364.9,548.8,0.5,0.5);

	this.shape_3303 = new cjs.Shape();
	this.shape_3303.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3303.setTransform(353.3,550.3,0.5,0.5);

	this.shape_3304 = new cjs.Shape();
	this.shape_3304.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3304.setTransform(338.4,550.2,0.5,0.5);

	this.shape_3305 = new cjs.Shape();
	this.shape_3305.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdglA3AAQAeAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_3305.setTransform(316.2,547.5,0.5,0.5);

	this.shape_3306 = new cjs.Shape();
	this.shape_3306.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3306.setTransform(306.1,547.4,0.5,0.5);

	this.shape_3307 = new cjs.Shape();
	this.shape_3307.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAvAAAXgZQAYgZAAg2IAAiVIAXAAIAAEOIgUAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_3307.setTransform(295.6,550.5,0.5,0.5);

	this.shape_3308 = new cjs.Shape();
	this.shape_3308.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3308.setTransform(280.7,550.3,0.5,0.5);

	this.shape_3309 = new cjs.Shape();
	this.shape_3309.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQABhCAigmQAiglA6AAQAjAAAhAMIgIAWQgigMgbAAQgvAAgbAfQgaAfAAA4QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg5AAghgkg");
	this.shape_3309.setTransform(267.5,550.3,0.5,0.5);

	this.shape_3310 = new cjs.Shape();
	this.shape_3310.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAwAAAWgZQAYgZAAg2IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_3310.setTransform(246.9,550.5,0.5,0.5);

	this.shape_3311 = new cjs.Shape();
	this.shape_3311.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3311.setTransform(232,550.3,0.5,0.5);

	this.shape_3312 = new cjs.Shape();
	this.shape_3312.graphics.f("#000000").s().p("AgMC2IAAiLIh6jgIAeAAIBpDGIBqjGIAcAAIh6DeIAACNg");
	this.shape_3312.setTransform(217.8,548,0.5,0.5);

	this.shape_3313 = new cjs.Shape();
	this.shape_3313.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3313.setTransform(201.4,556.1,0.5,0.5);

	this.shape_3314 = new cjs.Shape();
	this.shape_3314.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_3314.setTransform(190.9,550.2,0.5,0.5);

	this.shape_3315 = new cjs.Shape();
	this.shape_3315.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3315.setTransform(175.9,550.3,0.5,0.5);

	this.shape_3316 = new cjs.Shape();
	this.shape_3316.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3316.setTransform(165.5,547.9,0.5,0.5);

	this.shape_3317 = new cjs.Shape();
	this.shape_3317.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3317.setTransform(158.2,548.8,0.5,0.5);

	this.shape_3318 = new cjs.Shape();
	this.shape_3318.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3318.setTransform(146.9,550.4,0.5,0.5);

	this.shape_3319 = new cjs.Shape();
	this.shape_3319.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3319.setTransform(136.5,550.2,0.5,0.5);

	this.shape_3320 = new cjs.Shape();
	this.shape_3320.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg7AAgggkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3320.setTransform(123.7,550.3,0.5,0.5);

	this.shape_3321 = new cjs.Shape();
	this.shape_3321.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhFAdglQAdglA4AAQAdAAAWAKQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3321.setTransform(108.7,547.5,0.5,0.5);

	this.shape_3322 = new cjs.Shape();
	this.shape_3322.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_3322.setTransform(98.6,547.9,0.5,0.5);

	this.shape_3323 = new cjs.Shape();
	this.shape_3323.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAVAQANQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3323.setTransform(89.7,550.3,0.5,0.5);

	this.shape_3324 = new cjs.Shape();
	this.shape_3324.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3324.setTransform(76.4,550.2,0.5,0.5);

	this.shape_3325 = new cjs.Shape();
	this.shape_3325.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3325.setTransform(61.3,550.3,0.5,0.5);

	this.shape_3326 = new cjs.Shape();
	this.shape_3326.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3326.setTransform(48.1,550.3,0.5,0.5);

	this.shape_3327 = new cjs.Shape();
	this.shape_3327.graphics.f("#000000").s().p("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");
	this.shape_3327.setTransform(339.6,512.2,0.5,0.5);

	this.shape_3328 = new cjs.Shape();
	this.shape_3328.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3328.setTransform(341.5,441.4,0.5,0.5);

	this.shape_3329 = new cjs.Shape();
	this.shape_3329.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAKgGQAKgHAHgMQAIgMALgbIAMgkIhnkNIAaAAIA5CYQAbBFAGAYIABAAIAihfIA5iWIAZAAIh4E5QgQAngIANQgLAOgNAGQgNAHgTgBQgPAAgRgEg");
	this.shape_3329.setTransform(332.6,438.7,0.5,0.5);

	this.shape_3330 = new cjs.Shape();
	this.shape_3330.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3330.setTransform(322.7,435.5,0.5,0.5);

	this.shape_3331 = new cjs.Shape();
	this.shape_3331.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_3331.setTransform(314,432.7,0.5,0.5);

	this.shape_3332 = new cjs.Shape();
	this.shape_3332.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAwAAAbAhQAcAhgBA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3332.setTransform(304.1,435.6,0.5,0.5);

	this.shape_3333 = new cjs.Shape();
	this.shape_3333.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAQA+AEAXIABAAQAPg7AHgSIA3ikIAWAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_3333.setTransform(287.9,435.6,0.5,0.5);

	this.shape_3334 = new cjs.Shape();
	this.shape_3334.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAbAhQAdAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgVAKgVAEQgRADgZAAQg7AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_3334.setTransform(271.7,435.6,0.5,0.5);

	this.shape_3335 = new cjs.Shape();
	this.shape_3335.graphics.f("#000000").s().p("AgwDwIAAgVQAQAEAQAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAhgQATQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_3335.setTransform(260.1,436.2,0.5,0.5);

	this.shape_3336 = new cjs.Shape();
	this.shape_3336.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3336.setTransform(248.2,435.5,0.5,0.5);

	this.shape_3337 = new cjs.Shape();
	this.shape_3337.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3337.setTransform(239.5,433.1,0.5,0.5);

	this.shape_3338 = new cjs.Shape();
	this.shape_3338.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAbAhQAcAiABA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgVAKgUAEQgTADgYAAQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_3338.setTransform(229.6,435.6,0.5,0.5);

	this.shape_3339 = new cjs.Shape();
	this.shape_3339.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_3339.setTransform(215.2,432.7,0.5,0.5);

	this.shape_3340 = new cjs.Shape();
	this.shape_3340.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3340.setTransform(203.1,434.1,0.5,0.5);

	this.shape_3341 = new cjs.Shape();
	this.shape_3341.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3341.setTransform(184.9,435.5,0.5,0.5);

	this.shape_3342 = new cjs.Shape();
	this.shape_3342.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3342.setTransform(174.5,433.1,0.5,0.5);

	this.shape_3343 = new cjs.Shape();
	this.shape_3343.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgMQAIgMALgbIAMgkIhnkNIAZAAIA6CYQAYBBAJAcIABAAQANgqAUg1IA6iWIAZAAIh4E5QgPAogKAMQgKAOgNAGQgNAHgUgBQgPAAgQgEg");
	this.shape_3343.setTransform(159.1,438.7,0.5,0.5);

	this.shape_3344 = new cjs.Shape();
	this.shape_3344.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3344.setTransform(148.8,434.1,0.5,0.5);

	this.shape_3345 = new cjs.Shape();
	this.shape_3345.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3345.setTransform(141.8,433.1,0.5,0.5);

	this.shape_3346 = new cjs.Shape();
	this.shape_3346.graphics.f("#000000").s().p("ABVCHIhVh4IhVB4IgbAAIBiiKIheiDIAcAAIBQByIBQhyIAbAAIhdCDIBjCKg");
	this.shape_3346.setTransform(132.6,435.6,0.5,0.5);

	this.shape_3347 = new cjs.Shape();
	this.shape_3347.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgZAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_3347.setTransform(119.3,435.6,0.5,0.5);

	this.shape_3348 = new cjs.Shape();
	this.shape_3348.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3348.setTransform(109.4,432.7,0.5,0.5);

	this.shape_3349 = new cjs.Shape();
	this.shape_3349.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_3349.setTransform(99.3,438.5,0.5,0.5);

	this.shape_3350 = new cjs.Shape();
	this.shape_3350.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgQgTgfAAQgpAAgVAXQgTAYAAAwIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQALgTAUgMQAVgLAZAAQBBAAAQAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXABA0IAACwg");
	this.shape_3350.setTransform(80.1,435.5,0.5,0.5);

	this.shape_3351 = new cjs.Shape();
	this.shape_3351.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3351.setTransform(61.3,435.6,0.5,0.5);

	this.shape_3352 = new cjs.Shape();
	this.shape_3352.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3352.setTransform(48.1,435.6,0.5,0.5);

	this.shape_3353 = new cjs.Shape();
	this.shape_3353.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3353.setTransform(709.9,394.4,0.5,0.5);

	this.shape_3354 = new cjs.Shape();
	this.shape_3354.graphics.f("#000000").s().p("AhPB4QgVgVgBgkQAAgnAigXQAggUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAWAXAAAxIAACzIgRAAIgGgrIgCAAQgVAagWALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_3354.setTransform(699.9,397.4,0.5,0.5);

	this.shape_3355 = new cjs.Shape();
	this.shape_3355.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgaAqhCAAQhdAAABhjg");
	this.shape_3355.setTransform(686,397.5,0.5,0.5);

	this.shape_3356 = new cjs.Shape();
	this.shape_3356.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOgkgNQgogNgQgLQgRgLgIgNQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAPANAsAQQAiAMATAKQAQAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3356.setTransform(672.5,397.3,0.5,0.5);

	this.shape_3357 = new cjs.Shape();
	this.shape_3357.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3357.setTransform(663.8,394.9,0.5,0.5);

	this.shape_3358 = new cjs.Shape();
	this.shape_3358.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAbIABAAQAKghALgeIBGi2IAZAAIhoENg");
	this.shape_3358.setTransform(655,397.3,0.5,0.5);

	this.shape_3359 = new cjs.Shape();
	this.shape_3359.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3359.setTransform(635.3,397.4,0.5,0.5);

	this.shape_3360 = new cjs.Shape();
	this.shape_3360.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgnQAggnA0AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3360.setTransform(615.4,397.3,0.5,0.5);

	this.shape_3361 = new cjs.Shape();
	this.shape_3361.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QANAkAHAaIABAAQAIgeAMghIBGi2IAaAAIhpENg");
	this.shape_3361.setTransform(602.6,397.3,0.5,0.5);

	this.shape_3362 = new cjs.Shape();
	this.shape_3362.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3362.setTransform(589.7,397.3,0.5,0.5);

	this.shape_3363 = new cjs.Shape();
	this.shape_3363.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgEAGgIAAQgPAAAAgYg");
	this.shape_3363.setTransform(579.8,394.9,0.5,0.5);

	this.shape_3364 = new cjs.Shape();
	this.shape_3364.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgYAZQgWAZAAA2IAACVIgYAAIAAmDIAYAAIgCCeIACAAQAQgYAXgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_3364.setTransform(569.5,394.4,0.5,0.5);

	this.shape_3365 = new cjs.Shape();
	this.shape_3365.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_3365.setTransform(556.1,397.3,0.5,0.5);

	this.shape_3366 = new cjs.Shape();
	this.shape_3366.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3366.setTransform(542.6,397.4,0.5,0.5);

	this.shape_3367 = new cjs.Shape();
	this.shape_3367.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3367.setTransform(522.2,397.3,0.5,0.5);

	this.shape_3368 = new cjs.Shape();
	this.shape_3368.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3368.setTransform(510.3,395.8,0.5,0.5);

	this.shape_3369 = new cjs.Shape();
	this.shape_3369.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgYAKgTAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3369.setTransform(492.6,397.3,0.5,0.5);

	this.shape_3370 = new cjs.Shape();
	this.shape_3370.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3370.setTransform(482.7,394.4,0.5,0.5);

	this.shape_3371 = new cjs.Shape();
	this.shape_3371.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAQgYAWgMQAVgLAeAAQA5AAAdAjQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_3371.setTransform(472.6,394.5,0.5,0.5);

	this.shape_3372 = new cjs.Shape();
	this.shape_3372.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAYAAAwIAACzIgTAAIgGgrIgCAAQgVAagVALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgZAPQgYAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3372.setTransform(457.4,397.4,0.5,0.5);

	this.shape_3373 = new cjs.Shape();
	this.shape_3373.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AfgnQAhgnA1AAQAvAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3373.setTransform(437.5,397.3,0.5,0.5);

	this.shape_3374 = new cjs.Shape();
	this.shape_3374.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3374.setTransform(426.4,397.2,0.5,0.5);

	this.shape_3375 = new cjs.Shape();
	this.shape_3375.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3375.setTransform(413.6,397.3,0.5,0.5);

	this.shape_3376 = new cjs.Shape();
	this.shape_3376.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgQAShHIAqiaIAZAAIhKENg");
	this.shape_3376.setTransform(397.3,397.3,0.5,0.5);

	this.shape_3377 = new cjs.Shape();
	this.shape_3377.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3377.setTransform(378.6,394.4,0.5,0.5);

	this.shape_3378 = new cjs.Shape();
	this.shape_3378.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3378.setTransform(368.7,397.3,0.5,0.5);

	this.shape_3379 = new cjs.Shape();
	this.shape_3379.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_3379.setTransform(354.3,394.4,0.5,0.5);

	this.shape_3380 = new cjs.Shape();
	this.shape_3380.graphics.f("#000000").s().p("AhABoQggglgBhBQAAhCAjgmQAiglA6AAQAkAAAfAMIgHAWQgigMgbAAQgwAAgaAfQgZAfgBA4QABA3AZAfQAaAfAtAAQAlAAAggNIAAAXQgaAMgrAAQg5AAghgkg");
	this.shape_3380.setTransform(340.9,397.3,0.5,0.5);

	this.shape_3381 = new cjs.Shape();
	this.shape_3381.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3381.setTransform(331.7,394.9,0.5,0.5);

	this.shape_3382 = new cjs.Shape();
	this.shape_3382.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgeIgCAAIiIFOIgPAAIiIlPIgCAAQACAbAAAlIAAEPIgZAAIAAlrIAnAAICBE/IABAAICBk/IAnAAIAAFrg");
	this.shape_3382.setTransform(317.8,395,0.5,0.5);

	this.shape_3383 = new cjs.Shape();
	this.shape_3383.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhGAdgkQAeglA2AAQAeAAAVAKQAWALARAaIABAAIgBifIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QgBB0BZAAQAuAAAWgbQAVgbAAg9IAAgEQAAg9gVgdQgWgbgvAAQgrAAgWAfg");
	this.shape_3383.setTransform(292.2,394.5,0.5,0.5);

	this.shape_3384 = new cjs.Shape();
	this.shape_3384.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3384.setTransform(277.6,397.2,0.5,0.5);

	this.shape_3385 = new cjs.Shape();
	this.shape_3385.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3385.setTransform(262.8,397.4,0.5,0.5);

	this.shape_3386 = new cjs.Shape();
	this.shape_3386.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3386.setTransform(243.8,397.3,0.5,0.5);

	this.shape_3387 = new cjs.Shape();
	this.shape_3387.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3387.setTransform(230.5,397.2,0.5,0.5);

	this.shape_3388 = new cjs.Shape();
	this.shape_3388.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3388.setTransform(220.1,394.9,0.5,0.5);

	this.shape_3389 = new cjs.Shape();
	this.shape_3389.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_3389.setTransform(212.1,394.4,0.5,0.5);

	this.shape_3390 = new cjs.Shape();
	this.shape_3390.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_3390.setTransform(200.4,395.8,0.5,0.5);

	this.shape_3391 = new cjs.Shape();
	this.shape_3391.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3391.setTransform(189.1,397.4,0.5,0.5);

	this.shape_3392 = new cjs.Shape();
	this.shape_3392.graphics.f("#000000").s().p("ABdC2IhelRQgCANgJAmIhQEeIgWAAIhklrIAbAAIBREvIAEAUQAGgiAThFIA/jcIAbAAIBJD9QANAtAFAZIAIgmIBNkdIAaAAIhlFrg");
	this.shape_3392.setTransform(171.4,395,0.5,0.5);

	this.shape_3393 = new cjs.Shape();
	this.shape_3393.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBAgXA4g");
	this.shape_3393.setTransform(150.2,404.3,0.5,0.5);

	this.shape_3394 = new cjs.Shape();
	this.shape_3394.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgdAagTQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3394.setTransform(141.9,397.3,0.5,0.5);

	this.shape_3395 = new cjs.Shape();
	this.shape_3395.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3395.setTransform(131.6,395.8,0.5,0.5);

	this.shape_3396 = new cjs.Shape();
	this.shape_3396.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3396.setTransform(124.6,394.4,0.5,0.5);

	this.shape_3397 = new cjs.Shape();
	this.shape_3397.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AaAdQAZAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgWAZgFAyICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3397.setTransform(114.7,397.3,0.5,0.5);

	this.shape_3398 = new cjs.Shape();
	this.shape_3398.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAQgZAVgLQAWgLAeAAQA5AAAcAjQAdAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_3398.setTransform(100.5,394.5,0.5,0.5);

	this.shape_3399 = new cjs.Shape();
	this.shape_3399.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3399.setTransform(83,394.4,0.5,0.5);

	this.shape_3400 = new cjs.Shape();
	this.shape_3400.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3400.setTransform(72.7,397.3,0.5,0.5);

	this.shape_3401 = new cjs.Shape();
	this.shape_3401.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA3AAQA5AAAfAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_3401.setTransform(57.8,397.3,0.5,0.5);

	this.shape_3402 = new cjs.Shape();
	this.shape_3402.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3402.setTransform(45.8,395.8,0.5,0.5);

	this.shape_3403 = new cjs.Shape();
	this.shape_3403.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAhAAA6IAAASIjCAAQAAA5AaAdQAZAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg5AAghgkgAg3hcQgYAagDAxICnAAQAAgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_3403.setTransform(746.9,359.1,0.5,0.5);

	this.shape_3404 = new cjs.Shape();
	this.shape_3404.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAlAGAZIABAAQAJggALgfIBGi2IAaAAIhpENg");
	this.shape_3404.setTransform(734.1,359.1,0.5,0.5);

	this.shape_3405 = new cjs.Shape();
	this.shape_3405.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_3405.setTransform(725.4,356.6,0.5,0.5);

	this.shape_3406 = new cjs.Shape();
	this.shape_3406.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3406.setTransform(718,357.6,0.5,0.5);

	this.shape_3407 = new cjs.Shape();
	this.shape_3407.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAiglA6AAQAjAAAhAMIgHAWQgkgMgZAAQgxAAgaAfQgaAfABA4QgBA3AaAfQAbAfAsAAQAlAAAfgNIAAAXQgZAMgqAAQg6AAghgkg");
	this.shape_3407.setTransform(708.2,359.1,0.5,0.5);

	this.shape_3408 = new cjs.Shape();
	this.shape_3408.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgXAZgFAyICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_3408.setTransform(694.8,359.1,0.5,0.5);

	this.shape_3409 = new cjs.Shape();
	this.shape_3409.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_3409.setTransform(680.6,362,0.5,0.5);

	this.shape_3410 = new cjs.Shape();
	this.shape_3410.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgRgOgmgNQgmgNgSgLQgQgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAQAMQAOANArAQQAkAMARAKQAQAKAKAOQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_3410.setTransform(666.6,359.1,0.5,0.5);

	this.shape_3411 = new cjs.Shape();
	this.shape_3411.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AggnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAASIjCAAQACA5AYAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgZAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3411.setTransform(653.8,359.1,0.5,0.5);

	this.shape_3412 = new cjs.Shape();
	this.shape_3412.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3412.setTransform(642.7,359,0.5,0.5);

	this.shape_3413 = new cjs.Shape();
	this.shape_3413.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3413.setTransform(626.1,359,0.5,0.5);

	this.shape_3414 = new cjs.Shape();
	this.shape_3414.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3414.setTransform(617.4,356.6,0.5,0.5);

	this.shape_3415 = new cjs.Shape();
	this.shape_3415.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAQgDAcgLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3415.setTransform(607.5,359.1,0.5,0.5);

	this.shape_3416 = new cjs.Shape();
	this.shape_3416.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_3416.setTransform(593.1,356.2,0.5,0.5);

	this.shape_3417 = new cjs.Shape();
	this.shape_3417.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3417.setTransform(581,357.6,0.5,0.5);

	this.shape_3418 = new cjs.Shape();
	this.shape_3418.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_3418.setTransform(562.9,359,0.5,0.5);

	this.shape_3419 = new cjs.Shape();
	this.shape_3419.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3419.setTransform(552.4,356.6,0.5,0.5);

	this.shape_3420 = new cjs.Shape();
	this.shape_3420.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3420.setTransform(540,356.2,0.5,0.5);

	this.shape_3421 = new cjs.Shape();
	this.shape_3421.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg4ADgYAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3421.setTransform(529.9,359.1,0.5,0.5);

	this.shape_3422 = new cjs.Shape();
	this.shape_3422.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_3422.setTransform(519.2,357.6,0.5,0.5);

	this.shape_3423 = new cjs.Shape();
	this.shape_3423.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3423.setTransform(508.1,359.1,0.5,0.5);

	this.shape_3424 = new cjs.Shape();
	this.shape_3424.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_3424.setTransform(489.9,359,0.5,0.5);

	this.shape_3425 = new cjs.Shape();
	this.shape_3425.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_3425.setTransform(464.5,359,0.5,0.5);

	this.shape_3426 = new cjs.Shape();
	this.shape_3426.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPggAAgqQAAhBAhglQAfglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgeAlg5AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_3426.setTransform(449.4,359.1,0.5,0.5);

	this.shape_3427 = new cjs.Shape();
	this.shape_3427.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3427.setTransform(432.5,356.2,0.5,0.5);

	this.shape_3428 = new cjs.Shape();
	this.shape_3428.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3428.setTransform(422.4,359.1,0.5,0.5);

	this.shape_3429 = new cjs.Shape();
	this.shape_3429.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3429.setTransform(411.6,357.6,0.5,0.5);

	this.shape_3430 = new cjs.Shape();
	this.shape_3430.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAQgDAcgLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_3430.setTransform(400.5,359.1,0.5,0.5);

	this.shape_3431 = new cjs.Shape();
	this.shape_3431.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3431.setTransform(382.3,359,0.5,0.5);

	this.shape_3432 = new cjs.Shape();
	this.shape_3432.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3432.setTransform(361.4,356.1,0.5,0.5);

	this.shape_3433 = new cjs.Shape();
	this.shape_3433.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3433.setTransform(349.3,359.1,0.5,0.5);

	this.shape_3434 = new cjs.Shape();
	this.shape_3434.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgSgOgkgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAZgRAtAAQAsAAAoAQIgJAWQgogQgjAAQgeAAgVALQgTALgBATQAAAWAPAMQAPANAsAQQAjAMARAKQARAKAIAOQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3434.setTransform(329.2,359.1,0.5,0.5);

	this.shape_3435 = new cjs.Shape();
	this.shape_3435.graphics.f("#000000").s().p("AgRCYQgSgUABgpIAAitIgpAAIAAgPIApgLIAMg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgALAOQALAPAXAAQAWAAASgEIAAATQgQAHgZAAQgigBgRgSg");
	this.shape_3435.setTransform(318.9,357.6,0.5,0.5);

	this.shape_3436 = new cjs.Shape();
	this.shape_3436.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_3436.setTransform(307.3,359,0.5,0.5);

	this.shape_3437 = new cjs.Shape();
	this.shape_3437.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgVgbgjAAQgmAAgYAag");
	this.shape_3437.setTransform(292.7,359.1,0.5,0.5);

	this.shape_3438 = new cjs.Shape();
	this.shape_3438.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3438.setTransform(274.5,359,0.5,0.5);

	this.shape_3439 = new cjs.Shape();
	this.shape_3439.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegGQgNgGgHgKQgHgJAAgMQAAgaAigWQgYgJgNgVQgNgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgOAHgIALQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhfB6QAAA5BSAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_3439.setTransform(256.6,362,0.5,0.5);

	this.shape_3440 = new cjs.Shape();
	this.shape_3440.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg3ADgZAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3440.setTransform(242.7,359.1,0.5,0.5);

	this.shape_3441 = new cjs.Shape();
	this.shape_3441.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3441.setTransform(232.3,359,0.5,0.5);

	this.shape_3442 = new cjs.Shape();
	this.shape_3442.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3442.setTransform(223.5,356.1,0.5,0.5);

	this.shape_3443 = new cjs.Shape();
	this.shape_3443.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQgBgdASgRQAQgTAfgGQgMgGgIgKQgHgJAAgMQgBgaAkgWQgYgJgNgVQgNgTgBgcQABgpAZgZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgHgCQgQAIgHAKQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQArAAAZASQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgcgTgAhfB6QAAA5BTAAQBpAAAAhFQAAgYgQgLQgRgLglAAIgsAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgTgQQgSgSggAAQggAAgTATg");
	this.shape_3443.setTransform(205.5,362,0.5,0.5);

	this.shape_3444 = new cjs.Shape();
	this.shape_3444.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3444.setTransform(191.4,359,0.5,0.5);

	this.shape_3445 = new cjs.Shape();
	this.shape_3445.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3445.setTransform(180.9,356.6,0.5,0.5);

	this.shape_3446 = new cjs.Shape();
	this.shape_3446.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3446.setTransform(172,359.1,0.5,0.5);

	this.shape_3447 = new cjs.Shape();
	this.shape_3447.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3447.setTransform(158.7,359.1,0.5,0.5);

	this.shape_3448 = new cjs.Shape();
	this.shape_3448.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgXAag");
	this.shape_3448.setTransform(144,362,0.5,0.5);

	this.shape_3449 = new cjs.Shape();
	this.shape_3449.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgPgTggAAQgpAAgVAXQgTAYAAAwIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBBAAAQAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXABA0IAACwg");
	this.shape_3449.setTransform(124.9,359,0.5,0.5);

	this.shape_3450 = new cjs.Shape();
	this.shape_3450.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_3450.setTransform(110.7,356.6,0.5,0.5);

	this.shape_3451 = new cjs.Shape();
	this.shape_3451.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3451.setTransform(103.7,359,0.5,0.5);

	this.shape_3452 = new cjs.Shape();
	this.shape_3452.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3452.setTransform(90.8,359.1,0.5,0.5);

	this.shape_3453 = new cjs.Shape();
	this.shape_3453.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_3453.setTransform(76.6,362,0.5,0.5);

	this.shape_3454 = new cjs.Shape();
	this.shape_3454.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_3454.setTransform(61.1,359.2,0.5,0.5);

	this.shape_3455 = new cjs.Shape();
	this.shape_3455.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3455.setTransform(47.6,359.1,0.5,0.5);

	this.shape_3456 = new cjs.Shape();
	this.shape_3456.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3456.setTransform(665.9,320.7,0.5,0.5);

	this.shape_3457 = new cjs.Shape();
	this.shape_3457.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3457.setTransform(652.6,320.8,0.5,0.5);

	this.shape_3458 = new cjs.Shape();
	this.shape_3458.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegGQgMgGgIgKQgHgJAAgMQAAgaAigWQgYgJgMgVQgOgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgOAIgIAKQgIAKAAALQAAAOAKAGQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB6QAAA5BTAAQBpAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgSgQQgTgSggAAQggAAgTATg");
	this.shape_3458.setTransform(631.9,323.8,0.5,0.5);

	this.shape_3459 = new cjs.Shape();
	this.shape_3459.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_3459.setTransform(617.7,320.7,0.5,0.5);

	this.shape_3460 = new cjs.Shape();
	this.shape_3460.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3460.setTransform(607.3,318.4,0.5,0.5);

	this.shape_3461 = new cjs.Shape();
	this.shape_3461.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3461.setTransform(600.3,320.7,0.5,0.5);

	this.shape_3462 = new cjs.Shape();
	this.shape_3462.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3462.setTransform(587.5,320.8,0.5,0.5);

	this.shape_3463 = new cjs.Shape();
	this.shape_3463.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_3463.setTransform(569.3,320.7,0.5,0.5);

	this.shape_3464 = new cjs.Shape();
	this.shape_3464.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3464.setTransform(546.8,320.7,0.5,0.5);

	this.shape_3465 = new cjs.Shape();
	this.shape_3465.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgrIgCAAQgVAagVALQgWALgcAAQgpAAgVgUgAAeAAQg3ADgZAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_3465.setTransform(528.2,320.9,0.5,0.5);

	this.shape_3466 = new cjs.Shape();
	this.shape_3466.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQguAAgYAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgCCeIADAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_3466.setTransform(514.5,317.9,0.5,0.5);

	this.shape_3467 = new cjs.Shape();
	this.shape_3467.graphics.f("#000000").s().p("AgdA/QAUhHAIg1IAcAAIADAEQgTBCgYA2g");
	this.shape_3467.setTransform(497.1,327.8,0.5,0.5);

	this.shape_3468 = new cjs.Shape();
	this.shape_3468.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgdASgRQAQgTAegGQgMgGgHgKQgHgKAAgLQAAgaAigWQgXgJgOgVQgNgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIALAAAKQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB6QAAA5BTAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA6gAg4igQgTASAAAiQAAAfATARQATARAgAAQAhAAASgRQASgRAAggQAAgkgTgQQgSgSggAAQghAAgSATg");
	this.shape_3468.setTransform(488.1,323.8,0.5,0.5);

	this.shape_3469 = new cjs.Shape();
	this.shape_3469.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBDAAQBcAAgBBjIAACwg");
	this.shape_3469.setTransform(474,320.7,0.5,0.5);

	this.shape_3470 = new cjs.Shape();
	this.shape_3470.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3470.setTransform(463.5,318.4,0.5,0.5);

	this.shape_3471 = new cjs.Shape();
	this.shape_3471.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg4AAghgkg");
	this.shape_3471.setTransform(454.9,320.8,0.5,0.5);

	this.shape_3472 = new cjs.Shape();
	this.shape_3472.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_3472.setTransform(444.4,320.7,0.5,0.5);

	this.shape_3473 = new cjs.Shape();
	this.shape_3473.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA2AAQAwAAAbAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgbgjAAQgmAAgZAag");
	this.shape_3473.setTransform(431.6,320.8,0.5,0.5);

	this.shape_3474 = new cjs.Shape();
	this.shape_3474.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3474.setTransform(421.7,318.4,0.5,0.5);

	this.shape_3475 = new cjs.Shape();
	this.shape_3475.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_3475.setTransform(411.6,323.8,0.5,0.5);

	this.shape_3476 = new cjs.Shape();
	this.shape_3476.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBCgYA2g");
	this.shape_3476.setTransform(393.9,327.8,0.5,0.5);

	this.shape_3477 = new cjs.Shape();
	this.shape_3477.graphics.f("#000000").s().p("AhMCiQghglAAhBQAAhAAfgnQAhgnA0AAQAwAAAcAhQAbAiAAA4IAAAUIjCAAQABA4AZAdQAaAeAvAAQAUAAAUgEQAQgCAdgMIAAAXQgYAKgTADQgSAEgYAAQg6AAghgkgAg2giQgYAZgEAwICmAAQAAgtgUgcQgVgagkAAQgmAAgXAagAgbhzIAAgEQAUgVAPgWQASgWAHgNIAjAAIAAAEQgKAOgVAVQgVAVgZAWg");
	this.shape_3477.setTransform(384.6,318,0.5,0.5);

	this.shape_3478 = new cjs.Shape();
	this.shape_3478.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAPANArAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3478.setTransform(371.5,320.8,0.5,0.5);

	this.shape_3479 = new cjs.Shape();
	this.shape_3479.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgVgRgOQgRgOglgNQgogOgQgKQgRgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3479.setTransform(359.7,320.8,0.5,0.5);

	this.shape_3480 = new cjs.Shape();
	this.shape_3480.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQARATAkAAQAwAAAWgZQAYgZAAg2IAAiVIAXAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAABhjg");
	this.shape_3480.setTransform(346.2,321,0.5,0.5);

	this.shape_3481 = new cjs.Shape();
	this.shape_3481.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3481.setTransform(331.3,320.8,0.5,0.5);

	this.shape_3482 = new cjs.Shape();
	this.shape_3482.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAnIABAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA/AVAaQAWAcAuAAQApAAAYgfQAWgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_3482.setTransform(316.6,323.8,0.5,0.5);

	this.shape_3483 = new cjs.Shape();
	this.shape_3483.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjDAAQABA5AaAdQAZAdAvAAQATAAAWgDQAPgDAcgLIAAAWQgWAKgTAEQgTADgYAAQg7AAgggkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_3483.setTransform(301.7,320.8,0.5,0.5);

	this.shape_3484 = new cjs.Shape();
	this.shape_3484.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAARAEIgEAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3484.setTransform(290.6,320.7,0.5,0.5);

	this.shape_3485 = new cjs.Shape();
	this.shape_3485.graphics.f("#000000").s().p("AgdA/QAThDAIg5IAdAAIADAEQgTBCgYA2g");
	this.shape_3485.setTransform(275,327.8,0.5,0.5);

	this.shape_3486 = new cjs.Shape();
	this.shape_3486.graphics.f("#000000").s().p("AheC0QgbgUAAgjQAAgdARgRQAQgTAegGQgMgGgHgKQgHgJgBgMQAAgaAjgWQgXgJgNgVQgOgTAAgcQAAgpAagZQAagYArAAQAbAAAOAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgHgCQgQAIgHAKQgIAKAAALQAAANAKAHQAKAFAXAAIAvAAQArAAAYASQAXASAAAjQAAArgiAXQgjAXg/AAQg0AAgcgTgAhfB6QAAA5BSAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhLAAABA6gAg4igQgTASAAAiQAAAfATARQAUARAfAAQAhAAASgRQASgRAAggQAAgkgSgQQgUgSgfAAQggAAgTATg");
	this.shape_3486.setTransform(266,323.8,0.5,0.5);

	this.shape_3487 = new cjs.Shape();
	this.shape_3487.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3487.setTransform(251.8,320.7,0.5,0.5);

	this.shape_3488 = new cjs.Shape();
	this.shape_3488.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_3488.setTransform(241.4,318.4,0.5,0.5);

	this.shape_3489 = new cjs.Shape();
	this.shape_3489.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgogNgQgLQgRgLgIgNQgJgOABgTQAAgeAZgSQAZgRAtAAQAsAAAoAQIgJAWQgogQgjAAQgeAAgVALQgTALgBATQAAAWAPAMQAPANAsAQQAiAMATAKQARALAIANQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3489.setTransform(232.5,320.8,0.5,0.5);

	this.shape_3490 = new cjs.Shape();
	this.shape_3490.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgGgrIgCAAQgVAagVALQgWALgcAAQgpAAgVgUgAAeAAQg3ADgZAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_3490.setTransform(219.4,320.9,0.5,0.5);

	this.shape_3491 = new cjs.Shape();
	this.shape_3491.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_3491.setTransform(205.7,317.9,0.5,0.5);

	this.shape_3492 = new cjs.Shape();
	this.shape_3492.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_3492.setTransform(192.3,320.8,0.5,0.5);

	this.shape_3493 = new cjs.Shape();
	this.shape_3493.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAEQgTBAgXA4g");
	this.shape_3493.setTransform(176.2,327.8,0.5,0.5);

	this.shape_3494 = new cjs.Shape();
	this.shape_3494.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegGQgNgGgHgKQgHgJAAgMQAAgaAigWQgYgJgMgVQgOgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgOAHgIALQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgTgAhfB6QAAA5BSAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_3494.setTransform(167.2,323.8,0.5,0.5);

	this.shape_3495 = new cjs.Shape();
	this.shape_3495.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_3495.setTransform(153.1,320.7,0.5,0.5);

	this.shape_3496 = new cjs.Shape();
	this.shape_3496.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3496.setTransform(142.6,318.4,0.5,0.5);

	this.shape_3497 = new cjs.Shape();
	this.shape_3497.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_3497.setTransform(135.6,320.7,0.5,0.5);

	this.shape_3498 = new cjs.Shape();
	this.shape_3498.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQASATAjAAQAvAAAYgZQAWgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhDAAQhbAAgBhjg");
	this.shape_3498.setTransform(122.2,321,0.5,0.5);

	this.shape_3499 = new cjs.Shape();
	this.shape_3499.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3499.setTransform(110.3,319.3,0.5,0.5);

	this.shape_3500 = new cjs.Shape();
	this.shape_3500.graphics.f("#000000").s().p("ABVCHIhVh4IhVB4IgbAAIBiiKIhfiDIAdAAIBQByIBPhyIAcAAIhdCDIBjCKg");
	this.shape_3500.setTransform(99.8,320.8,0.5,0.5);

	this.shape_3501 = new cjs.Shape();
	this.shape_3501.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAbAhQAdAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgVAKgUAEQgTADgYAAQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_3501.setTransform(86.5,320.8,0.5,0.5);

	this.shape_3502 = new cjs.Shape();
	this.shape_3502.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3502.setTransform(75,319.3,0.5,0.5);

	this.shape_3503 = new cjs.Shape();
	this.shape_3503.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgTAAQgeAAgLARQgLASAAAlIAAAaIA+AAIAAAVIg+AAIAAD4g");
	this.shape_3503.setTransform(61.4,317.9,0.5,0.5);

	this.shape_3504 = new cjs.Shape();
	this.shape_3504.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3504.setTransform(49.2,320.8,0.5,0.5);

	this.shape_3505 = new cjs.Shape();
	this.shape_3505.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAAABjIAACwg");
	this.shape_3505.setTransform(721.2,282.5,0.5,0.5);

	this.shape_3506 = new cjs.Shape();
	this.shape_3506.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3506.setTransform(706.1,282.6,0.5,0.5);

	this.shape_3507 = new cjs.Shape();
	this.shape_3507.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3507.setTransform(695.8,280.1,0.5,0.5);

	this.shape_3508 = new cjs.Shape();
	this.shape_3508.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQABAgAJAOQAMAPAXAAQAWAAATgEIAAATQgRAHgZAAQgigBgSgSg");
	this.shape_3508.setTransform(688.4,281.1,0.5,0.5);

	this.shape_3509 = new cjs.Shape();
	this.shape_3509.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3509.setTransform(678.6,282.6,0.5,0.5);

	this.shape_3510 = new cjs.Shape();
	this.shape_3510.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3510.setTransform(665.2,282.6,0.5,0.5);

	this.shape_3511 = new cjs.Shape();
	this.shape_3511.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3511.setTransform(655.3,279.7,0.5,0.5);

	this.shape_3512 = new cjs.Shape();
	this.shape_3512.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_3512.setTransform(645.5,282.6,0.5,0.5);

	this.shape_3513 = new cjs.Shape();
	this.shape_3513.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3513.setTransform(632.4,282.6,0.5,0.5);

	this.shape_3514 = new cjs.Shape();
	this.shape_3514.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3514.setTransform(612.8,282.6,0.5,0.5);

	this.shape_3515 = new cjs.Shape();
	this.shape_3515.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgdASgRQAQgTAegGQgMgGgHgKQgHgKAAgLQAAgaAigWQgXgJgOgVQgNgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIALAAAKQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB6QAAA5BTAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA6gAg4igQgTASAAAiQAAAfATARQATARAgAAQAhAAASgRQASgRAAggQAAgkgTgQQgSgSggAAQghAAgSATg");
	this.shape_3515.setTransform(593.2,285.5,0.5,0.5);

	this.shape_3516 = new cjs.Shape();
	this.shape_3516.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQguAAgYAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3516.setTransform(579.1,282.5,0.5,0.5);

	this.shape_3517 = new cjs.Shape();
	this.shape_3517.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3517.setTransform(564,282.6,0.5,0.5);

	this.shape_3518 = new cjs.Shape();
	this.shape_3518.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgPgTggAAQgpAAgUAXQgVAYABAwIAACeIgYAAIAAi4QgBhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQALgTAVgMQAUgLAaAAQBAAAAQAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAXABA0IAACwg");
	this.shape_3518.setTransform(545.3,282.5,0.5,0.5);

	this.shape_3519 = new cjs.Shape();
	this.shape_3519.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCCICBAAIgyiDIgOgrQgFAXgJAVg");
	this.shape_3519.setTransform(526.4,280.2,0.5,0.5);

	this.shape_3520 = new cjs.Shape();
	this.shape_3520.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3520.setTransform(509,288.4,0.5,0.5);

	this.shape_3521 = new cjs.Shape();
	this.shape_3521.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAbAdAuAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3521.setTransform(499,282.6,0.5,0.5);

	this.shape_3522 = new cjs.Shape();
	this.shape_3522.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAiglA6AAQAkAAAfAMIgGAWQgkgMgZAAQgyAAgZAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg6AAghgkg");
	this.shape_3522.setTransform(486.3,282.6,0.5,0.5);

	this.shape_3523 = new cjs.Shape();
	this.shape_3523.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAhgBA6IAAASIjBAAQABA5AYAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3523.setTransform(472.9,282.6,0.5,0.5);

	this.shape_3524 = new cjs.Shape();
	this.shape_3524.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3524.setTransform(463,280.1,0.5,0.5);

	this.shape_3525 = new cjs.Shape();
	this.shape_3525.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_3525.setTransform(452.9,285.5,0.5,0.5);

	this.shape_3526 = new cjs.Shape();
	this.shape_3526.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3526.setTransform(431.1,282.6,0.5,0.5);

	this.shape_3527 = new cjs.Shape();
	this.shape_3527.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3527.setTransform(414.1,282.5,0.5,0.5);

	this.shape_3528 = new cjs.Shape();
	this.shape_3528.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3528.setTransform(400.8,282.6,0.5,0.5);

	this.shape_3529 = new cjs.Shape();
	this.shape_3529.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3529.setTransform(390.4,279.6,0.5,0.5);

	this.shape_3530 = new cjs.Shape();
	this.shape_3530.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBFAHAYIAAAAIAihfIA6iWIAZAAIh4E5QgQAngJANQgKAOgNAGQgNAHgTgBQgPAAgRgEg");
	this.shape_3530.setTransform(373.2,285.7,0.5,0.5);

	this.shape_3531 = new cjs.Shape();
	this.shape_3531.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3531.setTransform(359.9,282.6,0.5,0.5);

	this.shape_3532 = new cjs.Shape();
	this.shape_3532.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3532.setTransform(349.5,279.7,0.5,0.5);

	this.shape_3533 = new cjs.Shape();
	this.shape_3533.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAbAAA6IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_3533.setTransform(339.5,285.5,0.5,0.5);

	this.shape_3534 = new cjs.Shape();
	this.shape_3534.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAYAAA4IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAKgTAWgMQAUgLAZAAQBBAAARAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_3534.setTransform(320.3,282.5,0.5,0.5);

	this.shape_3535 = new cjs.Shape();
	this.shape_3535.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAQgDAcgLIAAAWQgXAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICmAAQABgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_3535.setTransform(302,282.6,0.5,0.5);

	this.shape_3536 = new cjs.Shape();
	this.shape_3536.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3536.setTransform(280.4,279.8,0.5,0.5);

	this.shape_3537 = new cjs.Shape();
	this.shape_3537.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3537.setTransform(270.3,279.7,0.5,0.5);

	this.shape_3538 = new cjs.Shape();
	this.shape_3538.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQARATAkAAQAvAAAXgZQAYgZAAg2IAAiVIAXAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAABhjg");
	this.shape_3538.setTransform(259.8,282.7,0.5,0.5);

	this.shape_3539 = new cjs.Shape();
	this.shape_3539.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3539.setTransform(244.9,282.6,0.5,0.5);

	this.shape_3540 = new cjs.Shape();
	this.shape_3540.graphics.f("#000000").s().p("ABOCHIg8i0QgEgMgKgqIgCAAIhMDqIgYAAIhNkNIAZAAIAsCcQAQA+AEAXIACAAQAOg7AHgSIA3ikIAWAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_3540.setTransform(228.2,282.6,0.5,0.5);

	this.shape_3541 = new cjs.Shape();
	this.shape_3541.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgMALgbIAMgkIhnkNIAaAAIA4CYQAaBBAIAcIAAAAQAOgqAVg1IA4iWIAaAAIh4E5QgPAogKAMQgJAOgOAGQgNAHgTgBQgQAAgQgEg");
	this.shape_3541.setTransform(206.5,285.7,0.5,0.5);

	this.shape_3542 = new cjs.Shape();
	this.shape_3542.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_3542.setTransform(193.7,282.6,0.5,0.5);

	this.shape_3543 = new cjs.Shape();
	this.shape_3543.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_3543.setTransform(179.2,279.7,0.5,0.5);

	this.shape_3544 = new cjs.Shape();
	this.shape_3544.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3544.setTransform(167.2,281.1,0.5,0.5);

	this.shape_3545 = new cjs.Shape();
	this.shape_3545.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA0AAQAxAAAbAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg7AAgggkgAg2hcQgXAZgFAyICnAAQgBgvgUgbQgUgbglAAQgmAAgXAag");
	this.shape_3545.setTransform(149.5,282.6,0.5,0.5);

	this.shape_3546 = new cjs.Shape();
	this.shape_3546.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_3546.setTransform(134.9,282.7,0.5,0.5);

	this.shape_3547 = new cjs.Shape();
	this.shape_3547.graphics.f("#000000").s().p("ABaDHIAAhnIABg9IgBAAQgeAug9ABQg1AAgegkQgdgjAAhCQAAhEAdglQAegmA2AAQA6AAAeArIABAAIAEgmIAVAAIAAGIgAhAiRQgXAfAAA8QAAA5AWAcQAXAdAqAAQAvAAAWgcQAVgbAAg/IAAgDQAAg8gVgcQgWgbguAAQgrAAgWAfg");
	this.shape_3547.setTransform(119.4,285.5,0.5,0.5);

	this.shape_3548 = new cjs.Shape();
	this.shape_3548.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3548.setTransform(109.4,280.1,0.5,0.5);

	this.shape_3549 = new cjs.Shape();
	this.shape_3549.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3549.setTransform(99,282.5,0.5,0.5);

	this.shape_3550 = new cjs.Shape();
	this.shape_3550.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_3550.setTransform(84,279.7,0.5,0.5);

	this.shape_3551 = new cjs.Shape();
	this.shape_3551.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAhgmQAjglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAbAfAsAAQAlAAAfgNIAAAXQgZAMgrAAQg4AAgigkg");
	this.shape_3551.setTransform(70.6,282.6,0.5,0.5);

	this.shape_3552 = new cjs.Shape();
	this.shape_3552.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAASIjCAAQACA5AYAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3552.setTransform(57.3,282.6,0.5,0.5);

	this.shape_3553 = new cjs.Shape();
	this.shape_3553.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3553.setTransform(45.8,281.1,0.5,0.5);

	this.shape_3554 = new cjs.Shape();
	this.shape_3554.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgvAAgXAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_3554.setTransform(685.6,241.4,0.5,0.5);

	this.shape_3555 = new cjs.Shape();
	this.shape_3555.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAkAAAfAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_3555.setTransform(672.2,244.3,0.5,0.5);

	this.shape_3556 = new cjs.Shape();
	this.shape_3556.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3556.setTransform(663,241.9,0.5,0.5);

	this.shape_3557 = new cjs.Shape();
	this.shape_3557.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgSgTgjAAQgwAAgXAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAQgYAWgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_3557.setTransform(652.6,241.4,0.5,0.5);

	this.shape_3558 = new cjs.Shape();
	this.shape_3558.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_3558.setTransform(635.8,244.3,0.5,0.5);

	this.shape_3559 = new cjs.Shape();
	this.shape_3559.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3559.setTransform(608.8,244.2,0.5,0.5);

	this.shape_3560 = new cjs.Shape();
	this.shape_3560.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3560.setTransform(593.4,244.2,0.5,0.5);

	this.shape_3561 = new cjs.Shape();
	this.shape_3561.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3561.setTransform(580.1,244.3,0.5,0.5);

	this.shape_3562 = new cjs.Shape();
	this.shape_3562.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgcAAgNARQgLASAAAmIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3562.setTransform(569.6,241.4,0.5,0.5);

	this.shape_3563 = new cjs.Shape();
	this.shape_3563.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_3563.setTransform(557.5,244.2,0.5,0.5);

	this.shape_3564 = new cjs.Shape();
	this.shape_3564.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3564.setTransform(547,241.9,0.5,0.5);

	this.shape_3565 = new cjs.Shape();
	this.shape_3565.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3565.setTransform(530.1,244.2,0.5,0.5);

	this.shape_3566 = new cjs.Shape();
	this.shape_3566.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegGQgNgGgHgKQgHgKAAgLQAAgaAigWQgXgJgOgVQgNgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgiAXhAAAQgzAAgcgTgAhgB6QAAA5BTAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA6gAg4igQgTASAAAiQAAAfATARQATARAgAAQAgAAATgRQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_3566.setTransform(515.8,247.3,0.5,0.5);

	this.shape_3567 = new cjs.Shape();
	this.shape_3567.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3567.setTransform(506.3,241.9,0.5,0.5);

	this.shape_3568 = new cjs.Shape();
	this.shape_3568.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgRgOglgNQgngNgSgLQgQgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQAPAKAKAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3568.setTransform(497.4,244.3,0.5,0.5);

	this.shape_3569 = new cjs.Shape();
	this.shape_3569.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA1AAQAvAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3569.setTransform(484.5,244.3,0.5,0.5);

	this.shape_3570 = new cjs.Shape();
	this.shape_3570.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhFAdglQAdglA4AAQAdAAAVAKQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3570.setTransform(469.5,241.5,0.5,0.5);

	this.shape_3571 = new cjs.Shape();
	this.shape_3571.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3571.setTransform(447.7,241.5,0.5,0.5);

	this.shape_3572 = new cjs.Shape();
	this.shape_3572.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAASIjBAAQABA5AYAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3572.setTransform(433.5,244.3,0.5,0.5);

	this.shape_3573 = new cjs.Shape();
	this.shape_3573.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3573.setTransform(419.1,244.2,0.5,0.5);

	this.shape_3574 = new cjs.Shape();
	this.shape_3574.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3574.setTransform(404,244.3,0.5,0.5);

	this.shape_3575 = new cjs.Shape();
	this.shape_3575.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3575.setTransform(393.7,241.9,0.5,0.5);

	this.shape_3576 = new cjs.Shape();
	this.shape_3576.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOgkgNQgmgNgSgLQgRgLgIgNQgJgOAAgTQABgeAZgSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQggAAgUALQgUALABATQgBAWAQAMQAOANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_3576.setTransform(384.8,244.3,0.5,0.5);

	this.shape_3577 = new cjs.Shape();
	this.shape_3577.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgEAGgIAAQgPAAAAgYg");
	this.shape_3577.setTransform(376,241.9,0.5,0.5);

	this.shape_3578 = new cjs.Shape();
	this.shape_3578.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAbIABAAQAMgpAJgWIBGi2IAZAAIhpENg");
	this.shape_3578.setTransform(367.3,244.3,0.5,0.5);

	this.shape_3579 = new cjs.Shape();
	this.shape_3579.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3579.setTransform(354,244.2,0.5,0.5);

	this.shape_3580 = new cjs.Shape();
	this.shape_3580.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgnA1AAQAxAAAbAhQAcAhAAA6IAAASIjCAAQAAA5AaAdQAZAdAvAAQATAAAVgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg7AAgggkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_3580.setTransform(339.4,244.3,0.5,0.5);

	this.shape_3581 = new cjs.Shape();
	this.shape_3581.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3581.setTransform(321.7,244.2,0.5,0.5);

	this.shape_3582 = new cjs.Shape();
	this.shape_3582.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_3582.setTransform(313,241.9,0.5,0.5);

	this.shape_3583 = new cjs.Shape();
	this.shape_3583.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgXAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgYAag");
	this.shape_3583.setTransform(303.1,244.3,0.5,0.5);

	this.shape_3584 = new cjs.Shape();
	this.shape_3584.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgCCeIACAAQAQgYAXgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_3584.setTransform(288.7,241.4,0.5,0.5);

	this.shape_3585 = new cjs.Shape();
	this.shape_3585.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3585.setTransform(276.6,242.8,0.5,0.5);

	this.shape_3586 = new cjs.Shape();
	this.shape_3586.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3586.setTransform(261.4,242.8,0.5,0.5);

	this.shape_3587 = new cjs.Shape();
	this.shape_3587.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjDAAQABA5AaAdQAZAdAuAAQAUAAAWgDQAPgDAcgLIAAAWQgWAKgTAEQgTADgZAAQg5AAghgkgAg3hcQgYAagDAxICnAAQAAgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_3587.setTransform(250.4,244.3,0.5,0.5);

	this.shape_3588 = new cjs.Shape();
	this.shape_3588.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3588.setTransform(240.5,241.4,0.5,0.5);

	this.shape_3589 = new cjs.Shape();
	this.shape_3589.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_3589.setTransform(223.5,244.2,0.5,0.5);

	this.shape_3590 = new cjs.Shape();
	this.shape_3590.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAwAAAbAhQAcAigBA5IAAASIjCAAQACA5AYAdQAaAdAuAAQAUAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3590.setTransform(208.9,244.3,0.5,0.5);

	this.shape_3591 = new cjs.Shape();
	this.shape_3591.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQABAgAJAOQAMAPAXAAQAWAAATgEIAAATQgRAHgZAAQgigBgSgSg");
	this.shape_3591.setTransform(197.5,242.8,0.5,0.5);

	this.shape_3592 = new cjs.Shape();
	this.shape_3592.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgwASgZQARgXAqAAQAYAAAUAGIgFAWQgUgGgUAAQgcAAgMARQgMASAAAmIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3592.setTransform(190.4,241.4,0.5,0.5);

	this.shape_3593 = new cjs.Shape();
	this.shape_3593.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3593.setTransform(178.3,244.3,0.5,0.5);

	this.shape_3594 = new cjs.Shape();
	this.shape_3594.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBFAGAYIABAAIAihfIA6iWIAZAAIh4E5QgPAmgKAOQgJANgOAHQgNAHgUgBQgPAAgQgEg");
	this.shape_3594.setTransform(158.3,247.4,0.5,0.5);

	this.shape_3595 = new cjs.Shape();
	this.shape_3595.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjCAAQACA5AYAdQAaAdAuAAQAUAAAWgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_3595.setTransform(145.5,244.3,0.5,0.5);

	this.shape_3596 = new cjs.Shape();
	this.shape_3596.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_3596.setTransform(131,241.4,0.5,0.5);

	this.shape_3597 = new cjs.Shape();
	this.shape_3597.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_3597.setTransform(116.8,242,0.5,0.5);

	this.shape_3598 = new cjs.Shape();
	this.shape_3598.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3598.setTransform(100.4,250.1,0.5,0.5);

	this.shape_3599 = new cjs.Shape();
	this.shape_3599.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_3599.setTransform(92.3,241.4,0.5,0.5);

	this.shape_3600 = new cjs.Shape();
	this.shape_3600.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_3600.setTransform(81,244.2,0.5,0.5);

	this.shape_3601 = new cjs.Shape();
	this.shape_3601.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3601.setTransform(67.6,244.3,0.5,0.5);

	this.shape_3602 = new cjs.Shape();
	this.shape_3602.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA2AFAfIABAAQAPg7AHgSIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_3602.setTransform(51,244.3,0.5,0.5);

	this.shape_3603 = new cjs.Shape();
	this.shape_3603.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3603.setTransform(719.9,206,0.5,0.5);

	this.shape_3604 = new cjs.Shape();
	this.shape_3604.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3604.setTransform(711.2,203.6,0.5,0.5);

	this.shape_3605 = new cjs.Shape();
	this.shape_3605.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAASIjCAAQACA5AYAdQAaAdAvAAQATAAAVgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_3605.setTransform(701.3,206.1,0.5,0.5);

	this.shape_3606 = new cjs.Shape();
	this.shape_3606.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgSgTgjAAQgvAAgXAZQgXAYAAA3IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAQgYAWgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_3606.setTransform(686.8,203.2,0.5,0.5);

	this.shape_3607 = new cjs.Shape();
	this.shape_3607.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_3607.setTransform(674.8,204.6,0.5,0.5);

	this.shape_3608 = new cjs.Shape();
	this.shape_3608.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAVAGIgFAWQgUgGgUAAQgcAAgMARQgMARAAAnIAAAZIA/AAIAAAVIg/AAIAAD4g");
	this.shape_3608.setTransform(661.1,203.1,0.5,0.5);

	this.shape_3609 = new cjs.Shape();
	this.shape_3609.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3609.setTransform(649,206.1,0.5,0.5);

	this.shape_3610 = new cjs.Shape();
	this.shape_3610.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAKgGQAKgHAHgMQAIgMALgbIAMgkIhnkNIAaAAIA5CYQAbBFAGAYIABAAIAihfIA5iWIAZAAIh4E5QgQAngIANQgLAOgNAGQgNAHgTgBQgPAAgRgEg");
	this.shape_3610.setTransform(629,209.2,0.5,0.5);

	this.shape_3611 = new cjs.Shape();
	this.shape_3611.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3611.setTransform(618.7,204.6,0.5,0.5);

	this.shape_3612 = new cjs.Shape();
	this.shape_3612.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3612.setTransform(611.8,203.6,0.5,0.5);

	this.shape_3613 = new cjs.Shape();
	this.shape_3613.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3613.setTransform(606,203.2,0.5,0.5);

	this.shape_3614 = new cjs.Shape();
	this.shape_3614.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3614.setTransform(595.9,206.1,0.5,0.5);

	this.shape_3615 = new cjs.Shape();
	this.shape_3615.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAAABjIAACwg");
	this.shape_3615.setTransform(582.1,206,0.5,0.5);

	this.shape_3616 = new cjs.Shape();
	this.shape_3616.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3616.setTransform(571.7,203.6,0.5,0.5);

	this.shape_3617 = new cjs.Shape();
	this.shape_3617.graphics.f("#000000").s().p("AheC0QgcgUAAgjQABgdAQgRQASgTAdgGQgMgGgHgKQgHgJAAgMQAAgaAigWQgXgJgOgVQgNgTAAgcQAAgpAagZQAagYArAAQAaAAAPAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIALAAAKQAAANAKAHQAKAFAXAAIAvAAQAqAAAZASQAXASAAAjQAAArgjAXQgiAXhAAAQgzAAgcgTgAhgB6QAAA5BTAAQBqAAAAhFQAAgXgRgMQgPgLgnAAIgrAAQhLAAAAA6gAg4igQgTASAAAiQAAAfATARQATASAggBQAhABASgSQASgRAAggQAAgkgSgQQgTgSghAAQggAAgSATg");
	this.shape_3617.setTransform(562.1,209,0.5,0.5);

	this.shape_3618 = new cjs.Shape();
	this.shape_3618.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3618.setTransform(552.6,203.6,0.5,0.5);

	this.shape_3619 = new cjs.Shape();
	this.shape_3619.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIACAAQARgdATgNQASgMAbAAQASAAASAEIgEAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3619.setTransform(545.6,206,0.5,0.5);

	this.shape_3620 = new cjs.Shape();
	this.shape_3620.graphics.f("#000000").s().p("Ag/B7QgagQgPghQgPggAAgqQAAhBAhglQAfglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgeAlg5AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_3620.setTransform(532.3,206.1,0.5,0.5);

	this.shape_3621 = new cjs.Shape();
	this.shape_3621.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhFAdglQAdglA4AAQAdAAAWAKQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_3621.setTransform(510.2,203.3,0.5,0.5);

	this.shape_3622 = new cjs.Shape();
	this.shape_3622.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_3622.setTransform(495.6,206,0.5,0.5);

	this.shape_3623 = new cjs.Shape();
	this.shape_3623.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3623.setTransform(480.8,206.1,0.5,0.5);

	this.shape_3624 = new cjs.Shape();
	this.shape_3624.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokNIAZAAIA5CYQAZBBAJAcIAAAAQAOgqAUg1IA5iWIAaAAIh4E5QgQAogJAMQgJANgOAHQgNAHgTgBQgPAAgRgEg");
	this.shape_3624.setTransform(462,209.2,0.5,0.5);

	this.shape_3625 = new cjs.Shape();
	this.shape_3625.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3625.setTransform(451.7,204.6,0.5,0.5);

	this.shape_3626 = new cjs.Shape();
	this.shape_3626.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3626.setTransform(444.7,203.6,0.5,0.5);

	this.shape_3627 = new cjs.Shape();
	this.shape_3627.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_3627.setTransform(437.7,206,0.5,0.5);

	this.shape_3628 = new cjs.Shape();
	this.shape_3628.graphics.f("#000000").s().p("AhdC0QgdgUAAgjQAAgdARgRQARgTAfgGQgNgGgHgKQgHgJAAgMQAAgaAigWQgXgJgOgVQgNgTABgcQgBgpAagZQAagYArAAQAaAAAPAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQArAAAZASQAXASAAAjQAAArgjAXQghAXhBAAQgyAAgcgTgAhgB6QAAA5BUAAQBpAAAAhFQAAgXgQgMQgSgLgkAAIgsAAQhKAAgBA6gAg4igQgTASAAAiQAAAfAUARQATASAfgBQAhABASgSQASgRAAggQAAgkgTgQQgSgSghAAQgfAAgTATg");
	this.shape_3628.setTransform(425.3,209,0.5,0.5);

	this.shape_3629 = new cjs.Shape();
	this.shape_3629.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgVAKgUAEQgTADgYAAQg7AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_3629.setTransform(411.6,206.1,0.5,0.5);

	this.shape_3630 = new cjs.Shape();
	this.shape_3630.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_3630.setTransform(400.1,204.6,0.5,0.5);

	this.shape_3631 = new cjs.Shape();
	this.shape_3631.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_3631.setTransform(388.6,206,0.5,0.5);

	this.shape_3632 = new cjs.Shape();
	this.shape_3632.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3632.setTransform(378.1,203.6,0.5,0.5);

	this.shape_3633 = new cjs.Shape();
	this.shape_3633.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_3633.setTransform(361.6,206.1,0.5,0.5);

	this.shape_3634 = new cjs.Shape();
	this.shape_3634.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_3634.setTransform(347.2,203.2,0.5,0.5);

	this.shape_3635 = new cjs.Shape();
	this.shape_3635.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3635.setTransform(335.1,204.6,0.5,0.5);

	this.shape_3636 = new cjs.Shape();
	this.shape_3636.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_3636.setTransform(317,206,0.5,0.5);

	this.shape_3637 = new cjs.Shape();
	this.shape_3637.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3637.setTransform(306.5,203.6,0.5,0.5);

	this.shape_3638 = new cjs.Shape();
	this.shape_3638.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAbAhQAcAiAAA5IAAASIjBAAQgBA4AaAeQAaAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgjAAQgmAAgYAag");
	this.shape_3638.setTransform(290,206.1,0.5,0.5);

	this.shape_3639 = new cjs.Shape();
	this.shape_3639.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdglA3AAQAeAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgbAAg9IAAgEQAAg+gVgcQgWgbgvAAQgrAAgWAfg");
	this.shape_3639.setTransform(275,203.3,0.5,0.5);

	this.shape_3640 = new cjs.Shape();
	this.shape_3640.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_3640.setTransform(264.9,203.6,0.5,0.5);

	this.shape_3641 = new cjs.Shape();
	this.shape_3641.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3641.setTransform(258,206,0.5,0.5);

	this.shape_3642 = new cjs.Shape();
	this.shape_3642.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAdAkAABEQAABDgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAaAAA7IAAAIQAAA/AVAaQAWAcAvAAQApAAAXgfQAXgdAAg5QAAh3hWAAQguAAgXAag");
	this.shape_3642.setTransform(244.9,209,0.5,0.5);

	this.shape_3643 = new cjs.Shape();
	this.shape_3643.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_3643.setTransform(225.3,203.2,0.5,0.5);

	this.shape_3644 = new cjs.Shape();
	this.shape_3644.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_3644.setTransform(210.5,206.1,0.5,0.5);

	this.shape_3645 = new cjs.Shape();
	this.shape_3645.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3645.setTransform(195.5,206.1,0.5,0.5);

	this.shape_3646 = new cjs.Shape();
	this.shape_3646.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3646.setTransform(183.6,204.6,0.5,0.5);

	this.shape_3647 = new cjs.Shape();
	this.shape_3647.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_3647.setTransform(166.9,206.1,0.5,0.5);

	this.shape_3648 = new cjs.Shape();
	this.shape_3648.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3648.setTransform(156.6,204.6,0.5,0.5);

	this.shape_3649 = new cjs.Shape();
	this.shape_3649.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_3649.setTransform(146.5,206.1,0.5,0.5);

	this.shape_3650 = new cjs.Shape();
	this.shape_3650.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_3650.setTransform(137.8,203.6,0.5,0.5);

	this.shape_3651 = new cjs.Shape();
	this.shape_3651.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQALAPAXAAQAWAAASgEIAAATQgRAHgXAAQgkgBgQgSg");
	this.shape_3651.setTransform(130.4,204.6,0.5,0.5);

	this.shape_3652 = new cjs.Shape();
	this.shape_3652.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_3652.setTransform(122.2,206,0.5,0.5);

	this.shape_3653 = new cjs.Shape();
	this.shape_3653.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ADgYAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_3653.setTransform(109.2,206.1,0.5,0.5);

	this.shape_3654 = new cjs.Shape();
	this.shape_3654.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIABAAQARgYAWgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_3654.setTransform(88.8,203.2,0.5,0.5);

	this.shape_3655 = new cjs.Shape();
	this.shape_3655.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_3655.setTransform(76.8,204.6,0.5,0.5);

	this.shape_3656 = new cjs.Shape();
	this.shape_3656.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_3656.setTransform(65.2,206.1,0.5,0.5);

	this.shape_3657 = new cjs.Shape();
	this.shape_3657.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBBAAAhAXQAgAXAAAvQAAAfgUAVQgTAVglAGIAAACQAsAHAUATQAVAVAAAlQAAAygiAcQghAbg8AAgAheCgIBWAAQBkAAAAhTQAAhKhpAAIhRAAgAhegTIBRAAQAyAAAXgRQAYgQAAglQAAglgbgQQgagQgzAAIhKAAg");
	this.shape_3657.setTransform(50.3,203.8,0.5,0.5);

	this.instance_13 = new lib.hands_0nwhitetable();
	this.instance_13.parent = this;
	this.instance_13.setTransform(831,-5);

	this.shape_3658 = new cjs.Shape();
	this.shape_3658.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_3658.setTransform(495.4,815.8,0.5,0.5);

	this.shape_3659 = new cjs.Shape();
	this.shape_3659.graphics.f("#000000").s().p("AgvCPIB0kKIigAAIAAgTIC3AAIAAAOIh1EPg");
	this.shape_3659.setTransform(487.3,809.4,0.5,0.5);

	this.shape_3660 = new cjs.Shape();
	this.shape_3660.graphics.f("#000000").s().p("AhCCAQgXgUAAgmQAAgaAQgTQAQgTAigNQgfgPgNgQQgNgQAAgYQAAgUALgQQAKgPATgJQARgIAXAAQAlAAAWASQAWAUAAAfQAAAVgOARQgOARgfAPQAlANAQATQAPATAAAZQAAAkgYAVQgZAVgpAAQgrAAgXgTgAg2AfQgPAQAAAaQAAAbASAPQATAPAgAAQAgAAATgQQATgPAAgcQAAgYgPgPQgQgQgqgQQglAOgOARgAgshzQgQAOAAAXQAAAOAGAKQAFAKANAKQALAIAbALQAggNANgOQAOgOAAgWQAAgXgQgOQgRgOgcAAQgaAAgSAOg");
	this.shape_3660.setTransform(475.9,809.4,0.5,0.5);

	this.shape_3661 = new cjs.Shape();
	this.shape_3661.graphics.f("#000000").s().p("AhICOIAAgRIAmAGQAwAAAbgjQAbgjADhCIgCAAQgOASgUAKQgUAKgUAAQgnAAgXgWQgWgVAAgoQAAgrAYgaQAYgbAnAAQAcAAAUAPQAWAPALAcQALAcAAAoQAAA2gOAnQgPAlgcATQgdASgnAAQgVAAgQgFgAgzhsQgSAVAAAkQAAAiARARQAQARAgAAQATAAARgJQARgIAKgOQAKgPAAgPQAAgXgJgTQgJgUgQgMQgQgLgVAAQgeAAgTAVg");
	this.shape_3661.setTransform(464.4,809.4,0.5,0.5);

	this.shape_3662 = new cjs.Shape();
	this.shape_3662.graphics.f("#000000").s().p("AAcCPIAAjPQAAgZADgiIgHAFIg7AwIgLgOIBNg6IAQAAIAAEdg");
	this.shape_3662.setTransform(451.7,809.4,0.5,0.5);

	this.shape_3663 = new cjs.Shape();
	this.shape_3663.graphics.f("#000000").s().p("AgWAxQAOg0AHgtIAWAAIACAEQgNAwgUAtg");
	this.shape_3663.setTransform(439.7,816.7,0.5,0.5);

	this.shape_3664 = new cjs.Shape();
	this.shape_3664.graphics.f("#000000").s().p("AgnCuQA6hPAAheQAAgygPgsQgNgsgfgkIAXAAQAbAhAQAuQAOAuAAAxQAAA0gOAsQgQAsgbAhg");
	this.shape_3664.setTransform(435.1,811,0.5,0.5);

	this.shape_3665 = new cjs.Shape();
	this.shape_3665.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAHALQAJAMASAAQATAAAOgDIAAAPQgPAFgSAAQgbAAgNgPg");
	this.shape_3665.setTransform(429,810,0.5,0.5);

	this.shape_3666 = new cjs.Shape();
	this.shape_3666.graphics.f("#000000").s().p("ABACYIAAiKQAAgfgNgPQgOgOgcAAQglAAgSATQgRATAAArIAAB1IgTAAIAAkvIATAAIgBB7IABAAQAMgTASgIQAUgIAYgBQBJAAgBBNIAACLg");
	this.shape_3666.setTransform(419.9,808.9,0.5,0.5);

	this.shape_3667 = new cjs.Shape();
	this.shape_3667.graphics.f("#000000").s().p("AhJCNQgWgQAAgbQAAgWANgPQAOgOAXgFQgKgFgFgHQgGgHAAgKQAAgUAbgRQgSgHgLgRQgKgQAAgVQAAgfAUgUQAVgTAiAAQASAAANAEIBEAAIAAANIgsADQASAXAAAZQAAAfgVATQgUATghAAIgVgBQgMAGgFAIQgGAHAAAJQAAAKAHAFQAIAFASAAIAkAAQAkAAARAOQATAOAAAbQAAAigcASQgaASgyAAQgpAAgVgPgAhLBgQAAAsBBAAQBTAAAAg2QAAgTgNgIQgMgJgfAAIghAAQg7AAAAAugAgsh+QgPAPAAAaQAAAZAPANQAPAOAZAAQAaAAAOgOQAOgNAAgaQAAgagOgPQgPgNgZAAQgZAAgPAOg");
	this.shape_3667.setTransform(408.7,813.5,0.5,0.5);

	this.shape_3668 = new cjs.Shape();
	this.shape_3668.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQAEAGAAAJQAAAHgEAGQgDAGgGAAQgMgBAAgSg");
	this.shape_3668.setTransform(401.2,809.3,0.5,0.5);

	this.shape_3669 = new cjs.Shape();
	this.shape_3669.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAWAAQAMAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_3669.setTransform(395.8,811.1,0.5,0.5);

	this.shape_3670 = new cjs.Shape();
	this.shape_3670.graphics.f("#000000").s().p("AASCuQgbghgPgsQgPgsAAg0QAAgyAPgtQAPguAbghIAWAAQgdAkgOAsQgPAtAAAxQAABfA6BOg");
	this.shape_3670.setTransform(388.6,811,0.5,0.5);

	this.shape_3671 = new cjs.Shape();
	this.shape_3671.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_3671.setTransform(378.3,808.9,0.5,0.5);

	this.shape_3672 = new cjs.Shape();
	this.shape_3672.graphics.f("#000000").s().p("Ag8BSQgagdAAgzQAAgxAZgfQAagfApAAQAmAAAVAaQAWAbAAAsIAAAPIiYAAQABAsATAWQAUAXAlABQAUgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQgtAAgbgcgAgqhHQgSATgEAmICCAAQAAgkgQgVQgQgVgcAAQgeAAgSAVg");
	this.shape_3672.setTransform(370.5,811.2,0.5,0.5);

	this.shape_3673 = new cjs.Shape();
	this.shape_3673.graphics.f("#000000").s().p("ABACYIAAiKQAAgfgNgPQgOgOgcAAQgkAAgTATQgRAUAAAqIAAB1IgUAAIAAkvIAUAAIgBB7IABAAQAMgSASgJQATgIAZgBQBJAAAABNIAACLg");
	this.shape_3673.setTransform(359.2,808.9,0.5,0.5);

	this.shape_3674 = new cjs.Shape();
	this.shape_3674.graphics.f("#000000").s().p("AgxBSQgbgdAAgzQABg0AagdQAbgeAtAAQAcAAAZAJIgFARQgbgIgVgBQglAAgVAYQgUAYAAAtQAAArAUAYQAVAYAjABQAbAAAagKIAAARQgTAKgiAAQgtAAgZgcg");
	this.shape_3674.setTransform(348.7,811.2,0.5,0.5);

	this.shape_3675 = new cjs.Shape();
	this.shape_3675.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgLh9QAAgTALAAQAGAAADAEQAEAGgBAJQABAIgEAFQgDAGgGAAQgLgBAAgSg");
	this.shape_3675.setTransform(341.5,809.3,0.5,0.5);

	this.shape_3676 = new cjs.Shape();
	this.shape_3676.graphics.f("#000000").s().p("ABwCPIAAjYQAAgUACgbIgBAAIhrEHIgMAAIhqkHIgCAAIACAxIAADWIgTAAIAAkdIAeAAIBlD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_3676.setTransform(330.6,809.4,0.5,0.5);

	this.shape_3677 = new cjs.Shape();
	this.shape_3677.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAHgEAHgLQAHgLAHgUIAKgcIhRjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgNAhgHAIQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_3677.setTransform(312.2,813.6,0.5,0.5);

	this.shape_3678 = new cjs.Shape();
	this.shape_3678.graphics.f("#000000").s().p("AgyBSQgagcABg0QAAg0AbgdQAZgeAvAAQAcAAAZAJIgGARQgcgIgTgBQgnAAgUAYQgUAYAAAtQAAArAUAYQAVAYAiABQAcAAAagKIAAARQgUAKgiAAQgsAAgagcg");
	this.shape_3678.setTransform(303.1,811.2,0.5,0.5);

	this.shape_3679 = new cjs.Shape();
	this.shape_3679.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgcAAQglAAgTATQgRATAAAsIAAB0IgUAAIAAjTIARAAIADAdIACAAQAVghA0AAQBHAAABBNIAACKg");
	this.shape_3679.setTransform(292.3,811.1,0.5,0.5);

	this.shape_3680 = new cjs.Shape();
	this.shape_3680.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgbAAQgdAAggAQIgHgRQAkgQAgAAQAjAAASASQARATAAAmIAACMIgPAAIgFgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgrACgUAMQgSALgBAZQAAAUANALQAMALAWAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_3680.setTransform(280.7,811.2,0.5,0.5);

	this.shape_3681 = new cjs.Shape();
	this.shape_3681.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_3681.setTransform(268.5,809.4,0.5,0.5);

	this.shape_3682 = new cjs.Shape();
	this.shape_3682.graphics.f("#000000").s().p("AgWAxQAOg0AHgtIAWAAIACAEQgNAwgUAtg");
	this.shape_3682.setTransform(253.6,816.7,0.5,0.5);

	this.shape_3683 = new cjs.Shape();
	this.shape_3683.graphics.f("#000000").s().p("AgnCuQA6hOAAhfQAAgygPgsQgOgsgdgkIAWAAQAbAhAPAuQAPAuAAAxQAAA0gPAsQgPAsgbAhg");
	this.shape_3683.setTransform(249,811,0.5,0.5);

	this.shape_3684 = new cjs.Shape();
	this.shape_3684.graphics.f("#000000").s().p("AgOB3QgNgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAHAMQAJAMASAAQATAAANgDIAAAPQgOAFgSAAQgbAAgOgPg");
	this.shape_3684.setTransform(242.9,810,0.5,0.5);

	this.shape_3685 = new cjs.Shape();
	this.shape_3685.graphics.f("#000000").s().p("AgbCZIAAjCIgoAAIAAgMIAogHIAAgQQAAgnAOgTQAOgSAgAAQARAAASAFIgFARQgOgFgQAAQgWAAgKAOQgJAMAAAfIAAAUIAxAAIAAARIgxAAIAADCg");
	this.shape_3685.setTransform(237.3,808.9,0.5,0.5);

	this.shape_3686 = new cjs.Shape();
	this.shape_3686.graphics.f("#000000").s().p("Ag8BSQgagdAAgzQAAgxAZgfQAagfApAAQAmAAAVAaQAWAaAAAtIAAAPIiYAAQABAsATAWQAUAXAlABQAUgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgUAAQgtAAgbgcgAgqhHQgSATgEAmICCAAQAAgkgQgVQgPgVgdAAQgdAAgTAVg");
	this.shape_3686.setTransform(228.2,811.2,0.5,0.5);

	this.shape_3687 = new cjs.Shape();
	this.shape_3687.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_3687.setTransform(220.4,808.9,0.5,0.5);

	this.shape_3688 = new cjs.Shape();
	this.shape_3688.graphics.f("#000000").s().p("AASCuQgbghgPgsQgPgsAAg0QAAgyAPgtQAPguAbghIAWAAQgdAkgOAsQgPAtAAAxQAABfA6BOg");
	this.shape_3688.setTransform(215.5,811,0.5,0.5);

	this.shape_3689 = new cjs.Shape();
	this.shape_3689.graphics.f("#000000").s().p("AhKBhIAAgVQAfAQAkAAQAgAAAPgKQAQgKAAgSQAAgQgNgLQgMgLgegLQgcgIgQgLQgOgIgFgKQgHgLAAgPQAAgXAUgOQAUgOAjAAQAkAAAdANIgHASQgggOgaAAQgZAAgPAJQgPAJAAAPQAAARALAKQANAKAhALQAcALANAIQAOAIAGAKQAGALAAAOQAAAdgVAPQgWAPgnAAQgrAAgYgNg");
	this.shape_3689.setTransform(202.8,811.2,0.5,0.5);

	this.shape_3690 = new cjs.Shape();
	this.shape_3690.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_3690.setTransform(192.4,811.1,0.5,0.5);

	this.shape_3691 = new cjs.Shape();
	this.shape_3691.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh9QAAgTALAAQAGAAADAEQAEAGAAAJQAAAIgEAFQgDAGgGAAQgLgBAAgSg");
	this.shape_3691.setTransform(184.2,809.3,0.5,0.5);

	this.shape_3692 = new cjs.Shape();
	this.shape_3692.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhSBaIBZB6g");
	this.shape_3692.setTransform(177.9,808.9,0.5,0.5);

	this.shape_3693 = new cjs.Shape();
	this.shape_3693.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAJgwIALAAIAAA0IA9AAIAAARIg9AAIAACFQAAAYAIAMQAIAMASAAQASAAAOgDIAAAPQgOAFgSAAQgbAAgNgPg");
	this.shape_3693.setTransform(168.7,810,0.5,0.5);

	this.shape_3694 = new cjs.Shape();
	this.shape_3694.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_3694.setTransform(159.9,811.2,0.5,0.5);

	this.shape_3695 = new cjs.Shape();
	this.shape_3695.graphics.f("#000000").s().p("ABJCPIg+jcQgIgagEgSQgCARgHAWQgFAXg6DKIgQAAIhOkdIAUAAIBDD9QAEgWAQg7IAxisIAVAAIA5DGQALAmAEARQACgQAEgOIA8jfIAUAAIhPEdg");
	this.shape_3695.setTransform(146,809.4,0.5,0.5);

	this.shape_3696 = new cjs.Shape();
	this.shape_3696.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAkAAAQASQASATAAAmIAACMIgPAAIgEgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgRgQgAAYAAQgtACgSAMQgTALgBAZQAAAUANALQALALAYAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_3696.setTransform(126.2,811.2,0.5,0.5);

	this.shape_3697 = new cjs.Shape();
	this.shape_3697.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIABAAQAOgYAOgJQAOgJAVAAQAMAAARACIgEATQgMgDgPAAQgaAAgSAXQgRAXAAAjIAAB0g");
	this.shape_3697.setTransform(118.1,811.1,0.5,0.5);

	this.shape_3698 = new cjs.Shape();
	this.shape_3698.graphics.f("#000000").s().p("AhBB/QgYgcABg0QAAg2AWgdQAYgdArAAQAXAAAQAIQARAJAOAUIABAAIgBh9IATAAIAAEvIgNAAIgFggIgBAAQgYAkguAAQgqAAgYgbgAgzgXQgRAXAAAvQAABaBFAAQAkAAARgVQARgVAAgwIAAgDQAAgwgRgWQgQgWglAAQgjAAgRAZg");
	this.shape_3698.setTransform(107.2,809,0.5,0.5);

	this.shape_3699 = new cjs.Shape();
	this.shape_3699.graphics.f("#000000").s().p("ABABsIAAiJQABgggOgOQgOgPgcAAQglAAgRATQgSATAAAsIAAB0IgTAAIAAjTIAQAAIAEAdIABAAQAUghA0AAQBIAAAABNIAACKg");
	this.shape_3699.setTransform(95.8,811.1,0.5,0.5);

	this.shape_3700 = new cjs.Shape();
	this.shape_3700.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgcAAghAQIgHgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_3700.setTransform(84.1,811.2,0.5,0.5);

	this.shape_3701 = new cjs.Shape();
	this.shape_3701.graphics.f("#000000").s().p("ABDBqIhDhfIhCBfIgWAAIBNhsIhKhnIAWAAIA/BZIA+hZIAWAAIhJBnIBOBsg");
	this.shape_3701.setTransform(74.2,811.2,0.5,0.5);

	this.shape_3702 = new cjs.Shape();
	this.shape_3702.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgxAagfQAYgfAqAAQAmAAAVAaQAVAaAAAtIAAAPIiXAAQAAArAUAXQAUAXAkABQAWgBALgCQAOgCAUgJIAAARQgRAIgQAEQgMACgWAAQgtAAgagcgAgqhHQgTAUgDAlICCAAQAAglgQgUQgPgVgdAAQgeAAgSAVg");
	this.shape_3702.setTransform(63.8,811.2,0.5,0.5);

	this.shape_3703 = new cjs.Shape();
	this.shape_3703.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_3703.setTransform(56,808.9,0.5,0.5);

	this.shape_3704 = new cjs.Shape();
	this.shape_3704.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgoBmIgWAAIBzkeIAMAAIBwEegAgKhNIgoBlIBlAAIgziHQgDARgHARg");
	this.shape_3704.setTransform(47.8,809.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_3704},{t:this.shape_3703},{t:this.shape_3702},{t:this.shape_3701},{t:this.shape_3700},{t:this.shape_3699},{t:this.shape_3698},{t:this.shape_3697},{t:this.shape_3696},{t:this.shape_3695},{t:this.shape_3694},{t:this.shape_3693},{t:this.shape_3692},{t:this.shape_3691},{t:this.shape_3690},{t:this.shape_3689},{t:this.shape_3688},{t:this.shape_3687},{t:this.shape_3686},{t:this.shape_3685},{t:this.shape_3684},{t:this.shape_3683},{t:this.shape_3682},{t:this.shape_3681},{t:this.shape_3680},{t:this.shape_3679},{t:this.shape_3678},{t:this.shape_3677},{t:this.shape_3676},{t:this.shape_3675},{t:this.shape_3674},{t:this.shape_3673},{t:this.shape_3672},{t:this.shape_3671},{t:this.shape_3670},{t:this.shape_3669},{t:this.shape_3668},{t:this.shape_3667},{t:this.shape_3666},{t:this.shape_3665},{t:this.shape_3664},{t:this.shape_3663},{t:this.shape_3662},{t:this.shape_3661},{t:this.shape_3660},{t:this.shape_3659},{t:this.shape_3658},{t:this.instance_13},{t:this.shape_3657},{t:this.shape_3656},{t:this.shape_3655},{t:this.shape_3654},{t:this.shape_3653},{t:this.shape_3652},{t:this.shape_3651},{t:this.shape_3650},{t:this.shape_3649},{t:this.shape_3648},{t:this.shape_3647},{t:this.shape_3646},{t:this.shape_3645},{t:this.shape_3644},{t:this.shape_3643},{t:this.shape_3642},{t:this.shape_3641},{t:this.shape_3640},{t:this.shape_3639},{t:this.shape_3638},{t:this.shape_3637},{t:this.shape_3636},{t:this.shape_3635},{t:this.shape_3634},{t:this.shape_3633},{t:this.shape_3632},{t:this.shape_3631},{t:this.shape_3630},{t:this.shape_3629},{t:this.shape_3628},{t:this.shape_3627},{t:this.shape_3626},{t:this.shape_3625},{t:this.shape_3624},{t:this.shape_3623},{t:this.shape_3622},{t:this.shape_3621},{t:this.shape_3620},{t:this.shape_3619},{t:this.shape_3618},{t:this.shape_3617},{t:this.shape_3616},{t:this.shape_3615},{t:this.shape_3614},{t:this.shape_3613},{t:this.shape_3612},{t:this.shape_3611},{t:this.shape_3610},{t:this.shape_3609},{t:this.shape_3608},{t:this.shape_3607},{t:this.shape_3606},{t:this.shape_3605},{t:this.shape_3604},{t:this.shape_3603},{t:this.shape_3602},{t:this.shape_3601},{t:this.shape_3600},{t:this.shape_3599},{t:this.shape_3598},{t:this.shape_3597},{t:this.shape_3596},{t:this.shape_3595},{t:this.shape_3594},{t:this.shape_3593},{t:this.shape_3592},{t:this.shape_3591},{t:this.shape_3590},{t:this.shape_3589},{t:this.shape_3588},{t:this.shape_3587},{t:this.shape_3586},{t:this.shape_3585},{t:this.shape_3584},{t:this.shape_3583},{t:this.shape_3582},{t:this.shape_3581},{t:this.shape_3580},{t:this.shape_3579},{t:this.shape_3578},{t:this.shape_3577},{t:this.shape_3576},{t:this.shape_3575},{t:this.shape_3574},{t:this.shape_3573},{t:this.shape_3572},{t:this.shape_3571},{t:this.shape_3570},{t:this.shape_3569},{t:this.shape_3568},{t:this.shape_3567},{t:this.shape_3566},{t:this.shape_3565},{t:this.shape_3564},{t:this.shape_3563},{t:this.shape_3562},{t:this.shape_3561},{t:this.shape_3560},{t:this.shape_3559},{t:this.shape_3558},{t:this.shape_3557},{t:this.shape_3556},{t:this.shape_3555},{t:this.shape_3554},{t:this.shape_3553},{t:this.shape_3552},{t:this.shape_3551},{t:this.shape_3550},{t:this.shape_3549},{t:this.shape_3548},{t:this.shape_3547},{t:this.shape_3546},{t:this.shape_3545},{t:this.shape_3544},{t:this.shape_3543},{t:this.shape_3542},{t:this.shape_3541},{t:this.shape_3540},{t:this.shape_3539},{t:this.shape_3538},{t:this.shape_3537},{t:this.shape_3536},{t:this.shape_3535},{t:this.shape_3534},{t:this.shape_3533},{t:this.shape_3532},{t:this.shape_3531},{t:this.shape_3530},{t:this.shape_3529},{t:this.shape_3528},{t:this.shape_3527},{t:this.shape_3526},{t:this.shape_3525},{t:this.shape_3524},{t:this.shape_3523},{t:this.shape_3522},{t:this.shape_3521},{t:this.shape_3520},{t:this.shape_3519},{t:this.shape_3518},{t:this.shape_3517},{t:this.shape_3516},{t:this.shape_3515},{t:this.shape_3514},{t:this.shape_3513},{t:this.shape_3512},{t:this.shape_3511},{t:this.shape_3510},{t:this.shape_3509},{t:this.shape_3508},{t:this.shape_3507},{t:this.shape_3506},{t:this.shape_3505},{t:this.shape_3504},{t:this.shape_3503},{t:this.shape_3502},{t:this.shape_3501},{t:this.shape_3500},{t:this.shape_3499},{t:this.shape_3498},{t:this.shape_3497},{t:this.shape_3496},{t:this.shape_3495},{t:this.shape_3494},{t:this.shape_3493},{t:this.shape_3492},{t:this.shape_3491},{t:this.shape_3490},{t:this.shape_3489},{t:this.shape_3488},{t:this.shape_3487},{t:this.shape_3486},{t:this.shape_3485},{t:this.shape_3484},{t:this.shape_3483},{t:this.shape_3482},{t:this.shape_3481},{t:this.shape_3480},{t:this.shape_3479},{t:this.shape_3478},{t:this.shape_3477},{t:this.shape_3476},{t:this.shape_3475},{t:this.shape_3474},{t:this.shape_3473},{t:this.shape_3472},{t:this.shape_3471},{t:this.shape_3470},{t:this.shape_3469},{t:this.shape_3468},{t:this.shape_3467},{t:this.shape_3466},{t:this.shape_3465},{t:this.shape_3464},{t:this.shape_3463},{t:this.shape_3462},{t:this.shape_3461},{t:this.shape_3460},{t:this.shape_3459},{t:this.shape_3458},{t:this.shape_3457},{t:this.shape_3456},{t:this.shape_3455},{t:this.shape_3454},{t:this.shape_3453},{t:this.shape_3452},{t:this.shape_3451},{t:this.shape_3450},{t:this.shape_3449},{t:this.shape_3448},{t:this.shape_3447},{t:this.shape_3446},{t:this.shape_3445},{t:this.shape_3444},{t:this.shape_3443},{t:this.shape_3442},{t:this.shape_3441},{t:this.shape_3440},{t:this.shape_3439},{t:this.shape_3438},{t:this.shape_3437},{t:this.shape_3436},{t:this.shape_3435},{t:this.shape_3434},{t:this.shape_3433},{t:this.shape_3432},{t:this.shape_3431},{t:this.shape_3430},{t:this.shape_3429},{t:this.shape_3428},{t:this.shape_3427},{t:this.shape_3426},{t:this.shape_3425},{t:this.shape_3424},{t:this.shape_3423},{t:this.shape_3422},{t:this.shape_3421},{t:this.shape_3420},{t:this.shape_3419},{t:this.shape_3418},{t:this.shape_3417},{t:this.shape_3416},{t:this.shape_3415},{t:this.shape_3414},{t:this.shape_3413},{t:this.shape_3412},{t:this.shape_3411},{t:this.shape_3410},{t:this.shape_3409},{t:this.shape_3408},{t:this.shape_3407},{t:this.shape_3406},{t:this.shape_3405},{t:this.shape_3404},{t:this.shape_3403},{t:this.shape_3402},{t:this.shape_3401},{t:this.shape_3400},{t:this.shape_3399},{t:this.shape_3398},{t:this.shape_3397},{t:this.shape_3396},{t:this.shape_3395},{t:this.shape_3394},{t:this.shape_3393},{t:this.shape_3392},{t:this.shape_3391},{t:this.shape_3390},{t:this.shape_3389},{t:this.shape_3388},{t:this.shape_3387},{t:this.shape_3386},{t:this.shape_3385},{t:this.shape_3384},{t:this.shape_3383},{t:this.shape_3382},{t:this.shape_3381},{t:this.shape_3380},{t:this.shape_3379},{t:this.shape_3378},{t:this.shape_3377},{t:this.shape_3376},{t:this.shape_3375},{t:this.shape_3374},{t:this.shape_3373},{t:this.shape_3372},{t:this.shape_3371},{t:this.shape_3370},{t:this.shape_3369},{t:this.shape_3368},{t:this.shape_3367},{t:this.shape_3366},{t:this.shape_3365},{t:this.shape_3364},{t:this.shape_3363},{t:this.shape_3362},{t:this.shape_3361},{t:this.shape_3360},{t:this.shape_3359},{t:this.shape_3358},{t:this.shape_3357},{t:this.shape_3356},{t:this.shape_3355},{t:this.shape_3354},{t:this.shape_3353},{t:this.shape_3352},{t:this.shape_3351},{t:this.shape_3350},{t:this.shape_3349},{t:this.shape_3348},{t:this.shape_3347},{t:this.shape_3346},{t:this.shape_3345},{t:this.shape_3344},{t:this.shape_3343},{t:this.shape_3342},{t:this.shape_3341},{t:this.shape_3340},{t:this.shape_3339},{t:this.shape_3338},{t:this.shape_3337},{t:this.shape_3336},{t:this.shape_3335},{t:this.shape_3334},{t:this.shape_3333},{t:this.shape_3332},{t:this.shape_3331},{t:this.shape_3330},{t:this.shape_3329},{t:this.shape_3328},{t:this.shape_3327},{t:this.shape_3326},{t:this.shape_3325},{t:this.shape_3324},{t:this.shape_3323},{t:this.shape_3322},{t:this.shape_3321},{t:this.shape_3320},{t:this.shape_3319},{t:this.shape_3318},{t:this.shape_3317},{t:this.shape_3316},{t:this.shape_3315},{t:this.shape_3314},{t:this.shape_3313},{t:this.shape_3312},{t:this.shape_3311},{t:this.shape_3310},{t:this.shape_3309},{t:this.shape_3308},{t:this.shape_3307},{t:this.shape_3306},{t:this.shape_3305},{t:this.shape_3304},{t:this.shape_3303},{t:this.shape_3302},{t:this.shape_3301},{t:this.shape_3300},{t:this.shape_3299},{t:this.shape_3298},{t:this.shape_3297},{t:this.shape_3296},{t:this.shape_3295},{t:this.shape_3294},{t:this.shape_3293},{t:this.shape_3292},{t:this.shape_3291},{t:this.shape_3290},{t:this.shape_3289},{t:this.shape_3288},{t:this.shape_3287},{t:this.shape_3286},{t:this.shape_3285},{t:this.shape_3284},{t:this.shape_3283},{t:this.shape_3282},{t:this.shape_3281},{t:this.shape_3280},{t:this.shape_3279},{t:this.shape_3278},{t:this.shape_3277},{t:this.shape_3276},{t:this.shape_3275},{t:this.shape_3274},{t:this.shape_3273},{t:this.shape_3272},{t:this.shape_3271},{t:this.shape_3270},{t:this.shape_3269},{t:this.shape_3268},{t:this.shape_3267},{t:this.shape_3266},{t:this.shape_3265},{t:this.shape_3264},{t:this.shape_3263},{t:this.shape_3262},{t:this.shape_3261},{t:this.shape_3260},{t:this.shape_3259},{t:this.shape_3258},{t:this.shape_3257},{t:this.shape_3256},{t:this.shape_3255},{t:this.shape_3254},{t:this.shape_3253},{t:this.shape_3252},{t:this.shape_3251},{t:this.shape_3250},{t:this.shape_3249},{t:this.shape_3248},{t:this.shape_3247},{t:this.shape_3246},{t:this.shape_3245},{t:this.shape_3244},{t:this.shape_3243},{t:this.shape_3242},{t:this.shape_3241},{t:this.shape_3240},{t:this.shape_3239},{t:this.shape_3238},{t:this.shape_3237},{t:this.shape_3236},{t:this.shape_3235},{t:this.shape_3234},{t:this.shape_3233},{t:this.shape_3232},{t:this.shape_3231},{t:this.shape_3230},{t:this.shape_3229},{t:this.shape_3228},{t:this.shape_3227},{t:this.shape_3226},{t:this.shape_3225},{t:this.shape_3224},{t:this.shape_3223},{t:this.shape_3222},{t:this.shape_3221},{t:this.shape_3220},{t:this.shape_3219},{t:this.shape_3218},{t:this.shape_3217},{t:this.shape_3216},{t:this.shape_3215},{t:this.shape_3214},{t:this.shape_3213},{t:this.shape_3212},{t:this.shape_3211},{t:this.shape_3210},{t:this.shape_3209},{t:this.shape_3208},{t:this.shape_3207},{t:this.shape_3206},{t:this.shape_3205},{t:this.shape_3204},{t:this.shape_3203},{t:this.shape_3202},{t:this.shape_3201},{t:this.shape_3200},{t:this.shape_3199},{t:this.shape_3198},{t:this.shape_3197},{t:this.shape_3196},{t:this.shape_3195},{t:this.shape_3194},{t:this.shape_3193},{t:this.shape_3192},{t:this.shape_3191},{t:this.shape_3190},{t:this.shape_3189},{t:this.shape_3188},{t:this.shape_3187},{t:this.shape_3186},{t:this.shape_3185},{t:this.shape_3184},{t:this.shape_3183},{t:this.shape_3182},{t:this.shape_3181},{t:this.shape_3180},{t:this.shape_3179},{t:this.shape_3178},{t:this.shape_3177},{t:this.shape_3176},{t:this.shape_3175},{t:this.shape_3174},{t:this.shape_3173},{t:this.shape_3172},{t:this.shape_3171},{t:this.shape_3170},{t:this.shape_3169},{t:this.shape_3168},{t:this.shape_3167},{t:this.shape_3166},{t:this.shape_3165},{t:this.shape_3164},{t:this.shape_3163},{t:this.shape_3162},{t:this.shape_3161},{t:this.shape_3160},{t:this.shape_3159},{t:this.shape_3158},{t:this.shape_3157},{t:this.shape_3156},{t:this.shape_3155},{t:this.shape_3154},{t:this.shape_3153},{t:this.shape_3152},{t:this.shape_3151},{t:this.shape_3150},{t:this.shape_3149},{t:this.shape_3148},{t:this.shape_3147},{t:this.shape_3146},{t:this.shape_3145},{t:this.shape_3144},{t:this.shape_3143},{t:this.shape_3142},{t:this.shape_3141},{t:this.shape_3140},{t:this.shape_3139},{t:this.shape_3138},{t:this.shape_3137},{t:this.shape_3136},{t:this.shape_3135},{t:this.shape_3134},{t:this.shape_3133},{t:this.shape_3132},{t:this.shape_3131},{t:this.shape_3130},{t:this.shape_3129},{t:this.shape_3128},{t:this.shape_3127},{t:this.shape_3126},{t:this.shape_3125},{t:this.shape_3124},{t:this.shape_3123},{t:this.shape_3122},{t:this.shape_3121},{t:this.shape_3120},{t:this.shape_3119},{t:this.shape_3118},{t:this.shape_3117},{t:this.shape_3116},{t:this.shape_3115},{t:this.shape_3114},{t:this.shape_3113},{t:this.shape_3112},{t:this.shape_3111},{t:this.shape_3110},{t:this.shape_3109},{t:this.shape_3108},{t:this.shape_3107},{t:this.shape_3106},{t:this.shape_3105},{t:this.shape_3104},{t:this.shape_3103},{t:this.shape_3102},{t:this.shape_3101},{t:this.shape_3100},{t:this.shape_3099},{t:this.shape_3098},{t:this.shape_3097},{t:this.shape_3096},{t:this.shape_3095},{t:this.shape_3094},{t:this.shape_3093},{t:this.shape_3092},{t:this.shape_3091},{t:this.shape_3090},{t:this.shape_3089},{t:this.shape_3088},{t:this.shape_3087},{t:this.shape_3086},{t:this.shape_3085},{t:this.shape_3084},{t:this.shape_3083},{t:this.shape_3082},{t:this.shape_3081},{t:this.shape_3080},{t:this.shape_3079},{t:this.shape_3078},{t:this.shape_3077},{t:this.shape_3076},{t:this.shape_3075},{t:this.shape_3074},{t:this.shape_3073},{t:this.shape_3072},{t:this.shape_3071}]},108).to({state:[]},1).wait(56));

	// ButtonLeftRight copy 34
	this.buttonR16 = new lib.ButtonLeft_Right();
	this.buttonR16.name = "buttonR16";
	this.buttonR16.parent = this;
	this.buttonR16.setTransform(2025,513.5,1,1,180);
	this.buttonR16._off = true;
	new cjs.ButtonHelper(this.buttonR16, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR16).wait(107).to({_off:false},0).to({_off:true},1).wait(57));

	// ButtonLeftRight copy 35
	this.buttonL16 = new lib.ButtonLeft_Right();
	this.buttonL16.name = "buttonL16";
	this.buttonL16.parent = this;
	this.buttonL16.setTransform(0,437.2);
	this.buttonL16._off = true;
	new cjs.ButtonHelper(this.buttonL16, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL16).wait(107).to({_off:false},0).to({_off:true},1).wait(57));

	// Layer 1
	this.instance_14 = new lib.katchin_face();
	this.instance_14.parent = this;
	this.instance_14.setTransform(1334,186,0.742,0.742);

	this.instance_15 = new lib.katchin_side();
	this.instance_15.parent = this;
	this.instance_15.setTransform(1026,168,0.61,0.61);

	this.shape_3705 = new cjs.Shape();
	this.shape_3705.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_3705.setTransform(283.2,816.2,0.5,0.5);

	this.shape_3706 = new cjs.Shape();
	this.shape_3706.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_3706.setTransform(278.6,809.3,0.5,0.5);

	this.shape_3707 = new cjs.Shape();
	this.shape_3707.graphics.f("#000000").s().p("Ag8BSQgagdAAgzQAAgyAZgeQAZgfAqAAQAlAAAWAaQAVAaABAtIAAAPIiYAAQABAsATAWQAUAXAkABQAVgBAMgCQAOgCAUgJIAAARQgRAIgQAEQgNACgVAAQgsAAgbgcgAgrhHQgSATgDAmICCAAQAAgkgQgVQgPgVgdAAQgeAAgTAVg");
	this.shape_3707.setTransform(270.8,811.6,0.5,0.5);

	this.shape_3708 = new cjs.Shape();
	this.shape_3708.graphics.f("#000000").s().p("ABACYIAAiKQAAgfgNgPQgOgOgcAAQgkAAgTATQgRAUAAAqIAAB1IgUAAIAAkvIAUAAIgBB7IABAAQANgTARgIQATgIAZgBQBJAAAABNIAACLg");
	this.shape_3708.setTransform(259.5,809.3,0.5,0.5);

	this.shape_3709 = new cjs.Shape();
	this.shape_3709.graphics.f("#000000").s().p("AgyBSQgZgdAAgzQAAg1AagcQAbgeAuAAQAbAAAZAJIgFARQgbgIgVgBQgmAAgUAYQgUAZAAAsQAAAqAUAZQAUAYAjABQAcAAAagKIAAARQgUAKghAAQgsAAgbgcg");
	this.shape_3709.setTransform(249,811.6,0.5,0.5);

	this.shape_3710 = new cjs.Shape();
	this.shape_3710.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQADAGABAJQgBAIgDAFQgDAGgGAAQgMgBAAgSg");
	this.shape_3710.setTransform(241.8,809.7,0.5,0.5);

	this.shape_3711 = new cjs.Shape();
	this.shape_3711.graphics.f("#000000").s().p("ABwCPIAAjYQAAgZACgWIgBAAIhrEHIgMAAIhqkHIgCAAQACAZAAAYIAADWIgTAAIAAkdIAfAAIBkD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_3711.setTransform(230.9,809.8,0.5,0.5);

	this.shape_3712 = new cjs.Shape();
	this.shape_3712.graphics.f("#000000").s().p("AhaCWIAAgRQAMADAMAAQAKAAAIgEQAIgFAGgKQAGgLAIgUIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgIAKQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_3712.setTransform(212.5,814,0.5,0.5);

	this.shape_3713 = new cjs.Shape();
	this.shape_3713.graphics.f("#000000").s().p("AgxBSQgagdAAgzQAAg0AagdQAbgeAtAAQAcAAAZAJIgFARQgbgIgVgBQgmAAgUAYQgUAYAAAtQAAArAUAYQAUAYAkABQAbAAAagKIAAARQgTAKgiAAQgtAAgZgcg");
	this.shape_3713.setTransform(203.4,811.6,0.5,0.5);

	this.shape_3714 = new cjs.Shape();
	this.shape_3714.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_3714.setTransform(192.5,811.5,0.5,0.5);

	this.shape_3715 = new cjs.Shape();
	this.shape_3715.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgFgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgRgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_3715.setTransform(180.9,811.6,0.5,0.5);

	this.shape_3716 = new cjs.Shape();
	this.shape_3716.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_3716.setTransform(168.8,809.8,0.5,0.5);

	this.shape_3717 = new cjs.Shape();
	this.shape_3717.graphics.f("#000000").s().p("AhaCWIAAgRQAMADANAAQAKAAAHgEQAIgFAGgKQAFgIAJgXIALgcIhSjTIAUAAIAtB3IAaBJIAAAAIBIjAIAUAAIheD1QgMAfgHAKQgIALgLAFQgLAFgOAAQgKAAgPgEg");
	this.shape_3717.setTransform(151.8,814,0.5,0.5);

	this.shape_3718 = new cjs.Shape();
	this.shape_3718.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAcAAA1QAAA1gYAcQgXAdgrAAQgWAAgTgJgAg1gaQgQAWAAAwIAAADQAAAwARAVQAQAVAkAAQAiAAASgZQARgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_3718.setTransform(141.5,809.4,0.5,0.5);

	this.shape_3719 = new cjs.Shape();
	this.shape_3719.graphics.f("#000000").s().p("AgWAxQAGgXAFgYQAFgTAFgfIAWAAIACAEQgQA2gRAng");
	this.shape_3719.setTransform(128.6,805.1,0.5,0.5);

	this.shape_3720 = new cjs.Shape();
	this.shape_3720.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgnBlIBkAAIgyiHQgEARgHARg");
	this.shape_3720.setTransform(121.2,809.8,0.5,0.5);

	this.shape_3721 = new cjs.Shape();
	this.shape_3721.graphics.f("#000000").s().p("ABUCPIioj9IgCAAQACAoAAAcIAAC5IgTAAIAAkdIAUAAICoD8IABAAIgBj8IATAAIAAEdg");
	this.shape_3721.setTransform(108,809.8,0.5,0.5);

	this.shape_3722 = new cjs.Shape();
	this.shape_3722.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_3722.setTransform(98.2,809.8,0.5,0.5);

	this.shape_3723 = new cjs.Shape();
	this.shape_3723.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgVAAIAAkdIAVAAIAAB/IClAAIAAh/IAUAAIAAEdg");
	this.shape_3723.setTransform(88.5,809.8,0.5,0.5);

	this.shape_3724 = new cjs.Shape();
	this.shape_3724.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQARghAfgTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA8AdAjQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_3724.setTransform(75.4,809.8,0.5,0.5);

	this.shape_3725 = new cjs.Shape();
	this.shape_3725.graphics.f("#000000").s().p("ABiCQIgohmIhzAAIgnBmIgXAAIBzkeIALAAIBxEegAgKhNIgnBlIBkAAIgyiHQgEARgHARg");
	this.shape_3725.setTransform(62.9,809.8,0.5,0.5);

	this.shape_3726 = new cjs.Shape();
	this.shape_3726.graphics.f("#000000").s().p("ABICPIhtiWIgmAgIAAB2IgUAAIAAkdIAUAAIAACTICPiTIAZAAIh0B5IB3Ckg");
	this.shape_3726.setTransform(52.1,809.8,0.5,0.5);

	this.shape_3727 = new cjs.Shape();
	this.shape_3727.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_3727.setTransform(43.8,805.1,0.5,0.5);

	this.shape_3728 = new cjs.Shape();
	this.shape_3728.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_3728.setTransform(682.2,580.2,0.5,0.5);

	this.shape_3729 = new cjs.Shape();
	this.shape_3729.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAagZQAYgZAAgsIAAgag");
	this.shape_3729.setTransform(672,574.4,0.5,0.5);

	this.shape_3730 = new cjs.Shape();
	this.shape_3730.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_3730.setTransform(657.7,571.6,0.5,0.5);

	this.shape_3731 = new cjs.Shape();
	this.shape_3731.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_3731.setTransform(647.6,571.9,0.5,0.5);

	this.shape_3732 = new cjs.Shape();
	this.shape_3732.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_3732.setTransform(640.6,574.3,0.5,0.5);

	this.shape_3733 = new cjs.Shape();
	this.shape_3733.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3733.setTransform(627.3,574.4,0.5,0.5);

	this.shape_3734 = new cjs.Shape();
	this.shape_3734.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_3734.setTransform(617,571.5,0.5,0.5);

	this.shape_3735 = new cjs.Shape();
	this.shape_3735.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACaICjAAIAAAXIijAAIAACjg");
	this.shape_3735.setTransform(608.8,572.1,0.5,0.5);

	this.shape_3736 = new cjs.Shape();
	this.shape_3736.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3736.setTransform(587.2,574.3,0.5,0.5);

	this.shape_3737 = new cjs.Shape();
	this.shape_3737.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3737.setTransform(576.7,571.9,0.5,0.5);

	this.shape_3738 = new cjs.Shape();
	this.shape_3738.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkAMARAKQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3738.setTransform(561.2,574.4,0.5,0.5);

	this.shape_3739 = new cjs.Shape();
	this.shape_3739.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3739.setTransform(551.3,574.3,0.5,0.5);

	this.shape_3740 = new cjs.Shape();
	this.shape_3740.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3740.setTransform(538.2,574.4,0.5,0.5);

	this.shape_3741 = new cjs.Shape();
	this.shape_3741.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AaAcQAZAeAvAAQAYAAAQgEQASgDAbgKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgbglAAQgmABgXAZg");
	this.shape_3741.setTransform(524.9,574.4,0.5,0.5);

	this.shape_3742 = new cjs.Shape();
	this.shape_3742.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAJgFAIgOQAHgKAMgdIAMgkIhnkOIAZAAIA6CYQAdBNAEARIAAAAIAihfIA6iXIAZAAIh4E6QgPAmgKAOQgKANgNAHQgOAHgTAAQgNAAgSgGg");
	this.shape_3742.setTransform(512.1,577.4,0.5,0.5);

	this.shape_3743 = new cjs.Shape();
	this.shape_3743.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgFAIgOQAHgKALgdIAOgkIhokOIAZAAIA5CYQAZBCAJAcIAAAAQAOgqAUg1IA5iXIAaAAIh4E6QgPAngKANQgJANgOAHQgOAHgSAAQgOAAgSgGg");
	this.shape_3743.setTransform(493.7,577.4,0.5,0.5);

	this.shape_3744 = new cjs.Shape();
	this.shape_3744.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3744.setTransform(485,571.5,0.5,0.5);

	this.shape_3745 = new cjs.Shape();
	this.shape_3745.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3745.setTransform(478,574.3,0.5,0.5);

	this.shape_3746 = new cjs.Shape();
	this.shape_3746.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3746.setTransform(465,574.4,0.5,0.5);

	this.shape_3747 = new cjs.Shape();
	this.shape_3747.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AaAcQAZAeAvAAQAYAAAQgEQASgDAbgKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgbglAAQgmABgXAZg");
	this.shape_3747.setTransform(451.7,574.4,0.5,0.5);

	this.shape_3748 = new cjs.Shape();
	this.shape_3748.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3748.setTransform(434,574.3,0.5,0.5);

	this.shape_3749 = new cjs.Shape();
	this.shape_3749.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgEQASgDAbgKIAAAWQgXAKgTAEQgWADgWAAQg5AAghgkgAg3hcQgXAagEAwICmAAQAAgvgUgaQgUgbglAAQgmABgYAZg");
	this.shape_3749.setTransform(421.2,574.4,0.5,0.5);

	this.shape_3750 = new cjs.Shape();
	this.shape_3750.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgZAYgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_3750.setTransform(406.7,571.5,0.5,0.5);

	this.shape_3751 = new cjs.Shape();
	this.shape_3751.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgKAAgMQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_3751.setTransform(385.8,577.3,0.5,0.5);

	this.shape_3752 = new cjs.Shape();
	this.shape_3752.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_3752.setTransform(371.7,574.3,0.5,0.5);

	this.shape_3753 = new cjs.Shape();
	this.shape_3753.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_3753.setTransform(361.2,571.9,0.5,0.5);

	this.shape_3754 = new cjs.Shape();
	this.shape_3754.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3754.setTransform(354.3,574.3,0.5,0.5);

	this.shape_3755 = new cjs.Shape();
	this.shape_3755.graphics.f("#000000").s().p("AhpAnIAAiwIAXAAIAACuQAAApASATQARATAkgBQAvAAAXgYQAXgXAAg5IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_3755.setTransform(340.8,574.5,0.5,0.5);

	this.shape_3756 = new cjs.Shape();
	this.shape_3756.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3756.setTransform(325.4,571.6,0.5,0.5);

	this.shape_3757 = new cjs.Shape();
	this.shape_3757.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBbAAABBjIAACwg");
	this.shape_3757.setTransform(304.1,574.3,0.5,0.5);

	this.shape_3758 = new cjs.Shape();
	this.shape_3758.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhglA2AAQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_3758.setTransform(289.1,574.4,0.5,0.5);

	this.shape_3759 = new cjs.Shape();
	this.shape_3759.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA9AWAdQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_3759.setTransform(274.4,577.3,0.5,0.5);

	this.shape_3760 = new cjs.Shape();
	this.shape_3760.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkgBQAwAAAWgYQAXgXAAg5IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_3760.setTransform(258.8,574.5,0.5,0.5);

	this.shape_3761 = new cjs.Shape();
	this.shape_3761.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAASgEIAAAUQgRAGgYAAQgiAAgRgUg");
	this.shape_3761.setTransform(240.3,572.9,0.5,0.5);

	this.shape_3762 = new cjs.Shape();
	this.shape_3762.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3762.setTransform(233.3,571.5,0.5,0.5);

	this.shape_3763 = new cjs.Shape();
	this.shape_3763.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_3763.setTransform(227.6,571.9,0.5,0.5);

	this.shape_3764 = new cjs.Shape();
	this.shape_3764.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQASATAjgBQAvAAAXgYQAXgYAAg4IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_3764.setTransform(217.1,574.5,0.5,0.5);

	this.shape_3765 = new cjs.Shape();
	this.shape_3765.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgaAWgKQAWgMAdAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_3765.setTransform(202.4,571.6,0.5,0.5);

	this.shape_3766 = new cjs.Shape();
	this.shape_3766.graphics.f("#000000").s().p("AgyDeQBLhlAAh4QAAg9gUg7QgSg5glgtIAcAAQAjArATA6QATA4AABCQAABBgTA5QgTA4gjAqg");
	this.shape_3766.setTransform(184.2,574.1,0.5,0.5);

	this.shape_3767 = new cjs.Shape();
	this.shape_3767.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA2ABQAvgBAcAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAXAAARgEQATgDAagKIAAAWQgXAKgUAEQgVADgVAAQg6AAgigkgAg2hcQgYAbgEAvICmAAQAAgugUgbQgUgbgkAAQgmABgYAZg");
	this.shape_3767.setTransform(173.9,574.4,0.5,0.5);

	this.shape_3768 = new cjs.Shape();
	this.shape_3768.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgTgEgQAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_3768.setTransform(162.8,574.3,0.5,0.5);

	this.shape_3769 = new cjs.Shape();
	this.shape_3769.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAkgBQAvAAAXgYQAWgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgcAqhBAAQhdAAAAhjg");
	this.shape_3769.setTransform(149.4,574.5,0.5,0.5);

	this.shape_3770 = new cjs.Shape();
	this.shape_3770.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3770.setTransform(137.5,572.9,0.5,0.5);

	this.shape_3771 = new cjs.Shape();
	this.shape_3771.graphics.f("#000000").s().p("Ag/BoQgiglABhBQAAhCAigmQAiglA6AAQAjgBAhAMIgHAWQgkgLgaAAQgwAAgaAfQgaAfABA4QgBA3AaAfQAbAfAsAAQAlAAAfgOIAAAYQgaANgpgBQg6ABggglg");
	this.shape_3771.setTransform(127.6,574.4,0.5,0.5);

	this.shape_3772 = new cjs.Shape();
	this.shape_3772.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgEQATgDAagKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgbglAAQgmABgXAZg");
	this.shape_3772.setTransform(114.3,574.4,0.5,0.5);

	this.shape_3773 = new cjs.Shape();
	this.shape_3773.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3773.setTransform(102.8,572.9,0.5,0.5);

	this.shape_3774 = new cjs.Shape();
	this.shape_3774.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_3774.setTransform(95.9,571.9,0.5,0.5);

	this.shape_3775 = new cjs.Shape();
	this.shape_3775.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_3775.setTransform(85.5,571.5,0.5,0.5);

	this.shape_3776 = new cjs.Shape();
	this.shape_3776.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAhgmQAjglA6AAQAkgBAfAMIgGAWQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAlAAAfgOIAAAYQgbANgpgBQg4ABgiglg");
	this.shape_3776.setTransform(72.2,574.4,0.5,0.5);

	this.shape_3777 = new cjs.Shape();
	this.shape_3777.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIADAAQAQgdATgNQASgMAbAAQASAAATAEIgFAXQgTgEgQAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_3777.setTransform(61.8,574.3,0.5,0.5);

	this.shape_3778 = new cjs.Shape();
	this.shape_3778.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3778.setTransform(48.7,574.4,0.5,0.5);

	this.shape_3779 = new cjs.Shape();
	this.shape_3779.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3779.setTransform(634.8,533.3,0.5,0.5);

	this.shape_3780 = new cjs.Shape();
	this.shape_3780.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_3780.setTransform(620.2,536,0.5,0.5);

	this.shape_3781 = new cjs.Shape();
	this.shape_3781.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_3781.setTransform(605.3,536.1,0.5,0.5);

	this.shape_3782 = new cjs.Shape();
	this.shape_3782.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkAMARAKQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3782.setTransform(586.4,536.1,0.5,0.5);

	this.shape_3783 = new cjs.Shape();
	this.shape_3783.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAWgLAjAAQBbAAAABiIAACxg");
	this.shape_3783.setTransform(573.1,533.2,0.5,0.5);

	this.shape_3784 = new cjs.Shape();
	this.shape_3784.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkABBEQgBBCgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3784.setTransform(558.3,539.1,0.5,0.5);

	this.shape_3785 = new cjs.Shape();
	this.shape_3785.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAJgFAJgOQAHgLALgcIAOgkIhokOIAZAAIA5CYQAbBFAHAZIAAAAIAihfIA5iXIAaAAIh5E6QgNAkgLAQQgJANgPAHQgNAHgSAAQgOAAgSgGg");
	this.shape_3785.setTransform(544.5,539.2,0.5,0.5);

	this.shape_3786 = new cjs.Shape();
	this.shape_3786.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3786.setTransform(535.7,533.2,0.5,0.5);

	this.shape_3787 = new cjs.Shape();
	this.shape_3787.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgKAAgMQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_3787.setTransform(526.2,539.1,0.5,0.5);

	this.shape_3788 = new cjs.Shape();
	this.shape_3788.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAhgkQAfgmA4ABQA4AAAfAlQAgAmAABAQAABDggAkQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_3788.setTransform(512,536.1,0.5,0.5);

	this.shape_3789 = new cjs.Shape();
	this.shape_3789.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgSgEgRAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_3789.setTransform(500.5,536,0.5,0.5);

	this.shape_3790 = new cjs.Shape();
	this.shape_3790.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3790.setTransform(490.2,534.6,0.5,0.5);

	this.shape_3791 = new cjs.Shape();
	this.shape_3791.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA1ABQAwgBAcAiQAbAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAZAAAQgEQASgDAbgKIAAAWQgWAKgVAEQgUADgXAAQg5AAgigkgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgbgkAAQgmABgXAZg");
	this.shape_3791.setTransform(479.1,536.1,0.5,0.5);

	this.shape_3792 = new cjs.Shape();
	this.shape_3792.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA9AWAdQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_3792.setTransform(464.9,539.1,0.5,0.5);

	this.shape_3793 = new cjs.Shape();
	this.shape_3793.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgSA+gYA4g");
	this.shape_3793.setTransform(447.2,543.1,0.5,0.5);

	this.shape_3794 = new cjs.Shape();
	this.shape_3794.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARAMAIAMQAIAOAAASQAAAlgcATQgbAUgygBQg2AAgggRg");
	this.shape_3794.setTransform(438.8,536.1,0.5,0.5);

	this.shape_3795 = new cjs.Shape();
	this.shape_3795.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA3AaAdQAZAeAvAAQAYAAAQgEQASgDAbgKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgbglAAQgmABgXAZg");
	this.shape_3795.setTransform(426,536.1,0.5,0.5);

	this.shape_3796 = new cjs.Shape();
	this.shape_3796.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_3796.setTransform(411.8,539.1,0.5,0.5);

	this.shape_3797 = new cjs.Shape();
	this.shape_3797.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3797.setTransform(396.6,536.1,0.5,0.5);

	this.shape_3798 = new cjs.Shape();
	this.shape_3798.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAjgBAgAMIgGAWQgkgLgZAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgOIAAAYQgaANgqgBQg5ABghglg");
	this.shape_3798.setTransform(384.5,536.1,0.5,0.5);

	this.shape_3799 = new cjs.Shape();
	this.shape_3799.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgJgOAAgTQAAgeAagSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUALAAATQAAAWAPAMQAPAMArARQAlAMARAKQARAMAIAMQAIAOAAASQAAAlgcATQgbAUgygBQg2AAgggRg");
	this.shape_3799.setTransform(372.1,536.1,0.5,0.5);

	this.shape_3800 = new cjs.Shape();
	this.shape_3800.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3800.setTransform(358.3,533.3,0.5,0.5);

	this.shape_3801 = new cjs.Shape();
	this.shape_3801.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvgBgXAZQgXAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_3801.setTransform(343.7,536,0.5,0.5);

	this.shape_3802 = new cjs.Shape();
	this.shape_3802.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3802.setTransform(328.9,536.1,0.5,0.5);

	this.shape_3803 = new cjs.Shape();
	this.shape_3803.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3803.setTransform(319.7,533.2,0.5,0.5);

	this.shape_3804 = new cjs.Shape();
	this.shape_3804.graphics.f("#000000").s().p("AAYDeQgkgpgTg6QgUg5AAhAQAAhAAUg7QATg6AkgqIAcAAQgmAtgSA5QgTA6gBA+QABB5BKBkg");
	this.shape_3804.setTransform(313.5,535.8,0.5,0.5);

	this.shape_3805 = new cjs.Shape();
	this.shape_3805.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgEQATgDAagKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgbglAAQgmABgXAZg");
	this.shape_3805.setTransform(296.2,536.1,0.5,0.5);

	this.shape_3806 = new cjs.Shape();
	this.shape_3806.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3806.setTransform(285.2,536,0.5,0.5);

	this.shape_3807 = new cjs.Shape();
	this.shape_3807.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkgBQAwAAAWgYQAXgXAAg5IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_3807.setTransform(271.7,536.3,0.5,0.5);

	this.shape_3808 = new cjs.Shape();
	this.shape_3808.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_3808.setTransform(259.8,534.6,0.5,0.5);

	this.shape_3809 = new cjs.Shape();
	this.shape_3809.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_3809.setTransform(248.5,536.1,0.5,0.5);

	this.shape_3810 = new cjs.Shape();
	this.shape_3810.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIABAAQAagqBDAAQBdAAAABjIAACwg");
	this.shape_3810.setTransform(234.8,536,0.5,0.5);

	this.shape_3811 = new cjs.Shape();
	this.shape_3811.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_3811.setTransform(213.1,533.2,0.5,0.5);

	this.shape_3812 = new cjs.Shape();
	this.shape_3812.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_3812.setTransform(201.1,534.6,0.5,0.5);

	this.shape_3813 = new cjs.Shape();
	this.shape_3813.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAGAAAMQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_3813.setTransform(194.1,533.7,0.5,0.5);

	this.shape_3814 = new cjs.Shape();
	this.shape_3814.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA3AFAeIABAAQAQg+AGgPIA4ilIAVAAIA1ClQATBAADAMIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_3814.setTransform(182,536.1,0.5,0.5);

	this.shape_3815 = new cjs.Shape();
	this.shape_3815.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBcAAgBBjIAACwg");
	this.shape_3815.setTransform(158.7,536,0.5,0.5);

	this.shape_3816 = new cjs.Shape();
	this.shape_3816.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3816.setTransform(143.6,536.1,0.5,0.5);

	this.shape_3817 = new cjs.Shape();
	this.shape_3817.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3817.setTransform(133.3,533.7,0.5,0.5);

	this.shape_3818 = new cjs.Shape();
	this.shape_3818.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_3818.setTransform(125.9,534.6,0.5,0.5);

	this.shape_3819 = new cjs.Shape();
	this.shape_3819.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_3819.setTransform(114.6,536.1,0.5,0.5);

	this.shape_3820 = new cjs.Shape();
	this.shape_3820.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAZgqBDAAQBdAAAABjIAACwg");
	this.shape_3820.setTransform(100.9,536,0.5,0.5);

	this.shape_3821 = new cjs.Shape();
	this.shape_3821.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_3821.setTransform(90.4,533.7,0.5,0.5);

	this.shape_3822 = new cjs.Shape();
	this.shape_3822.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQAAhCAjgmQAiglA6AAQAjgBAhAMIgHAWQglgLgZAAQgxAAgZAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAlAAAfgOIAAAYQgbANgogBQg6ABggglg");
	this.shape_3822.setTransform(81.8,536.1,0.5,0.5);

	this.shape_3823 = new cjs.Shape();
	this.shape_3823.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgRgJgIgOQgIgOAAgTQgBgeAagSQAagRAtAAQArAAAoAQIgJAWQgogQgiAAQghAAgTALQgTALAAATQAAAWAOAMQAPANAsAQQAkAMARAKQAQALAJANQAIAOAAASQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3823.setTransform(69.4,536.1,0.5,0.5);

	this.shape_3824 = new cjs.Shape();
	this.shape_3824.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3824.setTransform(56.3,536.1,0.5,0.5);

	this.shape_3825 = new cjs.Shape();
	this.shape_3825.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_3825.setTransform(47.1,533.1,0.5,0.5);

	this.shape_3826 = new cjs.Shape();
	this.shape_3826.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3826.setTransform(671,497.8,0.5,0.5);

	this.shape_3827 = new cjs.Shape();
	this.shape_3827.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA1ABQAwgBAbAiQAcAhAAA6IAAATIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgEQASgDAagKIAAAWQgWAKgUAEQgUADgWAAQg6AAghgkgAg3hcQgXAagEAwICmAAQAAgvgVgaQgTgbglAAQgmABgYAZg");
	this.shape_3827.setTransform(658.2,497.9,0.5,0.5);

	this.shape_3828 = new cjs.Shape();
	this.shape_3828.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_3828.setTransform(643.7,495,0.5,0.5);

	this.shape_3829 = new cjs.Shape();
	this.shape_3829.graphics.f("#000000").s().p("ACdCKIAAixQAAgogPgRQgQgTggABQgqAAgTAWQgUAWAAAyIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAmIACAAQALgUAVgMQAUgLAZAAQBAAAASAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_3829.setTransform(618.3,497.8,0.5,0.5);

	this.shape_3830 = new cjs.Shape();
	this.shape_3830.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAhgmA3ABQA3AAAgAlQAgAlAABBQAABDggAkQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_3830.setTransform(599.5,497.9,0.5,0.5);

	this.shape_3831 = new cjs.Shape();
	this.shape_3831.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_3831.setTransform(587.9,497.8,0.5,0.5);

	this.shape_3832 = new cjs.Shape();
	this.shape_3832.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgTgGgVAAQgcAAgMARQgMARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_3832.setTransform(579.1,494.9,0.5,0.5);

	this.shape_3833 = new cjs.Shape();
	this.shape_3833.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3833.setTransform(559.8,495.1,0.5,0.5);

	this.shape_3834 = new cjs.Shape();
	this.shape_3834.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgoQAhgnA1ABQAvgBAcAiQAbAgAAA7IAAATIjBAAQABA3AZAdQAZAeAvAAQAXAAARgEQATgDAagKIAAAWQgYAKgSAEQgWADgVAAQg6AAghgkgAg3hcQgXAagEAwICmAAQAAgugUgbQgUgbgkAAQgmABgZAZg");
	this.shape_3834.setTransform(545.7,497.9,0.5,0.5);

	this.shape_3835 = new cjs.Shape();
	this.shape_3835.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggABQgpAAgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgTAZAAA2IAACVIgZAAIAAkOIAUAAIAGAmIABAAQAMgUAUgMQAUgLAaAAQBAAAARAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_3835.setTransform(527.5,497.8,0.5,0.5);

	this.shape_3836 = new cjs.Shape();
	this.shape_3836.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggABQgqAAgTAWQgUAWAAAyIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_3836.setTransform(505,497.8,0.5,0.5);

	this.shape_3837 = new cjs.Shape();
	this.shape_3837.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjCAAQABA4AaAcQAZAeAvAAQAYAAAQgEQASgDAbgKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglAAQgmABgXAZg");
	this.shape_3837.setTransform(486.6,497.9,0.5,0.5);

	this.shape_3838 = new cjs.Shape();
	this.shape_3838.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_3838.setTransform(475.2,496.4,0.5,0.5);

	this.shape_3839 = new cjs.Shape();
	this.shape_3839.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQAsAAAnAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAlgbATQgcAUgygBQg2AAgggRg");
	this.shape_3839.setTransform(465.1,497.9,0.5,0.5);

	this.shape_3840 = new cjs.Shape();
	this.shape_3840.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3840.setTransform(446.6,497.9,0.5,0.5);

	this.shape_3841 = new cjs.Shape();
	this.shape_3841.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3841.setTransform(437.9,495.4,0.5,0.5);

	this.shape_3842 = new cjs.Shape();
	this.shape_3842.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgZAXgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_3842.setTransform(427.5,495,0.5,0.5);

	this.shape_3843 = new cjs.Shape();
	this.shape_3843.graphics.f("#000000").s().p("AgMC2IAAlUIh2AAIAAgXIEFAAIAAAXIh2AAIAAFUg");
	this.shape_3843.setTransform(413.2,495.6,0.5,0.5);

	this.shape_3844 = new cjs.Shape();
	this.shape_3844.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAZgUgBQgTABAAgZg");
	this.shape_3844.setTransform(396.9,503.7,0.5,0.5);

	this.shape_3845 = new cjs.Shape();
	this.shape_3845.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqByIBzCcg");
	this.shape_3845.setTransform(388.8,495,0.5,0.5);

	this.shape_3846 = new cjs.Shape();
	this.shape_3846.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAASAEIgEAXQgSgEgRAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_3846.setTransform(377.5,497.8,0.5,0.5);

	this.shape_3847 = new cjs.Shape();
	this.shape_3847.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhBAhglQAggmA2ABQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgYgfgtAAQgtAAgXAfg");
	this.shape_3847.setTransform(364.1,497.9,0.5,0.5);

	this.shape_3848 = new cjs.Shape();
	this.shape_3848.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA4AFAdIABAAQAQg+AGgPIA4ilIAVAAIA1ClQASA4AEAUIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_3848.setTransform(347.4,497.9,0.5,0.5);

	this.shape_3849 = new cjs.Shape();
	this.shape_3849.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_3849.setTransform(327.5,497.8,0.5,0.5);

	this.shape_3850 = new cjs.Shape();
	this.shape_3850.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA6IAAATIjDAAQABA3AaAdQAZAeAvAAQAXAAASgEQASgDAagKIAAAWQgYAKgSAEQgVADgWAAQg6AAghgkgAg3hcQgYAbgDAvICnAAQgBgugUgbQgUgbglAAQgmABgYAZg");
	this.shape_3850.setTransform(314.7,497.9,0.5,0.5);

	this.shape_3851 = new cjs.Shape();
	this.shape_3851.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAWgLAjAAQBcAAgBBiIAACxg");
	this.shape_3851.setTransform(300.2,495,0.5,0.5);

	this.shape_3852 = new cjs.Shape();
	this.shape_3852.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_3852.setTransform(278.6,497.8,0.5,0.5);

	this.shape_3853 = new cjs.Shape();
	this.shape_3853.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3853.setTransform(268.1,495.4,0.5,0.5);

	this.shape_3854 = new cjs.Shape();
	this.shape_3854.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjCAAQABA3AZAdQAaAeAvAAQAYAAAQgEQATgDAagKIAAAWQgYAKgTAEQgVADgVAAQg6AAghgkgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglAAQgmABgXAZg");
	this.shape_3854.setTransform(251.6,497.9,0.5,0.5);

	this.shape_3855 = new cjs.Shape();
	this.shape_3855.graphics.f("#000000").s().p("AgMCHIhokOIAZAAIBGC4QAOAkAHAaIABAAQAKgjALgcIBGi3IAZAAIhpEOg");
	this.shape_3855.setTransform(238.7,497.9,0.5,0.5);

	this.shape_3856 = new cjs.Shape();
	this.shape_3856.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3856.setTransform(230,495.4,0.5,0.5);

	this.shape_3857 = new cjs.Shape();
	this.shape_3857.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_3857.setTransform(222.7,496.4,0.5,0.5);

	this.shape_3858 = new cjs.Shape();
	this.shape_3858.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3858.setTransform(211.4,497.9,0.5,0.5);

	this.shape_3859 = new cjs.Shape();
	this.shape_3859.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3859.setTransform(201,497.8,0.5,0.5);

	this.shape_3860 = new cjs.Shape();
	this.shape_3860.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3860.setTransform(191.1,497.8,0.5,0.5);

	this.shape_3861 = new cjs.Shape();
	this.shape_3861.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3861.setTransform(178,497.9,0.5,0.5);

	this.shape_3862 = new cjs.Shape();
	this.shape_3862.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_3862.setTransform(164.3,497.8,0.5,0.5);

	this.shape_3863 = new cjs.Shape();
	this.shape_3863.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAbAhABA6IAAATIjDAAQABA3AZAdQAaAeAuAAQAYAAASgEQASgDAagKIAAAWQgXAKgTAEQgWADgWAAQg5AAghgkgAg3hcQgXAbgEAvICnAAQAAgugVgbQgUgbglAAQgmABgYAZg");
	this.shape_3863.setTransform(143.1,497.9,0.5,0.5);

	this.shape_3864 = new cjs.Shape();
	this.shape_3864.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAASAEIgEAXQgSgEgRAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_3864.setTransform(132,497.8,0.5,0.5);

	this.shape_3865 = new cjs.Shape();
	this.shape_3865.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAFAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_3865.setTransform(123.3,495.4,0.5,0.5);

	this.shape_3866 = new cjs.Shape();
	this.shape_3866.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_3866.setTransform(113.2,500.8,0.5,0.5);

	this.shape_3867 = new cjs.Shape();
	this.shape_3867.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgNAAgUQgBgeAagSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTALAAATQgBAWAPAMQAPANArAQQAjAMATAKQARAMAIAMQAIANAAATQAAAlgbATQgcAUgygBQg3AAgfgRg");
	this.shape_3867.setTransform(99.2,497.9,0.5,0.5);

	this.shape_3868 = new cjs.Shape();
	this.shape_3868.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_3868.setTransform(85.9,497.8,0.5,0.5);

	this.shape_3869 = new cjs.Shape();
	this.shape_3869.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3869.setTransform(75.4,495.4,0.5,0.5);

	this.shape_3870 = new cjs.Shape();
	this.shape_3870.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhBAhglQAggmA2ABQA5AAAfAlQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgYgfgtAAQgtAAgXAfg");
	this.shape_3870.setTransform(58.4,497.9,0.5,0.5);

	this.shape_3871 = new cjs.Shape();
	this.shape_3871.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3871.setTransform(46.5,496.4,0.5,0.5);

	this.shape_3872 = new cjs.Shape();
	this.shape_3872.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgFAIgOQAHgLALgcIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgQAngJANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_3872.setTransform(664.3,462.7,0.5,0.5);

	this.shape_3873 = new cjs.Shape();
	this.shape_3873.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3873.setTransform(651.2,459.6,0.5,0.5);

	this.shape_3874 = new cjs.Shape();
	this.shape_3874.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA4AFAdIABAAQAQg+AGgPIA3ilIAWAAIA1ClQATA9ADAPIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_3874.setTransform(635.7,459.6,0.5,0.5);

	this.shape_3875 = new cjs.Shape();
	this.shape_3875.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3875.setTransform(612.7,459.6,0.5,0.5);

	this.shape_3876 = new cjs.Shape();
	this.shape_3876.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgngOgRgLQgRgKgIgNQgIgNAAgUQgBgeAagSQAagRAtAAQArAAAoAQIgJAWQgogQgiAAQghAAgTALQgTALAAATQgBAWAPAMQAQANAqAQQAjAMATAKQAQALAJANQAIANAAATQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3876.setTransform(593.7,459.6,0.5,0.5);

	this.shape_3877 = new cjs.Shape();
	this.shape_3877.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3877.setTransform(580.6,459.6,0.5,0.5);

	this.shape_3878 = new cjs.Shape();
	this.shape_3878.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA6IAAATIjBAAQAAA3AaAdQAZAeAvAAQAXAAARgEQAUgDAYgKIAAAWQgWAKgTAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAvICmAAQAAgugUgbQgVgbgjAAQgmABgZAZg");
	this.shape_3878.setTransform(560.7,459.6,0.5,0.5);

	this.shape_3879 = new cjs.Shape();
	this.shape_3879.graphics.f("#000000").s().p("AhABoQggglgBhBQAAhCAjgmQAiglA6AAQAkgBAfAMIgHAXQgjgMgZAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAggNIAAAXQgcAMgpAAQg5ABghglg");
	this.shape_3879.setTransform(548,459.6,0.5,0.5);

	this.shape_3880 = new cjs.Shape();
	this.shape_3880.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3880.setTransform(534.4,459.6,0.5,0.5);

	this.shape_3881 = new cjs.Shape();
	this.shape_3881.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAdAkAABEQgBBBgeAmQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhCiWQgXAZAAA8IAAAIQAAA+AWAcQAVAbAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_3881.setTransform(520.9,462.6,0.5,0.5);

	this.shape_3882 = new cjs.Shape();
	this.shape_3882.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3882.setTransform(506.9,459.6,0.5,0.5);

	this.shape_3883 = new cjs.Shape();
	this.shape_3883.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA6IAAATIjCAAQAAA3AaAdQAZAeAvAAQAYAAAQgEQATgDAZgKIAAAWQgWAKgTAEQgWAEgVgBQg6AAghgkgAg3hcQgYAbgDAvICnAAQgBgugUgbQgVgbgkAAQgmABgYAZg");
	this.shape_3883.setTransform(487.4,459.6,0.5,0.5);

	this.shape_3884 = new cjs.Shape();
	this.shape_3884.graphics.f("#000000").s().p("AgMCHIhokOIAZAAIBGC4QAPAkAGAaIABAAQAKgkAKgbIBHi3IAZAAIhpEOg");
	this.shape_3884.setTransform(474.6,459.6,0.5,0.5);

	this.shape_3885 = new cjs.Shape();
	this.shape_3885.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAFAAAMQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_3885.setTransform(465.9,457.2,0.5,0.5);

	this.shape_3886 = new cjs.Shape();
	this.shape_3886.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3886.setTransform(458.5,458.1,0.5,0.5);

	this.shape_3887 = new cjs.Shape();
	this.shape_3887.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3887.setTransform(447.2,459.6,0.5,0.5);

	this.shape_3888 = new cjs.Shape();
	this.shape_3888.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAdgHQgMgFgHgKQgHgKAAgMQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigTgSQgRgRghAAQghAAgSATg");
	this.shape_3888.setTransform(434.3,462.6,0.5,0.5);

	this.shape_3889 = new cjs.Shape();
	this.shape_3889.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgnA2ABQAvgBAcAiQAbAhAAA6IAAATIjCAAQABA3AZAdQAaAeAuAAQAZAAAQgEQAUgDAZgKIAAAWQgXAKgUAEQgUAEgXgBQg5AAgigkgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgbgjAAQgnABgXAZg");
	this.shape_3889.setTransform(420.6,459.6,0.5,0.5);

	this.shape_3890 = new cjs.Shape();
	this.shape_3890.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_3890.setTransform(406.1,459.5,0.5,0.5);

	this.shape_3891 = new cjs.Shape();
	this.shape_3891.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3891.setTransform(383.9,456.8,0.5,0.5);

	this.shape_3892 = new cjs.Shape();
	this.shape_3892.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjCAAQABA3AZAdQAaAeAvAAQAYAAAQgEQATgDAagKIAAAWQgYAKgTAEQgVAEgVgBQg7AAgggkgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglAAQgmABgXAZg");
	this.shape_3892.setTransform(369.7,459.6,0.5,0.5);

	this.shape_3893 = new cjs.Shape();
	this.shape_3893.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgngOgRgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAagRAsAAQAsAAAnAQIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQARAMAIAMQAIANAAATQAAAlgbATQgcAUgygBQg3AAgfgRg");
	this.shape_3893.setTransform(356.7,459.6,0.5,0.5);

	this.shape_3894 = new cjs.Shape();
	this.shape_3894.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkgBQAwABAWgZQAYgZAAg3IAAiUIAXAAIAAEOIgUAAIgFglIgBAAQgbAqhCAAQhdAAABhjg");
	this.shape_3894.setTransform(343.3,459.8,0.5,0.5);

	this.shape_3895 = new cjs.Shape();
	this.shape_3895.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA6IAAATIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgEQASgDAbgKIAAAWQgXAKgUAEQgVAEgWgBQg5AAgigkgAg3hcQgXAagEAwICmAAQAAgvgUgaQgUgbglAAQglABgZAZg");
	this.shape_3895.setTransform(322.2,459.6,0.5,0.5);

	this.shape_3896 = new cjs.Shape();
	this.shape_3896.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgZAXgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_3896.setTransform(307.8,456.7,0.5,0.5);

	this.shape_3897 = new cjs.Shape();
	this.shape_3897.graphics.f("#000000").s().p("AhvCsIAAgZQAmARA+AAQArAAAbgVQAagVAAghQAAgUgIgOQgJgNgUgMQgTgLgmgNQg4gSgVgWQgVgXAAglQAAgoAggaQAggaAxAAQA0AAAtATIgKAWQgtgTgpAAQgoAAgXATQgYATAAAgQAAAUAHANQAIANAQAKQATALAlAOQAsAOAUANQAVAOALASQAJARAAAZQAAAughAaQghAbg3AAQhDAAgjgPg");
	this.shape_3897.setTransform(293.3,457.3,0.5,0.5);

	this.shape_3898 = new cjs.Shape();
	this.shape_3898.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAZgUgBQgTABAAgZg");
	this.shape_3898.setTransform(276.6,465.4,0.5,0.5);

	this.shape_3899 = new cjs.Shape();
	this.shape_3899.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQAsAAAnAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAlgbATQgcAUgygBQg2AAgggRg");
	this.shape_3899.setTransform(267.5,459.6,0.5,0.5);

	this.shape_3900 = new cjs.Shape();
	this.shape_3900.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQgBgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQgBgaAkgUQgYgKgNgVQgOgVAAgbQAAgnAagaQAZgYAtAAQAaAAAOAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgiAXQgkAXg+AAQg0AAgbgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgQgLQgSgLglAAIgrAAQhKAAAAA6gAg5igQgSATAAAgQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgTgRQgSgRggAAQghAAgTATg");
	this.shape_3900.setTransform(255.1,462.6,0.5,0.5);

	this.shape_3901 = new cjs.Shape();
	this.shape_3901.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_3901.setTransform(240.9,459.5,0.5,0.5);

	this.shape_3902 = new cjs.Shape();
	this.shape_3902.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAHQAFAFAAAMQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_3902.setTransform(230.5,457.2,0.5,0.5);

	this.shape_3903 = new cjs.Shape();
	this.shape_3903.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3903.setTransform(223.1,458.1,0.5,0.5);

	this.shape_3904 = new cjs.Shape();
	this.shape_3904.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3904.setTransform(214.6,458.1,0.5,0.5);

	this.shape_3905 = new cjs.Shape();
	this.shape_3905.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgnQAfgnA1ABQAxgBAbAiQAcAhAAA6IAAATIjCAAQAAA3AaAdQAZAeAvAAQAYAAAQgEQATgDAZgKIAAAWQgWAKgTAEQgVAEgWgBQg6AAghgkgAg3hcQgYAbgDAvICnAAQgBgugUgbQgUgbglAAQgmABgYAZg");
	this.shape_3905.setTransform(203.5,459.6,0.5,0.5);

	this.shape_3906 = new cjs.Shape();
	this.shape_3906.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgRgJgIgOQgIgNAAgUQgBgeAagSQAagRAtAAQArAAAoAQIgJAWQgogQgiAAQghAAgTALQgTALAAATQAAAWAOAMQAQANArAQQAjAMASAKQAQALAJANQAIAOAAASQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3906.setTransform(190.5,459.6,0.5,0.5);

	this.shape_3907 = new cjs.Shape();
	this.shape_3907.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3907.setTransform(171.9,459.6,0.5,0.5);

	this.shape_3908 = new cjs.Shape();
	this.shape_3908.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkgBQAwABAWgZQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAAAhjg");
	this.shape_3908.setTransform(158.5,459.8,0.5,0.5);

	this.shape_3909 = new cjs.Shape();
	this.shape_3909.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3909.setTransform(143.6,459.6,0.5,0.5);

	this.shape_3910 = new cjs.Shape();
	this.shape_3910.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3910.setTransform(132,459.5,0.5,0.5);

	this.shape_3911 = new cjs.Shape();
	this.shape_3911.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAwgBAcAiQAcAhAAA6IAAATIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgEQASgDAbgKIAAAWQgXAKgTAEQgWAEgWgBQg5AAghgkgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgbgkAAQgmABgYAZg");
	this.shape_3911.setTransform(119.2,459.6,0.5,0.5);

	this.shape_3912 = new cjs.Shape();
	this.shape_3912.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_3912.setTransform(104.8,459.5,0.5,0.5);

	this.shape_3913 = new cjs.Shape();
	this.shape_3913.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgnA1ABQAvgBAcAiQAcAggBA7IAAATIjBAAQABA3AYAdQAaAeAvAAQAXAAARgEQATgDAagKIAAAWQgXAKgUAEQgUAEgWgBQg6AAgigkgAg2hcQgZAbgDAvICmAAQAAgugUgbQgUgbgkAAQgmABgYAZg");
	this.shape_3913.setTransform(90.2,459.6,0.5,0.5);

	this.shape_3914 = new cjs.Shape();
	this.shape_3914.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAbAAAiQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_3914.setTransform(76.5,462.6,0.5,0.5);

	this.shape_3915 = new cjs.Shape();
	this.shape_3915.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_3915.setTransform(55.8,459.5,0.5,0.5);

	this.shape_3916 = new cjs.Shape();
	this.shape_3916.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3916.setTransform(45.3,457.2,0.5,0.5);

	this.shape_3917 = new cjs.Shape();
	this.shape_3917.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgQgOQgSgNglgOQgogOgQgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAbgRArAAQAtAAAnAQIgJAWQgogQgjAAQggAAgTALQgUALAAATQAAAWAPAMQAPANArAQQAjAMATAKQARAMAIAMQAIANAAATQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3917.setTransform(646.6,421.4,0.5,0.5);

	this.shape_3918 = new cjs.Shape();
	this.shape_3918.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3918.setTransform(632.8,418.6,0.5,0.5);

	this.shape_3919 = new cjs.Shape();
	this.shape_3919.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_3919.setTransform(618.4,421.4,0.5,0.5);

	this.shape_3920 = new cjs.Shape();
	this.shape_3920.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgnQAfgnA1ABQAwgBAcAiQAcAhAAA6IAAATIjDAAQABA3AZAdQAaAeAuAAQAZAAARgEQASgDAagKIAAAWQgXAKgUAEQgVAEgWgBQg5AAgigkgAg2hcQgZAbgDAvICmAAQABgugVgbQgUgbglAAQgmABgXAZg");
	this.shape_3920.setTransform(605.1,421.4,0.5,0.5);

	this.shape_3921 = new cjs.Shape();
	this.shape_3921.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgQAAIAAmCIAZAAIgCCfIACAAQAPgZAWgLQAWgMAeAAQA5AAAdAkQAdAkAABDQgBBEgeAkQgeAlg2AAQgdAAgXgMgAhEgiQgVAbAAA+IAAAFQAAA9AWAbQAVAaAuAAQAsAAAVgfQAXgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_3921.setTransform(590.9,418.6,0.5,0.5);

	this.shape_3922 = new cjs.Shape();
	this.shape_3922.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3922.setTransform(568.3,418.6,0.5,0.5);

	this.shape_3923 = new cjs.Shape();
	this.shape_3923.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSglAAQgvgBgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIABAAQAagrBDAAQBcAAABBjIAACwg");
	this.shape_3923.setTransform(553.7,421.3,0.5,0.5);

	this.shape_3924 = new cjs.Shape();
	this.shape_3924.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_3924.setTransform(538.8,421.4,0.5,0.5);

	this.shape_3925 = new cjs.Shape();
	this.shape_3925.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgogOgQgLQgQgJgJgOQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgngQgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARAMAIAMQAIAOAAASQAAAkgbAUQgcAUgygBQg2AAgggRg");
	this.shape_3925.setTransform(519.9,421.4,0.5,0.5);

	this.shape_3926 = new cjs.Shape();
	this.shape_3926.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3926.setTransform(511.2,418.5,0.5,0.5);

	this.shape_3927 = new cjs.Shape();
	this.shape_3927.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAGAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_3927.setTransform(505.4,418.9,0.5,0.5);

	this.shape_3928 = new cjs.Shape();
	this.shape_3928.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgPgNgngOQgogOgQgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAagRAsAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUALAAATQAAAWAPAMQAPANArAQQAlAMARAKQARAMAIAMQAIAOAAASQAAAlgcATQgbAUgygBQg2AAgggRg");
	this.shape_3928.setTransform(496.5,421.4,0.5,0.5);

	this.shape_3929 = new cjs.Shape();
	this.shape_3929.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgpgOgPgLQgRgKgIgNQgJgNABgUQAAgeAZgSQAagRAsAAQAtAAAnAQIgJAWQgogQgjAAQggAAgTALQgTALgBATQAAAWAQAMQAOANAsAQQAiAMATAKQARAMAIAMQAIANAAATQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3929.setTransform(484.6,421.4,0.5,0.5);

	this.shape_3930 = new cjs.Shape();
	this.shape_3930.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AZAfQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3930.setTransform(471.3,421.4,0.5,0.5);

	this.shape_3931 = new cjs.Shape();
	this.shape_3931.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_3931.setTransform(460.9,418.4,0.5,0.5);

	this.shape_3932 = new cjs.Shape();
	this.shape_3932.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgTBCgXA0g");
	this.shape_3932.setTransform(446.4,428.3,0.5,0.5);

	this.shape_3933 = new cjs.Shape();
	this.shape_3933.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3933.setTransform(441.2,418.5,0.5,0.5);

	this.shape_3934 = new cjs.Shape();
	this.shape_3934.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3934.setTransform(431.1,421.4,0.5,0.5);

	this.shape_3935 = new cjs.Shape();
	this.shape_3935.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3935.setTransform(420.7,421.3,0.5,0.5);

	this.shape_3936 = new cjs.Shape();
	this.shape_3936.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAhgmA3ABQA3AAAgAlQAgAlAABBQAABDggAkQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAeQAZAgArAAQAtAAAYggQAZgfAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_3936.setTransform(407.4,421.4,0.5,0.5);

	this.shape_3937 = new cjs.Shape();
	this.shape_3937.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAjgBAgAMIgGAXQgkgMgZAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgaAMgqAAQg5ABghglg");
	this.shape_3937.setTransform(394.2,421.4,0.5,0.5);

	this.shape_3938 = new cjs.Shape();
	this.shape_3938.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAhgmA3ABQA3AAAgAlQAgAlAABBQAABDggAkQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAeQAZAgArAAQAtAAAYggQAZgeAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_3938.setTransform(373.7,421.4,0.5,0.5);

	this.shape_3939 = new cjs.Shape();
	this.shape_3939.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_3939.setTransform(361.8,419.9,0.5,0.5);

	this.shape_3940 = new cjs.Shape();
	this.shape_3940.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkAAQgvgBgYAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_3940.setTransform(343.6,421.3,0.5,0.5);

	this.shape_3941 = new cjs.Shape();
	this.shape_3941.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAhgmA3ABQA3AAAgAlQAgAlAABBQAABDggAkQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAeQAZAgArAAQAtAAAYggQAZgeAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_3941.setTransform(328.6,421.4,0.5,0.5);

	this.shape_3942 = new cjs.Shape();
	this.shape_3942.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAFAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_3942.setTransform(318.2,418.9,0.5,0.5);

	this.shape_3943 = new cjs.Shape();
	this.shape_3943.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3943.setTransform(310.9,419.9,0.5,0.5);

	this.shape_3944 = new cjs.Shape();
	this.shape_3944.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3944.setTransform(303.9,418.9,0.5,0.5);

	this.shape_3945 = new cjs.Shape();
	this.shape_3945.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3945.setTransform(293,418.6,0.5,0.5);

	this.shape_3946 = new cjs.Shape();
	this.shape_3946.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_3946.setTransform(277.9,418.6,0.5,0.5);

	this.shape_3947 = new cjs.Shape();
	this.shape_3947.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3947.setTransform(263.5,421.4,0.5,0.5);

	this.shape_3948 = new cjs.Shape();
	this.shape_3948.graphics.f("#000000").s().p("ABSCKIAAivQAAgngRgUQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_3948.setTransform(243.1,421.3,0.5,0.5);

	this.shape_3949 = new cjs.Shape();
	this.shape_3949.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAHQAFAFAAAMQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_3949.setTransform(232.6,418.9,0.5,0.5);

	this.shape_3950 = new cjs.Shape();
	this.shape_3950.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_3950.setTransform(220.2,418.5,0.5,0.5);

	this.shape_3951 = new cjs.Shape();
	this.shape_3951.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3951.setTransform(210.1,421.4,0.5,0.5);

	this.shape_3952 = new cjs.Shape();
	this.shape_3952.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_3952.setTransform(196.6,424.3,0.5,0.5);

	this.shape_3953 = new cjs.Shape();
	this.shape_3953.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AZAfQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3953.setTransform(181.2,421.4,0.5,0.5);

	this.shape_3954 = new cjs.Shape();
	this.shape_3954.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAWAMAPAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgHgpIgCAAQgeAug6AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAUgbAAg9IAAgFQAAg+gUgbQgVgbgwAAQgrAAgWAfg");
	this.shape_3954.setTransform(159.1,418.6,0.5,0.5);

	this.shape_3955 = new cjs.Shape();
	this.shape_3955.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_3955.setTransform(144.5,421.3,0.5,0.5);

	this.shape_3956 = new cjs.Shape();
	this.shape_3956.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3956.setTransform(129.7,421.4,0.5,0.5);

	this.shape_3957 = new cjs.Shape();
	this.shape_3957.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_3957.setTransform(112.3,419.9,0.5,0.5);

	this.shape_3958 = new cjs.Shape();
	this.shape_3958.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgnA1ABQAxgBAbAiQAbAhABA6IAAATIjDAAQABA3AaAdQAZAeAuAAQAYAAASgEQASgDAagKIAAAWQgXAKgTAEQgWAEgWgBQg5AAghgkgAg3hcQgXAbgEAvICnAAQAAgugVgbQgUgbglAAQgmABgYAZg");
	this.shape_3958.setTransform(101.2,421.4,0.5,0.5);

	this.shape_3959 = new cjs.Shape();
	this.shape_3959.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_3959.setTransform(86.8,421.3,0.5,0.5);

	this.shape_3960 = new cjs.Shape();
	this.shape_3960.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgSgEgRAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_3960.setTransform(75.1,421.3,0.5,0.5);

	this.shape_3961 = new cjs.Shape();
	this.shape_3961.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3961.setTransform(62,421.4,0.5,0.5);

	this.shape_3962 = new cjs.Shape();
	this.shape_3962.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQAAgdARgSQASgSAdgHQgMgFgIgKQgHgKAAgMQAAgaAjgUQgYgKgOgVQgNgVABgbQgBgoAagZQAagYAsAAQAbAAANAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgHgCQgQAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgbgUgAhgB6QABA4BTAAQBpAAAAhEQAAgYgQgLQgSgLgkAAIgsAAQhKAAgBA6gAg4igQgSASAAAhQgBAgAUARQASARAgAAQAhAAASgRQASgRAAghQAAgjgTgRQgRgRghAAQghAAgSATg");
	this.shape_3962.setTransform(49.1,424.3,0.5,0.5);

	this.shape_3963 = new cjs.Shape();
	this.shape_3963.graphics.f("#000000").s().p("AgdA+QAThBAJg7IAcAAIADAGQgSA+gYA4g");
	this.shape_3963.setTransform(670.5,390.1,0.5,0.5);

	this.shape_3964 = new cjs.Shape();
	this.shape_3964.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggnA1ABQAwgBAbAiQAcAhAAA6IAAATIjBAAQAAA3AZAdQAaAeAvAAQAYAAAQgEQASgDAagKIAAAWQgWAKgUAEQgUAEgWgBQg6AAgigkgAg2hcQgZAagDAwICmAAQAAgvgVgaQgTgbglAAQgmABgXAZg");
	this.shape_3964.setTransform(661.2,383.1,0.5,0.5);

	this.shape_3965 = new cjs.Shape();
	this.shape_3965.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAVALQAXALAQAaIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgegjgAhBgeQgXAeABA7QgBBzBZAAQAtAAAWgaQAWgcAAg8IAAgFQAAg+gWgbQgUgbgvAAQgsAAgWAfg");
	this.shape_3965.setTransform(646.2,380.3,0.5,0.5);

	this.shape_3966 = new cjs.Shape();
	this.shape_3966.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3966.setTransform(631.8,383.1,0.5,0.5);

	this.shape_3967 = new cjs.Shape();
	this.shape_3967.graphics.f("#000000").s().p("AgwDwIAAgWQAQAFAQAAQAkAAAAgrIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgQAAAAgYg");
	this.shape_3967.setTransform(621,383.7,0.5,0.5);

	this.shape_3968 = new cjs.Shape();
	this.shape_3968.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAmIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_3968.setTransform(605.7,383,0.5,0.5);

	this.shape_3969 = new cjs.Shape();
	this.shape_3969.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3969.setTransform(590.9,383.1,0.5,0.5);

	this.shape_3970 = new cjs.Shape();
	this.shape_3970.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAHQAEAFAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_3970.setTransform(581.7,380.7,0.5,0.5);

	this.shape_3971 = new cjs.Shape();
	this.shape_3971.graphics.f("#000000").s().p("Ag0C4QgWgLgOgXIgDAAIgHApIgQAAIAAmCIAaAAIgCCfIACAAQAOgZAXgLQAWgMAdAAQA5AAAcAkQAdAkAABDQAABEgeAkQgeAlg2AAQgdAAgXgMgAhEgiQgVAbABA+IAAAFQgBA9AWAbQAVAaAuAAQAsAAAVgfQAXgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_3971.setTransform(571.6,380.3,0.5,0.5);

	this.shape_3972 = new cjs.Shape();
	this.shape_3972.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggABQgqAAgTAWQgUAWAAAyIAACeIgYAAIAAi4QAAhEg/AAQgrgBgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_3972.setTransform(552.4,383,0.5,0.5);

	this.shape_3973 = new cjs.Shape();
	this.shape_3973.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAoARAUQARATAkgBQAwABAWgZQAXgXAAg5IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_3973.setTransform(533.5,383.3,0.5,0.5);

	this.shape_3974 = new cjs.Shape();
	this.shape_3974.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3974.setTransform(523.2,380.2,0.5,0.5);

	this.shape_3975 = new cjs.Shape();
	this.shape_3975.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_3975.setTransform(512.8,383.1,0.5,0.5);

	this.shape_3976 = new cjs.Shape();
	this.shape_3976.graphics.f("#000000").s().p("AhZCKQgsgygBhYQABg4AUgqQAVgpAogYQAngXA0AAQA2AAAqAUIgLAXQgngUgtAAQhDAAgoAsQgnAsAABLQAABNAlAsQAmArBDAAQAuAAAmgMIAAAWQgkANg2AAQhLAAgsgxg");
	this.shape_3976.setTransform(497.9,380.8,0.5,0.5);

	this.shape_3977 = new cjs.Shape();
	this.shape_3977.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_3977.setTransform(485.4,383,0.5,0.5);

	this.shape_3978 = new cjs.Shape();
	this.shape_3978.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggnA1ABQAxgBAbAiQAbAhAAA6IAAATIjBAAQABA3AZAdQAZAeAvAAQAYAAAQgEQAUgDAYgKIAAAWQgWAKgTAEQgWAEgVgBQg6AAghgkgAg3hcQgXAbgEAvICnAAQgBgugUgbQgUgbglAAQglABgZAZg");
	this.shape_3978.setTransform(474.3,383.1,0.5,0.5);

	this.shape_3979 = new cjs.Shape();
	this.shape_3979.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAARAEIgEAXQgSgEgRAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_3979.setTransform(463.3,383,0.5,0.5);

	this.shape_3980 = new cjs.Shape();
	this.shape_3980.graphics.f("#000000").s().p("AhtC2IAAlrIBaAAQCBAAAABoQAAA1gkAbQglAchAAAIg4AAIAACXgAhTAKIAyAAQA9gBAbgTQAbgUAAguQAAgqgagUQgagVg1AAIg8AAg");
	this.shape_3980.setTransform(450.5,380.8,0.5,0.5);

	this.shape_3981 = new cjs.Shape();
	this.shape_3981.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNAAgXQAAgUgRgOQgQgNgmgOQgngOgRgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAbgRArAAQAsAAAoAQIgKAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQARAMAIAMQAIANAAATQAAAlgbATQgcAUgygBQg3AAgfgRg");
	this.shape_3981.setTransform(429.8,383.1,0.5,0.5);

	this.shape_3982 = new cjs.Shape();
	this.shape_3982.graphics.f("#000000").s().p("AhPB4QgVgUgBglQAAgnAigWQAhgVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_3982.setTransform(416.8,383.1,0.5,0.5);

	this.shape_3983 = new cjs.Shape();
	this.shape_3983.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgZAXgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_3983.setTransform(396.4,380.2,0.5,0.5);

	this.shape_3984 = new cjs.Shape();
	this.shape_3984.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjgBAgAMIgGAXQgkgMgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgaAMgqAAQg5ABggglg");
	this.shape_3984.setTransform(383,383.1,0.5,0.5);

	this.shape_3985 = new cjs.Shape();
	this.shape_3985.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkgBQAwABAWgZQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAABhjg");
	this.shape_3985.setTransform(369.1,383.3,0.5,0.5);

	this.shape_3986 = new cjs.Shape();
	this.shape_3986.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAUgNAAgXQAAgUgQgOQgQgNgngOQgngOgRgLQgPgJgJgOQgJgNAAgUQAAgeAagSQAagRAsAAQAtAAAmAQIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAQQAkAMARAKQARALAIANQAJANAAATQAAAlgcATQgbAUgygBQg3AAgfgRg");
	this.shape_3986.setTransform(355.6,383.1,0.5,0.5);

	this.shape_3987 = new cjs.Shape();
	this.shape_3987.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNgBgXQAAgUgQgOQgQgNgngOQgngOgRgLQgQgJgIgOQgJgNAAgUQAAgeAagSQAagRAsAAQAsAAAnAQIgJAWQgngQgjAAQggAAgTALQgUALAAATQABAWAPAMQAPANAqAQQAkAMARAKQARALAJANQAIAOAAASQAAAlgbATQgcAUgygBQg3AAgfgRg");
	this.shape_3987.setTransform(337.1,383.1,0.5,0.5);

	this.shape_3988 = new cjs.Shape();
	this.shape_3988.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgnQAggnA2ABQAvgBAcAiQAbAhAAA6IAAATIjCAAQABA3AZAdQAaAeAuAAQAZAAARgEQASgDAagKIAAAWQgXAKgUAEQgUAEgXgBQg5AAgigkgAg2hcQgZAbgDAvICmAAQABgugVgbQgUgbgkAAQgnABgXAZg");
	this.shape_3988.setTransform(324.3,383.1,0.5,0.5);

	this.shape_3989 = new cjs.Shape();
	this.shape_3989.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwgBgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_3989.setTransform(309.8,383,0.5,0.5);

	this.shape_3990 = new cjs.Shape();
	this.shape_3990.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABDggAkQggAlg4AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA4AZAeQAYAgAsAAQAtAAAYggQAZgeAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_3990.setTransform(294.8,383.1,0.5,0.5);

	this.shape_3991 = new cjs.Shape();
	this.shape_3991.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_3991.setTransform(282.8,381.6,0.5,0.5);

	this.shape_3992 = new cjs.Shape();
	this.shape_3992.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNgBgXQAAgUgQgOQgQgNgngOQgngOgQgLQgRgJgIgOQgJgNAAgUQABgeAZgSQAagRAsAAQAsAAAnAQIgJAWQgngQgjAAQggAAgTALQgUALABATQAAAWAPAMQAPANAqAQQAkAMARAKQARALAJANQAIANAAATQAAAlgbATQgcAUgygBQg3AAgfgRg");
	this.shape_3992.setTransform(272.7,383.1,0.5,0.5);

	this.shape_3993 = new cjs.Shape();
	this.shape_3993.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggnA0ABQAxgBAbAiQAcAgAAA7IAAATIjDAAQABA3AaAdQAZAeAuAAQAYAAASgEQASgDAagKIAAAWQgYAKgSAEQgVAEgXgBQg5AAghgkgAg3hcQgYAbgDAvICnAAQAAgugVgbQgUgbglAAQgmABgYAZg");
	this.shape_3993.setTransform(253.3,383.1,0.5,0.5);

	this.shape_3994 = new cjs.Shape();
	this.shape_3994.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAiglA6AAQAjgBAgAMIgGAXQgkgMgZAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgNIAAAXQgaAMgqAAQg5ABghglg");
	this.shape_3994.setTransform(240.5,383.1,0.5,0.5);

	this.shape_3995 = new cjs.Shape();
	this.shape_3995.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_3995.setTransform(226.9,383.1,0.5,0.5);

	this.shape_3996 = new cjs.Shape();
	this.shape_3996.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_3996.setTransform(217.7,380.2,0.5,0.5);

	this.shape_3997 = new cjs.Shape();
	this.shape_3997.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_3997.setTransform(207.7,386.1,0.5,0.5);

	this.shape_3998 = new cjs.Shape();
	this.shape_3998.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA2AAQAeAAAVALQAXAMAPAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgGgpIgDAAQgeAug6AAQg3AAgegjgAhBgeQgWAeAAA7QgBBzBZAAQAtAAAWgaQAWgbgBg9IAAgFQABg+gWgbQgVgbgvAAQgrAAgWAfg");
	this.shape_3998.setTransform(185.1,380.3,0.5,0.5);

	this.shape_3999 = new cjs.Shape();
	this.shape_3999.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_3999.setTransform(175,380.2,0.5,0.5);

	this.shape_4000 = new cjs.Shape();
	this.shape_4000.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkgBQAvABAXgZQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAABhjg");
	this.shape_4000.setTransform(164.5,383.3,0.5,0.5);

	this.shape_4001 = new cjs.Shape();
	this.shape_4001.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAhgmA2ABQA4AAAgAlQAgAlAABBQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhWQgYAfAAA3QAAA3AYAfQAZAgAsAAQAtAAAYggQAZgeAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4001.setTransform(149.6,383.1,0.5,0.5);

	this.shape_4002 = new cjs.Shape();
	this.shape_4002.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA6AFAbIABAAQAQg+AGgPIA4ilIAVAAIA1ClQAQA0AGAYIACAAQABgLAShLIAqibIAZAAIhKEOg");
	this.shape_4002.setTransform(132.9,383.1,0.5,0.5);

	this.shape_4003 = new cjs.Shape();
	this.shape_4003.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4003.setTransform(114.2,380.2,0.5,0.5);

	this.shape_4004 = new cjs.Shape();
	this.shape_4004.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgnA0ABQAwgBAcAiQAbAgAAA7IAAATIjCAAQABA3AZAdQAbAeAuAAQAYAAAQgEQASgDAbgKIAAAWQgYAKgTAEQgVAEgVgBQg6AAghgkgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglAAQgmABgXAZg");
	this.shape_4004.setTransform(104.3,383.1,0.5,0.5);

	this.shape_4005 = new cjs.Shape();
	this.shape_4005.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4005.setTransform(89.9,380.2,0.5,0.5);

	this.shape_4006 = new cjs.Shape();
	this.shape_4006.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhCAigmQAiglA6AAQAkgBAfAMIgGAXQgkgMgZAAQgxAAgZAfQgaAeAAA5QAAA3AaAfQAZAfAtAAQAlAAAfgNIAAAXQgaAMgpAAQg6ABghglg");
	this.shape_4006.setTransform(76.5,383.1,0.5,0.5);

	this.shape_4007 = new cjs.Shape();
	this.shape_4007.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAIAAAEAHQAEAFAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4007.setTransform(67.3,380.7,0.5,0.5);

	this.shape_4008 = new cjs.Shape();
	this.shape_4008.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgXAAIAAlrIAnAAICAE/IABAAICBk/IAmAAIAAFrg");
	this.shape_4008.setTransform(53.4,380.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_4008},{t:this.shape_4007},{t:this.shape_4006},{t:this.shape_4005},{t:this.shape_4004},{t:this.shape_4003},{t:this.shape_4002},{t:this.shape_4001},{t:this.shape_4000},{t:this.shape_3999},{t:this.shape_3998},{t:this.shape_3997},{t:this.shape_3996},{t:this.shape_3995},{t:this.shape_3994},{t:this.shape_3993},{t:this.shape_3992},{t:this.shape_3991},{t:this.shape_3990},{t:this.shape_3989},{t:this.shape_3988},{t:this.shape_3987},{t:this.shape_3986},{t:this.shape_3985},{t:this.shape_3984},{t:this.shape_3983},{t:this.shape_3982},{t:this.shape_3981},{t:this.shape_3980},{t:this.shape_3979},{t:this.shape_3978},{t:this.shape_3977},{t:this.shape_3976},{t:this.shape_3975},{t:this.shape_3974},{t:this.shape_3973},{t:this.shape_3972},{t:this.shape_3971},{t:this.shape_3970},{t:this.shape_3969},{t:this.shape_3968},{t:this.shape_3967},{t:this.shape_3966},{t:this.shape_3965},{t:this.shape_3964},{t:this.shape_3963},{t:this.shape_3962},{t:this.shape_3961},{t:this.shape_3960},{t:this.shape_3959},{t:this.shape_3958},{t:this.shape_3957},{t:this.shape_3956},{t:this.shape_3955},{t:this.shape_3954},{t:this.shape_3953},{t:this.shape_3952},{t:this.shape_3951},{t:this.shape_3950},{t:this.shape_3949},{t:this.shape_3948},{t:this.shape_3947},{t:this.shape_3946},{t:this.shape_3945},{t:this.shape_3944},{t:this.shape_3943},{t:this.shape_3942},{t:this.shape_3941},{t:this.shape_3940},{t:this.shape_3939},{t:this.shape_3938},{t:this.shape_3937},{t:this.shape_3936},{t:this.shape_3935},{t:this.shape_3934},{t:this.shape_3933},{t:this.shape_3932},{t:this.shape_3931},{t:this.shape_3930},{t:this.shape_3929},{t:this.shape_3928},{t:this.shape_3927},{t:this.shape_3926},{t:this.shape_3925},{t:this.shape_3924},{t:this.shape_3923},{t:this.shape_3922},{t:this.shape_3921},{t:this.shape_3920},{t:this.shape_3919},{t:this.shape_3918},{t:this.shape_3917},{t:this.shape_3916},{t:this.shape_3915},{t:this.shape_3914},{t:this.shape_3913},{t:this.shape_3912},{t:this.shape_3911},{t:this.shape_3910},{t:this.shape_3909},{t:this.shape_3908},{t:this.shape_3907},{t:this.shape_3906},{t:this.shape_3905},{t:this.shape_3904},{t:this.shape_3903},{t:this.shape_3902},{t:this.shape_3901},{t:this.shape_3900},{t:this.shape_3899},{t:this.shape_3898},{t:this.shape_3897},{t:this.shape_3896},{t:this.shape_3895},{t:this.shape_3894},{t:this.shape_3893},{t:this.shape_3892},{t:this.shape_3891},{t:this.shape_3890},{t:this.shape_3889},{t:this.shape_3888},{t:this.shape_3887},{t:this.shape_3886},{t:this.shape_3885},{t:this.shape_3884},{t:this.shape_3883},{t:this.shape_3882},{t:this.shape_3881},{t:this.shape_3880},{t:this.shape_3879},{t:this.shape_3878},{t:this.shape_3877},{t:this.shape_3876},{t:this.shape_3875},{t:this.shape_3874},{t:this.shape_3873},{t:this.shape_3872},{t:this.shape_3871},{t:this.shape_3870},{t:this.shape_3869},{t:this.shape_3868},{t:this.shape_3867},{t:this.shape_3866},{t:this.shape_3865},{t:this.shape_3864},{t:this.shape_3863},{t:this.shape_3862},{t:this.shape_3861},{t:this.shape_3860},{t:this.shape_3859},{t:this.shape_3858},{t:this.shape_3857},{t:this.shape_3856},{t:this.shape_3855},{t:this.shape_3854},{t:this.shape_3853},{t:this.shape_3852},{t:this.shape_3851},{t:this.shape_3850},{t:this.shape_3849},{t:this.shape_3848},{t:this.shape_3847},{t:this.shape_3846},{t:this.shape_3845},{t:this.shape_3844},{t:this.shape_3843},{t:this.shape_3842},{t:this.shape_3841},{t:this.shape_3840},{t:this.shape_3839},{t:this.shape_3838},{t:this.shape_3837},{t:this.shape_3836},{t:this.shape_3835},{t:this.shape_3834},{t:this.shape_3833},{t:this.shape_3832},{t:this.shape_3831},{t:this.shape_3830},{t:this.shape_3829},{t:this.shape_3828},{t:this.shape_3827},{t:this.shape_3826},{t:this.shape_3825},{t:this.shape_3824},{t:this.shape_3823},{t:this.shape_3822},{t:this.shape_3821},{t:this.shape_3820},{t:this.shape_3819},{t:this.shape_3818},{t:this.shape_3817},{t:this.shape_3816},{t:this.shape_3815},{t:this.shape_3814},{t:this.shape_3813},{t:this.shape_3812},{t:this.shape_3811},{t:this.shape_3810},{t:this.shape_3809},{t:this.shape_3808},{t:this.shape_3807},{t:this.shape_3806},{t:this.shape_3805},{t:this.shape_3804},{t:this.shape_3803},{t:this.shape_3802},{t:this.shape_3801},{t:this.shape_3800},{t:this.shape_3799},{t:this.shape_3798},{t:this.shape_3797},{t:this.shape_3796},{t:this.shape_3795},{t:this.shape_3794},{t:this.shape_3793},{t:this.shape_3792},{t:this.shape_3791},{t:this.shape_3790},{t:this.shape_3789},{t:this.shape_3788},{t:this.shape_3787},{t:this.shape_3786},{t:this.shape_3785},{t:this.shape_3784},{t:this.shape_3783},{t:this.shape_3782},{t:this.shape_3781},{t:this.shape_3780},{t:this.shape_3779},{t:this.shape_3778},{t:this.shape_3777},{t:this.shape_3776},{t:this.shape_3775},{t:this.shape_3774},{t:this.shape_3773},{t:this.shape_3772},{t:this.shape_3771},{t:this.shape_3770},{t:this.shape_3769},{t:this.shape_3768},{t:this.shape_3767},{t:this.shape_3766},{t:this.shape_3765},{t:this.shape_3764},{t:this.shape_3763},{t:this.shape_3762},{t:this.shape_3761},{t:this.shape_3760},{t:this.shape_3759},{t:this.shape_3758},{t:this.shape_3757},{t:this.shape_3756},{t:this.shape_3755},{t:this.shape_3754},{t:this.shape_3753},{t:this.shape_3752},{t:this.shape_3751},{t:this.shape_3750},{t:this.shape_3749},{t:this.shape_3748},{t:this.shape_3747},{t:this.shape_3746},{t:this.shape_3745},{t:this.shape_3744},{t:this.shape_3743},{t:this.shape_3742},{t:this.shape_3741},{t:this.shape_3740},{t:this.shape_3739},{t:this.shape_3738},{t:this.shape_3737},{t:this.shape_3736},{t:this.shape_3735},{t:this.shape_3734},{t:this.shape_3733},{t:this.shape_3732},{t:this.shape_3731},{t:this.shape_3730},{t:this.shape_3729},{t:this.shape_3728},{t:this.shape_3727},{t:this.shape_3726},{t:this.shape_3725},{t:this.shape_3724},{t:this.shape_3723},{t:this.shape_3722},{t:this.shape_3721},{t:this.shape_3720},{t:this.shape_3719},{t:this.shape_3718},{t:this.shape_3717},{t:this.shape_3716},{t:this.shape_3715},{t:this.shape_3714},{t:this.shape_3713},{t:this.shape_3712},{t:this.shape_3711},{t:this.shape_3710},{t:this.shape_3709},{t:this.shape_3708},{t:this.shape_3707},{t:this.shape_3706},{t:this.shape_3705},{t:this.instance_15},{t:this.instance_14}]},107).to({state:[]},1).wait(57));

	// ButtonLeftRight copy 32
	this.buttonR15 = new lib.ButtonLeft_Right();
	this.buttonR15.name = "buttonR15";
	this.buttonR15.parent = this;
	this.buttonR15.setTransform(2025,513.5,1,1,180);
	this.buttonR15._off = true;
	new cjs.ButtonHelper(this.buttonR15, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR15).wait(106).to({_off:false},0).to({_off:true},1).wait(58));

	// ButtonLeftRight copy 33
	this.buttonL15 = new lib.ButtonLeft_Right();
	this.buttonL15.name = "buttonL15";
	this.buttonL15.parent = this;
	this.buttonL15.setTransform(0,437.2);
	this.buttonL15._off = true;
	new cjs.ButtonHelper(this.buttonL15, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL15).wait(106).to({_off:false},0).to({_off:true},1).wait(58));

	// Layer_2
	this.shape_4009 = new cjs.Shape();
	this.shape_4009.graphics.f("#FFFFFF").s().p("Egt8AEiIAApDMBb5AAAIAAJDg");
	this.shape_4009.setTransform(1096.3,891.2);
	this.shape_4009._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_4009).wait(106).to({_off:false},0).to({_off:true},1).wait(58));

	// Layer 1
	this.instance_16 = new lib.fly_2();
	this.instance_16.parent = this;
	this.instance_16.setTransform(1301,127,0.859,0.859);

	this.instance_17 = new lib.fly_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(843,164,0.899,0.899);

	this.shape_4010 = new cjs.Shape();
	this.shape_4010.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_4010.setTransform(521.7,815.2,0.5,0.5);

	this.shape_4011 = new cjs.Shape();
	this.shape_4011.graphics.f("#000000").s().p("AhLBhIAAgVQAgAQAkAAQAgAAAPgKQAQgKAAgSQAAgQgNgLQgNgLgdgLQgegKgOgJQgOgIgFgKQgHgKAAgQQAAgYAUgNQATgOAkAAQAkAAAdANIgHASQgggOgaAAQgZAAgPAJQgPAJgBAPQAAAQAMALQAMAKAiALQAcALANAIQANAHAHALQAGAMAAANQAAAcgVAQQgWAPgnAAQgsAAgYgNg");
	this.shape_4011.setTransform(514.6,810.6,0.5,0.5);

	this.shape_4012 = new cjs.Shape();
	this.shape_4012.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQglAAgSATQgRAUgBArIAAB0IgSAAIAAjTIAQAAIADAdIABAAQAWghAzAAQBIAAAABNIAACKg");
	this.shape_4012.setTransform(504.2,810.5,0.5,0.5);

	this.shape_4013 = new cjs.Shape();
	this.shape_4013.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQAEAGAAAJQAAAHgEAGQgDAGgGAAQgMgBAAgSg");
	this.shape_4013.setTransform(496,808.7,0.5,0.5);

	this.shape_4014 = new cjs.Shape();
	this.shape_4014.graphics.f("#000000").s().p("AA4CYIhQhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhTBaIBaB6g");
	this.shape_4014.setTransform(489.8,808.3,0.5,0.5);

	this.shape_4015 = new cjs.Shape();
	this.shape_4015.graphics.f("#000000").s().p("AgOB3QgNgPAAggIAAiIIggAAIAAgMIAggJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAIALQAIAMATAAQASAAANgDIAAAPQgOAFgSAAQgbAAgOgPg");
	this.shape_4015.setTransform(480.5,809.4,0.5,0.5);

	this.shape_4016 = new cjs.Shape();
	this.shape_4016.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAASASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgtACgSAMQgTALAAAZQAAAUAMALQAMALAWAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_4016.setTransform(471.7,810.6,0.5,0.5);

	this.shape_4017 = new cjs.Shape();
	this.shape_4017.graphics.f("#000000").s().p("ABJCPIg+jcIgMgsIgIAnIg/DhIgRAAIhOkdIAUAAIBDD9QAGgfAOgyIAxisIAVAAIA5DGQAJAdAGAaIAGgeIA8jfIAUAAIhOEdg");
	this.shape_4017.setTransform(457.8,808.8,0.5,0.5);

	this.shape_4018 = new cjs.Shape();
	this.shape_4018.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQgfAAgSgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_4018.setTransform(438,810.6,0.5,0.5);

	this.shape_4019 = new cjs.Shape();
	this.shape_4019.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgXAPgKQAOgJAVAAQANAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAWAAAkIAAB0g");
	this.shape_4019.setTransform(429.9,810.5,0.5,0.5);

	this.shape_4020 = new cjs.Shape();
	this.shape_4020.graphics.f("#000000").s().p("AhBB/QgYgcAAg0QAAg1AXgeQAXgdArAAQAZAAAPAIQASAJAMAUIACAAIgCgwIAAhNIAUAAIAAEvIgNAAIgFggIgCAAQgYAkgtAAQgrAAgXgbgAgzgXQgRAXAAAvQAABaBFAAQAkAAARgVQAQgVAAgwIAAgDQAAgwgQgWQgRgWglAAQgiAAgRAZg");
	this.shape_4020.setTransform(419,808.4,0.5,0.5);

	this.shape_4021 = new cjs.Shape();
	this.shape_4021.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgbAAQglAAgSATQgSAUAAArIAAB0IgTAAIAAjTIAQAAIAEAdIABAAQAUghA0AAQBJAAgBBNIAACKg");
	this.shape_4021.setTransform(407.6,810.5,0.5,0.5);

	this.shape_4022 = new cjs.Shape();
	this.shape_4022.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQgBgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAkAAAQASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgRgQgAAYAAQgtACgSAMQgTALAAAZQgBAUANALQALALAYAAQAgAAAUgTQAUgUAAgiIAAgUg");
	this.shape_4022.setTransform(396,810.6,0.5,0.5);

	this.shape_4023 = new cjs.Shape();
	this.shape_4023.graphics.f("#000000").s().p("ABCBqIhChfIhDBfIgVAAIBNhsIhKhnIAXAAIA+BZIA/hZIAVAAIhJBnIBOBsg");
	this.shape_4023.setTransform(386,810.6,0.5,0.5);

	this.shape_4024 = new cjs.Shape();
	this.shape_4024.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgxAZgfQAZgfAqAAQAlAAAWAaQAWAaAAAtIAAAPIiYAAQAAArAUAXQAUAXAkABQAVgBALgCQAQgCATgJIAAARQgRAIgQAEQgNACgVAAQgtAAgagcgAgrhHQgSAUgDAlICCAAQAAgkgQgVQgQgVgcAAQgeAAgTAVg");
	this.shape_4024.setTransform(375.6,810.6,0.5,0.5);

	this.shape_4025 = new cjs.Shape();
	this.shape_4025.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_4025.setTransform(367.8,808.3,0.5,0.5);

	this.shape_4026 = new cjs.Shape();
	this.shape_4026.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgmhlQgGgNgHgVQgEARgGARg");
	this.shape_4026.setTransform(359.6,808.8,0.5,0.5);

	this.shape_4027 = new cjs.Shape();
	this.shape_4027.graphics.f("#000000").s().p("AhaCWIAAgRQALADANAAQAKAAAIgEQAIgFAGgKQAHgLAHgUIAKgcIhRjTIAUAAIAtB3QATAyAHAXIAAAAIAbhKIAth2IAUAAIheD1QgNAfgHAKQgHAKgLAGQgKAFgPAAQgKAAgPgEg");
	this.shape_4027.setTransform(343.8,813,0.5,0.5);

	this.shape_4028 = new cjs.Shape();
	this.shape_4028.graphics.f("#000000").s().p("AgpCRQgSgKgLgRIgBAAIgGAgIgMAAIAAkvIATAAIgBB9IABAAQAMgTASgJQASgJAWAAQAtAAAWAcQAXAcAAA1QgBA0gXAdQgYAdgqAAQgWAAgTgJgAg1gaQgRAWAAAwIAAADQABAvAQAWQASAVAjAAQAiAAASgZQARgXAAguQAAhbhFAAQglAAgQAWg");
	this.shape_4028.setTransform(333.5,808.4,0.5,0.5);

	this.shape_4029 = new cjs.Shape();
	this.shape_4029.graphics.f("#000000").s().p("AgWAxQAGgTAGgcQAHgiACgQIAWAAIACAEQgOAygTArg");
	this.shape_4029.setTransform(320.6,804.1,0.5,0.5);

	this.shape_4030 = new cjs.Shape();
	this.shape_4030.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgUAAIAAkdIAUAAIAAB/IClAAIAAh/IAVAAIAAEdg");
	this.shape_4030.setTransform(312,808.8,0.5,0.5);

	this.shape_4031 = new cjs.Shape();
	this.shape_4031.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA8AdAjQAeAiA1AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_4031.setTransform(298.9,808.8,0.5,0.5);

	this.shape_4032 = new cjs.Shape();
	this.shape_4032.graphics.f("#000000").s().p("AhdBrQghgmgBhFQABhEAhgnQAjgnA6AAQA7AAAjAnQAiAoAABDQgBBEghAnQgiAog8AAQg7AAgigogAhNhdQgcAgAAA9QAAA9AcAiQAaAhAzAAQA0AAAaghQAcghAAg+QAAg9gcghQgaghg0AAQgyAAgbAig");
	this.shape_4032.setTransform(284.7,808.8,0.5,0.5);

	this.shape_4033 = new cjs.Shape();
	this.shape_4033.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgjAog7AAQg7AAgigogAhNhdQgcAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgbAig");
	this.shape_4033.setTransform(269.4,808.8,0.5,0.5);

	this.shape_4034 = new cjs.Shape();
	this.shape_4034.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_4034.setTransform(256.6,808.8,0.5,0.5);

	this.shape_4035 = new cjs.Shape();
	this.shape_4035.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAYASAAAkQAAAZgOARQgPAQgdAFIAAABQAhAFAQAQQARAQAAAeQAAAngbAVQgbAWgtAAgAhJB9IBDAAQBOAAABhAQAAg7hUAAIg+AAgAhJgPIA+AAQAoAAASgNQATgOgBgcQABgcgVgOQgUgMgoAAIg6AAg");
	this.shape_4035.setTransform(244.1,808.8,0.5,0.5);

	this.shape_4036 = new cjs.Shape();
	this.shape_4036.graphics.f("#000000").s().p("AhXCHIAAgTQAgANAvAAQAiAAAUgRQAVgPAAgbQAAgQgHgLQgGgKgQgJQgQgJgcgKQgtgOgQgSQgQgRAAgdQAAggAZgUQAZgVAmAAQApAAAjAQIgHARQgkgPggAAQgfAAgTAPQgTAOAAAZQAAARAGAJQAFAKAOAJQANAIAfALQAgAKASAMQARAKAIAOQAHAOAAATQAAAkgaAVQgaAVgrAAQg1AAgbgMg");
	this.shape_4036.setTransform(226.8,808.8,0.5,0.5);

	this.shape_4037 = new cjs.Shape();
	this.shape_4037.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_4037.setTransform(216.2,808.8,0.5,0.5);

	this.shape_4038 = new cjs.Shape();
	this.shape_4038.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_4038.setTransform(207.7,808.8,0.5,0.5);

	this.shape_4039 = new cjs.Shape();
	this.shape_4039.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_4039.setTransform(200.9,808.8,0.5,0.5);

	this.shape_4040 = new cjs.Shape();
	this.shape_4040.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAAB5ICAAAIAAASIiAAAIAACAg");
	this.shape_4040.setTransform(190.8,808.8,0.5,0.5);

	this.shape_4041 = new cjs.Shape();
	this.shape_4041.graphics.f("#000000").s().p("AhYCRIAAgSIBMhPQAhgkALgNQAMgRAGgRQAHgRAAgRQAAgZgRgQQgRgRgaABQgjAAghAaIgLgOQAkgeAsAAQAjAAAWAUQAWAUAAAjQAAAcgPAaQgNAZgnAoIhIBMIAAAAICXAAIAAATg");
	this.shape_4041.setTransform(173.9,808.7,0.5,0.5);

	this.shape_4042 = new cjs.Shape();
	this.shape_4042.graphics.f("#000000").s().p("ABTCPIAAiNIimAAIAACNIgUAAIAAkdIAUAAIAAB/ICmAAIAAh/IAUAAIAAEdg");
	this.shape_4042.setTransform(155.9,808.8,0.5,0.5);

	this.shape_4043 = new cjs.Shape();
	this.shape_4043.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_4043.setTransform(143.5,808.8,0.5,0.5);

	this.shape_4044 = new cjs.Shape();
	this.shape_4044.graphics.f("#000000").s().p("AgJCPIAAkdIATAAIAAEdg");
	this.shape_4044.setTransform(135.7,808.8,0.5,0.5);

	this.shape_4045 = new cjs.Shape();
	this.shape_4045.graphics.f("#000000").s().p("ABJCPIg/jcIgKgsIgJAnIg/DhIgRAAIhPkdIAWAAIBCD9QAGgfAOgyIAxisIAVAAIA5DGQAJAdAGAaIAGgeIA8jfIAVAAIhPEdg");
	this.shape_4045.setTransform(124.3,808.8,0.5,0.5);

	this.shape_4046 = new cjs.Shape();
	this.shape_4046.graphics.f("#000000").s().p("ABGCPIhJh9IhGAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAZATAAAoQABAdgPATQgQATgfAIIBOCDgAhJABIA2AAQAkAAAUgPQATgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_4046.setTransform(105,808.8,0.5,0.5);

	this.shape_4047 = new cjs.Shape();
	this.shape_4047.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsIB/AAIAAASIh/AAIAAB6ICHAAIAAATg");
	this.shape_4047.setTransform(93.2,808.8,0.5,0.5);

	this.shape_4048 = new cjs.Shape();
	this.shape_4048.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAZASAAAkQAAAZgPARQgPAQgdAFIAAABQAiAFAQAQQAQAQAAAeQAAAngaAVQgbAWguAAgAhJB9IBDAAQBPAAAAhAQAAg7hTAAIg/AAgAhJgPIA/AAQAnAAASgNQATgOAAgcQAAgcgVgOQgUgMgoAAIg6AAg");
	this.shape_4048.setTransform(81.4,808.8,0.5,0.5);

	this.shape_4049 = new cjs.Shape();
	this.shape_4049.graphics.f("#000000").s().p("ABwCPIAAjYQAAgUADgbIgCAAIhrEHIgLAAIhrkHIgBAAIABAxIAADWIgTAAIAAkdIAfAAIBkD6IABAAIBlj6IAeAAIAAEdg");
	this.shape_4049.setTransform(66.1,808.8,0.5,0.5);

	this.shape_4050 = new cjs.Shape();
	this.shape_4050.graphics.f("#000000").s().p("ABhCQIgnhmIh0AAIgnBmIgWAAIBykeIAMAAIBxEegAgKhNIgoBlIBlAAIgyiHQgFARgGARg");
	this.shape_4050.setTransform(51.5,808.8,0.5,0.5);

	this.shape_4051 = new cjs.Shape();
	this.shape_4051.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_4051.setTransform(44,804.1,0.5,0.5);

	this.shape_4052 = new cjs.Shape();
	this.shape_4052.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_4052.setTransform(174.2,579.2,0.5,0.5);

	this.shape_4053 = new cjs.Shape();
	this.shape_4053.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_4053.setTransform(166.2,570.5,0.5,0.5);

	this.shape_4054 = new cjs.Shape();
	this.shape_4054.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4054.setTransform(154.8,573.3,0.5,0.5);

	this.shape_4055 = new cjs.Shape();
	this.shape_4055.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4055.setTransform(141.5,573.4,0.5,0.5);

	this.shape_4056 = new cjs.Shape();
	this.shape_4056.graphics.f("#000000").s().p("ABNCHIg7i0QgEgMgKgqIgCAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQANg1AIgYIA4ikIAVAAIA1CjQATA9ADARIACAAQACgTAShEIApiaIAZAAIhKENg");
	this.shape_4056.setTransform(124.8,573.4,0.5,0.5);

	this.shape_4057 = new cjs.Shape();
	this.shape_4057.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4057.setTransform(104.9,573.3,0.5,0.5);

	this.shape_4058 = new cjs.Shape();
	this.shape_4058.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAaAdAvAAQAUAAAUgDQATgDAagLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgUgbglAAQgmAAgXAag");
	this.shape_4058.setTransform(92,573.4,0.5,0.5);

	this.shape_4059 = new cjs.Shape();
	this.shape_4059.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4059.setTransform(77.6,570.5,0.5,0.5);

	this.shape_4060 = new cjs.Shape();
	this.shape_4060.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4060.setTransform(55.9,573.3,0.5,0.5);

	this.shape_4061 = new cjs.Shape();
	this.shape_4061.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_4061.setTransform(45.4,571,0.5,0.5);

	this.shape_4062 = new cjs.Shape();
	this.shape_4062.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOgkgNQgngNgRgLQgRgLgIgNQgIgOgBgTQAAgeAagSQAZgRAuAAQAsAAAnAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAPANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4062.setTransform(669,535.2,0.5,0.5);

	this.shape_4063 = new cjs.Shape();
	this.shape_4063.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4063.setTransform(660.3,532.3,0.5,0.5);

	this.shape_4064 = new cjs.Shape();
	this.shape_4064.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_4064.setTransform(654.5,532.7,0.5,0.5);

	this.shape_4065 = new cjs.Shape();
	this.shape_4065.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgKgIgOQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgogQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAQANAqAQQAkAMASAKQAQAKAJAOQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_4065.setTransform(645.6,535.2,0.5,0.5);

	this.shape_4066 = new cjs.Shape();
	this.shape_4066.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOglgNQgmgNgRgLQgQgKgJgOQgJgOAAgTQABgeAZgSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAQAMQAPANAqAQQAkAMARAKQARAKAJAOQAIAOAAASQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4066.setTransform(633.7,535.2,0.5,0.5);

	this.shape_4067 = new cjs.Shape();
	this.shape_4067.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4067.setTransform(620.4,535.2,0.5,0.5);

	this.shape_4068 = new cjs.Shape();
	this.shape_4068.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgOIAxgJIAAgWQAAgxATgYQARgXAqAAQAUAAAZAGIgGAWQgUgGgTAAQgdAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4068.setTransform(610,532.2,0.5,0.5);

	this.shape_4069 = new cjs.Shape();
	this.shape_4069.graphics.f("#000000").s().p("AhTCiQgegkAAhCQAAhGAdgkQAdgmA4AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsgBgWAgg");
	this.shape_4069.setTransform(590.7,532.4,0.5,0.5);

	this.shape_4070 = new cjs.Shape();
	this.shape_4070.graphics.f("#000000").s().p("ABSCKIAAivQABgogSgTQgSgTgjAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4070.setTransform(576,535.1,0.5,0.5);

	this.shape_4071 = new cjs.Shape();
	this.shape_4071.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4071.setTransform(561.2,535.2,0.5,0.5);

	this.shape_4072 = new cjs.Shape();
	this.shape_4072.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgVgRgOQgSgOgkgNQgogNgQgLQgRgLgIgNQgIgOAAgTQgBgeAagSQAZgRAuAAQArAAAoAQIgJAWQgogQgiAAQggAAgUALQgTALAAATQAAAWAOAMQAPANAsAQQAiAMATAKQARALAIANQAIANAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_4072.setTransform(542.3,535.2,0.5,0.5);

	this.shape_4073 = new cjs.Shape();
	this.shape_4073.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4073.setTransform(529,535.1,0.5,0.5);

	this.shape_4074 = new cjs.Shape();
	this.shape_4074.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4074.setTransform(513.9,535.2,0.5,0.5);

	this.shape_4075 = new cjs.Shape();
	this.shape_4075.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_4075.setTransform(503.6,532.7,0.5,0.5);

	this.shape_4076 = new cjs.Shape();
	this.shape_4076.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYgBQgjAAgRgSg");
	this.shape_4076.setTransform(496.2,533.7,0.5,0.5);

	this.shape_4077 = new cjs.Shape();
	this.shape_4077.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4077.setTransform(484.9,535.2,0.5,0.5);

	this.shape_4078 = new cjs.Shape();
	this.shape_4078.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAYAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAKgTAWgMQAUgLAZAAQBBAAARAwIABAAQANgXAWgMQAWgNAdAAQAtAAAVAYQAWAXAAA0IAACwg");
	this.shape_4078.setTransform(467.4,535.1,0.5,0.5);

	this.shape_4079 = new cjs.Shape();
	this.shape_4079.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_4079.setTransform(452,535.1,0.5,0.5);

	this.shape_4080 = new cjs.Shape();
	this.shape_4080.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4080.setTransform(438.7,535.2,0.5,0.5);

	this.shape_4081 = new cjs.Shape();
	this.shape_4081.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgOIAygJIAAgWQAAgxATgYQARgXAqAAQAUAAAZAGIgGAWQgUgGgTAAQgdAAgNARQgKARAAAmIAAAZIA+AAIAAAWIg+AAIAAD4g");
	this.shape_4081.setTransform(428.3,532.2,0.5,0.5);

	this.shape_4082 = new cjs.Shape();
	this.shape_4082.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_4082.setTransform(414.1,532.3,0.5,0.5);

	this.shape_4083 = new cjs.Shape();
	this.shape_4083.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4083.setTransform(404,535.2,0.5,0.5);

	this.shape_4084 = new cjs.Shape();
	this.shape_4084.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYgBQgjAAgRgSg");
	this.shape_4084.setTransform(393.3,533.7,0.5,0.5);

	this.shape_4085 = new cjs.Shape();
	this.shape_4085.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4085.setTransform(383.1,535.2,0.5,0.5);

	this.shape_4086 = new cjs.Shape();
	this.shape_4086.graphics.f("#000000").s().p("AhzC/IAAgVQANAEATAAQAMAAAJgGQALgGAHgNQAIgNAKgbIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAjhfIA5iXIAZAAIh4E6QgPAngKANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_4086.setTransform(371.4,538.3,0.5,0.5);

	this.shape_4087 = new cjs.Shape();
	this.shape_4087.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4087.setTransform(361.5,535.1,0.5,0.5);

	this.shape_4088 = new cjs.Shape();
	this.shape_4088.graphics.f("#000000").s().p("Ag/BoQgiglABhBQgBhCAjgmQAiglA6AAQAjAAAhAMIgHAWQgkgMgaAAQgxAAgZAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg6AAgggkg");
	this.shape_4088.setTransform(349.9,535.2,0.5,0.5);

	this.shape_4089 = new cjs.Shape();
	this.shape_4089.graphics.f("#000000").s().p("AgdA/QAThDAIg6IAdAAIADAGQgTBAgYA3g");
	this.shape_4089.setTransform(333.8,542.1,0.5,0.5);

	this.shape_4090 = new cjs.Shape();
	this.shape_4090.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4090.setTransform(325.4,535.2,0.5,0.5);

	this.shape_4091 = new cjs.Shape();
	this.shape_4091.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhGAdgkQAdgmA3AAQAeAAAWALQAUALASAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAegBA7QAABzBZAAQAuAAAWgbQAVgbAAg8IAAgFQAAg+gVgbQgWgbgvAAQgqgBgXAgg");
	this.shape_4091.setTransform(311.6,532.4,0.5,0.5);

	this.shape_4092 = new cjs.Shape();
	this.shape_4092.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4092.setTransform(297.2,535.2,0.5,0.5);

	this.shape_4093 = new cjs.Shape();
	this.shape_4093.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAaAdAvAAQAUAAAUgDQATgDAagLIAAAWQgYAKgTAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgUgbglAAQgmAAgXAag");
	this.shape_4093.setTransform(283.9,535.2,0.5,0.5);

	this.shape_4094 = new cjs.Shape();
	this.shape_4094.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQARgZAVgLQAVgMAeAAQA5AAAcAkQAdAkAABDQAABEgeAlQgeAkg2AAQgcAAgYgMgAhEgiQgVAcAAA9IAAAFQAAA+AWAZQAWAbAtAAQArAAAXgeQAWggAAg5QAAh0hYAAQgvgBgVAcg");
	this.shape_4094.setTransform(269.7,532.4,0.5,0.5);

	this.shape_4095 = new cjs.Shape();
	this.shape_4095.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAaAdAvAAQAUAAAUgDQATgDAagLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgUgbglAAQgmAAgXAag");
	this.shape_4095.setTransform(248.1,535.2,0.5,0.5);

	this.shape_4096 = new cjs.Shape();
	this.shape_4096.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgKgMgUQgOgUAAgcQAAgpAagYQAagYAsAAQAaAAAOAFIBXAAIAAARIg4ADQAWAdAAAhQAAAmgaAZQgaAYgrAAQgSAAgIgBQgOAIgIAKQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgjAXg+AAQgzAAgdgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAhAAASgRQASgRAAghQAAgjgSgRQgTgRggAAQggAAgTATg");
	this.shape_4096.setTransform(234.4,538.1,0.5,0.5);

	this.shape_4097 = new cjs.Shape();
	this.shape_4097.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAQQgYAPAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4097.setTransform(220.5,535.2,0.5,0.5);

	this.shape_4098 = new cjs.Shape();
	this.shape_4098.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAKAPQAKAPAYAAQAWAAATgEIAAATQgSAHgYgBQgjAAgQgSg");
	this.shape_4098.setTransform(209.8,533.7,0.5,0.5);

	this.shape_4099 = new cjs.Shape();
	this.shape_4099.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgkAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4099.setTransform(198.3,535.1,0.5,0.5);

	this.shape_4100 = new cjs.Shape();
	this.shape_4100.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4100.setTransform(187.8,532.7,0.5,0.5);

	this.shape_4101 = new cjs.Shape();
	this.shape_4101.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAOAjAHAbIAAAAQAMgkAKgbIBFi2IAaAAIhpENg");
	this.shape_4101.setTransform(179.1,535.2,0.5,0.5);

	this.shape_4102 = new cjs.Shape();
	this.shape_4102.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgYAfg");
	this.shape_4102.setTransform(159.1,535.2,0.5,0.5);

	this.shape_4103 = new cjs.Shape();
	this.shape_4103.graphics.f("#000000").s().p("AgRCYQgRgTAAgqIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAKAPQALAPAXAAQAWAAASgEIAAATQgRAHgXgBQgkAAgQgSg");
	this.shape_4103.setTransform(147.2,533.7,0.5,0.5);

	this.shape_4104 = new cjs.Shape();
	this.shape_4104.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4104.setTransform(129,535.1,0.5,0.5);

	this.shape_4105 = new cjs.Shape();
	this.shape_4105.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4105.setTransform(113.9,535.2,0.5,0.5);

	this.shape_4106 = new cjs.Shape();
	this.shape_4106.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_4106.setTransform(103.6,532.7,0.5,0.5);

	this.shape_4107 = new cjs.Shape();
	this.shape_4107.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAKAPQAKAPAYAAQAWAAATgEIAAATQgSAHgYgBQgjAAgRgSg");
	this.shape_4107.setTransform(96.3,533.7,0.5,0.5);

	this.shape_4108 = new cjs.Shape();
	this.shape_4108.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_4108.setTransform(89.3,532.7,0.5,0.5);

	this.shape_4109 = new cjs.Shape();
	this.shape_4109.graphics.f("#000000").s().p("AhTCiQgegkAAhCQAAhGAdgkQAdgmA4AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsgBgWAgg");
	this.shape_4109.setTransform(78.4,532.4,0.5,0.5);

	this.shape_4110 = new cjs.Shape();
	this.shape_4110.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdgmA4AAQAdAAAVALQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsgBgWAgg");
	this.shape_4110.setTransform(63.2,532.4,0.5,0.5);

	this.shape_4111 = new cjs.Shape();
	this.shape_4111.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAQQgYAPAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4111.setTransform(48.8,535.2,0.5,0.5);

	this.shape_4112 = new cjs.Shape();
	this.shape_4112.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4112.setTransform(669.8,496.8,0.5,0.5);

	this.shape_4113 = new cjs.Shape();
	this.shape_4113.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4113.setTransform(659.3,494.5,0.5,0.5);

	this.shape_4114 = new cjs.Shape();
	this.shape_4114.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_4114.setTransform(645.7,496.8,0.5,0.5);

	this.shape_4115 = new cjs.Shape();
	this.shape_4115.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AggnQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAaAdAuAAQAUAAAWgDQASgDAagLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgUgbglAAQglAAgYAag");
	this.shape_4115.setTransform(632.9,496.9,0.5,0.5);

	this.shape_4116 = new cjs.Shape();
	this.shape_4116.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgCCfIACAAQAPgZAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABEgeAlQgeAkg2AAQgcAAgYgMgAhEgiQgVAcAAA9IAAAFQAAA+AWAZQAWAbAtAAQArAAAXgeQAWghAAg4QAAh0hYAAQgvgBgVAcg");
	this.shape_4116.setTransform(618.7,494.2,0.5,0.5);

	this.shape_4117 = new cjs.Shape();
	this.shape_4117.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQANgXAWgMQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4117.setTransform(599.5,496.8,0.5,0.5);

	this.shape_4118 = new cjs.Shape();
	this.shape_4118.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4118.setTransform(581,497,0.5,0.5);

	this.shape_4119 = new cjs.Shape();
	this.shape_4119.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdgmA4AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4119.setTransform(560.1,494.2,0.5,0.5);

	this.shape_4120 = new cjs.Shape();
	this.shape_4120.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAVAAIAEAlIABAAQAbgqBCAAQBcAAAABjIAACwg");
	this.shape_4120.setTransform(545.5,496.8,0.5,0.5);

	this.shape_4121 = new cjs.Shape();
	this.shape_4121.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4121.setTransform(530.7,497,0.5,0.5);

	this.shape_4122 = new cjs.Shape();
	this.shape_4122.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0AAQAwAAAcAhQAcAhAAA6IAAATIjDAAQABA4AZAdQAaAdAuAAQAUAAAWgDQASgDAagLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgUgbglAAQglAAgYAag");
	this.shape_4122.setTransform(510.7,496.9,0.5,0.5);

	this.shape_4123 = new cjs.Shape();
	this.shape_4123.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4123.setTransform(496.3,496.8,0.5,0.5);

	this.shape_4124 = new cjs.Shape();
	this.shape_4124.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4124.setTransform(485.8,494.5,0.5,0.5);

	this.shape_4125 = new cjs.Shape();
	this.shape_4125.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4125.setTransform(480,494,0.5,0.5);

	this.shape_4126 = new cjs.Shape();
	this.shape_4126.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAQQgZAPAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4126.setTransform(470,497,0.5,0.5);

	this.shape_4127 = new cjs.Shape();
	this.shape_4127.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQANgXAWgMQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4127.setTransform(452.5,496.8,0.5,0.5);

	this.shape_4128 = new cjs.Shape();
	this.shape_4128.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4128.setTransform(437.1,496.8,0.5,0.5);

	this.shape_4129 = new cjs.Shape();
	this.shape_4129.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACvQAAAoASATQASATAjAAQAvAAAYgZQAWgYAAg3IAAiVIAYAAIAAEOIgUAAIgFglIgCAAQgZAqhDAAQhdAAAAhjg");
	this.shape_4129.setTransform(423.6,497.1,0.5,0.5);

	this.shape_4130 = new cjs.Shape();
	this.shape_4130.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4130.setTransform(408.7,496.9,0.5,0.5);

	this.shape_4131 = new cjs.Shape();
	this.shape_4131.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYgBQgjAAgRgTg");
	this.shape_4131.setTransform(396.8,495.4,0.5,0.5);

	this.shape_4132 = new cjs.Shape();
	this.shape_4132.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgUBDgWA0g");
	this.shape_4132.setTransform(382.9,503.9,0.5,0.5);

	this.shape_4133 = new cjs.Shape();
	this.shape_4133.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4133.setTransform(377.7,494,0.5,0.5);

	this.shape_4134 = new cjs.Shape();
	this.shape_4134.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAQQgYAPAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4134.setTransform(367.6,497,0.5,0.5);

	this.shape_4135 = new cjs.Shape();
	this.shape_4135.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAkg0AAQg9AAgeguIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_4135.setTransform(354.1,499.9,0.5,0.5);

	this.shape_4136 = new cjs.Shape();
	this.shape_4136.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4136.setTransform(338.7,496.9,0.5,0.5);

	this.shape_4137 = new cjs.Shape();
	this.shape_4137.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgTBAgXA3g");
	this.shape_4137.setTransform(321.4,503.9,0.5,0.5);

	this.shape_4138 = new cjs.Shape();
	this.shape_4138.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhHAdgjQAegmA3AAQAdAAAVALQAVAKASAbIACAAIgCg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4138.setTransform(311.1,494.2,0.5,0.5);

	this.shape_4139 = new cjs.Shape();
	this.shape_4139.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4139.setTransform(301,494,0.5,0.5);

	this.shape_4140 = new cjs.Shape();
	this.shape_4140.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAQQgYAPAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4140.setTransform(290.9,497,0.5,0.5);

	this.shape_4141 = new cjs.Shape();
	this.shape_4141.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_4141.setTransform(280.6,496.8,0.5,0.5);

	this.shape_4142 = new cjs.Shape();
	this.shape_4142.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA2AAQAvAAAcAhQAbAiAAA5IAAATIjCAAQABA4AZAdQAaAdAuAAQAVAAAUgDQAUgDAZgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgjAAQgmAAgYAag");
	this.shape_4142.setTransform(267.7,496.9,0.5,0.5);

	this.shape_4143 = new cjs.Shape();
	this.shape_4143.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgMQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4143.setTransform(249.5,496.8,0.5,0.5);

	this.shape_4144 = new cjs.Shape();
	this.shape_4144.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAATIjDAAQAAA3AaAeQAaAdAuAAQAVAAAUgDQASgDAbgLIAAAWQgXAKgUAEQgRADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgUgbglAAQgmAAgYAag");
	this.shape_4144.setTransform(231.2,496.9,0.5,0.5);

	this.shape_4145 = new cjs.Shape();
	this.shape_4145.graphics.f("#000000").s().p("AgTBvQAAgYATAAQAUAAAAAYQAAAYgUAAQgTAAAAgYgAgOhbQgFgGAAgNQAAgZATAAQAUAAAAAZQAAANgFAGQgHAGgIgBQgHABgHgGg");
	this.shape_4145.setTransform(214.6,497.2,0.5,0.5);

	this.shape_4146 = new cjs.Shape();
	this.shape_4146.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgOglgNQgmgNgRgLQgRgKgIgOQgIgOgBgTQAAgeAagSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAQANArAQQAjAMASAKQAQAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4146.setTransform(205.5,496.9,0.5,0.5);

	this.shape_4147 = new cjs.Shape();
	this.shape_4147.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg3ACgZAQQgYAPAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgYAAgtIAAgZg");
	this.shape_4147.setTransform(192.4,497,0.5,0.5);

	this.shape_4148 = new cjs.Shape();
	this.shape_4148.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmCIAZAAIgBCdIABAAQAQgZAXgKQAWgLAjAAQBcAAgBBiIAACxg");
	this.shape_4148.setTransform(172.1,494,0.5,0.5);

	this.shape_4149 = new cjs.Shape();
	this.shape_4149.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_4149.setTransform(158.7,496.9,0.5,0.5);

	this.shape_4150 = new cjs.Shape();
	this.shape_4150.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_4150.setTransform(144.8,497.1,0.5,0.5);

	this.shape_4151 = new cjs.Shape();
	this.shape_4151.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4151.setTransform(131.3,496.9,0.5,0.5);

	this.shape_4152 = new cjs.Shape();
	this.shape_4152.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQAsAAAoAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAVAQANQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4152.setTransform(112.8,496.9,0.5,0.5);

	this.shape_4153 = new cjs.Shape();
	this.shape_4153.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAATIjDAAQAAA3AbAeQAZAdAuAAQAVAAAUgDQASgDAagLIAAAWQgWAKgTAEQgTADgZAAQg5AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_4153.setTransform(100,496.9,0.5,0.5);

	this.shape_4154 = new cjs.Shape();
	this.shape_4154.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4154.setTransform(85.5,496.8,0.5,0.5);

	this.shape_4155 = new cjs.Shape();
	this.shape_4155.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4155.setTransform(70.4,496.9,0.5,0.5);

	this.shape_4156 = new cjs.Shape();
	this.shape_4156.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAATQgSAHgYgBQgjAAgRgTg");
	this.shape_4156.setTransform(58.5,495.4,0.5,0.5);

	this.shape_4157 = new cjs.Shape();
	this.shape_4157.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4157.setTransform(48.4,496.9,0.5,0.5);

	this.shape_4158 = new cjs.Shape();
	this.shape_4158.graphics.f("#000000").s().p("AgRCYQgSgTAAgqIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgQgSg");
	this.shape_4158.setTransform(663.4,457.2,0.5,0.5);

	this.shape_4159 = new cjs.Shape();
	this.shape_4159.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAvAAAXgZQAXgYAAg3IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgZAqhDAAQhcAAAAhjg");
	this.shape_4159.setTransform(651.8,458.8,0.5,0.5);

	this.shape_4160 = new cjs.Shape();
	this.shape_4160.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_4160.setTransform(638.5,458.7,0.5,0.5);

	this.shape_4161 = new cjs.Shape();
	this.shape_4161.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4161.setTransform(624.8,458.6,0.5,0.5);

	this.shape_4162 = new cjs.Shape();
	this.shape_4162.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_4162.setTransform(609.6,458.8,0.5,0.5);

	this.shape_4163 = new cjs.Shape();
	this.shape_4163.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgTgPgjgMQgngOgRgKQgRgLgIgNQgJgOAAgTQABgeAZgSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgeAAgVALQgUALAAATQAAAWAQAMQAOANArAQQAjAMATAKQARALAIANQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4163.setTransform(589.5,458.7,0.5,0.5);

	this.shape_4164 = new cjs.Shape();
	this.shape_4164.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAATIjCAAQABA4AZAdQAaAdAvAAQAUAAAUgDQATgDAagLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgUgbglAAQgmAAgXAag");
	this.shape_4164.setTransform(576.6,458.7,0.5,0.5);

	this.shape_4165 = new cjs.Shape();
	this.shape_4165.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgQgTgfAAQgpAAgVAXQgTAYgBAwIAACeIgYAAIAAi4QAAhFg+AAQgrAAgTAZQgTAZgBA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBBAAAQAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAXAYAAAzIAACwg");
	this.shape_4165.setTransform(558.4,458.6,0.5,0.5);

	this.shape_4166 = new cjs.Shape();
	this.shape_4166.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_4166.setTransform(544.2,456.2,0.5,0.5);

	this.shape_4167 = new cjs.Shape();
	this.shape_4167.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4167.setTransform(536.9,457.2,0.5,0.5);

	this.shape_4168 = new cjs.Shape();
	this.shape_4168.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA2AAQAvAAAcAhQAbAiAAA5IAAATIjCAAQABA4AZAdQAaAdAuAAQAUAAAWgDQASgEAagKIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgVgbgjAAQgmAAgZAag");
	this.shape_4168.setTransform(525.8,458.7,0.5,0.5);

	this.shape_4169 = new cjs.Shape();
	this.shape_4169.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIAAAAQAOgXAWgMQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4169.setTransform(507.6,458.6,0.5,0.5);

	this.shape_4170 = new cjs.Shape();
	this.shape_4170.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4170.setTransform(488.8,458.7,0.5,0.5);

	this.shape_4171 = new cjs.Shape();
	this.shape_4171.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgSgPgkgMQgogOgQgKQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4171.setTransform(475.3,458.7,0.5,0.5);

	this.shape_4172 = new cjs.Shape();
	this.shape_4172.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgUBEgWAzg");
	this.shape_4172.setTransform(459.7,465.6,0.5,0.5);

	this.shape_4173 = new cjs.Shape();
	this.shape_4173.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4173.setTransform(449.9,458.6,0.5,0.5);

	this.shape_4174 = new cjs.Shape();
	this.shape_4174.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAeglA5AAQA4AAAfAlQAgAmAABAQAABBghAmQggAlg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_4174.setTransform(434.9,458.7,0.5,0.5);

	this.shape_4175 = new cjs.Shape();
	this.shape_4175.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAYAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQALgTAVgMQAUgLAZAAQBBAAARAwIABAAQANgXAWgMQAWgNAdAAQAtAAAVAYQAWAXAAA0IAACwg");
	this.shape_4175.setTransform(416.2,458.6,0.5,0.5);

	this.shape_4176 = new cjs.Shape();
	this.shape_4176.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgMQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4176.setTransform(393.7,458.6,0.5,0.5);

	this.shape_4177 = new cjs.Shape();
	this.shape_4177.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4177.setTransform(374.9,458.7,0.5,0.5);

	this.shape_4178 = new cjs.Shape();
	this.shape_4178.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQAAhCAjgmQAiglA6AAQAjAAAhAMIgIAWQgjgMgaAAQgxAAgZAfQgaAfAAA4QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg5AAghgkg");
	this.shape_4178.setTransform(361.7,458.7,0.5,0.5);

	this.shape_4179 = new cjs.Shape();
	this.shape_4179.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4179.setTransform(347.9,458.6,0.5,0.5);

	this.shape_4180 = new cjs.Shape();
	this.shape_4180.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_4180.setTransform(332.7,458.8,0.5,0.5);

	this.shape_4181 = new cjs.Shape();
	this.shape_4181.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhHAdgjQAdgmA3AAQAeAAAVALQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYgBQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_4181.setTransform(310.6,455.9,0.5,0.5);

	this.shape_4182 = new cjs.Shape();
	this.shape_4182.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4182.setTransform(296,458.6,0.5,0.5);

	this.shape_4183 = new cjs.Shape();
	this.shape_4183.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4183.setTransform(281.2,458.7,0.5,0.5);

	this.shape_4184 = new cjs.Shape();
	this.shape_4184.graphics.f("#000000").s().p("AgyDfQBLhmgBh4QABg+gUg6QgUg7gjgsIAcAAQAjAsATA6QAUA6gBBAQABBCgUA4QgTA4gjArg");
	this.shape_4184.setTransform(264.7,458.4,0.5,0.5);

	this.shape_4185 = new cjs.Shape();
	this.shape_4185.graphics.f("#000000").s().p("ABbC2IiKi/IgxAqIAACVIgZAAIAAlrIAZAAIAAC9IC2i9IAgAAIiUCaICYDRg");
	this.shape_4185.setTransform(255.2,456.4,0.5,0.5);

	this.shape_4186 = new cjs.Shape();
	this.shape_4186.graphics.f("#000000").s().p("AAyC3IAAhcIi6AAIAAgRIC0kAIAeAAIAAD7IA/AAIAAAWIg/AAIAABcgAAVhyIh/C3ICcAAIAAhnQAAhDAEg7IgCAAQgEAHgbAng");
	this.shape_4186.setTransform(239.3,456.3,0.5,0.5);

	this.shape_4187 = new cjs.Shape();
	this.shape_4187.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAogpAQgXQARgXAIgUQAHgUAAgXQAAgggVgVQgVgUgiAAQgtAAgqAhIgNgRQAsgnA4ABQAwAAAaAZQAcAZAAAtQAAAjgTAjQgRAggxAyIhcBgIAAABIDBAAIAAAYg");
	this.shape_4187.setTransform(224.5,456.2,0.5,0.5);

	this.shape_4188 = new cjs.Shape();
	this.shape_4188.graphics.f("#000000").s().p("AgdA/QAUhHAIg2IAcAAIADAGQgTBAgYA3g");
	this.shape_4188.setTransform(207.6,465.6,0.5,0.5);

	this.shape_4189 = new cjs.Shape();
	this.shape_4189.graphics.f("#000000").s().p("ABcC2IiMi/IgwAqIAACVIgaAAIAAlrIAaAAIAAC9IC2i9IAgAAIiUCaICYDRg");
	this.shape_4189.setTransform(199.2,456.4,0.5,0.5);

	this.shape_4190 = new cjs.Shape();
	this.shape_4190.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAogpAQgXQASgXAGgUQAIgUAAgXQAAgggVgVQgVgUgiAAQgtAAgqAhIgOgRQAugnA4ABQAuAAAcAZQAbAZAAAtQAAAkgSAiQgTAggxAyIhbBgIAAABIDBAAIAAAYg");
	this.shape_4190.setTransform(183,456.2,0.5,0.5);

	this.shape_4191 = new cjs.Shape();
	this.shape_4191.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAqgtAOgTQAQgWAJgVQAHgUAAgXQAAgggWgVQgUgUgiAAQguAAgpAhIgNgRQAsgnA4ABQAwAAAaAZQAbAZAAAtQABAkgTAiQgTAigwAwIhcBgIAAABIDCAAIAAAYg");
	this.shape_4191.setTransform(168.5,456.2,0.5,0.5);

	this.shape_4192 = new cjs.Shape();
	this.shape_4192.graphics.f("#000000").s().p("AgdA/QAThDAIg6IAdAAIADAGQgTBAgYA3g");
	this.shape_4192.setTransform(151.6,465.6,0.5,0.5);

	this.shape_4193 = new cjs.Shape();
	this.shape_4193.graphics.f("#000000").s().p("ABbC2IiLi/IgwAqIAACVIgaAAIAAlrIAaAAIAAC9IC2i9IAhAAIiVCaICYDRg");
	this.shape_4193.setTransform(143.1,456.4,0.5,0.5);

	this.shape_4194 = new cjs.Shape();
	this.shape_4194.graphics.f("#000000").s().p("AhUCiQgegZAAgwQAAggAVgZQAUgYAsgRQgpgTgQgVQgQgUAAgfQAAgaANgTQANgUAYgLQAYgLAcAAQAtAAAeAYQAcAXAAApQAAAcgSAWQgSAVgnASQAwATAUAXQATAXAAAiQAAAtgfAbQggAbg0gBQg4AAgcgZgAhGAoQgTAVAAAgQABAjAXATQAYATApAAQAnAAAZgVQAZgUAAgiQAAgfgTgTQgUgUg2gVQguASgUAWgAg4iTQgVASAAAdQAAARAHAPQAIAMAPALQAQALAhAPQApgQARgTQASgTAAgbQAAgdgVgRQgVgSgkAAQgjAAgVARg");
	this.shape_4194.setTransform(127.1,456.3,0.5,0.5);

	this.shape_4195 = new cjs.Shape();
	this.shape_4195.graphics.f("#000000").s().p("AAkC2IAAkIQAAgfADgsIgIAHIhMA9IgOgSIBihKIAVAAIAAFrg");
	this.shape_4195.setTransform(110.8,456.4,0.5,0.5);

	this.shape_4196 = new cjs.Shape();
	this.shape_4196.graphics.f("#000000").s().p("AAXDfQgjgsgTg3QgUg6ABhAQAAhAATg7QASg4AkgtIAcAAQglAvgSA5QgTA4AAA/QAAB5BKBlg");
	this.shape_4196.setTransform(102,458.4,0.5,0.5);

	this.shape_4197 = new cjs.Shape();
	this.shape_4197.graphics.f("#000000").s().p("AhTCiQgegkAAhCQAAhGAdgkQAdgmA4AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYgBQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgrAAgXAfg");
	this.shape_4197.setTransform(83.8,455.9,0.5,0.5);

	this.shape_4198 = new cjs.Shape();
	this.shape_4198.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4198.setTransform(73.7,455.8,0.5,0.5);

	this.shape_4199 = new cjs.Shape();
	this.shape_4199.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4199.setTransform(63.3,458.7,0.5,0.5);

	this.shape_4200 = new cjs.Shape();
	this.shape_4200.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQAAgdARgSQAQgSAfgHQgMgFgIgKQgHgKAAgMQAAgaAjgVQgYgJgOgVQgNgVABgbQgBgpAagYQAagYAsAAQAbAAANAFIBXAAIAAARIg4ADQAWAdAAAhQAAAngaAYQgZAYgsAAQgSAAgHgBQgQAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQArAAAZASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgcgUgAhgB6QABA4BTAAQBpAAAAhEQAAgYgQgLQgRgLglAAIgsAAQhKAAgBA6gAg4igQgSASAAAhQgBAgAUARQATARAfAAQAgAAATgRQASgRAAghQAAgjgTgRQgRgRghAAQghAAgSATg");
	this.shape_4200.setTransform(49.2,461.6,0.5,0.5);

	this.shape_4201 = new cjs.Shape();
	this.shape_4201.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA6AFAbIABAAQAQg9AGgQIA4ikIAVAAIA1CjQARA4AFAWIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_4201.setTransform(675.7,420.4,0.5,0.5);

	this.shape_4202 = new cjs.Shape();
	this.shape_4202.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4202.setTransform(659,420.4,0.5,0.5);

	this.shape_4203 = new cjs.Shape();
	this.shape_4203.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4203.setTransform(648.7,417.5,0.5,0.5);

	this.shape_4204 = new cjs.Shape();
	this.shape_4204.graphics.f("#000000").s().p("AgMDCIAAmCIAYAAIAAGCg");
	this.shape_4204.setTransform(642.9,417.5,0.5,0.5);

	this.shape_4205 = new cjs.Shape();
	this.shape_4205.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAbAhABA6IAAATIjDAAQABA4AZAdQAaAdAuAAQAVAAAVgDQASgDAagLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_4205.setTransform(633,420.4,0.5,0.5);

	this.shape_4206 = new cjs.Shape();
	this.shape_4206.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQALgHAHgMQAKgQAIgYIANgjIhnkOIAaAAIA4CYQAbBFAHAZIAAAAQAKggAZg/IA4iXIAaAAIh5E6QgOAlgKAPQgJAMgOAIQgOAHgSAAQgOAAgSgGg");
	this.shape_4206.setTransform(620.2,423.5,0.5,0.5);

	this.shape_4207 = new cjs.Shape();
	this.shape_4207.graphics.f("#000000").s().p("AgRCYQgSgTABgqIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgSAFgWAAQgkAAgQgSg");
	this.shape_4207.setTransform(603.3,418.9,0.5,0.5);

	this.shape_4208 = new cjs.Shape();
	this.shape_4208.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAQAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4208.setTransform(592,420.5,0.5,0.5);

	this.shape_4209 = new cjs.Shape();
	this.shape_4209.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAARAEIgEAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_4209.setTransform(581.6,420.3,0.5,0.5);

	this.shape_4210 = new cjs.Shape();
	this.shape_4210.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4210.setTransform(568.5,420.5,0.5,0.5);

	this.shape_4211 = new cjs.Shape();
	this.shape_4211.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgYAAIAAmCIAYAAIgCELIABAAICKiXIAdAAIhpByIByCcg");
	this.shape_4211.setTransform(557.2,417.5,0.5,0.5);

	this.shape_4212 = new cjs.Shape();
	this.shape_4212.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgXAZQgWAYAAA3IAACVIgZAAIAAmCIAZAAIgBCdIACAAQAQgZAWgKQAWgLAiAAQBcAAABBiIAACxg");
	this.shape_4212.setTransform(535.8,417.5,0.5,0.5);

	this.shape_4213 = new cjs.Shape();
	this.shape_4213.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgKgMgUQgOgUAAgcQAAgpAagYQAagYAsAAQAaAAAOAFIBXAAIAAARIg4ADQAWAdAAAhQAAAmgaAZQgaAYgrAAQgSAAgIgBQgOAIgIAKQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgjAXg/AAQgyAAgdgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAhAAASgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_4213.setTransform(521.6,423.4,0.5,0.5);

	this.shape_4214 = new cjs.Shape();
	this.shape_4214.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_4214.setTransform(512,418,0.5,0.5);

	this.shape_4215 = new cjs.Shape();
	this.shape_4215.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAmCIAZAAIgBCdIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4215.setTransform(501.7,417.5,0.5,0.5);

	this.shape_4216 = new cjs.Shape();
	this.shape_4216.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAVAAAYAHIgGAVQgUgGgUAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4216.setTransform(484.5,417.5,0.5,0.5);

	this.shape_4217 = new cjs.Shape();
	this.shape_4217.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4217.setTransform(472.3,420.4,0.5,0.5);

	this.shape_4218 = new cjs.Shape();
	this.shape_4218.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4218.setTransform(453.8,418.9,0.5,0.5);

	this.shape_4219 = new cjs.Shape();
	this.shape_4219.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgkAAQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_4219.setTransform(442.3,420.3,0.5,0.5);

	this.shape_4220 = new cjs.Shape();
	this.shape_4220.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABg/AggnQAggnA0AAQAwAAAcAhQAbAhABA6IAAATIjDAAQABA4AZAdQAaAdAuAAQAVAAAVgDQASgDAagLIAAAWQgYAKgSAEQgSADgaAAQg6AAgggkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgUgbglAAQglAAgYAag");
	this.shape_4220.setTransform(427.7,420.4,0.5,0.5);

	this.shape_4221 = new cjs.Shape();
	this.shape_4221.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgQgTgfAAQgpAAgVAXQgTAYgBAwIAACeIgYAAIAAi4QAAhFg+AAQgrAAgTAZQgTAZgBA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAUgMQAVgLAZAAQBBAAAQAwIABAAQANgXAXgMQAWgNAcAAQAtAAAWAYQAXAYAAAzIAACwg");
	this.shape_4221.setTransform(409.5,420.3,0.5,0.5);

	this.shape_4222 = new cjs.Shape();
	this.shape_4222.graphics.f("#000000").s().p("AgSCYQgQgTgBgqIAAitIgnAAIAAgPIAngLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQgBAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgTAFgWAAQgkAAgRgSg");
	this.shape_4222.setTransform(393.7,418.9,0.5,0.5);

	this.shape_4223 = new cjs.Shape();
	this.shape_4223.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4223.setTransform(385.5,420.3,0.5,0.5);

	this.shape_4224 = new cjs.Shape();
	this.shape_4224.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_4224.setTransform(372.2,420.4,0.5,0.5);

	this.shape_4225 = new cjs.Shape();
	this.shape_4225.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgogOgQgKQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQAsAAAoAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4225.setTransform(358.7,420.4,0.5,0.5);

	this.shape_4226 = new cjs.Shape();
	this.shape_4226.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgogOgQgKQgRgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAoAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAPANArAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4226.setTransform(346.8,420.4,0.5,0.5);

	this.shape_4227 = new cjs.Shape();
	this.shape_4227.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgVAbgVAKQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAQAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4227.setTransform(333.8,420.5,0.5,0.5);

	this.shape_4228 = new cjs.Shape();
	this.shape_4228.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4228.setTransform(313.4,420.3,0.5,0.5);

	this.shape_4229 = new cjs.Shape();
	this.shape_4229.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAQAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4229.setTransform(298.6,420.5,0.5,0.5);

	this.shape_4230 = new cjs.Shape();
	this.shape_4230.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdgmA4AAQAdAAAVALQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYgBQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4230.setTransform(277.7,417.7,0.5,0.5);

	this.shape_4231 = new cjs.Shape();
	this.shape_4231.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAhgBA6IAAATIjCAAQABA4AZAdQAaAdAuAAQAUAAAWgDQASgDAagLIAAAWQgXAKgUAEQgSADgZAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgUgbgkAAQgmAAgYAag");
	this.shape_4231.setTransform(263.5,420.4,0.5,0.5);

	this.shape_4232 = new cjs.Shape();
	this.shape_4232.graphics.f("#000000").s().p("AhgCHIAAgPICgjoIiUAAIAAgWIC0AAIAAAPIigDpIChAAIAAAVg");
	this.shape_4232.setTransform(250.6,420.4,0.5,0.5);

	this.shape_4233 = new cjs.Shape();
	this.shape_4233.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_4233.setTransform(241.9,418,0.5,0.5);

	this.shape_4234 = new cjs.Shape();
	this.shape_4234.graphics.f("#000000").s().p("AgLDCIAAmCIAXAAIAAGCg");
	this.shape_4234.setTransform(236.1,417.5,0.5,0.5);

	this.shape_4235 = new cjs.Shape();
	this.shape_4235.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_4235.setTransform(230.4,418,0.5,0.5);

	this.shape_4236 = new cjs.Shape();
	this.shape_4236.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4236.setTransform(223,418.9,0.5,0.5);

	this.shape_4237 = new cjs.Shape();
	this.shape_4237.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_4237.setTransform(211.3,420.6,0.5,0.5);

	this.shape_4238 = new cjs.Shape();
	this.shape_4238.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAbAhAAA6IAAATIjBAAQABA4AZAdQAZAdAvAAQAUAAAUgDQATgDAagLIAAAWQgXAKgUAEQgRADgZAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_4238.setTransform(190.3,420.4,0.5,0.5);

	this.shape_4239 = new cjs.Shape();
	this.shape_4239.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgXAZQgWAYAAA3IAACVIgZAAIAAmCIAZAAIgBCdIACAAQAPgZAXgKQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_4239.setTransform(175.8,417.5,0.5,0.5);

	this.shape_4240 = new cjs.Shape();
	this.shape_4240.graphics.f("#000000").s().p("AhvCtIAAgaQAmARA+AAQAsAAAagUQAagWAAggQAAgVgIgOQgJgNgUgMQgSgKgngOQg3gRgWgXQgVgWAAgmQAAgpAggZQAggaAxAAQA0AAAtATIgJAXQgtgUgqABQgoAAgXASQgYATAAAgQAAAVAHAMQAHANARAKQASALAmAOQAsAOAUANQAWAOAKASQAJARAAAaQAAAtghAbQghAag3AAQhEAAgigOg");
	this.shape_4240.setTransform(161.3,418.1,0.5,0.5);

	this.shape_4241 = new cjs.Shape();
	this.shape_4241.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_4241.setTransform(144.7,426.2,0.5,0.5);

	this.shape_4242 = new cjs.Shape();
	this.shape_4242.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAKgHAHgMQAKgQAIgYIAOgjIhokOIAZAAIA6CYQAaBFAGAZIABAAQALggAXg/IA6iXIAZAAIh4E6QgOAlgLAPQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_4242.setTransform(135.8,423.5,0.5,0.5);

	this.shape_4243 = new cjs.Shape();
	this.shape_4243.graphics.f("#000000").s().p("AgRCYQgSgTABgqIAAitIgpAAIAAgPIApgLIAMg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAfALAPQALAPAXAAQAWAAASgEIAAAUQgSAFgXAAQgiAAgRgSg");
	this.shape_4243.setTransform(125.5,418.9,0.5,0.5);

	this.shape_4244 = new cjs.Shape();
	this.shape_4244.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgEAGgIAAQgPAAAAgYg");
	this.shape_4244.setTransform(118.5,418,0.5,0.5);

	this.shape_4245 = new cjs.Shape();
	this.shape_4245.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAABhjg");
	this.shape_4245.setTransform(108,420.6,0.5,0.5);

	this.shape_4246 = new cjs.Shape();
	this.shape_4246.graphics.f("#000000").s().p("ABaDHIAAhnIABg+IgBAAQgdAvg+AAQg2AAgdgjQgdgjAAhCQAAhEAdgmQAeglA2AAQA6AAAdArIACAAIAEgmIAVAAIAAGIgAhBiRQgWAfAAA8QAAA3AWAeQAXAdApAAQAxAAAVgcQAVgbAAg/IAAgDQAAg9gVgbQgWgbguAAQgqAAgYAfg");
	this.shape_4246.setTransform(92.6,423.4,0.5,0.5);

	this.shape_4247 = new cjs.Shape();
	this.shape_4247.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAHQgDAGgIAAQgPAAAAgYg");
	this.shape_4247.setTransform(82.5,418,0.5,0.5);

	this.shape_4248 = new cjs.Shape();
	this.shape_4248.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4248.setTransform(75.2,418.9,0.5,0.5);

	this.shape_4249 = new cjs.Shape();
	this.shape_4249.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4249.setTransform(63.7,420.3,0.5,0.5);

	this.shape_4250 = new cjs.Shape();
	this.shape_4250.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4250.setTransform(48.8,420.5,0.5,0.5);

	this.shape_4251 = new cjs.Shape();
	this.shape_4251.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_4251.setTransform(649.6,382.2,0.5,0.5);

	this.shape_4252 = new cjs.Shape();
	this.shape_4252.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4252.setTransform(640.3,379.7,0.5,0.5);

	this.shape_4253 = new cjs.Shape();
	this.shape_4253.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4253.setTransform(630,382.1,0.5,0.5);

	this.shape_4254 = new cjs.Shape();
	this.shape_4254.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgVAagVALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_4254.setTransform(615.2,382.2,0.5,0.5);

	this.shape_4255 = new cjs.Shape();
	this.shape_4255.graphics.f("#000000").s().p("AheCzQgcgTABgjQAAgcARgTQAQgSAegHQgMgFgHgKQgHgJgBgNQAAgaAjgVQgYgKgMgUQgOgUAAgcQAAgoAagZQAagYArAAQAbAAAOAFIBWAAIAAARIg4ADQAXAdAAAhQAAAngaAYQgaAYgrAAQgSAAgIgBQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAXASQAYARAAAkQAAArgiAXQgkAXg+AAQgzAAgdgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAABA6gAg5igQgSASAAAhQAAAfATASQAUARAfAAQAhAAASgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgTATg");
	this.shape_4255.setTransform(602.3,385.1,0.5,0.5);

	this.shape_4256 = new cjs.Shape();
	this.shape_4256.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4256.setTransform(591.5,382.1,0.5,0.5);

	this.shape_4257 = new cjs.Shape();
	this.shape_4257.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4257.setTransform(578.2,382.2,0.5,0.5);

	this.shape_4258 = new cjs.Shape();
	this.shape_4258.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAVAAAYAHIgGAVQgUgGgUAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4258.setTransform(561.1,379.2,0.5,0.5);

	this.shape_4259 = new cjs.Shape();
	this.shape_4259.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4259.setTransform(549,382.2,0.5,0.5);

	this.shape_4260 = new cjs.Shape();
	this.shape_4260.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AggnQAggnA1AAQAwAAAcAhQAbAiAAA5IAAATIjCAAQAAA3AaAeQAaAdAuAAQAVAAAUgDQASgDAbgLIAAAWQgXAKgUAEQgSADgZAAQg5AAgigkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_4260.setTransform(527.9,382.2,0.5,0.5);

	this.shape_4261 = new cjs.Shape();
	this.shape_4261.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgogOgQgKQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQAsAAAoAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4261.setTransform(514.8,382.2,0.5,0.5);

	this.shape_4262 = new cjs.Shape();
	this.shape_4262.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4262.setTransform(501.5,382.1,0.5,0.5);

	this.shape_4263 = new cjs.Shape();
	this.shape_4263.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAbAiABA5IAAATIjDAAQABA4AaAdQAZAdAvAAQATAAAWgDQASgDAagLIAAAWQgYAKgSAEQgTADgYAAQg6AAghgkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgUgbglAAQglAAgZAag");
	this.shape_4263.setTransform(487,382.2,0.5,0.5);

	this.shape_4264 = new cjs.Shape();
	this.shape_4264.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgSgPglgMQgngOgQgKQgRgKgIgOQgIgOgBgTQAAgeAagSQAZgRAuAAQArAAAnAQIgJAWQgngQgiAAQggAAgUALQgTALAAATQgBAWAPAMQAQANArAQQAjAMASAKQAQAKAJAOQAIANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4264.setTransform(473.9,382.2,0.5,0.5);

	this.shape_4265 = new cjs.Shape();
	this.shape_4265.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4265.setTransform(454.2,382.2,0.5,0.5);

	this.shape_4266 = new cjs.Shape();
	this.shape_4266.graphics.f("#000000").s().p("AhUCiQgdgjAAhDQAAhGAdgkQAegmA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgXAeABA7QAAB0BYgBQAuAAAVgbQAWgZAAg+IAAgFQAAg+gWgbQgVgbguAAQgrAAgXAfg");
	this.shape_4266.setTransform(433.3,379.4,0.5,0.5);

	this.shape_4267 = new cjs.Shape();
	this.shape_4267.graphics.f("#000000").s().p("AgMDCIAAmCIAYAAIAAGCg");
	this.shape_4267.setTransform(423.3,379.3,0.5,0.5);

	this.shape_4268 = new cjs.Shape();
	this.shape_4268.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4268.setTransform(412.9,382.2,0.5,0.5);

	this.shape_4269 = new cjs.Shape();
	this.shape_4269.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAYAAA3IAACVIgZAAIAAmCIAZAAIgBCdIABAAQARgZAWgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_4269.setTransform(398,379.3,0.5,0.5);

	this.shape_4270 = new cjs.Shape();
	this.shape_4270.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_4270.setTransform(376.3,382.1,0.5,0.5);

	this.shape_4271 = new cjs.Shape();
	this.shape_4271.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgnQAggnA0AAQAwAAAcAhQAbAhABA6IAAATIjDAAQABA4AZAdQAaAdAuAAQAVAAAVgDQASgDAagLIAAAWQgYAKgTAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_4271.setTransform(361.7,382.2,0.5,0.5);

	this.shape_4272 = new cjs.Shape();
	this.shape_4272.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4272.setTransform(350.3,380.7,0.5,0.5);

	this.shape_4273 = new cjs.Shape();
	this.shape_4273.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4273.setTransform(343.2,379.2,0.5,0.5);

	this.shape_4274 = new cjs.Shape();
	this.shape_4274.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4274.setTransform(331.1,382.2,0.5,0.5);

	this.shape_4275 = new cjs.Shape();
	this.shape_4275.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgSgPglgMQgngOgRgKQgQgKgIgOQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQABAWAPAMQAPANAqAQQAkAMARAKQARAKAIAOQAJANAAATQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_4275.setTransform(311,382.2,0.5,0.5);

	this.shape_4276 = new cjs.Shape();
	this.shape_4276.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4276.setTransform(297.7,382.1,0.5,0.5);

	this.shape_4277 = new cjs.Shape();
	this.shape_4277.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_4277.setTransform(287.2,379.7,0.5,0.5);

	this.shape_4278 = new cjs.Shape();
	this.shape_4278.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmCIAZAAIgCELIABAAICJiXIAeAAIhpByIBzCcg");
	this.shape_4278.setTransform(279.3,379.3,0.5,0.5);

	this.shape_4279 = new cjs.Shape();
	this.shape_4279.graphics.f("#000000").s().p("AgSCYQgRgTAAgqIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgTAFgXAAQgjAAgRgSg");
	this.shape_4279.setTransform(267.5,380.7,0.5,0.5);

	this.shape_4280 = new cjs.Shape();
	this.shape_4280.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4280.setTransform(256.2,382.2,0.5,0.5);

	this.shape_4281 = new cjs.Shape();
	this.shape_4281.graphics.f("#000000").s().p("ABdC2IhQkXQgKgjgDgWQgHAdgFAUIhREfIgVAAIhklrIAbAAIBVFDQAGgiAThFIA+jcIAcAAIBJD9QANAtAFAaIAIgnIBNkdIAaAAIhlFrg");
	this.shape_4281.setTransform(238.5,379.9,0.5,0.5);

	this.shape_4282 = new cjs.Shape();
	this.shape_4282.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAKgGQAKgHAHgMQAJgNAJgbIANgjIhnkOIAaAAIA4CYQAaBCAIAcIAAAAQAKggAZg/IA4iXIAaAAIh4E6QgPAmgKAOQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_4282.setTransform(214.7,385.3,0.5,0.5);

	this.shape_4283 = new cjs.Shape();
	this.shape_4283.graphics.f("#000000").s().p("Ag0C4QgWgLgOgWIgDAAIgHAoIgQAAIAAmCIAaAAIgCCfIACAAQAOgZAWgLQAWgMAeAAQA6AAAbAkQAdAlABBCQAABDgfAmQgeAkg2AAQgcAAgYgMgAhEgiQgVAcABA9IAAAFQgBA+AWAZQAWAbAtAAQAsAAAWgeQAWggAAg5QAAh0hYAAQgvgBgVAcg");
	this.shape_4283.setTransform(201.6,379.4,0.5,0.5);

	this.shape_4284 = new cjs.Shape();
	this.shape_4284.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAcAhgBA6IAAATIjCAAQACA4AYAdQAaAdAuAAQAUAAAWgDQASgDAagLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgUgbgkAAQgmAAgYAag");
	this.shape_4284.setTransform(180,382.2,0.5,0.5);

	this.shape_4285 = new cjs.Shape();
	this.shape_4285.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhGAdgkQAdgmA4AAQAdAAAVALQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYgBQAuAAAVgbQAWgZAAg+IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4285.setTransform(165,379.4,0.5,0.5);

	this.shape_4286 = new cjs.Shape();
	this.shape_4286.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAagWALQgWALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAQAAAfQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4286.setTransform(150.6,382.2,0.5,0.5);

	this.shape_4287 = new cjs.Shape();
	this.shape_4287.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4287.setTransform(133.2,382.1,0.5,0.5);

	this.shape_4288 = new cjs.Shape();
	this.shape_4288.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgSgPgkgMQgogOgRgKQgQgLgIgNQgJgOAAgTQAAgeAagSQAZgRAtAAQAtAAAmAQIgJAWQgngQgjAAQgfAAgUALQgUALAAATQABAWAPAMQAOANArAQQAjAMATAKQAPAKAKAOQAIANAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4288.setTransform(109.2,382.2,0.5,0.5);

	this.shape_4289 = new cjs.Shape();
	this.shape_4289.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAwAAAbAhQAcAhgBA6IAAATIjCAAQACA4AYAdQAaAdAuAAQAUAAAVgDQATgDAagLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgYAZgEAyICmAAQABgvgVgbQgUgbgkAAQgmAAgYAag");
	this.shape_4289.setTransform(96.3,382.2,0.5,0.5);

	this.shape_4290 = new cjs.Shape();
	this.shape_4290.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_4290.setTransform(83.6,382.2,0.5,0.5);

	this.shape_4291 = new cjs.Shape();
	this.shape_4291.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAATIjCAAQAAA3AaAeQAaAdAuAAQAVAAAUgDQAUgDAZgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQAAgwgUgaQgVgbgjAAQgmAAgYAag");
	this.shape_4291.setTransform(70.2,382.2,0.5,0.5);

	this.shape_4292 = new cjs.Shape();
	this.shape_4292.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_4292.setTransform(60.4,379.7,0.5,0.5);

	this.shape_4293 = new cjs.Shape();
	this.shape_4293.graphics.f("#000000").s().p("AhsC2IAAlrIBYAAQCCAAAABpQAAA1gkAaQglAdhAAAIg5AAIAACWgAhUAKIAzAAQA8AAAcgTQAbgVAAgtQAAgqgagVQgagUg1AAIg9AAg");
	this.shape_4293.setTransform(50.6,379.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_4293},{t:this.shape_4292},{t:this.shape_4291},{t:this.shape_4290},{t:this.shape_4289},{t:this.shape_4288},{t:this.shape_4287},{t:this.shape_4286},{t:this.shape_4285},{t:this.shape_4284},{t:this.shape_4283},{t:this.shape_4282},{t:this.shape_4281},{t:this.shape_4280},{t:this.shape_4279},{t:this.shape_4278},{t:this.shape_4277},{t:this.shape_4276},{t:this.shape_4275},{t:this.shape_4274},{t:this.shape_4273},{t:this.shape_4272},{t:this.shape_4271},{t:this.shape_4270},{t:this.shape_4269},{t:this.shape_4268},{t:this.shape_4267},{t:this.shape_4266},{t:this.shape_4265},{t:this.shape_4264},{t:this.shape_4263},{t:this.shape_4262},{t:this.shape_4261},{t:this.shape_4260},{t:this.shape_4259},{t:this.shape_4258},{t:this.shape_4257},{t:this.shape_4256},{t:this.shape_4255},{t:this.shape_4254},{t:this.shape_4253},{t:this.shape_4252},{t:this.shape_4251},{t:this.shape_4250},{t:this.shape_4249},{t:this.shape_4248},{t:this.shape_4247},{t:this.shape_4246},{t:this.shape_4245},{t:this.shape_4244},{t:this.shape_4243},{t:this.shape_4242},{t:this.shape_4241},{t:this.shape_4240},{t:this.shape_4239},{t:this.shape_4238},{t:this.shape_4237},{t:this.shape_4236},{t:this.shape_4235},{t:this.shape_4234},{t:this.shape_4233},{t:this.shape_4232},{t:this.shape_4231},{t:this.shape_4230},{t:this.shape_4229},{t:this.shape_4228},{t:this.shape_4227},{t:this.shape_4226},{t:this.shape_4225},{t:this.shape_4224},{t:this.shape_4223},{t:this.shape_4222},{t:this.shape_4221},{t:this.shape_4220},{t:this.shape_4219},{t:this.shape_4218},{t:this.shape_4217},{t:this.shape_4216},{t:this.shape_4215},{t:this.shape_4214},{t:this.shape_4213},{t:this.shape_4212},{t:this.shape_4211},{t:this.shape_4210},{t:this.shape_4209},{t:this.shape_4208},{t:this.shape_4207},{t:this.shape_4206},{t:this.shape_4205},{t:this.shape_4204},{t:this.shape_4203},{t:this.shape_4202},{t:this.shape_4201},{t:this.shape_4200},{t:this.shape_4199},{t:this.shape_4198},{t:this.shape_4197},{t:this.shape_4196},{t:this.shape_4195},{t:this.shape_4194},{t:this.shape_4193},{t:this.shape_4192},{t:this.shape_4191},{t:this.shape_4190},{t:this.shape_4189},{t:this.shape_4188},{t:this.shape_4187},{t:this.shape_4186},{t:this.shape_4185},{t:this.shape_4184},{t:this.shape_4183},{t:this.shape_4182},{t:this.shape_4181},{t:this.shape_4180},{t:this.shape_4179},{t:this.shape_4178},{t:this.shape_4177},{t:this.shape_4176},{t:this.shape_4175},{t:this.shape_4174},{t:this.shape_4173},{t:this.shape_4172},{t:this.shape_4171},{t:this.shape_4170},{t:this.shape_4169},{t:this.shape_4168},{t:this.shape_4167},{t:this.shape_4166},{t:this.shape_4165},{t:this.shape_4164},{t:this.shape_4163},{t:this.shape_4162},{t:this.shape_4161},{t:this.shape_4160},{t:this.shape_4159},{t:this.shape_4158},{t:this.shape_4157},{t:this.shape_4156},{t:this.shape_4155},{t:this.shape_4154},{t:this.shape_4153},{t:this.shape_4152},{t:this.shape_4151},{t:this.shape_4150},{t:this.shape_4149},{t:this.shape_4148},{t:this.shape_4147},{t:this.shape_4146},{t:this.shape_4145},{t:this.shape_4144},{t:this.shape_4143},{t:this.shape_4142},{t:this.shape_4141},{t:this.shape_4140},{t:this.shape_4139},{t:this.shape_4138},{t:this.shape_4137},{t:this.shape_4136},{t:this.shape_4135},{t:this.shape_4134},{t:this.shape_4133},{t:this.shape_4132},{t:this.shape_4131},{t:this.shape_4130},{t:this.shape_4129},{t:this.shape_4128},{t:this.shape_4127},{t:this.shape_4126},{t:this.shape_4125},{t:this.shape_4124},{t:this.shape_4123},{t:this.shape_4122},{t:this.shape_4121},{t:this.shape_4120},{t:this.shape_4119},{t:this.shape_4118},{t:this.shape_4117},{t:this.shape_4116},{t:this.shape_4115},{t:this.shape_4114},{t:this.shape_4113},{t:this.shape_4112},{t:this.shape_4111},{t:this.shape_4110},{t:this.shape_4109},{t:this.shape_4108},{t:this.shape_4107},{t:this.shape_4106},{t:this.shape_4105},{t:this.shape_4104},{t:this.shape_4103},{t:this.shape_4102},{t:this.shape_4101},{t:this.shape_4100},{t:this.shape_4099},{t:this.shape_4098},{t:this.shape_4097},{t:this.shape_4096},{t:this.shape_4095},{t:this.shape_4094},{t:this.shape_4093},{t:this.shape_4092},{t:this.shape_4091},{t:this.shape_4090},{t:this.shape_4089},{t:this.shape_4088},{t:this.shape_4087},{t:this.shape_4086},{t:this.shape_4085},{t:this.shape_4084},{t:this.shape_4083},{t:this.shape_4082},{t:this.shape_4081},{t:this.shape_4080},{t:this.shape_4079},{t:this.shape_4078},{t:this.shape_4077},{t:this.shape_4076},{t:this.shape_4075},{t:this.shape_4074},{t:this.shape_4073},{t:this.shape_4072},{t:this.shape_4071},{t:this.shape_4070},{t:this.shape_4069},{t:this.shape_4068},{t:this.shape_4067},{t:this.shape_4066},{t:this.shape_4065},{t:this.shape_4064},{t:this.shape_4063},{t:this.shape_4062},{t:this.shape_4061},{t:this.shape_4060},{t:this.shape_4059},{t:this.shape_4058},{t:this.shape_4057},{t:this.shape_4056},{t:this.shape_4055},{t:this.shape_4054},{t:this.shape_4053},{t:this.shape_4052},{t:this.shape_4051},{t:this.shape_4050},{t:this.shape_4049},{t:this.shape_4048},{t:this.shape_4047},{t:this.shape_4046},{t:this.shape_4045},{t:this.shape_4044},{t:this.shape_4043},{t:this.shape_4042},{t:this.shape_4041},{t:this.shape_4040},{t:this.shape_4039},{t:this.shape_4038},{t:this.shape_4037},{t:this.shape_4036},{t:this.shape_4035},{t:this.shape_4034},{t:this.shape_4033},{t:this.shape_4032},{t:this.shape_4031},{t:this.shape_4030},{t:this.shape_4029},{t:this.shape_4028},{t:this.shape_4027},{t:this.shape_4026},{t:this.shape_4025},{t:this.shape_4024},{t:this.shape_4023},{t:this.shape_4022},{t:this.shape_4021},{t:this.shape_4020},{t:this.shape_4019},{t:this.shape_4018},{t:this.shape_4017},{t:this.shape_4016},{t:this.shape_4015},{t:this.shape_4014},{t:this.shape_4013},{t:this.shape_4012},{t:this.shape_4011},{t:this.shape_4010},{t:this.instance_17},{t:this.instance_16}]},106).to({state:[]},1).wait(58));

	// ButtonLeftRight copy 30
	this.buttonR_6 = new lib.ButtonLeft_Right();
	this.buttonR_6.name = "buttonR_6";
	this.buttonR_6.parent = this;
	this.buttonR_6.setTransform(2025,513.5,1,1,180);
	new cjs.ButtonHelper(this.buttonR_6, 0, 1, 1);

	this.buttonR14 = new lib.ButtonLeft_Right();
	this.buttonR14.name = "buttonR14";
	this.buttonR14.parent = this;
	this.buttonR14.setTransform(2025,513.5,1,1,180);
	new cjs.ButtonHelper(this.buttonR14, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.buttonR_6}]},61).to({state:[{t:this.buttonR14}]},44).to({state:[]},1).wait(59));

	// ButtonLeftRight copy 31
	this.buttonL14 = new lib.ButtonLeft_Right();
	this.buttonL14.name = "buttonL14";
	this.buttonL14.parent = this;
	this.buttonL14.setTransform(0,437.2);
	this.buttonL14._off = true;
	new cjs.ButtonHelper(this.buttonL14, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL14).wait(61).to({_off:false},0).to({_off:true},45).wait(59));

	// Layer 1
	this.instance_18 = new lib.green_stone_draw();
	this.instance_18.parent = this;
	this.instance_18.setTransform(1026.7,557.9);
	this.instance_18._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_18).wait(61).to({_off:false},0).to({y:556.6},14).to({y:556.3,alpha:0},8).to({_off:true},1).wait(81));

	// Layer 1
	this.instance_19 = new lib.green_stone();
	this.instance_19.parent = this;
	this.instance_19.setTransform(718.3,547.2);
	this.instance_19.alpha = 0;
	this.instance_19._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_19).wait(71).to({_off:false},0).to({alpha:1},16).wait(18).to({_off:true},1).wait(59));

	// ButtonLeftRight copy 28
	this.buttonR13 = new lib.ButtonLeft_Right();
	this.buttonR13.name = "buttonR13";
	this.buttonR13.parent = this;
	this.buttonR13.setTransform(2025,513.5,1,1,180);
	this.buttonR13._off = true;
	new cjs.ButtonHelper(this.buttonR13, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR13).wait(60).to({_off:false},0).to({_off:true},1).wait(104));

	// ButtonLeftRight copy 29
	this.buttonL13 = new lib.ButtonLeft_Right();
	this.buttonL13.name = "buttonL13";
	this.buttonL13.parent = this;
	this.buttonL13.setTransform(0,437.2);
	this.buttonL13._off = true;
	new cjs.ButtonHelper(this.buttonL13, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL13).wait(60).to({_off:false},0).to({_off:true},1).wait(104));

	// Layer 1
	this.shape_4294 = new cjs.Shape();
	this.shape_4294.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUABQgTgBAAgYg");
	this.shape_4294.setTransform(353.2,689.4,0.5,0.5);

	this.shape_4295 = new cjs.Shape();
	this.shape_4295.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAbAiQAcAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgXAKgUADQgUAFgXAAQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgagjgBQgnABgXAZg");
	this.shape_4295.setTransform(343.2,683.6,0.5,0.5);

	this.shape_4296 = new cjs.Shape();
	this.shape_4296.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4296.setTransform(333.3,680.7,0.5,0.5);

	this.shape_4297 = new cjs.Shape();
	this.shape_4297.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4297.setTransform(323.2,680.8,0.5,0.5);

	this.shape_4298 = new cjs.Shape();
	this.shape_4298.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4298.setTransform(308,683.6,0.5,0.5);

	this.shape_4299 = new cjs.Shape();
	this.shape_4299.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4299.setTransform(297.2,682.1,0.5,0.5);

	this.shape_4300 = new cjs.Shape();
	this.shape_4300.graphics.f("#000000").s().p("AhABoQgggkAAhDQAAhCAiglQAiglA6AAQAjAAAgALIgGAWQgigLgbAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAghglg");
	this.shape_4300.setTransform(287.4,683.6,0.5,0.5);

	this.shape_4301 = new cjs.Shape();
	this.shape_4301.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4301.setTransform(278.2,681.1,0.5,0.5);

	this.shape_4302 = new cjs.Shape();
	this.shape_4302.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA2AAQAeAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_4302.setTransform(267.3,680.8,0.5,0.5);

	this.shape_4303 = new cjs.Shape();
	this.shape_4303.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA2AAQAvgBAcAiQAbAhAAA5IAAAUIjCAAQABA4AZAcQAaAeAuAAQAZAAARgDQASgEAagLIAAAXQgXAKgUADQgUAFgXAAQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgugVgbQgVgagjgBQgnABgXAZg");
	this.shape_4303.setTransform(253.1,683.6,0.5,0.5);

	this.shape_4304 = new cjs.Shape();
	this.shape_4304.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_4304.setTransform(242,683.5,0.5,0.5);

	this.shape_4305 = new cjs.Shape();
	this.shape_4305.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAGAmIABAAQAcgrA8AAQA3AAAcAkQAdAkAABEQABBBgfAmQgeAlg0AAQg+AAgcgvIgDAAIADCkgAhDiWQgWAZABA8IAAAIQgBA+AWAbQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_4305.setTransform(229,686.5,0.5,0.5);

	this.shape_4306 = new cjs.Shape();
	this.shape_4306.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4306.setTransform(213.6,683.5,0.5,0.5);

	this.shape_4307 = new cjs.Shape();
	this.shape_4307.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAkAAQAugBAYgYQAWgaAAg2IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgcAqhBAAQhdAAAAhjg");
	this.shape_4307.setTransform(198.4,683.7,0.5,0.5);

	this.shape_4308 = new cjs.Shape();
	this.shape_4308.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAUAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgbQAVgbAAg8IAAgFQAAg9gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_4308.setTransform(176.3,680.8,0.5,0.5);

	this.shape_4309 = new cjs.Shape();
	this.shape_4309.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4309.setTransform(161.7,683.5,0.5,0.5);

	this.shape_4310 = new cjs.Shape();
	this.shape_4310.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4310.setTransform(146.9,683.6,0.5,0.5);

	this.shape_4311 = new cjs.Shape();
	this.shape_4311.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4311.setTransform(129.5,682.1,0.5,0.5);

	this.shape_4312 = new cjs.Shape();
	this.shape_4312.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAiglA6AAQAkAAAfALIgGAWQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAbAfAsAAQAlAAAfgNIAAAWQgaANgpABQg6AAghglg");
	this.shape_4312.setTransform(119.6,683.6,0.5,0.5);

	this.shape_4313 = new cjs.Shape();
	this.shape_4313.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gCIAzgBIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagWALQgWALgbAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4313.setTransform(106.1,683.6,0.5,0.5);

	this.shape_4314 = new cjs.Shape();
	this.shape_4314.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_4314.setTransform(95.7,683.5,0.5,0.5);

	this.shape_4315 = new cjs.Shape();
	this.shape_4315.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgSgUg");
	this.shape_4315.setTransform(85.4,682.1,0.5,0.5);

	this.shape_4316 = new cjs.Shape();
	this.shape_4316.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgRgOglgNQgogOgQgLQgRgKgIgNQgJgNAAgUQABgeAZgSQAagRAtAAQArAAAnAQIgJAWQgogQghAAQghAAgTALQgUALABATQgBAWAQAMQAOAMArARQAjAMATAKQAQALAJANQAIANAAATQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_4316.setTransform(75.3,683.6,0.5,0.5);

	this.shape_4317 = new cjs.Shape();
	this.shape_4317.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWggAAg4QAAh0hYAAQgvAAgVAbg");
	this.shape_4317.setTransform(62.2,680.8,0.5,0.5);

	this.shape_4318 = new cjs.Shape();
	this.shape_4318.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4318.setTransform(47,683.6,0.5,0.5);

	this.shape_4319 = new cjs.Shape();
	this.shape_4319.graphics.f("#000000").s().p("ABTDCIAAiwQAAgogSgSQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAQgZAWgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_4319.setTransform(791.5,642.4,0.5,0.5);

	this.shape_4320 = new cjs.Shape();
	this.shape_4320.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4320.setTransform(779.5,643.8,0.5,0.5);

	this.shape_4321 = new cjs.Shape();
	this.shape_4321.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhgkQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4321.setTransform(767.9,645.3,0.5,0.5);

	this.shape_4322 = new cjs.Shape();
	this.shape_4322.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQARgZAUgKQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4322.setTransform(753.3,642.5,0.5,0.5);

	this.shape_4323 = new cjs.Shape();
	this.shape_4323.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4323.setTransform(730.7,642.5,0.5,0.5);

	this.shape_4324 = new cjs.Shape();
	this.shape_4324.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAcAggBA6IAAAUIjBAAQABA4AYAcQAaAeAvAAQAXAAARgDQATgDAagMIAAAXQgXAKgUADQgVAFgVAAQg6AAgiglgAg2hcQgZAbgDAvICmAAQAAgugUgbQgUgagkgBQgmABgYAZg");
	this.shape_4324.setTransform(716.5,645.3,0.5,0.5);

	this.shape_4325 = new cjs.Shape();
	this.shape_4325.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgvAAgYAYQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4325.setTransform(702,645.2,0.5,0.5);

	this.shape_4326 = new cjs.Shape();
	this.shape_4326.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4326.setTransform(691.6,642.9,0.5,0.5);

	this.shape_4327 = new cjs.Shape();
	this.shape_4327.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4327.setTransform(681.5,645.3,0.5,0.5);

	this.shape_4328 = new cjs.Shape();
	this.shape_4328.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggABQgpAAgVAWQgTAXAAAxIAACeIgZAAIAAi4QAAhEg+AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4328.setTransform(664,645.2,0.5,0.5);

	this.shape_4329 = new cjs.Shape();
	this.shape_4329.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAbAgAAA6IAAAUIjBAAQABA4AYAcQAaAeAvAAQAYAAAQgDQATgDAagMIAAAXQgXAKgUADQgVAFgVAAQg6AAgiglgAg2hcQgXAagFAwICmAAQAAgugUgbQgUgagkgBQgnABgXAZg");
	this.shape_4329.setTransform(645.7,645.3,0.5,0.5);

	this.shape_4330 = new cjs.Shape();
	this.shape_4330.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4330.setTransform(634.6,645.2,0.5,0.5);

	this.shape_4331 = new cjs.Shape();
	this.shape_4331.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4331.setTransform(617.7,643.8,0.5,0.5);

	this.shape_4332 = new cjs.Shape();
	this.shape_4332.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4332.setTransform(606.4,645.3,0.5,0.5);

	this.shape_4333 = new cjs.Shape();
	this.shape_4333.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4333.setTransform(592.6,642.4,0.5,0.5);

	this.shape_4334 = new cjs.Shape();
	this.shape_4334.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_4334.setTransform(580.6,643.8,0.5,0.5);

	this.shape_4335 = new cjs.Shape();
	this.shape_4335.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAKgHAHgMQAJgOAJgZIANgkIhnkOIAZAAIA6CYQAaBFAGAZIABAAQALggAXg/IA6iXIAZAAIh5E6QgNAlgLAPQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_4335.setTransform(564,648.4,0.5,0.5);

	this.shape_4336 = new cjs.Shape();
	this.shape_4336.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAARADIgEAYQgPgEgUAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4336.setTransform(554.1,645.2,0.5,0.5);

	this.shape_4337 = new cjs.Shape();
	this.shape_4337.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4337.setTransform(545.3,642.4,0.5,0.5);

	this.shape_4338 = new cjs.Shape();
	this.shape_4338.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAggmQAggnA1AAQAwgBAcAiQAbAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgXAKgUADQgUAFgXAAQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgagkgBQgmABgXAZg");
	this.shape_4338.setTransform(535.5,645.3,0.5,0.5);

	this.shape_4339 = new cjs.Shape();
	this.shape_4339.graphics.f("#000000").s().p("ABNCHIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAOA2AGAfIACAAQAOg7AHgSIA4ilIAVAAIA1CkQAQAyAGAbIACAAQABgNAThJIApibIAZAAIhKEOg");
	this.shape_4339.setTransform(519.2,645.3,0.5,0.5);

	this.shape_4340 = new cjs.Shape();
	this.shape_4340.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAg/AhgnQAggnA0AAQAwgBAcAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAYAAASgDQASgDAagMIAAAXQgXAKgUADQgVAFgWAAQg5AAgiglgAg3hcQgXAbgEAvICnAAQAAgugVgbQgUgaglgBQglABgZAZg");
	this.shape_4340.setTransform(503,645.3,0.5,0.5);

	this.shape_4341 = new cjs.Shape();
	this.shape_4341.graphics.f("#000000").s().p("AgwDwIAAgWQARAFAPAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAigPASQgQASgcAAQgVAAgNgGgAARjdQAAgYAQAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgQAAAAgYg");
	this.shape_4341.setTransform(491.5,645.9,0.5,0.5);

	this.shape_4342 = new cjs.Shape();
	this.shape_4342.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQgBgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgJgMgVQgOgUAAgcQAAgnAagaQAZgYAtAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgIgBQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgiAXQgkAXg+AAQg0AAgbgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgTgRQgSgRggAAQghAAgSATg");
	this.shape_4342.setTransform(477,648.3,0.5,0.5);

	this.shape_4343 = new cjs.Shape();
	this.shape_4343.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4343.setTransform(462.9,645.2,0.5,0.5);

	this.shape_4344 = new cjs.Shape();
	this.shape_4344.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4344.setTransform(452.4,642.9,0.5,0.5);

	this.shape_4345 = new cjs.Shape();
	this.shape_4345.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQABAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4345.setTransform(445.1,643.8,0.5,0.5);

	this.shape_4346 = new cjs.Shape();
	this.shape_4346.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4346.setTransform(433.8,645.3,0.5,0.5);

	this.shape_4347 = new cjs.Shape();
	this.shape_4347.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggnA0AAQAwgBAcAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAYAAASgDQASgDAagMIAAAXQgYAKgTADQgVAFgWAAQg5AAgiglgAg3hcQgXAbgEAvICmAAQABgugVgbQgUgaglgBQglABgZAZg");
	this.shape_4347.setTransform(420.5,645.3,0.5,0.5);

	this.shape_4348 = new cjs.Shape();
	this.shape_4348.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4348.setTransform(409.4,645.2,0.5,0.5);

	this.shape_4349 = new cjs.Shape();
	this.shape_4349.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhCAiglQAiglA6AAQAjAAAgALIgGAWQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAggglg");
	this.shape_4349.setTransform(397.8,645.3,0.5,0.5);

	this.shape_4350 = new cjs.Shape();
	this.shape_4350.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4350.setTransform(377.3,645.3,0.5,0.5);

	this.shape_4351 = new cjs.Shape();
	this.shape_4351.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4351.setTransform(367,642.9,0.5,0.5);

	this.shape_4352 = new cjs.Shape();
	this.shape_4352.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4352.setTransform(356.1,642.5,0.5,0.5);

	this.shape_4353 = new cjs.Shape();
	this.shape_4353.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_4353.setTransform(341.3,645.5,0.5,0.5);

	this.shape_4354 = new cjs.Shape();
	this.shape_4354.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4354.setTransform(329.4,643.8,0.5,0.5);

	this.shape_4355 = new cjs.Shape();
	this.shape_4355.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAUgNABgWQAAgUgRgPQgQgOgmgNQgogOgQgLQgRgKgIgNQgIgNAAgUQgBgeAagSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAOAMQAQANArAQQAjAMASAKQAPAJAKAPQAIAOAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_4355.setTransform(319.3,645.3,0.5,0.5);

	this.shape_4356 = new cjs.Shape();
	this.shape_4356.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4356.setTransform(299.6,645.3,0.5,0.5);

	this.shape_4357 = new cjs.Shape();
	this.shape_4357.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAxgBAaAiQAcAhAAA5IAAAUIjCAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgWAKgVADQgUAFgXAAQg5AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4357.setTransform(279.7,645.3,0.5,0.5);

	this.shape_4358 = new cjs.Shape();
	this.shape_4358.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_4358.setTransform(268.2,643.8,0.5,0.5);

	this.shape_4359 = new cjs.Shape();
	this.shape_4359.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4359.setTransform(256.9,645.3,0.5,0.5);

	this.shape_4360 = new cjs.Shape();
	this.shape_4360.graphics.f("#000000").s().p("AgLCHIhpkOIAZAAIBGC4QAOAiAHAbIABAAQALgjAKgbIBGi3IAZAAIhpEOg");
	this.shape_4360.setTransform(244.8,645.3,0.5,0.5);

	this.shape_4361 = new cjs.Shape();
	this.shape_4361.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4361.setTransform(236.1,642.9,0.5,0.5);

	this.shape_4362 = new cjs.Shape();
	this.shape_4362.graphics.f("#000000").s().p("AgRCXQgRgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgQAGgYAAQgjAAgRgUg");
	this.shape_4362.setTransform(228.7,643.8,0.5,0.5);

	this.shape_4363 = new cjs.Shape();
	this.shape_4363.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4363.setTransform(221.8,642.4,0.5,0.5);

	this.shape_4364 = new cjs.Shape();
	this.shape_4364.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACuQAAApASATQASATAjAAQAvgBAYgYQAWgZAAg3IAAiUIAYAAIAAEOIgUAAIgFglIgCAAQgaAqhCAAQhdAAAAhjg");
	this.shape_4364.setTransform(211.3,645.5,0.5,0.5);

	this.shape_4365 = new cjs.Shape();
	this.shape_4365.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAiglA6AAQAjAAAgALIgGAWQgigLgbAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAghglg");
	this.shape_4365.setTransform(198.1,645.3,0.5,0.5);

	this.shape_4366 = new cjs.Shape();
	this.shape_4366.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4366.setTransform(177.6,645.3,0.5,0.5);

	this.shape_4367 = new cjs.Shape();
	this.shape_4367.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_4367.setTransform(165.7,643.8,0.5,0.5);

	this.shape_4368 = new cjs.Shape();
	this.shape_4368.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNgBgWQAAgUgQgPQgQgOgmgNQgogOgQgLQgRgLgIgMQgJgNAAgUQAAgeAagSQAagRAsAAQAsAAAnAQIgJAWQgogQgiAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArARQAjAMATAKQAPAJAKAPQAIANAAATQAAAkgbAUQgcATgyABQg1gBghgQg");
	this.shape_4368.setTransform(149,645.3,0.5,0.5);

	this.shape_4369 = new cjs.Shape();
	this.shape_4369.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4369.setTransform(138.7,643.8,0.5,0.5);

	this.shape_4370 = new cjs.Shape();
	this.shape_4370.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgUgQgPQgSgOglgNQgogOgQgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAbgRArAAQAsAAAoAQIgKAWQgogQgiAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArARQAjAMATAKQAQALAJANQAIANAAATQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4370.setTransform(128.5,645.3,0.5,0.5);

	this.shape_4371 = new cjs.Shape();
	this.shape_4371.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4371.setTransform(119.8,642.9,0.5,0.5);

	this.shape_4372 = new cjs.Shape();
	this.shape_4372.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4372.setTransform(112.5,643.8,0.5,0.5);

	this.shape_4373 = new cjs.Shape();
	this.shape_4373.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAARADIgEAYQgPgEgUAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4373.setTransform(104.3,645.2,0.5,0.5);

	this.shape_4374 = new cjs.Shape();
	this.shape_4374.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4374.setTransform(91.2,645.3,0.5,0.5);

	this.shape_4375 = new cjs.Shape();
	this.shape_4375.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxgBAbAiQAcAhAAA5IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAYAAAQgDQATgEAZgLIAAAXQgWAKgTADQgVAFgWAAQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgugUgbQgVgagkgBQgmABgYAZg");
	this.shape_4375.setTransform(71.3,645.3,0.5,0.5);

	this.shape_4376 = new cjs.Shape();
	this.shape_4376.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_4376.setTransform(56.9,642.4,0.5,0.5);

	this.shape_4377 = new cjs.Shape();
	this.shape_4377.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4377.setTransform(44.8,643.8,0.5,0.5);

	this.shape_4378 = new cjs.Shape();
	this.shape_4378.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4378.setTransform(753.8,604.3,0.5,0.5);

	this.shape_4379 = new cjs.Shape();
	this.shape_4379.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAcAiQAcAggBA6IAAAUIjCAAQACA4AYAcQAaAeAvAAQAXAAARgDQATgDAagMIAAAXQgXAKgUADQgVAFgVAAQg6AAgiglgAg2hcQgZAbgDAvICmAAQAAgugUgbQgUgagkgBQgnABgXAZg");
	this.shape_4379.setTransform(739.7,607.1,0.5,0.5);

	this.shape_4380 = new cjs.Shape();
	this.shape_4380.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAQA/AEAWIABAAQAQg+AGgPIA3ilIAWAAIA1CkQASA8AEARIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_4380.setTransform(723.4,607.1,0.5,0.5);

	this.shape_4381 = new cjs.Shape();
	this.shape_4381.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4381.setTransform(706.7,607.1,0.5,0.5);

	this.shape_4382 = new cjs.Shape();
	this.shape_4382.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4382.setTransform(696.4,604.2,0.5,0.5);

	this.shape_4383 = new cjs.Shape();
	this.shape_4383.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4383.setTransform(690.6,604.2,0.5,0.5);

	this.shape_4384 = new cjs.Shape();
	this.shape_4384.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4384.setTransform(680.5,607.1,0.5,0.5);

	this.shape_4385 = new cjs.Shape();
	this.shape_4385.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4385.setTransform(659.6,604.3,0.5,0.5);

	this.shape_4386 = new cjs.Shape();
	this.shape_4386.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAcgqBCAAQBbAAABBjIAACwg");
	this.shape_4386.setTransform(645,607,0.5,0.5);

	this.shape_4387 = new cjs.Shape();
	this.shape_4387.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4387.setTransform(630.2,607.1,0.5,0.5);

	this.shape_4388 = new cjs.Shape();
	this.shape_4388.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4388.setTransform(613.2,607,0.5,0.5);

	this.shape_4389 = new cjs.Shape();
	this.shape_4389.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgaglgBQgmABgXAZg");
	this.shape_4389.setTransform(600.3,607.1,0.5,0.5);

	this.shape_4390 = new cjs.Shape();
	this.shape_4390.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4390.setTransform(590.5,604.6,0.5,0.5);

	this.shape_4391 = new cjs.Shape();
	this.shape_4391.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4391.setTransform(584.7,604.2,0.5,0.5);

	this.shape_4392 = new cjs.Shape();
	this.shape_4392.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgaglgBQgmABgXAZg");
	this.shape_4392.setTransform(574.8,607.1,0.5,0.5);

	this.shape_4393 = new cjs.Shape();
	this.shape_4393.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4393.setTransform(563.4,605.6,0.5,0.5);

	this.shape_4394 = new cjs.Shape();
	this.shape_4394.graphics.f("#000000").s().p("AB8C3IgyiAIiUAAIgyCAIgcAAICSltIAQAAICPFtgAgNhjIgzCCICBAAIhAisQgHAagHAQg");
	this.shape_4394.setTransform(551.6,604.7,0.5,0.5);

	this.shape_4395 = new cjs.Shape();
	this.shape_4395.graphics.f("#000000").s().p("ABNCHIg7i0QgHgVgHghIgCAAIhMDqIgYAAIhOkOIAbAAIArCdQAOA2AGAfIACAAQANg2AIgXIA4ilIAVAAIA1CkQATA8ADARIACAAQABgNAThJIApibIAZAAIhKEOg");
	this.shape_4395.setTransform(528.1,607.1,0.5,0.5);

	this.shape_4396 = new cjs.Shape();
	this.shape_4396.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAwgBAbAiQAcAggBA6IAAAUIjCAAQABA4AZAcQAaAeAuAAQAZAAAQgDQATgDAagMIAAAXQgXAKgUADQgUAFgXAAQg5AAgiglgAg2hcQgXAagFAwICmAAQAAgugUgbQgUgagkgBQgmABgYAZg");
	this.shape_4396.setTransform(511.9,607.1,0.5,0.5);

	this.shape_4397 = new cjs.Shape();
	this.shape_4397.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4397.setTransform(497.5,607,0.5,0.5);

	this.shape_4398 = new cjs.Shape();
	this.shape_4398.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA4AZAcQAaAeAuAAQAZAAARgDQASgEAagLIAAAXQgXAKgTADQgWAFgWAAQg5AAgiglgAg3hcQgXAbgEAvICnAAQAAgugVgbQgUgaglgBQglABgZAZg");
	this.shape_4398.setTransform(476.3,607.1,0.5,0.5);

	this.shape_4399 = new cjs.Shape();
	this.shape_4399.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAQgZAXgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_4399.setTransform(461.8,604.2,0.5,0.5);

	this.shape_4400 = new cjs.Shape();
	this.shape_4400.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4400.setTransform(449.8,605.6,0.5,0.5);

	this.shape_4401 = new cjs.Shape();
	this.shape_4401.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_4401.setTransform(431.6,607,0.5,0.5);

	this.shape_4402 = new cjs.Shape();
	this.shape_4402.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4402.setTransform(421.1,604.6,0.5,0.5);

	this.shape_4403 = new cjs.Shape();
	this.shape_4403.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgbQAVgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4403.setTransform(403.6,604.3,0.5,0.5);

	this.shape_4404 = new cjs.Shape();
	this.shape_4404.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AaAcQAZAeAvAAQAYAAAQgDQASgDAbgMIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4404.setTransform(389.4,607.1,0.5,0.5);

	this.shape_4405 = new cjs.Shape();
	this.shape_4405.graphics.f("#000000").s().p("AgMCHIhokOIAZAAIBGC4QAOAiAHAbIABAAQAKgiALgcIBGi3IAZAAIhpEOg");
	this.shape_4405.setTransform(376.6,607.1,0.5,0.5);

	this.shape_4406 = new cjs.Shape();
	this.shape_4406.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4406.setTransform(366.7,607,0.5,0.5);

	this.shape_4407 = new cjs.Shape();
	this.shape_4407.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgDAagMIAAAXQgWAKgUADQgUAFgWAAQg6AAgiglgAg2hcQgYAagEAwICmAAQAAgvgVgaQgTgaglgBQgmABgXAZg");
	this.shape_4407.setTransform(353.8,607.1,0.5,0.5);

	this.shape_4408 = new cjs.Shape();
	this.shape_4408.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgWQAAgUgRgPQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgogQgiAAQggAAgTALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQAQALAJANQAIAOAAASQAAAkgcAUQgaATgzABQg1gBghgQg");
	this.shape_4408.setTransform(340.8,607.1,0.5,0.5);

	this.shape_4409 = new cjs.Shape();
	this.shape_4409.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgDAagMIAAAXQgWAKgUADQgUAFgWAAQg6AAgiglgAg2hcQgYAagEAwICmAAQAAgvgVgaQgTgaglgBQgmABgXAZg");
	this.shape_4409.setTransform(328,607.1,0.5,0.5);

	this.shape_4410 = new cjs.Shape();
	this.shape_4410.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4410.setTransform(316.9,607,0.5,0.5);

	this.shape_4411 = new cjs.Shape();
	this.shape_4411.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_4411.setTransform(303.8,610,0.5,0.5);

	this.shape_4412 = new cjs.Shape();
	this.shape_4412.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvgBAbAiQAcAhAAA5IAAAUIjBAAQgBA3AaAdQAaAeAvAAQAYAAAQgDQASgDAagMIAAAXQgWAKgUADQgVAFgVAAQg6AAgiglgAg2hcQgZAbgDAvICmAAQAAgvgUgaQgVgagjgBQgmABgYAZg");
	this.shape_4412.setTransform(282.2,607.1,0.5,0.5);

	this.shape_4413 = new cjs.Shape();
	this.shape_4413.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_4413.setTransform(271.1,607,0.5,0.5);

	this.shape_4414 = new cjs.Shape();
	this.shape_4414.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxgBAbAiQAcAgAAA6IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgSADQgWAFgVAAQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgugUgbQgUgaglgBQgmABgYAZg");
	this.shape_4414.setTransform(258.3,607.1,0.5,0.5);

	this.shape_4415 = new cjs.Shape();
	this.shape_4415.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA3AFAeIABAAQAQg+AGgPIA3ilIAWAAIA1CkQASA8AEARIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_4415.setTransform(242.1,607.1,0.5,0.5);

	this.shape_4416 = new cjs.Shape();
	this.shape_4416.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgogQgiAAQggAAgTALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQAQALAJANQAIAOAAASQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4416.setTransform(220.2,607.1,0.5,0.5);

	this.shape_4417 = new cjs.Shape();
	this.shape_4417.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgDAbgMIAAAXQgWAKgVADQgUAFgWAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4417.setTransform(207.4,607.1,0.5,0.5);

	this.shape_4418 = new cjs.Shape();
	this.shape_4418.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4418.setTransform(197.5,604.2,0.5,0.5);

	this.shape_4419 = new cjs.Shape();
	this.shape_4419.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAGAmIABAAQAcgrA8AAQA3AAAcAkQAdAkAABEQAABBgeAmQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhDiWQgVAZAAA8IAAAIQAAA+AUAbQAWAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_4419.setTransform(187.4,610,0.5,0.5);

	this.shape_4420 = new cjs.Shape();
	this.shape_4420.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4420.setTransform(176.6,604.6,0.5,0.5);

	this.shape_4421 = new cjs.Shape();
	this.shape_4421.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAiglA6AAQAjAAAgALIgGAWQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAggglg");
	this.shape_4421.setTransform(167.9,607.1,0.5,0.5);

	this.shape_4422 = new cjs.Shape();
	this.shape_4422.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4422.setTransform(154.1,607,0.5,0.5);

	this.shape_4423 = new cjs.Shape();
	this.shape_4423.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_4423.setTransform(143.6,604.6,0.5,0.5);

	this.shape_4424 = new cjs.Shape();
	this.shape_4424.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4424.setTransform(136.7,607,0.5,0.5);

	this.shape_4425 = new cjs.Shape();
	this.shape_4425.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlg0AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_4425.setTransform(123.6,610,0.5,0.5);

	this.shape_4426 = new cjs.Shape();
	this.shape_4426.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgWAKgVADQgUAFgXAAQg5AAghglgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgagkgBQgmABgYAZg");
	this.shape_4426.setTransform(102,607.1,0.5,0.5);

	this.shape_4427 = new cjs.Shape();
	this.shape_4427.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgWQAAgUgRgPQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgogQgiAAQggAAgTALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQAQALAJANQAIAOAAASQAAAkgcAUQgaATgzABQg1gBghgQg");
	this.shape_4427.setTransform(89,607.1,0.5,0.5);

	this.shape_4428 = new cjs.Shape();
	this.shape_4428.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgWAKgVADQgUAFgXAAQg5AAghglgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgagkgBQgmABgYAZg");
	this.shape_4428.setTransform(76.2,607.1,0.5,0.5);

	this.shape_4429 = new cjs.Shape();
	this.shape_4429.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAQgZAXgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_4429.setTransform(61.7,604.2,0.5,0.5);

	this.shape_4430 = new cjs.Shape();
	this.shape_4430.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_4430.setTransform(47.4,604.7,0.5,0.5);

	this.shape_4431 = new cjs.Shape();
	this.shape_4431.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUABQgTgBAAgYg");
	this.shape_4431.setTransform(826.2,574.6,0.5,0.5);

	this.shape_4432 = new cjs.Shape();
	this.shape_4432.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4432.setTransform(816,568.8,0.5,0.5);

	this.shape_4433 = new cjs.Shape();
	this.shape_4433.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAASgEIAAAUQgRAGgYAAQgiAAgRgUg");
	this.shape_4433.setTransform(805.3,567.3,0.5,0.5);

	this.shape_4434 = new cjs.Shape();
	this.shape_4434.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4434.setTransform(794,568.8,0.5,0.5);

	this.shape_4435 = new cjs.Shape();
	this.shape_4435.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_4435.setTransform(782.6,565.9,0.5,0.5);

	this.shape_4436 = new cjs.Shape();
	this.shape_4436.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_4436.setTransform(767.7,569,0.5,0.5);

	this.shape_4437 = new cjs.Shape();
	this.shape_4437.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAoAAAUgNQAVgNAAgWQAAgUgRgPQgQgOgmgNQgogOgQgLQgQgKgJgNQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgogQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQAQALAJANQAIAOAAASQAAAkgbAUQgcATgyABQg1gBghgQg");
	this.shape_4437.setTransform(754.2,568.8,0.5,0.5);

	this.shape_4438 = new cjs.Shape();
	this.shape_4438.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4438.setTransform(743.9,567.3,0.5,0.5);

	this.shape_4439 = new cjs.Shape();
	this.shape_4439.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4439.setTransform(732.6,568.8,0.5,0.5);

	this.shape_4440 = new cjs.Shape();
	this.shape_4440.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_4440.setTransform(715.4,566.5,0.5,0.5);

	this.shape_4441 = new cjs.Shape();
	this.shape_4441.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4441.setTransform(693.6,568.7,0.5,0.5);

	this.shape_4442 = new cjs.Shape();
	this.shape_4442.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAxgBAaAiQAcAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgEAagLIAAAXQgWAKgUADQgVAFgVAAQg6AAgiglgAg3hcQgXAagEAwICmAAQAAgvgUgaQgVgagkgBQglABgZAZg");
	this.shape_4442.setTransform(680.8,568.8,0.5,0.5);

	this.shape_4443 = new cjs.Shape();
	this.shape_4443.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA2AAQAeAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_4443.setTransform(665.8,566,0.5,0.5);

	this.shape_4444 = new cjs.Shape();
	this.shape_4444.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4444.setTransform(651.2,568.7,0.5,0.5);

	this.shape_4445 = new cjs.Shape();
	this.shape_4445.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAkAAQAugBAYgYQAWgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgcAqhBAAQhdAAAAhjg");
	this.shape_4445.setTransform(636,569,0.5,0.5);

	this.shape_4446 = new cjs.Shape();
	this.shape_4446.graphics.f("#000000").s().p("AhMChQgigkAAhBQAAhBAhgmQAfgnA1AAQAwAAAbAiQAcAhABA4IAAAUIjCAAQAAA3AaAeQAZAdAvABQAYgBAQgDQASgDAagLIAAAWQgVALgVADQgUAEgWAAQg6AAghglgAg3gjQgYAbgDAvICmAAQAAgvgVgaQgUgagkAAQgmAAgYAZgAgbhzIAAgEQAWgYANgTQAVgbAEgIIAjAAIAAAFQgLAOgUAUQgTATgbAYg");
	this.shape_4446.setTransform(614.9,566,0.5,0.5);

	this.shape_4447 = new cjs.Shape();
	this.shape_4447.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAHgLALgcIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgQAngJANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_4447.setTransform(602.1,571.9,0.5,0.5);

	this.shape_4448 = new cjs.Shape();
	this.shape_4448.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4448.setTransform(593.3,566.4,0.5,0.5);

	this.shape_4449 = new cjs.Shape();
	this.shape_4449.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_4449.setTransform(583,568.7,0.5,0.5);

	this.shape_4450 = new cjs.Shape();
	this.shape_4450.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAhgVA+gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgFgrIgDAAQgUAagVALQgYALgaAAQgoAAgXgUgAAeAAQg3ACgaAPQgYAPAAAgQAAAaAQAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_4450.setTransform(568.2,568.8,0.5,0.5);

	this.shape_4451 = new cjs.Shape();
	this.shape_4451.graphics.f("#000000").s().p("Ag9DeIAAgXQATAGASAAQA8AAAAhCIAAluIAaAAIAAFrQgBBchUAAQgXAAgPgGg");
	this.shape_4451.setTransform(556.4,568.8,0.5,0.5);

	this.shape_4452 = new cjs.Shape();
	this.shape_4452.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgUAAQgcAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4452.setTransform(546,565.8,0.5,0.5);

	this.shape_4453 = new cjs.Shape();
	this.shape_4453.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABCghAlQgfAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4453.setTransform(533.9,568.8,0.5,0.5);

	this.shape_4454 = new cjs.Shape();
	this.shape_4454.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhBAhgmQAjglA6AAQAkAAAfALIgGAWQgjgLgaAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAlAAAfgNIAAAWQgbANgpABQg4AAgiglg");
	this.shape_4454.setTransform(514,568.8,0.5,0.5);

	this.shape_4455 = new cjs.Shape();
	this.shape_4455.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4455.setTransform(504.8,566.4,0.5,0.5);

	this.shape_4456 = new cjs.Shape();
	this.shape_4456.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_4456.setTransform(499,565.9,0.5,0.5);

	this.shape_4457 = new cjs.Shape();
	this.shape_4457.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4457.setTransform(488.6,568.8,0.5,0.5);

	this.shape_4458 = new cjs.Shape();
	this.shape_4458.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgQAAIAAmCIAZAAIgBCeIABAAQAQgYAVgLQAVgMAfAAQA5AAAdAkQAdAkAABDQgBBEgeAkQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQAsAAAWgfQAWggAAg4QAAh0hYAAQgvAAgVAbg");
	this.shape_4458.setTransform(474,566,0.5,0.5);

	this.shape_4459 = new cjs.Shape();
	this.shape_4459.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggABQgqAAgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAASAwIAAAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4459.setTransform(454.8,568.7,0.5,0.5);

	this.shape_4460 = new cjs.Shape();
	this.shape_4460.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQALgHAHgMQAHgKALgdIAOgkIhokOIAZAAIA6CYQAZBFAIAZIAAAAQAOgqAUg1IA6iXIAZAAIh4E6QgQAogJAMQgJANgOAHQgOAHgSAAQgOAAgSgGg");
	this.shape_4460.setTransform(437.6,571.9,0.5,0.5);

	this.shape_4461 = new cjs.Shape();
	this.shape_4461.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgQgOgmgNQgogOgQgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAagRAsAAQAtAAAmAQIgJAWQgogQgiAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArARQAjAMATAKQAQALAJANQAIANAAATQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4461.setTransform(425.8,568.8,0.5,0.5);

	this.shape_4462 = new cjs.Shape();
	this.shape_4462.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgaglgBQgmABgXAZg");
	this.shape_4462.setTransform(406.3,568.8,0.5,0.5);

	this.shape_4463 = new cjs.Shape();
	this.shape_4463.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgPgTggABQgpAAgVAWQgTAYgBAwIAACeIgYAAIAAi4QAAhEg+AAQgsAAgSAYQgTAZgBA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAMgUATgLQAVgLAZAAQBBAAAQAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAXAXAAA0IAACwg");
	this.shape_4463.setTransform(388.1,568.7,0.5,0.5);

	this.shape_4464 = new cjs.Shape();
	this.shape_4464.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4464.setTransform(369.6,568.8,0.5,0.5);

	this.shape_4465 = new cjs.Shape();
	this.shape_4465.graphics.f("#000000").s().p("Ag/BoQgiglABhCQgBhBAjgmQAiglA6AAQAjAAAhALIgHAWQgjgLgaAAQgyAAgZAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgpABQg6AAggglg");
	this.shape_4465.setTransform(357.5,568.8,0.5,0.5);

	this.shape_4466 = new cjs.Shape();
	this.shape_4466.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvgBAcAiQAbAgAAA6IAAAUIjBAAQABA4AZAcQAZAeAvAAQAXAAARgDQATgEAagLIAAAXQgXAKgUADQgVAFgVAAQg6AAgiglgAg2hcQgYAbgEAvICmAAQAAgugUgbQgUgagkgBQgmABgYAZg");
	this.shape_4466.setTransform(344.2,568.8,0.5,0.5);

	this.shape_4467 = new cjs.Shape();
	this.shape_4467.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4467.setTransform(330,566,0.5,0.5);

	this.shape_4468 = new cjs.Shape();
	this.shape_4468.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_4468.setTransform(310.3,565.9,0.5,0.5);

	this.shape_4469 = new cjs.Shape();
	this.shape_4469.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4469.setTransform(298.9,568.7,0.5,0.5);

	this.shape_4470 = new cjs.Shape();
	this.shape_4470.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4470.setTransform(285.6,568.8,0.5,0.5);

	this.shape_4471 = new cjs.Shape();
	this.shape_4471.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgZAAIhMkOIAaAAIArCdQAQA/AEAWIACAAQAMg2AJgXIA3ilIAWAAIA1CkQASA8AEARIABAAQADgSAShEIApibIAYAAIhJEOg");
	this.shape_4471.setTransform(268.9,568.8,0.5,0.5);

	this.shape_4472 = new cjs.Shape();
	this.shape_4472.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4472.setTransform(249,568.7,0.5,0.5);

	this.shape_4473 = new cjs.Shape();
	this.shape_4473.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4473.setTransform(240.3,566.4,0.5,0.5);

	this.shape_4474 = new cjs.Shape();
	this.shape_4474.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxgBAbAiQAcAhAAA5IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAYAAAQgDQATgEAZgLIAAAXQgWAKgTADQgVAFgWAAQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgugUgbQgUgaglgBQgmABgYAZg");
	this.shape_4474.setTransform(230.4,568.8,0.5,0.5);

	this.shape_4475 = new cjs.Shape();
	this.shape_4475.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_4475.setTransform(216,565.9,0.5,0.5);

	this.shape_4476 = new cjs.Shape();
	this.shape_4476.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4476.setTransform(203.9,567.3,0.5,0.5);

	this.shape_4477 = new cjs.Shape();
	this.shape_4477.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4477.setTransform(190.2,565.8,0.5,0.5);

	this.shape_4478 = new cjs.Shape();
	this.shape_4478.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhgkQAeglA5AAQA3AAAgAlQAgAmAABAQAABCghAlQgfAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4478.setTransform(178.1,568.8,0.5,0.5);

	this.shape_4479 = new cjs.Shape();
	this.shape_4479.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4479.setTransform(159.5,567.3,0.5,0.5);

	this.shape_4480 = new cjs.Shape();
	this.shape_4480.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4480.setTransform(148,568.7,0.5,0.5);

	this.shape_4481 = new cjs.Shape();
	this.shape_4481.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AfgnQAhgnA1AAQAvgBAcAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAZAAARgDQASgEAagLIAAAXQgXAKgUADQgUAFgXAAQg5AAgiglgAg2hcQgZAbgDAvICmAAQABgugVgbQgUgagkgBQgnABgXAZg");
	this.shape_4481.setTransform(133.4,568.8,0.5,0.5);

	this.shape_4482 = new cjs.Shape();
	this.shape_4482.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggABQgpAAgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgTAYAAA3IAACVIgZAAIAAkOIAUAAIAGAlIABAAQALgTAVgMQAUgLAZAAQBBAAARAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4482.setTransform(115.2,568.7,0.5,0.5);

	this.shape_4483 = new cjs.Shape();
	this.shape_4483.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgnA1AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA4AZAcQAaAeAuAAQAZAAARgDQASgEAagLIAAAXQgXAKgTADQgWAFgWAAQg5AAghglgAg3hcQgXAbgEAvICmAAQABgugVgbQgUgaglgBQglABgZAZg");
	this.shape_4483.setTransform(96.9,568.8,0.5,0.5);

	this.shape_4484 = new cjs.Shape();
	this.shape_4484.graphics.f("#000000").s().p("AgLCHIhpkOIAZAAIBGC4QAOAiAHAbIAAAAQAMgjAJgbIBGi3IAaAAIhpEOg");
	this.shape_4484.setTransform(84.1,568.8,0.5,0.5);

	this.shape_4485 = new cjs.Shape();
	this.shape_4485.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAgglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4485.setTransform(70.7,568.8,0.5,0.5);

	this.shape_4486 = new cjs.Shape();
	this.shape_4486.graphics.f("#000000").s().p("ACdCKIAAixQAAgogPgRQgQgTggABQgpAAgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4486.setTransform(52.1,568.7,0.5,0.5);

	this.shape_4487 = new cjs.Shape();
	this.shape_4487.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4487.setTransform(746.1,527.7,0.5,0.5);

	this.shape_4488 = new cjs.Shape();
	this.shape_4488.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4488.setTransform(736,530.6,0.5,0.5);

	this.shape_4489 = new cjs.Shape();
	this.shape_4489.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgeATgMQASgMAbAAQASAAATADIgFAYQgQgEgTAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4489.setTransform(725.6,530.5,0.5,0.5);

	this.shape_4490 = new cjs.Shape();
	this.shape_4490.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARATAkAAQAwgBAWgYQAXgaAAg2IAAiUIAYAAIAAEOIgUAAIgFglIgBAAQgcAqhBAAQhdAAAAhjg");
	this.shape_4490.setTransform(712.2,530.7,0.5,0.5);

	this.shape_4491 = new cjs.Shape();
	this.shape_4491.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4491.setTransform(700.3,529.1,0.5,0.5);

	this.shape_4492 = new cjs.Shape();
	this.shape_4492.graphics.f("#000000").s().p("Ag/BoQgiglAAhCQAAhCAjglQAiglA6AAQAjAAAhALIgIAWQgggLgdAAQgwAAgaAfQgZAfgBA4QABA3AZAfQAaAfAtAAQAlAAAggNIAAAWQgbANgpABQg6AAggglg");
	this.shape_4492.setTransform(690.4,530.6,0.5,0.5);

	this.shape_4493 = new cjs.Shape();
	this.shape_4493.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgaglgBQgmABgXAZg");
	this.shape_4493.setTransform(677.1,530.6,0.5,0.5);

	this.shape_4494 = new cjs.Shape();
	this.shape_4494.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4494.setTransform(665.6,529.1,0.5,0.5);

	this.shape_4495 = new cjs.Shape();
	this.shape_4495.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4495.setTransform(658.7,528.1,0.5,0.5);

	this.shape_4496 = new cjs.Shape();
	this.shape_4496.graphics.f("#000000").s().p("ABTDCIAAiwQgBgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQARgZAWgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_4496.setTransform(648.3,527.7,0.5,0.5);

	this.shape_4497 = new cjs.Shape();
	this.shape_4497.graphics.f("#000000").s().p("Ag/BoQgiglAAhCQAAhBAjgmQAiglA6AAQAjAAAhALIgHAWQgjgLgbAAQgxAAgZAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgbANgoABQg6AAggglg");
	this.shape_4497.setTransform(635,530.6,0.5,0.5);

	this.shape_4498 = new cjs.Shape();
	this.shape_4498.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAfAAArIAACVg");
	this.shape_4498.setTransform(624.5,530.5,0.5,0.5);

	this.shape_4499 = new cjs.Shape();
	this.shape_4499.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4499.setTransform(611.5,530.6,0.5,0.5);

	this.shape_4500 = new cjs.Shape();
	this.shape_4500.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4500.setTransform(594.1,529.1,0.5,0.5);

	this.shape_4501 = new cjs.Shape();
	this.shape_4501.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0ABQAxgBAbAiQAcAgAAA6IAAAUIjDAAQABA4AaAcQAZAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgSADQgWAFgVAAQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgugUgbQgUgaglgBQgmABgYAZg");
	this.shape_4501.setTransform(583,530.6,0.5,0.5);

	this.shape_4502 = new cjs.Shape();
	this.shape_4502.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAKgGQAKgHAHgMQAIgLAKgcIANgkIhnkOIAaAAIA5CYQAaBFAHAZIAAAAQALggAYg/IA5iXIAZAAIh5E6QgOAlgKAPQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_4502.setTransform(570.2,533.6,0.5,0.5);

	this.shape_4503 = new cjs.Shape();
	this.shape_4503.graphics.f("#000000").s().p("AgdA+QAThCAIg6IAdAAIADAGQgTA/gYA3g");
	this.shape_4503.setTransform(554.6,537.5,0.5,0.5);

	this.shape_4504 = new cjs.Shape();
	this.shape_4504.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQAAgcAQgTQASgSAegHQgNgFgHgKQgIgJABgNQAAgZAigWQgXgIgOgWQgNgUAAgcQAAgoAagZQAagYArAAQAbAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgHgBQgQAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgjAXQgiAXhAAAQgzAAgbgUgAhgB6QAAA4BUAAQBpAAAAhEQAAgYgQgLQgTgLgjAAIgsAAQhLAAAAA6gAg4igQgTASAAAhQAAAgAUARQASARAgAAQAhAAASgRQASgRAAghQAAgjgTgRQgSgRghAAQggAAgSATg");
	this.shape_4504.setTransform(545.6,533.5,0.5,0.5);

	this.shape_4505 = new cjs.Shape();
	this.shape_4505.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4505.setTransform(531.4,530.5,0.5,0.5);

	this.shape_4506 = new cjs.Shape();
	this.shape_4506.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_4506.setTransform(521,528.1,0.5,0.5);

	this.shape_4507 = new cjs.Shape();
	this.shape_4507.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4507.setTransform(510.1,527.8,0.5,0.5);

	this.shape_4508 = new cjs.Shape();
	this.shape_4508.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_4508.setTransform(495.5,530.5,0.5,0.5);

	this.shape_4509 = new cjs.Shape();
	this.shape_4509.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4509.setTransform(485,528.1,0.5,0.5);

	this.shape_4510 = new cjs.Shape();
	this.shape_4510.graphics.f("#000000").s().p("Ag0C4QgWgLgOgXIgDAAIgHApIgPAAIAAmCIAZAAIgDCeIADAAQAOgYAXgLQAUgMAfAAQA5AAAcAkQAdAkAABDQABBEgfAkQgeAlg2AAQgcAAgYgMgAhEgiQgUAbAAA+IAAAFQAAA9AVAaQAVAbAuAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4510.setTransform(474.9,527.8,0.5,0.5);

	this.shape_4511 = new cjs.Shape();
	this.shape_4511.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4511.setTransform(459.5,530.5,0.5,0.5);

	this.shape_4512 = new cjs.Shape();
	this.shape_4512.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAkAAQAugBAYgYQAWgaAAg2IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgcAqhBAAQhdAAAAhjg");
	this.shape_4512.setTransform(444.3,530.7,0.5,0.5);

	this.shape_4513 = new cjs.Shape();
	this.shape_4513.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1ABQAwgBAbAiQAcAhABA5IAAAUIjCAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgEAagLIAAAXQgVAKgUADQgWAFgVAAQg6AAghglgAg3hcQgYAagDAwICmAAQAAgvgUgaQgVgagkgBQgmABgYAZg");
	this.shape_4513.setTransform(423.2,530.6,0.5,0.5);

	this.shape_4514 = new cjs.Shape();
	this.shape_4514.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAWgLAjAAQBcAAAABiIAACxg");
	this.shape_4514.setTransform(408.8,527.7,0.5,0.5);

	this.shape_4515 = new cjs.Shape();
	this.shape_4515.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh3AAIAAFTg");
	this.shape_4515.setTransform(394.5,528.2,0.5,0.5);

	this.shape_4516 = new cjs.Shape();
	this.shape_4516.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAYgUABQgTgBAAgYg");
	this.shape_4516.setTransform(378.2,536.4,0.5,0.5);

	this.shape_4517 = new cjs.Shape();
	this.shape_4517.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4517.setTransform(367.1,527.8,0.5,0.5);

	this.shape_4518 = new cjs.Shape();
	this.shape_4518.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4518.setTransform(357.1,527.7,0.5,0.5);

	this.shape_4519 = new cjs.Shape();
	this.shape_4519.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4519.setTransform(346.7,530.6,0.5,0.5);

	this.shape_4520 = new cjs.Shape();
	this.shape_4520.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQgBgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQgBgaAkgVQgXgIgOgWQgOgUAAgcQABgoAZgZQAZgYAtAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgIgBQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXARAAAkQAAArgiAXQgkAXg+AAQg0AAgbgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgQgLQgTgLgjAAIgsAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgTgRQgSgRggAAQghAAgSATg");
	this.shape_4520.setTransform(332.6,533.5,0.5,0.5);

	this.shape_4521 = new cjs.Shape();
	this.shape_4521.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgbQAVgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4521.setTransform(311.3,527.8,0.5,0.5);

	this.shape_4522 = new cjs.Shape();
	this.shape_4522.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAbAeAuAAQAYAAAQgDQASgEAbgLIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4522.setTransform(297.1,530.6,0.5,0.5);

	this.shape_4523 = new cjs.Shape();
	this.shape_4523.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4523.setTransform(286,530.5,0.5,0.5);

	this.shape_4524 = new cjs.Shape();
	this.shape_4524.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAjAAQAvgBAXgYQAXgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgBAAQgbAqhCAAQhdAAAAhjg");
	this.shape_4524.setTransform(272.6,530.7,0.5,0.5);

	this.shape_4525 = new cjs.Shape();
	this.shape_4525.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgRgUg");
	this.shape_4525.setTransform(260.7,529.1,0.5,0.5);

	this.shape_4526 = new cjs.Shape();
	this.shape_4526.graphics.f("#000000").s().p("ABUCHIhUh4IhVB4IgbAAIBiiKIhfiEIAdAAIBQBzIBPhzIAbAAIhcCEIBjCKg");
	this.shape_4526.setTransform(250.3,530.6,0.5,0.5);

	this.shape_4527 = new cjs.Shape();
	this.shape_4527.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0ABQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgaglgBQgmABgXAZg");
	this.shape_4527.setTransform(236.9,530.6,0.5,0.5);

	this.shape_4528 = new cjs.Shape();
	this.shape_4528.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4528.setTransform(225.5,529.1,0.5,0.5);

	this.shape_4529 = new cjs.Shape();
	this.shape_4529.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_4529.setTransform(217.3,530.5,0.5,0.5);

	this.shape_4530 = new cjs.Shape();
	this.shape_4530.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4530.setTransform(210.3,528.1,0.5,0.5);

	this.shape_4531 = new cjs.Shape();
	this.shape_4531.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQABAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4531.setTransform(203,529.1,0.5,0.5);

	this.shape_4532 = new cjs.Shape();
	this.shape_4532.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_4532.setTransform(196,527.7,0.5,0.5);

	this.shape_4533 = new cjs.Shape();
	this.shape_4533.graphics.f("#000000").s().p("AhpAnIAAiwIAXAAIAACuQAAApASATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_4533.setTransform(185.5,530.7,0.5,0.5);

	this.shape_4534 = new cjs.Shape();
	this.shape_4534.graphics.f("#000000").s().p("ACdCKIAAixQAAgogPgRQgQgTggABQgpAAgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4534.setTransform(166.9,530.5,0.5,0.5);

	this.shape_4535 = new cjs.Shape();
	this.shape_4535.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAUAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgXAeAAA7QAABzBZAAQAuAAAWgbQAVgbAAg8IAAgFQAAg+gVgbQgWgbgvAAQgrAAgWAfg");
	this.shape_4535.setTransform(140.9,527.8,0.5,0.5);

	this.shape_4536 = new cjs.Shape();
	this.shape_4536.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4536.setTransform(126.3,530.5,0.5,0.5);

	this.shape_4537 = new cjs.Shape();
	this.shape_4537.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4537.setTransform(111.5,530.6,0.5,0.5);

	this.shape_4538 = new cjs.Shape();
	this.shape_4538.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_4538.setTransform(94.1,529.1,0.5,0.5);

	this.shape_4539 = new cjs.Shape();
	this.shape_4539.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4539.setTransform(82.8,530.6,0.5,0.5);

	this.shape_4540 = new cjs.Shape();
	this.shape_4540.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4540.setTransform(72.4,530.5,0.5,0.5);

	this.shape_4541 = new cjs.Shape();
	this.shape_4541.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4541.setTransform(59.4,530.6,0.5,0.5);

	this.shape_4542 = new cjs.Shape();
	this.shape_4542.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqByIBzCcg");
	this.shape_4542.setTransform(48,527.7,0.5,0.5);

	this.shape_4543 = new cjs.Shape();
	this.shape_4543.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4543.setTransform(796.1,489.4,0.5,0.5);

	this.shape_4544 = new cjs.Shape();
	this.shape_4544.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQAAgcAQgTQASgSAegHQgMgFgIgKQgIgJABgNQgBgaAkgVQgXgIgOgWQgNgUgBgcQABgoAZgZQAZgYAtAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgHgBQgQAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgjAXQgiAXhAAAQgzAAgbgUgAhgB6QAAA4BUAAQBpAAAAhEQAAgYgQgLQgTgLgjAAIgsAAQhLAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgTgRQgSgRghAAQggAAgSATg");
	this.shape_4544.setTransform(781.9,495.3,0.5,0.5);

	this.shape_4545 = new cjs.Shape();
	this.shape_4545.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4545.setTransform(772.3,489.9,0.5,0.5);

	this.shape_4546 = new cjs.Shape();
	this.shape_4546.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_4546.setTransform(762,489.4,0.5,0.5);

	this.shape_4547 = new cjs.Shape();
	this.shape_4547.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4547.setTransform(740.8,492.3,0.5,0.5);

	this.shape_4548 = new cjs.Shape();
	this.shape_4548.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4548.setTransform(726.3,492.2,0.5,0.5);

	this.shape_4549 = new cjs.Shape();
	this.shape_4549.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_4549.setTransform(715.9,489.9,0.5,0.5);

	this.shape_4550 = new cjs.Shape();
	this.shape_4550.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4550.setTransform(705.8,489.5,0.5,0.5);

	this.shape_4551 = new cjs.Shape();
	this.shape_4551.graphics.f("#000000").s().p("ACdCKIAAixQAAgogPgRQgQgTggABQgqAAgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4551.setTransform(686.6,492.2,0.5,0.5);

	this.shape_4552 = new cjs.Shape();
	this.shape_4552.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4552.setTransform(667.8,492.3,0.5,0.5);

	this.shape_4553 = new cjs.Shape();
	this.shape_4553.graphics.f("#000000").s().p("Ag/BoQgiglAAhCQABhCAiglQAiglA6AAQAjAAAhAMIgHAVQgigLgcAAQgwAAgZAfQgaAeAAA5QAAA3AaAfQAZAfAtAAQAlAAAfgNIAAAWQgbANgoABQg6AAggglg");
	this.shape_4553.setTransform(654.6,492.3,0.5,0.5);

	this.shape_4554 = new cjs.Shape();
	this.shape_4554.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAJgGQALgHAHgMQAHgKAMgdIAMgkIhnkOIAZAAIA6CYQAYBCAJAcIABAAQANgqAUg1IA6iXIAZAAIh4E6QgQAogJAMQgKANgNAHQgOAHgTAAQgNAAgSgGg");
	this.shape_4554.setTransform(635.7,495.4,0.5,0.5);

	this.shape_4555 = new cjs.Shape();
	this.shape_4555.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4555.setTransform(627,489.4,0.5,0.5);

	this.shape_4556 = new cjs.Shape();
	this.shape_4556.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4556.setTransform(621.2,489.4,0.5,0.5);

	this.shape_4557 = new cjs.Shape();
	this.shape_4557.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_4557.setTransform(610.8,492.5,0.5,0.5);

	this.shape_4558 = new cjs.Shape();
	this.shape_4558.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4558.setTransform(600.4,489.3,0.5,0.5);

	this.shape_4559 = new cjs.Shape();
	this.shape_4559.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAxgBAaAiQAcAhAAA5IAAAUIjBAAQAAA3AZAdQAaAeAvAAQAYAAAQgDQASgEAagLIAAAXQgWAKgUADQgUAFgWAAQg6AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgagkgBQgmABgXAZg");
	this.shape_4559.setTransform(588.7,492.3,0.5,0.5);

	this.shape_4560 = new cjs.Shape();
	this.shape_4560.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_4560.setTransform(577.6,492.2,0.5,0.5);

	this.shape_4561 = new cjs.Shape();
	this.shape_4561.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4561.setTransform(564.5,492.3,0.5,0.5);

	this.shape_4562 = new cjs.Shape();
	this.shape_4562.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAiglA6AAQAkAAAfAMIgGAVQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgpABQg5AAghglg");
	this.shape_4562.setTransform(552.5,492.3,0.5,0.5);

	this.shape_4563 = new cjs.Shape();
	this.shape_4563.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4563.setTransform(532,492.3,0.5,0.5);

	this.shape_4564 = new cjs.Shape();
	this.shape_4564.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4564.setTransform(520.1,490.8,0.5,0.5);

	this.shape_4565 = new cjs.Shape();
	this.shape_4565.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4565.setTransform(506.5,489.4,0.5,0.5);

	this.shape_4566 = new cjs.Shape();
	this.shape_4566.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4566.setTransform(500.7,489.4,0.5,0.5);

	this.shape_4567 = new cjs.Shape();
	this.shape_4567.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4567.setTransform(495,489.9,0.5,0.5);

	this.shape_4568 = new cjs.Shape();
	this.shape_4568.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_4568.setTransform(487.1,489.4,0.5,0.5);

	this.shape_4569 = new cjs.Shape();
	this.shape_4569.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgQgOgmgNQgogOgQgLQgRgKgIgNQgJgNABgUQAAgeAZgSQAagRAsAAQAtAAAnAQIgJAWQgpgQgiAAQggAAgTALQgTALgBATQAAAWAPAMQAPAMAsARQAiAMATAKQAQALAJANQAIANAAATQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4569.setTransform(473.7,492.3,0.5,0.5);

	this.shape_4570 = new cjs.Shape();
	this.shape_4570.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAhgnA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgEAagLIAAAXQgYAKgTADQgVAFgVAAQg6AAgiglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4570.setTransform(454.3,492.3,0.5,0.5);

	this.shape_4571 = new cjs.Shape();
	this.shape_4571.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4571.setTransform(439.8,489.4,0.5,0.5);

	this.shape_4572 = new cjs.Shape();
	this.shape_4572.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_4572.setTransform(427.8,490.8,0.5,0.5);

	this.shape_4573 = new cjs.Shape();
	this.shape_4573.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQARgZAWgKQAWgLAiAAQBcAAAABiIAACxg");
	this.shape_4573.setTransform(409.6,489.4,0.5,0.5);

	this.shape_4574 = new cjs.Shape();
	this.shape_4574.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4574.setTransform(397.6,490.8,0.5,0.5);

	this.shape_4575 = new cjs.Shape();
	this.shape_4575.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4575.setTransform(390.6,489.9,0.5,0.5);

	this.shape_4576 = new cjs.Shape();
	this.shape_4576.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCdQAPA3AFAeIABAAQAQg+AGgPIA4ilIAVAAIA1CkQASA8AEARIABAAQADgSARhEIAqibIAZAAIhKEOg");
	this.shape_4576.setTransform(378.5,492.3,0.5,0.5);

	this.shape_4577 = new cjs.Shape();
	this.shape_4577.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4577.setTransform(355.2,492.2,0.5,0.5);

	this.shape_4578 = new cjs.Shape();
	this.shape_4578.graphics.f("#000000").s().p("Ag+B7QgbgRgPggQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCghAlQgfAmg4AAQgjAAgbgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_4578.setTransform(340.1,492.3,0.5,0.5);

	this.shape_4579 = new cjs.Shape();
	this.shape_4579.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4579.setTransform(329.8,489.9,0.5,0.5);

	this.shape_4580 = new cjs.Shape();
	this.shape_4580.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_4580.setTransform(322.4,490.8,0.5,0.5);

	this.shape_4581 = new cjs.Shape();
	this.shape_4581.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAiglA6AAQAjAAAgAMIgGAVQgigLgbAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAghglg");
	this.shape_4581.setTransform(312.6,492.3,0.5,0.5);

	this.shape_4582 = new cjs.Shape();
	this.shape_4582.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4582.setTransform(298.8,492.2,0.5,0.5);

	this.shape_4583 = new cjs.Shape();
	this.shape_4583.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_4583.setTransform(283.6,492.5,0.5,0.5);

	this.shape_4584 = new cjs.Shape();
	this.shape_4584.graphics.f("#000000").s().p("AgwDwIAAgWQARAFAPAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAigPASQgQASgcAAQgVAAgNgGgAARjdQAAgYAQAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgQAAAAgYg");
	this.shape_4584.setTransform(271.6,492.9,0.5,0.5);

	this.shape_4585 = new cjs.Shape();
	this.shape_4585.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBDAAQBcAAAABjIAACwg");
	this.shape_4585.setTransform(262.9,492.2,0.5,0.5);

	this.shape_4586 = new cjs.Shape();
	this.shape_4586.graphics.f("#000000").s().p("Ag+B7QgbgRgPggQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCghAlQggAmg3AAQgjAAgbgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_4586.setTransform(247.9,492.3,0.5,0.5);

	this.shape_4587 = new cjs.Shape();
	this.shape_4587.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAiglA6AAQAjAAAgAMIgGAVQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAggglg");
	this.shape_4587.setTransform(234.6,492.3,0.5,0.5);

	this.shape_4588 = new cjs.Shape();
	this.shape_4588.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4588.setTransform(214.2,492.2,0.5,0.5);

	this.shape_4589 = new cjs.Shape();
	this.shape_4589.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_4589.setTransform(203.8,489.9,0.5,0.5);

	this.shape_4590 = new cjs.Shape();
	this.shape_4590.graphics.f("#000000").s().p("AhfB8IAAgbQAqAUAsAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgQgNgmgOQgogOgQgLQgRgKgIgNQgIgNAAgUQAAgeAZgSQAagRAsAAQAsAAAoAQIgKAWQgogQgiAAQggAAgTALQgUALAAATQAAAWAQAMQAPANAqAQQAlAMARAKQAQALAJANQAIAOAAASQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4590.setTransform(188.2,492.3,0.5,0.5);

	this.shape_4591 = new cjs.Shape();
	this.shape_4591.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4591.setTransform(174.9,492.2,0.5,0.5);

	this.shape_4592 = new cjs.Shape();
	this.shape_4592.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4592.setTransform(159.8,492.3,0.5,0.5);

	this.shape_4593 = new cjs.Shape();
	this.shape_4593.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_4593.setTransform(149.5,489.9,0.5,0.5);

	this.shape_4594 = new cjs.Shape();
	this.shape_4594.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4594.setTransform(142.2,490.8,0.5,0.5);

	this.shape_4595 = new cjs.Shape();
	this.shape_4595.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_4595.setTransform(135.2,489.9,0.5,0.5);

	this.shape_4596 = new cjs.Shape();
	this.shape_4596.graphics.f("#000000").s().p("AhfB8IAAgbQApAUAtAAQAnAAAVgNQAVgNAAgWQAAgUgRgPQgQgOgmgNQgogOgQgLQgRgKgIgNQgJgNAAgUQAAgeAagSQAagRAsAAQAtAAAmAQIgJAWQgogQgiAAQggAAgTALQgUALAAATQABAWAPAMQAOAMArARQAjAMATAKQAQALAJANQAIANAAATQAAAkgcAUQgbATgyABQg1gBghgQg");
	this.shape_4596.setTransform(126.3,492.3,0.5,0.5);

	this.shape_4597 = new cjs.Shape();
	this.shape_4597.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABCghAlQgfAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4597.setTransform(113,492.3,0.5,0.5);

	this.shape_4598 = new cjs.Shape();
	this.shape_4598.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlg0AAQg9AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_4598.setTransform(98.3,495.3,0.5,0.5);

	this.shape_4599 = new cjs.Shape();
	this.shape_4599.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgSQgPgTggABQgpAAgVAWQgTAYAAAwIAACeIgZAAIAAi4QAAhEg+AAQgrAAgTAYQgUAZAAA2IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAMgUATgLQAVgLAZAAQBBAAAQAwIABAAQAOgYAWgLQAWgNAdAAQAsAAAWAYQAWAYABAzIAACwg");
	this.shape_4599.setTransform(79.1,492.2,0.5,0.5);

	this.shape_4600 = new cjs.Shape();
	this.shape_4600.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4600.setTransform(60.3,492.3,0.5,0.5);

	this.shape_4601 = new cjs.Shape();
	this.shape_4601.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAiglA6AAQAjAAAgAMIgGAVQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5AAggglg");
	this.shape_4601.setTransform(47.1,492.3,0.5,0.5);

	this.shape_4602 = new cjs.Shape();
	this.shape_4602.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4602.setTransform(699.6,452.6,0.5,0.5);

	this.shape_4603 = new cjs.Shape();
	this.shape_4603.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAiglA6AAQAkAAAfAMIgGAVQgigLgbAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg4gBghgkg");
	this.shape_4603.setTransform(689.7,454.1,0.5,0.5);

	this.shape_4604 = new cjs.Shape();
	this.shape_4604.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4604.setTransform(676.2,454.1,0.5,0.5);

	this.shape_4605 = new cjs.Shape();
	this.shape_4605.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4605.setTransform(665.8,454,0.5,0.5);

	this.shape_4606 = new cjs.Shape();
	this.shape_4606.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4606.setTransform(655.5,452.6,0.5,0.5);

	this.shape_4607 = new cjs.Shape();
	this.shape_4607.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgKgJgNQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQAQALAJANQAIAOAAASQAAAkgbAUQgcATgyABQg1gBghgRg");
	this.shape_4607.setTransform(645.4,454.1,0.5,0.5);

	this.shape_4608 = new cjs.Shape();
	this.shape_4608.graphics.f("#000000").s().p("Ag0C4QgXgMgOgWIgCAAIgHApIgPAAIAAmCIAYAAIAABhIgBAoIAAAVIABAAQAQgYAWgLQAVgMAeAAQA4AAAeAkQAcAkAABDQAABEgeAkQgfAlg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA8AWAbQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4608.setTransform(632.3,451.3,0.5,0.5);

	this.shape_4609 = new cjs.Shape();
	this.shape_4609.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4609.setTransform(617.1,454.1,0.5,0.5);

	this.shape_4610 = new cjs.Shape();
	this.shape_4610.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4610.setTransform(596.2,451.3,0.5,0.5);

	this.shape_4611 = new cjs.Shape();
	this.shape_4611.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAAABjIAACwg");
	this.shape_4611.setTransform(581.6,454,0.5,0.5);

	this.shape_4612 = new cjs.Shape();
	this.shape_4612.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4612.setTransform(566.8,454.1,0.5,0.5);

	this.shape_4613 = new cjs.Shape();
	this.shape_4613.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4613.setTransform(546.4,454,0.5,0.5);

	this.shape_4614 = new cjs.Shape();
	this.shape_4614.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgXAKgTADQgWAFgWAAQg5AAghglgAg3hcQgXAagEAwICmAAQAAgwgUgZQgUgaglgBQgmABgYAZg");
	this.shape_4614.setTransform(531.8,454.1,0.5,0.5);

	this.shape_4615 = new cjs.Shape();
	this.shape_4615.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_4615.setTransform(517.6,457,0.5,0.5);

	this.shape_4616 = new cjs.Shape();
	this.shape_4616.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4616.setTransform(502.2,454.1,0.5,0.5);

	this.shape_4617 = new cjs.Shape();
	this.shape_4617.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4617.setTransform(480.6,454,0.5,0.5);

	this.shape_4618 = new cjs.Shape();
	this.shape_4618.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4618.setTransform(470.2,451.6,0.5,0.5);

	this.shape_4619 = new cjs.Shape();
	this.shape_4619.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgKgJgNQgIgNAAgUQAAgeAZgSQAagRAtAAQArAAAoAQIgKAWQgogQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQAQALAJANQAIAOAAASQAAAkgbAUQgcATgyABQg1gBghgRg");
	this.shape_4619.setTransform(454.6,454.1,0.5,0.5);

	this.shape_4620 = new cjs.Shape();
	this.shape_4620.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4620.setTransform(445.9,451.2,0.5,0.5);

	this.shape_4621 = new cjs.Shape();
	this.shape_4621.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4621.setTransform(435.8,454.1,0.5,0.5);

	this.shape_4622 = new cjs.Shape();
	this.shape_4622.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_4622.setTransform(426.6,451.6,0.5,0.5);

	this.shape_4623 = new cjs.Shape();
	this.shape_4623.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgeATgMQASgMAbAAQASAAATAEIgFAXQgQgEgTAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4623.setTransform(419.7,454,0.5,0.5);

	this.shape_4624 = new cjs.Shape();
	this.shape_4624.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0AAQAxgBAbAiQAcAgAAA6IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgSADQgWAFgVAAQg6AAghglgAg2hcQgYAagEAwICnAAQgBgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4624.setTransform(406.8,454.1,0.5,0.5);

	this.shape_4625 = new cjs.Shape();
	this.shape_4625.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4625.setTransform(395.4,452.6,0.5,0.5);

	this.shape_4626 = new cjs.Shape();
	this.shape_4626.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4626.setTransform(384.1,454.1,0.5,0.5);

	this.shape_4627 = new cjs.Shape();
	this.shape_4627.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggABQgpAAgUAWQgUAYAAAwIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgTAZAAA2IAACVIgZAAIAAkOIAUAAIAGAlIABAAQAMgUAUgLQAUgLAZAAQBBAAARAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4627.setTransform(366.6,454,0.5,0.5);

	this.shape_4628 = new cjs.Shape();
	this.shape_4628.graphics.f("#000000").s().p("AhfB7IAAgaQAqAUAsAAQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgKgJgNQgIgMAAgVQAAgeAZgSQAagRAtAAQArAAAoAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQAQALAJANQAIAOAAASQAAAkgbAUQgcATgyABQg1gBghgRg");
	this.shape_4628.setTransform(342.6,454.1,0.5,0.5);

	this.shape_4629 = new cjs.Shape();
	this.shape_4629.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARATAkAAQAvgBAXgYQAXgZAAg3IAAiUIAZAAIAAEOIgWAAIgEglIgBAAQgbAqhDAAQhcAAABhjg");
	this.shape_4629.setTransform(329.2,454.2,0.5,0.5);

	this.shape_4630 = new cjs.Shape();
	this.shape_4630.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOggAAgqQAAhCAggkQAgglA3AAQA4AAAgAlQAgAmAABAQAABCghAlQgfAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4630.setTransform(314.2,454.1,0.5,0.5);

	this.shape_4631 = new cjs.Shape();
	this.shape_4631.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4631.setTransform(303.9,451.6,0.5,0.5);

	this.shape_4632 = new cjs.Shape();
	this.shape_4632.graphics.f("#000000").s().p("Ag/BoQgiglABhCQAAhCAiglQAiglA6AAQAjAAAhAMIgHAVQgigLgcAAQgwAAgaAfQgaAfABA4QgBA3AaAfQAbAfAsAAQAlAAAfgNIAAAWQgbANgoABQg6gBgggkg");
	this.shape_4632.setTransform(295.2,454.1,0.5,0.5);

	this.shape_4633 = new cjs.Shape();
	this.shape_4633.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0AAQAwgBAcAiQAbAgAAA6IAAAUIjCAAQABA4AZAcQAaAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgTADQgVAFgVAAQg6AAghglgAg2hcQgYAagEAwICmAAQAAgvgUgaQgUgaglgBQgmABgXAZg");
	this.shape_4633.setTransform(281.9,454.1,0.5,0.5);

	this.shape_4634 = new cjs.Shape();
	this.shape_4634.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4634.setTransform(270.8,454,0.5,0.5);

	this.shape_4635 = new cjs.Shape();
	this.shape_4635.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlg0AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_4635.setTransform(257.8,457,0.5,0.5);

	this.shape_4636 = new cjs.Shape();
	this.shape_4636.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_4636.setTransform(245.7,454,0.5,0.5);

	this.shape_4637 = new cjs.Shape();
	this.shape_4637.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_4637.setTransform(234.1,454,0.5,0.5);

	this.shape_4638 = new cjs.Shape();
	this.shape_4638.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4638.setTransform(219.1,454.1,0.5,0.5);

	this.shape_4639 = new cjs.Shape();
	this.shape_4639.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglAAQgvAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_4639.setTransform(204.2,454,0.5,0.5);

	this.shape_4640 = new cjs.Shape();
	this.shape_4640.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4640.setTransform(181.9,451.3,0.5,0.5);

	this.shape_4641 = new cjs.Shape();
	this.shape_4641.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_4641.setTransform(167.3,454,0.5,0.5);

	this.shape_4642 = new cjs.Shape();
	this.shape_4642.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4642.setTransform(152.5,454.1,0.5,0.5);

	this.shape_4643 = new cjs.Shape();
	this.shape_4643.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAVgNgBgWQABgVgRgOQgRgNgmgOQgngOgQgLQgRgKgIgNQgJgNAAgUQABgeAZgSQAagRAtAAQArAAAnAQIgJAWQgogQghAAQghAAgTALQgUALABATQgBAWAQAMQAPANAqAQQAkAMASAKQAPAJAKAPQAIANAAATQAAAkgbAUQgcATgyABQg2gBgggRg");
	this.shape_4643.setTransform(133.6,454.1,0.5,0.5);

	this.shape_4644 = new cjs.Shape();
	this.shape_4644.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASATAkAAQAugBAYgYQAWgZAAg3IAAiUIAZAAIAAEOIgVAAIgFglIgCAAQgaAqhCAAQhdAAAAhjg");
	this.shape_4644.setTransform(120.1,454.2,0.5,0.5);

	this.shape_4645 = new cjs.Shape();
	this.shape_4645.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgYgfgtAAQgsAAgZAfg");
	this.shape_4645.setTransform(105.2,454.1,0.5,0.5);

	this.shape_4646 = new cjs.Shape();
	this.shape_4646.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_4646.setTransform(94.9,451.6,0.5,0.5);

	this.shape_4647 = new cjs.Shape();
	this.shape_4647.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAiglA6AAQAjAAAgAMIgGAVQgigLgbAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgNIAAAWQgaANgqABQg5gBghgkg");
	this.shape_4647.setTransform(86.2,454.1,0.5,0.5);

	this.shape_4648 = new cjs.Shape();
	this.shape_4648.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgnQAggmA1AAQAwgBAbAiQAcAhAAA5IAAAUIjBAAQAAA3AaAdQAZAeAvAAQAYAAAQgDQASgDAagMIAAAXQgVAKgUADQgWAFgVAAQg6AAghglgAg3hcQgXAagEAwICmAAQAAgwgVgZQgTgaglgBQgmABgYAZg");
	this.shape_4648.setTransform(72.9,454.1,0.5,0.5);

	this.shape_4649 = new cjs.Shape();
	this.shape_4649.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_4649.setTransform(61.8,454,0.5,0.5);

	this.shape_4650 = new cjs.Shape();
	this.shape_4650.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_4650.setTransform(48.7,457,0.5,0.5);

	this.shape_4651 = new cjs.Shape();
	this.shape_4651.graphics.f("#000000").s().p("AheCzQgbgTAAgjQAAgcARgTQASgSAcgHQgLgFgIgKQgHgJAAgNQAAgaAjgVQgYgIgNgWQgOgUAAgcQAAgoAagZQAagYAsAAQAaAAAOAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSAAgHgBQgQAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAvAAQArAAAYASQAXARAAAkQAAArgiAXQgjAXg/AAQg0AAgcgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAgATARQASARAhAAQAiAAARgRQASgRAAghQAAgjgTgRQgRgRghAAQghAAgSATg");
	this.shape_4651.setTransform(790.5,418.8,0.5,0.5);

	this.shape_4652 = new cjs.Shape();
	this.shape_4652.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4652.setTransform(776.4,415.7,0.5,0.5);

	this.shape_4653 = new cjs.Shape();
	this.shape_4653.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_4653.setTransform(765.9,413.4,0.5,0.5);

	this.shape_4654 = new cjs.Shape();
	this.shape_4654.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_4654.setTransform(755.6,415.7,0.5,0.5);

	this.shape_4655 = new cjs.Shape();
	this.shape_4655.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4655.setTransform(745.1,413.4,0.5,0.5);

	this.shape_4656 = new cjs.Shape();
	this.shape_4656.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgQAAIAAmCIAZAAIgBCeIABAAQAQgYAVgLQAVgMAfAAQA5AAAdAkQAdAjAABEQgBBFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWggAAg4QAAh0hYAAQgvAAgVAbg");
	this.shape_4656.setTransform(735,413,0.5,0.5);

	this.shape_4657 = new cjs.Shape();
	this.shape_4657.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggABQgqAAgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhEg/AAQgrAAgTAYQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAASAwIABAAQANgYAWgLQAWgNAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_4657.setTransform(715.9,415.7,0.5,0.5);

	this.shape_4658 = new cjs.Shape();
	this.shape_4658.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_4658.setTransform(697.1,415.8,0.5,0.5);

	this.shape_4659 = new cjs.Shape();
	this.shape_4659.graphics.f("#000000").s().p("AhABoQggglAAhCQgBhCAjglQAiglA6AAQAkAAAfAMIgHAVQgggLgcAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAaAfAtAAQAlAAAggNIAAAWQgcANgpABQg4gBgigkg");
	this.shape_4659.setTransform(683.8,415.8,0.5,0.5);

	this.shape_4660 = new cjs.Shape();
	this.shape_4660.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgxATgYQARgXAqAAQAWAAAWAHIgFAVQgUgGgUAAQgdAAgMARQgKARgBAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4660.setTransform(667.9,412.8,0.5,0.5);

	this.shape_4661 = new cjs.Shape();
	this.shape_4661.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAgglA4AAQA3AAAgAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgYgfgtAAQgsAAgZAfg");
	this.shape_4661.setTransform(655.7,415.8,0.5,0.5);

	this.shape_4662 = new cjs.Shape();
	this.shape_4662.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4662.setTransform(634.2,415.7,0.5,0.5);

	this.shape_4663 = new cjs.Shape();
	this.shape_4663.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAmg4AAQgjAAgcgSgAhFhWQgYAeAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_4663.setTransform(619.1,415.8,0.5,0.5);

	this.shape_4664 = new cjs.Shape();
	this.shape_4664.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_4664.setTransform(608.8,413.4,0.5,0.5);

	this.shape_4665 = new cjs.Shape();
	this.shape_4665.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgRgUg");
	this.shape_4665.setTransform(601.5,414.3,0.5,0.5);

	this.shape_4666 = new cjs.Shape();
	this.shape_4666.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4666.setTransform(590.2,415.8,0.5,0.5);

	this.shape_4667 = new cjs.Shape();
	this.shape_4667.graphics.f("#000000").s().p("AgMCHIhokOIAZAAIBGC4QAOAiAHAcIABAAQAKgkAKgbIBHi3IAZAAIhpEOg");
	this.shape_4667.setTransform(578,415.8,0.5,0.5);

	this.shape_4668 = new cjs.Shape();
	this.shape_4668.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4668.setTransform(564.7,415.8,0.5,0.5);

	this.shape_4669 = new cjs.Shape();
	this.shape_4669.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgXAYQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_4669.setTransform(549.8,415.7,0.5,0.5);

	this.shape_4670 = new cjs.Shape();
	this.shape_4670.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4670.setTransform(534.7,415.7,0.5,0.5);

	this.shape_4671 = new cjs.Shape();
	this.shape_4671.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4671.setTransform(524.3,413.4,0.5,0.5);

	this.shape_4672 = new cjs.Shape();
	this.shape_4672.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAKgHAHgMQAHgKAMgdIAMgkIhnkOIAZAAIA6CYQAYBCAJAcIABAAQANgqAUg1IA6iXIAZAAIh4E6QgQAogJAMQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_4672.setTransform(508.9,418.9,0.5,0.5);

	this.shape_4673 = new cjs.Shape();
	this.shape_4673.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4673.setTransform(498.6,414.3,0.5,0.5);

	this.shape_4674 = new cjs.Shape();
	this.shape_4674.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4674.setTransform(491.6,413.4,0.5,0.5);

	this.shape_4675 = new cjs.Shape();
	this.shape_4675.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4675.setTransform(485.8,412.9,0.5,0.5);

	this.shape_4676 = new cjs.Shape();
	this.shape_4676.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAggVA+gCIAzgBIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagWALQgXALgaAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4676.setTransform(475.8,415.8,0.5,0.5);

	this.shape_4677 = new cjs.Shape();
	this.shape_4677.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQASATAjAAQAvgBAXgYQAXgZAAg3IAAiUIAYAAIAAEOIgVAAIgEglIgCAAQgaAqhCAAQhcAAAAhjg");
	this.shape_4677.setTransform(461.9,416,0.5,0.5);

	this.shape_4678 = new cjs.Shape();
	this.shape_4678.graphics.f("#000000").s().p("ABaDHIAAhnIABg+IgBAAQgeAwg9AAQg1AAgegkQgdgjAAhCQAAhEAdgmQAeglA2AAQA6AAAdArIACAAIAEgmIAVAAIAAGIgAhAiRQgXAfAAA8QAAA4AWAdQAWAdAqAAQAxAAAVgcQAVgbAAg/IAAgDQAAg9gVgbQgVgbgvAAQgrAAgWAfg");
	this.shape_4678.setTransform(446.4,418.8,0.5,0.5);

	this.shape_4679 = new cjs.Shape();
	this.shape_4679.graphics.f("#000000").s().p("AhfB7IAAgaQApAUAtAAQAnAAAVgNQAUgNABgWQAAgVgRgOQgQgNgmgOQgogOgRgLQgQgKgIgNQgIgNAAgUQgBgeAagSQAagRAtAAQAsAAAnAQIgJAWQgpgQghAAQghAAgTALQgTALAAATQAAAWAOAMQAQANArAQQAjAMASAKQAOAJALAPQAIANAAATQAAAkgcAUQgbATgyABQg2gBgggRg");
	this.shape_4679.setTransform(426.6,415.8,0.5,0.5);

	this.shape_4680 = new cjs.Shape();
	this.shape_4680.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgRgUg");
	this.shape_4680.setTransform(416.3,414.3,0.5,0.5);

	this.shape_4681 = new cjs.Shape();
	this.shape_4681.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_4681.setTransform(409.3,413.4,0.5,0.5);

	this.shape_4682 = new cjs.Shape();
	this.shape_4682.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_4682.setTransform(395.7,415.7,0.5,0.5);

	this.shape_4683 = new cjs.Shape();
	this.shape_4683.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABDggAkQggAmg4AAQgjAAgcgSgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgYgfgtAAQgsAAgYAfg");
	this.shape_4683.setTransform(382.4,415.8,0.5,0.5);

	this.shape_4684 = new cjs.Shape();
	this.shape_4684.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQABgxASgYQARgXAqAAQAVAAAXAHIgFAVQgUgGgUAAQgdAAgMARQgKARgBAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_4684.setTransform(372,412.8,0.5,0.5);

	this.shape_4685 = new cjs.Shape();
	this.shape_4685.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4685.setTransform(353.2,415.7,0.5,0.5);

	this.shape_4686 = new cjs.Shape();
	this.shape_4686.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAaAAIAsCdQAOA2AGAfIABAAQAOg2AIgXIA4ilIAVAAIA1CkQASA8AEARIACAAQACgSARhEIAqibIAYAAIhJEOg");
	this.shape_4686.setTransform(336.4,415.8,0.5,0.5);

	this.shape_4687 = new cjs.Shape();
	this.shape_4687.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAmg4AAQgjAAgcgSgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4687.setTransform(319.7,415.8,0.5,0.5);

	this.shape_4688 = new cjs.Shape();
	this.shape_4688.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4688.setTransform(304.8,415.7,0.5,0.5);

	this.shape_4689 = new cjs.Shape();
	this.shape_4689.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_4689.setTransform(292.2,412.9,0.5,0.5);

	this.shape_4690 = new cjs.Shape();
	this.shape_4690.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkAAQgwAAgWAYQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4690.setTransform(270.8,415.7,0.5,0.5);

	this.shape_4691 = new cjs.Shape();
	this.shape_4691.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggnQAfgmA1AAQAwgBAcAiQAbAhABA5IAAAUIjDAAQABA4AZAcQAaAeAuAAQAYAAASgDQASgEAagLIAAAXQgXAKgUADQgVAFgWAAQg5AAgiglgAg3hcQgXAbgEAvICmAAQABgvgVgaQgUgaglgBQglABgZAZg");
	this.shape_4691.setTransform(256.2,415.8,0.5,0.5);

	this.shape_4692 = new cjs.Shape();
	this.shape_4692.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0AAQAxgBAbAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAYAAASgDQASgDAagMIAAAXQgYAKgSADQgWAFgWAAQg5AAghglgAg3hcQgXAbgEAvICnAAQAAgvgVgaQgUgaglgBQgmABgYAZg");
	this.shape_4692.setTransform(242.2,415.8,0.5,0.5);

	this.shape_4693 = new cjs.Shape();
	this.shape_4693.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWggAAg4QAAh0hYAAQgvAAgVAbg");
	this.shape_4693.setTransform(228,413,0.5,0.5);

	this.shape_4694 = new cjs.Shape();
	this.shape_4694.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_4694.setTransform(205.4,413,0.5,0.5);

	this.shape_4695 = new cjs.Shape();
	this.shape_4695.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_4695.setTransform(191,415.8,0.5,0.5);

	this.shape_4696 = new cjs.Shape();
	this.shape_4696.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_4696.setTransform(177.3,412.9,0.5,0.5);

	this.shape_4697 = new cjs.Shape();
	this.shape_4697.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgeATgMQASgMAbAAQATAAASAEIgFAXQgPgEgUAAQgiAAgWAdQgWAfAAArIAACVg");
	this.shape_4697.setTransform(159,415.7,0.5,0.5);

	this.shape_4698 = new cjs.Shape();
	this.shape_4698.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0AAQAxgBAbAiQAbAgABA6IAAAUIjDAAQABA4AZAcQAaAeAuAAQAYAAASgDQASgDAagMIAAAXQgYAKgSADQgWAFgWAAQg5AAghglgAg3hcQgXAbgEAvICnAAQAAgvgVgaQgUgaglgBQgmABgYAZg");
	this.shape_4698.setTransform(146.1,415.8,0.5,0.5);

	this.shape_4699 = new cjs.Shape();
	this.shape_4699.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_4699.setTransform(136.3,413.4,0.5,0.5);

	this.shape_4700 = new cjs.Shape();
	this.shape_4700.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4700.setTransform(130.5,412.9,0.5,0.5);

	this.shape_4701 = new cjs.Shape();
	this.shape_4701.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgoQAggmA0AAQAxgBAbAiQAcAgAAA6IAAAUIjCAAQAAA4AaAcQAZAeAvAAQAYAAAQgDQATgDAagMIAAAXQgYAKgSADQgVAFgWAAQg6AAghglgAg3hcQgYAbgDAvICnAAQgBgvgUgaQgUgaglgBQgmABgYAZg");
	this.shape_4701.setTransform(120.6,415.8,0.5,0.5);

	this.shape_4702 = new cjs.Shape();
	this.shape_4702.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_4702.setTransform(109.2,414.3,0.5,0.5);

	this.shape_4703 = new cjs.Shape();
	this.shape_4703.graphics.f("#000000").s().p("AB9C3IgziAIiTAAIgyCAIgdAAICSltIAQAAICPFtgAgNhjIgyCDICAAAIhAitQgEATgKAXg");
	this.shape_4703.setTransform(97.4,413.5,0.5,0.5);

	this.shape_4704 = new cjs.Shape();
	this.shape_4704.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1AAQAwgBAcAiQAcAhAAA5IAAAUIjDAAQAAA3AaAdQAaAeAuAAQAZAAAQgDQASgDAbgMIAAAXQgWAKgVADQgUAFgXAAQg5AAghglgAg3hcQgXAagEAwICmAAQAAgwgUgZQgVgagkgBQgmABgYAZg");
	this.shape_4704.setTransform(76.2,415.8,0.5,0.5);

	this.shape_4705 = new cjs.Shape();
	this.shape_4705.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAQgZAXgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_4705.setTransform(61.7,412.9,0.5,0.5);

	this.shape_4706 = new cjs.Shape();
	this.shape_4706.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_4706.setTransform(47.4,413.5,0.5,0.5);

	this.shape_4707 = new cjs.Shape();
	this.shape_4707.graphics.f("#000000").s().p("AgXAdQgKgIABgVQgBgRAJgKQAIgKAQAAQAPAAAJAKQAKAKgBARQABASgKAKQgJAKgPAAQgOAAgJgJg");
	this.shape_4707.setTransform(386.2,344.6,0.5,0.5);

	this.shape_4708 = new cjs.Shape();
	this.shape_4708.graphics.f("#000000").s().p("AhZC0QgngpAAhJQAAhKAlgrQAjgrA9AAQA5AAAhAmQAiAlAAA9IAAAdIjRAAQABA2AaAcQAZAcAvAAQAxAAAwgVIAAApQgYAKgWAGQgWAEgfAAQhDAAgngpgAg1gfQgWAYgEApICfAAQgBgrgTgXQgTgXglAAQgkAAgVAYgAgdiBIAAgHQAMgPARgbQAQgbAHgPIA5AAIAAAGQgPAUgWAYQgZAcgRANg");
	this.shape_4708.setTransform(374.4,335.3,0.5,0.5);

	this.shape_4709 = new cjs.Shape();
	this.shape_4709.graphics.f("#000000").s().p("AiKDYIAAglQASAEAQAAQAvAAAVg2IARgrIh7kyIAxAAIBDCuQAWA6AFAbIACAAIAPgwQAMgkBAivIAxAAIiDFaQgSA0gaAVQgbAWglAAQgVAAgVgFg");
	this.shape_4709.setTransform(359.2,341.9,0.5,0.5);

	this.shape_4710 = new cjs.Shape();
	this.shape_4710.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgLAAgHgHg");
	this.shape_4710.setTransform(348.4,335.6,0.5,0.5);

	this.shape_4711 = new cjs.Shape();
	this.shape_4711.graphics.f("#000000").s().p("ABSCbIAAjEQgBglgQgTQgRgSglAAQgvAAgWAaQgWAaAAA8IAACeIguAAIAAkwIAmAAIAHAqIACAAQAOgWAagNQAbgMAdAAQA2AAAdAbQAbAaABA6IAADGg");
	this.shape_4711.setTransform(336.1,338.3,0.5,0.5);

	this.shape_4712 = new cjs.Shape();
	this.shape_4712.graphics.f("#000000").s().p("AhgCGQgZgXAAgrQAAhcCSgEIA0gCIAAgTQAAgkgPgRQgQgRgiAAQgmAAgvAYIgOgkQAWgMAbgHQAagHAbAAQA3AAAaAYQAaAYAAA2IAADPIgiAAIgJgrIgCAAQgYAdgWAJQgXALghAAQgsAAgbgYgAAeAEQg2ACgZAPQgYAPAAAgQAAAaAPAMQAPAOAcAAQAqAAAYgYQAZgYAAgqIAAgcg");
	this.shape_4712.setTransform(318.9,338.5,0.5,0.5);

	this.shape_4713 = new cjs.Shape();
	this.shape_4713.graphics.f("#000000").s().p("AhHD6IAAgpQASAFAXAAQAcAAANgQQAOgRAAgfIAAmWIAvAAIAAGSQAAA1gaAdQgbAdgxAAQgaAAgPgHg");
	this.shape_4713.setTransform(305.2,338.6,0.5,0.5);

	this.shape_4714 = new cjs.Shape();
	this.shape_4714.graphics.f("#000000").s().p("AhXCbIAAkwIAnAAIAEA5IADAAQAQgeAZgQQAWgQAdAAQASgBATAEIgHArQgSgFgPAAQglAAgZAfQgaAeAAAsIAACjg");
	this.shape_4714.setTransform(291.7,338.3,0.5,0.5);

	this.shape_4715 = new cjs.Shape();
	this.shape_4715.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhKAlgrQAjgrA9AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQABA1AaAdQAZAcAuAAQAxAAAxgVIAAApQgYAKgWAGQgWAEgfAAQhDAAgngpgAg2heQgVAYgEAqICfAAQAAgsgUgXQgTgXglAAQgjAAgXAYg");
	this.shape_4715.setTransform(276.9,338.5,0.5,0.5);

	this.shape_4716 = new cjs.Shape();
	this.shape_4716.graphics.f("#000000").s().p("AgXDRIAAkwIAuAAIAAEwgAgTiaQgHgIAAgQQAAgPAHgIQAJgHAKAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgKAAgJgHg");
	this.shape_4716.setTransform(265.2,335.6,0.5,0.5);

	this.shape_4717 = new cjs.Shape();
	this.shape_4717.graphics.f("#000000").s().p("AgWDZIAAmxIAtAAIAAGxg");
	this.shape_4717.setTransform(258,335.3,0.5,0.5);

	this.shape_4718 = new cjs.Shape();
	this.shape_4718.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA6AAAhAmQAiAmAAA9IAAAcIjSAAQACA2AaAcQAZAcAvAAQAwAAAwgVIAAApQgWAKgYAGQgVAEggAAQhCAAgngpgAg2heQgVAYgEAqICeAAQAAgsgTgXQgUgXgkAAQgjAAgXAYg");
	this.shape_4718.setTransform(246.5,338.5,0.5,0.5);

	this.shape_4719 = new cjs.Shape();
	this.shape_4719.graphics.f("#000000").s().p("AgtBhIAAi0IgsAAIAAgWIAsgUIAThBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAbAMAQQAOAPAWAAIAYgCIATgEIAAAjQgIAEgPACQgQADgKAAQhYAAABheg");
	this.shape_4719.setTransform(233.3,336.8,0.5,0.5);

	this.shape_4720 = new cjs.Shape();
	this.shape_4720.graphics.f("#000000").s().p("ACDDMIgyiBIiiAAIgzCBIgvAAICgmXIAnAAICgGXgAgRhdIgwB9ICDAAIgvh9QgIgSgLgoQgFAYgMAig");
	this.shape_4720.setTransform(219.3,335.9,0.5,0.5);

	this.shape_4721 = new cjs.Shape();
	this.shape_4721.graphics.f("#000000").s().p("AgpBGIAQhGQAKgvAEgWIAxAAIAEAHQgGAZgOAmQgNAggPAlg");
	this.shape_4721.setTransform(198.9,346.3,0.5,0.5);

	this.shape_4722 = new cjs.Shape();
	this.shape_4722.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA8AAQA4AAAjAmQAhAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAuAAQAxAAAxgVIAAApQgXAKgXAGQgWAEgfAAQhDAAgngpgAg2heQgVAYgEAqICfAAQAAgsgUgXQgTgXglAAQgjAAgXAYg");
	this.shape_4722.setTransform(188,338.5,0.5,0.5);

	this.shape_4723 = new cjs.Shape();
	this.shape_4723.graphics.f("#000000").s().p("ACsCbIAAjFQAAgkgQgTQgPgSghAAQgsAAgUAZQgVAZAAAzIAACpIgtAAIAAjFQAAgkgPgTQgQgSgiAAQgrAAgUAaQgUAaAAA8IAACeIguAAIAAkwIAlAAIAIAqIACAAQAMgWAZgNQAYgMAdAAQBIAAAUA0IADAAQANgZAagOQAbgOAhABQAzAAAaAbQAaAaAAA6IAADGg");
	this.shape_4723.setTransform(166.8,338.3,0.5,0.5);

	this.shape_4724 = new cjs.Shape();
	this.shape_4724.graphics.f("#000000").s().p("AhfCGQgagXAAgrQgBhcCTgEIA0gCIAAgTQAAgjgPgSQgQgRghAAQgnAAgvAYIgOgkQAXgMAagHQAbgHAaAAQA3AAAaAYQAbAYgBA2IAADPIgiAAIgJgrIgDAAQgXAdgWAJQgWALghAAQguAAgZgYgAAeAEQg1ACgaAPQgYAQAAAfQAAAaAPAMQAPAOAcAAQAqAAAYgYQAZgXAAgrIAAgcg");
	this.shape_4724.setTransform(145,338.5,0.5,0.5);

	this.shape_4725 = new cjs.Shape();
	this.shape_4725.graphics.f("#000000").s().p("ABSCbIAAjEQgBglgQgTQgRgSglAAQgvAAgWAaQgWAaAAA8IAACeIguAAIAAkwIAmAAIAHAqIACAAQAOgWAagNQAbgMAdAAQA3AAAcAbQAbAaABA6IAADGg");
	this.shape_4725.setTransform(128.9,338.3,0.5,0.5);

	this.shape_4726 = new cjs.Shape();
	this.shape_4726.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA8AAQA4AAAjAmQAhAlAAA+IAAAcIjRAAQABA2AaAcQAZAcAuAAQAxAAAxgVIAAApQgYAKgWAGQgWAEgfAAQhDAAgngpgAg1heQgWAYgEAqICfAAQAAgsgUgXQgTgXglAAQgjAAgWAYg");
	this.shape_4726.setTransform(104.8,338.5,0.5,0.5);

	this.shape_4727 = new cjs.Shape();
	this.shape_4727.graphics.f("#000000").s().p("ACsCbIAAjFQAAglgQgSQgPgSghAAQgrAAgVAZQgVAZAAAzIAACpIgtAAIAAjFQAAgkgPgTQgQgSgiAAQgrAAgUAaQgUAaAAA8IAACeIguAAIAAkwIAlAAIAIAqIACAAQAMgWAZgNQAYgMAdAAQBIAAAUA0IADAAQANgZAbgOQAagOAhABQAzAAAaAbQAaAaAAA6IAADGg");
	this.shape_4727.setTransform(83.5,338.3,0.5,0.5);

	this.shape_4728 = new cjs.Shape();
	this.shape_4728.graphics.f("#000000").s().p("AhgCGQgZgXAAgrQAAhcCSgEIA0gCIAAgTQAAgjgPgSQgQgRgiAAQgmAAgvAYIgOgkQAWgMAbgHQAagHAbAAQA3AAAaAYQAaAYAAA2IAADPIgiAAIgJgrIgCAAQgYAdgWAJQgXALghAAQgtAAgagYgAAeAEQg2ACgZAPQgYAPAAAgQAAAaAPAMQAPAOAcAAQAqAAAYgYQAZgYAAgqIAAgcg");
	this.shape_4728.setTransform(61.8,338.5,0.5,0.5);

	this.shape_4729 = new cjs.Shape();
	this.shape_4729.graphics.f("#000000").s().p("AhqCLIAAgrQAWALAZAHQAbAGAVAAQAkAAATgMQATgLABgYQAAgSgQgMQgQgNgrgRQgsgQgRgLQgSgMgIgPQgJgOAAgWQAAglAegVQAfgWAzAAQAwAAAxAUIgRAmQgtgTgmAAQgfAAgSAKQgRALAAARQAAAMAHAJQAFAIAPAJQANAHAnAPQA1ATAVAUQATAUAAAeQAAArggAXQggAXg4AAQg9AAghgTg");
	this.shape_4729.setTransform(47.6,338.5,0.5,0.5);

	this.shape_4730 = new cjs.Shape();
	this.shape_4730.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA8AAQA4AAAjAmQAhAlAAA+IAAAcIjRAAQABA2AaAcQAaAcAtAAQAwAAAygVIAAApQgXAKgYAGQgVAEggAAQhCAAgngpgAg2heQgVAYgEAqICeAAQABgsgUgXQgTgXglAAQgjAAgXAYg");
	this.shape_4730.setTransform(769.1,300.2,0.5,0.5);

	this.shape_4731 = new cjs.Shape();
	this.shape_4731.graphics.f("#000000").s().p("ABSDZIAAjGQgBgkgQgSQgRgTglAAQgwAAgVAaQgWAbAAA6IAACgIguAAIAAmxIAuAAIAACEQAAAZgDAOIAEAAQANgWAZgNQAZgMAfAAQA6AAAbAaQAcAbAAA5IAADHg");
	this.shape_4731.setTransform(752.4,297,0.5,0.5);

	this.shape_4732 = new cjs.Shape();
	this.shape_4732.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAXAAIAXgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4732.setTransform(738.4,298.6,0.5,0.5);

	this.shape_4733 = new cjs.Shape();
	this.shape_4733.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQARgfAYgPQAXgQAcAAQASgBATAEIgGArQgUgFgOAAQglAAgZAfQgaAeAAAsIAACjg");
	this.shape_4733.setTransform(721.3,300.1,0.5,0.5);

	this.shape_4734 = new cjs.Shape();
	this.shape_4734.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA6AAAhAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAwAAAxgVIAAApQgXAKgXAGQgWAEgfAAQhDAAgngpgAg1heQgWAYgEAqICfAAQgBgsgTgXQgUgXgkAAQgkAAgVAYg");
	this.shape_4734.setTransform(706.5,300.2,0.5,0.5);

	this.shape_4735 = new cjs.Shape();
	this.shape_4735.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAhgqA8AAQA9AAAhAtIAEAAIgCgVIgBiSIAuAAIAAGwIgmAAIgGgpIgCAAQggAug/AAQg7AAgigogAhAgaQgVAeAAA7QAAA6AVAeQAVAdAqAAQAuABAWgaQAVgaAAg5IAAgKQAAhAgWgbQgVgcgvAAQgoAAgWAfg");
	this.shape_4735.setTransform(689.3,297.2,0.5,0.5);

	this.shape_4736 = new cjs.Shape();
	this.shape_4736.graphics.f("#000000").s().p("ABSCbIAAjEQgBglgRgTQgRgSgkAAQgvAAgWAaQgWAZAAA9IAACeIguAAIAAkwIAlAAIAIAqIACAAQAOgWAZgNQAcgMAdAAQA3AAAcAbQAbAaABA6IAADGg");
	this.shape_4736.setTransform(672.3,300.1,0.5,0.5);

	this.shape_4737 = new cjs.Shape();
	this.shape_4737.graphics.f("#000000").s().p("AhjCBQgcgaAAg7IAAjGIAvAAIAADEQAAAlARATQARASAkAAQAvAAAWgaQAXgaAAg7IAAifIAuAAIAAEwIgmAAIgHgpIgCAAQgPAWgZAMQgaAMgeAAQg4AAgcgag");
	this.shape_4737.setTransform(654.7,300.4,0.5,0.5);

	this.shape_4738 = new cjs.Shape();
	this.shape_4738.graphics.f("#000000").s().p("AhqCLIAAgrQAYAMAXAGQAbAGAVAAQAjAAAUgMQATgLABgYQgBgSgPgMQgPgMgsgSQgrgPgSgMQgSgMgJgPQgIgOAAgWQAAglAegVQAfgWAzAAQAxAAAwAUIgRAmQgtgTgmAAQggAAgRAKQgQAKAAASQAAAMAGAJQAGAIAOAJQANAHAnAPQA2AUAUATQATAUAAAeQAAArggAXQggAXg4AAQg8AAgigTg");
	this.shape_4738.setTransform(631.9,300.2,0.5,0.5);

	this.shape_4739 = new cjs.Shape();
	this.shape_4739.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQARgfAYgPQAXgQAdAAQARgBATAEIgGArQgUgFgOAAQglAAgZAfQgaAeAAAsIAACjg");
	this.shape_4739.setTransform(620.2,300.1,0.5,0.5);

	this.shape_4740 = new cjs.Shape();
	this.shape_4740.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA5AAAiAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAvAAAygVIAAApQgYAKgXAGQgVAEgfAAQhDAAgngpgAg1heQgWAYgEAqICeAAQAAgsgTgXQgUgXgkAAQgkAAgVAYg");
	this.shape_4740.setTransform(605.5,300.2,0.5,0.5);

	this.shape_4741 = new cjs.Shape();
	this.shape_4741.graphics.f("#000000").s().p("ABRCbIAAjEQAAglgRgTQgRgSgkAAQgvAAgWAaQgXAZAAA9IAACeIgtAAIAAkwIAlAAIAIAqIACAAQAOgWAagNQAagMAeAAQA3AAAbAbQAcAaAAA6IAADGg");
	this.shape_4741.setTransform(588.7,300.1,0.5,0.5);

	this.shape_4742 = new cjs.Shape();
	this.shape_4742.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAXAAIAXgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4742.setTransform(574.8,298.6,0.5,0.5);

	this.shape_4743 = new cjs.Shape();
	this.shape_4743.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQARgfAYgPQAXgQAcAAQASgBATAEIgGArQgUgFgOAAQglAAgZAfQgaAeAAAsIAACjg");
	this.shape_4743.setTransform(565,300.1,0.5,0.5);

	this.shape_4744 = new cjs.Shape();
	this.shape_4744.graphics.f("#000000").s().p("AhfCGQgagXAAgrQgBhcCTgEIA0gCIAAgTQAAgjgPgSQgQgRghAAQgnAAgvAYIgOgkQAXgMAagHQAbgHAaAAQA3AAAaAYQAbAYgBA2IAADPIgiAAIgJgrIgDAAQgXAdgWAJQgWALghAAQguAAgZgYgAAeAEQg1ACgaAPQgYAQAAAfQAAAaAPAMQAPAOAcAAQAqAAAYgYQAZgXAAgrIAAgcg");
	this.shape_4744.setTransform(549.8,300.2,0.5,0.5);

	this.shape_4745 = new cjs.Shape();
	this.shape_4745.graphics.f("#000000").s().p("AiFDgIAAm5IAlAAIAHAqIACAAQASgZAXgLQAYgMAdAAQA9AAAhAqQAhAqAABKQAABKghAqQgiAqg8AAQgcAAgZgLQgZgMgQgWIgEAAQAEAZAAAZIAAB+gAhCidQgUAZgBA5IAAAKQAABBAVAaQAVAcAvAAQAnAAAXggQAWgfAAg4QAAg6gWgeQgXgegoAAQguAAgVAag");
	this.shape_4745.setTransform(534.1,303.5,0.5,0.5);

	this.shape_4746 = new cjs.Shape();
	this.shape_4746.graphics.f("#000000").s().p("AhqCLIAAgrQAYAMAXAGQAbAGAWAAQAiAAAUgMQAUgLAAgYQAAgSgQgMQgPgMgsgSQgrgPgRgMQgTgMgIgPQgJgOAAgWQAAglAegVQAfgWAzAAQAxAAAvAUIgQAmQgtgTgmAAQggAAgQAKQgRAKAAASQAAAMAGAJQAFAIAPAJQAOAHAmAPQA2AUAUATQATAUAAAeQAAArggAXQggAXg4AAQg8AAgigTg");
	this.shape_4746.setTransform(510.8,300.2,0.5,0.5);

	this.shape_4747 = new cjs.Shape();
	this.shape_4747.graphics.f("#000000").s().p("AhgCGQgZgXAAgrQAAhcCTgEIAzgCIAAgTQAAgkgPgRQgPgRgjAAQgmAAgvAYIgOgkQAWgMAbgHQAagHAbAAQA3AAAaAYQAaAYAAA2IAADPIgiAAIgJgrIgCAAQgYAdgWAJQgWALghAAQgtAAgbgYgAAeAEQg2ACgZAPQgYAPAAAgQAAAaAPAMQAPAOAcAAQAqAAAZgYQAYgYAAgqIAAgcg");
	this.shape_4747.setTransform(495.5,300.2,0.5,0.5);

	this.shape_4748 = new cjs.Shape();
	this.shape_4748.graphics.f("#000000").s().p("AhJCLQgfgTgSgkQgRgkAAgwQAAhKAlgpQAlgqBCAAQBAAAAlArQAmAqAABIQAABKgmAqQglAqhBAAQgpAAgggTgAhEhYQgXAdAAA7QAAA6AXAfQAYAeAsAAQAtAAAYgeQAYgfgBg6QABg5gYgfQgYgegtAAQgtAAgXAeg");
	this.shape_4748.setTransform(472,300.2,0.5,0.5);

	this.shape_4749 = new cjs.Shape();
	this.shape_4749.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgTiaQgHgIAAgQQAAgPAHgIQAJgHAKAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgKAAgJgHg");
	this.shape_4749.setTransform(459.8,297.4,0.5,0.5);

	this.shape_4750 = new cjs.Shape();
	this.shape_4750.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAhgqA8AAQA9AAAhAtIAEAAIgDinIAuAAIAAGwIgmAAIgGgpIgCAAQggAug/AAQg7AAgigogAhAgaQgVAeAAA7QAAA6AVAeQAVAdAqAAQAuABAWgaQAVgaAAg5IAAgKQAAhAgWgbQgVgcgvAAQgoAAgWAfg");
	this.shape_4750.setTransform(447.1,297.2,0.5,0.5);

	this.shape_4751 = new cjs.Shape();
	this.shape_4751.graphics.f("#000000").s().p("AhjCBQgcgaAAg7IAAjGIAvAAIAADEQAAAmARASQASASAjAAQAwAAAVgaQAXgagBg7IAAifIAuAAIAAEwIgmAAIgHgpIgCAAQgOAWgZAMQgZAMggAAQg3AAgcgag");
	this.shape_4751.setTransform(429.9,300.4,0.5,0.5);

	this.shape_4752 = new cjs.Shape();
	this.shape_4752.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAbANAQQANAPAXAAIAXgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4752.setTransform(416.1,298.6,0.5,0.5);

	this.shape_4753 = new cjs.Shape();
	this.shape_4753.graphics.f("#000000").s().p("AhqCLIAAgrQAXALAYAHQAbAGAVAAQAkAAATgMQATgLAAgYQAAgRgPgNQgQgNgrgRQgrgPgSgMQgSgMgIgPQgJgPAAgVQAAglAegVQAfgWAzAAQAwAAAxAUIgRAmQgsgTgnAAQgfAAgSAKQgQAKAAASQAAAMAGAJQAHAJANAIQANAHAoAPQA1AUAUATQATAUAAAeQAAArggAXQggAXg4AAQg8AAgigTg");
	this.shape_4753.setTransform(404.5,300.2,0.5,0.5);

	this.shape_4754 = new cjs.Shape();
	this.shape_4754.graphics.f("#000000").s().p("ABSCbIAAjEQAAglgRgTQgSgSgkAAQgvAAgWAaQgWAZAAA9IAACeIgvAAIAAkwIAmAAIAHAqIADAAQAOgWAZgNQAcgMAcAAQA4AAAcAbQAcAaAAA6IAADGg");
	this.shape_4754.setTransform(381.5,300.1,0.5,0.5);

	this.shape_4755 = new cjs.Shape();
	this.shape_4755.graphics.f("#000000").s().p("ABNCYIg4iyQgIgWgNg0IgBAAQgMAzgHAYIg5CxIg2AAIhUkwIAxAAIAtCvQAPA4ADAZIACAAQAEgWAGgUIBEjWIAwAAIA3CvQAPAuAHAiIACAAIAGgfIA6jgIAvAAIhUEwg");
	this.shape_4755.setTransform(361.6,300.2,0.5,0.5);

	this.shape_4756 = new cjs.Shape();
	this.shape_4756.graphics.f("#000000").s().p("AhJCLQgfgTgSgkQgRgkAAgwQAAhKAlgpQAlgqBCAAQBAAAAlArQAmAqAABIQAABKgmAqQglAqhBAAQgpAAgggTgAhEhYQgXAdAAA7QAAA6AXAfQAYAeAsAAQAtAAAYgeQAXgfABg6QgBg5gXgfQgYgegtAAQgtAAgXAeg");
	this.shape_4756.setTransform(341.9,300.2,0.5,0.5);

	this.shape_4757 = new cjs.Shape();
	this.shape_4757.graphics.f("#000000").s().p("AhXCbIAAkwIAnAAIAEA5IADAAQAQgeAYgQQAYgQAcAAQASgBATAEIgHArQgSgFgPAAQglAAgZAfQgaAeAAAsIAACjg");
	this.shape_4757.setTransform(321.1,300.1,0.5,0.5);

	this.shape_4758 = new cjs.Shape();
	this.shape_4758.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgLAAgHgHg");
	this.shape_4758.setTransform(310.7,297.4,0.5,0.5);

	this.shape_4759 = new cjs.Shape();
	this.shape_4759.graphics.f("#000000").s().p("AhYB1QgogqAAhIQAAhJAkgsQAlgrA8AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQABA2AaAcQAaAcAuAAQAwAAAxgVIAAApQgXAKgXAGQgWAEgfAAQhDAAgmgpgAg1heQgWAXgEArICeAAQAAgsgTgXQgUgXgjAAQgkAAgWAYg");
	this.shape_4759.setTransform(299.1,300.2,0.5,0.5);

	this.shape_4760 = new cjs.Shape();
	this.shape_4760.graphics.f("#000000").s().p("ABRDZIAAjGQAAgkgRgSQgQgTglAAQgvAAgWAaQgXAbAAA6IAACgIguAAIAAmxIAuAAIAACEQAAAZgCAOIADAAQANgWAagNQAZgMAfAAQA4AAAcAaQAdAbAAA5IAADHg");
	this.shape_4760.setTransform(282.4,297,0.5,0.5);

	this.shape_4761 = new cjs.Shape();
	this.shape_4761.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAWAAIAYgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4761.setTransform(268.5,298.6,0.5,0.5);

	this.shape_4762 = new cjs.Shape();
	this.shape_4762.graphics.f("#000000").s().p("ABRCbIAAjEQABglgSgTQgQgSglAAQguAAgXAaQgWAaAAA8IAACeIgvAAIAAkwIAmAAIAIAqIACAAQAOgWAagNQAagMAeAAQA4AAAbAbQAbAaAAA6IAADGg");
	this.shape_4762.setTransform(247.5,300.1,0.5,0.5);

	this.shape_4763 = new cjs.Shape();
	this.shape_4763.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhKAlgrQAjgrA9AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQACA2AZAcQAaAcAuAAQAxAAAwgVIAAApQgYAKgWAGQgWAEgfAAQhDAAgngpgAg1heQgWAYgEAqICfAAQAAgsgUgXQgTgXglAAQgjAAgWAYg");
	this.shape_4763.setTransform(230.7,300.2,0.5,0.5);

	this.shape_4764 = new cjs.Shape();
	this.shape_4764.graphics.f("#000000").s().p("AiFDgIAAm5IAlAAIAHAqIACAAQARgZAZgLQAYgMAdAAQA9AAAgAqQAhAqAABKQAABLghApQghAqg8AAQgcAAgagLQgZgMgQgWIgDAAQADAfAAATIAAB+gAhBidQgWAaAAA4IAAAKQAABBAWAaQAVAcAuAAQAoAAAWggQAXgfAAg4QAAg6gXgeQgWgegpAAQguAAgUAag");
	this.shape_4764.setTransform(214.3,303.5,0.5,0.5);

	this.shape_4765 = new cjs.Shape();
	this.shape_4765.graphics.f("#000000").s().p("AhJCLQgfgTgSgkQgRgkAAgwQAAhKAlgpQAlgqBCAAQBAAAAlArQAmAqAABIQAABKgmAqQglAqhBAAQgpAAgggTgAhEhYQgXAdAAA7QAAA6AXAfQAXAeAtAAQAtAAAYgeQAYgfAAg6QAAg5gYgfQgYgegtAAQgtAAgXAeg");
	this.shape_4765.setTransform(196.6,300.2,0.5,0.5);

	this.shape_4766 = new cjs.Shape();
	this.shape_4766.graphics.f("#000000").s().p("AhJCLQgfgSgSglQgRglAAgvQAAhKAlgpQAlgqBCAAQBAAAAlArQAmAqAABIQAABLgmApQglAqhBAAQgpAAgggTgAhEhYQgXAdAAA7QAAA7AXAeQAXAeAtAAQAtAAAYgeQAXgfAAg6QAAg5gXgfQgYgegtAAQgtAAgXAeg");
	this.shape_4766.setTransform(172,300.2,0.5,0.5);

	this.shape_4767 = new cjs.Shape();
	this.shape_4767.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAXAAIAXgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4767.setTransform(158.2,298.6,0.5,0.5);

	this.shape_4768 = new cjs.Shape();
	this.shape_4768.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAhgqA8AAQA9AAAhAtIAEAAIgCgVIgBiSIAuAAIAAGwIgmAAIgGgpIgCAAQggAug/AAQg7AAgigogAhAgaQgVAeAAA7QAAA6AVAeQAVAdAqAAQAuABAWgaQAVgaAAg5IAAgKQAAhAgWgbQgVgcgvAAQgoAAgWAfg");
	this.shape_4768.setTransform(136.7,297.2,0.5,0.5);

	this.shape_4769 = new cjs.Shape();
	this.shape_4769.graphics.f("#000000").s().p("AhYB1QgogpAAhJQAAhJAkgsQAlgrA8AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQABA2AaAcQAaAcAuAAQAwAAAxgVIAAApQgXAKgYAGQgVAEgfAAQhDAAgmgpgAg1heQgXAYgDAqICeAAQAAgsgTgXQgUgXgkAAQgjAAgWAYg");
	this.shape_4769.setTransform(120.5,300.2,0.5,0.5);

	this.shape_4770 = new cjs.Shape();
	this.shape_4770.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAhgqA8AAQA+AAAgAtIAEAAIgDinIAuAAIAAGwIgmAAIgGgpIgCAAQggAug/AAQg7AAgigogAhAgaQgWAfABA6QAAA5AVAfQAVAdAqAAQAuABAWgaQAVgZAAg6IAAgKQAAhAgVgbQgWgcguAAQgpAAgWAfg");
	this.shape_4770.setTransform(103.3,297.2,0.5,0.5);

	this.shape_4771 = new cjs.Shape();
	this.shape_4771.graphics.f("#000000").s().p("AgXDRIAAkwIAuAAIAAEwgAgTiaQgHgIAAgQQAAgPAHgIQAJgHAKAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgKAAgJgHg");
	this.shape_4771.setTransform(91.4,297.4,0.5,0.5);

	this.shape_4772 = new cjs.Shape();
	this.shape_4772.graphics.f("#000000").s().p("AhJB1QgkgoAAhLQAAhMAkgpQAmgqBDAAQATAAAZAFQAUAEAOAHIgOAnQgLgFgXgFQgTgEgNAAQhcAAAAB1QAAA4AXAfQAXAeArAAQAmAAApgRIAAApQgfAQgvAAQhBAAgkgpg");
	this.shape_4772.setTransform(81.3,300.2,0.5,0.5);

	this.shape_4773 = new cjs.Shape();
	this.shape_4773.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhKAkgrQAlgrA8AAQA5AAAhAmQAiAlAAA+IAAAcIjRAAQABA2AaAcQAZAcAvAAQAwAAAxgVIAAApQgYAKgXAGQgVAEgfAAQhDAAgngpgAg1heQgWAXgEArICeAAQAAgsgTgXQgUgXgkAAQgjAAgWAYg");
	this.shape_4773.setTransform(66.3,300.2,0.5,0.5);

	this.shape_4774 = new cjs.Shape();
	this.shape_4774.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAigqA7AAQA9AAAhAtIAEAAIgDinIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg8AAghgogAhAgaQgVAgAAA5QAAA5AVAfQAVAdAqAAQAuABAWgaQAVgZAAg6IAAgKQAAg/gVgcQgWgcgvAAQgoAAgWAfg");
	this.shape_4774.setTransform(49.1,297.2,0.5,0.5);

	this.shape_4775 = new cjs.Shape();
	this.shape_4775.graphics.f("#000000").s().p("AgWDZIAAmxIAtAAIAAGxg");
	this.shape_4775.setTransform(728.9,258.8,0.5,0.5);

	this.shape_4776 = new cjs.Shape();
	this.shape_4776.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA6AAAhAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAwAAAxgVIAAApQgXAKgYAGQgVAEgfAAQhDAAgngpgAg1heQgWAXgEArICeAAQAAgsgUgXQgSgXglAAQgkAAgVAYg");
	this.shape_4776.setTransform(717.3,262,0.5,0.5);

	this.shape_4777 = new cjs.Shape();
	this.shape_4777.graphics.f("#000000").s().p("ABRDZIAAjGQAAgkgRgSQgRgTgkAAQgvAAgWAaQgXAbAAA6IAACgIguAAIAAmxIAuAAIAACEQAAAZgBAOIACAAQAOgWAZgNQAZgMAgAAQA3AAAcAaQAcAbAAA5IAADHg");
	this.shape_4777.setTransform(700.6,258.8,0.5,0.5);

	this.shape_4778 = new cjs.Shape();
	this.shape_4778.graphics.f("#000000").s().p("AhJB1QgkgoAAhLQAAhLAlgqQAlgqBDAAQAUAAAYAFQAUAEAOAHIgOAnQgMgFgVgFQgTgEgNAAQhcAAAAB1QAAA5AWAeQAXAeAsAAQAmAAAogRIAAApQgfAQguAAQhCAAgkgpg");
	this.shape_4778.setTransform(685.3,262,0.5,0.5);

	this.shape_4779 = new cjs.Shape();
	this.shape_4779.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgLAAgHgHg");
	this.shape_4779.setTransform(674.6,259.1,0.5,0.5);

	this.shape_4780 = new cjs.Shape();
	this.shape_4780.graphics.f("#000000").s().p("ACaDLIAAkFQAAgzAFgvIgDAAIiLFnIglAAIiKloIgDAAQAFAuAAA5IAAEBIgsAAIAAmWIBHAAICBFPIABAAICClPIBHAAIAAGWg");
	this.shape_4780.setTransform(658.1,259.4,0.5,0.5);

	this.shape_4781 = new cjs.Shape();
	this.shape_4781.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAigqA8AAQA9AAAgAtIAEAAIgCgVIgBiSIAuAAIAAGwIgmAAIgGgpIgCAAQggAug+AAQg8AAgigogAhAgaQgVAeAAA7QAAA6AVAeQAVAdAqAAQAuABAWgaQAVgZAAg6IAAgKQAAhAgVgbQgWgcgvAAQgoAAgWAfg");
	this.shape_4781.setTransform(628.7,258.9,0.5,0.5);

	this.shape_4782 = new cjs.Shape();
	this.shape_4782.graphics.f("#000000").s().p("ABRCbIAAjEQABglgSgTQgRgSgkAAQgvAAgWAaQgXAZAAA9IAACeIguAAIAAkwIAmAAIAHAqIADAAQAOgWAagNQAagMAdAAQA4AAAbAbQAcAaAAA6IAADGg");
	this.shape_4782.setTransform(611.7,261.8,0.5,0.5);

	this.shape_4783 = new cjs.Shape();
	this.shape_4783.graphics.f("#000000").s().p("AhgCGQgagXAAgrQABhcCTgEIAzgCIAAgTQAAgjgPgSQgPgRgjAAQgmAAgvAYIgOgkQAXgMAagHQAagHAbAAQA3AAAaAYQAaAYAAA2IAADPIgiAAIgJgrIgDAAQgXAdgWAJQgXALggAAQgtAAgbgYgAAeAEQg2ACgZAPQgYAQAAAfQAAAaAPAMQAQAOAbAAQAqAAAYgYQAZgXAAgrIAAgcg");
	this.shape_4783.setTransform(594.5,262,0.5,0.5);

	this.shape_4784 = new cjs.Shape();
	this.shape_4784.graphics.f("#000000").s().p("AhqCLIAAgrQAWALAZAHQAbAGAVAAQAkAAATgMQAUgLAAgYQAAgRgQgNQgQgNgrgRQgrgPgSgMQgSgMgIgPQgJgPAAgVQAAglAegVQAfgWAzAAQAwAAAxAUIgRAmQgsgTgnAAQgfAAgSAKQgQAKAAASQAAANAGAIQAGAJAOAIQAQAIAlAOQA1ATAUAUQATAUAAAeQAAArggAXQggAXg4AAQg8AAgigTg");
	this.shape_4784.setTransform(572.9,262,0.5,0.5);

	this.shape_4785 = new cjs.Shape();
	this.shape_4785.graphics.f("#000000").s().p("ABRCbIAAjEQABglgSgTQgRgSgjAAQgwAAgWAaQgWAaAAA8IAACeIgvAAIAAkwIAmAAIAIAqIACAAQAPgWAZgNQAagMAeAAQA3AAAcAbQAcAaAAA6IAADGg");
	this.shape_4785.setTransform(557.4,261.8,0.5,0.5);

	this.shape_4786 = new cjs.Shape();
	this.shape_4786.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgLAAgHgHg");
	this.shape_4786.setTransform(545,259.1,0.5,0.5);

	this.shape_4787 = new cjs.Shape();
	this.shape_4787.graphics.f("#000000").s().p("ABCDZIhriRIgiAeIAABzIguAAIAAmxIAuAAIgDEUIADAAQANgTAXgZIBihnIA3AAIh7CBICDCvg");
	this.shape_4787.setTransform(535,258.8,0.5,0.5);

	this.shape_4788 = new cjs.Shape();
	this.shape_4788.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAbAMAQQAOAPAWAAIAYgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4788.setTransform(521.3,260.3,0.5,0.5);

	this.shape_4789 = new cjs.Shape();
	this.shape_4789.graphics.f("#000000").s().p("AhgCGQgZgXAAgrQAAhcCSgEIA0gCIAAgTQAAgjgPgSQgQgRgiAAQgmAAgvAYIgOgkQAWgMAbgHQAagHAbAAQA3AAAaAYQAaAYAAA2IAADPIgiAAIgJgrIgCAAQgYAdgWAJQgXALghAAQgtAAgagYgAAeAEQg2ACgZAPQgYAQAAAfQAAAZAPANQAPAOAcAAQAqAAAYgYQAZgXAAgrIAAgcg");
	this.shape_4789.setTransform(507.9,262,0.5,0.5);

	this.shape_4790 = new cjs.Shape();
	this.shape_4790.graphics.f("#000000").s().p("ABkDLIhSkPIgNguQgGgbAAgGQgGAmgOAqIhPEOIgvAAIhsmWIAyAAIBAD7QANA1AHArQAIg2AOguIBJj3IAxAAIBMD5QAOAsAJA2QAEgkAQg9IBAj6IAyAAIhtGWg");
	this.shape_4790.setTransform(487.3,259.4,0.5,0.5);

	this.shape_4791 = new cjs.Shape();
	this.shape_4791.graphics.f("#000000").s().p("AgpBGIAQhGQAJgkAFghIAxAAIAEAHQgGAZgPAmQgMAigPAjg");
	this.shape_4791.setTransform(462.7,269.8,0.5,0.5);

	this.shape_4792 = new cjs.Shape();
	this.shape_4792.graphics.f("#000000").s().p("AAcDLIAAkhQAAggADgkIhPBDIgYghIBrhTIAmAAIAAGWg");
	this.shape_4792.setTransform(449.7,259.4,0.5,0.5);

	this.shape_4793 = new cjs.Shape();
	this.shape_4793.graphics.f("#000000").s().p("AhhC1QgjgdAAg0QAAhGBUgmQgmgWgRgZQgQgZgBgfQAAgsAigbQAggaA2AAQA4AAAgAaQAgAZABAuQAAAfgTAYQgTAZgpAUQAyAXAVAaQAUAZAAAjQAAAzgjAeQgjAeg9AAQhBAAgigcgAhEAxQgTAWAAAeQAAAhAXATQAXATAqAAQApAAAXgUQAXgTAAgiQAAgbgVgVQgVgVg3gUQgpASgSAVgAg3iaQgTARAAAcQAAAZAQATQASATAqARQAogQAQgUQARgSAAgaQAAgdgUgQQgUgRgjAAQgiAAgVARg");
	this.shape_4793.setTransform(435.3,259.4,0.5,0.5);

	this.shape_4794 = new cjs.Shape();
	this.shape_4794.graphics.f("#000000").s().p("AhmDMIAAgoQAWAHAdAAQBBAAAigpQAjgpADhWIgEAAQgPAXgZAMQgaAMgeAAQg2AAggggQgggfAAg6QAAhAAkgkQAjglA6AAQApAAAfAVQAfAWAQAoQARApAAA3QAADui4AAQgfAAgUgFgAhAiPQgWAaAAAtQAAAoAUAXQAUAWApAAQAYAAAVgKQAVgJANgSQAMgSAAgUQAAgcgLgaQgMgZgUgNQgVgPgZAAQgoAAgVAag");
	this.shape_4794.setTransform(418.9,259.4,0.5,0.5);

	this.shape_4795 = new cjs.Shape();
	this.shape_4795.graphics.f("#000000").s().p("AAcDLIAAkhQAAgoACgcIhOBDIgYghIBqhTIAnAAIAAGWg");
	this.shape_4795.setTransform(400.8,259.4,0.5,0.5);

	this.shape_4796 = new cjs.Shape();
	this.shape_4796.graphics.f("#000000").s().p("ABRCbIAAjEQABglgSgTQgQgSglAAQgvAAgWAaQgWAZAAA9IAACeIgvAAIAAkwIAmAAIAHAqIADAAQAOgWAagNQAagMAdAAQA4AAAbAbQAcAaAAA6IAADGg");
	this.shape_4796.setTransform(378.5,261.8,0.5,0.5);

	this.shape_4797 = new cjs.Shape();
	this.shape_4797.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgIAAgQQAAgPAIgIQAHgHALAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgLAAgHgHg");
	this.shape_4797.setTransform(366,259.1,0.5,0.5);

	this.shape_4798 = new cjs.Shape();
	this.shape_4798.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhKAhgqQAhgqA8AAQA9AAAhAtIAEAAIgDinIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg7AAgigogAhAgaQgVAeAAA7QAAA6AVAeQAVAdAqAAQAuABAWgaQAVgaAAg5IAAgKQAAhAgWgbQgVgcgvAAQgoAAgWAfg");
	this.shape_4798.setTransform(345.9,258.9,0.5,0.5);

	this.shape_4799 = new cjs.Shape();
	this.shape_4799.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA8AAQA4AAAjAmQAhAmAAA9IAAAcIjSAAQACA2AaAcQAaAcAtAAQAxAAAwgVIAAApQgWAKgXAGQgWAEggAAQhCAAgngpgAg2heQgVAXgFArICfAAQAAgsgTgXQgTgXglAAQgjAAgXAYg");
	this.shape_4799.setTransform(329.6,262,0.5,0.5);

	this.shape_4800 = new cjs.Shape();
	this.shape_4800.graphics.f("#000000").s().p("AhqCLIAAgrQAYAMAXAGQAbAGAWAAQAiAAAUgMQAUgLgBgYQAAgSgPgMQgPgMgsgSQgrgPgRgMQgSgMgJgPQgJgPAAgVQAAglAegVQAfgWA0AAQAwAAAvAUIgQAmQgtgTgmAAQggAAgQAKQgRAKAAASQAAAMAGAJQAHAJAOAIQAMAHAoAPQA2AUATATQATAUAAAeQAAArggAXQggAXg3AAQg9AAgigTg");
	this.shape_4800.setTransform(314.9,262,0.5,0.5);

	this.shape_4801 = new cjs.Shape();
	this.shape_4801.graphics.f("#000000").s().p("AhJCLQgfgSgSglQgRglAAgvQAAhKAlgpQAlgqBCAAQBAAAAlArQAmApAABJQAABKglAqQgmAqhBAAQgpAAgggTgAhEhYQgXAdAAA7QAAA7AXAeQAXAeAtAAQAuAAAXgeQAXgfAAg6QAAg5gXgfQgXgeguAAQgtAAgXAeg");
	this.shape_4801.setTransform(299.4,262,0.5,0.5);

	this.shape_4802 = new cjs.Shape();
	this.shape_4802.graphics.f("#000000").s().p("AgWDZIAAmxIAtAAIAAGxg");
	this.shape_4802.setTransform(287.2,258.8,0.5,0.5);

	this.shape_4803 = new cjs.Shape();
	this.shape_4803.graphics.f("#000000").s().p("AhJB1QgkgoAAhLQAAhLAlgqQAlgqBDAAQAUAAAYAFQAUAEAOAHIgOAnQgMgFgVgFQgTgEgNAAQhcAAAAB1QAAA5AWAeQAXAeAsAAQAmAAAogRIAAApQgfAQguAAQhCAAgkgpg");
	this.shape_4803.setTransform(277.1,262,0.5,0.5);

	this.shape_4804 = new cjs.Shape();
	this.shape_4804.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAFA5IADAAQAQgeAZgQQAXgQAcAAQASgBATAEIgHArQgSgFgPAAQglAAgZAfQgbAeAAAsIAACjg");
	this.shape_4804.setTransform(257.8,261.8,0.5,0.5);

	this.shape_4805 = new cjs.Shape();
	this.shape_4805.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhKAkgrQAlgrA8AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQACA2AZAcQAaAcAtAAQAxAAAxgVIAAApQgXAKgXAGQgWAEgfAAQhDAAgngpgAg2heQgVAYgEAqICeAAQABgsgUgXQgUgXgjAAQgkAAgXAYg");
	this.shape_4805.setTransform(243,262,0.5,0.5);

	this.shape_4806 = new cjs.Shape();
	this.shape_4806.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgTiaQgHgIAAgQQAAgPAHgIQAJgHAKAAQALAAAIAHQAIAIAAAPQAAAQgIAIQgIAHgLAAQgKAAgJgHg");
	this.shape_4806.setTransform(231.4,259.1,0.5,0.5);

	this.shape_4807 = new cjs.Shape();
	this.shape_4807.graphics.f("#000000").s().p("AgWDZIAAmxIAtAAIAAGxg");
	this.shape_4807.setTransform(224.1,258.8,0.5,0.5);

	this.shape_4808 = new cjs.Shape();
	this.shape_4808.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA5AAAiAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAvAAAygVIAAApQgYAKgXAGQgVAEgfAAQhDAAgngpgAg1heQgWAYgEAqICfAAQgBgsgTgXQgUgXgkAAQgkAAgVAYg");
	this.shape_4808.setTransform(212.6,262,0.5,0.5);

	this.shape_4809 = new cjs.Shape();
	this.shape_4809.graphics.f("#000000").s().p("AguBhIAAi0IgrAAIAAgWIArgUIAUhBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAbAMAQQAOAPAWAAIAYgCIASgEIAAAjQgHAEgPACQgQADgKAAQhYAAAAheg");
	this.shape_4809.setTransform(199.4,260.3,0.5,0.5);

	this.shape_4810 = new cjs.Shape();
	this.shape_4810.graphics.f("#000000").s().p("ACDDMIgyiBIiiAAIgyCBIgwAAIChmXIAmAAICgGXgAgRhdIgwB9ICDAAIgvh9QgJgYgKgiQgFAYgMAig");
	this.shape_4810.setTransform(185.5,259.4,0.5,0.5);

	this.shape_4811 = new cjs.Shape();
	this.shape_4811.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhKAkgrQAlgrA8AAQA5AAAiAmQAhAlAAA+IAAAcIjRAAQACA2AZAcQAaAcAtAAQAxAAAxgVIAAApQgXAKgYAGQgVAEgfAAQhCAAgogpgAg1heQgWAXgEArICeAAQABgsgUgXQgUgXgjAAQgkAAgWAYg");
	this.shape_4811.setTransform(161.1,262,0.5,0.5);

	this.shape_4812 = new cjs.Shape();
	this.shape_4812.graphics.f("#000000").s().p("ABSDZIAAjGQAAgkgRgSQgRgTgkAAQgwAAgWAaQgWAbAAA6IAACgIgvAAIAAmxIAvAAIAACEQAAAVgDASIAEAAQANgWAagNQAYgMAgAAQA5AAAbAaQAcAaAAA6IAADHg");
	this.shape_4812.setTransform(144.4,258.8,0.5,0.5);

	this.shape_4813 = new cjs.Shape();
	this.shape_4813.graphics.f("#000000").s().p("AgtBhIAAi0IgtAAIAAgWIAtgUIAThBIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAbANAQQANAPAXAAIAXgCIASgEIAAAjQgIAEgOACQgQADgKAAQhXAAAAheg");
	this.shape_4813.setTransform(130.5,260.3,0.5,0.5);

	this.shape_4814 = new cjs.Shape();
	this.shape_4814.graphics.f("#000000").s().p("ABRCbIAAjEQAAglgRgTQgRgSgkAAQguAAgXAaQgWAZAAA9IAACeIguAAIAAkwIAlAAIAIAqIACAAQAOgWAZgNQAcgMAdAAQA3AAAbAbQAcAaAAA6IAADGg");
	this.shape_4814.setTransform(109.4,261.8,0.5,0.5);

	this.shape_4815 = new cjs.Shape();
	this.shape_4815.graphics.f("#000000").s().p("AhZB1QgngpAAhJQAAhJAkgsQAlgrA7AAQA5AAAiAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAwAAAxgVIAAApQgXAKgYAGQgVAEgfAAQhDAAgngpgAg1heQgWAYgEAqICfAAQgBgsgTgXQgUgXgkAAQgkAAgVAYg");
	this.shape_4815.setTransform(92.7,262,0.5,0.5);

	this.shape_4816 = new cjs.Shape();
	this.shape_4816.graphics.f("#000000").s().p("ABRDZIAAjGQAAgkgRgSQgRgTgkAAQgvAAgWAaQgXAbAAA6IAACgIgtAAIAAmxIAtAAIAACEQAAAZgBAOIACAAQAPgXAYgMQAZgMAgAAQA4AAAbAaQAcAbAAA5IAADHg");
	this.shape_4816.setTransform(76,258.8,0.5,0.5);

	this.shape_4817 = new cjs.Shape();
	this.shape_4817.graphics.f("#000000").s().p("ABlDLIhSkPQgHgUgHgaQgGgbAAgGQgGAmgOAqIhPEOIgvAAIhsmWIAyAAIBAD7QAOA1AFArQAIgzAPgxIBJj3IAxAAIBND5QANAsAJA2QAFgpAPg4IBAj6IAyAAIhtGWg");
	this.shape_4817.setTransform(53.9,259.4,0.5,0.5);

	this.instance_20 = new lib.pearl();
	this.instance_20.parent = this;
	this.instance_20.setTransform(1216,182,0.732,0.732);

	this.shape_4818 = new cjs.Shape();
	this.shape_4818.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_4818.setTransform(499.8,812.7,0.5,0.5);

	this.shape_4819 = new cjs.Shape();
	this.shape_4819.graphics.f("#000000").s().p("AhKBhIAAgVQAfAQAkAAQAfAAAQgKQAQgKAAgSQAAgQgNgLQgNgLgegLQgdgKgOgJQgNgIgHgKQgGgKAAgQQAAgYAUgNQAUgOAjAAQAjAAAeANIgHASQgggOgaAAQgZAAgQAJQgOAJAAAPQgBAQAMALQAMAKAiALQAbALAOAIQAOAHAGALQAGAMAAANQAAAcgWAQQgUAPgoAAQgrAAgYgNg");
	this.shape_4819.setTransform(492.7,808.1,0.5,0.5);

	this.shape_4820 = new cjs.Shape();
	this.shape_4820.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgdAAQglAAgSATQgSAUAAArIAAB0IgTAAIAAjTIAQAAIAEAdIACAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_4820.setTransform(482.3,808,0.5,0.5);

	this.shape_4821 = new cjs.Shape();
	this.shape_4821.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgMh9QAAgTAMAAQAGAAADAEQAEAGAAAJQAAAHgEAGQgDAGgGAAQgMgBAAgSg");
	this.shape_4821.setTransform(474.1,806.2,0.5,0.5);

	this.shape_4822 = new cjs.Shape();
	this.shape_4822.graphics.f("#000000").s().p("AA3CYIhPhsIgjAgIAABMIgTAAIAAkvIATAAIgBDSIABAAIBrh3IAYAAIhTBaIBaB6g");
	this.shape_4822.setTransform(467.9,805.8,0.5,0.5);

	this.shape_4823 = new cjs.Shape();
	this.shape_4823.graphics.f("#000000").s().p("AgOB3QgNgPAAggIAAiIIggAAIAAgMIAggJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAHALQAJAMATAAQASAAAOgDIAAAPQgPAFgSAAQgbAAgOgPg");
	this.shape_4823.setTransform(458.6,806.9,0.5,0.5);

	this.shape_4824 = new cjs.Shape();
	this.shape_4824.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgbAAQgcAAghAQIgHgRQAjgQAhAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAWAAQAhAAAUgTQAUgUAAgiIAAgUg");
	this.shape_4824.setTransform(449.8,808.1,0.5,0.5);

	this.shape_4825 = new cjs.Shape();
	this.shape_4825.graphics.f("#000000").s().p("ABJCPIg/jcIgKgsIgJAnIg/DhIgRAAIhPkdIAWAAIBCD9QAGgfAOgyIAxisIAVAAIA5DGIAPA3IAGgeIA8jfIAVAAIhPEdg");
	this.shape_4825.setTransform(435.9,806.3,0.5,0.5);

	this.shape_4826 = new cjs.Shape();
	this.shape_4826.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_4826.setTransform(416.1,808.1,0.5,0.5);

	this.shape_4827 = new cjs.Shape();
	this.shape_4827.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAVAAQANAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAWAAAkIAAB0g");
	this.shape_4827.setTransform(408,808,0.5,0.5);

	this.shape_4828 = new cjs.Shape();
	this.shape_4828.graphics.f("#000000").s().p("AhBB/QgYgcAAg0QAAg2AYgdQAWgdAsAAQAYAAAPAIQASAJAMAUIACAAIgCgwIAAhNIAUAAIAAEvIgNAAIgFggIgCAAQgYAkgtAAQgrAAgXgbgAgzgXQgRAXAAAvQAABaBFAAQAkAAARgVQAQgVAAgwIAAgDQAAgwgQgWQgRgWgkAAQgjAAgRAZg");
	this.shape_4828.setTransform(397.1,805.9,0.5,0.5);

	this.shape_4829 = new cjs.Shape();
	this.shape_4829.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_4829.setTransform(385.7,808,0.5,0.5);

	this.shape_4830 = new cjs.Shape();
	this.shape_4830.graphics.f("#000000").s().p("Ag+BeQgRgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAkgQAgAAQAjAAARASQASATAAAmIAACMIgPAAIgFgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgRgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_4830.setTransform(374.1,808.1,0.5,0.5);

	this.shape_4831 = new cjs.Shape();
	this.shape_4831.graphics.f("#000000").s().p("ABCBqIhChfIhDBfIgVAAIBNhsIhKhnIAXAAIA+BZIA/hZIAUAAIhIBnIBOBsg");
	this.shape_4831.setTransform(364.1,808.1,0.5,0.5);

	this.shape_4832 = new cjs.Shape();
	this.shape_4832.graphics.f("#000000").s().p("Ag8BSQgagcAAg0QAAgxAZgfQAagfApAAQAlAAAWAaQAWAaAAAtIAAAPIiYAAQAAArAUAXQAUAXAkABQAVgBALgCQAPgCAUgJIAAARQgRAIgQAEQgNACgVAAQgsAAgbgcgAgqhHQgTAUgDAlICCAAQAAgkgQgVQgQgVgcAAQgeAAgSAVg");
	this.shape_4832.setTransform(353.7,808.1,0.5,0.5);

	this.shape_4833 = new cjs.Shape();
	this.shape_4833.graphics.f("#000000").s().p("AgJCYIAAkvIATAAIAAEvg");
	this.shape_4833.setTransform(345.9,805.8,0.5,0.5);

	this.shape_4834 = new cjs.Shape();
	this.shape_4834.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgnhlQgFgNgGgVQgGAWgFAMg");
	this.shape_4834.setTransform(337.7,806.3,0.5,0.5);

	this.shape_4835 = new cjs.Shape();
	this.shape_4835.graphics.f("#000000").s().p("AhaCWIAAgRQALADANAAQAKAAAIgEQAHgEAHgLQAHgLAHgUIAKgcIhRjTIAUAAIAtB3QAUA0AGAVIAAAAIBIjAIAUAAIheD1QgNAhgHAIQgHAKgLAGQgLAFgOAAQgKAAgPgEg");
	this.shape_4835.setTransform(321.9,810.5,0.5,0.5);

	this.shape_4836 = new cjs.Shape();
	this.shape_4836.graphics.f("#000000").s().p("AgoCRQgTgKgLgRIgBAAIgFAgIgNAAIAAkvIATAAIgBB9IABAAQANgTARgJQARgJAXAAQAtAAAWAcQAWAcAAA1QABA1gYAcQgYAdgqAAQgXAAgRgJgAg1gaQgQAWgBAwIAAADQAAAvARAWQASAVAjAAQAiAAARgZQASgXAAguQAAhbhFAAQgmAAgPAWg");
	this.shape_4836.setTransform(311.6,805.9,0.5,0.5);

	this.shape_4837 = new cjs.Shape();
	this.shape_4837.graphics.f("#000000").s().p("AgXAxQAGgTAGgcQAIgiACgQIAWAAIACAEQgOAygTArg");
	this.shape_4837.setTransform(298.7,801.6,0.5,0.5);

	this.shape_4838 = new cjs.Shape();
	this.shape_4838.graphics.f("#000000").s().p("ABUCPIAAiNIinAAIAACNIgTAAIAAkdIATAAIAAB/ICnAAIAAh/IAUAAIAAEdg");
	this.shape_4838.setTransform(290.1,806.3,0.5,0.5);

	this.shape_4839 = new cjs.Shape();
	this.shape_4839.graphics.f("#000000").s().p("AhGBsQgignAAhFQAAgrAQghQAQghAggTQAfgSAoAAQApAAAhAQIgIASQgggQghAAQg1AAgfAjQgfAjAAA6QAAA9AeAiQAcAiA2AAQAlAAAdgKIAAASQgbAKgsAAQg8AAgigng");
	this.shape_4839.setTransform(277,806.3,0.5,0.5);

	this.shape_4840 = new cjs.Shape();
	this.shape_4840.graphics.f("#000000").s().p("AhdBrQghgmAAhFQAAhEAhgnQAjgnA6AAQA8AAAiAnQAhAoAABDQABBFgjAmQghAog8AAQg7AAgigogAhOhdQgbAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgcAig");
	this.shape_4840.setTransform(262.8,806.3,0.5,0.5);

	this.shape_4841 = new cjs.Shape();
	this.shape_4841.graphics.f("#000000").s().p("AhdBrQgignAAhEQAAhEAjgnQAignA6AAQA8AAAiAnQAiAoAABDQAABEgiAnQgiAog8AAQg6AAgjgogAhNhdQgcAgAAA9QAAA9AbAiQAcAhAyAAQA0AAAbghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgbAig");
	this.shape_4841.setTransform(247.5,806.3,0.5,0.5);

	this.shape_4842 = new cjs.Shape();
	this.shape_4842.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgPATgfAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_4842.setTransform(234.7,806.3,0.5,0.5);

	this.shape_4843 = new cjs.Shape();
	this.shape_4843.graphics.f("#000000").s().p("AhdCPIAAkdIBOAAQA1AAAYASQAZASAAAkQAAAZgQARQgPAQgdAFIAAABQAiAFARAQQAQAQAAAeQAAAngaAVQgbAWgvAAgAhJB9IBDAAQBPAAgBhAQAAg7hSAAIg/AAgAhJgPIA/AAQAnAAASgNQASgOAAgcQAAgcgUgOQgVgMgoAAIg5AAg");
	this.shape_4843.setTransform(222.2,806.3,0.5,0.5);

	this.shape_4844 = new cjs.Shape();
	this.shape_4844.graphics.f("#000000").s().p("AhNCPIAAkdIAUAAIAAEKICHAAIAAATg");
	this.shape_4844.setTransform(205.9,806.3,0.5,0.5);

	this.shape_4845 = new cjs.Shape();
	this.shape_4845.graphics.f("#000000").s().p("ABGCPIhIh9IhHAAIAAB9IgUAAIAAkdIBEAAQA0AAAZAUQAaATAAAoQAAAdgPATQgQATgeAIIBNCDgAhJABIA2AAQAkAAATgPQAUgQAAggQAAgggTgPQgUgPgrAAIgvAAg");
	this.shape_4845.setTransform(194.9,806.3,0.5,0.5);

	this.shape_4846 = new cjs.Shape();
	this.shape_4846.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgmhlQgEgJgIgZQgFATgGAPg");
	this.shape_4846.setTransform(182.1,806.3,0.5,0.5);

	this.shape_4847 = new cjs.Shape();
	this.shape_4847.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiIAAIAABsICAAAIAAASIiAAAIAAB6ICIAAIAAATg");
	this.shape_4847.setTransform(171,806.3,0.5,0.5);

	this.shape_4848 = new cjs.Shape();
	this.shape_4848.graphics.f("#000000").s().p("AhVCPIAAkdIBGAAQBlAAAABSQAAAqgcAVQgcAWgzAAIgsAAIAAB2gAhBAHIAnAAQAwAAAVgPQAVgPAAgkQAAghgUgQQgUgQgqAAIgvAAg");
	this.shape_4848.setTransform(159.7,806.3,0.5,0.5);

	this.shape_4849 = new cjs.Shape();
	this.shape_4849.graphics.f("#000000").s().p("ABhCQIgnhmIhzAAIgoBmIgWAAIBzkeIALAAIBxEegAgKhNIgoBlIBlAAIgmhlQgGgNgHgVQgEAWgGAMg");
	this.shape_4849.setTransform(142.2,806.3,0.5,0.5);

	this.shape_4850 = new cjs.Shape();
	this.shape_4850.graphics.f("#000000").s().p("AhNCPIAAkdICbAAIAAASIiHAAIAABsICAAAIAAASIiAAAIAAB6ICHAAIAAATg");
	this.shape_4850.setTransform(131.1,806.3,0.5,0.5);

	this.shape_4851 = new cjs.Shape();
	this.shape_4851.graphics.f("#000000").s().p("AhXCHIAAgTQAfANAvAAQAiAAAVgRQAVgQAAgaQAAgQgHgLQgHgKgPgJQgSgKgbgJQgsgOgQgSQgRgRAAgdQAAggAZgUQAagVAmAAQApAAAiAQIgHARQgjgPghAAQgeAAgTAPQgTAOAAAZQAAAQAGAKQAGALANAIQANAIAfALQAiALAQALQARAKAHAOQAIAPAAASQAAAkgaAVQgbAVgqAAQg2AAgagMg");
	this.shape_4851.setTransform(119.8,806.3,0.5,0.5);

	this.shape_4852 = new cjs.Shape();
	this.shape_4852.graphics.f("#000000").s().p("ABTCPIAAiNIilAAIAACNIgUAAIAAkdIAUAAIAAB/IClAAIAAh/IAVAAIAAEdg");
	this.shape_4852.setTransform(101.9,806.3,0.5,0.5);

	this.shape_4853 = new cjs.Shape();
	this.shape_4853.graphics.f("#000000").s().p("AgJCPIAAkKIhdAAIAAgTIDNAAIAAATIhdAAIAAEKg");
	this.shape_4853.setTransform(89.4,806.3,0.5,0.5);

	this.shape_4854 = new cjs.Shape();
	this.shape_4854.graphics.f("#000000").s().p("AhOB1QgcgcAAgyIAAi3IAUAAIAAC4QAAAqAXAWQAXAXApAAQApAAAWgWQAXgXAAgoIAAi6IAUAAIAAC4QAAAygdAbQgcAbgyAAQgyAAgcgbg");
	this.shape_4854.setTransform(77,806.4,0.5,0.5);

	this.shape_4855 = new cjs.Shape();
	this.shape_4855.graphics.f("#000000").s().p("AhcBrQgjgnABhEQgBhDAjgoQAignA6AAQA8AAAiAnQAhAoAABDQABBFgjAmQghAog8AAQg7AAghgogAhOhdQgbAhAAA8QAAA9AbAiQAcAhAyAAQAzAAAcghQAbghAAg+QAAg9gbghQgbghg0AAQgyAAgcAig");
	this.shape_4855.setTransform(62.2,806.3,0.5,0.5);

	this.shape_4856 = new cjs.Shape();
	this.shape_4856.graphics.f("#000000").s().p("AhXCHIAAgTQAfANAvAAQAiAAAVgRQAVgQAAgaQAAgQgHgLQgHgKgPgJQgSgKgbgJQgsgOgQgSQgRgRAAgdQAAggAZgUQAagVAmAAQApAAAiAQIgHARQgjgPghAAQgeAAgTAPQgTAOAAAZQAAAQAGAKQAGALANAIQANAIAfALQAiALAQALQARAKAHAOQAIAPAAASQAAAkgaAVQgbAVgqAAQg2AAgagMg");
	this.shape_4856.setTransform(49.1,806.3,0.5,0.5);

	this.shape_4857 = new cjs.Shape();
	this.shape_4857.graphics.f("#000000").s().p("AgUAxIgCgEIAQgwQAJgcAIgRIAMAAQgFASgHAfQgHAggCAQg");
	this.shape_4857.setTransform(42.2,801.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_4857},{t:this.shape_4856},{t:this.shape_4855},{t:this.shape_4854},{t:this.shape_4853},{t:this.shape_4852},{t:this.shape_4851},{t:this.shape_4850},{t:this.shape_4849},{t:this.shape_4848},{t:this.shape_4847},{t:this.shape_4846},{t:this.shape_4845},{t:this.shape_4844},{t:this.shape_4843},{t:this.shape_4842},{t:this.shape_4841},{t:this.shape_4840},{t:this.shape_4839},{t:this.shape_4838},{t:this.shape_4837},{t:this.shape_4836},{t:this.shape_4835},{t:this.shape_4834},{t:this.shape_4833},{t:this.shape_4832},{t:this.shape_4831},{t:this.shape_4830},{t:this.shape_4829},{t:this.shape_4828},{t:this.shape_4827},{t:this.shape_4826},{t:this.shape_4825},{t:this.shape_4824},{t:this.shape_4823},{t:this.shape_4822},{t:this.shape_4821},{t:this.shape_4820},{t:this.shape_4819},{t:this.shape_4818},{t:this.instance_20},{t:this.shape_4817},{t:this.shape_4816},{t:this.shape_4815},{t:this.shape_4814},{t:this.shape_4813},{t:this.shape_4812},{t:this.shape_4811},{t:this.shape_4810},{t:this.shape_4809},{t:this.shape_4808},{t:this.shape_4807},{t:this.shape_4806},{t:this.shape_4805},{t:this.shape_4804},{t:this.shape_4803},{t:this.shape_4802},{t:this.shape_4801},{t:this.shape_4800},{t:this.shape_4799},{t:this.shape_4798},{t:this.shape_4797},{t:this.shape_4796},{t:this.shape_4795},{t:this.shape_4794},{t:this.shape_4793},{t:this.shape_4792},{t:this.shape_4791},{t:this.shape_4790},{t:this.shape_4789},{t:this.shape_4788},{t:this.shape_4787},{t:this.shape_4786},{t:this.shape_4785},{t:this.shape_4784},{t:this.shape_4783},{t:this.shape_4782},{t:this.shape_4781},{t:this.shape_4780},{t:this.shape_4779},{t:this.shape_4778},{t:this.shape_4777},{t:this.shape_4776},{t:this.shape_4775},{t:this.shape_4774},{t:this.shape_4773},{t:this.shape_4772},{t:this.shape_4771},{t:this.shape_4770},{t:this.shape_4769},{t:this.shape_4768},{t:this.shape_4767},{t:this.shape_4766},{t:this.shape_4765},{t:this.shape_4764},{t:this.shape_4763},{t:this.shape_4762},{t:this.shape_4761},{t:this.shape_4760},{t:this.shape_4759},{t:this.shape_4758},{t:this.shape_4757},{t:this.shape_4756},{t:this.shape_4755},{t:this.shape_4754},{t:this.shape_4753},{t:this.shape_4752},{t:this.shape_4751},{t:this.shape_4750},{t:this.shape_4749},{t:this.shape_4748},{t:this.shape_4747},{t:this.shape_4746},{t:this.shape_4745},{t:this.shape_4744},{t:this.shape_4743},{t:this.shape_4742},{t:this.shape_4741},{t:this.shape_4740},{t:this.shape_4739},{t:this.shape_4738},{t:this.shape_4737},{t:this.shape_4736},{t:this.shape_4735},{t:this.shape_4734},{t:this.shape_4733},{t:this.shape_4732},{t:this.shape_4731},{t:this.shape_4730},{t:this.shape_4729},{t:this.shape_4728},{t:this.shape_4727},{t:this.shape_4726},{t:this.shape_4725},{t:this.shape_4724},{t:this.shape_4723},{t:this.shape_4722},{t:this.shape_4721},{t:this.shape_4720},{t:this.shape_4719},{t:this.shape_4718},{t:this.shape_4717},{t:this.shape_4716},{t:this.shape_4715},{t:this.shape_4714},{t:this.shape_4713},{t:this.shape_4712},{t:this.shape_4711},{t:this.shape_4710},{t:this.shape_4709},{t:this.shape_4708},{t:this.shape_4707},{t:this.shape_4706},{t:this.shape_4705},{t:this.shape_4704},{t:this.shape_4703},{t:this.shape_4702},{t:this.shape_4701},{t:this.shape_4700},{t:this.shape_4699},{t:this.shape_4698},{t:this.shape_4697},{t:this.shape_4696},{t:this.shape_4695},{t:this.shape_4694},{t:this.shape_4693},{t:this.shape_4692},{t:this.shape_4691},{t:this.shape_4690},{t:this.shape_4689},{t:this.shape_4688},{t:this.shape_4687},{t:this.shape_4686},{t:this.shape_4685},{t:this.shape_4684},{t:this.shape_4683},{t:this.shape_4682},{t:this.shape_4681},{t:this.shape_4680},{t:this.shape_4679},{t:this.shape_4678},{t:this.shape_4677},{t:this.shape_4676},{t:this.shape_4675},{t:this.shape_4674},{t:this.shape_4673},{t:this.shape_4672},{t:this.shape_4671},{t:this.shape_4670},{t:this.shape_4669},{t:this.shape_4668},{t:this.shape_4667},{t:this.shape_4666},{t:this.shape_4665},{t:this.shape_4664},{t:this.shape_4663},{t:this.shape_4662},{t:this.shape_4661},{t:this.shape_4660},{t:this.shape_4659},{t:this.shape_4658},{t:this.shape_4657},{t:this.shape_4656},{t:this.shape_4655},{t:this.shape_4654},{t:this.shape_4653},{t:this.shape_4652},{t:this.shape_4651},{t:this.shape_4650},{t:this.shape_4649},{t:this.shape_4648},{t:this.shape_4647},{t:this.shape_4646},{t:this.shape_4645},{t:this.shape_4644},{t:this.shape_4643},{t:this.shape_4642},{t:this.shape_4641},{t:this.shape_4640},{t:this.shape_4639},{t:this.shape_4638},{t:this.shape_4637},{t:this.shape_4636},{t:this.shape_4635},{t:this.shape_4634},{t:this.shape_4633},{t:this.shape_4632},{t:this.shape_4631},{t:this.shape_4630},{t:this.shape_4629},{t:this.shape_4628},{t:this.shape_4627},{t:this.shape_4626},{t:this.shape_4625},{t:this.shape_4624},{t:this.shape_4623},{t:this.shape_4622},{t:this.shape_4621},{t:this.shape_4620},{t:this.shape_4619},{t:this.shape_4618},{t:this.shape_4617},{t:this.shape_4616},{t:this.shape_4615},{t:this.shape_4614},{t:this.shape_4613},{t:this.shape_4612},{t:this.shape_4611},{t:this.shape_4610},{t:this.shape_4609},{t:this.shape_4608},{t:this.shape_4607},{t:this.shape_4606},{t:this.shape_4605},{t:this.shape_4604},{t:this.shape_4603},{t:this.shape_4602},{t:this.shape_4601},{t:this.shape_4600},{t:this.shape_4599},{t:this.shape_4598},{t:this.shape_4597},{t:this.shape_4596},{t:this.shape_4595},{t:this.shape_4594},{t:this.shape_4593},{t:this.shape_4592},{t:this.shape_4591},{t:this.shape_4590},{t:this.shape_4589},{t:this.shape_4588},{t:this.shape_4587},{t:this.shape_4586},{t:this.shape_4585},{t:this.shape_4584},{t:this.shape_4583},{t:this.shape_4582},{t:this.shape_4581},{t:this.shape_4580},{t:this.shape_4579},{t:this.shape_4578},{t:this.shape_4577},{t:this.shape_4576},{t:this.shape_4575},{t:this.shape_4574},{t:this.shape_4573},{t:this.shape_4572},{t:this.shape_4571},{t:this.shape_4570},{t:this.shape_4569},{t:this.shape_4568},{t:this.shape_4567},{t:this.shape_4566},{t:this.shape_4565},{t:this.shape_4564},{t:this.shape_4563},{t:this.shape_4562},{t:this.shape_4561},{t:this.shape_4560},{t:this.shape_4559},{t:this.shape_4558},{t:this.shape_4557},{t:this.shape_4556},{t:this.shape_4555},{t:this.shape_4554},{t:this.shape_4553},{t:this.shape_4552},{t:this.shape_4551},{t:this.shape_4550},{t:this.shape_4549},{t:this.shape_4548},{t:this.shape_4547},{t:this.shape_4546},{t:this.shape_4545},{t:this.shape_4544},{t:this.shape_4543},{t:this.shape_4542},{t:this.shape_4541},{t:this.shape_4540},{t:this.shape_4539},{t:this.shape_4538},{t:this.shape_4537},{t:this.shape_4536},{t:this.shape_4535},{t:this.shape_4534},{t:this.shape_4533},{t:this.shape_4532},{t:this.shape_4531},{t:this.shape_4530},{t:this.shape_4529},{t:this.shape_4528},{t:this.shape_4527},{t:this.shape_4526},{t:this.shape_4525},{t:this.shape_4524},{t:this.shape_4523},{t:this.shape_4522},{t:this.shape_4521},{t:this.shape_4520},{t:this.shape_4519},{t:this.shape_4518},{t:this.shape_4517},{t:this.shape_4516},{t:this.shape_4515},{t:this.shape_4514},{t:this.shape_4513},{t:this.shape_4512},{t:this.shape_4511},{t:this.shape_4510},{t:this.shape_4509},{t:this.shape_4508},{t:this.shape_4507},{t:this.shape_4506},{t:this.shape_4505},{t:this.shape_4504},{t:this.shape_4503},{t:this.shape_4502},{t:this.shape_4501},{t:this.shape_4500},{t:this.shape_4499},{t:this.shape_4498},{t:this.shape_4497},{t:this.shape_4496},{t:this.shape_4495},{t:this.shape_4494},{t:this.shape_4493},{t:this.shape_4492},{t:this.shape_4491},{t:this.shape_4490},{t:this.shape_4489},{t:this.shape_4488},{t:this.shape_4487},{t:this.shape_4486},{t:this.shape_4485},{t:this.shape_4484},{t:this.shape_4483},{t:this.shape_4482},{t:this.shape_4481},{t:this.shape_4480},{t:this.shape_4479},{t:this.shape_4478},{t:this.shape_4477},{t:this.shape_4476},{t:this.shape_4475},{t:this.shape_4474},{t:this.shape_4473},{t:this.shape_4472},{t:this.shape_4471},{t:this.shape_4470},{t:this.shape_4469},{t:this.shape_4468},{t:this.shape_4467},{t:this.shape_4466},{t:this.shape_4465},{t:this.shape_4464},{t:this.shape_4463},{t:this.shape_4462},{t:this.shape_4461},{t:this.shape_4460},{t:this.shape_4459},{t:this.shape_4458},{t:this.shape_4457},{t:this.shape_4456},{t:this.shape_4455},{t:this.shape_4454},{t:this.shape_4453},{t:this.shape_4452},{t:this.shape_4451},{t:this.shape_4450},{t:this.shape_4449},{t:this.shape_4448},{t:this.shape_4447},{t:this.shape_4446},{t:this.shape_4445},{t:this.shape_4444},{t:this.shape_4443},{t:this.shape_4442},{t:this.shape_4441},{t:this.shape_4440},{t:this.shape_4439},{t:this.shape_4438},{t:this.shape_4437},{t:this.shape_4436},{t:this.shape_4435},{t:this.shape_4434},{t:this.shape_4433},{t:this.shape_4432},{t:this.shape_4431},{t:this.shape_4430},{t:this.shape_4429},{t:this.shape_4428},{t:this.shape_4427},{t:this.shape_4426},{t:this.shape_4425},{t:this.shape_4424},{t:this.shape_4423},{t:this.shape_4422},{t:this.shape_4421},{t:this.shape_4420},{t:this.shape_4419},{t:this.shape_4418},{t:this.shape_4417},{t:this.shape_4416},{t:this.shape_4415},{t:this.shape_4414},{t:this.shape_4413},{t:this.shape_4412},{t:this.shape_4411},{t:this.shape_4410},{t:this.shape_4409},{t:this.shape_4408},{t:this.shape_4407},{t:this.shape_4406},{t:this.shape_4405},{t:this.shape_4404},{t:this.shape_4403},{t:this.shape_4402},{t:this.shape_4401},{t:this.shape_4400},{t:this.shape_4399},{t:this.shape_4398},{t:this.shape_4397},{t:this.shape_4396},{t:this.shape_4395},{t:this.shape_4394},{t:this.shape_4393},{t:this.shape_4392},{t:this.shape_4391},{t:this.shape_4390},{t:this.shape_4389},{t:this.shape_4388},{t:this.shape_4387},{t:this.shape_4386},{t:this.shape_4385},{t:this.shape_4384},{t:this.shape_4383},{t:this.shape_4382},{t:this.shape_4381},{t:this.shape_4380},{t:this.shape_4379},{t:this.shape_4378},{t:this.shape_4377},{t:this.shape_4376},{t:this.shape_4375},{t:this.shape_4374},{t:this.shape_4373},{t:this.shape_4372},{t:this.shape_4371},{t:this.shape_4370},{t:this.shape_4369},{t:this.shape_4368},{t:this.shape_4367},{t:this.shape_4366},{t:this.shape_4365},{t:this.shape_4364},{t:this.shape_4363},{t:this.shape_4362},{t:this.shape_4361},{t:this.shape_4360},{t:this.shape_4359},{t:this.shape_4358},{t:this.shape_4357},{t:this.shape_4356},{t:this.shape_4355},{t:this.shape_4354},{t:this.shape_4353},{t:this.shape_4352},{t:this.shape_4351},{t:this.shape_4350},{t:this.shape_4349},{t:this.shape_4348},{t:this.shape_4347},{t:this.shape_4346},{t:this.shape_4345},{t:this.shape_4344},{t:this.shape_4343},{t:this.shape_4342},{t:this.shape_4341},{t:this.shape_4340},{t:this.shape_4339},{t:this.shape_4338},{t:this.shape_4337},{t:this.shape_4336},{t:this.shape_4335},{t:this.shape_4334},{t:this.shape_4333},{t:this.shape_4332},{t:this.shape_4331},{t:this.shape_4330},{t:this.shape_4329},{t:this.shape_4328},{t:this.shape_4327},{t:this.shape_4326},{t:this.shape_4325},{t:this.shape_4324},{t:this.shape_4323},{t:this.shape_4322},{t:this.shape_4321},{t:this.shape_4320},{t:this.shape_4319},{t:this.shape_4318},{t:this.shape_4317},{t:this.shape_4316},{t:this.shape_4315},{t:this.shape_4314},{t:this.shape_4313},{t:this.shape_4312},{t:this.shape_4311},{t:this.shape_4310},{t:this.shape_4309},{t:this.shape_4308},{t:this.shape_4307},{t:this.shape_4306},{t:this.shape_4305},{t:this.shape_4304},{t:this.shape_4303},{t:this.shape_4302},{t:this.shape_4301},{t:this.shape_4300},{t:this.shape_4299},{t:this.shape_4298},{t:this.shape_4297},{t:this.shape_4296},{t:this.shape_4295},{t:this.shape_4294}]},60).to({state:[]},1).wait(104));

	// ButtonLeftRight copy 26
	this.buttonR12 = new lib.ButtonLeft_Right();
	this.buttonR12.name = "buttonR12";
	this.buttonR12.parent = this;
	this.buttonR12.setTransform(2025,513.5,1,1,180);
	this.buttonR12._off = true;
	new cjs.ButtonHelper(this.buttonR12, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR12).wait(59).to({_off:false},0).to({_off:true},1).wait(105));

	// ButtonLeftRight copy 27
	this.buttonL12 = new lib.ButtonLeft_Right();
	this.buttonL12.name = "buttonL12";
	this.buttonL12.parent = this;
	this.buttonL12.setTransform(0,437.2);
	this.buttonL12._off = true;
	new cjs.ButtonHelper(this.buttonL12, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL12).wait(59).to({_off:false},0).to({_off:true},1).wait(105));

	// Layer 1
	this.shape_4858 = new cjs.Shape();
	this.shape_4858.graphics.f("#000000").s().p("ACCHhIAAj6InCAAIAAgkIGyqjIAuAAIAAKsIChAAIAAAbIihAAIAAD6gAkmDMIGoAAIAAqMIgEAAg");
	this.shape_4858.setTransform(395.3,474.1,0.5,0.5);

	this.shape_4859 = new cjs.Shape();
	this.shape_4859.graphics.f("#000000").s().p("ABVHhIAAueIi1CbIgSgXIDHinIAeAAIAAPBg");
	this.shape_4859.setTransform(353.7,474.1,0.5,0.5);

	this.shape_4860 = new cjs.Shape();
	this.shape_4860.graphics.f("#000000").s().p("AiWHDQg6gughhJQghhJgMhYQgMhXAAhUQAAhTAMhXQAMhYAhhJQAhhJA6guQA6gvBcAAQBdAAA6AvQA6AuAhBJQAhBIAMBZQAMBYAABSQAABTgMBYQgMBZghBIQghBJg6AuQg6AvhdAAQhcAAg6gvgAhom8QgtAZgdAoQgeAogSAzQgRAzgKA0QgKA1gCAxQgDAxAAAiQAAAlADAwQACAwAKA1QAKA0ARAzQARAyAfApQAdAoAtAZQAsAaA8AAQA+AAArgaQAsgYAfgpQAdgnASg0QATg3AIgwQAKgzADgyQACg2AAgfQAAgdgCg2QgDgzgKgzQgIgvgTg4QgSg0gdgnQgfgpgsgYQgrgag+AAQg8AAgsAag");
	this.shape_4860.setTransform(319.2,474.1,0.5,0.5);

	this.shape_4861 = new cjs.Shape();
	this.shape_4861.graphics.f("#000000").s().p("AkNHpIAAgjIFPmKQBKhVAvhKQAthJAAhJQAAgygRgpQgRgogcgcQgdgcgogPQgpgQgvAAQhOAAg7AqQg8ApgZBSIgdgJQAahYBEguQBEgwBZAAQA2ABAvARQAuASAhAgQAfAgAUAqQASAsAAAwQAAAsgMApQgLAmgYApQgZApgiArQgkAugsAyIk7FzIH9AAIAAAdg");
	this.shape_4861.setTransform(279.9,473.7,0.5,0.5);

	this.shape_4862 = new cjs.Shape();
	this.shape_4862.graphics.f("#000000").s().p("Ah6AOIAAgbID1AAIAAAbg");
	this.shape_4862.setTransform(234.9,480.9,0.5,0.5);

	this.shape_4863 = new cjs.Shape();
	this.shape_4863.graphics.f("#000000").s().p("AkNHpIAAgjIFPmKQBMhZAthGQAthJAAhJQAAgygRgpQgRgogcgcQgdgdgpgOQgogQgvAAQhOAAg7AqQg8ApgZBSIgdgJQAahYBEguQBEgwBZAAQA2ABAvARQAuASAgAgQAhAfATArQASAsAAAwQAAAtgMAoQgLAmgZApQgWAogkAsQgkAugsAyIk7FzIH9AAIAAAdg");
	this.shape_4863.setTransform(187.4,473.7,0.5,0.5);

	this.shape_4864 = new cjs.Shape();
	this.shape_4864.graphics.f("#000000").s().p("AhxHfQgzgTgngkQgmgjgVgyQgWgyAAg/QAAgqAMgoQAOgrAYggQAagkAlgZQAlgZA1gQIAAgDQhWgggohAQgog/AAhCQAAg1ATgrQAUgtAggdQAfgfAvgSQAtgRA1AAQA2AAAtARQAuASAgAfQAgAdAUAtQATArAAA1QAABDgoA/QgoBAhWAfIAAADQA1AQAnAbQAmAaAZAjQAZAiALAnQAMAmAAAsQAAA/gWAyQgVAygmAjQgnAkgzATQg1ATg9AAQg8AAg1gTgAhjgEQgvATgiAgQgjAjgTAsQgUAvAAA1QAAAyASAuQATAuAhAhQAiAhAvATQAuATA5AAQA6AAAugTQAugSAjgiQAhghATguQASgtAAgzQAAg2gUguQgTgsgjgjQgjghgugSQgwgSg0AAQgzAAgwASgAhWnIQgoAPgdAcQgeAdgRAmQgRAlAAAwQAAAsARAmQAQAnAdAeQAeAeAoARQAoASAvAAQAuAAApgSQAogSAdgdQAegfAQgmQAQgmAAgsQAAgwgRglQgRgngegcQgdgcgogPQgngPguAAQguAAgoAPg");
	this.shape_4864.setTransform(150.6,474.1,0.5,0.5);

	this.shape_4865 = new cjs.Shape();
	this.shape_4865.graphics.f("#000000").s().p("AhWHpIEinwIgDgBQgkArg4AZQg5Aag+AAQg7AAgxgVQgzgVglgnQglgngUgzQgWg0AAhBQAAg9AWg2QAVg2AlglQAngnA0gUQA2gWA9AAQBAAAAzAWQA1AUAlAmQAmAmAUA0QAWA2AAA/QgBA1gSA7QgTA4gsBOIj/G9gAhlm7QgwAUghAjQgjAigSAwQgUAuABA6QgBA6ATAwQASAwAhAjQAgAhAvAUQAuAUA2AAQA0AAAwgUQAwgUAkghQAjgkAVgvQAWgwgBg6QABg6gUguQgSgvgjgjQghgjgwgUQgugTg4gBQg3ABguATg");
	this.shape_4865.setTransform(112.5,473.7,0.5,0.5);

	this.shape_4866 = new cjs.Shape();
	this.shape_4866.graphics.f("#000000").s().p("ABVHhIAAueIi1CbIgSgXIDHinIAeAAIAAPBg");
	this.shape_4866.setTransform(70.9,474.1,0.5,0.5);

	this.shape_4867 = new cjs.Shape();
	this.shape_4867.graphics.f("#231F20").s().p("AjoCsIFck1IAigaQAngTAbAdQAcAfgRAfQgJAPgOAJIl5Dvg");
	this.shape_4867.setTransform(1542.1,399.6,0.5,0.5);

	this.shape_4868 = new cjs.Shape();
	this.shape_4868.graphics.f("#231F20").s().p("AAuKZQmiAHiCAAIAAgyIAyAAQBZAAAfgaQAjgdAAhXIAAvIQAAhXgjgdQgfgchZAAIg1AAIAAgnQEQAHE3AAQCZAADXgHIAEDkIgoAAQgZhpgjgaQgggYhsgCIk6AAIAAIhIEAAAQBfAAAOgGQAigPAGhMIAoAAIAAEcIgoAAQgEhYgrgfQgkgZhcAAIjmAAIAAH+QAAA+AdAYQAdAZBHAAIDTAAQBhAAAwgvQAiggAzhxIAoAAIgnD/QkwgHh1AAg");
	this.shape_4868.setTransform(1533.8,456.1,0.5,0.5);

	this.shape_4869 = new cjs.Shape();
	this.shape_4869.graphics.f("#231F20").s().p("AgBKcQg8AAhjADIifAEIAAglIBIAAQBYAAAagbQAbgbAAhaIAAmRQgEhcgehzQg7joiBh2QhqhhhIgfQhWgliQAAIBEgXQBQgWA3AAQDwACC9DjQA+BLA6CLQAdBFAQA2QASgvAchBQA6iCA5hZQBIhwBpg7QBGgnBMgLQA+gIBHASQAkAJAXALQgcgFgkgCQhJgFgrANQhhAdg7AuQhEAzg5BiQhgClgvCsQgYBVgEA1IAAGoQAABaAaAbQAaAbBVAAIA4AAIAAAlQjHgHhkAAg");
	this.shape_4869.setTransform(1451,456,0.5,0.5);

	this.shape_4870 = new cjs.Shape();
	this.shape_4870.graphics.f("#231F20").s().p("AgJKaQg7AAhaACIiWAFIAAglIARAAQBgAAAsgcQA3ghAAhTIAAvVQAAhUgsggQgmgchcAAIgTAAIAAgnICVAFQBZACA8ABQA+gBBYgCICWgFIAAAnIgRAAQhgAAgtAcQg2AhAABTIAAPVQAABUAsAgQAmAcBcAAIATAAIAAAlQjHgHhkAAg");
	this.shape_4870.setTransform(1373.4,456.1,0.5,0.5);

	this.shape_4871 = new cjs.Shape();
	this.shape_4871.graphics.f("#231F20").s().p("AI9KmIvqw3IAJN/QACBHAmAhQAlAgBRAAIAoAAIAAAlQhGgBhXgDIhXgDQiQAFh3ACIAAglIA2AAQA9ABAqgpQApgpAAg6IgBv2QhLhNgxgVQgpgThMAAIAAglIACAAIBXAEQA2ADAhAAIBLgDIBYgEIO1QFIAGtAQgChWgoglQgoglhbAAIgfAAIAAglIB2AEQBGADAuAAQAtAABDgDIBvgEIAAAlIgbAAQhDAAgpAdQgrAeAAA3IgBS0g");
	this.shape_4871.setTransform(1290.9,456.4,0.5,0.5);

	this.shape_4872 = new cjs.Shape();
	this.shape_4872.graphics.f("#231F20").s().p("AHdKlQiuAAiIAHIAAgoIBFAAQAlAAAVgSQAWgRAAgdQgBgogLgZIhtlUInoAAIiJExQgVA0AQAuQAMAkAMALQAUATAuAAIBFAAIAAAoQjOgHglAAQidAAhFAHIAAgoIAtAAQBKAAAsgdQAsgdAahBIIEy0IArAAIHHRdQA6CKAkAlQAgAjBFAAIAxAAIAAAoQiegHhvAAgAkNBvIGzAAIjEovg");
	this.shape_4872.setTransform(1196.2,455.5,0.5,0.5);

	this.shape_4873 = new cjs.Shape();
	this.shape_4873.graphics.f("#231F20").s().p("AlqNCIAygjQA7gwAyg6QCei4AAjcIAAu6QAAhggagoQgfgvhRAAIhRAAIAAgkICeAEQBgADA+AAQA/AABdgDICbgEIAAAkIg7AAQhTAAgfAvQgaAoAABgIAAO5QAAC5jEC4QiFB8jFBog");
	this.shape_4873.setTransform(1126.9,466.8,0.5,0.5);

	this.shape_4874 = new cjs.Shape();
	this.shape_4874.graphics.f("#231F20").s().p("Ai4ExIAAphIFjAAIAAARIlPAAIAAEMIE7AAIAAASIk7AAIAAEgIFcAAIAAASg");
	this.shape_4874.setTransform(1481.8,542.2,0.5,0.5);

	this.shape_4875 = new cjs.Shape();
	this.shape_4875.graphics.f("#231F20").s().p("ADXExImzpIIgDAAIAAJIIgTAAIAAphIAaAAIG2JHIACAAIAApHIATAAIAAJhg");
	this.shape_4875.setTransform(1436,542.2,0.5,0.5);

	this.shape_4876 = new cjs.Shape();
	this.shape_4876.graphics.f("#231F20").s().p("Ah7EpQg6gYgqgqQgpgpgYg9QgYg7AAhGQAAhFAYg7QAYg9ApgpQApgqA6gZQA5gYBDAAQBEAAA5AYQA6AZApAqQApApAYA9QAYA7AABFQAABGgYA7QgYA9gpApQgoAqg7AYQg6AZhDAAQhDAAg4gZgAh1kYQg3AYgnApQgoAqgVA3QgVA3AAA/QAAA/AVA4QAVA3AmAqQAnApA2AYQA4AXBAABQBCgBA2gXQA3gYAngpQAmgqAVg3QAVg4AAg/QAAg/gWg3QgUg3gogqQgmgpg3gYQg3gXhAgBQg/ABg2AXg");
	this.shape_4876.setTransform(1385.2,542.2,0.5,0.5);

	this.shape_4877 = new cjs.Shape();
	this.shape_4877.graphics.f("#231F20").s().p("AgIExIAAkLIjSlWIAXAAIDEFDIDElDIAWAAIjRFWIAAELg");
	this.shape_4877.setTransform(1320.6,542.2,0.5,0.5);

	this.shape_4878 = new cjs.Shape();
	this.shape_4878.graphics.f("#231F20").s().p("AigExIAAphIATAAIAAJPIEuAAIAAASg");
	this.shape_4878.setTransform(1283.1,542.2,0.5,0.5);

	this.shape_4879 = new cjs.Shape();
	this.shape_4879.graphics.f("#231F20").s().p("ADYExIm1pIIgCAAIAAJIIgTAAIAAphIAbAAIG0JHIADAAIAApHIATAAIAAJhg");
	this.shape_4879.setTransform(1238.5,542.2,0.5,0.5);

	this.shape_4880 = new cjs.Shape();
	this.shape_4880.graphics.f("#231F20").s().p("Ah8EpQg5gYgqgqQgpgrgZg7QgXg7AAhGQAAhFAXg7QAZg7ApgrQAqgqA5gZQA5gYBDAAQBEAAA5AYQA7AZAoAqQAqArAYA7QAXA5AABHQAABHgXA6QgYA7gqArQgpAqg6AYQg6AZhDAAQhBAAg7gZgAh2kYQg3AZgmAoQgnApgWA4QgVA3AAA/QAAA/AVA4QAVA4AnApQAlAoA3AZQA4AXBAABQBCgBA3gXQA2gYAmgpQAngqAVg3QAWg5gBg+QABg9gWg5QgWg3gngqQgmgpg3gYQg4gXg/gBQg/ABg3AXg");
	this.shape_4880.setTransform(1187.7,542.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_4880},{t:this.shape_4879},{t:this.shape_4878},{t:this.shape_4877},{t:this.shape_4876},{t:this.shape_4875},{t:this.shape_4874},{t:this.shape_4873},{t:this.shape_4872},{t:this.shape_4871},{t:this.shape_4870},{t:this.shape_4869},{t:this.shape_4868},{t:this.shape_4867},{t:this.shape_4866},{t:this.shape_4865},{t:this.shape_4864},{t:this.shape_4863},{t:this.shape_4862},{t:this.shape_4861},{t:this.shape_4860},{t:this.shape_4859},{t:this.shape_4858}]},59).to({state:[]},1).wait(105));

	// ButtonLeftRight copy 24
	this.buttonR11 = new lib.ButtonLeft_Right();
	this.buttonR11.name = "buttonR11";
	this.buttonR11.parent = this;
	this.buttonR11.setTransform(2025,513.5,1,1,180);
	this.buttonR11._off = true;
	new cjs.ButtonHelper(this.buttonR11, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR11).wait(58).to({_off:false},0).to({_off:true},1).wait(106));

	// ButtonLeftRight copy 25
	this.buttonL11 = new lib.ButtonLeft_Right();
	this.buttonL11.name = "buttonL11";
	this.buttonL11.parent = this;
	this.buttonL11.setTransform(0,437.2);
	this.buttonL11._off = true;
	new cjs.ButtonHelper(this.buttonL11, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL11).wait(58).to({_off:false},0).to({_off:true},1).wait(106));

	// Layer 1
	this.instance_21 = new lib.flowers();
	this.instance_21.parent = this;
	this.instance_21.setTransform(-28,-8);
	this.instance_21._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_21).wait(58).to({_off:false},0).to({_off:true},1).wait(106));

	// ButtonLeftRight copy 22
	this.buttonR10 = new lib.ButtonLeft_Right();
	this.buttonR10.name = "buttonR10";
	this.buttonR10.parent = this;
	this.buttonR10.setTransform(2025,513.5,1,1,180);
	this.buttonR10._off = true;
	new cjs.ButtonHelper(this.buttonR10, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR10).wait(57).to({_off:false},0).to({_off:true},1).wait(107));

	// ButtonLeftRight copy 23
	this.buttonL10 = new lib.ButtonLeft_Right();
	this.buttonL10.name = "buttonL10";
	this.buttonL10.parent = this;
	this.buttonL10.setTransform(0,437.2);
	this.buttonL10._off = true;
	new cjs.ButtonHelper(this.buttonL10, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL10).wait(57).to({_off:false},0).to({_off:true},1).wait(107));

	// Layer 1
	this.instance_22 = new lib.greenBraceletDraw();
	this.instance_22.parent = this;
	this.instance_22.setTransform(802,-5);

	this.shape_4881 = new cjs.Shape();
	this.shape_4881.graphics.f("#000000").s().p("AgWDYIAAmwIAtAAIAAGwg");
	this.shape_4881.setTransform(216.4,584.9,0.5,0.5);

	this.shape_4882 = new cjs.Shape();
	this.shape_4882.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhJAkgrQAlgrA8AAQA6AAAhAmQAhAlAAA+IAAAcIjRAAQACA2AZAcQAaAcAtAAQAxAAAxgVIAAApQgYALgWAEQgZAFgcAAQhDAAgngpgAg2hfQgVAYgEArICeAAQABgsgUgXQgUgXgjAAQgkAAgXAXg");
	this.shape_4882.setTransform(204.8,588.1,0.5,0.5);

	this.shape_4883 = new cjs.Shape();
	this.shape_4883.graphics.f("#000000").s().p("ABSDYIAAjFQAAgjgRgUQgRgSglAAQgvAAgWAaQgWAaAAA7IAACfIgvAAIAAmwIAvAAIAACEQAAAVgDASIAEAAQANgWAZgNQAagNAeABQA4gBAdAbQAcAbAAA4IAADHg");
	this.shape_4883.setTransform(188.1,584.9,0.5,0.5);

	this.shape_4884 = new cjs.Shape();
	this.shape_4884.graphics.f("#000000").s().p("AhJB1QgkgoAAhLQAAhMAkgpQAmgqBDAAQAXAAAVAFQAWAEAMAHIgOAnQgQgHgSgDQgSgEgNAAQhcAAgBB1QAAA5AYAeQAWAeArAAQAmAAApgRIAAApQgfAQgvAAQhAAAglgpg");
	this.shape_4884.setTransform(172.8,588.1,0.5,0.5);

	this.shape_4885 = new cjs.Shape();
	this.shape_4885.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSibQgIgHAAgPQAAgQAIgIQAHgHALAAQAMAAAHAHQAIAIAAAQQAAAPgIAHQgHAIgMAAQgLAAgHgIg");
	this.shape_4885.setTransform(162.1,585.3,0.5,0.5);

	this.shape_4886 = new cjs.Shape();
	this.shape_4886.graphics.f("#000000").s().p("ACaDLIAAkFQAAgpAEg5IgCAAIiMFnIgkAAIiKlnIgDAAQAEAmAABAIAAEBIgrAAIAAmVIBHAAICAFOIACAAICClOIBHAAIAAGVg");
	this.shape_4886.setTransform(145.6,585.5,0.5,0.5);

	this.shape_4887 = new cjs.Shape();
	this.shape_4887.graphics.f("#000000").s().p("AiKDZIAAgmQAQAEASAAQAvAAAVg1IARgsIh7kyIAyAAIBCCuQAXA+ADAXIADAAIAPgwQANgpA/iqIAxAAIiDFbQgSAygaAXQgaAVgnAAQgVAAgUgEg");
	this.shape_4887.setTransform(118.2,591.5,0.5,0.5);

	this.shape_4888 = new cjs.Shape();
	this.shape_4888.graphics.f("#000000").s().p("AhJB1QgkgoAAhLQAAhMAkgpQAmgqBDAAQAWAAAWAFQAWAEAMAHIgOAnQgQgHgSgDQgTgEgNAAQhcAAAAB1QAAA4AXAfQAXAeArAAQAmAAApgRIAAApQgfAQgvAAQhAAAglgpg");
	this.shape_4888.setTransform(104.5,588.1,0.5,0.5);

	this.shape_4889 = new cjs.Shape();
	this.shape_4889.graphics.f("#000000").s().p("ABRCbIAAjEQAAglgRgTQgQgSglAAQguAAgXAaQgWAagBA7IAACfIguAAIAAkwIAmAAIAHAqIADAAQANgXAbgMQAZgMAeAAQA3AAAcAaQAdAcAAA5IAADGg");
	this.shape_4889.setTransform(88.8,587.9,0.5,0.5);

	this.shape_4890 = new cjs.Shape();
	this.shape_4890.graphics.f("#000000").s().p("AhgCHQgagYAAgrQAAhcCUgEIAzgBIAAgUQAAgjgPgSQgPgQgjAAQglAAgwAWIgOgjQAUgLAegIQAagHAaAAQA3AAAaAYQAbAYAAA2IAADPIgjAAIgJgrIgCAAQgXAdgXAJQgXALghAAQgsAAgbgXgAAeAEQg4ACgWAPQgZAPAAAhQAAAZAPANQAPANAbgBQArABAZgYQAYgYAAgrIAAgbg");
	this.shape_4890.setTransform(71.5,588.1,0.5,0.5);

	this.shape_4891 = new cjs.Shape();
	this.shape_4891.graphics.f("#000000").s().p("ABpDLIjelUIgBAAQAEA9AAAxIAADmIgsAAIAAmVIA1AAIDdFTIACAAIgCgxQgCgrABgPIAAjoIAsAAIAAGVg");
	this.shape_4891.setTransform(53.3,585.5,0.5,0.5);

	this.shape_4892 = new cjs.Shape();
	this.shape_4892.graphics.f("#000000").s().p("AAJA/QAJgdAHghQAJglADgZIAdAAIADAEQgIAggNAhQgQAqgGANgAhEA/QAHgYAIglQAIgkAEgbIAdAAIADAEQgSBBgZA3g");
	this.shape_4892.setTransform(259.4,542.4,0.5,0.5);

	this.shape_4893 = new cjs.Shape();
	this.shape_4893.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_4893.setTransform(251.1,549.2,0.5,0.5);

	this.shape_4894 = new cjs.Shape();
	this.shape_4894.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4894.setTransform(239.8,550.7,0.5,0.5);

	this.shape_4895 = new cjs.Shape();
	this.shape_4895.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgwAAgXAZQgWAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_4895.setTransform(226.1,547.8,0.5,0.5);

	this.shape_4896 = new cjs.Shape();
	this.shape_4896.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_4896.setTransform(214,549.2,0.5,0.5);

	this.shape_4897 = new cjs.Shape();
	this.shape_4897.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgyASgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgcAAgMARQgMARAAAmIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_4897.setTransform(200.4,547.7,0.5,0.5);

	this.shape_4898 = new cjs.Shape();
	this.shape_4898.graphics.f("#000000").s().p("Ag/B7QgagQgQghQgOgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBghAmQgfAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4898.setTransform(188.2,550.7,0.5,0.5);

	this.shape_4899 = new cjs.Shape();
	this.shape_4899.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAwAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgXAag");
	this.shape_4899.setTransform(167.1,550.7,0.5,0.5);

	this.shape_4900 = new cjs.Shape();
	this.shape_4900.graphics.f("#000000").s().p("AhABoQggglgBhBQABhCAhgmQAjglA6AAQAkAAAgAMIgIAWQgigMgbAAQgwAAgaAfQgZAfgBA4QABA3AZAfQAaAfAtAAQAlAAAggNIAAAXQgaAMgrAAQg5AAghgkg");
	this.shape_4900.setTransform(154.4,550.7,0.5,0.5);

	this.shape_4901 = new cjs.Shape();
	this.shape_4901.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_4901.setTransform(140.6,550.6,0.5,0.5);

	this.shape_4902 = new cjs.Shape();
	this.shape_4902.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4902.setTransform(125.8,550.7,0.5,0.5);

	this.shape_4903 = new cjs.Shape();
	this.shape_4903.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_4903.setTransform(115,549.2,0.5,0.5);

	this.shape_4904 = new cjs.Shape();
	this.shape_4904.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4904.setTransform(106.8,550.6,0.5,0.5);

	this.shape_4905 = new cjs.Shape();
	this.shape_4905.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4905.setTransform(93.5,550.7,0.5,0.5);

	this.shape_4906 = new cjs.Shape();
	this.shape_4906.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAmIABAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA/AVAaQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQguAAgWAag");
	this.shape_4906.setTransform(78.8,553.6,0.5,0.5);

	this.shape_4907 = new cjs.Shape();
	this.shape_4907.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4907.setTransform(59.7,550.6,0.5,0.5);

	this.shape_4908 = new cjs.Shape();
	this.shape_4908.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_4908.setTransform(45.5,548.2,0.5,0.5);

	this.shape_4909 = new cjs.Shape();
	this.shape_4909.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AhgnQAggnA0AAQAwAAAcAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_4909.setTransform(708.5,512.4,0.5,0.5);

	this.shape_4910 = new cjs.Shape();
	this.shape_4910.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA3IAACVIgYAAIAAmDIAYAAIgBCeIABAAQARgYAWgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_4910.setTransform(694.1,509.5,0.5,0.5);

	this.shape_4911 = new cjs.Shape();
	this.shape_4911.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_4911.setTransform(682,510.9,0.5,0.5);

	this.shape_4912 = new cjs.Shape();
	this.shape_4912.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgOIAxgJIAAgWQAAgyATgXQARgXAqAAQAXAAAWAGIgGAWQgUgGgTAAQgdAAgNARQgLARAAAmIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_4912.setTransform(668.4,509.5,0.5,0.5);

	this.shape_4913 = new cjs.Shape();
	this.shape_4913.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4913.setTransform(656.2,512.4,0.5,0.5);

	this.shape_4914 = new cjs.Shape();
	this.shape_4914.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAuAAQAVAAAUgDQAPgDAdgLIAAAWQgWAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_4914.setTransform(635.1,512.4,0.5,0.5);

	this.shape_4915 = new cjs.Shape();
	this.shape_4915.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_4915.setTransform(624,512.3,0.5,0.5);

	this.shape_4916 = new cjs.Shape();
	this.shape_4916.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4916.setTransform(611,512.5,0.5,0.5);

	this.shape_4917 = new cjs.Shape();
	this.shape_4917.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgLAShMIAqiaIAZAAIhKENg");
	this.shape_4917.setTransform(595.4,512.4,0.5,0.5);

	this.shape_4918 = new cjs.Shape();
	this.shape_4918.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4918.setTransform(579,512.5,0.5,0.5);

	this.shape_4919 = new cjs.Shape();
	this.shape_4919.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgXAKgTAEQgSADgaAAQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgYAag");
	this.shape_4919.setTransform(559.1,512.4,0.5,0.5);

	this.shape_4920 = new cjs.Shape();
	this.shape_4920.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_4920.setTransform(548,512.3,0.5,0.5);

	this.shape_4921 = new cjs.Shape();
	this.shape_4921.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAgglQAgglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_4921.setTransform(534.7,512.4,0.5,0.5);

	this.shape_4922 = new cjs.Shape();
	this.shape_4922.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_4922.setTransform(516,512.3,0.5,0.5);

	this.shape_4923 = new cjs.Shape();
	this.shape_4923.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAuAAQAVAAAUgDQAQgDAcgLIAAAWQgWAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_4923.setTransform(491.1,512.4,0.5,0.5);

	this.shape_4924 = new cjs.Shape();
	this.shape_4924.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_4924.setTransform(472.9,512.3,0.5,0.5);

	this.shape_4925 = new cjs.Shape();
	this.shape_4925.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA1AAQAwAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgRADgZAAQg7AAgggkgAg2hcQgYAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgXAag");
	this.shape_4925.setTransform(448,512.4,0.5,0.5);

	this.shape_4926 = new cjs.Shape();
	this.shape_4926.graphics.f("#000000").s().p("AhUCiQgdgjAAhDQAAhGAdgkQAeglA3AAQAdAAAWAKQAUALASAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgXAeAAA7QABB0BYAAQAuAAAVgbQAWgbAAg9IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_4926.setTransform(433,509.6,0.5,0.5);

	this.shape_4927 = new cjs.Shape();
	this.shape_4927.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAOAAAgQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4927.setTransform(418.6,512.5,0.5,0.5);

	this.shape_4928 = new cjs.Shape();
	this.shape_4928.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_4928.setTransform(401.1,512.3,0.5,0.5);

	this.shape_4929 = new cjs.Shape();
	this.shape_4929.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgXAAQgkgBgQgSg");
	this.shape_4929.setTransform(378.7,510.9,0.5,0.5);

	this.shape_4930 = new cjs.Shape();
	this.shape_4930.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4930.setTransform(371.7,510,0.5,0.5);

	this.shape_4931 = new cjs.Shape();
	this.shape_4931.graphics.f("#000000").s().p("AhUCiQgdgjAAhDQAAhGAdgkQAdglA4AAQAdAAAWAKQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQggAug5AAQg3AAgegigAhBgeQgXAeAAA7QABB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_4931.setTransform(354.2,509.6,0.5,0.5);

	this.shape_4932 = new cjs.Shape();
	this.shape_4932.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4932.setTransform(339.6,512.3,0.5,0.5);

	this.shape_4933 = new cjs.Shape();
	this.shape_4933.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAPAAAfQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4933.setTransform(324.8,512.5,0.5,0.5);

	this.shape_4934 = new cjs.Shape();
	this.shape_4934.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_4934.setTransform(309,509.5,0.5,0.5);

	this.shape_4935 = new cjs.Shape();
	this.shape_4935.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4935.setTransform(298.9,512.5,0.5,0.5);

	this.shape_4936 = new cjs.Shape();
	this.shape_4936.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_4936.setTransform(285,512.6,0.5,0.5);

	this.shape_4937 = new cjs.Shape();
	this.shape_4937.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQAqAAApAQIgKAWQgngQgiAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4937.setTransform(271.5,512.4,0.5,0.5);

	this.shape_4938 = new cjs.Shape();
	this.shape_4938.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_4938.setTransform(262.8,510,0.5,0.5);

	this.shape_4939 = new cjs.Shape();
	this.shape_4939.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAlAGAZIABAAQAJggALgfIBHi2IAZAAIhpENg");
	this.shape_4939.setTransform(254.1,512.4,0.5,0.5);

	this.shape_4940 = new cjs.Shape();
	this.shape_4940.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAIgGAJgNQAIgNAKgaIANgkIhnkNIAZAAIA6CYQAaBFAGAYIABAAIAihfIA6iWIAZAAIh5E5QgNAlgLAPQgJANgOAHQgNAHgUgBQgPAAgQgEg");
	this.shape_4940.setTransform(235.7,515.5,0.5,0.5);

	this.shape_4941 = new cjs.Shape();
	this.shape_4941.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_4941.setTransform(225.8,512.3,0.5,0.5);

	this.shape_4942 = new cjs.Shape();
	this.shape_4942.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAcAiAAA5IAAASIjCAAQAAA5AaAdQAZAdAuAAQAUAAAWgDQAPgDAcgLIAAAWQgWAKgTAEQgTADgZAAQg5AAghgkgAg3hcQgYAagDAxICnAAQAAgvgVgbQgVgbgkAAQglAAgZAag");
	this.shape_4942.setTransform(213,512.4,0.5,0.5);

	this.shape_4943 = new cjs.Shape();
	this.shape_4943.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAjAGAbIABAAQAJggALgfIBGi2IAaAAIhpENg");
	this.shape_4943.setTransform(200.1,512.4,0.5,0.5);

	this.shape_4944 = new cjs.Shape();
	this.shape_4944.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAZgRAuAAQArAAAoAQIgJAWQgpgQghAAQggAAgUALQgTALAAATQAAAWAPAMQAPANArAQQAkANARAJQARALAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_4944.setTransform(181.6,512.4,0.5,0.5);

	this.shape_4945 = new cjs.Shape();
	this.shape_4945.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgWQAtgUAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAPAAAfQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4945.setTransform(168.5,512.5,0.5,0.5);

	this.shape_4946 = new cjs.Shape();
	this.shape_4946.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQARA4AFAWIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_4946.setTransform(153,512.4,0.5,0.5);

	this.shape_4947 = new cjs.Shape();
	this.shape_4947.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjBAAQABA5AYAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_4947.setTransform(130.2,512.4,0.5,0.5);

	this.shape_4948 = new cjs.Shape();
	this.shape_4948.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgkAAQguAAgYAZQgWAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_4948.setTransform(115.7,509.5,0.5,0.5);

	this.shape_4949 = new cjs.Shape();
	this.shape_4949.graphics.f("#000000").s().p("AhvCtIAAgaQAoARA8AAQAsAAAagVQAagUAAghQAAgVgIgOQgJgNgUgMQgSgKgngOQg3gSgWgWQgVgWAAgmQAAgoAggaQAggaAxAAQA0AAAtATIgJAWQgtgSgqgBQgoABgXASQgYATAAAgQAAAUAHANQAHANARAKQASALAmAOQAsAOAUANQAWAOAKASQAJARAAAZQAAAvghAZQghAbg3AAQhEAAgigOg");
	this.shape_4949.setTransform(101.2,510.1,0.5,0.5);

	this.shape_4950 = new cjs.Shape();
	this.shape_4950.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_4950.setTransform(84.6,518.2,0.5,0.5);

	this.shape_4951 = new cjs.Shape();
	this.shape_4951.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIADAAQAQgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4951.setTransform(77.5,512.3,0.5,0.5);

	this.shape_4952 = new cjs.Shape();
	this.shape_4952.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAcAhAAA6IAAASIjCAAQABA5AZAdQAZAdAvAAQATAAAVgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg6AAghgkgAg3hcQgYAagDAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_4952.setTransform(64.6,512.4,0.5,0.5);

	this.shape_4953 = new cjs.Shape();
	this.shape_4953.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA3IAACVIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAXgLAiAAQBcAAAABiIAACxg");
	this.shape_4953.setTransform(50.2,509.5,0.5,0.5);

	this.shape_4954 = new cjs.Shape();
	this.shape_4954.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4954.setTransform(725,474.1,0.5,0.5);

	this.shape_4955 = new cjs.Shape();
	this.shape_4955.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4955.setTransform(711.7,474.2,0.5,0.5);

	this.shape_4956 = new cjs.Shape();
	this.shape_4956.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgcAAgNARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_4956.setTransform(701.3,471.2,0.5,0.5);

	this.shape_4957 = new cjs.Shape();
	this.shape_4957.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_4957.setTransform(685.5,472.7,0.5,0.5);

	this.shape_4958 = new cjs.Shape();
	this.shape_4958.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4958.setTransform(678.5,471.7,0.5,0.5);

	this.shape_4959 = new cjs.Shape();
	this.shape_4959.graphics.f("#000000").s().p("AheC0QgcgUAAgjQABgdARgRQAQgTAegGQgLgGgIgKQgHgJgBgMQAAgaAkgWQgYgJgNgVQgOgTAAgcQAAgpAagZQAagYAsAAQAZAAAPAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgPAIgHAKQgIAKAAALQAAANAKAHQAKAFAXAAIAvAAQAqAAAZASQAXASAAAjQAAArgiAXQgjAXg/AAQg0AAgcgTgAhfB6QAAA5BSAAQBqAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhLAAABA6gAg5igQgSASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgSgQQgUgSgfAAQggAAgUATg");
	this.shape_4959.setTransform(662.4,477.1,0.5,0.5);

	this.shape_4960 = new cjs.Shape();
	this.shape_4960.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_4960.setTransform(648.2,474.1,0.5,0.5);

	this.shape_4961 = new cjs.Shape();
	this.shape_4961.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_4961.setTransform(637.8,471.7,0.5,0.5);

	this.shape_4962 = new cjs.Shape();
	this.shape_4962.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4962.setTransform(630.8,474.1,0.5,0.5);

	this.shape_4963 = new cjs.Shape();
	this.shape_4963.graphics.f("#000000").s().p("AhPB4QgWgVABgkQAAgnAggXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgRgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAVAXAAAxIAACzIgSAAIgFgrIgDAAQgUAagVALQgWALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAPABAfQAAAaAPANQAQAPAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_4963.setTransform(617.8,474.2,0.5,0.5);

	this.shape_4964 = new cjs.Shape();
	this.shape_4964.graphics.f("#000000").s().p("AhyDHIAAmIIAVAAIAFAnIACAAQAcgsA8AAQA3AAAcAkQAeAkAABEQAABCgfAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgVAZgBA8IAAAIQABA/AUAaQAWAcAvAAQApAAAXgfQAXgdAAg5QAAh3hWAAQgvAAgWAag");
	this.shape_4964.setTransform(604.3,477.1,0.5,0.5);

	this.shape_4965 = new cjs.Shape();
	this.shape_4965.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA1AAQAxAAAbAhQAbAiAAA5IAAASIjBAAQABA5AZAdQAZAdAvAAQATAAAVgDQAQgDAcgLIAAAWQgWAKgUAEQgRADgZAAQg7AAghgkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgbgkAAQglAAgZAag");
	this.shape_4965.setTransform(589.3,474.2,0.5,0.5);

	this.shape_4966 = new cjs.Shape();
	this.shape_4966.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAARAEIgEAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_4966.setTransform(578.2,474.1,0.5,0.5);

	this.shape_4967 = new cjs.Shape();
	this.shape_4967.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAdAkAABEQgBBCgeAlQgeAlg1AAQg9AAgdgvIgBAAIABCkgAhDiWQgVAZgBA8IAAAIQABA/AUAaQAWAcAvAAQApAAAXgfQAXgdAAg5QAAh3hWAAQguAAgXAag");
	this.shape_4967.setTransform(565.2,477.1,0.5,0.5);

	this.shape_4968 = new cjs.Shape();
	this.shape_4968.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNABgWQgBgUgQgPQgRgOglgNQgngNgSgLQgPgKgJgOQgIgOAAgTQgBgeAagSQAZgRAtAAQAsAAAoAQIgJAWQgogQgjAAQgeAAgVALQgTALAAATQAAAWAOAMQAQANArAQQAjAMASAKQAQAKAIAOQAJAOAAASQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_4968.setTransform(544.5,474.2,0.5,0.5);

	this.shape_4969 = new cjs.Shape();
	this.shape_4969.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4969.setTransform(531.5,474.2,0.5,0.5);

	this.shape_4970 = new cjs.Shape();
	this.shape_4970.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgQAShHIAqiaIAZAAIhKENg");
	this.shape_4970.setTransform(515.9,474.2,0.5,0.5);

	this.shape_4971 = new cjs.Shape();
	this.shape_4971.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_4971.setTransform(496.9,471.9,0.5,0.5);

	this.shape_4972 = new cjs.Shape();
	this.shape_4972.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AYAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgvgUgbQgVgbgjAAQgmAAgYAag");
	this.shape_4972.setTransform(480.1,474.2,0.5,0.5);

	this.shape_4973 = new cjs.Shape();
	this.shape_4973.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAUgNAAgWQAAgUgQgPQgSgOgkgNQgngNgSgLQgPgKgJgOQgJgOABgTQAAgeAZgSQAZgRAtAAQAsAAAoAQIgJAWQgogQgjAAQgeAAgVALQgTALgBATQAAAWAPAMQAPANAsAQQAjAMARAKQARAKAIAOQAJANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4973.setTransform(467,474.2,0.5,0.5);

	this.shape_4974 = new cjs.Shape();
	this.shape_4974.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAvAAAXgZQAXgYAAg3IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgZAqhDAAQhcAAAAhjg");
	this.shape_4974.setTransform(453.6,474.3,0.5,0.5);

	this.shape_4975 = new cjs.Shape();
	this.shape_4975.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4975.setTransform(438.9,474.2,0.5,0.5);

	this.shape_4976 = new cjs.Shape();
	this.shape_4976.graphics.f("#000000").s().p("Ag/BoQgiglABhBQAAhCAigmQAiglA6AAQAjAAAhAMIgHAWQgjgMgaAAQgxAAgZAfQgaAeAAA5QAAA3AaAfQAZAfAtAAQAlAAAfgNIAAAXQgZAMgqAAQg6AAgggkg");
	this.shape_4976.setTransform(426.9,474.2,0.5,0.5);

	this.shape_4977 = new cjs.Shape();
	this.shape_4977.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_4977.setTransform(413.5,474.2,0.5,0.5);

	this.shape_4978 = new cjs.Shape();
	this.shape_4978.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAQgYAWgMQAVgLAeAAQA5AAAdAjQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_4978.setTransform(399.3,471.4,0.5,0.5);

	this.shape_4979 = new cjs.Shape();
	this.shape_4979.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhFAdglQAdglA4AAQAdAAAWAKQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAWgbQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_4979.setTransform(376.7,471.4,0.5,0.5);

	this.shape_4980 = new cjs.Shape();
	this.shape_4980.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AaAdQAZAdAvAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgXAag");
	this.shape_4980.setTransform(362.5,474.2,0.5,0.5);

	this.shape_4981 = new cjs.Shape();
	this.shape_4981.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_4981.setTransform(350.5,471.3,0.5,0.5);

	this.shape_4982 = new cjs.Shape();
	this.shape_4982.graphics.f("#000000").s().p("Ag+B7QgbgQgPghQgPggAAgqQAAhBAgglQAgglA4AAQA4AAAfAlQAgAmAABAQAABBghAmQggAlg3AAQgkAAgagRgAhFhWQgYAeAAA4QAAA3AYAgQAaAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4982.setTransform(335.7,474.2,0.5,0.5);

	this.shape_4983 = new cjs.Shape();
	this.shape_4983.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4983.setTransform(320.8,474.2,0.5,0.5);

	this.shape_4984 = new cjs.Shape();
	this.shape_4984.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_4984.setTransform(310.4,471.3,0.5,0.5);

	this.shape_4985 = new cjs.Shape();
	this.shape_4985.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_4985.setTransform(296.5,472.7,0.5,0.5);

	this.shape_4986 = new cjs.Shape();
	this.shape_4986.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_4986.setTransform(289.5,471.7,0.5,0.5);

	this.shape_4987 = new cjs.Shape();
	this.shape_4987.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgNQAIgNAKgaIAOgkIhokNIAZAAIA6CYQAaBFAGAYIABAAIAihfIA6iWIAZAAIh4E5QgPAmgKAOQgJANgOAHQgNAHgUgBQgPAAgQgEg");
	this.shape_4987.setTransform(274.2,477.3,0.5,0.5);

	this.shape_4988 = new cjs.Shape();
	this.shape_4988.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAPAAAfQAAAZAQAOQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_4988.setTransform(261.1,474.2,0.5,0.5);

	this.shape_4989 = new cjs.Shape();
	this.shape_4989.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAPA4AFAdIABAAQAPg7AHgSIA4ikIAVAAIA1CjQARA4AFAWIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_4989.setTransform(245.6,474.2,0.5,0.5);

	this.shape_4990 = new cjs.Shape();
	this.shape_4990.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgnA1AAQAwAAAcAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAQgDAcgLIAAAWQgXAKgTAEQgSADgaAAQg6AAghgkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_4990.setTransform(222.7,474.2,0.5,0.5);

	this.shape_4991 = new cjs.Shape();
	this.shape_4991.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgvAAgXAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_4991.setTransform(208.3,471.3,0.5,0.5);

	this.shape_4992 = new cjs.Shape();
	this.shape_4992.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_4992.setTransform(196.2,472.7,0.5,0.5);

	this.shape_4993 = new cjs.Shape();
	this.shape_4993.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgxASgYQARgXAqAAQAXAAAWAGIgGAWQgUgGgUAAQgdAAgMARQgLASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_4993.setTransform(182.6,471.2,0.5,0.5);

	this.shape_4994 = new cjs.Shape();
	this.shape_4994.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhBAgglQAfglA5AAQA4AAAfAlQAgAmAABAQAABBggAmQghAlg3AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA3AYAgQAaAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_4994.setTransform(170.4,474.2,0.5,0.5);

	this.shape_4995 = new cjs.Shape();
	this.shape_4995.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNAAgWQAAgVgRgOQgRgOglgNQgogNgQgLQgRgLgIgNQgJgOABgTQAAgeAZgSQAZgRAtAAQAsAAAoAQIgJAWQgogQgjAAQgeAAgVALQgTALgBATQAAAWAPAMQAPANAsAQQAiAMATAKQARALAIANQAIANAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_4995.setTransform(150.3,474.2,0.5,0.5);

	this.shape_4996 = new cjs.Shape();
	this.shape_4996.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAApARASQASATAjAAQAwAAAWgZQAYgZAAg2IAAiVIAYAAIAAEOIgVAAIgEglIgCAAQgbAqhCAAQhcAAAAhjg");
	this.shape_4996.setTransform(136.8,474.3,0.5,0.5);

	this.shape_4997 = new cjs.Shape();
	this.shape_4997.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhCAggkQAgglA4AAQA3AAAgAlQAgAmAABAQAABCggAlQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_4997.setTransform(121.9,474.2,0.5,0.5);

	this.shape_4998 = new cjs.Shape();
	this.shape_4998.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgEAGgIAAQgPAAAAgYg");
	this.shape_4998.setTransform(111.6,471.7,0.5,0.5);

	this.shape_4999 = new cjs.Shape();
	this.shape_4999.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_4999.setTransform(102.9,474.2,0.5,0.5);

	this.shape_5000 = new cjs.Shape();
	this.shape_5000.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAoAAAUgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAVAQANQAPANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_5000.setTransform(90.5,474.2,0.5,0.5);

	this.shape_5001 = new cjs.Shape();
	this.shape_5001.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5001.setTransform(77.2,474.1,0.5,0.5);

	this.shape_5002 = new cjs.Shape();
	this.shape_5002.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5002.setTransform(62.2,474.2,0.5,0.5);

	this.shape_5003 = new cjs.Shape();
	this.shape_5003.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAgggkg");
	this.shape_5003.setTransform(48.9,474.2,0.5,0.5);

	this.shape_5004 = new cjs.Shape();
	this.shape_5004.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAJgGAIgNQAIgNAKgaIANgkIhnkNIAZAAIA5CYQAbBFAHAYIAAAAIAihfIA5iWIAaAAIh5E5QgOAmgKAOQgKANgNAHQgNAHgUgBQgOAAgRgEg");
	this.shape_5004.setTransform(730.4,439,0.5,0.5);

	this.shape_5005 = new cjs.Shape();
	this.shape_5005.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_5005.setTransform(720.5,435.8,0.5,0.5);

	this.shape_5006 = new cjs.Shape();
	this.shape_5006.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgaAAQg5AAgigkgAg2hcQgZAagDAxICmAAQABgvgVgbQgVgbgkAAQglAAgYAag");
	this.shape_5006.setTransform(707.7,435.9,0.5,0.5);

	this.shape_5007 = new cjs.Shape();
	this.shape_5007.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAOAjAHAbIAAAAQAKggAMgfIBFi2IAaAAIhoENg");
	this.shape_5007.setTransform(694.8,435.9,0.5,0.5);

	this.shape_5008 = new cjs.Shape();
	this.shape_5008.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQAAgdAQgRQARgTAfgGQgNgGgHgKQgIgJABgMQAAgaAigWQgYgJgNgVQgNgUAAgbQAAgpAagZQAZgYAsAAQAbAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgTABgHgCQgOAHgIALQgIAKAAALQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgjAXQgiAXhAAAQgyAAgcgTgAhgB6QABA5BTAAQBpAAAAhFQAAgYgQgLQgSgLgkAAIgsAAQhLAAAAA6gAg4igQgTASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgTgQQgSgSghAAQggAAgSATg");
	this.shape_5008.setTransform(675.7,438.9,0.5,0.5);

	this.shape_5009 = new cjs.Shape();
	this.shape_5009.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5009.setTransform(661.5,435.8,0.5,0.5);

	this.shape_5010 = new cjs.Shape();
	this.shape_5010.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5010.setTransform(651.1,433.5,0.5,0.5);

	this.shape_5011 = new cjs.Shape();
	this.shape_5011.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggnA0AAQAxAAAbAhQAbAhABA6IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgYAKgSAEQgTADgZAAQg6AAgggkgAg2hcQgYAZgEAyICnAAQAAgvgVgbQgUgbglAAQgmAAgXAag");
	this.shape_5011.setTransform(641.2,435.9,0.5,0.5);

	this.shape_5012 = new cjs.Shape();
	this.shape_5012.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAVgLQAWgLAeAAQA5AAAcAjQAdAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5012.setTransform(627,433.1,0.5,0.5);

	this.shape_5013 = new cjs.Shape();
	this.shape_5013.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5013.setTransform(608.3,435.8,0.5,0.5);

	this.shape_5014 = new cjs.Shape();
	this.shape_5014.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAbAdAuAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_5014.setTransform(595.5,435.9,0.5,0.5);

	this.shape_5015 = new cjs.Shape();
	this.shape_5015.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIAABhIgBApIAAAVIABAAQAQgYAWgMQAVgLAeAAQA5AAAdAjQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5015.setTransform(581.3,433.1,0.5,0.5);

	this.shape_5016 = new cjs.Shape();
	this.shape_5016.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgVAYABAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZABA3IAACUIgaAAIAAkOIAVAAIAFAlIACAAQALgTAVgMQAUgLAaAAQA/AAASAwIABAAQAOgXAVgNQAWgMAdAAQAtAAAVAYQAWAXAAA0IAACwg");
	this.shape_5016.setTransform(562.1,435.8,0.5,0.5);

	this.shape_5017 = new cjs.Shape();
	this.shape_5017.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_5017.setTransform(543.8,435.9,0.5,0.5);

	this.shape_5018 = new cjs.Shape();
	this.shape_5018.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgSQgQgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAKgTAWgMQAUgLAZAAQBAAAASAwIABAAQAMgXAXgNQAWgMAdAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_5018.setTransform(525.6,435.8,0.5,0.5);

	this.shape_5019 = new cjs.Shape();
	this.shape_5019.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggnA2AAQAvAAAbAhQAcAiAAA5IAAASIjBAAQAAA4AZAeQAaAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgWAKgUAEQgSADgYAAQg7AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgbgjAAQgmAAgYAag");
	this.shape_5019.setTransform(507.3,435.9,0.5,0.5);

	this.shape_5020 = new cjs.Shape();
	this.shape_5020.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAdAAAuIAACUg");
	this.shape_5020.setTransform(496.2,435.8,0.5,0.5);

	this.shape_5021 = new cjs.Shape();
	this.shape_5021.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_5021.setTransform(480.5,433.6,0.5,0.5);

	this.shape_5022 = new cjs.Shape();
	this.shape_5022.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_5022.setTransform(462.7,433.1,0.5,0.5);

	this.shape_5023 = new cjs.Shape();
	this.shape_5023.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgkAAQguAAgYAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5023.setTransform(448.1,435.8,0.5,0.5);

	this.shape_5024 = new cjs.Shape();
	this.shape_5024.graphics.f("#000000").s().p("AhPB4QgWgVABgkQAAgnAggXQAhgUA+gCIA0gBIAAgSQAAgmgQgUQgRgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAVAXAAAxIAACzIgSAAIgFgrIgDAAQgUAagVALQgWALgdAAQgoAAgWgUgAAeAAQg5ADgYAPQgYAPABAfQAAAaAPANQAQAPAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_5024.setTransform(433.3,436,0.5,0.5);

	this.shape_5025 = new cjs.Shape();
	this.shape_5025.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggnA2AAQAwAAAbAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgbgjAAQgmAAgZAag");
	this.shape_5025.setTransform(413.3,435.9,0.5,0.5);

	this.shape_5026 = new cjs.Shape();
	this.shape_5026.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhEAigkQAiglA6AAQAjAAAgAMIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA4QAAA2AaAgQAaAfAtAAQAlAAAfgNIAAAXQgZAMgrAAQg5AAghgkg");
	this.shape_5026.setTransform(400.6,435.9,0.5,0.5);

	this.shape_5027 = new cjs.Shape();
	this.shape_5027.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5027.setTransform(386.8,435.8,0.5,0.5);

	this.shape_5028 = new cjs.Shape();
	this.shape_5028.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPggAAgqQAAhBAhglQAfglA4AAQA4AAAfAlQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5028.setTransform(371.7,435.9,0.5,0.5);

	this.shape_5029 = new cjs.Shape();
	this.shape_5029.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5029.setTransform(353.5,435.8,0.5,0.5);

	this.shape_5030 = new cjs.Shape();
	this.shape_5030.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAaAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_5030.setTransform(340.7,435.9,0.5,0.5);

	this.shape_5031 = new cjs.Shape();
	this.shape_5031.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgvAAgXAZQgXAZAAA2IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_5031.setTransform(326.2,433,0.5,0.5);

	this.shape_5032 = new cjs.Shape();
	this.shape_5032.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_5032.setTransform(307.9,435.8,0.5,0.5);

	this.shape_5033 = new cjs.Shape();
	this.shape_5033.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAeglA4AAQA5AAAfAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_5033.setTransform(294.6,435.9,0.5,0.5);

	this.shape_5034 = new cjs.Shape();
	this.shape_5034.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgOIAzgJIAAgWQAAgwASgZQARgXAqAAQAYAAAUAGIgFAWQgUgGgUAAQgcAAgMARQgMASAAAlIAAAaIA/AAIAAAVIg/AAIAAD4g");
	this.shape_5034.setTransform(284.2,433,0.5,0.5);

	this.shape_5035 = new cjs.Shape();
	this.shape_5035.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5035.setTransform(268.8,435.8,0.5,0.5);

	this.shape_5036 = new cjs.Shape();
	this.shape_5036.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgXAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQglAAgZAag");
	this.shape_5036.setTransform(256,435.9,0.5,0.5);

	this.shape_5037 = new cjs.Shape();
	this.shape_5037.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_5037.setTransform(241.5,433,0.5,0.5);

	this.shape_5038 = new cjs.Shape();
	this.shape_5038.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_5038.setTransform(229.5,434.4,0.5,0.5);

	this.shape_5039 = new cjs.Shape();
	this.shape_5039.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgWAKgVAEQgRADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgbgkAAQgmAAgYAag");
	this.shape_5039.setTransform(218.4,435.9,0.5,0.5);

	this.shape_5040 = new cjs.Shape();
	this.shape_5040.graphics.f("#000000").s().p("AhdC0QgcgUAAgjQAAgdAQgRQARgTAfgGQgMgGgIgKQgIgJABgMQgBgaAjgWQgYgJgNgVQgNgUAAgbQAAgpAagZQAZgYAtAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgNAHgKALQgHAKAAALQAAANAKAHQAKAFAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgjAXQgiAXhAAAQgyAAgcgTgAhgB6QAAA5BUAAQBpAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhKAAgBA6gAg4igQgTASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgTgQQgSgSghAAQggAAgSATg");
	this.shape_5040.setTransform(204.8,438.9,0.5,0.5);

	this.shape_5041 = new cjs.Shape();
	this.shape_5041.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_5041.setTransform(190.6,435.9,0.5,0.5);

	this.shape_5042 = new cjs.Shape();
	this.shape_5042.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_5042.setTransform(178.7,434.4,0.5,0.5);

	this.shape_5043 = new cjs.Shape();
	this.shape_5043.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_5043.setTransform(160,433.1,0.5,0.5);

	this.shape_5044 = new cjs.Shape();
	this.shape_5044.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5044.setTransform(145.6,436,0.5,0.5);

	this.shape_5045 = new cjs.Shape();
	this.shape_5045.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_5045.setTransform(136.4,433,0.5,0.5);

	this.shape_5046 = new cjs.Shape();
	this.shape_5046.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5046.setTransform(126.3,436,0.5,0.5);

	this.shape_5047 = new cjs.Shape();
	this.shape_5047.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAnAAAVgOQAVgNAAgWQAAgUgRgPQgRgOglgNQgngNgRgLQgRgLgIgNQgIgNAAgUQAAgeAZgSQAZgRAtAAQArAAApAQIgKAWQgngQgjAAQgfAAgUALQgUALAAATQAAAWAPAMQAQANAqAQQAlAMARAKQARALAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_5047.setTransform(114,435.9,0.5,0.5);

	this.shape_5048 = new cjs.Shape();
	this.shape_5048.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgmgQgUQgQgUgiAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgTAAIgGgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg5ADgXAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5048.setTransform(94.3,436,0.5,0.5);

	this.shape_5049 = new cjs.Shape();
	this.shape_5049.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgAKAOQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_5049.setTransform(76.9,434.4,0.5,0.5);

	this.shape_5050 = new cjs.Shape();
	this.shape_5050.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQARATAkAAQAvAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_5050.setTransform(65.2,436.1,0.5,0.5);

	this.shape_5051 = new cjs.Shape();
	this.shape_5051.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABDgeAkQgeAlg0AAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAbQAVAcAvAAQAqAAAWgfQAXgdAAg5QAAh3hWAAQguAAgWAag");
	this.shape_5051.setTransform(50.6,438.9,0.5,0.5);

	this.shape_5052 = new cjs.Shape();
	this.shape_5052.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhBAgglQAgglA3AAQA4AAAgAlQAgAmAABAQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_5052.setTransform(689.8,397.7,0.5,0.5);

	this.shape_5053 = new cjs.Shape();
	this.shape_5053.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_5053.setTransform(677.9,396.2,0.5,0.5);

	this.shape_5054 = new cjs.Shape();
	this.shape_5054.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAfgmQAggnA2AAQAvAAAcAhQAcAigBA5IAAASIjCAAQAAA4AaAeQAaAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgXAKgUAEQgRADgaAAQg6AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgjAAQgmAAgZAag");
	this.shape_5054.setTransform(660.2,397.7,0.5,0.5);

	this.shape_5055 = new cjs.Shape();
	this.shape_5055.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgRQgPgTggAAQgpAAgUAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAARAwIABAAQAOgXAWgNQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_5055.setTransform(642,397.6,0.5,0.5);

	this.shape_5056 = new cjs.Shape();
	this.shape_5056.graphics.f("#000000").s().p("AhTCiQgegjAAhDQAAhFAdglQAdglA4AAQAdAAAWAKQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAWgbQAVgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgrAAgXAfg");
	this.shape_5056.setTransform(616,394.9,0.5,0.5);

	this.shape_5057 = new cjs.Shape();
	this.shape_5057.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAbAdAuAAQAUAAAUgDQAQgDAdgLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_5057.setTransform(601.9,397.7,0.5,0.5);

	this.shape_5058 = new cjs.Shape();
	this.shape_5058.graphics.f("#000000").s().p("ABHDCIhmiJIgsApIAABgIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_5058.setTransform(589.8,394.8,0.5,0.5);

	this.shape_5059 = new cjs.Shape();
	this.shape_5059.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAnAAAVgOQAVgNgBgWQAAgUgQgPQgRgOgmgNQgmgNgRgLQgRgKgIgOQgJgOAAgTQAAgeAagSQAZgRAtAAQAsAAAnAQIgJAWQgogQgiAAQgfAAgUALQgUALAAATQABAWAPAMQAPANAqAQQAlANAQAJQARALAIANQAJAOAAASQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_5059.setTransform(576.5,397.7,0.5,0.5);

	this.shape_5060 = new cjs.Shape();
	this.shape_5060.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgdAAQgoAAgWgUgAAeAAQg6ADgWAPQgZAPAAAfQAAAaAQANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5060.setTransform(563.4,397.7,0.5,0.5);

	this.shape_5061 = new cjs.Shape();
	this.shape_5061.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAcAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAuAAQAVAAAUgDQAPgDAegLIAAAWQgWAKgVAEQgRADgaAAQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_5061.setTransform(543.5,397.7,0.5,0.5);

	this.shape_5062 = new cjs.Shape();
	this.shape_5062.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA2IAACVIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAWgLAjAAQBbAAAABiIAACxg");
	this.shape_5062.setTransform(529.1,394.8,0.5,0.5);

	this.shape_5063 = new cjs.Shape();
	this.shape_5063.graphics.f("#000000").s().p("AhvCtIAAgaQApARA7AAQAsAAAagVQAbgVAAggQgBgWgIgNQgJgNgTgMQgVgLglgNQg4gSgUgWQgWgWAAgmQAAgoAggaQAhgaAxAAQAzAAAtAUIgJAVQgtgTgqAAQgoAAgXATQgYATAAAgQAAAVAHAMQAIANAQAKQASAMAmANQAqAOAWANQAWAOAJASQALAQAAAaQAAAugiAaQghAbg3AAQhEAAgigOg");
	this.shape_5063.setTransform(514.6,395.4,0.5,0.5);

	this.shape_5064 = new cjs.Shape();
	this.shape_5064.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_5064.setTransform(497.9,403.5,0.5,0.5);

	this.shape_5065 = new cjs.Shape();
	this.shape_5065.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5065.setTransform(492,394.8,0.5,0.5);

	this.shape_5066 = new cjs.Shape();
	this.shape_5066.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgWALgcAAQgpAAgVgUgAAeAAQg5ADgXAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5066.setTransform(481.9,397.7,0.5,0.5);

	this.shape_5067 = new cjs.Shape();
	this.shape_5067.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQgiAAgWAdQgWAdAAAuIAACUg");
	this.shape_5067.setTransform(471.5,397.6,0.5,0.5);

	this.shape_5068 = new cjs.Shape();
	this.shape_5068.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAxAAAbAhQAbAiABA5IAAASIjDAAQABA5AZAdQAaAdAuAAQAVAAAVgDQAPgDAdgLIAAAWQgXAKgTAEQgSADgaAAQg6AAgggkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgUgbglAAQglAAgZAag");
	this.shape_5068.setTransform(458.7,397.7,0.5,0.5);

	this.shape_5069 = new cjs.Shape();
	this.shape_5069.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBDAAQBbAAAABjIAACwg");
	this.shape_5069.setTransform(444.3,397.6,0.5,0.5);

	this.shape_5070 = new cjs.Shape();
	this.shape_5070.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgnA0AAQAwAAAcAhQAbAhAAA6IAAASIjCAAQABA5AZAdQAbAdAuAAQAUAAAUgDQAPgDAegLIAAAWQgYAKgTAEQgSADgYAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgbgkAAQgmAAgXAag");
	this.shape_5070.setTransform(429.7,397.7,0.5,0.5);

	this.shape_5071 = new cjs.Shape();
	this.shape_5071.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegGQgMgGgIgKQgHgJAAgMQAAgaAigWQgYgJgMgVQgOgUAAgbQAAgpAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAYgrAAQgSABgIgCQgNAHgJALQgIAKAAALQAAAOAKAGQAKAFAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB6QAAA5BTAAQBpAAAAhFQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAiQAAAeATASQAUARAfAAQAhAAASgRQASgRAAggQAAgkgSgQQgTgSggAAQggAAgTATg");
	this.shape_5071.setTransform(416,400.6,0.5,0.5);

	this.shape_5072 = new cjs.Shape();
	this.shape_5072.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgTgkAAQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5072.setTransform(395.3,397.6,0.5,0.5);

	this.shape_5073 = new cjs.Shape();
	this.shape_5073.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5073.setTransform(384.8,395.2,0.5,0.5);

	this.shape_5074 = new cjs.Shape();
	this.shape_5074.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_5074.setTransform(367.3,394.9,0.5,0.5);

	this.shape_5075 = new cjs.Shape();
	this.shape_5075.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5075.setTransform(357.2,394.8,0.5,0.5);

	this.shape_5076 = new cjs.Shape();
	this.shape_5076.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5076.setTransform(350.3,397.6,0.5,0.5);

	this.shape_5077 = new cjs.Shape();
	this.shape_5077.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAggkQAgglA3AAQA4AAAgAlQAgAlAABBQAABBggAmQggAlg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_5077.setTransform(336.9,397.7,0.5,0.5);

	this.shape_5078 = new cjs.Shape();
	this.shape_5078.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOAzAGAiIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_5078.setTransform(320.2,397.7,0.5,0.5);

	this.shape_5079 = new cjs.Shape();
	this.shape_5079.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgnA1AAQAvAAAcAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQAUAAAUgDQAQgDAdgLIAAAWQgXAKgUAEQgRADgZAAQg7AAghgkgAg2hcQgYAagEAxICmAAQAAgvgUgbQgUgbgkAAQgmAAgYAag");
	this.shape_5079.setTransform(297.4,397.7,0.5,0.5);

	this.shape_5080 = new cjs.Shape();
	this.shape_5080.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgvAAgXAZQgXAYAAA3IAACVIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAXgLAiAAQBbAAABBiIAACxg");
	this.shape_5080.setTransform(283,394.8,0.5,0.5);

	this.shape_5081 = new cjs.Shape();
	this.shape_5081.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAitIgoAAIAAgPIAogLIANg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_5081.setTransform(270.9,396.2,0.5,0.5);

	this.shape_5082 = new cjs.Shape();
	this.shape_5082.graphics.f("#000000").s().p("AhUCiQgdgkAAhCQAAhFAdglQAdglA4AAQAdAAAVAKQAVAKASAbIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegigAhBgeQgWAeAAA7QAAB0BYAAQAuAAAVgbQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_5082.setTransform(252.2,394.9,0.5,0.5);

	this.shape_5083 = new cjs.Shape();
	this.shape_5083.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASAEIgFAXQgRgEgSAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_5083.setTransform(240.9,397.6,0.5,0.5);

	this.shape_5084 = new cjs.Shape();
	this.shape_5084.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgXQAhgUA+gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgrIgCAAQgTAagXALQgVALgcAAQgpAAgVgUgAAeAAQg6ADgWAPQgYAPAAAfQAAAaAPANQAQAPAcAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5084.setTransform(227.9,397.7,0.5,0.5);

	this.shape_5085 = new cjs.Shape();
	this.shape_5085.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOAzAGAiIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_5085.setTransform(212.4,397.7,0.5,0.5);

	this.shape_5086 = new cjs.Shape();
	this.shape_5086.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPggAAgqQAAhBAhglQAfglA4AAQA3AAAgAlQAgAmAABAQAABBghAmQgfAlg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5086.setTransform(195.7,397.7,0.5,0.5);

	this.shape_5087 = new cjs.Shape();
	this.shape_5087.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAitIgoAAIAAgPIAogLIANg+IAMAAIAABCIBPAAIAAAWIhPAAIAACqQAAAeAKAQQAMAPAXAAQAWAAATgEIAAATQgSAHgYAAQgjgBgRgSg");
	this.shape_5087.setTransform(183.8,396.2,0.5,0.5);

	this.shape_5088 = new cjs.Shape();
	this.shape_5088.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAitIgpAAIAAgPIApgLIAMg+IANAAIAABCIBOAAIAAAWIhOAAIAACqQAAAgAKAOQAKAPAYAAQAWAAATgEIAAATQgSAHgYAAQgjgBgQgSg");
	this.shape_5088.setTransform(168.6,396.2,0.5,0.5);

	this.shape_5089 = new cjs.Shape();
	this.shape_5089.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARATAlAAQAuAAAXgZQAXgYAAg3IAAiVIAZAAIAAEOIgWAAIgEglIgBAAQgaAqhDAAQhdAAAAhjg");
	this.shape_5089.setTransform(156.9,397.8,0.5,0.5);

	this.shape_5090 = new cjs.Shape();
	this.shape_5090.graphics.f("#000000").s().p("Ag0C4QgXgLgOgWIgCAAIgHAoIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAWgLQAVgLAeAAQA5AAAcAjQAdAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA+AWAaQAWAbAtAAQArAAAXgfQAWggAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5090.setTransform(142.3,394.9,0.5,0.5);

	this.shape_5091 = new cjs.Shape();
	this.shape_5091.graphics.f("#000000").s().p("AgdA/QAUhHAIg1IAcAAIADAEQgTBCgYA2g");
	this.shape_5091.setTransform(124.5,404.6,0.5,0.5);

	this.shape_5092 = new cjs.Shape();
	this.shape_5092.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQALgHAHgMQAIgNAKgaIAOgkIhokNIAZAAIA5CYQAbBFAGAYIABAAQAKggAYg/IA5iWIAaAAIh4E5QgOAmgLAOQgJANgOAHQgNAHgTgBQgPAAgRgEg");
	this.shape_5092.setTransform(116.3,400.8,0.5,0.5);

	this.shape_5093 = new cjs.Shape();
	this.shape_5093.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATAEIgFAXQgRgEgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5093.setTransform(106.4,397.6,0.5,0.5);

	this.shape_5094 = new cjs.Shape();
	this.shape_5094.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5094.setTransform(97.7,394.8,0.5,0.5);

	this.shape_5095 = new cjs.Shape();
	this.shape_5095.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgnA1AAQAwAAAbAhQAdAiAAA5IAAASIjCAAQAAA4AaAeQAZAdAvAAQAUAAAUgDQAPgDAdgLIAAAWQgVAKgVAEQgRADgZAAQg6AAghgkgAg3hcQgXAZgEAyICmAAQAAgwgVgaQgUgbgkAAQgmAAgYAag");
	this.shape_5095.setTransform(87.8,397.7,0.5,0.5);

	this.shape_5096 = new cjs.Shape();
	this.shape_5096.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOAzAGAiIACAAQAOg5AHgUIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_5096.setTransform(71.6,397.7,0.5,0.5);

	this.shape_5097 = new cjs.Shape();
	this.shape_5097.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgnA1AAQAwAAAbAhQAbAhAAA6IAAASIjBAAQABA5AZAdQAZAdAvAAQATAAAVgDQAQgDAdgLIAAAWQgYAKgSAEQgTADgYAAQg7AAgggkgAg3hcQgXAagEAxICnAAQgBgvgUgbQgVgbgjAAQgmAAgZAag");
	this.shape_5097.setTransform(55.4,397.7,0.5,0.5);

	this.shape_5098 = new cjs.Shape();
	this.shape_5098.graphics.f("#000000").s().p("AgwDwIAAgVQARAEAPAAQAkAAAAgrIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgTAAgOgGgAARjdQAAgYAQAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_5098.setTransform(43.8,398.3,0.5,0.5);

	this.shape_5099 = new cjs.Shape();
	this.shape_5099.graphics.f("#000000").s().p("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");
	this.shape_5099.setTransform(390.2,359.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_5099},{t:this.shape_5098},{t:this.shape_5097},{t:this.shape_5096},{t:this.shape_5095},{t:this.shape_5094},{t:this.shape_5093},{t:this.shape_5092},{t:this.shape_5091},{t:this.shape_5090},{t:this.shape_5089},{t:this.shape_5088},{t:this.shape_5087},{t:this.shape_5086},{t:this.shape_5085},{t:this.shape_5084},{t:this.shape_5083},{t:this.shape_5082},{t:this.shape_5081},{t:this.shape_5080},{t:this.shape_5079},{t:this.shape_5078},{t:this.shape_5077},{t:this.shape_5076},{t:this.shape_5075},{t:this.shape_5074},{t:this.shape_5073},{t:this.shape_5072},{t:this.shape_5071},{t:this.shape_5070},{t:this.shape_5069},{t:this.shape_5068},{t:this.shape_5067},{t:this.shape_5066},{t:this.shape_5065},{t:this.shape_5064},{t:this.shape_5063},{t:this.shape_5062},{t:this.shape_5061},{t:this.shape_5060},{t:this.shape_5059},{t:this.shape_5058},{t:this.shape_5057},{t:this.shape_5056},{t:this.shape_5055},{t:this.shape_5054},{t:this.shape_5053},{t:this.shape_5052},{t:this.shape_5051},{t:this.shape_5050},{t:this.shape_5049},{t:this.shape_5048},{t:this.shape_5047},{t:this.shape_5046},{t:this.shape_5045},{t:this.shape_5044},{t:this.shape_5043},{t:this.shape_5042},{t:this.shape_5041},{t:this.shape_5040},{t:this.shape_5039},{t:this.shape_5038},{t:this.shape_5037},{t:this.shape_5036},{t:this.shape_5035},{t:this.shape_5034},{t:this.shape_5033},{t:this.shape_5032},{t:this.shape_5031},{t:this.shape_5030},{t:this.shape_5029},{t:this.shape_5028},{t:this.shape_5027},{t:this.shape_5026},{t:this.shape_5025},{t:this.shape_5024},{t:this.shape_5023},{t:this.shape_5022},{t:this.shape_5021},{t:this.shape_5020},{t:this.shape_5019},{t:this.shape_5018},{t:this.shape_5017},{t:this.shape_5016},{t:this.shape_5015},{t:this.shape_5014},{t:this.shape_5013},{t:this.shape_5012},{t:this.shape_5011},{t:this.shape_5010},{t:this.shape_5009},{t:this.shape_5008},{t:this.shape_5007},{t:this.shape_5006},{t:this.shape_5005},{t:this.shape_5004},{t:this.shape_5003},{t:this.shape_5002},{t:this.shape_5001},{t:this.shape_5000},{t:this.shape_4999},{t:this.shape_4998},{t:this.shape_4997},{t:this.shape_4996},{t:this.shape_4995},{t:this.shape_4994},{t:this.shape_4993},{t:this.shape_4992},{t:this.shape_4991},{t:this.shape_4990},{t:this.shape_4989},{t:this.shape_4988},{t:this.shape_4987},{t:this.shape_4986},{t:this.shape_4985},{t:this.shape_4984},{t:this.shape_4983},{t:this.shape_4982},{t:this.shape_4981},{t:this.shape_4980},{t:this.shape_4979},{t:this.shape_4978},{t:this.shape_4977},{t:this.shape_4976},{t:this.shape_4975},{t:this.shape_4974},{t:this.shape_4973},{t:this.shape_4972},{t:this.shape_4971},{t:this.shape_4970},{t:this.shape_4969},{t:this.shape_4968},{t:this.shape_4967},{t:this.shape_4966},{t:this.shape_4965},{t:this.shape_4964},{t:this.shape_4963},{t:this.shape_4962},{t:this.shape_4961},{t:this.shape_4960},{t:this.shape_4959},{t:this.shape_4958},{t:this.shape_4957},{t:this.shape_4956},{t:this.shape_4955},{t:this.shape_4954},{t:this.shape_4953},{t:this.shape_4952},{t:this.shape_4951},{t:this.shape_4950},{t:this.shape_4949},{t:this.shape_4948},{t:this.shape_4947},{t:this.shape_4946},{t:this.shape_4945},{t:this.shape_4944},{t:this.shape_4943},{t:this.shape_4942},{t:this.shape_4941},{t:this.shape_4940},{t:this.shape_4939},{t:this.shape_4938},{t:this.shape_4937},{t:this.shape_4936},{t:this.shape_4935},{t:this.shape_4934},{t:this.shape_4933},{t:this.shape_4932},{t:this.shape_4931},{t:this.shape_4930},{t:this.shape_4929},{t:this.shape_4928},{t:this.shape_4927},{t:this.shape_4926},{t:this.shape_4925},{t:this.shape_4924},{t:this.shape_4923},{t:this.shape_4922},{t:this.shape_4921},{t:this.shape_4920},{t:this.shape_4919},{t:this.shape_4918},{t:this.shape_4917},{t:this.shape_4916},{t:this.shape_4915},{t:this.shape_4914},{t:this.shape_4913},{t:this.shape_4912},{t:this.shape_4911},{t:this.shape_4910},{t:this.shape_4909},{t:this.shape_4908},{t:this.shape_4907},{t:this.shape_4906},{t:this.shape_4905},{t:this.shape_4904},{t:this.shape_4903},{t:this.shape_4902},{t:this.shape_4901},{t:this.shape_4900},{t:this.shape_4899},{t:this.shape_4898},{t:this.shape_4897},{t:this.shape_4896},{t:this.shape_4895},{t:this.shape_4894},{t:this.shape_4893},{t:this.shape_4892},{t:this.shape_4891},{t:this.shape_4890},{t:this.shape_4889},{t:this.shape_4888},{t:this.shape_4887},{t:this.shape_4886},{t:this.shape_4885},{t:this.shape_4884},{t:this.shape_4883},{t:this.shape_4882},{t:this.shape_4881},{t:this.instance_22}]},57).to({state:[]},1).wait(107));

	// ButtonLeftRight copy 20
	this.buttonR9 = new lib.ButtonLeft_Right();
	this.buttonR9.name = "buttonR9";
	this.buttonR9.parent = this;
	this.buttonR9.setTransform(2025,513.5,1,1,180);
	this.buttonR9._off = true;
	new cjs.ButtonHelper(this.buttonR9, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR9).wait(56).to({_off:false},0).to({_off:true},1).wait(108));

	// ButtonLeftRight copy 21
	this.buttonL9 = new lib.ButtonLeft_Right();
	this.buttonL9.name = "buttonL9";
	this.buttonL9.parent = this;
	this.buttonL9.setTransform(0,437.2);
	this.buttonL9._off = true;
	new cjs.ButtonHelper(this.buttonL9, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL9).wait(56).to({_off:false},0).to({_off:true},1).wait(108));

	// Layer 1
	this.instance_23 = new lib.bwnecklacedraw();
	this.instance_23.parent = this;
	this.instance_23.setTransform(816,-8);

	this.shape_5100 = new cjs.Shape();
	this.shape_5100.graphics.f("#000000").s().p("AhqCLIAAgrQAWAMAZAFQAYAHAYAAQAjAAAUgLQAUgLAAgZQAAgRgQgNQgQgNgrgRQgqgOgTgNQgSgMgIgPQgJgOAAgWQAAglAegVQAegWA0AAQAyAAAvAUIgRAmQgugUglAAQggAAgQALQgRALAAASQAAAMAGAIQAGAJAOAHQAPAJAmAOQA3AUASATQATAUAAAeQAAArggAXQgfAXg5AAQg9AAghgTg");
	this.shape_5100.setTransform(281.1,535.1,0.5,0.5);

	this.shape_5101 = new cjs.Shape();
	this.shape_5101.graphics.f("#000000").s().p("ABSCbIAAjEQAAglgRgTQgSgSgjAAQgvAAgXAaQgWAaAAA7IAACfIgvAAIAAkwIAnAAIAHAqIACAAQAOgXAagMQAZgMAfAAQA3AAAcAaQAbAbABA6IAADGg");
	this.shape_5101.setTransform(265.5,534.9,0.5,0.5);

	this.shape_5102 = new cjs.Shape();
	this.shape_5102.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSiaQgIgJAAgPQAAgPAIgIQAIgHAKAAQAMAAAHAIQAIAHAAAPQAAAQgIAIQgHAHgMABQgLgBgHgHg");
	this.shape_5102.setTransform(253.1,532.3,0.5,0.5);

	this.shape_5103 = new cjs.Shape();
	this.shape_5103.graphics.f("#000000").s().p("ABCDZIhqiQIgjAdIAABzIguAAIAAmwIAuAAIAADkQAAATgCAcIACAAQALgQAZgcIBihnIA3AAIh8CAICECwg");
	this.shape_5103.setTransform(243.1,531.9,0.5,0.5);

	this.shape_5104 = new cjs.Shape();
	this.shape_5104.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgWIArgTIAUhCIAaAAIAABHIBYAAIAAAkIhYAAIAACyQAAAcANAPQANAPAWAAQAOAAAKgDQANgBAFgCIAAAkQgHACgPAEQgNACgNAAQhYgBAAhcg");
	this.shape_5104.setTransform(229.4,533.5,0.5,0.5);

	this.shape_5105 = new cjs.Shape();
	this.shape_5105.graphics.f("#000000").s().p("AhgCHQgZgYAAgrQAAhbCSgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgXAcgXALQgWAKgiAAQguAAgZgXgAAeAEQg2ADgZAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_5105.setTransform(216.1,535.1,0.5,0.5);

	this.shape_5106 = new cjs.Shape();
	this.shape_5106.graphics.f("#000000").s().p("ABlDMIhgk+IgGggQgGAjgOAtIhPEOIgvAAIhsmXIAyAAIBAD7QAOA2AGAqQAHgyAPgyIBJj3IAxAAIBMD5QAOArAJA3QAEgjAQg+IBAj6IAyAAIhtGXg");
	this.shape_5106.setTransform(195.4,532.5,0.5,0.5);

	this.shape_5107 = new cjs.Shape();
	this.shape_5107.graphics.f("#000000").s().p("AhfCHQgagYAAgrQAAhbCTgFIAzgBIAAgTQAAglgPgQQgPgSgjAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAaAYAAA1IAADPIgiAAIgJgrIgCAAQgWAbgYAMQgVAKgiAAQguAAgZgXgAAeAEQg3ADgXAOQgZAQAAAgQAAAYAPAOQAQANAbAAQAqAAAZgYQAYgXAAgrIAAgcg");
	this.shape_5107.setTransform(166.4,535.1,0.5,0.5);

	this.shape_5108 = new cjs.Shape();
	this.shape_5108.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQAQgdAZgRQAXgQAcAAQAWAAAPADIgGArQgVgEgNAAQglAAgaAeQgaAdAAAuIAACig");
	this.shape_5108.setTransform(154.2,534.9,0.5,0.5);

	this.shape_5109 = new cjs.Shape();
	this.shape_5109.graphics.f("#000000").s().p("AhkCzQghgpAAhMQAAhLAhgpQAhgqA8AAQA9AAAiAtIADAAIgCgWIgBiRIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg7AAgigogAhAgZQgVAeAAA6QAAA7AVAdQAWAeApAAQAvAAAVgaQAVgZAAg6IAAgKQAAhAgVgbQgXgcgtAAQgpAAgWAgg");
	this.shape_5109.setTransform(138.2,532,0.5,0.5);

	this.shape_5110 = new cjs.Shape();
	this.shape_5110.graphics.f("#000000").s().p("ABRCbIAAjEQAAgkgRgUQgRgSgkAAQguAAgXAaQgXAaABA7IAACfIguAAIAAkwIAlAAIAIAqIACAAQAPgXAYgMQAZgMAgAAQA3AAAcAaQAbAcAAA5IAADGg");
	this.shape_5110.setTransform(121.2,534.9,0.5,0.5);

	this.shape_5111 = new cjs.Shape();
	this.shape_5111.graphics.f("#000000").s().p("AhfCHQgbgZAAgqQAAhbCTgFIA0gBIAAgTQAAgkgPgRQgQgSgiAAQglAAgwAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAZQAbAYgBA1IAADPIgiAAIgJgrIgDAAQgVAcgYALQgWAKghAAQgvAAgYgXgAAeAEQg3ADgYAOQgYAQAAAgQAAAYAPAOQAQANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_5111.setTransform(104,535.1,0.5,0.5);

	this.shape_5112 = new cjs.Shape();
	this.shape_5112.graphics.f("#000000").s().p("ABWCZIhVh8IhWB8Ig0AAIBwicIhqiUIA0AAIBQB1IBPh1IA0AAIhqCUIBwCcg");
	this.shape_5112.setTransform(89.1,535.1,0.5,0.5);

	this.shape_5113 = new cjs.Shape();
	this.shape_5113.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhIAlgsQAkgrA8AAQA6AAAhAlQAhAmAAA+IAAAdIjRAAQACA2AZAbQAbAcAsAAQAyAAAwgVIAAApQgZALgWAFQgVAEgfAAQhCAAgogpgAg1hfQgXAZgDAqICeAAQABgsgUgXQgUgYgjAAQgkAAgWAYg");
	this.shape_5113.setTransform(73.7,535.1,0.5,0.5);

	this.shape_5114 = new cjs.Shape();
	this.shape_5114.graphics.f("#000000").s().p("AgWDZIAAmwIAtAAIAAGwg");
	this.shape_5114.setTransform(62,531.9,0.5,0.5);

	this.shape_5115 = new cjs.Shape();
	this.shape_5115.graphics.f("#000000").s().p("ACDDMIgyiBIijAAIgyCBIgvAAICgmXIAnAAICgGXgAgRhdIgwB9ICDAAIgwh9QgIgVgKglQgHAfgKAbg");
	this.shape_5115.setTransform(49.4,532.5,0.5,0.5);

	this.shape_5116 = new cjs.Shape();
	this.shape_5116.graphics.f("#000000").s().p("AAJA+QAJgcAHgiQAJgoADgWIAdAAIAEAGQgKAhgMAeQgMAggKAXgAhFA+QAIgVAIgnQAHgjAFgdIAdAAIADAGQgUBDgXAzg");
	this.shape_5116.setTransform(361,489.4,0.5,0.5);

	this.shape_5117 = new cjs.Shape();
	this.shape_5117.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABg/AggoQAggmA0gBQAwABAcAhQAbAiABA5IAAASIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQAPgDAdgLIAAAWQgYAKgSAEQgSAEgagBQg6AAgggkgAg3hcQgXAagEAxICmAAQABgvgVgbQgUgaglAAQglgBgZAag");
	this.shape_5117.setTransform(350.1,497.7,0.5,0.5);

	this.shape_5118 = new cjs.Shape();
	this.shape_5118.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgTQgQgTggAAQgpAAgUAYQgUAWAAAyIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAaQgUAZAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgLQAVgMAYAAQBAAAASAxIABAAQAMgYAXgNQAXgMAcAAQAsAAAWAYQAWAWAAA1IAACwg");
	this.shape_5118.setTransform(331.9,497.6,0.5,0.5);

	this.shape_5119 = new cjs.Shape();
	this.shape_5119.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_5119.setTransform(317.8,495.2,0.5,0.5);

	this.shape_5120 = new cjs.Shape();
	this.shape_5120.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_5120.setTransform(310.4,496.2,0.5,0.5);

	this.shape_5121 = new cjs.Shape();
	this.shape_5121.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAvABAdAhQAcAiAAA5IAAASIjDAAQAAA4AbAeQAZAdAuAAQAYAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgagBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgYAag");
	this.shape_5121.setTransform(292.7,497.7,0.5,0.5);

	this.shape_5122 = new cjs.Shape();
	this.shape_5122.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAXgLAhAAQBdAAgBBiIAACxg");
	this.shape_5122.setTransform(278.3,494.8,0.5,0.5);

	this.shape_5123 = new cjs.Shape();
	this.shape_5123.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgMIAMg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZAAAPgFIAAAVQgQAFgZAAQgiABgRgUg");
	this.shape_5123.setTransform(266.2,496.2,0.5,0.5);

	this.shape_5124 = new cjs.Shape();
	this.shape_5124.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_5124.setTransform(251,496.2,0.5,0.5);

	this.shape_5125 = new cjs.Shape();
	this.shape_5125.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5125.setTransform(239.7,497.7,0.5,0.5);

	this.shape_5126 = new cjs.Shape();
	this.shape_5126.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgWAKgVAEQgRAEgZgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_5126.setTransform(219.8,497.7,0.5,0.5);

	this.shape_5127 = new cjs.Shape();
	this.shape_5127.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgSQgPgTggAAQgqAAgUAYQgTAXAAAxIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAaQgUAZAAA2IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgKQAUgMAZAAQBAAAARAxIABAAQAOgYAWgNQAXgMAbAAQAtAAAWAYQAWAXAAA0IAACwg");
	this.shape_5127.setTransform(201.6,497.6,0.5,0.5);

	this.shape_5128 = new cjs.Shape();
	this.shape_5128.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_5128.setTransform(176.2,497.7,0.5,0.5);

	this.shape_5129 = new cjs.Shape();
	this.shape_5129.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg9IANAAIAABCIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_5129.setTransform(164.3,496.2,0.5,0.5);

	this.shape_5130 = new cjs.Shape();
	this.shape_5130.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_5130.setTransform(146.1,497.6,0.5,0.5);

	this.shape_5131 = new cjs.Shape();
	this.shape_5131.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhglA2AAQA4AAAgAmQAgAlAABBQAABBggAmQghAlg3AAQgkABgbgSgAhFhWQgYAfAAA3QAAA4AZAfQAXAfAtAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_5131.setTransform(131.1,497.7,0.5,0.5);

	this.shape_5132 = new cjs.Shape();
	this.shape_5132.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_5132.setTransform(120.7,495.2,0.5,0.5);

	this.shape_5133 = new cjs.Shape();
	this.shape_5133.graphics.f("#000000").s().p("AgSCXQgQgSAAgqIAAiuIgpAAIAAgOIApgMIAMg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXABQAZAAAQgFIAAAVQgRAFgZAAQgiABgSgUg");
	this.shape_5133.setTransform(113.4,496.2,0.5,0.5);

	this.shape_5134 = new cjs.Shape();
	this.shape_5134.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5134.setTransform(102.1,497.7,0.5,0.5);

	this.shape_5135 = new cjs.Shape();
	this.shape_5135.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5135.setTransform(92.9,494.8,0.5,0.5);

	this.shape_5136 = new cjs.Shape();
	this.shape_5136.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_5136.setTransform(83,497.7,0.5,0.5);

	this.shape_5137 = new cjs.Shape();
	this.shape_5137.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBGC3QAOAjAGAaIABAAQAJghAMgdIBGi2IAZAAIhpENg");
	this.shape_5137.setTransform(70.2,497.7,0.5,0.5);

	this.shape_5138 = new cjs.Shape();
	this.shape_5138.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjBAAQAAA4AaAeQAZAdAvAAQAXAAARgDQAPgDAegLIAAAWQgWAKgVAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgXAag");
	this.shape_5138.setTransform(57.3,497.7,0.5,0.5);

	this.shape_5139 = new cjs.Shape();
	this.shape_5139.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXAEIgFAYQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5139.setTransform(46.2,497.6,0.5,0.5);

	this.shape_5140 = new cjs.Shape();
	this.shape_5140.graphics.f("#000000").s().p("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");
	this.shape_5140.setTransform(321.2,459.5,0.5,0.5);

	this.shape_5141 = new cjs.Shape();
	this.shape_5141.graphics.f("#000000").s().p("AgTAAQAAgXATAAQAUAAAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_5141.setTransform(599.8,427,0.5,0.5);

	this.shape_5142 = new cjs.Shape();
	this.shape_5142.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5142.setTransform(589.4,421.1,0.5,0.5);

	this.shape_5143 = new cjs.Shape();
	this.shape_5143.graphics.f("#000000").s().p("AheC0QgcgTAAgkQABgcARgSQARgTAdgHQgMgFgHgJQgHgKgBgMQAAgaAkgVQgZgKgMgVQgOgVAAgaQAAgoAagaQAagYAsAAQAZAAAPAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAJAAANQAAANAKAGQAKAGAXAAIAuAAQAtAAAWARQAYASAAAjQAAArgiAXQgkAXg+AAQg0AAgcgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAABA7gAg5igQgSATAAAhQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgUgSgfAAQggAAgUATg");
	this.shape_5143.setTransform(575.1,424.1,0.5,0.5);

	this.shape_5144 = new cjs.Shape();
	this.shape_5144.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_5144.setTransform(565.6,418.7,0.5,0.5);

	this.shape_5145 = new cjs.Shape();
	this.shape_5145.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgQgKgJgOQgIgNAAgUQAAgeAZgSQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgTALAAATQAAAWAPAMQAOANArAPQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_5145.setTransform(556.6,421.2,0.5,0.5);

	this.shape_5146 = new cjs.Shape();
	this.shape_5146.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAiAAA5IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgXAKgTAEQgTAEgZgBQg6AAgggkgAg3hcQgXAZgEAyICmAAQAAgwgUgaQgVgagkAAQgmgBgYAag");
	this.shape_5146.setTransform(543.8,421.2,0.5,0.5);

	this.shape_5147 = new cjs.Shape();
	this.shape_5147.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAegkQAdgmA2AAQAcAAAYALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgbAAg9IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_5147.setTransform(528.8,418.4,0.5,0.5);

	this.shape_5148 = new cjs.Shape();
	this.shape_5148.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgUQAAgyASgYQARgXAqAAQAXAAAWAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5148.setTransform(512,418.2,0.5,0.5);

	this.shape_5149 = new cjs.Shape();
	this.shape_5149.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAhgmQAfglA4AAQA4AAAfAmQAgAmAABAQAABCggAlQghAlg3AAQgjABgcgSgAhEhWQgZAfAAA3QAAA3AZAgQAYAfAsAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5149.setTransform(499.9,421.2,0.5,0.5);

	this.shape_5150 = new cjs.Shape();
	this.shape_5150.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgnQAhgmA0gBQAwABAcAhQAbAiAAA5IAAASIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAQgDAdgLIAAAWQgYAKgTAEQgSAEgYgBQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgvgUgbQgVgagkAAQgmgBgXAag");
	this.shape_5150.setTransform(478.8,421.2,0.5,0.5);

	this.shape_5151 = new cjs.Shape();
	this.shape_5151.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAVgNAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgJgOAAgTQAAgfAagRQAagRAsgBQAsAAAoARIgKAWQgngQgjAAQgfAAgUALQgUAMAAASQAAAWAPAMQAOAMAsAQQAmAOAQAKQARAKAIANQAIAOAAASQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_5151.setTransform(465.8,421.2,0.5,0.5);

	this.shape_5152 = new cjs.Shape();
	this.shape_5152.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgvAAgXAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAcgqBBAAQBdAAAABjIAACwg");
	this.shape_5152.setTransform(452.5,421.1,0.5,0.5);

	this.shape_5153 = new cjs.Shape();
	this.shape_5153.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggnQAfgmA1gBQAwABAcAhQAbAjABA4IAAASIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAWQgXAKgTAEQgSAEgagBQg6AAgggkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgagkAAQglgBgZAag");
	this.shape_5153.setTransform(437.9,421.2,0.5,0.5);

	this.shape_5154 = new cjs.Shape();
	this.shape_5154.graphics.f("#000000").s().p("AhfB8IAAgaQApATAtABQAngBAVgNQAVgNAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgQgKgJgOQgIgMAAgVQAAgeAZgSQAagRAtgBQAsAAAnARIgJAWQgpgQghAAQggAAgUALQgTAMAAASQAAAWAPAMQAOANAsAPQAlAOAQAKQARAKAIANQAIAOAAASQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_5154.setTransform(424.8,421.2,0.5,0.5);

	this.shape_5155 = new cjs.Shape();
	this.shape_5155.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAjAAA4IAAASIjDAAQABA4AaAeQAZAdAuAAQAXAAATgDQAPgDAcgLIAAAWQgWAKgTAEQgTAEgZgBQg5AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgVgagkAAQgmgBgYAag");
	this.shape_5155.setTransform(405.4,421.2,0.5,0.5);

	this.shape_5156 = new cjs.Shape();
	this.shape_5156.graphics.f("#000000").s().p("AhfB8IAAgaQAoATAuABQAmgBAWgNQAVgNAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgRgKgIgOQgIgOAAgTQgBgeAagSQAZgRAugBQArAAAoARIgKAWQgngQgiAAQggAAgUALQgTAMAAASQgBAWAPAMQAOANAsAPQAlAOARAKQAQAKAJANQAIAOAAASQAAAkgbAUQgcATgyAAQg3AAgfgQg");
	this.shape_5156.setTransform(392.4,421.2,0.5,0.5);

	this.shape_5157 = new cjs.Shape();
	this.shape_5157.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgnQAfgmA1gBQAwABAcAhQAcAiAAA5IAAASIjDAAQABA4AaAeQAZAdAuAAQAXAAATgDQAPgDAdgLIAAAWQgYAKgSAEQgTAEgZgBQg5AAghgkgAg3hcQgXAagEAxICnAAQAAgvgVgbQgVgagkAAQgmgBgYAag");
	this.shape_5157.setTransform(379.5,421.2,0.5,0.5);

	this.shape_5158 = new cjs.Shape();
	this.shape_5158.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_5158.setTransform(365.1,421.1,0.5,0.5);

	this.shape_5159 = new cjs.Shape();
	this.shape_5159.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5159.setTransform(350.3,421.2,0.5,0.5);

	this.shape_5160 = new cjs.Shape();
	this.shape_5160.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAGAnIABAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABBgeAlQgeAlg0AAQg+AAgdgvIgCAAIACCkgAhCiWQgXAaAAA7IAAAIQAAA/AWAbQAVAbAvAAQApAAAYgfQAWgeAAg3QAAh4hWAAQgtAAgXAag");
	this.shape_5160.setTransform(336.8,424.1,0.5,0.5);

	this.shape_5161 = new cjs.Shape();
	this.shape_5161.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAYAAAwIAACzIgSAAIgHgqIgCAAQgUAagWALQgVAKgcAAQgpAAgVgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5161.setTransform(321.6,421.2,0.5,0.5);

	this.shape_5162 = new cjs.Shape();
	this.shape_5162.graphics.f("#000000").s().p("Ag8DeIAAgXQAVAGAQAAQA7gBAAhBIAAluIAZAAIAAFrQAABchUAAQgYAAgNgGg");
	this.shape_5162.setTransform(309.7,421.2,0.5,0.5);

	this.shape_5163 = new cjs.Shape();
	this.shape_5163.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAIgNAKgcIAOgjIhokOIAZAAIA6CYQAcBNAFARIAAAAIBcj2IAZAAIh4E6QgQAogJAMQgLAOgMAGQgNAGgTABQgQAAgQgGg");
	this.shape_5163.setTransform(296.5,424.3,0.5,0.5);

	this.shape_5164 = new cjs.Shape();
	this.shape_5164.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAZQgRgFgSAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_5164.setTransform(286.6,421.1,0.5,0.5);

	this.shape_5165 = new cjs.Shape();
	this.shape_5165.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgnQAggmA1gBQAwABAbAhQAcAiAAA5IAAASIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAPgDAegLIAAAWQgXAKgUAEQgSAEgZgBQg5AAgigkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgVgagkAAQgngBgWAag");
	this.shape_5165.setTransform(273.7,421.2,0.5,0.5);

	this.shape_5166 = new cjs.Shape();
	this.shape_5166.graphics.f("#000000").s().p("AgLCHIhpkNIAaAAIBFC3QAPAjAGAaIABAAQANgpAIgVIBGi2IAZAAIhpENg");
	this.shape_5166.setTransform(260.9,421.2,0.5,0.5);

	this.shape_5167 = new cjs.Shape();
	this.shape_5167.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAYAAAwIAACzIgTAAIgGgqIgCAAQgUAagWALQgVAKgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5167.setTransform(241.2,421.2,0.5,0.5);

	this.shape_5168 = new cjs.Shape();
	this.shape_5168.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdglQAegmA3AAQAcAAAWALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgaAAg+IAAgEQAAg+gVgcQgWgbguAAQgsAAgWAfg");
	this.shape_5168.setTransform(220.3,418.4,0.5,0.5);

	this.shape_5169 = new cjs.Shape();
	this.shape_5169.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgqIgCAAQgUAZgVAMQgWAKgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5169.setTransform(205.9,421.2,0.5,0.5);

	this.shape_5170 = new cjs.Shape();
	this.shape_5170.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgSgTgjAAQgvAAgXAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_5170.setTransform(192.1,418.3,0.5,0.5);

	this.shape_5171 = new cjs.Shape();
	this.shape_5171.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgoQAhgmA1gBQAvABAcAhQAcAigBA5IAAASIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAQgDAdgLIAAAWQgXAKgUAEQgRAEgagBQg5AAgigkgAg2hcQgYAagEAxICmAAQABgvgVgbQgVgagjAAQgngBgXAag");
	this.shape_5171.setTransform(170.9,421.2,0.5,0.5);

	this.shape_5172 = new cjs.Shape();
	this.shape_5172.graphics.f("#000000").s().p("AhzC/IAAgVQAPAEAQAAQANAAAJgGQALgGAHgMQAIgNAKgcIAOgjIhokOIAZAAIA5CYQAZBAAJAeIAAAAQAJgeAZhBIA5iXIAaAAIh4E6QgQApgJALQgKANgNAHQgNAGgTABQgPAAgRgGg");
	this.shape_5172.setTransform(158.1,424.3,0.5,0.5);

	this.shape_5173 = new cjs.Shape();
	this.shape_5173.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5173.setTransform(149.3,418.7,0.5,0.5);

	this.shape_5174 = new cjs.Shape();
	this.shape_5174.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgPAAIiIlPIgCAAQACAcAAAjIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5174.setTransform(135.4,418.9,0.5,0.5);

	this.shape_5175 = new cjs.Shape();
	this.shape_5175.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_5175.setTransform(112.8,418.3,0.5,0.5);

	this.shape_5176 = new cjs.Shape();
	this.shape_5176.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgSgTgjAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAagqBCAAQBdAAgBBjIAACwg");
	this.shape_5176.setTransform(98,421.1,0.5,0.5);

	this.shape_5177 = new cjs.Shape();
	this.shape_5177.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_5177.setTransform(87.6,418.7,0.5,0.5);

	this.shape_5178 = new cjs.Shape();
	this.shape_5178.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAXgLAiAAQBcAAAABiIAACxg");
	this.shape_5178.setTransform(77.2,418.3,0.5,0.5);

	this.shape_5179 = new cjs.Shape();
	this.shape_5179.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogMIANg9IAMAAIAABCIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXABQAZAAAQgFIAAAVQgSAFgYAAQgiABgSgUg");
	this.shape_5179.setTransform(65.2,419.7,0.5,0.5);

	this.shape_5180 = new cjs.Shape();
	this.shape_5180.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_5180.setTransform(51.2,418.9,0.5,0.5);

	this.shape_5181 = new cjs.Shape();
	this.shape_5181.graphics.f("#000000").s().p("AANA+IgDgEQAIgeAMghQAJgZAOggIAQAAQgHAXgIAnQgIAlgEAZgAhBA+IgDgEQAJghALgdQANgkAKgWIAQAAQgJAfgHAgQgIAjgDAag");
	this.shape_5181.setTransform(44.2,412.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_5181},{t:this.shape_5180},{t:this.shape_5179},{t:this.shape_5178},{t:this.shape_5177},{t:this.shape_5176},{t:this.shape_5175},{t:this.shape_5174},{t:this.shape_5173},{t:this.shape_5172},{t:this.shape_5171},{t:this.shape_5170},{t:this.shape_5169},{t:this.shape_5168},{t:this.shape_5167},{t:this.shape_5166},{t:this.shape_5165},{t:this.shape_5164},{t:this.shape_5163},{t:this.shape_5162},{t:this.shape_5161},{t:this.shape_5160},{t:this.shape_5159},{t:this.shape_5158},{t:this.shape_5157},{t:this.shape_5156},{t:this.shape_5155},{t:this.shape_5154},{t:this.shape_5153},{t:this.shape_5152},{t:this.shape_5151},{t:this.shape_5150},{t:this.shape_5149},{t:this.shape_5148},{t:this.shape_5147},{t:this.shape_5146},{t:this.shape_5145},{t:this.shape_5144},{t:this.shape_5143},{t:this.shape_5142},{t:this.shape_5141},{t:this.shape_5140},{t:this.shape_5139},{t:this.shape_5138},{t:this.shape_5137},{t:this.shape_5136},{t:this.shape_5135},{t:this.shape_5134},{t:this.shape_5133},{t:this.shape_5132},{t:this.shape_5131},{t:this.shape_5130},{t:this.shape_5129},{t:this.shape_5128},{t:this.shape_5127},{t:this.shape_5126},{t:this.shape_5125},{t:this.shape_5124},{t:this.shape_5123},{t:this.shape_5122},{t:this.shape_5121},{t:this.shape_5120},{t:this.shape_5119},{t:this.shape_5118},{t:this.shape_5117},{t:this.shape_5116},{t:this.shape_5115},{t:this.shape_5114},{t:this.shape_5113},{t:this.shape_5112},{t:this.shape_5111},{t:this.shape_5110},{t:this.shape_5109},{t:this.shape_5108},{t:this.shape_5107},{t:this.shape_5106},{t:this.shape_5105},{t:this.shape_5104},{t:this.shape_5103},{t:this.shape_5102},{t:this.shape_5101},{t:this.shape_5100},{t:this.instance_23}]},56).to({state:[]},1).wait(108));

	// ButtonLeftRight copy 18
	this.buttonR8 = new lib.ButtonLeft_Right();
	this.buttonR8.name = "buttonR8";
	this.buttonR8.parent = this;
	this.buttonR8.setTransform(2025,513.5,1,1,180);
	this.buttonR8._off = true;
	new cjs.ButtonHelper(this.buttonR8, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR8).wait(55).to({_off:false},0).to({_off:true},1).wait(109));

	// ButtonLeftRight copy 19
	this.buttonL8 = new lib.ButtonLeft_Right();
	this.buttonL8.name = "buttonL8";
	this.buttonL8.parent = this;
	this.buttonL8.setTransform(0,437.2);
	this.buttonL8._off = true;
	new cjs.ButtonHelper(this.buttonL8, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL8).wait(55).to({_off:false},0).to({_off:true},1).wait(109));

	// Layer_20
	this.instance_24 = new lib.handshammersblk();
	this.instance_24.parent = this;
	this.instance_24.setTransform(-46,-30,1.044,1.044);
	this.instance_24._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_24).wait(55).to({_off:false},0).to({_off:true},1).wait(109));

	// ButtonLeftRight copy 16
	this.buttonR7 = new lib.ButtonLeft_Right();
	this.buttonR7.name = "buttonR7";
	this.buttonR7.parent = this;
	this.buttonR7.setTransform(2025,513.5,1,1,180);
	this.buttonR7._off = true;
	new cjs.ButtonHelper(this.buttonR7, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR7).wait(54).to({_off:false},0).to({_off:true},1).wait(110));

	// ButtonLeftRight copy 17
	this.buttonL7 = new lib.ButtonLeft_Right();
	this.buttonL7.name = "buttonL7";
	this.buttonL7.parent = this;
	this.buttonL7.setTransform(0,437.2);
	this.buttonL7._off = true;
	new cjs.ButtonHelper(this.buttonL7, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL7).wait(54).to({_off:false},0).to({_off:true},1).wait(110));

	// Layer 1
	this.instance_25 = new lib.miye();
	this.instance_25.parent = this;
	this.instance_25.setTransform(850,-4);

	this.shape_5182 = new cjs.Shape();
	this.shape_5182.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5182.setTransform(189.2,715,0.5,0.5);

	this.shape_5183 = new cjs.Shape();
	this.shape_5183.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5183.setTransform(182.1,709,0.5,0.5);

	this.shape_5184 = new cjs.Shape();
	this.shape_5184.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5184.setTransform(169.2,709.2,0.5,0.5);

	this.shape_5185 = new cjs.Shape();
	this.shape_5185.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5185.setTransform(159.3,706.7,0.5,0.5);

	this.shape_5186 = new cjs.Shape();
	this.shape_5186.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5186.setTransform(153.6,706.2,0.5,0.5);

	this.shape_5187 = new cjs.Shape();
	this.shape_5187.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5187.setTransform(143.7,709.2,0.5,0.5);

	this.shape_5188 = new cjs.Shape();
	this.shape_5188.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5188.setTransform(132.2,707.6,0.5,0.5);

	this.shape_5189 = new cjs.Shape();
	this.shape_5189.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAPAAICQFtgAgNhjIgzCDICBAAIhBiuQgGAagHARg");
	this.shape_5189.setTransform(120.5,706.8,0.5,0.5);

	this.shape_5190 = new cjs.Shape();
	this.shape_5190.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAxABAbAgQAcAjAAA4IAAATIjDAAQABA4AaAeQAZAdAvAAQAXAAASgDQATgEAYgLIAAAXQgYALgRACQgVAEgWABQg6AAghglgAg3hcQgYAagDAwICnAAQAAgvgVgaQgVgbgkABQgmgBgYAag");
	this.shape_5190.setTransform(99.2,709.2,0.5,0.5);

	this.shape_5191 = new cjs.Shape();
	this.shape_5191.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAWgLAjAAQBcAAgBBhIAACyg");
	this.shape_5191.setTransform(84.8,706.2,0.5,0.5);

	this.shape_5192 = new cjs.Shape();
	this.shape_5192.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5192.setTransform(72.7,707.6,0.5,0.5);

	this.shape_5193 = new cjs.Shape();
	this.shape_5193.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_5193.setTransform(57.6,707.6,0.5,0.5);

	this.shape_5194 = new cjs.Shape();
	this.shape_5194.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5194.setTransform(46.3,709.2,0.5,0.5);

	this.shape_5195 = new cjs.Shape();
	this.shape_5195.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgNAAgWQAAgVgRgOQgRgOgmgNQgngOgQgLQgRgLgIgNQgIgNgBgTQAAgeAagSQAagRAtgBQArABAnAQIgJAWQgogQghAAQghAAgTAKQgTAMAAATQgBAWAPAMQAPANArAPQAkANASAKQAPAJAKAPQAIANAAATQAAAkgbATQgcAVgyAAQg2AAgggRg");
	this.shape_5195.setTransform(766.8,670.9,0.5,0.5);

	this.shape_5196 = new cjs.Shape();
	this.shape_5196.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAIgNAKgaIANgkIhnkOIAaAAIA4CYQAbBFAHAZIAAAAQAKggAZg/IA4iXIAaAAIh5E6QgOAlgKAPQgKANgOAHQgNAHgSAAQgOAAgSgGg");
	this.shape_5196.setTransform(755.1,674,0.5,0.5);

	this.shape_5197 = new cjs.Shape();
	this.shape_5197.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5197.setTransform(742.1,670.9,0.5,0.5);

	this.shape_5198 = new cjs.Shape();
	this.shape_5198.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAdglA3AAQAeAAAWALQAVAKAQAaIACAAQgBgegBgfIAAhhIAZAAIAAGCIgQAAIgHgpIgCAAQgeAug6AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgbQAUgaAAg9IAAgFQAAg+gUgbQgWgbgvAAQgrAAgWAfg");
	this.shape_5198.setTransform(727.8,668.1,0.5,0.5);

	this.shape_5199 = new cjs.Shape();
	this.shape_5199.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAJgGQALgHAHgMQAIgMAKgbIANgkIhnkOIAaAAIA4CYQAaBCAIAcIAAAAQAOgqAVg1IA4iXIAaAAIh4E6QgPAogKAMQgKANgNAHQgOAHgSAAQgOAAgSgGg");
	this.shape_5199.setTransform(708.1,674,0.5,0.5);

	this.shape_5200 = new cjs.Shape();
	this.shape_5200.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5200.setTransform(699.4,668,0.5,0.5);

	this.shape_5201 = new cjs.Shape();
	this.shape_5201.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_5201.setTransform(692.4,670.8,0.5,0.5);

	this.shape_5202 = new cjs.Shape();
	this.shape_5202.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5202.setTransform(679.4,670.9,0.5,0.5);

	this.shape_5203 = new cjs.Shape();
	this.shape_5203.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAbAdAuAAQAYAAAQgDQASgDAbgMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgUgbglABQgmgBgXAag");
	this.shape_5203.setTransform(666.1,670.9,0.5,0.5);

	this.shape_5204 = new cjs.Shape();
	this.shape_5204.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5204.setTransform(648.4,670.8,0.5,0.5);

	this.shape_5205 = new cjs.Shape();
	this.shape_5205.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_5205.setTransform(639.7,668.4,0.5,0.5);

	this.shape_5206 = new cjs.Shape();
	this.shape_5206.graphics.f("#000000").s().p("AhNBoQghglAAhBQAAg/AggnQAhgoA1AAQAvABAcAgQAcAigBA5IAAATIjCAAQACA4AYAeQAaAdAuAAQAZAAAQgDQATgDAagMIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgvgVgaQgUgbgkABQgngBgXAag");
	this.shape_5206.setTransform(629.8,670.9,0.5,0.5);

	this.shape_5207 = new cjs.Shape();
	this.shape_5207.graphics.f("#000000").s().p("ABTDCIAAiwQAAgogSgSQgRgTgkAAQgvAAgYAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAQgZAWgKQAXgLAhAAQBdAAAABhIAACyg");
	this.shape_5207.setTransform(615.3,668,0.5,0.5);

	this.shape_5208 = new cjs.Shape();
	this.shape_5208.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_5208.setTransform(603.3,669.4,0.5,0.5);

	this.shape_5209 = new cjs.Shape();
	this.shape_5209.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5209.setTransform(585.1,670.8,0.5,0.5);

	this.shape_5210 = new cjs.Shape();
	this.shape_5210.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5210.setTransform(574.6,668.4,0.5,0.5);

	this.shape_5211 = new cjs.Shape();
	this.shape_5211.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5211.setTransform(562.2,668,0.5,0.5);

	this.shape_5212 = new cjs.Shape();
	this.shape_5212.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA1AAQAvABAcAgQAcAigBA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAZAAAPgDQATgDAagMIAAAXQgaALgRACQgUAEgWABQg6AAgiglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbgkABQgmgBgYAag");
	this.shape_5212.setTransform(552.4,670.9,0.5,0.5);

	this.shape_5213 = new cjs.Shape();
	this.shape_5213.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5213.setTransform(537.9,668,0.5,0.5);

	this.shape_5214 = new cjs.Shape();
	this.shape_5214.graphics.f("#000000").s().p("Ag/BoQgiglAAhCQAAhBAigmQAjgmA6AAQAkAAAgANIgIAVQghgLgcAAQgwAAgaAeQgZAfgBA5QABA3AZAfQAaAfAtAAQAlAAAggNIAAAWQgbAOgqAAQg5gBgggkg");
	this.shape_5214.setTransform(524.6,670.9,0.5,0.5);

	this.shape_5215 = new cjs.Shape();
	this.shape_5215.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5215.setTransform(515.3,668.4,0.5,0.5);

	this.shape_5216 = new cjs.Shape();
	this.shape_5216.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5216.setTransform(501.4,668.6,0.5,0.5);

	this.shape_5217 = new cjs.Shape();
	this.shape_5217.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAdglA3AAQAeAAAVALQAWAKAQAaIACAAQgBgegBgfIAAhhIAZAAIAAGCIgQAAIgHgpIgCAAQgeAug6AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAuAAAWgbQAUgaAAg9IAAgFQAAg+gUgbQgWgbgvAAQgrAAgWAfg");
	this.shape_5217.setTransform(475.8,668.1,0.5,0.5);

	this.shape_5218 = new cjs.Shape();
	this.shape_5218.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5218.setTransform(461.2,670.8,0.5,0.5);

	this.shape_5219 = new cjs.Shape();
	this.shape_5219.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5219.setTransform(446.4,670.9,0.5,0.5);

	this.shape_5220 = new cjs.Shape();
	this.shape_5220.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgQgOQgSgOglgNQgogOgQgLQgRgKgIgOQgIgNAAgTQgBgeAagSQAagRAtgBQArABAoAQIgJAWQgpgQghAAQggAAgUAKQgTAMAAATQAAAWAOAMQAPANAsAPQAiAMATALQARALAIANQAIANAAATQAAAkgcATQgbAVgyAAQg2AAgggRg");
	this.shape_5220.setTransform(427.4,670.9,0.5,0.5);

	this.shape_5221 = new cjs.Shape();
	this.shape_5221.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_5221.setTransform(414.1,670.8,0.5,0.5);

	this.shape_5222 = new cjs.Shape();
	this.shape_5222.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_5222.setTransform(403.7,668.4,0.5,0.5);

	this.shape_5223 = new cjs.Shape();
	this.shape_5223.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_5223.setTransform(395.7,668,0.5,0.5);

	this.shape_5224 = new cjs.Shape();
	this.shape_5224.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5224.setTransform(384,669.4,0.5,0.5);

	this.shape_5225 = new cjs.Shape();
	this.shape_5225.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5225.setTransform(372.7,670.9,0.5,0.5);

	this.shape_5226 = new cjs.Shape();
	this.shape_5226.graphics.f("#000000").s().p("ABdC2IhelRQgDATgIAfIhQEfIgWAAIhklrIAbAAIBREvIAEAUQAGgjAThEIA/jcIAbAAIBJD8QANAtAFAaIBVlDIAaAAIhlFrg");
	this.shape_5226.setTransform(355,668.6,0.5,0.5);

	this.shape_5227 = new cjs.Shape();
	this.shape_5227.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5227.setTransform(329.5,670.9,0.5,0.5);

	this.shape_5228 = new cjs.Shape();
	this.shape_5228.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_5228.setTransform(317.6,669.4,0.5,0.5);

	this.shape_5229 = new cjs.Shape();
	this.shape_5229.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5229.setTransform(299.5,670.8,0.5,0.5);

	this.shape_5230 = new cjs.Shape();
	this.shape_5230.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5230.setTransform(284.4,670.9,0.5,0.5);

	this.shape_5231 = new cjs.Shape();
	this.shape_5231.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_5231.setTransform(274.1,668.4,0.5,0.5);

	this.shape_5232 = new cjs.Shape();
	this.shape_5232.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5232.setTransform(266.7,669.4,0.5,0.5);

	this.shape_5233 = new cjs.Shape();
	this.shape_5233.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5233.setTransform(255.4,670.9,0.5,0.5);

	this.shape_5234 = new cjs.Shape();
	this.shape_5234.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5234.setTransform(245,670.8,0.5,0.5);

	this.shape_5235 = new cjs.Shape();
	this.shape_5235.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5235.setTransform(236.3,668.4,0.5,0.5);

	this.shape_5236 = new cjs.Shape();
	this.shape_5236.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAlg0AAQg9AAgegvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAbQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_5236.setTransform(226.2,673.8,0.5,0.5);

	this.shape_5237 = new cjs.Shape();
	this.shape_5237.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgRgKgIgOQgIgMAAgUQAAgeAZgSQAagRAsgBQAsABAoAQIgKAWQgogQgiAAQggAAgTAKQgUAMAAATQAAAVAQANQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAVgzAAQg1AAghgRg");
	this.shape_5237.setTransform(212.2,670.9,0.5,0.5);

	this.shape_5238 = new cjs.Shape();
	this.shape_5238.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5238.setTransform(198.9,670.8,0.5,0.5);

	this.shape_5239 = new cjs.Shape();
	this.shape_5239.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_5239.setTransform(188.5,668.4,0.5,0.5);

	this.shape_5240 = new cjs.Shape();
	this.shape_5240.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5240.setTransform(174.5,669.4,0.5,0.5);

	this.shape_5241 = new cjs.Shape();
	this.shape_5241.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5241.setTransform(163.2,670.9,0.5,0.5);

	this.shape_5242 = new cjs.Shape();
	this.shape_5242.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5242.setTransform(149.9,670.9,0.5,0.5);

	this.shape_5243 = new cjs.Shape();
	this.shape_5243.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5243.setTransform(138.8,670.8,0.5,0.5);

	this.shape_5244 = new cjs.Shape();
	this.shape_5244.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgKgMgUQgOgUAAgcQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAmgaAZQgaAYgrAAQgSAAgIgBQgOAIgIAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgkAXg+AAQgzAAgdgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQAUARAfAAQAiAAARgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgSATg");
	this.shape_5244.setTransform(126.3,673.8,0.5,0.5);

	this.shape_5245 = new cjs.Shape();
	this.shape_5245.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgeAAgMARQgKARAAAmIAAAZIA+AAIAAAWIg+AAIAAD4g");
	this.shape_5245.setTransform(110.1,667.9,0.5,0.5);

	this.shape_5246 = new cjs.Shape();
	this.shape_5246.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5246.setTransform(97.9,670.9,0.5,0.5);

	this.shape_5247 = new cjs.Shape();
	this.shape_5247.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgKAWQgogQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5247.setTransform(77.8,670.9,0.5,0.5);

	this.shape_5248 = new cjs.Shape();
	this.shape_5248.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5248.setTransform(64.7,670.9,0.5,0.5);

	this.shape_5249 = new cjs.Shape();
	this.shape_5249.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAPA5AFAdIABAAQAQg+AGgQIA4ikIAVAAIA1CkQATA/ADAPIABAAQADgTARhEIAqibIAZAAIhKEOg");
	this.shape_5249.setTransform(49.2,670.9,0.5,0.5);

	this.shape_5250 = new cjs.Shape();
	this.shape_5250.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAYAAAQgDQASgDAbgMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgUgbglABQgmgBgXAag");
	this.shape_5250.setTransform(761.5,632.7,0.5,0.5);

	this.shape_5251 = new cjs.Shape();
	this.shape_5251.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5251.setTransform(747,629.7,0.5,0.5);

	this.shape_5252 = new cjs.Shape();
	this.shape_5252.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQAsABAnAQIgJAWQgpgQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAkgbATQgcAVgyAAQg1AAghgRg");
	this.shape_5252.setTransform(733.4,632.7,0.5,0.5);

	this.shape_5253 = new cjs.Shape();
	this.shape_5253.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgRA+gZA5g");
	this.shape_5253.setTransform(717.8,639.6,0.5,0.5);

	this.shape_5254 = new cjs.Shape();
	this.shape_5254.graphics.f("#000000").s().p("AhMBoQgiglABhBQgBhAAggmQAggoA1AAQAwABAbAgQAcAjABA4IAAATIjCAAQAAA3AaAfQAZAdAvAAQAYAAAQgDQASgDAagMIAAAXQgYALgRACQgVAEgWABQg6AAghglgAg3hcQgYAagDAwICmAAQAAgvgUgaQgVgbgkABQgmgBgYAag");
	this.shape_5254.setTransform(708.5,632.7,0.5,0.5);

	this.shape_5255 = new cjs.Shape();
	this.shape_5255.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_5255.setTransform(697.4,632.5,0.5,0.5);

	this.shape_5256 = new cjs.Shape();
	this.shape_5256.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOghAAgpQAAhCAggkQAggmA3AAQA4AAAgAmQAgAmAABAQAABBggAmQggAmg4AAQgjAAgcgSgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg2gZghQgZgegsAAQgsAAgZAeg");
	this.shape_5256.setTransform(684.1,632.7,0.5,0.5);

	this.shape_5257 = new cjs.Shape();
	this.shape_5257.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgTQgQgSggAAQgpABgUAWQgUAYAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA2IAACVIgZAAIAAkOIAUAAIAGAlIABAAQAMgUAUgLQAUgLAZAAQBBAAARAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_5257.setTransform(665.4,632.5,0.5,0.5);

	this.shape_5258 = new cjs.Shape();
	this.shape_5258.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAdAAAtIAACVg");
	this.shape_5258.setTransform(650,632.5,0.5,0.5);

	this.shape_5259 = new cjs.Shape();
	this.shape_5259.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvABAcAgQAcAigBA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAZAAARgDQASgDAagMIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgvgVgaQgUgbgkABQgngBgXAag");
	this.shape_5259.setTransform(637.2,632.7,0.5,0.5);

	this.shape_5260 = new cjs.Shape();
	this.shape_5260.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAPgZAXgKQAXgLAhAAQBcAAAABhIAACyg");
	this.shape_5260.setTransform(622.7,629.7,0.5,0.5);

	this.shape_5261 = new cjs.Shape();
	this.shape_5261.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5261.setTransform(610.7,631.1,0.5,0.5);

	this.shape_5262 = new cjs.Shape();
	this.shape_5262.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAdAAAtIAACVg");
	this.shape_5262.setTransform(602.5,632.5,0.5,0.5);

	this.shape_5263 = new cjs.Shape();
	this.shape_5263.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARASAkABQAvAAAXgZQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAAAhjg");
	this.shape_5263.setTransform(589.1,632.8,0.5,0.5);

	this.shape_5264 = new cjs.Shape();
	this.shape_5264.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACbICjAAIAAAWIijAAIAACjg");
	this.shape_5264.setTransform(576.4,630.3,0.5,0.5);

	this.shape_5265 = new cjs.Shape();
	this.shape_5265.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5265.setTransform(559.2,638.5,0.5,0.5);

	this.shape_5266 = new cjs.Shape();
	this.shape_5266.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgQAngJANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_5266.setTransform(550.3,635.7,0.5,0.5);

	this.shape_5267 = new cjs.Shape();
	this.shape_5267.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5267.setTransform(540.4,632.5,0.5,0.5);

	this.shape_5268 = new cjs.Shape();
	this.shape_5268.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_5268.setTransform(531.6,629.7,0.5,0.5);

	this.shape_5269 = new cjs.Shape();
	this.shape_5269.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA1AAQAvABAcAgQAcAigBA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAZAAAQgDQATgDAagMIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgvgVgaQgUgbgkABQgngBgXAag");
	this.shape_5269.setTransform(521.8,632.7,0.5,0.5);

	this.shape_5270 = new cjs.Shape();
	this.shape_5270.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAPA5AFAdIABAAQAQg+AGgQIA4ikIAVAAIA1CkQASA9AEARIABAAQADgTARhEIAqibIAZAAIhKEOg");
	this.shape_5270.setTransform(505.5,632.7,0.5,0.5);

	this.shape_5271 = new cjs.Shape();
	this.shape_5271.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAwABAbAgQAcAjABA4IAAATIjCAAQAAA3AaAfQAZAdAvAAQAYAAAQgDQASgDAagMIAAAXQgZALgQACQgWAEgVABQg6AAghglgAg3hcQgXAZgEAxICmAAQAAgvgUgaQgVgbgkABQgmgBgYAag");
	this.shape_5271.setTransform(489.3,632.7,0.5,0.5);

	this.shape_5272 = new cjs.Shape();
	this.shape_5272.graphics.f("#000000").s().p("AgwDwIAAgWQAQAFAQAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAhgQATQgQASgcAAQgTAAgOgGgAARjdQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgQAAAAgYg");
	this.shape_5272.setTransform(477.8,633.2,0.5,0.5);

	this.shape_5273 = new cjs.Shape();
	this.shape_5273.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAVAAAXAHIgFAVQgUgGgUAAQgcAAgMARQgMARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5273.setTransform(467,629.7,0.5,0.5);

	this.shape_5274 = new cjs.Shape();
	this.shape_5274.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5274.setTransform(454.8,632.7,0.5,0.5);

	this.shape_5275 = new cjs.Shape();
	this.shape_5275.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgKAWQgogQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5275.setTransform(434.7,632.7,0.5,0.5);

	this.shape_5276 = new cjs.Shape();
	this.shape_5276.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvABAcAgQAbAjAAA4IAAATIjCAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgDAbgMIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgbgjABQgngBgXAag");
	this.shape_5276.setTransform(421.9,632.7,0.5,0.5);

	this.shape_5277 = new cjs.Shape();
	this.shape_5277.graphics.f("#000000").s().p("Ag/BoQgiglAAhCQABhBAigmQAigmA6AAQAjAAAhANIgHAVQghgLgdAAQgwAAgaAeQgaAfABA5QgBA3AaAfQAaAfAtAAQAlAAAfgNIAAAWQgbAOgoAAQg5gBghgkg");
	this.shape_5277.setTransform(409.1,632.7,0.5,0.5);

	this.shape_5278 = new cjs.Shape();
	this.shape_5278.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5278.setTransform(395.7,632.7,0.5,0.5);

	this.shape_5279 = new cjs.Shape();
	this.shape_5279.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5279.setTransform(385.9,630.2,0.5,0.5);

	this.shape_5280 = new cjs.Shape();
	this.shape_5280.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAmIABAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAlg0AAQg9AAgdgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA+AVAbQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_5280.setTransform(375.8,635.6,0.5,0.5);

	this.shape_5281 = new cjs.Shape();
	this.shape_5281.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAdglA4AAQAdAAAVALQAVAKASAaIACAAQgCgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5281.setTransform(353.2,629.9,0.5,0.5);

	this.shape_5282 = new cjs.Shape();
	this.shape_5282.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5282.setTransform(338.6,632.5,0.5,0.5);

	this.shape_5283 = new cjs.Shape();
	this.shape_5283.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_5283.setTransform(328.1,630.2,0.5,0.5);

	this.shape_5284 = new cjs.Shape();
	this.shape_5284.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqByIBzCcg");
	this.shape_5284.setTransform(320.1,629.7,0.5,0.5);

	this.shape_5285 = new cjs.Shape();
	this.shape_5285.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_5285.setTransform(308.7,632.5,0.5,0.5);

	this.shape_5286 = new cjs.Shape();
	this.shape_5286.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5286.setTransform(297.4,632.7,0.5,0.5);

	this.shape_5287 = new cjs.Shape();
	this.shape_5287.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_5287.setTransform(287,632.5,0.5,0.5);

	this.shape_5288 = new cjs.Shape();
	this.shape_5288.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgyATgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgeAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5288.setTransform(280,629.7,0.5,0.5);

	this.shape_5289 = new cjs.Shape();
	this.shape_5289.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABBggAmQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_5289.setTransform(267.8,632.7,0.5,0.5);

	this.shape_5290 = new cjs.Shape();
	this.shape_5290.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_5290.setTransform(256.2,632.5,0.5,0.5);

	this.shape_5291 = new cjs.Shape();
	this.shape_5291.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAYAAAQgDQASgDAbgMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgUgbglABQgmgBgXAag");
	this.shape_5291.setTransform(245.1,632.7,0.5,0.5);

	this.shape_5292 = new cjs.Shape();
	this.shape_5292.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5292.setTransform(230.7,632.5,0.5,0.5);

	this.shape_5293 = new cjs.Shape();
	this.shape_5293.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOghAAgpQAAhCAggkQAggmA3AAQA4AAAgAmQAgAmAABAQAABBggAmQggAmg4AAQgjAAgcgSgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg2gZghQgZgegsAAQgsAAgZAeg");
	this.shape_5293.setTransform(215.6,632.7,0.5,0.5);

	this.shape_5294 = new cjs.Shape();
	this.shape_5294.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_5294.setTransform(194.1,632.5,0.5,0.5);

	this.shape_5295 = new cjs.Shape();
	this.shape_5295.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAAMgFAFQgEAHgHAAQgPAAAAgYg");
	this.shape_5295.setTransform(183.6,630.2,0.5,0.5);

	this.shape_5296 = new cjs.Shape();
	this.shape_5296.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQALgHAHgMQAJgQAJgXIAOgkIhokOIAZAAIA5CYQAbBFAGAZIABAAQALggAXg/IA5iXIAaAAIh4E6QgPAlgKAPQgJAMgOAIQgOAHgSAAQgOAAgSgGg");
	this.shape_5296.setTransform(168.3,635.7,0.5,0.5);

	this.shape_5297 = new cjs.Shape();
	this.shape_5297.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQABAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgTAGgXAAQgiAAgSgUg");
	this.shape_5297.setTransform(158,631.1,0.5,0.5);

	this.shape_5298 = new cjs.Shape();
	this.shape_5298.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5298.setTransform(151,630.2,0.5,0.5);

	this.shape_5299 = new cjs.Shape();
	this.shape_5299.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvABAbAgQAcAjAAA4IAAATIjBAAQAAA3AZAfQAaAdAvAAQAYAAAQgDQASgDAagMIAAAXQgYALgSACQgUAEgWABQg6AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgbgjABQgmgBgYAag");
	this.shape_5299.setTransform(141.1,632.7,0.5,0.5);

	this.shape_5300 = new cjs.Shape();
	this.shape_5300.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_5300.setTransform(126.7,632.5,0.5,0.5);

	this.shape_5301 = new cjs.Shape();
	this.shape_5301.graphics.f("#000000").s().p("AhPB4QgWgVABgkQAAgnAggWQAhgVA+gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgFgrIgDAAQgUAagVALQgYALgbAAQgnAAgXgUgAAeAAQg3ACgaAPQgYAPABAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_5301.setTransform(111.9,632.7,0.5,0.5);

	this.shape_5302 = new cjs.Shape();
	this.shape_5302.graphics.f("#000000").s().p("AgSCXQgQgSgBgqIAAiuIgnAAIAAgOIAngLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQgBAfAKAPQAMAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgSgUg");
	this.shape_5302.setTransform(101.1,631.1,0.5,0.5);

	this.shape_5303 = new cjs.Shape();
	this.shape_5303.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBdAAgBBjIAACwg");
	this.shape_5303.setTransform(89.6,632.5,0.5,0.5);

	this.shape_5304 = new cjs.Shape();
	this.shape_5304.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5304.setTransform(74.5,632.7,0.5,0.5);

	this.shape_5305 = new cjs.Shape();
	this.shape_5305.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAmIABAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAlg0AAQg9AAgdgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA+AVAbQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_5305.setTransform(59.8,635.6,0.5,0.5);

	this.shape_5306 = new cjs.Shape();
	this.shape_5306.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgKAWQgogQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5306.setTransform(45.8,632.7,0.5,0.5);

	this.shape_5307 = new cjs.Shape();
	this.shape_5307.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5307.setTransform(695.1,591.4,0.5,0.5);

	this.shape_5308 = new cjs.Shape();
	this.shape_5308.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5308.setTransform(682.9,594.4,0.5,0.5);

	this.shape_5309 = new cjs.Shape();
	this.shape_5309.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcARgTQATgSAcgHQgLgFgIgKQgHgJAAgNQAAgaAigVQgXgJgOgVQgNgUABgcQAAgoAZgZQAagYArAAQAbAAAOAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgSAAgIgBQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAvAAQAqAAAZASQAXASAAAjQAAArgjAXQgiAXhAAAQgyAAgdgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgAUARQASARAgAAQAhAAASgRQASgRAAghQAAgjgTgRQgRgRgiAAQggAAgSATg");
	this.shape_5309.setTransform(662.2,597.3,0.5,0.5);

	this.shape_5310 = new cjs.Shape();
	this.shape_5310.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5310.setTransform(648.1,594.3,0.5,0.5);

	this.shape_5311 = new cjs.Shape();
	this.shape_5311.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAAMgFAFQgDAHgIAAQgPAAAAgYg");
	this.shape_5311.setTransform(637.6,591.9,0.5,0.5);

	this.shape_5312 = new cjs.Shape();
	this.shape_5312.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5312.setTransform(631.8,591.5,0.5,0.5);

	this.shape_5313 = new cjs.Shape();
	this.shape_5313.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAxABAbAgQAbAjABA4IAAATIjDAAQABA4AZAeQAaAdAuAAQAYAAASgDQATgEAYgLIAAAXQgYALgRACQgWAEgWABQg5AAghglgAg3hcQgXAagEAwICnAAQAAgvgVgaQgUgbglABQgmgBgYAag");
	this.shape_5313.setTransform(622,594.4,0.5,0.5);

	this.shape_5314 = new cjs.Shape();
	this.shape_5314.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggoA0AAQAxABAbAgQAcAiAAA5IAAATIjDAAQABA4AaAeQAZAdAuAAQAZAAAQgDQATgDAagMIAAAXQgaALgQACQgVAEgXABQg5AAghglgAg3hcQgYAagDAwICnAAQgBgvgUgaQgUgbglABQgmgBgYAag");
	this.shape_5314.setTransform(608,594.4,0.5,0.5);

	this.shape_5315 = new cjs.Shape();
	this.shape_5315.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgdAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5315.setTransform(598,591.4,0.5,0.5);

	this.shape_5316 = new cjs.Shape();
	this.shape_5316.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_5316.setTransform(583.8,591.5,0.5,0.5);

	this.shape_5317 = new cjs.Shape();
	this.shape_5317.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5317.setTransform(573.7,594.4,0.5,0.5);

	this.shape_5318 = new cjs.Shape();
	this.shape_5318.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5318.setTransform(560,594.3,0.5,0.5);

	this.shape_5319 = new cjs.Shape();
	this.shape_5319.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAggmA4AAQA4AAAfAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_5319.setTransform(544.9,594.4,0.5,0.5);

	this.shape_5320 = new cjs.Shape();
	this.shape_5320.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5320.setTransform(534.6,591.9,0.5,0.5);

	this.shape_5321 = new cjs.Shape();
	this.shape_5321.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5321.setTransform(527.2,592.9,0.5,0.5);

	this.shape_5322 = new cjs.Shape();
	this.shape_5322.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAhgkQAfgmA4AAQA4AAAfAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_5322.setTransform(515.6,594.4,0.5,0.5);

	this.shape_5323 = new cjs.Shape();
	this.shape_5323.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgTQgQgSggAAQgpABgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAYAAA3IAACVIgZAAIAAkOIAUAAIAGAlIABAAQALgTAVgMQAUgLAZAAQBBAAARAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_5323.setTransform(497,594.3,0.5,0.5);

	this.shape_5324 = new cjs.Shape();
	this.shape_5324.graphics.f("#000000").s().p("AhNBoQghglAAhBQAAhAAhgmQAfgoA1AAQAwABAcAgQAbAjABA4IAAATIjDAAQABA4AZAeQAaAdAuAAQAYAAASgDQASgEAagLIAAAXQgaALgRACQgVAEgWABQg5AAgiglgAg3hcQgXAagEAwICmAAQABgvgVgaQgUgbglABQglgBgZAag");
	this.shape_5324.setTransform(478.7,594.4,0.5,0.5);

	this.shape_5325 = new cjs.Shape();
	this.shape_5325.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAdglA4AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5325.setTransform(457.1,591.6,0.5,0.5);

	this.shape_5326 = new cjs.Shape();
	this.shape_5326.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_5326.setTransform(442.4,594.3,0.5,0.5);

	this.shape_5327 = new cjs.Shape();
	this.shape_5327.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_5327.setTransform(427.6,594.4,0.5,0.5);

	this.shape_5328 = new cjs.Shape();
	this.shape_5328.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhCAiglQAigmA6AAQAkAAAfANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAbAfAsAAQAlAAAfgNIAAAWQgaAOgpAAQg6gBghgkg");
	this.shape_5328.setTransform(408.9,594.4,0.5,0.5);

	this.shape_5329 = new cjs.Shape();
	this.shape_5329.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_5329.setTransform(399.7,591.9,0.5,0.5);

	this.shape_5330 = new cjs.Shape();
	this.shape_5330.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_5330.setTransform(385.6,594.3,0.5,0.5);

	this.shape_5331 = new cjs.Shape();
	this.shape_5331.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_5331.setTransform(367.1,594.4,0.5,0.5);

	this.shape_5332 = new cjs.Shape();
	this.shape_5332.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5332.setTransform(353.4,594.3,0.5,0.5);

	this.shape_5333 = new cjs.Shape();
	this.shape_5333.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAKgHAHgMQAJgNAJgaIANgkIhnkOIAaAAIA5CYQAaBFAHAZIAAAAQALggAYg/IA5iXIAZAAIh5E6QgNAlgLAPQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_5333.setTransform(339.9,597.5,0.5,0.5);

	this.shape_5334 = new cjs.Shape();
	this.shape_5334.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAdglA4AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5334.setTransform(326.1,591.6,0.5,0.5);

	this.shape_5335 = new cjs.Shape();
	this.shape_5335.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5335.setTransform(305,594.4,0.5,0.5);

	this.shape_5336 = new cjs.Shape();
	this.shape_5336.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAmIACAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA/AWAaQAVAcAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_5336.setTransform(284.9,597.3,0.5,0.5);

	this.shape_5337 = new cjs.Shape();
	this.shape_5337.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5337.setTransform(269.5,594.4,0.5,0.5);

	this.shape_5338 = new cjs.Shape();
	this.shape_5338.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5338.setTransform(259.1,591.5,0.5,0.5);

	this.shape_5339 = new cjs.Shape();
	this.shape_5339.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5339.setTransform(249.2,594.4,0.5,0.5);

	this.shape_5340 = new cjs.Shape();
	this.shape_5340.graphics.f("#000000").s().p("AgLCHIhpkOIAaAAIBGC3QAMAiAIAcIABAAQAKgiALgcIBFi3IAaAAIhoEOg");
	this.shape_5340.setTransform(236.4,594.4,0.5,0.5);

	this.shape_5341 = new cjs.Shape();
	this.shape_5341.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgDAagMIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5341.setTransform(223.5,594.4,0.5,0.5);

	this.shape_5342 = new cjs.Shape();
	this.shape_5342.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAdglA4AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgbQAVgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5342.setTransform(208.5,591.6,0.5,0.5);

	this.shape_5343 = new cjs.Shape();
	this.shape_5343.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5343.setTransform(187.3,594.4,0.5,0.5);

	this.shape_5344 = new cjs.Shape();
	this.shape_5344.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_5344.setTransform(175.3,592.9,0.5,0.5);

	this.shape_5345 = new cjs.Shape();
	this.shape_5345.graphics.f("#000000").s().p("AgdA/QAUhJAHg0IAdAAIADAGQgSA/gZA4g");
	this.shape_5345.setTransform(161.5,601.3,0.5,0.5);

	this.shape_5346 = new cjs.Shape();
	this.shape_5346.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAdglA4AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5346.setTransform(151.2,591.6,0.5,0.5);

	this.shape_5347 = new cjs.Shape();
	this.shape_5347.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAhgkQAfgmA4AAQA4AAAfAmQAgAlAABBQAABCggAlQggAmg4AAQgjAAgcgSgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_5347.setTransform(136.5,594.4,0.5,0.5);

	this.shape_5348 = new cjs.Shape();
	this.shape_5348.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5348.setTransform(126.2,591.9,0.5,0.5);

	this.shape_5349 = new cjs.Shape();
	this.shape_5349.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5349.setTransform(119.2,594.3,0.5,0.5);

	this.shape_5350 = new cjs.Shape();
	this.shape_5350.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAfgmQAggoA2AAQAvABAcAgQAcAjAAA4IAAATIjDAAQAAA3AaAfQAaAdAuAAQAZAAAQgDQASgDAbgMIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgVgbgjABQgngBgXAag");
	this.shape_5350.setTransform(106.4,594.4,0.5,0.5);

	this.shape_5351 = new cjs.Shape();
	this.shape_5351.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAmIABAAQAcgrA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAlg0AAQg9AAgdgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA+AVAbQAVAcAvAAQApAAAYgfQAWgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_5351.setTransform(92.1,597.3,0.5,0.5);

	this.shape_5352 = new cjs.Shape();
	this.shape_5352.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgmQAggoA1AAQAxABAbAgQAbAjAAA4IAAATIjBAAQABA4AZAeQAZAdAvAAQAYAAAQgDQAUgEAYgLIAAAXQgZALgQACQgWAEgVABQg6AAghglgAg3hcQgXAagEAwICnAAQgBgvgUgaQgVgbgkABQglgBgZAag");
	this.shape_5352.setTransform(70.6,594.4,0.5,0.5);

	this.shape_5353 = new cjs.Shape();
	this.shape_5353.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAWgLAjAAQBbAAABBhIAACyg");
	this.shape_5353.setTransform(56.1,591.5,0.5,0.5);

	this.shape_5354 = new cjs.Shape();
	this.shape_5354.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5354.setTransform(44.1,592.9,0.5,0.5);

	this.shape_5355 = new cjs.Shape();
	this.shape_5355.graphics.f("#000000").s().p("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");
	this.shape_5355.setTransform(362.3,556.2,0.5,0.5);

	this.shape_5356 = new cjs.Shape();
	this.shape_5356.graphics.f("#000000").s().p("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");
	this.shape_5356.setTransform(384.2,518,0.5,0.5);

	this.shape_5357 = new cjs.Shape();
	this.shape_5357.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5357.setTransform(513.8,447.2,0.5,0.5);

	this.shape_5358 = new cjs.Shape();
	this.shape_5358.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABBggAmQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_5358.setTransform(503.3,441.4,0.5,0.5);

	this.shape_5359 = new cjs.Shape();
	this.shape_5359.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_5359.setTransform(493,438.9,0.5,0.5);

	this.shape_5360 = new cjs.Shape();
	this.shape_5360.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAdglA4AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5360.setTransform(482.1,438.6,0.5,0.5);

	this.shape_5361 = new cjs.Shape();
	this.shape_5361.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAAqARASQARASAkABQAvAAAXgZQAXgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAABhjg");
	this.shape_5361.setTransform(467.3,441.5,0.5,0.5);

	this.shape_5362 = new cjs.Shape();
	this.shape_5362.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5362.setTransform(455.4,439.9,0.5,0.5);

	this.shape_5363 = new cjs.Shape();
	this.shape_5363.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgRgKgIgOQgIgMAAgUQAAgeAZgSQAagRAsgBQAsABAoAQIgKAWQgogQgiAAQggAAgTAKQgUAMAAATQAAAWAQAMQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAVgzAAQg1AAghgRg");
	this.shape_5363.setTransform(445.3,441.4,0.5,0.5);

	this.shape_5364 = new cjs.Shape();
	this.shape_5364.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAfgmQAggoA1AAQAwABAcAgQAcAjgBA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgVgbgkABQgmgBgXAag");
	this.shape_5364.setTransform(425.9,441.4,0.5,0.5);

	this.shape_5365 = new cjs.Shape();
	this.shape_5365.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIADAAQAPgZAXgKQAWgLAiAAQBcAAAABhIAACyg");
	this.shape_5365.setTransform(411.4,438.5,0.5,0.5);

	this.shape_5366 = new cjs.Shape();
	this.shape_5366.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5366.setTransform(399.4,439.9,0.5,0.5);

	this.shape_5367 = new cjs.Shape();
	this.shape_5367.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5367.setTransform(385.7,438.4,0.5,0.5);

	this.shape_5368 = new cjs.Shape();
	this.shape_5368.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5368.setTransform(373.5,441.4,0.5,0.5);

	this.shape_5369 = new cjs.Shape();
	this.shape_5369.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAARADIgEAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5369.setTransform(355.4,441.3,0.5,0.5);

	this.shape_5370 = new cjs.Shape();
	this.shape_5370.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggoA0AAQAxABAbAgQAbAiABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAYAAASgDQASgEAagLIAAAXQgaALgQACQgWAEgWABQg5AAghglgAg3hcQgXAagEAwICnAAQAAgugVgbQgUgbglABQgmgBgYAag");
	this.shape_5370.setTransform(342.5,441.4,0.5,0.5);

	this.shape_5371 = new cjs.Shape();
	this.shape_5371.graphics.f("#000000").s().p("ABTCKIAAivQgBgpgRgSQgRgSgkgBQgvAAgXAZQgXAYAAA3IAACVIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_5371.setTransform(328.1,441.3,0.5,0.5);

	this.shape_5372 = new cjs.Shape();
	this.shape_5372.graphics.f("#000000").s().p("ABNCHIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAOA3AGAfIACAAQAOg6AHgUIA4ikIAVAAIA1CkQAQAyAGAcIACAAQABgOAThJIApibIAZAAIhKEOg");
	this.shape_5372.setTransform(311.2,441.4,0.5,0.5);

	this.shape_5373 = new cjs.Shape();
	this.shape_5373.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOggAAgqQAAhCAggkQAggmA3AAQA4AAAgAmQAgAmAABAQAABBghAmQgfAmg4AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_5373.setTransform(294.6,441.4,0.5,0.5);

	this.shape_5374 = new cjs.Shape();
	this.shape_5374.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAg/AggnQAhgoA0AAQAwABAcAgQAcAjAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgZALgSACQgUAEgXABQg5AAgiglgAg3hcQgXAZgEAxICmAAQAAgwgUgZQgUgbglABQgmgBgYAag");
	this.shape_5374.setTransform(273.5,441.4,0.5,0.5);

	this.shape_5375 = new cjs.Shape();
	this.shape_5375.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5375.setTransform(263.6,438.5,0.5,0.5);

	this.shape_5376 = new cjs.Shape();
	this.shape_5376.graphics.f("#000000").s().p("Ag+B7QgbgRgPggQgPghAAgpQAAhCAhgkQAggmA3AAQA4AAAfAmQAgAmAABAQAABBghAmQgfAmg4AAQgjgBgbgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgXAeg");
	this.shape_5376.setTransform(253.2,441.4,0.5,0.5);

	this.shape_5377 = new cjs.Shape();
	this.shape_5377.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgRgKgIgOQgJgNABgTQAAgeAZgSQAagRAsgBQAtABAnAQIgJAWQgpgQgiAAQgfAAgUAKQgTAMgBATQAAAWAPAMQAPANAsAPQAiAMATALQARALAIANQAIANAAATQAAAkgcATQgbAVgyAAQg1AAghgRg");
	this.shape_5377.setTransform(239.7,441.4,0.5,0.5);

	this.shape_5378 = new cjs.Shape();
	this.shape_5378.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5378.setTransform(220.3,441.4,0.5,0.5);

	this.shape_5379 = new cjs.Shape();
	this.shape_5379.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5379.setTransform(205.8,438.5,0.5,0.5);

	this.shape_5380 = new cjs.Shape();
	this.shape_5380.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_5380.setTransform(193.8,439.9,0.5,0.5);

	this.shape_5381 = new cjs.Shape();
	this.shape_5381.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg7AAggglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5381.setTransform(176.1,441.4,0.5,0.5);

	this.shape_5382 = new cjs.Shape();
	this.shape_5382.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgTQgPgSggAAQgpABgVAWQgTAYgBAwIAACeIgYAAIAAi4QABhFg/AAQgsAAgSAZQgTAZgBA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAMgUATgLQAVgLAZAAQBBAAAQAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAYQAXAXAAA0IAACwg");
	this.shape_5382.setTransform(157.9,441.3,0.5,0.5);

	this.shape_5383 = new cjs.Shape();
	this.shape_5383.graphics.f("#000000").s().p("Ag/B7QgagRgQggQgOghAAgpQAAhCAggkQAggmA3AAQA5AAAfAmQAgAmAABAQAABBggAmQggAmg4AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg2gZghQgZgegsAAQgsAAgZAeg");
	this.shape_5383.setTransform(139.1,441.4,0.5,0.5);

	this.shape_5384 = new cjs.Shape();
	this.shape_5384.graphics.f("#000000").s().p("Ag/BoQghglAAhCQAAhBAigmQAigmA6AAQAjAAAgANIgGAVQgigLgbAAQgxAAgaAeQgZAfAAA5QAAA3AZAfQAaAfAtAAQAlAAAfgNIAAAWQgaAOgqAAQg5gBgggkg");
	this.shape_5384.setTransform(125.8,441.4,0.5,0.5);

	this.shape_5385 = new cjs.Shape();
	this.shape_5385.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAxABAbAgQAcAjAAA4IAAATIjCAAQAAA4AaAeQAZAdAuAAQAZAAAQgDQASgEAagLIAAAXQgYALgRACQgVAEgXABQg5AAghglgAg3hcQgYAagDAwICmAAQAAgvgUgaQgVgbgkABQgmgBgYAag");
	this.shape_5385.setTransform(112.5,441.4,0.5,0.5);

	this.shape_5386 = new cjs.Shape();
	this.shape_5386.graphics.f("#000000").s().p("Ag0C4QgXgMgNgWIgDAAIgHApIgPAAIAAmCIAZAAIgCCeIACAAQAPgYAWgLQAVgMAeAAQA5AAAdAkQAcAkAABDQAABEgeAkQgeAlg2AAQgcAAgYgMgAhEgiQgUAbAAA+IAAAFQAAA9AVAaQAVAbAuAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5386.setTransform(98.3,438.6,0.5,0.5);

	this.shape_5387 = new cjs.Shape();
	this.shape_5387.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAeglA3AAQAdAAAVALQAVAKASAaIACAAQgCgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgeAug7AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5387.setTransform(75.7,438.6,0.5,0.5);

	this.shape_5388 = new cjs.Shape();
	this.shape_5388.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5388.setTransform(61.3,441.4,0.5,0.5);

	this.shape_5389 = new cjs.Shape();
	this.shape_5389.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQARgZAWgKQAWgLAjAAQBbAAABBhIAACyg");
	this.shape_5389.setTransform(47.6,438.5,0.5,0.5);

	this.shape_5390 = new cjs.Shape();
	this.shape_5390.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5390.setTransform(760.5,403.2,0.5,0.5);

	this.shape_5391 = new cjs.Shape();
	this.shape_5391.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5391.setTransform(749.8,401.6,0.5,0.5);

	this.shape_5392 = new cjs.Shape();
	this.shape_5392.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5392.setTransform(738.5,403.2,0.5,0.5);

	this.shape_5393 = new cjs.Shape();
	this.shape_5393.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpByIBzCcg");
	this.shape_5393.setTransform(727.1,400.2,0.5,0.5);

	this.shape_5394 = new cjs.Shape();
	this.shape_5394.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkABQAvAAAXgZQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_5394.setTransform(712.2,403.3,0.5,0.5);

	this.shape_5395 = new cjs.Shape();
	this.shape_5395.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgJAWQgpgQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5395.setTransform(698.8,403.2,0.5,0.5);

	this.shape_5396 = new cjs.Shape();
	this.shape_5396.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_5396.setTransform(688.5,401.6,0.5,0.5);

	this.shape_5397 = new cjs.Shape();
	this.shape_5397.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5397.setTransform(677.2,403.2,0.5,0.5);

	this.shape_5398 = new cjs.Shape();
	this.shape_5398.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlPIgCAAQACAbAAAkIAAEQIgXAAIAAlrIAnAAICAE/IABAAICBk/IAmAAIAAFrg");
	this.shape_5398.setTransform(659.9,400.8,0.5,0.5);

	this.shape_5399 = new cjs.Shape();
	this.shape_5399.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgTBAgXA3g");
	this.shape_5399.setTransform(639.1,410.1,0.5,0.5);

	this.shape_5400 = new cjs.Shape();
	this.shape_5400.graphics.f("#000000").s().p("AhUCiQgegZAAgwQAAggAVgZQAUgZAsgQQgogSgQgWQgRgVAAgeQAAgZANgVQAOgTAXgLQAYgLAcAAQAuAAAcAYQAdAYAAAoQAAAbgRAWQgTAWgnASQAvASAVAYQATAXAAAiQAAAtggAbQgfAbg0AAQg3AAgdgagAhFAnQgUAVAAAhQAAAiAYATQAXATAqAAQAnAAAagUQAZgUgBgiQABgfgUgUQgUgTg2gVQguARgTAWgAg4iTQgVASAAAdQAAASAHANQAJAOAPAKQALAJAlARQApgQASgTQARgTAAgbQAAgdgVgSQgVgRgkAAQgjAAgVARg");
	this.shape_5400.setTransform(629.5,400.8,0.5,0.5);

	this.shape_5401 = new cjs.Shape();
	this.shape_5401.graphics.f("#000000").s().p("AhGCzQgXgFgSgKIAAgaQAcAOAUAFQAWAGAXAAQAvAAAcgaQAdgZAAgrQAAgogcgYQgcgWgvAAQghAAgjAKIgPgKIAOinICvAAIAAAYIiXAAIgLCBQAogHAUAAQA5AAAiAcQAiAbAAAxQAAA5gjAeQgjAgg8AAQgbAAgZgGg");
	this.shape_5401.setTransform(615,400.9,0.5,0.5);

	this.shape_5402 = new cjs.Shape();
	this.shape_5402.graphics.f("#000000").s().p("AhcC1IAAgVQANAEAMAAQAOACAJAAQA+AAAigsQAjgsAEhUIgDAAQgSAWgaANQgYANgbAAQgzAAgcgcQgcgaAAg0QAAg3AfghQAfgjAxABQAjAAAbASQAbATAPAkQAOAlAAAyQAABGgTAwQgSAxgkAXQglAXgyABQgYAAgXgHgAhBiKQgYAaAAAuQAAAtAWAVQAWAVAoAAQAYAAAWgLQAWgKAMgSQANgTAAgTQAAgdgLgaQgMgZgVgPQgUgOgbAAQgnAAgXAbg");
	this.shape_5402.setTransform(600.2,400.8,0.5,0.5);

	this.shape_5403 = new cjs.Shape();
	this.shape_5403.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA9IgOgSIBihKIAVAAIAAFrg");
	this.shape_5403.setTransform(584,400.8,0.5,0.5);

	this.shape_5404 = new cjs.Shape();
	this.shape_5404.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgGAIgNQAIgNAKgaIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgQAngJANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_5404.setTransform(566.1,406.2,0.5,0.5);

	this.shape_5405 = new cjs.Shape();
	this.shape_5405.graphics.f("#000000").s().p("Ag0C4QgXgMgOgWIgCAAIgHApIgPAAIAAmCIAYAAIAABhIgBAoIAAAVIABAAQAQgYAWgLQAVgMAeAAQA4AAAeAkQAcAkAABDQAABEgeAkQgfAlg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA8AWAbQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5405.setTransform(553,400.4,0.5,0.5);

	this.shape_5406 = new cjs.Shape();
	this.shape_5406.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5406.setTransform(534,401.6,0.5,0.5);

	this.shape_5407 = new cjs.Shape();
	this.shape_5407.graphics.f("#000000").s().p("AhpAnIAAiwIAXAAIAACuQAAApASATQARASAkABQAvAAAXgZQAXgYAAg4IAAiUIAYAAIAAEOIgVAAIgEgmIgCAAQgaArhCAAQhcAAAAhjg");
	this.shape_5407.setTransform(522.3,403.3,0.5,0.5);

	this.shape_5408 = new cjs.Shape();
	this.shape_5408.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgCCeIACAAQAPgYAWgLQAVgMAfAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAaQAWAbAtAAQArAAAXgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5408.setTransform(507.6,400.4,0.5,0.5);

	this.shape_5409 = new cjs.Shape();
	this.shape_5409.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAUgOABgVQgBgVgQgOQgRgOglgNQgogOgRgLQgPgKgJgOQgJgNABgTQAAgeAZgSQAagRAsgBQAtABAnAQIgJAWQgpgQgiAAQgfAAgUAKQgTAMgBATQAAAWAPAMQAPANAsAPQAjANASAKQAQAKAIAOQAJANAAATQAAAkgcATQgbAVgyAAQg1AAghgRg");
	this.shape_5409.setTransform(487,403.2,0.5,0.5);

	this.shape_5410 = new cjs.Shape();
	this.shape_5410.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAhgoA1AAQAvABAcAgQAbAiAAA5IAAATIjBAAQABA5AZAdQAZAdAvAAQAXAAARgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAgiglgAg2hcQgYAagEAwICmAAQAAgugUgbQgUgbgkABQgmgBgYAag");
	this.shape_5410.setTransform(474.2,403.2,0.5,0.5);

	this.shape_5411 = new cjs.Shape();
	this.shape_5411.graphics.f("#000000").s().p("ACdCKIAAixQAAgngPgTQgQgSggAAQgpABgUAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgTAVgMQAUgLAZAAQBAAAASAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_5411.setTransform(456,403,0.5,0.5);

	this.shape_5412 = new cjs.Shape();
	this.shape_5412.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5412.setTransform(437.4,403.2,0.5,0.5);

	this.shape_5413 = new cjs.Shape();
	this.shape_5413.graphics.f("#000000").s().p("ABTCKIAAivQgBgpgRgSQgRgSgkgBQgvAAgXAZQgXAYAAA3IAACVIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBdAAgBBjIAACwg");
	this.shape_5413.setTransform(423.7,403,0.5,0.5);

	this.shape_5414 = new cjs.Shape();
	this.shape_5414.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBcAAgBBjIAACwg");
	this.shape_5414.setTransform(402,403,0.5,0.5);

	this.shape_5415 = new cjs.Shape();
	this.shape_5415.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA1AAQAvABAcAgQAcAigBA5IAAATIjCAAQACA5AYAdQAaAdAuAAQAZAAAQgDQATgEAagLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgugVgbQgUgbgkABQgngBgXAag");
	this.shape_5415.setTransform(387.4,403.2,0.5,0.5);

	this.shape_5416 = new cjs.Shape();
	this.shape_5416.graphics.f("#000000").s().p("AgLCHIhpkOIAZAAIBHC3QANAiAHAcIABAAQAJggAMgeIBFi3IAaAAIhoEOg");
	this.shape_5416.setTransform(374.6,403.2,0.5,0.5);

	this.shape_5417 = new cjs.Shape();
	this.shape_5417.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5417.setTransform(365.9,400.7,0.5,0.5);

	this.shape_5418 = new cjs.Shape();
	this.shape_5418.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgKgMgUQgOgUAAgcQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAmgaAZQgaAYgrAAQgSAAgIgBQgOAIgIAKQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgjAXQgjAXg/AAQgyAAgdgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgSATg");
	this.shape_5418.setTransform(356.3,406.1,0.5,0.5);

	this.shape_5419 = new cjs.Shape();
	this.shape_5419.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgQgEgTAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5419.setTransform(338.9,403,0.5,0.5);

	this.shape_5420 = new cjs.Shape();
	this.shape_5420.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5420.setTransform(330.2,400.7,0.5,0.5);

	this.shape_5421 = new cjs.Shape();
	this.shape_5421.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAfgmQAggoA1AAQAxABAbAgQAbAjABA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgvgUgaQgUgbglABQgmgBgXAag");
	this.shape_5421.setTransform(320.3,403.2,0.5,0.5);

	this.shape_5422 = new cjs.Shape();
	this.shape_5422.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIADAAQAPgZAXgKQAXgLAhAAQBcAAAABhIAACyg");
	this.shape_5422.setTransform(305.9,400.2,0.5,0.5);

	this.shape_5423 = new cjs.Shape();
	this.shape_5423.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5423.setTransform(293.8,401.6,0.5,0.5);

	this.shape_5424 = new cjs.Shape();
	this.shape_5424.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5424.setTransform(280.2,400.2,0.5,0.5);

	this.shape_5425 = new cjs.Shape();
	this.shape_5425.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgYAeg");
	this.shape_5425.setTransform(268,403.2,0.5,0.5);

	this.shape_5426 = new cjs.Shape();
	this.shape_5426.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAYAAA3IAACVIgZAAIAAkOIAWAAIAEAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_5426.setTransform(246.5,403,0.5,0.5);

	this.shape_5427 = new cjs.Shape();
	this.shape_5427.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5427.setTransform(231.4,403.2,0.5,0.5);

	this.shape_5428 = new cjs.Shape();
	this.shape_5428.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5428.setTransform(221.1,400.7,0.5,0.5);

	this.shape_5429 = new cjs.Shape();
	this.shape_5429.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5429.setTransform(213.7,401.6,0.5,0.5);

	this.shape_5430 = new cjs.Shape();
	this.shape_5430.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5430.setTransform(202.4,403.2,0.5,0.5);

	this.shape_5431 = new cjs.Shape();
	this.shape_5431.graphics.f("#000000").s().p("ABTCKIAAivQAAgpgSgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5431.setTransform(188.7,403,0.5,0.5);

	this.shape_5432 = new cjs.Shape();
	this.shape_5432.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5432.setTransform(178.2,400.7,0.5,0.5);

	this.shape_5433 = new cjs.Shape();
	this.shape_5433.graphics.f("#000000").s().p("Ag0C4QgXgLgNgXIgDAAIgHApIgQAAIAAmCIAaAAIgCCeIACAAQAOgYAWgLQAWgMAeAAQA5AAAcAkQAeAkAABDQAABEgfAkQgeAlg2AAQgdAAgXgMgAhEgiQgVAbABA+IAAAFQgBA9AWAaQAVAbAuAAQAsAAAVgfQAXgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_5433.setTransform(168.1,400.4,0.5,0.5);

	this.shape_5434 = new cjs.Shape();
	this.shape_5434.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5434.setTransform(148.9,403,0.5,0.5);

	this.shape_5435 = new cjs.Shape();
	this.shape_5435.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5435.setTransform(130.1,403.2,0.5,0.5);

	this.shape_5436 = new cjs.Shape();
	this.shape_5436.graphics.f("#000000").s().p("AhABoQggglgBhCQABhBAhgmQAjgmA6AAQAkAAAgANIgIAVQghgLgcAAQgxAAgZAeQgZAfgBA5QABA3AZAfQAZAfAuAAQAlAAAggNIAAAWQgbAOgqAAQg5gBghgkg");
	this.shape_5436.setTransform(116.9,403.2,0.5,0.5);

	this.shape_5437 = new cjs.Shape();
	this.shape_5437.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5437.setTransform(96.7,403.2,0.5,0.5);

	this.shape_5438 = new cjs.Shape();
	this.shape_5438.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgKAWQgogQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5438.setTransform(77.8,403.2,0.5,0.5);

	this.shape_5439 = new cjs.Shape();
	this.shape_5439.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5439.setTransform(64.7,403.2,0.5,0.5);

	this.shape_5440 = new cjs.Shape();
	this.shape_5440.graphics.f("#000000").s().p("ABNCHIg7i0IgPg2IgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAPA5AFAdIABAAQAQg9AGgRIA4ikIAVAAIA1CkQATA/ADAPIABAAQADgTARhEIAqibIAZAAIhKEOg");
	this.shape_5440.setTransform(49.2,403.2,0.5,0.5);

	this.shape_5441 = new cjs.Shape();
	this.shape_5441.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgSBAgYA3g");
	this.shape_5441.setTransform(784.7,371.8,0.5,0.5);

	this.shape_5442 = new cjs.Shape();
	this.shape_5442.graphics.f("#000000").s().p("AhNChQgggkAAhBQAAhAAfgnQAggnA2AAQAvAAAbAhQAcAiAAA4IAAAUIjBAAQgBA3AaAeQAaAeAuAAQAZAAAQgEQATgDAZgLIAAAWQgYAMgSACQgUAEgXAAQg5AAgiglgAg2gjQgZAagDAwICmAAQAAgvgUgaQgVgagjAAQgmAAgYAZgAgahzIAAgEQAUgXAPgUQASgYAGgLIAjAAIAAAFQgIAMgXAVQgUAVgaAXg");
	this.shape_5442.setTransform(775.4,362,0.5,0.5);

	this.shape_5443 = new cjs.Shape();
	this.shape_5443.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAJgGAJgNQAIgNAKgaIAOgkIhokOIAZAAIA5CYQAbBFAGAZIABAAIAihfIA5iXIAaAAIh4E6QgPAlgKAPQgKANgNAHQgOAHgTAAQgNAAgSgGg");
	this.shape_5443.setTransform(762.5,368,0.5,0.5);

	this.shape_5444 = new cjs.Shape();
	this.shape_5444.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5444.setTransform(753.8,362.4,0.5,0.5);

	this.shape_5445 = new cjs.Shape();
	this.shape_5445.graphics.f("#000000").s().p("ABTCKIAAivQgBgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5445.setTransform(743.5,364.8,0.5,0.5);

	this.shape_5446 = new cjs.Shape();
	this.shape_5446.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5446.setTransform(728.7,364.9,0.5,0.5);

	this.shape_5447 = new cjs.Shape();
	this.shape_5447.graphics.f("#000000").s().p("Ag9DeIAAgXQATAFATABQA7AAAAhCIAAluIAaAAIAAFrQgBBchUAAQgXAAgPgGg");
	this.shape_5447.setTransform(716.8,364.9,0.5,0.5);

	this.shape_5448 = new cjs.Shape();
	this.shape_5448.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5448.setTransform(705.4,364.8,0.5,0.5);

	this.shape_5449 = new cjs.Shape();
	this.shape_5449.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAgiglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5449.setTransform(692.5,364.9,0.5,0.5);

	this.shape_5450 = new cjs.Shape();
	this.shape_5450.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5450.setTransform(682.6,362.4,0.5,0.5);

	this.shape_5451 = new cjs.Shape();
	this.shape_5451.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5451.setTransform(676.9,362,0.5,0.5);

	this.shape_5452 = new cjs.Shape();
	this.shape_5452.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAgiglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5452.setTransform(667,364.9,0.5,0.5);

	this.shape_5453 = new cjs.Shape();
	this.shape_5453.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5453.setTransform(655.5,363.4,0.5,0.5);

	this.shape_5454 = new cjs.Shape();
	this.shape_5454.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhjIgzCDICBAAIhAiuQgHAagHARg");
	this.shape_5454.setTransform(643.8,362.5,0.5,0.5);

	this.shape_5455 = new cjs.Shape();
	this.shape_5455.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgTBAgXA3g");
	this.shape_5455.setTransform(626.4,371.8,0.5,0.5);

	this.shape_5456 = new cjs.Shape();
	this.shape_5456.graphics.f("#000000").s().p("AhNBoQggglgBhBQABhAAggmQAfgoA1AAQAwABAcAgQAcAjAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgVAEgWABQg5AAgiglgAg3hcQgXAZgEAxICmAAQAAgwgUgZQgVgbgkABQgmgBgYAag");
	this.shape_5456.setTransform(617.1,364.9,0.5,0.5);

	this.shape_5457 = new cjs.Shape();
	this.shape_5457.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5457.setTransform(598.9,364.8,0.5,0.5);

	this.shape_5458 = new cjs.Shape();
	this.shape_5458.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAigWQAggVA+gCIAzgBIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagWALQgXALgaAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5458.setTransform(580.3,364.9,0.5,0.5);

	this.shape_5459 = new cjs.Shape();
	this.shape_5459.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBcAAABBjIAACwg");
	this.shape_5459.setTransform(566.6,364.8,0.5,0.5);

	this.shape_5460 = new cjs.Shape();
	this.shape_5460.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5460.setTransform(545.4,364.9,0.5,0.5);

	this.shape_5461 = new cjs.Shape();
	this.shape_5461.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5461.setTransform(530.9,362,0.5,0.5);

	this.shape_5462 = new cjs.Shape();
	this.shape_5462.graphics.f("#000000").s().p("AgMC2IAAlTIh2AAIAAgYIEFAAIAAAYIh2AAIAAFTg");
	this.shape_5462.setTransform(516.6,362.6,0.5,0.5);

	this.shape_5463 = new cjs.Shape();
	this.shape_5463.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5463.setTransform(500.3,370.7,0.5,0.5);

	this.shape_5464 = new cjs.Shape();
	this.shape_5464.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQAsABAnAQIgJAWQgpgQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAkgbATQgcAVgyAAQg1AAghgRg");
	this.shape_5464.setTransform(491.2,364.9,0.5,0.5);

	this.shape_5465 = new cjs.Shape();
	this.shape_5465.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_5465.setTransform(482.5,362.4,0.5,0.5);

	this.shape_5466 = new cjs.Shape();
	this.shape_5466.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5466.setTransform(475.6,364.8,0.5,0.5);

	this.shape_5467 = new cjs.Shape();
	this.shape_5467.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5467.setTransform(465.6,364.8,0.5,0.5);

	this.shape_5468 = new cjs.Shape();
	this.shape_5468.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQABgnAggWQAhgVA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagWALQgWALgbAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5468.setTransform(452.6,364.9,0.5,0.5);

	this.shape_5469 = new cjs.Shape();
	this.shape_5469.graphics.f("#000000").s().p("ABqC2IAAizIjTAAIAACzIgaAAIAAlrIAaAAIAACiIDTAAIAAiiIAaAAIAAFrg");
	this.shape_5469.setTransform(437.1,362.6,0.5,0.5);

	this.shape_5470 = new cjs.Shape();
	this.shape_5470.graphics.f("#000000").s().p("AhfCHIAAgQICfjoIiUAAIAAgWIC0AAIAAARIihDoIChAAIAAAVg");
	this.shape_5470.setTransform(415.4,364.9,0.5,0.5);

	this.shape_5471 = new cjs.Shape();
	this.shape_5471.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5471.setTransform(405.1,363.4,0.5,0.5);

	this.shape_5472 = new cjs.Shape();
	this.shape_5472.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5472.setTransform(393.8,364.9,0.5,0.5);

	this.shape_5473 = new cjs.Shape();
	this.shape_5473.graphics.f("#000000").s().p("ABcC2IiMi/IgwAqIAACVIgZAAIAAlrIAZAAIAAC8IC2i8IAhAAIiUCaICYDRg");
	this.shape_5473.setTransform(381.4,362.6,0.5,0.5);

	this.shape_5474 = new cjs.Shape();
	this.shape_5474.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5474.setTransform(363.2,362.4,0.5,0.5);

	this.shape_5475 = new cjs.Shape();
	this.shape_5475.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgSQgPgSggAAQgqABgTAWQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5475.setTransform(349.1,364.8,0.5,0.5);

	this.shape_5476 = new cjs.Shape();
	this.shape_5476.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5476.setTransform(330.3,364.9,0.5,0.5);

	this.shape_5477 = new cjs.Shape();
	this.shape_5477.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgTAagXALQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5477.setTransform(315.6,364.9,0.5,0.5);

	this.shape_5478 = new cjs.Shape();
	this.shape_5478.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA6AAAdIAADrIgYAAIAAlrIAZAAIDWFCIACAAQgCgoAAgtIAAjtIAYAAIAAFrg");
	this.shape_5478.setTransform(300.1,362.6,0.5,0.5);

	this.shape_5479 = new cjs.Shape();
	this.shape_5479.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhHAdgkQAdglA3AAQAeAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgbAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_5479.setTransform(276.3,362.1,0.5,0.5);

	this.shape_5480 = new cjs.Shape();
	this.shape_5480.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBbAAABBjIAACwg");
	this.shape_5480.setTransform(261.7,364.8,0.5,0.5);

	this.shape_5481 = new cjs.Shape();
	this.shape_5481.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5481.setTransform(246.9,364.9,0.5,0.5);

	this.shape_5482 = new cjs.Shape();
	this.shape_5482.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAsgBQAsABAoAQIgKAWQgogQgiAAQggAAgTAKQgTAMAAATQAAAWAPAMQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAVgzAAQg1AAghgRg");
	this.shape_5482.setTransform(227.9,364.9,0.5,0.5);

	this.shape_5483 = new cjs.Shape();
	this.shape_5483.graphics.f("#000000").s().p("ACdCKIAAixQAAgogQgSQgPgSggAAQgpABgVAWQgTAYAAAwIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAYQAWAXAAA0IAACwg");
	this.shape_5483.setTransform(210.9,364.8,0.5,0.5);

	this.shape_5484 = new cjs.Shape();
	this.shape_5484.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5484.setTransform(192.4,364.9,0.5,0.5);

	this.shape_5485 = new cjs.Shape();
	this.shape_5485.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5485.setTransform(183.2,362.4,0.5,0.5);

	this.shape_5486 = new cjs.Shape();
	this.shape_5486.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5486.setTransform(177.4,362,0.5,0.5);

	this.shape_5487 = new cjs.Shape();
	this.shape_5487.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_5487.setTransform(171.7,362,0.5,0.5);

	this.shape_5488 = new cjs.Shape();
	this.shape_5488.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAGQgDAHgIAAQgPAAAAgYg");
	this.shape_5488.setTransform(165.9,362.4,0.5,0.5);

	this.shape_5489 = new cjs.Shape();
	this.shape_5489.graphics.f("#000000").s().p("ABdC2IhelRQgDATgIAfIhQEfIgWAAIhklrIAbAAIBREvIAEAUQAGgjAThEIA/jcIAbAAIBJD8QANAtAFAaIAIgmIBNkdIAaAAIhlFrg");
	this.shape_5489.setTransform(151.6,362.6,0.5,0.5);

	this.shape_5490 = new cjs.Shape();
	this.shape_5490.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwABAcAgQAbAjAAA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgVgbgkABQgmgBgXAag");
	this.shape_5490.setTransform(126.7,364.9,0.5,0.5);

	this.shape_5491 = new cjs.Shape();
	this.shape_5491.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5491.setTransform(116.8,362,0.5,0.5);

	this.shape_5492 = new cjs.Shape();
	this.shape_5492.graphics.f("#000000").s().p("AhyDHIAAmIIAWAAIAEAmIACAAQAcgrA8AAQA3AAAcAkQAeAkAABEQAABBgfAmQgeAlg1AAQg8AAgdgvIgCAAIACCkgAhDiWQgVAaAAA7IAAAIQAAA+AUAbQAWAcAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_5492.setTransform(106.7,367.8,0.5,0.5);

	this.shape_5493 = new cjs.Shape();
	this.shape_5493.graphics.f("#000000").s().p("AhyDHIAAmIIAVAAIAGAmIABAAQAcgrA8AAQA3AAAcAkQAdAkAABEQAABBgeAmQgeAlg0AAQg+AAgcgvIgCAAIACCkgAhDiWQgVAZAAA8IAAAIQAAA+AUAbQAWAcAvAAQApAAAXgfQAXgeAAg4QAAh3hWAAQgvAAgWAag");
	this.shape_5493.setTransform(91.5,367.8,0.5,0.5);

	this.shape_5494 = new cjs.Shape();
	this.shape_5494.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5494.setTransform(80.7,362.4,0.5,0.5);

	this.shape_5495 = new cjs.Shape();
	this.shape_5495.graphics.f("#000000").s().p("ABTDCIAAiwQAAgogSgSQgRgTgkAAQgvAAgYAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAQgZAWgKQAXgLAhAAQBcAAAABhIAACyg");
	this.shape_5495.setTransform(70.3,362,0.5,0.5);

	this.shape_5496 = new cjs.Shape();
	this.shape_5496.graphics.f("#000000").s().p("ABdC2IhelRQgCANgJAlIhQEfIgWAAIhklrIAbAAIBVFDQAFghAUhGIA/jcIAbAAIBJD8QANAtAFAaIBVlDIAaAAIhlFrg");
	this.shape_5496.setTransform(51.3,362.6,0.5,0.5);

	this.shape_5497 = new cjs.Shape();
	this.shape_5497.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAxABAbAgQAbAjAAA4IAAATIjBAAQABA5AZAdQAZAdAvAAQAYAAAQgDQAUgEAYgLIAAAXQgYALgSACQgVAEgVABQg6AAgiglgAg2hcQgYAagEAwICnAAQgBgugUgbQgVgbgkABQgmgBgXAag");
	this.shape_5497.setTransform(768.7,326.7,0.5,0.5);

	this.shape_5498 = new cjs.Shape();
	this.shape_5498.graphics.f("#000000").s().p("AhABoQghglAAhCQAAhCAjglQAigmA6AAQAkAAAfANIgHAVQgggLgdAAQgwAAgaAeQgaAfAAA5QAAA3AaAfQAaAfAtAAQAlAAAggNIAAAWQgcAOgpAAQg4gBgigkg");
	this.shape_5498.setTransform(756,326.7,0.5,0.5);

	this.shape_5499 = new cjs.Shape();
	this.shape_5499.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5499.setTransform(746.7,324.2,0.5,0.5);

	this.shape_5500 = new cjs.Shape();
	this.shape_5500.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_5500.setTransform(736.4,326.5,0.5,0.5);

	this.shape_5501 = new cjs.Shape();
	this.shape_5501.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5501.setTransform(721.6,326.7,0.5,0.5);

	this.shape_5502 = new cjs.Shape();
	this.shape_5502.graphics.f("#000000").s().p("Ag8DeIAAgXQASAFATABQA7AAAAhCIAAluIAZAAIAAFrQAABchUAAQgXAAgOgGg");
	this.shape_5502.setTransform(709.8,326.6,0.5,0.5);

	this.shape_5503 = new cjs.Shape();
	this.shape_5503.graphics.f("#000000").s().p("AgdA/QAThCAJg7IAcAAIADAGQgUBEgWAzg");
	this.shape_5503.setTransform(699.2,333.6,0.5,0.5);

	this.shape_5504 = new cjs.Shape();
	this.shape_5504.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgRgKgIgOQgIgMAAgUQAAgeAZgSQAagRAsgBQAsABAoAQIgKAWQgogQgiAAQggAAgTAKQgUAMAAATQAAAWAQAMQAPANAqAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgaAVgzAAQg1AAghgRg");
	this.shape_5504.setTransform(690.9,326.7,0.5,0.5);

	this.shape_5505 = new cjs.Shape();
	this.shape_5505.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5505.setTransform(680.6,325.1,0.5,0.5);

	this.shape_5506 = new cjs.Shape();
	this.shape_5506.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAdAAAtIAACVg");
	this.shape_5506.setTransform(672.4,326.5,0.5,0.5);

	this.shape_5507 = new cjs.Shape();
	this.shape_5507.graphics.f("#000000").s().p("AB8C3IgyiBIiUAAIgyCBIgcAAICSltIAQAAICPFtgAgNhjIgzCDICBAAIhAiuQgHAagHARg");
	this.shape_5507.setTransform(658.9,324.3,0.5,0.5);

	this.shape_5508 = new cjs.Shape();
	this.shape_5508.graphics.f("#000000").s().p("AhNBoQghglAAhBQAAhAAggmQAggoA2AAQAvABAcAgQAcAjgBA4IAAATIjCAAQACA5AYAdQAaAdAuAAQAZAAAQgDQATgEAagLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgugVgbQgUgbgkABQgngBgXAag");
	this.shape_5508.setTransform(637.6,326.7,0.5,0.5);

	this.shape_5509 = new cjs.Shape();
	this.shape_5509.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_5509.setTransform(623.2,326.5,0.5,0.5);

	this.shape_5510 = new cjs.Shape();
	this.shape_5510.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5510.setTransform(612.7,324.2,0.5,0.5);

	this.shape_5511 = new cjs.Shape();
	this.shape_5511.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACbICjAAIAAAWIijAAIAACjg");
	this.shape_5511.setTransform(604.6,324.3,0.5,0.5);

	this.shape_5512 = new cjs.Shape();
	this.shape_5512.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5512.setTransform(587.4,323.7,0.5,0.5);

	this.shape_5513 = new cjs.Shape();
	this.shape_5513.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhgkQAfgmA3AAQA4AAAgAmQAgAmAABAQAABBghAmQgfAmg4AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgZAeg");
	this.shape_5513.setTransform(575.3,326.7,0.5,0.5);

	this.shape_5514 = new cjs.Shape();
	this.shape_5514.graphics.f("#000000").s().p("ACdCKIAAixQAAgngQgTQgPgSggAAQgpABgVAWQgTAYAAAwIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA2IAACVIgZAAIAAkOIAVAAIAFAlIACAAQAMgUATgLQAVgLAZAAQBBAAAQAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAYQAWAXABA0IAACwg");
	this.shape_5514.setTransform(550,326.5,0.5,0.5);

	this.shape_5515 = new cjs.Shape();
	this.shape_5515.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQASASAkABQAuAAAYgZQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_5515.setTransform(531.1,326.8,0.5,0.5);

	this.shape_5516 = new cjs.Shape();
	this.shape_5516.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5516.setTransform(516.6,326.7,0.5,0.5);

	this.shape_5517 = new cjs.Shape();
	this.shape_5517.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgRgOQgQgNgmgOQgogOgQgLQgRgKgIgOQgJgNAAgTQAAgeAagSQAagRAsgBQAsABAoAQIgKAWQgogQgiAAQggAAgTAKQgUAMAAATQAAAWAPAMQAPANArAPQAlANARAKQARALAIANQAIAOAAASQAAAkgcATQgbAVgyAAQg1AAghgRg");
	this.shape_5517.setTransform(503.6,326.7,0.5,0.5);

	this.shape_5518 = new cjs.Shape();
	this.shape_5518.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQARASAkABQAvAAAXgZQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_5518.setTransform(490.2,326.8,0.5,0.5);

	this.shape_5519 = new cjs.Shape();
	this.shape_5519.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiIlPIgBAAQABAbAAAkIAAEQIgYAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5519.setTransform(471.7,324.3,0.5,0.5);

	this.shape_5520 = new cjs.Shape();
	this.shape_5520.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvABAbAgQAcAjAAA4IAAATIjBAAQgBA4AaAeQAaAdAvAAQAYAAAQgDQASgEAagLIAAAXQgYALgSACQgVAEgVABQg6AAgiglgAg2hcQgZAagDAwICmAAQAAgvgUgaQgVgbgjABQgmgBgYAag");
	this.shape_5520.setTransform(447.1,326.7,0.5,0.5);

	this.shape_5521 = new cjs.Shape();
	this.shape_5521.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5521.setTransform(432.7,323.7,0.5,0.5);

	this.shape_5522 = new cjs.Shape();
	this.shape_5522.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5522.setTransform(420.6,325.1,0.5,0.5);

	this.shape_5523 = new cjs.Shape();
	this.shape_5523.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5523.setTransform(406.9,323.7,0.5,0.5);

	this.shape_5524 = new cjs.Shape();
	this.shape_5524.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAhgkQAfgmA4AAQA4AAAfAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_5524.setTransform(394.8,326.7,0.5,0.5);

	this.shape_5525 = new cjs.Shape();
	this.shape_5525.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5525.setTransform(377.8,323.7,0.5,0.5);

	this.shape_5526 = new cjs.Shape();
	this.shape_5526.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhCAggkQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5526.setTransform(367.4,326.7,0.5,0.5);

	this.shape_5527 = new cjs.Shape();
	this.shape_5527.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAggkQAggmA4AAQA4AAAfAmQAgAmAABAQAABBghAmQggAmg3AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAaAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_5527.setTransform(352.5,326.7,0.5,0.5);

	this.shape_5528 = new cjs.Shape();
	this.shape_5528.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgvAAgXAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAQgZAWgKQAWgLAjAAQBbAAABBhIAACyg");
	this.shape_5528.setTransform(337.6,323.7,0.5,0.5);

	this.shape_5529 = new cjs.Shape();
	this.shape_5529.graphics.f("#000000").s().p("AhABoQggglAAhCQAAhBAhgmQAjgmA6AAQAkAAAfANIgHAVQghgLgbAAQgxAAgaAeQgaAfAAA5QAAA3AaAfQAZAfAuAAQAlAAAggNIAAAWQgcAOgpAAQg4gBgigkg");
	this.shape_5529.setTransform(324.2,326.7,0.5,0.5);

	this.shape_5530 = new cjs.Shape();
	this.shape_5530.graphics.f("#000000").s().p("AhwCsIAAgZQAoARA9AAQArAAAbgVQAagVAAghQAAgVgJgNQgHgNgVgMQgTgLglgNQg4gSgWgWQgVgXAAglQAAgoAggaQAggaAyAAQAzAAAtATIgKAWQgsgTgqAAQgoAAgXATQgYATAAAgQAAAUAHANQAIANAQAKQAUAMAlANQApANAXAOQAVAPAJARQAKAQAAAaQABAugiAaQgiAbg2AAQhDAAgkgPg");
	this.shape_5530.setTransform(311,324.3,0.5,0.5);

	this.shape_5531 = new cjs.Shape();
	this.shape_5531.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5531.setTransform(290.4,326.7,0.5,0.5);

	this.shape_5532 = new cjs.Shape();
	this.shape_5532.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5532.setTransform(275.9,323.7,0.5,0.5);

	this.shape_5533 = new cjs.Shape();
	this.shape_5533.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_5533.setTransform(263.9,325.1,0.5,0.5);

	this.shape_5534 = new cjs.Shape();
	this.shape_5534.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQABgxASgYQARgXAqAAQAVAAAXAHIgFAVQgUgGgUAAQgdAAgMARQgKARgBAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5534.setTransform(250.2,323.7,0.5,0.5);

	this.shape_5535 = new cjs.Shape();
	this.shape_5535.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_5535.setTransform(238,326.7,0.5,0.5);

	this.shape_5536 = new cjs.Shape();
	this.shape_5536.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgOQgQgOgmgNQgogOgQgLQgQgKgJgOQgIgMAAgUQAAgeAZgSQAagRAtgBQArABAoAQIgKAWQgogQghAAQghAAgTAKQgTAMAAATQAAAWAPAMQAPANArAPQAkANARAKQARALAIANQAIAOAAASQAAAjgbAUQgcAVgyAAQg1AAghgRg");
	this.shape_5536.setTransform(217.9,326.7,0.5,0.5);

	this.shape_5537 = new cjs.Shape();
	this.shape_5537.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAhAAhgmQAfgoA1AAQAxABAbAgQAcAjAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgVAEgWABQg5AAgiglgAg3hcQgXAZgEAxICmAAQAAgvgUgaQgUgbglABQglgBgZAag");
	this.shape_5537.setTransform(205.1,326.7,0.5,0.5);

	this.shape_5538 = new cjs.Shape();
	this.shape_5538.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_5538.setTransform(193.6,325.1,0.5,0.5);

	this.shape_5539 = new cjs.Shape();
	this.shape_5539.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgVAagVALQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_5539.setTransform(182.3,326.7,0.5,0.5);

	this.shape_5540 = new cjs.Shape();
	this.shape_5540.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQASASAjABQAvAAAYgZQAWgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAAAhjg");
	this.shape_5540.setTransform(168.4,326.8,0.5,0.5);

	this.shape_5541 = new cjs.Shape();
	this.shape_5541.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAdglA4AAQAdAAAVALQAVAKASAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5541.setTransform(153,323.9,0.5,0.5);

	this.shape_5542 = new cjs.Shape();
	this.shape_5542.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5542.setTransform(138.6,326.7,0.5,0.5);

	this.shape_5543 = new cjs.Shape();
	this.shape_5543.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAdAAAtIAACVg");
	this.shape_5543.setTransform(128.2,326.5,0.5,0.5);

	this.shape_5544 = new cjs.Shape();
	this.shape_5544.graphics.f("#000000").s().p("AhdCzQgdgTAAgjQAAgcARgTQASgSAegHQgNgFgHgKQgIgJABgNQAAgaAigVQgYgKgNgUQgNgUAAgcQAAgnAagaQAZgYAsAAQAaAAAPAFIBXAAIAAARIg5AEQAXAcAAAhQAAAngaAYQgaAYgrAAQgTAAgHgBQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgjAXQgjAXg/AAQgyAAgcgUgAhgB6QAAA4BUAAQBpAAAAhEQAAgYgQgLQgSgLglAAIgrAAQhKAAgBA6gAg4igQgTASAAAhQAAAfATASQAUARAfAAQAhAAASgRQASgRAAghQAAgjgTgRQgSgRghAAQggAAgSATg");
	this.shape_5544.setTransform(115.7,329.6,0.5,0.5);

	this.shape_5545 = new cjs.Shape();
	this.shape_5545.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5545.setTransform(98.3,326.5,0.5,0.5);

	this.shape_5546 = new cjs.Shape();
	this.shape_5546.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgZALgSACQgUAEgWABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgUgbglABQgmgBgXAag");
	this.shape_5546.setTransform(85.5,326.7,0.5,0.5);

	this.shape_5547 = new cjs.Shape();
	this.shape_5547.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAjAAQBcAAAABhIAACyg");
	this.shape_5547.setTransform(71,323.7,0.5,0.5);

	this.shape_5548 = new cjs.Shape();
	this.shape_5548.graphics.f("#000000").s().p("AgSCXQgQgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAATgEIAAAUQgRAGgZAAQgiAAgSgUg");
	this.shape_5548.setTransform(59,325.1,0.5,0.5);

	this.shape_5549 = new cjs.Shape();
	this.shape_5549.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABBggAmQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_5549.setTransform(47.4,326.7,0.5,0.5);

	this.shape_5550 = new cjs.Shape();
	this.shape_5550.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPgfAAgrQAAhCAggkQAggmA3AAQA4AAAgAmQAgAlAABBQAABBggAmQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_5550.setTransform(729.8,288.4,0.5,0.5);

	this.shape_5551 = new cjs.Shape();
	this.shape_5551.graphics.f("#000000").s().p("ABNCHIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAOA3AGAfIACAAQAOg6AHgUIA4ikIAVAAIA1CkQAQAyAGAcIACAAQABgOAThJIApibIAZAAIhKEOg");
	this.shape_5551.setTransform(713.1,288.4,0.5,0.5);

	this.shape_5552 = new cjs.Shape();
	this.shape_5552.graphics.f("#000000").s().p("AgSCXQgQgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfALAPQALAPAXAAQAWAAASgEIAAAUQgQAGgZAAQgiAAgSgUg");
	this.shape_5552.setTransform(699.4,286.9,0.5,0.5);

	this.shape_5553 = new cjs.Shape();
	this.shape_5553.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABhIAACyg");
	this.shape_5553.setTransform(681.2,285.5,0.5,0.5);

	this.shape_5554 = new cjs.Shape();
	this.shape_5554.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_5554.setTransform(669.2,286.9,0.5,0.5);

	this.shape_5555 = new cjs.Shape();
	this.shape_5555.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5555.setTransform(662.2,285.9,0.5,0.5);

	this.shape_5556 = new cjs.Shape();
	this.shape_5556.graphics.f("#000000").s().p("ABNCHIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCcQAPA7AFAbIABAAQAQg9AGgRIA4ikIAVAAIA1CkQAQAyAGAcIACAAQABgMAShLIAqibIAZAAIhKEOg");
	this.shape_5556.setTransform(650.1,288.4,0.5,0.5);

	this.shape_5557 = new cjs.Shape();
	this.shape_5557.graphics.f("#000000").s().p("AhcC1IAAgVQANAEAMAAQAOACAJAAQA+AAAigsQAigrAFhVIgDAAQgSAWgaANQgYANgbAAQgzAAgcgcQgcgbAAgzQAAg3AfghQAfgjAxABQAjAAAbASQAbAUAOAjQAPAkAAAzQAABGgTAwQgSAxglAXQgkAXgyABQgYAAgXgHgAhCiKQgXAaAAAuQAAAtAWAVQAWAVAoAAQAYAAAWgLQAWgKAMgSQANgTAAgTQAAgdgLgaQgMgZgVgPQgUgOgbAAQgnAAgYAbg");
	this.shape_5557.setTransform(626.9,286.1,0.5,0.5);

	this.shape_5558 = new cjs.Shape();
	this.shape_5558.graphics.f("#000000").s().p("AAyC3IAAhdIi6AAIAAgRIC0j/IAeAAIAAD7IA/AAIAAAVIg/AAIAABdgAAVhyIh/C3ICcAAIAAhnQAAhDAEg8IgCAAQgDAHgcAog");
	this.shape_5558.setTransform(612.5,286,0.5,0.5);

	this.shape_5559 = new cjs.Shape();
	this.shape_5559.graphics.f("#000000").s().p("AhcC1IAAgVQAOAEAMAAQANACAKAAQA8AAAjgsQAjgsAEhUIgDAAQgRAWgaANQgZANgbAAQgzAAgcgcQgcgaAAg0QAAg3AfghQAfgjAyABQAiAAAbASQAcAUAOAjQAOAlAAAyQAABHgSAvQgUAxgjAXQglAXgxABQgZAAgXgHgAhBiKQgYAbAAAtQAAAsAWAWQAWAVAoAAQAYAAAWgLQAWgKANgSQAMgSAAgUQAAgegLgZQgLgYgWgQQgUgOgaAAQgoAAgXAbg");
	this.shape_5559.setTransform(597.7,286.1,0.5,0.5);

	this.shape_5560 = new cjs.Shape();
	this.shape_5560.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA9IgOgSIBihKIAVAAIAAFrg");
	this.shape_5560.setTransform(581.5,286.1,0.5,0.5);

	this.shape_5561 = new cjs.Shape();
	this.shape_5561.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5561.setTransform(562,288.3,0.5,0.5);

	this.shape_5562 = new cjs.Shape();
	this.shape_5562.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5562.setTransform(551.5,285.9,0.5,0.5);

	this.shape_5563 = new cjs.Shape();
	this.shape_5563.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgPgEgUAAQghAAgXAdQgWAeAAAsIAACVg");
	this.shape_5563.setTransform(537.9,288.3,0.5,0.5);

	this.shape_5564 = new cjs.Shape();
	this.shape_5564.graphics.f("#000000").s().p("AhNBoQggglgBhBQABg/AfgnQAhgoA1AAQAvABAcAgQAbAiABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAZAAARgDQASgEAagLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgZAagDAwICmAAQABgugVgbQgUgbgkABQgngBgXAag");
	this.shape_5564.setTransform(525.1,288.4,0.5,0.5);

	this.shape_5565 = new cjs.Shape();
	this.shape_5565.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_5565.setTransform(515.2,285.9,0.5,0.5);

	this.shape_5566 = new cjs.Shape();
	this.shape_5566.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5566.setTransform(509.4,285.5,0.5,0.5);

	this.shape_5567 = new cjs.Shape();
	this.shape_5567.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggoA0AAQAxABAbAgQAbAiABA5IAAATIjDAAQABA5AaAdQAZAdAuAAQAYAAASgDQASgEAagLIAAAXQgaALgQACQgWAEgWABQg5AAghglgAg3hcQgXAagEAwICnAAQAAgugVgbQgUgbglABQgmgBgYAag");
	this.shape_5567.setTransform(499.6,288.4,0.5,0.5);

	this.shape_5568 = new cjs.Shape();
	this.shape_5568.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5568.setTransform(488.1,286.9,0.5,0.5);

	this.shape_5569 = new cjs.Shape();
	this.shape_5569.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgNhjIgyCDICAAAIhAiuQgFAUgJAXg");
	this.shape_5569.setTransform(476.4,286,0.5,0.5);

	this.shape_5570 = new cjs.Shape();
	this.shape_5570.graphics.f("#000000").s().p("AhNBoQggglgBhBQAAg/AggnQAhgoA0AAQAwABAcAgQAcAjgBA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgaALgRACQgUAEgXABQg5AAgiglgAg2hcQgYAZgEAxICmAAQAAgwgUgZQgVgbgkABQgmgBgXAag");
	this.shape_5570.setTransform(455.1,288.4,0.5,0.5);

	this.shape_5571 = new cjs.Shape();
	this.shape_5571.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAjAAQBcAAAABhIAACyg");
	this.shape_5571.setTransform(440.6,285.5,0.5,0.5);

	this.shape_5572 = new cjs.Shape();
	this.shape_5572.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgRAGgXAAQgjAAgRgUg");
	this.shape_5572.setTransform(428.6,286.9,0.5,0.5);

	this.shape_5573 = new cjs.Shape();
	this.shape_5573.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAdglQAdglA4AAQAdAAAWALQAVAKARAaIABAAQgBgeAAgfIAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgbQAWgaAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_5573.setTransform(409.9,285.6,0.5,0.5);

	this.shape_5574 = new cjs.Shape();
	this.shape_5574.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5574.setTransform(395.7,288.4,0.5,0.5);

	this.shape_5575 = new cjs.Shape();
	this.shape_5575.graphics.f("#000000").s().p("ACdCKIAAixQAAgogPgSQgQgSggAAQgpABgVAWQgTAYgBAwIAACeIgYAAIAAi4QABhFg/AAQgqAAgUAZQgTAZgBA2IAACVIgYAAIAAkOIAUAAIAGAlIABAAQALgUAVgLQAUgLAZAAQBBAAAQAwIACAAQANgYAWgMQAWgMAcAAQAtAAAWAYQAXAXAAA0IAACwg");
	this.shape_5575.setTransform(377.5,288.3,0.5,0.5);

	this.shape_5576 = new cjs.Shape();
	this.shape_5576.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgQgEgTAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5576.setTransform(362.1,288.3,0.5,0.5);

	this.shape_5577 = new cjs.Shape();
	this.shape_5577.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhgkQAfgmA4AAQA3AAAgAmQAgAmAABAQAABBghAmQgfAmg4AAQgjgBgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_5577.setTransform(348.8,288.4,0.5,0.5);

	this.shape_5578 = new cjs.Shape();
	this.shape_5578.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgxATgYQARgXAqAAQAVAAAYAHIgGAVQgUgGgUAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5578.setTransform(338.4,285.4,0.5,0.5);

	this.shape_5579 = new cjs.Shape();
	this.shape_5579.graphics.f("#000000").s().p("AhzC/IAAgVQANAEATAAQAMAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihfIA6iXIAZAAIh4E6QgPAngKANQgKANgNAHQgOAHgSAAQgNAAgTgGg");
	this.shape_5579.setTransform(321.2,291.5,0.5,0.5);

	this.shape_5580 = new cjs.Shape();
	this.shape_5580.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_5580.setTransform(312.5,285.5,0.5,0.5);

	this.shape_5581 = new cjs.Shape();
	this.shape_5581.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5581.setTransform(306.7,285.5,0.5,0.5);

	this.shape_5582 = new cjs.Shape();
	this.shape_5582.graphics.f("#000000").s().p("AhPB4QgVgVAAgkQAAgnAggWQAhgVA+gCIA0gBIAAgSQgBgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWgBAyIAACzIgSAAIgFgrIgDAAQgUAagVALQgYALgbAAQgnAAgXgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_5582.setTransform(296.6,288.4,0.5,0.5);

	this.shape_5583 = new cjs.Shape();
	this.shape_5583.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_5583.setTransform(282.9,288.3,0.5,0.5);

	this.shape_5584 = new cjs.Shape();
	this.shape_5584.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_5584.setTransform(272.4,285.9,0.5,0.5);

	this.shape_5585 = new cjs.Shape();
	this.shape_5585.graphics.f("#000000").s().p("AhdCzQgdgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigVQgYgKgMgUQgOgUAAgcQAAgnAagaQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAmgaAZQgaAYgrAAQgSAAgIgBQgOAIgIAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAArgiAXQgkAXg+AAQgzAAgcgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQAUARAfAAQAiAAARgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgSATg");
	this.shape_5585.setTransform(262.9,291.3,0.5,0.5);

	this.shape_5586 = new cjs.Shape();
	this.shape_5586.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_5586.setTransform(253.3,285.9,0.5,0.5);

	this.shape_5587 = new cjs.Shape();
	this.shape_5587.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQATAAASADIgFAYQgPgEgUAAQgiAAgWAdQgWAeAAAsIAACVg");
	this.shape_5587.setTransform(246.3,288.3,0.5,0.5);

	this.shape_5588 = new cjs.Shape();
	this.shape_5588.graphics.f("#000000").s().p("Ag/B7QgbgSgOgfQgPghAAgpQAAhBAgglQAggmA4AAQA3AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgYAeg");
	this.shape_5588.setTransform(233,288.4,0.5,0.5);

	this.shape_5589 = new cjs.Shape();
	this.shape_5589.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5589.setTransform(211.7,288.4,0.5,0.5);

	this.shape_5590 = new cjs.Shape();
	this.shape_5590.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_5590.setTransform(201,286.9,0.5,0.5);

	this.shape_5591 = new cjs.Shape();
	this.shape_5591.graphics.f("#000000").s().p("AhOB4QgXgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgTAZgWAMQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5591.setTransform(189.7,288.4,0.5,0.5);

	this.shape_5592 = new cjs.Shape();
	this.shape_5592.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICJiXIAeAAIhpByIBzCcg");
	this.shape_5592.setTransform(178.3,285.5,0.5,0.5);

	this.shape_5593 = new cjs.Shape();
	this.shape_5593.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAqARASQASASAkABQAuAAAYgZQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgcArhBAAQhdAAAAhjg");
	this.shape_5593.setTransform(163.4,288.5,0.5,0.5);

	this.shape_5594 = new cjs.Shape();
	this.shape_5594.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgQgOQgSgOglgNQgogOgQgLQgRgKgIgOQgJgNABgTQAAgeAZgSQAbgRArgBQAtABAnAQIgJAWQgpgQgiAAQgfAAgUAKQgTAMgBATQAAAWAPAMQAPANAsAPQAkANARAKQARALAIANQAIANAAATQAAAkgcATQgbAVgyAAQg1AAghgRg");
	this.shape_5594.setTransform(150,288.4,0.5,0.5);

	this.shape_5595 = new cjs.Shape();
	this.shape_5595.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_5595.setTransform(139.7,286.9,0.5,0.5);

	this.shape_5596 = new cjs.Shape();
	this.shape_5596.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAggVA/gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgTAagXALQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_5596.setTransform(128.4,288.4,0.5,0.5);

	this.shape_5597 = new cjs.Shape();
	this.shape_5597.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5597.setTransform(111.1,286.1,0.5,0.5);

	this.shape_5598 = new cjs.Shape();
	this.shape_5598.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwABAcAgQAbAiAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgaALgRACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAxICmAAQAAgugUgbQgUgbglABQgmgBgXAag");
	this.shape_5598.setTransform(86.4,288.4,0.5,0.5);

	this.shape_5599 = new cjs.Shape();
	this.shape_5599.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQALgHAHgMQAIgMAKgbIAOgkIhokOIAZAAIA6CYQAYBCAJAcIAAAAQAOgqAUg1IA6iXIAZAAIh4E6QgQAogJAMQgKANgNAHQgOAHgSAAQgOAAgSgGg");
	this.shape_5599.setTransform(73.6,291.5,0.5,0.5);

	this.shape_5600 = new cjs.Shape();
	this.shape_5600.graphics.f("#000000").s().p("AgMC5IAAkOIAZAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_5600.setTransform(64.9,285.9,0.5,0.5);

	this.shape_5601 = new cjs.Shape();
	this.shape_5601.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiJFPIgPAAIiIlPIgBAAQABAbAAAkIAAEQIgYAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5601.setTransform(51,286.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_5601},{t:this.shape_5600},{t:this.shape_5599},{t:this.shape_5598},{t:this.shape_5597},{t:this.shape_5596},{t:this.shape_5595},{t:this.shape_5594},{t:this.shape_5593},{t:this.shape_5592},{t:this.shape_5591},{t:this.shape_5590},{t:this.shape_5589},{t:this.shape_5588},{t:this.shape_5587},{t:this.shape_5586},{t:this.shape_5585},{t:this.shape_5584},{t:this.shape_5583},{t:this.shape_5582},{t:this.shape_5581},{t:this.shape_5580},{t:this.shape_5579},{t:this.shape_5578},{t:this.shape_5577},{t:this.shape_5576},{t:this.shape_5575},{t:this.shape_5574},{t:this.shape_5573},{t:this.shape_5572},{t:this.shape_5571},{t:this.shape_5570},{t:this.shape_5569},{t:this.shape_5568},{t:this.shape_5567},{t:this.shape_5566},{t:this.shape_5565},{t:this.shape_5564},{t:this.shape_5563},{t:this.shape_5562},{t:this.shape_5561},{t:this.shape_5560},{t:this.shape_5559},{t:this.shape_5558},{t:this.shape_5557},{t:this.shape_5556},{t:this.shape_5555},{t:this.shape_5554},{t:this.shape_5553},{t:this.shape_5552},{t:this.shape_5551},{t:this.shape_5550},{t:this.shape_5549},{t:this.shape_5548},{t:this.shape_5547},{t:this.shape_5546},{t:this.shape_5545},{t:this.shape_5544},{t:this.shape_5543},{t:this.shape_5542},{t:this.shape_5541},{t:this.shape_5540},{t:this.shape_5539},{t:this.shape_5538},{t:this.shape_5537},{t:this.shape_5536},{t:this.shape_5535},{t:this.shape_5534},{t:this.shape_5533},{t:this.shape_5532},{t:this.shape_5531},{t:this.shape_5530},{t:this.shape_5529},{t:this.shape_5528},{t:this.shape_5527},{t:this.shape_5526},{t:this.shape_5525},{t:this.shape_5524},{t:this.shape_5523},{t:this.shape_5522},{t:this.shape_5521},{t:this.shape_5520},{t:this.shape_5519},{t:this.shape_5518},{t:this.shape_5517},{t:this.shape_5516},{t:this.shape_5515},{t:this.shape_5514},{t:this.shape_5513},{t:this.shape_5512},{t:this.shape_5511},{t:this.shape_5510},{t:this.shape_5509},{t:this.shape_5508},{t:this.shape_5507},{t:this.shape_5506},{t:this.shape_5505},{t:this.shape_5504},{t:this.shape_5503},{t:this.shape_5502},{t:this.shape_5501},{t:this.shape_5500},{t:this.shape_5499},{t:this.shape_5498},{t:this.shape_5497},{t:this.shape_5496},{t:this.shape_5495},{t:this.shape_5494},{t:this.shape_5493},{t:this.shape_5492},{t:this.shape_5491},{t:this.shape_5490},{t:this.shape_5489},{t:this.shape_5488},{t:this.shape_5487},{t:this.shape_5486},{t:this.shape_5485},{t:this.shape_5484},{t:this.shape_5483},{t:this.shape_5482},{t:this.shape_5481},{t:this.shape_5480},{t:this.shape_5479},{t:this.shape_5478},{t:this.shape_5477},{t:this.shape_5476},{t:this.shape_5475},{t:this.shape_5474},{t:this.shape_5473},{t:this.shape_5472},{t:this.shape_5471},{t:this.shape_5470},{t:this.shape_5469},{t:this.shape_5468},{t:this.shape_5467},{t:this.shape_5466},{t:this.shape_5465},{t:this.shape_5464},{t:this.shape_5463},{t:this.shape_5462},{t:this.shape_5461},{t:this.shape_5460},{t:this.shape_5459},{t:this.shape_5458},{t:this.shape_5457},{t:this.shape_5456},{t:this.shape_5455},{t:this.shape_5454},{t:this.shape_5453},{t:this.shape_5452},{t:this.shape_5451},{t:this.shape_5450},{t:this.shape_5449},{t:this.shape_5448},{t:this.shape_5447},{t:this.shape_5446},{t:this.shape_5445},{t:this.shape_5444},{t:this.shape_5443},{t:this.shape_5442},{t:this.shape_5441},{t:this.shape_5440},{t:this.shape_5439},{t:this.shape_5438},{t:this.shape_5437},{t:this.shape_5436},{t:this.shape_5435},{t:this.shape_5434},{t:this.shape_5433},{t:this.shape_5432},{t:this.shape_5431},{t:this.shape_5430},{t:this.shape_5429},{t:this.shape_5428},{t:this.shape_5427},{t:this.shape_5426},{t:this.shape_5425},{t:this.shape_5424},{t:this.shape_5423},{t:this.shape_5422},{t:this.shape_5421},{t:this.shape_5420},{t:this.shape_5419},{t:this.shape_5418},{t:this.shape_5417},{t:this.shape_5416},{t:this.shape_5415},{t:this.shape_5414},{t:this.shape_5413},{t:this.shape_5412},{t:this.shape_5411},{t:this.shape_5410},{t:this.shape_5409},{t:this.shape_5408},{t:this.shape_5407},{t:this.shape_5406},{t:this.shape_5405},{t:this.shape_5404},{t:this.shape_5403},{t:this.shape_5402},{t:this.shape_5401},{t:this.shape_5400},{t:this.shape_5399},{t:this.shape_5398},{t:this.shape_5397},{t:this.shape_5396},{t:this.shape_5395},{t:this.shape_5394},{t:this.shape_5393},{t:this.shape_5392},{t:this.shape_5391},{t:this.shape_5390},{t:this.shape_5389},{t:this.shape_5388},{t:this.shape_5387},{t:this.shape_5386},{t:this.shape_5385},{t:this.shape_5384},{t:this.shape_5383},{t:this.shape_5382},{t:this.shape_5381},{t:this.shape_5380},{t:this.shape_5379},{t:this.shape_5378},{t:this.shape_5377},{t:this.shape_5376},{t:this.shape_5375},{t:this.shape_5374},{t:this.shape_5373},{t:this.shape_5372},{t:this.shape_5371},{t:this.shape_5370},{t:this.shape_5369},{t:this.shape_5368},{t:this.shape_5367},{t:this.shape_5366},{t:this.shape_5365},{t:this.shape_5364},{t:this.shape_5363},{t:this.shape_5362},{t:this.shape_5361},{t:this.shape_5360},{t:this.shape_5359},{t:this.shape_5358},{t:this.shape_5357},{t:this.shape_5356},{t:this.shape_5355},{t:this.shape_5354},{t:this.shape_5353},{t:this.shape_5352},{t:this.shape_5351},{t:this.shape_5350},{t:this.shape_5349},{t:this.shape_5348},{t:this.shape_5347},{t:this.shape_5346},{t:this.shape_5345},{t:this.shape_5344},{t:this.shape_5343},{t:this.shape_5342},{t:this.shape_5341},{t:this.shape_5340},{t:this.shape_5339},{t:this.shape_5338},{t:this.shape_5337},{t:this.shape_5336},{t:this.shape_5335},{t:this.shape_5334},{t:this.shape_5333},{t:this.shape_5332},{t:this.shape_5331},{t:this.shape_5330},{t:this.shape_5329},{t:this.shape_5328},{t:this.shape_5327},{t:this.shape_5326},{t:this.shape_5325},{t:this.shape_5324},{t:this.shape_5323},{t:this.shape_5322},{t:this.shape_5321},{t:this.shape_5320},{t:this.shape_5319},{t:this.shape_5318},{t:this.shape_5317},{t:this.shape_5316},{t:this.shape_5315},{t:this.shape_5314},{t:this.shape_5313},{t:this.shape_5312},{t:this.shape_5311},{t:this.shape_5310},{t:this.shape_5309},{t:this.shape_5308},{t:this.shape_5307},{t:this.shape_5306},{t:this.shape_5305},{t:this.shape_5304},{t:this.shape_5303},{t:this.shape_5302},{t:this.shape_5301},{t:this.shape_5300},{t:this.shape_5299},{t:this.shape_5298},{t:this.shape_5297},{t:this.shape_5296},{t:this.shape_5295},{t:this.shape_5294},{t:this.shape_5293},{t:this.shape_5292},{t:this.shape_5291},{t:this.shape_5290},{t:this.shape_5289},{t:this.shape_5288},{t:this.shape_5287},{t:this.shape_5286},{t:this.shape_5285},{t:this.shape_5284},{t:this.shape_5283},{t:this.shape_5282},{t:this.shape_5281},{t:this.shape_5280},{t:this.shape_5279},{t:this.shape_5278},{t:this.shape_5277},{t:this.shape_5276},{t:this.shape_5275},{t:this.shape_5274},{t:this.shape_5273},{t:this.shape_5272},{t:this.shape_5271},{t:this.shape_5270},{t:this.shape_5269},{t:this.shape_5268},{t:this.shape_5267},{t:this.shape_5266},{t:this.shape_5265},{t:this.shape_5264},{t:this.shape_5263},{t:this.shape_5262},{t:this.shape_5261},{t:this.shape_5260},{t:this.shape_5259},{t:this.shape_5258},{t:this.shape_5257},{t:this.shape_5256},{t:this.shape_5255},{t:this.shape_5254},{t:this.shape_5253},{t:this.shape_5252},{t:this.shape_5251},{t:this.shape_5250},{t:this.shape_5249},{t:this.shape_5248},{t:this.shape_5247},{t:this.shape_5246},{t:this.shape_5245},{t:this.shape_5244},{t:this.shape_5243},{t:this.shape_5242},{t:this.shape_5241},{t:this.shape_5240},{t:this.shape_5239},{t:this.shape_5238},{t:this.shape_5237},{t:this.shape_5236},{t:this.shape_5235},{t:this.shape_5234},{t:this.shape_5233},{t:this.shape_5232},{t:this.shape_5231},{t:this.shape_5230},{t:this.shape_5229},{t:this.shape_5228},{t:this.shape_5227},{t:this.shape_5226},{t:this.shape_5225},{t:this.shape_5224},{t:this.shape_5223},{t:this.shape_5222},{t:this.shape_5221},{t:this.shape_5220},{t:this.shape_5219},{t:this.shape_5218},{t:this.shape_5217},{t:this.shape_5216},{t:this.shape_5215},{t:this.shape_5214},{t:this.shape_5213},{t:this.shape_5212},{t:this.shape_5211},{t:this.shape_5210},{t:this.shape_5209},{t:this.shape_5208},{t:this.shape_5207},{t:this.shape_5206},{t:this.shape_5205},{t:this.shape_5204},{t:this.shape_5203},{t:this.shape_5202},{t:this.shape_5201},{t:this.shape_5200},{t:this.shape_5199},{t:this.shape_5198},{t:this.shape_5197},{t:this.shape_5196},{t:this.shape_5195},{t:this.shape_5194},{t:this.shape_5193},{t:this.shape_5192},{t:this.shape_5191},{t:this.shape_5190},{t:this.shape_5189},{t:this.shape_5188},{t:this.shape_5187},{t:this.shape_5186},{t:this.shape_5185},{t:this.shape_5184},{t:this.shape_5183},{t:this.shape_5182},{t:this.instance_25}]},54).to({state:[]},1).wait(110));

	// ButtonLeftRight copy 14
	this.buttonR6 = new lib.ButtonLeft_Right();
	this.buttonR6.name = "buttonR6";
	this.buttonR6.parent = this;
	this.buttonR6.setTransform(2025,513.5,1,1,180);
	this.buttonR6._off = true;
	new cjs.ButtonHelper(this.buttonR6, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR6).wait(53).to({_off:false},0).to({_off:true},1).wait(111));

	// ButtonLeftRight copy 15
	this.buttonL6 = new lib.ButtonLeft_Right();
	this.buttonL6.name = "buttonL6";
	this.buttonL6.parent = this;
	this.buttonL6.setTransform(0,437.2);
	this.buttonL6._off = true;
	new cjs.ButtonHelper(this.buttonL6, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL6).wait(53).to({_off:false},0).to({_off:true},1).wait(111));

	// Layer 1
	this.shape_5602 = new cjs.Shape();
	this.shape_5602.graphics.f("#231F20").s().p("AgEAGQgCgCAAgEQAAgDACgBQABgBAAAAQABgBAAAAQABAAABAAQAAgBAAAAQADABACACQACABAAADQAAADgCADQgCABgDAAQAAAAAAAAQgBAAgBAAQAAAAgBgBQAAAAgBAAg");
	this.shape_5602.setTransform(1709.6,534,0.5,0.5);

	this.shape_5603 = new cjs.Shape();
	this.shape_5603.graphics.f("#231F20").s().p("AglBlQgOgGgLgMQgJgLgEgQQgFgRAAgQIAAiDIAHAAIAACBQAAALACAQQADANAIANQAIAMAPAJQAPAHAWAAQAYAAAOgHQAOgIAIgMQAIgMADgPQADgOAAgNIAAiBIAGAAIAACDQAAASgEAPQgDAPgLAMQgKAMgPAGQgPAIgWgBQgVABgQgIg");
	this.shape_5603.setTransform(1697.5,529.2,0.5,0.5);

	this.shape_5604 = new cjs.Shape();
	this.shape_5604.graphics.f("#231F20").s().p("AgqBnQgVgJgOgOQgPgQgHgTQgJgVABgYQgBgXAJgVQAHgSAPgRQAOgPAVgIQAUgJAWAAQAWAAAWAJQAUAIANAPQAQAQAHATQAJAXgBAVQABAXgJAWQgHATgQAQQgOAOgUAJQgUAIgXAAQgWAAgUgIgAgohgQgTAIgNAOQgOAPgIASQgHAUAAAVQAAAWAHATQAIATANAPQAOAOASAIQAUAJAVgBQAWABATgJQATgIAOgOQANgPAHgTQAIgTAAgWQAAgVgIgUQgHgSgOgPQgNgOgTgIQgUgJgVAAQgUAAgUAJg");
	this.shape_5604.setTransform(1680.2,529,0.5,0.5);

	this.shape_5605 = new cjs.Shape();
	this.shape_5605.graphics.f("#231F20").s().p("AgCBpIAAhcIhJh2IAIAAIBDBvIBEhvIAIAAIhJB2IAABcg");
	this.shape_5605.setTransform(1664.8,529,0.5,0.5);

	this.shape_5606 = new cjs.Shape();
	this.shape_5606.graphics.f("#231F20").s().p("Ag7BpIAAjSIB3AAIAAAHIhwAAIAABcIBoAAIAAAGIhoAAIAABpg");
	this.shape_5606.setTransform(1643,529,0.5,0.5);

	this.shape_5607 = new cjs.Shape();
	this.shape_5607.graphics.f("#231F20").s().p("AgrBnQgUgJgOgOQgPgPgHgUQgJgUABgZQgBgYAJgUQAHgUAPgPQAOgPAUgIQAVgJAWAAQAXAAAUAJQAVAIANAPQAPAPAIAUQAJAVAAAXQAAAYgJAVQgIAUgPAPQgOAOgUAJQgVAIgWAAQgVAAgWgIgAgphgQgSAHgNAPQgOAPgIASQgHAUAAAVQAAAWAHATQAHASAOAQQAOAPASAHQAUAJAVgBQAWABATgJQAUgIAMgOQAPgQAGgSQAIgSgBgXQABgUgIgVQgHgSgOgPQgOgPgSgHQgUgJgVAAQgUAAgVAJg");
	this.shape_5607.setTransform(1626.7,529,0.5,0.5);

	this.shape_5608 = new cjs.Shape();
	this.shape_5608.graphics.f("#231F20").s().p("AgCBpIAAjLIhIAAIAAgHICVAAIAAAHIhHAAIAADLg");
	this.shape_5608.setTransform(1602.2,529,0.5,0.5);

	this.shape_5609 = new cjs.Shape();
	this.shape_5609.graphics.f("#231F20").s().p("AA4BpIg+hpIgyAAIAABpIgHAAIAAjSIA7AAQAMAAAKACQANADAJAFQAKAHAFAKQAGAKAAAQQAAAPgGAKQgFAJgKAGQgJAHgKACQgLADgKAAIA/BpgAg4gGIA0AAQAbAAAQgMQAQgNAAgVQAAgOgGgJQgFgJgJgFQgJgGgMgBQgMgDgKAAIgwAAg");
	this.shape_5609.setTransform(1588.9,529,0.5,0.5);

	this.shape_5610 = new cjs.Shape();
	this.shape_5610.graphics.f("#231F20").s().p("ABWBpIgZg8Ih5AAIgaA8IgHAAIBbjSIAIAAIBYDSgAg6AnIB1AAIg5iMg");
	this.shape_5610.setTransform(1573.9,529,0.5,0.5);

	this.shape_5611 = new cjs.Shape();
	this.shape_5611.graphics.f("#231F20").s().p("AgEAGQgCgCAAgEQAAgDACgBQACgCACgBQABAAAAABQABAAABAAQAAAAABABQAAAAABABQACABAAADQAAAEgCACQgBAAAAAAQgBABAAAAQgBAAgBAAQAAAAgBAAQgCAAgCgBg");
	this.shape_5611.setTransform(1553.5,534,0.5,0.5);

	this.shape_5612 = new cjs.Shape();
	this.shape_5612.graphics.f("#231F20").s().p("AgCBpIAAhcIhJh2IAIAAIBDBvIBEhvIAIAAIhJB2IAABcg");
	this.shape_5612.setTransform(1543.6,529,0.5,0.5);

	this.shape_5613 = new cjs.Shape();
	this.shape_5613.graphics.f("#231F20").s().p("AA4BpIg/hpIgxAAIAABpIgHAAIAAjSIA7AAQAMAAAKACQAMADAKAFQAKAIAFAJQAGAKAAAQQAAAPgGAKQgFAJgJAGQgKAHgKACQgLADgKAAIBABpgAg4gGIA0AAQAcAAAPgMQAPgMAAgWQAAgPgFgIQgGgKgIgEQgJgGgLgBQgNgDgKAAIgwAAg");
	this.shape_5613.setTransform(1530.3,529,0.5,0.5);

	this.shape_5614 = new cjs.Shape();
	this.shape_5614.graphics.f("#231F20").s().p("Ag3BpIAAjSIAHAAIAADNIBoAAIAAAFg");
	this.shape_5614.setTransform(1517.2,529,0.5,0.5);

	this.shape_5615 = new cjs.Shape();
	this.shape_5615.graphics.f("#231F20").s().p("Ag/BpIAAjSIB6AAIAAAHIh0AAIAABcIBtAAIAAAGIhtAAIAABkIB5AAIAAAFg");
	this.shape_5615.setTransform(1503.5,529,0.5,0.5);

	this.shape_5616 = new cjs.Shape();
	this.shape_5616.graphics.f("#231F20").s().p("AA9BpIg9jLIAAAAIg7DLIgLAAIg/jSIAHAAIA8DNIABAAIA9jNIAIAAIA+DNIABAAIA8jNIAHAAIg/DSg");
	this.shape_5616.setTransform(1486.3,529,0.5,0.5);

	this.shape_5617 = new cjs.Shape();
	this.shape_5617.graphics.f("#231F20").s().p("Ag/BpIAAjSIB6AAIAAAHIhzAAIAABcIBsAAIAAAGIhsAAIAABkIB4AAIAAAFg");
	this.shape_5617.setTransform(1469.9,529,0.5,0.5);

	this.shape_5618 = new cjs.Shape();
	this.shape_5618.graphics.f("#231F20").s().p("AghBiQgNgKgFgNIAGgDQAFANAMAJQAMAIAPAAQAMAAAJgEQAIgFAHgHQAFgJACgKQAEgKgBgNIAAiXIAHAAIAACYQAAAdgOARQgOARgZAAQgSAAgOgKg");
	this.shape_5618.setTransform(1455.7,529.1,0.5,0.5);

	this.shape_5619 = new cjs.Shape();
	this.shape_5619.graphics.f("#231F20").s().p("Ag7BpIAAjSIB3AAIAAAHIhxAAIAABcIBpAAIAAAGIhpAAIAABpg");
	this.shape_5619.setTransform(1434.8,529,0.5,0.5);

	this.shape_5620 = new cjs.Shape();
	this.shape_5620.graphics.f("#231F20").s().p("AgqBnQgUgJgPgOQgOgPgIgUQgJgVAAgYQAAgXAJgVQAIgUAOgPQAPgPAUgIQAUgJAWAAQAXAAAUAJQAVAIANAPQAPAPAJAUQAHAUABAYQgBAZgHAUQgJAVgPAOQgNAOgVAJQgUAIgXAAQgWAAgUgIgAgohgQgTAIgOAOQgNAPgHASQgIAUAAAVQAAAWAIATQAGASAOAQQANAOAUAIQATAJAVgBQAWABAUgJQASgHAOgPQAOgQAGgSQAIgTAAgWQAAgVgIgUQgHgSgNgPQgOgOgTgIQgUgJgVAAQgUAAgUAJg");
	this.shape_5620.setTransform(1418.4,529,0.5,0.5);

	this.shape_5621 = new cjs.Shape();
	this.shape_5621.graphics.f("#231F20").s().p("AgDBpIAAjLIhHAAIAAgHICVAAIAAAHIhIAAIAADLg");
	this.shape_5621.setTransform(1393.9,529,0.5,0.5);

	this.shape_5622 = new cjs.Shape();
	this.shape_5622.graphics.f("#231F20").s().p("AA4BpIg/hpIgxAAIAABpIgHAAIAAjSIA7AAQAMAAAKACQAMADAKAFQAJAHAGAKQAGAKAAAQQAAAPgGAKQgGAKgIAFQgKAHgKACQgLADgKAAIBABpgAg4gGIAzAAQAdAAAPgMQAPgMAAgWQAAgPgFgIQgGgKgIgEQgKgGgKgBQgOgDgJAAIgwAAg");
	this.shape_5622.setTransform(1380.7,529,0.5,0.5);

	this.shape_5623 = new cjs.Shape();
	this.shape_5623.graphics.f("#231F20").s().p("ABXBpIgZg8Ih6AAIgaA8IgHAAIBcjSIAHAAIBYDSgAg5AnIB1AAIg6iMg");
	this.shape_5623.setTransform(1365.6,529,0.5,0.5);

	this.shape_5624 = new cjs.Shape();
	this.shape_5624.graphics.f("#231F20").s().p("AgEAGQgCgCAAgEQAAgDACgBQABgBAAAAQABgBAAAAQABAAAAAAQABgBAAAAQADABACACQACABAAADQAAADgDADQAAAAgBAAQAAABgBAAQAAAAgBAAQgBAAAAAAQAAAAgBAAQAAAAgBAAQAAAAgBgBQAAAAgBAAg");
	this.shape_5624.setTransform(1345.3,534,0.5,0.5);

	this.shape_5625 = new cjs.Shape();
	this.shape_5625.graphics.f("#231F20").s().p("Ag/BpIAAjSIB6AAIAAAHIh0AAIAABcIBtAAIAAAGIhtAAIAABkIB5AAIAAAFg");
	this.shape_5625.setTransform(1334.2,529,0.5,0.5);

	this.shape_5626 = new cjs.Shape();
	this.shape_5626.graphics.f("#231F20").s().p("AA4BpIg/hpIgxAAIAABpIgHAAIAAjSIA7AAQAMAAAKACQAMADAKAFQAJAHAGAKQAGAKAAAQQAAAPgGAKQgGAKgIAFQgKAHgKACQgLADgKAAIBABpgAg4gGIA0AAQAcAAAPgMQAPgMAAgWQAAgPgFgIQgGgKgIgEQgJgGgLgBQgOgDgJAAIgwAAg");
	this.shape_5626.setTransform(1320,529,0.5,0.5);

	this.shape_5627 = new cjs.Shape();
	this.shape_5627.graphics.f("#231F20").s().p("AgkBlQgPgGgLgMQgKgMgDgPQgFgPAAgSIAAiDIAHAAIAACBQAAALACAQQADANAIANQAIAMAOAJQAQAHAWAAQAYAAAOgHQAOgIAJgMQAHgMADgPQADgOAAgNIAAiBIAHAAIAACDQAAAQgFARQgEAQgJALQgLAMgPAGQgPAIgWgBQgVABgPgIg");
	this.shape_5627.setTransform(1304.5,529.2,0.5,0.5);

	this.shape_5628 = new cjs.Shape();
	this.shape_5628.graphics.f("#231F20").s().p("AgCBpIAAjLIhIAAIAAgHICVAAIAAAHIhHAAIAADLg");
	this.shape_5628.setTransform(1289.7,529,0.5,0.5);

	this.shape_5629 = new cjs.Shape();
	this.shape_5629.graphics.f("#231F20").s().p("ABXBpIgZg8Ih6AAIgaA8IgHAAIBcjSIAHAAIBYDSgAg5AnIB1AAIg7iMg");
	this.shape_5629.setTransform(1276.3,529,0.5,0.5);

	this.shape_5630 = new cjs.Shape();
	this.shape_5630.graphics.f("#231F20").s().p("ABLBpIiXjJIgBAAIAADJIgGAAIAAjSIAJAAICXDKIABAAIAAjKIAGAAIAADSg");
	this.shape_5630.setTransform(1260.3,529,0.5,0.5);

	this.shape_5631 = new cjs.Shape();
	this.shape_5631.graphics.f("#231F20").s().p("Ag7BpIAAjSIB3AAIAAAHIhwAAIAABcIBoAAIAAAGIhoAAIAABpg");
	this.shape_5631.setTransform(1236.4,529,0.5,0.5);

	this.shape_5632 = new cjs.Shape();
	this.shape_5632.graphics.f("#231F20").s().p("AgqBnQgUgIgPgPQgOgPgIgUQgIgUAAgZQAAgYAIgUQAIgUAOgPQAPgPAUgIQAUgJAWAAQAXAAAUAJQAUAIAPAPQAOAPAIAUQAIAUAAAYQAAAZgIAUQgIAUgOAPQgPAOgUAJQgVAIgWAAQgVAAgVgIgAgohgQgTAHgNAPQgOAPgHASQgIAUAAAVQAAAVAHAUQAHASAOAQQAOAPASAHQAUAJAVgBQAWABAUgJQASgHAOgPQAOgQAHgSQAHgUAAgVQAAgVgIgUQgHgSgOgPQgNgPgTgHQgUgJgVAAQgUAAgUAJg");
	this.shape_5632.setTransform(1220,529,0.5,0.5);

	this.shape_5633 = new cjs.Shape();
	this.shape_5633.graphics.f("#231F20").s().p("AgCBpIAAjLIhIAAIAAgHICVAAIAAAHIhIAAIAADLg");
	this.shape_5633.setTransform(1195.6,529,0.5,0.5);

	this.shape_5634 = new cjs.Shape();
	this.shape_5634.graphics.f("#231F20").s().p("AA4BpIg/hpIgxAAIAABpIgGAAIAAjSIA5AAQANAAAKACQAMADAJAFQALAIAFAJQAGAKAAAQQAAAPgGAKQgFAJgKAGQgJAHgLACQgKADgKAAIA/BpgAg4gGIAzAAQAcAAAQgMQAPgMAAgWQAAgPgFgIQgGgJgIgFQgJgGgLgBQgNgDgKAAIgwAAg");
	this.shape_5634.setTransform(1182.3,529,0.5,0.5);

	this.shape_5635 = new cjs.Shape();
	this.shape_5635.graphics.f("#231F20").s().p("ABXBpIgZg8Ih6AAIgaA8IgHAAIBcjSIAHAAIBYDSgAg6AnIB2AAIg7iMg");
	this.shape_5635.setTransform(1167.3,529,0.5,0.5);

	this.shape_5636 = new cjs.Shape();
	this.shape_5636.graphics.f("#231F20").s().p("AjoCsIFck1IAigaQAngUAbAeQAcAfgRAeQgJAPgOAJIl5Dwg");
	this.shape_5636.setTransform(1641.4,396.7,0.5,0.5);

	this.shape_5637 = new cjs.Shape();
	this.shape_5637.graphics.f("#231F20").s().p("ADvKbQiBgDhAAAQmiAIiCAAIAAgyIAyAAQBZAAAfgaQAjgdAAhXIAAvHQAAhXgjgeQgfgbhZgBIg1AAIAAgmQEuAGEZAAQBmAABSgCIC4gEIAEDjIgoAAQgZhpgjgaQgggYhsgCIk6AAIAAIgIEAAAQBfABAOgHQAigOAGhMIAoAAIAAEcIgoAAQgEhYgrgfQgkgZhcAAIjmAAIAAH/QAAA9AdAYQAdAZBHAAIDTAAQBhAAAwgvQAighAzhwIAoAAIgnD/IjkgFg");
	this.shape_5637.setTransform(1633.1,453.2,0.5,0.5);

	this.shape_5638 = new cjs.Shape();
	this.shape_5638.graphics.f("#231F20").s().p("ACUKfQhYgDg9AAQg+AAhhADIifAEIAAgkIBIAAQBXAAAbgcQAbgbAAhaIAAmRQgEhcgehzQg7joiBh2QhqhghIgfQhWgmiQABIBEgXQBQgXA3AAQDxADC8DiQA+BMA6CKQAdBFAQA2QASgvAchBQA6iCA5hZQBIhwBpg7QBGgnBMgLQA+gIBHASQAkAJAXALQgcgEgkgDQhJgEgrANQhhAcg7AuQhEAzg5BiQhgClgvCsQgYBVgEA1IAAGoQAABaAaAbQAaAcBVAAIA4AAIAAAkIiWgEg");
	this.shape_5638.setTransform(1550.3,453.1,0.5,0.5);

	this.shape_5639 = new cjs.Shape();
	this.shape_5639.graphics.f("#231F20").s().p("ACMKcQhYgDg8AAQg+AAhYADIiWAEIAAgkIARAAQBfAAAtgbQA3gjAAhTIAAvTQAAhVgsggQgmgbhcgBIgUAAIAAgmICWAEQBcACA5AAQBlAADHgGIAAAmIgRAAQhgABgsAbQg4AhAABUIAAPTQABBVAsAhQAmAbBcAAIATAAIAAAkIiWgEg");
	this.shape_5639.setTransform(1472.7,453.3,0.5,0.5);

	this.shape_5640 = new cjs.Shape();
	this.shape_5640.graphics.f("#231F20").s().p("AI9KmIvqw3IAJN+QACBIAlAhQAmAhBSAAIAnAAIAAAkIidgFIhXgCIkGAHIAAgkIA2AAQA9AAApgpQApgoAAg7IgCv3QhLhMgwgWQgpgShMgBIAAgkIACAAIBXAFQA4ACAfAAQAZAACKgHIO1QFIAGtBQgChVgoglQgogmhbAAIgfAAIAAgkIB2AFQBIACAsAAQBLAACUgHIAAAkIgaAAQhEAAgoAdQgsAfAAA3IgBS0g");
	this.shape_5640.setTransform(1390.2,453.5,0.5,0.5);

	this.shape_5641 = new cjs.Shape();
	this.shape_5641.graphics.f("#231F20").s().p("AHeKlQivAAiIAHIAAgoIBFAAQAlAAAVgRQAWgSAAgdQAAgogMgZIhtlUInoAAIiIExQgVA0APAuQAMAkANAMQATASAuAAIBGAAIAAAoQingHhNAAQicAAhFAHIAAgoIAtAAQBJAAAtgcQArgdAbhCIIDy0IArAAIHGReQA7CJAkAlQAgAjBGAAIAvAAIAAAoQicgHhvAAgAkNBvIGzAAIjEoug");
	this.shape_5641.setTransform(1295.5,452.6,0.5,0.5);

	this.shape_5642 = new cjs.Shape();
	this.shape_5642.graphics.f("#231F20").s().p("AlqNCIAygkQA7gvAyg6QCei5AAjaIAAu7QAAhggagpQgfgvhRAAIhRAAIAAgjICeAFQBjACA7AAQBoAADPgHIAAAjIg7AAQhTAAgfAvQgaAoAABhIAAO4QAAC5jEC4QiFB9jFBog");
	this.shape_5642.setTransform(1226.2,463.9,0.5,0.5);

	this.shape_5643 = new cjs.Shape();
	this.shape_5643.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5643.setTransform(775.1,558.6,0.5,0.5);

	this.shape_5644 = new cjs.Shape();
	this.shape_5644.graphics.f("#000000").s().p("AhVCjQgdgaAAgwQAAghAVgYQAVgZArgQQgpgUgQgUQgQgVAAgdQAAgbANgTQAOgVAXgKQAYgLAcAAQAvAAAbAYQAdAYAAAoQAAAbgSAWQgRAVgoATQAwATATAXQAUAXAAAiQAAAtggAbQgfAbg0AAQg2AAgfgZgAhFAnQgUAWAAAgQAAAiAYATQAWATArAAQAoAAAZgUQAZgVAAghQAAgegUgVQgUgTg2gVQgvATgSAUgAg4iTQgVARAAAfQAAASAIAMQAHANAPAMQAQALAhAOQAogQASgTQASgTAAgaQAAgfgVgRQgWgRgjgBQgiABgWARg");
	this.shape_5644.setTransform(764.8,550.4,0.5,0.5);

	this.shape_5645 = new cjs.Shape();
	this.shape_5645.graphics.f("#000000").s().p("AhTCRQgggrAAhLQAAhFAUgxQATgwAkgYQAjgXAxAAQAZAAASAFIAAAWQgTgHgZAAQg8AAgjAtQgiArgEBVIADAAQASgXAZgNQAagNAZAAQAzAAAdAeQAdAdAAAyQAAA3gfAhQgeAggzAAQg2AAghgqgAgogKQgWALgMASQgNASAAAUQAAAbAMAaQANAaAUAOQAVAPAZAAQApAAAWgZQAXgaAAgvQAAgqgXgYQgWgWgnAAQgYAAgWALg");
	this.shape_5645.setTransform(750.4,550.4,0.5,0.5);

	this.shape_5646 = new cjs.Shape();
	this.shape_5646.graphics.f("#000000").s().p("AhcC1IAAgWQALAEAPACQANACAKAAQA8AAAjgtQAjgsAEhUIgDAAQgTAXgZAMQgZANgaAAQgzAAgcgcQgcgaAAg0QAAg3AfgiQAfghAxAAQAkAAAaASQAaASAQAlQAOAmAAAxQAABFgTAyQgTAwgjAXQgkAXgyAAQgbAAgVgGgAhBiKQgYAbAAAuQAAArAWAWQAWAWAoAAQAYAAAWgMQAVgKANgSQANgSAAgUQAAgdgLgaQgMgZgVgOQgVgPgaAAQgnAAgXAbg");
	this.shape_5646.setTransform(735.6,550.4,0.5,0.5);

	this.shape_5647 = new cjs.Shape();
	this.shape_5647.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIhUBDIgOgRIBihKIAVAAIAAFrg");
	this.shape_5647.setTransform(719.4,550.5,0.5,0.5);

	this.shape_5648 = new cjs.Shape();
	this.shape_5648.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQABA5AZAdQAYAdAwAAQAWAAASgDQAUgEAZgKIAAAXQgYAKgSADQgTAEgYAAQg7AAggglgAg3hbQgXAZgEAwICmAAQAAgtgUgcQgVgbgjABQgmAAgZAag");
	this.shape_5648.setTransform(700.3,552.8,0.5,0.5);

	this.shape_5649 = new cjs.Shape();
	this.shape_5649.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_5649.setTransform(687.5,552.8,0.5,0.5);

	this.shape_5650 = new cjs.Shape();
	this.shape_5650.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_5650.setTransform(673.7,552.7,0.5,0.5);

	this.shape_5651 = new cjs.Shape();
	this.shape_5651.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_5651.setTransform(663.2,550.3,0.5,0.5);

	this.shape_5652 = new cjs.Shape();
	this.shape_5652.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgNAAgXQAAgUgRgOQgQgPgmgNQgngNgRgLQgSgMgHgMQgJgOAAgSQABgfAZgSQAZgSAuAAQArABAnAQIgJAXQgngRgiAAQghAAgTALQgTALAAAUQgBAVAQAMQAPAMAqAQQAkANASAKQAQALAJAOQAIAMAAATQAAAkgbAUQgcATgyABQg3AAgfgRg");
	this.shape_5652.setTransform(654.3,552.8,0.5,0.5);

	this.shape_5653 = new cjs.Shape();
	this.shape_5653.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5653.setTransform(637.8,552.7,0.5,0.5);

	this.shape_5654 = new cjs.Shape();
	this.shape_5654.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg7AAggglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_5654.setTransform(624.9,552.8,0.5,0.5);

	this.shape_5655 = new cjs.Shape();
	this.shape_5655.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5655.setTransform(615,550.3,0.5,0.5);

	this.shape_5656 = new cjs.Shape();
	this.shape_5656.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5656.setTransform(609.3,549.9,0.5,0.5);

	this.shape_5657 = new cjs.Shape();
	this.shape_5657.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg7AAggglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_5657.setTransform(599.4,552.8,0.5,0.5);

	this.shape_5658 = new cjs.Shape();
	this.shape_5658.graphics.f("#000000").s().p("AgSCYQgRgVAAgoIAAiuIgoAAIAAgOIAogLIANg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAfAJAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5658.setTransform(587.9,551.3,0.5,0.5);

	this.shape_5659 = new cjs.Shape();
	this.shape_5659.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_5659.setTransform(576.2,550.4,0.5,0.5);

	this.shape_5660 = new cjs.Shape();
	this.shape_5660.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgoA2AAQAvAAAcAiQAbAiABA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAKgUADQgRAEgaAAQg5AAgiglgAg2hbQgYAZgEAwICmAAQAAgugUgbQgVgbgjABQgnAAgXAag");
	this.shape_5660.setTransform(554.9,552.8,0.5,0.5);

	this.shape_5661 = new cjs.Shape();
	this.shape_5661.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_5661.setTransform(540.5,549.9,0.5,0.5);

	this.shape_5662 = new cjs.Shape();
	this.shape_5662.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5662.setTransform(528.4,551.3,0.5,0.5);

	this.shape_5663 = new cjs.Shape();
	this.shape_5663.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAiuIgoAAIAAgOIAogLIANg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAPQAKAPAYgBQAZAAAQgDIAAATQgSAGgYABQgjAAgQgTg");
	this.shape_5663.setTransform(513.3,551.3,0.5,0.5);

	this.shape_5664 = new cjs.Shape();
	this.shape_5664.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5664.setTransform(502,552.8,0.5,0.5);

	this.shape_5665 = new cjs.Shape();
	this.shape_5665.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgMgFgIgJQgHgKAAgMQAAgaAigVQgYgKgMgVQgOgVAAgaQAAgpAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgIAKQgIAKAAAMQAAANAKAFQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgiAXQgjAXg/AAQgzAAgdgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTASAAAiQAAAfATARQAUASAfAAQAhAAASgSQASgRAAggQAAgjgSgRQgTgSggAAQggAAgTATg");
	this.shape_5665.setTransform(482.4,555.7,0.5,0.5);

	this.shape_5666 = new cjs.Shape();
	this.shape_5666.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_5666.setTransform(468.3,552.7,0.5,0.5);

	this.shape_5667 = new cjs.Shape();
	this.shape_5667.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5667.setTransform(457.8,550.3,0.5,0.5);

	this.shape_5668 = new cjs.Shape();
	this.shape_5668.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_5668.setTransform(449.9,549.9,0.5,0.5);

	this.shape_5669 = new cjs.Shape();
	this.shape_5669.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5669.setTransform(438.5,552.7,0.5,0.5);

	this.shape_5670 = new cjs.Shape();
	this.shape_5670.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAggkQAhgmA2AAQA4AAAgAmQAgAmAABAQAABCggAmQghAkg3ABQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_5670.setTransform(425.2,552.8,0.5,0.5);

	this.shape_5671 = new cjs.Shape();
	this.shape_5671.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQAMg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQACgSAShFIApiaIAZAAIhKENg");
	this.shape_5671.setTransform(408.5,552.8,0.5,0.5);

	this.shape_5672 = new cjs.Shape();
	this.shape_5672.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkgBQgvAAgXAZQgXAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_5672.setTransform(385.2,552.7,0.5,0.5);

	this.shape_5673 = new cjs.Shape();
	this.shape_5673.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgoA1AAQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgTAEQgSAEgaAAQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_5673.setTransform(370.6,552.8,0.5,0.5);

	this.shape_5674 = new cjs.Shape();
	this.shape_5674.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAwAAAcAiQAbAiABA4IAAATIjDAAQABA5AZAdQAaAdAuAAQAXAAATgDQATgFAZgJIAAAXQgXAKgTADQgSAEgaAAQg6AAggglgAg3hbQgXAZgEAwICnAAQAAgtgVgcQgUgbglABQgmAAgYAag");
	this.shape_5674.setTransform(356.6,552.8,0.5,0.5);

	this.shape_5675 = new cjs.Shape();
	this.shape_5675.graphics.f("#000000").s().p("Ag0C4QgXgMgOgWIgCAAIgHApIgQAAIAAmCIAZAAIgBCfIABAAQAPgZAWgLQAXgMAdAAQA5AAAcAkQAeAkAABEQAABCgfAmQgeAkg2AAQgdAAgXgMgAhEgiQgVAbAAA/IAAAEQAAA9AWAbQAUAaAvAAQAsAAAVgfQAXgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_5675.setTransform(342.4,550,0.5,0.5);

	this.shape_5676 = new cjs.Shape();
	this.shape_5676.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdgkQAegmA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_5676.setTransform(319.8,550,0.5,0.5);

	this.shape_5677 = new cjs.Shape();
	this.shape_5677.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5677.setTransform(305.4,552.8,0.5,0.5);

	this.shape_5678 = new cjs.Shape();
	this.shape_5678.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5678.setTransform(291.7,549.9,0.5,0.5);

	this.shape_5679 = new cjs.Shape();
	this.shape_5679.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAtAAQArABAoAQIgKAXQgngRgiAAQghAAgTALQgTALAAAUQAAAVAPAMQAQANAqAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_5679.setTransform(271.4,552.8,0.5,0.5);

	this.shape_5680 = new cjs.Shape();
	this.shape_5680.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkNIAVAAIAFAlIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_5680.setTransform(258.1,552.7,0.5,0.5);

	this.shape_5681 = new cjs.Shape();
	this.shape_5681.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5681.setTransform(247.7,550.3,0.5,0.5);

	this.shape_5682 = new cjs.Shape();
	this.shape_5682.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_5682.setTransform(239.7,549.9,0.5,0.5);

	this.shape_5683 = new cjs.Shape();
	this.shape_5683.graphics.f("#000000").s().p("AgSCYQgQgUgBgpIAAiuIgnAAIAAgOIAngLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgAKAPQAMAPAXgBQAZAAAQgDIAAATQgTAGgXABQgiAAgSgTg");
	this.shape_5683.setTransform(228,551.3,0.5,0.5);

	this.shape_5684 = new cjs.Shape();
	this.shape_5684.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5684.setTransform(216.7,552.8,0.5,0.5);

	this.shape_5685 = new cjs.Shape();
	this.shape_5685.graphics.f("#000000").s().p("ABdC2IhelRQgEAZgHAZIhQEfIgWAAIhklrIAbAAIBVFCQAGggAUhGIA+jcIAbAAIBJD8QALAlAHAiIBVlDIAaAAIhlFrg");
	this.shape_5685.setTransform(199,550.5,0.5,0.5);

	this.shape_5686 = new cjs.Shape();
	this.shape_5686.graphics.f("#000000").s().p("AgdA+QAThEAIg3IAdAAIADAEQgTBBgYA2g");
	this.shape_5686.setTransform(177.9,559.7,0.5,0.5);

	this.shape_5687 = new cjs.Shape();
	this.shape_5687.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAbAiAAA4IAAATIjBAAQABA5AZAdQAYAdAwAAQAWAAASgDQAUgFAYgJIAAAXQgWAKgUADQgRAEgZAAQg7AAghglgAg2hbQgYAZgEAwICmAAQAAgtgUgcQgUgbgkABQgmAAgYAag");
	this.shape_5687.setTransform(168.5,552.8,0.5,0.5);

	this.shape_5688 = new cjs.Shape();
	this.shape_5688.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAWgLAXAAQBAAAASAwIABAAQANgXAWgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5688.setTransform(150.3,552.7,0.5,0.5);

	this.shape_5689 = new cjs.Shape();
	this.shape_5689.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5689.setTransform(136.1,550.3,0.5,0.5);

	this.shape_5690 = new cjs.Shape();
	this.shape_5690.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgnAAIAAgOIAngLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQABAgAJAPQAMAPAXgBQAZAAAQgDIAAATQgTAGgXABQgiAAgSgTg");
	this.shape_5690.setTransform(128.8,551.3,0.5,0.5);

	this.shape_5691 = new cjs.Shape();
	this.shape_5691.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgSgMgHgMQgJgOAAgSQABgfAZgSQAZgSAuAAQArABAnAQIgJAXQgngRgiAAQghAAgTALQgUALABAUQgBAVAQAMQAPAMAqAQQAkANASAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3AAgfgRg");
	this.shape_5691.setTransform(112.1,552.8,0.5,0.5);

	this.shape_5692 = new cjs.Shape();
	this.shape_5692.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5692.setTransform(103.3,550.3,0.5,0.5);

	this.shape_5693 = new cjs.Shape();
	this.shape_5693.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5693.setTransform(93,549.9,0.5,0.5);

	this.shape_5694 = new cjs.Shape();
	this.shape_5694.graphics.f("#000000").s().p("AgRCYQgRgUgBgpIAAiuIgnAAIAAgOIAngLIANg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQgBAgAKAPQAMAPAXgBQAZAAAPgDIAAATQgSAGgWABQgjAAgRgTg");
	this.shape_5694.setTransform(81,551.3,0.5,0.5);

	this.shape_5695 = new cjs.Shape();
	this.shape_5695.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgLQAIgMALgcIAMgkIhnkNIAZAAIA6CXQAYBAAJAeIABAAQAMgnAVg4IA6iWIAZAAIh4E5QgPAngKAMQgKAOgNAHQgNAGgUAAQgPAAgQgEg");
	this.shape_5695.setTransform(64.4,555.9,0.5,0.5);

	this.shape_5696 = new cjs.Shape();
	this.shape_5696.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBCAAAgAXQAgAWAAAvQAAAggUAVQgTAVglAGIAAABQArAGAVAVQAVAWAAAlQAAAygiAbQghAbg8AAgAheCfIBWAAQBkAAAAhRQAAhMhpABIhRAAgAhegTIBRAAQAyAAAXgRQAYgSAAgkQAAgjgbgRQgagQgzAAIhKAAg");
	this.shape_5696.setTransform(51.1,550.5,0.5,0.5);

	this.shape_5697 = new cjs.Shape();
	this.shape_5697.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAZgUAAQgTAAAAgZg");
	this.shape_5697.setTransform(868.9,520.3,0.5,0.5);

	this.shape_5698 = new cjs.Shape();
	this.shape_5698.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5698.setTransform(858.6,514.5,0.5,0.5);

	this.shape_5699 = new cjs.Shape();
	this.shape_5699.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5699.setTransform(847.9,513,0.5,0.5);

	this.shape_5700 = new cjs.Shape();
	this.shape_5700.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5700.setTransform(836.6,514.5,0.5,0.5);

	this.shape_5701 = new cjs.Shape();
	this.shape_5701.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_5701.setTransform(825.2,511.6,0.5,0.5);

	this.shape_5702 = new cjs.Shape();
	this.shape_5702.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_5702.setTransform(810.3,514.7,0.5,0.5);

	this.shape_5703 = new cjs.Shape();
	this.shape_5703.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAtAAQArABAoAQIgJAXQgpgRghAAQghAAgTALQgTAMAAATQAAAVAPAMQAQANAqAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_5703.setTransform(796.9,514.5,0.5,0.5);

	this.shape_5704 = new cjs.Shape();
	this.shape_5704.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAiuIgpAAIAAgOIApgLIAMg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAPQAKAPAYgBQAZAAAQgDIAAATQgSAGgXABQgkAAgQgTg");
	this.shape_5704.setTransform(786.6,513,0.5,0.5);

	this.shape_5705 = new cjs.Shape();
	this.shape_5705.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5705.setTransform(775.3,514.5,0.5,0.5);

	this.shape_5706 = new cjs.Shape();
	this.shape_5706.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5706.setTransform(758,512.2,0.5,0.5);

	this.shape_5707 = new cjs.Shape();
	this.shape_5707.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAhAAggmQAggoA1AAQAwAAAcAiQAbAiAAA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAKgUADQgRAEgaAAQg5AAgiglgAg2hbQgYAZgEAwICmAAQAAgugUgbQgVgbgkABQgmAAgXAag");
	this.shape_5707.setTransform(733.4,514.5,0.5,0.5);

	this.shape_5708 = new cjs.Shape();
	this.shape_5708.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgMQAHgMALgcIAOgkIhokNIAZAAIA5CXQAaBFAHAZIABAAIAihfIA5iWIAaAAIh4E5QgOAlgLAOQgKAOgOAHQgMAGgTAAQgPAAgRgEg");
	this.shape_5708.setTransform(720.5,517.6,0.5,0.5);

	this.shape_5709 = new cjs.Shape();
	this.shape_5709.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_5709.setTransform(711.8,512.1,0.5,0.5);

	this.shape_5710 = new cjs.Shape();
	this.shape_5710.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgQAAIiHlPIgCAAQACAbAAAkIAAEQIgYAAIAAlrIAnAAICAE/IACAAICBk/IAlAAIAAFrg");
	this.shape_5710.setTransform(697.9,512.2,0.5,0.5);

	this.shape_5711 = new cjs.Shape();
	this.shape_5711.graphics.f("#000000").s().p("AgdA+QAVhJAGgyIAdAAIADAEQgTBBgYA2g");
	this.shape_5711.setTransform(677.1,521.5,0.5,0.5);

	this.shape_5712 = new cjs.Shape();
	this.shape_5712.graphics.f("#000000").s().p("AhGCKIAAkNIAUAAIACAwIACAAQARgdATgNQASgMAbAAQAOAAAWADIgEAYQgRgEgSAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_5712.setTransform(670.7,514.4,0.5,0.5);

	this.shape_5713 = new cjs.Shape();
	this.shape_5713.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA5AYAdQAZAdAwAAQAWAAASgDQAUgEAZgKIAAAXQgXAKgUADQgSAEgYAAQg7AAghglgAg2hbQgYAZgEAwICmAAQAAgtgUgcQgVgbgjABQgmAAgYAag");
	this.shape_5713.setTransform(657.9,514.5,0.5,0.5);

	this.shape_5714 = new cjs.Shape();
	this.shape_5714.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5714.setTransform(648,511.6,0.5,0.5);

	this.shape_5715 = new cjs.Shape();
	this.shape_5715.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AZAeQAZAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAKgUADQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgjABQgmAAgYAag");
	this.shape_5715.setTransform(638.1,514.5,0.5,0.5);

	this.shape_5716 = new cjs.Shape();
	this.shape_5716.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgZAAIhMkNIAaAAIArCcQAOA2AGAfIABAAQANg0AJgZIA4ikIAVAAIA1CjQATA9ADARIACAAQACgSAShFIAoiaIAZAAIhJENg");
	this.shape_5716.setTransform(621.9,514.5,0.5,0.5);

	this.shape_5717 = new cjs.Shape();
	this.shape_5717.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_5717.setTransform(605.7,514.5,0.5,0.5);

	this.shape_5718 = new cjs.Shape();
	this.shape_5718.graphics.f("#000000").s().p("AgwDwIAAgVQAQAEAQAAQAkABAAgtIAAlFIAZAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_5718.setTransform(594.1,515.1,0.5,0.5);

	this.shape_5719 = new cjs.Shape();
	this.shape_5719.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_5719.setTransform(582.2,514.4,0.5,0.5);

	this.shape_5720 = new cjs.Shape();
	this.shape_5720.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAggmQAggoA1AAQAwAAAcAiQAcAhAAA5IAAATIjCAAQAAA5AaAdQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgSADQgTAEgYAAQg7AAggglgAg3hbQgXAZgEAwICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_5720.setTransform(569.4,514.5,0.5,0.5);

	this.shape_5721 = new cjs.Shape();
	this.shape_5721.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5721.setTransform(557.9,513,0.5,0.5);

	this.shape_5722 = new cjs.Shape();
	this.shape_5722.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAmABAWgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgngNgRgLQgRgMgIgMQgIgOAAgSQgBgfAagSQAagSAtAAQArABAoAQIgJAXQgogRgiAAQghAAgTALQgTAMAAATQAAAVAOAMQAQAMArAQQAlAOAQAJQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5722.setTransform(547.8,514.5,0.5,0.5);

	this.shape_5723 = new cjs.Shape();
	this.shape_5723.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAhgVA+gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgUAKQgWALgcAAQgoAAgXgUgAAeAAQg4ACgZAPQgYAPAAAgQABAaAPAOQAPAOAdAAQArAAAZgZQAZgZgBgsIAAgZg");
	this.shape_5723.setTransform(534.7,514.5,0.5,0.5);

	this.shape_5724 = new cjs.Shape();
	this.shape_5724.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAXQgUAXAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAWgLAXAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5724.setTransform(517.2,514.4,0.5,0.5);

	this.shape_5725 = new cjs.Shape();
	this.shape_5725.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5725.setTransform(495.2,514.4,0.5,0.5);

	this.shape_5726 = new cjs.Shape();
	this.shape_5726.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQASgEAbgKIAAAXQgXAJgTAEQgSAEgaAAQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_5726.setTransform(482.4,514.5,0.5,0.5);

	this.shape_5727 = new cjs.Shape();
	this.shape_5727.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAegkQAdgmA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAWgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_5727.setTransform(467.4,511.7,0.5,0.5);

	this.shape_5728 = new cjs.Shape();
	this.shape_5728.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkNIAVAAIAFAlIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_5728.setTransform(452.7,514.4,0.5,0.5);

	this.shape_5729 = new cjs.Shape();
	this.shape_5729.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg3IAAiVIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAABhjg");
	this.shape_5729.setTransform(437.6,514.7,0.5,0.5);

	this.shape_5730 = new cjs.Shape();
	this.shape_5730.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgSgTgjAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5730.setTransform(416,511.6,0.5,0.5);

	this.shape_5731 = new cjs.Shape();
	this.shape_5731.graphics.f("#000000").s().p("AgRCYQgRgUAAgpIAAiuIgpAAIAAgOIApgLIAMg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAPQAKAPAYgBQAZAAAQgDIAAATQgSAGgXABQgkAAgQgTg");
	this.shape_5731.setTransform(404,513,0.5,0.5);

	this.shape_5732 = new cjs.Shape();
	this.shape_5732.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5732.setTransform(397,512.1,0.5,0.5);

	this.shape_5733 = new cjs.Shape();
	this.shape_5733.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgUAXQgTAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQAOgYAWgMQAXgMAbAAQAtAAAWAYQAWAYAAAzIAACwg");
	this.shape_5733.setTransform(383,514.4,0.5,0.5);

	this.shape_5734 = new cjs.Shape();
	this.shape_5734.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmABAWgNQAUgOAAgWQAAgUgQgOQgQgPgmgNQgngNgSgLQgQgLgIgNQgJgOABgSQAAgfAZgSQAagSAsAAQAtABAnAQIgJAXQgogRgjAAQggAAgTALQgTAMgBATQAAAVAPAMQAQANArAPQAjAOARAJQARALAIAOQAJAMAAATQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5734.setTransform(365.6,514.5,0.5,0.5);

	this.shape_5735 = new cjs.Shape();
	this.shape_5735.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5735.setTransform(356.9,511.6,0.5,0.5);

	this.shape_5736 = new cjs.Shape();
	this.shape_5736.graphics.f("#000000").s().p("AhPB4QgVgUAAglQgBgnAigWQAggVA+gBIA0gCIAAgSQgBgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAWgBAyIAACzIgSAAIgFgrIgCAAQgWAbgUAKQgWALgdAAQgoAAgWgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_5736.setTransform(346.8,514.5,0.5,0.5);

	this.shape_5737 = new cjs.Shape();
	this.shape_5737.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgnAAIAAgOIAngLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgAKAPQAMAPAXgBQAZAAAQgDIAAATQgTAGgXABQgiAAgSgTg");
	this.shape_5737.setTransform(336,513,0.5,0.5);

	this.shape_5738 = new cjs.Shape();
	this.shape_5738.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_5738.setTransform(324.9,514.5,0.5,0.5);

	this.shape_5739 = new cjs.Shape();
	this.shape_5739.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgpAAgVAXQgTAXgBAxIAACeIgYAAIAAi4QABhFg/AAQgrAAgTAZQgTAZgBA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBBAAAQAwIABAAQAOgYAWgMQAYgMAbAAQAsAAAWAYQAXAYAAAzIAACwg");
	this.shape_5739.setTransform(306.8,514.4,0.5,0.5);

	this.shape_5740 = new cjs.Shape();
	this.shape_5740.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAwAAAcAiQAcAhAAA5IAAATIjCAAQABA5AZAdQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgSADQgTAEgYAAQg6AAghglgAg3hbQgXAZgEAwICnAAQgBgtgUgcQgVgbgkABQgmAAgYAag");
	this.shape_5740.setTransform(281.8,514.5,0.5,0.5);

	this.shape_5741 = new cjs.Shape();
	this.shape_5741.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5741.setTransform(270.4,513,0.5,0.5);

	this.shape_5742 = new cjs.Shape();
	this.shape_5742.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5742.setTransform(259.1,514.5,0.5,0.5);

	this.shape_5743 = new cjs.Shape();
	this.shape_5743.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5743.setTransform(249.9,512.1,0.5,0.5);

	this.shape_5744 = new cjs.Shape();
	this.shape_5744.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6AAQAkAAAfANIgGAWQgkgMgZAAQgyAAgZAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAkAAAggNIAAAXQgZANgqAAQg6AAghglg");
	this.shape_5744.setTransform(241.2,514.5,0.5,0.5);

	this.shape_5745 = new cjs.Shape();
	this.shape_5745.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhglQAggmA2AAQA5AAAfAmQAgAmAABAQAABBghAnQggAkg3ABQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_5745.setTransform(227.4,514.5,0.5,0.5);

	this.shape_5746 = new cjs.Shape();
	this.shape_5746.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAnABAVgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgogNgQgLQgSgMgHgMQgJgOAAgSQAAgfAagSQAagSAsAAQAtABAmAQIgJAXQgngRgjAAQggAAgTALQgUAMAAATQABAVAPAMQAOAMArAQQAkANASAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5746.setTransform(213.9,514.5,0.5,0.5);

	this.shape_5747 = new cjs.Shape();
	this.shape_5747.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmABAWgNQAUgNAAgXQAAgUgQgOQgQgPgmgNQgngNgSgLQgRgMgHgMQgJgOABgSQAAgfAZgSQAagSAsAAQAtABAnAQIgJAXQgogRgjAAQggAAgTALQgTAMgBATQAAAVAQAMQAPANArAPQAjAOARAJQARAKAJAPQAIAMAAATQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5747.setTransform(202,514.5,0.5,0.5);

	this.shape_5748 = new cjs.Shape();
	this.shape_5748.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5748.setTransform(189,514.5,0.5,0.5);

	this.shape_5749 = new cjs.Shape();
	this.shape_5749.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_5749.setTransform(168.6,514.4,0.5,0.5);

	this.shape_5750 = new cjs.Shape();
	this.shape_5750.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5750.setTransform(153.8,514.5,0.5,0.5);

	this.shape_5751 = new cjs.Shape();
	this.shape_5751.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAsAAQAsABAoAQIgKAXQgngRgjAAQggAAgTALQgTALAAAUQAAAVAPAMQAPANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5751.setTransform(134.8,514.5,0.5,0.5);

	this.shape_5752 = new cjs.Shape();
	this.shape_5752.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5752.setTransform(121.8,514.5,0.5,0.5);

	this.shape_5753 = new cjs.Shape();
	this.shape_5753.graphics.f("#000000").s().p("AhMChQghgkAAhBQAAhAAfgnQAhgnA0AAQAwAAAcAhQAbAiAAA4IAAAUIjCAAQABA4AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg6AAghglgAg2giQgYAZgEAwICmAAQAAgtgUgcQgVgagkAAQgmAAgXAagAgbhzIAAgEQARgSASgZQASgWAHgNIAjAAIAAAEQgKAOgVAVQgaAZgUASg");
	this.shape_5753.setTransform(101.9,511.7,0.5,0.5);

	this.shape_5754 = new cjs.Shape();
	this.shape_5754.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAKgHAHgLQAIgMALgcIAMgkIhnkNIAaAAIA4CXQAZBAAJAeIABAAQAMgnAWg4IA5iWIAZAAIh4E5QgPAngKAMQgKAPgNAGQgNAGgUAAQgOAAgRgEg");
	this.shape_5754.setTransform(89,517.6,0.5,0.5);

	this.shape_5755 = new cjs.Shape();
	this.shape_5755.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHAAQgPAAAAgYg");
	this.shape_5755.setTransform(80.3,512.1,0.5,0.5);

	this.shape_5756 = new cjs.Shape();
	this.shape_5756.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgSgSgjgBQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkNIAUAAIAFAlIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_5756.setTransform(70,514.4,0.5,0.5);

	this.shape_5757 = new cjs.Shape();
	this.shape_5757.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5757.setTransform(55.1,514.5,0.5,0.5);

	this.shape_5758 = new cjs.Shape();
	this.shape_5758.graphics.f("#000000").s().p("Ag8DdIAAgVQAVAEAQAAQA7ABAAhCIAAluIAZAAIAAFrQAABchUAAQgWAAgPgHg");
	this.shape_5758.setTransform(43.3,514.5,0.5,0.5);

	this.shape_5759 = new cjs.Shape();
	this.shape_5759.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgRgEgSAAQghAAgXAeQgWAcAAAtIAACVg");
	this.shape_5759.setTransform(910.5,476.2,0.5,0.5);

	this.shape_5760 = new cjs.Shape();
	this.shape_5760.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQABA5AZAdQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAKgUADQgRAEgaAAQg5AAgiglgAg2hbQgYAZgEAwICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_5760.setTransform(897.7,476.3,0.5,0.5);

	this.shape_5761 = new cjs.Shape();
	this.shape_5761.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5761.setTransform(887.8,473.8,0.5,0.5);

	this.shape_5762 = new cjs.Shape();
	this.shape_5762.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5762.setTransform(882,473.4,0.5,0.5);

	this.shape_5763 = new cjs.Shape();
	this.shape_5763.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgoA1AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAKgSADQgSAEgaAAQg6AAghglgAg3hbQgXAZgEAwICmAAQABgtgVgcQgUgbglABQglAAgZAag");
	this.shape_5763.setTransform(872.1,476.3,0.5,0.5);

	this.shape_5764 = new cjs.Shape();
	this.shape_5764.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5764.setTransform(860.7,474.8,0.5,0.5);

	this.shape_5765 = new cjs.Shape();
	this.shape_5765.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgMhiIgzCBICAAAIhAitQgFAWgIAWg");
	this.shape_5765.setTransform(848.9,473.9,0.5,0.5);

	this.shape_5766 = new cjs.Shape();
	this.shape_5766.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_5766.setTransform(826.7,473.5,0.5,0.5);

	this.shape_5767 = new cjs.Shape();
	this.shape_5767.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAKgTADQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAxICmAAQAAgtgUgcQgVgbgkABQgmAAgXAag");
	this.shape_5767.setTransform(812.5,476.3,0.5,0.5);

	this.shape_5768 = new cjs.Shape();
	this.shape_5768.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_5768.setTransform(798,476.2,0.5,0.5);

	this.shape_5769 = new cjs.Shape();
	this.shape_5769.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgEAGgHAAQgPAAAAgYg");
	this.shape_5769.setTransform(787.6,473.8,0.5,0.5);

	this.shape_5770 = new cjs.Shape();
	this.shape_5770.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAggkQAhgmA2AAQA4AAAgAmQAgAlAABBQAABBggAnQghAkg3ABQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_5770.setTransform(777.2,476.3,0.5,0.5);

	this.shape_5771 = new cjs.Shape();
	this.shape_5771.graphics.f("#000000").s().p("AgwDwIAAgVQAQAEAQAAQAkABAAgtIAAlFIAZAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_5771.setTransform(765.2,476.9,0.5,0.5);

	this.shape_5772 = new cjs.Shape();
	this.shape_5772.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5772.setTransform(754.5,473.4,0.5,0.5);

	this.shape_5773 = new cjs.Shape();
	this.shape_5773.graphics.f("#000000").s().p("AhNBoQghgkAAhCQAAg/AggnQAhgoA0AAQAvAAAdAiQAbAiAAA4IAAATIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgUAEQgSAEgZAAQg5AAgiglgAg2hbQgYAYgEAxICmAAQAAgugUgbQgVgbgkABQgnAAgWAag");
	this.shape_5773.setTransform(744.6,476.3,0.5,0.5);

	this.shape_5774 = new cjs.Shape();
	this.shape_5774.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAhAAQBcAAAABiIAACxg");
	this.shape_5774.setTransform(730.1,473.4,0.5,0.5);

	this.shape_5775 = new cjs.Shape();
	this.shape_5775.graphics.f("#000000").s().p("AhABoQgggkAAhCQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgjgMgaAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_5775.setTransform(716.8,476.3,0.5,0.5);

	this.shape_5776 = new cjs.Shape();
	this.shape_5776.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5776.setTransform(707.6,473.8,0.5,0.5);

	this.shape_5777 = new cjs.Shape();
	this.shape_5777.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgQAAIiHlPIgCAAQABAfABAgIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5777.setTransform(693.7,474,0.5,0.5);

	this.shape_5778 = new cjs.Shape();
	this.shape_5778.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_5778.setTransform(668.6,476.2,0.5,0.5);

	this.shape_5779 = new cjs.Shape();
	this.shape_5779.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAwAAAcAiQAcAhAAA5IAAATIjDAAQABA5AaAdQAYAdAvAAQAXAAATgDQATgEAZgKIAAAXQgYAKgSADQgTAEgZAAQg5AAghglgAg2hbQgYAYgEAxICnAAQAAgtgVgcQgVgbgkABQgmAAgXAag");
	this.shape_5779.setTransform(654,476.3,0.5,0.5);

	this.shape_5780 = new cjs.Shape();
	this.shape_5780.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5780.setTransform(639.6,473.4,0.5,0.5);

	this.shape_5781 = new cjs.Shape();
	this.shape_5781.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCcQAOA2AGAfIACAAQALgsAKghIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgNAThKIApiaIAZAAIhKENg");
	this.shape_5781.setTransform(622.7,476.3,0.5,0.5);

	this.shape_5782 = new cjs.Shape();
	this.shape_5782.graphics.f("#000000").s().p("AhGCzQgYgFgRgKIAAgaQAYAMAYAIQAUAEAZAAQAuAAAdgZQAdgZAAgrQAAgpgcgXQgdgWguAAQggAAgkAKIgPgKIAOimICvAAIAAAXIiXAAIgLCBQAmgHAWAAQA6gBAhAdQAiAbAAAyQAAA3gjAfQgjAgg8AAQgeAAgWgGg");
	this.shape_5782.setTransform(599.7,474.1,0.5,0.5);

	this.shape_5783 = new cjs.Shape();
	this.shape_5783.graphics.f("#000000").s().p("Ag9C2ICVlTIjNAAIAAgYIDrAAIAAASIiWFZg");
	this.shape_5783.setTransform(585,474,0.5,0.5);

	this.shape_5784 = new cjs.Shape();
	this.shape_5784.graphics.f("#000000").s().p("AhcC1IAAgWQAMAEAOACQANACAJAAQA9AAAjgtQAjgsADhUIgCAAQgTAXgZAMQgZANgaAAQgyAAgdgcQgcgaAAg0QAAg4AfghQAeghAzAAQAiAAAbASQAbATAOAkQAPAkAAAzQAABHgSAwQgUAwgjAXQgkAXgzAAQgaAAgVgGgAhBiKQgYAbAAAuQAAArAWAWQAWAWAoAAQAYAAAWgMQAVgKANgSQANgTABgTQgBgdgLgaQgMgZgVgOQgVgPgZAAQgoAAgXAbg");
	this.shape_5784.setTransform(570.4,473.9,0.5,0.5);

	this.shape_5785 = new cjs.Shape();
	this.shape_5785.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA8IgOgRIBihKIAVAAIAAFrg");
	this.shape_5785.setTransform(554.2,474,0.5,0.5);

	this.shape_5786 = new cjs.Shape();
	this.shape_5786.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA3IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_5786.setTransform(534.6,476.2,0.5,0.5);

	this.shape_5787 = new cjs.Shape();
	this.shape_5787.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAGAAAMQAAALgFAHQgFAGgGAAQgPAAAAgYg");
	this.shape_5787.setTransform(524.2,473.8,0.5,0.5);

	this.shape_5788 = new cjs.Shape();
	this.shape_5788.graphics.f("#000000").s().p("AgSCYQgRgUAAgpIAAiuIgoAAIAAgOIAogLIANg9IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAQQAMAPAXgBQAZAAAQgDIAAATQgSAGgYABQgiAAgSgTg");
	this.shape_5788.setTransform(510.2,474.8,0.5,0.5);

	this.shape_5789 = new cjs.Shape();
	this.shape_5789.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgRAEgZAAQg7AAggglgAg3hbQgXAYgEAxICmAAQAAgugVgbQgUgbgkABQgnAAgXAag");
	this.shape_5789.setTransform(499.1,476.3,0.5,0.5);

	this.shape_5790 = new cjs.Shape();
	this.shape_5790.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgUAXQgTAXAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQAOgYAWgMQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5790.setTransform(480.9,476.2,0.5,0.5);

	this.shape_5791 = new cjs.Shape();
	this.shape_5791.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5791.setTransform(460.1,473.4,0.5,0.5);

	this.shape_5792 = new cjs.Shape();
	this.shape_5792.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQASgEAbgKIAAAXQgXAKgTADQgSAEgaAAQg6AAggglgAg3hbQgXAYgEAxICmAAQAAgugUgbQgVgbgkABQgmAAgYAag");
	this.shape_5792.setTransform(450.2,476.3,0.5,0.5);

	this.shape_5793 = new cjs.Shape();
	this.shape_5793.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAZgLAgAAQBcAAgBBiIAACxg");
	this.shape_5793.setTransform(435.8,473.4,0.5,0.5);

	this.shape_5794 = new cjs.Shape();
	this.shape_5794.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAWQgjgMgaAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_5794.setTransform(422.4,476.3,0.5,0.5);

	this.shape_5795 = new cjs.Shape();
	this.shape_5795.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgPAAAAgYg");
	this.shape_5795.setTransform(413.2,473.8,0.5,0.5);

	this.shape_5796 = new cjs.Shape();
	this.shape_5796.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgPAAIiIlPIgCAAIACA/IAAEQIgZAAIAAlrIAoAAICAE/IACAAICAk/IAnAAIAAFrg");
	this.shape_5796.setTransform(399.3,474,0.5,0.5);

	this.shape_5797 = new cjs.Shape();
	this.shape_5797.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgGAJgNQAHgLALgcIAOgkIhokNIAZAAIA5CXQAaBFAIAZIAAAAIAihfIA5iWIAaAAIh4E5QgOAlgLAOQgKAOgOAHQgMAGgTAAQgPAAgRgEg");
	this.shape_5797.setTransform(375.8,479.4,0.5,0.5);

	this.shape_5798 = new cjs.Shape();
	this.shape_5798.graphics.f("#000000").s().p("Ag/BoQgiglAAhBQABhCAigmQAigmA6AAQAkAAAgANIgHAWQgjgMgbAAQgwAAgaAfQgaAfABA4QgBA3AaAfQAaAfAtAAQAlAAAfgNIAAAXQgZANgqAAQg6AAggglg");
	this.shape_5798.setTransform(364.2,476.3,0.5,0.5);

	this.shape_5799 = new cjs.Shape();
	this.shape_5799.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA2IAACVIgZAAIAAkNIAWAAIAEAlIABAAQAcgrBCAAQBcAAgBBjIAACwg");
	this.shape_5799.setTransform(350.4,476.2,0.5,0.5);

	this.shape_5800 = new cjs.Shape();
	this.shape_5800.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5800.setTransform(335.6,476.3,0.5,0.5);

	this.shape_5801 = new cjs.Shape();
	this.shape_5801.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA6AAAdIAADrIgYAAIAAlrIAZAAIDWFBIACAAQgCgnAAgtIAAjtIAYAAIAAFrg");
	this.shape_5801.setTransform(320.1,474,0.5,0.5);

	this.shape_5802 = new cjs.Shape();
	this.shape_5802.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdgkQAegmA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQgfAug6AAQg4AAgcgjgAhBgeQgXAeAAA7QAABzBZAAQAuAAAWgaQAUgbABg9IAAgEQgBg+gUgcQgWgbgvAAQgqAAgXAfg");
	this.shape_5802.setTransform(296.3,473.5,0.5,0.5);

	this.shape_5803 = new cjs.Shape();
	this.shape_5803.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_5803.setTransform(281.6,476.2,0.5,0.5);

	this.shape_5804 = new cjs.Shape();
	this.shape_5804.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5804.setTransform(266.8,476.3,0.5,0.5);

	this.shape_5805 = new cjs.Shape();
	this.shape_5805.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmABAWgNQAVgOAAgWQAAgUgRgOQgPgOgngOQgngNgRgLQgSgMgHgMQgJgOAAgSQAAgfAagSQAagSAsAAQAsABAoAQIgKAXQgngRgjAAQggAAgTALQgUAMAAATQAAAVAPAMQARANApAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_5805.setTransform(247.9,476.3,0.5,0.5);

	this.shape_5806 = new cjs.Shape();
	this.shape_5806.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA2IAACVIgZAAIAAkNIAVAAIAFAlIABAAQAcgrBBAAQBdAAAABjIAACwg");
	this.shape_5806.setTransform(234.6,476.2,0.5,0.5);

	this.shape_5807 = new cjs.Shape();
	this.shape_5807.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgGAGgGAAQgPAAAAgYg");
	this.shape_5807.setTransform(224.1,473.8,0.5,0.5);

	this.shape_5808 = new cjs.Shape();
	this.shape_5808.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_5808.setTransform(216.2,473.4,0.5,0.5);

	this.shape_5809 = new cjs.Shape();
	this.shape_5809.graphics.f("#000000").s().p("AgRCYQgSgVAAgoIAAiuIgoAAIAAgOIAogLIANg9IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAPQAKAPAYgBQAZAAAQgDIAAATQgSAGgYABQgjAAgQgTg");
	this.shape_5809.setTransform(204.4,474.8,0.5,0.5);

	this.shape_5810 = new cjs.Shape();
	this.shape_5810.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5810.setTransform(193.1,476.3,0.5,0.5);

	this.shape_5811 = new cjs.Shape();
	this.shape_5811.graphics.f("#000000").s().p("ABdC2IhelRQgDAUgIAeIhQEfIgWAAIhklrIAbAAIBVFCQAGggAThGIA/jcIAbAAIBJD8QAMAqAGAdIBVlDIAaAAIhlFrg");
	this.shape_5811.setTransform(175.5,474,0.5,0.5);

	this.shape_5812 = new cjs.Shape();
	this.shape_5812.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5812.setTransform(150.3,476.3,0.5,0.5);

	this.shape_5813 = new cjs.Shape();
	this.shape_5813.graphics.f("#000000").s().p("AhHCKIAAkNIAVAAIADAwIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgRgEgSAAQgiAAgWAeQgWAdAAAsIAACVg");
	this.shape_5813.setTransform(139.9,476.2,0.5,0.5);

	this.shape_5814 = new cjs.Shape();
	this.shape_5814.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdglQAegmA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAvAAAUgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_5814.setTransform(126,473.5,0.5,0.5);

	this.shape_5815 = new cjs.Shape();
	this.shape_5815.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkgBQgwAAgXAZQgWAZAAA2IAACVIgYAAIAAkNIAUAAIAFAlIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_5815.setTransform(111.4,476.2,0.5,0.5);

	this.shape_5816 = new cjs.Shape();
	this.shape_5816.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAhgVA+gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5816.setTransform(96.6,476.3,0.5,0.5);

	this.shape_5817 = new cjs.Shape();
	this.shape_5817.graphics.f("#000000").s().p("ABUCHIhUh4IhVB4IgcAAIBjiKIhfiDIAdAAIBQByIBPhyIAbAAIhdCDIBkCKg");
	this.shape_5817.setTransform(84,476.3,0.5,0.5);

	this.shape_5818 = new cjs.Shape();
	this.shape_5818.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA5AYAdQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgXAKgUADQgSAEgYAAQg7AAghglgAg2hbQgXAYgFAxICmAAQAAgtgUgcQgVgbgjABQgnAAgXAag");
	this.shape_5818.setTransform(70.6,476.3,0.5,0.5);

	this.shape_5819 = new cjs.Shape();
	this.shape_5819.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_5819.setTransform(60.7,473.4,0.5,0.5);

	this.shape_5820 = new cjs.Shape();
	this.shape_5820.graphics.f("#000000").s().p("AB8C3IgyiBIiUAAIgyCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_5820.setTransform(50.2,473.9,0.5,0.5);

	this.shape_5821 = new cjs.Shape();
	this.shape_5821.graphics.f("#000000").s().p("AAcDLIAAkgQAAgoADgdIgOANIhBA2IgZggIBrhTIAnAAIAAGVg");
	this.shape_5821.setTransform(500.2,396.4,0.5,0.5);

	this.shape_5822 = new cjs.Shape();
	this.shape_5822.graphics.f("#000000").s().p("AhiC1QgjgdAAg0QAAhGBVgmQgngWgQgZQgQgaAAgfQAAgsAggaQAhgaA2AAQA3AAAhAZQAhAbAAAtQAAAegTAZQgTAZgpAUQAyAXAVAaQAVAZAAAjQAAAzgkAeQgjAeg+AAQg/AAgkgcgAhFAxQgSAXAAAdQAAAhAXATQAXASApABQAqgBAXgTQAXgUAAgiQAAgagWgWQgWgUg0gUQgpARgUAWgAg2iaQgUAQAAAcQAAAbAQARQAQASAsATQAogQAQgUQARgTAAgaQAAgcgUgQQgUgQgjgBQgjABgTAQg");
	this.shape_5822.setTransform(485.8,396.4,0.5,0.5);

	this.shape_5823 = new cjs.Shape();
	this.shape_5823.graphics.f("#000000").s().p("AhmDLIAAgnQAXAHAcAAQBBAAAigpQAjgqAChVIgDAAQgPAXgaAMQgZAMgfAAQg2AAgfggQgggfAAg6QAAhAAkglQAjgkA6AAQApAAAeAVQAgAWAQAoQARApAAA3QAADui4AAQgiAAgRgGgAhAiPQgXAaAAAtQAAAoAVAXQATAWApAAQAaAAAUgKQAVgJANgSQAMgSAAgTQAAgfgMgXQgKgZgVgPQgUgNgaAAQgoAAgVAZg");
	this.shape_5823.setTransform(469.5,396.4,0.5,0.5);

	this.shape_5824 = new cjs.Shape();
	this.shape_5824.graphics.f("#000000").s().p("AAcDLIAAkgQAAghADgkIhPBDIgYggIBqhTIAnAAIAAGVg");
	this.shape_5824.setTransform(451.3,396.4,0.5,0.5);

	this.shape_5825 = new cjs.Shape();
	this.shape_5825.graphics.f("#000000").s().p("Ah3AVIAAgpIDvAAIAAApg");
	this.shape_5825.setTransform(430.5,398.9,0.5,0.5);

	this.shape_5826 = new cjs.Shape();
	this.shape_5826.graphics.f("#000000").s().p("Ah/C4IAAgsQATAMAeAHQAdAIAbAAQAwAAAcgYQAbgWAAgsQAAhUhoAAQgbAAgrAHIgYgPIAPi+IDKAAIAAAqIiiAAIgLB7QAfgHAhAAQBAAAAlAgQAkAfAAA3QAABAgoAjQgoAkhGAAQhFAAgkgWg");
	this.shape_5826.setTransform(408,396.5,0.5,0.5);

	this.shape_5827 = new cjs.Shape();
	this.shape_5827.graphics.f("#000000").s().p("AhRDLICnlrIjcAAIAAgqIENAAIAAAkIilFxg");
	this.shape_5827.setTransform(391.5,396.4,0.5,0.5);

	this.shape_5828 = new cjs.Shape();
	this.shape_5828.graphics.f("#000000").s().p("AhmDLIAAgnQAXAHAbAAQBCAAAigpQAigpAEhWIgEAAQgPAXgZAMQgaAMgfAAQg2AAgfggQgggfAAg6QAAhAAkglQAjgkA6AAQApAAAeAVQAgAWAQAoQARApAAA3QAADui4AAQgiAAgRgGgAhBiPQgVAZAAAuQAAApAUAWQAUAWApAAQAZAAAUgKQAWgJAMgSQAMgSAAgTQAAgdgLgZQgLgZgVgPQgUgNgaAAQgoAAgWAZg");
	this.shape_5828.setTransform(375.2,396.4,0.5,0.5);

	this.shape_5829 = new cjs.Shape();
	this.shape_5829.graphics.f("#000000").s().p("AAdDLIAAkgQAAgoABgdIgMANIhCA2IgZggIBrhTIAoAAIAAGVg");
	this.shape_5829.setTransform(357.1,396.4,0.5,0.5);

	this.shape_5830 = new cjs.Shape();
	this.shape_5830.graphics.f("#000000").s().p("AhgCHQgZgYAAgrQAAhbCTgFIAzgCIAAgSQAAglgPgQQgPgSgjAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAYQAaAZAAA1IAADPIgiAAIgJgrIgCAAQgWAbgYAMQgXAKggAAQguAAgagXgAAeAEQg3ADgXAOQgZAPAAAhQAAAYAPAOQAQANAbAAQAqAAAZgYQAYgYAAgqIAAgcg");
	this.shape_5830.setTransform(335,398.9,0.5,0.5);

	this.shape_5831 = new cjs.Shape();
	this.shape_5831.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgXIArgTIAUhAIAaAAIAABGIBYAAIAAAkIhYAAIAACzQAAAbAMAPQAOAPAWgBQAOAAAKgBIATgEIAAAjQgIAEgPACQgMACgOAAQhYABAAhdg");
	this.shape_5831.setTransform(322.5,397.3,0.5,0.5);

	this.shape_5832 = new cjs.Shape();
	this.shape_5832.graphics.f("#000000").s().p("AhfCHQgagZAAgqQgBhbCTgFIA0gCIAAgSQAAgkgPgRQgQgSghAAQglAAgxAYIgOgkQAYgMAZgHQAdgHAYAAQA3AAAaAYQAaAZAAA1IAADPIgiAAIgJgrIgCAAQgWAcgYALQgXAKggAAQguAAgZgXgAAeAEQg2ADgYAOQgZAQAAAgQAAAYAQAOQAPANAbAAQApAAAZgYQAZgXAAgrIAAgcg");
	this.shape_5832.setTransform(309.1,398.9,0.5,0.5);

	this.shape_5833 = new cjs.Shape();
	this.shape_5833.graphics.f("#000000").s().p("ABCDYIhqiQIgjAeIAAByIguAAIAAmwIAuAAIAADlQAAATgDAdIADAAQALgRAZgcIBihoIA3AAIh7CCICDCug");
	this.shape_5833.setTransform(295.3,395.7,0.5,0.5);

	this.shape_5834 = new cjs.Shape();
	this.shape_5834.graphics.f("#000000").s().p("AhjCBQgcgbAAg6IAAjGIAvAAIAADFQAAAmARARQARATAkAAQAvAAAWgaQAWgaAAg8IAAifIAvAAIAAEwIgmAAIgHgpIgDAAQgOAWgZAMQgZAMggAAQg3AAgcgag");
	this.shape_5834.setTransform(277.9,399.1,0.5,0.5);

	this.shape_5835 = new cjs.Shape();
	this.shape_5835.graphics.f("#000000").s().p("AhqCLIAAgrQAWALAZAHQAYAGAYAAQAjAAAUgMQAUgLAAgYQAAgSgQgMQgQgNgrgRQgqgOgTgNQgSgLgIgPQgJgQAAgUQAAgmAegWQAegVA0AAQAyAAAvAUIgRAlQgugSglAAQggAAgQAKQgRAKAAASQAAANAGAIQAGAJAOAHQAPAJAmAOQA3AUASATQATAUAAAfQAAAqggAXQgfAXg5AAQg8AAgigTg");
	this.shape_5835.setTransform(262.5,398.9,0.5,0.5);

	this.shape_5836 = new cjs.Shape();
	this.shape_5836.graphics.f("#000000").s().p("AguBiIAAi1IgrAAIAAgXIArgTIAUhAIAaAAIAABGIBYAAIAAAkIhYAAIAACzQAAAbANAPQANAPAXgBQANAAAKgBIASgEIAAAjQgIAEgOACQgMACgOAAQhYABAAhdg");
	this.shape_5836.setTransform(250.5,397.3,0.5,0.5);

	this.shape_5837 = new cjs.Shape();
	this.shape_5837.graphics.f("#000000").s().p("AhfCHQgagYAAgrQAAhbCTgFIAzgCIAAgSQAAglgPgQQgPgSgjAAQgkAAgxAYIgOgkQAXgMAagHQAcgHAZAAQA3AAAaAYQAaAZAAA1IAADPIgiAAIgJgrIgCAAQgWAbgYAMQgXAKggAAQguAAgZgXgAAeAEQg3ADgXAOQgZAPAAAhQAAAYAPAOQAQANAbAAQAqAAAZgYQAYgXAAgrIAAgcg");
	this.shape_5837.setTransform(237.1,398.9,0.5,0.5);

	this.shape_5838 = new cjs.Shape();
	this.shape_5838.graphics.f("#000000").s().p("ACbDLIAAkEQAAg0AEgvIgDAAIiLFnIglAAIiKlnIgDAAQAFAtAAA4IAAECIgsAAIAAmVIBHAAICBFOIABAAICClOIBHAAIAAGVg");
	this.shape_5838.setTransform(216.8,396.4,0.5,0.5);

	this.shape_5839 = new cjs.Shape();
	this.shape_5839.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhIAkgsQAlgrA8AAQA6AAAgAmQAiAmAAA9IAAAcIjRAAQABA2AaAcQAZAcAvAAQAxAAAwgVIAAAqQgZAKgWAEQgVAFgfAAQhDAAgngpgAg1heQgWAXgEArICfAAQgBgrgTgYQgUgYgkABQgkAAgVAYg");
	this.shape_5839.setTransform(188.6,398.9,0.5,0.5);

	this.shape_5840 = new cjs.Shape();
	this.shape_5840.graphics.f("#000000").s().p("AiKDYIAAglQAQADASABQAvAAAVg2IARgrIh7kyIAyAAIBCCuQAXA8AEAZIACAAIAPgwIBMjTIAxAAIiDFaQgSA0gaAVQgaAWgmAAQgVAAgVgFg");
	this.shape_5840.setTransform(173.4,402.4,0.5,0.5);

	this.shape_5841 = new cjs.Shape();
	this.shape_5841.graphics.f("#000000").s().p("AgWDRIAAkwIAtAAIAAEwgAgSibQgIgHAAgPQAAgRAIgHQAHgHALAAQALAAAIAHQAIAIAAAQQAAAPgIAHQgJAJgKAAQgKAAgIgJg");
	this.shape_5841.setTransform(162.6,396.1,0.5,0.5);

	this.shape_5842 = new cjs.Shape();
	this.shape_5842.graphics.f("#000000").s().p("ACaDLIAAkEQAAgrAEg4IgDAAIiKFnIgmAAIiKlnIgCAAQAEAtAAA4IAAECIgsAAIAAmVIBHAAICCFOIABAAICBlOIBHAAIAAGVg");
	this.shape_5842.setTransform(146.2,396.4,0.5,0.5);

	this.shape_5843 = new cjs.Shape();
	this.shape_5843.graphics.f("#000000").s().p("AhXCbIAAkwIAmAAIAGA5IACAAQAQgdAYgRQAYgQAcAAQAWAAAPADIgGArQgWgEgMAAQglAAgZAeQgaAdAAAuIAACig");
	this.shape_5843.setTransform(121.1,398.8,0.5,0.5);

	this.shape_5844 = new cjs.Shape();
	this.shape_5844.graphics.f("#000000").s().p("AhZB1QgngpAAhKQAAhIAkgsQAlgrA8AAQA5AAAiAmQAhAnAAA8IAAAcIjSAAQACA3AaAbQAaAcAtAAQAxAAAxgVIAAAqQgYAKgWAEQgWAFggAAQhCAAgngpgAg2heQgVAXgEArICeAAQABgrgUgYQgTgYglABQgjAAgXAYg");
	this.shape_5844.setTransform(106.3,398.9,0.5,0.5);

	this.shape_5845 = new cjs.Shape();
	this.shape_5845.graphics.f("#000000").s().p("AhkCyQghgoAAhMQAAhLAhgpQAhgqA8AAQA9AAAhAtIAEAAIgDinIAuAAIAAGwIglAAIgHgpIgCAAQggAug/AAQg8AAghgpgAhAgaQgVAfAAA6QAAA7AVAdQAVAeAqAAQAuAAAWgaQAVgaAAg5IAAgKQAAhAgWgbQgWgcguAAQgoAAgWAfg");
	this.shape_5845.setTransform(89.1,395.9,0.5,0.5);

	this.shape_5846 = new cjs.Shape();
	this.shape_5846.graphics.f("#000000").s().p("ABRCbIAAjEQABglgSgTQgRgSgjAAQgvAAgXAaQgWAaAAA7IAACfIgvAAIAAkwIAmAAIAIAqIACAAQAOgXAagMQAZgMAfAAQA3AAAcAaQAbAbAAA6IAADGg");
	this.shape_5846.setTransform(72.1,398.8,0.5,0.5);

	this.shape_5847 = new cjs.Shape();
	this.shape_5847.graphics.f("#000000").s().p("AhzCmQgogoAAhGIAAkFIAwAAIAAEIQAAAzAbAcQAcAbA1AAQA0AAAcgcQAbgaAAg0IAAkIIAwAAIAAEGQAABGgqAoQgqAnhJAAQhKAAgogog");
	this.shape_5847.setTransform(52.9,396.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_5847},{t:this.shape_5846},{t:this.shape_5845},{t:this.shape_5844},{t:this.shape_5843},{t:this.shape_5842},{t:this.shape_5841},{t:this.shape_5840},{t:this.shape_5839},{t:this.shape_5838},{t:this.shape_5837},{t:this.shape_5836},{t:this.shape_5835},{t:this.shape_5834},{t:this.shape_5833},{t:this.shape_5832},{t:this.shape_5831},{t:this.shape_5830},{t:this.shape_5829},{t:this.shape_5828},{t:this.shape_5827},{t:this.shape_5826},{t:this.shape_5825},{t:this.shape_5824},{t:this.shape_5823},{t:this.shape_5822},{t:this.shape_5821},{t:this.shape_5820},{t:this.shape_5819},{t:this.shape_5818},{t:this.shape_5817},{t:this.shape_5816},{t:this.shape_5815},{t:this.shape_5814},{t:this.shape_5813},{t:this.shape_5812},{t:this.shape_5811},{t:this.shape_5810},{t:this.shape_5809},{t:this.shape_5808},{t:this.shape_5807},{t:this.shape_5806},{t:this.shape_5805},{t:this.shape_5804},{t:this.shape_5803},{t:this.shape_5802},{t:this.shape_5801},{t:this.shape_5800},{t:this.shape_5799},{t:this.shape_5798},{t:this.shape_5797},{t:this.shape_5796},{t:this.shape_5795},{t:this.shape_5794},{t:this.shape_5793},{t:this.shape_5792},{t:this.shape_5791},{t:this.shape_5790},{t:this.shape_5789},{t:this.shape_5788},{t:this.shape_5787},{t:this.shape_5786},{t:this.shape_5785},{t:this.shape_5784},{t:this.shape_5783},{t:this.shape_5782},{t:this.shape_5781},{t:this.shape_5780},{t:this.shape_5779},{t:this.shape_5778},{t:this.shape_5777},{t:this.shape_5776},{t:this.shape_5775},{t:this.shape_5774},{t:this.shape_5773},{t:this.shape_5772},{t:this.shape_5771},{t:this.shape_5770},{t:this.shape_5769},{t:this.shape_5768},{t:this.shape_5767},{t:this.shape_5766},{t:this.shape_5765},{t:this.shape_5764},{t:this.shape_5763},{t:this.shape_5762},{t:this.shape_5761},{t:this.shape_5760},{t:this.shape_5759},{t:this.shape_5758},{t:this.shape_5757},{t:this.shape_5756},{t:this.shape_5755},{t:this.shape_5754},{t:this.shape_5753},{t:this.shape_5752},{t:this.shape_5751},{t:this.shape_5750},{t:this.shape_5749},{t:this.shape_5748},{t:this.shape_5747},{t:this.shape_5746},{t:this.shape_5745},{t:this.shape_5744},{t:this.shape_5743},{t:this.shape_5742},{t:this.shape_5741},{t:this.shape_5740},{t:this.shape_5739},{t:this.shape_5738},{t:this.shape_5737},{t:this.shape_5736},{t:this.shape_5735},{t:this.shape_5734},{t:this.shape_5733},{t:this.shape_5732},{t:this.shape_5731},{t:this.shape_5730},{t:this.shape_5729},{t:this.shape_5728},{t:this.shape_5727},{t:this.shape_5726},{t:this.shape_5725},{t:this.shape_5724},{t:this.shape_5723},{t:this.shape_5722},{t:this.shape_5721},{t:this.shape_5720},{t:this.shape_5719},{t:this.shape_5718},{t:this.shape_5717},{t:this.shape_5716},{t:this.shape_5715},{t:this.shape_5714},{t:this.shape_5713},{t:this.shape_5712},{t:this.shape_5711},{t:this.shape_5710},{t:this.shape_5709},{t:this.shape_5708},{t:this.shape_5707},{t:this.shape_5706},{t:this.shape_5705},{t:this.shape_5704},{t:this.shape_5703},{t:this.shape_5702},{t:this.shape_5701},{t:this.shape_5700},{t:this.shape_5699},{t:this.shape_5698},{t:this.shape_5697},{t:this.shape_5696},{t:this.shape_5695},{t:this.shape_5694},{t:this.shape_5693},{t:this.shape_5692},{t:this.shape_5691},{t:this.shape_5690},{t:this.shape_5689},{t:this.shape_5688},{t:this.shape_5687},{t:this.shape_5686},{t:this.shape_5685},{t:this.shape_5684},{t:this.shape_5683},{t:this.shape_5682},{t:this.shape_5681},{t:this.shape_5680},{t:this.shape_5679},{t:this.shape_5678},{t:this.shape_5677},{t:this.shape_5676},{t:this.shape_5675},{t:this.shape_5674},{t:this.shape_5673},{t:this.shape_5672},{t:this.shape_5671},{t:this.shape_5670},{t:this.shape_5669},{t:this.shape_5668},{t:this.shape_5667},{t:this.shape_5666},{t:this.shape_5665},{t:this.shape_5664},{t:this.shape_5663},{t:this.shape_5662},{t:this.shape_5661},{t:this.shape_5660},{t:this.shape_5659},{t:this.shape_5658},{t:this.shape_5657},{t:this.shape_5656},{t:this.shape_5655},{t:this.shape_5654},{t:this.shape_5653},{t:this.shape_5652},{t:this.shape_5651},{t:this.shape_5650},{t:this.shape_5649},{t:this.shape_5648},{t:this.shape_5647},{t:this.shape_5646},{t:this.shape_5645},{t:this.shape_5644},{t:this.shape_5643},{t:this.shape_5642},{t:this.shape_5641},{t:this.shape_5640},{t:this.shape_5639},{t:this.shape_5638},{t:this.shape_5637},{t:this.shape_5636},{t:this.shape_5635},{t:this.shape_5634},{t:this.shape_5633},{t:this.shape_5632},{t:this.shape_5631},{t:this.shape_5630},{t:this.shape_5629},{t:this.shape_5628},{t:this.shape_5627},{t:this.shape_5626},{t:this.shape_5625},{t:this.shape_5624},{t:this.shape_5623},{t:this.shape_5622},{t:this.shape_5621},{t:this.shape_5620},{t:this.shape_5619},{t:this.shape_5618},{t:this.shape_5617},{t:this.shape_5616},{t:this.shape_5615},{t:this.shape_5614},{t:this.shape_5613},{t:this.shape_5612},{t:this.shape_5611},{t:this.shape_5610},{t:this.shape_5609},{t:this.shape_5608},{t:this.shape_5607},{t:this.shape_5606},{t:this.shape_5605},{t:this.shape_5604},{t:this.shape_5603},{t:this.shape_5602}]},53).to({state:[]},1).wait(111));

	// ButtonLeftRight copy 9
	this.buttonR5 = new lib.ButtonLeft_Right();
	this.buttonR5.name = "buttonR5";
	this.buttonR5.parent = this;
	this.buttonR5.setTransform(2025,513.5,1,1,180);
	this.buttonR5._off = true;
	new cjs.ButtonHelper(this.buttonR5, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR5).wait(52).to({_off:false},0).to({_off:true},1).wait(112));

	// ButtonLeftRight copy 11
	this.buttonL5 = new lib.ButtonLeft_Right();
	this.buttonL5.name = "buttonL5";
	this.buttonL5.parent = this;
	this.buttonL5.setTransform(0,437.2);
	this.buttonL5._off = true;
	new cjs.ButtonHelper(this.buttonL5, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL5).wait(52).to({_off:false},0).to({_off:true},1).wait(112));

	// Layer 1
	this.instance_26 = new lib.nancy_studio();
	this.instance_26.parent = this;
	this.instance_26.setTransform(732,-4);

	this.shape_5848 = new cjs.Shape();
	this.shape_5848.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_5848.setTransform(571.3,707.7,0.5,0.5);

	this.shape_5849 = new cjs.Shape();
	this.shape_5849.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_5849.setTransform(561.3,701.9,0.5,0.5);

	this.shape_5850 = new cjs.Shape();
	this.shape_5850.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5850.setTransform(550.2,701.8,0.5,0.5);

	this.shape_5851 = new cjs.Shape();
	this.shape_5851.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5851.setTransform(537.1,701.9,0.5,0.5);

	this.shape_5852 = new cjs.Shape();
	this.shape_5852.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAlAAQAvAAAXgYQAXgZgBg3IAAiUIAYAAIAAEOIgUAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_5852.setTransform(523.2,702.1,0.5,0.5);

	this.shape_5853 = new cjs.Shape();
	this.shape_5853.graphics.f("#000000").s().p("ABZDHIAAhnIACg+IgCAAQgdAwg9AAQg1AAgegkQgdgjAAhCQAAhFAdglQAdglA3AAQA7AAAcArIABAAIAFgmIAVAAIAAGIgAhBiRQgWAfAAA8QAAA4AWAdQAWAdAqAAQAxAAAUgbQAWgbgBg/IAAgDQABg9gWgcQgUgbgvAAQgrAAgXAfg");
	this.shape_5853.setTransform(507.8,704.9,0.5,0.5);

	this.shape_5854 = new cjs.Shape();
	this.shape_5854.graphics.f("#000000").s().p("AhvCtIAAgaQAnARA9AAQAsAAAagVQAagUAAgiQAAgUgIgOQgKgOgTgLQgTgLgmgNQg4gSgVgWQgVgXAAglQAAgpAggZQAggaAxAAQA0AAAtATIgJAWQgvgTgoAAQgnAAgYATQgYATAAAgQAAAUAHANQAHANARAKQAPAKApAPQAsAOAUAOQAWANAKASQAJARAAAZQAAAughAbQgiAag2AAQhCAAgkgOg");
	this.shape_5854.setTransform(493.7,699.6,0.5,0.5);

	this.shape_5855 = new cjs.Shape();
	this.shape_5855.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAVgcAAg8IAAgEQAAg9gVgdQgVgbgwAAQgqAAgXAfg");
	this.shape_5855.setTransform(472.1,699.1,0.5,0.5);

	this.shape_5856 = new cjs.Shape();
	this.shape_5856.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5856.setTransform(460.8,701.8,0.5,0.5);

	this.shape_5857 = new cjs.Shape();
	this.shape_5857.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5857.setTransform(447.8,701.9,0.5,0.5);

	this.shape_5858 = new cjs.Shape();
	this.shape_5858.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAlAGAYIABAAQAJggALgeIBHi2IAZAAIhoENg");
	this.shape_5858.setTransform(435.6,701.9,0.5,0.5);

	this.shape_5859 = new cjs.Shape();
	this.shape_5859.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAWADIgEAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5859.setTransform(425.7,701.8,0.5,0.5);

	this.shape_5860 = new cjs.Shape();
	this.shape_5860.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5860.setTransform(412.6,701.9,0.5,0.5);

	this.shape_5861 = new cjs.Shape();
	this.shape_5861.graphics.f("#000000").s().p("ABqC2IAAizIjTAAIAACzIgaAAIAAlrIAaAAIAACiIDTAAIAAiiIAaAAIAAFrg");
	this.shape_5861.setTransform(397.2,699.6,0.5,0.5);

	this.shape_5862 = new cjs.Shape();
	this.shape_5862.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_5862.setTransform(373.9,701.8,0.5,0.5);

	this.shape_5863 = new cjs.Shape();
	this.shape_5863.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_5863.setTransform(363.5,699.5,0.5,0.5);

	this.shape_5864 = new cjs.Shape();
	this.shape_5864.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAmg3AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5864.setTransform(346.5,701.9,0.5,0.5);

	this.shape_5865 = new cjs.Shape();
	this.shape_5865.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_5865.setTransform(336.1,699.5,0.5,0.5);

	this.shape_5866 = new cjs.Shape();
	this.shape_5866.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgXAeAAA7QABBzBYAAQAuAAAVgaQAWgcAAg8IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_5866.setTransform(325.3,699.1,0.5,0.5);

	this.shape_5867 = new cjs.Shape();
	this.shape_5867.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_5867.setTransform(310.5,702.1,0.5,0.5);

	this.shape_5868 = new cjs.Shape();
	this.shape_5868.graphics.f("#000000").s().p("AgSCXQgQgTgBgpIAAiuIgnAAIAAgOIAngMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAPAXAAQAZAAAPgDIAAAUQgRAFgXABQgjAAgSgUg");
	this.shape_5868.setTransform(298.6,700.4,0.5,0.5);

	this.shape_5869 = new cjs.Shape();
	this.shape_5869.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgNgBgXQAAgVgQgNQgQgPgmgNQgqgOgOgKQgRgLgIgNQgJgOAAgSQABgfAZgSQAZgSAuAAQArAAAnARIgJAXQgngRgiAAQghAAgTALQgUALABATQgBAWAQAMQAOANArAPQAkANASAKQAQALAJAOQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_5869.setTransform(288.5,701.9,0.5,0.5);

	this.shape_5870 = new cjs.Shape();
	this.shape_5870.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAKgGQAJgGAIgMQAJgQAJgZIANgjIhnkOIAaAAIA5CYQAaBFAHAZIAAAAQALghAYg/IA5iWIAZAAIh5E6QgNAlgLAOQgKAOgNAHQgNAGgUAAQgOAAgRgEg");
	this.shape_5870.setTransform(270.1,705,0.5,0.5);

	this.shape_5871 = new cjs.Shape();
	this.shape_5871.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_5871.setTransform(260.2,701.8,0.5,0.5);

	this.shape_5872 = new cjs.Shape();
	this.shape_5872.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5872.setTransform(251.5,699,0.5,0.5);

	this.shape_5873 = new cjs.Shape();
	this.shape_5873.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjBAAQAAA3AaAfQAZAdAvAAQAXAAARgDQATgEAagKIAAAXQgWAJgVAEQgRAEgZAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgbgkABQgmAAgXAag");
	this.shape_5873.setTransform(241.6,701.9,0.5,0.5);

	this.shape_5874 = new cjs.Shape();
	this.shape_5874.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIACAAQAOg7AHgSIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgOAThJIApiaIAZAAIhKENg");
	this.shape_5874.setTransform(225.4,701.9,0.5,0.5);

	this.shape_5875 = new cjs.Shape();
	this.shape_5875.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAwAAAbAiQAcAhgBA5IAAATIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgbgjABQgnAAgXAag");
	this.shape_5875.setTransform(209.2,701.9,0.5,0.5);

	this.shape_5876 = new cjs.Shape();
	this.shape_5876.graphics.f("#000000").s().p("AgwDwIAAgVQATAFANAAQAkAAAAgsIAAlGIAZAAIAAFCQAAAigQASQgPASgdAAQgUAAgNgGgAARjdQAAgYAPAAQAIAAAFAGQAEAHAAALQAAALgEAHQgFAGgIAAQgPAAAAgYg");
	this.shape_5876.setTransform(197.6,702.5,0.5,0.5);

	this.shape_5877 = new cjs.Shape();
	this.shape_5877.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5877.setTransform(182.6,701.9,0.5,0.5);

	this.shape_5878 = new cjs.Shape();
	this.shape_5878.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_5878.setTransform(162.2,701.8,0.5,0.5);

	this.shape_5879 = new cjs.Shape();
	this.shape_5879.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_5879.setTransform(151.7,699.5,0.5,0.5);

	this.shape_5880 = new cjs.Shape();
	this.shape_5880.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5880.setTransform(138.1,701.8,0.5,0.5);

	this.shape_5881 = new cjs.Shape();
	this.shape_5881.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA4AYAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgXAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgXAYgFAyICmAAQAAgwgUgaQgVgbgjABQgnAAgXAag");
	this.shape_5881.setTransform(125.3,701.9,0.5,0.5);

	this.shape_5882 = new cjs.Shape();
	this.shape_5882.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_5882.setTransform(110.8,701.8,0.5,0.5);

	this.shape_5883 = new cjs.Shape();
	this.shape_5883.graphics.f("#000000").s().p("AheC0QgcgTAAgkQABgcAQgSQARgTAegHQgLgFgIgJQgIgKAAgMQABgbAigUQgYgKgMgVQgOgVAAgbQAAgnAagaQAagYArAAQAZAAAQAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgPAIgHAKQgIAJAAANQAAAMAKAGQAKAGAXAAIAuAAQAtAAAWASQAYASAAAjQAAAqgjAYQgjAXg/AAQgzAAgcgTgAhgB7QABA3BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA7gAg5igQgSATAAAgQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgUgSggAAQggAAgTATg");
	this.shape_5883.setTransform(96.6,704.9,0.5,0.5);

	this.shape_5884 = new cjs.Shape();
	this.shape_5884.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAHgHAAQgPgBAAgYg");
	this.shape_5884.setTransform(87,699.5,0.5,0.5);

	this.shape_5885 = new cjs.Shape();
	this.shape_5885.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTALAAATQAAAWAPAMQAPANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_5885.setTransform(78.1,701.9,0.5,0.5);

	this.shape_5886 = new cjs.Shape();
	this.shape_5886.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgoA1AAQAwAAAcAiQAcAhAAA5IAAATIjDAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgTAEQgSAEgaAAQg6AAghglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgbgkABQgnAAgXAag");
	this.shape_5886.setTransform(65.3,701.9,0.5,0.5);

	this.shape_5887 = new cjs.Shape();
	this.shape_5887.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_5887.setTransform(50.3,699.1,0.5,0.5);

	this.shape_5888 = new cjs.Shape();
	this.shape_5888.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAWgLAXAAQBAAAASAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5888.setTransform(603.7,663.6,0.5,0.5);

	this.shape_5889 = new cjs.Shape();
	this.shape_5889.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_5889.setTransform(584.9,663.7,0.5,0.5);

	this.shape_5890 = new cjs.Shape();
	this.shape_5890.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgnAAIAAgOIAngMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXAAQAZAAAQgDIAAAUQgTAFgXABQgiAAgSgUg");
	this.shape_5890.setTransform(573,662.2,0.5,0.5);

	this.shape_5891 = new cjs.Shape();
	this.shape_5891.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAnAAAVgMQAUgNAAgXQAAgVgQgNQgQgPgmgNQgqgOgPgKQgQgLgIgNQgJgOAAgSQAAgfAagSQAagSAsAAQAsAAAnARIgJAXQgngRgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAPQAkANASAKQAPALAKAOQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_5891.setTransform(562.8,663.7,0.5,0.5);

	this.shape_5892 = new cjs.Shape();
	this.shape_5892.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAABhjg");
	this.shape_5892.setTransform(549.4,663.8,0.5,0.5);

	this.shape_5893 = new cjs.Shape();
	this.shape_5893.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg4AAghglg");
	this.shape_5893.setTransform(536.2,663.7,0.5,0.5);

	this.shape_5894 = new cjs.Shape();
	this.shape_5894.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5894.setTransform(516,663.7,0.5,0.5);

	this.shape_5895 = new cjs.Shape();
	this.shape_5895.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQgBA3AaAfQAZAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgbgkABQgnAAgWAag");
	this.shape_5895.setTransform(496.1,663.7,0.5,0.5);

	this.shape_5896 = new cjs.Shape();
	this.shape_5896.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5896.setTransform(477.9,663.6,0.5,0.5);

	this.shape_5897 = new cjs.Shape();
	this.shape_5897.graphics.f("#000000").s().p("AhOB4QgXgUABglQAAgnAggWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAsAAAXAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQArAAAZgZQAYgZAAgsIAAgZg");
	this.shape_5897.setTransform(459.4,663.7,0.5,0.5);

	this.shape_5898 = new cjs.Shape();
	this.shape_5898.graphics.f("#000000").s().p("AhABoQggglAAhBQgBhCAjgmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAaAfAtAAQAlAAAggNIAAAXQgaANgrAAQg4AAgiglg");
	this.shape_5898.setTransform(447.3,663.7,0.5,0.5);

	this.shape_5899 = new cjs.Shape();
	this.shape_5899.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_5899.setTransform(433.9,663.7,0.5,0.5);

	this.shape_5900 = new cjs.Shape();
	this.shape_5900.graphics.f("#000000").s().p("Ag0C4QgYgMgNgWIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAWgLQAWgMAdAAQA5AAAcAkQAdAjAABFQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAcAAA+IAAAEQAAA9AWAbQAWAaAtAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_5900.setTransform(419.7,660.9,0.5,0.5);

	this.shape_5901 = new cjs.Shape();
	this.shape_5901.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAXAAARgDQATgEAagKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgbgkABQgmAAgXAag");
	this.shape_5901.setTransform(398.1,663.7,0.5,0.5);

	this.shape_5902 = new cjs.Shape();
	this.shape_5902.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5902.setTransform(383.7,660.8,0.5,0.5);

	this.shape_5903 = new cjs.Shape();
	this.shape_5903.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgIgNAAgTQAAgfAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_5903.setTransform(370.1,663.7,0.5,0.5);

	this.shape_5904 = new cjs.Shape();
	this.shape_5904.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAFQgSBAgYA3g");
	this.shape_5904.setTransform(354.4,670.6,0.5,0.5);

	this.shape_5905 = new cjs.Shape();
	this.shape_5905.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAmgKANQgLAPgMAGQgNAGgTAAQgPAAgRgEg");
	this.shape_5905.setTransform(346.3,666.8,0.5,0.5);

	this.shape_5906 = new cjs.Shape();
	this.shape_5906.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5906.setTransform(336.3,663.6,0.5,0.5);

	this.shape_5907 = new cjs.Shape();
	this.shape_5907.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5907.setTransform(327.6,660.8,0.5,0.5);

	this.shape_5908 = new cjs.Shape();
	this.shape_5908.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggoA0AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgTAEQgRAEgaAAQg6AAghglgAg3hbQgXAZgEAxICmAAQABgwgVgaQgUgbglABQglAAgZAag");
	this.shape_5908.setTransform(317.7,663.7,0.5,0.5);

	this.shape_5909 = new cjs.Shape();
	this.shape_5909.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_5909.setTransform(301.5,663.7,0.5,0.5);

	this.shape_5910 = new cjs.Shape();
	this.shape_5910.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgxgVgZQgUgbgkABQgmAAgXAag");
	this.shape_5910.setTransform(285.3,663.7,0.5,0.5);

	this.shape_5911 = new cjs.Shape();
	this.shape_5911.graphics.f("#000000").s().p("AgwDwIAAgVQATAFANAAQAlAAAAgsIAAlGIAYAAIAAFCQAAAhgQATQgPASgdAAQgUAAgNgGgAARjdQAAgYAQAAQAHAAAFAGQAEAGAAAMQAAALgEAHQgFAGgHAAQgQAAAAgYg");
	this.shape_5911.setTransform(273.8,664.3,0.5,0.5);

	this.shape_5912 = new cjs.Shape();
	this.shape_5912.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjDAAQABA4AaAeQAZAdAvAAQAXAAASgDQATgEAZgKIAAAXQgYAJgSAEQgTAEgYAAQg7AAggglgAg2hbQgYAYgEAyICnAAQAAgwgVgaQgVgbgkABQgmAAgXAag");
	this.shape_5912.setTransform(258.9,663.7,0.5,0.5);

	this.shape_5913 = new cjs.Shape();
	this.shape_5913.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_5913.setTransform(243.9,660.9,0.5,0.5);

	this.shape_5914 = new cjs.Shape();
	this.shape_5914.graphics.f("#000000").s().p("AhOB4QgXgUAAglQABgnAggWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgCAAQgVAbgVAKQgVALgcAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5914.setTransform(229.5,663.7,0.5,0.5);

	this.shape_5915 = new cjs.Shape();
	this.shape_5915.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5915.setTransform(212,663.6,0.5,0.5);

	this.shape_5916 = new cjs.Shape();
	this.shape_5916.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAdAAAWALQAWALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_5916.setTransform(192.7,660.9,0.5,0.5);

	this.shape_5917 = new cjs.Shape();
	this.shape_5917.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_5917.setTransform(178.1,663.6,0.5,0.5);

	this.shape_5918 = new cjs.Shape();
	this.shape_5918.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_5918.setTransform(163.3,663.7,0.5,0.5);

	this.shape_5919 = new cjs.Shape();
	this.shape_5919.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgYAXgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_5919.setTransform(149.5,660.8,0.5,0.5);

	this.shape_5920 = new cjs.Shape();
	this.shape_5920.graphics.f("#000000").s().p("AheC0QgbgTAAgkQAAgcARgSQARgTAdgHQgLgFgIgJQgHgKgBgMQABgbAigUQgYgKgMgVQgOgVAAgbQAAgnAagaQAagYAsAAQAZAAAPAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAJAAANQAAAMAKAGQAKAGAXAAIAuAAQAsAAAXASQAYASAAAjQAAAqgiAYQgjAXg/AAQg0AAgcgTgAhfB7QAAA3BSAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAABA7gAg5igQgSATAAAgQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgSgRQgUgSgfAAQghAAgTATg");
	this.shape_5920.setTransform(128.7,666.6,0.5,0.5);

	this.shape_5921 = new cjs.Shape();
	this.shape_5921.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgvAAgXAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_5921.setTransform(114.5,663.6,0.5,0.5);

	this.shape_5922 = new cjs.Shape();
	this.shape_5922.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAFAGQAFAHAAALQAAALgFAHQgFAHgGAAQgPgBAAgYg");
	this.shape_5922.setTransform(104.1,661.2,0.5,0.5);

	this.shape_5923 = new cjs.Shape();
	this.shape_5923.graphics.f("#000000").s().p("AgSCXQgQgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXAAQAZAAAQgDIAAAUQgRAFgZABQgiAAgSgUg");
	this.shape_5923.setTransform(96.7,662.2,0.5,0.5);

	this.shape_5924 = new cjs.Shape();
	this.shape_5924.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAWAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_5924.setTransform(85.4,663.7,0.5,0.5);

	this.shape_5925 = new cjs.Shape();
	this.shape_5925.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgbgjABQgnAAgXAag");
	this.shape_5925.setTransform(72.1,663.7,0.5,0.5);

	this.shape_5926 = new cjs.Shape();
	this.shape_5926.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5926.setTransform(61.1,663.6,0.5,0.5);

	this.shape_5927 = new cjs.Shape();
	this.shape_5927.graphics.f("#000000").s().p("Ag/BoQghglAAhBQAAhCAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA3AZAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_5927.setTransform(49.4,663.7,0.5,0.5);

	this.shape_5928 = new cjs.Shape();
	this.shape_5928.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5928.setTransform(638.6,625.3,0.5,0.5);

	this.shape_5929 = new cjs.Shape();
	this.shape_5929.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgYAfg");
	this.shape_5929.setTransform(625.3,625.4,0.5,0.5);

	this.shape_5930 = new cjs.Shape();
	this.shape_5930.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQABgyASgXQARgXAqAAQAXAAAVAHIgFAVQgWgHgSABQgdAAgLARQgMAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_5930.setTransform(614.9,622.5,0.5,0.5);

	this.shape_5931 = new cjs.Shape();
	this.shape_5931.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_5931.setTransform(596.1,625.3,0.5,0.5);

	this.shape_5932 = new cjs.Shape();
	this.shape_5932.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_5932.setTransform(581.1,625.4,0.5,0.5);

	this.shape_5933 = new cjs.Shape();
	this.shape_5933.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAHgHAAQgPgBAAgYg");
	this.shape_5933.setTransform(570.7,623,0.5,0.5);

	this.shape_5934 = new cjs.Shape();
	this.shape_5934.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmAAAWgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgJgOABgSQAAgfAZgSQAagSAsAAQAtAAAnARIgKAXQgngRgjAAQggAAgTALQgTALgBATQAAAWAPAMQAPANAsAPQAjANASAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_5934.setTransform(561.8,625.4,0.5,0.5);

	this.shape_5935 = new cjs.Shape();
	this.shape_5935.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAmAAAWgMQAUgNABgXQgBgVgQgNQgQgPgmgNQgqgOgPgKQgQgLgIgNQgJgOABgSQAAgfAZgSQAagSAsAAQAtAAAnARIgJAXQgogRgjAAQggAAgTALQgTALgBATQAAAWAPAMQAPANAsAPQAjANASAKQAPALAKAOQAIAMAAATQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_5935.setTransform(549.9,625.4,0.5,0.5);

	this.shape_5936 = new cjs.Shape();
	this.shape_5936.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5936.setTransform(536.9,625.4,0.5,0.5);

	this.shape_5937 = new cjs.Shape();
	this.shape_5937.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_5937.setTransform(523.4,628.4,0.5,0.5);

	this.shape_5938 = new cjs.Shape();
	this.shape_5938.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_5938.setTransform(504.7,625.3,0.5,0.5);

	this.shape_5939 = new cjs.Shape();
	this.shape_5939.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAhAAA5IAAATIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAZgEAxICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_5939.setTransform(491.9,625.4,0.5,0.5);

	this.shape_5940 = new cjs.Shape();
	this.shape_5940.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAhAAQBbAAABBiIAACxg");
	this.shape_5940.setTransform(477.4,622.5,0.5,0.5);

	this.shape_5941 = new cjs.Shape();
	this.shape_5941.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgNgFgHgJQgHgKAAgMQAAgbAigUQgYgKgNgVQgNgVAAgbQAAgoAagZQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAbAAAiQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgyAAgdgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgTgSggAAQghAAgSATg");
	this.shape_5941.setTransform(456.5,628.4,0.5,0.5);

	this.shape_5942 = new cjs.Shape();
	this.shape_5942.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAagrBEAAQBcAAgBBjIAACwg");
	this.shape_5942.setTransform(442.4,625.3,0.5,0.5);

	this.shape_5943 = new cjs.Shape();
	this.shape_5943.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAHgHAAQgPgBAAgYg");
	this.shape_5943.setTransform(431.9,623,0.5,0.5);

	this.shape_5944 = new cjs.Shape();
	this.shape_5944.graphics.f("#000000").s().p("AhABoQggglgBhBQABhCAhgmQAjgmA6AAQAkAAAgANIgIAVQgjgLgaAAQgxAAgZAfQgZAfgBA4QABA3AZAfQAZAfAuAAQAjAAAigNIAAAXQgaANgrAAQg5AAghglg");
	this.shape_5944.setTransform(423.3,625.4,0.5,0.5);

	this.shape_5945 = new cjs.Shape();
	this.shape_5945.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5945.setTransform(409.7,625.4,0.5,0.5);

	this.shape_5946 = new cjs.Shape();
	this.shape_5946.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_5946.setTransform(399.3,625.3,0.5,0.5);

	this.shape_5947 = new cjs.Shape();
	this.shape_5947.graphics.f("#000000").s().p("Ag0C4QgYgMgNgWIgCAAIgHApIgPAAIAAmCIAYAAIAABhIgBAoIAAAWIABAAQAQgZAWgLQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAbAAA/IAAAEQAAA8AWAcQAWAaAtAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_5947.setTransform(386.3,622.6,0.5,0.5);

	this.shape_5948 = new cjs.Shape();
	this.shape_5948.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgUAYQgTAWAAAyIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQAOgXAWgNQAXgMAbAAQAtAAAWAYQAWAYAAAzIAACwg");
	this.shape_5948.setTransform(367.1,625.3,0.5,0.5);

	this.shape_5949 = new cjs.Shape();
	this.shape_5949.graphics.f("#000000").s().p("AhiC2IAAlrIDGAAIAAAYIitAAIAACJICjAAIAAAWIijAAIAACdICtAAIAAAXg");
	this.shape_5949.setTransform(349.3,623.1,0.5,0.5);

	this.shape_5950 = new cjs.Shape();
	this.shape_5950.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_5950.setTransform(332.1,631.2,0.5,0.5);

	this.shape_5951 = new cjs.Shape();
	this.shape_5951.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAYAAAzIAACwg");
	this.shape_5951.setTransform(317.9,625.3,0.5,0.5);

	this.shape_5952 = new cjs.Shape();
	this.shape_5952.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_5952.setTransform(298.9,625.6,0.5,0.5);

	this.shape_5953 = new cjs.Shape();
	this.shape_5953.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAaAiQAdAhAAA5IAAATIjCAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTAEgYAAQg6AAghglgAg3hbQgYAZgDAxICmAAQAAgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_5953.setTransform(284.5,625.4,0.5,0.5);

	this.shape_5954 = new cjs.Shape();
	this.shape_5954.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgIgNAAgTQAAgfAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_5954.setTransform(271.5,625.4,0.5,0.5);

	this.shape_5955 = new cjs.Shape();
	this.shape_5955.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAAAhjg");
	this.shape_5955.setTransform(258,625.6,0.5,0.5);

	this.shape_5956 = new cjs.Shape();
	this.shape_5956.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlPIgCAAIACA/IAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_5956.setTransform(239.6,623.1,0.5,0.5);

	this.shape_5957 = new cjs.Shape();
	this.shape_5957.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5957.setTransform(214.7,625.4,0.5,0.5);

	this.shape_5958 = new cjs.Shape();
	this.shape_5958.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAaIABAAQAKggALgeIBGi2IAZAAIhpENg");
	this.shape_5958.setTransform(202.6,625.4,0.5,0.5);

	this.shape_5959 = new cjs.Shape();
	this.shape_5959.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_5959.setTransform(189.3,625.4,0.5,0.5);

	this.shape_5960 = new cjs.Shape();
	this.shape_5960.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAfAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgwAAQgrAAgWAfg");
	this.shape_5960.setTransform(173.8,622.6,0.5,0.5);

	this.shape_5961 = new cjs.Shape();
	this.shape_5961.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_5961.setTransform(162.5,625.3,0.5,0.5);

	this.shape_5962 = new cjs.Shape();
	this.shape_5962.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAlAABBQAABDggAkQghAmg3AAQgjAAgcgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_5962.setTransform(149.2,625.4,0.5,0.5);

	this.shape_5963 = new cjs.Shape();
	this.shape_5963.graphics.f("#000000").s().p("AhZCKQgsgxAAhZQAAg3AVgrQAVgqAngXQAogXAzAAQA0AAArAUIgKAXQgpgUgrAAQhDAAgnAsQgoArAABMQAABOAlArQAmArBDAAQAuAAAngMIAAAXQgkAMg3AAQhLAAgsgxg");
	this.shape_5963.setTransform(134.2,623.1,0.5,0.5);

	this.shape_5964 = new cjs.Shape();
	this.shape_5964.graphics.f("#000000").s().p("AhMBoQghgkgBhCQABhAAggmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjDAAQAAA3AaAfQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAJgTAEQgSAEgaAAQg6AAggglgAg3hbQgXAZgEAxICmAAQAAgwgUgaQgVgbgkABQglAAgZAag");
	this.shape_5964.setTransform(112.3,625.4,0.5,0.5);

	this.shape_5965 = new cjs.Shape();
	this.shape_5965.graphics.f("#000000").s().p("AiJC2IAAlrIBiAAQBWAAAuAtQAtAuAABYQAABagwAvQgvAvhdAAgAhwCgIA9AAQCiAAAAiiQAAhOgognQgngohNABIhDAAg");
	this.shape_5965.setTransform(96.8,623.1,0.5,0.5);

	this.shape_5966 = new cjs.Shape();
	this.shape_5966.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgFAYgJIAAAXQgWAJgTAEQgTAEgYAAQg6AAghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_5966.setTransform(73.7,625.4,0.5,0.5);

	this.shape_5967 = new cjs.Shape();
	this.shape_5967.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_5967.setTransform(59.2,622.5,0.5,0.5);

	this.shape_5968 = new cjs.Shape();
	this.shape_5968.graphics.f("#000000").s().p("AgSCXQgRgUAAgoIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_5968.setTransform(47.2,623.9,0.5,0.5);

	this.shape_5969 = new cjs.Shape();
	this.shape_5969.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_5969.setTransform(592,584.4,0.5,0.5);

	this.shape_5970 = new cjs.Shape();
	this.shape_5970.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAagrBEAAQBcAAAABjIAACwg");
	this.shape_5970.setTransform(577.4,587.1,0.5,0.5);

	this.shape_5971 = new cjs.Shape();
	this.shape_5971.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5971.setTransform(562.6,587.2,0.5,0.5);

	this.shape_5972 = new cjs.Shape();
	this.shape_5972.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_5972.setTransform(545.6,587.1,0.5,0.5);

	this.shape_5973 = new cjs.Shape();
	this.shape_5973.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQgBA3AaAfQAZAdAwAAQAXAAARgDQAUgEAYgKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgZAZgDAxICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_5973.setTransform(532.8,587.2,0.5,0.5);

	this.shape_5974 = new cjs.Shape();
	this.shape_5974.graphics.f("#000000").s().p("AgSCXQgQgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAPAXAAQAZAAAQgDIAAAUQgTAFgXABQgiAAgSgUg");
	this.shape_5974.setTransform(521.3,585.7,0.5,0.5);

	this.shape_5975 = new cjs.Shape();
	this.shape_5975.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgTgkAAQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBCAAQBdAAAABjIAACwg");
	this.shape_5975.setTransform(509.8,587.1,0.5,0.5);

	this.shape_5976 = new cjs.Shape();
	this.shape_5976.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAhAAA5IAAATIjBAAQAAA3AZAfQAZAdAwAAQAXAAARgDQASgEAbgKIAAAXQgXAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_5976.setTransform(495.2,587.2,0.5,0.5);

	this.shape_5977 = new cjs.Shape();
	this.shape_5977.graphics.f("#000000").s().p("AhZCKQgtgyAAhYQAAg3AWgrQAVgrAngWQAogXAzAAQA1AAAqAUIgKAXQgpgUgqAAQhEAAgnAsQgoArAABMQABBPAkAqQAlArBEAAQAuAAAngMIAAAXQgkAMg2AAQhNAAgrgxg");
	this.shape_5977.setTransform(480.7,584.8,0.5,0.5);

	this.shape_5978 = new cjs.Shape();
	this.shape_5978.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgrgPgNgJQgRgLgIgNQgJgOAAgSQABgfAZgSQAZgSAuAAQArAAAnARIgJAXQgngRgiAAQghAAgTALQgUALABATQgBAWAQAMQAOANArAPQAkANASAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_5978.setTransform(459.7,587.2,0.5,0.5);

	this.shape_5979 = new cjs.Shape();
	this.shape_5979.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_5979.setTransform(449.4,585.7,0.5,0.5);

	this.shape_5980 = new cjs.Shape();
	this.shape_5980.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5980.setTransform(441.2,587.1,0.5,0.5);

	this.shape_5981 = new cjs.Shape();
	this.shape_5981.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgyCBIgdAAICTltIAPAAICPFtgAgMhiIg0CBICCAAIhBitQgFAWgIAWg");
	this.shape_5981.setTransform(427.7,584.8,0.5,0.5);

	this.shape_5982 = new cjs.Shape();
	this.shape_5982.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAwAAAbAiQAdAhAAA5IAAATIjCAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgVAJgUAEQgTAEgYAAQg7AAggglgAg3hbQgXAYgEAyICmAAQAAgxgVgZQgUgbgkABQgmAAgYAag");
	this.shape_5982.setTransform(406.5,587.2,0.5,0.5);

	this.shape_5983 = new cjs.Shape();
	this.shape_5983.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTglAAQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_5983.setTransform(392,587.1,0.5,0.5);

	this.shape_5984 = new cjs.Shape();
	this.shape_5984.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_5984.setTransform(381.5,584.7,0.5,0.5);

	this.shape_5985 = new cjs.Shape();
	this.shape_5985.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_5985.setTransform(375.8,584.3,0.5,0.5);

	this.shape_5986 = new cjs.Shape();
	this.shape_5986.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_5986.setTransform(367.8,584.3,0.5,0.5);

	this.shape_5987 = new cjs.Shape();
	this.shape_5987.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_5987.setTransform(353.1,587.2,0.5,0.5);

	this.shape_5988 = new cjs.Shape();
	this.shape_5988.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgYAfg");
	this.shape_5988.setTransform(338.1,587.2,0.5,0.5);

	this.shape_5989 = new cjs.Shape();
	this.shape_5989.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAWADIgEAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_5989.setTransform(326.6,587.1,0.5,0.5);

	this.shape_5990 = new cjs.Shape();
	this.shape_5990.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBDAAAfAXQAgAWAAAvQAAAfgUAWQgTAVglAGIAAABQArAGAVAVQAVAVAAAmQAAAygiAbQghAbg8AAgAheCgIBWAAQBkgBAAhRQAAhMhpAAIhRAAgAhegTIBRAAQAyAAAXgRQAXgRAAglQAAgjgagRQgagQgzAAIhKAAg");
	this.shape_5990.setTransform(313.3,584.9,0.5,0.5);

	this.shape_5991 = new cjs.Shape();
	this.shape_5991.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjDAAQAAA3AbAfQAZAdAuAAQAYAAARgDQASgEAbgKIAAAXQgXAJgTAEQgSAEgaAAQg6AAggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_5991.setTransform(291.1,587.2,0.5,0.5);

	this.shape_5992 = new cjs.Shape();
	this.shape_5992.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAZgLAgAAQBcAAgBBiIAACxg");
	this.shape_5992.setTransform(276.7,584.3,0.5,0.5);

	this.shape_5993 = new cjs.Shape();
	this.shape_5993.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_5993.setTransform(264.6,585.7,0.5,0.5);

	this.shape_5994 = new cjs.Shape();
	this.shape_5994.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_5994.setTransform(249.5,585.7,0.5,0.5);

	this.shape_5995 = new cjs.Shape();
	this.shape_5995.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5995.setTransform(238.2,587.2,0.5,0.5);

	this.shape_5996 = new cjs.Shape();
	this.shape_5996.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAmAAAWgMQAVgOAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUALAAATQAAAWAPAMQAQANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_5996.setTransform(219.2,587.2,0.5,0.5);

	this.shape_5997 = new cjs.Shape();
	this.shape_5997.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgpAAgVAYQgTAXgBAxIAACdIgYAAIAAi4QABhFg/AAQgqAAgUAZQgTAagBA2IAACUIgYAAIAAkOIAUAAIAGAmIABAAQAMgVATgLQAXgLAXAAQBBAAAQAwIACAAQANgXAWgNQAYgMAaAAQAtAAAWAYQAXAYgBAzIAACwg");
	this.shape_5997.setTransform(202.2,587.1,0.5,0.5);

	this.shape_5998 = new cjs.Shape();
	this.shape_5998.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_5998.setTransform(183.6,587.2,0.5,0.5);

	this.shape_5999 = new cjs.Shape();
	this.shape_5999.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_5999.setTransform(173.3,587.1,0.5,0.5);

	this.shape_6000 = new cjs.Shape();
	this.shape_6000.graphics.f("#000000").s().p("AheC0QgcgTAAgkQABgcAQgSQASgTAdgHQgLgFgIgJQgIgKAAgMQAAgbAjgUQgYgKgNgVQgNgVAAgbQAAgnAagaQAagYArAAQAZAAAQAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgOAIgIAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAWASQAYASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg5igQgSASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgUgSggAAQggAAgTATg");
	this.shape_6000.setTransform(160.8,590.1,0.5,0.5);

	this.shape_6001 = new cjs.Shape();
	this.shape_6001.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_6001.setTransform(146.6,587.2,0.5,0.5);

	this.shape_6002 = new cjs.Shape();
	this.shape_6002.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgeASgMQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6002.setTransform(135.1,587.1,0.5,0.5);

	this.shape_6003 = new cjs.Shape();
	this.shape_6003.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_6003.setTransform(122,590.1,0.5,0.5);

	this.shape_6004 = new cjs.Shape();
	this.shape_6004.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_6004.setTransform(104.5,584.3,0.5,0.5);

	this.shape_6005 = new cjs.Shape();
	this.shape_6005.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6005.setTransform(94.4,587.2,0.5,0.5);

	this.shape_6006 = new cjs.Shape();
	this.shape_6006.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_6006.setTransform(83.7,585.7,0.5,0.5);

	this.shape_6007 = new cjs.Shape();
	this.shape_6007.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAvAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgTAEgZAAQg5AAghglgAg3hbQgYAZgDAxICnAAQAAgwgVgaQgVgbgkABQgmAAgYAag");
	this.shape_6007.setTransform(72.6,587.2,0.5,0.5);

	this.shape_6008 = new cjs.Shape();
	this.shape_6008.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgSggAAQgpAAgUAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAWgLAXAAQBAAAASAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6008.setTransform(54.4,587.1,0.5,0.5);

	this.shape_6009 = new cjs.Shape();
	this.shape_6009.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6009.setTransform(645.6,546,0.5,0.5);

	this.shape_6010 = new cjs.Shape();
	this.shape_6010.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6010.setTransform(635.6,548.9,0.5,0.5);

	this.shape_6011 = new cjs.Shape();
	this.shape_6011.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6011.setTransform(625.2,548.8,0.5,0.5);

	this.shape_6012 = new cjs.Shape();
	this.shape_6012.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6012.setTransform(612.3,548.9,0.5,0.5);

	this.shape_6013 = new cjs.Shape();
	this.shape_6013.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAOAjAHAaIABAAQAKghALgdIBGi2IAZAAIhpENg");
	this.shape_6013.setTransform(599.5,548.9,0.5,0.5);

	this.shape_6014 = new cjs.Shape();
	this.shape_6014.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6014.setTransform(586.6,548.9,0.5,0.5);

	this.shape_6015 = new cjs.Shape();
	this.shape_6015.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmAAAWgMQAVgOAAgWQAAgVgRgNQgRgPglgNQgqgPgOgJQgRgLgIgNQgJgOAAgSQAAggAagRQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUALAAATQAAAWAPAMQAPANArAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_6015.setTransform(573.6,548.9,0.5,0.5);

	this.shape_6016 = new cjs.Shape();
	this.shape_6016.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6016.setTransform(553.7,548.8,0.5,0.5);

	this.shape_6017 = new cjs.Shape();
	this.shape_6017.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAHQgEAHgHAAQgPgBAAgYg");
	this.shape_6017.setTransform(543.2,546.5,0.5,0.5);

	this.shape_6018 = new cjs.Shape();
	this.shape_6018.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6018.setTransform(529.3,547.4,0.5,0.5);

	this.shape_6019 = new cjs.Shape();
	this.shape_6019.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6019.setTransform(517.7,546,0.5,0.5);

	this.shape_6020 = new cjs.Shape();
	this.shape_6020.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQgBgcASgSQARgTAegHQgMgFgIgJQgHgKAAgMQgBgbAkgUQgYgKgNgVQgNgUgBgcQABgoAZgZQAagYAsAAQAZAAAPAFIBWAAIAAARIg3AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgTAAgGgCQgQAIgHAKQgIAJAAANQAAAMAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgiAYQgjAXg/AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgQgLQgRgLglAAIgsAAQhKAAAAA7gAg5igQgSATAAAgQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgTgRQgTgSgfAAQghAAgTATg");
	this.shape_6020.setTransform(503.5,551.9,0.5,0.5);

	this.shape_6021 = new cjs.Shape();
	this.shape_6021.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_6021.setTransform(489.2,549.1,0.5,0.5);

	this.shape_6022 = new cjs.Shape();
	this.shape_6022.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6022.setTransform(474.5,548.9,0.5,0.5);

	this.shape_6023 = new cjs.Shape();
	this.shape_6023.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6023.setTransform(463.8,547.4,0.5,0.5);

	this.shape_6024 = new cjs.Shape();
	this.shape_6024.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAUgFAZgJIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgbgjABQgnAAgXAag");
	this.shape_6024.setTransform(446.1,548.9,0.5,0.5);

	this.shape_6025 = new cjs.Shape();
	this.shape_6025.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAZgLAfAAQBdAAAABiIAACxg");
	this.shape_6025.setTransform(431.6,546,0.5,0.5);

	this.shape_6026 = new cjs.Shape();
	this.shape_6026.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAmAAAWgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgIgOgBgSQAAgfAagSQAZgSAuAAQArAAAnARIgJAXQgngRgiAAQghAAgTALQgTALAAATQgBAWAPAMQAPANArAPQAkANASAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_6026.setTransform(418,548.9,0.5,0.5);

	this.shape_6027 = new cjs.Shape();
	this.shape_6027.graphics.f("#000000").s().p("AgdA+QAUhIAIg0IAcAAIADAFQgTBBgYA2g");
	this.shape_6027.setTransform(402.4,555.9,0.5,0.5);

	this.shape_6028 = new cjs.Shape();
	this.shape_6028.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6028.setTransform(396,548.8,0.5,0.5);

	this.shape_6029 = new cjs.Shape();
	this.shape_6029.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAagYAAgtIAAgZg");
	this.shape_6029.setTransform(382.9,548.9,0.5,0.5);

	this.shape_6030 = new cjs.Shape();
	this.shape_6030.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6030.setTransform(373.7,546,0.5,0.5);

	this.shape_6031 = new cjs.Shape();
	this.shape_6031.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AZAgQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6031.setTransform(363.4,548.9,0.5,0.5);

	this.shape_6032 = new cjs.Shape();
	this.shape_6032.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgXAYgMQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6032.setTransform(348.5,546,0.5,0.5);

	this.shape_6033 = new cjs.Shape();
	this.shape_6033.graphics.f("#000000").s().p("Ag/BoQgiglABhBQAAhCAigmQAigmA6AAQAkAAAgANIgHAVQgkgLgaAAQgwAAgZAfQgaAeAAA5QAAA3AaAfQAYAfAuAAQAlAAAfgNIAAAXQgZANgqAAQg6AAggglg");
	this.shape_6033.setTransform(335.1,548.9,0.5,0.5);

	this.shape_6034 = new cjs.Shape();
	this.shape_6034.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmAAAWgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgrgPgNgJQgQgLgJgNQgIgOAAgSQgBgfAagSQAZgSAuAAQAsAAAnARIgJAXQgogRgiAAQghAAgTALQgTALAAATQAAAWAOAMQAPANAsAPQAjANASAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg3gBgfgQg");
	this.shape_6034.setTransform(322.7,548.9,0.5,0.5);

	this.shape_6035 = new cjs.Shape();
	this.shape_6035.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6035.setTransform(303.3,548.9,0.5,0.5);

	this.shape_6036 = new cjs.Shape();
	this.shape_6036.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAAoARAUQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_6036.setTransform(288.7,549.1,0.5,0.5);

	this.shape_6037 = new cjs.Shape();
	this.shape_6037.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAcAAAuIAACUg");
	this.shape_6037.setTransform(277.1,548.8,0.5,0.5);

	this.shape_6038 = new cjs.Shape();
	this.shape_6038.graphics.f("#000000").s().p("AgRCXQgRgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgXABQgjAAgRgUg");
	this.shape_6038.setTransform(266.8,547.4,0.5,0.5);

	this.shape_6039 = new cjs.Shape();
	this.shape_6039.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6039.setTransform(248.9,548.9,0.5,0.5);

	this.shape_6040 = new cjs.Shape();
	this.shape_6040.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA4AYAeQAZAdAwAAQAWAAASgDQAUgEAZgKIAAAXQgXAJgUAEQgSAEgYAAQg6AAgiglgAg2hbQgZAZgDAxICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_6040.setTransform(229,548.9,0.5,0.5);

	this.shape_6041 = new cjs.Shape();
	this.shape_6041.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAdAAIhpBzIBzCbg");
	this.shape_6041.setTransform(217,546,0.5,0.5);

	this.shape_6042 = new cjs.Shape();
	this.shape_6042.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_6042.setTransform(206.8,546.5,0.5,0.5);

	this.shape_6043 = new cjs.Shape();
	this.shape_6043.graphics.f("#000000").s().p("AhiC2IAAlrIAZAAIAAFTICtAAIAAAYg");
	this.shape_6043.setTransform(198.4,546.6,0.5,0.5);

	this.shape_6044 = new cjs.Shape();
	this.shape_6044.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6044.setTransform(181.2,554.7,0.5,0.5);

	this.shape_6045 = new cjs.Shape();
	this.shape_6045.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6045.setTransform(170.9,548.9,0.5,0.5);

	this.shape_6046 = new cjs.Shape();
	this.shape_6046.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAHgGAAQgPgBAAgYg");
	this.shape_6046.setTransform(161.8,546.5,0.5,0.5);

	this.shape_6047 = new cjs.Shape();
	this.shape_6047.graphics.f("#000000").s().p("AgLCHIhpkNIAZAAIBGC3QAPAjAGAaIAAAAQALggAKgeIBGi2IAaAAIhpENg");
	this.shape_6047.setTransform(153,548.9,0.5,0.5);

	this.shape_6048 = new cjs.Shape();
	this.shape_6048.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6048.setTransform(139.9,548.9,0.5,0.5);

	this.shape_6049 = new cjs.Shape();
	this.shape_6049.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6049.setTransform(126.2,548.8,0.5,0.5);

	this.shape_6050 = new cjs.Shape();
	this.shape_6050.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAHgHAAQgPgBAAgYg");
	this.shape_6050.setTransform(115.7,546.5,0.5,0.5);

	this.shape_6051 = new cjs.Shape();
	this.shape_6051.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6051.setTransform(104.8,546.1,0.5,0.5);

	this.shape_6052 = new cjs.Shape();
	this.shape_6052.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgTgkAAQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_6052.setTransform(90.2,548.8,0.5,0.5);

	this.shape_6053 = new cjs.Shape();
	this.shape_6053.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6053.setTransform(75.4,548.9,0.5,0.5);

	this.shape_6054 = new cjs.Shape();
	this.shape_6054.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgaAeAAA5QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_6054.setTransform(63.3,548.9,0.5,0.5);

	this.shape_6055 = new cjs.Shape();
	this.shape_6055.graphics.f("#000000").s().p("AhvCtIAAgaQAmARA9AAQAsAAAbgVQAagUAAgiQAAgUgIgOQgKgOgTgLQgTgLgmgNQg4gSgVgWQgVgXAAglQAAgpAggZQAggaAxAAQAzAAAuATIgJAWQgvgTgpAAQgmAAgYATQgZATAAAgQAAAUAIANQAHAMARALQAPAKApAPQArAOAVAOQAVANALASQAKASAAAYQgBAtghAcQgiAag3AAQhBAAgkgOg");
	this.shape_6055.setTransform(50.1,546.6,0.5,0.5);

	this.shape_6056 = new cjs.Shape();
	this.shape_6056.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6056.setTransform(613.7,510.7,0.5,0.5);

	this.shape_6057 = new cjs.Shape();
	this.shape_6057.graphics.f("#000000").s().p("AgRCXQgRgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAPAYAAQAZAAAQgDIAAAUQgSAFgXABQgkAAgQgUg");
	this.shape_6057.setTransform(601.8,509.2,0.5,0.5);

	this.shape_6058 = new cjs.Shape();
	this.shape_6058.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABGQAABCgeAkQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAbAAA6IAAAIQAAA/AVAbQAWAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQguAAgXAag");
	this.shape_6058.setTransform(583.9,513.6,0.5,0.5);

	this.shape_6059 = new cjs.Shape();
	this.shape_6059.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6059.setTransform(573,508.2,0.5,0.5);

	this.shape_6060 = new cjs.Shape();
	this.shape_6060.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6060.setTransform(562.7,507.8,0.5,0.5);

	this.shape_6061 = new cjs.Shape();
	this.shape_6061.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6061.setTransform(549,510.7,0.5,0.5);

	this.shape_6062 = new cjs.Shape();
	this.shape_6062.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIACAAQAMgxAJgcIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgOAThJIApiaIAZAAIhKENg");
	this.shape_6062.setTransform(534,510.7,0.5,0.5);

	this.shape_6063 = new cjs.Shape();
	this.shape_6063.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6063.setTransform(517.3,510.7,0.5,0.5);

	this.shape_6064 = new cjs.Shape();
	this.shape_6064.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6064.setTransform(506.9,507.8,0.5,0.5);

	this.shape_6065 = new cjs.Shape();
	this.shape_6065.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6065.setTransform(501.2,507.8,0.5,0.5);

	this.shape_6066 = new cjs.Shape();
	this.shape_6066.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6066.setTransform(491.3,510.7,0.5,0.5);

	this.shape_6067 = new cjs.Shape();
	this.shape_6067.graphics.f("#000000").s().p("AgkDDIAAj4IgyAAIAAgPIAygJIAAgVQAAgxATgYQARgXAqAAQAXAAAWAHIgGAVQgVgHgTABQgdAAgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6067.setTransform(481.3,507.7,0.5,0.5);

	this.shape_6068 = new cjs.Shape();
	this.shape_6068.graphics.f("#000000").s().p("AhdC0QgcgTAAgkQgBgcASgSQARgTAegHQgMgFgIgJQgHgKAAgMQAAgbAigUQgYgKgMgVQgOgVAAgbQAAgnAagaQAagYAsAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgOAIgJAKQgHAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAsAAAYASQAXASAAAjQAAAqgiAYQgkAXg+AAQgzAAgcgTgAhfB7QAAA3BTAAQBpAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhKAAAAA7gAg4igQgTATAAAgQAAAgATARQATARAgAAQAiAAARgRQASgRAAggQAAgjgTgRQgSgSggAAQghAAgSATg");
	this.shape_6068.setTransform(463.4,513.6,0.5,0.5);

	this.shape_6069 = new cjs.Shape();
	this.shape_6069.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6069.setTransform(449.2,510.6,0.5,0.5);

	this.shape_6070 = new cjs.Shape();
	this.shape_6070.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAGgGABQgPgBAAgYg");
	this.shape_6070.setTransform(438.8,508.2,0.5,0.5);

	this.shape_6071 = new cjs.Shape();
	this.shape_6071.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6071.setTransform(433,507.8,0.5,0.5);

	this.shape_6072 = new cjs.Shape();
	this.shape_6072.graphics.f("#000000").s().p("AhNBoQgggkAAhCQgBg/AggnQAggoA1AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQAAA3AaAfQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgUAEQgSAEgZAAQg5AAgiglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgbgkABQgnAAgWAag");
	this.shape_6072.setTransform(423.1,510.7,0.5,0.5);

	this.shape_6073 = new cjs.Shape();
	this.shape_6073.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAjAGAaIABAAQAKghALgdIBGi2IAZAAIhpENg");
	this.shape_6073.setTransform(410.3,510.7,0.5,0.5);

	this.shape_6074 = new cjs.Shape();
	this.shape_6074.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6074.setTransform(397.2,510.7,0.5,0.5);

	this.shape_6075 = new cjs.Shape();
	this.shape_6075.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAWADIgEAYQgTgEgQAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_6075.setTransform(386.8,510.6,0.5,0.5);

	this.shape_6076 = new cjs.Shape();
	this.shape_6076.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6076.setTransform(376.5,509.2,0.5,0.5);

	this.shape_6077 = new cjs.Shape();
	this.shape_6077.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6077.setTransform(358.4,507.8,0.5,0.5);

	this.shape_6078 = new cjs.Shape();
	this.shape_6078.graphics.f("#000000").s().p("AgSCXQgQgTgBgpIAAiuIgnAAIAAgOIAngMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXAAQAZAAAQgDIAAAUQgTAFgXABQgiAAgSgUg");
	this.shape_6078.setTransform(346.3,509.2,0.5,0.5);

	this.shape_6079 = new cjs.Shape();
	this.shape_6079.graphics.f("#000000").s().p("ABTCKIAAivQAAgogSgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAbgrBBAAQBcAAAABjIAACwg");
	this.shape_6079.setTransform(334.8,510.6,0.5,0.5);

	this.shape_6080 = new cjs.Shape();
	this.shape_6080.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6080.setTransform(319.7,510.7,0.5,0.5);

	this.shape_6081 = new cjs.Shape();
	this.shape_6081.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAWgLAXAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6081.setTransform(301.1,510.6,0.5,0.5);

	this.shape_6082 = new cjs.Shape();
	this.shape_6082.graphics.f("#000000").s().p("Ag6AKIAAgTIB1AAIAAATg");
	this.shape_6082.setTransform(285.6,510.6,0.5,0.5);

	this.shape_6083 = new cjs.Shape();
	this.shape_6083.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6083.setTransform(274.5,510.7,0.5,0.5);

	this.shape_6084 = new cjs.Shape();
	this.shape_6084.graphics.f("#000000").s().p("AhNBoQgggkAAhCQgBg/AggnQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA3AaAfQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgxgVgZQgUgbgkABQgmAAgXAag");
	this.shape_6084.setTransform(260.6,510.7,0.5,0.5);

	this.shape_6085 = new cjs.Shape();
	this.shape_6085.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6085.setTransform(249.5,510.6,0.5,0.5);

	this.shape_6086 = new cjs.Shape();
	this.shape_6086.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_6086.setTransform(236.2,507.8,0.5,0.5);

	this.shape_6087 = new cjs.Shape();
	this.shape_6087.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgAKAOQAMAPAXAAQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6087.setTransform(224.1,509.2,0.5,0.5);

	this.shape_6088 = new cjs.Shape();
	this.shape_6088.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6088.setTransform(206.2,510.7,0.5,0.5);

	this.shape_6089 = new cjs.Shape();
	this.shape_6089.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6089.setTransform(185.3,507.9,0.5,0.5);

	this.shape_6090 = new cjs.Shape();
	this.shape_6090.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTAEgYAAQg6AAghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6090.setTransform(171.1,510.7,0.5,0.5);

	this.shape_6091 = new cjs.Shape();
	this.shape_6091.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6091.setTransform(156.1,507.9,0.5,0.5);

	this.shape_6092 = new cjs.Shape();
	this.shape_6092.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6092.setTransform(144.9,510.6,0.5,0.5);

	this.shape_6093 = new cjs.Shape();
	this.shape_6093.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6093.setTransform(131.8,510.7,0.5,0.5);

	this.shape_6094 = new cjs.Shape();
	this.shape_6094.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAOA4AGAeIACAAQANg3AIgWIA4ikIAVAAIA1CjQATA9ADARIACAAQABgOAThJIApiaIAZAAIhKENg");
	this.shape_6094.setTransform(116.3,510.7,0.5,0.5);

	this.shape_6095 = new cjs.Shape();
	this.shape_6095.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6095.setTransform(99.8,510.7,0.5,0.5);

	this.shape_6096 = new cjs.Shape();
	this.shape_6096.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnAAAVgMQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTALAAATQAAAWAPAMQAPANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6096.setTransform(80.9,510.7,0.5,0.5);

	this.shape_6097 = new cjs.Shape();
	this.shape_6097.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6097.setTransform(67.8,510.7,0.5,0.5);

	this.shape_6098 = new cjs.Shape();
	this.shape_6098.graphics.f("#000000").s().p("ABNCHIhKjqIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA5AFAdIABAAQAQg+AGgPIA4ikIAVAAIA1CjQATBAADAOIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_6098.setTransform(52.3,510.7,0.5,0.5);

	this.shape_6099 = new cjs.Shape();
	this.shape_6099.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6099.setTransform(610.9,469.5,0.5,0.5);

	this.shape_6100 = new cjs.Shape();
	this.shape_6100.graphics.f("#000000").s().p("AhNBoQghgkAAhCQABhAAfgmQAggoA2AAQAvAAAcAiQAbAhAAA5IAAATIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgjABQgnAAgXAag");
	this.shape_6100.setTransform(601.1,472.4,0.5,0.5);

	this.shape_6101 = new cjs.Shape();
	this.shape_6101.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIADAAQAOgYAYgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_6101.setTransform(586.6,469.5,0.5,0.5);

	this.shape_6102 = new cjs.Shape();
	this.shape_6102.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_6102.setTransform(573.2,472.4,0.5,0.5);

	this.shape_6103 = new cjs.Shape();
	this.shape_6103.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAFAGQAFAHAAALQAAALgFAHQgFAGgGABQgPgBAAgYg");
	this.shape_6103.setTransform(564,470,0.5,0.5);

	this.shape_6104 = new cjs.Shape();
	this.shape_6104.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgQAAIiHlPIgCAAIACA/IAAEQIgZAAIAAlrIAoAAICAE/IABAAICCk/IAmAAIAAFrg");
	this.shape_6104.setTransform(550.1,470.1,0.5,0.5);

	this.shape_6105 = new cjs.Shape();
	this.shape_6105.graphics.f("#000000").s().p("AgdA+QAThEAIg4IAdAAIADAFQgTBBgYA2g");
	this.shape_6105.setTransform(529.4,479.4,0.5,0.5);

	this.shape_6106 = new cjs.Shape();
	this.shape_6106.graphics.f("#000000").s().p("AhxC5IAAgWIBhhlQAkgnAUgZQARgWAHgVQAIgTAAgYQAAghgVgUQgWgUghAAQgtAAgqAhIgNgRQAtgnA4AAQAuAAAcAaQAbAZAAAtQAAAkgTAiQgRAfgxAzIhdBgIAAABIDCAAIAAAYg");
	this.shape_6106.setTransform(519.6,470,0.5,0.5);

	this.shape_6107 = new cjs.Shape();
	this.shape_6107.graphics.f("#000000").s().p("Ag9C2ICVlTIjNAAIAAgYIDrAAIAAASIiWFZg");
	this.shape_6107.setTransform(505.2,470.1,0.5,0.5);

	this.shape_6108 = new cjs.Shape();
	this.shape_6108.graphics.f("#000000").s().p("AhcC1IAAgWQAHADATADIAXACQA8AAAjgtQAjgsAEhUIgDAAQgTAXgYAMQgaANgaAAQgyAAgdgcQgcgaAAg0QAAg3AfghQAfgjAxABQAjAAAbASQAaASAQAlQAOAmAAAxQAABFgTAyQgTAwgjAXQgkAYgyAAQgbAAgVgHgAhBiKQgYAcAAAsQAAArAWAXQAWAWAoAAQAYAAAWgLQAWgLANgSQAMgTAAgTQAAgcgLgbQgLgZgWgOQgUgPgbAAQgnAAgXAbg");
	this.shape_6108.setTransform(490.5,470.1,0.5,0.5);

	this.shape_6109 = new cjs.Shape();
	this.shape_6109.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIhUBDIgOgRIBihKIAVAAIAAFrg");
	this.shape_6109.setTransform(474.3,470.1,0.5,0.5);

	this.shape_6110 = new cjs.Shape();
	this.shape_6110.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6110.setTransform(454.7,472.3,0.5,0.5);

	this.shape_6111 = new cjs.Shape();
	this.shape_6111.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6111.setTransform(444.3,470,0.5,0.5);

	this.shape_6112 = new cjs.Shape();
	this.shape_6112.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_6112.setTransform(427.3,472.3,0.5,0.5);

	this.shape_6113 = new cjs.Shape();
	this.shape_6113.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6113.setTransform(412.2,472.4,0.5,0.5);

	this.shape_6114 = new cjs.Shape();
	this.shape_6114.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6114.setTransform(401.9,470,0.5,0.5);

	this.shape_6115 = new cjs.Shape();
	this.shape_6115.graphics.f("#000000").s().p("AgRCXQgSgTABgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAQAXgBQAZAAAPgDIAAAUQgSAFgWABQgjAAgRgUg");
	this.shape_6115.setTransform(394.6,470.9,0.5,0.5);

	this.shape_6116 = new cjs.Shape();
	this.shape_6116.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6116.setTransform(383.2,472.4,0.5,0.5);

	this.shape_6117 = new cjs.Shape();
	this.shape_6117.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAABhjg");
	this.shape_6117.setTransform(369.4,472.6,0.5,0.5);

	this.shape_6118 = new cjs.Shape();
	this.shape_6118.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6118.setTransform(353.9,469.6,0.5,0.5);

	this.shape_6119 = new cjs.Shape();
	this.shape_6119.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6119.setTransform(339.5,472.4,0.5,0.5);

	this.shape_6120 = new cjs.Shape();
	this.shape_6120.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_6120.setTransform(329.1,472.3,0.5,0.5);

	this.shape_6121 = new cjs.Shape();
	this.shape_6121.graphics.f("#000000").s().p("AheC0QgcgTAAgkQABgcARgSQAQgTAegHQgLgFgIgJQgIgKAAgMQAAgbAjgUQgYgKgNgVQgNgVAAgbQAAgnAagaQAagYArAAQAZAAAQAFIBWAAIAAARIg4AEQAXAcAAAhQAAAngaAYQgaAZgrAAQgTAAgHgCQgPAIgHAKQgIAJAAANQAAAMAKAGQAKAGAXAAIAuAAQAtAAAWASQAYASAAAjQAAAqgjAYQgjAXg+AAQg0AAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA7gAg5igQgSATAAAgQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgUgSggAAQggAAgTATg");
	this.shape_6121.setTransform(316.7,475.4,0.5,0.5);

	this.shape_6122 = new cjs.Shape();
	this.shape_6122.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6122.setTransform(299.3,472.3,0.5,0.5);

	this.shape_6123 = new cjs.Shape();
	this.shape_6123.graphics.f("#000000").s().p("AhNBoQgggkAAhCQgBg/AggnQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgxgVgZQgUgbgkABQgmAAgXAag");
	this.shape_6123.setTransform(286.4,472.4,0.5,0.5);

	this.shape_6124 = new cjs.Shape();
	this.shape_6124.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_6124.setTransform(275,470.9,0.5,0.5);

	this.shape_6125 = new cjs.Shape();
	this.shape_6125.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAHIgGAVQgWgHgSABQgcAAgMARQgMAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6125.setTransform(267.9,469.5,0.5,0.5);

	this.shape_6126 = new cjs.Shape();
	this.shape_6126.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICTltIAPAAICPFtgAgNhiIgzCBICCAAIgyiCQgHgRgIgaQgFAYgJAUg");
	this.shape_6126.setTransform(255.6,470.1,0.5,0.5);

	this.shape_6127 = new cjs.Shape();
	this.shape_6127.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6127.setTransform(238.3,478.2,0.5,0.5);

	this.shape_6128 = new cjs.Shape();
	this.shape_6128.graphics.f("#000000").s().p("Ag9C2ICVlTIjNAAIAAgYIDrAAIAAASIiWFZg");
	this.shape_6128.setTransform(227.9,470.1,0.5,0.5);

	this.shape_6129 = new cjs.Shape();
	this.shape_6129.graphics.f("#000000").s().p("AhSCSQghgsAAhKQAAhGAUgxQATgxAjgXQAlgYAwABQAYgBATAHIAAAWQgSgIgaAAQg8AAgjAtQghAsgFBUIADAAQATgXAYgNQAagNAZAAQAzABAdAdQAcAcABAzQAAA5geAgQgfAfgzABQg2AAgggqgAgngJQgVAJgOATQgNATgBATQAAAaANAbQANAaAUAOQAWAQAYgBQApABAXgaQAWgZAAgxQAAgpgWgXQgXgXgmAAQgZAAgVAMg");
	this.shape_6129.setTransform(213.5,470.1,0.5,0.5);

	this.shape_6130 = new cjs.Shape();
	this.shape_6130.graphics.f("#000000").s().p("AhcC1IAAgWQAIADARADIAXACQA9AAAjgtQAjgsAEhUIgDAAQgTAXgZAMQgZANgaAAQgzAAgcgcQgcgaAAg0QAAg3AfghQAfgjAxABQAjAAAbASQAbATAPAkQAOAmAAAxQAABFgTAyQgSAwgkAXQgkAYgzAAQgaAAgVgHgAhBiKQgYAbAAAtQAAAtAWAVQAWAWAoAAQAYAAAWgLQAWgLAMgSQANgTAAgTQAAgcgLgbQgMgZgVgOQgVgPgaAAQgnAAgXAbg");
	this.shape_6130.setTransform(198.7,470.1,0.5,0.5);

	this.shape_6131 = new cjs.Shape();
	this.shape_6131.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA8IgOgRIBihKIAVAAIAAFrg");
	this.shape_6131.setTransform(182.5,470.1,0.5,0.5);

	this.shape_6132 = new cjs.Shape();
	this.shape_6132.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBcAAAABjIAACwg");
	this.shape_6132.setTransform(163,472.3,0.5,0.5);

	this.shape_6133 = new cjs.Shape();
	this.shape_6133.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6133.setTransform(152.5,470,0.5,0.5);

	this.shape_6134 = new cjs.Shape();
	this.shape_6134.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmABAWgNQAVgOAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgJgOAAgSQAAgfAagSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUALAAATQAAAWAPAMQAQANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_6134.setTransform(136.9,472.4,0.5,0.5);

	this.shape_6135 = new cjs.Shape();
	this.shape_6135.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6135.setTransform(126.6,470.9,0.5,0.5);

	this.shape_6136 = new cjs.Shape();
	this.shape_6136.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQgiAAgWAeQgWAcAAAuIAACUg");
	this.shape_6136.setTransform(118.5,472.3,0.5,0.5);

	this.shape_6137 = new cjs.Shape();
	this.shape_6137.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICSltIAQAAICPFtgAgNhiIgzCBICBAAIhAitQgHAcgHAQg");
	this.shape_6137.setTransform(105,470.1,0.5,0.5);

	this.shape_6138 = new cjs.Shape();
	this.shape_6138.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgRAEgZAAQg7AAghglgAg2hbQgYAZgEAxICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_6138.setTransform(83.7,472.4,0.5,0.5);

	this.shape_6139 = new cjs.Shape();
	this.shape_6139.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6139.setTransform(69.3,472.3,0.5,0.5);

	this.shape_6140 = new cjs.Shape();
	this.shape_6140.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHABQgPgBAAgYg");
	this.shape_6140.setTransform(58.8,470,0.5,0.5);

	this.shape_6141 = new cjs.Shape();
	this.shape_6141.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAYIiuAAIAACaICkAAIAAAWIikAAIAACjg");
	this.shape_6141.setTransform(50.7,470.1,0.5,0.5);

	this.shape_6142 = new cjs.Shape();
	this.shape_6142.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgxATgYQARgXAqAAQAXAAAWAHIgGAVQgWgHgRABQgdAAgNARQgLAQABAnIAAAZIA+AAIAAAWIg+AAIAAD4g");
	this.shape_6142.setTransform(600.4,431.2,0.5,0.5);

	this.shape_6143 = new cjs.Shape();
	this.shape_6143.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6143.setTransform(588.2,434.2,0.5,0.5);

	this.shape_6144 = new cjs.Shape();
	this.shape_6144.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6144.setTransform(562.9,434.1,0.5,0.5);

	this.shape_6145 = new cjs.Shape();
	this.shape_6145.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgaArhDAAQhdAAAAhjg");
	this.shape_6145.setTransform(544,434.3,0.5,0.5);

	this.shape_6146 = new cjs.Shape();
	this.shape_6146.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQAAA4AaAeQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgbgjABQgnAAgXAag");
	this.shape_6146.setTransform(529.6,434.2,0.5,0.5);

	this.shape_6147 = new cjs.Shape();
	this.shape_6147.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgIgNAAgTQAAgfAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6147.setTransform(516.5,434.2,0.5,0.5);

	this.shape_6148 = new cjs.Shape();
	this.shape_6148.graphics.f("#000000").s().p("AhpAnIAAiwIAXAAIAACuQAAApASATQARASAkAAQAvAAAXgYQAXgYAAg4IAAiUIAYAAIAAEOIgVAAIgEgmIgCAAQgaArhCAAQhcAAAAhjg");
	this.shape_6148.setTransform(503.1,434.3,0.5,0.5);

	this.shape_6149 = new cjs.Shape();
	this.shape_6149.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgPAAIiIlPIgCAAQACAcAAAjIAAEQIgYAAIAAlrIAnAAICAE/IACAAICAk/IAmAAIAAFrg");
	this.shape_6149.setTransform(484.6,431.9,0.5,0.5);

	this.shape_6150 = new cjs.Shape();
	this.shape_6150.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQABA4AZAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTAEgYAAQg6AAghglgAg2hbQgYAYgEAyICnAAQgBgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6150.setTransform(460,434.2,0.5,0.5);

	this.shape_6151 = new cjs.Shape();
	this.shape_6151.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6151.setTransform(445.6,431.3,0.5,0.5);

	this.shape_6152 = new cjs.Shape();
	this.shape_6152.graphics.f("#000000").s().p("AgRCXQgRgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_6152.setTransform(433.5,432.7,0.5,0.5);

	this.shape_6153 = new cjs.Shape();
	this.shape_6153.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQgBgyATgXQARgXAqAAQAXAAAWAHIgGAVQgWgHgRABQgeAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6153.setTransform(419.9,431.2,0.5,0.5);

	this.shape_6154 = new cjs.Shape();
	this.shape_6154.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_6154.setTransform(407.7,434.2,0.5,0.5);

	this.shape_6155 = new cjs.Shape();
	this.shape_6155.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6155.setTransform(390.7,431.3,0.5,0.5);

	this.shape_6156 = new cjs.Shape();
	this.shape_6156.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6156.setTransform(380.4,434.2,0.5,0.5);

	this.shape_6157 = new cjs.Shape();
	this.shape_6157.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6157.setTransform(365.4,434.2,0.5,0.5);

	this.shape_6158 = new cjs.Shape();
	this.shape_6158.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAXgLAiAAQBbAAABBiIAACxg");
	this.shape_6158.setTransform(350.5,431.3,0.5,0.5);

	this.shape_6159 = new cjs.Shape();
	this.shape_6159.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_6159.setTransform(337.1,434.2,0.5,0.5);

	this.shape_6160 = new cjs.Shape();
	this.shape_6160.graphics.f("#000000").s().p("AhwCtIAAgaQAnARA+AAQArAAAbgVQAagUAAgiQAAgUgJgOQgJgOgTgLQgTgLglgNQg5gSgVgWQgVgXAAglQAAgpAggZQAggaAxAAQA0AAAsATIgJAWQgugTgoAAQgnAAgZATQgXATAAAgQAAAUAHANQAHAMARALQAPAKApAPQAsAOAUAOQAVANAKASQAKASAAAYQABAtgiAcQgiAag2AAQhDAAgkgOg");
	this.shape_6160.setTransform(323.9,431.8,0.5,0.5);

	this.shape_6161 = new cjs.Shape();
	this.shape_6161.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgFAZgJIAAAXQgXAJgTAEQgSAEgaAAQg6AAggglgAg3hbQgXAZgEAxICnAAQAAgwgVgaQgVgbgkABQgmAAgYAag");
	this.shape_6161.setTransform(303.3,434.2,0.5,0.5);

	this.shape_6162 = new cjs.Shape();
	this.shape_6162.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAZgLAfAAQBdAAgBBiIAACxg");
	this.shape_6162.setTransform(288.8,431.3,0.5,0.5);

	this.shape_6163 = new cjs.Shape();
	this.shape_6163.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6163.setTransform(276.8,432.7,0.5,0.5);

	this.shape_6164 = new cjs.Shape();
	this.shape_6164.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg4AAgcgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgwAAQgqAAgXAfg");
	this.shape_6164.setTransform(258.1,431.4,0.5,0.5);

	this.shape_6165 = new cjs.Shape();
	this.shape_6165.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6165.setTransform(243.4,434.1,0.5,0.5);

	this.shape_6166 = new cjs.Shape();
	this.shape_6166.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgoA1AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAXAAATgDQATgEAZgKIAAAXQgYAJgTAEQgRAEgaAAQg6AAghglgAg3hbQgXAZgEAxICnAAQAAgwgVgaQgUgbglABQglAAgZAag");
	this.shape_6166.setTransform(228.9,434.2,0.5,0.5);

	this.shape_6167 = new cjs.Shape();
	this.shape_6167.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6167.setTransform(217.4,432.7,0.5,0.5);

	this.shape_6168 = new cjs.Shape();
	this.shape_6168.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6168.setTransform(208.9,432.7,0.5,0.5);

	this.shape_6169 = new cjs.Shape();
	this.shape_6169.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6169.setTransform(197.6,434.2,0.5,0.5);

	this.shape_6170 = new cjs.Shape();
	this.shape_6170.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6170.setTransform(177.2,434.2,0.5,0.5);

	this.shape_6171 = new cjs.Shape();
	this.shape_6171.graphics.f("#000000").s().p("AgRCXQgRgTAAgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgXABQgkAAgQgUg");
	this.shape_6171.setTransform(165.2,432.7,0.5,0.5);

	this.shape_6172 = new cjs.Shape();
	this.shape_6172.graphics.f("#000000").s().p("ABTCKIAAivQgBgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBEAAQBcAAgBBjIAACwg");
	this.shape_6172.setTransform(147.1,434.1,0.5,0.5);

	this.shape_6173 = new cjs.Shape();
	this.shape_6173.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6173.setTransform(132,434.2,0.5,0.5);

	this.shape_6174 = new cjs.Shape();
	this.shape_6174.graphics.f("#000000").s().p("AgRCXQgRgTgBgpIAAiuIgnAAIAAgOIAngMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQgBAgAKAOQAMAQAXgBQAZAAAPgDIAAAUQgSAFgWABQgjAAgRgUg");
	this.shape_6174.setTransform(120.1,432.7,0.5,0.5);

	this.shape_6175 = new cjs.Shape();
	this.shape_6175.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgNAAgXQAAgVgRgNQgQgPgmgNQgqgOgOgKQgRgLgIgNQgIgOgBgSQAAgfAagSQAZgSAuAAQArAAAnARIgIAXQgogRgiAAQghAAgTALQgTALAAATQgBAWAPAMQAQANAqAPQAkANASAKQAQALAJAOQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_6175.setTransform(110,434.2,0.5,0.5);

	this.shape_6176 = new cjs.Shape();
	this.shape_6176.graphics.f("#000000").s().p("Ag/B8QgagRgQghQgOgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6176.setTransform(96.7,434.2,0.5,0.5);

	this.shape_6177 = new cjs.Shape();
	this.shape_6177.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBDAAAfAXQAgAWAAAvQAAAfgUAWQgSAVgmAGIAAABQArAGAVAVQAVAVAAAmQAAAygiAbQghAbg8AAgAhdCfIBVAAQBkAAAAhRQAAhMhpABIhQAAgAhdgTIBQAAQAyAAAXgRQAYgSAAgkQAAgjgbgRQgagQgzAAIhJAAg");
	this.shape_6177.setTransform(81.8,431.9,0.5,0.5);

	this.shape_6178 = new cjs.Shape();
	this.shape_6178.graphics.f("#000000").s().p("Ag/B8QgagSgPggQgPghAAgpQAAhBAhgmQAggkA2gBQA5AAAfAmQAgAmAABAQAABCghAlQggAmg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgtAAgXAfg");
	this.shape_6178.setTransform(59.1,434.2,0.5,0.5);

	this.shape_6179 = new cjs.Shape();
	this.shape_6179.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6179.setTransform(47.2,432.7,0.5,0.5);

	this.shape_6180 = new cjs.Shape();
	this.shape_6180.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_6180.setTransform(599.9,394.4,0.5,0.5);

	this.shape_6181 = new cjs.Shape();
	this.shape_6181.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6181.setTransform(588.3,395.8,0.5,0.5);

	this.shape_6182 = new cjs.Shape();
	this.shape_6182.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6182.setTransform(573.7,395.9,0.5,0.5);

	this.shape_6183 = new cjs.Shape();
	this.shape_6183.graphics.f("#000000").s().p("ABNCHIg7i0QgGgSgJgkIgBAAIhMDqIgYAAIhOkNIAbAAIArCbQAPA7AFAbIABAAQAQg+AGgPIA4ikIAVAAIA1CjQAQAyAGAcIACAAQABgMAShLIAqiaIAZAAIhKENg");
	this.shape_6183.setTransform(557.5,395.9,0.5,0.5);

	this.shape_6184 = new cjs.Shape();
	this.shape_6184.graphics.f("#000000").s().p("Ag/B8QgagSgQggQgOghAAgpQAAhBAggmQAggkA3gBQA4AAAgAmQAgAmAABAQAABCggAlQghAmg3AAQgjAAgcgRgAhFhWQgYAeAAA4QAAA3AYAgQAZAfAsAAQAsAAAagfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgZAfg");
	this.shape_6184.setTransform(534.2,395.9,0.5,0.5);

	this.shape_6185 = new cjs.Shape();
	this.shape_6185.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAmABAWgNQAVgOAAgWQAAgUgRgOQgQgPgmgNQgqgPgOgJQgRgLgIgNQgJgOAAgSQABgfAZgSQAZgSAtAAQAsAAAnARIgJAXQgngRgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAPQAkANASAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_6185.setTransform(520.7,395.9,0.5,0.5);

	this.shape_6186 = new cjs.Shape();
	this.shape_6186.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6186.setTransform(512,393,0.5,0.5);

	this.shape_6187 = new cjs.Shape();
	this.shape_6187.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAglgPgVQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6187.setTransform(501.9,395.9,0.5,0.5);

	this.shape_6188 = new cjs.Shape();
	this.shape_6188.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6188.setTransform(486.1,393,0.5,0.5);

	this.shape_6189 = new cjs.Shape();
	this.shape_6189.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAaAiQAdAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTAEgYAAQg7AAggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6189.setTransform(476.2,395.9,0.5,0.5);

	this.shape_6190 = new cjs.Shape();
	this.shape_6190.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_6190.setTransform(461.8,393,0.5,0.5);

	this.shape_6191 = new cjs.Shape();
	this.shape_6191.graphics.f("#000000").s().p("AhABoQggglAAhBQAAhDAiglQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgaAfAAA4QAAA3AaAfQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAghglg");
	this.shape_6191.setTransform(448.4,395.9,0.5,0.5);

	this.shape_6192 = new cjs.Shape();
	this.shape_6192.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAGgGABQgPgBAAgYg");
	this.shape_6192.setTransform(439.2,393.5,0.5,0.5);

	this.shape_6193 = new cjs.Shape();
	this.shape_6193.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiJFPIgOAAIiIlPIgCAAIACA/IAAEQIgYAAIAAlrIAnAAICAE/IACAAICAk/IAmAAIAAFrg");
	this.shape_6193.setTransform(425.3,393.6,0.5,0.5);

	this.shape_6194 = new cjs.Shape();
	this.shape_6194.graphics.f("#000000").s().p("AgdA+QAThEAIg4IAdAAIADAFQgTBBgYA2g");
	this.shape_6194.setTransform(404.5,402.9,0.5,0.5);

	this.shape_6195 = new cjs.Shape();
	this.shape_6195.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgLgJgNQgIgNAAgTQAAgfAZgSQAagSAtAAQArAAAoARIgJAXQgpgRghAAQghAAgTALQgTALAAATQAAAWAPAMQAPANArAPQAlAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6195.setTransform(396.1,395.9,0.5,0.5);

	this.shape_6196 = new cjs.Shape();
	this.shape_6196.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAZgrBDAAQBdAAAABjIAACwg");
	this.shape_6196.setTransform(382.9,395.8,0.5,0.5);

	this.shape_6197 = new cjs.Shape();
	this.shape_6197.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6197.setTransform(372.4,393.5,0.5,0.5);

	this.shape_6198 = new cjs.Shape();
	this.shape_6198.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqBzIBzCbg");
	this.shape_6198.setTransform(364.4,393,0.5,0.5);

	this.shape_6199 = new cjs.Shape();
	this.shape_6199.graphics.f("#000000").s().p("AgRCXQgSgTABgpIAAiuIgpAAIAAgOIApgMIAMg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQALAQAXgBQAZAAAPgDIAAAUQgSAFgWABQgjAAgRgUg");
	this.shape_6199.setTransform(352.7,394.4,0.5,0.5);

	this.shape_6200 = new cjs.Shape();
	this.shape_6200.graphics.f("#000000").s().p("AhOB4QgXgUAAglQABgoAggVQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAsAAAXAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgVALgcAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAPAOAdAAQArAAAZgZQAYgZAAgsIAAgZg");
	this.shape_6200.setTransform(341.4,395.9,0.5,0.5);

	this.shape_6201 = new cjs.Shape();
	this.shape_6201.graphics.f("#000000").s().p("ABdC2IhelRQgEAZgHAZIhQEfIgWAAIhklrIAbAAIBVFCQAGghAUhFIA+jcIAbAAIBJD8QALAoAHAfIAIgmIBNkdIAaAAIhlFrg");
	this.shape_6201.setTransform(323.7,393.6,0.5,0.5);

	this.shape_6202 = new cjs.Shape();
	this.shape_6202.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAvAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgTAEgZAAQg5AAghglgAg3hbQgYAZgDAxICnAAQAAgwgVgaQgVgbgkABQgmAAgYAag");
	this.shape_6202.setTransform(298.7,395.9,0.5,0.5);

	this.shape_6203 = new cjs.Shape();
	this.shape_6203.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIABAAICKiXIAeAAIhqBzIBzCbg");
	this.shape_6203.setTransform(286.7,393,0.5,0.5);

	this.shape_6204 = new cjs.Shape();
	this.shape_6204.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAGAAAFAGQAFAHAAALQAAALgFAHQgFAGgGABQgPgBAAgYg");
	this.shape_6204.setTransform(276.5,393.5,0.5,0.5);

	this.shape_6205 = new cjs.Shape();
	this.shape_6205.graphics.f("#000000").s().p("AhiC2IAAlrIAZAAIAAFTICsAAIAAAYg");
	this.shape_6205.setTransform(268.1,393.6,0.5,0.5);

	this.shape_6206 = new cjs.Shape();
	this.shape_6206.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6206.setTransform(250.9,401.7,0.5,0.5);

	this.shape_6207 = new cjs.Shape();
	this.shape_6207.graphics.f("#000000").s().p("AhcC1IAAgWQAIADARADIAXACQA9AAAjgtQAjgsAEhUIgDAAQgTAXgZAMQgZANgaAAQgzAAgcgcQgcgaAAg0QAAg3AfghQAfgjAxABQAjAAAbASQAbATAPAkQAOAmAAAxQAABFgTAyQgSAwgkAXQgkAYgzAAQgaAAgVgHgAhBiKQgYAbAAAtQAAAtAWAVQAWAWAoAAQAYAAAWgLQAWgLAMgSQANgTAAgTQAAgcgLgbQgMgZgVgOQgVgPgaAAQgnAAgXAbg");
	this.shape_6207.setTransform(240.4,393.6,0.5,0.5);

	this.shape_6208 = new cjs.Shape();
	this.shape_6208.graphics.f("#000000").s().p("AhGCzQgYgFgRgKIAAgaQAaAOAWAFQATAFAZAAQAvAAAegZQAcgaAAgqQABgogdgYQgdgWgvAAQgfAAgkAKIgPgKIAPimICuAAIAAAXIiXAAIgMCBQAngIAWABQA6AAAhAcQAhAaABAyQgBA4giAfQgjAfg9ABQgZAAgagGg");
	this.shape_6208.setTransform(226.1,393.7,0.5,0.5);

	this.shape_6209 = new cjs.Shape();
	this.shape_6209.graphics.f("#000000").s().p("AhcC1IAAgWQAIADASADIAWACQA9AAAjgtQAjgtADhTIgCAAQgTAXgZAMQgZANgaAAQgyAAgdgcQgcgaAAg0QAAg4AfggQAfgjAyABQAhAAAcASQAbATAOAkQAPAkAAAzQAABHgSAwQgUAwgjAXQgkAYgzAAQgaAAgVgHgAhBiKQgYAcAAAsQAAAsAWAWQAWAWAoAAQAXAAAXgLQAXgLAMgSQAMgTAAgTQAAgegLgZQgLgYgWgPQgVgPgZAAQgoAAgXAbg");
	this.shape_6209.setTransform(211.3,393.6,0.5,0.5);

	this.shape_6210 = new cjs.Shape();
	this.shape_6210.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIgIAHIhMA8IgOgRIBihKIAVAAIAAFrg");
	this.shape_6210.setTransform(195.1,393.6,0.5,0.5);

	this.shape_6211 = new cjs.Shape();
	this.shape_6211.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_6211.setTransform(175.6,395.8,0.5,0.5);

	this.shape_6212 = new cjs.Shape();
	this.shape_6212.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6212.setTransform(165.1,393.5,0.5,0.5);

	this.shape_6213 = new cjs.Shape();
	this.shape_6213.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAZAAIA5CYQAbBFAGAZIABAAQALghAXg/IA5iWIAaAAIh4E6QgOAlgLAOQgKAOgOAHQgMAGgTAAQgPAAgRgEg");
	this.shape_6213.setTransform(149.7,399,0.5,0.5);

	this.shape_6214 = new cjs.Shape();
	this.shape_6214.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6214.setTransform(141,393,0.5,0.5);

	this.shape_6215 = new cjs.Shape();
	this.shape_6215.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHABQgPgBAAgYg");
	this.shape_6215.setTransform(135.2,393.5,0.5,0.5);

	this.shape_6216 = new cjs.Shape();
	this.shape_6216.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgUAYQgTAWAAAyIAACdIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQAOgXAWgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6216.setTransform(121.2,395.8,0.5,0.5);

	this.shape_6217 = new cjs.Shape();
	this.shape_6217.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6217.setTransform(102.6,395.9,0.5,0.5);

	this.shape_6218 = new cjs.Shape();
	this.shape_6218.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAXAAAWAHIgGAVQgVgHgTABQgdAAgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6218.setTransform(93.4,393,0.5,0.5);

	this.shape_6219 = new cjs.Shape();
	this.shape_6219.graphics.f("#000000").s().p("AhGCKIAAkOIAUAAIACAxIADAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6219.setTransform(78,395.8,0.5,0.5);

	this.shape_6220 = new cjs.Shape();
	this.shape_6220.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTAEgYAAQg6AAghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6220.setTransform(65.1,395.9,0.5,0.5);

	this.shape_6221 = new cjs.Shape();
	this.shape_6221.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgYAXgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_6221.setTransform(50.7,393,0.5,0.5);

	this.shape_6222 = new cjs.Shape();
	this.shape_6222.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgCCeIACAAQAPgYAYgLQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_6222.setTransform(618.2,354.8,0.5,0.5);

	this.shape_6223 = new cjs.Shape();
	this.shape_6223.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6223.setTransform(606.1,356.2,0.5,0.5);

	this.shape_6224 = new cjs.Shape();
	this.shape_6224.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6224.setTransform(599.2,355.2,0.5,0.5);

	this.shape_6225 = new cjs.Shape();
	this.shape_6225.graphics.f("#000000").s().p("ABNCHIg7i0IgOg2IgCAAIhMDqIgZAAIhMkNIAaAAIArCbQAQBAAEAWIABAAQAOg3AIgWIA4ikIAVAAIA1CjQATA9ADARIACAAQACgTAShEIAoiaIAZAAIhJENg");
	this.shape_6225.setTransform(587.1,357.7,0.5,0.5);

	this.shape_6226 = new cjs.Shape();
	this.shape_6226.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gBIAzgCIAAgSQABgmgRgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgVALgdAAQgoAAgVgUgAAeAAQg4ACgYAPQgZAPABAgQgBAaAQAOQAPAOAdAAQAqAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6226.setTransform(564,357.7,0.5,0.5);

	this.shape_6227 = new cjs.Shape();
	this.shape_6227.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6227.setTransform(549.7,354.9,0.5,0.5);

	this.shape_6228 = new cjs.Shape();
	this.shape_6228.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAGgGABQgPgBAAgYg");
	this.shape_6228.setTransform(539.7,355.2,0.5,0.5);

	this.shape_6229 = new cjs.Shape();
	this.shape_6229.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6229.setTransform(532.7,357.6,0.5,0.5);

	this.shape_6230 = new cjs.Shape();
	this.shape_6230.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgtAAgYAfg");
	this.shape_6230.setTransform(519.4,357.7,0.5,0.5);

	this.shape_6231 = new cjs.Shape();
	this.shape_6231.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_6231.setTransform(509,354.8,0.5,0.5);

	this.shape_6232 = new cjs.Shape();
	this.shape_6232.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAYIitAAIAACaICjAAIAAAWIijAAIAACjg");
	this.shape_6232.setTransform(500.9,355.4,0.5,0.5);

	this.shape_6233 = new cjs.Shape();
	this.shape_6233.graphics.f("#000000").s().p("Ag/B8QgagRgPghQgPghAAgpQAAhBAhgmQAggkA3gBQA3AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA3AZAgQAZAfArAAQAsAAAZgfQAZggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_6233.setTransform(479.2,357.7,0.5,0.5);

	this.shape_6234 = new cjs.Shape();
	this.shape_6234.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAJAOQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6234.setTransform(467.3,356.2,0.5,0.5);

	this.shape_6235 = new cjs.Shape();
	this.shape_6235.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA3AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgEQAAg+gVgcQgVgbgvAAQgrAAgXAfg");
	this.shape_6235.setTransform(448.6,354.9,0.5,0.5);

	this.shape_6236 = new cjs.Shape();
	this.shape_6236.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AZAeQAZAdAwAAQAXAAARgDQASgEAbgKIAAAXQgXAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgjABQgmAAgYAag");
	this.shape_6236.setTransform(434.4,357.7,0.5,0.5);

	this.shape_6237 = new cjs.Shape();
	this.shape_6237.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAaIAAAAQAKggAMgeIBGi2IAZAAIhoENg");
	this.shape_6237.setTransform(421.6,357.7,0.5,0.5);

	this.shape_6238 = new cjs.Shape();
	this.shape_6238.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgYAfg");
	this.shape_6238.setTransform(408.2,357.7,0.5,0.5);

	this.shape_6239 = new cjs.Shape();
	this.shape_6239.graphics.f("#000000").s().p("ACdCKIAAiwQAAgngPgUQgQgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAWgLAXAAQBAAAASAwIABAAQAMgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6239.setTransform(389.6,357.6,0.5,0.5);

	this.shape_6240 = new cjs.Shape();
	this.shape_6240.graphics.f("#000000").s().p("AhzDAIAAgWQAQAEAPAAQANAAAJgGQAKgGAIgMQAIgMAKgdIAOgjIhokOIAZAAIA6CYQAaBFAHAZIAAAAIAihgIA6iWIAZAAIh4E6QgPAngKAMQgLAPgMAGQgNAGgTAAQgPAAgRgEg");
	this.shape_6240.setTransform(365.8,360.8,0.5,0.5);

	this.shape_6241 = new cjs.Shape();
	this.shape_6241.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_6241.setTransform(357.1,354.8,0.5,0.5);

	this.shape_6242 = new cjs.Shape();
	this.shape_6242.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6242.setTransform(351.3,354.8,0.5,0.5);

	this.shape_6243 = new cjs.Shape();
	this.shape_6243.graphics.f("#000000").s().p("AhPB4QgVgUAAglQgBgnAigWQAhgVA9gBIA0gCIAAgSQgBgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAPAOAdAAQAqAAAZgZQAagZAAgsIAAgZg");
	this.shape_6243.setTransform(341.2,357.7,0.5,0.5);

	this.shape_6244 = new cjs.Shape();
	this.shape_6244.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAXgYQAWgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgCAAQgaArhCAAQhdAAABhjg");
	this.shape_6244.setTransform(327.3,357.8,0.5,0.5);

	this.shape_6245 = new cjs.Shape();
	this.shape_6245.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6245.setTransform(315.4,356.2,0.5,0.5);

	this.shape_6246 = new cjs.Shape();
	this.shape_6246.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6246.setTransform(303.9,357.6,0.5,0.5);

	this.shape_6247 = new cjs.Shape();
	this.shape_6247.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjDAAQABA4AaAeQAYAdAvAAQAXAAATgDQATgEAZgKIAAAXQgYAJgSAEQgTAEgZAAQg5AAghglgAg3hbQgYAZgDAxICnAAQAAgwgVgaQgVgbgkABQgmAAgYAag");
	this.shape_6247.setTransform(289.3,357.7,0.5,0.5);

	this.shape_6248 = new cjs.Shape();
	this.shape_6248.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC3QAPAlAGAYIABAAQAKggAKgeIBGi2IAaAAIhpENg");
	this.shape_6248.setTransform(276.4,357.7,0.5,0.5);

	this.shape_6249 = new cjs.Shape();
	this.shape_6249.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQABA4AZAeQAYAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgSAEQgTAEgYAAQg6AAghglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6249.setTransform(263.6,357.7,0.5,0.5);

	this.shape_6250 = new cjs.Shape();
	this.shape_6250.graphics.f("#000000").s().p("AhMBoQghgjAAhDQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAZAdAwAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6250.setTransform(243,357.7,0.5,0.5);

	this.shape_6251 = new cjs.Shape();
	this.shape_6251.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6251.setTransform(228.5,354.8,0.5,0.5);

	this.shape_6252 = new cjs.Shape();
	this.shape_6252.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgVgRgNQgQgPgmgNQgqgPgOgJQgQgKgJgOQgIgNAAgTQAAgfAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTALAAATQAAAWAPAMQAPANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6252.setTransform(214.9,357.7,0.5,0.5);

	this.shape_6253 = new cjs.Shape();
	this.shape_6253.graphics.f("#000000").s().p("AgdA+QAThCAJg6IAcAAIADAFQgTBAgXA3g");
	this.shape_6253.setTransform(199.3,364.6,0.5,0.5);

	this.shape_6254 = new cjs.Shape();
	this.shape_6254.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAmABAWgNQAVgOAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUALAAATQAAAWAPAMQAQANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_6254.setTransform(190.9,357.7,0.5,0.5);

	this.shape_6255 = new cjs.Shape();
	this.shape_6255.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AaAdQAZAdAvAAQAXAAARgDQATgEAagKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgxgUgZQgVgbgkABQgmAAgXAag");
	this.shape_6255.setTransform(178.1,357.7,0.5,0.5);

	this.shape_6256 = new cjs.Shape();
	this.shape_6256.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgYABQgjAAgQgUg");
	this.shape_6256.setTransform(166.6,356.2,0.5,0.5);

	this.shape_6257 = new cjs.Shape();
	this.shape_6257.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgdAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgYAAgtIAAgZg");
	this.shape_6257.setTransform(155.3,357.7,0.5,0.5);

	this.shape_6258 = new cjs.Shape();
	this.shape_6258.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IANAAIAABBIBOAAIAAAVIhOAAIAACqQAAAgAKAOQAKAQAYgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6258.setTransform(144.6,356.2,0.5,0.5);

	this.shape_6259 = new cjs.Shape();
	this.shape_6259.graphics.f("#000000").s().p("AhvCtIAAgaQAnARA9AAQArAAAbgVQAagUABgiQAAgUgJgOQgJgOgUgLQgUgLglgNQg4gSgUgWQgWgWAAgmQAAgpAggZQAhgaAwAAQA0AAAtATIgJAWQgugTgpAAQgnAAgZATQgYATAAAgQAAAUAIANQAHAMARALQAOAJAqAQQAqANAWAPQAWANAKASQAKASAAAYQgBAughAbQgiAag2AAQhCAAgkgOg");
	this.shape_6259.setTransform(133.6,355.3,0.5,0.5);

	this.shape_6260 = new cjs.Shape();
	this.shape_6260.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAfAAA6QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6260.setTransform(112,354.9,0.5,0.5);

	this.shape_6261 = new cjs.Shape();
	this.shape_6261.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAwAAAbAiQAcAhgBA5IAAATIjCAAQACA4AYAeQAaAdAuAAQAYAAARgDQAUgEAZgKIAAAXQgXAJgUAEQgRAEgaAAQg5AAgiglgAg2hbQgZAZgDAxICmAAQABgwgVgaQgVgbgjABQgnAAgXAag");
	this.shape_6261.setTransform(97.8,357.7,0.5,0.5);

	this.shape_6262 = new cjs.Shape();
	this.shape_6262.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6262.setTransform(86.3,356.2,0.5,0.5);

	this.shape_6263 = new cjs.Shape();
	this.shape_6263.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6263.setTransform(79.4,355.2,0.5,0.5);

	this.shape_6264 = new cjs.Shape();
	this.shape_6264.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6264.setTransform(69,357.6,0.5,0.5);

	this.shape_6265 = new cjs.Shape();
	this.shape_6265.graphics.f("#000000").s().p("AhjCVQgkgkAAg/IAAjpIAaAAIAADqQgBA0AeAeQAdAdA0AAQA1AAAcgcQAcgdAAg0IAAjsIAaAAIAADqQAAA/glAjQgjAkhBAAQg/AAgjgkg");
	this.shape_6265.setTransform(52.3,355.5,0.5,0.5);

	this.shape_6266 = new cjs.Shape();
	this.shape_6266.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAggmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgTAEQgTAEgYAAQg7AAggglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6266.setTransform(615.9,319.4,0.5,0.5);

	this.shape_6267 = new cjs.Shape();
	this.shape_6267.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBbAAAABiIAACxg");
	this.shape_6267.setTransform(601.5,316.5,0.5,0.5);

	this.shape_6268 = new cjs.Shape();
	this.shape_6268.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogMIANg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAfAKAPQAMAQAXgBQAZAAAQgDIAAAUQgSAFgYABQgiAAgSgUg");
	this.shape_6268.setTransform(589.4,317.9,0.5,0.5);

	this.shape_6269 = new cjs.Shape();
	this.shape_6269.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgHgpIgBAAQgfAug6AAQg3AAgegjgAhBgeQgXAeAAA7QABBzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gWgcQgVgbguAAQgrAAgXAfg");
	this.shape_6269.setTransform(570.7,316.6,0.5,0.5);

	this.shape_6270 = new cjs.Shape();
	this.shape_6270.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6270.setTransform(556.1,319.3,0.5,0.5);

	this.shape_6271 = new cjs.Shape();
	this.shape_6271.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgUALgeAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6271.setTransform(541.3,319.4,0.5,0.5);

	this.shape_6272 = new cjs.Shape();
	this.shape_6272.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgRAEgZAAQg7AAggglgAg3hbQgXAYgEAyICmAAQAAgxgVgZQgUgbgkABQgnAAgXAag");
	this.shape_6272.setTransform(521.4,319.4,0.5,0.5);

	this.shape_6273 = new cjs.Shape();
	this.shape_6273.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_6273.setTransform(507.2,322.4,0.5,0.5);

	this.shape_6274 = new cjs.Shape();
	this.shape_6274.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6274.setTransform(491.7,319.4,0.5,0.5);

	this.shape_6275 = new cjs.Shape();
	this.shape_6275.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_6275.setTransform(480.2,319.3,0.5,0.5);

	this.shape_6276 = new cjs.Shape();
	this.shape_6276.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACuQAAApARATQARASAkAAQAwAAAWgYQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgaArhDAAQhcAAAAhjg");
	this.shape_6276.setTransform(466.7,319.6,0.5,0.5);

	this.shape_6277 = new cjs.Shape();
	this.shape_6277.graphics.f("#000000").s().p("AhjC2IAAlrIDGAAIAAAYIisAAIAACJICjAAIAAAXIijAAIAACcICsAAIAAAXg");
	this.shape_6277.setTransform(452.8,317.1,0.5,0.5);

	this.shape_6278 = new cjs.Shape();
	this.shape_6278.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQARgXAqAAQAXAAAWAHIgGAVQgVgHgTABQgdAAgMARQgLAQAAAnIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6278.setTransform(435.6,316.5,0.5,0.5);

	this.shape_6279 = new cjs.Shape();
	this.shape_6279.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA4AAAfAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhEhWQgZAeAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg3gZgfQgZgfgsAAQgsAAgYAfg");
	this.shape_6279.setTransform(423.5,319.4,0.5,0.5);

	this.shape_6280 = new cjs.Shape();
	this.shape_6280.graphics.f("#000000").s().p("AhfB8IAAgbQAnAVAvgBQAnABAVgNQAUgNAAgXQAAgVgQgNQgQgPgngNQgqgPgOgJQgQgLgIgNQgJgOAAgSQAAgfAagSQAagSAsAAQAtAAAmARIgJAXQgngRgjAAQggAAgTALQgUALAAATQABAWAPAMQAOANArAPQAlAOAQAJQARAKAJAPQAIAMAAATQAAAkgbAUQgcATgyABQg2gBgggQg");
	this.shape_6280.setTransform(403.4,319.4,0.5,0.5);

	this.shape_6281 = new cjs.Shape();
	this.shape_6281.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAagrBDAAQBdAAAABjIAACwg");
	this.shape_6281.setTransform(390.1,319.3,0.5,0.5);

	this.shape_6282 = new cjs.Shape();
	this.shape_6282.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAYAfAsAAQAsAAAZgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6282.setTransform(375,319.4,0.5,0.5);

	this.shape_6283 = new cjs.Shape();
	this.shape_6283.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAGAAAGAGQAEAHAAALQAAALgEAHQgGAGgGABQgPgBAAgYg");
	this.shape_6283.setTransform(364.7,317,0.5,0.5);

	this.shape_6284 = new cjs.Shape();
	this.shape_6284.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAdgHQgLgFgIgJQgHgKAAgMQAAgbAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgTgRQgSgSggAAQghAAgSATg");
	this.shape_6284.setTransform(355.1,322.4,0.5,0.5);

	this.shape_6285 = new cjs.Shape();
	this.shape_6285.graphics.f("#000000").s().p("AhMBoQgigkABhCQgBhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAYAdAwAAQAXAAARgDQAUgFAYgJIAAAXQgWAJgTAEQgTAEgYAAQg7AAggglgAg3hbQgYAZgDAxICnAAQgBgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6285.setTransform(341.4,319.4,0.5,0.5);

	this.shape_6286 = new cjs.Shape();
	this.shape_6286.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQAOAAAXADIgFAYQgSgEgRAAQghAAgXAeQgWAdAAAtIAACUg");
	this.shape_6286.setTransform(330.3,319.3,0.5,0.5);

	this.shape_6287 = new cjs.Shape();
	this.shape_6287.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgNALgcIANgjIhnkOIAaAAIA4CYQAbBFAHAZIAAAAQAKghAZg/IA4iWIAaAAIh5E6QgNAlgLAOQgKAOgOAHQgMAGgTAAQgQAAgQgEg");
	this.shape_6287.setTransform(312,322.5,0.5,0.5);

	this.shape_6288 = new cjs.Shape();
	this.shape_6288.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_6288.setTransform(298.7,319.3,0.5,0.5);

	this.shape_6289 = new cjs.Shape();
	this.shape_6289.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgWALgcAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQArAAAZgZQAZgZAAgsIAAgZg");
	this.shape_6289.setTransform(283.9,319.4,0.5,0.5);

	this.shape_6290 = new cjs.Shape();
	this.shape_6290.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgqAAgTAYQgUAVAAAzIAACdIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAaAAA2IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAVgLAYAAQBAAAARAwIABAAQANgXAXgNQAXgMAcAAQAsAAAWAYQAWAXAAA0IAACwg");
	this.shape_6290.setTransform(266.4,319.3,0.5,0.5);

	this.shape_6291 = new cjs.Shape();
	this.shape_6291.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6291.setTransform(241,319.3,0.5,0.5);

	this.shape_6292 = new cjs.Shape();
	this.shape_6292.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAGAAAFAGQAFAHAAALQAAALgFAHQgFAGgGABQgPgBAAgYg");
	this.shape_6292.setTransform(230.6,317,0.5,0.5);

	this.shape_6293 = new cjs.Shape();
	this.shape_6293.graphics.f("#000000").s().p("AheC0QgcgUAAgjQAAgcASgSQARgTAegHQgMgFgIgJQgHgKAAgMQAAgbAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAbgYArAAQAZAAAPAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgZAZgsAAQgSAAgIgCQgPAIgHAKQgIAKAAAMQAAAMAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAAqgjAYQgiAXhAAAQgzAAgcgTgAhgB7QAAA3BTAAQBqAAAAhEQAAgYgRgLQgQgLgmAAIgrAAQhLAAAAA7gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAggQAAgjgSgRQgTgSggAAQghAAgSATg");
	this.shape_6293.setTransform(214.4,322.4,0.5,0.5);

	this.shape_6294 = new cjs.Shape();
	this.shape_6294.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_6294.setTransform(200.3,319.3,0.5,0.5);

	this.shape_6295 = new cjs.Shape();
	this.shape_6295.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6295.setTransform(189.8,317,0.5,0.5);

	this.shape_6296 = new cjs.Shape();
	this.shape_6296.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC3QAPAjAGAaIABAAQAJghAMgdIBGi2IAZAAIhoENg");
	this.shape_6296.setTransform(181.1,319.4,0.5,0.5);

	this.shape_6297 = new cjs.Shape();
	this.shape_6297.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6297.setTransform(172.3,317,0.5,0.5);

	this.shape_6298 = new cjs.Shape();
	this.shape_6298.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6298.setTransform(166.6,316.5,0.5,0.5);

	this.shape_6299 = new cjs.Shape();
	this.shape_6299.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6299.setTransform(149.1,316.6,0.5,0.5);

	this.shape_6300 = new cjs.Shape();
	this.shape_6300.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6300.setTransform(134.4,319.4,0.5,0.5);

	this.shape_6301 = new cjs.Shape();
	this.shape_6301.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABDggAkQghAmg3AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgeQgZgfgsAAQgsAAgZAfg");
	this.shape_6301.setTransform(119.5,319.4,0.5,0.5);

	this.shape_6302 = new cjs.Shape();
	this.shape_6302.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIABAAQAPgYAYgLQAZgLAgAAQBcAAgBBiIAACxg");
	this.shape_6302.setTransform(104.6,316.5,0.5,0.5);

	this.shape_6303 = new cjs.Shape();
	this.shape_6303.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAeAAAUALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgEQAAg+gVgcQgVgbgvAAQgsAAgWAfg");
	this.shape_6303.setTransform(89,316.6,0.5,0.5);

	this.shape_6304 = new cjs.Shape();
	this.shape_6304.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6304.setTransform(78.9,316.5,0.5,0.5);

	this.shape_6305 = new cjs.Shape();
	this.shape_6305.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6305.setTransform(73.1,317,0.5,0.5);

	this.shape_6306 = new cjs.Shape();
	this.shape_6306.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgXAZQgWAZAAA1IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAOgYAYgLQAZgLAfAAQBcAAAABiIAACxg");
	this.shape_6306.setTransform(62.8,316.5,0.5,0.5);

	this.shape_6307 = new cjs.Shape();
	this.shape_6307.graphics.f("#000000").s().p("Ag/BoQghgkAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA4AZAeQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_6307.setTransform(49.4,319.4,0.5,0.5);

	this.shape_6308 = new cjs.Shape();
	this.shape_6308.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgSgEgRAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6308.setTransform(568,281.1,0.5,0.5);

	this.shape_6309 = new cjs.Shape();
	this.shape_6309.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAXAAARgDQAUgEAZgKIAAAXQgYAJgTAEQgSAEgYAAQg6AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6309.setTransform(555.1,281.2,0.5,0.5);

	this.shape_6310 = new cjs.Shape();
	this.shape_6310.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgYAYgLQAYgLAgAAQBdAAAABiIAACxg");
	this.shape_6310.setTransform(540.7,278.3,0.5,0.5);

	this.shape_6311 = new cjs.Shape();
	this.shape_6311.graphics.f("#000000").s().p("AgRCXQgSgTABgpIAAiuIgpAAIAAgOIApgMIAMg8IAMAAIAABBIBPAAIAAAVIhPAAIAACqQAAAgALAOQALAQAXgBQAZAAAPgDIAAAUQgRAFgYABQgiAAgRgUg");
	this.shape_6311.setTransform(522,279.7,0.5,0.5);

	this.shape_6312 = new cjs.Shape();
	this.shape_6312.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_6312.setTransform(510.5,281.1,0.5,0.5);

	this.shape_6313 = new cjs.Shape();
	this.shape_6313.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAhAAfgmQAggoA1AAQAxAAAaAiQAcAhAAA5IAAATIjBAAQAAA4AaAeQAYAdAwAAQAXAAARgDQASgEAagKIAAAXQgWAJgUAEQgSAEgYAAQg7AAghglgAg2hbQgYAYgEAyICmAAQAAgwgUgaQgVgbgkABQgmAAgXAag");
	this.shape_6313.setTransform(495.9,281.2,0.5,0.5);

	this.shape_6314 = new cjs.Shape();
	this.shape_6314.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAcgsA8AAQA3AAAdAkQAcAkAABFQAABCgeAkQgeAlg0AAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAbAAA6IAAAIQAAA+AWAcQAVAbAvAAQAqAAAXgfQAWgeAAg3QAAh4hWAAQgvAAgVAag");
	this.shape_6314.setTransform(481.7,284.1,0.5,0.5);

	this.shape_6315 = new cjs.Shape();
	this.shape_6315.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgVgRgNQgPgOgngOQgqgPgOgJQgRgLgIgNQgIgNAAgTQAAgfAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUALAAATQAAAWAQAMQAPANAqAPQAmAOAQAJQARAMAIANQAIANAAASQAAAkgcAUQgbATgyABQg2gBgggQg");
	this.shape_6315.setTransform(467.7,281.2,0.5,0.5);

	this.shape_6316 = new cjs.Shape();
	this.shape_6316.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABhAAggmQAfgoA1AAQAwAAAcAiQAcAhAAA5IAAATIjDAAQAAA4AaAeQAaAdAuAAQAYAAARgDQATgEAagKIAAAXQgXAJgUAEQgRAEgaAAQg6AAghglgAg3hbQgXAYgEAyICmAAQAAgwgUgaQgVgbgkABQgnAAgXAag");
	this.shape_6316.setTransform(448.2,281.2,0.5,0.5);

	this.shape_6317 = new cjs.Shape();
	this.shape_6317.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgYAYgLQAYgLAgAAQBcAAAABiIAACxg");
	this.shape_6317.setTransform(433.8,278.3,0.5,0.5);

	this.shape_6318 = new cjs.Shape();
	this.shape_6318.graphics.f("#000000").s().p("AhvCtIAAgaQAoARA8AAQAsAAAagVQAagUABgiQgBgUgIgOQgJgNgTgMQgWgLgkgNQg5gTgTgVQgWgXAAglQAAgoAggaQAhgaAwAAQA0AAAtATIgJAWQgugTgpAAQgnAAgYATQgYATAAAgQAAAUAHANQAHAMARALQAPAKApAPQAqANAWAPQAVAMALATQAKARAAAZQgBAughAbQgiAag2AAQhCAAgkgOg");
	this.shape_6318.setTransform(419.3,278.8,0.5,0.5);

	this.shape_6319 = new cjs.Shape();
	this.shape_6319.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6319.setTransform(402.6,287,0.5,0.5);

	this.shape_6320 = new cjs.Shape();
	this.shape_6320.graphics.f("#000000").s().p("AhSCSQghgrAAhLQAAhFATgyQAUgxAkgXQAjgYAxABQAXgBAUAHIAAAWQgTgIgZAAQg9AAgiAtQgiAtgEBTIADAAQASgXAZgNQAZgNAaAAQAzABAdAdQAcAcAAAzQAAA5geAgQgeAfgzABQg3AAgfgqgAgogJQgWAJgMATQgOATAAATQAAAcANAZQAMAZAVAPQAVAQAZgBQAoABAXgaQAXgaAAgwQAAgpgWgXQgXgXgmAAQgZAAgWAMg");
	this.shape_6320.setTransform(392.5,278.8,0.5,0.5);

	this.shape_6321 = new cjs.Shape();
	this.shape_6321.graphics.f("#000000").s().p("AAyC3IAAhdIi5AAIAAgRICzj/IAeAAIAAD7IA/AAIAAAVIg/AAIAABdgAAVhyIh/C3ICcAAIAAhoQAAhOAEgwIgCAAQgGAMgZAjg");
	this.shape_6321.setTransform(377.9,278.8,0.5,0.5);

	this.shape_6322 = new cjs.Shape();
	this.shape_6322.graphics.f("#000000").s().p("AhcC1IAAgWQAHADATADIAXACQA8AAAjgtQAjgsAEhUIgDAAQgTAXgYAMQgaANgaAAQgzAAgcgcQgcgaAAg0QAAg3AfghQAfgjAxABQAjAAAbASQAaASAQAlQAOAmAAAxQAABFgTAyQgTAwgjAXQgkAYgyAAQgbAAgVgHgAhBiKQgYAcAAAsQAAArAWAXQAWAWAoAAQAYAAAWgLQAWgLANgSQAMgTAAgTQAAgcgLgbQgLgZgWgOQgUgPgbAAQgnAAgXAbg");
	this.shape_6322.setTransform(363.1,278.8,0.5,0.5);

	this.shape_6323 = new cjs.Shape();
	this.shape_6323.graphics.f("#000000").s().p("AAkC2IAAkIQAAgkADgnIhUBDIgOgRIBihKIAVAAIAAFrg");
	this.shape_6323.setTransform(346.9,278.9,0.5,0.5);

	this.shape_6324 = new cjs.Shape();
	this.shape_6324.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAZAAA3IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBEAAQBbAAAABjIAACwg");
	this.shape_6324.setTransform(327.3,281.1,0.5,0.5);

	this.shape_6325 = new cjs.Shape();
	this.shape_6325.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAGQgFAGgHABQgPgBAAgYg");
	this.shape_6325.setTransform(316.8,278.7,0.5,0.5);

	this.shape_6326 = new cjs.Shape();
	this.shape_6326.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAZAAA3IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6326.setTransform(299.9,281.1,0.5,0.5);

	this.shape_6327 = new cjs.Shape();
	this.shape_6327.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQANAAAYADIgFAYQgTgEgQAAQgiAAgWAeQgWAdAAAtIAACUg");
	this.shape_6327.setTransform(288.2,281.1,0.5,0.5);

	this.shape_6328 = new cjs.Shape();
	this.shape_6328.graphics.f("#000000").s().p("Ag/B8QgbgSgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAmg4AAQgkAAgbgRgAhFhWQgYAfAAA3QAAA3AYAgQAZAfAsAAQAsAAAZgfQAZgfAAg4QAAg3gZgfQgZgfgsAAQgtAAgYAfg");
	this.shape_6328.setTransform(274.9,281.2,0.5,0.5);

	this.shape_6329 = new cjs.Shape();
	this.shape_6329.graphics.f("#000000").s().p("Ag0C4QgYgMgNgWIgCAAIgHApIgPAAIAAmCIAYAAIAABhIgBAoIAAAWIABAAQAQgZAWgLQAWgMAdAAQA5AAAdAkQAcAkAABEQAABDgeAlQgeAkg2AAQgdAAgXgMgAhEgiQgVAbAAA/IAAAEQAAA8AWAcQAWAaAtAAQAsAAAWgfQAWgeAAg6QAAh0hYAAQgwAAgUAbg");
	this.shape_6329.setTransform(260.2,278.4,0.5,0.5);

	this.shape_6330 = new cjs.Shape();
	this.shape_6330.graphics.f("#000000").s().p("AhfB8IAAgbQAoAVAugBQAnABAVgNQAVgOAAgWQAAgVgRgNQgRgPglgNQgqgPgOgJQgQgLgJgNQgIgOgBgSQAAgfAagSQAZgSAuAAQArAAAnARIgJAXQgngRgiAAQghAAgTALQgTALAAATQgBAWAPAMQAPANArAPQAkANASAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3gBgfgQg");
	this.shape_6330.setTransform(239.6,281.2,0.5,0.5);

	this.shape_6331 = new cjs.Shape();
	this.shape_6331.graphics.f("#000000").s().p("AhPB4QgWgUABglQAAgnAggWQAjgVA8gBIA0gCIAAgSQAAgmgQgUQgQgUgjAAQglAAgoAVIgJgVQAsgVArAAQAsAAAXAXQAVAWAAAyIAACzIgSAAIgFgrIgDAAQgVAbgUAKQgWALgdAAQgnAAgXgUgAAeAAQg3ACgaAPQgYAPABAgQAAAaAPAOQAQAOAcAAQAqAAAagZQAZgZAAgsIAAgZg");
	this.shape_6331.setTransform(226.5,281.2,0.5,0.5);

	this.shape_6332 = new cjs.Shape();
	this.shape_6332.graphics.f("#000000").s().p("ABOCHIg8i0IgPg2IgBAAIhMDqIgYAAIhOkNIAaAAIAsCbQARBAADAWIABAAQAOg3AIgWIA4ikIAVAAIA1CjQASA9AEARIABAAQADgTARhEIAqiaIAZAAIhKENg");
	this.shape_6332.setTransform(211,281.2,0.5,0.5);

	this.shape_6333 = new cjs.Shape();
	this.shape_6333.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_6333.setTransform(192.3,278.3,0.5,0.5);

	this.shape_6334 = new cjs.Shape();
	this.shape_6334.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjDAAQAAA4AbAeQAYAdAvAAQAYAAARgDQATgEAZgKIAAAXQgWAJgTAEQgTAEgZAAQg5AAghglgAg3hbQgYAZgDAxICmAAQAAgwgUgaQgVgbgkABQgmAAgYAag");
	this.shape_6334.setTransform(182.4,281.2,0.5,0.5);

	this.shape_6335 = new cjs.Shape();
	this.shape_6335.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAZAAA1IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgYAYgLQAYgLAhAAQBcAAgBBiIAACxg");
	this.shape_6335.setTransform(168,278.3,0.5,0.5);

	this.shape_6336 = new cjs.Shape();
	this.shape_6336.graphics.f("#000000").s().p("Ag/BoQghgkAAhCQAAhCAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAfQgZAfAAA4QAAA4AZAeQAZAfAuAAQAkAAAggNIAAAXQgZANgrAAQg5AAggglg");
	this.shape_6336.setTransform(154.6,281.2,0.5,0.5);

	this.shape_6337 = new cjs.Shape();
	this.shape_6337.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAHQgFAGgHABQgPgBAAgYg");
	this.shape_6337.setTransform(145.4,278.7,0.5,0.5);

	this.shape_6338 = new cjs.Shape();
	this.shape_6338.graphics.f("#000000").s().p("ACPC2IAAkTQAAgcADggIgCAAIiIFPIgPAAIiIlPIgCAAIACA/IAAEQIgYAAIAAlrIAnAAICAE/IACAAICAk/IAmAAIAAFrg");
	this.shape_6338.setTransform(131.5,278.9,0.5,0.5);

	this.shape_6339 = new cjs.Shape();
	this.shape_6339.graphics.f("#000000").s().p("AhzDAIAAgWQAPAEAQAAQANAAAJgGQAJgFAJgNQAHgNALgcIAOgjIhokOIAaAAIA4CYQAbBFAHAZIAAAAQAKghAZg/IA4iWIAaAAIh4E6QgOAlgLAOQgKAOgOAHQgMAGgTAAQgPAAgRgEg");
	this.shape_6339.setTransform(108,284.3,0.5,0.5);

	this.shape_6340 = new cjs.Shape();
	this.shape_6340.graphics.f("#000000").s().p("Ag/BoQgigkABhCQAAhCAigmQAigmA6AAQAkAAAgANIgHAVQgkgLgZAAQgxAAgZAfQgaAfAAA4QAAA4AaAeQAZAfAtAAQAlAAAfgNIAAAXQgZANgqAAQg6AAggglg");
	this.shape_6340.setTransform(96.4,281.2,0.5,0.5);

	this.shape_6341 = new cjs.Shape();
	this.shape_6341.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAcgrBCAAQBbAAABBjIAACwg");
	this.shape_6341.setTransform(82.6,281.1,0.5,0.5);

	this.shape_6342 = new cjs.Shape();
	this.shape_6342.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gBIAzgCIAAgSQAAgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAsAAAXAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgVALgdAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAPAOAdAAQArAAAYgZQAZgZAAgsIAAgZg");
	this.shape_6342.setTransform(67.8,281.2,0.5,0.5);

	this.shape_6343 = new cjs.Shape();
	this.shape_6343.graphics.f("#000000").s().p("ABrC2IjXlCIgCAAQADA6AAAdIAADrIgYAAIAAlrIAZAAIDWFCIACAAQgCgoAAguIAAjsIAYAAIAAFrg");
	this.shape_6343.setTransform(52.3,278.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_6343},{t:this.shape_6342},{t:this.shape_6341},{t:this.shape_6340},{t:this.shape_6339},{t:this.shape_6338},{t:this.shape_6337},{t:this.shape_6336},{t:this.shape_6335},{t:this.shape_6334},{t:this.shape_6333},{t:this.shape_6332},{t:this.shape_6331},{t:this.shape_6330},{t:this.shape_6329},{t:this.shape_6328},{t:this.shape_6327},{t:this.shape_6326},{t:this.shape_6325},{t:this.shape_6324},{t:this.shape_6323},{t:this.shape_6322},{t:this.shape_6321},{t:this.shape_6320},{t:this.shape_6319},{t:this.shape_6318},{t:this.shape_6317},{t:this.shape_6316},{t:this.shape_6315},{t:this.shape_6314},{t:this.shape_6313},{t:this.shape_6312},{t:this.shape_6311},{t:this.shape_6310},{t:this.shape_6309},{t:this.shape_6308},{t:this.shape_6307},{t:this.shape_6306},{t:this.shape_6305},{t:this.shape_6304},{t:this.shape_6303},{t:this.shape_6302},{t:this.shape_6301},{t:this.shape_6300},{t:this.shape_6299},{t:this.shape_6298},{t:this.shape_6297},{t:this.shape_6296},{t:this.shape_6295},{t:this.shape_6294},{t:this.shape_6293},{t:this.shape_6292},{t:this.shape_6291},{t:this.shape_6290},{t:this.shape_6289},{t:this.shape_6288},{t:this.shape_6287},{t:this.shape_6286},{t:this.shape_6285},{t:this.shape_6284},{t:this.shape_6283},{t:this.shape_6282},{t:this.shape_6281},{t:this.shape_6280},{t:this.shape_6279},{t:this.shape_6278},{t:this.shape_6277},{t:this.shape_6276},{t:this.shape_6275},{t:this.shape_6274},{t:this.shape_6273},{t:this.shape_6272},{t:this.shape_6271},{t:this.shape_6270},{t:this.shape_6269},{t:this.shape_6268},{t:this.shape_6267},{t:this.shape_6266},{t:this.shape_6265},{t:this.shape_6264},{t:this.shape_6263},{t:this.shape_6262},{t:this.shape_6261},{t:this.shape_6260},{t:this.shape_6259},{t:this.shape_6258},{t:this.shape_6257},{t:this.shape_6256},{t:this.shape_6255},{t:this.shape_6254},{t:this.shape_6253},{t:this.shape_6252},{t:this.shape_6251},{t:this.shape_6250},{t:this.shape_6249},{t:this.shape_6248},{t:this.shape_6247},{t:this.shape_6246},{t:this.shape_6245},{t:this.shape_6244},{t:this.shape_6243},{t:this.shape_6242},{t:this.shape_6241},{t:this.shape_6240},{t:this.shape_6239},{t:this.shape_6238},{t:this.shape_6237},{t:this.shape_6236},{t:this.shape_6235},{t:this.shape_6234},{t:this.shape_6233},{t:this.shape_6232},{t:this.shape_6231},{t:this.shape_6230},{t:this.shape_6229},{t:this.shape_6228},{t:this.shape_6227},{t:this.shape_6226},{t:this.shape_6225},{t:this.shape_6224},{t:this.shape_6223},{t:this.shape_6222},{t:this.shape_6221},{t:this.shape_6220},{t:this.shape_6219},{t:this.shape_6218},{t:this.shape_6217},{t:this.shape_6216},{t:this.shape_6215},{t:this.shape_6214},{t:this.shape_6213},{t:this.shape_6212},{t:this.shape_6211},{t:this.shape_6210},{t:this.shape_6209},{t:this.shape_6208},{t:this.shape_6207},{t:this.shape_6206},{t:this.shape_6205},{t:this.shape_6204},{t:this.shape_6203},{t:this.shape_6202},{t:this.shape_6201},{t:this.shape_6200},{t:this.shape_6199},{t:this.shape_6198},{t:this.shape_6197},{t:this.shape_6196},{t:this.shape_6195},{t:this.shape_6194},{t:this.shape_6193},{t:this.shape_6192},{t:this.shape_6191},{t:this.shape_6190},{t:this.shape_6189},{t:this.shape_6188},{t:this.shape_6187},{t:this.shape_6186},{t:this.shape_6185},{t:this.shape_6184},{t:this.shape_6183},{t:this.shape_6182},{t:this.shape_6181},{t:this.shape_6180},{t:this.shape_6179},{t:this.shape_6178},{t:this.shape_6177},{t:this.shape_6176},{t:this.shape_6175},{t:this.shape_6174},{t:this.shape_6173},{t:this.shape_6172},{t:this.shape_6171},{t:this.shape_6170},{t:this.shape_6169},{t:this.shape_6168},{t:this.shape_6167},{t:this.shape_6166},{t:this.shape_6165},{t:this.shape_6164},{t:this.shape_6163},{t:this.shape_6162},{t:this.shape_6161},{t:this.shape_6160},{t:this.shape_6159},{t:this.shape_6158},{t:this.shape_6157},{t:this.shape_6156},{t:this.shape_6155},{t:this.shape_6154},{t:this.shape_6153},{t:this.shape_6152},{t:this.shape_6151},{t:this.shape_6150},{t:this.shape_6149},{t:this.shape_6148},{t:this.shape_6147},{t:this.shape_6146},{t:this.shape_6145},{t:this.shape_6144},{t:this.shape_6143},{t:this.shape_6142},{t:this.shape_6141},{t:this.shape_6140},{t:this.shape_6139},{t:this.shape_6138},{t:this.shape_6137},{t:this.shape_6136},{t:this.shape_6135},{t:this.shape_6134},{t:this.shape_6133},{t:this.shape_6132},{t:this.shape_6131},{t:this.shape_6130},{t:this.shape_6129},{t:this.shape_6128},{t:this.shape_6127},{t:this.shape_6126},{t:this.shape_6125},{t:this.shape_6124},{t:this.shape_6123},{t:this.shape_6122},{t:this.shape_6121},{t:this.shape_6120},{t:this.shape_6119},{t:this.shape_6118},{t:this.shape_6117},{t:this.shape_6116},{t:this.shape_6115},{t:this.shape_6114},{t:this.shape_6113},{t:this.shape_6112},{t:this.shape_6111},{t:this.shape_6110},{t:this.shape_6109},{t:this.shape_6108},{t:this.shape_6107},{t:this.shape_6106},{t:this.shape_6105},{t:this.shape_6104},{t:this.shape_6103},{t:this.shape_6102},{t:this.shape_6101},{t:this.shape_6100},{t:this.shape_6099},{t:this.shape_6098},{t:this.shape_6097},{t:this.shape_6096},{t:this.shape_6095},{t:this.shape_6094},{t:this.shape_6093},{t:this.shape_6092},{t:this.shape_6091},{t:this.shape_6090},{t:this.shape_6089},{t:this.shape_6088},{t:this.shape_6087},{t:this.shape_6086},{t:this.shape_6085},{t:this.shape_6084},{t:this.shape_6083},{t:this.shape_6082},{t:this.shape_6081},{t:this.shape_6080},{t:this.shape_6079},{t:this.shape_6078},{t:this.shape_6077},{t:this.shape_6076},{t:this.shape_6075},{t:this.shape_6074},{t:this.shape_6073},{t:this.shape_6072},{t:this.shape_6071},{t:this.shape_6070},{t:this.shape_6069},{t:this.shape_6068},{t:this.shape_6067},{t:this.shape_6066},{t:this.shape_6065},{t:this.shape_6064},{t:this.shape_6063},{t:this.shape_6062},{t:this.shape_6061},{t:this.shape_6060},{t:this.shape_6059},{t:this.shape_6058},{t:this.shape_6057},{t:this.shape_6056},{t:this.shape_6055},{t:this.shape_6054},{t:this.shape_6053},{t:this.shape_6052},{t:this.shape_6051},{t:this.shape_6050},{t:this.shape_6049},{t:this.shape_6048},{t:this.shape_6047},{t:this.shape_6046},{t:this.shape_6045},{t:this.shape_6044},{t:this.shape_6043},{t:this.shape_6042},{t:this.shape_6041},{t:this.shape_6040},{t:this.shape_6039},{t:this.shape_6038},{t:this.shape_6037},{t:this.shape_6036},{t:this.shape_6035},{t:this.shape_6034},{t:this.shape_6033},{t:this.shape_6032},{t:this.shape_6031},{t:this.shape_6030},{t:this.shape_6029},{t:this.shape_6028},{t:this.shape_6027},{t:this.shape_6026},{t:this.shape_6025},{t:this.shape_6024},{t:this.shape_6023},{t:this.shape_6022},{t:this.shape_6021},{t:this.shape_6020},{t:this.shape_6019},{t:this.shape_6018},{t:this.shape_6017},{t:this.shape_6016},{t:this.shape_6015},{t:this.shape_6014},{t:this.shape_6013},{t:this.shape_6012},{t:this.shape_6011},{t:this.shape_6010},{t:this.shape_6009},{t:this.shape_6008},{t:this.shape_6007},{t:this.shape_6006},{t:this.shape_6005},{t:this.shape_6004},{t:this.shape_6003},{t:this.shape_6002},{t:this.shape_6001},{t:this.shape_6000},{t:this.shape_5999},{t:this.shape_5998},{t:this.shape_5997},{t:this.shape_5996},{t:this.shape_5995},{t:this.shape_5994},{t:this.shape_5993},{t:this.shape_5992},{t:this.shape_5991},{t:this.shape_5990},{t:this.shape_5989},{t:this.shape_5988},{t:this.shape_5987},{t:this.shape_5986},{t:this.shape_5985},{t:this.shape_5984},{t:this.shape_5983},{t:this.shape_5982},{t:this.shape_5981},{t:this.shape_5980},{t:this.shape_5979},{t:this.shape_5978},{t:this.shape_5977},{t:this.shape_5976},{t:this.shape_5975},{t:this.shape_5974},{t:this.shape_5973},{t:this.shape_5972},{t:this.shape_5971},{t:this.shape_5970},{t:this.shape_5969},{t:this.shape_5968},{t:this.shape_5967},{t:this.shape_5966},{t:this.shape_5965},{t:this.shape_5964},{t:this.shape_5963},{t:this.shape_5962},{t:this.shape_5961},{t:this.shape_5960},{t:this.shape_5959},{t:this.shape_5958},{t:this.shape_5957},{t:this.shape_5956},{t:this.shape_5955},{t:this.shape_5954},{t:this.shape_5953},{t:this.shape_5952},{t:this.shape_5951},{t:this.shape_5950},{t:this.shape_5949},{t:this.shape_5948},{t:this.shape_5947},{t:this.shape_5946},{t:this.shape_5945},{t:this.shape_5944},{t:this.shape_5943},{t:this.shape_5942},{t:this.shape_5941},{t:this.shape_5940},{t:this.shape_5939},{t:this.shape_5938},{t:this.shape_5937},{t:this.shape_5936},{t:this.shape_5935},{t:this.shape_5934},{t:this.shape_5933},{t:this.shape_5932},{t:this.shape_5931},{t:this.shape_5930},{t:this.shape_5929},{t:this.shape_5928},{t:this.shape_5927},{t:this.shape_5926},{t:this.shape_5925},{t:this.shape_5924},{t:this.shape_5923},{t:this.shape_5922},{t:this.shape_5921},{t:this.shape_5920},{t:this.shape_5919},{t:this.shape_5918},{t:this.shape_5917},{t:this.shape_5916},{t:this.shape_5915},{t:this.shape_5914},{t:this.shape_5913},{t:this.shape_5912},{t:this.shape_5911},{t:this.shape_5910},{t:this.shape_5909},{t:this.shape_5908},{t:this.shape_5907},{t:this.shape_5906},{t:this.shape_5905},{t:this.shape_5904},{t:this.shape_5903},{t:this.shape_5902},{t:this.shape_5901},{t:this.shape_5900},{t:this.shape_5899},{t:this.shape_5898},{t:this.shape_5897},{t:this.shape_5896},{t:this.shape_5895},{t:this.shape_5894},{t:this.shape_5893},{t:this.shape_5892},{t:this.shape_5891},{t:this.shape_5890},{t:this.shape_5889},{t:this.shape_5888},{t:this.shape_5887},{t:this.shape_5886},{t:this.shape_5885},{t:this.shape_5884},{t:this.shape_5883},{t:this.shape_5882},{t:this.shape_5881},{t:this.shape_5880},{t:this.shape_5879},{t:this.shape_5878},{t:this.shape_5877},{t:this.shape_5876},{t:this.shape_5875},{t:this.shape_5874},{t:this.shape_5873},{t:this.shape_5872},{t:this.shape_5871},{t:this.shape_5870},{t:this.shape_5869},{t:this.shape_5868},{t:this.shape_5867},{t:this.shape_5866},{t:this.shape_5865},{t:this.shape_5864},{t:this.shape_5863},{t:this.shape_5862},{t:this.shape_5861},{t:this.shape_5860},{t:this.shape_5859},{t:this.shape_5858},{t:this.shape_5857},{t:this.shape_5856},{t:this.shape_5855},{t:this.shape_5854},{t:this.shape_5853},{t:this.shape_5852},{t:this.shape_5851},{t:this.shape_5850},{t:this.shape_5849},{t:this.shape_5848},{t:this.instance_26}]},52).to({state:[]},1).wait(112));

	// ButtonLeftRight copy 4
	this.buttonR4 = new lib.ButtonLeft_Right();
	this.buttonR4.name = "buttonR4";
	this.buttonR4.parent = this;
	this.buttonR4.setTransform(2025,513.5,1,1,180);
	this.buttonR4._off = true;
	new cjs.ButtonHelper(this.buttonR4, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR4).wait(51).to({_off:false},0).to({_off:true},1).wait(113));

	// ButtonLeftRight copy 5
	this.buttonL4 = new lib.ButtonLeft_Right();
	this.buttonL4.name = "buttonL4";
	this.buttonL4.parent = this;
	this.buttonL4.setTransform(0,437.2);
	this.buttonL4._off = true;
	new cjs.ButtonHelper(this.buttonL4, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL4).wait(51).to({_off:false},0).to({_off:true},1).wait(113));

	// Layer 1
	this.shape_6344 = new cjs.Shape();
	this.shape_6344.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_6344.setTransform(331.4,653.5,0.5,0.5);

	this.shape_6345 = new cjs.Shape();
	this.shape_6345.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6345.setTransform(320.4,644.9,0.5,0.5);

	this.shape_6346 = new cjs.Shape();
	this.shape_6346.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_6346.setTransform(305.7,647.6,0.5,0.5);

	this.shape_6347 = new cjs.Shape();
	this.shape_6347.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIA0gBIAAgSQAAgmgQgUQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgGgrIgCAAQgWAbgUAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAagZAAgsIAAgag");
	this.shape_6347.setTransform(290.9,647.7,0.5,0.5);

	this.shape_6348 = new cjs.Shape();
	this.shape_6348.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6348.setTransform(281.7,644.8,0.5,0.5);

	this.shape_6349 = new cjs.Shape();
	this.shape_6349.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgNAAgWQAAgVgQgNQgQgPgmgNQgogOgRgKQgPgLgJgOQgJgNABgTQAAgeAZgSQAagSAsAAQAtAAAnARIgJAXQgogRgjAAQggAAgTALQgTAKgBAUQAAAVAPANQAPANAsAPQAjANARAKQARALAJAOQAIAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_6349.setTransform(272.8,647.7,0.5,0.5);

	this.shape_6350 = new cjs.Shape();
	this.shape_6350.graphics.f("#000000").s().p("AgMC2IAAlrIAZAAIAAFrg");
	this.shape_6350.setTransform(263.8,645.4,0.5,0.5);

	this.shape_6351 = new cjs.Shape();
	this.shape_6351.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjBAAQABA5AYAdQAaAdAvAAQAXAAARgDQATgEAagLIAAAXQgXALgUACQgVAEgVAAQg6AAgigkgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_6351.setTransform(246.9,647.7,0.5,0.5);

	this.shape_6352 = new cjs.Shape();
	this.shape_6352.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6352.setTransform(231.9,644.9,0.5,0.5);

	this.shape_6353 = new cjs.Shape();
	this.shape_6353.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCghAlQgfAlg4AAQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6353.setTransform(217.3,647.7,0.5,0.5);

	this.shape_6354 = new cjs.Shape();
	this.shape_6354.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_6354.setTransform(202.4,644.8,0.5,0.5);

	this.shape_6355 = new cjs.Shape();
	this.shape_6355.graphics.f("#000000").s().p("ABaC2IheifIhaAAIAACfIgZAAIAAlrIBWAAQBEAAAfAZQAhAZAAAyQAAAkgTAaQgTAYgoALIBjCmgAheABIBFAAQAuAAAZgTQAZgVABgoQAAgqgagSQgZgUg3ABIg8AAg");
	this.shape_6355.setTransform(188.2,645.4,0.5,0.5);

	this.shape_6356 = new cjs.Shape();
	this.shape_6356.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAFQgTBCgXA1g");
	this.shape_6356.setTransform(169.8,654.6,0.5,0.5);

	this.shape_6357 = new cjs.Shape();
	this.shape_6357.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AZAeQAaAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgXALgUACQgVAEgVAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgwgUgaQgVgbgjABQgmgBgYAag");
	this.shape_6357.setTransform(160.5,647.7,0.5,0.5);

	this.shape_6358 = new cjs.Shape();
	this.shape_6358.graphics.f("#000000").s().p("Ag/BnQgigjAAhDQAAhBAjgmQAigmA6AAQAkAAAgANIgIAVQgjgLgaAAQgwAAgaAeQgZAfgBA5QABA4AZAeQAaAfAtAAQAlAAAggOIAAAXQgbANgpAAQg6AAggglg");
	this.shape_6358.setTransform(147.8,647.7,0.5,0.5);

	this.shape_6359 = new cjs.Shape();
	this.shape_6359.graphics.f("#000000").s().p("ABTCKIAAiuQgBgpgRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBdAAgBBjIAACwg");
	this.shape_6359.setTransform(134,647.6,0.5,0.5);

	this.shape_6360 = new cjs.Shape();
	this.shape_6360.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA4AaAeQAaAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgTACQgWAEgWAAQg5AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgkABQglgBgZAag");
	this.shape_6360.setTransform(119.4,647.7,0.5,0.5);

	this.shape_6361 = new cjs.Shape();
	this.shape_6361.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_6361.setTransform(104.4,644.9,0.5,0.5);

	this.shape_6362 = new cjs.Shape();
	this.shape_6362.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_6362.setTransform(94.3,645.2,0.5,0.5);

	this.shape_6363 = new cjs.Shape();
	this.shape_6363.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC2QAPAnAGAXIAAAAQALgjALgbIBGi2IAZAAIhoENg");
	this.shape_6363.setTransform(85.6,647.7,0.5,0.5);

	this.shape_6364 = new cjs.Shape();
	this.shape_6364.graphics.f("#000000").s().p("Ag/B7QgagRgPggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_6364.setTransform(72.2,647.7,0.5,0.5);

	this.shape_6365 = new cjs.Shape();
	this.shape_6365.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6365.setTransform(60.7,647.6,0.5,0.5);

	this.shape_6366 = new cjs.Shape();
	this.shape_6366.graphics.f("#000000").s().p("AhtC2IAAlrIBZAAQCCAAAABpQgBA0gjAcQglAchAAAIg4AAIAACWgAhTAJIAyAAQA9AAAagTQAcgUAAgtQAAgrgagUQgagUg1AAIg8AAg");
	this.shape_6366.setTransform(48,645.4,0.5,0.5);

	this.shape_6367 = new cjs.Shape();
	this.shape_6367.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAagqBCAAQBcAAAABjIAACwg");
	this.shape_6367.setTransform(653.2,609.3,0.5,0.5);

	this.shape_6368 = new cjs.Shape();
	this.shape_6368.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6368.setTransform(642.7,607,0.5,0.5);

	this.shape_6369 = new cjs.Shape();
	this.shape_6369.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAJgFAIgOQAJgOAJgZIANgkIhnkOIAaAAIA4CYQAbBFAHAZIAAAAQAKggAZg/IA4iXIAaAAIh5E6QgNAkgLAQQgJAMgOAIQgOAHgTAAQgNAAgSgGg");
	this.shape_6369.setTransform(627.4,612.5,0.5,0.5);

	this.shape_6370 = new cjs.Shape();
	this.shape_6370.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAlIABAAQAagqBEAAQBcAAgBBjIAACwg");
	this.shape_6370.setTransform(614.1,609.3,0.5,0.5);

	this.shape_6371 = new cjs.Shape();
	this.shape_6371.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgXALgbAAQgoAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAagZgBgsIAAgag");
	this.shape_6371.setTransform(599.3,609.4,0.5,0.5);

	this.shape_6372 = new cjs.Shape();
	this.shape_6372.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAFAnIABAAQAcgsA8AAQA3AAAdAkQAcAkAABEQAABCgeAlQgeAlg0AAQg9AAgdgvIgCAAIACCkgAhCiWQgWAZAAA8IAAAIQAAA+AVAcQAWAbAuAAQApAAAYgfQAWgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_6372.setTransform(585.7,612.4,0.5,0.5);

	this.shape_6373 = new cjs.Shape();
	this.shape_6373.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgTAYQgUAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_6373.setTransform(566.6,609.3,0.5,0.5);

	this.shape_6374 = new cjs.Shape();
	this.shape_6374.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABBggAmQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6374.setTransform(547.8,609.4,0.5,0.5);

	this.shape_6375 = new cjs.Shape();
	this.shape_6375.graphics.f("#000000").s().p("AhZCKQgtgzABhXQAAg4AUgqQAVgpAogYQAngXA0AAQA2AAAqAUIgLAXQgngUgtAAQhDAAgoAsQgnArABBMQgBBOAlArQAmArBEAAQAtAAAmgMIAAAWQgkANg2AAQhLAAgsgxg");
	this.shape_6375.setTransform(532.8,607.1,0.5,0.5);

	this.shape_6376 = new cjs.Shape();
	this.shape_6376.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6376.setTransform(513.8,609.3,0.5,0.5);

	this.shape_6377 = new cjs.Shape();
	this.shape_6377.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6377.setTransform(500.9,609.4,0.5,0.5);

	this.shape_6378 = new cjs.Shape();
	this.shape_6378.graphics.f("#000000").s().p("AgMCHIhokNIAaAAIBFC2QAOAlAHAZIABAAQAKgiALgcIBFi2IAaAAIhpENg");
	this.shape_6378.setTransform(488.1,609.4,0.5,0.5);

	this.shape_6379 = new cjs.Shape();
	this.shape_6379.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6379.setTransform(479.3,606.5,0.5,0.5);

	this.shape_6380 = new cjs.Shape();
	this.shape_6380.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_6380.setTransform(473.6,607,0.5,0.5);

	this.shape_6381 = new cjs.Shape();
	this.shape_6381.graphics.f("#000000").s().p("AhvCsIAAgZQAmARA+AAQArAAAbgVQAagVABghQAAgUgJgOQgJgNgTgMQgWgLgkgNQg4gSgUgWQgWgXAAglQAAgoAggaQAggaAxAAQA0AAAtATIgJAWQgugTgpAAQgoAAgXATQgYATAAAgQAAAUAHANQAIANAQAKQAUAMAkANQAqANAWAOQAWAOAKASQAKAQAAAaQgBAughAaQgiAbg2AAQhCAAgkgPg");
	this.shape_6381.setTransform(463.8,607.1,0.5,0.5);

	this.shape_6382 = new cjs.Shape();
	this.shape_6382.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgpAAgUAYQgUAXAAAwIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgTAZAAA3IAACUIgZAAIAAkOIAUAAIAGAlIABAAQAMgUAUgLQAUgLAaAAQBAAAARAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAYAAA0IAACwg");
	this.shape_6382.setTransform(439,609.3,0.5,0.5);

	this.shape_6383 = new cjs.Shape();
	this.shape_6383.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6383.setTransform(420.5,609.4,0.5,0.5);

	this.shape_6384 = new cjs.Shape();
	this.shape_6384.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_6384.setTransform(406.7,606.5,0.5,0.5);

	this.shape_6385 = new cjs.Shape();
	this.shape_6385.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAeAAAtIAACUg");
	this.shape_6385.setTransform(395,609.3,0.5,0.5);

	this.shape_6386 = new cjs.Shape();
	this.shape_6386.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_6386.setTransform(381.7,609.4,0.5,0.5);

	this.shape_6387 = new cjs.Shape();
	this.shape_6387.graphics.f("#000000").s().p("AhlCKQgugwAAhZQAAg3AWgqQAYgsAqgXQAqgYA2ABQA7AAAwAVIgKAYQgwgXgyAAQhHAAgrAtQgqAtAABKQAABSAoApQApAqBMAAQAyAAAkgPIAAiAIhtAAIAAgWICGAAIAAClQg0AWhCAAQhVAAgugxg");
	this.shape_6387.setTransform(364.8,607.1,0.5,0.5);

	this.shape_6388 = new cjs.Shape();
	this.shape_6388.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAhAAfgmQAggoA2AAQAwAAAaAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgTACQgWAEgVAAQg6AAghgkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgVgbgjABQgmgBgYAag");
	this.shape_6388.setTransform(342.2,609.4,0.5,0.5);

	this.shape_6389 = new cjs.Shape();
	this.shape_6389.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAOgZAYgKQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_6389.setTransform(327.8,606.5,0.5,0.5);

	this.shape_6390 = new cjs.Shape();
	this.shape_6390.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6390.setTransform(315.7,607.9,0.5,0.5);

	this.shape_6391 = new cjs.Shape();
	this.shape_6391.graphics.f("#000000").s().p("AhzC/IAAgVQANAEATAAQAMAAAJgGQAKgFAIgOQAHgKAMgdIAMgkIhnkOIAaAAIA5CYQAdBNAEARIAAAAIAjhfIA5iXIAZAAIh4E6QgPAmgJAOQgLANgNAHQgOAHgSAAQgOAAgSgGg");
	this.shape_6391.setTransform(299.1,612.5,0.5,0.5);

	this.shape_6392 = new cjs.Shape();
	this.shape_6392.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgaAWgKQAWgMAdAAQA5AAAcAkQAdAjAABEQAABFgeAjQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_6392.setTransform(286.1,606.6,0.5,0.5);

	this.shape_6393 = new cjs.Shape();
	this.shape_6393.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6393.setTransform(263.5,606.6,0.5,0.5);

	this.shape_6394 = new cjs.Shape();
	this.shape_6394.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6394.setTransform(249.3,609.4,0.5,0.5);

	this.shape_6395 = new cjs.Shape();
	this.shape_6395.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6395.setTransform(238.2,609.3,0.5,0.5);

	this.shape_6396 = new cjs.Shape();
	this.shape_6396.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6396.setTransform(229.5,607,0.5,0.5);

	this.shape_6397 = new cjs.Shape();
	this.shape_6397.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_6397.setTransform(219.2,606.5,0.5,0.5);

	this.shape_6398 = new cjs.Shape();
	this.shape_6398.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6398.setTransform(198,609.4,0.5,0.5);

	this.shape_6399 = new cjs.Shape();
	this.shape_6399.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgPAAIAAmCIAYAAIgBCfIABAAQAQgZAWgLQAWgMAdAAQA4AAAeAkQAcAkAABDQAABEgeAkQgfAlg1AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQArAAAXgfQAWgeAAg6QAAh0hYAAQgvAAgVAbg");
	this.shape_6399.setTransform(183.8,606.6,0.5,0.5);

	this.shape_6400 = new cjs.Shape();
	this.shape_6400.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6400.setTransform(161.7,609.4,0.5,0.5);

	this.shape_6401 = new cjs.Shape();
	this.shape_6401.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_6401.setTransform(149.8,607.9,0.5,0.5);

	this.shape_6402 = new cjs.Shape();
	this.shape_6402.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgTgEgQAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6402.setTransform(135,609.3,0.5,0.5);

	this.shape_6403 = new cjs.Shape();
	this.shape_6403.graphics.f("#000000").s().p("AhNBoQggglgBhBQABg/AggnQAggoA0AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA5AZAdQAaAdAuAAQAaAAAQgDQASgEAagLIAAAXQgYALgTACQgVAEgWAAQg5AAgigkgAg2hcQgYAZgEAyICnAAQAAgwgVgaQgUgbglABQglgBgYAag");
	this.shape_6403.setTransform(122.1,609.4,0.5,0.5);

	this.shape_6404 = new cjs.Shape();
	this.shape_6404.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBCAAQBdAAAABjIAACwg");
	this.shape_6404.setTransform(107.7,609.3,0.5,0.5);

	this.shape_6405 = new cjs.Shape();
	this.shape_6405.graphics.f("#000000").s().p("AhdCzQgcgTAAgjQgBgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQgBgaAkgUQgYgKgNgVQgOgVAAgbQAAgnAagaQAZgYAtAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgPAIgHAKQgIAJAAAMQAAANAKAGQAKAGAXAAIAuAAQAsAAAYASQAXARAAAkQAAArgiAXQgkAXg+AAQg0AAgbgUgAhfB6QAAA4BTAAQBpAAAAhEQAAgYgQgLQgSgLglAAIgrAAQhKAAAAA6gAg5igQgSATAAAgQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgTgRQgSgRggAAQghAAgTATg");
	this.shape_6405.setTransform(93.5,612.4,0.5,0.5);

	this.shape_6406 = new cjs.Shape();
	this.shape_6406.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAGAAAMQAAAMgEAFQgEAHgIAAQgPAAAAgYg");
	this.shape_6406.setTransform(83.9,607,0.5,0.5);

	this.shape_6407 = new cjs.Shape();
	this.shape_6407.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAogBAUgNQAVgOAAgVQAAgVgRgNQgPgOgngOQgogOgQgKQgQgLgJgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgTAKAAAUQAAAVAPANQAPANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_6407.setTransform(75,609.4,0.5,0.5);

	this.shape_6408 = new cjs.Shape();
	this.shape_6408.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAwAAAbAiQAdAiAAA4IAAATIjCAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgVALgUACQgVAEgWAAQg6AAghgkgAg3hcQgYAagDAxICmAAQAAgwgUgaQgVgbgkABQgmgBgYAag");
	this.shape_6408.setTransform(62.1,609.4,0.5,0.5);

	this.shape_6409 = new cjs.Shape();
	this.shape_6409.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_6409.setTransform(47.1,606.6,0.5,0.5);

	this.shape_6410 = new cjs.Shape();
	this.shape_6410.graphics.f("#000000").s().p("EgpRADtQgcgUAAgjQAAgcARgSQASgTAdgGQgMgGgIgKQgHgJAAgMQAAgbAjgVQgXgKgOgUQgNgTAAgcQAAgpAagYQAZgZAsAAQAbAAAPAFIBWAAIAAARIg4AEQAWAcABAhQAAAogaAXQgcAYgrAAQgSAAgHgCQgPAIgHAKQgJALABALQgBANAKAHQALAFAXAAIAvAAQAsAAAXASQAXASABAjQgBArgiAXQgjAYhAgBQgzAAgcgTgEgpTAC0QAAA4BTAAQBrgBgBhEQAAgYgQgLQgSgLgkAAIgtAAQhKAAAAA7gEgosgBnQgSATgBAhQAAAfAUARQATAQAfAAQAjAAARgQQASgRAAggQABgkgTgQQgTgRghgBQghAAgSATgEg5XAEAIAAmIIAVAAIAFAnIACAAQAbgsA+AAQA3AAAcAkQAdAkAABEQAABCgfAlQgdAlg1AAQg+AAgdgvIgCAAIACCkgEg4ogBdQgWAaAAA7IAAAIQAAA/AVAbQAWAbAwAAQApAAAXgfQAWgfAAg3QAAh3hVAAQgwAAgWAagEhCTADIQAThDAJg6IAdAAIADAFQgTBDgYA1gEBcaAB3QgXgVAAgkQAAgoAhgVQAigWA+gBIAzgBIAAgSQAAgogPgTQgPgTgkAAQglAAgoAVIgJgWQAsgUArAAQAuAAAVAWQAWAXAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgcAAQgoAAgWgUgEBeHgABQg4ACgZAPQgYAPAAAgQAAAaAPANQARAOAbAAQArAAAagYQAYgZAAgsIAAgagEBRTAB5QgagRgPgfQgOgiAAgoQAAhCAgglQAgglA4AAQA4AAAfAlQAgAmABBBQAABBghAmQggAlg5AAQgiAAgdgSgEBROgBYQgZAeABA5QgBA2AZAgQAZAfAsAAQAuAAAYgfQAZggAAg2QAAg3gZggQgZgfgtAAQgtAAgYAfgEBGdAB4QgRgUAAgpIAAitIgoAAIAAgPIAogLIAMg+IAOAAIAABCIBPAAIAAAWIhPAAIAACqQgBAgALAOQALAPAYAAQAWAAASgEIAAAUQgSAGgXAAQgkAAgRgTgEBCFAB6IAAgbQAqAVAsAAQApAAAUgOQAVgNAAgWQAAgVgQgNQgRgOgmgOQgpgNgQgLQgPgKgKgOQgIgNAAgUQAAgeAZgRQAagSAtAAQAtAAAnARIgKAWQgngRgjAAQghABgTAKQgTALAAAUQAAAVAPANQAPANAsAPQAkANARAJQARAMAIANQAIANAAATQAAAjgbAVQgbATg0AAQg2AAgggRgEA1AABmQgigkAAhBQAAg/AhgoQAggnA1AAQAxAAAbAhQAcAhAAA6IAAATIjEAAQABA4AaAdQAZAdAvAAQAYAAASgDQASgDAagLIAAAWQgYALgSADQgVAEgXAAQg6AAghglgEA1VgBeQgYAbgDAwICoAAQAAgvgVgbQgUgaglAAQgnAAgYAZgEAtoAB4QgQgTAAgqIAAitIgpAAIAAgPIApgLIAMg+IAMAAIAABCIBQAAIAAAWIhQAAIAACqQAAAfAMAPQALAPAXAAQAXAAASgEIAAAUQgSAGgYAAQgjAAgSgTgEAnMABmQgigkABhBQAAhAAfgnQAggnA2AAQAwAAAbAhQAcAhAAA6IAAATIjDAAQABA4AZAdQAZAdAxAAQAYAAAQgDQASgDAagLIAAAWQgXALgTADQgVAEgVAAQg7AAghglgEAnhgBeQgXAagEAxICnAAQAAgvgVgbQgTgaglAAQgnAAgYAZgAbrB3QgXgVAAgkQAAgoAigVQAhgWA+gBIAzgBIAAgSQAAgogPgTQgPgTgkAAQglAAgpAVIgJgWQAtgUArAAQAtAAAWAWQAWAYAAAxIAACzIgSAAIgHgrIgBAAQgVAbgWAKQgWALgcAAQgoAAgWgUgAdYgBQg5ACgYAPQgZAPAAAgQAAAZAQAOQARAOAbAAQArAAAZgYQAZgaAAgrIAAgagAYJBmQgigkABhCQgBhCAjgmQAiglA7AAQAjAAAgAMIgGAWQglgMgZAAQgyAAgZAfQgaAfABA5QgBA3AaAeQAZAfAvAAQAkABAggOIAAAXQgaANgqAAQg6AAggglgATwBmQgggkAAhBQAAhBAfgmQAggnA2AAQAwAAAbAhQAcAiAAA5IAAATIjCAAQAAA3AaAeQAZAdAwAAQAYAAAQgDQASgDAagLIAAAWQgWALgUADQgVAEgVAAQg7AAgiglgAUHheQgYAagEAxICnAAQAAgwgVgaQgTgaglAAQgnAAgXAZgAPtB/QgXgMgNgWIgDAAIgHApIgPAAIAAmDIAZAAIgDCfIADAAQAPgYAWgMQAVgLAfAAQA5AAAcAkQAdAkAABEQABBDgfAkQgeAlg3AAQgcAAgYgMgAPdhcQgUAbAABAIAAAEQAAA9AVAbQAVAaAuAAQAsAAAXgfQAWgfAAg5QAAh0hZgBQgvAAgVAbgAIlBmQgigkAAhBQAAhBAhgmQAfgnA2AAQAwAAAcAhQAcAiAAA5IAAATIjEAAQAAA3AaAeQAaAdAvAAQAZAAAQgDQASgDAbgLIAAAWQgWALgVADQgUAEgXAAQg6AAghglgAI6heQgXAagEAxICnAAQAAgwgUgaQgVgagkAAQgnAAgYAZgAgfB6IAAgbQApAVAsAAQApAAAUgOQAVgNAAgWQAAgVgRgNQgPgOgngOQgogNgRgLQgQgLgIgNQgIgNAAgUQAAgeAYgRQAbgSAtAAQArAAAoARIgKAWQgngRgiAAQgiABgTAKQgTALAAAUQAAAUAPAOQAPANArAPQAlANARAJQARAMAIANQAJANAAATQAAAkgcAUQgbATg0AAQg2AAgfgRgAq7B5QgbgRgOgfQgPgiAAgoQAAhDAhgkQAgglA4AAQA4AAAfAlQAgAmAABBQAABCggAlQggAlg5AAQgjAAgcgSgArAhYQgYAfAAA4QgBA3AZAfQAZAfAsAAQAuAAAXgfQAZgfAAg3QAAg4gZgfQgYgfgtAAQgtAAgYAfgAvvB4QgRgTAAgqIAAitIgoAAIAAgPIAogLIAMg+IANAAIAABCIBQAAIAAAWIhQAAIAACqQAAAfALAPQALAPAYAAQAVAAATgEIAAAUQgRAGgYAAQgjAAgSgTgA0OB3QgWgVAAgkQAAgoAhgVQAhgWA/gBIAzgBIAAgSQAAgmgQgVQgPgTgkAAQglAAgoAVIgJgWQAsgUArAAQAuAAAVAWQAWAYAAAxIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgXALgcAAQgnAAgXgUgAyhgBQg4ACgZAPQgYAPAAAgQAAAaAPANQARAOAbAAQArAAAagYQAZgaAAgrIAAgagA4/AoIAAiwIAZAAIAACvQAAApARASQARASAkAAQAwAAAXgYQAXgYgBg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhDAAQhcAAAAhjgA9eBoQgdgjgBhCQABhFAdgmQAeglA4AAQAdAAAVALQAWALARAZIABAAIgBg+IAAhhIAYAAIAAGDIgQAAIgGgpIgCAAQgfAug6AAQg4AAgegjgA9LhXQgXAeABA7QAABzBZAAQAuAAAVgaQAVgbABg9IAAgEQAAg/gWgbQgVgcguAAQgtAAgWAggEgh4AB3QgXgVAAgkQAAgoAhgVQAhgWA/gBIAzgBIAAgSQAAgogPgTQgQgTgjAAQglAAgpAVIgJgWQAsgUAsAAQAtAAAWAWQAVAXAAAyIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgWALgcAAQgoAAgWgUgEggLgABQg5ACgZAPQgYAPAAAgQAAAaAQANQAQAOAcAAQArAAAZgYQAZgZAAgsIAAgagEgz/AB5QgbgRgOgfQgPgiAAgoQAAhDAggkQAgglA4AAQA4AAAgAlQAgAmAABBQgBBCggAlQgfAlg6AAQgjAAgbgSgEg0FgBYQgYAfAAA4QAAA3AZAfQAXAfAtAAQAuAAAYgfQAZgfAAg3QAAg4gZgfQgYgfguAAQgtAAgYAfgEg+HAAoIAAiwIAZAAIAACvQAAAoARATQASASAjAAQAxAAAXgYQAWgYAAg4IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhEAAQhbAAgBhjgEhEPAB4QgRgUAAgpIAAitIgoAAIAAgPIAogLIAMg+IAOAAIAABCIBPAAIAAAWIhPAAIAACqQAAAgALAOQAKAPAYAAQAWAAASgEIAAAUQgRAGgYAAQgkAAgRgTgEhNVABmQgggkgBhBQABhBAggmQAfgnA2AAQAwAAAcAhQAbAhABA6IAAATIjEAAQABA4AZAdQAaAdAvAAQAZAAARgDQASgDAagLIAAAWQgYALgTADQgVAEgWAAQg6AAgiglgEhM/gBeQgXAbgEAwICoAAQAAgvgVgbQgUgaglAAQgmAAgZAZgEhSHABoQgegjAAhCQAAhFAegmQAdglA4AAQAdAAAWALQAWALAQAZIABAAIgBg+IAAhhIAZAAIAAGDIgRAAIgGgpIgCAAQgeAug7AAQg3AAgegjgEhR1gBXQgWAeAAA7QAABzBZAAQAuAAAWgaQAVgbAAg9IAAgEQAAg/gVgbQgVgcgvAAQgtAAgWAggEhfRAB5QgbgRgOgfQgPgiAAgoQAAhCAhglQAfglA5AAQA3AAAgAlQAfAmABBBQAABCghAlQgfAlg5AAQgjAAgcgSgEhfWgBYQgZAeAAA5QAAA3AZAfQAZAfAsAAQAtAAAYgfQAZggAAg2QAAg3gZggQgYgfguAAQgsAAgYAfgEhjaABmQghgkAAhCQAAhCAigmQAiglA7AAQAkAAAgAMIgHAWQgkgMgZAAQgyAAgaAfQgZAfAAA5QAAA3AZAeQAaAfAuAAQAlABAggOIAAAXQgaANgqAAQg6AAghglgEBjkACGIAAiuQgBgqgRgSQgRgTgkAAQgxAAgWAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAagqBEAAQBcAAAABjIAACwgEBaoACGIAAiwQAAgpgPgSQgPgSghAAQgpAAgUAYQgUAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIATAAIAGAlIACAAQALgUAUgLQAVgLAZAAQBAAAASAwIABAAQAOgYAWgMQAVgMAdAAQAsAAAXAXQAWAYAAA0IAACwgEBOTACGIg7i0QgGgTgJgjIgCAAIhMDqIgZAAIhNkOIAaAAIAsCcQAPA7AEAaIACAAQAQg9AFgPIA4ilIAXAAIA1CkQAQA0AGAZIABAAQACgQAShGIApibIAaAAIhKEOgEA/XACGIAAkOIAVAAIACAxIACAAQARgdATgNQATgMAaAAQAUAAARADIgEAYQgSgEgRAAQgiAAgXAdQgWAeAAAtIAACUgEA9kACGIAAkOIAYAAIAAEOgEA7XACGIAAj4IgyAAIAAgPIAygJIAAgVQAAgyASgXQASgYArAAQAUAAAYAIIgGAVQgTgHgUAAQgdAAgMARQgMASAAAmIAAAZIBAAAIAAAWIhAAAIAAD4gEAy+ACGIAAiuQAAgqgRgSQgRgTgkAAQgxAAgWAZQgXAYAAA4IAACUIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAWgLAkAAQBcAAgBBjIAACwgEAlKACGIAAiwQAAgogQgTQgPgSggAAQgpAAgVAYQgTAXgBAwIAACeIgZAAIAAi4QAAhFg/AAQgqAAgUAZQgTAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAMgUATgLQAVgLAZAAQBAAAASAwIABAAQANgYAXgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwgAGjCGIAAiuQAAgpgRgTQgRgTgkAAQgxAAgWAZQgXAYAAA4IAACUIgZAAIAAmDIAZAAIgCCeIACAAQAQgZAXgKQAWgLAjAAQBcAAAABjIAACwgAj7CGIAAiuQAAgpgSgTQgQgTglAAQgxAAgWAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBDAAQBcAAAABjIAACwgAtWCGIAAkOIAZAAIAAEOgEglAACGIAAkOIAUAAIADAxIACAAQAQgdATgNQAUgMAbAAQASAAASADIgFAYQgSgEgRAAQgiAAgWAdQgXAeAAAtIAACUgEgtAACGIAAiuQAAgqgRgSQgRgTgkAAQgxAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAlIACAAQAZgqBEAAQBdAAAABjIAACwgEhGRACGIAAiuQAAgqgRgSQgRgTglAAQgwAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIABAAQAbgqBEAAQBbAAABBjIAACwgEhUIACGIAAkOIAYAAIAAEOgEhWVACGIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQATgYApAAQAVAAAYAIIgGAVQgTgHgUAAQgeAAgMARQgLASAAAmIAAAZIA/AAIAAAWIg/AAIAAD4gEhYSACGIAAiuQAAgpgRgTQgRgTgkAAQgwAAgXAZQgXAYABA4IAACUIgaAAIAAkOIAVAAIAGAlIABAAQAagqBEAAQBcAAAABjIAACwgEA9ggDTQAAgYAQAAQAIAAAEAGQAEAHABALQgBALgEAGQgEAHgIAAQgQAAAAgYgAtZjTQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYgEhUMgDTQAAgYAQAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgQAAAAgYg");
	this.shape_6410.setTransform(361.2,571.3,0.5,0.5);

	this.shape_6411 = new cjs.Shape();
	this.shape_6411.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAeglA3AAQAdAAAVALQAWAMAQAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgGgpIgDAAQgeAug6AAQg3AAgegjgAhBgeQgXAeABA7QAABzBYAAQAuAAAVgaQAVgbAAg9IAAgFQAAg+gVgbQgVgbguAAQgsAAgWAfg");
	this.shape_6411.setTransform(673.2,530.1,0.5,0.5);

	this.shape_6412 = new cjs.Shape();
	this.shape_6412.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_6412.setTransform(658.5,532.8,0.5,0.5);

	this.shape_6413 = new cjs.Shape();
	this.shape_6413.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6413.setTransform(643.7,532.9,0.5,0.5);

	this.shape_6414 = new cjs.Shape();
	this.shape_6414.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA1AAQAwAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AZAeQAaAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgXALgUACQgUAEgWAAQg6AAgigkgAg2hcQgZAagDAxICmAAQAAgxgVgZQgUgbgkABQgmgBgXAag");
	this.shape_6414.setTransform(623.8,532.9,0.5,0.5);

	this.shape_6415 = new cjs.Shape();
	this.shape_6415.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6415.setTransform(613.9,530,0.5,0.5);

	this.shape_6416 = new cjs.Shape();
	this.shape_6416.graphics.f("#000000").s().p("Ag0C4QgXgLgOgXIgCAAIgHApIgQAAIAAmCIAZAAIgBCfIABAAQAQgZAVgLQAWgMAeAAQA5AAAdAkQAdAkAABDQAABEgfAkQgeAlg2AAQgdAAgXgMgAhEgiQgVAcAAA9IAAAFQAAA9AWAbQAWAaAtAAQAsAAAWgfQAWgfAAg5QAAh0hYAAQgvAAgVAbg");
	this.shape_6416.setTransform(603.8,530.1,0.5,0.5);

	this.shape_6417 = new cjs.Shape();
	this.shape_6417.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6417.setTransform(588.6,532.9,0.5,0.5);

	this.shape_6418 = new cjs.Shape();
	this.shape_6418.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_6418.setTransform(575.1,535.9,0.5,0.5);

	this.shape_6419 = new cjs.Shape();
	this.shape_6419.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6419.setTransform(560,532.9,0.5,0.5);

	this.shape_6420 = new cjs.Shape();
	this.shape_6420.graphics.f("#000000").s().p("AhZCKQgsgyAAhYQAAg4AVgqQAVgqAngXQAngXA0AAQA2AAApAUIgKAXQgogUgsAAQhDAAgnAsQgoArAABMQAABNAlAsQAmArBDAAQAvAAAmgMIAAAWQglANg2AAQhLAAgsgxg");
	this.shape_6420.setTransform(546.1,530.6,0.5,0.5);

	this.shape_6421 = new cjs.Shape();
	this.shape_6421.graphics.f("#000000").s().p("AgTAAQAAgXATgBQAUABAAAXQAAAYgUAAQgTAAAAgYg");
	this.shape_6421.setTransform(528.2,538.7,0.5,0.5);

	this.shape_6422 = new cjs.Shape();
	this.shape_6422.graphics.f("#000000").s().p("AhzCmIAAgYQAUAKAbAHQAaAGAXAAQA3AAAbgWQAbgWAAgpQAAgkgcgUQgcgTg2AAIgnAAIAAgXIAnAAQAsAAAbgVQAbgWAAglQAAgegVgSQgWgTgjAAQgaAAgWAIQgVAGgeAUIgMgRQAUgRAfgLQAegKAeAAQAyAAAbAYQAbAXABAsQgBAigUAXQgXAXgjAGIAAACQAsAGAXAVQAXAXAAAlQAAAzgjAcQgjAchAAAQg3AAgqgVg");
	this.shape_6422.setTransform(517.5,530.6,0.5,0.5);

	this.shape_6423 = new cjs.Shape();
	this.shape_6423.graphics.f("#000000").s().p("AhGCzQgYgFgRgLIAAgZQAdAPATAEQAWAFAXAAQAuABAdgaQAdgZAAgrQAAgpgcgXQgcgWgvAAQgiAAgiAJIgPgJIAOimICvAAIAAAXIiXAAIgLCAQAogGAUAAQA6AAAhAcQAhAbAAAxQAAA4giAfQgjAfg8AAQgaAAgagFg");
	this.shape_6423.setTransform(503.4,530.7,0.5,0.5);

	this.shape_6424 = new cjs.Shape();
	this.shape_6424.graphics.f("#000000").s().p("AhdC1IAAgWQAJAEARACIAYABQA8AAAjgsQAjgtAEhTIgEAAQgRAXgaANQgYAMgbAAQgzAAgcgcQgcgbAAgzQAAg4AfggQAfgjAxABQAiAAAcASQAbATAPAkQAOAkAAAzQAABHgTAvQgSAxglAXQgkAXgyAAQgXAAgZgGgAhCiKQgXAbAAAtQAAAsAWAWQAVAVApAAQAYABAWgLQAVgLAOgSQAMgTAAgTQAAgegLgZQgMgYgVgPQgUgPgbAAQgnAAgYAbg");
	this.shape_6424.setTransform(488.6,530.6,0.5,0.5);

	this.shape_6425 = new cjs.Shape();
	this.shape_6425.graphics.f("#000000").s().p("AAkC2IAAkIQAAglADgmIgIAHIhMA8IgOgSIBihJIAVAAIAAFrg");
	this.shape_6425.setTransform(472.4,530.6,0.5,0.5);

	this.shape_6426 = new cjs.Shape();
	this.shape_6426.graphics.f("#000000").s().p("ABTCKIAAiuQAAgpgSgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAVAAIAEAlIACAAQAbgqBBAAQBcAAAABjIAACwg");
	this.shape_6426.setTransform(452.8,532.8,0.5,0.5);

	this.shape_6427 = new cjs.Shape();
	this.shape_6427.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6427.setTransform(442.4,530.5,0.5,0.5);

	this.shape_6428 = new cjs.Shape();
	this.shape_6428.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgOABgVQAAgVgRgNQgQgPgmgNQgogOgRgKQgPgLgJgOQgIgNAAgTQgBgeAagSQAagSAtAAQAsAAAnARIgJAXQgogRgiAAQghAAgTALQgTAKAAAUQAAAVAOANQAPANAsAPQAjANASAKQAQALAIAOQAJAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_6428.setTransform(426.8,532.9,0.5,0.5);

	this.shape_6429 = new cjs.Shape();
	this.shape_6429.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_6429.setTransform(416.5,531.4,0.5,0.5);

	this.shape_6430 = new cjs.Shape();
	this.shape_6430.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6430.setTransform(408.4,532.8,0.5,0.5);

	this.shape_6431 = new cjs.Shape();
	this.shape_6431.graphics.f("#000000").s().p("AB9C3IgziBIiTAAIgzCBIgcAAICSltIAPAAICQFtgAgNhjIgzCCICBAAIgxiCQgHgOgIgdQgGAZgIASg");
	this.shape_6431.setTransform(394.9,530.6,0.5,0.5);

	this.shape_6432 = new cjs.Shape();
	this.shape_6432.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAhAAfgmQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA5AZAdQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6432.setTransform(373.6,532.9,0.5,0.5);

	this.shape_6433 = new cjs.Shape();
	this.shape_6433.graphics.f("#000000").s().p("ABSCKIAAiuQAAgpgRgTQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAlIACAAQAagqBCAAQBdAAAABjIAACwg");
	this.shape_6433.setTransform(359.1,532.8,0.5,0.5);

	this.shape_6434 = new cjs.Shape();
	this.shape_6434.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_6434.setTransform(348.7,530.5,0.5,0.5);

	this.shape_6435 = new cjs.Shape();
	this.shape_6435.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIitAAIAACbICjAAIAAAWIijAAIAACjg");
	this.shape_6435.setTransform(340.5,530.6,0.5,0.5);

	this.shape_6436 = new cjs.Shape();
	this.shape_6436.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgxATgYQARgXAqAAQAVAAAXAHIgFAVQgUgGgUAAQgdAAgMARQgKARgBAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6436.setTransform(323.4,529.9,0.5,0.5);

	this.shape_6437 = new cjs.Shape();
	this.shape_6437.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6437.setTransform(311.2,532.9,0.5,0.5);

	this.shape_6438 = new cjs.Shape();
	this.shape_6438.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgTAYQgUAWAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAlIACAAQALgUAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_6438.setTransform(286,532.8,0.5,0.5);

	this.shape_6439 = new cjs.Shape();
	this.shape_6439.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAApARASQARASAkAAQAwAAAWgYQAXgXAAg5IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_6439.setTransform(267,533.1,0.5,0.5);

	this.shape_6440 = new cjs.Shape();
	this.shape_6440.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQATgEAZgLIAAAXQgWALgUACQgVAEgVAAQg6AAgigkgAg2hcQgYAbgEAwICmAAQAAgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_6440.setTransform(252.6,532.9,0.5,0.5);

	this.shape_6441 = new cjs.Shape();
	this.shape_6441.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgNQgQgPgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_6441.setTransform(239.6,532.9,0.5,0.5);

	this.shape_6442 = new cjs.Shape();
	this.shape_6442.graphics.f("#000000").s().p("AhpAnIAAiwIAYAAIAACvQAAAoARATQARASAkAAQAvAAAXgYQAXgYAAg4IAAiUIAZAAIAAEOIgWAAIgEgmIgBAAQgbArhDAAQhcAAABhjg");
	this.shape_6442.setTransform(226.1,533.1,0.5,0.5);

	this.shape_6443 = new cjs.Shape();
	this.shape_6443.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgPAAIiIlQIgCAAIACBAIAAEQIgYAAIAAlrIAnAAICAE/IACAAICAk/IAmAAIAAFrg");
	this.shape_6443.setTransform(207.7,530.6,0.5,0.5);

	this.shape_6444 = new cjs.Shape();
	this.shape_6444.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAg/AhgnQAggoA0AAQAxAAAbAiQAbAhABA5IAAATIjDAAQABA5AaAdQAZAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgWAEgWAAQg5AAghgkgAg3hcQgWAagFAxICnAAQAAgwgVgaQgUgbglABQgmgBgYAag");
	this.shape_6444.setTransform(183.1,532.9,0.5,0.5);

	this.shape_6445 = new cjs.Shape();
	this.shape_6445.graphics.f("#000000").s().p("ABTDCIAAiwQgBgngRgTQgRgTgkAAQgvAAgXAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQARgZAWgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_6445.setTransform(168.6,530,0.5,0.5);

	this.shape_6446 = new cjs.Shape();
	this.shape_6446.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_6446.setTransform(156.6,531.4,0.5,0.5);

	this.shape_6447 = new cjs.Shape();
	this.shape_6447.graphics.f("#000000").s().p("AgkDDIAAj4IgxAAIAAgPIAxgJIAAgVQAAgyATgXQARgXAqAAQAVAAAYAHIgGAVQgUgGgTAAQgdAAgNARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6447.setTransform(142.9,529.9,0.5,0.5);

	this.shape_6448 = new cjs.Shape();
	this.shape_6448.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABBggAmQggAlg4AAQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6448.setTransform(130.7,532.9,0.5,0.5);

	this.shape_6449 = new cjs.Shape();
	this.shape_6449.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6449.setTransform(113.8,530,0.5,0.5);

	this.shape_6450 = new cjs.Shape();
	this.shape_6450.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhglQAggkA3gBQA3AAAgAmQAgAmAABAQAABCghAlQgfAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA3AZAgQAZAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_6450.setTransform(103.4,532.9,0.5,0.5);

	this.shape_6451 = new cjs.Shape();
	this.shape_6451.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6451.setTransform(88.5,532.9,0.5,0.5);

	this.shape_6452 = new cjs.Shape();
	this.shape_6452.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTglAAQgvAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAPgZAYgKQAWgLAjAAQBcAAgBBiIAACxg");
	this.shape_6452.setTransform(73.6,530,0.5,0.5);

	this.shape_6453 = new cjs.Shape();
	this.shape_6453.graphics.f("#000000").s().p("AhABnQgggkAAhCQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgkgLgZAAQgxAAgaAeQgaAfAAA5QAAA4AaAeQAaAfAtAAQAlAAAfgOIAAAXQgaANgqAAQg5AAghglg");
	this.shape_6453.setTransform(60.2,532.9,0.5,0.5);

	this.shape_6454 = new cjs.Shape();
	this.shape_6454.graphics.f("#000000").s().p("AhvCsIAAgZQAmARA+AAQArAAAbgVQAagVAAghQAAgUgIgOQgJgNgUgMQgTgLgmgNQg2gSgXgWQgVgXAAglQAAgpAggZQAfgaAyAAQA0AAAsATIgJAWQgugTgoAAQgoAAgXATQgZATAAAgQABAUAHANQAIANAQAKQASALAmAOQAsAOAUANQAWAPAJARQALARAAAZQAAAugiAaQghAbg3AAQhDAAgjgPg");
	this.shape_6454.setTransform(47,530.6,0.5,0.5);

	this.shape_6455 = new cjs.Shape();
	this.shape_6455.graphics.f("#000000").s().p("AhMBoQgiglABhBQAAg/AfgnQAhgoA1AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQAAA5AaAdQAZAdAvAAQAZAAAPgDQATgEAagLIAAAXQgYALgSACQgWAEgVAAQg6AAghgkgAg2hcQgXAZgFAyICmAAQAAgwgUgaQgUgbgkABQgngBgXAag");
	this.shape_6455.setTransform(676.8,494.7,0.5,0.5);

	this.shape_6456 = new cjs.Shape();
	this.shape_6456.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_6456.setTransform(662.3,491.8,0.5,0.5);

	this.shape_6457 = new cjs.Shape();
	this.shape_6457.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_6457.setTransform(650.3,493.2,0.5,0.5);

	this.shape_6458 = new cjs.Shape();
	this.shape_6458.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6458.setTransform(635.1,493.2,0.5,0.5);

	this.shape_6459 = new cjs.Shape();
	this.shape_6459.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6459.setTransform(623.8,494.7,0.5,0.5);

	this.shape_6460 = new cjs.Shape();
	this.shape_6460.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgFAIgOQAJgOAJgZIAOgkIhokOIAZAAIA5CYQAbBFAGAZIABAAQALggAXg/IA5iXIAaAAIh4E6QgOAkgLAQQgJAMgOAIQgOAHgSAAQgOAAgSgGg");
	this.shape_6460.setTransform(605.1,497.7,0.5,0.5);

	this.shape_6461 = new cjs.Shape();
	this.shape_6461.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6461.setTransform(591.2,491.9,0.5,0.5);

	this.shape_6462 = new cjs.Shape();
	this.shape_6462.graphics.f("#000000").s().p("AhqAnIAAiwIAYAAIAACvQAAAoASATQASASAjAAQAwAAAXgYQAWgYAAg4IAAiUIAYAAIAAEOIgUAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_6462.setTransform(576.4,494.8,0.5,0.5);

	this.shape_6463 = new cjs.Shape();
	this.shape_6463.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6463.setTransform(564.5,493.2,0.5,0.5);

	this.shape_6464 = new cjs.Shape();
	this.shape_6464.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgNQgPgOgngOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAKAAAUQAAAVAPANQAQANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyAAQg2AAgggQg");
	this.shape_6464.setTransform(554.4,494.7,0.5,0.5);

	this.shape_6465 = new cjs.Shape();
	this.shape_6465.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6465.setTransform(534.5,494.7,0.5,0.5);

	this.shape_6466 = new cjs.Shape();
	this.shape_6466.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_6466.setTransform(522.5,493.2,0.5,0.5);

	this.shape_6467 = new cjs.Shape();
	this.shape_6467.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgzCBIgcAAICTltIAPAAICPFtgAgNhjIgzCCICCAAIgyiCQgHgOgIgdQgGAZgIASg");
	this.shape_6467.setTransform(504.2,492.3,0.5,0.5);

	this.shape_6468 = new cjs.Shape();
	this.shape_6468.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlQIgCAAIACBAIAAEQIgZAAIAAlrIAoAAICAE/IABAAICCk/IAmAAIAAFrg");
	this.shape_6468.setTransform(485.5,492.4,0.5,0.5);

	this.shape_6469 = new cjs.Shape();
	this.shape_6469.graphics.f("#000000").s().p("AgdA/QAThEAIg4IAdAAIADAFQgTBAgYA3g");
	this.shape_6469.setTransform(464.8,501.6,0.5,0.5);

	this.shape_6470 = new cjs.Shape();
	this.shape_6470.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTgkAAQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAagrBEAAQBcAAgBBjIAACwg");
	this.shape_6470.setTransform(455,494.6,0.5,0.5);

	this.shape_6471 = new cjs.Shape();
	this.shape_6471.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABBggAmQggAlg4AAQgjAAgcgRgAhFhXQgYAgAAA3QAAA3AZAgQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgZgegsAAQgtAAgYAeg");
	this.shape_6471.setTransform(439.9,494.7,0.5,0.5);

	this.shape_6472 = new cjs.Shape();
	this.shape_6472.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_6472.setTransform(428,493.2,0.5,0.5);

	this.shape_6473 = new cjs.Shape();
	this.shape_6473.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgNQgQgPgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_6473.setTransform(417.9,494.7,0.5,0.5);

	this.shape_6474 = new cjs.Shape();
	this.shape_6474.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA4AAAfAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_6474.setTransform(404.5,494.7,0.5,0.5);

	this.shape_6475 = new cjs.Shape();
	this.shape_6475.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBCAAAgAXQAgAXAAAuQAAAggUAUQgTAWglAFIAAACQAsAHAUATQAVAWAAAmQAAAxgiAbQghAcg8AAgAheCfIBWAAQBkAAAAhRQAAhMhpABIhRAAgAhegTIBRAAQAxAAAYgRQAXgRAAglQAAgkgagRQgagQgzAAIhKAAg");
	this.shape_6475.setTransform(389.7,492.4,0.5,0.5);

	this.shape_6476 = new cjs.Shape();
	this.shape_6476.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhFhXQgYAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgZAeg");
	this.shape_6476.setTransform(367,494.7,0.5,0.5);

	this.shape_6477 = new cjs.Shape();
	this.shape_6477.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6477.setTransform(355.1,493.2,0.5,0.5);

	this.shape_6478 = new cjs.Shape();
	this.shape_6478.graphics.f("#000000").s().p("AhMBoQghglAAhBQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgWALgVACQgVAEgVAAQg6AAghgkgAg2hcQgYAZgEAyICmAAQAAgxgUgZQgUgbglABQgmgBgXAag");
	this.shape_6478.setTransform(337.4,494.7,0.5,0.5);

	this.shape_6479 = new cjs.Shape();
	this.shape_6479.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgUAYQgTAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_6479.setTransform(319.2,494.6,0.5,0.5);

	this.shape_6480 = new cjs.Shape();
	this.shape_6480.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6480.setTransform(305,492.2,0.5,0.5);

	this.shape_6481 = new cjs.Shape();
	this.shape_6481.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6481.setTransform(297.6,493.2,0.5,0.5);

	this.shape_6482 = new cjs.Shape();
	this.shape_6482.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsAAQAngBAVgNQAVgOAAgVQAAgVgRgNQgQgPgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyAAQg2AAgggQg");
	this.shape_6482.setTransform(280.9,494.7,0.5,0.5);

	this.shape_6483 = new cjs.Shape();
	this.shape_6483.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_6483.setTransform(272.2,492.2,0.5,0.5);

	this.shape_6484 = new cjs.Shape();
	this.shape_6484.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAjAAQBbAAABBiIAACxg");
	this.shape_6484.setTransform(261.8,491.8,0.5,0.5);

	this.shape_6485 = new cjs.Shape();
	this.shape_6485.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6485.setTransform(249.8,493.2,0.5,0.5);

	this.shape_6486 = new cjs.Shape();
	this.shape_6486.graphics.f("#000000").s().p("AgdA/QAThCAIg6IAdAAIADAFQgSBAgYA3g");
	this.shape_6486.setTransform(235.9,501.6,0.5,0.5);

	this.shape_6487 = new cjs.Shape();
	this.shape_6487.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhGAeglQAdglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgegjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAXgaQAVgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_6487.setTransform(225.6,491.9,0.5,0.5);

	this.shape_6488 = new cjs.Shape();
	this.shape_6488.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAhAAfgmQAggoA2AAQAvAAAbAiQAcAiAAA4IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgWALgUACQgVAEgVAAQg6AAgigkgAg2hcQgYAagEAxICmAAQAAgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_6488.setTransform(211.4,494.7,0.5,0.5);

	this.shape_6489 = new cjs.Shape();
	this.shape_6489.graphics.f("#000000").s().p("AgMCHIhokNIAZAAIBGC2QAOAlAHAZIABAAQAKgjALgbIBGi2IAZAAIhoENg");
	this.shape_6489.setTransform(198.6,494.7,0.5,0.5);

	this.shape_6490 = new cjs.Shape();
	this.shape_6490.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhBAggmQAhgkA3gBQA3AAAgAmQAgAmAABAQAABCggAlQggAlg4AAQgjAAgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg4gZgfQgYgegtAAQgsAAgYAeg");
	this.shape_6490.setTransform(185.2,494.7,0.5,0.5);

	this.shape_6491 = new cjs.Shape();
	this.shape_6491.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgqAAgTAYQgUAWAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAASAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_6491.setTransform(166.6,494.6,0.5,0.5);

	this.shape_6492 = new cjs.Shape();
	this.shape_6492.graphics.f("#000000").s().p("AhMBoQgiglAAhBQAAhAAhgmQAfgoA1AAQAwAAAcAiQAcAiAAA4IAAATIjDAAQAAA4AbAeQAZAdAuAAQAZAAAQgDQASgEAbgLIAAAXQgXALgTACQgWAEgWAAQg5AAghgkgAg3hcQgXAagEAxICmAAQAAgwgUgaQgVgbgkABQgmgBgYAag");
	this.shape_6492.setTransform(141.7,494.7,0.5,0.5);

	this.shape_6493 = new cjs.Shape();
	this.shape_6493.graphics.f("#000000").s().p("ABSDCIAAiwQAAgogRgSQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgCCeIACAAQAPgZAYgKQAWgLAiAAQBdAAgBBiIAACxg");
	this.shape_6493.setTransform(127.2,491.8,0.5,0.5);

	this.shape_6494 = new cjs.Shape();
	this.shape_6494.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtAAQAngBAVgNQAUgNABgWQgBgVgQgNQgQgPgmgNQgogOgRgKQgPgLgJgOQgJgNABgTQAAgeAZgSQAagSAsAAQAtAAAnARIgJAXQgogRgjAAQggAAgTALQgTAKgBAUQAAAVAPANQAPANAsAPQAjANASAKQAPALAKAOQAIAMAAATQAAAkgcAUQgbATgyAAQg3AAgfgQg");
	this.shape_6494.setTransform(113.6,494.7,0.5,0.5);

	this.shape_6495 = new cjs.Shape();
	this.shape_6495.graphics.f("#000000").s().p("ABSCKIAAiuQAAgqgRgSQgRgTglAAQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAagrBDAAQBdAAAABjIAACwg");
	this.shape_6495.setTransform(93.7,494.6,0.5,0.5);

	this.shape_6496 = new cjs.Shape();
	this.shape_6496.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6496.setTransform(83.2,492.2,0.5,0.5);

	this.shape_6497 = new cjs.Shape();
	this.shape_6497.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6497.setTransform(73.1,494.7,0.5,0.5);

	this.shape_6498 = new cjs.Shape();
	this.shape_6498.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgJAAgNQAAgaAigUQgXgKgNgVQgOgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgNAHgJALQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgigSgSQgTgRggAAQghAAgSATg");
	this.shape_6498.setTransform(60.1,497.6,0.5,0.5);

	this.shape_6499 = new cjs.Shape();
	this.shape_6499.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6499.setTransform(46.2,494.7,0.5,0.5);

	this.shape_6500 = new cjs.Shape();
	this.shape_6500.graphics.f("#000000").s().p("AhNBoQggglAAhBQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVABQg6AAgiglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6500.setTransform(689.3,456.4,0.5,0.5);

	this.shape_6501 = new cjs.Shape();
	this.shape_6501.graphics.f("#000000").s().p("Ag/BnQghgjAAhDQAAhBAigmQAigmA6AAQAkAAAfANIgGAVQgkgLgZAAQgxAAgaAeQgZAgAAA4QAAA4AZAeQAaAfAtAAQAlAAAfgNIAAAWQgaAOgqAAQg5AAgggmg");
	this.shape_6501.setTransform(676.5,456.4,0.5,0.5);

	this.shape_6502 = new cjs.Shape();
	this.shape_6502.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_6502.setTransform(662.7,456.3,0.5,0.5);

	this.shape_6503 = new cjs.Shape();
	this.shape_6503.graphics.f("#000000").s().p("Ah3CJQgrgyAAhXQAAhWAsgzQArgxBLAAQBMAAAsAxQArAzAABWQAABXgsAyQgrAzhMAAQhLAAgsgzgAhjh4QgjArAABNQAABPAjApQAiArBBABQBCAAAigrQAjgqAAhPQAAhOgjgqQgigqhCAAQg/AAgkAqg");
	this.shape_6503.setTransform(645.4,454.1,0.5,0.5);

	this.shape_6504 = new cjs.Shape();
	this.shape_6504.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6504.setTransform(626,462.2,0.5,0.5);

	this.shape_6505 = new cjs.Shape();
	this.shape_6505.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgKAAgMQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigTgSQgRgRghAAQghAAgSATg");
	this.shape_6505.setTransform(616.3,459.4,0.5,0.5);

	this.shape_6506 = new cjs.Shape();
	this.shape_6506.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAagrBDAAQBdAAAABjIAACwg");
	this.shape_6506.setTransform(602.2,456.3,0.5,0.5);

	this.shape_6507 = new cjs.Shape();
	this.shape_6507.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6507.setTransform(591.7,454,0.5,0.5);

	this.shape_6508 = new cjs.Shape();
	this.shape_6508.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_6508.setTransform(584.3,454.9,0.5,0.5);

	this.shape_6509 = new cjs.Shape();
	this.shape_6509.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_6509.setTransform(572.8,456.3,0.5,0.5);

	this.shape_6510 = new cjs.Shape();
	this.shape_6510.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_6510.setTransform(562.3,454,0.5,0.5);

	this.shape_6511 = new cjs.Shape();
	this.shape_6511.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6511.setTransform(552.2,456.4,0.5,0.5);

	this.shape_6512 = new cjs.Shape();
	this.shape_6512.graphics.f("#000000").s().p("AhxDHIAAmIIAUAAIAFAnIACAAQAbgsA9AAQA3AAAcAkQAdAjAABFQAABCgeAlQgeAlg1AAQg9AAgdgvIgCAAIACCkgAhDiWQgWAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgfAAg3QAAh3hWAAQguAAgXAag");
	this.shape_6512.setTransform(538.7,459.4,0.5,0.5);

	this.shape_6513 = new cjs.Shape();
	this.shape_6513.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAXALAQAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6513.setTransform(516.1,453.6,0.5,0.5);

	this.shape_6514 = new cjs.Shape();
	this.shape_6514.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAg/AfgnQAhgoA1AAQAwAAAbAiQAbAhAAA5IAAATIjBAAQABA4AZAeQAZAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgSACQgWAEgVABQg6AAghglgAg2hcQgYAbgEAwICnAAQgBgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_6514.setTransform(502,456.4,0.5,0.5);

	this.shape_6515 = new cjs.Shape();
	this.shape_6515.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAGAAAMQAAAMgEAFQgFAHgHAAQgPAAAAgYg");
	this.shape_6515.setTransform(492.1,454,0.5,0.5);

	this.shape_6516 = new cjs.Shape();
	this.shape_6516.graphics.f("#000000").s().p("AhTChQgegiAAhDQAAhGAdglQAeglA2AAQAeAAAWALQAVALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQggAug5AAQg3AAgdgjgAhBgeQgWAegBA7QAABzBZAAQAtAAAXgaQAVgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_6516.setTransform(481.2,453.6,0.5,0.5);

	this.shape_6517 = new cjs.Shape();
	this.shape_6517.graphics.f("#000000").s().p("AhqAnIAAiwIAZAAIAACvQAAAoARATQASASAjABQAwAAAWgZQAXgXAAg5IAAiUIAZAAIAAEOIgVAAIgFgmIgBAAQgbArhCAAQhdAAAAhjg");
	this.shape_6517.setTransform(466.4,456.6,0.5,0.5);

	this.shape_6518 = new cjs.Shape();
	this.shape_6518.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgnAAIAAgOIAngLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQABAfAJAPQAMAPAXAAQAWAAATgEIAAAUQgTAGgXAAQgiAAgSgUg");
	this.shape_6518.setTransform(454.5,454.9,0.5,0.5);

	this.shape_6519 = new cjs.Shape();
	this.shape_6519.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgNgBgWQAAgVgQgNQgQgOgmgOQgogOgQgKQgRgMgIgNQgJgMAAgUQAAgeAagSQAagSAsAAQAsAAAnARIgJAXQgngRgjAAQggAAgTALQgUAKAAAUQABAVAPANQAOANArAPQAjANATAKQAQALAJAOQAIAMAAATQAAAkgbAUQgcATgyABQg3AAgfgRg");
	this.shape_6519.setTransform(444.4,456.4,0.5,0.5);

	this.shape_6520 = new cjs.Shape();
	this.shape_6520.graphics.f("#000000").s().p("AgdA/QAUhIAIg0IAcAAIADAFQgTBAgYA3g");
	this.shape_6520.setTransform(428.8,463.4,0.5,0.5);

	this.shape_6521 = new cjs.Shape();
	this.shape_6521.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQABA4AZAeQAaAdAuAAQAZAAAQgDQATgEAagLIAAAXQgXALgUACQgUAEgXABQg5AAgiglgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgUgbgkABQgngBgXAag");
	this.shape_6521.setTransform(419.5,456.4,0.5,0.5);

	this.shape_6522 = new cjs.Shape();
	this.shape_6522.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6522.setTransform(408.4,456.3,0.5,0.5);

	this.shape_6523 = new cjs.Shape();
	this.shape_6523.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6523.setTransform(395.5,456.4,0.5,0.5);

	this.shape_6524 = new cjs.Shape();
	this.shape_6524.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_6524.setTransform(381.1,453.5,0.5,0.5);

	this.shape_6525 = new cjs.Shape();
	this.shape_6525.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgjAAgRgUg");
	this.shape_6525.setTransform(369,454.9,0.5,0.5);

	this.shape_6526 = new cjs.Shape();
	this.shape_6526.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6526.setTransform(351.3,456.4,0.5,0.5);

	this.shape_6527 = new cjs.Shape();
	this.shape_6527.graphics.f("#000000").s().p("AgMDCIAAmDIAZAAIAAGDg");
	this.shape_6527.setTransform(341.5,453.5,0.5,0.5);

	this.shape_6528 = new cjs.Shape();
	this.shape_6528.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAEAGQAFAHAAALQAAALgFAGQgEAHgHAAQgPAAAAgYg");
	this.shape_6528.setTransform(335.7,454,0.5,0.5);

	this.shape_6529 = new cjs.Shape();
	this.shape_6529.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgwAAgXAZQgWAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIACAAQAQgZAWgKQAXgLAhAAQBdAAAABiIAACxg");
	this.shape_6529.setTransform(325.4,453.5,0.5,0.5);

	this.shape_6530 = new cjs.Shape();
	this.shape_6530.graphics.f("#000000").s().p("ABNCIIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQAOg7AHgSIA4ikIAVAAIA1CjQAQA1AGAZIACAAQABgOAThJIApiaIAZAAIhKEOg");
	this.shape_6530.setTransform(308.5,456.4,0.5,0.5);

	this.shape_6531 = new cjs.Shape();
	this.shape_6531.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6531.setTransform(284.7,453.6,0.5,0.5);

	this.shape_6532 = new cjs.Shape();
	this.shape_6532.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAVAAIAEAmIACAAQAZgrBDAAQBdAAgBBjIAACwg");
	this.shape_6532.setTransform(270.1,456.3,0.5,0.5);

	this.shape_6533 = new cjs.Shape();
	this.shape_6533.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gCIAzgBIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgWALgbAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6533.setTransform(255.3,456.4,0.5,0.5);

	this.shape_6534 = new cjs.Shape();
	this.shape_6534.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6534.setTransform(235.1,456.4,0.5,0.5);

	this.shape_6535 = new cjs.Shape();
	this.shape_6535.graphics.f("#000000").s().p("AhUChQgdgiAAhDQAAhGAdglQAdglA4AAQAdAAAVALQAXAMAPAZIACAAIgCg+IAAhhIAZAAIAAGCIgQAAIgGgpIgDAAQgeAug6AAQg3AAgegjgAhBgeQgWAeAAA7QgBBzBZAAQAtAAAWgaQAWgbgBg9IAAgFQABg+gWgbQgUgbgvAAQgsAAgWAfg");
	this.shape_6535.setTransform(220.9,453.6,0.5,0.5);

	this.shape_6536 = new cjs.Shape();
	this.shape_6536.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6536.setTransform(206.5,456.4,0.5,0.5);

	this.shape_6537 = new cjs.Shape();
	this.shape_6537.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAagrBEAAQBbAAABBjIAACwg");
	this.shape_6537.setTransform(192.7,456.3,0.5,0.5);

	this.shape_6538 = new cjs.Shape();
	this.shape_6538.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6538.setTransform(177.9,456.4,0.5,0.5);

	this.shape_6539 = new cjs.Shape();
	this.shape_6539.graphics.f("#000000").s().p("AhZCKQgsgyAAhYQAAg4AVgqQAVgqAngXQAngXA0AAQA2AAApAUIgKAXQgogUgsAAQhDAAgnAsQgoArAABMQAABNAlAsQAmArBDAAQAuAAAngMIAAAWQgmANg1AAQhLAAgsgxg");
	this.shape_6539.setTransform(164.1,454.1,0.5,0.5);

	this.shape_6540 = new cjs.Shape();
	this.shape_6540.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAFQgTBAgYA3g");
	this.shape_6540.setTransform(146,463.4,0.5,0.5);

	this.shape_6541 = new cjs.Shape();
	this.shape_6541.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6541.setTransform(140.8,453.5,0.5,0.5);

	this.shape_6542 = new cjs.Shape();
	this.shape_6542.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6542.setTransform(130.7,456.4,0.5,0.5);

	this.shape_6543 = new cjs.Shape();
	this.shape_6543.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjBAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQASgEAbgLIAAAXQgWALgVACQgUAEgWABQg6AAghglgAg2hcQgYAagEAxICmAAQAAgxgUgZQgUgbglABQgmgBgXAag");
	this.shape_6543.setTransform(117.4,456.4,0.5,0.5);

	this.shape_6544 = new cjs.Shape();
	this.shape_6544.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6544.setTransform(106.3,456.3,0.5,0.5);

	this.shape_6545 = new cjs.Shape();
	this.shape_6545.graphics.f("#000000").s().p("AgRCXQgSgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgYAAQgjAAgQgUg");
	this.shape_6545.setTransform(96,454.9,0.5,0.5);

	this.shape_6546 = new cjs.Shape();
	this.shape_6546.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6546.setTransform(84.5,456.3,0.5,0.5);

	this.shape_6547 = new cjs.Shape();
	this.shape_6547.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_6547.setTransform(69.4,456.4,0.5,0.5);

	this.shape_6548 = new cjs.Shape();
	this.shape_6548.graphics.f("#000000").s().p("ACPC2IAAkTQAAgdADgfIgCAAIiIFPIgQAAIiHlQIgCAAQACAcAAAkIAAEQIgZAAIAAlrIAoAAICAE/IABAAICBk/IAnAAIAAFrg");
	this.shape_6548.setTransform(51,454.1,0.5,0.5);

	this.shape_6549 = new cjs.Shape();
	this.shape_6549.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_6549.setTransform(671.3,418.2,0.5,0.5);

	this.shape_6550 = new cjs.Shape();
	this.shape_6550.graphics.f("#000000").s().p("AgRCXQgRgSAAgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQAKAPAYAAQAWAAATgEIAAAUQgSAGgXAAQgkAAgQgUg");
	this.shape_6550.setTransform(659.4,416.7,0.5,0.5);

	this.shape_6551 = new cjs.Shape();
	this.shape_6551.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6551.setTransform(640.7,415.4,0.5,0.5);

	this.shape_6552 = new cjs.Shape();
	this.shape_6552.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQABA4AYAeQAaAdAvAAQAXAAARgDQATgEAagLIAAAXQgXALgUACQgUAEgWABQg6AAgiglgAg2hcQgZAbgDAwICmAAQAAgwgUgaQgUgbgkABQgmgBgYAag");
	this.shape_6552.setTransform(626.5,418.2,0.5,0.5);

	this.shape_6553 = new cjs.Shape();
	this.shape_6553.graphics.f("#000000").s().p("AgLCIIhpkOIAZAAIBGC2QAPAlAGAZIABAAQAJgfAMgfIBGi2IAZAAIhoEOg");
	this.shape_6553.setTransform(613.7,418.2,0.5,0.5);

	this.shape_6554 = new cjs.Shape();
	this.shape_6554.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6554.setTransform(600.3,418.2,0.5,0.5);

	this.shape_6555 = new cjs.Shape();
	this.shape_6555.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogQgTQgPgSggAAQgpAAgVAYQgUAXAAAwIAACeIgYAAIAAi4QABhFg/AAQgsAAgSAZQgTAZgBA3IAACUIgYAAIAAkOIAUAAIAGAmIABAAQAMgVATgLQAVgLAZAAQBAAAARAwIABAAQAPgYAVgMQAWgMAcAAQAtAAAWAXQAXAYgBA0IAACwg");
	this.shape_6555.setTransform(581.7,418.1,0.5,0.5);

	this.shape_6556 = new cjs.Shape();
	this.shape_6556.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAbAhABA5IAAATIjDAAQABA4AaAeQAZAdAvAAQAXAAASgDQASgEAagLIAAAXQgYALgSACQgWAEgVABQg6AAghglgAg3hcQgYAbgDAwICnAAQgBgwgUgaQgUgbglABQgmgBgYAag");
	this.shape_6556.setTransform(556.7,418.2,0.5,0.5);

	this.shape_6557 = new cjs.Shape();
	this.shape_6557.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIABAAQAQgZAXgKQAXgLAiAAQBcAAgBBiIAACxg");
	this.shape_6557.setTransform(542.3,415.3,0.5,0.5);

	this.shape_6558 = new cjs.Shape();
	this.shape_6558.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgPgOgngOQgogOgQgKQgRgLgIgOQgIgMAAgUQAAgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAKAAAUQAAAVAPANQAQANAqAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg2AAgggRg");
	this.shape_6558.setTransform(528.7,418.2,0.5,0.5);

	this.shape_6559 = new cjs.Shape();
	this.shape_6559.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAFQgTBAgYA3g");
	this.shape_6559.setTransform(513,425.1,0.5,0.5);

	this.shape_6560 = new cjs.Shape();
	this.shape_6560.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgOgmgOQgogOgQgKQgRgLgIgOQgIgMAAgUQgBgeAagSQAagSAtAAQAsAAAnARIgJAXQgogRgiAAQghAAgTALQgTAKAAAUQAAAVAOANQAPANAsAPQAiANATAKQARAMAIANQAIAMAAATQAAAkgcAUQgbATgyABQg3AAgfgRg");
	this.shape_6560.setTransform(504.7,418.2,0.5,0.5);

	this.shape_6561 = new cjs.Shape();
	this.shape_6561.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6561.setTransform(490.8,415.4,0.5,0.5);

	this.shape_6562 = new cjs.Shape();
	this.shape_6562.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6562.setTransform(479.6,418.1,0.5,0.5);

	this.shape_6563 = new cjs.Shape();
	this.shape_6563.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6563.setTransform(466.5,418.2,0.5,0.5);

	this.shape_6564 = new cjs.Shape();
	this.shape_6564.graphics.f("#000000").s().p("ABNCIIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQANg3AIgWIA4ikIAVAAIA1CjQATA+ADAQIACAAQABgOAThJIApiaIAZAAIhKEOg");
	this.shape_6564.setTransform(451,418.2,0.5,0.5);

	this.shape_6565 = new cjs.Shape();
	this.shape_6565.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgTgEgQAAQgiAAgWAdQgWAfAAAsIAACUg");
	this.shape_6565.setTransform(437.7,418.1,0.5,0.5);

	this.shape_6566 = new cjs.Shape();
	this.shape_6566.graphics.f("#000000").s().p("AhNBoQgggkAAhCQAAg/AfgnQAhgoA1AAQAvAAAcAiQAcAhgBA5IAAATIjCAAQACA4AYAeQAaAdAvAAQAZAAAPgDQATgEAagLIAAAXQgXALgUACQgUAEgWABQg6AAgiglgAg2hcQgYAZgEAyICmAAQABgwgVgaQgUgbgkABQgmgBgYAag");
	this.shape_6566.setTransform(424.9,418.2,0.5,0.5);

	this.shape_6567 = new cjs.Shape();
	this.shape_6567.graphics.f("#000000").s().p("AgSCXQgRgTAAgpIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6567.setTransform(413.4,416.7,0.5,0.5);

	this.shape_6568 = new cjs.Shape();
	this.shape_6568.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6568.setTransform(406.4,415.2,0.5,0.5);

	this.shape_6569 = new cjs.Shape();
	this.shape_6569.graphics.f("#000000").s().p("AB8C3IgziBIiSAAIgzCBIgcAAICSltIAQAAICPFtgAgNhjIgzCCICBAAIhAitQgIAcgGAPg");
	this.shape_6569.setTransform(394,415.8,0.5,0.5);

	this.shape_6570 = new cjs.Shape();
	this.shape_6570.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6570.setTransform(376.7,424,0.5,0.5);

	this.shape_6571 = new cjs.Shape();
	this.shape_6571.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAeAKAQQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6571.setTransform(369.2,416.7,0.5,0.5);

	this.shape_6572 = new cjs.Shape();
	this.shape_6572.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6572.setTransform(361.1,418.1,0.5,0.5);

	this.shape_6573 = new cjs.Shape();
	this.shape_6573.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6573.setTransform(348,418.2,0.5,0.5);

	this.shape_6574 = new cjs.Shape();
	this.shape_6574.graphics.f("#000000").s().p("AhTChQgegjAAhCQAAhFAdgmQAeglA3AAQAdAAAWALQAWAMAQAZIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg3AAgdgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6574.setTransform(327.1,415.4,0.5,0.5);

	this.shape_6575 = new cjs.Shape();
	this.shape_6575.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAaAdAvAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6575.setTransform(312.9,418.2,0.5,0.5);

	this.shape_6576 = new cjs.Shape();
	this.shape_6576.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6576.setTransform(303,415.7,0.5,0.5);

	this.shape_6577 = new cjs.Shape();
	this.shape_6577.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhGAdglQAeglA2AAQAeAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgcAAg8IAAgFQAAg+gVgbQgVgbgwAAQgrAAgWAfg");
	this.shape_6577.setTransform(292.2,415.4,0.5,0.5);

	this.shape_6578 = new cjs.Shape();
	this.shape_6578.graphics.f("#000000").s().p("AhpAnIAAiwIAXAAIAACvQABAoARATQARASAkABQAwAAAWgZQAXgYAAg4IAAiUIAYAAIAAEOIgVAAIgEgmIgCAAQgaArhDAAQhcAAABhjg");
	this.shape_6578.setTransform(277.4,418.3,0.5,0.5);

	this.shape_6579 = new cjs.Shape();
	this.shape_6579.graphics.f("#000000").s().p("AgSCXQgRgSAAgqIAAiuIgoAAIAAgOIAogLIANg+IAMAAIAABCIBPAAIAAAVIhPAAIAACrQAAAfAKAPQAMAPAXAAQAWAAATgEIAAAUQgSAGgYAAQgiAAgSgUg");
	this.shape_6579.setTransform(265.5,416.7,0.5,0.5);

	this.shape_6580 = new cjs.Shape();
	this.shape_6580.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgOgmgOQgngOgRgKQgRgLgIgOQgJgMAAgUQABgeAZgSQAagSAsAAQAsAAAnARIgJAXQgngRgjAAQggAAgTALQgUAKABAUQAAAVAPANQAOANArAPQAjANATAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg3AAgfgRg");
	this.shape_6580.setTransform(255.4,418.2,0.5,0.5);

	this.shape_6581 = new cjs.Shape();
	this.shape_6581.graphics.f("#000000").s().p("AhMBoQghgkAAhCQAAg/AfgnQAhgoA0AAQAwAAAcAiQAbAhAAA5IAAATIjCAAQABA4AZAeQAbAdAuAAQAYAAAQgDQATgEAagLIAAAXQgYALgTACQgVAEgVABQg6AAghglgAg2hcQgYAZgEAyICmAAQAAgwgUgaQgUgbglABQgmgBgXAag");
	this.shape_6581.setTransform(235.9,418.2,0.5,0.5);

	this.shape_6582 = new cjs.Shape();
	this.shape_6582.graphics.f("#000000").s().p("ABSDCIAAiwQAAgngRgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgZAAIAAmDIAZAAIgBCeIACAAQAPgZAXgKQAWgLAiAAQBdAAAABiIAACxg");
	this.shape_6582.setTransform(221.4,415.3,0.5,0.5);

	this.shape_6583 = new cjs.Shape();
	this.shape_6583.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_6583.setTransform(207.8,418.2,0.5,0.5);

	this.shape_6584 = new cjs.Shape();
	this.shape_6584.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAZAdAvAAQAYAAAQgDQATgEAZgLIAAAXQgWALgTACQgVAEgWABQg6AAghglgAg3hcQgYAbgDAwICnAAQgBgwgUgaQgVgbgkABQgmgBgYAag");
	this.shape_6584.setTransform(188.4,418.2,0.5,0.5);

	this.shape_6585 = new cjs.Shape();
	this.shape_6585.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAARADIgEAYQgTgEgQAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_6585.setTransform(177.3,418.1,0.5,0.5);

	this.shape_6586 = new cjs.Shape();
	this.shape_6586.graphics.f("#000000").s().p("AhNBoQgggkgBhCQABg/AggnQAggoA0AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAZAAARgDQASgEAagLIAAAXQgYALgTACQgVAEgWABQg5AAgiglgAg3hcQgXAbgEAwICmAAQABgwgVgaQgUgbglABQglgBgZAag");
	this.shape_6586.setTransform(164.4,418.2,0.5,0.5);

	this.shape_6587 = new cjs.Shape();
	this.shape_6587.graphics.f("#000000").s().p("ABTDCIAAiwQAAgngSgTQgRgTgkAAQgwAAgWAZQgXAYAAA2IAACWIgYAAIAAmDIAYAAIgBCeIABAAQARgZAWgKQAXgLAhAAQBcAAAABiIAACxg");
	this.shape_6587.setTransform(150,415.3,0.5,0.5);

	this.shape_6588 = new cjs.Shape();
	this.shape_6588.graphics.f("#000000").s().p("ABNCIIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQAOg8AHgRIA4ikIAVAAIA1CjQAQA0AGAaIACAAQABgOAThJIApiaIAZAAIhKEOg");
	this.shape_6588.setTransform(133.2,418.2,0.5,0.5);

	this.shape_6589 = new cjs.Shape();
	this.shape_6589.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAcAhAAA5IAAATIjCAAQAAA4AaAeQAZAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgVAEgXABQg5AAghglgAg3hcQgYAbgDAwICnAAQAAgwgVgaQgUgbglABQgmgBgYAag");
	this.shape_6589.setTransform(110.3,418.2,0.5,0.5);

	this.shape_6590 = new cjs.Shape();
	this.shape_6590.graphics.f("#000000").s().p("AhABnQgggkAAhCQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgkgLgZAAQgxAAgaAeQgZAgAAA4QAAA4AZAeQAaAfAtAAQAlAAAfgNIAAAWQgaAOgqAAQg5AAghgmg");
	this.shape_6590.setTransform(97.6,418.2,0.5,0.5);

	this.shape_6591 = new cjs.Shape();
	this.shape_6591.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBDAAQBcAAAABjIAACwg");
	this.shape_6591.setTransform(83.8,418.1,0.5,0.5);

	this.shape_6592 = new cjs.Shape();
	this.shape_6592.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgbAAQgoAAgWgUgAAeAAQg4ACgYAPQgYAPAAAgQAAAaAPAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6592.setTransform(69,418.2,0.5,0.5);

	this.shape_6593 = new cjs.Shape();
	this.shape_6593.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6593.setTransform(58.6,418.1,0.5,0.5);

	this.shape_6594 = new cjs.Shape();
	this.shape_6594.graphics.f("#000000").s().p("AhjC2IAAlrIDHAAIAAAXIiuAAIAACbICkAAIAAAWIikAAIAACjg");
	this.shape_6594.setTransform(47.5,415.9,0.5,0.5);

	this.shape_6595 = new cjs.Shape();
	this.shape_6595.graphics.f("#000000").s().p("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");
	this.shape_6595.setTransform(343.1,380,0.5,0.5);

	this.shape_6596 = new cjs.Shape();
	this.shape_6596.graphics.f("#000000").s().p("AhzC/IAAgVQAMAEATAAQANAAAKgGQAJgFAIgOQAHgKAMgdIAMgkIhnkOIAaAAIA4CYQAaBCAIAcIABAAQANgqAVg1IA4iXIAaAAIh4E6QgPAogKAMQgKANgNAHQgOAHgTAAQgNAAgSgGg");
	this.shape_6596.setTransform(622.2,344.7,0.5,0.5);

	this.shape_6597 = new cjs.Shape();
	this.shape_6597.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6597.setTransform(613.4,338.8,0.5,0.5);

	this.shape_6598 = new cjs.Shape();
	this.shape_6598.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA9AWAdQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_6598.setTransform(603.4,344.6,0.5,0.5);

	this.shape_6599 = new cjs.Shape();
	this.shape_6599.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAhAAhgmQAfgoA1AAQAwAAAbAiQAdAhgBA5IAAATIjBAAQAAA3AaAfQAZAdAvAAQAYAAAQgDQASgEAagLIAAAXQgVALgUACQgWAEgVABQg6AAghglgAg3hcQgXAagEAxICmAAQAAgxgVgZQgTgbglABQgmgBgYAag");
	this.shape_6599.setTransform(588.4,341.7,0.5,0.5);

	this.shape_6600 = new cjs.Shape();
	this.shape_6600.graphics.f("#000000").s().p("AhMBoQgigkABhCQAAhAAfgmQAggoA2AAQAvAAAcAiQAbAhAAA5IAAATIjBAAQAAA3AaAfQAZAdAvAAQAYAAAQgDQATgEAZgLIAAAXQgWALgTACQgWAEgVABQg6AAghglgAg3hcQgXAbgEAwICmAAQAAgwgUgaQgVgbgjABQgngBgYAag");
	this.shape_6600.setTransform(574.4,341.7,0.5,0.5);

	this.shape_6601 = new cjs.Shape();
	this.shape_6601.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAtAAAWgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6601.setTransform(559.4,338.9,0.5,0.5);

	this.shape_6602 = new cjs.Shape();
	this.shape_6602.graphics.f("#000000").s().p("AhNBoQgggkgBhCQAAhAAhgmQAfgoA1AAQAwAAAcAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAZAAARgDQASgEAagLIAAAXQgXALgUACQgVAEgWABQg5AAgiglgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgbglABQglgBgZAag");
	this.shape_6602.setTransform(538.6,341.7,0.5,0.5);

	this.shape_6603 = new cjs.Shape();
	this.shape_6603.graphics.f("#000000").s().p("AhABnQgggjAAhDQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgkgLgZAAQgxAAgaAeQgaAfAAA5QAAA4AaAeQAaAfAtAAQAlAAAfgNIAAAWQgaAOgqAAQg5AAghgmg");
	this.shape_6603.setTransform(525.8,341.7,0.5,0.5);

	this.shape_6604 = new cjs.Shape();
	this.shape_6604.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6604.setTransform(512.3,341.7,0.5,0.5);

	this.shape_6605 = new cjs.Shape();
	this.shape_6605.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6605.setTransform(503.1,338.8,0.5,0.5);

	this.shape_6606 = new cjs.Shape();
	this.shape_6606.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlg0AAQg9AAgdgvIgBAAIABCkgAhDiWQgWAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQguAAgXAag");
	this.shape_6606.setTransform(493,344.6,0.5,0.5);

	this.shape_6607 = new cjs.Shape();
	this.shape_6607.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAVAXQAXAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6607.setTransform(471.2,341.7,0.5,0.5);

	this.shape_6608 = new cjs.Shape();
	this.shape_6608.graphics.f("#000000").s().p("ACdCKIAAiwQAAgogPgTQgQgSggAAQgqAAgTAYQgUAWAAAxIAACeIgYAAIAAi4QAAhFg/AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAASAwIABAAQANgYAWgMQAWgMAdAAQAsAAAWAXQAWAZAAAzIAACwg");
	this.shape_6608.setTransform(447.1,341.6,0.5,0.5);

	this.shape_6609 = new cjs.Shape();
	this.shape_6609.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_6609.setTransform(428.3,341.7,0.5,0.5);

	this.shape_6610 = new cjs.Shape();
	this.shape_6610.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQghAAgXAdQgWAfAAAsIAACUg");
	this.shape_6610.setTransform(416.7,341.6,0.5,0.5);

	this.shape_6611 = new cjs.Shape();
	this.shape_6611.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgyASgXQARgXAqAAQAVAAAYAHIgGAVQgTgGgVAAQgcAAgMARQgMARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6611.setTransform(407.9,338.7,0.5,0.5);

	this.shape_6612 = new cjs.Shape();
	this.shape_6612.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgNgFgHgKQgHgKAAgMQAAgaAigUQgXgKgOgVQgNgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgaAZgrAAQgSAAgIgCQgPAIgHAKQgIAKAAALQAAANAKAGQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg/AAQgzAAgcgUgAhgB6QAAA4BTAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhLAAAAA6gAg4igQgTASAAAhQAAAgATARQATARAgAAQAhAAASgRQASgRAAghQAAgigTgSQgRgRghAAQghAAgSATg");
	this.shape_6612.setTransform(390,344.6,0.5,0.5);

	this.shape_6613 = new cjs.Shape();
	this.shape_6613.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6613.setTransform(375.9,341.6,0.5,0.5);

	this.shape_6614 = new cjs.Shape();
	this.shape_6614.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_6614.setTransform(365.4,339.2,0.5,0.5);

	this.shape_6615 = new cjs.Shape();
	this.shape_6615.graphics.f("#000000").s().p("AhxDHIAAmIIAVAAIAEAnIACAAQAbgsA9AAQA3AAAdAkQAcAkAABEQAABCgeAlQgfAlgzAAQg+AAgdgvIgBAAIAAAVIABAoIAABngAhCiWQgXAaAAA7IAAAIQAAA+AWAcQAVAbAvAAQAqAAAWgfQAXgeAAg4QAAh3hWAAQgvAAgVAag");
	this.shape_6615.setTransform(355.3,344.6,0.5,0.5);

	this.shape_6616 = new cjs.Shape();
	this.shape_6616.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6616.setTransform(340.1,341.7,0.5,0.5);

	this.shape_6617 = new cjs.Shape();
	this.shape_6617.graphics.f("#000000").s().p("AhABnQgggjAAhDQAAhCAiglQAigmA6AAQAjAAAgANIgGAVQgkgLgZAAQgxAAgaAeQgaAfAAA5QAAA4AaAeQAaAfAtAAQAlAAAfgNIAAAWQgaAOgqAAQg5AAghgmg");
	this.shape_6617.setTransform(328,341.7,0.5,0.5);

	this.shape_6618 = new cjs.Shape();
	this.shape_6618.graphics.f("#000000").s().p("AhfB8IAAgbQApAVAtgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgOgmgOQgngOgRgKQgRgLgIgOQgJgMAAgUQABgeAZgSQAagSAsAAQAsAAAoARIgKAXQgngRgjAAQggAAgTALQgUAKABAUQAAAVAPANQAOANArAPQAlANARAKQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_6618.setTransform(315.7,341.7,0.5,0.5);

	this.shape_6619 = new cjs.Shape();
	this.shape_6619.graphics.f("#000000").s().p("AhjC2IAAlrIDGAAIAAAXIisAAIAACKICjAAIAAAXIijAAIAACcICsAAIAAAXg");
	this.shape_6619.setTransform(303.3,339.4,0.5,0.5);

	this.shape_6620 = new cjs.Shape();
	this.shape_6620.graphics.f("#000000").s().p("AgTAAQAAgYATAAQAUAAAAAYQAAAZgUAAQgTAAAAgZg");
	this.shape_6620.setTransform(286.1,347.5,0.5,0.5);

	this.shape_6621 = new cjs.Shape();
	this.shape_6621.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6621.setTransform(275.1,338.9,0.5,0.5);

	this.shape_6622 = new cjs.Shape();
	this.shape_6622.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIABAAQAbgrBDAAQBbAAABBjIAACwg");
	this.shape_6622.setTransform(260.4,341.6,0.5,0.5);

	this.shape_6623 = new cjs.Shape();
	this.shape_6623.graphics.f("#000000").s().p("AhPB4QgVgUAAglQAAgnAggWQAigVA9gCIA0gBIAAgSQgBgmgPgUQgQgUgjAAQglAAgoAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWgBAyIAACzIgSAAIgFgrIgDAAQgVAbgUAKQgYALgbAAQgnAAgXgUgAAeAAQg3ACgaAPQgXAPAAAgQAAAaAPAOQARAOAbAAQAqAAAagZQAZgZAAgsIAAgag");
	this.shape_6623.setTransform(245.6,341.7,0.5,0.5);

	this.shape_6624 = new cjs.Shape();
	this.shape_6624.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6624.setTransform(236.4,338.8,0.5,0.5);

	this.shape_6625 = new cjs.Shape();
	this.shape_6625.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAYAfAsAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgZgegsAAQgtAAgYAeg");
	this.shape_6625.setTransform(226.1,341.7,0.5,0.5);

	this.shape_6626 = new cjs.Shape();
	this.shape_6626.graphics.f("#000000").s().p("AhtC2IAAlrIBZAAQCCAAgBBpQAAA0gkAcQgjAchBAAIg4AAIAACWgAhTAJIAyAAQA9AAAbgTQAbgUAAgtQAAgqgZgVQgbgUg1AAIg8AAg");
	this.shape_6626.setTransform(211.8,339.4,0.5,0.5);

	this.shape_6627 = new cjs.Shape();
	this.shape_6627.graphics.f("#000000").s().p("AgdA/QAThEAIg4IAdAAIADAFQgTBAgYA3g");
	this.shape_6627.setTransform(193.9,348.6,0.5,0.5);

	this.shape_6628 = new cjs.Shape();
	this.shape_6628.graphics.f("#000000").s().p("ABNCIIg7i0IgOg2IgCAAIhMDqIgZAAIhMkOIAaAAIArCbQAQBBAEAVIABAAQAOg3AIgWIA4ikIAVAAIA1CjQATA+ADAQIACAAQACgTAShEIAoiaIAZAAIhJEOg");
	this.shape_6628.setTransform(182.4,341.7,0.5,0.5);

	this.shape_6629 = new cjs.Shape();
	this.shape_6629.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAigWQAhgVA9gCIAzgBIAAgSQABgmgRgUQgPgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAVAXQAXAWAAAyIAACzIgSAAIgHgrIgBAAQgWAbgVAKQgWALgbAAQgpAAgVgUgAAeAAQg3ACgZAPQgZAPAAAgQAAAaAQAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6629.setTransform(166,341.7,0.5,0.5);

	this.shape_6630 = new cjs.Shape();
	this.shape_6630.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgOgmgOQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_6630.setTransform(153.6,341.7,0.5,0.5);

	this.shape_6631 = new cjs.Shape();
	this.shape_6631.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6631.setTransform(143.7,341.6,0.5,0.5);

	this.shape_6632 = new cjs.Shape();
	this.shape_6632.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6632.setTransform(130.6,341.7,0.5,0.5);

	this.shape_6633 = new cjs.Shape();
	this.shape_6633.graphics.f("#000000").s().p("ABdC2IhelRQgDATgIAfIhQEfIgWAAIhklrIAbAAIBREvIAEATQAGgiAThEIA/jcIAbAAIBJD8QANAsAFAbIAIgmIBNkdIAaAAIhlFrg");
	this.shape_6633.setTransform(113,339.4,0.5,0.5);

	this.shape_6634 = new cjs.Shape();
	this.shape_6634.graphics.f("#000000").s().p("ACdCKIAAiwQAAgpgQgSQgPgSggAAQgqAAgUAYQgTAWAAAxIAACeIgZAAIAAi4QAAhFg+AAQgrAAgTAZQgUAZAAA3IAACUIgYAAIAAkOIAUAAIAFAmIACAAQALgVAVgLQAUgLAZAAQBAAAARAwIABAAQAOgYAWgMQAWgMAcAAQAtAAAWAXQAWAYAAA0IAACwg");
	this.shape_6634.setTransform(83.8,341.6,0.5,0.5);

	this.shape_6635 = new cjs.Shape();
	this.shape_6635.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOggAAgqQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAmAABAQAABCghAlQgfAmg4AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6635.setTransform(65,341.7,0.5,0.5);

	this.shape_6636 = new cjs.Shape();
	this.shape_6636.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQARgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6636.setTransform(53.4,341.6,0.5,0.5);

	this.shape_6637 = new cjs.Shape();
	this.shape_6637.graphics.f("#000000").s().p("AgjDDIAAj4IgzAAIAAgPIAzgJIAAgVQAAgxASgYQASgXApAAQAVAAAYAHIgGAVQgTgGgVAAQgdAAgMARQgLARAAAmIAAAZIA/AAIAAAWIg/AAIAAD4g");
	this.shape_6637.setTransform(44.6,338.7,0.5,0.5);

	this.shape_6638 = new cjs.Shape();
	this.shape_6638.graphics.f("#000000").s().p("AhzC/IAAgVQANAEASAAQANAAAJgGQAKgFAIgOQAHgKALgdIAOgkIhokOIAZAAIA6CYQAaBFAHAZIAAAAQAOgqAUg1IA6iXIAZAAIh4E6QgQAogJAMQgJANgOAHQgOAHgSAAQgOAAgSgGg");
	this.shape_6638.setTransform(650.5,306.5,0.5,0.5);

	this.shape_6639 = new cjs.Shape();
	this.shape_6639.graphics.f("#000000").s().p("AgLDCIAAmDIAYAAIAAGDg");
	this.shape_6639.setTransform(641.7,300.5,0.5,0.5);

	this.shape_6640 = new cjs.Shape();
	this.shape_6640.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6640.setTransform(636,300.5,0.5,0.5);

	this.shape_6641 = new cjs.Shape();
	this.shape_6641.graphics.f("#000000").s().p("AhOB4QgXgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAWAAAyIAACzIgSAAIgHgrIgCAAQgUAbgVAKQgXALgbAAQgoAAgWgUgAAeAAQg3ACgZAPQgYAPAAAgQAAAaAPAOQARAOAbAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6641.setTransform(625.9,303.4,0.5,0.5);

	this.shape_6642 = new cjs.Shape();
	this.shape_6642.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAagrBCAAQBcAAAABjIAACwg");
	this.shape_6642.setTransform(612.1,303.3,0.5,0.5);

	this.shape_6643 = new cjs.Shape();
	this.shape_6643.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6643.setTransform(601.7,301,0.5,0.5);

	this.shape_6644 = new cjs.Shape();
	this.shape_6644.graphics.f("#000000").s().p("AheCzQgcgTAAgjQAAgcASgTQARgSAegHQgMgFgIgKQgHgJAAgNQAAgaAigUQgXgKgNgVQgOgVAAgbQAAgoAagZQAagYAsAAQAaAAAOAFIBXAAIAAARIg4AEQAWAcAAAhQAAAngaAYQgbAZgqAAQgSAAgIgCQgOAIgIAKQgIAKAAALQAAAOAKAFQAKAGAXAAIAuAAQAtAAAXASQAXASAAAjQAAArgjAXQgjAXg+AAQg0AAgcgUgAhfB6QAAA4BSAAQBqAAAAhEQAAgYgRgLQgRgLglAAIgrAAQhKAAAAA6gAg4igQgTASAAAhQAAAfATASQATARAgAAQAiAAARgRQASgRAAghQAAgjgSgRQgTgRggAAQghAAgSATg");
	this.shape_6644.setTransform(592.1,306.4,0.5,0.5);

	this.shape_6645 = new cjs.Shape();
	this.shape_6645.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_6645.setTransform(582.6,301,0.5,0.5);

	this.shape_6646 = new cjs.Shape();
	this.shape_6646.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIABAAQASgfASgLQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6646.setTransform(575.6,303.3,0.5,0.5);

	this.shape_6647 = new cjs.Shape();
	this.shape_6647.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAgglQAhgkA3gBQA3AAAgAmQAgAmAABAQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA4AZAfQAZAfArAAQAtAAAYgfQAZgfAAg4QAAg3gZggQgYgegtAAQgsAAgZAeg");
	this.shape_6647.setTransform(562.3,303.4,0.5,0.5);

	this.shape_6648 = new cjs.Shape();
	this.shape_6648.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAnAAAVgNQAVgOAAgVQAAgVgRgNQgQgPgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQAsAAAnARIgJAXQgpgRghAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_6648.setTransform(542.1,303.4,0.5,0.5);

	this.shape_6649 = new cjs.Shape();
	this.shape_6649.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgngPgTQgQgUgjAAQgkAAgpAVIgJgVQAtgVAqAAQAtAAAWAXQAWAXAAAxIAACzIgSAAIgHgrIgCAAQgUAbgWAKQgWALgcAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAQAAAfQAAAZAQAPQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6649.setTransform(529.1,303.4,0.5,0.5);

	this.shape_6650 = new cjs.Shape();
	this.shape_6650.graphics.f("#000000").s().p("ABNCIIg7i0QgGgTgJgjIgBAAIhMDqIgYAAIhOkOIAbAAIArCbQAPA7AFAbIABAAQAQg+AGgPIA4ikIAVAAIA1CjQAQA0AGAaIABAAQADgTARhEIAqiaIAZAAIhKEOg");
	this.shape_6650.setTransform(513.6,303.4,0.5,0.5);

	this.shape_6651 = new cjs.Shape();
	this.shape_6651.graphics.f("#000000").s().p("AhfB8IAAgbQAqAVAsgBQAoAAAUgNQAVgOAAgVQAAgVgRgNQgQgPgmgNQgogOgQgKQgQgLgJgOQgIgLAAgVQAAgeAZgSQAagSAtAAQArAAAoARIgKAXQgngRgiAAQghAAgTALQgTAKAAAUQAAAVAPANQAPANArAPQAkAOARAJQARAMAIANQAIAMAAATQAAAkgbAUQgcATgyABQg2AAgggRg");
	this.shape_6651.setTransform(491.7,303.4,0.5,0.5);

	this.shape_6652 = new cjs.Shape();
	this.shape_6652.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgXAZQgWAYAAA4IAACUIgYAAIAAkOIAUAAIAFAmIACAAQAZgrBDAAQBdAAAABjIAACwg");
	this.shape_6652.setTransform(478.4,303.3,0.5,0.5);

	this.shape_6653 = new cjs.Shape();
	this.shape_6653.graphics.f("#000000").s().p("AgLC5IAAkOIAXAAIAAEOgAgPigQAAgYAPAAQAIAAAEAGQAEAHAAALQAAALgEAGQgEAHgIAAQgPAAAAgYg");
	this.shape_6653.setTransform(467.9,301,0.5,0.5);

	this.shape_6654 = new cjs.Shape();
	this.shape_6654.graphics.f("#000000").s().p("ABHDCIhmiJIgsAoIAABhIgZAAIAAmDIAZAAIgCEMIACAAICJiXIAeAAIhqByIBzCcg");
	this.shape_6654.setTransform(460,300.5,0.5,0.5);

	this.shape_6655 = new cjs.Shape();
	this.shape_6655.graphics.f("#000000").s().p("AgRCXQgSgSABgqIAAiuIgpAAIAAgOIApgLIAMg+IANAAIAABCIBOAAIAAAVIhOAAIAACrQAAAfAKAPQALAPAXAAQAWAAASgEIAAAUQgSAGgWAAQgjAAgRgUg");
	this.shape_6655.setTransform(448.3,301.9,0.5,0.5);

	this.shape_6656 = new cjs.Shape();
	this.shape_6656.graphics.f("#000000").s().p("AhOB4QgXgUAAglQABgnAggWQAigVA9gCIAzgBIAAgSQAAgmgPgUQgQgUgjAAQgkAAgpAVIgJgVQAsgVArAAQAtAAAWAXQAVAWAAAyIAACzIgSAAIgGgrIgCAAQgVAbgVAKQgWALgbAAQgpAAgVgUgAAeAAQg4ACgZAPQgYAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAagZQAYgZAAgsIAAgag");
	this.shape_6656.setTransform(437,303.4,0.5,0.5);

	this.shape_6657 = new cjs.Shape();
	this.shape_6657.graphics.f("#000000").s().p("ABdC2IhQkYQgKglgDgUQgGAegGAUIhQEfIgWAAIhklrIAbAAIBVFCQAGgiAUhEIA+jcIAbAAIBJD8QALAoAHAfIAIgmIBNkdIAaAAIhlFrg");
	this.shape_6657.setTransform(419.3,301.1,0.5,0.5);

	this.shape_6658 = new cjs.Shape();
	this.shape_6658.graphics.f("#000000").s().p("AgwDwIAAgWQAQAFAQAAQAlAAAAgrIAAlGIAYAAIAAFCQAAAigPASQgRASgbAAQgVAAgNgGgAARjdQAAgYAQAAQAIAAAEAGQAEAGAAAMQAAALgEAGQgEAHgIAAQgQAAAAgYg");
	this.shape_6658.setTransform(396.7,304,0.5,0.5);

	this.shape_6659 = new cjs.Shape();
	this.shape_6659.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAHAAAFAGQAEAHAAALQAAALgEAGQgFAHgHAAQgPAAAAgYg");
	this.shape_6659.setTransform(392.6,301,0.5,0.5);

	this.shape_6660 = new cjs.Shape();
	this.shape_6660.graphics.f("#000000").s().p("ABNCIIg7i0IgOg2IgCAAIhMDqIgYAAIhOkOIAbAAIArCbQAOA3AGAfIACAAQANg3AIgWIA4ikIAVAAIA1CjQATA+ADAQIACAAQACgTAShEIApiaIAZAAIhKEOg");
	this.shape_6660.setTransform(380.5,303.4,0.5,0.5);

	this.shape_6661 = new cjs.Shape();
	this.shape_6661.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPgfAAgrQAAhCAgglQAhgkA2gBQA4AAAgAmQAgAlAABBQAABCggAlQggAmg4AAQgjgBgcgRgAhFhXQgYAgAAA3QAAA3AYAgQAZAfAsAAQAtAAAYgfQAZgfAAg4QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6661.setTransform(363.8,303.4,0.5,0.5);

	this.shape_6662 = new cjs.Shape();
	this.shape_6662.graphics.f("#000000").s().p("AgMDCIAAmDIAYAAIAAGDg");
	this.shape_6662.setTransform(353.5,300.5,0.5,0.5);

	this.shape_6663 = new cjs.Shape();
	this.shape_6663.graphics.f("#000000").s().p("Ag/B7QgbgRgPggQgOghAAgpQAAhCAgglQAggkA4gBQA4AAAfAmQAgAmAABAQAABCghAlQggAmg3AAQgjgBgcgRgAhFhXQgYAfAAA4QAAA3AYAgQAaAfArAAQAtAAAYgfQAZggAAg3QAAg2gZghQgZgegsAAQgtAAgYAeg");
	this.shape_6663.setTransform(343.1,303.4,0.5,0.5);

	this.shape_6664 = new cjs.Shape();
	this.shape_6664.graphics.f("#000000").s().p("AhvCsIAAgZQAmARA+AAQArAAAbgVQAagUAAgiQAAgUgIgOQgJgNgUgMQgTgLgmgNQg2gSgXgWQgVgXAAglQAAgpAggZQAfgaAyAAQA0AAAtATIgKAWQgtgTgpAAQgoAAgXATQgYATAAAgQAAAUAHANQAHANARAKQATALAlAOQAsAOAUANQAWAPAKARQAJARAAAZQAAAughAaQghAbg3AAQhDAAgjgPg");
	this.shape_6664.setTransform(328.8,301.1,0.5,0.5);

	this.shape_6665 = new cjs.Shape();
	this.shape_6665.graphics.f("#000000").s().p("AhPB4QgWgVAAgkQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6665.setTransform(307.9,303.4,0.5,0.5);

	this.shape_6666 = new cjs.Shape();
	this.shape_6666.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIACAxIACAAQARgdATgNQASgMAbAAQASAAATADIgFAYQgTgEgQAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6666.setTransform(297.6,303.3,0.5,0.5);

	this.shape_6667 = new cjs.Shape();
	this.shape_6667.graphics.f("#000000").s().p("AhUChQgdgjAAhCQAAhFAdgmQAeglA3AAQAdAAAVALQAWALARAaIABAAIgBg+IAAhhIAYAAIAAGCIgQAAIgGgpIgCAAQgfAug6AAQg2AAgfgjgAhBgeQgWAeAAA7QAABzBYAAQAuAAAVgaQAWgbAAg9IAAgFQAAg+gVgbQgVgbgvAAQgsAAgWAfg");
	this.shape_6667.setTransform(283.7,300.6,0.5,0.5);

	this.shape_6668 = new cjs.Shape();
	this.shape_6668.graphics.f("#000000").s().p("ABSCKIAAivQAAgpgRgSQgRgSglgBQgvAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAWAAIAEAmIABAAQAbgrBDAAQBcAAgBBjIAACwg");
	this.shape_6668.setTransform(269.1,303.3,0.5,0.5);

	this.shape_6669 = new cjs.Shape();
	this.shape_6669.graphics.f("#000000").s().p("AhPB4QgWgUAAglQAAgnAhgWQAigVA9gCIAzgBIAAgSQAAgmgQgUQgPgUgjAAQglAAgoAVIgJgVQAsgVArAAQAtAAAWAXQAWAXAAAxIAACzIgTAAIgGgrIgCAAQgUAbgWAKQgXALgbAAQgnAAgXgUgAAeAAQg4ACgYAPQgZAPAAAgQAAAaAQAOQAQAOAcAAQAqAAAZgZQAZgZAAgsIAAgag");
	this.shape_6669.setTransform(254.3,303.4,0.5,0.5);

	this.shape_6670 = new cjs.Shape();
	this.shape_6670.graphics.f("#000000").s().p("ABVCIIhVh5IhVB5IgbAAIBiiLIheiDIAcAAIBQByIBQhyIAbAAIhdCDIBjCLg");
	this.shape_6670.setTransform(241.6,303.4,0.5,0.5);

	this.shape_6671 = new cjs.Shape();
	this.shape_6671.graphics.f("#000000").s().p("AhMBoQgigkAAhCQAAg/AhgnQAggoA0AAQAxAAAbAiQAbAhABA5IAAATIjDAAQABA4AZAeQAaAdAuAAQAYAAASgDQASgEAagLIAAAXQgYALgSACQgWAEgWABQg5AAghglgAg3hcQgXAbgEAwICnAAQAAgwgVgaQgUgbglABQgmgBgYAag");
	this.shape_6671.setTransform(228.3,303.4,0.5,0.5);

	this.shape_6672 = new cjs.Shape();
	this.shape_6672.graphics.f("#000000").s().p("AgLDCIAAmDIAXAAIAAGDg");
	this.shape_6672.setTransform(218.4,300.5,0.5,0.5);

	this.shape_6673 = new cjs.Shape();
	this.shape_6673.graphics.f("#000000").s().p("AB8C3IgyiBIiTAAIgyCBIgdAAICTltIAPAAICPFtgAgNhjIgzCCICCAAIhBitQgFAXgJAUg");
	this.shape_6673.setTransform(207.9,301.1,0.5,0.5);

	this.shape_6674 = new cjs.Shape();
	this.shape_6674.graphics.f("#000000").s().p("AgdA/QAThCAJg6IAcAAIADAFQgTBAgYA3g");
	this.shape_6674.setTransform(190.4,310.4,0.5,0.5);

	this.shape_6675 = new cjs.Shape();
	this.shape_6675.graphics.f("#000000").s().p("AhzCmIAAgYQAVALAaAGQAZAGAYAAQA2AAAcgWQAbgWAAgpQAAgkgcgUQgdgTg1AAIgnAAIAAgXIAoAAQArAAAbgVQAbgWAAglQAAgegWgSQgUgTgkAAQgaAAgXAIQgUAHgeATIgMgRQAUgRAfgLQAegKAeAAQAyAAAbAYQAcAXAAAsQAAAhgWAYQgVAXgkAGIAAACQAtAGAWAVQAXAWAAAmQAAAzgjAcQgjAchAAAQg3AAgqgVg");
	this.shape_6675.setTransform(180.5,301.1,0.5,0.5);

	this.shape_6676 = new cjs.Shape();
	this.shape_6676.graphics.f("#000000").s().p("AhzCmIAAgYQAVALAaAGQAZAGAYAAQA2AAAcgWQAbgWAAgpQAAgkgcgUQgdgTg1AAIgnAAIAAgXIAnAAQAsAAAbgVQAbgWAAglQAAgegWgSQgVgTgjAAQgaAAgXAIQgUAHgeATIgMgRQAUgRAfgLQAegKAeAAQAyAAAbAYQAbAXAAAsQAAAigVAXQgWAXgjAGIAAACQAsAGAXAVQAXAWAAAmQAAAzgjAcQgjAchAAAQg3AAgqgVg");
	this.shape_6676.setTransform(166,301.1,0.5,0.5);

	this.shape_6677 = new cjs.Shape();
	this.shape_6677.graphics.f("#000000").s().p("AhcC1IAAgWQAIADARADIAXABQA+AAAigsQAigrAFhVIgDAAQgTAXgZAMQgYANgbAAQgzAAgcgcQgcgbAAgzQAAg3AfghQAfgjAxABQAjAAAbASQAbATAOAkQAPAmAAAxQAABGgTAxQgSAwglAXQgkAYgyAAQgYAAgXgHgAhBiKQgYAaAAAuQAAAtAWAVQAVAVApAAQAYABAWgLQAVgLANgSQANgTAAgTQAAgdgLgaQgMgZgVgOQgUgPgbAAQgnAAgXAbg");
	this.shape_6677.setTransform(151.6,301.1,0.5,0.5);

	this.shape_6678 = new cjs.Shape();
	this.shape_6678.graphics.f("#000000").s().p("AAjC2IAAkJQAAgkADgmIgHAHIhMA8IgOgSIBhhJIAWAAIAAFrg");
	this.shape_6678.setTransform(135.4,301.1,0.5,0.5);

	this.shape_6679 = new cjs.Shape();
	this.shape_6679.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6679.setTransform(115.8,303.3,0.5,0.5);

	this.shape_6680 = new cjs.Shape();
	this.shape_6680.graphics.f("#000000").s().p("AgMC5IAAkOIAYAAIAAEOgAgPigQAAgYAPAAQAIAAADAGQAFAHAAALQAAALgFAGQgDAHgIAAQgPAAAAgYg");
	this.shape_6680.setTransform(105.4,301,0.5,0.5);

	this.shape_6681 = new cjs.Shape();
	this.shape_6681.graphics.f("#000000").s().p("ABSCKIAAivQAAgogRgTQgRgSgkgBQgwAAgWAZQgXAYAAA4IAACUIgZAAIAAkOIAVAAIAFAmIACAAQAagrBCAAQBdAAAABjIAACwg");
	this.shape_6681.setTransform(88.4,303.3,0.5,0.5);

	this.shape_6682 = new cjs.Shape();
	this.shape_6682.graphics.f("#000000").s().p("AhHCKIAAkOIAVAAIADAxIACAAQAQgdATgNQASgMAbAAQATAAASADIgFAYQgSgEgRAAQgiAAgWAdQgWAeAAAtIAACUg");
	this.shape_6682.setTransform(76.7,303.3,0.5,0.5);

	this.shape_6683 = new cjs.Shape();
	this.shape_6683.graphics.f("#000000").s().p("Ag/B7QgbgRgOggQgPghAAgpQAAhCAhglQAfgkA4gBQA4AAAfAmQAgAmAABAQAABCggAlQggAmg4AAQgjgBgcgRgAhEhXQgZAfAAA4QAAA4AZAfQAZAfArAAQAtAAAZgfQAYggAAg3QAAg2gZghQgYgegtAAQgsAAgYAeg");
	this.shape_6683.setTransform(63.4,303.4,0.5,0.5);

	this.shape_6684 = new cjs.Shape();
	this.shape_6684.graphics.f("#000000").s().p("Ah3C2IAAlrIBkAAQBCAAAgAXQAgAXAAAuQAAAggUAUQgTAWglAFIAAACQAsAHAUATQAVAWAAAmQAAAxgiAbQghAcg8AAgAheCgIBWAAQBkgBAAhRQAAhMhpABIhRAAgAhegTIBRAAQAxAAAYgRQAYgSAAgkQAAgkgbgRQgagQgzAAIhKAAg");
	this.shape_6684.setTransform(48.5,301.1,0.5,0.5);

	this.instance_27 = new lib.Wat_studio_reddress();
	this.instance_27.parent = this;
	this.instance_27.setTransform(775,-12);

	this.shape_6685 = new cjs.Shape();
	this.shape_6685.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_6685.setTransform(504.9,815.6,0.5,0.5);

	this.shape_6686 = new cjs.Shape();
	this.shape_6686.graphics.f("#000000").s().p("AhaCDIAAgUQARAJAUAFQAUAFASAAQAqAAAWgSQAWgRAAggQAAgcgWgQQgWgPgqAAIgfAAIAAgSIAfAAQAjAAAUgQQAVgRAAgdQAAgYgRgOQgQgPgcAAQgUAAgSAGQgTAHgUAOIgKgOQASgOAWgHQAYgJAXAAQAnAAAWATQAVATAAAiQAAAbgRARQgQASgcAGIAAABQAiAEASARQASARAAAeQAAAogbAWQgbAWgzAAQgsAAgggQg");
	this.shape_6686.setTransform(496.6,809.2,0.5,0.5);

	this.shape_6687 = new cjs.Shape();
	this.shape_6687.graphics.f("#000000").s().p("AhCB/QgXgTAAgmQAAgZAQgUQARgUAhgMQgggQgMgPQgNgRAAgXQAAgUAKgQQAMgQARgHQASgJAXAAQAkAAAXATQAVASAAAfQAAAXgNARQgPARgdANQAkAOAQATQAPATAAAaQAAAjgZAVQgYAVgpAAQgqAAgYgUgAg2AfQgPAQAAAaQAAAbASAPQATAOAgABQAggBATgPQAUgPAAgcQAAgYgQgPQgRgQgpgQQglAPgOAQgAgshzQgQANgBAYQABAOAGAKQAGAJAMAKQAMAJAZALQAggMAOgPQAOgPAAgVQAAgYgQgNQgRgNgcAAQgbAAgRANg");
	this.shape_6687.setTransform(485.4,809.2,0.5,0.5);

	this.shape_6688 = new cjs.Shape();
	this.shape_6688.graphics.f("#000000").s().p("AhICOIAAgRQAKADAKABIASACQAwAAAagjQAcgiADhDIgCAAQgOARgUALQgVAKgTAAQgoAAgWgWQgWgUgBgpQAAgqAZgbQAXgbAoAAQAcAAAVAPQAVAPALAcQAMAdAAAnQAAA3gPAmQgPAlgdATQgbASgnAAQgWAAgQgFgAgzhsQgSAUAAAlQgBAhASASQARARAfAAQATAAARgJQASgIAJgOQAKgOAAgQQAAgWgJgUQgJgUgQgMQgQgLgVAAQgfAAgSAVg");
	this.shape_6688.setTransform(473.9,809.2,0.5,0.5);

	this.shape_6689 = new cjs.Shape();
	this.shape_6689.graphics.f("#000000").s().p("AAcCPIAAjPQAAgZACgiIgGAFQgFAFg2ArIgLgOIBMg6IARAAIAAEdg");
	this.shape_6689.setTransform(461.2,809.2,0.5,0.5);

	this.shape_6690 = new cjs.Shape();
	this.shape_6690.graphics.f("#000000").s().p("AgWAxQAQg5AFgoIAWAAIADAEQgPAvgTAug");
	this.shape_6690.setTransform(449.2,816.5,0.5,0.5);

	this.shape_6691 = new cjs.Shape();
	this.shape_6691.graphics.f("#000000").s().p("AgPAAQAAgSAPAAQAQAAAAASQAAATgQAAQgPAAAAgTg");
	this.shape_6691.setTransform(445,815.6,0.5,0.5);

	this.shape_6692 = new cjs.Shape();
	this.shape_6692.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAHALQAJAMASAAQATAAAOgDIAAAPQgPAFgSAAQgbAAgNgPg");
	this.shape_6692.setTransform(439.1,809.9,0.5,0.5);

	this.shape_6693 = new cjs.Shape();
	this.shape_6693.graphics.f("#000000").s().p("AhXCHIAAgTQAfANAvAAQAiAAAVgRQAVgQAAgaQAAgQgHgLQgHgKgPgJQgSgKgbgJQgsgOgQgSQgRgRAAgdQAAggAZgUQAagVAmAAQApAAAiAQIgHARQgjgPghAAQgeAAgTAPQgTAOAAAZQAAAQAGAKQAGALANAIQANAIAfALQAiALAQALQARAKAHAOQAIAPAAASQAAAkgaAVQgbAVgqAAQg2AAgagMg");
	this.shape_6693.setTransform(430.5,809.2,0.5,0.5);

	this.shape_6694 = new cjs.Shape();
	this.shape_6694.graphics.f("#000000").s().p("AhaCWIAAgRQALADANAAQAKAAAIgEQAHgEAHgLQAFgIAJgXIAKgcIhRjTIAUAAIAtB3QATAyAHAXIAAAAQAHgVAUg1IAth2IAUAAIhfD1QgLAfgIAKQgIALgKAFQgLAFgOAAQgLAAgOgEg");
	this.shape_6694.setTransform(415.2,813.5,0.5,0.5);

	this.shape_6695 = new cjs.Shape();
	this.shape_6695.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAVAAQANAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_6695.setTransform(407.4,811,0.5,0.5);

	this.shape_6696 = new cjs.Shape();
	this.shape_6696.graphics.f("#000000").s().p("AhSAfIAAiKIATAAIAACJQAAAgANAOQANAOAdABQAlAAARgUQASgTAAgrIAAh0IATAAIAADTIgQAAIgDgdIgBAAQgWAhgzAAQhIAAAAhNg");
	this.shape_6696.setTransform(396.9,811.2,0.5,0.5);

	this.shape_6697 = new cjs.Shape();
	this.shape_6697.graphics.f("#000000").s().p("AgpCRQgRgKgLgRIgCAAIgGAgIgMAAIAAkvIAUAAIgCB9IACAAQALgTASgJQARgJAXAAQAtAAAWAcQAXAcAAA1QAAA1gYAcQgXAdgrAAQgWAAgTgJgAg1gaQgQAWAAAwIAAADQAAAwARAVQAQAVAkAAQAiAAASgZQARgYAAgtQAAhbhFAAQglAAgQAWg");
	this.shape_6697.setTransform(385.4,808.9,0.5,0.5);

	this.shape_6698 = new cjs.Shape();
	this.shape_6698.graphics.f("#000000").s().p("AA9BqIg7i3IgBAAIg7C3IgTAAIg8jTIAUAAIAiB6QALAqAEAZIACAAQAMgvAEgOIAsiAIARAAIAqCAQALAkAGAZIABAAQACgQAOg0IAgh5IATAAIg5DTg");
	this.shape_6698.setTransform(371.9,811.1,0.5,0.5);

	this.shape_6699 = new cjs.Shape();
	this.shape_6699.graphics.f("#000000").s().p("Ag8BRQgagcAAgzQAAgxAZggQAZgeAqAAQAlAAAWAaQAWAaAAAtIAAAPIiYAAQAAArAUAXQAUAYAkAAQAVAAALgDQAQgDATgIIAAARQgRAJgQACQgNADgVAAQgtAAgagdgAgrhIQgSAWgDAlICCAAQAAglgQgVQgQgVgcAAQgeAAgTAUg");
	this.shape_6699.setTransform(359.2,811.1,0.5,0.5);

	this.shape_6700 = new cjs.Shape();
	this.shape_6700.graphics.f("#000000").s().p("ABTCPIioj9IgBAAIADBEIAAC5IgUAAIAAkdIAUAAICoD8IACAAQgDgfAAgkIAAi5IAUAAIAAEdg");
	this.shape_6700.setTransform(346.5,809.2,0.5,0.5);

	this.shape_6701 = new cjs.Shape();
	this.shape_6701.graphics.f("#000000").s().p("AgWAxQAPg1AGgsIAWAAIACAEQgPA0gSApg");
	this.shape_6701.setTransform(331.6,816.5,0.5,0.5);

	this.shape_6702 = new cjs.Shape();
	this.shape_6702.graphics.f("#000000").s().p("Ag8B+QgagcAAgzQAAgxAZggQAageApAAQAmAAAVAaQAWAaAAAsIAAAQIiYAAQABAsATAWQAUAYAkAAQAVAAALgDQAPgDAUgIIAAARQgRAJgQACQgNADgVAAQgsAAgbgdgAgqgbQgTAVgDAlICCAAQAAgkgQgVQgQgVgcAAQgeAAgSAUgAgVhaIAAgDQAQgSAMgQQANgRAGgKIAbAAIAAADQgGALgSAQQgNANgXAVg");
	this.shape_6702.setTransform(324.3,808.8,0.5,0.5);

	this.shape_6703 = new cjs.Shape();
	this.shape_6703.graphics.f("#000000").s().p("AhaCWIAAgRQALADANAAQAKAAAIgEQAIgFAGgKQAFgIAJgXIAKgcIhRjTIAUAAIAtB3QATAyAHAXIAAAAIAbhKIAth2IAUAAIheD1QgNAfgHAKQgHAKgLAGQgKAFgPAAQgLAAgOgEg");
	this.shape_6703.setTransform(314.2,813.5,0.5,0.5);

	this.shape_6704 = new cjs.Shape();
	this.shape_6704.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgMh+QAAgSAMAAQAGAAADAFQAEAFAAAIQAAAKgEAEQgDAFgGABQgMAAAAgUg");
	this.shape_6704.setTransform(307.4,809.1,0.5,0.5);

	this.shape_6705 = new cjs.Shape();
	this.shape_6705.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgcAAQglAAgTATQgRATAAAsIAAB0IgUAAIAAjTIARAAIADAdIACAAQAVghA0AAQBHAAABBNIAACKg");
	this.shape_6705.setTransform(299.3,811,0.5,0.5);

	this.shape_6706 = new cjs.Shape();
	this.shape_6706.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgbAAQgdAAgfAQIgIgRQAkgQAgAAQAjAAASASQARATAAAmIAACMIgOAAIgGgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgUALAAAZQAAAUANALQAMALAWAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_6706.setTransform(287.7,811.1,0.5,0.5);

	this.shape_6707 = new cjs.Shape();
	this.shape_6707.graphics.f("#000000").s().p("AgvCtIAAgRQAQAEANAAQAuAAAAgzIAAkfIAUAAIAAEdQAABIhBAAQgSAAgMgGg");
	this.shape_6707.setTransform(278.4,811,0.5,0.5);

	this.shape_6708 = new cjs.Shape();
	this.shape_6708.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIACAAQAMgYAQgJQANgJAWAAQAMAAAQACIgDATQgOgDgOAAQgaAAgRAXQgSAXAAAjIAAB0g");
	this.shape_6708.setTransform(269.4,811,0.5,0.5);

	this.shape_6709 = new cjs.Shape();
	this.shape_6709.graphics.f("#000000").s().p("Ag8BRQgagcAAgzQAAgyAagfQAYgeAqAAQAmAAAVAaQAVAaAAAtIAAAPIiYAAQACAsATAWQAUAYAlAAQATAAANgDQAOgDAUgIIAAARQgRAJgQACQgMADgVAAQguAAgagdgAgqhIQgTAVgDAmICCAAQAAgmgQgUQgPgVgdAAQgeAAgSAUg");
	this.shape_6709.setTransform(259.3,811.1,0.5,0.5);

	this.shape_6710 = new cjs.Shape();
	this.shape_6710.graphics.f("#000000").s().p("AgJCRIAAjUIATAAIAADUgAgMh+QAAgSAMAAQAGAAAEAFQADAFAAAIQAAAKgDAEQgEAFgGABQgMAAAAgUg");
	this.shape_6710.setTransform(251.6,809.1,0.5,0.5);

	this.shape_6711 = new cjs.Shape();
	this.shape_6711.graphics.f("#000000").s().p("AgICYIAAkvIASAAIAAEvg");
	this.shape_6711.setTransform(247.1,808.8,0.5,0.5);

	this.shape_6712 = new cjs.Shape();
	this.shape_6712.graphics.f("#000000").s().p("Ag7BRQgbgcAAgzQAAgxAaggQAYgeAqAAQAmAAAVAaQAVAaAAAtIAAAPIiXAAQAAAqAUAYQAUAYAkAAQAWAAALgDQAPgDATgIIAAARQgRAJgQACQgMADgWAAQgtAAgZgdgAgqhIQgTAWgDAlICCAAQAAgmgQgUQgPgVgdAAQgeAAgSAUg");
	this.shape_6712.setTransform(239.3,811.1,0.5,0.5);

	this.shape_6713 = new cjs.Shape();
	this.shape_6713.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAKgwIAKAAIAAA0IA9AAIAAARIg9AAIAACFQAAAZAHALQAJAMASAAQATAAAOgDIAAAPQgPAFgSAAQgbAAgNgPg");
	this.shape_6713.setTransform(230.3,809.9,0.5,0.5);

	this.shape_6714 = new cjs.Shape();
	this.shape_6714.graphics.f("#000000").s().p("ABiCPIgohkIhzAAIgoBkIgWAAIBzkeIAMAAIBwEegAgKhNIgoBmIBlAAIgyiIQgEARgHARg");
	this.shape_6714.setTransform(221.1,809.2,0.5,0.5);

	this.shape_6715 = new cjs.Shape();
	this.shape_6715.graphics.f("#000000").s().p("AgXAxQAQg5AGgoIAWAAIADAEQgPAvgSAug");
	this.shape_6715.setTransform(207.5,816.5,0.5,0.5);

	this.shape_6716 = new cjs.Shape();
	this.shape_6716.graphics.f("#000000").s().p("AhKBhIAAgVQAfAQAkAAQAgAAAPgKQAQgLAAgRQAAgQgNgLQgMgKgegLQgcgKgQgJQgOgJgFgKQgHgLAAgOQAAgYAUgOQAUgOAjAAQAkAAAdANIgHARQgggNgaABQgZAAgPAIQgPAJAAAPQAAARALAKQANAJAhAMQAcALANAHQAOAJAGAKQAGALAAAOQAAAdgVAPQgWAPgnAAQgrAAgYgNg");
	this.shape_6716.setTransform(200.9,811.1,0.5,0.5);

	this.shape_6717 = new cjs.Shape();
	this.shape_6717.graphics.f("#000000").s().p("ABABsIAAiJQAAgggNgOQgOgPgcAAQgkAAgTATQgRAUAAArIAAB0IgUAAIAAjTIARAAIAEAdIABAAQAUghA0AAQBJAAAABNIAACKg");
	this.shape_6717.setTransform(190.5,811,0.5,0.5);

	this.shape_6718 = new cjs.Shape();
	this.shape_6718.graphics.f("#000000").s().p("AgJCRIAAjUIASAAIAADUgAgLh+QAAgSALAAQAGAAADAFQADAFAAAIQAAAKgDAEQgDAFgGABQgLAAAAgUg");
	this.shape_6718.setTransform(182.3,809.1,0.5,0.5);

	this.shape_6719 = new cjs.Shape();
	this.shape_6719.graphics.f("#000000").s().p("AA4CYIhPhrIgkAfIAABMIgTAAIAAkvIATAAIgBDRIABAAIBrh2IAYAAIhTBaIBaB6g");
	this.shape_6719.setTransform(176,808.8,0.5,0.5);

	this.shape_6720 = new cjs.Shape();
	this.shape_6720.graphics.f("#000000").s().p("AgNB3QgOgPAAggIAAiIIgfAAIAAgMIAfgJIAJgwIAKAAIAAA0IA+AAIAAARIg+AAIAACFQABAYAHAMQAJAMASAAQATAAAOgDIAAAPQgOAFgTAAQgbAAgNgPg");
	this.shape_6720.setTransform(166.8,809.9,0.5,0.5);

	this.shape_6721 = new cjs.Shape();
	this.shape_6721.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIAogBIAAgOQAAgegMgQQgMgPgcAAQgcAAggAQIgHgRQAjgQAhAAQAjAAARASQASATAAAmIAACMIgPAAIgEgiIgCAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgTALAAAZQAAAUAMALQALALAXAAQAhAAAUgTQAUgTAAgjIAAgUg");
	this.shape_6721.setTransform(158,811.1,0.5,0.5);

	this.shape_6722 = new cjs.Shape();
	this.shape_6722.graphics.f("#000000").s().p("ABJCPIg/jcQgHgagEgSQgDARgGAWQgFAXg6DKIgQAAIhPkdIAWAAIBCD9QAEgWAQg7IAxisIAVAAIA5DGQALAmADARQADgQAEgOIA8jfIAVAAIhQEdg");
	this.shape_6722.setTransform(144.1,809.2,0.5,0.5);

	this.shape_6723 = new cjs.Shape();
	this.shape_6723.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAgfAagSQAagQAwgBIApgBIAAgOQAAgegNgQQgMgPgbAAQgdAAgfAQIgIgRQAkgQAhAAQAiAAASASQARATAAAmIAACMIgOAAIgGgiIgBAAQgQAVgRAIQgQAJgXAAQggAAgQgQgAAXAAQgsACgSAMQgUALAAAZQAAAUANALQAMALAWAAQAhAAAUgTQATgUAAgiIAAgUg");
	this.shape_6723.setTransform(124.3,811.1,0.5,0.5);

	this.shape_6724 = new cjs.Shape();
	this.shape_6724.graphics.f("#000000").s().p("Ag3BsIAAjTIAQAAIACAmIABAAQAOgYAOgJQAOgJAVAAQAMAAARACIgEATQgMgDgPAAQgaAAgSAXQgRAXAAAjIAAB0g");
	this.shape_6724.setTransform(116.2,811,0.5,0.5);

	this.shape_6725 = new cjs.Shape();
	this.shape_6725.graphics.f("#000000").s().p("AhBB/QgXgcAAg0QgBg2AXgdQAXgdAsAAQAXAAARAIQAQAJANAUIABAAIgBh9IATAAIAAEvIgMAAIgFggIgCAAQgXAkguAAQgrAAgXgbgAgygXQgSAXAAAvQAABaBFAAQAkAAAQgVQASgVgBgwIAAgDQAAgwgQgWQgRgWgkAAQgjAAgQAZg");
	this.shape_6725.setTransform(105.3,808.9,0.5,0.5);

	this.shape_6726 = new cjs.Shape();
	this.shape_6726.graphics.f("#000000").s().p("ABBBsIAAiJQAAgggOgOQgNgPgdAAQglAAgSATQgRATAAAsIAAB0IgUAAIAAjTIARAAIADAdIACAAQAUghA1AAQBHAAABBNIAACKg");
	this.shape_6726.setTransform(93.9,811,0.5,0.5);

	this.shape_6727 = new cjs.Shape();
	this.shape_6727.graphics.f("#000000").s().p("Ag9BeQgSgQAAgcQAAggAagRQAagQAwgBIApgBIAAgOQAAgdgNgRQgMgPgbAAQgcAAghAQIgHgRQAkgQAgAAQAkAAARASQARASAAAnIAACMIgOAAIgFgiIgCAAQgPAVgSAIQgPAJgYAAQggAAgQgQgAAYAAQgsACgTAMQgTALAAAZQAAAUAMALQAMALAXAAQAhAAATgTQAUgUAAgiIAAgUg");
	this.shape_6727.setTransform(82.2,811.1,0.5,0.5);

	this.shape_6728 = new cjs.Shape();
	this.shape_6728.graphics.f("#000000").s().p("ABDBqIhDhfIhCBfIgWAAIBNhsIhKhnIAWAAIA/BZIA+hZIAWAAIhJBnIBOBsg");
	this.shape_6728.setTransform(72.3,811.1,0.5,0.5);

	this.shape_6729 = new cjs.Shape();
	this.shape_6729.graphics.f("#000000").s().p("Ag7BRQgagcAAgzQAAgxAZggQAYgeAqAAQAmAAAVAaQAWAagBAtIAAAPIiXAAQAAAqAUAYQAUAYAlAAQAUAAALgDQAPgDAUgIIAAARQgQAJgRACQgNADgUAAQguAAgZgdgAgqhIQgTAWgDAlICCAAQAAgmgQgUQgPgVgdAAQgeAAgSAUg");
	this.shape_6729.setTransform(61.9,811.1,0.5,0.5);

	this.shape_6730 = new cjs.Shape();
	this.shape_6730.graphics.f("#000000").s().p("AgJCYIAAkvIASAAIAAEvg");
	this.shape_6730.setTransform(54.1,808.8,0.5,0.5);

	this.shape_6731 = new cjs.Shape();
	this.shape_6731.graphics.f("#000000").s().p("ABiCPIgphkIhzAAIgnBkIgWAAIBykeIANAAIBwEegAgKhNIgoBmIBlAAIgyiIQgEARgHARg");
	this.shape_6731.setTransform(45.9,809.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_6731},{t:this.shape_6730},{t:this.shape_6729},{t:this.shape_6728},{t:this.shape_6727},{t:this.shape_6726},{t:this.shape_6725},{t:this.shape_6724},{t:this.shape_6723},{t:this.shape_6722},{t:this.shape_6721},{t:this.shape_6720},{t:this.shape_6719},{t:this.shape_6718},{t:this.shape_6717},{t:this.shape_6716},{t:this.shape_6715},{t:this.shape_6714},{t:this.shape_6713},{t:this.shape_6712},{t:this.shape_6711},{t:this.shape_6710},{t:this.shape_6709},{t:this.shape_6708},{t:this.shape_6707},{t:this.shape_6706},{t:this.shape_6705},{t:this.shape_6704},{t:this.shape_6703},{t:this.shape_6702},{t:this.shape_6701},{t:this.shape_6700},{t:this.shape_6699},{t:this.shape_6698},{t:this.shape_6697},{t:this.shape_6696},{t:this.shape_6695},{t:this.shape_6694},{t:this.shape_6693},{t:this.shape_6692},{t:this.shape_6691},{t:this.shape_6690},{t:this.shape_6689},{t:this.shape_6688},{t:this.shape_6687},{t:this.shape_6686},{t:this.shape_6685},{t:this.instance_27},{t:this.shape_6684},{t:this.shape_6683},{t:this.shape_6682},{t:this.shape_6681},{t:this.shape_6680},{t:this.shape_6679},{t:this.shape_6678},{t:this.shape_6677},{t:this.shape_6676},{t:this.shape_6675},{t:this.shape_6674},{t:this.shape_6673},{t:this.shape_6672},{t:this.shape_6671},{t:this.shape_6670},{t:this.shape_6669},{t:this.shape_6668},{t:this.shape_6667},{t:this.shape_6666},{t:this.shape_6665},{t:this.shape_6664},{t:this.shape_6663},{t:this.shape_6662},{t:this.shape_6661},{t:this.shape_6660},{t:this.shape_6659},{t:this.shape_6658},{t:this.shape_6657},{t:this.shape_6656},{t:this.shape_6655},{t:this.shape_6654},{t:this.shape_6653},{t:this.shape_6652},{t:this.shape_6651},{t:this.shape_6650},{t:this.shape_6649},{t:this.shape_6648},{t:this.shape_6647},{t:this.shape_6646},{t:this.shape_6645},{t:this.shape_6644},{t:this.shape_6643},{t:this.shape_6642},{t:this.shape_6641},{t:this.shape_6640},{t:this.shape_6639},{t:this.shape_6638},{t:this.shape_6637},{t:this.shape_6636},{t:this.shape_6635},{t:this.shape_6634},{t:this.shape_6633},{t:this.shape_6632},{t:this.shape_6631},{t:this.shape_6630},{t:this.shape_6629},{t:this.shape_6628},{t:this.shape_6627},{t:this.shape_6626},{t:this.shape_6625},{t:this.shape_6624},{t:this.shape_6623},{t:this.shape_6622},{t:this.shape_6621},{t:this.shape_6620},{t:this.shape_6619},{t:this.shape_6618},{t:this.shape_6617},{t:this.shape_6616},{t:this.shape_6615},{t:this.shape_6614},{t:this.shape_6613},{t:this.shape_6612},{t:this.shape_6611},{t:this.shape_6610},{t:this.shape_6609},{t:this.shape_6608},{t:this.shape_6607},{t:this.shape_6606},{t:this.shape_6605},{t:this.shape_6604},{t:this.shape_6603},{t:this.shape_6602},{t:this.shape_6601},{t:this.shape_6600},{t:this.shape_6599},{t:this.shape_6598},{t:this.shape_6597},{t:this.shape_6596},{t:this.shape_6595},{t:this.shape_6594},{t:this.shape_6593},{t:this.shape_6592},{t:this.shape_6591},{t:this.shape_6590},{t:this.shape_6589},{t:this.shape_6588},{t:this.shape_6587},{t:this.shape_6586},{t:this.shape_6585},{t:this.shape_6584},{t:this.shape_6583},{t:this.shape_6582},{t:this.shape_6581},{t:this.shape_6580},{t:this.shape_6579},{t:this.shape_6578},{t:this.shape_6577},{t:this.shape_6576},{t:this.shape_6575},{t:this.shape_6574},{t:this.shape_6573},{t:this.shape_6572},{t:this.shape_6571},{t:this.shape_6570},{t:this.shape_6569},{t:this.shape_6568},{t:this.shape_6567},{t:this.shape_6566},{t:this.shape_6565},{t:this.shape_6564},{t:this.shape_6563},{t:this.shape_6562},{t:this.shape_6561},{t:this.shape_6560},{t:this.shape_6559},{t:this.shape_6558},{t:this.shape_6557},{t:this.shape_6556},{t:this.shape_6555},{t:this.shape_6554},{t:this.shape_6553},{t:this.shape_6552},{t:this.shape_6551},{t:this.shape_6550},{t:this.shape_6549},{t:this.shape_6548},{t:this.shape_6547},{t:this.shape_6546},{t:this.shape_6545},{t:this.shape_6544},{t:this.shape_6543},{t:this.shape_6542},{t:this.shape_6541},{t:this.shape_6540},{t:this.shape_6539},{t:this.shape_6538},{t:this.shape_6537},{t:this.shape_6536},{t:this.shape_6535},{t:this.shape_6534},{t:this.shape_6533},{t:this.shape_6532},{t:this.shape_6531},{t:this.shape_6530},{t:this.shape_6529},{t:this.shape_6528},{t:this.shape_6527},{t:this.shape_6526},{t:this.shape_6525},{t:this.shape_6524},{t:this.shape_6523},{t:this.shape_6522},{t:this.shape_6521},{t:this.shape_6520},{t:this.shape_6519},{t:this.shape_6518},{t:this.shape_6517},{t:this.shape_6516},{t:this.shape_6515},{t:this.shape_6514},{t:this.shape_6513},{t:this.shape_6512},{t:this.shape_6511},{t:this.shape_6510},{t:this.shape_6509},{t:this.shape_6508},{t:this.shape_6507},{t:this.shape_6506},{t:this.shape_6505},{t:this.shape_6504},{t:this.shape_6503},{t:this.shape_6502},{t:this.shape_6501},{t:this.shape_6500},{t:this.shape_6499},{t:this.shape_6498},{t:this.shape_6497},{t:this.shape_6496},{t:this.shape_6495},{t:this.shape_6494},{t:this.shape_6493},{t:this.shape_6492},{t:this.shape_6491},{t:this.shape_6490},{t:this.shape_6489},{t:this.shape_6488},{t:this.shape_6487},{t:this.shape_6486},{t:this.shape_6485},{t:this.shape_6484},{t:this.shape_6483},{t:this.shape_6482},{t:this.shape_6481},{t:this.shape_6480},{t:this.shape_6479},{t:this.shape_6478},{t:this.shape_6477},{t:this.shape_6476},{t:this.shape_6475},{t:this.shape_6474},{t:this.shape_6473},{t:this.shape_6472},{t:this.shape_6471},{t:this.shape_6470},{t:this.shape_6469},{t:this.shape_6468},{t:this.shape_6467},{t:this.shape_6466},{t:this.shape_6465},{t:this.shape_6464},{t:this.shape_6463},{t:this.shape_6462},{t:this.shape_6461},{t:this.shape_6460},{t:this.shape_6459},{t:this.shape_6458},{t:this.shape_6457},{t:this.shape_6456},{t:this.shape_6455},{t:this.shape_6454},{t:this.shape_6453},{t:this.shape_6452},{t:this.shape_6451},{t:this.shape_6450},{t:this.shape_6449},{t:this.shape_6448},{t:this.shape_6447},{t:this.shape_6446},{t:this.shape_6445},{t:this.shape_6444},{t:this.shape_6443},{t:this.shape_6442},{t:this.shape_6441},{t:this.shape_6440},{t:this.shape_6439},{t:this.shape_6438},{t:this.shape_6437},{t:this.shape_6436},{t:this.shape_6435},{t:this.shape_6434},{t:this.shape_6433},{t:this.shape_6432},{t:this.shape_6431},{t:this.shape_6430},{t:this.shape_6429},{t:this.shape_6428},{t:this.shape_6427},{t:this.shape_6426},{t:this.shape_6425},{t:this.shape_6424},{t:this.shape_6423},{t:this.shape_6422},{t:this.shape_6421},{t:this.shape_6420},{t:this.shape_6419},{t:this.shape_6418},{t:this.shape_6417},{t:this.shape_6416},{t:this.shape_6415},{t:this.shape_6414},{t:this.shape_6413},{t:this.shape_6412},{t:this.shape_6411},{t:this.shape_6410},{t:this.shape_6409},{t:this.shape_6408},{t:this.shape_6407},{t:this.shape_6406},{t:this.shape_6405},{t:this.shape_6404},{t:this.shape_6403},{t:this.shape_6402},{t:this.shape_6401},{t:this.shape_6400},{t:this.shape_6399},{t:this.shape_6398},{t:this.shape_6397},{t:this.shape_6396},{t:this.shape_6395},{t:this.shape_6394},{t:this.shape_6393},{t:this.shape_6392},{t:this.shape_6391},{t:this.shape_6390},{t:this.shape_6389},{t:this.shape_6388},{t:this.shape_6387},{t:this.shape_6386},{t:this.shape_6385},{t:this.shape_6384},{t:this.shape_6383},{t:this.shape_6382},{t:this.shape_6381},{t:this.shape_6380},{t:this.shape_6379},{t:this.shape_6378},{t:this.shape_6377},{t:this.shape_6376},{t:this.shape_6375},{t:this.shape_6374},{t:this.shape_6373},{t:this.shape_6372},{t:this.shape_6371},{t:this.shape_6370},{t:this.shape_6369},{t:this.shape_6368},{t:this.shape_6367},{t:this.shape_6366},{t:this.shape_6365},{t:this.shape_6364},{t:this.shape_6363},{t:this.shape_6362},{t:this.shape_6361},{t:this.shape_6360},{t:this.shape_6359},{t:this.shape_6358},{t:this.shape_6357},{t:this.shape_6356},{t:this.shape_6355},{t:this.shape_6354},{t:this.shape_6353},{t:this.shape_6352},{t:this.shape_6351},{t:this.shape_6350},{t:this.shape_6349},{t:this.shape_6348},{t:this.shape_6347},{t:this.shape_6346},{t:this.shape_6345},{t:this.shape_6344}]},51).to({state:[]},1).wait(113));

	// ButtonLeftRight copy 10
	this.buttonR3 = new lib.ButtonLeft_Right();
	this.buttonR3.name = "buttonR3";
	this.buttonR3.parent = this;
	this.buttonR3.setTransform(2025,513.5,1,1,180);
	this.buttonR3._off = true;
	new cjs.ButtonHelper(this.buttonR3, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR3).wait(50).to({_off:false},0).to({_off:true},1).wait(114));

	// Layer_52 copy 3
	this.buttonL3 = new lib.ButtonLeft_Right();
	this.buttonL3.name = "buttonL3";
	this.buttonL3.parent = this;
	this.buttonL3.setTransform(0,437.3);
	this.buttonL3._off = true;
	new cjs.ButtonHelper(this.buttonL3, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL3).wait(50).to({_off:false},0).to({_off:true},1).wait(114));

	// Layer 1
	this.shape_6732 = new cjs.Shape();
	this.shape_6732.graphics.f("#000000").s().p("AhsEzQg7gagogsQgpgsgXhAQgWg/gBhIQAAhIAYg6QAXg9AogrQAogrA2gYQA4gYA9AAQBJAAA3AaQA2AaAlAqQAkArASA1QASA2AAA3IAAAaIouAAQAAA5AQA3QARA4AjAsQAiAsA2AbQA0AcBIAAQBJAAA5geQA6gdApg4IAXATQgvA8g9AgQg/AfhRAAQhEAAg5gZgAh2kUQgyAeggAqQghAsgPAuQgOAvAAAjIIOAAQgBg9gTgyQgWg0ghgjQghgjgwgUQgwgUg6AAQhGAAgyAdg");
	this.shape_6732.setTransform(301.5,480.5,0.5,0.5);

	this.shape_6733 = new cjs.Shape();
	this.shape_6733.graphics.f("#000000").s().p("AgtIKIAApXIiEAAIAAgZICEAAIAAjhQgBg6AOglQAOglAYgXQAXgVAdgJQAcgJAdAAQAlAAAaAIIgGAXIgbgFQgMgCgRAAQglAAgZAPQgZAPgRAYQgOAYgHAeQgHAfAAAeIAADiICpAAIAAAZIipAAIAAJXg");
	this.shape_6733.setTransform(273.8,470,0.5,0.5);

	this.shape_6734 = new cjs.Shape();
	this.shape_6734.graphics.f("#000000").s().p("AgOHRIAApxIAdAAIAAJxgAgVmVQgJgJAAgQQAAgPAJgJQAKgKALAAQANAAAJAKQAJAIAAAQQAAARgKAIQgKAKgLAAQgLAAgKgKg");
	this.shape_6734.setTransform(255.6,472.9,0.5,0.5);

	this.shape_6735 = new cjs.Shape();
	this.shape_6735.graphics.f("#000000").s().p("Aj+HhIAAvCIAfAAIAAOnIHeAAIAAAbg");
	this.shape_6735.setTransform(234,472.1,0.5,0.5);

	this.shape_6736 = new cjs.Shape();
	this.shape_6736.graphics.f("#000000").s().p("AjmHbQgTgEgJgDIAJgaIAWAFQAPADANAAQAdAAAVgLQAUgKAQgSQAPgQAKgWQANgdAFgPIA8ijIj4qCIAhAAIDlJgIDepgIAgAAIk1M/QgWA7gjAfQgkAgg6AAQgLAAgRgCg");
	this.shape_6736.setTransform(182.6,488.7,0.5,0.5);

	this.shape_6737 = new cjs.Shape();
	this.shape_6737.graphics.f("#000000").s().p("AgOICIAAwDIAdAAIAAQDg");
	this.shape_6737.setTransform(160.3,470.5,0.5,0.5);

	this.shape_6738 = new cjs.Shape();
	this.shape_6738.graphics.f("#000000").s().p("AiEFCIgEpOQAAgRgDgRIAfAAIAFCkIADAAQAbhhA7gsQA7gqBGAAIAYABIAAAaIgKgCIgIAAQg7AAgrAbQgoAbgcAqQgcAsgMA0QgNA1AAAzIAAFCg");
	this.shape_6738.setTransform(144.9,480,0.5,0.5);

	this.shape_6739 = new cjs.Shape();
	this.shape_6739.graphics.f("#000000").s().p("AhuFBQglgLgegWQgegVgSgiQgTgiAAgvQAAhCAjgpQAigpA0gVQA1gXA6gHQA4gGAzAAIBtAAIAAgzQAAhpg4gwQg4gwhZAAQg3AAgwAUQgvAUgoAjIgQgXQAsgnA3gTQA3gUA0AAQBsAAA9A3QA+A3AAB3IAAERQAAAnADAlIAIBCIgdAAQgCgKgCgYIgDgoIgDgqIgBgiIgEAAQgbBWhDApQhDAqhKAAQgnAAglgLgAAAgVQg7AGguASQgvASgfAkQgfAjAAA8QAAAsARAdQARAeAbARQAZARAhAJQAfAIAeAAQBEAAAugaQAugaAcgoQAcgoALgwQALgwAAgvIAAg7IhhAAQg1AAg2AHg");
	this.shape_6739.setTransform(113,480.5,0.5,0.5);

	this.shape_6740 = new cjs.Shape();
	this.shape_6740.graphics.f("#000000").s().p("AkjHhIAAvCIIxAAIAAAcIoTAAIAAGnIH0AAIAAAbIn0AAIAAHJIIpAAIAAAbg");
	this.shape_6740.setTransform(77.9,472.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.shape_6740},{t:this.shape_6739},{t:this.shape_6738},{t:this.shape_6737},{t:this.shape_6736},{t:this.shape_6735},{t:this.shape_6734},{t:this.shape_6733},{t:this.shape_6732}]},50).to({state:[]},1).wait(114));

	// ButtonLeftRight copy 6
	this.buttonR_2 = new lib.ButtonLeft_Right();
	this.buttonR_2.name = "buttonR_2";
	this.buttonR_2.parent = this;
	this.buttonR_2.setTransform(2025,513.5,1,1,180);
	new cjs.ButtonHelper(this.buttonR_2, 0, 1, 1);

	this.buttonR2 = new lib.ButtonLeft_Right();
	this.buttonR2.name = "buttonR2";
	this.buttonR2.parent = this;
	this.buttonR2.setTransform(2025,513.5,1,1,180);
	new cjs.ButtonHelper(this.buttonR2, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.buttonR_2}]},2).to({state:[{t:this.buttonR2}]},47).to({state:[]},1).wait(115));

	// ButtonLeftRight
	this.buttonL2 = new lib.ButtonLeft_Right();
	this.buttonL2.name = "buttonL2";
	this.buttonL2.parent = this;
	this.buttonL2.setTransform(0,437.2);
	this.buttonL2._off = true;
	new cjs.ButtonHelper(this.buttonL2, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL2).wait(2).to({_off:false},0).to({_off:true},48).wait(115));

	// Layer_7
	this.bridge__drawing = new lib.bridhe_drawing();
	this.bridge__drawing.name = "bridge__drawing";
	this.bridge__drawing.parent = this;
	this.bridge__drawing.setTransform(1003,493.5,1,1,0,0,0,1022,493.5);
	this.bridge__drawing._off = true;

	this.timeline.addTween(cjs.Tween.get(this.bridge__drawing).wait(2).to({_off:false},0).wait(19).to({alpha:0},17).to({_off:true},1).wait(126));

	// Layer 1
	this.bracelet_bridge = new lib.bridgebracelt();
	this.bracelet_bridge.name = "bracelet_bridge";
	this.bracelet_bridge.parent = this;
	this.bracelet_bridge.setTransform(740.1,488.4,1,1,0,0,0,702.6,366.4);
	this.bracelet_bridge.alpha = 0;
	this.bracelet_bridge._off = true;

	this.timeline.addTween(cjs.Tween.get(this.bracelet_bridge).wait(25).to({_off:false},0).to({alpha:1},15).wait(9).to({_off:true},1).wait(115));

	// ButtonLeftRight copy 12
	this.buttonL1 = new lib.ButtonLeft_Right();
	this.buttonL1.name = "buttonL1";
	this.buttonL1.parent = this;
	this.buttonL1.setTransform(0,437.2);
	this.buttonL1._off = true;
	new cjs.ButtonHelper(this.buttonL1, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonL1).wait(1).to({_off:false},0).to({_off:true},1).wait(163));

	// ButtonLeftRight copy 13
	this.buttonR1 = new lib.ButtonLeft_Right();
	this.buttonR1.name = "buttonR1";
	this.buttonR1.parent = this;
	this.buttonR1.setTransform(2025,513.5,1,1,180);
	this.buttonR1._off = true;
	new cjs.ButtonHelper(this.buttonR1, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.buttonR1).wait(1).to({_off:false},0).to({_off:true},1).wait(163));

	// stone image
	this.instance_28 = new lib.Stone_twins();
	this.instance_28.parent = this;
	this.instance_28.setTransform(1152,71,0.806,0.806);
	this.instance_28._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_28).wait(1).to({_off:false},0).to({_off:true},1).wait(163));

	// Layer 1
	this.shape_6741 = new cjs.Shape();
	this.shape_6741.graphics.f("#000000").s().p("EgYvAimIAAgIQAGABAGAAQAFAAAEgCQAEgDADgEQADgGAEgLIAFgNIgohqIAKAAIAWA7IANAlIABAAIAjhgIAKAAIgvB7QgGAPgEAGQgDAEgGADQgFADgIAAQgFAAgHgCgEgiOAimIAAgIQAGABAGAAQAFAAAEgCQAEgDADgEQADgEAEgNIAFgNIgohqIAKAAIAWA7IANAlIABAAIAkhgIAKAAIgwB7QgGAPgEAGQgEAEgFADQgFADgHAAQgGAAgHgCgEgNGAhwQAAgJAIAAQAIAAAAAJQAAAKgIAAQgIAAAAgKgEgPYAhrQgNgOAAgZQAAgaAMgPQANgPAVAAQATAAALAMQAKAOAAAWIAAAIIhMAAQAAAWAKAMQAKALATAAQAKAAAGgBQAHgBAKgFIAAAJQgIAEgIACIgRABQgXgBgNgOgEgPQAgfQgJAJgBAUIBBAAQAAgTgIgKQgIgLgOAAQgPAAgKALgEgStAhrQgNgOAAgZQAAgbANgPQANgOAYAAQAOAAAMAEIgCAJQgOgFgKABQgUAAgKAMQgKAMAAAWQAAAWAKAMQAKAMASAAQAOAAANgFIAAAIQgKAGgRAAQgWgBgNgOgEgZ2AhrQgNgOAAgZQAAgcAOgOQANgOAXAAQAOAAANAEIgDAJQgOgFgKABQgTAAgLAMQgKAMAAAWQAAAVAKANQALAMASAAQAOAAAMgFIAAAIQgJAGgRAAQgXgBgNgOgEgdcAhyQgJgIAAgPQAAgPANgIQANgJAZAAIAUgBIAAgHQAAgQgGgHQgGgIgOAAQgPAAgQAIIgDgIQASgIAQAAQASAAAIAJQAJAJAAATIAABHIgHAAIgDgRIAAAAQgIAKgJAEQgIAFgMAAQgPgBgJgHgEgcxAhDQgXABgJAFQgJAGAAANQAAAKAGAFQAFAGAMAAQARAAAKgKQAJgKAAgRIAAgKgEgjcAh1QgIgFgGgIIgBAAIgCAQIgHAAIAAiYIAKAAIgBA+IABAAQAGgJAJgFQAIgFAMABQAXAAALANQALAPAAAbQAAAagMAOQgLAOgWABQgLgBgKgEgEgjiAgfQgIALAAAZIAAABQAAAYAJALQAIAKASAAQARAAAJgMQAJgNAAgVQAAgvgjABQgTgBgIALgEgm4Ah0IAAgKQAPAGAYABQARgBALgHQAKgJAAgMQAAgJgDgFQgEgFgHgFIgXgJQgXgIgHgJQgJgIAAgPQAAgPANgLQAMgKAUAAQAVAAARAHIgEAJQgSgIgQAAQgPAAgKAIQgJAHAAANQAAAJADAEQADAFAGAEQAHAFAQAFQARAFAIAGQAIAFAEAIQAEAGAAAKQAAASgNALQgOAJgVABQgbgBgNgFgEg1PAhmQgRgUAAgiQAAgiARgTQARgUAeAAQAeAAARAUQARAUAAAhQAAAigRAUQgRAUgeAAQgeAAgRgUgEg1HAgBQgOARAAAeQAAAeAOASQANAQAaABQAaAAANgRQAOgRAAgfQAAgfgOgQQgNgQgaAAQgaAAgNAQgEg43Ah0IAAgKQAPAGAYABQARgBALgHQAKgJAAgMQAAgJgDgFQgEgFgHgFIgXgJQgWgIgIgJQgJgIAAgPQAAgPANgLQANgKATAAQAVAAARAHIgEAJQgRgIgRAAQgPAAgKAIQgJAHAAANQAAAIADAFQADAFAGAEQAHAFAQAFQARAFAIAGQAIAFAEAIQAEAGAAAKQAAASgNALQgOAJgVABQgbgBgNgFgEgNxAh4IAAiYIAJAAIAACYgEgQLAh4IAAhFQAAgQgHgIQgGgGgPAAQgSgBgKAKQgIAKAAAVIAAA7IgKAAIAAiYIAKAAIgBA+IABAAQAGgKAJgEQAJgFANABQAlAAAAAnIAABFgEgThAh4IAAhqIAJAAIAABqgEgURAh4IAAhsIABgYIgBAAIg1CEIgHAAIg1iEIgBAAIABAZIAABrIgJAAIAAiPIAPAAIAzB+IAAAAIAzh+IAPAAIAACPgEgapAh4IAAhFQAAgQgGgIQgHgGgOAAQgTgBgJAKQgJAKAAAVIAAA7IgKAAIAAhqIAJAAIABAOIABAAQAKgQAbAAQAkAAAAAnIAABFgEgeNAh4IhUh/IgBAAIABAiIAABdIgJAAIAAiPIAKAAIBUB/IABAAIgBh/IAJAAIAACPgEgniAh4IhUh/IgBAAIABAiIAABdIgJAAIAAiPIAKAAIBUB/IABAAIgBh/IAKAAIAACPgEgpyAh4IAAiPIAKAAIAACPgEgq7Ah4IgliEIgkCEIgIAAIgniPIAKAAIAiB/QACgOAHgbIAZhWIALAAIAdBkIAHAbIAhh/IAKAAIgnCPgEgtyAh4IAAiFIguAAIAAgKIBnAAIAAAKIgvAAIAACFgEgwvAh4IAAiPIBOAAIAAAJIhEAAIAAA2IBAAAIAAAKIhAAAIAAA9IBEAAIAAAJgEgxiAh4IhUh/IgBAAIABAiIAABdIgJAAIAAiPIAKAAIBUB/IABAAIgBgiIAAhdIAJAAIAACPgEg2mAh4IAAiFIguAAIAAgKIBnAAIAAAKIgvAAIAACFgEglTAgaIAKgxIAMAAIABACQgHAZgKAWgEg5bAgaIgBgCIAIgZIAJgWIAGAAIgGAZIgFAYgAzjfwQAAgJAHAAQABAAAAAAQABAAAAAAQABABAAAAQABAAAAABQACADAAAEQAAAEgCADQgBADgDAAQgHAAAAgKgA4th3QAAgLAKgBQAKABAAALQAAANgKAAQgKAAAAgNgA/ZiCQgOgYAAguQAAgwAOgWQAOgYAeAAQAdAAAPAYQAPAYAAAuQAAAwgPAXQgPAXgdAAQgdAAgPgYgA/PkFQgLAUAAApQAAAqALAUQALAVAXAAQAXgBALgUQALgVAAgpQAAgpgLgUQgLgWgXAAQgYAAgKAWgEgpGgByQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAPATAAAgQAAAigQATQgQASgcAAQgSAAgNgIgEgpJgDcQgMAQAAAbQAAAcAMAQQAMAPAXABQAWgBAMgPQAMgQAAgcQAAgbgMgQQgMgPgXgBQgWABgMAPgEgslgB7QgPgSAAgiQAAgiAPgTQAPgTAcAAQAOABALAFQALAGAIAMIABAAIgBgfIAAgwIAMAAIAADCIgIAAIgDgVIgBAAQgPAXgdAAQgcAAgPgRgEgscgDcQgLAQAAAdQAAA6AtAAQAXAAAKgOQALgNAAgfIAAgCQAAgegKgPQgLgOgXAAQgXABgLAPgEgvEgCcIAAhYIAMAAIAABXQAAAWAJAJQAIAIATABQAYAAALgNQAMgMAAgbIAAhLIAMAAIAACIIgLAAIgCgTIgBAAQgNAVgiAAQguAAAAgygEgwPgBzQgIgLAAgUIAAhXIgUAAIAAgHIAUgGIAGgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAGAIQAFAHAMAAQANAAAHgCIAAAKQgJADgLAAQgSAAgJgJgEgybgByIAAgOQAVALAWAAQAUAAALgHQAKgHAAgLQAAgKgIgHQgIgHgTgHQgUgHgJgGQgIgEgEgHQgEgHAAgJQAAgQAMgJQANgIAXgBQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAGAAAKQAAAKAIAHQAHAGAWAHQATAIAIAFQAIAFAEAHQAEAGAAAJQAAASgNAKQgOAKgaAAQgbAAgQgIgEg1UgB8QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAOgGIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgEg1JgDeQgMAMgCAYIBUAAQAAgXgKgNQgLgOgSAAQgTAAgMAOgEg5AgBzQgIgLAAgUIAAhXIgUAAIAAgHIAUgGIAGgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAGAIQAGAHALAAQANAAAIgCIAAAKQgJADgMAAQgSAAgJgJgA5whsIAAgvIhdAAIAAgJIBaiAIAPAAIAAB+IAfAAIAAALIgfAAIAAAvgA6+imIBOAAIAAg0QAAgnACgYIgBAAgA8bhsIAAiFIABglIgEADIgmAeIgHgJIAxglIALAAIAAC3gEgh5gBsIAAgMIAwgyQAVgVAIgMQAIgLAEgKQAEgJAAgNQAAgPgLgLQgLgKgRAAQgWAAgVAQIgHgIQAXgTAcAAQAXAAAOAMQAOANAAAWQAAATgJAQQgKASgYAYIgvAwIAAAAIBiAAIAAANgEgjrgBsIAAhYQAAgVgIgJQgJgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAiIIAKAAIADATIAAAAQAOgWAhAAQAuABAAAxIAABZgEgmDgBsIAAiIIAMAAIAACIgEgqUgBsIAAiIIAMAAIAACIgEg2VgBsIAAhYQAAgVgIgJQgJgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAjCIAMAAIAABPIAAAAQAIgMAMgGQAMgFAQgBQAuABAAAxIAABZgEgmFgEaQAAgMAIAAQAEAAACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgEgqWgEaQAAgMAIAAQAEAAACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgEA4AgG3QgOgKAAgSQAAgOAIgJQAJgKAPgDQgGgCgEgFQgEgFAAgGQAAgOASgKQgMgFgHgLQgGgJAAgOQAAgVANgMQANgMAVAAQANAAAIACIArAAIAAAJIgcACQAMAOAAARQAAATgNAMQgNAMgWAAIgNgBQgIAFgDAEQgEAGAAAGQAAAGAFAEQAFADALAAIAYAAQAWAAAMAIQALAJAAASQAAAVgRAMQgRALghAAQgZAAgOgJgEA3/gHUQAAAcApAAQA2gBAAghQAAgMgJgGQgIgGgTAAIgWAAQglAAAAAegEA4TgJiQgKAKAAAQQAAAPAKAJQAJAJAQAAQARAAAJgJQAJgJAAgPQAAgSgJgIQgKgKgQABQgQAAgJAJgEgmpgGwIAAgLQAHACAIAAQAHAAAEgDQAFgDAEgHQAEgGAFgOIAHgRIg0iIIANAAIAcBMQANAjAEANIABAAIAth8IANAAIg9CeQgHATgFAGQgFAIgHADQgGADgKAAQgHAAgIgCgEgtXgHAIAAgLQALACAIAAQAeAAAAghIAAi3IAMAAIAAC2QAAAugqAAQgMAAgHgDgAwfnKQAKglAEgZIAPAAIABACQgJAhgNAbgEAywgHxIAAgNQAUAKAXAAQAUAAAKgHQALgGAAgMQAAgJgJgIQgIgHgTgGQgUgIgIgFQgJgFgEgHQgEgHAAgJQAAgPANgJQANgJAXAAQAWAAATAIIgEAMQgUgJgRAAQgQAAgLAGQgJAFAAAKQAAALAHAGQAHAGAXAIQARAHAJAFQAJAFAEAHQAEAGAAAJQAAATgOAJQgOAKgZAAQgbAAgQgIgEAw7gHxQgNgJgIgQQgHgPAAgWQAAghAQgSQAQgTAcAAQAcAAAQATQAQASAAAhQAAAhgRATQgPASgdAAQgSAAgNgIgEAw4gJaQgMAQAAAbQAAAbAMAQQAMAQAXAAQAWAAAMgQQANgPAAgcQAAgcgNgPQgMgQgXAAQgWAAgMAQgEAt8gH7QgQgSAAghQAAghARgTQARgTAeAAQARAAAQAGIgDALQgRgGgOAAQgYAAgNAQQgNAPAAAdQAAAbANAPQAMAQAYAAQATAAAPgHIAAAMQgNAHgVgBQgdAAgRgSgEAqugH7QgQgSAAggQAAghAQgTQAQgUAbAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQANAPAXAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgEAq5gJdQgLAMgDAZIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgEAnBgHxQgOgJgHgQQgHgQAAgVQAAghAQgSQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgTAAgNgIgEAm+gJaQgMAPAAAcQAAAcAMAPQANAQAWAAQAXAAAMgQQAMgPAAgcQAAgcgMgPQgNgQgWAAQgWAAgNAQgEAjdgH7QgQgSAAggQAAghAQgTQAQgUAbAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQAMAPAYAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgEAjogJdQgLAMgDAZIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgEAhbgHuQgLgHgHgKIgBAAIgDAUIgIAAIAAjCIAMAAIgBBPIABAAQAIgLALgHQALgFAPAAQAcAAAPASQAOARAAAjQAAAigPASQgPASgcAAQgOAAgMgFgEAhTgJcQgKAOAAAfIAAACQAAAfALANQALANAWAAQAXAAALgPQALgPAAgdQAAg7gsAAQgYAAgLAOgAd5nsQgNgCgIgFIAAgMQAMAFAMAEQAKADAMgBQAYAAAPgMQAOgNAAgVQAAgVgOgLQgOgMgYAAQgQAAgSAFIgHgFIAHhTIBXAAIAAAMIhMAAIgFBAQATgEALABQAdgBARAOQARAOAAAaQAAAbgSAQQgRAPgfAAQgOAAgLgDgAZInsIAAgKQAGACAHAAIALABQAfAAASgWQARgWACgrIgBAAQgKAMgMAHQgNAGgNAAQgZAAgPgOQgOgOAAgaQAAgbAQgRQAPgRAZAAQASAAANAKQAOAJAHASQAHARAAAaQAAAlgJAXQgKAYgSAMQgRALgaAAQgNABgLgEgAZVqMQgLANAAAXQAAAXALALQALALAUgBQAMAAALgFQALgFAGgKQAHgKAAgIQAAgPgGgNQgGgMgKgIQgLgHgNAAQgUAAgMANgAQQnxQgOgJgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgRATQgQASgcAAQgSAAgNgIgAQNpaQgMAPAAAcQAAAbAMAQQAMAQAXAAQAWAAAMgQQANgQAAgbQAAgcgNgPQgMgQgXAAQgWAAgMAQgAKHnxIAAgNQAUAKAXAAQATAAALgHQALgGAAgMQAAgJgJgIQgHgHgUgGQgUgIgIgFQgJgFgEgHQgEgGAAgKQAAgPANgJQANgJAWAAQAWAAAUAIIgFAMQgTgJgSAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQATAHAIAFQAJAFAEAHQAEAHAAAIQAAATgOAJQgOAKgZAAQgbAAgQgIgAJGnyQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAHAAIAAAgIAnAAIAAALIgnAAIAABWQAAAQAFAHQAGAHALAAQANAAAIgBIAAAJQgJADgMAAQgSAAgJgJgAHxnyQgIgKAAgUIAAhYIgVAAIAAgHIAVgFIAGgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAFAHAMAAQAMAAAIgBIAAAJQgJADgLAAQgTAAgIgJgAFln7QgRgSAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAOQANAPAYAAQALAAAJgBQAIgBAOgHIAAAMQgLAFgKABQgJACgMAAQgeAAgQgSgAFwpdQgMAMgCAZIBUAAQAAgXgLgOQgKgNgSAAQgUAAgLANgADZnxIAAgNQAUAKAXAAQAUAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgVgIgIgFQgIgFgEgHQgFgHAAgJQAAgPANgJQANgJAXAAQAWAAATAIIgEAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAHAGQAHAGAXAIQASAHAJAFQAIAFAEAHQAEAGAAAJQAAATgOAJQgNAKgaAAQgbAAgQgIgABNoaIAAhZIANAAIAABYQAAAVAIAJQAJAJASAAQAYAAALgMQAMgNAAgbIAAhLIAMAAIAACIIgKAAIgDgSIAAAAQgOAVghgBQgvAAAAgxgAi3n7QgRgSAAghQAAghASgTQARgTAdAAQARAAARAGIgEALQgRgGgNAAQgZAAgNAQQgNAPAAAdQAAAbANAPQANAQAXAAQATAAAPgHIAAAMQgMAHgWgBQgdAAgQgSgAlGnzQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgTgIgKQgIgKgRAAQgTAAgUAKIgFgKQAWgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgKANgLAFQgKAGgPgBQgVAAgKgKgAkPovQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAVAAANgMQAMgNAAgVIAAgOgAnKnxIAAgNQAVAKAWAAQAUAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgIgFgEgHQgEgGAAgKQAAgPAMgJQANgJAXAAQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQATAHAIAFQAIAFAEAHQAEAHAAAIQAAATgNAJQgOAKgaAAQgbAAgQgIgApBnxIAAgNQAVAKAXAAQAUAAAKgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgHgFgFgHQgEgGAAgKQAAgPANgJQAMgJAXAAQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQATAHAIAFQAIAFAEAHQAFAHAAAIQAAASgOAKQgOAKgZAAQgbAAgRgIgAq7nzQgLgKAAgSQAAgUARgLQAQgLAfgBIAaAAIAAgJQAAgUgIgJQgHgKgSAAQgTAAgUAKIgFgKQAXgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgLANgKAFQgLAGgPgBQgUAAgLgKgAqEovQgcABgNAIQgMAIAAAPQAAANAIAHQAIAHAOAAQAWAAAMgMQANgNAAgVIAAgOgA0onxQgOgJgHgQQgHgQAAgVQAAghAQgSQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgQATQgRASgcAAQgSAAgNgIgA0rpaQgMAPAAAcQAAAcAMAPQAMAQAXAAQAWAAAMgQQANgPAAgcQAAgcgNgPQgMgQgXAAQgWAAgMAQgA2JnyQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAFAHAMAAQANAAAHgBIAAAJQgJADgLAAQgSAAgJgJgA4VnxIAAgNQAUAKAXAAQAUAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgIgFgEgHQgEgHAAgJQAAgPAMgJQANgJAXAAQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQASAHAJAFQAIAEAEAIQAEAGAAAJQAAATgNAJQgOAKgaAAQgbAAgQgIgA6KnxQgNgJgIgQQgHgQAAgVQAAggAQgTQARgTAbAAQAcAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgSAAgOgIgA6NpaQgMAPAAAcQAAAbAMAQQANAQAWAAQAXAAAMgQQAMgQAAgbQAAgcgMgPQgNgQgWAAQgXAAgMAQgEgkWgH7QgQgSAAggQAAgiAQgSQAQgUAbAAQAYAAAOARQANARAAAcIAAAKIhhAAQAAAbANAPQANAPAXAAQAMAAAJgBQAIgBAOgHIAAAMQgLAFgKABQgJACgNAAQgdAAgRgSgEgkLgJdQgLANgCAYIBTAAQAAgYgKgNQgKgNgSAAQgUAAgMANgEgrqgHzQgLgKAAgSQAAgUARgLQAQgLAfgBIAaAAIAAgJQAAgTgIgKQgHgKgSAAQgTAAgUAKIgFgKQAXgLAVAAQAXAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgLANgKAFQgLAGgPgBQgUAAgLgKgEgqzgIvQgcABgNAIQgMAIAAAPQAAANAIAHQAIAHAOAAQAWAAAMgMQANgNAAgVIAAgOgEgxSgH7QgRgSAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAOQANAPAYAAQAMAAAIgBQAIgBAOgHIAAAMQgLAFgKABQgJACgMAAQgeAAgQgSgEgxHgJdQgMAMgCAZIBUAAQAAgXgLgOQgKgNgSAAQgUAAgLANgEg1RgH7QgRgSAAggQAAghAQgTQAQgUAbAAQAYAAAOARQANARAAAcIAAAKIhhAAQAAAcANAOQANAPAYAAQALAAAJgBQAIgBAOgHIAAAMQgMAFgJABQgJACgMAAQgeAAgQgSgEg1GgJdQgMAMgCAZIBTAAQAAgXgKgOQgKgNgSAAQgUAAgLANgEg2ngHyQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAHAAIAAAgIAnAAIAAALIgnAAIAABWQAAAQAFAHQAGAHALAAQANAAAIgBIAAAJQgJADgMAAQgSAAgJgJgEA3LgHrIAAhYQAAgUgJgKQgIgJgSAAQgYAAgMAMQgLANAAAbIAABLIgNAAIAAiIIALAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgEA0zgHrIAAiIIAMAAIAACIgEAvtgHrIAAjCIAMAAIAADCgEApCgHrIAAiIIALAAIABAZIABAAQAJgQAJgFQAJgGAOAAIASACIgCALQgJgBgJAAQgRgBgLAPQgLAPAAAWIAABLgEAlngHrIAAh9IgaAAIAAgHIAagEIAAgLQAAgZAJgLQAJgMAVAAQALAAALADIgDALQgKgDgKAAQgOAAgGAJQgGAIAAATIAAAMIAgAAIAAALIggAAIAAB9gAbqnrIBLiqIhnAAIAAgMIB2AAIAAAJIhLCtgAXmnrIAAiFIACglIgEAEIgmAeIgIgJIAyglIALAAIAAC2gAU6nrIAAhZQAAgUgIgJQgHgJgQAAQgVAAgKALQgKAMAAAYIAABQIgNAAIAAhcQAAgjgfAAQgVAAgKAMQgKANAAAbIAABLIgMAAIAAiIIAKAAIADATIABAAQAFgKAKgGQALgFAMAAQAgAAAJAYIABAAQAHgMALgGQALgGAOAAQAWAAALAMQALALAAAaIAABZgAOYnrIAAiIIALAAIABAZIABAAQAIgPAKgGQAJgGAOAAIASACIgCALQgJgBgJAAQgRgBgLAPQgLAPAAAWIAABLgANSnrIAAh9IgZAAIAAgHIAZgEIAAgLQAAgZAJgLQAJgMAVAAQAMAAAKADIgCALQgKgDgKAAQgPAAgGAJQgGAIAAATIAAAMIAgAAIAAALIggAAIAAB9gAAXnrIAAhYQAAgUgJgKQgIgJgRAAQgYAAgMAMQgLANAAAbIAABLIgNAAIAAjCIANAAIgBBPIABAAQAHgLAMgHQAMgFARAAQAtAAAAAxIAABZgAr5nrIAAiKIACgeIgBAAIhECoIgIAAIhEioIgBAAIABAgIAACIIgMAAIAAi2IATAAIBBCgIABAAIBAigIATAAIAAC2gAxJnrIAAhYQAAgVgIgJQgJgJgSAAQgYAAgLAMQgMANAAAbIAABLIgMAAIAAiIIALAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgA87nrIAAi2IAyAAQAiAAAQALQAQAMAAAXQAAAQgKALQgJAKgTADIAAAAQAVAEALALQAKAKAAASQAAAagRAOQgQANgfAAgA8un2IArAAQAygBAAgpQAAglg1AAIgoAAgA8upQIAoAAQAaAAALgIQAMgKAAgRQAAgSgNgJQgNgIgaAAIglAAgA+4nrIAAhYQAAgVgJgJQgIgJgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAiIIAKAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgEghQgHrIAAiIIAMAAIAACIgEgnNgHrIAAiIIAMAAIAACIgEgoFgHrIAAhYQAAgUgJgKQgIgJgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAiIIAKAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgEgvPgHrIAAiIIALAAIABAZIABAAQAIgPAJgGQAKgGANAAIATACIgDALQgIgBgJAAQgRgBgMAPQgLAPAAAWIAABLgEgyVgHrIAAiIIANAAIAACIgEgzOgHrIAAjCIAMAAIAADCgEg3VgHrIgZhAIhKAAIgZBAIgOAAIBJi3IAIAAIBIC3gEg4agJ4IgZBBIBBAAIgghXIgIAWgEgj9gKFIAAgCIASgWQAKgLACgHIASAAIAAADIgPARIgYAWgEA0xgKYQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEghSgKYQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEgnPgKYQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEgyWgKYQAAgMAIAAQADAAADADQACADAAAGQAAAGgCADQgDADgDAAQgIAAAAgMgEAkhgM2QgOgKAAgSQAAgOAJgIQAJgKAOgEQgGgCgEgFQgDgEAAgHQAAgNARgKQgMgGgGgKQgHgKAAgOQAAgUANgMQANgMAWgBQANABAHACIAsAAIAAAIIgcADQALANAAARQAAAUgNAMQgNAMgWAAIgNgBQgHAEgEAFQgEAGAAAFQAAAHAFADQAFADALAAIAYAAQAWAAAMAIQALAKAAARQAAAVgRAMQgRALggAAQgaAAgOgJgEAkggNTQAAAcAqAAQA1AAAAgiQAAgMgIgGQgIgFgTAAIgXAAQglAAAAAdgEAk0gPhQgKAKAAAQQAAAQAKAJQAKAJAPAAQARAAAJgJQAJgJAAgQQAAgSgJgIQgJgJgRAAQgQAAgJAJgAdvs2QgOgKAAgSQAAgOAIgIQAJgKAPgEQgHgCgDgFQgEgEAAgHQAAgNASgKQgMgGgHgKQgGgKAAgOQAAgUANgMQANgMAVgBQANABAIACIArAAIAAAIIgcADQALANAAARQAAAUgNAMQgMAMgWAAIgNgBQgIAEgEAFQgDAGAAAFQAAAHAEADQAFADAMAAIAYAAQAWAAALAIQAMAKAAARQAAAVgRAMQgRALghAAQgZAAgOgJgAdutTQAAAcApAAQA1AAAAgiQAAgMgIgGQgIgFgTAAIgWAAQglAAAAAdgAeBvhQgJAKAAAQQAAAQAKAJQAJAJAQAAQARAAAJgJQAJgJAAgQQAAgSgJgIQgKgJgQAAQgQAAgKAJgAqmstIAAjEIALAAIACAUIABAAQAOgXAeAAQAcABAOARQAPATAAAiQAAAhgQATQgPASgaAAQgfAAgOgYIgBAAIABBSgAqOvbQgLANAAAdIAAAEQAAAgAKANQALAOAYAAQAVAAALgPQALgQAAgcQAAg7grgBQgXAAgLAOgA3Hs2QgOgKAAgSQAAgOAIgIQAJgKAPgEQgHgCgDgFQgEgEAAgHQAAgNASgKQgMgGgHgKQgGgKAAgOQAAgUANgMQANgMAVgBQANABAIACIArAAIAAAIIgcADQAMANAAARQAAAUgNAMQgNAMgWAAIgNgBQgIAEgEAFQgDAGAAAFQAAAHAEADQAGADALAAIAYAAQAWAAALAIQAMAKAAARQAAAVgRAMQgRALghAAQgZAAgOgJgA3ItTQAAAcApAAQA2AAAAgiQAAgMgJgGQgIgFgTAAIgWAAQglAAAAAdgA21vhQgJAKAAAQQAAAQAKAJQAJAJAQAAQARAAAJgJQAJgJAAgQQAAgSgJgIQgKgJgQAAQgQAAgKAJgEgu4gMvIAAgKQAIABAIAAQAGAAAFgCQAFgEAEgGQAEgGAFgOIAGgRIgziIIAMAAIAdBMQANAjADAMIABAAIARgvIAdhMIANAAIg9CdQgHATgFAHQgFAHgHADQgGADgKAAQgIAAgIgCgEg5rgMwIAAgKQAIACAIAAQASAAAAgVIAAikIANAAIAAChQAAASgIAIQgIAJgPAAQgKAAgGgDgEAzjgNwQgJgKAAgVIAAhXIgUAAIAAgHIAUgGIAHgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAFAIQAGAHAMAAQAMAAAIgCIAAAKQgJADgMAAQgRAAgJgJgEAxTgNxQgLgLAAgRQAAgVARgLQAQgKAfgBIAaAAIAAgJQAAgUgIgJQgHgLgSAAQgTAAgUALIgEgLQAWgLAWAAQAWABALAMQALAKAAAaIAABaIgJAAIgDgWIgBAAQgLANgKAFQgLAGgPAAQgUAAgLgKgEAyKgOuQgcABgNAJQgMAHAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgEAsqgN5QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAPgGIAAAMQgMAEgKACQgJACgMAAQgeAAgQgSgEAs1gPbQgMAMgCAYIBUAAQAAgXgKgNQgLgOgSAAQgTAAgMAOgEAo+gNwQgIgLAAgUIAAhXIgUAAIAAgHIAUgGIAGgeIAHAAIAAAgIAnAAIAAALIgnAAIAABVQAAAQAFAIQAGAHALAAQANAAAIgCIAAAKQgJADgMAAQgSAAgJgJgEAmygN5QgQgTAAggQAAghAQgTQAPgUAcAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAPQAMAPAYAAQAMAAAJgCQAIgBAOgGIAAAMQgMAEgJACQgJACgNAAQgdAAgRgSgEAm9gPbQgMAMgCAYIBUAAQAAgXgKgNQgKgOgSAAQgUAAgMAOgEAijgNvQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAigQATQgRASgcAAQgSAAgNgIgEAiggPZQgMAQAAAbQAAAcAMAQQAMAPAXABQAXgBALgPQANgQAAgcQAAgbgNgQQgMgQgWAAQgXAAgMAQgEAhCgNwQgIgKAAgVIAAhXIgUAAIAAgHIAUgGIAGgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAGAIQAGAHALAAQANAAAHgCIAAAKQgJADgLAAQgSAAgJgJgAVCtvQgNgJgIgRQgHgPAAgWQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgRAUQgPASgdAAQgSAAgNgIgAU/vZQgMAQAAAbQAAAcAMAQQAMAPAXABQAWgBAMgPQANgQAAgcQAAgbgNgQQgMgQgXAAQgWAAgMAQgAOwtvIAAgOQAUALAXAAQAUAAALgHQAKgHAAgLQAAgKgIgHQgIgHgUgHQgTgHgJgGQgIgEgEgHQgFgGAAgKQAAgQANgJQANgIAXgBQAWABATAHIgEAMQgUgJgRAAQgRAAgJAGQgKAGAAAKQAAAKAHAHQAHAGAXAHQASAHAIAGQAJAFAEAHQAEAGAAAJQAAATgOAJQgNAKgaAAQgbAAgQgIgALWt5QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAOgGIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgALhvbQgMAMgCAYIBUAAQAAgXgLgNQgKgOgSAAQgTAAgMAOgAJKt5QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAOgGIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgAJVvbQgMAMgCAYIBUAAQAAgXgLgNQgKgOgSAAQgTAAgMAOgAFXtxQgLgLAAgRQAAgVARgLQAQgKAggBIAZAAIAAgJQAAgUgIgJQgHgLgSAAQgTAAgUALIgEgLQAWgLAWAAQAWABALAMQALAKAAAaIAABaIgJAAIgDgWIgBAAQgLANgKAFQgLAGgPAAQgUAAgLgKgAGOuuQgcABgNAJQgMAHAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgADmt5QgQgTAAghQAAghARgTQARgTAdAAQARAAARAHIgDAKQgSgFgNgBQgZAAgMAQQgNAQAAAcQAAAcANAPQAMAPAXABQATAAAQgHIAAALQgNAHgVAAQgdAAgRgSgAght5QgQgTAAggQAAghAQgTQAQgUAaAAQAYAAAOARQANARAAAcIAAAKIhgAAQAAAcANAPQANAPAWAAQAMAAAJgCQAIgBAOgGIAAAMQgLAEgKACQgJACgNAAQgcAAgRgSgAgWvbQgLAMgCAYIBSAAQAAgXgKgNQgKgOgSAAQgTAAgMAOgAkjtxQgLgLAAgRQAAgVAQgLQARgKAfgBIAaAAIAAgJQAAgUgIgJQgIgLgRAAQgTAAgUALIgFgLQAXgLAVAAQAWABAMAMQALALAAAZIAABaIgJAAIgEgWIgBAAQgKANgLAFQgKAGgPAAQgUAAgLgKgAjsuuQgdABgMAJQgMAHAAAQQAAAMAIAIQAHAGAPABQAWAAAMgNQAMgMAAgWIAAgNgAoNtxQgLgLAAgRQAAgVAQgLQAQgKAggBIAaAAIAAgJQAAgUgIgJQgIgLgSAAQgSAAgVALIgEgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgKANgLAFQgLAGgOAAQgUAAgLgKgAnXuuQgcABgMAJQgMAHAAAQQAAAMAHAIQAIAGAOABQAWAAANgNQAMgMAAgWIAAgNgAwIt5QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQAAAcANAPQANAPAYAAQAMAAAIgCQAIgBAOgGIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgAv9vbQgMAMgCAYIBUAAQAAgXgLgNQgKgOgSAAQgUAAgLAOgAz0twQgIgKAAgVIAAhXIgUAAIAAgHIAUgGIAGgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAGAIQAGAHALAAQANAAAHgCIAAAKQgIADgMAAQgSAAgJgJgA+PuZIAAhYIAMAAIAABXQAAAWAIAJQAJAIASABQAYAAAMgNQALgMAAgbIAAhLIAMAAIAACIIgKAAIgDgTIAAAAQgNAVgiAAQguAAAAgygEggfgN4QgPgSAAgiQAAgiAPgTQAPgTAcAAQAOABALAFQALAFAIANIABAAIgBgfIAAgxIANAAIAADDIgJAAIgDgVIgBAAQgPAXgdAAQgcAAgPgRgEggVgPZQgMAQAAAdQAAA6AtAAQAXAAALgOQAKgMAAggIAAgCQAAgegKgPQgLgOgXAAQgWAAgLAQgEgj5gN4QgPgSAAgiQAAgiAPgTQAPgTAcAAQAOABALAFQALAFAIANIABAAIgBgfIAAgxIANAAIAADDIgJAAIgDgVIgBAAQgPAXgdAAQgcAAgPgRgEgjwgPZQgLAQAAAdQAAA6AtAAQAXAAALgOQAKgMAAggIAAgCQAAgegKgPQgLgOgXAAQgWAAgMAQgEgoegNvQgOgKgHgQQgHgPAAgWQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAigQATQgQASgdAAQgSAAgNgIgEgohgPZQgMAQAAAbQAAAcAMAQQAMAPAXABQAWgBANgPQAMgQAAgcQAAgbgMgQQgNgQgWAAQgWAAgNAQgEgzCgN5QgQgTAAggQAAghAQgTQAPgUAbAAQAYAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAPQAMAPAYAAQAMAAAIgCQAIgBAPgGIAAAMQgLAEgLACQgIACgNAAQgdAAgRgSgEgy3gPbQgMAMgCAYIBUAAQAAgXgKgNQgLgOgSAAQgTAAgMAOgEg4GgN5QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAOgGIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgEg37gPbQgMAMgCAYIBUAAQAAgXgLgNQgKgOgSAAQgTAAgMAOgEAutgNpIAAiIIALAAIABAYIABAAQAIgPAKgFQAJgHAOAAIASACIgCAMQgJgCgJAAQgRAAgLAOQgLAPAAAWIAABMgEArpgNpIAAhYQAAgVgIgJQgJgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAjDIAMAAIAABQIAAAAQAIgMAMgGQAMgFAQgBQAuABAAAxIAABZgAc6tpIAAhYQAAgVgJgJQgJgKgSAAQgYAAgLANQgLAMAAAbIAABMIgNAAIAAiIIALAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgAaitpIAAiIIAMAAIAACIgAZ8tpIgzhFIgWAUIAAAxIgNAAIAAjDIANAAIgBCHIAAAAIBFhMIAPAAIg1A6IA6BOgAXDtpIAAiIIAKAAIACAYIABAAQAIgPAJgFQAKgHANAAIATACIgDAMQgIgCgJAAQgRAAgMAOQgLAQAAAVIAABMgAThtpIgdhbIgIgbIAAAAIgnB2IgMAAIgniIIAOAAIAVBOIAKAsIABAAQAHgfAEgIIAchTIALAAIAaBTQAIAZADANIABAAIAKgrIAVhOIAMAAIglCIgANZtpIAAiIIAKAAIACAYIABAAQAIgPAJgFQAKgHANAAIATACIgDAMQgIgCgJAAQgRAAgMAOQgLAPAAAWIAABMgAHetpIAAiIIAKAAIACAYIAAAAQAJgPAJgFQAKgHANAAIATACIgDAMQgIgCgJAAQgSAAgLAOQgLAQAAAVIAABMgABitpIAAjDIAMAAIAADDgAhjtpIAAjDIAMAAIAADDgAidtpIAAjDIANAAIAADDgAmHtpIAAiIIALAAIABAYIABAAQAIgPAJgFQAKgHANAAIATACIgDAMQgIgCgJAAQgRAAgLAOQgMAQAAAVIAABMgAtLtpIAAiIIAKAAIABAYIABAAQAJgPAJgFQAJgHAOAAIASACIgCAMQgIgCgJAAQgSAAgLAOQgLAQAAAVIAABMgAuFtpIAAiIIAMAAIAACIgAxJtpIAAhYQAAgVgIgJQgJgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAjDIAMAAIgBBQIABAAQAIgMALgGQANgFAQgBQAuABAAAxIAABZgA38tpIAAhYQAAgVgJgJQgJgKgSAAQgYAAgLANQgLAMAAAbIAABMIgNAAIAAiIIALAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgA6UtpIAAiIIAMAAIAACIgA74tpIAAiIIALAAIABAYIABAAQAIgPAKgFQAJgHAOAAIASACIgCAMQgJgCgJAAQgRAAgLAOQgLAPAAAWIAABMgEgk5gNpIAAjDIAMAAIAADDgEgmdgNpIAAiIIALAAIABAYIABAAQAIgPAKgFQAJgHAOAAIASACIgCAMQgJgCgJAAQgRAAgLAOQgLAQAAAVIAABMgEgp+gNpIgehbIgHgbIgBAAIgmB2IgNAAIgmiIIANAAIAWBOIAKAsIAAAAQAHgaAEgNIAchTIALAAIAbBTIALAmIAAAAQABgGAJglIAVhOIAMAAIgkCIgEgwFgNpIAAiIIAKAAIACAYIABAAQAIgPAJgFQAKgHANAAIATACIgDAMQgIgCgJAAQgRAAgMAOQgLAQAAAVIAABMgEgw/gNpIAAjDIANAAIAADDgEg0XgNpIgdhbIgIgbIgBAAIgmB2IgMAAIgniIIANAAIAWBOIAKAsIABAAIAKgnIAchTIAMAAIAaBTIALAmIABAAQAAgGAKglIAUhOIANAAIglCIgAagwXQAAgMAIABQAEgBACADQACAEAAAFQAAAHgCACQgDAEgDAAQgIAAAAgNgAuHwXQAAgMAIABQAEgBACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgA6WwXQAAgMAIABQAEgBACADQACAEAAAFQAAAHgCACQgDAEgDAAQgIAAAAgNgEg5KgQXQAAgMAIABQADgBADADQACAEAAAFQAAAHgCACQgDAEgDAAQgIAAAAgNgAfbyrIAAjFIAKAAIADAUIAAAAQAOgWAfAAQAbAAAPASQAOASAAAjQAAAhgPASQgPASgaAAQggAAgOgXIgBAAIABBSgAfy1aQgLAOAAAcIAAAFQAAAfALAOQAKANAYAAQAVAAAMgPQALgQAAgbQAAg8grAAQgXAAgMANgAXzytIAAgLQAHACAIAAQAHAAAEgDQAGgEADgGQAEgGAFgNIAHgSIg0iIIANAAIAcBMQANAjAEANIABAAIARgwIAchMIANAAIg8CeQgIATgFAGQgFAIgGADQgHADgKAAQgHAAgIgCgAGYyrIAAjFIALAAIACAUIABAAQAOgWAeAAQAcAAAOASQAPASAAAjQAAAggQATQgPASgaAAQgfAAgOgXIgBAAIABBSgAGw1aQgLANAAAdIAAAFQAAAfAKAOQALANAYAAQAVAAALgPQALgPAAgcQAAg8grAAQgXAAgLANgAycyuIAAgLQAIADAIAAQATAAAAgWIAAikIAMAAIAACiQAAARgIAJQgHAJgPAAQgKAAgHgDgEgwQgStIAAgLQAHACAIAAQAHAAAFgDQAEgDAEgHQAEgGAFgNIAHgSIg0iIIANAAIAdBMQANAjADANIABAAIARgwIAdhMIAMAAIg8CeQgHATgGAGQgFAIgGADQgHADgJAAQgIAAgIgCgEghmgTHQAJgiAFgcIAOAAIACACQgKAhgMAbgEA3cgTvQgJgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAHAAIAAAgIAnAAIAAALIgnAAIAABWQAAAQAFAHQAGAHALAAQANAAAIgBIAAAJQgJADgMAAQgSAAgIgJgEAzpgTwQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgTgIgKQgIgKgRAAQgTAAgUAKIgFgKQAWgLAWAAQAWAAALAMQAMALAAAZIAABaIgKAAIgDgVIgBAAQgLANgKAFQgKAGgPgBQgVAAgKgKgEA0ggUsQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAVAAANgMQAMgMAAgWIAAgOgEAwjgT4QgRgSAAggQAAghAQgTQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAOQANAPAYAAQALAAAJgBQAIgBAOgHIAAAMQgLAFgKABQgJACgMAAQgeAAgQgSgEAwugVaQgMANgCAYIBUAAQAAgXgLgOQgKgNgSAAQgTAAgMANgEAs3gTvQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAFAHAMAAQANAAAHgBIAAAJQgJADgLAAQgSAAgJgJgEApbgT3QgPgRAAgiQAAgjAPgSQAPgTAcAAQAOAAALAFQALAGAIAMIABAAIgBgeIAAgxIANAAIAADCIgJAAIgDgUIgBAAQgPAWgdAAQgcAAgPgRgEApkgVXQgLAQAAAdQAAA5AtAAQAXAAALgNQAKgNAAgfIAAgCQAAgfgKgOQgLgOgXAAQgWAAgMAQgEAnRgT4QgRgSAAggQAAgiAQgSQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAOQANAPAYAAQALAAAJgBQAIgCAOgGIAAAMQgLAFgKABQgJACgMAAQgeAAgQgSgEAncgVaQgMANgCAYIBUAAQAAgXgKgOQgLgNgSAAQgTAAgMANgEAl8gTvQgJgKAAgUIAAhYIgUAAIAAgHIAUgFIAHgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAFAHQAGAHAMAAQAMAAAIgBIAAAJQgJADgMAAQgRAAgJgJgEAkCgT4QgQgSAAghQAAghARgTQARgTAeAAQAQAAARAGIgDALQgSgGgNAAQgZAAgMAQQgNAPAAAdQAAAbANAPQAMAQAXAAQATAAAQgHIAAAMQgNAHgVgBQgeAAgQgSgEAhzgTwQgLgKAAgSQAAgUARgLQAQgLAfgBIAaAAIAAgJQAAgUgIgJQgHgKgSAAQgTAAgUAKIgFgKQAXgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgLANgKAFQgLAGgPgBQgUAAgLgKgEAiqgUsQgcABgNAIQgMAIAAAPQAAANAIAHQAIAHAOAAQAWAAAMgMQANgMAAgWIAAgOgAU+z3QgPgRAAgiQAAgjAPgSQAPgTAcAAQAOAAALAFQALAGAIAMIABAAIgBgeIAAgxIANAAIAADCIgIAAIgEgUIgBAAQgPAWgdAAQgcAAgPgRgAVI1XQgMAQAAAdQAAA5AtAAQAXAAALgNQAKgNAAgfIAAgCQAAgfgKgOQgLgOgXAAQgWAAgLAQgAQJ0XIAAhZIAMAAIAABYQAAAVAJAJQAIAJASAAQAZAAALgMQALgMAAgcIAAhLIANAAIAACIIgLAAIgCgSIgBAAQgNAVgigBQguAAAAgxgAOJzuQgNgJgIgQQgHgPAAgWQAAghAQgSQARgTAbAAQAcAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgSABgOgJgAOG1XQgMAPAAAcQAAAbAMAQQANAQAWAAQAXAAAMgQQAMgQAAgbQAAgcgMgPQgNgQgWAAQgXAAgMAQgAKnzuQgNgJgHgQQgIgRAAgUQAAghAQgSQARgTAcAAQAbAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgSABgOgJgAKk1XQgMAPAAAcQAAAcANAPQAMAQAWAAQAXAAAMgQQAMgPAAgcQAAgcgMgPQgNgQgWAAQgWAAgNAQgADVzuQgOgJgHgQQgHgRAAgUQAAggAQgTQAQgTAcAAQAcAAAQATQAPATAAAgQAAAhgQATQgQASgcAAQgSABgNgJgADS1XQgMAPAAAcQAAAbAMAQQAMAQAXAAQAWAAAMgQQANgQAAgbQAAgcgNgPQgMgQgXAAQgWAAgMAQgAlSzuIAAgNQAUAKAXAAQATAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgIgFgEgHQgEgHAAgJQAAgPANgJQAMgJAXAAQAWAAAUAIIgFAMQgTgJgSAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQASAHAJAFQAIAFAEAHQAFAGAAAJQAAATgOAJQgOAKgZAAQgcABgPgJgAotz4QgQgSAAggQAAghAQgTQAQgUAbAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQAMAPAYAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgAoi1aQgMANgCAYIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgAryz4QgRgSAAggQAAgiAQgSQAQgUAbAAQAYAAAOARQAOARAAAcIAAAKIhiAAQAAAbANAPQANAPAYAAQALAAAJgBQAHgBAPgHIAAAMQgLAEgKACQgJACgMAAQgeAAgQgSgArn1aQgMAMgCAZIBTAAQAAgYgKgNQgKgNgSAAQgUAAgLANgAw3z4QgQgSAAggQAAghAQgTQAQgUAbAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQAMAPAYAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgAws1aQgLAMgDAZIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgA2iz4QgQgSAAggQAAgiAQgSQAPgUAcAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQAMAPAYAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgA2X1aQgMANgCAYIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgA33zvQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAFAHAMAAQAMAAAIgBIAAAJQgIADgMAAQgSAAgJgJgA6DzuIAAgNQAUAKAXAAQAUAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgIgFgEgHQgFgHAAgJQAAgPANgJQANgJAXAAQAWAAATAIIgEAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAHAGQAHAGAXAIQASAHAJAFQAIAFAEAHQAEAGAAAJQAAATgOAJQgNAKgaAAQgbABgQgJgA79zwQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgTgIgKQgIgKgRAAQgTAAgUAKIgFgKQAWgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgKANgLAFQgKAGgPgBQgVAAgKgKgA7G0sQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAVAAANgMQAMgMAAgWIAAgOgEgkVgT4QgQgSAAggQAAgiAQgSQAPgUAcAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAbANAPQAMAPAYAAQAMAAAIgBQAJgBAOgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgEgkKgVaQgMANgCAYIBUAAQAAgYgKgNQgLgNgRAAQgUAAgMANgEgokgT4QgRgSAAghQAAghARgTQARgTAeAAQARAAAQAGIgDALQgRgGgNAAQgZAAgNAQQgNAPAAAdQAAAbANAPQAMAQAYAAQATAAAPgHIAAAMQgNAHgVgBQgdAAgQgSgEgxrgT4QgQgSAAghQAAghARgTQARgTAeAAQARAAAQAGIgDALQgRgGgOAAQgYAAgNAQQgNAPAAAdQAAAbANAPQAMAQAYAAQATAAAPgHIAAAMQgNAHgVgBQgdAAgRgSgEg2QgTwQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgUgIgJQgIgKgRAAQgTAAgUAKIgFgKQAXgLAVAAQAWAAAMAMQALALAAAZIAABaIgKAAIgDgVIgBAAQgKANgLAFQgKAGgPgBQgUAAgLgKgEg1ZgUsQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAWAAAMgMQAMgMAAgWIAAgOgEA1vgToIAAiIIALAAIABAZIABAAQAIgPAKgGQAJgGAOAAIASACIgCALQgJgCgJAAQgRAAgLAPQgLAPAAAWIAABLgEAvigToIAAhYQAAgUgJgJQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAjCIAMAAIgBBPIABAAQAIgMALgGQANgFAQAAQAuAAAAAxIAABZgAejzoIAAhZQAAgTgIgJQgIgKgQAAQgUAAgKALQgKAMAAAYIAABQIgNAAIAAhcQAAgjgfAAQgWAAgJAMQgKANAAAbIAABLIgMAAIAAiIIAKAAIADATIAAAAQAGgKAKgGQALgFAMAAQAgAAAJAYIABAAQAGgMALgGQAMgGAOAAQAWAAALAMQALALAAAaIAABZgAbAzoIAAiIIAMAAIAACIgAXPzoIAAjCIAMAAIAADCgAT/zoIAAhYQAAgUgIgJQgJgKgSAAQgYAAgLAMQgMANAAAbIAABLIgMAAIAAiIIAKAAIADATIAAAAQAOgVAhAAQAvAAAAAxIAABZgAMvzoIAAh9IgZAAIAAgHIAZgEIAAgLQAAgZAJgLQAJgMAVAAQAMAAAKADIgDALQgKgDgJAAQgPAAgGAJQgGAIAAATIAAAMIAgAAIAAALIggAAIAAB9gAIwzoIAAiIIAKAAIACAZIABAAQAIgPAJgGQAKgGANAAIATACIgDALQgIgCgJAAQgRAAgMAPQgLAPAAAWIAABLgACJzoIAAhYQAAgUgJgJQgJgKgSAAQgYAAgLAMQgMANAAAbIAABLIgMAAIAAjCIAMAAIAABPIABAAQAHgMAMgGQAMgFARAAQAuAAAAAxIAABZgAghzoIgehbIgHgaIgBAAIgmB1IgMAAIgniIIANAAIAWBPIAKArIABAAIAKgnIAchTIALAAIAbBTQAIAZADANIABAAQAAgGAKgkIAThPIANAAIgkCIgAmqzoIAAiIIALAAIABAZIABAAQAIgPAKgGQAJgGAOAAIASACIgCALQgJgCgJAAQgRAAgLAPQgLAPAAAWIAABLgApvzoIAAjCIAMAAIAADCgAtHzoIgehbIgHgaIgBAAIgmB1IgNAAIgmiIIANAAIAWBPIAKArIAAAAQAHgaAEgNIAchTIALAAIAbBTIALAmIAAAAIAKgqIAVhPIAMAAIgkCIgA0fzoIAAiIIALAAIABAZIABAAQAIgPAKgGQAJgGAOAAIASACIgCALQgJgCgJAAQgRAAgLAPQgLAPAAAWIAABLgA82zoIAAhZQAAgUgIgIQgHgKgQAAQgVAAgKALQgKAMAAAYIAABQIgMAAIAAhcQAAgjggAAQgVAAgKAMQgKANAAAbIAABLIgMAAIAAiIIAKAAIADATIABAAQAFgKALgGQAKgFAMAAQAgAAAJAYIABAAQAHgMALgGQALgGAOAAQAWAAALAMQALALAAAaIAABZgEgiSgToIAAjCIANAAIAADCgEglWgToIAAhYQAAgVgIgIQgJgKgSAAQgYAAgLAMQgMANAAAbIAABLIgMAAIAAjCIAMAAIAABPIABAAQAHgMAMgGQAMgFARAAQAuAAAAAxIAABZgEgpngToIAAiIIANAAIAACIgEgqkgToIAAiKIACgeIgBAAIhECoIgJAAIhDioIgBAAIABAgIAACIIgNAAIAAi2IAUAAIBBCgIAAAAIBBigIATAAIAAC2gEgyrgToIAAhYQAAgUgJgJQgJgKgRAAQgYAAgMAMQgLAMAAAcIAABLIgNAAIAAiIIALAAIACATIABAAQAOgVAhAAQAuAAAAAxIAABZgEg3OgToIhsiiIgBAAIACAsIAAB2IgMAAIAAi2IAMAAIBsCiIABAAIgBgrIAAh3IAMAAIAAC2gAa+2VQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgAx72VQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEgpogWVQAAgMAHAAQAEAAACADQADADAAAGQAAAGgDADQgCADgEAAQgHAAAAgMgAZP4tIAAgKQAIADAIgBQASAAAAgVIAAikIANAAIAAChQAAASgIAIQgIAJgPAAQgKAAgGgDgAn84sIAAgKQAIABAIAAQAGAAAFgCQAEgDAFgHQAFgIAEgMIAGgRIgziIIAMAAIAdBMQANAjADAMIABAAIARgvIAdhMIANAAIg9CdQgHATgFAHQgFAHgHADQgGADgKAAQgIAAgIgCgA9c4qIAAjEIALAAIACAUIABAAQAOgXAeAAQAcABAOARQAOATAAAiQAAAhgPATQgPASgaAAQgfAAgPgYIAAAAIAABSgA9F7YQgLANAAAdIAAAEQAAAgALANQALAOAYAAQAVAAALgPQALgQAAgcQAAg7grgBQgXAAgMAOgEAvWgZ1QgPgSAAgiQAAgiAPgTQAPgTAcAAQAOABALAFQALAGAIAMIABAAIgBgfIAAgxIANAAIAADDIgIAAIgEgVIgBAAQgPAXgdAAQgcAAgPgRgEAvggbWQgMAQAAAdQAAA6AtAAQAXAAALgOQAKgMAAggIAAgCQAAgegKgPQgLgOgXAAQgWAAgLAQgEAqygZuQgLgLAAgRQAAgVARgLQAQgKAggBIAZAAIAAgJQAAgUgHgJQgIgLgSAAQgTAAgUALIgEgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgKANgLAFQgLAGgPAAQgUAAgLgKgEArpgarQgcABgMAIQgNAIAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgEAntgZsIAAgOQAUALAXAAQATAAALgHQALgHAAgLQAAgKgJgHQgIgHgTgHQgUgHgIgGQgJgEgEgHQgEgHAAgJQAAgQANgJQAMgIAXgBQAWABAUAHIgFAMQgTgJgSAAQgQAAgKAGQgKAGAAAKQAAAKAIAHQAHAFAWAIQASAHAJAGQAJAFAEAHQAEAGAAAJQAAATgOAJQgOAKgZAAQgcAAgPgIgEAhhgZtQgJgLAAgUIAAhXIgUAAIAAgHIAUgGIAHgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAFAIQAGAHAMAAQAMAAAIgCIAAAKQgJADgMAAQgRAAgJgJgAfR5uQgLgLAAgRQAAgVARgLQAQgKAggBIAZAAIAAgJQAAgUgHgJQgIgLgSAAQgSAAgVALIgEgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgKANgLAFQgLAGgPAAQgUAAgLgKgEAgIgarQgcABgMAIQgNAIAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgAT+5sQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAigQATQgQASgcAAQgTAAgNgIgAT77WQgMAQAAAbQAAAcAMAQQANAPAWABQAXgBAMgPQAMgQAAgcQAAgbgMgQQgNgQgWAAQgXAAgMAQgAQv5sQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAigQATQgQASgdAAQgSAAgNgIgAQs7WQgMAQAAAbQAAAcAMAQQAMAPAXABQAWgBANgPQAMgQAAgcQAAgbgMgQQgNgQgWAAQgWAAgNAQgAOH5rIAAgNQAUAIAeAAQAXAAANgKQANgLAAgQQAAgLgEgGQgFgIgKgFQgKgFgSgGQgcgKgLgMQgLgKAAgTQAAgVAQgNQARgMAZAAQAZAAAXAJIgFALQgXgJgUAAQgUAAgMAJQgMAKAAAPQAAAKADAHQAEAGAIAGQAJAFAUAIQAVAHALAGQALAIAFAIQAFAJAAAMQAAAXgRANQgRAOgcAAQghAAgSgHgALH5uQgLgLAAgRQAAgVARgLQAQgKAfgBIAaAAIAAgJQAAgUgIgJQgHgLgSAAQgTAAgUALIgEgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgLANgKAFQgLAGgPAAQgUAAgLgKgAL+6rQgcABgNAIQgMAIAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgAHT51QgPgRAAgjQAAgiAOgTQAPgTAcAAQAOABAMAFQAKAGAJAMIABAAIgBgfIAAgxIAMAAIAADDIgIAAIgDgVIgBAAQgQAXgdAAQgcAAgOgRgAHc7WQgLAQAAAdQAAA6AsAAQAXAAALgOQALgNAAgfIAAgCQAAgfgLgOQgLgOgXAAQgWAAgLAQgACv5uQgLgLAAgRQAAgVAQgLQAQgKAggBIAaAAIAAgJQAAgUgIgJQgIgLgRAAQgTAAgUALIgFgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgKANgLAFQgKAGgPAAQgVAAgKgKgADm6rQgdACgMAHQgMAIAAAQQAAAMAIAIQAHAGAPABQAVAAANgNQAMgMAAgWIAAgNgAhT52QgRgTAAggQAAghAQgTQAQgUAbAAQAYAAAOARQANARAAAcIAAAKIhhAAQAAAcANAPQANAPAYAAQAMAAAIgCQAIgBANgGIAAAMQgKAEgKACQgJACgMAAQgeAAgQgSgAhI7YQgMAMgCAYIBUAAQAAgXgLgNQgKgOgSAAQgUAAgLAOgApf5qQgLgGgHgLIgBAAIgEAVIgIAAIAAjDIANAAIgBBQIABAAQAHgMALgGQALgFAQgBQAcABAOARQAPASAAAiQAAAigPATQgPASgcAAQgOAAgMgGgApn7YQgKAOAAAfIAAACQAAAgALAMQAKAOAXAAQAWAAALgPQAMgQAAgdQAAg6gtgBQgYAAgKAOgAtR51QgOgSAAgiQAAgjAOgSQAPgTAcAAQAOABALAFQALAFAJANIAAAAIAAgfIAAgxIAMAAIAADDIgIAAIgDgVIgBAAQgQAXgdAAQgcAAgPgRgAtH7WQgLAQAAAdQAAA6AsAAQAXAAALgOQALgNAAgfIAAgCQAAgegLgPQgLgOgXAAQgWAAgLAQgAvb52QgQgTAAggQAAghAQgTQAPgUAcAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAPQAMAPAYAAQAMAAAIgCQAJgBAOgGIAAAMQgMAEgJACQgJACgNAAQgdAAgRgSgAvQ7YQgMAMgCAYIBUAAQAAgXgKgNQgLgOgRAAQgUAAgMAOgAzK52QgRgTAAggQAAghAQgTQARgUAaAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQALAAAJgCQAIgBAPgGIAAAMQgMAEgKACQgJACgMAAQgeAAgQgSgAy/7YQgMAMgCAYIBUAAQAAgXgKgNQgLgOgSAAQgTAAgMAOgA1W52QgRgTAAggQAAghAQgTQARgUAaAAQAYAAAOARQAOARAAAcIAAAKIhiAAQABAcAMAPQANAPAYAAQAMAAAIgCQAIgBAPgGIAAAMQgMAEgKACQgJACgMAAQgeAAgQgSgA1L7YQgMAMgCAYIBUAAQAAgXgKgNQgLgOgSAAQgTAAgMAOgA525sQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAPATAAAgQAAAigQATQgQASgcAAQgSAAgNgIgA557WQgMAQAAAbQAAAcAMAQQAMAPAXABQAWgBAMgPQANgQAAgcQAAgbgNgQQgMgQgXAAQgWAAgMAQgEgi2gZsQgOgKgHgQQgHgQAAgVQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAigQATQgQASgcAAQgTAAgNgIgEgi5gbWQgMAQAAAbQAAAcAMAQQANAPAWABQAXgBAMgPQAMgQAAgcQAAgbgMgQQgNgQgWAAQgXAAgMAQgEglQgZtQgJgLAAgUIAAhXIgUAAIAAgHIAUgGIAHgeIAGAAIAAAgIAoAAIAAALIgoAAIAABVQAAAQAGAIQAFAHAMAAQAMAAAIgCIAAAKQgJADgMAAQgRAAgJgJgEgnggZuQgLgLAAgRQAAgVARgLQAQgKAggBIAZAAIAAgJQAAgUgHgJQgIgLgSAAQgSAAgVALIgEgLQAWgLAWAAQAWABALAMQALALAAAZIAABaIgJAAIgDgWIgBAAQgKANgLAFQgLAGgPAAQgUAAgLgKgEgmpgarQgcACgMAHQgNAIAAAQQAAAMAIAIQAIAGAOABQAWAAAMgNQANgMAAgWIAAgNgEgrWgZsQgOgKgHgQQgHgPAAgWQAAggAQgTQAQgTAcAAQAcAAAPATQAQATAAAgQAAAhgQAUQgQASgcAAQgSAAgNgIgEgrZgbWQgMAQAAAbQAAAcAMAQQAMAPAWABQAXgBAMgPQAMgQAAgcQAAgbgMgQQgNgQgWAAQgWAAgMAQgEg0kgZ1QgPgSAAgiQAAgjAPgSQAPgTAbAAQAOABAMAFQALAFAIANIABAAIgBgfIAAgxIAMAAIAADDIgIAAIgDgVIgBAAQgPAXgdAAQgcAAgPgRgEg0bgbWQgLAQAAAdQAAA6AtAAQAXAAAKgOQALgNAAgfIAAgCQAAgegKgPQgLgOgYAAQgWAAgLAQgEg5IgZuQgLgLAAgRQAAgVAQgLQARgKAfgBIAaAAIAAgJQAAgUgIgJQgIgLgRAAQgTAAgUALIgFgLQAXgLAVAAQAXABALAMQALAKAAAaIAABaIgJAAIgEgWIgBAAQgKANgKAFQgLAGgPAAQgUAAgLgKgEg4RgarQgcABgNAIQgMAIAAAQQAAAMAIAIQAHAGAPABQAWAAAMgNQAMgMAAgWIAAgNgEAuXgZmIAAhYQAAgVgIgJQgJgKgSAAQgYAAgLANQgMAMAAAbIAABMIgMAAIAAiIIAKAAIADATIAAAAQAOgWAhAAQAvABAAAxIAABZgEAnBgZmIAAhYQAAgVgJgJQgJgKgRAAQgYAAgMANQgLAMAAAbIAABMIgNAAIAAiIIALAAIACATIABAAQAOgWAhAAQAuABAAAxIAABZgEAkpgZmIAAiIIAMAAIAACIgEAkDgZmIgzhFIgWAUIAAAxIgNAAIAAjDIANAAIgBCHIAAAAIBGhMIAOAAIg1A6IA6BOgAd35mIgvipIgGAZIgoCQIgLAAIgyi3IANAAIApCYIACAKQADgQAKgjIAfhvIAOAAIAkB/QAHAXACAMIAFgTIAmiPIANAAIgyC3gAY45mIAAiIIAMAAIAACIgAXs5mIglh2IgBAAIgmB2IgNAAIgmiIIANAAIAVBOQAIAcACAPIABAAIALgmIAchTIALAAIAbBTIAKAmIABAAQABgJAJgiIAVhOIAMAAIgkCIgASw5mIAAjDIANAAIAADDgAJj5mIAAiIIALAAIABAYIABAAQAJgPAJgFQAJgHAOAAIASACIgCAMQgJgCgJAAQgRAAgLAOQgLAQAAAVIAABMgAGU5mIAAhYQAAgVgJgJQgJgKgSAAQgYAAgLANQgLAMAAAbIAABMIgNAAIAAiIIALAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgACC5mIgqg9IgrA9IgOAAIAxhGIgvhCIAOAAIApA5IAog5IANAAIguBCIAyBGgAiV5mIAAjDIAMAAIAADDgAi65mIgahBIhKAAIgZBBIgOAAIBJi4IAIAAIBIC4gAkA7zIgZBAIBBAAIgZhBIgHgWQgDAMgFALgAxH5mIAAiIIALAAIABAYIABAAQAIgPAKgFQAJgHAOAAIASACIgCAMQgJgCgJAAQgRAAgLAOQgLAQAAAVIAABMgA2X5mIAAhYQAAgVgIgJQgJgKgSAAQgYAAgLANQgMAMAAAbIAABMIgMAAIAAiIIAKAAIADATIAAAAQAOgWAhAAQAvABAAAxIAABZgA7E5mIAAiIIAMAAIAACIgA/W5mIAAhYQAAgVgJgJQgJgKgRAAQgYAAgMANQgLAMAAAbIAABMIgNAAIAAiIIALAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgEgkEgZmIAAiIIANAAIAACIgEgo4gZmIg0iIIANAAIAjBcQAHASADANIABAAQAFgRAGgOIAihcIANAAIg0CIgEgsjgZmIAAhYQAAgVgIgJQgJgKgSAAQgYAAgLANQgMAMAAAbIAABMIgMAAIAAiIIAKAAIADATIABAAQANgWAiAAQAuABAAAxIAABZgEgu5gZmIAAhYQAAgVgJgJQgIgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAiIIAKAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgEgxRgZmIAAiIIAMAAIAACIgEg1jgZmIAAhYQAAgVgJgJQgIgKgSAAQgYAAgMANQgLAMAAAbIAABMIgMAAIAAiIIAKAAIACATIABAAQANgWAiAAQAuABAAAxIAABZgEAkngcUQAAgMAIABQAEgBACADQACAEAAAFQAAAGgCADQgDAEgDAAQgIAAAAgNgAZw8UQAAgMAIABQADgBADADQACAEAAAFQAAAGgCADQgDAEgDAAQgIAAAAgNgAY28UQAAgMAIABQAEgBACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgA7G8UQAAgMAIABQAEgBACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgEgkFgcUQAAgMAHABQAEgBADADQACAEAAAFQAAAGgCADQgDAEgEAAQgHAAAAgNgEgxTgcUQAAgMAIABQAEgBACADQACAEAAAFQAAAGgCADQgCAEgEAAQgIAAAAgNgAbb+qIAAgLQAIACAIAAQAGAAAFgDQAEgDAFgHQAFgHAEgMIAGgSIgziIIAMAAIAdBMQANAjADANIABAAIARgwIAdhMIANAAIg9CeQgHATgFAGQgFAIgHADQgGADgKAAQgIAAgIgCgAyr+oIAAjFIAKAAIADAUIAAAAQAOgWAfAAQAbAAAPASQAOASAAAjQAAAhgPASQgPASgaAAQggAAgOgXIgBAAIABBSgEgSUghXQgLAOAAAcIAAAFQAAAfALAOQALANAXAAQAVAAAMgPQALgPAAgcQAAg8grAAQgXAAgMANgEgpdgexQgOgLAAgRQAAgOAJgJQAIgKAPgDQgGgCgEgFQgDgFAAgGQAAgOARgKQgMgFgHgLQgGgKAAgNQAAgVANgMQANgMAWAAQANAAAHACIAsAAIAAAJIgcACQALANAAASQAAATgNAMQgNAMgWAAIgNgBQgIAFgDAEQgEAGAAAGQAAAGAFAEQAFACALABIAYAAQAWAAAMAIQALAJAAASQAAAVgRAMQgRALghAAQgZAAgOgJgEgpegfOQAAAcApAAQA2gBAAghQAAgMgJgGQgIgGgTAAIgWAAQglAAAAAegEgpKghcQgKAJAAARQAAAPAKAJQAJAJAQAAQARAAAJgJQAJgJAAgPQAAgSgJgIQgJgKgRABQgQAAgJAJgEAxsgfrQgOgJgHgQQgHgRAAgUQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgSABgOgJgEAxpghUQgMAPAAAcQAAAcAMAPQANAQAWAAQAXAAAMgQQAMgQAAgbQAAgcgMgPQgNgQgWAAQgXAAgMAQgEAvSgfsQgJgKAAgUIAAhYIgUAAIAAgHIAUgFIAHgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAFAHAMAAQAMAAAIgBIAAAJQgJADgMAAQgSAAgIgJgEAtDgftQgMgKAAgSQAAgUARgLQAQgLAggBIAZAAIAAgJQAAgUgHgJQgIgKgSAAQgSAAgVAKIgEgKQAWgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgKANgLAFQgLAGgOgBQgVAAgKgKgEAt5ggpQgcABgMAIQgMAIAAAPQAAANAHAHQAIAHAOAAQAWAAAMgMQANgMAAgWIAAgOgEApdgfrQgNgJgHgQQgIgRAAgUQAAggAQgTQARgTAcAAQAbAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgSABgOgJgEApaghUQgMAPAAAcQAAAcANAPQAMAQAWAAQAXAAAMgQQAMgPAAgcQAAgcgMgPQgNgQgWAAQgWAAgNAQgEAnQgfoQgLgHgHgKIgBAAIgEAUIgIAAIAAjCIANAAIgBBPIABAAQAHgLALgHQALgFAQAAQAcAAAOASQAPASAAAiQAAAhgPATQgPASgcAAQgOAAgMgFgEAnIghWQgKAOAAAfIAAACQAAAfALANQAKANAXAAQAXAAAKgPQAMgPAAgdQAAg7gtAAQgXAAgLAOgEAkrgftQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgUgIgJQgIgKgRAAQgTAAgUAKIgFgKQAXgLAVAAQAXAAALAMQALALAAAZIAABaIgJAAIgEgVIgBAAQgKANgLAFQgKAGgPgBQgUAAgLgKgEAliggpQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAWAAAMgMQAMgMAAgWIAAgOgEAg2gfrQgOgJgHgQQgHgPAAgWQAAghAQgSQAQgTAcAAQAcAAAQATQAQASAAAhQAAAhgQATQgRASgcAAQgSABgNgJgEAgzghUQgMAPAAAcQAAAcAMAPQAMAQAXAAQAWAAAMgQQANgPAAgcQAAgcgNgPQgMgQgXAAQgWAAgMAQgAex/1QgQgSAAghQAAghARgTQARgTAdAAQARAAARAGIgDALQgSgGgNAAQgZAAgNAQQgMAPAAAdQAAAbAMAPQANAQAXAAQATAAAQgHIAAAMQgNAHgVgBQgdAAgRgSgAYI/tQgMgKAAgSQAAgUARgLQAQgLAggBIAZAAIAAgJQAAgUgHgJQgIgKgSAAQgSAAgVAKIgEgKQAWgLAWAAQAWAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgKANgLAFQgLAGgOgBQgVAAgKgKgEAY+ggpQgcABgMAIQgMAIAAAPQAAANAHAHQAIAHAOAAQAWAAAMgMQANgMAAgWIAAgOgASm/0QgPgRAAgiQAAgjAPgSQAPgTAcAAQAOAAALAFQALAGAIAMIABAAIgBgeIAAgxIAMAAIAADCIgIAAIgDgUIgBAAQgPAWgdAAQgcAAgPgRgEASvghUQgLAQAAAdQAAA5AtAAQAXAAAKgNQALgNAAgfIAAgCQAAgfgKgOQgLgOgXAAQgXAAgLAQgAO7/rQgOgJgHgQQgHgPAAgWQAAghAQgSQAQgTAcAAQAcAAAPATQAQASAAAhQAAAhgQATQgQASgcAAQgSABgNgJgEAO4ghUQgMAPAAAcQAAAcAMAPQAMAQAWAAQAXAAAMgQQAMgPAAgcQAAgcgMgPQgNgQgWAAQgWAAgMAQgAMg/tQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgUgIgJQgIgKgRAAQgTAAgUAKIgFgKQAXgLAVAAQAWAAAMAMQALALAAAZIAABaIgKAAIgDgVIgBAAQgKANgLAFQgKAGgPgBQgUAAgLgKgEANXggpQgdABgMAIQgMAIAAAPQAAANAIAHQAHAHAPAAQAWAAAMgMQAMgMAAgWIAAgOgAJw/sQgJgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAHAAIAAAgIAnAAIAAALIgnAAIAABWQAAAPAFAIQAGAHALAAQANAAAIgBIAAAJQgJADgMAAQgSAAgIgJgAFk/1QgQgSAAggQAAgiAQgSQAQgUAbAAQAYAAANARQAOARAAAcIAAAKIhhAAQAAAbANAPQANAPAXAAQAMAAAJgBQAHgBAPgHIAAAMQgLAFgKABQgJACgNAAQgdAAgRgSgEAFvghXQgLAMgCAZIBTAAQAAgYgKgNQgKgNgSAAQgUAAgMANgACW/1QgQgSAAggQAAgiAQgSQAPgUAcAAQAXAAAOARQAOARAAAcIAAAKIhhAAQAAAcANAOQAMAPAYAAQAMAAAJgBQAHgBAPgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgEAChghXQgMANgCAYIBUAAQAAgXgKgOQgKgNgSAAQgUAAgMANgAhU/sQgJgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAHAAIAAAgIAnAAIAAALIgnAAIAABWQAAAQAFAHQAGAHALAAQANAAAIgBIAAAJQgJADgMAAQgSAAgIgJgAkj/rIAAgNQAVAKAXAAQAUAAAKgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgIgJgFQgHgFgFgHQgEgGAAgKQAAgPANgJQAMgJAXAAQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQATAHAIAFQAIAFAEAHQAFAHAAAIQAAASgOAKQgOAKgZAAQgbABgRgJgAn7/rQgOgJgHgQQgHgRAAgUQAAggAQgTQAQgTAcAAQAcAAAQATQAQATAAAgQAAAhgQATQgQASgcAAQgTABgNgJgEgH+ghUQgMAPAAAcQAAAcAMAPQANAQAWAAQAXAAAMgQQAMgQAAgbQAAgcgMgPQgNgQgWAAQgXAAgMAQgAsn/rQgNgJgHgQQgIgRAAgUQAAghAQgSQARgTAbAAQAcAAAQATQAQASAAAhQAAAhgQATQgQASgcAAQgSABgOgJgEgMqghUQgMAPAAAcQAAAcANAPQALAQAXAAQAXAAAMgQQAMgPAAgcQAAgcgMgPQgNgQgWAAQgWAAgNAQgA3+/rIAAgNQAUAKAXAAQAUAAAKgHQALgGAAgMQAAgJgJgIQgIgHgTgGQgUgIgIgFQgIgFgFgHQgEgGAAgKQAAgPANgJQANgJAXAAQAVAAAUAIIgFAMQgTgJgRAAQgRAAgKAGQgJAFAAAKQAAALAHAGQAHAGAXAIQASAHAIAFQAJAFAEAHQAEAHAAAIQAAASgOAKQgOAKgZAAQgbABgQgJgA6D/0QgPgRAAgiQAAgjAPgSQAPgTAcAAQAOAAALAFQALAGAIAMIABAAIgBgeIAAgxIAMAAIAADCIgIAAIgDgUIgBAAQgPAWgdAAQgcAAgPgRgEgZ6ghUQgLAQAAAdQAAA5AtAAQAXAAALgNQAKgOAAgeIAAgCQAAgfgKgOQgLgOgXAAQgWAAgMAQgA+k/1QgQgSAAggQAAgiAQgSQAQgUAbAAQAYAAAOARQANARAAAcIAAAKIhhAAQAAAcANAOQANAPAXAAQAMAAAJgBQAIgBAOgHIAAAMQgMAFgJABQgJACgNAAQgdAAgRgSgEgeZghXQgLANgCAYIBTAAQAAgXgKgOQgKgNgSAAQgUAAgMANgEgmSgftQgLgKAAgSQAAgUARgLQAQgLAfgBIAaAAIAAgJQAAgUgIgJQgHgKgSAAQgTAAgUAKIgFgKQAXgLAVAAQAXAAALAMQALALAAAZIAABaIgJAAIgDgVIgBAAQgLANgKAFQgLAGgPgBQgUAAgLgKgEglbggpQgcABgNAIQgMAIAAAPQAAANAIAHQAIAHAOAAQAWAAAMgMQANgMAAgWIAAgOgEgwRgf1QgQgSAAggQAAgiAQgSQAQgUAbAAQAYAAANARQAOARAAAcIAAAKIhhAAQAAAbANAPQANAPAXAAQAMAAAJgBQAHgBAPgHIAAAMQgLAFgKABQgJACgNAAQgdAAgRgSgEgwGghXQgLANgCAYIBTAAQAAgYgKgNQgKgNgSAAQgUAAgMANgEgxmgfsQgIgKAAgUIAAhYIgUAAIAAgHIAUgFIAGgfIAGAAIAAAgIAoAAIAAALIgoAAIAABWQAAAQAGAHQAGAHALAAQANAAAHgBIAAAJQgJADgLAAQgSAAgJgJgEgzygfrIAAgNQAUAKAXAAQAUAAALgHQAKgGAAgMQAAgJgIgIQgIgHgTgGQgUgHgJgGQgIgFgEgHQgEgHAAgJQAAgPAMgJQANgJAXAAQAWAAAUAIIgFAMQgUgJgRAAQgQAAgKAGQgKAFAAAKQAAALAIAGQAHAGAWAIQASAHAJAFQAIAFAEAHQAEAGAAAJQAAATgNAJQgOAKgaAAQgbABgQgJgEg1sgftQgLgKAAgSQAAgUAQgLQARgLAfgBIAaAAIAAgJQAAgUgIgJQgIgKgRAAQgTAAgUAKIgFgKQAXgLAVAAQAXAAALAMQALALAAAZIAABaIgJAAIgEgVIgBAAQgKANgKAFQgLAGgPgBQgUAAgLgKgEg01ggpQgcABgNAIQgMAIAAAPQAAANAIAHQAIAHAOAAQAWAAAMgMQAMgMAAgWIAAgOgEA1MgflIAAhYQAAgUgJgJQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgNAAIAAiIIALAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgEAwegflIAAiIIANAAIAACIgEArfgflIAAiIIAKAAIABAZIABAAQAJgQAJgFQAJgGAOAAIASACIgCALQgIgCgKAAQgRAAgLAPQgLAPAAAWIAABLgEAjxgflIAAjCIAMAAIAADCgEAi3gflIAAjCIAMAAIAADCgAaO/lIAAiIIAKAAIACAZIABAAQAIgPAJgGQAKgGANAAIATACIgDALQgIgCgJAAQgRAAgMAPQgLAPAAAWIAABLgAXP/lIAAhYQAAgUgJgJQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgNAAIAAiIIALAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgAU3/lIAAiIIAMAAIAACIgAQ8/lIAAiIIAKAAIACAZIAAAAQAJgPAJgGQAKgGANAAIATACIgDALQgIgCgJAAQgSAAgLAPQgLAPAAAWIAABLgAK8/lIAAiIIALAAIABAZIABAAQAIgPAJgGQAKgGANAAIATACIgDALQgIgCgJAAQgRAAgMAPQgLAPAAAWIAABLgAI7/lIgrg9IgrA9IgNAAIAxhGIgvhCIAOAAIAoA5IAog5IAOAAIgvBCIAyBGgABV/lIAAhYQAAgVgIgIQgJgKgSAAQgYAAgLAMQgMANAAAbIAABLIgLAAIAAjCIALAAIAABPIABAAQAHgMAMgGQAMgFARAAQAuAAAAAxIAABZgAl6/lIAAiIIALAAIABAZIABAAQAJgPAJgGQAJgGAOAAIASACIgCALQgJgCgJAAQgRAAgLAPQgLAPAAAWIAABLgApH/lIAAhYQAAgVgJgIQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAiIIAKAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgAtz/lIAAhYQAAgVgIgIQgJgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAjCIAMAAIgBBPIABAAQAIgMAMgGQALgFARAAQAuAAAAAxIAABZgAzl/lIAAiIIAMAAIAACIgA0d/lIAAhYQAAgUgJgJQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAjCIAMAAIgBBPIABAAQAIgMALgGQANgFAQAAQAuAAAAAxIAABZgA7C/lIAAhYQAAgUgIgJQgJgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAiIIAKAAIADATIAAAAQAOgVAhAAQAuAAAAAxIAABZgA/m/lIAAiIIAMAAIAACIgEghJgflIAAiIIAKAAIACAZIAAAAQAJgQAJgFQAKgGANAAIATACIgDALQgIgCgJAAQgSAAgLAPQgLAPAAAWIAABLgEgjGgflIAAi2IBkAAIAAALIhXAAIAABOIBSAAIAAALIhSAAIAABSgEgqSgflIAAhYQAAgVgJgIQgIgKgSAAQgYAAgMAMQgLANAAAbIAABLIgMAAIAAiIIAKAAIACATIABAAQANgVAiAAQAuAAAAAxIAABZgEgsqgflIAAiIIAMAAIAACIgEguNgflIAAiIIAKAAIABAZIABAAQAJgQAJgFQAJgGAOAAIASACIgCALQgIgCgKAAQgRAAgLAPQgLAPAAAWIAABLgEg2qgflIAAiKIACgeIgBAAIhECoIgIAAIhEioIgBAAIABAgIAACIIgMAAIAAi2IATAAIBBCgIAAAAIBBigIATAAIAAC2gEAwdgiSQAAgMAIAAQADAAADADQACAEAAAFQAAAGgCADQgDADgDAAQgIAAAAgMgEAU1giSQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEgTngiSQAAgMAIAAQAEAAACADQACADAAAGQAAAGgCADQgCADgEAAQgIAAAAgMgEgfogiSQAAgMAIAAQAEAAACADQACAEAAAFQAAAGgCADQgCADgEAAQgIAAAAgMgEgssgiSQAAgMAIAAQAEAAACADQACAEAAAFQAAAGgCADQgCADgEAAQgIAAAAgMg");
	this.shape_6741.setTransform(432.1,600.1);
	this.shape_6741._off = true;

	this.timeline.addTween(cjs.Tween.get(this.shape_6741).wait(1).to({_off:false},0).to({_off:true},1).wait(163));

	// Layer 1
	this.start1 = new lib.start();
	this.start1.name = "start1";
	this.start1.parent = this;
	this.start1.setTransform(1665,473.3);
	new cjs.ButtonHelper(this.start1, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.start1).to({_off:true},1).wait(164));

	// Slide 1
	this.shape_6742 = new cjs.Shape();
	this.shape_6742.graphics.f("#5F493F").s().p("AoqHDQhfhggwh9QgphsAAhvQAAiHA7iCQA8iBBrhlQB3hsCSgxQCVgwDUAAQATAAB3AGQB1AFAXAAQBdAAAjgLIAYAAIAAEWIgnAAQgDgygIgeQgJgfgRgYQghgzhegcQhggciKAAQloAAiXC4Qh9CZAAE7QAAE2CvCrQCwCrFAAAQCAAAA1gYQA0gYAAg7IAAi9QAAhZgYgbQgYgbhQAAIhjAAIAAglICaAFQBbACA8AAQA7AABVgCICOgFIAAAlIg2AAQhRAAgZAbQgYAbAABZIAAE2QhaAMhrAHQhpAGhaAAQncAAjxjvg");
	this.shape_6742.setTransform(1319.6,332,0.5,0.5);

	this.shape_6743 = new cjs.Shape();
	this.shape_6743.graphics.f("#5F493F").s().p("AI7KnIwQx7IAPO7QACBIAlAgQAlAhBRAAIBNAAIAAAkQhHgBhXgDIhWgCQh+AEh1ACIAAgkIA2AAQA8AAApgpQAqgoAAg6IgVvyQhMhOglgTQgjgThJAAIAAglIADAAIBOAFQAtACAgAAIBLgCIBXgFIPDQlIgMthQgChVgoglQgoglhbAAIgxAAIAAglIB2AFQBGACAuAAQAtAABCgCIBugFIAAAlIgsAAQhBAAgiAcQghAdgBA5IARS2g");
	this.shape_6743.setTransform(1229.4,332.5,0.5,0.5);

	this.shape_6744 = new cjs.Shape();
	this.shape_6744.graphics.f("#5F493F").s().p("AgIKXQg3AAhTACIiMAEIAAgkIBDAAQBQAAAYgcQAagbAAhZIAAvPQAAhZgYgbQgYgchQAAIg0AAIAAgmICMAEQBSACA3AAQA6AABRgCICLgEIAAAmIhCAAQhQAAgZAcQgZAbgBBZIAAPPQAABZAZAbQAYAcBPAAIA0AAIAAAkQi4gGhdAAg");
	this.shape_6744.setTransform(1164.9,332.1,0.5,0.5);

	this.shape_6745 = new cjs.Shape();
	this.shape_6745.graphics.f("#5F493F").s().p("AEdKKQgqgghiiYIhDhmQi+ksgPgUQgHgKgTgHQgegMg0AAQhWAHgPAAIAAHXQAABZAZAbQAXAbBQABIBHAAIAAAkQixgGhYgBQg5ABhXACIiQAEIAAgkIAsAAQBRgBAZgbQAZgbgBhZIAAvQQAAhZgYgbQgYgchPAAIgyAAIAAgkQBwgKCUgKQCGgHBdgDQDiAACGBbQCFBaAACYQAABig7BLQg9BNiRBVIB4CwQDHEhBBBVQAxA/AwAZQAwAaBAAAIBOAAIAAAgQiZAXhXgBQhzABg1gsgAlQqLIAAJvQA9AKA+AAQCbAABGhHQBHhHABiYQAAikhUhcQhUhciXAAQgbAAhKAJg");
	this.shape_6745.setTransform(1106.6,331.9,0.5,0.5);

	this.shape_6746 = new cjs.Shape();
	this.shape_6746.graphics.f("#5F493F").s().p("AgYKXQmEAHh5gBIAAgkIAvAAQBPAAAZgcQAYgbAAhZIAAvPQAAhZgYgbQgZgchPAAIgxAAIAAgmQEXAGEFAAQDMAADdgGIAKEKIglAAQgJh/grgrQgqgshzAAIl1AAIAAIwIFiAAQBGAAAfghQAfgiAFhTIAlAAIAAF1IglAAQgDhcgogtQgogqhPAAIlJAAIAAIIQAAA+AbAYQAbAaBDAAIEVAAQBiAAA0gnQA1gmBNiBIAlAAIhnD/QldgGhsAAg");
	this.shape_6746.setTransform(1027,332.1,0.5,0.5);

	this.shape_6747 = new cjs.Shape();
	this.shape_6747.graphics.f("#5F493F").s().p("AgIKnQg3AAhUACIiKAEIAAgkIBCAAQBRAAAZgbQAZgaAAhWIAAxKIl3AAQhSgBgbAmQgeAngLCMIgiAAIAHk5IAGAAQAiAUAYAGQAcAGA1ABIPfAAQA1gBAbgGQAZgGAjgUIAFAAIAHE5IgiAAQgLiMgdgnQgcgmhSABIl2AAIAARKQAABWAYAaQAYAbBQAAIAzAAIAAAkQi4gGhdAAg");
	this.shape_6747.setTransform(954,331.3,0.5,0.5);

	this.shape_6748 = new cjs.Shape();
	this.shape_6748.graphics.f("#5F493F").s().p("Ah9KtQgxgFhEgNQg9gLgQAAQgQAAgTAGQgTAFgHAHIgbAAIg2kaIAlgMQAzCKBjBEQBiBECTAAQCeAABihNQBihMAAh9QAAhghHhEQhIhEjEhcQjUhjhQhHQhthhAAiJQAAiWB7heQB6hdDDAAQAtAAAuAFQArAFBBANQBNANAVAAQAUAAAdgJIAUAAIAKESIgjgDQgJiAhRhDQhShDiWAAQiPAAhXA/QhYA/AABmQAABYBKBEQBMBFC8BTQC8BTBPBAQCDBtAACdQAACriKBwQiKBvjSAAQgyAAgzgFg");
	this.shape_6748.setTransform(882.9,332,0.5,0.5);

	this.shape_6749 = new cjs.Shape();
	this.shape_6749.graphics.f("#5F493F").s().p("AG7KjQiBABh1AGIAAgkIBAAAQAiAAAUgSQAUgRAAgdQAAgcgKgYIi2m/ImcAAIiSGKQgWA7AAAsQAAAeAbASQAaASAwAAIBAAAIAAAkQiKgGhHgBQiRABhAAGIAAgkIAqAAQBEAAAhgXQAggWAYhAIG9zCIA4AAIHHRYQA3CMAgAmQAgAlA/AAIAsAAIAAAkQiHgGhxgBgAj3ATIFrAAIjCnSg");
	this.shape_6749.setTransform(809.9,331.5,0.5,0.5);

	this.shape_6750 = new cjs.Shape();
	this.shape_6750.graphics.f("#5F493F").s().p("Ag6KpIonxCIgUOFQgDBOAkAaQAkAZBvABIApAAIAAAkQingGhTgBQg7ABjPAGIAAgkQBvAAAugSQBMgdADhXIAXuRQACh5gxgxQgxgxh7AAIgsAAIAAgkIACAAIBaAFQA2ACAkAAQAoAAA6gCIBfgFIADAAII5RtIHnxtIBrAFQBAACApAAQArAAA+gCIBogFIAAAkIgkAAQheABgrAfQgrAgAABDIATPdQADBXAgAeQAgAdBgAAIAkAAIAAAkQi1gGhbgBQg8ABhdACIibAEIAAgkIAlAAQBbAAAogdQApgegChBIgUxFIomT8g");
	this.shape_6750.setTransform(715.3,332.7,0.5,0.5);

	this.shape_6751 = new cjs.Shape();
	this.shape_6751.graphics.f("#4D362E").s().p("AjfGBIAAsBIDRAAQAqAAApAJQAqAJAjAWQAiAXAWAkQAVAkAAA4QAAAxgRAmQgTAmgeAYQgdAZgqANQgnAMgvAAIjGAAIAAF7gAjGgNIDHAAQAkAAAkgKQAjgKAcgWQAdgVARgjQASghgBgxQABgxgTggQgRgggfgVQgdgTglgJQgigIglAAIjCAAg");
	this.shape_6751.setTransform(1193.1,483.6,0.5,0.5);

	this.shape_6752 = new cjs.Shape();
	this.shape_6752.graphics.f("#4D362E").s().p("AgLGBIAAsBIAXAAIAAMBg");
	this.shape_6752.setTransform(1160.5,483.6,0.5,0.5);

	this.shape_6753 = new cjs.Shape();
	this.shape_6753.graphics.f("#4D362E").s().p("AEDGBIAAmCIoFAAIAAGCIgYAAIAAsBIAYAAIAAFpIIFAAIAAlpIAYAAIAAMBg");
	this.shape_6753.setTransform(1125,483.6,0.5,0.5);

	this.shape_6754 = new cjs.Shape();
	this.shape_6754.graphics.f("#4D362E").s().p("AiEF9Qg8gZgngsIATgQQAoAsA4AXQA3AWA7AAQAnAAAogMQAngNAdgXQAdgXARgjQARgiAAgtQAAgtgTgeQgTgfgdgVQgdgWglgPQgogPgjgLQgsgNgsgSQgogSgcgYQgdgYgQgiQgQgjAAgxQAAgvATgmQAUgmAggZQAggZAsgOQArgOAvAAQA5AAA2AWQA2AXAhApIgTAQQgegmgwgVQgugVg4AAQgoAAgkALQgkAKggAXQgfAXgSAhQgTAiAAAtQAAAtARAfQAQAfAbAWQAbAWAjAOQAhAOAlAMQAwAPAqARQArARAgAYQAfAXATAjQASAiAAAxQAAAxgTAnQgTAnggAaQgfAbgrANQgsAOgtAAQhIAAg7gag");
	this.shape_6754.setTransform(1080.3,483.6,0.5,0.5);

	this.shape_6755 = new cjs.Shape();
	this.shape_6755.graphics.f("#4D362E").s().p("AlBGBIAAsBIDbAAQBYAABNAWQBOAXA5AvQA6AvAhBJQAgBKABBiQgBBkggBIQghBJg6AvQg4AvhPAXQhOAXhXAAgAkpFrIC9AAQBVAABKgVQBLgWA1grQA2gsAhhFQAfhEAAhgQAAhfgfhFQghhGg2grQg1gshLgVQhLgUhUAAIi9AAg");
	this.shape_6755.setTransform(1035.5,483.6,0.5,0.5);

	this.shape_6756 = new cjs.Shape();
	this.shape_6756.graphics.f("#4D362E").s().p("AERHqIoorjIgEAAIAALjIgYAAIAAsBIAiAAIIpLiIADAAIAAu0IAZAAIAAPTg");
	this.shape_6756.setTransform(983.3,478.3,0.5,0.5);

	this.shape_6757 = new cjs.Shape();
	this.shape_6757.graphics.f("#4D362E").s().p("AjoGBIAAsBIHAAAIAAAWImoAAIAAFSIGPAAIAAAWImPAAIAAFtIG5AAIAAAWg");
	this.shape_6757.setTransform(938.3,483.6,0.5,0.5);

	this.shape_6758 = new cjs.Shape();
	this.shape_6758.graphics.f("#4D362E").s().p("AgLGBIAAsBIAXAAIAAMBg");
	this.shape_6758.setTransform(905.2,483.6,0.5,0.5);

	this.shape_6759 = new cjs.Shape();
	this.shape_6759.graphics.f("#4D362E").s().p("ADNGBIjomDIi0AAIAAGDIgYAAIAAsBIDVAAQAqAAArAHQAsAIAiAVQAiAVAWAlQAWAmAAA6QAAA3gVAkQgUAjghAXQghAWgoAKQgpAKgjAAIDoGEgAjPgXIC8AAQBqAAA4gtQA4gsAAhSQAAgygUghQgTghghgTQgggTgqgIQgsgIgoAAIiwAAg");
	this.shape_6759.setTransform(874.7,483.6,0.5,0.5);

	this.shape_6760 = new cjs.Shape();
	this.shape_6760.graphics.f("#4D362E").s().p("AjbGBIAAsBIG3AAIAAAWImfAAIAAFSIGBAAIAAAWImBAAIAAGDg");
	this.shape_6760.setTransform(834.3,483.6,0.5,0.5);

	this.shape_6761 = new cjs.Shape();
	this.shape_6761.graphics.f("#4D362E").s().p("AnwKVII+0pIAeAAIGEOaIgaAAIiel1Im/AAIlOMEgAh+iDIGuAAIjUoCg");
	this.shape_6761.setTransform(1008.6,452.2,0.5,0.5);

	this.shape_6762 = new cjs.Shape();
	this.shape_6762.graphics.f("#000000").s().p("AiCDnIAAnNIAvAAIAAGjIDWAAIAAAqg");
	this.shape_6762.setTransform(1380.6,647.1,0.5,0.5);

	this.shape_6763 = new cjs.Shape();
	this.shape_6763.graphics.f("#000000").s().p("AiSDnIAAnNIEdAAIAAAqIjuAAIAACfIDfAAIAAAoIjfAAIAACyID2AAIAAAqg");
	this.shape_6763.setTransform(1362.1,647.1,0.5,0.5);

	this.shape_6764 = new cjs.Shape();
	this.shape_6764.graphics.f("#000000").s().p("AB+DnIAAjaIj7AAIAADaIgvAAIAAnNIAvAAIAADJID7AAIAAjJIAvAAIAAHNg");
	this.shape_6764.setTransform(1340,647.1,0.5,0.5);

	this.shape_6765 = new cjs.Shape();
	this.shape_6765.graphics.f("#000000").s().p("Ag+DgQgsgSggggQghghgRgsQgSgrAAg2QAAg0ASgsQASgtAhggQAfggAtgTQAtgSAyAAQAaAAAYAFQAYAGAWAJQAWAKARANQAQAMANATIgnAdQgHgLgMgMQgMgLgRgIQgPgIgUgGQgUgFgWAAQgrAAgkAQQgiAPgbAdQgYAbgNAlQgNAjAAApQAAAnANAmQANAkAZAcQAZAbAjARQAlAQAqAAQAoAAAkgRQAkgPAYglIAlAYQgMARgRAQQgPAPgXANQgUALgcAIQgcAHgeAAQgyAAgugTg");
	this.shape_6765.setTransform(1317,647.1,0.5,0.5);

	this.shape_6766 = new cjs.Shape();
	this.shape_6766.graphics.f("#000000").s().p("AgXDnIAAnNIAuAAIAAHNg");
	this.shape_6766.setTransform(1300.6,647.1,0.5,0.5);

	this.shape_6767 = new cjs.Shape();
	this.shape_6767.graphics.f("#000000").s().p("AC1DnIAAmQIgCAAIinGQIgYAAIinmQIgBAAIAAGQIguAAIAAnNIBHAAICbF9IABAAICbl9IBHAAIAAHNg");
	this.shape_6767.setTransform(1281.9,647.1,0.5,0.5);

	this.shape_6768 = new cjs.Shape();
	this.shape_6768.graphics.f("#000000").s().p("AgXDnIAAjHIitkGIA8AAICJDgICMjgIA3AAIisEGIAADHg");
	this.shape_6768.setTransform(1250.2,647.1,0.5,0.5);

	this.shape_6769 = new cjs.Shape();
	this.shape_6769.graphics.f("#000000").s().p("Ag+DgQgsgSggggQgggggSgtQgSgtAAg0QAAg1ATgrQASgtAgggQAfgfAtgUQAtgSAyAAQAbAAAXAFQAZAGAVAJQAWAKARANQASAOALARIgnAdQgGgLgNgMQgNgMgPgHQgQgIgUgGQgUgFgVAAQgsAAgkAQQgjAQgZAcQgYAbgOAlQgNAlAAAnQAAAoANAlQAOAlAYAbQAYAbAlARQAkAQArAAQAnAAAkgRQAkgPAYglIAlAYQgLARgRAQQgSAQgVAMQgVALgbAIQgbAHgfAAQgxAAgvgTg");
	this.shape_6769.setTransform(1229.4,647.1,0.5,0.5);

	this.shape_6770 = new cjs.Shape();
	this.shape_6770.graphics.f("#000000").s().p("ACBDnIkMmMIgBAAIAAGMIgvAAIAAnNIA7AAIEMGIIABAAIAAmIIAvAAIAAHNg");
	this.shape_6770.setTransform(1204.8,647.1,0.5,0.5);

	this.shape_6771 = new cjs.Shape();
	this.shape_6771.graphics.f("#000000").s().p("ACpDnIgyh6IjuAAIgyB6Ig0AAIDInNIAtAAIDGHNgAhlBDIDKAAIhlj1g");
	this.shape_6771.setTransform(1180.9,647.1,0.5,0.5);

	this.shape_6772 = new cjs.Shape();
	this.shape_6772.graphics.f("#000000").s().p("ACBDnIkMmMIgBAAIAAGMIgvAAIAAnNIA7AAIELGIIACAAIAAmIIAvAAIAAHNg");
	this.shape_6772.setTransform(1157,647.1,0.5,0.5);

	this.shape_6773 = new cjs.Shape();
	this.shape_6773.graphics.f("#000000").s().p("Ah3DoQgagIgUgQQgUgQgLgYQgLgYAAgfQAAgaAIgVQAIgVAOgRQAPgQATgMQATgNAXgKIgUgXQgKgMgIgOQgHgMgFgQQgFgRgBgOQAAgbAKgTQAJgVAPgOQAQgNAVgIQATgHAZAAQAYAAASAHQAWAIAOAMQAQAOAIATQAJATAAAZQAAAXgJASQgIASgQAPQgNAOgUAMQgQALgVAKIBrBuIBAhvIA0AAIhUCOIBnBrIhAAAIhChFQgdAoghASQghATguAAQgdAAgbgJgAiKAyQgVAaAAAlQAAAUAIAQQAGAQAOAMQAPAMARAGQAQAGAUAAQAnAAAYgQQAYgRAXgiIh5iAQgpASgXAagAhbi2QgUATAAAhQAAANAFAMQAFANAIANIARAVQAKALAFAEIAfgQQAPgJAMgLQALgLAIgOQAHgOAAgSQAAgcgSgTQgRgSgdAAQgeAAgUATg");
	this.shape_6773.setTransform(1125.4,647,0.5,0.5);

	this.shape_6774 = new cjs.Shape();
	this.shape_6774.graphics.f("#000000").s().p("AgrDuQgVgEgTgIQgTgJgQgNQgRgNgMgRIAogeQAPAZAcAQQAaARAlAAQAQAAATgFQATgHAOgKQAPgMAJgQQAKgSAAgVQAAgYgKgQQgIgPgRgMQgPgLgVgHIgpgOQgXgIgWgIQgWgIgSgQQgSgOgKgWQgLgVAAggQAAggANgZQAOgYAVgQQAVgPAbgIQAYgHAaAAQAvAAAhARQAiAQARAXIglAeQgPgUgYgNQgYgNghAAQgPAAgSAFQgTAGgNAKQgPALgIAQQgJARAAAWQAAAWAIAOQAIAOAPALQANAJATAHIAkANIAwARQAZAIATAPQATAOANAXQANAYAAAhQAAAjgOAZQgNAZgVARQgVAQgbAIQgdAIgYAAQgVAAgVgFg");
	this.shape_6774.setTransform(1095.9,647.1,0.5,0.5);

	this.shape_6775 = new cjs.Shape();
	this.shape_6775.graphics.f("#000000").s().p("ACBDnIkMmMIgBAAIAAGMIgvAAIAAnNIA7AAIELGIIACAAIAAmIIAvAAIAAHNg");
	this.shape_6775.setTransform(1074.4,647.1,0.5,0.5);

	this.shape_6776 = new cjs.Shape();
	this.shape_6776.graphics.f("#000000").s().p("AgXDnIAAnNIAuAAIAAHNg");
	this.shape_6776.setTransform(1057.7,647.1,0.5,0.5);

	this.shape_6777 = new cjs.Shape();
	this.shape_6777.graphics.f("#000000").s().p("ABoDnIjmj1IAAAAIAAD1IgvAAIAAnNIAvAAIAADQIAAAAIDbjQIBEAAIjoDSID1D7g");
	this.shape_6777.setTransform(1044.7,647.1,0.5,0.5);

	this.shape_6778 = new cjs.Shape();
	this.shape_6778.graphics.f("#000000").s().p("AgWDnIAAmjIibAAIAAgqIFjAAIAAAqIiaAAIAAGjg");
	this.shape_6778.setTransform(1023.7,647.1,0.5,0.5);

	this.shape_6779 = new cjs.Shape();
	this.shape_6779.graphics.f("#000000").s().p("ACqDnIgzh6IjuAAIgyB6Ig0AAIDInNIAsAAIDHHNgAhmBDIDLAAIhlj1g");
	this.shape_6779.setTransform(1004.9,647.1,0.5,0.5);

	this.shape_6780 = new cjs.Shape();
	this.shape_6780.graphics.f("#000000").s().p("AB1DnIh0mLIgBAAIh0GLIg3AAIiInNIAxAAIBzGNIABAAIB0mNIA3AAIBzGNIABAAIBxmNIAyAAIiIHNg");
	this.shape_6780.setTransform(978,647.1,0.5,0.5);

	this.shape_6781 = new cjs.Shape();
	this.shape_6781.graphics.f("#000000").s().p("AhSDSQghgbgIgpIAsgMQAFAbATATQAUATAfAAQAXAAAQgIQAQgKAJgOQAJgPAEgUQAEgWAAgSIAAlEIAvAAIAAFIQAAAVgFAbQgGAbgNAUQgOAWgYAOQgZAOglAAQgxAAghgbg");
	this.shape_6781.setTransform(945.3,647.4,0.5,0.5);

	this.shape_6782 = new cjs.Shape();
	this.shape_6782.graphics.f("#000000").s().p("AgXDnIAAnNIAvAAIAAHNg");
	this.shape_6782.setTransform(934.1,647.1,0.5,0.5);

	this.shape_6783 = new cjs.Shape();
	this.shape_6783.graphics.f("#000000").s().p("AB1DnIh0mLIgBAAIh0GLIg3AAIiInNIAyAAIByGNIABAAIBzmNIA4AAIBzGNIACAAIBwmNIAyAAIiIHNg");
	this.shape_6783.setTransform(914,647.1,0.5,0.5);

	this.shape_6784 = new cjs.Shape();
	this.shape_6784.graphics.f("#000000").s().p("AhfDgQgsgSggggQgggggTgtQgSgtAAg0QAAg0ASgsQAUguAfgfQAfggAtgTQAtgSAyAAQA0AAArASQAtATAgAgQAgAgASAtQATAtAAAzQAAAzgTAuQgSAsggAhQghAggsASQgsATgzAAQgxAAgugTgAhPi4QgkARgYAbQgaAdgMAjQgNAkAAAoQAAAqANAjQAMAkAaAcQAYAbAkARQAkAQArAAQAsAAAkgQQAkgRAYgbQAZgbANglQANgkAAgpQAAgngNglQgNgkgZgcQgYgbgkgRQgjgQgtAAQgrAAgkAQg");
	this.shape_6784.setTransform(884.2,647.1,0.5,0.5);

	this.shape_6785 = new cjs.Shape();
	this.shape_6785.graphics.f("#000000").s().p("AiCDnIAAnNIAvAAIAAGjIDWAAIAAAqg");
	this.shape_6785.setTransform(864.3,647.1,0.5,0.5);

	this.shape_6786 = new cjs.Shape();
	this.shape_6786.graphics.f("#000000").s().p("AhfDgQgsgSggggQgggggTgtQgSgtAAg0QAAg0ASgsQAUguAfgfQAfggAtgTQAtgSAyAAQA0AAArASQAtATAgAgQAgAgASAtQATArAAA1QAAA1gTAsQgSAsggAhQghAggsASQgsATgzAAQgxAAgugTgAhPi4QgkARgYAbQgaAdgMAjQgNAmAAAmQAAAoANAlQAMAkAaAcQAYAbAkARQAkAQArAAQAsAAAkgQQAkgRAYgbQAYgaAOgmQANglAAgoQAAgmgNgmQgNgkgZgcQgYgbgkgRQgjgQgtAAQgrAAgkAQg");
	this.shape_6786.setTransform(840.8,647.1,0.5,0.5);

	this.shape_6787 = new cjs.Shape();
	this.shape_6787.graphics.f("#000000").s().p("AgrDuQgXgFgRgHQgUgKgPgMQgSgPgLgPIApgeQAPAZAbAQQAaARAlAAQAQAAATgFQATgGAOgLQAQgOAIgOQAKgRAAgWQAAgZgKgPQgIgPgRgMQgPgLgVgHIhWgeQgXgJgRgPQgSgOgKgWQgLgXAAgeQAAggANgZQAOgYAVgQQAWgPAagIQAYgHAaAAQAvAAAiARQAiARAQAWIglAeQgPgUgYgNQgXgNgiAAQgOAAgTAFQgTAGgNAKQgOAKgJARQgJARAAAWQAAAWAIAOQAKAPANAKQAOAKASAGIBVAeQAZAJATAOQATAOAMAXQANAWAAAjQAAAigNAaQgOAZgVARQgVAQgbAIQgdAIgYAAQgVAAgVgFg");
	this.shape_6787.setTransform(817.6,647.1,0.5,0.5);

	this.shape_6788 = new cjs.Shape();
	this.shape_6788.graphics.f("#000000").s().p("ACpDnIgyh6IjuAAIgzB6IgzAAIDHnNIAtAAIDHHNgAhmBDIDLAAIhlj1g");
	this.shape_6788.setTransform(789.5,647.1,0.5,0.5);

	this.shape_6789 = new cjs.Shape();
	this.shape_6789.graphics.f("#000000").s().p("ABiDnIh/jYIhOAAIAADYIgvAAIAAnNICIAAQAeAAAfAGQAeAIAVAOQAUAOANAYQALAYAAAhQAAAbgJATQgIAVgRAQQgPAPgWAJQgWAJgZACICHDcgAhrgZIBRAAQA5AAAegUQAegUAAgqQAAgXgIgPQgIgQgQgKQgPgKgVgEQgVgEgagBIhTAAg");
	this.shape_6789.setTransform(769.4,647.1,0.5,0.5);

	this.shape_6790 = new cjs.Shape();
	this.shape_6790.graphics.f("#000000").s().p("AjFDnIAAnNICaAAQAqAAArAOQAsAPAiAdQAkAdAUArQAWArAAA5QAAA7gWAqQgUArgkAdQgjAegrANQgqAPgrAAgAiWC9IBdAAQA0AAAmgQQAogQAYgbQAagaANgiQAMghAAglQAAgjgMgiQgNghgagbQgZgbgngQQgmgQg0AAIhdAAg");
	this.shape_6790.setTransform(746.8,647.1,0.5,0.5);

	this.shape_6791 = new cjs.Shape();
	this.shape_6791.graphics.f("#000000").s().p("ACBDnIkMmMIgBAAIAAGMIgvAAIAAnNIA7AAIELGIIACAAIAAmIIAvAAIAAHNg");
	this.shape_6791.setTransform(721.4,647.1,0.5,0.5);

	this.shape_6792 = new cjs.Shape();
	this.shape_6792.graphics.f("#000000").s().p("ACqDnIg0h6IjtAAIgzB6IgzAAIDInNIAtAAIDGHNgAhlBDIDKAAIhlj1g");
	this.shape_6792.setTransform(697.5,647.1,0.5,0.5);

	this.shape_6793 = new cjs.Shape();
	this.shape_6793.graphics.f("#000000").s().p("ACNDnIiNjQIiMDQIg6AAICpjxIiajcIA6AAIB+C6IB+i6IA4AAIiZDcICpDxg");
	this.shape_6793.setTransform(675.5,647.1,0.5,0.5);

	this.shape_6794 = new cjs.Shape();
	this.shape_6794.graphics.f("#000000").s().p("AiSDnIAAnNIEdAAIAAAqIjuAAIAACfIDfAAIAAAoIjfAAIAACyID2AAIAAAqg");
	this.shape_6794.setTransform(656,647.1,0.5,0.5);

	this.shape_6795 = new cjs.Shape();
	this.shape_6795.graphics.f("#000000").s().p("AiCDnIAAnNIAvAAIAAGjIDWAAIAAAqg");
	this.shape_6795.setTransform(638.6,647.1,0.5,0.5);

	this.shape_6796 = new cjs.Shape();
	this.shape_6796.graphics.f("#000000").s().p("ACqDnIgzh6IjuAAIgyB6Ig0AAIDInNIAsAAIDHHNgAhmBDIDLAAIhlj1g");
	this.shape_6796.setTransform(617.6,647.1,0.5,0.5);

	this.shape_6797 = new cjs.Shape();
	this.shape_6797.graphics.f("#000000").s().p("AgcCFQgEgDAAgHQAAgGAEgFQAFgFAGAAQAFAAAEADQADADAAAHQAAAHgEAFQgFAFgFAAQgGAAgDgEgAAJhtQgDgEAAgHQAAgGAEgFQAEgFAHAAQAFAAADADQAEADAAAHQAAAHgEAFQgFAFgGAAQgEAAgFgDg");
	this.shape_6797.setTransform(1173,603.1,0.5,0.5);

	this.shape_6798 = new cjs.Shape();
	this.shape_6798.graphics.f("#000000").s().p("AhDCEQgXgJgLgRIAJgIQALAPAVAJQAUAJAZAAQASAAANgGQAPgFALgKQAKgJAGgNQAGgNAAgNQAAgMgEgIQgCgKgJgGQgHgIgNgGIgggMQgjgLgOgOQgPgOAAgXQAAgVAJgOQAIgPAOgKQANgJARgGQASgFAPAAQAcAAATAJQASAKAJANIgKAIQgHgOgTgHQgSgIgVAAQgKAAgQADQgMAEgNAIQgMAHgIAOQgIALAAAUQAAAXAOALQAOAKAcAKQArANAPAQQAQARAAAZQAAARgHAPQgHAPgNALQgMALgRAGQgSAHgVAAQgbAAgWgLg");
	this.shape_6798.setTransform(1162.9,603,0.5,0.5);

	this.shape_6799 = new cjs.Shape();
	this.shape_6799.graphics.f("#000000").s().p("AhQCLIArj/IABgPIANAAIgEAiIgDAUIgDASIACAAQASgqAbgTQAbgSAeAAIAKAAIgBALIgFgBIgDAAQgZAAgUAMQgUALgNATQgPASgJAXQgIAUgFAZIgYCLg");
	this.shape_6799.setTransform(1154,602.8,0.5,0.5);

	this.shape_6800 = new cjs.Shape();
	this.shape_6800.graphics.f("#000000").s().p("Ag6CGQgXgJgQgQQgQgQgIgXQgJgXAAgaQAAgeAMgfQALgdAUgXQAVgXAcgOQAdgNAhAAQAbAAAVAIQAUAJANAOQANAPAGATQAHASAAAXIgBAPQgBAJgCAKIjyAAQgCAKAAAKQAAA3AeAeQAdAeA1AAQAhAAAZgOQAagPASgWIAHAIQgRAWgcAQQgcAPgkAAQgeAAgXgJgAgeh4QgaAMgQARQgQARgLAWQgKAUgEAUIDlAAQACgMAAgNQAAgqgZgaQgZgbgsAAQgeAAgYAMg");
	this.shape_6800.setTransform(1140.2,603,0.5,0.5);

	this.shape_6801 = new cjs.Shape();
	this.shape_6801.graphics.f("#000000").s().p("AgtDeIBOm7IAMAAIhMG7g");
	this.shape_6801.setTransform(1129.4,598.7,0.5,0.5);

	this.shape_6802 = new cjs.Shape();
	this.shape_6802.graphics.f("#000000").s().p("Ag6CGQgXgJgRgQQgPgQgIgXQgJgWAAgbQAAgfALgeQAMgdAVgXQATgXAdgOQAdgNAhAAQAbAAAVAIQAUAJANAOQANAOAGAUQAGATABAWIgBAPIgEATIjxAAIgCAUQAAA3AdAeQAfAeA0AAQAhAAAZgOQAZgOATgXIAHAIQgQAWgdAQQgcAPgkAAQgeAAgXgJgAgeh4QgZAMgRARQgRAQgLAXQgLAXgCARIDlAAIABgZQAAgrgYgZQgagbgrAAQgeAAgYAMg");
	this.shape_6802.setTransform(1117.3,603,0.5,0.5);

	this.shape_6803 = new cjs.Shape();
	this.shape_6803.graphics.f("#000000").s().p("AAfCHIghj/IgBAAIiOD/IgRAAIgWkNIANAAIAVEAIABAAICMkAIARAAIAiEAIABAAICAkAIAOAAIiIENg");
	this.shape_6803.setTransform(1100.3,603,0.5,0.5);

	this.shape_6804 = new cjs.Shape();
	this.shape_6804.graphics.f("#000000").s().p("Ag6CGQgXgJgQgQQgQgQgIgXQgJgXAAgaQAAgeAMgfQALgdAUgXQAVgXAcgOQAdgNAhAAQAbAAAVAIQAUAJANAOQANAPAGATQAHASAAAXIgBAPQgBAJgCAKIjyAAQgCAKAAAKQAAA3AeAeQAdAeA1AAQAhAAAZgOQAagPASgWIAHAIQgRAWgcAQQgcAPgkAAQgeAAgXgJgAgeh4QgaAMgQARQgSASgJAVQgKAUgEAUIDlAAQACgMAAgNQAAgqgZgaQgZgbgsAAQgeAAgYAMg");
	this.shape_6804.setTransform(1080.8,603,0.5,0.5);

	this.shape_6805 = new cjs.Shape();
	this.shape_6805.graphics.f("#000000").s().p("AhPEPQgFAAgDgCIABgKIAPABQATABALgHQAMgHAHgJQAHgLADgNIA/lgIANAAIg6FGQgCAMgFATQgFAPgJAMQgJAMgMAGQgOAHgUAAgABAj0QgDgDAAgHQAAgGAEgFQAEgGAGAAQAGAAADADQAEAEAAAGQAAAHgFAGQgEAEgGAAQgEABgFgEg");
	this.shape_6805.setTransform(1067.6,603.3,0.5,0.5);

	this.shape_6806 = new cjs.Shape();
	this.shape_6806.graphics.f("#000000").s().p("AhQCLIAskOIANAAIgEAiQgBAKgCAKIgDASIABAAQATgrAbgSQAagSAfAAIAKAAIgCALIgEgBIgDAAQgaAAgUAMQgUAMgNASQgPAUgIAVQgJAZgEAUIgZCLg");
	this.shape_6806.setTransform(1055.4,602.8,0.5,0.5);

	this.shape_6807 = new cjs.Shape();
	this.shape_6807.graphics.f("#000000").s().p("Ag7CGQgXgJgQgQQgPgQgJgXQgIgWAAgbQAAgfAMgeQALgdAUgXQAUgXAdgOQAdgNAhAAQAbAAAVAIQATAJAOAOQAMAOAIAUQAFATAAAWIgBAPQAAAJgDAKIjxAAIgCAUQAAA3AdAeQAeAeA1AAQAgAAAagOQAagOASgXIAHAIQgQAVgdARQgcAPgkAAQgeAAgYgJgAgfh4QgZAMgQARQgRARgKAWQgLAVgDATIDlAAIABgZQAAgrgZgZQgZgbgrAAQgeAAgZAMg");
	this.shape_6807.setTransform(1041.5,603,0.5,0.5);

	this.shape_6808 = new cjs.Shape();
	this.shape_6808.graphics.f("#000000").s().p("AglCmQgNgMAAgVIABgNIAljPIg+AAIACgLIA9AAIANhPIANAAIgOBPIBKAAIgCALIhJAAIgiDEIgCAMIgBALQAAATAMAJQALAIARAAIAOgCQAJgBAHgDIAAAKQgIADgIABQgHACgJAAQgZAAgNgMg");
	this.shape_6808.setTransform(1029.9,601.2,0.5,0.5);

	this.shape_6809 = new cjs.Shape();
	this.shape_6809.graphics.f("#000000").s().p("AhDCEQgWgJgMgRIAJgIQALAPAVAJQAUAJAZAAQASAAANgGQAQgFAKgKQAKgJAGgNQAGgNAAgNQAAgMgEgIQgCgKgJgGQgIgIgMgGIgggMQgjgLgOgOQgPgOAAgXQAAgVAJgOQAIgPAOgKQANgJARgGQASgFAPAAQAcAAATAJQASAKAKANIgLAIQgHgOgTgHQgSgIgUAAQgLAAgQADQgMAEgNAIQgMAHgJAOQgHALgBAUQAAAXAPALQAOAKAdAKQAqANAPAQQAQARAAAZQAAARgHAPQgHAPgNALQgMALgRAGQgSAHgVAAQgbAAgWgLg");
	this.shape_6809.setTransform(1018.6,603,0.5,0.5);

	this.shape_6810 = new cjs.Shape();
	this.shape_6810.graphics.f("#000000").s().p("Ag3CMQgRgEgMgIQgNgIgIgNQgJgOAAgTQAAgfARgTQARgTAcgJQAdgKAmgEQAjgEAuAAIAEgWIACgQQgBgkgUgSQgVgSgjAAQgYAAgUAJQgXAKgQAOIgHgKQAUgQAZgJQAXgIAXAAQAqAAAXAVQAYAVgBAmIAAAQIgWB4QgDAPgCASIgBAcIgNAAQAAgPADgPIAFgiIgCAAQgOAhgdAUQgdATgiAAQgOAAgOgDgAAHgHQghAEgXAIQgZAKgNAQQgNAQAAAZQgBARAIAMQAIANAKAGQAKAGAOADQANADAMAAQAaAAAUgLQATgKAQgSQAOgTAJgUQAIgUAEgUIAFgZIgRAAQgkAAgjAEg");
	this.shape_6810.setTransform(1005,603,0.5,0.5);

	this.shape_6811 = new cjs.Shape();
	this.shape_6811.graphics.f("#000000").s().p("ACtCLIAdigIADgeQAAgOgFgNQgDgNgJgMQgKgLgNgHQgPgHgUAAQgWAAgSAKQgTAJgQARQgPARgLAYQgLAZgFAeIgXCHIgNAAIAcihIACgdQAAgPgEgMQgDgOgIgLQgKgMgMgGQgOgHgUAAQgrAAgfAjQgfAjgLA+IgYCHIgMAAIAskOIANAAIgEAjIgDAUIgDARIABAAQARgnAcgUQAbgUAhAAQAVAAAQAHQAQAHAKALQAJAKAGAQQAFAQAAAQIABAAQARgpAegVQAegVAiAAQAVAAARAHQAQAIAKAMQALAMAFAPQAFAQAAARQAAAPgDAQIgcCfg");
	this.shape_6811.setTransform(984.6,602.8,0.5,0.5);

	this.shape_6812 = new cjs.Shape();
	this.shape_6812.graphics.f("#000000").s().p("AhODhIAukCIg5AAIABgLIA4AAIAShhQAEgZAIgPQAIgQAKgKQAMgKAMgEQAMgEAMAAQAQABALADIgDAKQgMgDgLAAQgQAAgMAHQgMAGgHALQgHAHgGAPQgFAOgBANIgRBhIBJAAIgDALIhIAAIguECg");
	this.shape_6812.setTransform(961.9,598.5,0.5,0.5);

	this.shape_6813 = new cjs.Shape();
	this.shape_6813.graphics.f("#000000").s().p("AhFCGQgXgJgQgRQgOgOgJgYQgIgXAAgZQAAgfALgeQAKgdAVgYQAVgXAcgNQAdgOAjAAQAgAAAWAJQAYAKAPAQQAQASAIAVQAHAWAAAZQAAAggKAeQgLAegVAWQgUAXgdAOQgcANgjAAQggAAgXgJgAgrh3QgbAOgSAVQgSAVgKAcQgKAcAAAdQAAAWAHAVQAHAUANAPQANAPAWAJQAVAJAdAAQAfAAAbgNQAagMATgWQASgVALgdQAKgcAAgdQAAgVgHgVQgHgUgOgQQgNgOgWgKQgVgJgdAAQgfAAgbANg");
	this.shape_6813.setTransform(946.7,603,0.5,0.5);

	this.shape_6814 = new cjs.Shape();
	this.shape_6814.graphics.f("#000000").s().p("AiGDMIgLgCIACgLIAJACIAMABQAOAAAKgFQAKgEAIgIQAHgGAGgLIAxhZIg4kUIAMAAIA1EGICNkGIAOAAIjDFmQgOAZgRAOQgPAOgbAAIgMgCg");
	this.shape_6814.setTransform(923.9,606.6,0.5,0.5);

	this.shape_6815 = new cjs.Shape();
	this.shape_6815.graphics.f("#000000").s().p("AhQCLIAtkOIAMAAIgEAiQAAAKgDAKIgDASIACAAQASgqAbgTQAbgSAfAAIAJAAIgBALIgFgBIgDAAQgZAAgUAMQgUALgNATQgPASgJAXQgJAYgEAVIgYCLg");
	this.shape_6815.setTransform(914.9,602.8,0.5,0.5);

	this.shape_6816 = new cjs.Shape();
	this.shape_6816.graphics.f("#000000").s().p("AhFCGQgXgJgQgRQgPgQgJgWQgHgVAAgbQAAgfAKgeQALgdAVgYQAVgXAcgNQAcgOAkAAQAgAAAWAJQAXAKAQAQQAPAQAIAXQAIAXAAAYQAAAegLAgQgKAdgVAXQgTAXgeAOQgdANgiAAQggAAgXgJgAgrh3QgcAOgRAVQgSAVgLAcQgKAcAAAdQAAAWAHAVQAHATAOAQQAMAOAXAKQAVAJAdAAQAgAAAZgNQAbgMASgWQAUgWAJgcQAKgcAAgdQAAgVgHgVQgHgVgNgPQgOgPgWgJQgVgJgcAAQggAAgaANg");
	this.shape_6816.setTransform(900.2,603,0.5,0.5);

	this.shape_6817 = new cjs.Shape();
	this.shape_6817.graphics.f("#000000").s().p("AglCmQgNgMAAgVIABgNIAljPIg+AAIACgLIA9AAIANhPIANAAIgOBPIBKAAIgCALIhJAAIgiDEIgCAMIgBALQAAATAMAJQALAIARAAIAOgCQAJgBAHgDIAAAKQgIADgIABQgHACgJAAQgZAAgNgMg");
	this.shape_6817.setTransform(888.1,601.2,0.5,0.5);

	this.shape_6818 = new cjs.Shape();
	this.shape_6818.graphics.f("#000000").s().p("AhDCEQgXgJgLgRIAJgIQALAPAVAJQAUAJAZAAQASAAANgGQAPgFALgKQAKgJAGgNQAGgNAAgNQAAgMgEgIQgCgKgJgGQgHgIgNgGIgggMQgjgLgOgOQgOgOgBgXQAAgVAJgOQAIgPAOgKQAOgJAQgGQASgFAPAAQAcAAATAJQATAKAJANIgLAIQgHgOgTgHQgSgIgVAAQgJAAgRADQgLAEgOAIQgMAIgJANQgHALAAAUQgBAXAPALQAOAKAcAKQAsANAOAQQAQARAAAZQAAARgHAPQgHAPgNALQgMALgRAGQgSAHgVAAQgbAAgWgLg");
	this.shape_6818.setTransform(876.9,603,0.5,0.5);

	this.shape_6819 = new cjs.Shape();
	this.shape_6819.graphics.f("#000000").s().p("Ag7CGQgWgJgRgQQgPgQgJgXQgIgWAAgbQAAgfAMgeQALgdAUgXQAVgXAcgOQAdgNAhAAQAbAAAVAIQATAJAOAOQAMAOAIAUQAFATAAAWIgBAPQAAAJgDAKIjxAAIgCAUQAAA3AdAeQAeAeA0AAQAiAAAZgOQAagPASgWIAHAIQgRAWgcAQQgcAPglAAQgdAAgYgJgAgfh4QgZAMgQARQgQARgLAWQgKAUgFAUIDmAAIABgZQAAgrgZgZQgZgbgrAAQgeAAgZAMg");
	this.shape_6819.setTransform(855.9,603,0.5,0.5);

	this.shape_6820 = new cjs.Shape();
	this.shape_6820.graphics.f("#000000").s().p("ABPDeIAfi/QAAgNgEgPQgFgNgIgKQgKgMgNgGQgPgHgTAAQgXAAgTAKQgUAJgPARQgPAQgNAYQgLAYgFAfIgYCIIgNAAIBOm7IANAAIgrD0IABAAQASgnAdgTQAdgVAiABQAWgBAQAIQAPAHALANQALALAFAQQAGAQAAAQQAAAKgEAVIgcCgg");
	this.shape_6820.setTransform(839,598.7,0.5,0.5);

	this.shape_6821 = new cjs.Shape();
	this.shape_6821.graphics.f("#000000").s().p("AhLDQIBGmTIiPAAIACgMIEnAAIgDAMIiKAAIhHGTg");
	this.shape_6821.setTransform(826.3,599.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_6821},{t:this.shape_6820},{t:this.shape_6819},{t:this.shape_6818},{t:this.shape_6817},{t:this.shape_6816},{t:this.shape_6815},{t:this.shape_6814},{t:this.shape_6813},{t:this.shape_6812},{t:this.shape_6811},{t:this.shape_6810},{t:this.shape_6809},{t:this.shape_6808},{t:this.shape_6807},{t:this.shape_6806},{t:this.shape_6805},{t:this.shape_6804},{t:this.shape_6803},{t:this.shape_6802},{t:this.shape_6801},{t:this.shape_6800},{t:this.shape_6799},{t:this.shape_6798},{t:this.shape_6797},{t:this.shape_6796},{t:this.shape_6795},{t:this.shape_6794},{t:this.shape_6793},{t:this.shape_6792},{t:this.shape_6791},{t:this.shape_6790},{t:this.shape_6789},{t:this.shape_6788},{t:this.shape_6787},{t:this.shape_6786},{t:this.shape_6785},{t:this.shape_6784},{t:this.shape_6783},{t:this.shape_6782},{t:this.shape_6781},{t:this.shape_6780},{t:this.shape_6779},{t:this.shape_6778},{t:this.shape_6777},{t:this.shape_6776},{t:this.shape_6775},{t:this.shape_6774},{t:this.shape_6773},{t:this.shape_6772},{t:this.shape_6771},{t:this.shape_6770},{t:this.shape_6769},{t:this.shape_6768},{t:this.shape_6767},{t:this.shape_6766},{t:this.shape_6765},{t:this.shape_6764},{t:this.shape_6763},{t:this.shape_6762},{t:this.shape_6761},{t:this.shape_6760},{t:this.shape_6759},{t:this.shape_6758},{t:this.shape_6757},{t:this.shape_6756},{t:this.shape_6755},{t:this.shape_6754},{t:this.shape_6753},{t:this.shape_6752},{t:this.shape_6751},{t:this.shape_6750},{t:this.shape_6749},{t:this.shape_6748},{t:this.shape_6747},{t:this.shape_6746},{t:this.shape_6745},{t:this.shape_6744},{t:this.shape_6743},{t:this.shape_6742}]}).to({state:[]},1).wait(164));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1619,791,1117.7,362.3);
// library properties:
lib.properties = {
	id: 'CE9F58D36F1D4AA68D11E7BC4A5817AC',
	width: 2025,
	height: 988,
	fps: 12,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"//cdn.shopify.com/s/files/1/1015/3461/t/10/assets/masteringafriendship_atlas.jpg", id:"masteringafriendship_atlas_"}
	],
	preloads: []
};



// bootstrap callback support:

(lib.Stage = function(canvas) {
	createjs.Stage.call(this, canvas);
}).prototype = p = new createjs.Stage();

p.setAutoPlay = function(autoPlay) {
	this.tickEnabled = autoPlay;
}
p.play = function() { this.tickEnabled = true; this.getChildAt(0).gotoAndPlay(this.getTimelinePosition()) }
p.stop = function(ms) { if(ms) this.seek(ms); this.tickEnabled = false; }
p.seek = function(ms) { this.tickEnabled = true; this.getChildAt(0).gotoAndStop(lib.properties.fps * ms / 1000); }
p.getDuration = function() { return this.getChildAt(0).totalFrames / lib.properties.fps * 1000; }

p.getTimelinePosition = function() { return this.getChildAt(0).currentFrame / lib.properties.fps * 1000; }

an.bootcompsLoaded = an.bootcompsLoaded || [];
if(!an.bootstrapListeners) {
	an.bootstrapListeners=[];
}

an.bootstrapCallback=function(fnCallback) {
	an.bootstrapListeners.push(fnCallback);
	if(an.bootcompsLoaded.length > 0) {
		for(var i=0; i<an.bootcompsLoaded.length; ++i) {
			fnCallback(an.bootcompsLoaded[i]);
		}
	}
};

an.compositions = an.compositions || {};
an.compositions['CE9F58D36F1D4AA68D11E7BC4A5817AC'] = {
	getStage: function() { return exportRoot.getStage(); },
	getLibrary: function() { return lib; },
	getSpriteSheet: function() { return ss; },
	getImages: function() { return img; }
};

an.compositionLoaded = function(id) {
	an.bootcompsLoaded.push(id);
	for(var j=0; j<an.bootstrapListeners.length; j++) {
		an.bootstrapListeners[j](id);
	}
}

an.getComposition = function(id) {
	return an.compositions[id];
}



})(createjs = createjs||{}, AdobeAn = AdobeAn||{});
var createjs, AdobeAn;